/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _, jQuery) {var About, AuthTransition, DecisionBoard, GroupSelectionRegion, LocationTransition, Page, PointsList, Proposal, ProposalDescription, Root, SliderBubblemouth, buildPointsList,
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	__webpack_require__(41);

	__webpack_require__(70);

	__webpack_require__(68);

	__webpack_require__(20);

	__webpack_require__(69);

	__webpack_require__(71);

	__webpack_require__(25);

	__webpack_require__(13);

	__webpack_require__(37);

	__webpack_require__(38);

	__webpack_require__(28);

	__webpack_require__(5);

	__webpack_require__(7);

	__webpack_require__(8);

	__webpack_require__(74);

	__webpack_require__(4);

	__webpack_require__(16);

	__webpack_require__(17);

	__webpack_require__(87);

	__webpack_require__(21);

	__webpack_require__(89);

	__webpack_require__(22);

	__webpack_require__(3);

	__webpack_require__(77);

	__webpack_require__(47);

	__webpack_require__(88);

	__webpack_require__(9);

	__webpack_require__(40);

	__webpack_require__(75);

	__webpack_require__(76);

	__webpack_require__(73);

	__webpack_require__(72);

	__webpack_require__(78);

	__webpack_require__(35);

	fetch('decisionboard', {
	  docked: false
	});

	fetch('root', {
	  opinions_to_publish: []
	});

	window.get_proposal_mode = function() {
	  var loc, ref;
	  loc = fetch('location');
	  if (loc.url === '/') {
	    return null;
	  } else if (((ref = loc.query_params) != null ? ref.results : void 0) || TWO_COL()) {
	    return 'results';
	  } else {
	    return 'crafting';
	  }
	};

	window.get_selected_point = function() {
	  return fetch('location').query_params.selected;
	};

	window.namespaced_key = function(base_key, base_object) {
	  var namespace_key;
	  namespace_key = fetch(base_object).key;
	  if (namespace_key[0] === '/') {
	    namespace_key = namespace_key.substring(1, namespace_key.length);
	  }
	  return namespace_key + "_" + base_key;
	};

	window.proposal_url = (function(_this) {
	  return function(proposal) {
	    var result, subdomain;
	    proposal = fetch(proposal);
	    result = '/' + proposal.slug;
	    subdomain = fetch('/subdomain');
	    if (TWO_COL() || (!customization('show_crafting_page_first', proposal) || !proposal.active) || (!customization('discussion', proposal))) {
	      result += '?results=true';
	    }
	    return result;
	  };
	})(this);

	window.isNeutralOpinion = function(stance) {
	  return Math.abs(stance) < 0.05;
	};

	window.updateProposalMode = function(proposal_mode, triggered_by) {
	  var loc;
	  loc = fetch('location');
	  if (proposal_mode === 'results' && loc.query_params.results || proposal_mode === 'crafting' && !loc.query_params.results) {
	    return;
	  }
	  if (proposal_mode === 'results') {
	    loc.query_params.results = true;
	  } else {
	    delete loc.query_params.results;
	  }
	  delete loc.query_params.selected;
	  save(loc);
	  if (proposal_mode === 'results' && $('.histogram').length > 0) {
	    $('.histogram').ensureInView({
	      offset_buffer: -50
	    });
	  }
	  return window.writeToLog({
	    what: 'toggle proposal mode',
	    details: {
	      from: get_proposal_mode(),
	      to: proposal_mode,
	      triggered_by: triggered_by
	    }
	  });
	};

	window.opinionsForProposal = function(proposal) {
	  var filter_func, opinion, opinions;
	  filter_func = customization("homie_histo_filter", proposal);
	  opinions = fetch(proposal).opinions || [];
	  opinions = (function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = opinions.length; i < len; i++) {
	      opinion = opinions[i];
	      if (!filter_func || filter_func(fetch(opinion.user))) {
	        results.push(opinion);
	      }
	    }
	    return results;
	  })();
	  return opinions;
	};

	Proposal = ReactiveComponent({
	  displayName: 'Proposal',
	  render: function() {
	    var adjustments, can_opine, col, community_points, current_user, doc, draw_handle, edit_mode, has_community_points, has_focus, i, included_points, len, local_proposal, minheight, mode, newpoint_threshold, pc, pnt, point_cols, proposal_header, ref, subdomain, valence, your_opinion;
	    doc = fetch('document');
	    if (doc.title !== this.proposal.name) {
	      doc.title = this.proposal.name;
	      save(doc);
	    }
	    your_opinion = fetch(this.proposal.your_opinion);
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    point_cols = ['your_con_points', 'your_pro_points', 'community_cons', 'community_pros'];
	    edit_mode = false;
	    for (i = 0, len = point_cols.length; i < len; i++) {
	      pc = point_cols[i];
	      col = fetch(pc);
	      if (col.adding_new_point || ((ref = col.editing_points) != null ? ref.length : void 0) > 0) {
	        edit_mode = pc;
	        break;
	      }
	    }
	    local_proposal = fetch(shared_local_key(this.proposal));
	    has_focus = get_selected_point() ? 'point' : edit_mode ? 'edit point' : "opinion";
	    if (local_proposal.has_focus !== has_focus) {
	      local_proposal.has_focus = has_focus;
	      save(local_proposal);
	    }
	    mode = get_proposal_mode();
	    if (your_opinion.published) {
	      can_opine = permit('update opinion', this.proposal, your_opinion);
	    } else {
	      can_opine = permit('publish opinion', this.proposal);
	    }
	    if (mode === 'crafting' && !((can_opine === Permission.PERMITTED || can_opine === Permission.UNVERIFIED_EMAIL || can_opine === Permission.NOT_LOGGED_IN || can_opine === Permission.INSUFFICIENT_INFORMATION) || (can_opine === Permission.DISABLED && your_opinion.published))) {
	      updateProposalMode('results', 'permission not granted for crafting');
	    }
	    proposal_header = (customization('ProposalNavigation', this.proposal))();
	    newpoint_threshold = this.buildNewPointThreshold();
	    draw_handle = (can_opine !== Permission.DISABLED && can_opine !== Permission.INSUFFICIENT_PRIVILEGES) || your_opinion.published;
	    adjustments = fetch('reasons_height_adjustment');
	    minheight = 100 + (adjustments.opinion_region_height || 0);
	    if (get_selected_point()) {
	      minheight += adjustments.open_point_height;
	    }
	    if (adjustments.edit_point_height) {
	      minheight += adjustments.edit_point_height;
	    }
	    community_points = fetch("/page/" + this.proposal.slug).points || [];
	    if (mode === 'crafting') {
	      included_points = fetch(this.proposal.your_opinion).point_inclusions;
	      community_points = (function() {
	        var j, len1, results;
	        results = [];
	        for (j = 0, len1 = community_points.length; j < len1; j++) {
	          pnt = community_points[j];
	          if (!_.contains(included_points, pnt.key)) {
	            results.push(pnt);
	          }
	        }
	        return results;
	      })();
	    }
	    has_community_points = community_points.length > 0;
	    return DIV({
	      id: "proposal-" + this.proposal.id,
	      key: this.props.slug,
	      style: {
	        paddingBottom: browser.is_mobile && has_focus === 'edit point' ? 200 : void 0
	      }
	    }, DIV({
	      className: 'proposal_header'
	    }, customization('docking_proposal_header', this.proposal) ? Dock({
	      dock_on_zoomed_screens: false,
	      skip_jut: true
	    }, proposal_header) : proposal_header), DIV(null, ProposalDescription(), customization('opinion_filters') ? OpinionFilter({
	      style: {
	        width: BODY_WIDTH(),
	        margin: '40px auto 20px auto',
	        textAlign: 'center'
	      }
	    }) : void 0, DIV({
	      style: {
	        width: PROPOSAL_HISTO_WIDTH(),
	        margin: '0 auto',
	        position: 'relative',
	        zIndex: 1
	      }
	    }, Histogram({
	      key: namespaced_key('histogram', this.proposal),
	      proposal: this.proposal,
	      opinions: opinionsForProposal(this.proposal),
	      width: PROPOSAL_HISTO_WIDTH(),
	      height: fetch('histogram-dock').docked ? 50 : 170,
	      enable_selection: true,
	      draw_base: fetch('histogram-dock').docked ? true : false,
	      backgrounded: mode === 'crafting',
	      on_click_when_backgrounded: function() {
	        return updateProposalMode('results', 'click_histogram');
	      }
	    }), Dock({
	      key: 'slider-dock',
	      docked_key: namespaced_key('slider', this.proposal),
	      dock_on_zoomed_screens: true,
	      constraints: ['decisionboard-dock', 'histogram-dock'],
	      skip_jut: mode === 'results',
	      dockable: (function(_this) {
	        return function() {
	          return mode === 'crafting';
	        };
	      })(this),
	      dummy: get_proposal_mode() === 'crafting',
	      dummy2: PROPOSAL_HISTO_WIDTH()
	    }, (function(_this) {
	      return function() {
	        var plurality;
	        plurality = mode === 'crafting' ? 'individual' : 'group';
	        return OpinionSlider({
	          key: namespaced_key('slider', _this.proposal),
	          width: PROPOSAL_HISTO_WIDTH() - 10,
	          your_opinion: _this.proposal.your_opinion,
	          focused: mode === 'crafting',
	          backgrounded: false,
	          permitted: draw_handle,
	          pole_labels: [[customization("slider_pole_labels." + plurality + ".oppose", _this.proposal), customization("slider_pole_labels." + plurality + ".oppose_sub", _this.proposal)], [customization("slider_pole_labels." + plurality + ".support", _this.proposal), customization("slider_pole_labels." + plurality + ".support_sub", _this.proposal)]]
	        });
	      };
	    })(this)())), DIV({
	      className: 'reasons_region',
	      style: {
	        width: REASONS_REGION_WIDTH(),
	        minHeight: minheight,
	        position: 'relative',
	        paddingBottom: '4em',
	        margin: (draw_handle && !TWO_COL() ? '24px' : '0') + " auto 0 auto",
	        display: !customization('discussion', this.proposal) ? 'none' : void 0
	      }
	    }, GroupSelectionRegion(), PointsList({
	      key: 'community_cons',
	      rendered_as: 'community_point',
	      points_editable: TWO_COL(),
	      valence: 'cons',
	      newpoint_threshold: newpoint_threshold,
	      points_draggable: mode === 'crafting',
	      drop_target: false,
	      points: buildPointsList(this.proposal, 'cons', (mode === 'results' ? 'score' : 'last_inclusion'), mode === 'crafting'),
	      style: {
	        visibility: !TWO_COL() && !has_community_points ? 'hidden' : void 0
	      }
	    }), !TWO_COL() && customization('discussion', this.proposal) ? Dock({
	      key: 'decisionboard-dock',
	      docked_key: 'decisionboard',
	      constraints: ['slider-dock'],
	      dock_on_zoomed_screens: true,
	      dockable: (function(_this) {
	        return function() {
	          return mode === 'crafting';
	        };
	      })(this),
	      start: -24,
	      stop: function() {
	        return $('.reasons_region').offset().top + $('.reasons_region').outerHeight() - 20;
	      },
	      style: {
	        position: 'absolute',
	        width: DECISION_BOARD_WIDTH(),
	        zIndex: 0,
	        display: 'inline-block',
	        verticalAlign: 'top'
	      }
	    }, DecisionBoard({
	      key: 'decisionboard'
	    })) : void 0, PointsList({
	      key: 'community_pros',
	      rendered_as: 'community_point',
	      points_editable: TWO_COL(),
	      valence: 'pros',
	      newpoint_threshold: newpoint_threshold,
	      points_draggable: mode === 'crafting',
	      drop_target: false,
	      points: buildPointsList(this.proposal, 'pros', (mode === 'results' ? 'score' : 'last_inclusion'), mode === 'crafting'),
	      style: {
	        visibility: !TWO_COL() && !has_community_points ? 'hidden' : void 0
	      }
	    }))), edit_mode && browser.is_mobile ? (valence = edit_mode === 'community_pros' || edit_mode === 'your_pro_points' ? 'pros' : 'cons', pc = fetch(edit_mode), EditPoint({
	      key: pc.adding_new_point ? "new_point_" + valence : pc.editing_points[0],
	      fresh: pc.adding_new_point,
	      valence: valence,
	      your_points_key: edit_mode
	    })) : mode === 'results' && your_opinion.published && customization('ThanksForYourOpinion', this.proposal) ? customization('ThanksForYourOpinion', this.proposal)() : void 0);
	  },
	  buildNewPointThreshold: function() {
	    var newpoint_threshold, points;
	    points = this.page.points || [];
	    newpoint_threshold = (_.sortBy(points, (function(_this) {
	      return function(pnt) {
	        return -Date.parse(pnt.created_at);
	      };
	    })(this)))[Math.ceil(points.length / 10)];
	    return (newpoint_threshold && Date.parse(newpoint_threshold.created_at)) || new Date();
	  }
	});

	ProposalDescription = ReactiveComponent({
	  displayName: 'ProposalDescription',
	  render: function() {
	    var current_user, editor, error, hues, idx, item, ref, sub, subdomain, subdomains;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    if (!this.local.description_fields) {
	      try {
	        this.local.description_fields = $.parseJSON(this.proposal.description_fields);
	        this.local.expanded_field = null;
	      } catch (error) {
	        this.local.description_fields = null;
	      }
	    }
	    this.max_description_height = customization('collapse_descriptions_at', this.proposal);
	    return DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        position: 'relative',
	        margin: 'auto',
	        fontSize: 18,
	        marginBottom: 18
	      }
	    }, DIV({
	      id: 'proposal_name',
	      style: {
	        lineHeight: 1.2,
	        fontWeight: 700,
	        fontSize: 45,
	        paddingBottom: 15
	      }
	    }, this.proposal.name, customization('show_meta') ? DIV({
	      style: {
	        fontSize: 16,
	        color: "#888",
	        fontStyle: 'italic',
	        paddingTop: 18
	      }
	    }, prettyDate(this.proposal.created_at), (editor = proposal_editor(this.proposal)) && editor === this.proposal.user ? SPAN({
	      style: {}
	    }, " by " + ((ref = fetch(editor)) != null ? ref.name : void 0)) : void 0) : void 0), !this.proposal.active ? SPAN({
	      style: {
	        display: 'inline-block',
	        color: 'rgb(250, 146, 45)',
	        padding: '4px 0px',
	        marginTop: 10
	      }
	    }, I({
	      className: 'fa fa-info-circle',
	      style: {
	        paddingRight: 7
	      }
	    }), 'Closed to new contributions at this time.') : void 0, DIV({
	      className: 'proposal_details',
	      style: {
	        paddingTop: '1em',
	        position: 'relative',
	        maxHeight: this.local.description_collapsed ? this.max_description_height : void 0,
	        overflow: this.local.description_collapsed ? 'hidden' : void 0
	      }
	    }, this.local.description_collapsed ? DIV({
	      style: {
	        backgroundColor: '#f9f9f9',
	        width: HOMEPAGE_WIDTH(),
	        position: 'absolute',
	        bottom: 0,
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        paddingTop: 10,
	        paddingBottom: 10,
	        fontWeight: 600,
	        textAlign: 'center'
	      },
	      onMouseDown: (function(_this) {
	        return function() {
	          _this.local.description_collapsed = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'Expand full text') : void 0, DIV({
	      dangerouslySetInnerHTML: {
	        __html: this.proposal.description
	      }
	    })), this.local.description_fields ? DIV({
	      id: 'description_fields',
	      style: {
	        marginTop: '1em'
	      }
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = this.local.description_fields;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        item = ref1[i];
	        if (item.group) {
	          results.push(this.renderDescriptionFieldGroup(item));
	        } else {
	          results.push(this.renderDescriptionField(item));
	        }
	      }
	      return results;
	    }).call(this)) : void 0, DIV({
	      style: {
	        marginTop: 15,
	        color: '#666'
	      }
	    }, permit('update proposal', this.proposal) > 0 ? I({
	      className: 'fa fa-cog',
	      style: {
	        cursor: 'pointer',
	        color: this.local.show_options ? logo_red : "#aaa",
	        fontSize: 24,
	        marginRight: 10,
	        display: 'inline-block'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_options = !_this.local.show_options;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0, (current_user != null ? current_user.logged_in : void 0) ? I({
	      className: 'fa fa-bell',
	      title: 'notifications',
	      style: {
	        cursor: 'pointer',
	        color: this.local.show_notifications ? logo_red : "#aaa",
	        fontSize: 24
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_notifications = !_this.local.show_notifications;
	          return save(_this.local);
	        };
	      })(this)
	    }) : void 0), this.local.show_options ? DIV({
	      style: {
	        marginTop: 5
	      }
	    }, A({
	      href: this.proposal.key + "/edit",
	      style: {
	        marginRight: 10,
	        color: '#999'
	      }
	    }, t('edit')), A({
	      style: {
	        marginRight: 10,
	        color: '#999',
	        backgroundColor: this.local.edit_roles ? '#fafafa' : 'transparent'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.edit_roles = !_this.local.edit_roles;
	          return save(_this.local);
	        };
	      })(this)
	    }, t('share')), permit('delete proposal', this.proposal) > 0 ? A({
	      style: {
	        marginRight: 10,
	        color: '#999'
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (confirm('Delete this proposal forever?')) {
	            destroy(_this.proposal.key);
	            return loadPage('/');
	          }
	        };
	      })(this)
	    }, t('delete')) : void 0, current_user.is_super_admin ? SPAN({
	      style: {
	        marginRight: 10,
	        color: '#999'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.copy_to_subdomain = !_this.local.copy_to_subdomain;
	          return save(_this.local);
	        };
	      })(this)
	    }, A(null, 'Copy to subdomain'), this.local.copy_to_subdomain ? (subdomains = fetch('/subdomains').subs, hues = getNiceRandomHues(subdomains != null ? subdomains.length : void 0), UL({
	      style: {}
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = subdomains.length; i < len; idx = ++i) {
	        sub = subdomains[idx];
	        results.push(LI({
	          style: {
	            display: 'inline-block',
	            listStyle: 'none'
	          }
	        }, A({
	          href: "/proposal/" + this.proposal.id + "/copy_to/" + sub.id,
	          'data-nojax': false,
	          style: {
	            padding: "4px 8px",
	            fontSize: 18,
	            backgroundColor: hsv2rgb(hues[idx], .7, .5),
	            color: 'white',
	            display: 'inline-block'
	          }
	        }, sub.name)));
	      }
	      return results;
	    }).call(this))) : void 0) : void 0) : void 0, this.local.edit_roles ? DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto',
	        backgroundColor: '#fafafa',
	        padding: '10px 60px'
	      }
	    }, ProposalRoles({
	      key: this.proposal.key
	    })) : void 0, this.local.show_notifications ? ActivityFeed() : void 0);
	  },
	  componentDidMount: function() {
	    if (this.max_description_height && this.local.description_collapsed === void 0 && $('.proposal_details').height() > this.max_description_height) {
	      this.local.description_collapsed = true;
	      return save(this.local);
	    }
	  },
	  componentDidUpdate: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (subdomain.name === 'RANDOM2015' && this.local.description_fields && $('#description_fields').find('.MathJax').length === 0) {
	      return MathJax.Hub.Queue(["Typeset", MathJax.Hub, "description_fields"]);
	    }
	  },
	  renderDescriptionField: function(field) {
	    var symbol;
	    symbol = field.expanded ? 'fa-chevron-down' : 'fa-chevron-right';
	    return DIV({
	      className: 'description_field',
	      key: field.label,
	      style: {
	        padding: '.25em 0'
	      }
	    }, DIV({
	      style: {
	        cursor: 'pointer'
	      },
	      onClick: (function(_this) {
	        return function() {
	          field.expanded = !field.expanded;
	          save(_this.local);
	          if (field.expanded) {
	            return window.writeToLog({
	              what: 'expand proposal description',
	              details: {
	                description_type: field.label
	              }
	            });
	          }
	        };
	      })(this)
	    }, SPAN({
	      className: "fa " + symbol,
	      style: {
	        opacity: .7,
	        position: 'relative',
	        left: -3,
	        paddingRight: 6,
	        display: 'inline-block',
	        width: 20
	      }
	    }), SPAN({
	      style: {
	        lineHeight: 1.6,
	        fontSize: 18
	      }
	    }, field.label)), field.expanded ? DIV({
	      style: {
	        padding: '10px 0',
	        overflow: 'hidden'
	      },
	      dangerouslySetInnerHTML: {
	        __html: field.html
	      }
	    }) : void 0);
	  },
	  renderDescriptionFieldGroup: function(group) {
	    var field;
	    return DIV({
	      className: 'description_group',
	      key: group.group,
	      style: {
	        position: 'relative',
	        marginBottom: 10,
	        borderLeft: '1px solid #e1e1e1',
	        paddingLeft: 20,
	        left: -20
	      }
	    }, DIV({
	      style: {
	        position: 'absolute',
	        width: 200,
	        left: -217,
	        textAlign: 'right',
	        top: 4,
	        fontWeight: browser.high_density_display ? 300 : 400
	      }
	    }, LABEL(null, group.group)), (function() {
	      var i, len, ref, results;
	      ref = group.items;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        field = ref[i];
	        results.push(this.renderDescriptionField(field));
	      }
	      return results;
	    }).call(this));
	  }
	});

	styles += ".proposal_details code, .proposal_details pre {\n  font-family: \"Courier New\",Courier,\"Lucida Sans Typewriter\",\"Lucida Typewriter\",monospace;\n},.proposal_details br, .description_field br {\n  padding-bottom: 0.5em; }\n.proposal_details p, \n.proposal_details ul, \n.description_field ul, \n.proposal_details ol, \n.description_field ol, \n.proposal_details table, \n.description_field p, \n.description_field table {\n  margin-bottom: 0.5em; }\n.proposal_details td, .description_field td {\n  padding: 0 3px; }\n.proposal_details li, .description_field li {\n  list-style: outside; }\n.proposal_details ol li, .proposal_details ol li {\n  list-style-type: decimal; }  \n.proposal_details ul, .description_field ul,\n.proposal_details ol, .description_field ol {\n  padding-left: 20px;\n  margin-left: 20px; }\n.proposal_details a, .description_field a {\n  text-decoration: underline; }\n.proposal_details blockquote, .description_field blockquote {\n  opacity: 0.7;\n  padding: 10px 20px; }\n.proposal_details table, .description_field table {\n  padding: 20px 0px; font-size: 11px; }";

	DecisionBoard = ReactiveComponent({
	  displayName: 'DecisionBoard',
	  render: function() {
	    var are_points_in_wings, can_opine, current_user, db, decision_board_style, enable_opining, give_opinion_button_width, give_opinion_style, gutter, hist, included_points, opinion_region_x, opinion_slider_width, p, pnt, register_dependency, slider, stance_position, subdomain, wing_points, your_opinion;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    db = fetch('decision_board');
	    your_opinion = fetch(this.proposal.your_opinion);
	    if (your_opinion.published) {
	      can_opine = permit('update opinion', this.proposal, your_opinion);
	    } else {
	      can_opine = permit('publish opinion', this.proposal);
	    }
	    enable_opining = can_opine !== Permission.INSUFFICIENT_PRIVILEGES && (can_opine !== Permission.DISABLED || your_opinion.published) && !(hist.selected_opinions || hist.selected_opinion);
	    if (!enable_opining) {
	      return DIV(null);
	    }
	    register_dependency = fetch(namespaced_key('slider', this.proposal)).value;
	    wing_points = fetch("/page/" + this.proposal.slug).points || [];
	    included_points = fetch(this.proposal.your_opinion).point_inclusions;
	    wing_points = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = wing_points.length; i < len; i++) {
	        pnt = wing_points[i];
	        if (!_.contains(included_points, pnt.key)) {
	          results.push(pnt);
	        }
	      }
	      return results;
	    })();
	    are_points_in_wings = wing_points.length > 0;
	    decision_board_style = {
	      borderRadius: 16,
	      borderStyle: 'dashed',
	      borderWidth: 3,
	      borderColor: focus_blue,
	      transition: this.last_proposal_mode !== get_proposal_mode() || this.transitioning ? ("transform " + TRANSITION_SPEED + "ms, ") + ("width " + TRANSITION_SPEED + "ms, ") + ("min-height " + TRANSITION_SPEED + "ms") : 'none'
	    };
	    if (db.user_hovering_on_drop_target) {
	      decision_board_style.borderStyle = 'solid';
	    }
	    if (get_proposal_mode() === 'results') {
	      give_opinion_button_width = 200;
	      slider = fetch(namespaced_key('slider', this.proposal));
	      gutter = .1 * give_opinion_button_width;
	      opinion_slider_width = BODY_WIDTH() - 10;
	      stance_position = (slider.value + 1) / 2 * opinion_slider_width / BODY_WIDTH();
	      opinion_region_x = -gutter + stance_position * (DECISION_BOARD_WIDTH() - give_opinion_button_width + 2 * gutter);
	      _.extend(decision_board_style, {
	        borderStyle: 'solid',
	        backgroundColor: focus_blue,
	        borderBottom: '1px solid rgba(0,0,0,.6)',
	        cursor: 'pointer',
	        transform: "translate(" + opinion_region_x + "px, -18px)",
	        minHeight: 32,
	        width: give_opinion_button_width
	      });
	    } else {
	      _.extend(decision_board_style, {
	        transform: "translate(0, 10px)",
	        minHeight: are_points_in_wings ? 275 : 170,
	        width: DECISION_BOARD_WIDTH(),
	        borderBottom: decision_board_style.borderWidth + "px dashed " + focus_blue
	      });
	    }
	    if (get_proposal_mode() === 'results') {
	      give_opinion_style = {
	        display: 'block',
	        color: 'white',
	        padding: '.25em 18px',
	        margin: 0,
	        fontSize: 16,
	        boxShadow: 'none'
	      };
	    } else {
	      give_opinion_style = {
	        visibility: 'hidden'
	      };
	    }
	    return DIV({
	      className: 'opinion_region',
	      style: {
	        width: DECISION_BOARD_WIDTH()
	      }
	    }, SliderBubblemouth(), DIV({
	      key: 'body',
	      className: 'decision_board_body',
	      style: css.crossbrowserify(decision_board_style),
	      onClick: (function(_this) {
	        return function() {
	          if (get_proposal_mode() === 'results') {
	            return updateProposalMode('crafting', 'give_opinion_button');
	          }
	        };
	      })(this)
	    }, DIV(null, get_proposal_mode() === 'crafting' ? DIV({
	      className: 'your_points',
	      style: {
	        padding: '0 18px',
	        marginTop: -3
	      }
	    }, PointsList({
	      key: 'your_con_points',
	      valence: 'cons',
	      rendered_as: 'decision_board_point',
	      points_editable: true,
	      points_draggable: true,
	      drop_target: are_points_in_wings,
	      points: (function() {
	        var i, len, ref, results;
	        ref = fetch(this.proposal.your_opinion).point_inclusions;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          p = ref[i];
	          if (!fetch(p).is_pro) {
	            results.push(p);
	          }
	        }
	        return results;
	      }).call(this)
	    }), PointsList({
	      key: 'your_pro_points',
	      valence: 'pros',
	      rendered_as: 'decision_board_point',
	      points_editable: true,
	      points_draggable: true,
	      drop_target: are_points_in_wings,
	      points: (function() {
	        var i, len, ref, results;
	        ref = fetch(this.proposal.your_opinion).point_inclusions;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          p = ref[i];
	          if (fetch(p).is_pro) {
	            results.push(p);
	          }
	        }
	        return results;
	      }).call(this)
	    }), DIV({
	      style: {
	        clear: 'both'
	      }
	    })) : void 0, A({
	      className: 'give_opinion_button primary_button',
	      style: give_opinion_style
	    }, your_opinion.published ? t('Update your Opinion') : t('Give your Opinion')))), DIV({
	      key: 'footer',
	      style: {
	        width: DECISION_BOARD_WIDTH()
	      }
	    }, DIV({
	      className: 'save_opinion_button primary_button',
	      style: {
	        display: 'none',
	        backgroundColor: focus_blue
	      },
	      onClick: (function(_this) {
	        return function() {
	          return saveOpinion(_this.proposal);
	        };
	      })(this)
	    }, your_opinion.published ? t('Return to results') : t('Save your opinion')), !your_opinion.published ? DIV({
	      className: 'below_save',
	      style: {
	        display: 'none'
	      }
	    }, A({
	      className: 'cancel_opinion_button primary_cancel_button',
	      onClick: (function(_this) {
	        return function() {
	          return updateProposalMode('results', 'cancel_button');
	        };
	      })(this)
	    }, t('skip_to_results'))) : DIV({
	      className: 'below_save',
	      style: {
	        display: 'none'
	      }
	    }, A({
	      style: {
	        textDecoration: 'underline'
	      },
	      className: 'cancel_opinion_button primary_cancel_button',
	      onClick: (function(_this) {
	        return function() {
	          your_opinion.published = false;
	          return save(your_opinion);
	        };
	      })(this)
	    }, 'Unpublish opinion'))));
	  },
	  componentDidUpdate: function() {
	    this.transition();
	    return this.makeDroppable();
	  },
	  componentDidMount: function() {
	    this.transition();
	    return this.makeDroppable();
	  },
	  makeDroppable: function() {
	    var $el, db;
	    db = fetch('decision_board');
	    $el = $(this.getDOMNode());
	    if ($el.is('.ui-droppable')) {
	      return;
	    }
	    return $el.droppable({
	      accept: ".point_content",
	      drop: (function(_this) {
	        return function(ev, ui) {
	          var your_opinion;
	          if (ui.draggable.parent().is('.community_point')) {
	            your_opinion = fetch(_this.proposal.your_opinion);
	            your_opinion.point_inclusions.push(ui.draggable.parent().data('id'));
	            save(your_opinion);
	            window.writeToLog({
	              what: 'included point',
	              details: {
	                point: ui.draggable.parent().data('id')
	              }
	            });
	            db.user_hovering_on_drop_target = false;
	            return save(db);
	          }
	        };
	      })(this),
	      out: (function(_this) {
	        return function(ev, ui) {
	          if (ui.draggable.parent().is('.community_point')) {
	            db.user_hovering_on_drop_target = false;
	            return save(db);
	          }
	        };
	      })(this),
	      over: (function(_this) {
	        return function(ev, ui) {
	          if (ui.draggable.parent().is('.community_point')) {
	            db.user_hovering_on_drop_target = true;
	            return save(db);
	          }
	        };
	      })(this)
	    });
	  },
	  update_reasons_height: function() {
	    var s;
	    s = fetch('reasons_height_adjustment');
	    s.opinion_region_height = $(this.getDOMNode()).height();
	    return save(s);
	  },
	  transition: function() {
	    var final_state, initial_state, mode, perform, speed;
	    if (this.is_waiting()) {
	      return;
	    }
	    speed = !Modernizr.csstransitions || !this.last_proposal_mode ? 0 : TRANSITION_SPEED;
	    mode = get_proposal_mode();
	    perform = (function(_this) {
	      return function(transitions) {
	        var k, results, v;
	        results = [];
	        for (k in transitions) {
	          if (!hasProp.call(transitions, k)) continue;
	          v = transitions[k];
	          results.push($(_this.getDOMNode()).find(k).css(v));
	        }
	        return results;
	      };
	    })(this);
	    initial_state = {
	      '.give_opinion_button': {
	        visibility: 'hidden'
	      },
	      '.your_points, .save_opinion_button, .below_save': {
	        display: 'none'
	      }
	    };
	    final_state = JSON.parse(JSON.stringify(initial_state));
	    if (mode === 'results') {
	      final_state['.give_opinion_button'].visibility = '';
	    } else {
	      final_state['.your_points, .save_opinion_button, .below_save'].display = '';
	    }
	    if (this.last_proposal_mode !== mode) {
	      if (speed > 0) {
	        perform(initial_state);
	        this.transitioning = true;
	        _.delay((function(_this) {
	          return function() {
	            if (_this.isMounted()) {
	              perform(final_state);
	              _this.transitioning = false;
	              return _this.update_reasons_height();
	            }
	          };
	        })(this), speed + 200);
	      } else if (!this.transitioning) {
	        perform(initial_state);
	        perform(final_state);
	        this.update_reasons_height();
	      }
	      return this.last_proposal_mode = mode;
	    }
	  }
	});

	window.saveOpinion = function(proposal) {
	  var auth_form, can_opine, root, your_opinion;
	  root = fetch('root');
	  your_opinion = fetch(proposal.your_opinion);
	  if (your_opinion.published) {
	    can_opine = permit('update opinion', proposal, your_opinion);
	  } else {
	    can_opine = permit('publish opinion', proposal);
	  }
	  if (can_opine > 0) {
	    your_opinion.published = true;
	    save(your_opinion);
	    return updateProposalMode('results', 'save_button');
	  } else {
	    if (can_opine === Permission.UNVERIFIED_EMAIL) {
	      auth_form = 'verify email';
	      current_user.trying_to = 'send_verification_token';
	      save(current_user);
	    } else if (can_opine === Permission.INSUFFICIENT_INFORMATION) {
	      auth_form = 'user questions';
	    } else {
	      auth_form = 'create account';
	    }
	    reset_key('auth', {
	      form: auth_form,
	      goal: 'Save your opinion',
	      ask_questions: true
	    });
	    root.opinions_to_publish.push(proposal.your_opinion);
	    return save(root);
	  }
	};

	SliderBubblemouth = ReactiveComponent({
	  displayName: 'SliderBubblemouth',
	  render: function() {
	    var dash, db, fill, h, slider, stroke_width, transform, w;
	    slider = fetch(namespaced_key('slider', this.proposal));
	    db = fetch('decision_board');
	    w = 34;
	    h = 24;
	    stroke_width = 11;
	    if (get_proposal_mode() === 'crafting') {
	      transform = "";
	      fill = 'white';
	      if (db.user_hovering_on_drop_target) {
	        dash = "none";
	      } else {
	        dash = "25, 10";
	      }
	    } else {
	      transform = "translate(0, -25px) scale(.5) ";
	      fill = focus_blue;
	      dash = "none";
	    }
	    return DIV({
	      key: 'slider_bubblemouth',
	      style: css.crossbrowserify({
	        left: 10 + translateStanceToPixelX(slider.value, DECISION_BOARD_WIDTH() - w - 20),
	        top: -h + 10 + 3,
	        position: 'absolute',
	        width: w,
	        height: h,
	        zIndex: 10,
	        transition: "transform " + TRANSITION_SPEED + "ms",
	        transform: transform
	      })
	    }, Bubblemouth({
	      apex_xfrac: (slider.value + 1) / 2,
	      width: w,
	      height: h,
	      fill: fill,
	      stroke: focus_blue,
	      stroke_width: get_proposal_mode() === 'crafting' ? stroke_width : 0,
	      dash_array: dash
	    }));
	  }
	});

	GroupSelectionRegion = ReactiveComponent({
	  displayName: 'GroupSelectionRegion',
	  render: function() {
	    var avatar_size, h, has_histogram_focus, hist, left, name, name_style, name_width, place_avatar_opinion_value, title, user, w;
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    has_histogram_focus = hist.selected_opinions || hist.selected_opinion;
	    if (has_histogram_focus) {
	      return DIV({
	        style: {
	          width: BODY_WIDTH() + 160,
	          border: "3px solid " + (get_selected_point() ? '#eee' : focus_blue),
	          height: '100%',
	          position: 'absolute',
	          borderRadius: 16,
	          marginLeft: -BODY_WIDTH() / 2 - 80,
	          left: '50%',
	          top: 18
	        }
	      }, hist.selected_opinions ? (w = 40, h = 30, left = translateStanceToPixelX(hist.selected_opinion_value, BODY_WIDTH()) + 10, DIV({
	        style: cssTriangle('top', (get_selected_point() ? '#eee' : focus_blue), w, h, {
	          position: 'relative',
	          top: -32,
	          left: left
	        })
	      }, DIV({
	        style: cssTriangle('top', 'white', w - 1, h - 1, {
	          position: 'relative',
	          left: -(w - 2) / 2,
	          top: 6
	        })
	      }))) : (place_avatar_opinion_value = hist.selected_opinion_value > 0 ? .66 : -.8, left = translateStanceToPixelX(place_avatar_opinion_value, BODY_WIDTH() + 160), avatar_size = 80, user = fetch(fetch(hist.selected_opinion).user), name = user.name || 'Anonymous', title = name + "'" + (name[name.length - 1] !== 's' ? 's' : '') + " Opinion", name_width = widthWhenRendered(title, {
	        fontSize: '30px',
	        fontWeight: '600'
	      }), hist.selected_opinion_value > 0 ? name_style = {
	        left: -28 - avatar_size * .5 - name_width,
	        borderTopLeftRadius: 16,
	        paddingRight: avatar_size * .75,
	        paddingLeft: 18
	      } : name_style = {
	        left: avatar_size / 4,
	        borderTopRightRadius: 16,
	        paddingLeft: avatar_size * .75,
	        paddingRight: 18
	      }, DIV({
	        style: {
	          left: left,
	          position: 'absolute',
	          zIndex: 1
	        }
	      }, DIV(null, Avatar({
	        key: user,
	        user: user,
	        hide_tooltip: true,
	        style: {
	          position: 'absolute',
	          width: avatar_size,
	          height: avatar_size,
	          top: -avatar_size * .75,
	          left: -avatar_size / 4,
	          zIndex: 99,
	          border: "3px solid " + focus_blue
	        }
	      }), DIV({
	        style: _.extend(name_style, {
	          position: 'absolute',
	          backgroundColor: focus_blue,
	          paddingTop: 8,
	          paddingBottom: 8,
	          color: 'white',
	          top: -58,
	          width: name_width + 10 + 18 + avatar_size * .75 + 10
	        })
	      }, SPAN({
	        style: {
	          fontSize: 30
	        }
	      }, title))))));
	    } else {
	      return SPAN(null);
	    }
	  }
	});

	buildPointsList = function(proposal, valence, sort_field, filter_included) {
	  var filtered, filtered_out, hist, i, included_points, inclusions, len, o, opinions, pnt, point, point_inclusions_per_point, points, results, sort;
	  sort_field = sort_field || 'score';
	  points = fetch("/page/" + proposal.slug).points || [];
	  opinions = fetch(proposal).opinions;
	  filtered_out = fetch('filtered');
	  if (filtered_out.users) {
	    filtered = true;
	    opinions = (function() {
	      var i, len, ref, results;
	      results = [];
	      for (i = 0, len = opinions.length; i < len; i++) {
	        o = opinions[i];
	        if (!((ref = filtered_out.users) != null ? ref[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    })();
	  }
	  points = (function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = points.length; i < len; i++) {
	      pnt = points[i];
	      if (pnt.is_pro === (valence === 'pros')) {
	        results.push(pnt);
	      }
	    }
	    return results;
	  })();
	  if (filter_included) {
	    included_points = fetch(proposal.your_opinion).point_inclusions;
	    points = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = points.length; i < len; i++) {
	        pnt = points[i];
	        if (!_.contains(included_points, pnt.key)) {
	          results.push(pnt);
	        }
	      }
	      return results;
	    })();
	  }
	  hist = fetch(namespaced_key('histogram', proposal));
	  if (hist.selected_opinion) {
	    opinions = [hist.selected_opinion];
	    filtered = true;
	  } else if (hist.selected_opinions) {
	    opinions = hist.selected_opinions;
	    filtered = true;
	  }
	  point_inclusions_per_point = {};
	  _.each(opinions, (function(_this) {
	    return function(opinion_key) {
	      var i, len, opinion, point, ref, results;
	      opinion = fetch(opinion_key);
	      if (opinion.point_inclusions) {
	        ref = opinion.point_inclusions;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          point = ref[i];
	          point_inclusions_per_point[point] || (point_inclusions_per_point[point] = 0);
	          results.push(point_inclusions_per_point[point] += 1);
	        }
	        return results;
	      }
	    };
	  })(this));
	  if (opinions.length < 2) {
	    for (point in point_inclusions_per_point) {
	      inclusions = point_inclusions_per_point[point];
	      if (fetch(point).hide_name) {
	        delete point_inclusions_per_point[point];
	      }
	    }
	  }
	  points = (function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = points.length; i < len; i++) {
	      pnt = points[i];
	      if (pnt.key in point_inclusions_per_point) {
	        results.push(pnt);
	      }
	    }
	    return results;
	  })();
	  sort = function(pnt) {
	    if (filtered) {
	      return -point_inclusions_per_point[pnt.key];
	    } else {
	      return -pnt[sort_field];
	    }
	  };
	  points = _.sortBy(points, sort);
	  results = [];
	  for (i = 0, len = points.length; i < len; i++) {
	    pnt = points[i];
	    results.push(pnt.key);
	  }
	  return results;
	};

	PointsList = ReactiveComponent({
	  displayName: 'PointsList',
	  render: function() {
	    var get_heading, header_height, header_prefix, header_style, heading, mode, other_heading, pnt, point, points, wrapper, your_points;
	    points = (function() {
	      var i, len, ref, results;
	      ref = this.props.points;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        pnt = ref[i];
	        results.push(fetch(pnt));
	      }
	      return results;
	    }).call(this);
	    mode = get_proposal_mode();
	    your_points = this.data();
	    if (this.props.points_editable && !your_points.editing_points) {
	      _.extend(your_points, {
	        editing_points: [],
	        adding_new_point: false
	      });
	      save(your_points);
	    }
	    if (this.props.rendered_as === 'community_point') {
	      header_prefix = mode === 'results' ? 'top' : "other";
	      header_style = {
	        width: POINT_WIDTH(),
	        fontSize: 30,
	        position: 'relative',
	        left: this.props.valence === 'cons' ? -20 : 20
	      };
	      wrapper = this.drawCommunityPoints;
	    } else {
	      header_prefix = 'your';
	      header_style = {
	        width: POINT_WIDTH(),
	        fontWeight: 700,
	        color: focus_blue,
	        fontSize: 30
	      };
	      wrapper = this.drawYourPoints;
	    }
	    get_heading = (function(_this) {
	      return function(valence) {
	        var heading;
	        heading = customization("point_labels." + header_prefix + "_" + valence + "_header", _this.proposal);
	        if (!heading) {
	          heading = customization("point_labels." + header_prefix + "_header", _this.proposal).replace('--valences--', capitalize(customization("point_labels." + valence, _this.proposal))).replace('--valence--', capitalize(customization("point_labels." + (valence.substring(0, 3)), _this.proposal)));
	        }
	        return heading;
	      };
	    })(this);
	    heading = get_heading(this.props.valence);
	    other_heading = get_heading(this.props.valence === 'pros' ? 'cons' : 'pros');
	    header_height = Math.max(heightWhenRendered(heading, header_style), heightWhenRendered(other_heading, header_style));
	    return wrapper([
	      DIV({
	        className: 'points_heading_label',
	        style: _.extend(header_style, {
	          textAlign: 'center',
	          marginBottom: 18,
	          marginTop: 7,
	          height: header_height
	        })
	      }, heading), UL(null, (function() {
	        var i, len, ref, results;
	        if (points.length > 0 || this.props.rendered_as === 'decision_board_point') {
	          results = [];
	          for (i = 0, len = points.length; i < len; i++) {
	            point = points[i];
	            if (this.props.points_editable && (ref = point.key, indexOf.call(your_points.editing_points, ref) >= 0) && !browser.is_mobile) {
	              results.push(EditPoint({
	                key: point.key,
	                fresh: false,
	                valence: this.props.valence,
	                your_points_key: this.props.key
	              }));
	            } else {
	              results.push(Point({
	                key: point.key,
	                rendered_as: this.props.rendered_as,
	                your_points_key: this.props.key,
	                enable_dragging: this.props.points_draggable,
	                is_new: this.props.newpoint_threshold && Date.parse(point.created_at) > this.props.newpoint_threshold
	              }));
	            }
	          }
	          return results;
	        }
	      }).call(this)), this.props.drop_target ? this.drawDropTarget() : void 0, this.props.points_editable ? this.drawAddNewPoint() : void 0
	    ]);
	  },
	  columnStandsOut: function() {
	    var contains_selection, is_editing, your_points;
	    your_points = this.data();
	    contains_selection = get_selected_point() && fetch(get_selected_point()).is_pro === (this.props.valence === 'pros');
	    is_editing = this.props.points_editable && (your_points.editing_points.length > 0 || your_points.adding_new_point);
	    return contains_selection || is_editing;
	  },
	  drawCommunityPoints: function(children) {
	    var x_pos;
	    x_pos = this.props.points_draggable ? this.props.valence === 'cons' ? 0 : DECISION_BOARD_WIDTH() : !TWO_COL() ? DECISION_BOARD_WIDTH() / 2 : 0;
	    return DIV({
	      className: "points_by_community " + this.props.valence + "_by_community",
	      style: css.crossbrowserify(_.defaults(this.props.style || {}, {
	        display: 'inline-block',
	        verticalAlign: 'top',
	        width: POINT_WIDTH(),
	        minHeight: (this.page.points.length > 4 ? jQuery(window).height() : 400),
	        zIndex: this.columnStandsOut() ? 6 : 1,
	        margin: '38px 18px 0 18px',
	        position: 'relative',
	        transition: "transform " + TRANSITION_SPEED + "ms",
	        transform: "translate(" + x_pos + "px, 0)"
	      }))
	    }, children);
	  },
	  drawYourPoints: function(children) {
	    return DIV({
	      className: "points_on_decision_board " + this.props.valence + "_on_decision_board",
	      style: _.defaults(this.props.style || {}, {
	        display: 'inline-block',
	        verticalAlign: 'top',
	        width: POINT_WIDTH(),
	        marginTop: 28,
	        position: 'relative',
	        zIndex: this.columnStandsOut() ? 6 : 1,
	        float: this.props.valence === 'pros' ? 'right' : 'left'
	      })
	    }, children);
	  },
	  drawAddNewPoint: function() {
	    var can_add_new_point, hist, hist_selection, your_points;
	    your_points = this.data();
	    can_add_new_point = permit('create point', this.proposal);
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    hist_selection = hist.selected_opinions || hist.selected_opinion;
	    if (can_add_new_point !== Permission.INSUFFICIENT_PRIVILEGES && !hist_selection) {
	      if (!your_points.adding_new_point) {
	        return DIV({
	          onClick: (function(_this) {
	            return function() {
	              if (can_add_new_point === Permission.NOT_LOGGED_IN) {
	                reset_key('auth', {
	                  form: 'create account',
	                  goal: 'Write a point',
	                  ask_questions: true
	                });
	              } else if (can_add_new_point === Permission.UNVERIFIED_EMAIL) {
	                reset_key('auth', {
	                  form: 'verify email',
	                  goal: 'Write a point',
	                  ask_questions: true
	                });
	                save(auth);
	                current_user.trying_to = 'send_verification_token';
	                save(current_user);
	              } else {
	                your_points.adding_new_point = true;
	                save(your_points);
	              }
	              return writeToLog({
	                what: 'click new point'
	              });
	            };
	          })(this)
	        }, this.props.rendered_as === 'decision_board_point' ? this.drawAddNewPointInDecisionBoard() : this.drawAddNewPointInCommunityCol());
	      } else if (!browser.is_mobile) {
	        return EditPoint({
	          key: "new_point_" + this.props.valence,
	          fresh: true,
	          valence: this.props.valence,
	          your_points_key: this.props.key
	        });
	      }
	    }
	  },
	  drawAddNewPointInCommunityCol: function() {
	    return DIV({
	      id: "add-point-" + this.props.valence,
	      style: {
	        cursor: 'pointer',
	        marginTop: 20
	      }
	    }, this.drawGhostedPoint({
	      width: POINT_WIDTH(),
	      text: "Write a new " + (capitalize(this.props.valence === 'pros' ? customization('point_labels.pro', this.proposal) : customization('point_labels.con', this.proposal))),
	      is_left: this.props.valence === 'cons',
	      style: {},
	      text_style: {
	        textDecoration: 'underline',
	        fontSize: browser.is_mobile ? 24 : void 0
	      }
	    }));
	  },
	  drawAddNewPointInDecisionBoard: function() {
	    var noun, your_points;
	    your_points = this.data();
	    noun = capitalize(this.props.valence === 'pros' ? customization('point_labels.pro', this.proposal) : customization('point_labels.con', this.proposal));
	    return DIV({
	      style: {
	        padding: '.25em 0',
	        marginTop: '1em',
	        marginLeft: this.props.drop_target ? 20 : 9,
	        fontSize: POINT_FONT_SIZE()
	      }
	    }, this.props.drop_target ? SPAN({
	      style: {
	        fontWeight: browser.high_density_display ? 300 : 400
	      }
	    }, (t('or')) + " ") : void 0, SPAN({
	      style: {
	        padding: this.props.drop_target ? '0 6px' : '0 11px 0 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: '&bull;'
	      }
	    }), A({
	      className: "write_" + this.props.valence,
	      style: {
	        textDecoration: 'underline',
	        color: focus_blue
	      }
	    }, t('write_a_new_point', {
	      noun: noun
	    })));
	  },
	  drawDropTarget: function() {
	    var drop_target_text, dt_w, left_or_right, local_proposal, noun;
	    left_or_right = this.props.valence === 'pros' ? 'right' : 'left';
	    noun = capitalize(this.props.valence === 'pros' ? customization('point_labels.pro', this.proposal) : customization('point_labels.con', this.proposal));
	    drop_target_text = t("drag_from_" + left_or_right, {
	      noun: noun
	    });
	    dt_w = POINT_WIDTH() - 24;
	    local_proposal = fetch(shared_local_key(this.proposal));
	    return DIV({
	      style: {
	        marginLeft: this.props.valence === 'cons' ? 24 : 0,
	        marginRight: this.props.valence === 'pros' ? 24 : 0,
	        position: 'relative',
	        left: this.props.valence === 'cons' ? -18 : 18
	      }
	    }, this.drawGhostedPoint({
	      width: POINT_WIDTH() - 24,
	      text: drop_target_text,
	      is_left: this.props.valence === 'cons',
	      style: {
	        opacity: local_proposal.has_focus === 'edit point' ? .1 : void 0
	      },
	      text_style: {}
	    }));
	  },
	  drawGhostedPoint: function(props) {
	    var h, is_left, local_proposal, mouth_style, padding_x, padding_y, s_h, s_w, stroke_width, style, text, text_height, text_style, w, width;
	    text_style = props.text_style || {};
	    style = props.style || {};
	    width = props.width;
	    text = props.text;
	    is_left = props.is_left;
	    w = width;
	    padding_x = 18;
	    padding_y = 12;
	    text_height = heightWhenRendered(text, {
	      'font-size': POINT_FONT_SIZE(),
	      'width': w - 2 * padding_x
	    });
	    stroke_width = 1;
	    h = Math.max(text_height + 2 * padding_y, 85);
	    s_w = 8;
	    s_h = 6;
	    mouth_style = {
	      top: 8,
	      position: 'absolute'
	    };
	    if (is_left) {
	      mouth_style['transform'] = 'rotate(270deg) scaleX(-1)';
	      mouth_style['left'] = -POINT_MOUTH_WIDTH + stroke_width + 1;
	    } else {
	      mouth_style['transform'] = 'rotate(90deg)';
	      mouth_style['right'] = -POINT_MOUTH_WIDTH + stroke_width + 1;
	    }
	    local_proposal = fetch(shared_local_key(this.proposal));
	    return DIV({
	      style: _.defaults(style, {
	        position: 'relative',
	        opacity: local_proposal.has_focus === 'edit point' ? .1 : void 0
	      })
	    }, SVG({
	      width: w,
	      height: h
	    }, DEFS(null, PATTERN({
	      id: "drop-stripes-" + is_left + "-" + width,
	      width: s_w,
	      height: s_h,
	      patternUnits: "userSpaceOnUse"
	    }, RECT({
	      width: '100%',
	      height: '100%',
	      fill: 'white'
	    }), (function(_this) {
	      return function() {
	        var cross_hatch, i, idx, len, ref, results, x1, x2, y1, y2;
	        if (is_left) {
	          cross_hatch = [[-s_w / 2, 0, s_w, 1.5 * s_h], [0, -s_h / 2, 1.5 * s_w, s_h]];
	        } else {
	          cross_hatch = [[1.5 * s_w, 0, 0, 1.5 * s_h], [s_w, -s_h / 2, -s_w / 2, s_h]];
	        }
	        results = [];
	        for (idx = i = 0, len = cross_hatch.length; i < len; idx = ++i) {
	          ref = cross_hatch[idx], x1 = ref[0], y1 = ref[1], x2 = ref[2], y2 = ref[3];
	          results.push(LINE({
	            x1: x1,
	            y1: y1,
	            x2: x2,
	            y2: y2,
	            stroke: focus_blue,
	            strokeWidth: 1,
	            strokeOpacity: .2
	          }));
	        }
	        return results;
	      };
	    })(this)())), RECT({
	      width: w - 2 * stroke_width,
	      height: h - 2 * stroke_width,
	      x: stroke_width,
	      y: stroke_width,
	      rx: 16,
	      ry: 16,
	      fill: "url(#drop-stripes-" + is_left + "-" + width + ")",
	      stroke: focus_blue,
	      strokeWidth: stroke_width,
	      strokeDasharray: '4, 3'
	    })), SPAN({
	      style: _.defaults({}, text_style, {
	        fontSize: POINT_FONT_SIZE(),
	        position: 'absolute',
	        top: padding_y,
	        left: padding_x,
	        width: w - 2 * padding_x
	      })
	    }, text), Bubblemouth({
	      apex_xfrac: 0,
	      width: POINT_MOUTH_WIDTH,
	      height: POINT_MOUTH_WIDTH,
	      fill: '#F9FBFD',
	      stroke: focus_blue,
	      stroke_width: 6,
	      dash_array: '24, 18',
	      style: css.crossbrowserify(mouth_style)
	    }));
	  }
	});

	About = ReactiveComponent({
	  displayName: 'About',
	  componentWillMount: function() {
	    this.local.embed_html_directly = true;
	    this.local.html = null;
	    return this.local.save;
	  },
	  componentDidMount: function() {
	    return this.handleContent();
	  },
	  componentDidUpdate: function() {
	    return this.handleContent();
	  },
	  handleContent: function() {
	    var $el, iframe;
	    $el = $(this.getDOMNode());
	    if (this.local.embed_html_directly) {
	      if (this.local.html) {
	        return $el.find('.embedded_about_html').html(this.local.html);
	      }
	    } else {
	      $el.prop('tagName').toLowerCase() === 'iframe';
	      iframe = $el[0];
	      return _.delay(function() {
	        var e, error;
	        try {
	          return iframe.height = iframe.contentWindow.document.body.scrollHeight + "px";
	        } catch (error) {
	          e = error;
	          iframe.height = "2000px";
	          console.error('http/https mismatch for about page. Should work in production.');
	          return console.error(e);
	        }
	      }, 1000);
	    }
	  },
	  render: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (this.local.embed_html_directly && !this.local.html && subdomain.about_page_url) {
	      $.get(subdomain.about_page_url, (function(_this) {
	        return function(response) {
	          _this.local.html = response;
	          return save(_this.local);
	        };
	      })(this));
	    }
	    return DIV({
	      style: {
	        marginTop: 20
	      }
	    }, !subdomain.about_page_url ? DIV(null, 'No about page defined') : !this.local.embed_html_directly ? IFRAME({
	      src: subdomain.about_page_url,
	      width: CONTENT_WIDTH(),
	      style: {
	        display: 'block',
	        margin: 'auto'
	      }
	    }) : DIV({
	      className: 'embedded_about_html'
	    }));
	  }
	});

	LocationTransition = ReactiveComponent({
	  displayName: 'locationTransition',
	  render: function() {
	    var auth, loc;
	    loc = fetch('location');
	    if (this.last_location !== loc.url) {
	      auth = fetch('auth');
	      if (loc.url === '/edit_profile' && auth.form !== 'edit profile') {
	        reset_key(auth, {
	          form: 'edit profile',
	          ask_questions: true
	        });
	      } else if (auth.form) {
	        reset_key(auth);
	      }
	      this.last_location = loc.url;
	    }
	    return SPAN(null);
	  }
	});

	AuthTransition = ReactiveComponent({
	  displayName: 'Computer',
	  render: function() {
	    var can_opine, current_user, i, len, opinion, opinion_key, ref, remaining_opinions;
	    current_user = fetch('/current_user');
	    if (current_user.csrf) {
	      arest.csrf(current_user.csrf);
	    }
	    if (this.root.opinions_to_publish.length > 0) {
	      remaining_opinions = [];
	      ref = this.root.opinions_to_publish;
	      for (i = 0, len = ref.length; i < len; i++) {
	        opinion_key = ref[i];
	        opinion = fetch(opinion_key);
	        can_opine = permit('publish opinion', opinion.proposal);
	        if (can_opine > 0 && !opinion.published) {
	          opinion.published = true;
	          save(opinion);
	        } else {
	          remaining_opinions.push(opinion_key);
	        }
	      }
	      if (remaining_opinions.length !== this.root.opinions_to_publish.length) {
	        this.root.opinions_to_publish = remaining_opinions;
	        save(this.root);
	      }
	    }
	    if (current_user.needs_to_complete_profile) {
	      reset_key('auth', {
	        key: 'auth',
	        form: 'create account via invitation',
	        goal: 'Complete registration',
	        ask_questions: true
	      });
	    } else if (current_user.needs_to_verify && !window.send_verification_token) {
	      current_user.trying_to = 'send_verification_token';
	      save(current_user);
	      window.send_verification_token = true;
	      reset_key('auth', {
	        key: 'auth',
	        form: 'verify email',
	        goal: 'confirm you control this email',
	        ask_questions: false
	      });
	    }
	    return SPAN(null);
	  }
	});

	Page = ReactiveComponent({
	  displayName: 'Page',
	  mixins: [AccessControlled],
	  render: function() {
	    var auth, loc, subdomain;
	    subdomain = fetch('/subdomain');
	    loc = fetch('location');
	    auth = fetch('auth');
	    return DIV({
	      style: {
	        position: 'relative',
	        zIndex: 1,
	        minHeight: subdomain.name !== 'livingvotersguide' ? 200 : void 0,
	        margin: 'auto'
	      }
	    }, (function() {
	      var ref;
	      if (auth.form) {
	        return Auth();
	      } else if (!this.accessGranted()) {
	        return SPAN(null);
	      } else if (loc.url.match(/(.+)\/edit/)) {
	        return EditProposal({
	          key: loc.url.match(/(.+)\/edit/)[1],
	          fresh: false
	        });
	      } else {
	        switch (loc.url) {
	          case '/':
	            return Homepage({
	              key: 'homepage'
	            });
	          case '/about':
	            return About();
	          case '/proposal/new':
	            return EditProposal({
	              key: "new_proposal",
	              fresh: true
	            });
	          case '/dashboard/email_notifications':
	            return Notifications({
	              key: '/page/dashboard/email_notifications'
	            });
	          case '/dashboard/assessment':
	            return FactcheckDash({
	              key: "/page/dashboard/assessment"
	            });
	          case '/dashboard/import_data':
	            return ImportDataDash({
	              key: "/page/dashboard/import_data"
	            });
	          case '/dashboard/moderate':
	            return ModerationDash({
	              key: "/page/dashboard/moderate"
	            });
	          case '/dashboard/application':
	            return AppSettingsDash({
	              key: "/page/dashboard/application"
	            });
	          case '/dashboard/roles':
	            return SubdomainRoles({
	              key: "/page/dashboard/roles"
	            });
	          case '/dashboard/tags':
	            return UserTags({
	              key: "/page/dashboard/tags"
	            });
	          default:
	            if (((ref = this.page) != null ? ref.proposal : void 0) != null) {
	              return Proposal({
	                key: this.page.proposal
	              });
	            } else {
	              return LOADING_INDICATOR;
	            }
	        }
	      }
	    }).call(this));
	  }
	});

	Root = ReactiveComponent({
	  displayName: 'Root',
	  render: function() {
	    var app, current_user, loc, subdomain;
	    loc = fetch('location');
	    app = fetch('/application');
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    return DIV({
	      onTouchMove: function() {
	        window.is_swipping = true;
	        return true;
	      },
	      onTouchEnd: function() {
	        window.is_swipping = false;
	        return true;
	      },
	      style: {
	        width: DOCUMENT_WIDTH()
	      },
	      onClick: this.resetSelection
	    }, StateDash(), StateGraph(), AuthTransition(), LocationTransition(), BrowserLocation(), !subdomain.name ? LOADING_INDICATOR : DIV({
	      style: {
	        backgroundColor: 'white',
	        overflowX: 'hidden'
	      }
	    }, BrowserHacks(), Header({
	      key: 'page_header'
	    }), Page({
	      key: "/page" + loc.url
	    }), Footer({
	      key: 'page_footer'
	    })), Tooltip(), app.dev ? Development() : void 0, current_user.is_super_admin || app.godmode ? GodMode() : void 0);
	  },
	  resetSelection: function(e) {
	    var hist, loc, page, selected, wysiwyg_editor;
	    loc = fetch('location');
	    page = fetch("/page" + loc.url);
	    if (!fetch('auth').form && page.proposal) {
	      hist = fetch(namespaced_key('histogram', page.proposal));
	      if (get_selected_point()) {
	        window.writeToLog({
	          what: 'deselected a point',
	          details: {
	            point: get_selected_point()
	          }
	        });
	        delete loc.query_params.selected;
	        save(loc);
	      } else if (hist.selected_opinions || hist.selected_opinion) {
	        if (hist.dragging) {
	          hist.dragging = false;
	        } else {
	          hist.selected_opinion = null;
	          hist.selected_opinions = null;
	          hist.selected_opinion_value = null;
	        }
	        save(hist);
	      }
	    }
	    wysiwyg_editor = fetch('wysiwyg_editor');
	    if (wysiwyg_editor.showing) {
	      selected = document.getSelection();
	      if (selected.isCollapsed) {
	        wysiwyg_editor.showing = false;
	        return save(wysiwyg_editor);
	      }
	    }
	  }
	});

	window.Point = Point;

	window.Comment = Comment;

	window.Franklin = Root;

	__webpack_require__(29);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	//     Underscore.js 1.5.2
	//     http://underscorejs.org
	//     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.

	(function() {

	  // Baseline setup
	  // --------------

	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;

	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;

	  // Establish the object that gets returned to break out of a loop iteration.
	  var breaker = {};

	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    concat           = ArrayProto.concat,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;

	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeForEach      = ArrayProto.forEach,
	    nativeMap          = ArrayProto.map,
	    nativeReduce       = ArrayProto.reduce,
	    nativeReduceRight  = ArrayProto.reduceRight,
	    nativeFilter       = ArrayProto.filter,
	    nativeEvery        = ArrayProto.every,
	    nativeSome         = ArrayProto.some,
	    nativeIndexOf      = ArrayProto.indexOf,
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;

	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };

	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object via a string identifier,
	  // for Closure Compiler "advanced" mode.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }

	  // Current version.
	  _.VERSION = '1.5.2';

	  // Collection Functions
	  // --------------------

	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.
	  var each = _.each = _.forEach = function(obj, iterator, context) {
	    if (obj == null) return;
	    if (nativeForEach && obj.forEach === nativeForEach) {
	      obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, length = obj.length; i < length; i++) {
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (var i = 0, length = keys.length; i < length; i++) {
	        if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
	      }
	    }
	  };

	  // Return the results of applying the iterator to each element.
	  // Delegates to **ECMAScript 5**'s native `map` if available.
	  _.map = _.collect = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	    each(obj, function(value, index, list) {
	      results.push(iterator.call(context, value, index, list));
	    });
	    return results;
	  };

	  var reduceError = 'Reduce of empty array with no initial value';

	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduce && obj.reduce === nativeReduce) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
	    }
	    each(obj, function(value, index, list) {
	      if (!initial) {
	        memo = value;
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, value, index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };

	  // The right-associative version of reduce, also known as `foldr`.
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
	    }
	    var length = obj.length;
	    if (length !== +length) {
	      var keys = _.keys(obj);
	      length = keys.length;
	    }
	    each(obj, function(value, index, list) {
	      index = keys ? keys[--length] : --length;
	      if (!initial) {
	        memo = obj[index];
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, obj[index], index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };

	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, iterator, context) {
	    var result;
	    any(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };

	  // Return all the elements that pass a truth test.
	  // Delegates to **ECMAScript 5**'s native `filter` if available.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
	    each(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) results.push(value);
	    });
	    return results;
	  };

	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, iterator, context) {
	    return _.filter(obj, function(value, index, list) {
	      return !iterator.call(context, value, index, list);
	    }, context);
	  };

	  // Determine whether all of the elements match a truth test.
	  // Delegates to **ECMAScript 5**'s native `every` if available.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = true;
	    if (obj == null) return result;
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
	    each(obj, function(value, index, list) {
	      if (!(result = result && iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };

	  // Determine if at least one element in the object matches a truth test.
	  // Delegates to **ECMAScript 5**'s native `some` if available.
	  // Aliased as `any`.
	  var any = _.some = _.any = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = false;
	    if (obj == null) return result;
	    if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
	    each(obj, function(value, index, list) {
	      if (result || (result = iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };

	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
	    return any(obj, function(value) {
	      return value === target;
	    });
	  };

	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };

	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, function(value){ return value[key]; });
	  };

	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs, first) {
	    if (_.isEmpty(attrs)) return first ? void 0 : [];
	    return _[first ? 'find' : 'filter'](obj, function(value) {
	      for (var key in attrs) {
	        if (attrs[key] !== value[key]) return false;
	      }
	      return true;
	    });
	  };

	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.where(obj, attrs, true);
	  };

	  // Return the maximum element or (element-based computation).
	  // Can't optimize arrays of integers longer than 65,535 elements.
	  // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
	  _.max = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.max.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return -Infinity;
	    var result = {computed : -Infinity, value: -Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed > result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };

	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.min.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return Infinity;
	    var result = {computed : Infinity, value: Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed < result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };

	  // Shuffle an array, using the modern version of the 
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisherâ€“Yates_shuffle).
	  _.shuffle = function(obj) {
	    var rand;
	    var index = 0;
	    var shuffled = [];
	    each(obj, function(value) {
	      rand = _.random(index++);
	      shuffled[index - 1] = shuffled[rand];
	      shuffled[rand] = value;
	    });
	    return shuffled;
	  };

	  // Sample **n** random values from an array.
	  // If **n** is not specified, returns a single random element from the array.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (arguments.length < 2 || guard) {
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };

	  // An internal function to generate lookup iterators.
	  var lookupIterator = function(value) {
	    return _.isFunction(value) ? value : function(obj){ return obj[value]; };
	  };

	  // Sort the object's values by a criterion produced by an iterator.
	  _.sortBy = function(obj, value, context) {
	    var iterator = lookupIterator(value);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iterator.call(context, value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };

	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, value, context) {
	      var result = {};
	      var iterator = value == null ? _.identity : lookupIterator(value);
	      each(obj, function(value, index) {
	        var key = iterator.call(context, value, index, obj);
	        behavior(result, key, value);
	      });
	      return result;
	    };
	  };

	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, key, value) {
	    (_.has(result, key) ? result[key] : (result[key] = [])).push(value);
	  });

	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, key, value) {
	    result[key] = value;
	  });

	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, key) {
	    _.has(result, key) ? result[key]++ : result[key] = 1;
	  });

	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iterator, context) {
	    iterator = iterator == null ? _.identity : lookupIterator(iterator);
	    var value = iterator.call(context, obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
	    }
	    return low;
	  };

	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };

	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
	  };

	  // Array Functions
	  // ---------------

	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    return (n == null) || guard ? array[0] : slice.call(array, 0, n);
	  };

	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
	  };

	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n == null) || guard) {
	      return array[array.length - 1];
	    } else {
	      return slice.call(array, Math.max(array.length - n, 0));
	    }
	  };

	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, (n == null) || guard ? 1 : n);
	  };

	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };

	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, output) {
	    if (shallow && _.every(input, _.isArray)) {
	      return concat.apply(output, input);
	    }
	    each(input, function(value) {
	      if (_.isArray(value) || _.isArguments(value)) {
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);
	      } else {
	        output.push(value);
	      }
	    });
	    return output;
	  };

	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, []);
	  };

	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };

	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {
	    if (_.isFunction(isSorted)) {
	      context = iterator;
	      iterator = isSorted;
	      isSorted = false;
	    }
	    var initial = iterator ? _.map(array, iterator, context) : array;
	    var results = [];
	    var seen = [];
	    each(initial, function(value, index) {
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
	        seen.push(value);
	        results.push(array[index]);
	      }
	    });
	    return results;
	  };

	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(_.flatten(arguments, true));
	  };

	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var rest = slice.call(arguments, 1);
	    return _.filter(_.uniq(array), function(item) {
	      return _.every(rest, function(other) {
	        return _.indexOf(other, item) >= 0;
	      });
	    });
	  };

	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
	    return _.filter(array, function(value){ return !_.contains(rest, value); });
	  };

	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    var length = _.max(_.pluck(arguments, "length").concat(0));
	    var results = new Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(arguments, '' + i);
	    }
	    return results;
	  };

	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, length = list.length; i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };

	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
	  // we need this function. Return the position of the first occurrence of an
	  // item in an array, or -1 if the item is not included in the array.
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, length = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
	    for (; i < length; i++) if (array[i] === item) return i;
	    return -1;
	  };

	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var hasIndex = from != null;
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
	    }
	    var i = (hasIndex ? from : array.length);
	    while (i--) if (array[i] === item) return i;
	    return -1;
	  };

	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = arguments[2] || 1;

	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var idx = 0;
	    var range = new Array(length);

	    while(idx < length) {
	      range[idx++] = start;
	      start += step;
	    }

	    return range;
	  };

	  // Function (ahem) Functions
	  // ------------------

	  // Reusable constructor function for prototype setting.
	  var ctor = function(){};

	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    var args, bound;
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError;
	    args = slice.call(arguments, 2);
	    return bound = function() {
	      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
	      ctor.prototype = func.prototype;
	      var self = new ctor;
	      ctor.prototype = null;
	      var result = func.apply(self, args.concat(slice.call(arguments)));
	      if (Object(result) === result) return result;
	      return self;
	    };
	  };

	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context.
	  _.partial = function(func) {
	    var args = slice.call(arguments, 1);
	    return function() {
	      return func.apply(this, args.concat(slice.call(arguments)));
	    };
	  };

	  // Bind all of an object's methods to that object. Useful for ensuring that
	  // all callbacks defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var funcs = slice.call(arguments, 1);
	    if (funcs.length === 0) throw new Error("bindAll must be passed function names");
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
	    return obj;
	  };

	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memo = {};
	    hasher || (hasher = _.identity);
	    return function() {
	      var key = hasher.apply(this, arguments);
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
	    };
	  };

	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){ return func.apply(null, args); }, wait);
	  };

	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };

	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    options || (options = {});
	    var later = function() {
	      previous = options.leading === false ? 0 : new Date;
	      timeout = null;
	      result = func.apply(context, args);
	    };
	    return function() {
	      var now = new Date;
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };

	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = new Date();
	      var later = function() {
	        var last = (new Date()) - timestamp;
	        if (last < wait) {
	          timeout = setTimeout(later, wait - last);
	        } else {
	          timeout = null;
	          if (!immediate) result = func.apply(context, args);
	        }
	      };
	      var callNow = immediate && !timeout;
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	      }
	      if (callNow) result = func.apply(context, args);
	      return result;
	    };
	  };

	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = function(func) {
	    var ran = false, memo;
	    return function() {
	      if (ran) return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };

	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return function() {
	      var args = [func];
	      push.apply(args, arguments);
	      return wrapper.apply(this, args);
	    };
	  };

	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments;
	      for (var i = funcs.length - 1; i >= 0; i--) {
	        args = [funcs[i].apply(this, args)];
	      }
	      return args[0];
	    };
	  };

	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };

	  // Object Functions
	  // ----------------

	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = nativeKeys || function(obj) {
	    if (obj !== Object(obj)) throw new TypeError('Invalid object');
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    return keys;
	  };

	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = new Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };

	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = new Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };

	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };

	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };

	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };

	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    each(keys, function(key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  };

	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!_.contains(keys, key)) copy[key] = obj[key];
	    }
	    return copy;
	  };

	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          if (obj[prop] === void 0) obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };

	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };

	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };

	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a == 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className != toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, dates, and booleans are compared by value.
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return a == String(b);
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
	        // other numeric values.
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a == +b;
	      // RegExps are compared by their source patterns and flags.
	      case '[object RegExp]':
	        return a.source == b.source &&
	               a.global == b.global &&
	               a.multiline == b.multiline &&
	               a.ignoreCase == b.ignoreCase;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] == a) return bStack[length] == b;
	    }
	    // Objects with different constructors are not equivalent, but `Object`s
	    // from different frames are.
	    var aCtor = a.constructor, bCtor = b.constructor;
	    if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
	                             _.isFunction(bCtor) && (bCtor instanceof bCtor))) {
	      return false;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size = 0, result = true;
	    // Recursively compare objects and arrays.
	    if (className == '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size == b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Deep compare objects.
	      for (var key in a) {
	        if (_.has(a, key)) {
	          // Count the expected number of properties.
	          size++;
	          // Deep compare each member.
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	      // Ensure that both objects contain the same number of properties.
	      if (result) {
	        for (key in b) {
	          if (_.has(b, key) && !(size--)) break;
	        }
	        result = !size;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };

	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };

	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };

	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };

	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };

	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    return obj === Object(obj);
	  };

	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) == '[object ' + name + ']';
	    };
	  });

	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return !!(obj && _.has(obj, 'callee'));
	    };
	  }

	  // Optimize `isFunction` if appropriate.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj === 'function';
	    };
	  }

	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };

	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj != +obj;
	  };

	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
	  };

	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };

	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };

	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return hasOwnProperty.call(obj, key);
	  };

	  // Utility Functions
	  // -----------------

	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };

	  // Keep the identity function around for default iterators.
	  _.identity = function(value) {
	    return value;
	  };

	  // Run a function **n** times.
	  _.times = function(n, iterator, context) {
	    var accum = Array(Math.max(0, n));
	    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
	    return accum;
	  };

	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };

	  // List of HTML entities for escaping.
	  var entityMap = {
	    escape: {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#x27;'
	    }
	  };
	  entityMap.unescape = _.invert(entityMap.escape);

	  // Regexes containing the keys and values listed immediately above.
	  var entityRegexes = {
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
	  };

	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  _.each(['escape', 'unescape'], function(method) {
	    _[method] = function(string) {
	      if (string == null) return '';
	      return ('' + string).replace(entityRegexes[method], function(match) {
	        return entityMap[method][match];
	      });
	    };
	  });

	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return void 0;
	    var value = object[property];
	    return _.isFunction(value) ? value.call(object) : value;
	  };

	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };

	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };

	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };

	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;

	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\t':     't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;

	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  _.template = function(text, data, settings) {
	    var render;
	    settings = _.defaults({}, settings, _.templateSettings);

	    // Combine delimiters into one regular expression via alternation.
	    var matcher = new RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');

	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset)
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });

	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      }
	      if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      }
	      if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	      index = offset + match.length;
	      return match;
	    });
	    source += "';\n";

	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + "return __p;\n";

	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }

	    if (data) return render(data, _);
	    var template = function(data) {
	      return render.call(this, data, _);
	    };

	    // Provide the compiled function source as a convenience for precompilation.
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';

	    return template;
	  };

	  // Add a "chain" function, which will delegate to the wrapper.
	  _.chain = function(obj) {
	    return _(obj).chain();
	  };

	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.

	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };

	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);

	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });

	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });

	  _.extend(_.prototype, {

	    // Start chaining a wrapped Underscore object.
	    chain: function() {
	      this._chain = true;
	      return this;
	    },

	    // Extracts the result from a wrapped and chained object.
	    value: function() {
	      return this._wrapped;
	    }

	  });

	}).call(this);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * jQuery JavaScript Library v2.1.1
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-05-01T17:11Z
	 */

	(function( global, factory ) {

	  if ( typeof module === "object" && typeof module.exports === "object" ) {
	    // For CommonJS and CommonJS-like environments where a proper window is present,
	    // execute the factory and get jQuery
	    // For environments that do not inherently posses a window with a document
	    // (such as Node.js), expose a jQuery-making factory as module.exports
	    // This accentuates the need for the creation of a real window
	    // e.g. var jQuery = require("jquery")(window);
	    // See ticket #14549 for more info
	    module.exports = global.document ?
	      factory( global, true ) :
	      function( w ) {
	        if ( !w.document ) {
	          throw new Error( "jQuery requires a window with a document" );
	        }
	        return factory( w );
	      };
	  } else {
	    factory( global );
	  }

	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

	// Can't do this because several apps including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	// Support: Firefox 18+
	//

	var arr = [];

	var slice = arr.slice;

	var concat = arr.concat;

	var push = arr.push;

	var indexOf = arr.indexOf;

	var class2type = {};

	var toString = class2type.toString;

	var hasOwn = class2type.hasOwnProperty;

	var support = {};



	var
	  // Use the correct document accordingly with window argument (sandbox)
	  document = window.document,

	  version = "2.1.1",

	  // Define a local copy of jQuery
	  jQuery = function( selector, context ) {
	    // The jQuery object is actually just the init constructor 'enhanced'
	    // Need init if jQuery is called (just allow error to be thrown if not included)
	    return new jQuery.fn.init( selector, context );
	  },

	  // Support: Android<4.1
	  // Make sure we trim BOM and NBSP
	  rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	  // Matches dashed string for camelizing
	  rmsPrefix = /^-ms-/,
	  rdashAlpha = /-([\da-z])/gi,

	  // Used by jQuery.camelCase as callback to replace()
	  fcamelCase = function( all, letter ) {
	    return letter.toUpperCase();
	  };

	jQuery.fn = jQuery.prototype = {
	  // The current version of jQuery being used
	  jquery: version,

	  constructor: jQuery,

	  // Start with an empty selector
	  selector: "",

	  // The default length of a jQuery object is 0
	  length: 0,

	  toArray: function() {
	    return slice.call( this );
	  },

	  // Get the Nth element in the matched element set OR
	  // Get the whole matched element set as a clean array
	  get: function( num ) {
	    return num != null ?

	      // Return just the one element from the set
	      ( num < 0 ? this[ num + this.length ] : this[ num ] ) :

	      // Return all the elements in a clean array
	      slice.call( this );
	  },

	  // Take an array of elements and push it onto the stack
	  // (returning the new matched element set)
	  pushStack: function( elems ) {

	    // Build a new jQuery matched element set
	    var ret = jQuery.merge( this.constructor(), elems );

	    // Add the old object onto the stack (as a reference)
	    ret.prevObject = this;
	    ret.context = this.context;

	    // Return the newly-formed element set
	    return ret;
	  },

	  // Execute a callback for every element in the matched set.
	  // (You can seed the arguments with an array of args, but this is
	  // only used internally.)
	  each: function( callback, args ) {
	    return jQuery.each( this, callback, args );
	  },

	  map: function( callback ) {
	    return this.pushStack( jQuery.map(this, function( elem, i ) {
	      return callback.call( elem, i, elem );
	    }));
	  },

	  slice: function() {
	    return this.pushStack( slice.apply( this, arguments ) );
	  },

	  first: function() {
	    return this.eq( 0 );
	  },

	  last: function() {
	    return this.eq( -1 );
	  },

	  eq: function( i ) {
	    var len = this.length,
	      j = +i + ( i < 0 ? len : 0 );
	    return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	  },

	  end: function() {
	    return this.prevObject || this.constructor(null);
	  },

	  // For internal use only.
	  // Behaves like an Array's method, not like a jQuery method.
	  push: push,
	  sort: arr.sort,
	  splice: arr.splice
	};

	jQuery.extend = jQuery.fn.extend = function() {
	  var options, name, src, copy, copyIsArray, clone,
	    target = arguments[0] || {},
	    i = 1,
	    length = arguments.length,
	    deep = false;

	  // Handle a deep copy situation
	  if ( typeof target === "boolean" ) {
	    deep = target;

	    // skip the boolean and the target
	    target = arguments[ i ] || {};
	    i++;
	  }

	  // Handle case when target is a string or something (possible in deep copy)
	  if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
	    target = {};
	  }

	  // extend jQuery itself if only one argument is passed
	  if ( i === length ) {
	    target = this;
	    i--;
	  }

	  for ( ; i < length; i++ ) {
	    // Only deal with non-null/undefined values
	    if ( (options = arguments[ i ]) != null ) {
	      // Extend the base object
	      for ( name in options ) {
	        src = target[ name ];
	        copy = options[ name ];

	        // Prevent never-ending loop
	        if ( target === copy ) {
	          continue;
	        }

	        // Recurse if we're merging plain objects or arrays
	        if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
	          if ( copyIsArray ) {
	            copyIsArray = false;
	            clone = src && jQuery.isArray(src) ? src : [];

	          } else {
	            clone = src && jQuery.isPlainObject(src) ? src : {};
	          }

	          // Never move original objects, clone them
	          target[ name ] = jQuery.extend( deep, clone, copy );

	        // Don't bring in undefined values
	        } else if ( copy !== undefined ) {
	          target[ name ] = copy;
	        }
	      }
	    }
	  }

	  // Return the modified object
	  return target;
	};

	jQuery.extend({
	  // Unique for each copy of jQuery on the page
	  expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	  // Assume jQuery is ready without the ready module
	  isReady: true,

	  error: function( msg ) {
	    throw new Error( msg );
	  },

	  noop: function() {},

	  // See test/unit/core.js for details concerning isFunction.
	  // Since version 1.3, DOM methods and functions like alert
	  // aren't supported. They return false on IE (#2968).
	  isFunction: function( obj ) {
	    return jQuery.type(obj) === "function";
	  },

	  isArray: Array.isArray,

	  isWindow: function( obj ) {
	    return obj != null && obj === obj.window;
	  },

	  isNumeric: function( obj ) {
	    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
	    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	    // subtraction forces infinities to NaN
	    return !jQuery.isArray( obj ) && obj - parseFloat( obj ) >= 0;
	  },

	  isPlainObject: function( obj ) {
	    // Not plain objects:
	    // - Any object or value whose internal [[Class]] property is not "[object Object]"
	    // - DOM nodes
	    // - window
	    if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
	      return false;
	    }

	    if ( obj.constructor &&
	        !hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
	      return false;
	    }

	    // If the function hasn't returned already, we're confident that
	    // |obj| is a plain object, created by {} or constructed with new Object
	    return true;
	  },

	  isEmptyObject: function( obj ) {
	    var name;
	    for ( name in obj ) {
	      return false;
	    }
	    return true;
	  },

	  type: function( obj ) {
	    if ( obj == null ) {
	      return obj + "";
	    }
	    // Support: Android < 4.0, iOS < 6 (functionish RegExp)
	    return typeof obj === "object" || typeof obj === "function" ?
	      class2type[ toString.call(obj) ] || "object" :
	      typeof obj;
	  },

	  // Evaluates a script in a global context
	  globalEval: function( code ) {
	    var script,
	      indirect = eval;

	    code = jQuery.trim( code );

	    if ( code ) {
	      // If the code includes a valid, prologue position
	      // strict mode pragma, execute code by injecting a
	      // script tag into the document.
	      if ( code.indexOf("use strict") === 1 ) {
	        script = document.createElement("script");
	        script.text = code;
	        document.head.appendChild( script ).parentNode.removeChild( script );
	      } else {
	      // Otherwise, avoid the DOM node creation, insertion
	      // and removal by using an indirect global eval
	        indirect( code );
	      }
	    }
	  },

	  // Convert dashed to camelCase; used by the css and data modules
	  // Microsoft forgot to hump their vendor prefix (#9572)
	  camelCase: function( string ) {
	    return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	  },

	  nodeName: function( elem, name ) {
	    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	  },

	  // args is for internal usage only
	  each: function( obj, callback, args ) {
	    var value,
	      i = 0,
	      length = obj.length,
	      isArray = isArraylike( obj );

	    if ( args ) {
	      if ( isArray ) {
	        for ( ; i < length; i++ ) {
	          value = callback.apply( obj[ i ], args );

	          if ( value === false ) {
	            break;
	          }
	        }
	      } else {
	        for ( i in obj ) {
	          value = callback.apply( obj[ i ], args );

	          if ( value === false ) {
	            break;
	          }
	        }
	      }

	    // A special, fast, case for the most common use of each
	    } else {
	      if ( isArray ) {
	        for ( ; i < length; i++ ) {
	          value = callback.call( obj[ i ], i, obj[ i ] );

	          if ( value === false ) {
	            break;
	          }
	        }
	      } else {
	        for ( i in obj ) {
	          value = callback.call( obj[ i ], i, obj[ i ] );

	          if ( value === false ) {
	            break;
	          }
	        }
	      }
	    }

	    return obj;
	  },

	  // Support: Android<4.1
	  trim: function( text ) {
	    return text == null ?
	      "" :
	      ( text + "" ).replace( rtrim, "" );
	  },

	  // results is for internal usage only
	  makeArray: function( arr, results ) {
	    var ret = results || [];

	    if ( arr != null ) {
	      if ( isArraylike( Object(arr) ) ) {
	        jQuery.merge( ret,
	          typeof arr === "string" ?
	          [ arr ] : arr
	        );
	      } else {
	        push.call( ret, arr );
	      }
	    }

	    return ret;
	  },

	  inArray: function( elem, arr, i ) {
	    return arr == null ? -1 : indexOf.call( arr, elem, i );
	  },

	  merge: function( first, second ) {
	    var len = +second.length,
	      j = 0,
	      i = first.length;

	    for ( ; j < len; j++ ) {
	      first[ i++ ] = second[ j ];
	    }

	    first.length = i;

	    return first;
	  },

	  grep: function( elems, callback, invert ) {
	    var callbackInverse,
	      matches = [],
	      i = 0,
	      length = elems.length,
	      callbackExpect = !invert;

	    // Go through the array, only saving the items
	    // that pass the validator function
	    for ( ; i < length; i++ ) {
	      callbackInverse = !callback( elems[ i ], i );
	      if ( callbackInverse !== callbackExpect ) {
	        matches.push( elems[ i ] );
	      }
	    }

	    return matches;
	  },

	  // arg is for internal usage only
	  map: function( elems, callback, arg ) {
	    var value,
	      i = 0,
	      length = elems.length,
	      isArray = isArraylike( elems ),
	      ret = [];

	    // Go through the array, translating each of the items to their new values
	    if ( isArray ) {
	      for ( ; i < length; i++ ) {
	        value = callback( elems[ i ], i, arg );

	        if ( value != null ) {
	          ret.push( value );
	        }
	      }

	    // Go through every key on the object,
	    } else {
	      for ( i in elems ) {
	        value = callback( elems[ i ], i, arg );

	        if ( value != null ) {
	          ret.push( value );
	        }
	      }
	    }

	    // Flatten any nested arrays
	    return concat.apply( [], ret );
	  },

	  // A global GUID counter for objects
	  guid: 1,

	  // Bind a function to a context, optionally partially applying any
	  // arguments.
	  proxy: function( fn, context ) {
	    var tmp, args, proxy;

	    if ( typeof context === "string" ) {
	      tmp = fn[ context ];
	      context = fn;
	      fn = tmp;
	    }

	    // Quick check to determine if target is callable, in the spec
	    // this throws a TypeError, but we will just return undefined.
	    if ( !jQuery.isFunction( fn ) ) {
	      return undefined;
	    }

	    // Simulated bind
	    args = slice.call( arguments, 2 );
	    proxy = function() {
	      return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	    };

	    // Set the guid of unique handler to the same of original handler, so it can be removed
	    proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	    return proxy;
	  },

	  now: Date.now,

	  // jQuery.support is not used in Core but other projects attach their
	  // properties to it so it needs to exist.
	  support: support
	});

	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	  class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});

	function isArraylike( obj ) {
	  var length = obj.length,
	    type = jQuery.type( obj );

	  if ( type === "function" || jQuery.isWindow( obj ) ) {
	    return false;
	  }

	  if ( obj.nodeType === 1 && length ) {
	    return true;
	  }

	  return type === "array" || length === 0 ||
	    typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v1.10.19
	 * http://sizzlejs.com/
	 *
	 * Copyright 2013 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-04-18
	 */
	(function( window ) {

	var i,
	  support,
	  Expr,
	  getText,
	  isXML,
	  tokenize,
	  compile,
	  select,
	  outermostContext,
	  sortInput,
	  hasDuplicate,

	  // Local document vars
	  setDocument,
	  document,
	  docElem,
	  documentIsHTML,
	  rbuggyQSA,
	  rbuggyMatches,
	  matches,
	  contains,

	  // Instance-specific data
	  expando = "sizzle" + -(new Date()),
	  preferredDoc = window.document,
	  dirruns = 0,
	  done = 0,
	  classCache = createCache(),
	  tokenCache = createCache(),
	  compilerCache = createCache(),
	  sortOrder = function( a, b ) {
	    if ( a === b ) {
	      hasDuplicate = true;
	    }
	    return 0;
	  },

	  // General-purpose constants
	  strundefined = typeof undefined,
	  MAX_NEGATIVE = 1 << 31,

	  // Instance methods
	  hasOwn = ({}).hasOwnProperty,
	  arr = [],
	  pop = arr.pop,
	  push_native = arr.push,
	  push = arr.push,
	  slice = arr.slice,
	  // Use a stripped-down indexOf if we can't use a native one
	  indexOf = arr.indexOf || function( elem ) {
	    var i = 0,
	      len = this.length;
	    for ( ; i < len; i++ ) {
	      if ( this[i] === elem ) {
	        return i;
	      }
	    }
	    return -1;
	  },

	  booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	  // Regular expressions

	  // Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	  whitespace = "[\\x20\\t\\r\\n\\f]",
	  // http://www.w3.org/TR/css3-syntax/#characters
	  characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	  // Loosely modeled on CSS identifier characters
	  // An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	  // Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	  identifier = characterEncoding.replace( "w", "w#" ),

	  // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	  attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
	    // Operator (capture 2)
	    "*([*^$|!~]?=)" + whitespace +
	    // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
	    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
	    "*\\]",

	  pseudos = ":(" + characterEncoding + ")(?:\\((" +
	    // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
	    // 1. quoted (capture 3; capture 4 or capture 5)
	    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	    // 2. simple (capture 6)
	    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	    // 3. anything else (capture 2)
	    ".*" +
	    ")\\)|)",

	  // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	  rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	  rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	  rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	  rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	  rpseudo = new RegExp( pseudos ),
	  ridentifier = new RegExp( "^" + identifier + "$" ),

	  matchExpr = {
	    "ID": new RegExp( "^#(" + characterEncoding + ")" ),
	    "CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
	    "TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
	    "ATTR": new RegExp( "^" + attributes ),
	    "PSEUDO": new RegExp( "^" + pseudos ),
	    "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
	      "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
	      "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
	    "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	    // For use in libraries implementing .is()
	    // We use this for POS matching in `select`
	    "needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
	      whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	  },

	  rinputs = /^(?:input|select|textarea|button)$/i,
	  rheader = /^h\d$/i,

	  rnative = /^[^{]+\{\s*\[native \w/,

	  // Easily-parseable/retrievable ID or TAG or CLASS selectors
	  rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	  rsibling = /[+~]/,
	  rescape = /'|\\/g,

	  // CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	  runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	  funescape = function( _, escaped, escapedWhitespace ) {
	    var high = "0x" + escaped - 0x10000;
	    // NaN means non-codepoint
	    // Support: Firefox<24
	    // Workaround erroneous numeric interpretation of +"0x"
	    return high !== high || escapedWhitespace ?
	      escaped :
	      high < 0 ?
	        // BMP codepoint
	        String.fromCharCode( high + 0x10000 ) :
	        // Supplemental Plane codepoint (surrogate pair)
	        String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	  };

	// Optimize for push.apply( _, NodeList )
	try {
	  push.apply(
	    (arr = slice.call( preferredDoc.childNodes )),
	    preferredDoc.childNodes
	  );
	  // Support: Android<4.0
	  // Detect silently failing push.apply
	  arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
	  push = { apply: arr.length ?

	    // Leverage slice if possible
	    function( target, els ) {
	      push_native.apply( target, slice.call(els) );
	    } :

	    // Support: IE<9
	    // Otherwise append directly
	    function( target, els ) {
	      var j = target.length,
	        i = 0;
	      // Can't trust NodeList.length
	      while ( (target[j++] = els[i++]) ) {}
	      target.length = j - 1;
	    }
	  };
	}

	function Sizzle( selector, context, results, seed ) {
	  var match, elem, m, nodeType,
	    // QSA vars
	    i, groups, old, nid, newContext, newSelector;

	  if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
	    setDocument( context );
	  }

	  context = context || document;
	  results = results || [];

	  if ( !selector || typeof selector !== "string" ) {
	    return results;
	  }

	  if ( (nodeType = context.nodeType) !== 1 && nodeType !== 9 ) {
	    return [];
	  }

	  if ( documentIsHTML && !seed ) {

	    // Shortcuts
	    if ( (match = rquickExpr.exec( selector )) ) {
	      // Speed-up: Sizzle("#ID")
	      if ( (m = match[1]) ) {
	        if ( nodeType === 9 ) {
	          elem = context.getElementById( m );
	          // Check parentNode to catch when Blackberry 4.6 returns
	          // nodes that are no longer in the document (jQuery #6963)
	          if ( elem && elem.parentNode ) {
	            // Handle the case where IE, Opera, and Webkit return items
	            // by name instead of ID
	            if ( elem.id === m ) {
	              results.push( elem );
	              return results;
	            }
	          } else {
	            return results;
	          }
	        } else {
	          // Context is not a document
	          if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
	            contains( context, elem ) && elem.id === m ) {
	            results.push( elem );
	            return results;
	          }
	        }

	      // Speed-up: Sizzle("TAG")
	      } else if ( match[2] ) {
	        push.apply( results, context.getElementsByTagName( selector ) );
	        return results;

	      // Speed-up: Sizzle(".CLASS")
	      } else if ( (m = match[3]) && support.getElementsByClassName && context.getElementsByClassName ) {
	        push.apply( results, context.getElementsByClassName( m ) );
	        return results;
	      }
	    }

	    // QSA path
	    if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	      nid = old = expando;
	      newContext = context;
	      newSelector = nodeType === 9 && selector;

	      // qSA works strangely on Element-rooted queries
	      // We can work around this by specifying an extra ID on the root
	      // and working up from there (Thanks to Andrew Dupont for the technique)
	      // IE 8 doesn't work on object elements
	      if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
	        groups = tokenize( selector );

	        if ( (old = context.getAttribute("id")) ) {
	          nid = old.replace( rescape, "\\$&" );
	        } else {
	          context.setAttribute( "id", nid );
	        }
	        nid = "[id='" + nid + "'] ";

	        i = groups.length;
	        while ( i-- ) {
	          groups[i] = nid + toSelector( groups[i] );
	        }
	        newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
	        newSelector = groups.join(",");
	      }

	      if ( newSelector ) {
	        try {
	          push.apply( results,
	            newContext.querySelectorAll( newSelector )
	          );
	          return results;
	        } catch(qsaError) {
	        } finally {
	          if ( !old ) {
	            context.removeAttribute("id");
	          }
	        }
	      }
	    }
	  }

	  // All others
	  return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}

	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *  property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *  deleting the oldest entry
	 */
	function createCache() {
	  var keys = [];

	  function cache( key, value ) {
	    // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
	    if ( keys.push( key + " " ) > Expr.cacheLength ) {
	      // Only keep the most recent entries
	      delete cache[ keys.shift() ];
	    }
	    return (cache[ key + " " ] = value);
	  }
	  return cache;
	}

	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
	  fn[ expando ] = true;
	  return fn;
	}

	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
	  var div = document.createElement("div");

	  try {
	    return !!fn( div );
	  } catch (e) {
	    return false;
	  } finally {
	    // Remove from its parent by default
	    if ( div.parentNode ) {
	      div.parentNode.removeChild( div );
	    }
	    // release memory in IE
	    div = null;
	  }
	}

	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
	  var arr = attrs.split("|"),
	    i = attrs.length;

	  while ( i-- ) {
	    Expr.attrHandle[ arr[i] ] = handler;
	  }
	}

	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
	  var cur = b && a,
	    diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
	      ( ~b.sourceIndex || MAX_NEGATIVE ) -
	      ( ~a.sourceIndex || MAX_NEGATIVE );

	  // Use IE sourceIndex if available on both nodes
	  if ( diff ) {
	    return diff;
	  }

	  // Check if b follows a
	  if ( cur ) {
	    while ( (cur = cur.nextSibling) ) {
	      if ( cur === b ) {
	        return -1;
	      }
	    }
	  }

	  return a ? 1 : -1;
	}

	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
	  return function( elem ) {
	    var name = elem.nodeName.toLowerCase();
	    return name === "input" && elem.type === type;
	  };
	}

	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
	  return function( elem ) {
	    var name = elem.nodeName.toLowerCase();
	    return (name === "input" || name === "button") && elem.type === type;
	  };
	}

	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
	  return markFunction(function( argument ) {
	    argument = +argument;
	    return markFunction(function( seed, matches ) {
	      var j,
	        matchIndexes = fn( [], seed.length, argument ),
	        i = matchIndexes.length;

	      // Match elements found at the specified indexes
	      while ( i-- ) {
	        if ( seed[ (j = matchIndexes[i]) ] ) {
	          seed[j] = !(matches[j] = seed[j]);
	        }
	      }
	    });
	  });
	}

	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
	  return context && typeof context.getElementsByTagName !== strundefined && context;
	}

	// Expose support vars for convenience
	support = Sizzle.support = {};

	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
	  // documentElement is verified for cases where it doesn't yet exist
	  // (such as loading iframes in IE - #4833)
	  var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	  return documentElement ? documentElement.nodeName !== "HTML" : false;
	};

	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
	  var hasCompare,
	    doc = node ? node.ownerDocument || node : preferredDoc,
	    parent = doc.defaultView;

	  // If no document and documentElement is available, return
	  if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
	    return document;
	  }

	  // Set our document
	  document = doc;
	  docElem = doc.documentElement;

	  // Support tests
	  documentIsHTML = !isXML( doc );

	  // Support: IE>8
	  // If iframe document is assigned to "document" variable and if iframe has been reloaded,
	  // IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	  // IE6-8 do not support the defaultView property so parent will be undefined
	  if ( parent && parent !== parent.top ) {
	    // IE11 does not have attachEvent, so all must suffer
	    if ( parent.addEventListener ) {
	      parent.addEventListener( "unload", function() {
	        setDocument();
	      }, false );
	    } else if ( parent.attachEvent ) {
	      parent.attachEvent( "onunload", function() {
	        setDocument();
	      });
	    }
	  }

	  /* Attributes
	  ---------------------------------------------------------------------- */

	  // Support: IE<8
	  // Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)
	  support.attributes = assert(function( div ) {
	    div.className = "i";
	    return !div.getAttribute("className");
	  });

	  /* getElement(s)By*
	  ---------------------------------------------------------------------- */

	  // Check if getElementsByTagName("*") returns only elements
	  support.getElementsByTagName = assert(function( div ) {
	    div.appendChild( doc.createComment("") );
	    return !div.getElementsByTagName("*").length;
	  });

	  // Check if getElementsByClassName can be trusted
	  support.getElementsByClassName = rnative.test( doc.getElementsByClassName ) && assert(function( div ) {
	    div.innerHTML = "<div class='a'></div><div class='a i'></div>";

	    // Support: Safari<4
	    // Catch class over-caching
	    div.firstChild.className = "i";
	    // Support: Opera<10
	    // Catch gEBCN failure to find non-leading classes
	    return div.getElementsByClassName("i").length === 2;
	  });

	  // Support: IE<10
	  // Check if getElementById returns elements by name
	  // The broken getElementById methods don't pick up programatically-set names,
	  // so use a roundabout getElementsByName test
	  support.getById = assert(function( div ) {
	    docElem.appendChild( div ).id = expando;
	    return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	  });

	  // ID find and filter
	  if ( support.getById ) {
	    Expr.find["ID"] = function( id, context ) {
	      if ( typeof context.getElementById !== strundefined && documentIsHTML ) {
	        var m = context.getElementById( id );
	        // Check parentNode to catch when Blackberry 4.6 returns
	        // nodes that are no longer in the document #6963
	        return m && m.parentNode ? [ m ] : [];
	      }
	    };
	    Expr.filter["ID"] = function( id ) {
	      var attrId = id.replace( runescape, funescape );
	      return function( elem ) {
	        return elem.getAttribute("id") === attrId;
	      };
	    };
	  } else {
	    // Support: IE6/7
	    // getElementById is not reliable as a find shortcut
	    delete Expr.find["ID"];

	    Expr.filter["ID"] =  function( id ) {
	      var attrId = id.replace( runescape, funescape );
	      return function( elem ) {
	        var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id");
	        return node && node.value === attrId;
	      };
	    };
	  }

	  // Tag
	  Expr.find["TAG"] = support.getElementsByTagName ?
	    function( tag, context ) {
	      if ( typeof context.getElementsByTagName !== strundefined ) {
	        return context.getElementsByTagName( tag );
	      }
	    } :
	    function( tag, context ) {
	      var elem,
	        tmp = [],
	        i = 0,
	        results = context.getElementsByTagName( tag );

	      // Filter out possible comments
	      if ( tag === "*" ) {
	        while ( (elem = results[i++]) ) {
	          if ( elem.nodeType === 1 ) {
	            tmp.push( elem );
	          }
	        }

	        return tmp;
	      }
	      return results;
	    };

	  // Class
	  Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
	    if ( typeof context.getElementsByClassName !== strundefined && documentIsHTML ) {
	      return context.getElementsByClassName( className );
	    }
	  };

	  /* QSA/matchesSelector
	  ---------------------------------------------------------------------- */

	  // QSA and matchesSelector support

	  // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	  rbuggyMatches = [];

	  // qSa(:focus) reports false when true (Chrome 21)
	  // We allow this because of a bug in IE8/9 that throws an error
	  // whenever `document.activeElement` is accessed on an iframe
	  // So, we allow :focus to pass through QSA all the time to avoid the IE error
	  // See http://bugs.jquery.com/ticket/13378
	  rbuggyQSA = [];

	  if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
	    // Build QSA regex
	    // Regex strategy adopted from Diego Perini
	    assert(function( div ) {
	      // Select is set to empty string on purpose
	      // This is to test IE's treatment of not explicitly
	      // setting a boolean content attribute,
	      // since its presence should be enough
	      // http://bugs.jquery.com/ticket/12359
	      div.innerHTML = "<select msallowclip=''><option selected=''></option></select>";

	      // Support: IE8, Opera 11-12.16
	      // Nothing should be selected when empty strings follow ^= or $= or *=
	      // The test attribute must be unknown in Opera but "safe" for WinRT
	      // http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
	      if ( div.querySelectorAll("[msallowclip^='']").length ) {
	        rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
	      }

	      // Support: IE8
	      // Boolean attributes and "value" are not treated correctly
	      if ( !div.querySelectorAll("[selected]").length ) {
	        rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
	      }

	      // Webkit/Opera - :checked should return selected option elements
	      // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
	      // IE8 throws error here and will not see later tests
	      if ( !div.querySelectorAll(":checked").length ) {
	        rbuggyQSA.push(":checked");
	      }
	    });

	    assert(function( div ) {
	      // Support: Windows 8 Native Apps
	      // The type and name attributes are restricted during .innerHTML assignment
	      var input = doc.createElement("input");
	      input.setAttribute( "type", "hidden" );
	      div.appendChild( input ).setAttribute( "name", "D" );

	      // Support: IE8
	      // Enforce case-sensitivity of name attribute
	      if ( div.querySelectorAll("[name=d]").length ) {
	        rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
	      }

	      // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
	      // IE8 throws error here and will not see later tests
	      if ( !div.querySelectorAll(":enabled").length ) {
	        rbuggyQSA.push( ":enabled", ":disabled" );
	      }

	      // Opera 10-11 does not throw on post-comma invalid pseudos
	      div.querySelectorAll("*,:x");
	      rbuggyQSA.push(",.*:");
	    });
	  }

	  if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
	    docElem.webkitMatchesSelector ||
	    docElem.mozMatchesSelector ||
	    docElem.oMatchesSelector ||
	    docElem.msMatchesSelector) )) ) {

	    assert(function( div ) {
	      // Check to see if it's possible to do matchesSelector
	      // on a disconnected node (IE 9)
	      support.disconnectedMatch = matches.call( div, "div" );

	      // This should fail with an exception
	      // Gecko does not error, returns false instead
	      matches.call( div, "[s!='']:x" );
	      rbuggyMatches.push( "!=", pseudos );
	    });
	  }

	  rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	  rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	  /* Contains
	  ---------------------------------------------------------------------- */
	  hasCompare = rnative.test( docElem.compareDocumentPosition );

	  // Element contains another
	  // Purposefully does not implement inclusive descendent
	  // As in, an element does not contain itself
	  contains = hasCompare || rnative.test( docElem.contains ) ?
	    function( a, b ) {
	      var adown = a.nodeType === 9 ? a.documentElement : a,
	        bup = b && b.parentNode;
	      return a === bup || !!( bup && bup.nodeType === 1 && (
	        adown.contains ?
	          adown.contains( bup ) :
	          a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	      ));
	    } :
	    function( a, b ) {
	      if ( b ) {
	        while ( (b = b.parentNode) ) {
	          if ( b === a ) {
	            return true;
	          }
	        }
	      }
	      return false;
	    };

	  /* Sorting
	  ---------------------------------------------------------------------- */

	  // Document order sorting
	  sortOrder = hasCompare ?
	  function( a, b ) {

	    // Flag for duplicate removal
	    if ( a === b ) {
	      hasDuplicate = true;
	      return 0;
	    }

	    // Sort on method existence if only one input has compareDocumentPosition
	    var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
	    if ( compare ) {
	      return compare;
	    }

	    // Calculate position if both inputs belong to the same document
	    compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
	      a.compareDocumentPosition( b ) :

	      // Otherwise we know they are disconnected
	      1;

	    // Disconnected nodes
	    if ( compare & 1 ||
	      (!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

	      // Choose the first element that is related to our preferred document
	      if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
	        return -1;
	      }
	      if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
	        return 1;
	      }

	      // Maintain original order
	      return sortInput ?
	        ( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
	        0;
	    }

	    return compare & 4 ? -1 : 1;
	  } :
	  function( a, b ) {
	    // Exit early if the nodes are identical
	    if ( a === b ) {
	      hasDuplicate = true;
	      return 0;
	    }

	    var cur,
	      i = 0,
	      aup = a.parentNode,
	      bup = b.parentNode,
	      ap = [ a ],
	      bp = [ b ];

	    // Parentless nodes are either documents or disconnected
	    if ( !aup || !bup ) {
	      return a === doc ? -1 :
	        b === doc ? 1 :
	        aup ? -1 :
	        bup ? 1 :
	        sortInput ?
	        ( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
	        0;

	    // If the nodes are siblings, we can do a quick check
	    } else if ( aup === bup ) {
	      return siblingCheck( a, b );
	    }

	    // Otherwise we need full lists of their ancestors for comparison
	    cur = a;
	    while ( (cur = cur.parentNode) ) {
	      ap.unshift( cur );
	    }
	    cur = b;
	    while ( (cur = cur.parentNode) ) {
	      bp.unshift( cur );
	    }

	    // Walk down the tree looking for a discrepancy
	    while ( ap[i] === bp[i] ) {
	      i++;
	    }

	    return i ?
	      // Do a sibling check if the nodes have a common ancestor
	      siblingCheck( ap[i], bp[i] ) :

	      // Otherwise nodes in our document sort first
	      ap[i] === preferredDoc ? -1 :
	      bp[i] === preferredDoc ? 1 :
	      0;
	  };

	  return doc;
	};

	Sizzle.matches = function( expr, elements ) {
	  return Sizzle( expr, null, null, elements );
	};

	Sizzle.matchesSelector = function( elem, expr ) {
	  // Set document vars if needed
	  if ( ( elem.ownerDocument || elem ) !== document ) {
	    setDocument( elem );
	  }

	  // Make sure that attribute selectors are quoted
	  expr = expr.replace( rattributeQuotes, "='$1']" );

	  if ( support.matchesSelector && documentIsHTML &&
	    ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
	    ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

	    try {
	      var ret = matches.call( elem, expr );

	      // IE 9's matchesSelector returns false on disconnected nodes
	      if ( ret || support.disconnectedMatch ||
	          // As well, disconnected nodes are said to be in a document
	          // fragment in IE 9
	          elem.document && elem.document.nodeType !== 11 ) {
	        return ret;
	      }
	    } catch(e) {}
	  }

	  return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};

	Sizzle.contains = function( context, elem ) {
	  // Set document vars if needed
	  if ( ( context.ownerDocument || context ) !== document ) {
	    setDocument( context );
	  }
	  return contains( context, elem );
	};

	Sizzle.attr = function( elem, name ) {
	  // Set document vars if needed
	  if ( ( elem.ownerDocument || elem ) !== document ) {
	    setDocument( elem );
	  }

	  var fn = Expr.attrHandle[ name.toLowerCase() ],
	    // Don't get fooled by Object.prototype properties (jQuery #13807)
	    val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
	      fn( elem, name, !documentIsHTML ) :
	      undefined;

	  return val !== undefined ?
	    val :
	    support.attributes || !documentIsHTML ?
	      elem.getAttribute( name ) :
	      (val = elem.getAttributeNode(name)) && val.specified ?
	        val.value :
	        null;
	};

	Sizzle.error = function( msg ) {
	  throw new Error( "Syntax error, unrecognized expression: " + msg );
	};

	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
	  var elem,
	    duplicates = [],
	    j = 0,
	    i = 0;

	  // Unless we *know* we can detect duplicates, assume their presence
	  hasDuplicate = !support.detectDuplicates;
	  sortInput = !support.sortStable && results.slice( 0 );
	  results.sort( sortOrder );

	  if ( hasDuplicate ) {
	    while ( (elem = results[i++]) ) {
	      if ( elem === results[ i ] ) {
	        j = duplicates.push( i );
	      }
	    }
	    while ( j-- ) {
	      results.splice( duplicates[ j ], 1 );
	    }
	  }

	  // Clear input after sorting to release objects
	  // See https://github.com/jquery/sizzle/pull/225
	  sortInput = null;

	  return results;
	};

	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
	  var node,
	    ret = "",
	    i = 0,
	    nodeType = elem.nodeType;

	  if ( !nodeType ) {
	    // If no nodeType, this is expected to be an array
	    while ( (node = elem[i++]) ) {
	      // Do not traverse comment nodes
	      ret += getText( node );
	    }
	  } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	    // Use textContent for elements
	    // innerText usage removed for consistency of new lines (jQuery #11153)
	    if ( typeof elem.textContent === "string" ) {
	      return elem.textContent;
	    } else {
	      // Traverse its children
	      for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
	        ret += getText( elem );
	      }
	    }
	  } else if ( nodeType === 3 || nodeType === 4 ) {
	    return elem.nodeValue;
	  }
	  // Do not include comment or processing instruction nodes

	  return ret;
	};

	Expr = Sizzle.selectors = {

	  // Can be adjusted by the user
	  cacheLength: 50,

	  createPseudo: markFunction,

	  match: matchExpr,

	  attrHandle: {},

	  find: {},

	  relative: {
	    ">": { dir: "parentNode", first: true },
	    " ": { dir: "parentNode" },
	    "+": { dir: "previousSibling", first: true },
	    "~": { dir: "previousSibling" }
	  },

	  preFilter: {
	    "ATTR": function( match ) {
	      match[1] = match[1].replace( runescape, funescape );

	      // Move the given value to match[3] whether quoted or unquoted
	      match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

	      if ( match[2] === "~=" ) {
	        match[3] = " " + match[3] + " ";
	      }

	      return match.slice( 0, 4 );
	    },

	    "CHILD": function( match ) {
	      /* matches from matchExpr["CHILD"]
	        1 type (only|nth|...)
	        2 what (child|of-type)
	        3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
	        4 xn-component of xn+y argument ([+-]?\d*n|)
	        5 sign of xn-component
	        6 x of xn-component
	        7 sign of y-component
	        8 y of y-component
	      */
	      match[1] = match[1].toLowerCase();

	      if ( match[1].slice( 0, 3 ) === "nth" ) {
	        // nth-* requires argument
	        if ( !match[3] ) {
	          Sizzle.error( match[0] );
	        }

	        // numeric x and y parameters for Expr.filter.CHILD
	        // remember that false/true cast respectively to 0/1
	        match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
	        match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

	      // other types prohibit arguments
	      } else if ( match[3] ) {
	        Sizzle.error( match[0] );
	      }

	      return match;
	    },

	    "PSEUDO": function( match ) {
	      var excess,
	        unquoted = !match[6] && match[2];

	      if ( matchExpr["CHILD"].test( match[0] ) ) {
	        return null;
	      }

	      // Accept quoted arguments as-is
	      if ( match[3] ) {
	        match[2] = match[4] || match[5] || "";

	      // Strip excess characters from unquoted arguments
	      } else if ( unquoted && rpseudo.test( unquoted ) &&
	        // Get excess from tokenize (recursively)
	        (excess = tokenize( unquoted, true )) &&
	        // advance to the next closing parenthesis
	        (excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

	        // excess is a negative index
	        match[0] = match[0].slice( 0, excess );
	        match[2] = unquoted.slice( 0, excess );
	      }

	      // Return only captures needed by the pseudo filter method (type and argument)
	      return match.slice( 0, 3 );
	    }
	  },

	  filter: {

	    "TAG": function( nodeNameSelector ) {
	      var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
	      return nodeNameSelector === "*" ?
	        function() { return true; } :
	        function( elem ) {
	          return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
	        };
	    },

	    "CLASS": function( className ) {
	      var pattern = classCache[ className + " " ];

	      return pattern ||
	        (pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
	        classCache( className, function( elem ) {
	          return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute("class") || "" );
	        });
	    },

	    "ATTR": function( name, operator, check ) {
	      return function( elem ) {
	        var result = Sizzle.attr( elem, name );

	        if ( result == null ) {
	          return operator === "!=";
	        }
	        if ( !operator ) {
	          return true;
	        }

	        result += "";

	        return operator === "=" ? result === check :
	          operator === "!=" ? result !== check :
	          operator === "^=" ? check && result.indexOf( check ) === 0 :
	          operator === "*=" ? check && result.indexOf( check ) > -1 :
	          operator === "$=" ? check && result.slice( -check.length ) === check :
	          operator === "~=" ? ( " " + result + " " ).indexOf( check ) > -1 :
	          operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
	          false;
	      };
	    },

	    "CHILD": function( type, what, argument, first, last ) {
	      var simple = type.slice( 0, 3 ) !== "nth",
	        forward = type.slice( -4 ) !== "last",
	        ofType = what === "of-type";

	      return first === 1 && last === 0 ?

	        // Shortcut for :nth-*(n)
	        function( elem ) {
	          return !!elem.parentNode;
	        } :

	        function( elem, context, xml ) {
	          var cache, outerCache, node, diff, nodeIndex, start,
	            dir = simple !== forward ? "nextSibling" : "previousSibling",
	            parent = elem.parentNode,
	            name = ofType && elem.nodeName.toLowerCase(),
	            useCache = !xml && !ofType;

	          if ( parent ) {

	            // :(first|last|only)-(child|of-type)
	            if ( simple ) {
	              while ( dir ) {
	                node = elem;
	                while ( (node = node[ dir ]) ) {
	                  if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
	                    return false;
	                  }
	                }
	                // Reverse direction for :only-* (if we haven't yet done so)
	                start = dir = type === "only" && !start && "nextSibling";
	              }
	              return true;
	            }

	            start = [ forward ? parent.firstChild : parent.lastChild ];

	            // non-xml :nth-child(...) stores cache data on `parent`
	            if ( forward && useCache ) {
	              // Seek `elem` from a previously-cached index
	              outerCache = parent[ expando ] || (parent[ expando ] = {});
	              cache = outerCache[ type ] || [];
	              nodeIndex = cache[0] === dirruns && cache[1];
	              diff = cache[0] === dirruns && cache[2];
	              node = nodeIndex && parent.childNodes[ nodeIndex ];

	              while ( (node = ++nodeIndex && node && node[ dir ] ||

	                // Fallback to seeking `elem` from the start
	                (diff = nodeIndex = 0) || start.pop()) ) {

	                // When found, cache indexes on `parent` and break
	                if ( node.nodeType === 1 && ++diff && node === elem ) {
	                  outerCache[ type ] = [ dirruns, nodeIndex, diff ];
	                  break;
	                }
	              }

	            // Use previously-cached element index if available
	            } else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
	              diff = cache[1];

	            // xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
	            } else {
	              // Use the same loop as above to seek `elem` from the start
	              while ( (node = ++nodeIndex && node && node[ dir ] ||
	                (diff = nodeIndex = 0) || start.pop()) ) {

	                if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
	                  // Cache the index of each encountered element
	                  if ( useCache ) {
	                    (node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
	                  }

	                  if ( node === elem ) {
	                    break;
	                  }
	                }
	              }
	            }

	            // Incorporate the offset, then check against cycle size
	            diff -= last;
	            return diff === first || ( diff % first === 0 && diff / first >= 0 );
	          }
	        };
	    },

	    "PSEUDO": function( pseudo, argument ) {
	      // pseudo-class names are case-insensitive
	      // http://www.w3.org/TR/selectors/#pseudo-classes
	      // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
	      // Remember that setFilters inherits from pseudos
	      var args,
	        fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
	          Sizzle.error( "unsupported pseudo: " + pseudo );

	      // The user may use createPseudo to indicate that
	      // arguments are needed to create the filter function
	      // just as Sizzle does
	      if ( fn[ expando ] ) {
	        return fn( argument );
	      }

	      // But maintain support for old signatures
	      if ( fn.length > 1 ) {
	        args = [ pseudo, pseudo, "", argument ];
	        return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
	          markFunction(function( seed, matches ) {
	            var idx,
	              matched = fn( seed, argument ),
	              i = matched.length;
	            while ( i-- ) {
	              idx = indexOf.call( seed, matched[i] );
	              seed[ idx ] = !( matches[ idx ] = matched[i] );
	            }
	          }) :
	          function( elem ) {
	            return fn( elem, 0, args );
	          };
	      }

	      return fn;
	    }
	  },

	  pseudos: {
	    // Potentially complex pseudos
	    "not": markFunction(function( selector ) {
	      // Trim the selector passed to compile
	      // to avoid treating leading and trailing
	      // spaces as combinators
	      var input = [],
	        results = [],
	        matcher = compile( selector.replace( rtrim, "$1" ) );

	      return matcher[ expando ] ?
	        markFunction(function( seed, matches, context, xml ) {
	          var elem,
	            unmatched = matcher( seed, null, xml, [] ),
	            i = seed.length;

	          // Match elements unmatched by `matcher`
	          while ( i-- ) {
	            if ( (elem = unmatched[i]) ) {
	              seed[i] = !(matches[i] = elem);
	            }
	          }
	        }) :
	        function( elem, context, xml ) {
	          input[0] = elem;
	          matcher( input, null, xml, results );
	          return !results.pop();
	        };
	    }),

	    "has": markFunction(function( selector ) {
	      return function( elem ) {
	        return Sizzle( selector, elem ).length > 0;
	      };
	    }),

	    "contains": markFunction(function( text ) {
	      return function( elem ) {
	        return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
	      };
	    }),

	    // "Whether an element is represented by a :lang() selector
	    // is based solely on the element's language value
	    // being equal to the identifier C,
	    // or beginning with the identifier C immediately followed by "-".
	    // The matching of C against the element's language value is performed case-insensitively.
	    // The identifier C does not have to be a valid language name."
	    // http://www.w3.org/TR/selectors/#lang-pseudo
	    "lang": markFunction( function( lang ) {
	      // lang value must be a valid identifier
	      if ( !ridentifier.test(lang || "") ) {
	        Sizzle.error( "unsupported lang: " + lang );
	      }
	      lang = lang.replace( runescape, funescape ).toLowerCase();
	      return function( elem ) {
	        var elemLang;
	        do {
	          if ( (elemLang = documentIsHTML ?
	            elem.lang :
	            elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

	            elemLang = elemLang.toLowerCase();
	            return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
	          }
	        } while ( (elem = elem.parentNode) && elem.nodeType === 1 );
	        return false;
	      };
	    }),

	    // Miscellaneous
	    "target": function( elem ) {
	      var hash = window.location && window.location.hash;
	      return hash && hash.slice( 1 ) === elem.id;
	    },

	    "root": function( elem ) {
	      return elem === docElem;
	    },

	    "focus": function( elem ) {
	      return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	    },

	    // Boolean properties
	    "enabled": function( elem ) {
	      return elem.disabled === false;
	    },

	    "disabled": function( elem ) {
	      return elem.disabled === true;
	    },

	    "checked": function( elem ) {
	      // In CSS3, :checked should return both checked and selected elements
	      // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
	      var nodeName = elem.nodeName.toLowerCase();
	      return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
	    },

	    "selected": function( elem ) {
	      // Accessing this property makes selected-by-default
	      // options in Safari work properly
	      if ( elem.parentNode ) {
	        elem.parentNode.selectedIndex;
	      }

	      return elem.selected === true;
	    },

	    // Contents
	    "empty": function( elem ) {
	      // http://www.w3.org/TR/selectors/#empty-pseudo
	      // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
	      //   but not by others (comment: 8; processing instruction: 7; etc.)
	      // nodeType < 6 works because attributes (2) do not appear as children
	      for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
	        if ( elem.nodeType < 6 ) {
	          return false;
	        }
	      }
	      return true;
	    },

	    "parent": function( elem ) {
	      return !Expr.pseudos["empty"]( elem );
	    },

	    // Element/input types
	    "header": function( elem ) {
	      return rheader.test( elem.nodeName );
	    },

	    "input": function( elem ) {
	      return rinputs.test( elem.nodeName );
	    },

	    "button": function( elem ) {
	      var name = elem.nodeName.toLowerCase();
	      return name === "input" && elem.type === "button" || name === "button";
	    },

	    "text": function( elem ) {
	      var attr;
	      return elem.nodeName.toLowerCase() === "input" &&
	        elem.type === "text" &&

	        // Support: IE<8
	        // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
	        ( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
	    },

	    // Position-in-collection
	    "first": createPositionalPseudo(function() {
	      return [ 0 ];
	    }),

	    "last": createPositionalPseudo(function( matchIndexes, length ) {
	      return [ length - 1 ];
	    }),

	    "eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
	      return [ argument < 0 ? argument + length : argument ];
	    }),

	    "even": createPositionalPseudo(function( matchIndexes, length ) {
	      var i = 0;
	      for ( ; i < length; i += 2 ) {
	        matchIndexes.push( i );
	      }
	      return matchIndexes;
	    }),

	    "odd": createPositionalPseudo(function( matchIndexes, length ) {
	      var i = 1;
	      for ( ; i < length; i += 2 ) {
	        matchIndexes.push( i );
	      }
	      return matchIndexes;
	    }),

	    "lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
	      var i = argument < 0 ? argument + length : argument;
	      for ( ; --i >= 0; ) {
	        matchIndexes.push( i );
	      }
	      return matchIndexes;
	    }),

	    "gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
	      var i = argument < 0 ? argument + length : argument;
	      for ( ; ++i < length; ) {
	        matchIndexes.push( i );
	      }
	      return matchIndexes;
	    })
	  }
	};

	Expr.pseudos["nth"] = Expr.pseudos["eq"];

	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	  Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
	  Expr.pseudos[ i ] = createButtonPseudo( i );
	}

	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();

	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	  var matched, match, tokens, type,
	    soFar, groups, preFilters,
	    cached = tokenCache[ selector + " " ];

	  if ( cached ) {
	    return parseOnly ? 0 : cached.slice( 0 );
	  }

	  soFar = selector;
	  groups = [];
	  preFilters = Expr.preFilter;

	  while ( soFar ) {

	    // Comma and first run
	    if ( !matched || (match = rcomma.exec( soFar )) ) {
	      if ( match ) {
	        // Don't consume trailing commas as valid
	        soFar = soFar.slice( match[0].length ) || soFar;
	      }
	      groups.push( (tokens = []) );
	    }

	    matched = false;

	    // Combinators
	    if ( (match = rcombinators.exec( soFar )) ) {
	      matched = match.shift();
	      tokens.push({
	        value: matched,
	        // Cast descendant combinators to space
	        type: match[0].replace( rtrim, " " )
	      });
	      soFar = soFar.slice( matched.length );
	    }

	    // Filters
	    for ( type in Expr.filter ) {
	      if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
	        (match = preFilters[ type ]( match ))) ) {
	        matched = match.shift();
	        tokens.push({
	          value: matched,
	          type: type,
	          matches: match
	        });
	        soFar = soFar.slice( matched.length );
	      }
	    }

	    if ( !matched ) {
	      break;
	    }
	  }

	  // Return the length of the invalid excess
	  // if we're just parsing
	  // Otherwise, throw an error or return tokens
	  return parseOnly ?
	    soFar.length :
	    soFar ?
	      Sizzle.error( selector ) :
	      // Cache the tokens
	      tokenCache( selector, groups ).slice( 0 );
	};

	function toSelector( tokens ) {
	  var i = 0,
	    len = tokens.length,
	    selector = "";
	  for ( ; i < len; i++ ) {
	    selector += tokens[i].value;
	  }
	  return selector;
	}

	function addCombinator( matcher, combinator, base ) {
	  var dir = combinator.dir,
	    checkNonElements = base && dir === "parentNode",
	    doneName = done++;

	  return combinator.first ?
	    // Check against closest ancestor/preceding element
	    function( elem, context, xml ) {
	      while ( (elem = elem[ dir ]) ) {
	        if ( elem.nodeType === 1 || checkNonElements ) {
	          return matcher( elem, context, xml );
	        }
	      }
	    } :

	    // Check against all ancestor/preceding elements
	    function( elem, context, xml ) {
	      var oldCache, outerCache,
	        newCache = [ dirruns, doneName ];

	      // We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
	      if ( xml ) {
	        while ( (elem = elem[ dir ]) ) {
	          if ( elem.nodeType === 1 || checkNonElements ) {
	            if ( matcher( elem, context, xml ) ) {
	              return true;
	            }
	          }
	        }
	      } else {
	        while ( (elem = elem[ dir ]) ) {
	          if ( elem.nodeType === 1 || checkNonElements ) {
	            outerCache = elem[ expando ] || (elem[ expando ] = {});
	            if ( (oldCache = outerCache[ dir ]) &&
	              oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

	              // Assign to newCache so results back-propagate to previous elements
	              return (newCache[ 2 ] = oldCache[ 2 ]);
	            } else {
	              // Reuse newcache so results back-propagate to previous elements
	              outerCache[ dir ] = newCache;

	              // A match means we're done; a fail means we have to keep checking
	              if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
	                return true;
	              }
	            }
	          }
	        }
	      }
	    };
	}

	function elementMatcher( matchers ) {
	  return matchers.length > 1 ?
	    function( elem, context, xml ) {
	      var i = matchers.length;
	      while ( i-- ) {
	        if ( !matchers[i]( elem, context, xml ) ) {
	          return false;
	        }
	      }
	      return true;
	    } :
	    matchers[0];
	}

	function multipleContexts( selector, contexts, results ) {
	  var i = 0,
	    len = contexts.length;
	  for ( ; i < len; i++ ) {
	    Sizzle( selector, contexts[i], results );
	  }
	  return results;
	}

	function condense( unmatched, map, filter, context, xml ) {
	  var elem,
	    newUnmatched = [],
	    i = 0,
	    len = unmatched.length,
	    mapped = map != null;

	  for ( ; i < len; i++ ) {
	    if ( (elem = unmatched[i]) ) {
	      if ( !filter || filter( elem, context, xml ) ) {
	        newUnmatched.push( elem );
	        if ( mapped ) {
	          map.push( i );
	        }
	      }
	    }
	  }

	  return newUnmatched;
	}

	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	  if ( postFilter && !postFilter[ expando ] ) {
	    postFilter = setMatcher( postFilter );
	  }
	  if ( postFinder && !postFinder[ expando ] ) {
	    postFinder = setMatcher( postFinder, postSelector );
	  }
	  return markFunction(function( seed, results, context, xml ) {
	    var temp, i, elem,
	      preMap = [],
	      postMap = [],
	      preexisting = results.length,

	      // Get initial elements from seed or context
	      elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

	      // Prefilter to get matcher input, preserving a map for seed-results synchronization
	      matcherIn = preFilter && ( seed || !selector ) ?
	        condense( elems, preMap, preFilter, context, xml ) :
	        elems,

	      matcherOut = matcher ?
	        // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
	        postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

	          // ...intermediate processing is necessary
	          [] :

	          // ...otherwise use results directly
	          results :
	        matcherIn;

	    // Find primary matches
	    if ( matcher ) {
	      matcher( matcherIn, matcherOut, context, xml );
	    }

	    // Apply postFilter
	    if ( postFilter ) {
	      temp = condense( matcherOut, postMap );
	      postFilter( temp, [], context, xml );

	      // Un-match failing elements by moving them back to matcherIn
	      i = temp.length;
	      while ( i-- ) {
	        if ( (elem = temp[i]) ) {
	          matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
	        }
	      }
	    }

	    if ( seed ) {
	      if ( postFinder || preFilter ) {
	        if ( postFinder ) {
	          // Get the final matcherOut by condensing this intermediate into postFinder contexts
	          temp = [];
	          i = matcherOut.length;
	          while ( i-- ) {
	            if ( (elem = matcherOut[i]) ) {
	              // Restore matcherIn since elem is not yet a final match
	              temp.push( (matcherIn[i] = elem) );
	            }
	          }
	          postFinder( null, (matcherOut = []), temp, xml );
	        }

	        // Move matched elements from seed to results to keep them synchronized
	        i = matcherOut.length;
	        while ( i-- ) {
	          if ( (elem = matcherOut[i]) &&
	            (temp = postFinder ? indexOf.call( seed, elem ) : preMap[i]) > -1 ) {

	            seed[temp] = !(results[temp] = elem);
	          }
	        }
	      }

	    // Add elements to results, through postFinder if defined
	    } else {
	      matcherOut = condense(
	        matcherOut === results ?
	          matcherOut.splice( preexisting, matcherOut.length ) :
	          matcherOut
	      );
	      if ( postFinder ) {
	        postFinder( null, results, matcherOut, xml );
	      } else {
	        push.apply( results, matcherOut );
	      }
	    }
	  });
	}

	function matcherFromTokens( tokens ) {
	  var checkContext, matcher, j,
	    len = tokens.length,
	    leadingRelative = Expr.relative[ tokens[0].type ],
	    implicitRelative = leadingRelative || Expr.relative[" "],
	    i = leadingRelative ? 1 : 0,

	    // The foundational matcher ensures that elements are reachable from top-level context(s)
	    matchContext = addCombinator( function( elem ) {
	      return elem === checkContext;
	    }, implicitRelative, true ),
	    matchAnyContext = addCombinator( function( elem ) {
	      return indexOf.call( checkContext, elem ) > -1;
	    }, implicitRelative, true ),
	    matchers = [ function( elem, context, xml ) {
	      return ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
	        (checkContext = context).nodeType ?
	          matchContext( elem, context, xml ) :
	          matchAnyContext( elem, context, xml ) );
	    } ];

	  for ( ; i < len; i++ ) {
	    if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
	      matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
	    } else {
	      matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

	      // Return special upon seeing a positional matcher
	      if ( matcher[ expando ] ) {
	        // Find the next relative operator (if any) for proper handling
	        j = ++i;
	        for ( ; j < len; j++ ) {
	          if ( Expr.relative[ tokens[j].type ] ) {
	            break;
	          }
	        }
	        return setMatcher(
	          i > 1 && elementMatcher( matchers ),
	          i > 1 && toSelector(
	            // If the preceding token was a descendant combinator, insert an implicit any-element `*`
	            tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
	          ).replace( rtrim, "$1" ),
	          matcher,
	          i < j && matcherFromTokens( tokens.slice( i, j ) ),
	          j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
	          j < len && toSelector( tokens )
	        );
	      }
	      matchers.push( matcher );
	    }
	  }

	  return elementMatcher( matchers );
	}

	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	  var bySet = setMatchers.length > 0,
	    byElement = elementMatchers.length > 0,
	    superMatcher = function( seed, context, xml, results, outermost ) {
	      var elem, j, matcher,
	        matchedCount = 0,
	        i = "0",
	        unmatched = seed && [],
	        setMatched = [],
	        contextBackup = outermostContext,
	        // We must always have either seed elements or outermost context
	        elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
	        // Use integer dirruns iff this is the outermost matcher
	        dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
	        len = elems.length;

	      if ( outermost ) {
	        outermostContext = context !== document && context;
	      }

	      // Add elements passing elementMatchers directly to results
	      // Keep `i` a string if there are no elements so `matchedCount` will be "00" below
	      // Support: IE<9, Safari
	      // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
	      for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
	        if ( byElement && elem ) {
	          j = 0;
	          while ( (matcher = elementMatchers[j++]) ) {
	            if ( matcher( elem, context, xml ) ) {
	              results.push( elem );
	              break;
	            }
	          }
	          if ( outermost ) {
	            dirruns = dirrunsUnique;
	          }
	        }

	        // Track unmatched elements for set filters
	        if ( bySet ) {
	          // They will have gone through all possible matchers
	          if ( (elem = !matcher && elem) ) {
	            matchedCount--;
	          }

	          // Lengthen the array for every element, matched or not
	          if ( seed ) {
	            unmatched.push( elem );
	          }
	        }
	      }

	      // Apply set filters to unmatched elements
	      matchedCount += i;
	      if ( bySet && i !== matchedCount ) {
	        j = 0;
	        while ( (matcher = setMatchers[j++]) ) {
	          matcher( unmatched, setMatched, context, xml );
	        }

	        if ( seed ) {
	          // Reintegrate element matches to eliminate the need for sorting
	          if ( matchedCount > 0 ) {
	            while ( i-- ) {
	              if ( !(unmatched[i] || setMatched[i]) ) {
	                setMatched[i] = pop.call( results );
	              }
	            }
	          }

	          // Discard index placeholder values to get only actual matches
	          setMatched = condense( setMatched );
	        }

	        // Add matches to results
	        push.apply( results, setMatched );

	        // Seedless set matches succeeding multiple successful matchers stipulate sorting
	        if ( outermost && !seed && setMatched.length > 0 &&
	          ( matchedCount + setMatchers.length ) > 1 ) {

	          Sizzle.uniqueSort( results );
	        }
	      }

	      // Override manipulation of globals by nested matchers
	      if ( outermost ) {
	        dirruns = dirrunsUnique;
	        outermostContext = contextBackup;
	      }

	      return unmatched;
	    };

	  return bySet ?
	    markFunction( superMatcher ) :
	    superMatcher;
	}

	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	  var i,
	    setMatchers = [],
	    elementMatchers = [],
	    cached = compilerCache[ selector + " " ];

	  if ( !cached ) {
	    // Generate a function of recursive functions that can be used to check each element
	    if ( !match ) {
	      match = tokenize( selector );
	    }
	    i = match.length;
	    while ( i-- ) {
	      cached = matcherFromTokens( match[i] );
	      if ( cached[ expando ] ) {
	        setMatchers.push( cached );
	      } else {
	        elementMatchers.push( cached );
	      }
	    }

	    // Cache the compiled function
	    cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

	    // Save selector and tokenization
	    cached.selector = selector;
	  }
	  return cached;
	};

	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
	  var i, tokens, token, type, find,
	    compiled = typeof selector === "function" && selector,
	    match = !seed && tokenize( (selector = compiled.selector || selector) );

	  results = results || [];

	  // Try to minimize operations if there is no seed and only one group
	  if ( match.length === 1 ) {

	    // Take a shortcut and set the context if the root selector is an ID
	    tokens = match[0] = match[0].slice( 0 );
	    if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
	        support.getById && context.nodeType === 9 && documentIsHTML &&
	        Expr.relative[ tokens[1].type ] ) {

	      context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
	      if ( !context ) {
	        return results;

	      // Precompiled matchers will still verify ancestry, so step up a level
	      } else if ( compiled ) {
	        context = context.parentNode;
	      }

	      selector = selector.slice( tokens.shift().value.length );
	    }

	    // Fetch a seed set for right-to-left matching
	    i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
	    while ( i-- ) {
	      token = tokens[i];

	      // Abort if we hit a combinator
	      if ( Expr.relative[ (type = token.type) ] ) {
	        break;
	      }
	      if ( (find = Expr.find[ type ]) ) {
	        // Search, expanding context for leading sibling combinators
	        if ( (seed = find(
	          token.matches[0].replace( runescape, funescape ),
	          rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
	        )) ) {

	          // If seed is empty or no tokens remain, we can return early
	          tokens.splice( i, 1 );
	          selector = seed.length && toSelector( tokens );
	          if ( !selector ) {
	            push.apply( results, seed );
	            return results;
	          }

	          break;
	        }
	      }
	    }
	  }

	  // Compile and execute a filtering function if one is not provided
	  // Provide `match` to avoid retokenization if we modified the selector above
	  ( compiled || compile( selector, match ) )(
	    seed,
	    context,
	    !documentIsHTML,
	    results,
	    rsibling.test( selector ) && testContext( context.parentNode ) || context
	  );
	  return results;
	};

	// One-time assignments

	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

	// Support: Chrome<14
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;

	// Initialize against the default document
	setDocument();

	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
	  // Should return 1, but returns 4 (following)
	  return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});

	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
	  div.innerHTML = "<a href='#'></a>";
	  return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
	  addHandle( "type|href|height|width", function( elem, name, isXML ) {
	    if ( !isXML ) {
	      return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
	    }
	  });
	}

	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
	  div.innerHTML = "<input/>";
	  div.firstChild.setAttribute( "value", "" );
	  return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
	  addHandle( "value", function( elem, name, isXML ) {
	    if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
	      return elem.defaultValue;
	    }
	  });
	}

	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
	  return div.getAttribute("disabled") == null;
	}) ) {
	  addHandle( booleans, function( elem, name, isXML ) {
	    var val;
	    if ( !isXML ) {
	      return elem[ name ] === true ? name.toLowerCase() :
	          (val = elem.getAttributeNode( name )) && val.specified ?
	          val.value :
	        null;
	    }
	  });
	}

	return Sizzle;

	})( window );



	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;



	var rneedsContext = jQuery.expr.match.needsContext;

	var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



	var risSimple = /^.[^:#\[\.,]*$/;

	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
	  if ( jQuery.isFunction( qualifier ) ) {
	    return jQuery.grep( elements, function( elem, i ) {
	      /* jshint -W018 */
	      return !!qualifier.call( elem, i, elem ) !== not;
	    });

	  }

	  if ( qualifier.nodeType ) {
	    return jQuery.grep( elements, function( elem ) {
	      return ( elem === qualifier ) !== not;
	    });

	  }

	  if ( typeof qualifier === "string" ) {
	    if ( risSimple.test( qualifier ) ) {
	      return jQuery.filter( qualifier, elements, not );
	    }

	    qualifier = jQuery.filter( qualifier, elements );
	  }

	  return jQuery.grep( elements, function( elem ) {
	    return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
	  });
	}

	jQuery.filter = function( expr, elems, not ) {
	  var elem = elems[ 0 ];

	  if ( not ) {
	    expr = ":not(" + expr + ")";
	  }

	  return elems.length === 1 && elem.nodeType === 1 ?
	    jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
	    jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
	      return elem.nodeType === 1;
	    }));
	};

	jQuery.fn.extend({
	  find: function( selector ) {
	    var i,
	      len = this.length,
	      ret = [],
	      self = this;

	    if ( typeof selector !== "string" ) {
	      return this.pushStack( jQuery( selector ).filter(function() {
	        for ( i = 0; i < len; i++ ) {
	          if ( jQuery.contains( self[ i ], this ) ) {
	            return true;
	          }
	        }
	      }) );
	    }

	    for ( i = 0; i < len; i++ ) {
	      jQuery.find( selector, self[ i ], ret );
	    }

	    // Needed because $( selector, context ) becomes $( context ).find( selector )
	    ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
	    ret.selector = this.selector ? this.selector + " " + selector : selector;
	    return ret;
	  },
	  filter: function( selector ) {
	    return this.pushStack( winnow(this, selector || [], false) );
	  },
	  not: function( selector ) {
	    return this.pushStack( winnow(this, selector || [], true) );
	  },
	  is: function( selector ) {
	    return !!winnow(
	      this,

	      // If this is a positional/relative selector, check membership in the returned set
	      // so $("p:first").is("p:last") won't return true for a doc with two "p".
	      typeof selector === "string" && rneedsContext.test( selector ) ?
	        jQuery( selector ) :
	        selector || [],
	      false
	    ).length;
	  }
	});


	// Initialize a jQuery object


	// A central reference to the root jQuery(document)
	var rootjQuery,

	  // A simple way to check for HTML strings
	  // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	  // Strict HTML recognition (#11290: must start with <)
	  rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	  init = jQuery.fn.init = function( selector, context ) {
	    var match, elem;

	    // HANDLE: $(""), $(null), $(undefined), $(false)
	    if ( !selector ) {
	      return this;
	    }

	    // Handle HTML strings
	    if ( typeof selector === "string" ) {
	      if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
	        // Assume that strings that start and end with <> are HTML and skip the regex check
	        match = [ null, selector, null ];

	      } else {
	        match = rquickExpr.exec( selector );
	      }

	      // Match html or make sure no context is specified for #id
	      if ( match && (match[1] || !context) ) {

	        // HANDLE: $(html) -> $(array)
	        if ( match[1] ) {
	          context = context instanceof jQuery ? context[0] : context;

	          // scripts is true for back-compat
	          // Intentionally let the error be thrown if parseHTML is not present
	          jQuery.merge( this, jQuery.parseHTML(
	            match[1],
	            context && context.nodeType ? context.ownerDocument || context : document,
	            true
	          ) );

	          // HANDLE: $(html, props)
	          if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
	            for ( match in context ) {
	              // Properties of context are called as methods if possible
	              if ( jQuery.isFunction( this[ match ] ) ) {
	                this[ match ]( context[ match ] );

	              // ...and otherwise set as attributes
	              } else {
	                this.attr( match, context[ match ] );
	              }
	            }
	          }

	          return this;

	        // HANDLE: $(#id)
	        } else {
	          elem = document.getElementById( match[2] );

	          // Check parentNode to catch when Blackberry 4.6 returns
	          // nodes that are no longer in the document #6963
	          if ( elem && elem.parentNode ) {
	            // Inject the element directly into the jQuery object
	            this.length = 1;
	            this[0] = elem;
	          }

	          this.context = document;
	          this.selector = selector;
	          return this;
	        }

	      // HANDLE: $(expr, $(...))
	      } else if ( !context || context.jquery ) {
	        return ( context || rootjQuery ).find( selector );

	      // HANDLE: $(expr, context)
	      // (which is just equivalent to: $(context).find(expr)
	      } else {
	        return this.constructor( context ).find( selector );
	      }

	    // HANDLE: $(DOMElement)
	    } else if ( selector.nodeType ) {
	      this.context = this[0] = selector;
	      this.length = 1;
	      return this;

	    // HANDLE: $(function)
	    // Shortcut for document ready
	    } else if ( jQuery.isFunction( selector ) ) {
	      return typeof rootjQuery.ready !== "undefined" ?
	        rootjQuery.ready( selector ) :
	        // Execute immediately if ready is not present
	        selector( jQuery );
	    }

	    if ( selector.selector !== undefined ) {
	      this.selector = selector.selector;
	      this.context = selector.context;
	    }

	    return jQuery.makeArray( selector, this );
	  };

	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;

	// Initialize central reference
	rootjQuery = jQuery( document );


	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	  // methods guaranteed to produce a unique set when starting from a unique set
	  guaranteedUnique = {
	    children: true,
	    contents: true,
	    next: true,
	    prev: true
	  };

	jQuery.extend({
	  dir: function( elem, dir, until ) {
	    var matched = [],
	      truncate = until !== undefined;

	    while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
	      if ( elem.nodeType === 1 ) {
	        if ( truncate && jQuery( elem ).is( until ) ) {
	          break;
	        }
	        matched.push( elem );
	      }
	    }
	    return matched;
	  },

	  sibling: function( n, elem ) {
	    var matched = [];

	    for ( ; n; n = n.nextSibling ) {
	      if ( n.nodeType === 1 && n !== elem ) {
	        matched.push( n );
	      }
	    }

	    return matched;
	  }
	});

	jQuery.fn.extend({
	  has: function( target ) {
	    var targets = jQuery( target, this ),
	      l = targets.length;

	    return this.filter(function() {
	      var i = 0;
	      for ( ; i < l; i++ ) {
	        if ( jQuery.contains( this, targets[i] ) ) {
	          return true;
	        }
	      }
	    });
	  },

	  closest: function( selectors, context ) {
	    var cur,
	      i = 0,
	      l = this.length,
	      matched = [],
	      pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
	        jQuery( selectors, context || this.context ) :
	        0;

	    for ( ; i < l; i++ ) {
	      for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
	        // Always skip document fragments
	        if ( cur.nodeType < 11 && (pos ?
	          pos.index(cur) > -1 :

	          // Don't pass non-elements to Sizzle
	          cur.nodeType === 1 &&
	            jQuery.find.matchesSelector(cur, selectors)) ) {

	          matched.push( cur );
	          break;
	        }
	      }
	    }

	    return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	  },

	  // Determine the position of an element within
	  // the matched set of elements
	  index: function( elem ) {

	    // No argument, return index in parent
	    if ( !elem ) {
	      return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
	    }

	    // index in selector
	    if ( typeof elem === "string" ) {
	      return indexOf.call( jQuery( elem ), this[ 0 ] );
	    }

	    // Locate the position of the desired element
	    return indexOf.call( this,

	      // If it receives a jQuery object, the first element is used
	      elem.jquery ? elem[ 0 ] : elem
	    );
	  },

	  add: function( selector, context ) {
	    return this.pushStack(
	      jQuery.unique(
	        jQuery.merge( this.get(), jQuery( selector, context ) )
	      )
	    );
	  },

	  addBack: function( selector ) {
	    return this.add( selector == null ?
	      this.prevObject : this.prevObject.filter(selector)
	    );
	  }
	});

	function sibling( cur, dir ) {
	  while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
	  return cur;
	}

	jQuery.each({
	  parent: function( elem ) {
	    var parent = elem.parentNode;
	    return parent && parent.nodeType !== 11 ? parent : null;
	  },
	  parents: function( elem ) {
	    return jQuery.dir( elem, "parentNode" );
	  },
	  parentsUntil: function( elem, i, until ) {
	    return jQuery.dir( elem, "parentNode", until );
	  },
	  next: function( elem ) {
	    return sibling( elem, "nextSibling" );
	  },
	  prev: function( elem ) {
	    return sibling( elem, "previousSibling" );
	  },
	  nextAll: function( elem ) {
	    return jQuery.dir( elem, "nextSibling" );
	  },
	  prevAll: function( elem ) {
	    return jQuery.dir( elem, "previousSibling" );
	  },
	  nextUntil: function( elem, i, until ) {
	    return jQuery.dir( elem, "nextSibling", until );
	  },
	  prevUntil: function( elem, i, until ) {
	    return jQuery.dir( elem, "previousSibling", until );
	  },
	  siblings: function( elem ) {
	    return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	  },
	  children: function( elem ) {
	    return jQuery.sibling( elem.firstChild );
	  },
	  contents: function( elem ) {
	    return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	  }
	}, function( name, fn ) {
	  jQuery.fn[ name ] = function( until, selector ) {
	    var matched = jQuery.map( this, fn, until );

	    if ( name.slice( -5 ) !== "Until" ) {
	      selector = until;
	    }

	    if ( selector && typeof selector === "string" ) {
	      matched = jQuery.filter( selector, matched );
	    }

	    if ( this.length > 1 ) {
	      // Remove duplicates
	      if ( !guaranteedUnique[ name ] ) {
	        jQuery.unique( matched );
	      }

	      // Reverse order for parents* and prev-derivatives
	      if ( rparentsprev.test( name ) ) {
	        matched.reverse();
	      }
	    }

	    return this.pushStack( matched );
	  };
	});
	var rnotwhite = (/\S+/g);



	// String to Object options format cache
	var optionsCache = {};

	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
	  var object = optionsCache[ options ] = {};
	  jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
	    object[ flag ] = true;
	  });
	  return object;
	}

	/*
	 * Create a callback list using the following parameters:
	 *
	 *  options: an optional list of space-separated options that will change how
	 *      the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *  once:     will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *  memory:     will keep track of previous values and will call any callback added
	 *          after the list has been fired right away with the latest "memorized"
	 *          values (like a Deferred)
	 *
	 *  unique:     will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *  stopOnFalse:  interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {

	  // Convert options from String-formatted to Object-formatted if needed
	  // (we check in cache first)
	  options = typeof options === "string" ?
	    ( optionsCache[ options ] || createOptions( options ) ) :
	    jQuery.extend( {}, options );

	  var // Last fire value (for non-forgettable lists)
	    memory,
	    // Flag to know if list was already fired
	    fired,
	    // Flag to know if list is currently firing
	    firing,
	    // First callback to fire (used internally by add and fireWith)
	    firingStart,
	    // End of the loop when firing
	    firingLength,
	    // Index of currently firing callback (modified by remove if needed)
	    firingIndex,
	    // Actual callback list
	    list = [],
	    // Stack of fire calls for repeatable lists
	    stack = !options.once && [],
	    // Fire callbacks
	    fire = function( data ) {
	      memory = options.memory && data;
	      fired = true;
	      firingIndex = firingStart || 0;
	      firingStart = 0;
	      firingLength = list.length;
	      firing = true;
	      for ( ; list && firingIndex < firingLength; firingIndex++ ) {
	        if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
	          memory = false; // To prevent further calls using add
	          break;
	        }
	      }
	      firing = false;
	      if ( list ) {
	        if ( stack ) {
	          if ( stack.length ) {
	            fire( stack.shift() );
	          }
	        } else if ( memory ) {
	          list = [];
	        } else {
	          self.disable();
	        }
	      }
	    },
	    // Actual Callbacks object
	    self = {
	      // Add a callback or a collection of callbacks to the list
	      add: function() {
	        if ( list ) {
	          // First, we save the current length
	          var start = list.length;
	          (function add( args ) {
	            jQuery.each( args, function( _, arg ) {
	              var type = jQuery.type( arg );
	              if ( type === "function" ) {
	                if ( !options.unique || !self.has( arg ) ) {
	                  list.push( arg );
	                }
	              } else if ( arg && arg.length && type !== "string" ) {
	                // Inspect recursively
	                add( arg );
	              }
	            });
	          })( arguments );
	          // Do we need to add the callbacks to the
	          // current firing batch?
	          if ( firing ) {
	            firingLength = list.length;
	          // With memory, if we're not firing then
	          // we should call right away
	          } else if ( memory ) {
	            firingStart = start;
	            fire( memory );
	          }
	        }
	        return this;
	      },
	      // Remove a callback from the list
	      remove: function() {
	        if ( list ) {
	          jQuery.each( arguments, function( _, arg ) {
	            var index;
	            while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
	              list.splice( index, 1 );
	              // Handle firing indexes
	              if ( firing ) {
	                if ( index <= firingLength ) {
	                  firingLength--;
	                }
	                if ( index <= firingIndex ) {
	                  firingIndex--;
	                }
	              }
	            }
	          });
	        }
	        return this;
	      },
	      // Check if a given callback is in the list.
	      // If no argument is given, return whether or not list has callbacks attached.
	      has: function( fn ) {
	        return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
	      },
	      // Remove all callbacks from the list
	      empty: function() {
	        list = [];
	        firingLength = 0;
	        return this;
	      },
	      // Have the list do nothing anymore
	      disable: function() {
	        list = stack = memory = undefined;
	        return this;
	      },
	      // Is it disabled?
	      disabled: function() {
	        return !list;
	      },
	      // Lock the list in its current state
	      lock: function() {
	        stack = undefined;
	        if ( !memory ) {
	          self.disable();
	        }
	        return this;
	      },
	      // Is it locked?
	      locked: function() {
	        return !stack;
	      },
	      // Call all callbacks with the given context and arguments
	      fireWith: function( context, args ) {
	        if ( list && ( !fired || stack ) ) {
	          args = args || [];
	          args = [ context, args.slice ? args.slice() : args ];
	          if ( firing ) {
	            stack.push( args );
	          } else {
	            fire( args );
	          }
	        }
	        return this;
	      },
	      // Call all the callbacks with the given arguments
	      fire: function() {
	        self.fireWith( this, arguments );
	        return this;
	      },
	      // To know if the callbacks have already been called at least once
	      fired: function() {
	        return !!fired;
	      }
	    };

	  return self;
	};


	jQuery.extend({

	  Deferred: function( func ) {
	    var tuples = [
	        // action, add listener, listener list, final state
	        [ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
	        [ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
	        [ "notify", "progress", jQuery.Callbacks("memory") ]
	      ],
	      state = "pending",
	      promise = {
	        state: function() {
	          return state;
	        },
	        always: function() {
	          deferred.done( arguments ).fail( arguments );
	          return this;
	        },
	        then: function( /* fnDone, fnFail, fnProgress */ ) {
	          var fns = arguments;
	          return jQuery.Deferred(function( newDefer ) {
	            jQuery.each( tuples, function( i, tuple ) {
	              var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	              // deferred[ done | fail | progress ] for forwarding actions to newDefer
	              deferred[ tuple[1] ](function() {
	                var returned = fn && fn.apply( this, arguments );
	                if ( returned && jQuery.isFunction( returned.promise ) ) {
	                  returned.promise()
	                    .done( newDefer.resolve )
	                    .fail( newDefer.reject )
	                    .progress( newDefer.notify );
	                } else {
	                  newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
	                }
	              });
	            });
	            fns = null;
	          }).promise();
	        },
	        // Get a promise for this deferred
	        // If obj is provided, the promise aspect is added to the object
	        promise: function( obj ) {
	          return obj != null ? jQuery.extend( obj, promise ) : promise;
	        }
	      },
	      deferred = {};

	    // Keep pipe for back-compat
	    promise.pipe = promise.then;

	    // Add list-specific methods
	    jQuery.each( tuples, function( i, tuple ) {
	      var list = tuple[ 2 ],
	        stateString = tuple[ 3 ];

	      // promise[ done | fail | progress ] = list.add
	      promise[ tuple[1] ] = list.add;

	      // Handle state
	      if ( stateString ) {
	        list.add(function() {
	          // state = [ resolved | rejected ]
	          state = stateString;

	        // [ reject_list | resolve_list ].disable; progress_list.lock
	        }, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
	      }

	      // deferred[ resolve | reject | notify ]
	      deferred[ tuple[0] ] = function() {
	        deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
	        return this;
	      };
	      deferred[ tuple[0] + "With" ] = list.fireWith;
	    });

	    // Make the deferred a promise
	    promise.promise( deferred );

	    // Call given func if any
	    if ( func ) {
	      func.call( deferred, deferred );
	    }

	    // All done!
	    return deferred;
	  },

	  // Deferred helper
	  when: function( subordinate /* , ..., subordinateN */ ) {
	    var i = 0,
	      resolveValues = slice.call( arguments ),
	      length = resolveValues.length,

	      // the count of uncompleted subordinates
	      remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

	      // the master Deferred. If resolveValues consist of only a single Deferred, just use that.
	      deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

	      // Update function for both resolve and progress values
	      updateFunc = function( i, contexts, values ) {
	        return function( value ) {
	          contexts[ i ] = this;
	          values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
	          if ( values === progressValues ) {
	            deferred.notifyWith( contexts, values );
	          } else if ( !( --remaining ) ) {
	            deferred.resolveWith( contexts, values );
	          }
	        };
	      },

	      progressValues, progressContexts, resolveContexts;

	    // add listeners to Deferred subordinates; treat others as resolved
	    if ( length > 1 ) {
	      progressValues = new Array( length );
	      progressContexts = new Array( length );
	      resolveContexts = new Array( length );
	      for ( ; i < length; i++ ) {
	        if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
	          resolveValues[ i ].promise()
	            .done( updateFunc( i, resolveContexts, resolveValues ) )
	            .fail( deferred.reject )
	            .progress( updateFunc( i, progressContexts, progressValues ) );
	        } else {
	          --remaining;
	        }
	      }
	    }

	    // if we're not waiting on anything, resolve the master
	    if ( !remaining ) {
	      deferred.resolveWith( resolveContexts, resolveValues );
	    }

	    return deferred.promise();
	  }
	});


	// The deferred used on DOM ready
	var readyList;

	jQuery.fn.ready = function( fn ) {
	  // Add the callback
	  jQuery.ready.promise().done( fn );

	  return this;
	};

	jQuery.extend({
	  // Is the DOM ready to be used? Set to true once it occurs.
	  isReady: false,

	  // A counter to track how many items to wait for before
	  // the ready event fires. See #6781
	  readyWait: 1,

	  // Hold (or release) the ready event
	  holdReady: function( hold ) {
	    if ( hold ) {
	      jQuery.readyWait++;
	    } else {
	      jQuery.ready( true );
	    }
	  },

	  // Handle when the DOM is ready
	  ready: function( wait ) {

	    // Abort if there are pending holds or we're already ready
	    if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
	      return;
	    }

	    // Remember that the DOM is ready
	    jQuery.isReady = true;

	    // If a normal DOM Ready event fired, decrement, and wait if need be
	    if ( wait !== true && --jQuery.readyWait > 0 ) {
	      return;
	    }

	    // If there are functions bound, to execute
	    readyList.resolveWith( document, [ jQuery ] );

	    // Trigger any bound ready events
	    if ( jQuery.fn.triggerHandler ) {
	      jQuery( document ).triggerHandler( "ready" );
	      jQuery( document ).off( "ready" );
	    }
	  }
	});

	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
	  document.removeEventListener( "DOMContentLoaded", completed, false );
	  window.removeEventListener( "load", completed, false );
	  jQuery.ready();
	}

	jQuery.ready.promise = function( obj ) {
	  if ( !readyList ) {

	    readyList = jQuery.Deferred();

	    // Catch cases where $(document).ready() is called after the browser event has already occurred.
	    // we once tried to use readyState "interactive" here, but it caused issues like the one
	    // discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
	    if ( document.readyState === "complete" ) {
	      // Handle it asynchronously to allow scripts the opportunity to delay ready
	      setTimeout( jQuery.ready );

	    } else {

	      // Use the handy event callback
	      document.addEventListener( "DOMContentLoaded", completed, false );

	      // A fallback to window.onload, that will always work
	      window.addEventListener( "load", completed, false );
	    }
	  }
	  return readyList.promise( obj );
	};

	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();




	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	  var i = 0,
	    len = elems.length,
	    bulk = key == null;

	  // Sets many values
	  if ( jQuery.type( key ) === "object" ) {
	    chainable = true;
	    for ( i in key ) {
	      jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
	    }

	  // Sets one value
	  } else if ( value !== undefined ) {
	    chainable = true;

	    if ( !jQuery.isFunction( value ) ) {
	      raw = true;
	    }

	    if ( bulk ) {
	      // Bulk operations run against the entire set
	      if ( raw ) {
	        fn.call( elems, value );
	        fn = null;

	      // ...except when executing function values
	      } else {
	        bulk = fn;
	        fn = function( elem, key, value ) {
	          return bulk.call( jQuery( elem ), value );
	        };
	      }
	    }

	    if ( fn ) {
	      for ( ; i < len; i++ ) {
	        fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
	      }
	    }
	  }

	  return chainable ?
	    elems :

	    // Gets
	    bulk ?
	      fn.call( elems ) :
	      len ? fn( elems[0], key ) : emptyGet;
	};


	/**
	 * Determines whether an object can have data
	 */
	jQuery.acceptData = function( owner ) {
	  // Accepts only:
	  //  - Node
	  //    - Node.ELEMENT_NODE
	  //    - Node.DOCUMENT_NODE
	  //  - Object
	  //    - Any
	  /* jshint -W018 */
	  return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};


	function Data() {
	  // Support: Android < 4,
	  // Old WebKit does not have Object.preventExtensions/freeze method,
	  // return new empty object instead with no [[set]] accessor
	  Object.defineProperty( this.cache = {}, 0, {
	    get: function() {
	      return {};
	    }
	  });

	  this.expando = jQuery.expando + Math.random();
	}

	Data.uid = 1;
	Data.accepts = jQuery.acceptData;

	Data.prototype = {
	  key: function( owner ) {
	    // We can accept data for non-element nodes in modern browsers,
	    // but we should not, see #8335.
	    // Always return the key for a frozen object.
	    if ( !Data.accepts( owner ) ) {
	      return 0;
	    }

	    var descriptor = {},
	      // Check if the owner object already has a cache key
	      unlock = owner[ this.expando ];

	    // If not, create one
	    if ( !unlock ) {
	      unlock = Data.uid++;

	      // Secure it in a non-enumerable, non-writable property
	      try {
	        descriptor[ this.expando ] = { value: unlock };
	        Object.defineProperties( owner, descriptor );

	      // Support: Android < 4
	      // Fallback to a less secure definition
	      } catch ( e ) {
	        descriptor[ this.expando ] = unlock;
	        jQuery.extend( owner, descriptor );
	      }
	    }

	    // Ensure the cache object
	    if ( !this.cache[ unlock ] ) {
	      this.cache[ unlock ] = {};
	    }

	    return unlock;
	  },
	  set: function( owner, data, value ) {
	    var prop,
	      // There may be an unlock assigned to this node,
	      // if there is no entry for this "owner", create one inline
	      // and set the unlock as though an owner entry had always existed
	      unlock = this.key( owner ),
	      cache = this.cache[ unlock ];

	    // Handle: [ owner, key, value ] args
	    if ( typeof data === "string" ) {
	      cache[ data ] = value;

	    // Handle: [ owner, { properties } ] args
	    } else {
	      // Fresh assignments by object are shallow copied
	      if ( jQuery.isEmptyObject( cache ) ) {
	        jQuery.extend( this.cache[ unlock ], data );
	      // Otherwise, copy the properties one-by-one to the cache object
	      } else {
	        for ( prop in data ) {
	          cache[ prop ] = data[ prop ];
	        }
	      }
	    }
	    return cache;
	  },
	  get: function( owner, key ) {
	    // Either a valid cache is found, or will be created.
	    // New caches will be created and the unlock returned,
	    // allowing direct access to the newly created
	    // empty data object. A valid owner object must be provided.
	    var cache = this.cache[ this.key( owner ) ];

	    return key === undefined ?
	      cache : cache[ key ];
	  },
	  access: function( owner, key, value ) {
	    var stored;
	    // In cases where either:
	    //
	    //   1. No key was specified
	    //   2. A string key was specified, but no value provided
	    //
	    // Take the "read" path and allow the get method to determine
	    // which value to return, respectively either:
	    //
	    //   1. The entire cache object
	    //   2. The data stored at the key
	    //
	    if ( key === undefined ||
	        ((key && typeof key === "string") && value === undefined) ) {

	      stored = this.get( owner, key );

	      return stored !== undefined ?
	        stored : this.get( owner, jQuery.camelCase(key) );
	    }

	    // [*]When the key is not a string, or both a key and value
	    // are specified, set or extend (existing objects) with either:
	    //
	    //   1. An object of properties
	    //   2. A key and value
	    //
	    this.set( owner, key, value );

	    // Since the "set" path can have two possible entry points
	    // return the expected data based on which path was taken[*]
	    return value !== undefined ? value : key;
	  },
	  remove: function( owner, key ) {
	    var i, name, camel,
	      unlock = this.key( owner ),
	      cache = this.cache[ unlock ];

	    if ( key === undefined ) {
	      this.cache[ unlock ] = {};

	    } else {
	      // Support array or space separated string of keys
	      if ( jQuery.isArray( key ) ) {
	        // If "name" is an array of keys...
	        // When data is initially created, via ("key", "val") signature,
	        // keys will be converted to camelCase.
	        // Since there is no way to tell _how_ a key was added, remove
	        // both plain key and camelCase key. #12786
	        // This will only penalize the array argument path.
	        name = key.concat( key.map( jQuery.camelCase ) );
	      } else {
	        camel = jQuery.camelCase( key );
	        // Try the string as a key before any manipulation
	        if ( key in cache ) {
	          name = [ key, camel ];
	        } else {
	          // If a key with the spaces exists, use it.
	          // Otherwise, create an array by matching non-whitespace
	          name = camel;
	          name = name in cache ?
	            [ name ] : ( name.match( rnotwhite ) || [] );
	        }
	      }

	      i = name.length;
	      while ( i-- ) {
	        delete cache[ name[ i ] ];
	      }
	    }
	  },
	  hasData: function( owner ) {
	    return !jQuery.isEmptyObject(
	      this.cache[ owner[ this.expando ] ] || {}
	    );
	  },
	  discard: function( owner ) {
	    if ( owner[ this.expando ] ) {
	      delete this.cache[ owner[ this.expando ] ];
	    }
	  }
	};
	var data_priv = new Data();

	var data_user = new Data();



	/*
	  Implementation Summary

	  1. Enforce API surface and semantic compatibility with 1.9.x branch
	  2. Improve the module's maintainability by reducing the storage
	    paths to a single mechanism.
	  3. Use the same single mechanism to support "private" and "user" data.
	  4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	  5. Avoid exposing implementation details on user objects (eg. expando properties)
	  6. Provide a clear path for implementation upgrade to WeakMap in 2014
	*/
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	  rmultiDash = /([A-Z])/g;

	function dataAttr( elem, key, data ) {
	  var name;

	  // If nothing was found internally, try to fetch any
	  // data from the HTML5 data-* attribute
	  if ( data === undefined && elem.nodeType === 1 ) {
	    name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	    data = elem.getAttribute( name );

	    if ( typeof data === "string" ) {
	      try {
	        data = data === "true" ? true :
	          data === "false" ? false :
	          data === "null" ? null :
	          // Only convert to a number if it doesn't change the string
	          +data + "" === data ? +data :
	          rbrace.test( data ) ? jQuery.parseJSON( data ) :
	          data;
	      } catch( e ) {}

	      // Make sure we set the data so it isn't changed later
	      data_user.set( elem, key, data );
	    } else {
	      data = undefined;
	    }
	  }
	  return data;
	}

	jQuery.extend({
	  hasData: function( elem ) {
	    return data_user.hasData( elem ) || data_priv.hasData( elem );
	  },

	  data: function( elem, name, data ) {
	    return data_user.access( elem, name, data );
	  },

	  removeData: function( elem, name ) {
	    data_user.remove( elem, name );
	  },

	  // TODO: Now that all calls to _data and _removeData have been replaced
	  // with direct calls to data_priv methods, these can be deprecated.
	  _data: function( elem, name, data ) {
	    return data_priv.access( elem, name, data );
	  },

	  _removeData: function( elem, name ) {
	    data_priv.remove( elem, name );
	  }
	});

	jQuery.fn.extend({
	  data: function( key, value ) {
	    var i, name, data,
	      elem = this[ 0 ],
	      attrs = elem && elem.attributes;

	    // Gets all values
	    if ( key === undefined ) {
	      if ( this.length ) {
	        data = data_user.get( elem );

	        if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
	          i = attrs.length;
	          while ( i-- ) {

	            // Support: IE11+
	            // The attrs elements can be null (#14894)
	            if ( attrs[ i ] ) {
	              name = attrs[ i ].name;
	              if ( name.indexOf( "data-" ) === 0 ) {
	                name = jQuery.camelCase( name.slice(5) );
	                dataAttr( elem, name, data[ name ] );
	              }
	            }
	          }
	          data_priv.set( elem, "hasDataAttrs", true );
	        }
	      }

	      return data;
	    }

	    // Sets multiple values
	    if ( typeof key === "object" ) {
	      return this.each(function() {
	        data_user.set( this, key );
	      });
	    }

	    return access( this, function( value ) {
	      var data,
	        camelKey = jQuery.camelCase( key );

	      // The calling jQuery object (element matches) is not empty
	      // (and therefore has an element appears at this[ 0 ]) and the
	      // `value` parameter was not undefined. An empty jQuery object
	      // will result in `undefined` for elem = this[ 0 ] which will
	      // throw an exception if an attempt to read a data cache is made.
	      if ( elem && value === undefined ) {
	        // Attempt to get data from the cache
	        // with the key as-is
	        data = data_user.get( elem, key );
	        if ( data !== undefined ) {
	          return data;
	        }

	        // Attempt to get data from the cache
	        // with the key camelized
	        data = data_user.get( elem, camelKey );
	        if ( data !== undefined ) {
	          return data;
	        }

	        // Attempt to "discover" the data in
	        // HTML5 custom data-* attrs
	        data = dataAttr( elem, camelKey, undefined );
	        if ( data !== undefined ) {
	          return data;
	        }

	        // We tried really hard, but the data doesn't exist.
	        return;
	      }

	      // Set the data...
	      this.each(function() {
	        // First, attempt to store a copy or reference of any
	        // data that might've been store with a camelCased key.
	        var data = data_user.get( this, camelKey );

	        // For HTML5 data-* attribute interop, we have to
	        // store property names with dashes in a camelCase form.
	        // This might not apply to all properties...*
	        data_user.set( this, camelKey, value );

	        // *... In the case of properties that might _actually_
	        // have dashes, we need to also store a copy of that
	        // unchanged property.
	        if ( key.indexOf("-") !== -1 && data !== undefined ) {
	          data_user.set( this, key, value );
	        }
	      });
	    }, null, value, arguments.length > 1, null, true );
	  },

	  removeData: function( key ) {
	    return this.each(function() {
	      data_user.remove( this, key );
	    });
	  }
	});


	jQuery.extend({
	  queue: function( elem, type, data ) {
	    var queue;

	    if ( elem ) {
	      type = ( type || "fx" ) + "queue";
	      queue = data_priv.get( elem, type );

	      // Speed up dequeue by getting out quickly if this is just a lookup
	      if ( data ) {
	        if ( !queue || jQuery.isArray( data ) ) {
	          queue = data_priv.access( elem, type, jQuery.makeArray(data) );
	        } else {
	          queue.push( data );
	        }
	      }
	      return queue || [];
	    }
	  },

	  dequeue: function( elem, type ) {
	    type = type || "fx";

	    var queue = jQuery.queue( elem, type ),
	      startLength = queue.length,
	      fn = queue.shift(),
	      hooks = jQuery._queueHooks( elem, type ),
	      next = function() {
	        jQuery.dequeue( elem, type );
	      };

	    // If the fx queue is dequeued, always remove the progress sentinel
	    if ( fn === "inprogress" ) {
	      fn = queue.shift();
	      startLength--;
	    }

	    if ( fn ) {

	      // Add a progress sentinel to prevent the fx queue from being
	      // automatically dequeued
	      if ( type === "fx" ) {
	        queue.unshift( "inprogress" );
	      }

	      // clear up the last queue stop function
	      delete hooks.stop;
	      fn.call( elem, next, hooks );
	    }

	    if ( !startLength && hooks ) {
	      hooks.empty.fire();
	    }
	  },

	  // not intended for public consumption - generates a queueHooks object, or returns the current one
	  _queueHooks: function( elem, type ) {
	    var key = type + "queueHooks";
	    return data_priv.get( elem, key ) || data_priv.access( elem, key, {
	      empty: jQuery.Callbacks("once memory").add(function() {
	        data_priv.remove( elem, [ type + "queue", key ] );
	      })
	    });
	  }
	});

	jQuery.fn.extend({
	  queue: function( type, data ) {
	    var setter = 2;

	    if ( typeof type !== "string" ) {
	      data = type;
	      type = "fx";
	      setter--;
	    }

	    if ( arguments.length < setter ) {
	      return jQuery.queue( this[0], type );
	    }

	    return data === undefined ?
	      this :
	      this.each(function() {
	        var queue = jQuery.queue( this, type, data );

	        // ensure a hooks for this queue
	        jQuery._queueHooks( this, type );

	        if ( type === "fx" && queue[0] !== "inprogress" ) {
	          jQuery.dequeue( this, type );
	        }
	      });
	  },
	  dequeue: function( type ) {
	    return this.each(function() {
	      jQuery.dequeue( this, type );
	    });
	  },
	  clearQueue: function( type ) {
	    return this.queue( type || "fx", [] );
	  },
	  // Get a promise resolved when queues of a certain type
	  // are emptied (fx is the type by default)
	  promise: function( type, obj ) {
	    var tmp,
	      count = 1,
	      defer = jQuery.Deferred(),
	      elements = this,
	      i = this.length,
	      resolve = function() {
	        if ( !( --count ) ) {
	          defer.resolveWith( elements, [ elements ] );
	        }
	      };

	    if ( typeof type !== "string" ) {
	      obj = type;
	      type = undefined;
	    }
	    type = type || "fx";

	    while ( i-- ) {
	      tmp = data_priv.get( elements[ i ], type + "queueHooks" );
	      if ( tmp && tmp.empty ) {
	        count++;
	        tmp.empty.add( resolve );
	      }
	    }
	    resolve();
	    return defer.promise( obj );
	  }
	});
	var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

	var isHidden = function( elem, el ) {
	    // isHidden might be called from jQuery#filter function;
	    // in that case, element will be second argument
	    elem = el || elem;
	    return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	  };

	var rcheckableType = (/^(?:checkbox|radio)$/i);



	(function() {
	  var fragment = document.createDocumentFragment(),
	    div = fragment.appendChild( document.createElement( "div" ) ),
	    input = document.createElement( "input" );

	  // #11217 - WebKit loses check when the name is after the checked attribute
	  // Support: Windows Web Apps (WWA)
	  // `name` and `type` need .setAttribute for WWA
	  input.setAttribute( "type", "radio" );
	  input.setAttribute( "checked", "checked" );
	  input.setAttribute( "name", "t" );

	  div.appendChild( input );

	  // Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
	  // old WebKit doesn't clone checked state correctly in fragments
	  support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	  // Make sure textarea (and checkbox) defaultValue is properly cloned
	  // Support: IE9-IE11+
	  div.innerHTML = "<textarea>x</textarea>";
	  support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	})();
	var strundefined = typeof undefined;



	support.focusinBubbles = "onfocusin" in window;


	var
	  rkeyEvent = /^key/,
	  rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	  rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	  rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

	function returnTrue() {
	  return true;
	}

	function returnFalse() {
	  return false;
	}

	function safeActiveElement() {
	  try {
	    return document.activeElement;
	  } catch ( err ) { }
	}

	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {

	  global: {},

	  add: function( elem, types, handler, data, selector ) {

	    var handleObjIn, eventHandle, tmp,
	      events, t, handleObj,
	      special, handlers, type, namespaces, origType,
	      elemData = data_priv.get( elem );

	    // Don't attach events to noData or text/comment nodes (but allow plain objects)
	    if ( !elemData ) {
	      return;
	    }

	    // Caller can pass in an object of custom data in lieu of the handler
	    if ( handler.handler ) {
	      handleObjIn = handler;
	      handler = handleObjIn.handler;
	      selector = handleObjIn.selector;
	    }

	    // Make sure that the handler has a unique ID, used to find/remove it later
	    if ( !handler.guid ) {
	      handler.guid = jQuery.guid++;
	    }

	    // Init the element's event structure and main handler, if this is the first
	    if ( !(events = elemData.events) ) {
	      events = elemData.events = {};
	    }
	    if ( !(eventHandle = elemData.handle) ) {
	      eventHandle = elemData.handle = function( e ) {
	        // Discard the second event of a jQuery.event.trigger() and
	        // when an event is called after a page has unloaded
	        return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
	          jQuery.event.dispatch.apply( elem, arguments ) : undefined;
	      };
	    }

	    // Handle multiple events separated by a space
	    types = ( types || "" ).match( rnotwhite ) || [ "" ];
	    t = types.length;
	    while ( t-- ) {
	      tmp = rtypenamespace.exec( types[t] ) || [];
	      type = origType = tmp[1];
	      namespaces = ( tmp[2] || "" ).split( "." ).sort();

	      // There *must* be a type, no attaching namespace-only handlers
	      if ( !type ) {
	        continue;
	      }

	      // If event changes its type, use the special event handlers for the changed type
	      special = jQuery.event.special[ type ] || {};

	      // If selector defined, determine special event api type, otherwise given type
	      type = ( selector ? special.delegateType : special.bindType ) || type;

	      // Update special based on newly reset type
	      special = jQuery.event.special[ type ] || {};

	      // handleObj is passed to all event handlers
	      handleObj = jQuery.extend({
	        type: type,
	        origType: origType,
	        data: data,
	        handler: handler,
	        guid: handler.guid,
	        selector: selector,
	        needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
	        namespace: namespaces.join(".")
	      }, handleObjIn );

	      // Init the event handler queue if we're the first
	      if ( !(handlers = events[ type ]) ) {
	        handlers = events[ type ] = [];
	        handlers.delegateCount = 0;

	        // Only use addEventListener if the special events handler returns false
	        if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	          if ( elem.addEventListener ) {
	            elem.addEventListener( type, eventHandle, false );
	          }
	        }
	      }

	      if ( special.add ) {
	        special.add.call( elem, handleObj );

	        if ( !handleObj.handler.guid ) {
	          handleObj.handler.guid = handler.guid;
	        }
	      }

	      // Add to the element's handler list, delegates in front
	      if ( selector ) {
	        handlers.splice( handlers.delegateCount++, 0, handleObj );
	      } else {
	        handlers.push( handleObj );
	      }

	      // Keep track of which events have ever been used, for event optimization
	      jQuery.event.global[ type ] = true;
	    }

	  },

	  // Detach an event or set of events from an element
	  remove: function( elem, types, handler, selector, mappedTypes ) {

	    var j, origCount, tmp,
	      events, t, handleObj,
	      special, handlers, type, namespaces, origType,
	      elemData = data_priv.hasData( elem ) && data_priv.get( elem );

	    if ( !elemData || !(events = elemData.events) ) {
	      return;
	    }

	    // Once for each type.namespace in types; type may be omitted
	    types = ( types || "" ).match( rnotwhite ) || [ "" ];
	    t = types.length;
	    while ( t-- ) {
	      tmp = rtypenamespace.exec( types[t] ) || [];
	      type = origType = tmp[1];
	      namespaces = ( tmp[2] || "" ).split( "." ).sort();

	      // Unbind all events (on this namespace, if provided) for the element
	      if ( !type ) {
	        for ( type in events ) {
	          jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
	        }
	        continue;
	      }

	      special = jQuery.event.special[ type ] || {};
	      type = ( selector ? special.delegateType : special.bindType ) || type;
	      handlers = events[ type ] || [];
	      tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

	      // Remove matching events
	      origCount = j = handlers.length;
	      while ( j-- ) {
	        handleObj = handlers[ j ];

	        if ( ( mappedTypes || origType === handleObj.origType ) &&
	          ( !handler || handler.guid === handleObj.guid ) &&
	          ( !tmp || tmp.test( handleObj.namespace ) ) &&
	          ( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
	          handlers.splice( j, 1 );

	          if ( handleObj.selector ) {
	            handlers.delegateCount--;
	          }
	          if ( special.remove ) {
	            special.remove.call( elem, handleObj );
	          }
	        }
	      }

	      // Remove generic event handler if we removed something and no more handlers exist
	      // (avoids potential for endless recursion during removal of special event handlers)
	      if ( origCount && !handlers.length ) {
	        if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	          jQuery.removeEvent( elem, type, elemData.handle );
	        }

	        delete events[ type ];
	      }
	    }

	    // Remove the expando if it's no longer used
	    if ( jQuery.isEmptyObject( events ) ) {
	      delete elemData.handle;
	      data_priv.remove( elem, "events" );
	    }
	  },

	  trigger: function( event, data, elem, onlyHandlers ) {

	    var i, cur, tmp, bubbleType, ontype, handle, special,
	      eventPath = [ elem || document ],
	      type = hasOwn.call( event, "type" ) ? event.type : event,
	      namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

	    cur = tmp = elem = elem || document;

	    // Don't do events on text and comment nodes
	    if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
	      return;
	    }

	    // focus/blur morphs to focusin/out; ensure we're not firing them right now
	    if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
	      return;
	    }

	    if ( type.indexOf(".") >= 0 ) {
	      // Namespaced trigger; create a regexp to match event type in handle()
	      namespaces = type.split(".");
	      type = namespaces.shift();
	      namespaces.sort();
	    }
	    ontype = type.indexOf(":") < 0 && "on" + type;

	    // Caller can pass in a jQuery.Event object, Object, or just an event type string
	    event = event[ jQuery.expando ] ?
	      event :
	      new jQuery.Event( type, typeof event === "object" && event );

	    // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
	    event.isTrigger = onlyHandlers ? 2 : 3;
	    event.namespace = namespaces.join(".");
	    event.namespace_re = event.namespace ?
	      new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
	      null;

	    // Clean up the event in case it is being reused
	    event.result = undefined;
	    if ( !event.target ) {
	      event.target = elem;
	    }

	    // Clone any incoming data and prepend the event, creating the handler arg list
	    data = data == null ?
	      [ event ] :
	      jQuery.makeArray( data, [ event ] );

	    // Allow special events to draw outside the lines
	    special = jQuery.event.special[ type ] || {};
	    if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
	      return;
	    }

	    // Determine event propagation path in advance, per W3C events spec (#9951)
	    // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
	    if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

	      bubbleType = special.delegateType || type;
	      if ( !rfocusMorph.test( bubbleType + type ) ) {
	        cur = cur.parentNode;
	      }
	      for ( ; cur; cur = cur.parentNode ) {
	        eventPath.push( cur );
	        tmp = cur;
	      }

	      // Only add window if we got to document (e.g., not plain obj or detached DOM)
	      if ( tmp === (elem.ownerDocument || document) ) {
	        eventPath.push( tmp.defaultView || tmp.parentWindow || window );
	      }
	    }

	    // Fire handlers on the event path
	    i = 0;
	    while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

	      event.type = i > 1 ?
	        bubbleType :
	        special.bindType || type;

	      // jQuery handler
	      handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
	      if ( handle ) {
	        handle.apply( cur, data );
	      }

	      // Native handler
	      handle = ontype && cur[ ontype ];
	      if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
	        event.result = handle.apply( cur, data );
	        if ( event.result === false ) {
	          event.preventDefault();
	        }
	      }
	    }
	    event.type = type;

	    // If nobody prevented the default action, do it now
	    if ( !onlyHandlers && !event.isDefaultPrevented() ) {

	      if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
	        jQuery.acceptData( elem ) ) {

	        // Call a native DOM method on the target with the same name name as the event.
	        // Don't do default actions on window, that's where global variables be (#6170)
	        if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

	          // Don't re-trigger an onFOO event when we call its FOO() method
	          tmp = elem[ ontype ];

	          if ( tmp ) {
	            elem[ ontype ] = null;
	          }

	          // Prevent re-triggering of the same event, since we already bubbled it above
	          jQuery.event.triggered = type;
	          elem[ type ]();
	          jQuery.event.triggered = undefined;

	          if ( tmp ) {
	            elem[ ontype ] = tmp;
	          }
	        }
	      }
	    }

	    return event.result;
	  },

	  dispatch: function( event ) {

	    // Make a writable jQuery.Event from the native event object
	    event = jQuery.event.fix( event );

	    var i, j, ret, matched, handleObj,
	      handlerQueue = [],
	      args = slice.call( arguments ),
	      handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
	      special = jQuery.event.special[ event.type ] || {};

	    // Use the fix-ed jQuery.Event rather than the (read-only) native event
	    args[0] = event;
	    event.delegateTarget = this;

	    // Call the preDispatch hook for the mapped type, and let it bail if desired
	    if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
	      return;
	    }

	    // Determine handlers
	    handlerQueue = jQuery.event.handlers.call( this, event, handlers );

	    // Run delegates first; they may want to stop propagation beneath us
	    i = 0;
	    while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
	      event.currentTarget = matched.elem;

	      j = 0;
	      while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

	        // Triggered event must either 1) have no namespace, or
	        // 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
	        if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

	          event.handleObj = handleObj;
	          event.data = handleObj.data;

	          ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
	              .apply( matched.elem, args );

	          if ( ret !== undefined ) {
	            if ( (event.result = ret) === false ) {
	              event.preventDefault();
	              event.stopPropagation();
	            }
	          }
	        }
	      }
	    }

	    // Call the postDispatch hook for the mapped type
	    if ( special.postDispatch ) {
	      special.postDispatch.call( this, event );
	    }

	    return event.result;
	  },

	  handlers: function( event, handlers ) {
	    var i, matches, sel, handleObj,
	      handlerQueue = [],
	      delegateCount = handlers.delegateCount,
	      cur = event.target;

	    // Find delegate handlers
	    // Black-hole SVG <use> instance trees (#13180)
	    // Avoid non-left-click bubbling in Firefox (#3861)
	    if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

	      for ( ; cur !== this; cur = cur.parentNode || this ) {

	        // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
	        if ( cur.disabled !== true || event.type !== "click" ) {
	          matches = [];
	          for ( i = 0; i < delegateCount; i++ ) {
	            handleObj = handlers[ i ];

	            // Don't conflict with Object.prototype properties (#13203)
	            sel = handleObj.selector + " ";

	            if ( matches[ sel ] === undefined ) {
	              matches[ sel ] = handleObj.needsContext ?
	                jQuery( sel, this ).index( cur ) >= 0 :
	                jQuery.find( sel, this, null, [ cur ] ).length;
	            }
	            if ( matches[ sel ] ) {
	              matches.push( handleObj );
	            }
	          }
	          if ( matches.length ) {
	            handlerQueue.push({ elem: cur, handlers: matches });
	          }
	        }
	      }
	    }

	    // Add the remaining (directly-bound) handlers
	    if ( delegateCount < handlers.length ) {
	      handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
	    }

	    return handlerQueue;
	  },

	  // Includes some event props shared by KeyEvent and MouseEvent
	  props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	  fixHooks: {},

	  keyHooks: {
	    props: "char charCode key keyCode".split(" "),
	    filter: function( event, original ) {

	      // Add which for key events
	      if ( event.which == null ) {
	        event.which = original.charCode != null ? original.charCode : original.keyCode;
	      }

	      return event;
	    }
	  },

	  mouseHooks: {
	    props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
	    filter: function( event, original ) {
	      var eventDoc, doc, body,
	        button = original.button;

	      // Calculate pageX/Y if missing and clientX/Y available
	      if ( event.pageX == null && original.clientX != null ) {
	        eventDoc = event.target.ownerDocument || document;
	        doc = eventDoc.documentElement;
	        body = eventDoc.body;

	        event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
	        event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
	      }

	      // Add which for click: 1 === left; 2 === middle; 3 === right
	      // Note: button is not normalized, so don't use it
	      if ( !event.which && button !== undefined ) {
	        event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
	      }

	      return event;
	    }
	  },

	  fix: function( event ) {
	    if ( event[ jQuery.expando ] ) {
	      return event;
	    }

	    // Create a writable copy of the event object and normalize some properties
	    var i, prop, copy,
	      type = event.type,
	      originalEvent = event,
	      fixHook = this.fixHooks[ type ];

	    if ( !fixHook ) {
	      this.fixHooks[ type ] = fixHook =
	        rmouseEvent.test( type ) ? this.mouseHooks :
	        rkeyEvent.test( type ) ? this.keyHooks :
	        {};
	    }
	    copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

	    event = new jQuery.Event( originalEvent );

	    i = copy.length;
	    while ( i-- ) {
	      prop = copy[ i ];
	      event[ prop ] = originalEvent[ prop ];
	    }

	    // Support: Cordova 2.5 (WebKit) (#13255)
	    // All events should have a target; Cordova deviceready doesn't
	    if ( !event.target ) {
	      event.target = document;
	    }

	    // Support: Safari 6.0+, Chrome < 28
	    // Target should not be a text node (#504, #13143)
	    if ( event.target.nodeType === 3 ) {
	      event.target = event.target.parentNode;
	    }

	    return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	  },

	  special: {
	    load: {
	      // Prevent triggered image.load events from bubbling to window.load
	      noBubble: true
	    },
	    focus: {
	      // Fire native event if possible so blur/focus sequence is correct
	      trigger: function() {
	        if ( this !== safeActiveElement() && this.focus ) {
	          this.focus();
	          return false;
	        }
	      },
	      delegateType: "focusin"
	    },
	    blur: {
	      trigger: function() {
	        if ( this === safeActiveElement() && this.blur ) {
	          this.blur();
	          return false;
	        }
	      },
	      delegateType: "focusout"
	    },
	    click: {
	      // For checkbox, fire native event so checked state will be right
	      trigger: function() {
	        if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
	          this.click();
	          return false;
	        }
	      },

	      // For cross-browser consistency, don't fire native .click() on links
	      _default: function( event ) {
	        return jQuery.nodeName( event.target, "a" );
	      }
	    },

	    beforeunload: {
	      postDispatch: function( event ) {

	        // Support: Firefox 20+
	        // Firefox doesn't alert if the returnValue field is not set.
	        if ( event.result !== undefined && event.originalEvent ) {
	          event.originalEvent.returnValue = event.result;
	        }
	      }
	    }
	  },

	  simulate: function( type, elem, event, bubble ) {
	    // Piggyback on a donor event to simulate a different one.
	    // Fake originalEvent to avoid donor's stopPropagation, but if the
	    // simulated event prevents default then we do the same on the donor.
	    var e = jQuery.extend(
	      new jQuery.Event(),
	      event,
	      {
	        type: type,
	        isSimulated: true,
	        originalEvent: {}
	      }
	    );
	    if ( bubble ) {
	      jQuery.event.trigger( e, null, elem );
	    } else {
	      jQuery.event.dispatch.call( elem, e );
	    }
	    if ( e.isDefaultPrevented() ) {
	      event.preventDefault();
	    }
	  }
	};

	jQuery.removeEvent = function( elem, type, handle ) {
	  if ( elem.removeEventListener ) {
	    elem.removeEventListener( type, handle, false );
	  }
	};

	jQuery.Event = function( src, props ) {
	  // Allow instantiation without the 'new' keyword
	  if ( !(this instanceof jQuery.Event) ) {
	    return new jQuery.Event( src, props );
	  }

	  // Event object
	  if ( src && src.type ) {
	    this.originalEvent = src;
	    this.type = src.type;

	    // Events bubbling up the document may have been marked as prevented
	    // by a handler lower down the tree; reflect the correct value.
	    this.isDefaultPrevented = src.defaultPrevented ||
	        src.defaultPrevented === undefined &&
	        // Support: Android < 4.0
	        src.returnValue === false ?
	      returnTrue :
	      returnFalse;

	  // Event type
	  } else {
	    this.type = src;
	  }

	  // Put explicitly provided properties onto the event object
	  if ( props ) {
	    jQuery.extend( this, props );
	  }

	  // Create a timestamp if incoming event doesn't have one
	  this.timeStamp = src && src.timeStamp || jQuery.now();

	  // Mark it as fixed
	  this[ jQuery.expando ] = true;
	};

	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
	  isDefaultPrevented: returnFalse,
	  isPropagationStopped: returnFalse,
	  isImmediatePropagationStopped: returnFalse,

	  preventDefault: function() {
	    var e = this.originalEvent;

	    this.isDefaultPrevented = returnTrue;

	    if ( e && e.preventDefault ) {
	      e.preventDefault();
	    }
	  },
	  stopPropagation: function() {
	    var e = this.originalEvent;

	    this.isPropagationStopped = returnTrue;

	    if ( e && e.stopPropagation ) {
	      e.stopPropagation();
	    }
	  },
	  stopImmediatePropagation: function() {
	    var e = this.originalEvent;

	    this.isImmediatePropagationStopped = returnTrue;

	    if ( e && e.stopImmediatePropagation ) {
	      e.stopImmediatePropagation();
	    }

	    this.stopPropagation();
	  }
	};

	// Create mouseenter/leave events using mouseover/out and event-time checks
	// Support: Chrome 15+
	jQuery.each({
	  mouseenter: "mouseover",
	  mouseleave: "mouseout",
	  pointerenter: "pointerover",
	  pointerleave: "pointerout"
	}, function( orig, fix ) {
	  jQuery.event.special[ orig ] = {
	    delegateType: fix,
	    bindType: fix,

	    handle: function( event ) {
	      var ret,
	        target = this,
	        related = event.relatedTarget,
	        handleObj = event.handleObj;

	      // For mousenter/leave call the handler if related is outside the target.
	      // NB: No relatedTarget if the mouse left/entered the browser window
	      if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
	        event.type = handleObj.origType;
	        ret = handleObj.handler.apply( this, arguments );
	        event.type = fix;
	      }
	      return ret;
	    }
	  };
	});

	// Create "bubbling" focus and blur events
	// Support: Firefox, Chrome, Safari
	if ( !support.focusinBubbles ) {
	  jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

	    // Attach a single capturing handler on the document while someone wants focusin/focusout
	    var handler = function( event ) {
	        jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
	      };

	    jQuery.event.special[ fix ] = {
	      setup: function() {
	        var doc = this.ownerDocument || this,
	          attaches = data_priv.access( doc, fix );

	        if ( !attaches ) {
	          doc.addEventListener( orig, handler, true );
	        }
	        data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
	      },
	      teardown: function() {
	        var doc = this.ownerDocument || this,
	          attaches = data_priv.access( doc, fix ) - 1;

	        if ( !attaches ) {
	          doc.removeEventListener( orig, handler, true );
	          data_priv.remove( doc, fix );

	        } else {
	          data_priv.access( doc, fix, attaches );
	        }
	      }
	    };
	  });
	}

	jQuery.fn.extend({

	  on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
	    var origFn, type;

	    // Types can be a map of types/handlers
	    if ( typeof types === "object" ) {
	      // ( types-Object, selector, data )
	      if ( typeof selector !== "string" ) {
	        // ( types-Object, data )
	        data = data || selector;
	        selector = undefined;
	      }
	      for ( type in types ) {
	        this.on( type, selector, data, types[ type ], one );
	      }
	      return this;
	    }

	    if ( data == null && fn == null ) {
	      // ( types, fn )
	      fn = selector;
	      data = selector = undefined;
	    } else if ( fn == null ) {
	      if ( typeof selector === "string" ) {
	        // ( types, selector, fn )
	        fn = data;
	        data = undefined;
	      } else {
	        // ( types, data, fn )
	        fn = data;
	        data = selector;
	        selector = undefined;
	      }
	    }
	    if ( fn === false ) {
	      fn = returnFalse;
	    } else if ( !fn ) {
	      return this;
	    }

	    if ( one === 1 ) {
	      origFn = fn;
	      fn = function( event ) {
	        // Can use an empty set, since event contains the info
	        jQuery().off( event );
	        return origFn.apply( this, arguments );
	      };
	      // Use same guid so caller can remove using origFn
	      fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	    }
	    return this.each( function() {
	      jQuery.event.add( this, types, fn, data, selector );
	    });
	  },
	  one: function( types, selector, data, fn ) {
	    return this.on( types, selector, data, fn, 1 );
	  },
	  off: function( types, selector, fn ) {
	    var handleObj, type;
	    if ( types && types.preventDefault && types.handleObj ) {
	      // ( event )  dispatched jQuery.Event
	      handleObj = types.handleObj;
	      jQuery( types.delegateTarget ).off(
	        handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
	        handleObj.selector,
	        handleObj.handler
	      );
	      return this;
	    }
	    if ( typeof types === "object" ) {
	      // ( types-object [, selector] )
	      for ( type in types ) {
	        this.off( type, selector, types[ type ] );
	      }
	      return this;
	    }
	    if ( selector === false || typeof selector === "function" ) {
	      // ( types [, fn] )
	      fn = selector;
	      selector = undefined;
	    }
	    if ( fn === false ) {
	      fn = returnFalse;
	    }
	    return this.each(function() {
	      jQuery.event.remove( this, types, fn, selector );
	    });
	  },

	  trigger: function( type, data ) {
	    return this.each(function() {
	      jQuery.event.trigger( type, data, this );
	    });
	  },
	  triggerHandler: function( type, data ) {
	    var elem = this[0];
	    if ( elem ) {
	      return jQuery.event.trigger( type, data, elem, true );
	    }
	  }
	});


	var
	  rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	  rtagName = /<([\w:]+)/,
	  rhtml = /<|&#?\w+;/,
	  rnoInnerhtml = /<(?:script|style|link)/i,
	  // checked="checked" or checked
	  rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	  rscriptType = /^$|\/(?:java|ecma)script/i,
	  rscriptTypeMasked = /^true\/(.*)/,
	  rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	  // We have to close these tags to support XHTML (#13200)
	  wrapMap = {

	    // Support: IE 9
	    option: [ 1, "<select multiple='multiple'>", "</select>" ],

	    thead: [ 1, "<table>", "</table>" ],
	    col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	    tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	    td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	    _default: [ 0, "", "" ]
	  };

	// Support: IE 9
	wrapMap.optgroup = wrapMap.option;

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;

	// Support: 1.x compatibility
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
	  return jQuery.nodeName( elem, "table" ) &&
	    jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

	    elem.getElementsByTagName("tbody")[0] ||
	      elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
	    elem;
	}

	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
	  elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	  return elem;
	}
	function restoreScript( elem ) {
	  var match = rscriptTypeMasked.exec( elem.type );

	  if ( match ) {
	    elem.type = match[ 1 ];
	  } else {
	    elem.removeAttribute("type");
	  }

	  return elem;
	}

	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
	  var i = 0,
	    l = elems.length;

	  for ( ; i < l; i++ ) {
	    data_priv.set(
	      elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
	    );
	  }
	}

	function cloneCopyEvent( src, dest ) {
	  var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	  if ( dest.nodeType !== 1 ) {
	    return;
	  }

	  // 1. Copy private data: events, handlers, etc.
	  if ( data_priv.hasData( src ) ) {
	    pdataOld = data_priv.access( src );
	    pdataCur = data_priv.set( dest, pdataOld );
	    events = pdataOld.events;

	    if ( events ) {
	      delete pdataCur.handle;
	      pdataCur.events = {};

	      for ( type in events ) {
	        for ( i = 0, l = events[ type ].length; i < l; i++ ) {
	          jQuery.event.add( dest, type, events[ type ][ i ] );
	        }
	      }
	    }
	  }

	  // 2. Copy user data
	  if ( data_user.hasData( src ) ) {
	    udataOld = data_user.access( src );
	    udataCur = jQuery.extend( {}, udataOld );

	    data_user.set( dest, udataCur );
	  }
	}

	function getAll( context, tag ) {
	  var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
	      context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
	      [];

	  return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
	    jQuery.merge( [ context ], ret ) :
	    ret;
	}

	// Support: IE >= 9
	function fixInput( src, dest ) {
	  var nodeName = dest.nodeName.toLowerCase();

	  // Fails to persist the checked state of a cloned checkbox or radio button.
	  if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
	    dest.checked = src.checked;

	  // Fails to return the selected option to the default selected state when cloning options
	  } else if ( nodeName === "input" || nodeName === "textarea" ) {
	    dest.defaultValue = src.defaultValue;
	  }
	}

	jQuery.extend({
	  clone: function( elem, dataAndEvents, deepDataAndEvents ) {
	    var i, l, srcElements, destElements,
	      clone = elem.cloneNode( true ),
	      inPage = jQuery.contains( elem.ownerDocument, elem );

	    // Support: IE >= 9
	    // Fix Cloning issues
	    if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
	        !jQuery.isXMLDoc( elem ) ) {

	      // We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
	      destElements = getAll( clone );
	      srcElements = getAll( elem );

	      for ( i = 0, l = srcElements.length; i < l; i++ ) {
	        fixInput( srcElements[ i ], destElements[ i ] );
	      }
	    }

	    // Copy the events from the original to the clone
	    if ( dataAndEvents ) {
	      if ( deepDataAndEvents ) {
	        srcElements = srcElements || getAll( elem );
	        destElements = destElements || getAll( clone );

	        for ( i = 0, l = srcElements.length; i < l; i++ ) {
	          cloneCopyEvent( srcElements[ i ], destElements[ i ] );
	        }
	      } else {
	        cloneCopyEvent( elem, clone );
	      }
	    }

	    // Preserve script evaluation history
	    destElements = getAll( clone, "script" );
	    if ( destElements.length > 0 ) {
	      setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
	    }

	    // Return the cloned set
	    return clone;
	  },

	  buildFragment: function( elems, context, scripts, selection ) {
	    var elem, tmp, tag, wrap, contains, j,
	      fragment = context.createDocumentFragment(),
	      nodes = [],
	      i = 0,
	      l = elems.length;

	    for ( ; i < l; i++ ) {
	      elem = elems[ i ];

	      if ( elem || elem === 0 ) {

	        // Add nodes directly
	        if ( jQuery.type( elem ) === "object" ) {
	          // Support: QtWebKit
	          // jQuery.merge because push.apply(_, arraylike) throws
	          jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

	        // Convert non-html into a text node
	        } else if ( !rhtml.test( elem ) ) {
	          nodes.push( context.createTextNode( elem ) );

	        // Convert html into DOM nodes
	        } else {
	          tmp = tmp || fragment.appendChild( context.createElement("div") );

	          // Deserialize a standard representation
	          tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
	          wrap = wrapMap[ tag ] || wrapMap._default;
	          tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

	          // Descend through wrappers to the right content
	          j = wrap[ 0 ];
	          while ( j-- ) {
	            tmp = tmp.lastChild;
	          }

	          // Support: QtWebKit
	          // jQuery.merge because push.apply(_, arraylike) throws
	          jQuery.merge( nodes, tmp.childNodes );

	          // Remember the top-level container
	          tmp = fragment.firstChild;

	          // Fixes #12346
	          // Support: Webkit, IE
	          tmp.textContent = "";
	        }
	      }
	    }

	    // Remove wrapper from fragment
	    fragment.textContent = "";

	    i = 0;
	    while ( (elem = nodes[ i++ ]) ) {

	      // #4087 - If origin and destination elements are the same, and this is
	      // that element, do not do anything
	      if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
	        continue;
	      }

	      contains = jQuery.contains( elem.ownerDocument, elem );

	      // Append to fragment
	      tmp = getAll( fragment.appendChild( elem ), "script" );

	      // Preserve script evaluation history
	      if ( contains ) {
	        setGlobalEval( tmp );
	      }

	      // Capture executables
	      if ( scripts ) {
	        j = 0;
	        while ( (elem = tmp[ j++ ]) ) {
	          if ( rscriptType.test( elem.type || "" ) ) {
	            scripts.push( elem );
	          }
	        }
	      }
	    }

	    return fragment;
	  },

	  cleanData: function( elems ) {
	    var data, elem, type, key,
	      special = jQuery.event.special,
	      i = 0;

	    for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
	      if ( jQuery.acceptData( elem ) ) {
	        key = elem[ data_priv.expando ];

	        if ( key && (data = data_priv.cache[ key ]) ) {
	          if ( data.events ) {
	            for ( type in data.events ) {
	              if ( special[ type ] ) {
	                jQuery.event.remove( elem, type );

	              // This is a shortcut to avoid jQuery.event.remove's overhead
	              } else {
	                jQuery.removeEvent( elem, type, data.handle );
	              }
	            }
	          }
	          if ( data_priv.cache[ key ] ) {
	            // Discard any remaining `private` data
	            delete data_priv.cache[ key ];
	          }
	        }
	      }
	      // Discard any remaining `user` data
	      delete data_user.cache[ elem[ data_user.expando ] ];
	    }
	  }
	});

	jQuery.fn.extend({
	  text: function( value ) {
	    return access( this, function( value ) {
	      return value === undefined ?
	        jQuery.text( this ) :
	        this.empty().each(function() {
	          if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
	            this.textContent = value;
	          }
	        });
	    }, null, value, arguments.length );
	  },

	  append: function() {
	    return this.domManip( arguments, function( elem ) {
	      if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
	        var target = manipulationTarget( this, elem );
	        target.appendChild( elem );
	      }
	    });
	  },

	  prepend: function() {
	    return this.domManip( arguments, function( elem ) {
	      if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
	        var target = manipulationTarget( this, elem );
	        target.insertBefore( elem, target.firstChild );
	      }
	    });
	  },

	  before: function() {
	    return this.domManip( arguments, function( elem ) {
	      if ( this.parentNode ) {
	        this.parentNode.insertBefore( elem, this );
	      }
	    });
	  },

	  after: function() {
	    return this.domManip( arguments, function( elem ) {
	      if ( this.parentNode ) {
	        this.parentNode.insertBefore( elem, this.nextSibling );
	      }
	    });
	  },

	  remove: function( selector, keepData /* Internal Use Only */ ) {
	    var elem,
	      elems = selector ? jQuery.filter( selector, this ) : this,
	      i = 0;

	    for ( ; (elem = elems[i]) != null; i++ ) {
	      if ( !keepData && elem.nodeType === 1 ) {
	        jQuery.cleanData( getAll( elem ) );
	      }

	      if ( elem.parentNode ) {
	        if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
	          setGlobalEval( getAll( elem, "script" ) );
	        }
	        elem.parentNode.removeChild( elem );
	      }
	    }

	    return this;
	  },

	  empty: function() {
	    var elem,
	      i = 0;

	    for ( ; (elem = this[i]) != null; i++ ) {
	      if ( elem.nodeType === 1 ) {

	        // Prevent memory leaks
	        jQuery.cleanData( getAll( elem, false ) );

	        // Remove any remaining nodes
	        elem.textContent = "";
	      }
	    }

	    return this;
	  },

	  clone: function( dataAndEvents, deepDataAndEvents ) {
	    dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
	    deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

	    return this.map(function() {
	      return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
	    });
	  },

	  html: function( value ) {
	    return access( this, function( value ) {
	      var elem = this[ 0 ] || {},
	        i = 0,
	        l = this.length;

	      if ( value === undefined && elem.nodeType === 1 ) {
	        return elem.innerHTML;
	      }

	      // See if we can take a shortcut and just use innerHTML
	      if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
	        !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

	        value = value.replace( rxhtmlTag, "<$1></$2>" );

	        try {
	          for ( ; i < l; i++ ) {
	            elem = this[ i ] || {};

	            // Remove element nodes and prevent memory leaks
	            if ( elem.nodeType === 1 ) {
	              jQuery.cleanData( getAll( elem, false ) );
	              elem.innerHTML = value;
	            }
	          }

	          elem = 0;

	        // If using innerHTML throws an exception, use the fallback method
	        } catch( e ) {}
	      }

	      if ( elem ) {
	        this.empty().append( value );
	      }
	    }, null, value, arguments.length );
	  },

	  replaceWith: function() {
	    var arg = arguments[ 0 ];

	    // Make the changes, replacing each context element with the new content
	    this.domManip( arguments, function( elem ) {
	      arg = this.parentNode;

	      jQuery.cleanData( getAll( this ) );

	      if ( arg ) {
	        arg.replaceChild( elem, this );
	      }
	    });

	    // Force removal if there was no new content (e.g., from empty arguments)
	    return arg && (arg.length || arg.nodeType) ? this : this.remove();
	  },

	  detach: function( selector ) {
	    return this.remove( selector, true );
	  },

	  domManip: function( args, callback ) {

	    // Flatten any nested arrays
	    args = concat.apply( [], args );

	    var fragment, first, scripts, hasScripts, node, doc,
	      i = 0,
	      l = this.length,
	      set = this,
	      iNoClone = l - 1,
	      value = args[ 0 ],
	      isFunction = jQuery.isFunction( value );

	    // We can't cloneNode fragments that contain checked, in WebKit
	    if ( isFunction ||
	        ( l > 1 && typeof value === "string" &&
	          !support.checkClone && rchecked.test( value ) ) ) {
	      return this.each(function( index ) {
	        var self = set.eq( index );
	        if ( isFunction ) {
	          args[ 0 ] = value.call( this, index, self.html() );
	        }
	        self.domManip( args, callback );
	      });
	    }

	    if ( l ) {
	      fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
	      first = fragment.firstChild;

	      if ( fragment.childNodes.length === 1 ) {
	        fragment = first;
	      }

	      if ( first ) {
	        scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
	        hasScripts = scripts.length;

	        // Use the original fragment for the last item instead of the first because it can end up
	        // being emptied incorrectly in certain situations (#8070).
	        for ( ; i < l; i++ ) {
	          node = fragment;

	          if ( i !== iNoClone ) {
	            node = jQuery.clone( node, true, true );

	            // Keep references to cloned scripts for later restoration
	            if ( hasScripts ) {
	              // Support: QtWebKit
	              // jQuery.merge because push.apply(_, arraylike) throws
	              jQuery.merge( scripts, getAll( node, "script" ) );
	            }
	          }

	          callback.call( this[ i ], node, i );
	        }

	        if ( hasScripts ) {
	          doc = scripts[ scripts.length - 1 ].ownerDocument;

	          // Reenable scripts
	          jQuery.map( scripts, restoreScript );

	          // Evaluate executable scripts on first document insertion
	          for ( i = 0; i < hasScripts; i++ ) {
	            node = scripts[ i ];
	            if ( rscriptType.test( node.type || "" ) &&
	              !data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

	              if ( node.src ) {
	                // Optional AJAX dependency, but won't run scripts if not present
	                if ( jQuery._evalUrl ) {
	                  jQuery._evalUrl( node.src );
	                }
	              } else {
	                jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
	              }
	            }
	          }
	        }
	      }
	    }

	    return this;
	  }
	});

	jQuery.each({
	  appendTo: "append",
	  prependTo: "prepend",
	  insertBefore: "before",
	  insertAfter: "after",
	  replaceAll: "replaceWith"
	}, function( name, original ) {
	  jQuery.fn[ name ] = function( selector ) {
	    var elems,
	      ret = [],
	      insert = jQuery( selector ),
	      last = insert.length - 1,
	      i = 0;

	    for ( ; i <= last; i++ ) {
	      elems = i === last ? this : this.clone( true );
	      jQuery( insert[ i ] )[ original ]( elems );

	      // Support: QtWebKit
	      // .get() because push.apply(_, arraylike) throws
	      push.apply( ret, elems.get() );
	    }

	    return this.pushStack( ret );
	  };
	});


	var iframe,
	  elemdisplay = {};

	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
	  var style,
	    elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

	    // getDefaultComputedStyle might be reliably used only on attached element
	    display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

	      // Use of this method is a temporary fix (more like optmization) until something better comes along,
	      // since it was removed from specification and supported only in FF
	      style.display : jQuery.css( elem[ 0 ], "display" );

	  // We don't have any data stored on the element,
	  // so use "detach" method as fast way to get rid of the element
	  elem.detach();

	  return display;
	}

	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
	  var doc = document,
	    display = elemdisplay[ nodeName ];

	  if ( !display ) {
	    display = actualDisplay( nodeName, doc );

	    // If the simple way fails, read from inside an iframe
	    if ( display === "none" || !display ) {

	      // Use the already-created iframe if possible
	      iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

	      // Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
	      doc = iframe[ 0 ].contentDocument;

	      // Support: IE
	      doc.write();
	      doc.close();

	      display = actualDisplay( nodeName, doc );
	      iframe.detach();
	    }

	    // Store the correct default display
	    elemdisplay[ nodeName ] = display;
	  }

	  return display;
	}
	var rmargin = (/^margin/);

	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

	var getStyles = function( elem ) {
	    return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
	  };



	function curCSS( elem, name, computed ) {
	  var width, minWidth, maxWidth, ret,
	    style = elem.style;

	  computed = computed || getStyles( elem );

	  // Support: IE9
	  // getPropertyValue is only needed for .css('filter') in IE9, see #12537
	  if ( computed ) {
	    ret = computed.getPropertyValue( name ) || computed[ name ];
	  }

	  if ( computed ) {

	    if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
	      ret = jQuery.style( elem, name );
	    }

	    // Support: iOS < 6
	    // A tribute to the "awesome hack by Dean Edwards"
	    // iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
	    // this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
	    if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

	      // Remember the original values
	      width = style.width;
	      minWidth = style.minWidth;
	      maxWidth = style.maxWidth;

	      // Put in the new values to get a computed value out
	      style.minWidth = style.maxWidth = style.width = ret;
	      ret = computed.width;

	      // Revert the changed values
	      style.width = width;
	      style.minWidth = minWidth;
	      style.maxWidth = maxWidth;
	    }
	  }

	  return ret !== undefined ?
	    // Support: IE
	    // IE returns zIndex value as an integer.
	    ret + "" :
	    ret;
	}


	function addGetHookIf( conditionFn, hookFn ) {
	  // Define the hook, we'll check on the first run if it's really needed.
	  return {
	    get: function() {
	      if ( conditionFn() ) {
	        // Hook not needed (or it's not possible to use it due to missing dependency),
	        // remove it.
	        // Since there are no other hooks for marginRight, remove the whole object.
	        delete this.get;
	        return;
	      }

	      // Hook needed; redefine it so that the support test is not executed again.

	      return (this.get = hookFn).apply( this, arguments );
	    }
	  };
	}


	(function() {
	  var pixelPositionVal, boxSizingReliableVal,
	    docElem = document.documentElement,
	    container = document.createElement( "div" ),
	    div = document.createElement( "div" );

	  if ( !div.style ) {
	    return;
	  }

	  div.style.backgroundClip = "content-box";
	  div.cloneNode( true ).style.backgroundClip = "";
	  support.clearCloneStyle = div.style.backgroundClip === "content-box";

	  container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
	    "position:absolute";
	  container.appendChild( div );

	  // Executing both pixelPosition & boxSizingReliable tests require only one layout
	  // so they're executed at the same time to save the second computation.
	  function computePixelPositionAndBoxSizingReliable() {
	    div.style.cssText =
	      // Support: Firefox<29, Android 2.3
	      // Vendor-prefix box-sizing
	      "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
	      "box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
	      "border:1px;padding:1px;width:4px;position:absolute";
	    div.innerHTML = "";
	    docElem.appendChild( container );

	    var divStyle = window.getComputedStyle( div, null );
	    pixelPositionVal = divStyle.top !== "1%";
	    boxSizingReliableVal = divStyle.width === "4px";

	    docElem.removeChild( container );
	  }

	  // Support: node.js jsdom
	  // Don't assume that getComputedStyle is a property of the global object
	  if ( window.getComputedStyle ) {
	    jQuery.extend( support, {
	      pixelPosition: function() {
	        // This test is executed only once but we still do memoizing
	        // since we can use the boxSizingReliable pre-computing.
	        // No need to check if the test was already performed, though.
	        computePixelPositionAndBoxSizingReliable();
	        return pixelPositionVal;
	      },
	      boxSizingReliable: function() {
	        if ( boxSizingReliableVal == null ) {
	          computePixelPositionAndBoxSizingReliable();
	        }
	        return boxSizingReliableVal;
	      },
	      reliableMarginRight: function() {
	        // Support: Android 2.3
	        // Check if div with explicit width and no margin-right incorrectly
	        // gets computed margin-right based on width of container. (#3333)
	        // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
	        // This support function is only executed once so no memoizing is needed.
	        var ret,
	          marginDiv = div.appendChild( document.createElement( "div" ) );

	        // Reset CSS: box-sizing; display; margin; border; padding
	        marginDiv.style.cssText = div.style.cssText =
	          // Support: Firefox<29, Android 2.3
	          // Vendor-prefix box-sizing
	          "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
	          "box-sizing:content-box;display:block;margin:0;border:0;padding:0";
	        marginDiv.style.marginRight = marginDiv.style.width = "0";
	        div.style.width = "1px";
	        docElem.appendChild( container );

	        ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );

	        docElem.removeChild( container );

	        return ret;
	      }
	    });
	  }
	})();


	// A method for quickly swapping in/out CSS properties to get correct calculations.
	jQuery.swap = function( elem, options, callback, args ) {
	  var ret, name,
	    old = {};

	  // Remember the old values, and insert the new ones
	  for ( name in options ) {
	    old[ name ] = elem.style[ name ];
	    elem.style[ name ] = options[ name ];
	  }

	  ret = callback.apply( elem, args || [] );

	  // Revert the old values
	  for ( name in options ) {
	    elem.style[ name ] = old[ name ];
	  }

	  return ret;
	};


	var
	  // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	  // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	  rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	  rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	  rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	  cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	  cssNormalTransform = {
	    letterSpacing: "0",
	    fontWeight: "400"
	  },

	  cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {

	  // shortcut for names that are not vendor prefixed
	  if ( name in style ) {
	    return name;
	  }

	  // check for vendor prefixed names
	  var capName = name[0].toUpperCase() + name.slice(1),
	    origName = name,
	    i = cssPrefixes.length;

	  while ( i-- ) {
	    name = cssPrefixes[ i ] + capName;
	    if ( name in style ) {
	      return name;
	    }
	  }

	  return origName;
	}

	function setPositiveNumber( elem, value, subtract ) {
	  var matches = rnumsplit.exec( value );
	  return matches ?
	    // Guard against undefined "subtract", e.g., when used as in cssHooks
	    Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
	    value;
	}

	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	  var i = extra === ( isBorderBox ? "border" : "content" ) ?
	    // If we already have the right measurement, avoid augmentation
	    4 :
	    // Otherwise initialize for horizontal or vertical properties
	    name === "width" ? 1 : 0,

	    val = 0;

	  for ( ; i < 4; i += 2 ) {
	    // both box models exclude margin, so add it if we want it
	    if ( extra === "margin" ) {
	      val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
	    }

	    if ( isBorderBox ) {
	      // border-box includes padding, so remove it if we want content
	      if ( extra === "content" ) {
	        val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	      }

	      // at this point, extra isn't border nor margin, so remove border
	      if ( extra !== "margin" ) {
	        val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	      }
	    } else {
	      // at this point, extra isn't content, so add padding
	      val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

	      // at this point, extra isn't content nor padding, so add border
	      if ( extra !== "padding" ) {
	        val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	      }
	    }
	  }

	  return val;
	}

	function getWidthOrHeight( elem, name, extra ) {

	  // Start with offset property, which is equivalent to the border-box value
	  var valueIsBorderBox = true,
	    val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
	    styles = getStyles( elem ),
	    isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	  // some non-html elements return undefined for offsetWidth, so check for null/undefined
	  // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	  // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	  if ( val <= 0 || val == null ) {
	    // Fall back to computed then uncomputed css if necessary
	    val = curCSS( elem, name, styles );
	    if ( val < 0 || val == null ) {
	      val = elem.style[ name ];
	    }

	    // Computed unit is not pixels. Stop here and return.
	    if ( rnumnonpx.test(val) ) {
	      return val;
	    }

	    // we need the check for style in case a browser which returns unreliable values
	    // for getComputedStyle silently falls back to the reliable elem.style
	    valueIsBorderBox = isBorderBox &&
	      ( support.boxSizingReliable() || val === elem.style[ name ] );

	    // Normalize "", auto, and prepare for extra
	    val = parseFloat( val ) || 0;
	  }

	  // use the active box-sizing model to add/subtract irrelevant styles
	  return ( val +
	    augmentWidthOrHeight(
	      elem,
	      name,
	      extra || ( isBorderBox ? "border" : "content" ),
	      valueIsBorderBox,
	      styles
	    )
	  ) + "px";
	}

	function showHide( elements, show ) {
	  var display, elem, hidden,
	    values = [],
	    index = 0,
	    length = elements.length;

	  for ( ; index < length; index++ ) {
	    elem = elements[ index ];
	    if ( !elem.style ) {
	      continue;
	    }

	    values[ index ] = data_priv.get( elem, "olddisplay" );
	    display = elem.style.display;
	    if ( show ) {
	      // Reset the inline display of this element to learn if it is
	      // being hidden by cascaded rules or not
	      if ( !values[ index ] && display === "none" ) {
	        elem.style.display = "";
	      }

	      // Set elements which have been overridden with display: none
	      // in a stylesheet to whatever the default browser style is
	      // for such an element
	      if ( elem.style.display === "" && isHidden( elem ) ) {
	        values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
	      }
	    } else {
	      hidden = isHidden( elem );

	      if ( display !== "none" || !hidden ) {
	        data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
	      }
	    }
	  }

	  // Set the display of most of the elements in a second loop
	  // to avoid the constant reflow
	  for ( index = 0; index < length; index++ ) {
	    elem = elements[ index ];
	    if ( !elem.style ) {
	      continue;
	    }
	    if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
	      elem.style.display = show ? values[ index ] || "" : "none";
	    }
	  }

	  return elements;
	}

	jQuery.extend({
	  // Add in style property hooks for overriding the default
	  // behavior of getting and setting a style property
	  cssHooks: {
	    opacity: {
	      get: function( elem, computed ) {
	        if ( computed ) {
	          // We should always get a number back from opacity
	          var ret = curCSS( elem, "opacity" );
	          return ret === "" ? "1" : ret;
	        }
	      }
	    }
	  },

	  // Don't automatically add "px" to these possibly-unitless properties
	  cssNumber: {
	    "columnCount": true,
	    "fillOpacity": true,
	    "flexGrow": true,
	    "flexShrink": true,
	    "fontWeight": true,
	    "lineHeight": true,
	    "opacity": true,
	    "order": true,
	    "orphans": true,
	    "widows": true,
	    "zIndex": true,
	    "zoom": true
	  },

	  // Add in properties whose names you wish to fix before
	  // setting or getting the value
	  cssProps: {
	    // normalize float css property
	    "float": "cssFloat"
	  },

	  // Get and set the style property on a DOM Node
	  style: function( elem, name, value, extra ) {
	    // Don't set styles on text and comment nodes
	    if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
	      return;
	    }

	    // Make sure that we're working with the right name
	    var ret, type, hooks,
	      origName = jQuery.camelCase( name ),
	      style = elem.style;

	    name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

	    // gets hook for the prefixed version
	    // followed by the unprefixed version
	    hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

	    // Check if we're setting a value
	    if ( value !== undefined ) {
	      type = typeof value;

	      // convert relative number strings (+= or -=) to relative numbers. #7345
	      if ( type === "string" && (ret = rrelNum.exec( value )) ) {
	        value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
	        // Fixes bug #9237
	        type = "number";
	      }

	      // Make sure that null and NaN values aren't set. See: #7116
	      if ( value == null || value !== value ) {
	        return;
	      }

	      // If a number was passed in, add 'px' to the (except for certain CSS properties)
	      if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
	        value += "px";
	      }

	      // Fixes #8908, it can be done more correctly by specifying setters in cssHooks,
	      // but it would mean to define eight (for every problematic property) identical functions
	      if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
	        style[ name ] = "inherit";
	      }

	      // If a hook was provided, use that value, otherwise just set the specified value
	      if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
	        style[ name ] = value;
	      }

	    } else {
	      // If a hook was provided get the non-computed value from there
	      if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
	        return ret;
	      }

	      // Otherwise just get the value from the style object
	      return style[ name ];
	    }
	  },

	  css: function( elem, name, extra, styles ) {
	    var val, num, hooks,
	      origName = jQuery.camelCase( name );

	    // Make sure that we're working with the right name
	    name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

	    // gets hook for the prefixed version
	    // followed by the unprefixed version
	    hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

	    // If a hook was provided get the computed value from there
	    if ( hooks && "get" in hooks ) {
	      val = hooks.get( elem, true, extra );
	    }

	    // Otherwise, if a way to get the computed value exists, use that
	    if ( val === undefined ) {
	      val = curCSS( elem, name, styles );
	    }

	    //convert "normal" to computed value
	    if ( val === "normal" && name in cssNormalTransform ) {
	      val = cssNormalTransform[ name ];
	    }

	    // Return, converting to number if forced or a qualifier was provided and val looks numeric
	    if ( extra === "" || extra ) {
	      num = parseFloat( val );
	      return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
	    }
	    return val;
	  }
	});

	jQuery.each([ "height", "width" ], function( i, name ) {
	  jQuery.cssHooks[ name ] = {
	    get: function( elem, computed, extra ) {
	      if ( computed ) {
	        // certain elements can have dimension info if we invisibly show them
	        // however, it must have a current display style that would benefit from this
	        return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
	          jQuery.swap( elem, cssShow, function() {
	            return getWidthOrHeight( elem, name, extra );
	          }) :
	          getWidthOrHeight( elem, name, extra );
	      }
	    },

	    set: function( elem, value, extra ) {
	      var styles = extra && getStyles( elem );
	      return setPositiveNumber( elem, value, extra ?
	        augmentWidthOrHeight(
	          elem,
	          name,
	          extra,
	          jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
	          styles
	        ) : 0
	      );
	    }
	  };
	});

	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	  function( elem, computed ) {
	    if ( computed ) {
	      // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
	      // Work around by temporarily setting element display to inline-block
	      return jQuery.swap( elem, { "display": "inline-block" },
	        curCSS, [ elem, "marginRight" ] );
	    }
	  }
	);

	// These hooks are used by animate to expand properties
	jQuery.each({
	  margin: "",
	  padding: "",
	  border: "Width"
	}, function( prefix, suffix ) {
	  jQuery.cssHooks[ prefix + suffix ] = {
	    expand: function( value ) {
	      var i = 0,
	        expanded = {},

	        // assumes a single number if not a string
	        parts = typeof value === "string" ? value.split(" ") : [ value ];

	      for ( ; i < 4; i++ ) {
	        expanded[ prefix + cssExpand[ i ] + suffix ] =
	          parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
	      }

	      return expanded;
	    }
	  };

	  if ( !rmargin.test( prefix ) ) {
	    jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	  }
	});

	jQuery.fn.extend({
	  css: function( name, value ) {
	    return access( this, function( elem, name, value ) {
	      var styles, len,
	        map = {},
	        i = 0;

	      if ( jQuery.isArray( name ) ) {
	        styles = getStyles( elem );
	        len = name.length;

	        for ( ; i < len; i++ ) {
	          map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
	        }

	        return map;
	      }

	      return value !== undefined ?
	        jQuery.style( elem, name, value ) :
	        jQuery.css( elem, name );
	    }, name, value, arguments.length > 1 );
	  },
	  show: function() {
	    return showHide( this, true );
	  },
	  hide: function() {
	    return showHide( this );
	  },
	  toggle: function( state ) {
	    if ( typeof state === "boolean" ) {
	      return state ? this.show() : this.hide();
	    }

	    return this.each(function() {
	      if ( isHidden( this ) ) {
	        jQuery( this ).show();
	      } else {
	        jQuery( this ).hide();
	      }
	    });
	  }
	});


	function Tween( elem, options, prop, end, easing ) {
	  return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
	  constructor: Tween,
	  init: function( elem, options, prop, end, easing, unit ) {
	    this.elem = elem;
	    this.prop = prop;
	    this.easing = easing || "swing";
	    this.options = options;
	    this.start = this.now = this.cur();
	    this.end = end;
	    this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	  },
	  cur: function() {
	    var hooks = Tween.propHooks[ this.prop ];

	    return hooks && hooks.get ?
	      hooks.get( this ) :
	      Tween.propHooks._default.get( this );
	  },
	  run: function( percent ) {
	    var eased,
	      hooks = Tween.propHooks[ this.prop ];

	    if ( this.options.duration ) {
	      this.pos = eased = jQuery.easing[ this.easing ](
	        percent, this.options.duration * percent, 0, 1, this.options.duration
	      );
	    } else {
	      this.pos = eased = percent;
	    }
	    this.now = ( this.end - this.start ) * eased + this.start;

	    if ( this.options.step ) {
	      this.options.step.call( this.elem, this.now, this );
	    }

	    if ( hooks && hooks.set ) {
	      hooks.set( this );
	    } else {
	      Tween.propHooks._default.set( this );
	    }
	    return this;
	  }
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
	  _default: {
	    get: function( tween ) {
	      var result;

	      if ( tween.elem[ tween.prop ] != null &&
	        (!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
	        return tween.elem[ tween.prop ];
	      }

	      // passing an empty string as a 3rd parameter to .css will automatically
	      // attempt a parseFloat and fallback to a string if the parse fails
	      // so, simple values such as "10px" are parsed to Float.
	      // complex values such as "rotate(1rad)" are returned as is.
	      result = jQuery.css( tween.elem, tween.prop, "" );
	      // Empty strings, null, undefined and "auto" are converted to 0.
	      return !result || result === "auto" ? 0 : result;
	    },
	    set: function( tween ) {
	      // use step hook for back compat - use cssHook if its there - use .style if its
	      // available and use plain properties where available
	      if ( jQuery.fx.step[ tween.prop ] ) {
	        jQuery.fx.step[ tween.prop ]( tween );
	      } else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
	        jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
	      } else {
	        tween.elem[ tween.prop ] = tween.now;
	      }
	    }
	  }
	};

	// Support: IE9
	// Panic based approach to setting things on disconnected nodes

	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	  set: function( tween ) {
	    if ( tween.elem.nodeType && tween.elem.parentNode ) {
	      tween.elem[ tween.prop ] = tween.now;
	    }
	  }
	};

	jQuery.easing = {
	  linear: function( p ) {
	    return p;
	  },
	  swing: function( p ) {
	    return 0.5 - Math.cos( p * Math.PI ) / 2;
	  }
	};

	jQuery.fx = Tween.prototype.init;

	// Back Compat <1.8 extension point
	jQuery.fx.step = {};




	var
	  fxNow, timerId,
	  rfxtypes = /^(?:toggle|show|hide)$/,
	  rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	  rrun = /queueHooks$/,
	  animationPrefilters = [ defaultPrefilter ],
	  tweeners = {
	    "*": [ function( prop, value ) {
	      var tween = this.createTween( prop, value ),
	        target = tween.cur(),
	        parts = rfxnum.exec( value ),
	        unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

	        // Starting value computation is required for potential unit mismatches
	        start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
	          rfxnum.exec( jQuery.css( tween.elem, prop ) ),
	        scale = 1,
	        maxIterations = 20;

	      if ( start && start[ 3 ] !== unit ) {
	        // Trust units reported by jQuery.css
	        unit = unit || start[ 3 ];

	        // Make sure we update the tween properties later on
	        parts = parts || [];

	        // Iteratively approximate from a nonzero starting point
	        start = +target || 1;

	        do {
	          // If previous iteration zeroed out, double until we get *something*
	          // Use a string for doubling factor so we don't accidentally see scale as unchanged below
	          scale = scale || ".5";

	          // Adjust and apply
	          start = start / scale;
	          jQuery.style( tween.elem, prop, start + unit );

	        // Update scale, tolerating zero or NaN from tween.cur()
	        // And breaking the loop if scale is unchanged or perfect, or if we've just had enough
	        } while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
	      }

	      // Update tween properties
	      if ( parts ) {
	        start = tween.start = +start || +target || 0;
	        tween.unit = unit;
	        // If a +=/-= token was provided, we're doing a relative animation
	        tween.end = parts[ 1 ] ?
	          start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
	          +parts[ 2 ];
	      }

	      return tween;
	    } ]
	  };

	// Animations created synchronously will run synchronously
	function createFxNow() {
	  setTimeout(function() {
	    fxNow = undefined;
	  });
	  return ( fxNow = jQuery.now() );
	}

	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
	  var which,
	    i = 0,
	    attrs = { height: type };

	  // if we include width, step value is 1 to do all cssExpand values,
	  // if we don't include width, step value is 2 to skip over Left and Right
	  includeWidth = includeWidth ? 1 : 0;
	  for ( ; i < 4 ; i += 2 - includeWidth ) {
	    which = cssExpand[ i ];
	    attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	  }

	  if ( includeWidth ) {
	    attrs.opacity = attrs.width = type;
	  }

	  return attrs;
	}

	function createTween( value, prop, animation ) {
	  var tween,
	    collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
	    index = 0,
	    length = collection.length;
	  for ( ; index < length; index++ ) {
	    if ( (tween = collection[ index ].call( animation, prop, value )) ) {

	      // we're done with this property
	      return tween;
	    }
	  }
	}

	function defaultPrefilter( elem, props, opts ) {
	  /* jshint validthis: true */
	  var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
	    anim = this,
	    orig = {},
	    style = elem.style,
	    hidden = elem.nodeType && isHidden( elem ),
	    dataShow = data_priv.get( elem, "fxshow" );

	  // handle queue: false promises
	  if ( !opts.queue ) {
	    hooks = jQuery._queueHooks( elem, "fx" );
	    if ( hooks.unqueued == null ) {
	      hooks.unqueued = 0;
	      oldfire = hooks.empty.fire;
	      hooks.empty.fire = function() {
	        if ( !hooks.unqueued ) {
	          oldfire();
	        }
	      };
	    }
	    hooks.unqueued++;

	    anim.always(function() {
	      // doing this makes sure that the complete handler will be called
	      // before this completes
	      anim.always(function() {
	        hooks.unqueued--;
	        if ( !jQuery.queue( elem, "fx" ).length ) {
	          hooks.empty.fire();
	        }
	      });
	    });
	  }

	  // height/width overflow pass
	  if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	    // Make sure that nothing sneaks out
	    // Record all 3 overflow attributes because IE9-10 do not
	    // change the overflow attribute when overflowX and
	    // overflowY are set to the same value
	    opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

	    // Set display property to inline-block for height/width
	    // animations on inline elements that are having width/height animated
	    display = jQuery.css( elem, "display" );

	    // Test default display if display is currently "none"
	    checkDisplay = display === "none" ?
	      data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

	    if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
	      style.display = "inline-block";
	    }
	  }

	  if ( opts.overflow ) {
	    style.overflow = "hidden";
	    anim.always(function() {
	      style.overflow = opts.overflow[ 0 ];
	      style.overflowX = opts.overflow[ 1 ];
	      style.overflowY = opts.overflow[ 2 ];
	    });
	  }

	  // show/hide pass
	  for ( prop in props ) {
	    value = props[ prop ];
	    if ( rfxtypes.exec( value ) ) {
	      delete props[ prop ];
	      toggle = toggle || value === "toggle";
	      if ( value === ( hidden ? "hide" : "show" ) ) {

	        // If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
	        if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
	          hidden = true;
	        } else {
	          continue;
	        }
	      }
	      orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

	    // Any non-fx value stops us from restoring the original display value
	    } else {
	      display = undefined;
	    }
	  }

	  if ( !jQuery.isEmptyObject( orig ) ) {
	    if ( dataShow ) {
	      if ( "hidden" in dataShow ) {
	        hidden = dataShow.hidden;
	      }
	    } else {
	      dataShow = data_priv.access( elem, "fxshow", {} );
	    }

	    // store state if its toggle - enables .stop().toggle() to "reverse"
	    if ( toggle ) {
	      dataShow.hidden = !hidden;
	    }
	    if ( hidden ) {
	      jQuery( elem ).show();
	    } else {
	      anim.done(function() {
	        jQuery( elem ).hide();
	      });
	    }
	    anim.done(function() {
	      var prop;

	      data_priv.remove( elem, "fxshow" );
	      for ( prop in orig ) {
	        jQuery.style( elem, prop, orig[ prop ] );
	      }
	    });
	    for ( prop in orig ) {
	      tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

	      if ( !( prop in dataShow ) ) {
	        dataShow[ prop ] = tween.start;
	        if ( hidden ) {
	          tween.end = tween.start;
	          tween.start = prop === "width" || prop === "height" ? 1 : 0;
	        }
	      }
	    }

	  // If this is a noop like .hide().hide(), restore an overwritten display value
	  } else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
	    style.display = display;
	  }
	}

	function propFilter( props, specialEasing ) {
	  var index, name, easing, value, hooks;

	  // camelCase, specialEasing and expand cssHook pass
	  for ( index in props ) {
	    name = jQuery.camelCase( index );
	    easing = specialEasing[ name ];
	    value = props[ index ];
	    if ( jQuery.isArray( value ) ) {
	      easing = value[ 1 ];
	      value = props[ index ] = value[ 0 ];
	    }

	    if ( index !== name ) {
	      props[ name ] = value;
	      delete props[ index ];
	    }

	    hooks = jQuery.cssHooks[ name ];
	    if ( hooks && "expand" in hooks ) {
	      value = hooks.expand( value );
	      delete props[ name ];

	      // not quite $.extend, this wont overwrite keys already present.
	      // also - reusing 'index' from above because we have the correct "name"
	      for ( index in value ) {
	        if ( !( index in props ) ) {
	          props[ index ] = value[ index ];
	          specialEasing[ index ] = easing;
	        }
	      }
	    } else {
	      specialEasing[ name ] = easing;
	    }
	  }
	}

	function Animation( elem, properties, options ) {
	  var result,
	    stopped,
	    index = 0,
	    length = animationPrefilters.length,
	    deferred = jQuery.Deferred().always( function() {
	      // don't match elem in the :animated selector
	      delete tick.elem;
	    }),
	    tick = function() {
	      if ( stopped ) {
	        return false;
	      }
	      var currentTime = fxNow || createFxNow(),
	        remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	        // archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
	        temp = remaining / animation.duration || 0,
	        percent = 1 - temp,
	        index = 0,
	        length = animation.tweens.length;

	      for ( ; index < length ; index++ ) {
	        animation.tweens[ index ].run( percent );
	      }

	      deferred.notifyWith( elem, [ animation, percent, remaining ]);

	      if ( percent < 1 && length ) {
	        return remaining;
	      } else {
	        deferred.resolveWith( elem, [ animation ] );
	        return false;
	      }
	    },
	    animation = deferred.promise({
	      elem: elem,
	      props: jQuery.extend( {}, properties ),
	      opts: jQuery.extend( true, { specialEasing: {} }, options ),
	      originalProperties: properties,
	      originalOptions: options,
	      startTime: fxNow || createFxNow(),
	      duration: options.duration,
	      tweens: [],
	      createTween: function( prop, end ) {
	        var tween = jQuery.Tween( elem, animation.opts, prop, end,
	            animation.opts.specialEasing[ prop ] || animation.opts.easing );
	        animation.tweens.push( tween );
	        return tween;
	      },
	      stop: function( gotoEnd ) {
	        var index = 0,
	          // if we are going to the end, we want to run all the tweens
	          // otherwise we skip this part
	          length = gotoEnd ? animation.tweens.length : 0;
	        if ( stopped ) {
	          return this;
	        }
	        stopped = true;
	        for ( ; index < length ; index++ ) {
	          animation.tweens[ index ].run( 1 );
	        }

	        // resolve when we played the last frame
	        // otherwise, reject
	        if ( gotoEnd ) {
	          deferred.resolveWith( elem, [ animation, gotoEnd ] );
	        } else {
	          deferred.rejectWith( elem, [ animation, gotoEnd ] );
	        }
	        return this;
	      }
	    }),
	    props = animation.props;

	  propFilter( props, animation.opts.specialEasing );

	  for ( ; index < length ; index++ ) {
	    result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
	    if ( result ) {
	      return result;
	    }
	  }

	  jQuery.map( props, createTween, animation );

	  if ( jQuery.isFunction( animation.opts.start ) ) {
	    animation.opts.start.call( elem, animation );
	  }

	  jQuery.fx.timer(
	    jQuery.extend( tick, {
	      elem: elem,
	      anim: animation,
	      queue: animation.opts.queue
	    })
	  );

	  // attach callbacks from options
	  return animation.progress( animation.opts.progress )
	    .done( animation.opts.done, animation.opts.complete )
	    .fail( animation.opts.fail )
	    .always( animation.opts.always );
	}

	jQuery.Animation = jQuery.extend( Animation, {

	  tweener: function( props, callback ) {
	    if ( jQuery.isFunction( props ) ) {
	      callback = props;
	      props = [ "*" ];
	    } else {
	      props = props.split(" ");
	    }

	    var prop,
	      index = 0,
	      length = props.length;

	    for ( ; index < length ; index++ ) {
	      prop = props[ index ];
	      tweeners[ prop ] = tweeners[ prop ] || [];
	      tweeners[ prop ].unshift( callback );
	    }
	  },

	  prefilter: function( callback, prepend ) {
	    if ( prepend ) {
	      animationPrefilters.unshift( callback );
	    } else {
	      animationPrefilters.push( callback );
	    }
	  }
	});

	jQuery.speed = function( speed, easing, fn ) {
	  var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
	    complete: fn || !fn && easing ||
	      jQuery.isFunction( speed ) && speed,
	    duration: speed,
	    easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	  };

	  opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
	    opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	  // normalize opt.queue - true/undefined/null -> "fx"
	  if ( opt.queue == null || opt.queue === true ) {
	    opt.queue = "fx";
	  }

	  // Queueing
	  opt.old = opt.complete;

	  opt.complete = function() {
	    if ( jQuery.isFunction( opt.old ) ) {
	      opt.old.call( this );
	    }

	    if ( opt.queue ) {
	      jQuery.dequeue( this, opt.queue );
	    }
	  };

	  return opt;
	};

	jQuery.fn.extend({
	  fadeTo: function( speed, to, easing, callback ) {

	    // show any hidden elements after setting opacity to 0
	    return this.filter( isHidden ).css( "opacity", 0 ).show()

	      // animate to the value specified
	      .end().animate({ opacity: to }, speed, easing, callback );
	  },
	  animate: function( prop, speed, easing, callback ) {
	    var empty = jQuery.isEmptyObject( prop ),
	      optall = jQuery.speed( speed, easing, callback ),
	      doAnimation = function() {
	        // Operate on a copy of prop so per-property easing won't be lost
	        var anim = Animation( this, jQuery.extend( {}, prop ), optall );

	        // Empty animations, or finishing resolves immediately
	        if ( empty || data_priv.get( this, "finish" ) ) {
	          anim.stop( true );
	        }
	      };
	      doAnimation.finish = doAnimation;

	    return empty || optall.queue === false ?
	      this.each( doAnimation ) :
	      this.queue( optall.queue, doAnimation );
	  },
	  stop: function( type, clearQueue, gotoEnd ) {
	    var stopQueue = function( hooks ) {
	      var stop = hooks.stop;
	      delete hooks.stop;
	      stop( gotoEnd );
	    };

	    if ( typeof type !== "string" ) {
	      gotoEnd = clearQueue;
	      clearQueue = type;
	      type = undefined;
	    }
	    if ( clearQueue && type !== false ) {
	      this.queue( type || "fx", [] );
	    }

	    return this.each(function() {
	      var dequeue = true,
	        index = type != null && type + "queueHooks",
	        timers = jQuery.timers,
	        data = data_priv.get( this );

	      if ( index ) {
	        if ( data[ index ] && data[ index ].stop ) {
	          stopQueue( data[ index ] );
	        }
	      } else {
	        for ( index in data ) {
	          if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
	            stopQueue( data[ index ] );
	          }
	        }
	      }

	      for ( index = timers.length; index--; ) {
	        if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
	          timers[ index ].anim.stop( gotoEnd );
	          dequeue = false;
	          timers.splice( index, 1 );
	        }
	      }

	      // start the next in the queue if the last step wasn't forced
	      // timers currently will call their complete callbacks, which will dequeue
	      // but only if they were gotoEnd
	      if ( dequeue || !gotoEnd ) {
	        jQuery.dequeue( this, type );
	      }
	    });
	  },
	  finish: function( type ) {
	    if ( type !== false ) {
	      type = type || "fx";
	    }
	    return this.each(function() {
	      var index,
	        data = data_priv.get( this ),
	        queue = data[ type + "queue" ],
	        hooks = data[ type + "queueHooks" ],
	        timers = jQuery.timers,
	        length = queue ? queue.length : 0;

	      // enable finishing flag on private data
	      data.finish = true;

	      // empty the queue first
	      jQuery.queue( this, type, [] );

	      if ( hooks && hooks.stop ) {
	        hooks.stop.call( this, true );
	      }

	      // look for any active animations, and finish them
	      for ( index = timers.length; index--; ) {
	        if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
	          timers[ index ].anim.stop( true );
	          timers.splice( index, 1 );
	        }
	      }

	      // look for any animations in the old queue and finish them
	      for ( index = 0; index < length; index++ ) {
	        if ( queue[ index ] && queue[ index ].finish ) {
	          queue[ index ].finish.call( this );
	        }
	      }

	      // turn off finishing flag
	      delete data.finish;
	    });
	  }
	});

	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	  var cssFn = jQuery.fn[ name ];
	  jQuery.fn[ name ] = function( speed, easing, callback ) {
	    return speed == null || typeof speed === "boolean" ?
	      cssFn.apply( this, arguments ) :
	      this.animate( genFx( name, true ), speed, easing, callback );
	  };
	});

	// Generate shortcuts for custom animations
	jQuery.each({
	  slideDown: genFx("show"),
	  slideUp: genFx("hide"),
	  slideToggle: genFx("toggle"),
	  fadeIn: { opacity: "show" },
	  fadeOut: { opacity: "hide" },
	  fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
	  jQuery.fn[ name ] = function( speed, easing, callback ) {
	    return this.animate( props, speed, easing, callback );
	  };
	});

	jQuery.timers = [];
	jQuery.fx.tick = function() {
	  var timer,
	    i = 0,
	    timers = jQuery.timers;

	  fxNow = jQuery.now();

	  for ( ; i < timers.length; i++ ) {
	    timer = timers[ i ];
	    // Checks the timer has not already been removed
	    if ( !timer() && timers[ i ] === timer ) {
	      timers.splice( i--, 1 );
	    }
	  }

	  if ( !timers.length ) {
	    jQuery.fx.stop();
	  }
	  fxNow = undefined;
	};

	jQuery.fx.timer = function( timer ) {
	  jQuery.timers.push( timer );
	  if ( timer() ) {
	    jQuery.fx.start();
	  } else {
	    jQuery.timers.pop();
	  }
	};

	jQuery.fx.interval = 13;

	jQuery.fx.start = function() {
	  if ( !timerId ) {
	    timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	  }
	};

	jQuery.fx.stop = function() {
	  clearInterval( timerId );
	  timerId = null;
	};

	jQuery.fx.speeds = {
	  slow: 600,
	  fast: 200,
	  // Default speed
	  _default: 400
	};


	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
	  time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	  type = type || "fx";

	  return this.queue( type, function( next, hooks ) {
	    var timeout = setTimeout( next, time );
	    hooks.stop = function() {
	      clearTimeout( timeout );
	    };
	  });
	};


	(function() {
	  var input = document.createElement( "input" ),
	    select = document.createElement( "select" ),
	    opt = select.appendChild( document.createElement( "option" ) );

	  input.type = "checkbox";

	  // Support: iOS 5.1, Android 4.x, Android 2.3
	  // Check the default checkbox/radio value ("" on old WebKit; "on" elsewhere)
	  support.checkOn = input.value !== "";

	  // Must access the parent to make an option select properly
	  // Support: IE9, IE10
	  support.optSelected = opt.selected;

	  // Make sure that the options inside disabled selects aren't marked as disabled
	  // (WebKit marks them as disabled)
	  select.disabled = true;
	  support.optDisabled = !opt.disabled;

	  // Check if an input maintains its value after becoming a radio
	  // Support: IE9, IE10
	  input = document.createElement( "input" );
	  input.value = "t";
	  input.type = "radio";
	  support.radioValue = input.value === "t";
	})();


	var nodeHook, boolHook,
	  attrHandle = jQuery.expr.attrHandle;

	jQuery.fn.extend({
	  attr: function( name, value ) {
	    return access( this, jQuery.attr, name, value, arguments.length > 1 );
	  },

	  removeAttr: function( name ) {
	    return this.each(function() {
	      jQuery.removeAttr( this, name );
	    });
	  }
	});

	jQuery.extend({
	  attr: function( elem, name, value ) {
	    var hooks, ret,
	      nType = elem.nodeType;

	    // don't get/set attributes on text, comment and attribute nodes
	    if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
	      return;
	    }

	    // Fallback to prop when attributes are not supported
	    if ( typeof elem.getAttribute === strundefined ) {
	      return jQuery.prop( elem, name, value );
	    }

	    // All attributes are lowercase
	    // Grab necessary hook if one is defined
	    if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	      name = name.toLowerCase();
	      hooks = jQuery.attrHooks[ name ] ||
	        ( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
	    }

	    if ( value !== undefined ) {

	      if ( value === null ) {
	        jQuery.removeAttr( elem, name );

	      } else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
	        return ret;

	      } else {
	        elem.setAttribute( name, value + "" );
	        return value;
	      }

	    } else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
	      return ret;

	    } else {
	      ret = jQuery.find.attr( elem, name );

	      // Non-existent attributes return null, we normalize to undefined
	      return ret == null ?
	        undefined :
	        ret;
	    }
	  },

	  removeAttr: function( elem, value ) {
	    var name, propName,
	      i = 0,
	      attrNames = value && value.match( rnotwhite );

	    if ( attrNames && elem.nodeType === 1 ) {
	      while ( (name = attrNames[i++]) ) {
	        propName = jQuery.propFix[ name ] || name;

	        // Boolean attributes get special treatment (#10870)
	        if ( jQuery.expr.match.bool.test( name ) ) {
	          // Set corresponding property to false
	          elem[ propName ] = false;
	        }

	        elem.removeAttribute( name );
	      }
	    }
	  },

	  attrHooks: {
	    type: {
	      set: function( elem, value ) {
	        if ( !support.radioValue && value === "radio" &&
	          jQuery.nodeName( elem, "input" ) ) {
	          // Setting the type on a radio button after the value resets the value in IE6-9
	          // Reset value to default in case type is set after value during creation
	          var val = elem.value;
	          elem.setAttribute( "type", value );
	          if ( val ) {
	            elem.value = val;
	          }
	          return value;
	        }
	      }
	    }
	  }
	});

	// Hooks for boolean attributes
	boolHook = {
	  set: function( elem, value, name ) {
	    if ( value === false ) {
	      // Remove boolean attributes when set to false
	      jQuery.removeAttr( elem, name );
	    } else {
	      elem.setAttribute( name, name );
	    }
	    return name;
	  }
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	  var getter = attrHandle[ name ] || jQuery.find.attr;

	  attrHandle[ name ] = function( elem, name, isXML ) {
	    var ret, handle;
	    if ( !isXML ) {
	      // Avoid an infinite loop by temporarily removing this function from the getter
	      handle = attrHandle[ name ];
	      attrHandle[ name ] = ret;
	      ret = getter( elem, name, isXML ) != null ?
	        name.toLowerCase() :
	        null;
	      attrHandle[ name ] = handle;
	    }
	    return ret;
	  };
	});




	var rfocusable = /^(?:input|select|textarea|button)$/i;

	jQuery.fn.extend({
	  prop: function( name, value ) {
	    return access( this, jQuery.prop, name, value, arguments.length > 1 );
	  },

	  removeProp: function( name ) {
	    return this.each(function() {
	      delete this[ jQuery.propFix[ name ] || name ];
	    });
	  }
	});

	jQuery.extend({
	  propFix: {
	    "for": "htmlFor",
	    "class": "className"
	  },

	  prop: function( elem, name, value ) {
	    var ret, hooks, notxml,
	      nType = elem.nodeType;

	    // don't get/set properties on text, comment and attribute nodes
	    if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
	      return;
	    }

	    notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

	    if ( notxml ) {
	      // Fix name and attach hooks
	      name = jQuery.propFix[ name ] || name;
	      hooks = jQuery.propHooks[ name ];
	    }

	    if ( value !== undefined ) {
	      return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
	        ret :
	        ( elem[ name ] = value );

	    } else {
	      return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
	        ret :
	        elem[ name ];
	    }
	  },

	  propHooks: {
	    tabIndex: {
	      get: function( elem ) {
	        return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
	          elem.tabIndex :
	          -1;
	      }
	    }
	  }
	});

	// Support: IE9+
	// Selectedness for an option in an optgroup can be inaccurate
	if ( !support.optSelected ) {
	  jQuery.propHooks.selected = {
	    get: function( elem ) {
	      var parent = elem.parentNode;
	      if ( parent && parent.parentNode ) {
	        parent.parentNode.selectedIndex;
	      }
	      return null;
	    }
	  };
	}

	jQuery.each([
	  "tabIndex",
	  "readOnly",
	  "maxLength",
	  "cellSpacing",
	  "cellPadding",
	  "rowSpan",
	  "colSpan",
	  "useMap",
	  "frameBorder",
	  "contentEditable"
	], function() {
	  jQuery.propFix[ this.toLowerCase() ] = this;
	});




	var rclass = /[\t\r\n\f]/g;

	jQuery.fn.extend({
	  addClass: function( value ) {
	    var classes, elem, cur, clazz, j, finalValue,
	      proceed = typeof value === "string" && value,
	      i = 0,
	      len = this.length;

	    if ( jQuery.isFunction( value ) ) {
	      return this.each(function( j ) {
	        jQuery( this ).addClass( value.call( this, j, this.className ) );
	      });
	    }

	    if ( proceed ) {
	      // The disjunction here is for better compressibility (see removeClass)
	      classes = ( value || "" ).match( rnotwhite ) || [];

	      for ( ; i < len; i++ ) {
	        elem = this[ i ];
	        cur = elem.nodeType === 1 && ( elem.className ?
	          ( " " + elem.className + " " ).replace( rclass, " " ) :
	          " "
	        );

	        if ( cur ) {
	          j = 0;
	          while ( (clazz = classes[j++]) ) {
	            if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
	              cur += clazz + " ";
	            }
	          }

	          // only assign if different to avoid unneeded rendering.
	          finalValue = jQuery.trim( cur );
	          if ( elem.className !== finalValue ) {
	            elem.className = finalValue;
	          }
	        }
	      }
	    }

	    return this;
	  },

	  removeClass: function( value ) {
	    var classes, elem, cur, clazz, j, finalValue,
	      proceed = arguments.length === 0 || typeof value === "string" && value,
	      i = 0,
	      len = this.length;

	    if ( jQuery.isFunction( value ) ) {
	      return this.each(function( j ) {
	        jQuery( this ).removeClass( value.call( this, j, this.className ) );
	      });
	    }
	    if ( proceed ) {
	      classes = ( value || "" ).match( rnotwhite ) || [];

	      for ( ; i < len; i++ ) {
	        elem = this[ i ];
	        // This expression is here for better compressibility (see addClass)
	        cur = elem.nodeType === 1 && ( elem.className ?
	          ( " " + elem.className + " " ).replace( rclass, " " ) :
	          ""
	        );

	        if ( cur ) {
	          j = 0;
	          while ( (clazz = classes[j++]) ) {
	            // Remove *all* instances
	            while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
	              cur = cur.replace( " " + clazz + " ", " " );
	            }
	          }

	          // only assign if different to avoid unneeded rendering.
	          finalValue = value ? jQuery.trim( cur ) : "";
	          if ( elem.className !== finalValue ) {
	            elem.className = finalValue;
	          }
	        }
	      }
	    }

	    return this;
	  },

	  toggleClass: function( value, stateVal ) {
	    var type = typeof value;

	    if ( typeof stateVal === "boolean" && type === "string" ) {
	      return stateVal ? this.addClass( value ) : this.removeClass( value );
	    }

	    if ( jQuery.isFunction( value ) ) {
	      return this.each(function( i ) {
	        jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
	      });
	    }

	    return this.each(function() {
	      if ( type === "string" ) {
	        // toggle individual class names
	        var className,
	          i = 0,
	          self = jQuery( this ),
	          classNames = value.match( rnotwhite ) || [];

	        while ( (className = classNames[ i++ ]) ) {
	          // check each className given, space separated list
	          if ( self.hasClass( className ) ) {
	            self.removeClass( className );
	          } else {
	            self.addClass( className );
	          }
	        }

	      // Toggle whole class name
	      } else if ( type === strundefined || type === "boolean" ) {
	        if ( this.className ) {
	          // store className if set
	          data_priv.set( this, "__className__", this.className );
	        }

	        // If the element has a class name or if we're passed "false",
	        // then remove the whole classname (if there was one, the above saved it).
	        // Otherwise bring back whatever was previously saved (if anything),
	        // falling back to the empty string if nothing was stored.
	        this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
	      }
	    });
	  },

	  hasClass: function( selector ) {
	    var className = " " + selector + " ",
	      i = 0,
	      l = this.length;
	    for ( ; i < l; i++ ) {
	      if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
	        return true;
	      }
	    }

	    return false;
	  }
	});




	var rreturn = /\r/g;

	jQuery.fn.extend({
	  val: function( value ) {
	    var hooks, ret, isFunction,
	      elem = this[0];

	    if ( !arguments.length ) {
	      if ( elem ) {
	        hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

	        if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
	          return ret;
	        }

	        ret = elem.value;

	        return typeof ret === "string" ?
	          // handle most common string cases
	          ret.replace(rreturn, "") :
	          // handle cases where value is null/undef or number
	          ret == null ? "" : ret;
	      }

	      return;
	    }

	    isFunction = jQuery.isFunction( value );

	    return this.each(function( i ) {
	      var val;

	      if ( this.nodeType !== 1 ) {
	        return;
	      }

	      if ( isFunction ) {
	        val = value.call( this, i, jQuery( this ).val() );
	      } else {
	        val = value;
	      }

	      // Treat null/undefined as ""; convert numbers to string
	      if ( val == null ) {
	        val = "";

	      } else if ( typeof val === "number" ) {
	        val += "";

	      } else if ( jQuery.isArray( val ) ) {
	        val = jQuery.map( val, function( value ) {
	          return value == null ? "" : value + "";
	        });
	      }

	      hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

	      // If set returns undefined, fall back to normal setting
	      if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
	        this.value = val;
	      }
	    });
	  }
	});

	jQuery.extend({
	  valHooks: {
	    option: {
	      get: function( elem ) {
	        var val = jQuery.find.attr( elem, "value" );
	        return val != null ?
	          val :
	          // Support: IE10-11+
	          // option.text throws exceptions (#14686, #14858)
	          jQuery.trim( jQuery.text( elem ) );
	      }
	    },
	    select: {
	      get: function( elem ) {
	        var value, option,
	          options = elem.options,
	          index = elem.selectedIndex,
	          one = elem.type === "select-one" || index < 0,
	          values = one ? null : [],
	          max = one ? index + 1 : options.length,
	          i = index < 0 ?
	            max :
	            one ? index : 0;

	        // Loop through all the selected options
	        for ( ; i < max; i++ ) {
	          option = options[ i ];

	          // IE6-9 doesn't update selected after form reset (#2551)
	          if ( ( option.selected || i === index ) &&
	              // Don't return options that are disabled or in a disabled optgroup
	              ( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
	              ( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

	            // Get the specific value for the option
	            value = jQuery( option ).val();

	            // We don't need an array for one selects
	            if ( one ) {
	              return value;
	            }

	            // Multi-Selects return an array
	            values.push( value );
	          }
	        }

	        return values;
	      },

	      set: function( elem, value ) {
	        var optionSet, option,
	          options = elem.options,
	          values = jQuery.makeArray( value ),
	          i = options.length;

	        while ( i-- ) {
	          option = options[ i ];
	          if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
	            optionSet = true;
	          }
	        }

	        // force browsers to behave consistently when non-matching value is set
	        if ( !optionSet ) {
	          elem.selectedIndex = -1;
	        }
	        return values;
	      }
	    }
	  }
	});

	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
	  jQuery.valHooks[ this ] = {
	    set: function( elem, value ) {
	      if ( jQuery.isArray( value ) ) {
	        return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
	      }
	    }
	  };
	  if ( !support.checkOn ) {
	    jQuery.valHooks[ this ].get = function( elem ) {
	      // Support: Webkit
	      // "" is returned instead of "on" if a value isn't specified
	      return elem.getAttribute("value") === null ? "on" : elem.value;
	    };
	  }
	});




	// Return jQuery for attributes-only inclusion


	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	  "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	  "change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	  // Handle event binding
	  jQuery.fn[ name ] = function( data, fn ) {
	    return arguments.length > 0 ?
	      this.on( name, null, data, fn ) :
	      this.trigger( name );
	  };
	});

	jQuery.fn.extend({
	  hover: function( fnOver, fnOut ) {
	    return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	  },

	  bind: function( types, data, fn ) {
	    return this.on( types, null, data, fn );
	  },
	  unbind: function( types, fn ) {
	    return this.off( types, null, fn );
	  },

	  delegate: function( selector, types, data, fn ) {
	    return this.on( types, selector, data, fn );
	  },
	  undelegate: function( selector, types, fn ) {
	    // ( namespace ) or ( selector, types [, fn] )
	    return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	  }
	});


	var nonce = jQuery.now();

	var rquery = (/\?/);



	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
	  return JSON.parse( data + "" );
	};


	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
	  var xml, tmp;
	  if ( !data || typeof data !== "string" ) {
	    return null;
	  }

	  // Support: IE9
	  try {
	    tmp = new DOMParser();
	    xml = tmp.parseFromString( data, "text/xml" );
	  } catch ( e ) {
	    xml = undefined;
	  }

	  if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
	    jQuery.error( "Invalid XML: " + data );
	  }
	  return xml;
	};


	var
	  // Document location
	  ajaxLocParts,
	  ajaxLocation,

	  rhash = /#.*$/,
	  rts = /([?&])_=[^&]*/,
	  rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	  // #7653, #8125, #8152: local protocol detection
	  rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	  rnoContent = /^(?:GET|HEAD)$/,
	  rprotocol = /^\/\//,
	  rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	  /* Prefilters
	   * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	   * 2) These are called:
	   *    - BEFORE asking for a transport
	   *    - AFTER param serialization (s.data is a string if s.processData is true)
	   * 3) key is the dataType
	   * 4) the catchall symbol "*" can be used
	   * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	   */
	  prefilters = {},

	  /* Transports bindings
	   * 1) key is the dataType
	   * 2) the catchall symbol "*" can be used
	   * 3) selection will start with transport dataType and THEN go to "*" if needed
	   */
	  transports = {},

	  // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	  allTypes = "*/".concat("*");

	// #8138, IE may throw an exception when accessing
	// a field from window.location if document.domain has been set
	try {
	  ajaxLocation = location.href;
	} catch( e ) {
	  // Use the href attribute of an A element
	  // since IE will modify it given document.location
	  ajaxLocation = document.createElement( "a" );
	  ajaxLocation.href = "";
	  ajaxLocation = ajaxLocation.href;
	}

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {

	  // dataTypeExpression is optional and defaults to "*"
	  return function( dataTypeExpression, func ) {

	    if ( typeof dataTypeExpression !== "string" ) {
	      func = dataTypeExpression;
	      dataTypeExpression = "*";
	    }

	    var dataType,
	      i = 0,
	      dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

	    if ( jQuery.isFunction( func ) ) {
	      // For each dataType in the dataTypeExpression
	      while ( (dataType = dataTypes[i++]) ) {
	        // Prepend if requested
	        if ( dataType[0] === "+" ) {
	          dataType = dataType.slice( 1 ) || "*";
	          (structure[ dataType ] = structure[ dataType ] || []).unshift( func );

	        // Otherwise append
	        } else {
	          (structure[ dataType ] = structure[ dataType ] || []).push( func );
	        }
	      }
	    }
	  };
	}

	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	  var inspected = {},
	    seekingTransport = ( structure === transports );

	  function inspect( dataType ) {
	    var selected;
	    inspected[ dataType ] = true;
	    jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
	      var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
	      if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	        options.dataTypes.unshift( dataTypeOrTransport );
	        inspect( dataTypeOrTransport );
	        return false;
	      } else if ( seekingTransport ) {
	        return !( selected = dataTypeOrTransport );
	      }
	    });
	    return selected;
	  }

	  return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}

	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
	  var key, deep,
	    flatOptions = jQuery.ajaxSettings.flatOptions || {};

	  for ( key in src ) {
	    if ( src[ key ] !== undefined ) {
	      ( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
	    }
	  }
	  if ( deep ) {
	    jQuery.extend( true, target, deep );
	  }

	  return target;
	}

	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {

	  var ct, type, finalDataType, firstDataType,
	    contents = s.contents,
	    dataTypes = s.dataTypes;

	  // Remove auto dataType and get content-type in the process
	  while ( dataTypes[ 0 ] === "*" ) {
	    dataTypes.shift();
	    if ( ct === undefined ) {
	      ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
	    }
	  }

	  // Check if we're dealing with a known content-type
	  if ( ct ) {
	    for ( type in contents ) {
	      if ( contents[ type ] && contents[ type ].test( ct ) ) {
	        dataTypes.unshift( type );
	        break;
	      }
	    }
	  }

	  // Check to see if we have a response for the expected dataType
	  if ( dataTypes[ 0 ] in responses ) {
	    finalDataType = dataTypes[ 0 ];
	  } else {
	    // Try convertible dataTypes
	    for ( type in responses ) {
	      if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
	        finalDataType = type;
	        break;
	      }
	      if ( !firstDataType ) {
	        firstDataType = type;
	      }
	    }
	    // Or just use first one
	    finalDataType = finalDataType || firstDataType;
	  }

	  // If we found a dataType
	  // We add the dataType to the list if needed
	  // and return the corresponding response
	  if ( finalDataType ) {
	    if ( finalDataType !== dataTypes[ 0 ] ) {
	      dataTypes.unshift( finalDataType );
	    }
	    return responses[ finalDataType ];
	  }
	}

	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
	  var conv2, current, conv, tmp, prev,
	    converters = {},
	    // Work with a copy of dataTypes in case we need to modify it for conversion
	    dataTypes = s.dataTypes.slice();

	  // Create converters map with lowercased keys
	  if ( dataTypes[ 1 ] ) {
	    for ( conv in s.converters ) {
	      converters[ conv.toLowerCase() ] = s.converters[ conv ];
	    }
	  }

	  current = dataTypes.shift();

	  // Convert to each sequential dataType
	  while ( current ) {

	    if ( s.responseFields[ current ] ) {
	      jqXHR[ s.responseFields[ current ] ] = response;
	    }

	    // Apply the dataFilter if provided
	    if ( !prev && isSuccess && s.dataFilter ) {
	      response = s.dataFilter( response, s.dataType );
	    }

	    prev = current;
	    current = dataTypes.shift();

	    if ( current ) {

	    // There's only work to do if current dataType is non-auto
	      if ( current === "*" ) {

	        current = prev;

	      // Convert response if prev dataType is non-auto and differs from current
	      } else if ( prev !== "*" && prev !== current ) {

	        // Seek a direct converter
	        conv = converters[ prev + " " + current ] || converters[ "* " + current ];

	        // If none found, seek a pair
	        if ( !conv ) {
	          for ( conv2 in converters ) {

	            // If conv2 outputs current
	            tmp = conv2.split( " " );
	            if ( tmp[ 1 ] === current ) {

	              // If prev can be converted to accepted input
	              conv = converters[ prev + " " + tmp[ 0 ] ] ||
	                converters[ "* " + tmp[ 0 ] ];
	              if ( conv ) {
	                // Condense equivalence converters
	                if ( conv === true ) {
	                  conv = converters[ conv2 ];

	                // Otherwise, insert the intermediate dataType
	                } else if ( converters[ conv2 ] !== true ) {
	                  current = tmp[ 0 ];
	                  dataTypes.unshift( tmp[ 1 ] );
	                }
	                break;
	              }
	            }
	          }
	        }

	        // Apply converter (if not an equivalence)
	        if ( conv !== true ) {

	          // Unless errors are allowed to bubble, catch and return them
	          if ( conv && s[ "throws" ] ) {
	            response = conv( response );
	          } else {
	            try {
	              response = conv( response );
	            } catch ( e ) {
	              return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
	            }
	          }
	        }
	      }
	    }
	  }

	  return { state: "success", data: response };
	}

	jQuery.extend({

	  // Counter for holding the number of active queries
	  active: 0,

	  // Last-Modified header cache for next request
	  lastModified: {},
	  etag: {},

	  ajaxSettings: {
	    url: ajaxLocation,
	    type: "GET",
	    isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
	    global: true,
	    processData: true,
	    async: true,
	    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	    /*
	    timeout: 0,
	    data: null,
	    dataType: null,
	    username: null,
	    password: null,
	    cache: null,
	    throws: false,
	    traditional: false,
	    headers: {},
	    */

	    accepts: {
	      "*": allTypes,
	      text: "text/plain",
	      html: "text/html",
	      xml: "application/xml, text/xml",
	      json: "application/json, text/javascript"
	    },

	    contents: {
	      xml: /xml/,
	      html: /html/,
	      json: /json/
	    },

	    responseFields: {
	      xml: "responseXML",
	      text: "responseText",
	      json: "responseJSON"
	    },

	    // Data converters
	    // Keys separate source (or catchall "*") and destination types with a single space
	    converters: {

	      // Convert anything to text
	      "* text": String,

	      // Text to html (true = no transformation)
	      "text html": true,

	      // Evaluate text as a json expression
	      "text json": jQuery.parseJSON,

	      // Parse text as xml
	      "text xml": jQuery.parseXML
	    },

	    // For options that shouldn't be deep extended:
	    // you can add your own custom options here if
	    // and when you create one that shouldn't be
	    // deep extended (see ajaxExtend)
	    flatOptions: {
	      url: true,
	      context: true
	    }
	  },

	  // Creates a full fledged settings object into target
	  // with both ajaxSettings and settings fields.
	  // If target is omitted, writes into ajaxSettings.
	  ajaxSetup: function( target, settings ) {
	    return settings ?

	      // Building a settings object
	      ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

	      // Extending ajaxSettings
	      ajaxExtend( jQuery.ajaxSettings, target );
	  },

	  ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	  ajaxTransport: addToPrefiltersOrTransports( transports ),

	  // Main method
	  ajax: function( url, options ) {

	    // If url is an object, simulate pre-1.5 signature
	    if ( typeof url === "object" ) {
	      options = url;
	      url = undefined;
	    }

	    // Force options to be an object
	    options = options || {};

	    var transport,
	      // URL without anti-cache param
	      cacheURL,
	      // Response headers
	      responseHeadersString,
	      responseHeaders,
	      // timeout handle
	      timeoutTimer,
	      // Cross-domain detection vars
	      parts,
	      // To know if global events are to be dispatched
	      fireGlobals,
	      // Loop variable
	      i,
	      // Create the final options object
	      s = jQuery.ajaxSetup( {}, options ),
	      // Callbacks context
	      callbackContext = s.context || s,
	      // Context for global events is callbackContext if it is a DOM node or jQuery collection
	      globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
	        jQuery( callbackContext ) :
	        jQuery.event,
	      // Deferreds
	      deferred = jQuery.Deferred(),
	      completeDeferred = jQuery.Callbacks("once memory"),
	      // Status-dependent callbacks
	      statusCode = s.statusCode || {},
	      // Headers (they are sent all at once)
	      requestHeaders = {},
	      requestHeadersNames = {},
	      // The jqXHR state
	      state = 0,
	      // Default abort message
	      strAbort = "canceled",
	      // Fake xhr
	      jqXHR = {
	        readyState: 0,

	        // Builds headers hashtable if needed
	        getResponseHeader: function( key ) {
	          var match;
	          if ( state === 2 ) {
	            if ( !responseHeaders ) {
	              responseHeaders = {};
	              while ( (match = rheaders.exec( responseHeadersString )) ) {
	                responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
	              }
	            }
	            match = responseHeaders[ key.toLowerCase() ];
	          }
	          return match == null ? null : match;
	        },

	        // Raw string
	        getAllResponseHeaders: function() {
	          return state === 2 ? responseHeadersString : null;
	        },

	        // Caches the header
	        setRequestHeader: function( name, value ) {
	          var lname = name.toLowerCase();
	          if ( !state ) {
	            name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
	            requestHeaders[ name ] = value;
	          }
	          return this;
	        },

	        // Overrides response content-type header
	        overrideMimeType: function( type ) {
	          if ( !state ) {
	            s.mimeType = type;
	          }
	          return this;
	        },

	        // Status-dependent callbacks
	        statusCode: function( map ) {
	          var code;
	          if ( map ) {
	            if ( state < 2 ) {
	              for ( code in map ) {
	                // Lazy-add the new callback in a way that preserves old ones
	                statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
	              }
	            } else {
	              // Execute the appropriate callbacks
	              jqXHR.always( map[ jqXHR.status ] );
	            }
	          }
	          return this;
	        },

	        // Cancel the request
	        abort: function( statusText ) {
	          var finalText = statusText || strAbort;
	          if ( transport ) {
	            transport.abort( finalText );
	          }
	          done( 0, finalText );
	          return this;
	        }
	      };

	    // Attach deferreds
	    deferred.promise( jqXHR ).complete = completeDeferred.add;
	    jqXHR.success = jqXHR.done;
	    jqXHR.error = jqXHR.fail;

	    // Remove hash character (#7531: and string promotion)
	    // Add protocol if not provided (prefilters might expect it)
	    // Handle falsy url in the settings object (#10093: consistency with old signature)
	    // We also use the url parameter if available
	    s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
	      .replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

	    // Alias method option to type as per ticket #12004
	    s.type = options.method || options.type || s.method || s.type;

	    // Extract dataTypes list
	    s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

	    // A cross-domain request is in order when we have a protocol:host:port mismatch
	    if ( s.crossDomain == null ) {
	      parts = rurl.exec( s.url.toLowerCase() );
	      s.crossDomain = !!( parts &&
	        ( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
	          ( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
	            ( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
	      );
	    }

	    // Convert data if not already a string
	    if ( s.data && s.processData && typeof s.data !== "string" ) {
	      s.data = jQuery.param( s.data, s.traditional );
	    }

	    // Apply prefilters
	    inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

	    // If request was aborted inside a prefilter, stop there
	    if ( state === 2 ) {
	      return jqXHR;
	    }

	    // We can fire global events as of now if asked to
	    fireGlobals = s.global;

	    // Watch for a new set of requests
	    if ( fireGlobals && jQuery.active++ === 0 ) {
	      jQuery.event.trigger("ajaxStart");
	    }

	    // Uppercase the type
	    s.type = s.type.toUpperCase();

	    // Determine if request has content
	    s.hasContent = !rnoContent.test( s.type );

	    // Save the URL in case we're toying with the If-Modified-Since
	    // and/or If-None-Match header later on
	    cacheURL = s.url;

	    // More options handling for requests with no content
	    if ( !s.hasContent ) {

	      // If data is available, append data to url
	      if ( s.data ) {
	        cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	        // #9682: remove data so that it's not used in an eventual retry
	        delete s.data;
	      }

	      // Add anti-cache in url if needed
	      if ( s.cache === false ) {
	        s.url = rts.test( cacheURL ) ?

	          // If there is already a '_' parameter, set its value
	          cacheURL.replace( rts, "$1_=" + nonce++ ) :

	          // Otherwise add one to the end
	          cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
	      }
	    }

	    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
	    if ( s.ifModified ) {
	      if ( jQuery.lastModified[ cacheURL ] ) {
	        jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
	      }
	      if ( jQuery.etag[ cacheURL ] ) {
	        jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
	      }
	    }

	    // Set the correct header, if data is being sent
	    if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
	      jqXHR.setRequestHeader( "Content-Type", s.contentType );
	    }

	    // Set the Accepts header for the server, depending on the dataType
	    jqXHR.setRequestHeader(
	      "Accept",
	      s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
	        s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
	        s.accepts[ "*" ]
	    );

	    // Check for headers option
	    for ( i in s.headers ) {
	      jqXHR.setRequestHeader( i, s.headers[ i ] );
	    }

	    // Allow custom headers/mimetypes and early abort
	    if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	      // Abort if not done already and return
	      return jqXHR.abort();
	    }

	    // aborting is no longer a cancellation
	    strAbort = "abort";

	    // Install callbacks on deferreds
	    for ( i in { success: 1, error: 1, complete: 1 } ) {
	      jqXHR[ i ]( s[ i ] );
	    }

	    // Get transport
	    transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

	    // If no transport, we auto-abort
	    if ( !transport ) {
	      done( -1, "No Transport" );
	    } else {
	      jqXHR.readyState = 1;

	      // Send global event
	      if ( fireGlobals ) {
	        globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
	      }
	      // Timeout
	      if ( s.async && s.timeout > 0 ) {
	        timeoutTimer = setTimeout(function() {
	          jqXHR.abort("timeout");
	        }, s.timeout );
	      }

	      try {
	        state = 1;
	        transport.send( requestHeaders, done );
	      } catch ( e ) {
	        // Propagate exception as error if not done
	        if ( state < 2 ) {
	          done( -1, e );
	        // Simply rethrow otherwise
	        } else {
	          throw e;
	        }
	      }
	    }

	    // Callback for when everything is done
	    function done( status, nativeStatusText, responses, headers ) {
	      var isSuccess, success, error, response, modified,
	        statusText = nativeStatusText;

	      // Called once
	      if ( state === 2 ) {
	        return;
	      }

	      // State is "done" now
	      state = 2;

	      // Clear timeout if it exists
	      if ( timeoutTimer ) {
	        clearTimeout( timeoutTimer );
	      }

	      // Dereference transport for early garbage collection
	      // (no matter how long the jqXHR object will be used)
	      transport = undefined;

	      // Cache response headers
	      responseHeadersString = headers || "";

	      // Set readyState
	      jqXHR.readyState = status > 0 ? 4 : 0;

	      // Determine if successful
	      isSuccess = status >= 200 && status < 300 || status === 304;

	      // Get response data
	      if ( responses ) {
	        response = ajaxHandleResponses( s, jqXHR, responses );
	      }

	      // Convert no matter what (that way responseXXX fields are always set)
	      response = ajaxConvert( s, response, jqXHR, isSuccess );

	      // If successful, handle type chaining
	      if ( isSuccess ) {

	        // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
	        if ( s.ifModified ) {
	          modified = jqXHR.getResponseHeader("Last-Modified");
	          if ( modified ) {
	            jQuery.lastModified[ cacheURL ] = modified;
	          }
	          modified = jqXHR.getResponseHeader("etag");
	          if ( modified ) {
	            jQuery.etag[ cacheURL ] = modified;
	          }
	        }

	        // if no content
	        if ( status === 204 || s.type === "HEAD" ) {
	          statusText = "nocontent";

	        // if not modified
	        } else if ( status === 304 ) {
	          statusText = "notmodified";

	        // If we have data, let's convert it
	        } else {
	          statusText = response.state;
	          success = response.data;
	          error = response.error;
	          isSuccess = !error;
	        }
	      } else {
	        // We extract error from statusText
	        // then normalize statusText and status for non-aborts
	        error = statusText;
	        if ( status || !statusText ) {
	          statusText = "error";
	          if ( status < 0 ) {
	            status = 0;
	          }
	        }
	      }

	      // Set data for the fake xhr object
	      jqXHR.status = status;
	      jqXHR.statusText = ( nativeStatusText || statusText ) + "";

	      // Success/Error
	      if ( isSuccess ) {
	        deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
	      } else {
	        deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
	      }

	      // Status-dependent callbacks
	      jqXHR.statusCode( statusCode );
	      statusCode = undefined;

	      if ( fireGlobals ) {
	        globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
	          [ jqXHR, s, isSuccess ? success : error ] );
	      }

	      // Complete
	      completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

	      if ( fireGlobals ) {
	        globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	        // Handle the global AJAX counter
	        if ( !( --jQuery.active ) ) {
	          jQuery.event.trigger("ajaxStop");
	        }
	      }
	    }

	    return jqXHR;
	  },

	  getJSON: function( url, data, callback ) {
	    return jQuery.get( url, data, callback, "json" );
	  },

	  getScript: function( url, callback ) {
	    return jQuery.get( url, undefined, callback, "script" );
	  }
	});

	jQuery.each( [ "get", "post" ], function( i, method ) {
	  jQuery[ method ] = function( url, data, callback, type ) {
	    // shift arguments if data argument was omitted
	    if ( jQuery.isFunction( data ) ) {
	      type = type || callback;
	      callback = data;
	      data = undefined;
	    }

	    return jQuery.ajax({
	      url: url,
	      type: method,
	      dataType: type,
	      data: data,
	      success: callback
	    });
	  };
	});

	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	  jQuery.fn[ type ] = function( fn ) {
	    return this.on( type, fn );
	  };
	});


	jQuery._evalUrl = function( url ) {
	  return jQuery.ajax({
	    url: url,
	    type: "GET",
	    dataType: "script",
	    async: false,
	    global: false,
	    "throws": true
	  });
	};


	jQuery.fn.extend({
	  wrapAll: function( html ) {
	    var wrap;

	    if ( jQuery.isFunction( html ) ) {
	      return this.each(function( i ) {
	        jQuery( this ).wrapAll( html.call(this, i) );
	      });
	    }

	    if ( this[ 0 ] ) {

	      // The elements to wrap the target around
	      wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

	      if ( this[ 0 ].parentNode ) {
	        wrap.insertBefore( this[ 0 ] );
	      }

	      wrap.map(function() {
	        var elem = this;

	        while ( elem.firstElementChild ) {
	          elem = elem.firstElementChild;
	        }

	        return elem;
	      }).append( this );
	    }

	    return this;
	  },

	  wrapInner: function( html ) {
	    if ( jQuery.isFunction( html ) ) {
	      return this.each(function( i ) {
	        jQuery( this ).wrapInner( html.call(this, i) );
	      });
	    }

	    return this.each(function() {
	      var self = jQuery( this ),
	        contents = self.contents();

	      if ( contents.length ) {
	        contents.wrapAll( html );

	      } else {
	        self.append( html );
	      }
	    });
	  },

	  wrap: function( html ) {
	    var isFunction = jQuery.isFunction( html );

	    return this.each(function( i ) {
	      jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
	    });
	  },

	  unwrap: function() {
	    return this.parent().each(function() {
	      if ( !jQuery.nodeName( this, "body" ) ) {
	        jQuery( this ).replaceWith( this.childNodes );
	      }
	    }).end();
	  }
	});


	jQuery.expr.filters.hidden = function( elem ) {
	  // Support: Opera <= 12.12
	  // Opera reports offsetWidths and offsetHeights less than zero on some elements
	  return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
	};
	jQuery.expr.filters.visible = function( elem ) {
	  return !jQuery.expr.filters.hidden( elem );
	};




	var r20 = /%20/g,
	  rbracket = /\[\]$/,
	  rCRLF = /\r?\n/g,
	  rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	  rsubmittable = /^(?:input|select|textarea|keygen)/i;

	function buildParams( prefix, obj, traditional, add ) {
	  var name;

	  if ( jQuery.isArray( obj ) ) {
	    // Serialize array item.
	    jQuery.each( obj, function( i, v ) {
	      if ( traditional || rbracket.test( prefix ) ) {
	        // Treat each array item as a scalar.
	        add( prefix, v );

	      } else {
	        // Item is non-scalar (array or object), encode its numeric index.
	        buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
	      }
	    });

	  } else if ( !traditional && jQuery.type( obj ) === "object" ) {
	    // Serialize object item.
	    for ( name in obj ) {
	      buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
	    }

	  } else {
	    // Serialize scalar item.
	    add( prefix, obj );
	  }
	}

	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
	  var prefix,
	    s = [],
	    add = function( key, value ) {
	      // If value is a function, invoke it and return its value
	      value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
	      s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
	    };

	  // Set traditional to true for jQuery <= 1.3.2 behavior.
	  if ( traditional === undefined ) {
	    traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	  }

	  // If an array was passed in, assume that it is an array of form elements.
	  if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	    // Serialize the form elements
	    jQuery.each( a, function() {
	      add( this.name, this.value );
	    });

	  } else {
	    // If traditional, encode the "old" way (the way 1.3.2 or older
	    // did it), otherwise encode params recursively.
	    for ( prefix in a ) {
	      buildParams( prefix, a[ prefix ], traditional, add );
	    }
	  }

	  // Return the resulting serialization
	  return s.join( "&" ).replace( r20, "+" );
	};

	jQuery.fn.extend({
	  serialize: function() {
	    return jQuery.param( this.serializeArray() );
	  },
	  serializeArray: function() {
	    return this.map(function() {
	      // Can add propHook for "elements" to filter or add form elements
	      var elements = jQuery.prop( this, "elements" );
	      return elements ? jQuery.makeArray( elements ) : this;
	    })
	    .filter(function() {
	      var type = this.type;

	      // Use .is( ":disabled" ) so that fieldset[disabled] works
	      return this.name && !jQuery( this ).is( ":disabled" ) &&
	        rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
	        ( this.checked || !rcheckableType.test( type ) );
	    })
	    .map(function( i, elem ) {
	      var val = jQuery( this ).val();

	      return val == null ?
	        null :
	        jQuery.isArray( val ) ?
	          jQuery.map( val, function( val ) {
	            return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
	          }) :
	          { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
	    }).get();
	  }
	});


	jQuery.ajaxSettings.xhr = function() {
	  try {
	    return new XMLHttpRequest();
	  } catch( e ) {}
	};

	var xhrId = 0,
	  xhrCallbacks = {},
	  xhrSuccessStatus = {
	    // file protocol always yields status code 0, assume 200
	    0: 200,
	    // Support: IE9
	    // #1450: sometimes IE returns 1223 when it should be 204
	    1223: 204
	  },
	  xhrSupported = jQuery.ajaxSettings.xhr();

	// Support: IE9
	// Open requests must be manually aborted on unload (#5280)
	if ( window.ActiveXObject ) {
	  jQuery( window ).on( "unload", function() {
	    for ( var key in xhrCallbacks ) {
	      xhrCallbacks[ key ]();
	    }
	  });
	}

	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport(function( options ) {
	  var callback;

	  // Cross domain only allowed if supported through XMLHttpRequest
	  if ( support.cors || xhrSupported && !options.crossDomain ) {
	    return {
	      send: function( headers, complete ) {
	        var i,
	          xhr = options.xhr(),
	          id = ++xhrId;

	        xhr.open( options.type, options.url, options.async, options.username, options.password );

	        // Apply custom fields if provided
	        if ( options.xhrFields ) {
	          for ( i in options.xhrFields ) {
	            xhr[ i ] = options.xhrFields[ i ];
	          }
	        }

	        // Override mime type if needed
	        if ( options.mimeType && xhr.overrideMimeType ) {
	          xhr.overrideMimeType( options.mimeType );
	        }

	        // X-Requested-With header
	        // For cross-domain requests, seeing as conditions for a preflight are
	        // akin to a jigsaw puzzle, we simply never set it to be sure.
	        // (it can always be set on a per-request basis or even using ajaxSetup)
	        // For same-domain requests, won't change header if already provided.
	        if ( !options.crossDomain && !headers["X-Requested-With"] ) {
	          headers["X-Requested-With"] = "XMLHttpRequest";
	        }

	        // Set headers
	        for ( i in headers ) {
	          xhr.setRequestHeader( i, headers[ i ] );
	        }

	        // Callback
	        callback = function( type ) {
	          return function() {
	            if ( callback ) {
	              delete xhrCallbacks[ id ];
	              callback = xhr.onload = xhr.onerror = null;

	              if ( type === "abort" ) {
	                xhr.abort();
	              } else if ( type === "error" ) {
	                complete(
	                  // file: protocol always yields status 0; see #8605, #14207
	                  xhr.status,
	                  xhr.statusText
	                );
	              } else {
	                complete(
	                  xhrSuccessStatus[ xhr.status ] || xhr.status,
	                  xhr.statusText,
	                  // Support: IE9
	                  // Accessing binary-data responseText throws an exception
	                  // (#11426)
	                  typeof xhr.responseText === "string" ? {
	                    text: xhr.responseText
	                  } : undefined,
	                  xhr.getAllResponseHeaders()
	                );
	              }
	            }
	          };
	        };

	        // Listen to events
	        xhr.onload = callback();
	        xhr.onerror = callback("error");

	        // Create the abort callback
	        callback = xhrCallbacks[ id ] = callback("abort");

	        try {
	          // Do send the request (this may raise an exception)
	          xhr.send( options.hasContent && options.data || null );
	        } catch ( e ) {
	          // #14683: Only rethrow if this hasn't been notified as an error yet
	          if ( callback ) {
	            throw e;
	          }
	        }
	      },

	      abort: function() {
	        if ( callback ) {
	          callback();
	        }
	      }
	    };
	  }
	});




	// Install script dataType
	jQuery.ajaxSetup({
	  accepts: {
	    script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	  },
	  contents: {
	    script: /(?:java|ecma)script/
	  },
	  converters: {
	    "text script": function( text ) {
	      jQuery.globalEval( text );
	      return text;
	    }
	  }
	});

	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
	  if ( s.cache === undefined ) {
	    s.cache = false;
	  }
	  if ( s.crossDomain ) {
	    s.type = "GET";
	  }
	});

	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	  // This transport only deals with cross domain requests
	  if ( s.crossDomain ) {
	    var script, callback;
	    return {
	      send: function( _, complete ) {
	        script = jQuery("<script>").prop({
	          async: true,
	          charset: s.scriptCharset,
	          src: s.url
	        }).on(
	          "load error",
	          callback = function( evt ) {
	            script.remove();
	            callback = null;
	            if ( evt ) {
	              complete( evt.type === "error" ? 404 : 200, evt.type );
	            }
	          }
	        );
	        document.head.appendChild( script[ 0 ] );
	      },
	      abort: function() {
	        if ( callback ) {
	          callback();
	        }
	      }
	    };
	  }
	});




	var oldCallbacks = [],
	  rjsonp = /(=)\?(?=&|$)|\?\?/;

	// Default jsonp settings
	jQuery.ajaxSetup({
	  jsonp: "callback",
	  jsonpCallback: function() {
	    var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
	    this[ callback ] = true;
	    return callback;
	  }
	});

	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	  var callbackName, overwritten, responseContainer,
	    jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
	      "url" :
	      typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
	    );

	  // Handle iff the expected data type is "jsonp" or we have a parameter to set
	  if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

	    // Get callback name, remembering preexisting value associated with it
	    callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
	      s.jsonpCallback() :
	      s.jsonpCallback;

	    // Insert callback into url or form data
	    if ( jsonProp ) {
	      s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
	    } else if ( s.jsonp !== false ) {
	      s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
	    }

	    // Use data converter to retrieve json after script execution
	    s.converters["script json"] = function() {
	      if ( !responseContainer ) {
	        jQuery.error( callbackName + " was not called" );
	      }
	      return responseContainer[ 0 ];
	    };

	    // force json dataType
	    s.dataTypes[ 0 ] = "json";

	    // Install callback
	    overwritten = window[ callbackName ];
	    window[ callbackName ] = function() {
	      responseContainer = arguments;
	    };

	    // Clean-up function (fires after converters)
	    jqXHR.always(function() {
	      // Restore preexisting value
	      window[ callbackName ] = overwritten;

	      // Save back as free
	      if ( s[ callbackName ] ) {
	        // make sure that re-using the options doesn't screw things around
	        s.jsonpCallback = originalSettings.jsonpCallback;

	        // save the callback name for future use
	        oldCallbacks.push( callbackName );
	      }

	      // Call if it was a function and we have a response
	      if ( responseContainer && jQuery.isFunction( overwritten ) ) {
	        overwritten( responseContainer[ 0 ] );
	      }

	      responseContainer = overwritten = undefined;
	    });

	    // Delegate to script
	    return "script";
	  }
	});




	// data: string of html
	// context (optional): If specified, the fragment will be created in this context, defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
	  if ( !data || typeof data !== "string" ) {
	    return null;
	  }
	  if ( typeof context === "boolean" ) {
	    keepScripts = context;
	    context = false;
	  }
	  context = context || document;

	  var parsed = rsingleTag.exec( data ),
	    scripts = !keepScripts && [];

	  // Single tag
	  if ( parsed ) {
	    return [ context.createElement( parsed[1] ) ];
	  }

	  parsed = jQuery.buildFragment( [ data ], context, scripts );

	  if ( scripts && scripts.length ) {
	    jQuery( scripts ).remove();
	  }

	  return jQuery.merge( [], parsed.childNodes );
	};


	// Keep a copy of the old load method
	var _load = jQuery.fn.load;

	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
	  if ( typeof url !== "string" && _load ) {
	    return _load.apply( this, arguments );
	  }

	  var selector, type, response,
	    self = this,
	    off = url.indexOf(" ");

	  if ( off >= 0 ) {
	    selector = jQuery.trim( url.slice( off ) );
	    url = url.slice( 0, off );
	  }

	  // If it's a function
	  if ( jQuery.isFunction( params ) ) {

	    // We assume that it's the callback
	    callback = params;
	    params = undefined;

	  // Otherwise, build a param string
	  } else if ( params && typeof params === "object" ) {
	    type = "POST";
	  }

	  // If we have elements to modify, make the request
	  if ( self.length > 0 ) {
	    jQuery.ajax({
	      url: url,

	      // if "type" variable is undefined, then "GET" method will be used
	      type: type,
	      dataType: "html",
	      data: params
	    }).done(function( responseText ) {

	      // Save response for use in complete callback
	      response = arguments;

	      self.html( selector ?

	        // If a selector was specified, locate the right elements in a dummy div
	        // Exclude scripts to avoid IE 'Permission Denied' errors
	        jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

	        // Otherwise use the full result
	        responseText );

	    }).complete( callback && function( jqXHR, status ) {
	      self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
	    });
	  }

	  return this;
	};




	jQuery.expr.filters.animated = function( elem ) {
	  return jQuery.grep(jQuery.timers, function( fn ) {
	    return elem === fn.elem;
	  }).length;
	};




	var docElem = window.document.documentElement;

	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
	  return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}

	jQuery.offset = {
	  setOffset: function( elem, options, i ) {
	    var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
	      position = jQuery.css( elem, "position" ),
	      curElem = jQuery( elem ),
	      props = {};

	    // Set position first, in-case top/left are set even on static elem
	    if ( position === "static" ) {
	      elem.style.position = "relative";
	    }

	    curOffset = curElem.offset();
	    curCSSTop = jQuery.css( elem, "top" );
	    curCSSLeft = jQuery.css( elem, "left" );
	    calculatePosition = ( position === "absolute" || position === "fixed" ) &&
	      ( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

	    // Need to be able to calculate position if either top or left is auto and position is either absolute or fixed
	    if ( calculatePosition ) {
	      curPosition = curElem.position();
	      curTop = curPosition.top;
	      curLeft = curPosition.left;

	    } else {
	      curTop = parseFloat( curCSSTop ) || 0;
	      curLeft = parseFloat( curCSSLeft ) || 0;
	    }

	    if ( jQuery.isFunction( options ) ) {
	      options = options.call( elem, i, curOffset );
	    }

	    if ( options.top != null ) {
	      props.top = ( options.top - curOffset.top ) + curTop;
	    }
	    if ( options.left != null ) {
	      props.left = ( options.left - curOffset.left ) + curLeft;
	    }

	    if ( "using" in options ) {
	      options.using.call( elem, props );

	    } else {
	      curElem.css( props );
	    }
	  }
	};

	jQuery.fn.extend({
	  offset: function( options ) {
	    if ( arguments.length ) {
	      return options === undefined ?
	        this :
	        this.each(function( i ) {
	          jQuery.offset.setOffset( this, options, i );
	        });
	    }

	    var docElem, win,
	      elem = this[ 0 ],
	      box = { top: 0, left: 0 },
	      doc = elem && elem.ownerDocument;

	    if ( !doc ) {
	      return;
	    }

	    docElem = doc.documentElement;

	    // Make sure it's not a disconnected DOM node
	    if ( !jQuery.contains( docElem, elem ) ) {
	      return box;
	    }

	    // If we don't have gBCR, just use 0,0 rather than error
	    // BlackBerry 5, iOS 3 (original iPhone)
	    if ( typeof elem.getBoundingClientRect !== strundefined ) {
	      box = elem.getBoundingClientRect();
	    }
	    win = getWindow( doc );
	    return {
	      top: box.top + win.pageYOffset - docElem.clientTop,
	      left: box.left + win.pageXOffset - docElem.clientLeft
	    };
	  },

	  position: function() {
	    if ( !this[ 0 ] ) {
	      return;
	    }

	    var offsetParent, offset,
	      elem = this[ 0 ],
	      parentOffset = { top: 0, left: 0 };

	    // Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
	    if ( jQuery.css( elem, "position" ) === "fixed" ) {
	      // We assume that getBoundingClientRect is available when computed position is fixed
	      offset = elem.getBoundingClientRect();

	    } else {
	      // Get *real* offsetParent
	      offsetParent = this.offsetParent();

	      // Get correct offsets
	      offset = this.offset();
	      if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
	        parentOffset = offsetParent.offset();
	      }

	      // Add offsetParent borders
	      parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
	      parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
	    }

	    // Subtract parent offsets and element margins
	    return {
	      top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
	      left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
	    };
	  },

	  offsetParent: function() {
	    return this.map(function() {
	      var offsetParent = this.offsetParent || docElem;

	      while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
	        offsetParent = offsetParent.offsetParent;
	      }

	      return offsetParent || docElem;
	    });
	  }
	});

	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	  var top = "pageYOffset" === prop;

	  jQuery.fn[ method ] = function( val ) {
	    return access( this, function( elem, method, val ) {
	      var win = getWindow( elem );

	      if ( val === undefined ) {
	        return win ? win[ prop ] : elem[ method ];
	      }

	      if ( win ) {
	        win.scrollTo(
	          !top ? val : window.pageXOffset,
	          top ? val : window.pageYOffset
	        );

	      } else {
	        elem[ method ] = val;
	      }
	    }, method, val, arguments.length, null );
	  };
	});

	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// getComputedStyle returns percent when specified for top/left/bottom/right
	// rather than make the css module depend on the offset module, we just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
	  jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
	    function( elem, computed ) {
	      if ( computed ) {
	        computed = curCSS( elem, prop );
	        // if curCSS returns percentage, fallback to offset
	        return rnumnonpx.test( computed ) ?
	          jQuery( elem ).position()[ prop ] + "px" :
	          computed;
	      }
	    }
	  );
	});


	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	  jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
	    // margin is only for outerHeight, outerWidth
	    jQuery.fn[ funcName ] = function( margin, value ) {
	      var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
	        extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

	      return access( this, function( elem, type, value ) {
	        var doc;

	        if ( jQuery.isWindow( elem ) ) {
	          // As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
	          // isn't a whole lot we can do. See pull request at this URL for discussion:
	          // https://github.com/jquery/jquery/pull/764
	          return elem.document.documentElement[ "client" + name ];
	        }

	        // Get document width or height
	        if ( elem.nodeType === 9 ) {
	          doc = elem.documentElement;

	          // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
	          // whichever is greatest
	          return Math.max(
	            elem.body[ "scroll" + name ], doc[ "scroll" + name ],
	            elem.body[ "offset" + name ], doc[ "offset" + name ],
	            doc[ "client" + name ]
	          );
	        }

	        return value === undefined ?
	          // Get width or height on the element, requesting but not forcing parseFloat
	          jQuery.css( elem, type, extra ) :

	          // Set width or height on the element
	          jQuery.style( elem, type, value, extra );
	      }, type, chainable ? margin : undefined, chainable, null );
	    };
	  });
	});


	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
	  return this.length;
	};

	jQuery.fn.andSelf = jQuery.fn.addBack;




	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.

	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

	if ( typeof define === "function" && define.amd ) {
	  define( "jquery", [], function() {
	    return jQuery;
	  });
	}




	var
	  // Map over jQuery in case of overwrite
	  _jQuery = window.jQuery,

	  // Map over the $ in case of overwrite
	  _$ = window.$;

	jQuery.noConflict = function( deep ) {
	  if ( window.$ === jQuery ) {
	    window.$ = _$;
	  }

	  if ( deep && window.jQuery === jQuery ) {
	    window.jQuery = _jQuery;
	  }

	  return jQuery;
	};

	// Expose jQuery and $ identifiers, even in
	// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === strundefined ) {
	  window.jQuery = window.$ = jQuery;
	}

	return jQuery;

	}));

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, React, $) {var css_as_str, el, height_cache, size_cache, width_cache,
	  hasProp = {}.hasOwnProperty;

	__webpack_require__(34);

	__webpack_require__(12);

	window.back_to_homepage_button = function(style) {
	  var hash, homepage, loc;
	  loc = fetch('location');
	  homepage = loc.url === '/';
	  hash = loc.url.split('/')[1].replace('-', '_');
	  return A({
	    href: "/#" + hash,
	    style: _.defaults(style, {
	      fontSize: 43,
	      visibility: homepage ? 'hidden' : void 0,
	      color: 'black'
	    })
	  }, '<');
	};

	for (el in React.DOM) {
	  window[el.toUpperCase()] = React.DOM[el];
	}

	window.styles = "";

	window.TRANSITION_SPEED = 700;

	window.LIVE_UPDATE_INTERVAL = 3 * 60 * 1000;

	setInterval(function() {
	  var dependent_keys, key, proposals;
	  dependent_keys = [];
	  proposals = false;
	  for (key in arest.components_4_key.hash) {
	    if (key[0] === '/' && arest.components_4_key.get(key).length > 0 && !key.match(/\/(user|opinion|point|proposals)\//)) {
	      if (key.match(/\/proposal\//)) {
	        proposals = true;
	      } else if (key !== '/current_user' || fetch('/current_user').logged_in) {
	        arest.serverFetch(key);
	      }
	    }
	  }
	  if (proposals) {
	    return arest.serverFetch('/proposals');
	  }
	}, LIVE_UPDATE_INTERVAL);

	window.POINT_MOUTH_WIDTH = 17;

	window.getCoords = function(el) {
	  var docEl, offset, rect;
	  rect = el.getBoundingClientRect();
	  docEl = document.documentElement;
	  offset = {
	    top: rect.top + window.pageYOffset - docEl.clientTop,
	    left: rect.left + window.pageXOffset - docEl.clientLeft
	  };
	  return _.extend(offset, {
	    cx: offset.left + rect.width / 2,
	    cy: offset.top + rect.height / 2
	  });
	};

	window.asset = function(name) {
	  var app;
	  app = fetch('/application');
	  if (app.app != null) {
	    return (app.asset_host || '') + "/images/" + name;
	  } else {
	    return "";
	  }
	};

	window.on_ajax_error = function() {
	  var root;
	  (root = fetch('root')).server_error = true;
	  return save(root);
	};

	window.on_client_error = function(e) {
	  if (navigator.userAgent.indexOf('PhantomJS') >= 0) {
	    return;
	  }
	  return save({
	    key: '/new/client_error',
	    stack: e.stack,
	    message: e.message || e.description,
	    name: e.name,
	    line_number: e.lineNumber,
	    column_number: e.columnNumber
	  });
	};

	window.writeToLog = function(entry) {
	  _.extend(entry, {
	    key: '/new/log',
	    where: fetch('location').url
	  });
	  return save(entry);
	};

	window.prettyDate = function(time) {
	  var date, day_diff, diff, r;
	  date = new Date(time);
	  diff = ((new Date()).getTime() - date.getTime()) / 1000;
	  day_diff = Math.floor(diff / 86400);
	  if (isNaN(day_diff) || day_diff < 0) {
	    return;
	  }
	  r = day_diff === 0 && (diff < 60 && "just now" || diff < 120 && "1 minute ago" || diff < 3600 && Math.floor(diff / 60) + " minutes ago" || diff < 7200 && "1 hour ago" || diff < 86400 && Math.floor(diff / 3600) + " hours ago") || day_diff === 1 && "Yesterday" || day_diff < 7 && day_diff + " days ago" || day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago" || ((date.getMonth() + 1) + "/" + (date.getDay() + 1) + "/" + (date.getFullYear()));
	  r = r.replace('1 days ago', '1 day ago').replace('1 weeks ago', '1 week ago').replace('1 years ago', '1 year ago');
	  return r;
	};

	window.shorten = function(str, max_length) {
	  max_length || (max_length = 70);
	  return "" + (str.substring(0, max_length)) + (str.length > max_length ? '...' : '');
	};

	window.inRange = function(val, min, max) {
	  return val <= max && val >= min;
	};

	window.capitalize = function(string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	};

	window.L = window.LOADING_INDICATOR = DIV(null, 'Loading...');

	window.slugify = function(text) {
	  return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '').substring(0, 30);
	};

	window.shared_local_key = function(key_or_object) {
	  var key;
	  key = key_or_object.key || key_or_object;
	  if (key[0] === '/') {
	    key = key.substring(1, key.length);
	    return key + "/shared";
	  } else {
	    return key;
	  }
	};

	window.reset_key = function(obj_or_key, updates) {
	  var k, v;
	  updates = updates || {};
	  if (!obj_or_key.key) {
	    obj_or_key = fetch(obj_or_key);
	  }
	  for (k in obj_or_key) {
	    if (!hasProp.call(obj_or_key, k)) continue;
	    v = obj_or_key[k];
	    if (k !== 'key') {
	      delete obj_or_key[k];
	    }
	  }
	  _.extend(obj_or_key, updates);
	  return save(obj_or_key);
	};

	window.splitParagraphs = function(user_content) {
	  var hyperlink_pattern, i, idx, len, para, paragraphs, results, text;
	  if (!user_content) {
	    return SPAN(null);
	  }
	  user_content = user_content.replace(/(<li>|<br\s?\/?>|<p>)/g, '\n');
	  user_content = user_content.replace(/(<([^>]+)>)/ig, "");
	  hyperlink_pattern = /(^|[\s\n])((?:https?):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()~_|!:,.;]*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi;
	  user_content = user_content.replace(hyperlink_pattern, "$1(*-&)link:$2(*-&)");
	  paragraphs = user_content.split(/(?:\r?\n)/g);
	  results = [];
	  for (idx = i = 0, len = paragraphs.length; i < len; idx = ++i) {
	    para = paragraphs[idx];
	    results.push(P({
	      key: "para-" + idx
	    }, (function() {
	      var j, len1, ref, results1;
	      ref = para.split('(*-&)');
	      results1 = [];
	      for (idx = j = 0, len1 = ref.length; j < len1; idx = ++j) {
	        text = ref[idx];
	        if (text.substring(0, 5) === 'link:') {
	          results1.push(A({
	            key: idx,
	            href: text.substring(5, text.length),
	            target: '_blank'
	          }, text.substring(5, text.length)));
	        } else {
	          results1.push(SPAN({
	            key: idx
	          }, text));
	        }
	      }
	      return results1;
	    })()));
	  }
	  return results;
	};

	width_cache = {};

	window.widthWhenRendered = function(str, style) {
	  var $el, key, width;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if (!(key in width_cache)) {
	    _.defaults(style, {
	      display: 'inline-block'
	    });
	    $el = $("<span id='width_test'><span>" + str + "</span></span>").css(style);
	    $('#content').append($el);
	    width = $('#width_test span').width();
	    $('#width_test').remove();
	    width_cache[key] = width;
	  }
	  return width_cache[key];
	};

	height_cache = {};

	window.heightWhenRendered = function(str, style) {
	  var $el, height, key;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if (!(key in height_cache)) {
	    $el = $("<div id='height_test'>" + str + "</div>").css(style);
	    $('#content').append($el);
	    height = $('#height_test').height();
	    $('#height_test').remove();
	    height_cache[key] = height;
	  }
	  return height_cache[key];
	};

	size_cache = {};

	window.sizeWhenRendered = function(str, style) {
	  var h, k, key, main, test, v, w;
	  main = document.getElementById('content');
	  if (!main) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	  style || (style = {});
	  style.str = str;
	  key = JSON.stringify(style);
	  delete style.str;
	  if (!(key in size_cache)) {
	    style.display || (style.display = 'inline-block');
	    test = document.createElement("span");
	    test.innerHTML = "<span>" + str + "</span>";
	    for (k in style) {
	      v = style[k];
	      test.style[k] = v;
	    }
	    main.appendChild(test);
	    h = test.offsetHeight;
	    w = test.offsetWidth;
	    main.removeChild(test);
	    size_cache[key] = {
	      width: w,
	      height: h
	    };
	  }
	  return size_cache[key];
	};

	window.translateStanceToPixelX = function(stance, width) {
	  return (stance + 1) / 2 * width;
	};

	window.translatePixelXToStance = function(pixel_x, width) {
	  return 2 * (pixel_x / width) - 1;
	};

	window.closest = function(node, check) {
	  if (!node || node === document) {
	    return false;
	  } else {
	    return check(node) || closest(node.parentNode, check);
	  }
	};

	window.css = {};

	css_as_str = function(attrs) {
	  return _.keys(attrs).map(function(p) {
	    return p + ": " + attrs[p];
	  }).join(';') + ';';
	};

	css.crossbrowserify = function(props, as_str) {
	  var i, j, len, len1, prefix, prefixes;
	  if (as_str == null) {
	    as_str = false;
	  }
	  prefixes = ['-webkit-', '-ms-', '-mox-', '-o-'];
	  if (props.transform) {
	    for (i = 0, len = prefixes.length; i < len; i++) {
	      prefix = prefixes[i];
	      props[prefix + "transform"] = props.transform;
	    }
	  }
	  if (props.transition) {
	    for (j = 0, len1 = prefixes.length; j < len1; j++) {
	      prefix = prefixes[j];
	      props[prefix + "transition"] = props.transition.replace("transform", prefix + "transform");
	    }
	  }
	  if (props.userSelect) {
	    _.extend(props, {
	      MozUserSelect: props.userSelect,
	      WebkitUserSelect: props.userSelect,
	      msUserSelect: props.userSelect
	    });
	  }
	  if (as_str) {
	    return css_as_str(props);
	  } else {
	    return props;
	  }
	};

	css.grayscale = function(props) {
	  if (browser.is_mobile) {
	    console.log("CAUTION: grayscale filter on mobile can cause crashes");
	  }
	  _.extend(props, {
	    WebkitFilter: 'grayscale(100%)',
	    filter: 'grayscale(100%)'
	  });
	  return props;
	};

	css.grab_cursor = function(selector) {
	  return selector + " {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n} " + selector + ":active {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n}";
	};

	window.cssTriangle = function(direction, color, width, height, style) {
	  var border_color, border_width;
	  style = style || {};
	  switch (direction) {
	    case 'top':
	      border_width = "0 " + (width / 2) + "px " + height + "px " + (width / 2) + "px";
	      border_color = "transparent transparent " + color + " transparent";
	      break;
	    case 'bottom':
	      border_width = height + "px " + (width / 2) + "px 0 " + (width / 2) + "px";
	      border_color = color + " transparent transparent transparent";
	      break;
	    case 'left':
	      border_width = (height / 2) + "px " + width + "px " + (height / 2) + "px 0";
	      border_color = "transparent " + color + " transparent transparent";
	      break;
	    case 'right':
	      border_width = (height / 2) + "px 0 " + (height / 2) + "px " + width + "px";
	      border_color = "transparent transparent transparent " + color;
	  }
	  _.defaults(style, {
	    width: 0,
	    height: 0,
	    borderStyle: 'solid',
	    borderWidth: border_width,
	    borderColor: border_color
	  });
	  return style;
	};

	window.slugify = function(text) {
	  return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	};

	window.styles += "/* RESET\n * Eric Meyer's Reset CSS v2.0 (http://meyerweb.com/eric/tools/css/reset/)\n * http://cssreset.com\n */\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  line-height: 1.4; }\n\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #cccccc;\n  margin: 0;\n  padding: 0; }\n\nbody {\n  min-height: 100%; }\n\nol, ul {\n  list-style: none;\n  list-style-position: inside; }\n\nblockquote, q {\n  quotes: none; }\n\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none; }\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\ntd, th {vertical-align: top;}\n\nh1, h2, h3, h4, h5, h6, strong {\n  font-weight: bold; }\n\nem, i {\n  font-style: italic; }\n\nb, strong { font-weight: bold; }\n\n/* ELEMENT DEFAULTS */\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }\n\na {\n  color: inherit;\n  outline: none;\n  cursor: pointer;\n  text-decoration: none; }\n  a img {\n    border: none; }\n\ntable {\n  border-collapse: separate; }\n\nul {\n  margin: 0;\n  list-style-type: disc; }\n\nol {\n  margin: 0;\n  list-style-type: decimal; }\n\nblockquote {\n  quotes: '\"' '\"' \"'\" \"'\"; }\n  blockquote:before {\n    content: open-quote;}\n  blockquote:after {\n    content: close-quote;}\n";

	window.styles += "\nbody, h1, h2, h3, h4, h5, h6 {\n  color: black; }\n\nbody, input, button, textarea {\n  font-family: 'Avenir Next W01', 'Avenir Next', 'Lucida Grande', 'Lucida Sans Unicode', 'Helvetica Neue', Helvetica, Verdana, sans-serif; }\n\n.content {\n  position: relative;\n  font-size: 16px;\n  color: black;\n  min-height: 500px; }\n\n.button {\n  font-size: 16px; }\n\n.button, button, input[type='submit'] {\n  outline: none;\n  cursor: pointer;\n  text-align: center; }\n\n\n.flipped {\n  -moz-transform: scaleX(-1);\n  -o-transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: 'FlipH'; }\n\n.primary_button, .primary_cancel_button {\n  border-radius: 16px;\n  text-align: center;\n  padding: 3px;\n  cursor: pointer; }\n\n.primary_button {\n  background-color: " + focus_blue + ";\n  color: white;\n  font-size: 29px;\n  margin-top: 14px;\n  box-shadow: 0px 1px 0px black;\n  border: none;\n  padding: 8px 36px; }\n\n.primary_button.disabled {\n  background-color: #eeeeee;\n  color: #cccccc;\n  box-shadow: none;\n  border: none;\n  cursor: wait; }\n\na.primary_cancel_button {\n  color: #888888;\n  margin-top: 0.5em; }\n\na.cancel_opinion_button {\n  float: right;\n  margin-top: 0.5em; }\n\nbutton.primary_button, input[type='submit'] {\n  display: inline-block; }\n";

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(6), __webpack_require__(2)))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var FBLike, FBShare, FoodcorpsHeader, Tweet, ZipcodeBox, agree_disagree, carcd_header, challenge_justify, conference_config, customization_value, customizations, dao_blue, dao_purple, dao_red, dao_section, dao_section_description, dao_section_heading, dao_yellow, delta_pluses, desacuerdo_acuerdo, ecast_highlight_color, effective_ineffective, essential_questions, hala_brown, hala_gray, hala_magenta, hala_orange, hala_proposal_style, hala_section_call_to_action, hala_section_description, hala_section_heading, hala_teal, i, important_unimportant, interested, j, k, len, len1, monitorinstitute_red, monuments, passes_tags, plus_minus, port, port_agree_disagree, port_pros_cons, portuguese, priority, pro_con, promising_weak, pros_contras, ready_not_ready, relevance, rupaul_header, seattle2035_cream, seattle2035_dark, seattle2035_pink, spa, spanish, strengths_improvements, strengths_limitations, strengths_weaknesses, strong_weak, support_challenge_claim, support_oppose, v, yes_no,
	  hasProp = {}.hasOwnProperty;

	__webpack_require__(12);

	__webpack_require__(10);

	window.customization = function(field, object_or_key) {
	  var chain_of_configs, cluster_key, config, i, key, len, proposal, ref, subdomain, subdomain_config, subdomain_name, value;
	  subdomain = fetch('/subdomain');
	  subdomain_name = (ref = subdomain.name) != null ? ref.toLowerCase() : void 0;
	  value = void 0;
	  key = object_or_key ? object_or_key.key ? object_or_key.key : object_or_key : null;
	  chain_of_configs = [];
	  if (customizations[subdomain_name] != null) {
	    subdomain_config = fetch("customizations/" + subdomain_name);
	    if (key) {
	      if (subdomain_config[key] != null) {
	        chain_of_configs.push(subdomain_config[key]);
	      }
	      if (key.match(/\/proposal\//)) {
	        proposal = object_or_key;
	        cluster_key = "cluster/" + proposal.cluster;
	        if (subdomain_config[cluster_key] != null) {
	          chain_of_configs.push(subdomain_config[cluster_key]);
	        }
	      }
	    }
	    chain_of_configs.push(subdomain_config);
	  }
	  chain_of_configs.push(fetch('customizations/default'));
	  for (i = 0, len = chain_of_configs.length; i < len; i++) {
	    config = chain_of_configs[i];
	    value = customization_value(field, config);
	    if (value != null) {
	      break;
	    }
	  }
	  return value;
	};

	customization_value = function(field, config) {
	  var b, brackets, f, fields, i, idx, j, len, len1, val;
	  val = config;
	  fields = field.split('.');
	  for (idx = i = 0, len = fields.length; i < len; idx = ++i) {
	    f = fields[idx];
	    if (f.indexOf('[') > 0) {
	      brackets = f.match(/\[(.*?)\]/g);
	      f = f.substring(0, f.indexOf('['));
	    }
	    if ((val[f] != null) || idx === fields.length - 1) {
	      val = val[f];
	      if ((brackets != null ? brackets.length : void 0) > 0) {
	        for (j = 0, len1 = brackets.length; j < len1; j++) {
	          b = brackets[j];
	          f = b.substring(2, b.length - 2);
	          if ((val != null) && (val[f] != null)) {
	            val = val[f];
	          } else {
	            return void 0;
	          }
	        }
	      }
	    } else {
	      return void 0;
	    }
	  }
	  return val;
	};

	customizations = {};

	__webpack_require__(7);

	__webpack_require__(3);

	__webpack_require__(30);

	__webpack_require__(14);

	__webpack_require__(18);

	__webpack_require__(31);

	__webpack_require__(22);

	__webpack_require__(33);

	pro_con = {
	  pro: 'pro',
	  pros: 'pros',
	  con: 'con',
	  cons: 'cons',
	  your_header: "Give your --valences--",
	  other_header: "Others' --valences--",
	  top_header: "Top --valences--",
	  your_cons_header: null,
	  your_pros_header: null
	};

	strengths_weaknesses = {
	  pro: 'strength',
	  pros: 'strengths',
	  con: 'weakness',
	  cons: 'weaknesses',
	  your_header: "--valences--",
	  other_header: "--valences-- observed",
	  top_header: "Foremost --valences--"
	};

	strengths_limitations = {
	  pro: 'strength',
	  pros: 'strengths',
	  con: 'limitation',
	  cons: 'limitations',
	  your_header: "--valences-- you observed",
	  other_header: "--valences-- observed",
	  top_header: "Foremost --valences--"
	};

	challenge_justify = {
	  pro: 'justification',
	  pros: 'justifications',
	  con: 'challenge',
	  cons: 'challenges',
	  your_header: "Give your --valences--",
	  other_header: "--valences-- identified",
	  top_header: "Top --valences--"
	};

	strengths_improvements = {
	  pro: 'strength',
	  pros: 'strengths',
	  con: 'improvement',
	  cons: 'improvements',
	  your_header: "--valences-- you observe",
	  your_cons_header: "Your suggested improvements",
	  your_pros_header: "Strengths you observe",
	  other_header: "--valences-- identified",
	  top_header: "Top --valences--"
	};

	support_challenge_claim = {
	  pro: 'supporting claim',
	  pros: 'supporting claims',
	  con: 'challenging claim',
	  cons: 'challenging claims',
	  your_header: "--valences-- you recognize",
	  other_header: "--valences-- identified",
	  top_header: "Top --valences--"
	};

	delta_pluses = {
	  pro: 'plus',
	  pros: 'pluses',
	  con: 'delta',
	  cons: 'deltas',
	  your_header: "--valences-- you recognize",
	  other_header: "--valences-- identified",
	  top_header: "Top --valences--"
	};

	pros_contras = {
	  pro: 'pro',
	  pros: 'pros',
	  con: 'contra',
	  cons: 'contras',
	  your_header: "Ingresa tus --valences--",
	  other_header: "Otros --valences--",
	  top_header: "Top --valences--"
	};

	port_pros_cons = {
	  pro: 'A Favor',
	  pros: 'A Favor',
	  con: 'Contra',
	  cons: 'Contra',
	  your_header: "Teus pontos --valences--",
	  other_header: "Outros --valences--",
	  top_header: "Top --valences--"
	};

	support_oppose = {
	  individual: {
	    support: 'Support',
	    oppose: 'Oppose',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Supporters',
	    oppose: 'Opposers',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  slider_feedback: function(value, proposal) {
	    var degree, strength_of_opinion, valence;
	    if (Math.abs(value) < 0.05) {
	      return "You are undecided";
	    } else {
	      degree = Math.abs(value);
	      strength_of_opinion = degree > .999 ? "Fully " : degree > .5 ? "Firmly " : "Slightly ";
	      valence = customization("slider_pole_labels.individual." + (value > 0 ? 'support' : 'oppose'), proposal);
	      return "You " + strength_of_opinion + " " + valence;
	    }
	  }
	};

	relevance = {
	  individual: {
	    support: 'Big impact!',
	    oppose: 'No impact on me',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Big impact!',
	    oppose: 'No impact on me',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	priority = {
	  individual: {
	    support: 'High Priority',
	    oppose: 'Low Priority',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'High Priority',
	    oppose: 'Low Priority',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	interested = {
	  individual: {
	    support: 'Interested',
	    oppose: 'Uninterested',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Interested',
	    oppose: 'Uninterested',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	important_unimportant = {
	  individual: {
	    support: 'Important',
	    oppose: 'Unimportant',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Important',
	    oppose: 'Unimportant',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	yes_no = {
	  individual: {
	    support: 'Yes',
	    oppose: 'No',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Yes',
	    oppose: 'No',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	strong_weak = {
	  individual: {
	    support: 'Strong',
	    oppose: 'Weak',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Strong',
	    oppose: 'Weak',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	promising_weak = {
	  individual: {
	    support: 'Promising',
	    oppose: 'Weak',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Promising',
	    oppose: 'Weak',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	ready_not_ready = {
	  individual: {
	    support: 'Ready',
	    oppose: 'Not ready',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Ready',
	    oppose: 'Not ready',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	agree_disagree = {
	  individual: {
	    support: 'Agree',
	    oppose: 'Disagree',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Agree',
	    oppose: 'Disagree',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  slider_feedback: function(value, proposal) {
	    var degree, strength_of_opinion, valence;
	    if (Math.abs(value) < 0.05) {
	      return "You are undecided";
	    } else {
	      degree = Math.abs(value);
	      strength_of_opinion = degree > .999 ? "Fully " : degree > .5 ? "Firmly " : "Slightly ";
	      valence = customization("slider_pole_labels.individual." + (value > 0 ? 'support' : 'oppose'), proposal);
	      return "You " + strength_of_opinion + " " + valence;
	    }
	  }
	};

	plus_minus = {
	  individual: {
	    support: '+',
	    oppose: '–',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: '+',
	    oppose: '–',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	effective_ineffective = {
	  individual: {
	    support: 'Effective',
	    oppose: 'Ineffective',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Effective',
	    oppose: 'Ineffective',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	desacuerdo_acuerdo = {
	  individual: {
	    support: 'Acuerdo',
	    oppose: 'Desacuerdo',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Acuerdo',
	    oppose: 'Desacuerdo',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	port_agree_disagree = {
	  individual: {
	    support: 'Concordo',
	    oppose: 'Discordo',
	    support_sub: '',
	    oppose_sub: ''
	  },
	  group: {
	    support: 'Concordo',
	    oppose: 'Discordo',
	    support_sub: '',
	    oppose_sub: ''
	  }
	};

	conference_config = {
	  slider_pole_labels: {
	    individual: {
	      support: 'Accept',
	      oppose: 'Reject'
	    },
	    group: {
	      support: 'Accept',
	      oppose: 'Reject'
	    }
	  },
	  homie_histo_title: "PC's ratings"
	};

	customizations["default"] = {
	  lang: 'en',
	  discussion: true,
	  proposal_filters: true,
	  show_new_proposal_button: true,
	  show_crafting_page_first: false,
	  show_histogram_on_crafting: true,
	  point_labels: pro_con,
	  show_slider_feedback: true,
	  slider_pole_labels: agree_disagree,
	  show_meta: true,
	  docking_proposal_header: false,
	  slider_handle: slider_handle.face,
	  slider_ticks: false,
	  slider_regions: null,
	  show_score: true,
	  show_proposer_icon: false,
	  collapse_descriptions_at: false,
	  homie_histo_filter: false,
	  homie_histo_title: 'Opinions',
	  archived: false,
	  label: false,
	  description: function() {
	    return null;
	  },
	  additional_auth_footer: false,
	  civility_pledge: false,
	  has_homepage: true,
	  auth: {
	    user_questions: []
	  },
	  Homepage: SimpleHomepage,
	  ProposalNavigation: DefaultProposalNavigation,
	  HomepageHeader: DefaultHeader,
	  NonHomepageHeader: ShortHeader,
	  Footer: DefaultFooter,
	  ThanksForYourOpinion: false
	};

	rupaul_header = ReactiveComponent({
	  displayName: 'ImageHeader',
	  render: function() {
	    var homepage, hsl, is_light, loc, masthead_style, subdomain;
	    subdomain = fetch('/subdomain');
	    loc = fetch('location');
	    homepage = loc.url === '/';
	    masthead_style = {
	      textAlign: 'left',
	      backgroundColor: subdomain.branding.primary_color,
	      height: 45
	    };
	    hsl = parseCssHsl(subdomain.branding.primary_color);
	    is_light = hsl.l > .75;
	    if (subdomain.branding.masthead) {
	      _.extend(masthead_style, {
	        height: 300,
	        backgroundPosition: 'center',
	        backgroundSize: 'cover',
	        backgroundImage: "url(" + subdomain.branding.masthead + ")"
	      });
	    } else {
	      throw 'ImageHeader can\'t be used without a branding masthead';
	    }
	    return DIV(null, DIV({
	      style: masthead_style
	    }, ProfileMenu(), back_to_homepage_button({
	      position: 'relative',
	      marginLeft: 20,
	      display: 'inline-block',
	      color: !is_light ? 'white' : void 0,
	      fontSize: 43,
	      visibility: homepage || !customization('has_homepage') ? 'hidden' : void 0,
	      verticalAlign: 'middle',
	      marginTop: 5
	    })), DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: '40px auto',
	        display: !homepage ? 'none' : void 0
	      }
	    }, DIV({
	      style: {
	        fontSize: 52,
	        fontWeight: 300,
	        marginBottom: 20,
	        color: '#CE496E'
	      }
	    }, "Welcome Hunties to season 8 of RuPaul's Drag Race!"), DIV({
	      style: {
	        marginBottom: 12,
	        fontSize: 21
	      }
	    }, "This is a space for you to serve the T, throw some shade, show some \nlove and share who you think has the Charisma, Uniqueness, Nerve and \nTalent to be America's Next Drag Superstar! So, just between us \nsquirrel-friends, who do think will be win season 8?"), DIV({
	      style: {
	        fontSize: 21
	      }
	    }, "You can change your votes each week. When a queen gets eliminated, we'll \nSashay away her from the list. Good luck! And Don't Fuck it Up!")));
	  }
	});

	customizations['rupaulseason8'] = {
	  show_proposer_icon: false,
	  proposal_filters: false,
	  show_meta: false,
	  point_labels: {
	    pro: 'Love',
	    pros: 'Love',
	    con: 'Shade',
	    cons: 'Shade',
	    your_header: "Throw your --valences--",
	    other_header: "Others' --valences--",
	    top_header: "Best --valences--"
	  },
	  slider_pole_labels: {
	    individual: {
	      support: 'YAAAAAAS',
	      oppose: 'Hellz No!',
	      support_sub: '',
	      oppose_sub: ''
	    },
	    group: {
	      support: 'YAAAAAAS',
	      oppose: 'Hellz No!',
	      support_sub: '',
	      oppose_sub: ''
	    }
	  },
	  HomepageHeader: rupaul_header,
	  NonHomepageHeader: rupaul_header
	};

	carcd_header = ReactiveComponent({
	  displayName: 'Carcd_header',
	  render: function() {
	    var homepage, loc;
	    loc = fetch('location');
	    homepage = loc.url === '/';
	    return DIV({
	      style: {
	        position: 'relative',
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto',
	        height: !homepage ? 180 : void 0
	      }
	    }, A({
	      href: 'http://carcd.consider.it',
	      target: '_blank',
	      style: {
	        position: 'absolute',
	        top: 20,
	        left: -48,
	        zIndex: 5
	      }
	    }, IMG({
	      src: asset('carcd/logo2.png'),
	      style: {
	        height: 145
	      }
	    })), DIV({
	      style: {
	        height: 82,
	        width: '100%',
	        position: 'relative',
	        top: 50,
	        left: 0
	      }
	    }, back_to_homepage_button({
	      display: 'block',
	      fontSize: 43,
	      visibility: homepage ? 'hidden' : void 0,
	      verticalAlign: 'top',
	      left: -91,
	      top: 10,
	      color: 'black',
	      position: 'relative'
	    })), homepage ? DIV({
	      style: {
	        paddingTop: 82,
	        width: HOMEPAGE_WIDTH(),
	        paddingLeft: 70,
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        fontSize: 26,
	        fontWeight: 600,
	        color: '#7D9DB6'
	      }
	    }, "We need your feedback!"), DIV({
	      style: {
	        fontSize: 20,
	        marginBottom: 18
	      }
	    }, "This survey gives you a chance to influence the CARCD strategic plan and \nour priorities for the next several years.  Please take the time to \nrespond to the questions below – elaborate, argue, tell us what you \nreally think!"), DIV({
	      style: {
	        fontSize: 20,
	        marginBottom: 6
	      }
	    }, "Thank you for your time,", BR(null), "The CARCD team")) : void 0, DIV({
	      style: {
	        position: 'absolute',
	        top: 18,
	        right: 0,
	        width: 110
	      }
	    }, ProfileMenu()));
	  }
	});

	customizations['carcd'] = customizations['carcd-demo'] = {
	  show_proposer_icon: false,
	  proposal_filters: false,
	  point_labels: pro_con,
	  slider_pole_labels: priority,
	  show_slider_feedback: false,
	  "cluster/Serving Districts": {
	    point_labels: {
	      pro: 'argument for depth',
	      pros: 'Arguments for Depth',
	      con: 'argument for breadth',
	      cons: 'Arguments for Breadth',
	      your_header: "Your --valences--",
	      other_header: "--valences--",
	      top_header: "Top --valences--"
	    },
	    slider_pole_labels: {
	      individual: {
	        support: 'High impact districts',
	        oppose: 'All districts',
	        support_sub: '',
	        oppose_sub: ''
	      },
	      group: {
	        support: 'High impact districts',
	        oppose: 'All districts',
	        support_sub: '',
	        oppose_sub: ''
	      }
	    },
	    description: function() {
	      return DIV({
	        style: {
	          fontSize: 18,
	          fontWeight: 400,
	          position: 'relative',
	          top: 12,
	          padding: 4,
	          fontStyle: 'italic',
	          color: '#888'
	        }
	      }, "Serve districts equally, or should it deeply focus more of its efforts on those districts with the capacity?");
	    },
	    show_slider_feedback: false
	  },
	  "cluster/Accreditation": {
	    slider_pole_labels: priority,
	    description: function() {
	      return DIV({
	        style: {
	          fontSize: 18,
	          fontWeight: 500,
	          position: 'relative',
	          top: 12,
	          padding: 4,
	          fontStyle: 'italic',
	          color: '#888'
	        }
	      }, "How much should CARCD actively push districts to embrace and meet the Vision and Standards expectations? ");
	    },
	    show_slider_feedback: false
	  },
	  "cluster/Program Emphasis": {
	    point_labels: pro_con,
	    slider_pole_labels: priority,
	    show_slider_feedback: false,
	    description: function() {
	      return DIV({
	        style: {
	          fontSize: 18,
	          fontWeight: 500,
	          position: 'relative',
	          top: 12,
	          padding: 4,
	          fontStyle: 'italic',
	          color: '#888'
	        }
	      }, "Rank the priority of each of program option. Remember, to emphasize everything is to emphasize nothing.");
	    }
	  },
	  "cluster/Lagging Districts": {
	    point_labels: pro_con,
	    slider_pole_labels: agree_disagree,
	    show_slider_feedback: false,
	    description: function() {
	      return DIV({
	        style: {
	          fontSize: 18,
	          fontWeight: 500,
	          position: 'relative',
	          top: 12,
	          padding: 4,
	          fontStyle: 'italic',
	          color: '#888'
	        }
	      }, "Parts of the state lack effective, sustainable districts. What should CARCD's response be?");
	    }
	  },
	  "cluster/Questions": {
	    point_labels: pro_con,
	    slider_pole_labels: important_unimportant,
	    show_slider_feedback: false
	  },
	  HomepageHeader: carcd_header,
	  NonHomepageHeader: carcd_header
	};

	customizations['consider'] = {
	  proposal_filters: false,
	  opinion_filters: false,
	  "cluster/Bug Reports": {
	    slider_pole_labels: relevance,
	    show_slider_feedback: false,
	    discussion: false,
	    description: function() {
	      return DIV({
	        style: {
	          fontSize: 18,
	          fontWeight: 500,
	          position: 'relative',
	          top: 12,
	          padding: 4,
	          fontStyle: 'italic',
	          color: '#888'
	        }
	      }, "Describe bugs you've encountered. Please include your browser and device!");
	    }
	  },
	  "cluster/Hard Tasks": {
	    slider_pole_labels: important_unimportant,
	    show_slider_feedback: false,
	    description: function() {
	      return DIV({
	        style: {
	          fontSize: 18,
	          fontWeight: 500,
	          position: 'relative',
	          top: 12,
	          padding: 4,
	          fontStyle: 'italic',
	          color: '#888'
	        }
	      }, "What tasks should we make significantly easier?");
	    }
	  },
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var HEADER_HEIGHT;
	      HEADER_HEIGHT = 30;
	      return DIV({
	        style: {
	          position: "relative",
	          margin: "0 auto",
	          backgroundColor: logo_red,
	          height: HEADER_HEIGHT,
	          zIndex: 1
	        }
	      }, DIV({
	        style: {
	          width: CONTENT_WIDTH(),
	          margin: 'auto'
	        }
	      }, SPAN({
	        style: {
	          position: "relative",
	          top: 4,
	          left: window.innerWidth > 1055 ? -23.5 : 0
	        }
	      }, drawLogo(HEADER_HEIGHT + 5, 'white', (this.local.in_red ? 'transparent' : logo_red), !this.local.in_red, false)), SPAN({
	        style: {
	          fontSize: 22,
	          position: 'relative',
	          top: -5,
	          color: 'white',
	          fontStyle: 'italic'
	        }
	      }, 'Issue Slate')));
	    }
	  })
	};

	customizations['us'] = {
	  show_proposer_icon: true
	};

	customizations['cimsec'] = {
	  slider_pole_labels: effective_ineffective
	};

	customizations['tunisia'] = {
	  proposal_filters: false,
	  show_meta: false,
	  lang: 'tun_ar',
	  slider_pole_labels: {
	    individual: {
	      support: 'أوافق',
	      oppose: 'أخالف'
	    },
	    group: {
	      support: 'أوافق',
	      oppose: 'أخالف'
	    }
	  },
	  homie_histo_title: 'الآراء',
	  point_labels: {
	    pro: 'نقطة إجابية',
	    pros: 'نقاط إجابية',
	    con: 'نقطة سلبية',
	    cons: 'نقاط سلبية',
	    your_header: "--valences-- أبد",
	    other_header: "--valences--  أخرى",
	    top_header: "--valences--  الرئيسية"
	  }
	};

	portuguese = ['sintaj', 'delegados_sintaj'];

	for (i = 0, len = portuguese.length; i < len; i++) {
	  port = portuguese[i];
	  customizations[port] = {
	    lang: 'ptbr',
	    point_labels: port_pros_cons,
	    slider_pole_labels: port_agree_disagree,
	    homie_histo_title: "Opiniões",
	    show_slider_feedback: false,
	    proposal_filters: false
	  };
	}

	spanish = ['alcala', 'villagb', 'citysens', 'iniciativasciudadanas', 'movilidadcdmx', 'zonaq', 'valenciaencomu', 'aguademayo', 'eparticipa', 'theartofco'];

	for (j = 0, len1 = spanish.length; j < len1; j++) {
	  spa = spanish[j];
	  customizations[spa] = {
	    lang: 'spa',
	    point_labels: pros_contras,
	    slider_pole_labels: desacuerdo_acuerdo,
	    homie_histo_title: "Opiniones",
	    show_slider_feedback: false,
	    proposal_filters: false
	  };
	}

	customizations['alcala'] = _.extend({}, customizations['alcala'], {
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var subdomain;
	      subdomain = fetch('/subdomain');
	      return DIV({
	        style: {
	          position: 'relative'
	        }
	      }, IMG({
	        style: {
	          width: '100%',
	          display: 'block'
	        },
	        src: subdomain.branding.masthead
	      }), ProfileMenu(), DIV({
	        style: {
	          padding: '20px 0'
	        }
	      }, DIV({
	        style: {
	          width: HOMEPAGE_WIDTH(),
	          margin: 'auto'
	        }
	      })));
	    }
	  })
	});

	monitorinstitute_red = "#BE0712";

	customizations['monitorinstitute'] = {
	  point_labels: strengths_improvements,
	  slider_pole_labels: strong_weak,
	  homie_histo_title: "Opinions",
	  show_slider_feedback: false,
	  NonHomepageHeader: ReactiveComponent({
	    displayName: 'NonHomepageHeader',
	    render: function() {
	      var section_style;
	      section_style = {
	        padding: '8px 0',
	        fontSize: 16
	      };
	      return DIV({
	        style: {
	          position: 'relative',
	          width: BODY_WIDTH(),
	          paddingTop: 20,
	          margin: '0 auto 15px auto'
	        }
	      }, back_to_homepage_button({
	        fontSize: 43,
	        position: 'absolute',
	        marginRight: 30,
	        left: -60,
	        top: 3
	      }), A({
	        href: 'http://monitorinstitute.com/',
	        target: '_blank',
	        style: {
	          display: 'inline-block'
	        }
	      }, IMG({
	        src: asset("monitorinstitute/logo.jpg")
	      })), DIV({
	        style: {
	          position: 'absolute',
	          right: -70,
	          top: 0,
	          width: 200
	        }
	      }, ProfileMenu()));
	    }
	  }),
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var section_style;
	      section_style = {
	        padding: '8px 0',
	        fontSize: 16
	      };
	      return DIV({
	        style: {
	          position: 'relative'
	        }
	      }, DIV({
	        style: {
	          width: CONTENT_WIDTH(),
	          margin: 'auto',
	          paddingTop: 20,
	          position: 'relative'
	        }
	      }, A({
	        href: 'http://monitorinstitute.com/',
	        target: '_blank'
	      }, IMG({
	        src: asset("monitorinstitute/logo.jpg")
	      })), ProfileMenu(), DIV({
	        style: {}
	      }, DIV({
	        style: {
	          color: monitorinstitute_red,
	          fontSize: 34,
	          marginTop: 40
	        }
	      }, "The Monitor Institute intellectual agenda"), DIV({
	        style: {
	          fontStyle: 'italic',
	          marginBottom: 20
	        }
	      }, 'Spring 2015'), DIV({
	        style: {
	          width: CONTENT_WIDTH() * .7,
	          borderRight: "1px solid #ddd",
	          display: 'inline-block',
	          paddingRight: 25
	        }
	      }, P({
	        style: section_style
	      }, "Central to the Monitor Institute brand is the idea that we pursue \n“next practice” in social impact. We do not simply master and teach \nwell‐established best practices, but treat those as table stakes and \nfocus our attention on the learning edges for the field. Our core \nexpertise is in helping social impact leaders and organizations \ndevelop the skillsets they need to achieve greater progress than \nin the past and prepare themselves for tomorrow’s context."), P({
	        style: section_style
	      }, "This document is a place for us to articulate two things: ", SPAN({
	        style: {
	          fontStyle: 'italic'
	        }
	      }, "what we believe"), " to be “next practice” today, and what ", SPAN({
	        style: {
	          fontStyle: 'italic'
	        }
	      }, "what we want to know"), " about how those practices can and will develop further. The former is our \npoint of view; the latter is the whitespace that is waiting to be \nfilled in over the coming three to five years."), P({
	        style: section_style
	      }, "It is designed to be used in a variety of ways:"), UL({
	        style: {
	          listStylePosition: 'outside',
	          paddingLeft: 30
	        }
	      }, LI({
	        style: section_style
	      }, "It is primarily a ", SPAN({
	        style: {
	          fontWeight: 600
	        }
	      }, "statement of strategy and vision"), ". It does not contain \nevery next practice in the world, nor every important question to be \nresolved, but only the ones that we believe are both (a) the most \ntransformative in the field of social impact and (b) those that we are \nequipped and committed to working on. It must therefore be a living document, \nrevisited and revised often enough that it always reflects our most \nup‐to‐date perspectives."), LI({
	        style: section_style
	      }, "Next, it is a ", SPAN({
	        style: {
	          fontWeight: 600
	        }
	      }, "rubric for making choices"), " that will keep us aligned and focused. \nWe will know we are doing well as a next‐practice consulting team when our \nmix of commercial and eminence work promotes the points of view described \nunder ", SPAN({
	        style: {
	          fontStyle: 'italic'
	        }
	      }, "what we believe"), " and helps us answer the questions listed under ", SPAN({
	        style: {
	          fontStyle: 'italic'
	        }
	      }, "what we want to know"), ". When there is a question as to whether we should pursue an \nopportunity that arrives or choose to focus resources in a given direction, \nwe can check our judgment by asking whether it will help us do either or both \nof those things. That is equally true for scanning, for relationship‐building \nand sales, for eminence projects, and for commercial work."))), DIV({
	        style: {
	          display: 'inline-block',
	          width: CONTENT_WIDTH() * .25,
	          verticalAlign: 'top',
	          marginTop: 200,
	          paddingLeft: 25,
	          color: monitorinstitute_red,
	          fontWeight: 600
	        }
	      }, "This is the intro to the draft intellectual agenda. Please provide \nfeedback on each proposed intellectual agenda item below."))));
	    }
	  })
	};

	hala_teal = "#0FB09A";

	hala_orange = '#FBAF3B';

	hala_magenta = '#CB2A5C';

	hala_gray = '#666';

	hala_brown = '#A77C53';

	hala_section_heading = {
	  fontSize: 42,
	  fontWeight: 300,
	  color: hala_teal,
	  marginBottom: 5
	};

	hala_section_description = {
	  fontSize: 18,
	  fontWeight: 400,
	  color: hala_gray
	};

	hala_section_call_to_action = {
	  fontSize: 18,
	  width: HOMEPAGE_WIDTH,
	  marginBottom: 20,
	  color: hala_gray
	};

	hala_proposal_style = {
	  borderBottom: "1px solid #ddd"
	};

	customizations['hala'] = {
	  point_labels: pro_con,
	  slider_pole_labels: agree_disagree,
	  homie_histo_title: "Opinions",
	  show_proposer_icon: false,
	  show_meta: false,
	  civility_pledge: true,
	  show_score: true,
	  proposal_filters: false,
	  proposal_style: hala_proposal_style,
	  uncollapseable: true,
	  opinion_filters: [
	    {
	      label: 'focus group',
	      tooltip: null,
	      pass: function(user) {
	        return passes_tags(user, 'hala_focus_group');
	      }
	    }
	  ],
	  "cluster/Transportation": {
	    homepage_label: 'Transportation proposal'
	  },
	  "cluster/Urban Village Expansion Areas": {
	    homepage_label: 'Proposals',
	    description: function() {
	      return DIV({
	        style: {
	          width: HOMEPAGE_WIDTH()
	        }
	      }, DIV({
	        style: hala_section_heading
	      }, "Urban Village Expansion Areas"), DIV({
	        style: hala_section_description
	      }, "Urban Villages are areas where Seattleites have decided growth is most appropriate. Some of \nthese boundaries may be expanded to take advantage of the high density of amenities that \ncurrently exist in those areas.", DIV({
	        style: {
	          marginTop: 10
	        }
	      }, "What do you think of the following proposals?")));
	    }
	  },
	  "cluster/Historic Areas and Unique Conditions": {
	    homepage_label: 'Proposals',
	    description: function() {
	      return DIV({
	        style: {
	          width: HOMEPAGE_WIDTH()
	        }
	      }, DIV({
	        style: hala_section_heading
	      }, "Historic Areas and Unique Conditions"), DIV({
	        style: hala_section_description
	      }, "Seattle has many historic areas, some on the National Register and some known to locals as \nplaces of historic or cultural significance. These areas can be tricky sites for new buildings \nand often require costly planning, design and construction.", DIV({
	        style: {
	          marginTop: 10
	        }
	      }, "What do you think of the following proposals?")));
	    }
	  },
	  "cluster/Minimize Displacement": {
	    homepage_label: 'Displacement proposal',
	    description: function() {
	      return DIV({
	        style: {
	          width: HOMEPAGE_WIDTH()
	        }
	      }, DIV({
	        style: hala_section_heading
	      }, "Minimize Displacement"), DIV({
	        style: hala_section_description
	      }, "Displacement is happening throughout Seattle, and particular communities \nare at high risk of displacement. Data analysis and community outreach will \nhelp identify how growth may benefit or burden certain populations. We will \nuse that data to make sure our strategies are reaching the communities most \nin need.", DIV({
	        style: {
	          marginTop: 10
	        }
	      }, "What do you think of the following proposal?")));
	    }
	  },
	  "cluster/Fair Chance Housing": {
	    homepage_label: 'Proposals',
	    description: function() {
	      return DIV({
	        style: {
	          width: HOMEPAGE_WIDTH()
	        }
	      }, DIV({
	        style: hala_section_heading
	      }, "Fair Chance Housing legislation"), DIV({
	        style: hala_section_description
	      }, "Fair Chance Housing legislation is aimed at increasing access to Housing for \nPeople with Criminal History. \nAn estimated one in every three adults in the United States has a criminal \nrecord, and nearly half of all children in the U.S. have one parent with a \ncriminal record. Due to a rise in the use of criminal background checks during \nthe tenant screening process, people with arrest and conviction records face \nmajor barriers to housing. Fair Chance Housing legislation could lessen some of \nthe barriers people face.", DIV({
	        style: {
	          marginTop: 10
	        }
	      }, "What do you think of the following proposals?")));
	    }
	  },
	  "cluster/Housing Options and Community Assets": {
	    homepage_label: 'MHA Principles',
	    description: function() {
	      return DIV({
	        style: {
	          width: HOMEPAGE_WIDTH()
	        }
	      }, DIV({
	        style: _.extend({}, hala_section_heading, {
	          color: hala_brown,
	          fontSize: 42,
	          fontWeight: 400
	        })
	      }, SPAN({
	        style: {
	          borderBottom: "1px solid " + hala_brown,
	          color: hala_brown
	        }
	      }, "Mandatory Housing Affordability ", SPAN({
	        style: {
	          fontStyle: 'italic'
	        }
	      }, "Principles"))), DIV({
	        style: hala_section_description
	      }, "Mandatory Housing Affordability (MHA) would require all new commercial and multifamily development either to \ninclude affordable housing on site or make an in-lieu payment for affordable \nhousing using a State-approved approach. In exchange for the new affordable \nhousing requirement, additional development capacity will be granted in \nthe form of zoning changes. A community input process will help inform details \nand location of the zoning changes to implement MHA. The MHA program is a \ncornerstone of the ", A({
	        href: 'http://www.seattle.gov/hala/about',
	        target: '_blank',
	        style: {
	          color: hala_teal,
	          textDecoration: 'underline'
	        }
	      }, 'Grand Bargain'), " and is essential to achieving affordable \nhousing goals of 6,000 new affordable units over ten years. "), DIV({
	        style: _.extend({}, hala_section_description, {
	          fontStyle: 'italic',
	          marginTop: 20
	        })
	      }, "The questions below assume that zoning changes will take place to fully implement MHA.  \nWe are asking for input on how those zoning changes will look and feel.  These questions \nare intended to get at the values that should drive these zoning changes.  What are the \nimportant principles for us to keep in mind when we propose zoning changes in the next few months? \nBear in mind, the following elements are only a portion of the MHA. We will continue adding \npieces as they become available."), DIV({
	        style: _.extend({}, hala_section_heading, {
	          marginTop: 20
	        })
	      }, "Housing Options and Community Assets"), DIV({
	        style: hala_section_description
	      }, "What do you think of the following principles?"));
	    }
	  },
	  "cluster/Transitions": {
	    homepage_label: 'MHA Principles',
	    description: function() {
	      return DIV({
	        style: {
	          width: HOMEPAGE_WIDTH()
	        }
	      }, DIV({
	        style: hala_section_heading
	      }, "Transitions"), DIV({
	        style: hala_section_description
	      }, "When taller buildings are constructed in areas that are zoned for more density, \nneighboring buildings that are smaller sometimes feel out of place. Zoning \nregulations can plan for transitions between higher- and lower-scale zones as \nSeattle grows and accommodates new residents and growing families.", DIV({
	        style: {
	          marginTop: 10
	        }
	      }, "What do you think of the following principles?")));
	    }
	  },
	  "cluster/Urban Design Quality": {
	    homepage_label: 'MHA Principles',
	    description: function() {
	      return DIV({
	        style: {
	          width: HOMEPAGE_WIDTH()
	        }
	      }, DIV({
	        style: hala_section_heading
	      }, "Urban Design Quality"), DIV({
	        style: hala_section_description
	      }, "As Seattle builds new housing, we want to know what design features are \nimportant to you. These elements address quality of life with design choices \nfor new residential buildings and landscaping.", DIV({
	        style: {
	          marginTop: 10
	        }
	      }, "What do you think of the following principles?")));
	    }
	  },
	  auth: {
	    user_questions: [
	      {
	        tag: 'zip.editable',
	        question: 'The zipcode where I live is',
	        input: 'text',
	        required: false,
	        input_style: {
	          width: 85
	        },
	        validation: function(zip) {
	          return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
	        }
	      }, {
	        tag: 'age.editable',
	        question: 'My age is',
	        input: 'text',
	        input_style: {
	          width: 85
	        },
	        required: false
	      }, {
	        tag: 'race.editable',
	        question: 'My race is',
	        input: 'text',
	        required: false
	      }, {
	        tag: 'home.editable',
	        question: "My home is",
	        input: 'dropdown',
	        options: ['Rented', 'Owned by me', 'Other'],
	        required: false
	      }, {
	        tag: 'housing_type.editable',
	        question: "I live in",
	        input: 'dropdown',
	        options: ['A house or townhome', 'An apartment or condo', 'A single room', 'I\'m homeless'],
	        required: false
	      }
	    ]
	  },
	  additional_auth_footer: function() {
	    var auth, ref;
	    auth = fetch('auth');
	    if (auth.ask_questions && ((ref = auth.form) === 'create account' || ref === 'create account via invitation' || ref === 'user questions')) {
	      return DIV({
	        style: {
	          fontSize: 13,
	          color: auth_text_gray,
	          padding: '16px 0'
	        }
	      }, "We are collecting this information to find out if this tool is \ntruly reaching the diverse population that reflects our city. Thank you!");
	    } else {
	      return SPAN(null, '');
	    }
	  },
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var header_style, paragraph_heading_style, paragraph_style, section_style;
	      header_style = {
	        color: hala_brown,
	        fontSize: 44,
	        marginTop: 10
	      };
	      section_style = {
	        marginBottom: 20,
	        color: 'black'
	      };
	      paragraph_heading_style = {
	        display: 'block',
	        fontWeight: 400,
	        fontSize: 28,
	        color: hala_brown
	      };
	      paragraph_style = {
	        fontSize: 18,
	        color: hala_gray,
	        paddingTop: 10,
	        display: 'block'
	      };
	      return DIV({
	        style: {
	          position: 'relative'
	        }
	      }, A({
	        href: 'http://seattle.gov/hala',
	        target: '_blank',
	        style: {
	          display: 'block',
	          position: 'absolute',
	          top: 22,
	          left: 20,
	          color: "#0B4D92"
	        }
	      }, I({
	        className: 'fa fa-chevron-left',
	        style: {
	          display: 'inline-block',
	          marginRight: 5
	        }
	      }), 'seattle.gov/hala'), IMG({
	        style: {
	          width: '100%',
	          display: 'block'
	        },
	        src: asset('hala/hala-header.png')
	      }), ProfileMenu(), DIV({
	        style: {
	          borderTop: "7px solid " + hala_teal,
	          padding: '20px 0'
	        }
	      }, DIV({
	        style: {
	          width: HOMEPAGE_WIDTH(),
	          margin: 'auto'
	        }
	      }, DIV({
	        style: _.extend({}, section_style, {
	          color: hala_gray
	        })
	      }, DIV({
	        style: _.extend({}, paragraph_style, {
	          fontStyle: 'italic',
	          margin: 'auto',
	          padding: "40px 40px"
	        })
	      }, "“We are facing our worst housing affordability crisis in decades. My vision is a city where \npeople who work in Seattle can afford to live here…We all share a responsibility in making Seattle \naffordable. Together, HALA will take us there.”", DIV({
	        style: _.extend({}, paragraph_style, {
	          paddingLeft: '70%'
	        })
	      }, "– Mayor Ed Murray"))), DIV({
	        style: section_style
	      }, SPAN({
	        style: paragraph_heading_style
	      }, "Your thoughts on the Housing Affordability and Livability Agenda (HALA) are key to securing quality, \naffordable housing for Seattle for many years to come"), SPAN({
	        style: paragraph_style
	      }, "HALA addresses Seattle's housing affordability crisis on many fronts. As we take proposals from idea \nto practice, we have been listening to the community to find out what matters to you. This online \nconversation reflects the variety of what many of the ideas we've heard thus far and will continue \nto provide with meaningful ideas on how to move forward.")), DIV({
	        style: section_style
	      }, SPAN({
	        style: paragraph_heading_style
	      }, 'We need your ideas to get HALA right'), SPAN({
	        style: paragraph_style
	      }, "We have listed many key recommendations below. This is an opportunity for you to shape the recommendations \nbefore they are finalized.", SPAN({
	        style: {
	          color: 'black',
	          fontWeight: 600
	        }
	      }, " We are committed to using your feedback in a constructive way and will report back on how we use it."), " Please add your opinion below."), SPAN({
	        style: paragraph_style
	      }, "As the year progresses, we will be looking at other new programs, so check back often to weigh in on them.")), DIV({
	        style: {
	          marginTop: 20,
	          fontSize: 18
	        }
	      }, DIV({
	        style: {
	          marginBottom: 18
	        }
	      }, "Thanks for your time,"), A({
	        href: 'http://www.seattle.gov/dpd/cityplanning/default.htm',
	        target: '_blank',
	        style: {
	          display: 'block',
	          marginBottom: 8
	        }
	      }, IMG({
	        src: asset('hala/Seattle-Logo-and-signature2.jpg'),
	        style: {
	          height: 70
	        }
	      })), DIV({
	        style: _.extend({}, section_style, {
	          margin: 0,
	          marginTop: 10,
	          fontSize: 18
	        })
	      }, 'p.s. Email us at ', A({
	        href: "mailto:halainfo@seattle.gov",
	        style: {
	          textDecoration: 'underline'
	        }
	      }, "halainfo@seattle.gov"), ' or visit our website at ', A({
	        href: "http://seattle.gov/HALA",
	        style: {
	          textDecoration: 'underline'
	        }
	      }, "seattle.gov/HALA"), ' if you want to know more.')))));
	    }
	  })
	};

	seattle2035_cream = "#FCFBE6";

	seattle2035_pink = '#F06668';

	seattle2035_dark = '#5C1517';

	customizations['seattle2035'] = {
	  point_labels: pro_con,
	  slider_pole_labels: agree_disagree,
	  homie_histo_title: "Opinions",
	  show_proposer_icon: true,
	  civility_pledge: true,
	  "cluster/Overall": {
	    point_labels: strengths_weaknesses,
	    slider_pole_labels: yes_no,
	    show_slider_feedback: false
	  },
	  auth: {
	    user_questions: [
	      {
	        tag: 'zip.editable',
	        question: 'The zipcode where I live is',
	        input: 'text',
	        required: false,
	        input_style: {
	          width: 85
	        },
	        validation: function(zip) {
	          return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
	        }
	      }, {
	        tag: 'age.editable',
	        question: 'My age is',
	        input: 'text',
	        input_style: {
	          width: 85
	        },
	        required: false
	      }, {
	        tag: 'race.editable',
	        question: 'My race is',
	        input: 'text',
	        required: false
	      }, {
	        tag: 'hispanic.editable',
	        question: "I'm of Hispanic origin",
	        input: 'dropdown',
	        options: ['No', 'Yes'],
	        required: false
	      }, {
	        tag: 'gender.editable',
	        question: "My gender is",
	        input: 'dropdown',
	        options: ['Female', 'Male', 'Transgender', 'Other'],
	        required: false
	      }, {
	        tag: 'home.editable',
	        question: "My home is",
	        input: 'dropdown',
	        options: ['Rented', 'Owned by me', 'Other'],
	        required: false
	      }
	    ]
	  },
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var header_style, paragraph_heading_style, paragraph_style, section_style;
	      header_style = {
	        color: seattle2035_pink,
	        fontSize: 44,
	        marginTop: 10
	      };
	      section_style = {
	        marginBottom: 20,
	        color: seattle2035_dark
	      };
	      paragraph_heading_style = {
	        display: 'block',
	        fontSize: 28,
	        color: seattle2035_pink
	      };
	      paragraph_style = {
	        fontSize: 18
	      };
	      return DIV({
	        style: {
	          position: 'relative'
	        }
	      }, A({
	        href: 'http://2035.seattle.gov/',
	        target: '_blank',
	        style: {
	          display: 'block',
	          position: 'absolute',
	          top: 22,
	          left: 20,
	          color: seattle2035_pink
	        }
	      }, I({
	        className: 'fa fa-chevron-left',
	        style: {
	          display: 'inline-block',
	          marginRight: 5
	        }
	      }), '2035.seattle.gov'), IMG({
	        style: {
	          width: '100%',
	          display: 'block',
	          paddingTop: 50
	        },
	        src: asset('seattle2035/banner.png')
	      }), ProfileMenu(), DIV({
	        style: {
	          borderTop: "5px solid " + seattle2035_pink,
	          padding: '20px 0'
	        }
	      }, DIV({
	        style: {
	          width: HOMEPAGE_WIDTH(),
	          margin: 'auto'
	        }
	      }, DIV({
	        style: header_style
	      }, 'Let’s talk about how Seattle is changing'), DIV({
	        style: section_style
	      }, SPAN({
	        style: paragraph_style
	      }, "Seattle is one of the fastest growing cities in America, expecting to add \n120,000 people and 115,000 jobs by 2035. We must plan for how \nand where that growth occurs.")), DIV({
	        style: section_style
	      }, SPAN({
	        style: paragraph_heading_style
	      }, 'The Seattle 2035 draft plan addresses Seattle’s growth'), SPAN({
	        style: paragraph_style
	      }, 'We are pleased to present a ', A({
	        target: '_blank',
	        href: 'http://2035.seattle.gov',
	        style: {
	          textDecoration: 'underline'
	        }
	      }, 'Draft Plan'), " for public discussion. The Draft Plan contains hundreds of \npolicies that guide decisions about our city, including \nKey Proposals for addressing growth and change. \nThese Key Proposals have emerged from conversations among \nCity agencies and through ", A({
	        target: '_blank',
	        href: 'http://www.seattle.gov/dpd/cs/groups/pan/@pan/documents/web_informational/p2262500.pdf',
	        style: {
	          textDecoration: 'underline'
	        }
	      }, 'public input'), '.')), DIV({
	        style: section_style
	      }, SPAN({
	        style: paragraph_heading_style
	      }, 'We need your feedback on the Key Proposals in the Draft Plan'), SPAN({
	        style: paragraph_style
	      }, "We have listed below some Key Proposals in the draft.\nDo these Key Proposals make sense for Seattle over the coming twenty years? \nPlease tell us by adding your opinion below. Your input will influence \nthe Mayor’s Recommended Plan, ", A({
	        target: '_blank',
	        href: 'http://2035.seattle.gov/about/faqs/#how-long',
	        style: {
	          textDecoration: 'underline'
	        }
	      }, 'coming in 2016 '), '!')), DIV({
	        style: {
	          marginTop: 20,
	          fontSize: 18,
	          color: seattle2035_dark
	        }
	      }, DIV({
	        style: {
	          marginBottom: 18
	        }
	      }, "Thanks for your time,"), A({
	        href: 'http://www.seattle.gov/dpd/cityplanning/default.htm',
	        target: '_blank',
	        style: {
	          display: 'block',
	          marginBottom: 8
	        }
	      }, IMG({
	        src: asset('seattle2035/DPD Logo.svg'),
	        style: {
	          height: 70
	        }
	      })), DIV({
	        style: _.extend({}, section_style, {
	          margin: 0,
	          marginTop: 10,
	          fontSize: 18
	        })
	      }, 'p.s. Email us at ', A({
	        href: "mailto:2035@seattle.gov",
	        style: {
	          textDecoration: 'underline'
	        }
	      }, "2035@seattle.gov"), " if you would like us to add another Key Proposal below for \ndiscussion or you have a comment about another issue in the Draft Plan."), DIV({
	        style: {
	          marginTop: 40,
	          backgroundColor: seattle2035_pink,
	          color: 'white',
	          fontSize: 28,
	          textAlign: 'center',
	          padding: "30px 42px"
	        }
	      }, "The comment period is now closed. Thank you for your input!")))));
	    }
	  })
	};

	FoodcorpsHeader = ReactiveComponent({
	  displayName: 'FoodcorpsHeader',
	  render: function() {
	    var homepage, loc;
	    loc = fetch('location');
	    homepage = loc.url === '/';
	    return DIV({
	      style: {
	        position: 'relative',
	        height: 200
	      }
	    }, IMG({
	      src: asset('foodcorps/logo.png'),
	      style: {
	        height: 160,
	        position: 'absolute',
	        top: 10,
	        left: (WINDOW_WIDTH() - CONTENT_WIDTH()) / 2,
	        zIndex: 5
	      }
	    }), DIV({
	      style: {
	        background: "url(" + (asset('foodcorps/bg.gif')) + ") repeat-x",
	        height: 68,
	        width: '100%',
	        position: 'relative',
	        top: 116,
	        left: 0
	      }
	    }), back_to_homepage_button({
	      display: 'inline-block',
	      fontSize: 43,
	      visibility: homepage ? 'hidden' : void 0,
	      verticalAlign: 'top',
	      marginTop: 52,
	      marginLeft: 15,
	      color: 'white',
	      zIndex: 10,
	      position: 'relative'
	    }), DIV({
	      style: {
	        position: 'absolute',
	        top: 18,
	        right: 0,
	        width: 110
	      }
	    }, ProfileMenu()));
	  }
	});

	customizations['foodcorps'] = {
	  point_labels: strengths_weaknesses,
	  slider_pole_labels: ready_not_ready,
	  show_slider_feedback: false,
	  HomepageHeader: FoodcorpsHeader,
	  NonHomepageHeader: FoodcorpsHeader
	};

	customizations['sosh'] = {
	  point_labels: strengths_weaknesses,
	  slider_pole_labels: yes_no,
	  show_slider_feedback: false
	};

	customizations['schools'] = {
	  homie_histo_title: "Students' opinions",
	  slider_pole_labels: agree_disagree
	};

	customizations['allsides'] = {
	  'cluster/Classroom Discussions': {
	    homie_histo_title: "Students' opinions"
	  },
	  'cluster/Civics': {
	    homie_histo_title: "Citizens' opinions"
	  },
	  show_crafting_page_first: true,
	  show_histogram_on_crafting: false,
	  has_homepage: false,
	  homepage_heading_columns: [
	    {
	      heading: 'Questions',
	      details: null
	    }, {
	      heading: null
	    }, {
	      heading: 'Community',
	      details: null
	    }, {
	      heading: '',
	      details: ''
	    }
	  ]
	};

	essential_questions = {
	  homie_histo_title: "Student responses",
	  slider_pole_labels: agree_disagree,
	  point_labels: challenge_justify
	};

	monuments = {
	  point_labels: strengths_weaknesses,
	  slider_pole_labels: ready_not_ready,
	  homie_histo_title: "Students' feedback"
	};

	customizations['humanities-los'] = {
	  show_slider_feedback: false,
	  point_labels: strengths_weaknesses,
	  slider_pole_labels: yes_no,
	  homie_histo_title: "Students' feedback",
	  "cluster/Essential Questions 8-2": essential_questions,
	  "cluster/Essential Questions 8-1": essential_questions,
	  "cluster/Monuments 8-2": monuments,
	  "cluster/Monuments 8-1": monuments
	};

	customizations['collective'] = {
	  show_meta: false,
	  proposal_filters: false,
	  "/cluster/Contributions": {
	    slider_pole_labels: important_unimportant
	  },
	  "/cluster/Licenses": {
	    slider_pole_labels: yes_no
	  }
	};

	customizations['anup2015'] = conference_config;

	customizations['random2015'] = _.extend({}, conference_config, {
	  opinion_value: function(o) {
	    return 3 * o.stance;
	  },
	  "/proposal/2638": {
	    point_labels: strengths_limitations,
	    slider_pole_labels: yes_no
	  },
	  "/proposal/2639": {
	    point_labels: strengths_weaknesses,
	    slider_pole_labels: yes_no
	  }
	});

	customizations['program-committee-demo'] = conference_config;

	window.paper_scores = function(paper) {
	  var field, l, len2, opinion_vals, opinion_value, opinions, ref, reviews, score, scores, stats;
	  stats = function(vals) {
	    var avg, diff, diffs, l, len2, len3, m, o, stddev, sum;
	    sum = 0;
	    for (l = 0, len2 = vals.length; l < len2; l++) {
	      o = vals[l];
	      sum += o;
	    }
	    avg = sum / vals.length;
	    diffs = vals.map(function(o) {
	      return (o - avg) * (o - avg);
	    });
	    sum = 0;
	    for (m = 0, len3 = diffs.length; m < len3; m++) {
	      diff = diffs[m];
	      sum += diff;
	    }
	    stddev = Math.sqrt(sum);
	    return {
	      cnt: vals.length,
	      avg: avg,
	      stddev: stddev
	    };
	  };
	  scores = {};
	  paper = fetch(paper);
	  opinions = fetch(paper).opinions;
	  opinion_value = customization("opinion_value", paper);
	  opinion_vals = opinions.map(function(o) {
	    return opinion_value(o);
	  });
	  scores.pc = stats(opinion_vals);
	  reviews = [];
	  ref = $.parseJSON(paper.description_fields);
	  for (l = 0, len2 = ref.length; l < len2; l++) {
	    field = ref[l];
	    if (!field.label.match(/Review/)) {
	      continue;
	    }
	    score = field.html.match(/Overall evaluation: ((-)?\d)/);
	    reviews.push(parseInt(score[1]));
	  }
	  scores.reviews = stats(reviews);
	  return scores;
	};

	customizations.ri = {
	  show_crafting_page_first: true,
	  slider_pole_labels: agree_disagree
	};

	customizations.enviroissues = {
	  show_crafting_page_first: true,
	  slider_pole_labels: agree_disagree,
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var homepage, loc;
	      loc = fetch('location');
	      homepage = loc.url === '/';
	      return DIV({
	        style: {
	          width: CONTENT_WIDTH(),
	          margin: '20px auto',
	          position: 'relative'
	        }
	      }, back_to_homepage_button({
	        display: 'inline-block',
	        fontSize: 43,
	        visibility: homepage ? 'hidden' : void 0,
	        verticalAlign: 'top',
	        marginTop: 22,
	        marginRight: 15,
	        color: '#888'
	      }), IMG({
	        src: asset('enviroissues/logo.png')
	      }), DIV({
	        style: {
	          position: 'absolute',
	          top: 18,
	          right: 0,
	          width: 110
	        }
	      }, ProfileMenu()));
	    }
	  })
	};

	customizations.enviroissues.NonHomepageHeader = customizations.enviroissues.HomepageHeader;

	ecast_highlight_color = "#73B3B9";

	customizations.ecastonline = customizations['ecast-demo'] = {
	  show_crafting_page_first: true,
	  slider_pole_labels: agree_disagree,
	  ProposalNavigation: ProposalNavigationWithMenu,
	  docking_proposal_header: true,
	  additional_auth_footer: function() {
	    var auth;
	    auth = fetch('fetch');
	    if (auth.ask_questions && auth.form !== 'edit profile') {
	      return DIV({
	        style: {
	          fontSize: 13,
	          color: auth_text_gray,
	          padding: '16px 0'
	        }
	      }, "The demographic data collected from participants in this project will be used for research purposes, for \nexample, to identify the demographic and other characteristics of the people who participated in the \ndeliberation.  This information can be used in analyzing the results of this online forum.  \nNo email addresses, demographic data, or personally-identifying information will be displayed to \nother visitors to this site.  Any comments you submit will be identified only by the display name \nyou enter below.  By completing this registration, you acknowledge that your participation in this \nproject is entirely voluntary and you agree that the data provided may be used for research. If you \nhave any questions or concerns at any time, please ", A({
	        href: 'mailto:info@ecastonline.org',
	        target: "_blank",
	        style: {
	          textDecoration: 'underline'
	        }
	      }, "Contact Us"), ".");
	    } else {
	      return SPAN(null, '');
	    }
	  },
	  auth: {
	    user_questions: [
	      {
	        tag: 'zip.editable',
	        question: 'My zip code is',
	        input: 'text',
	        required: true,
	        input_style: {
	          width: 85
	        },
	        validation: function(zip) {
	          return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
	        }
	      }, {
	        tag: 'gender.editable',
	        question: 'My gender is',
	        input: 'dropdown',
	        options: ['Male', 'Female'],
	        required: true
	      }, {
	        tag: 'age.editable',
	        question: 'My age is',
	        input: 'text',
	        required: true,
	        input_style: {
	          width: 50
	        },
	        validation: function(age) {
	          return /^[1-9]?[0-9]{1}$|^100$/.test(age);
	        }
	      }, {
	        tag: 'ethnicity.editable',
	        question: 'My ethnicity is',
	        input: 'dropdown',
	        options: ['African American', 'Asian', 'Latino/Hispanic', 'White', 'Other'],
	        required: true
	      }, {
	        tag: 'education.editable',
	        question: 'My formal education is',
	        input: 'dropdown',
	        options: ['Did not graduate from high school', 'Graduated from high school or equivalent', 'Attended, but did not graduate from college', 'College degree', 'Graduate professional degree'],
	        required: true
	      }
	    ]
	  },
	  homie_histo_title: "Citizens' opinions",
	  NonHomepageHeader: ReactiveComponent({
	    displayName: 'NonHomepageHeader',
	    render: function() {
	      return DIV({
	        style: {
	          backgroundColor: 'black',
	          width: '100%',
	          position: 'relative',
	          borderBottom: "2px solid " + ecast_highlight_color,
	          padding: "10px 0",
	          backgroundImage: "url(" + (asset('ecast/bg-small.png')) + ")",
	          height: 94
	        }
	      }, A({
	        href: "http://ecastonline.org/",
	        target: '_blank'
	      }, IMG({
	        style: {
	          height: 75,
	          position: 'absolute',
	          left: 50,
	          top: 10
	        },
	        src: asset('ecast/ecast-small.png')
	      })), A({
	        style: {
	          fontSize: 30,
	          fontWeight: 600,
	          color: 'white',
	          textShadow: '0 2px 4px rgba(0,0,0,.5)',
	          position: 'relative',
	          top: 20,
	          left: 250
	        },
	        href: '/'
	      }, "Informing NASA's Asteroid Initiative"), DIV({
	        style: {
	          position: 'absolute',
	          right: 0,
	          top: 14,
	          width: 110
	        }
	      }, ProfileMenu()));
	    }
	  }),
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var paragraph_style;
	      paragraph_style = {
	        marginBottom: 20,
	        textShadow: '0 1px 1px rgba(255,255,255,.5)',
	        fontWeight: 600
	      };
	      return DIV({
	        style: {
	          backgroundColor: 'black',
	          height: 685,
	          overflow: 'hidden',
	          width: '100%',
	          position: 'relative',
	          borderBottom: "5px solid " + ecast_highlight_color
	        }
	      }, IMG({
	        style: {
	          position: 'absolute',
	          width: 1300
	        },
	        src: asset('ecast/bg-small.png')
	      }), DIV({
	        style: {
	          position: 'absolute',
	          left: 50,
	          top: 38
	        }
	      }, DIV({
	        style: {
	          fontSize: 42,
	          fontWeight: 600,
	          color: 'white',
	          textShadow: '0 2px 4px rgba(0,0,0,.5)'
	        }
	      }, A({
	        href: '/'
	      }, "Informing NASA's Asteroid Initiative")), DIV({
	        style: {
	          fontSize: 24,
	          fontWeight: 600,
	          color: 'white',
	          textAlign: 'center',
	          marginTop: -5
	        }
	      }, A({
	        href: '/'
	      }, "A Citizen Forum"))), DIV({
	        style: {
	          position: 'absolute',
	          top: 61,
	          left: 790
	        }
	      }, DIV({
	        style: {
	          fontSize: 18,
	          color: 'white'
	        }
	      }, 'hosted by'), A({
	        href: "http://ecastonline.org/",
	        target: '_blank'
	      }, IMG({
	        style: {
	          display: 'block',
	          marginTop: 4,
	          width: 215
	        },
	        src: asset('ecast/ecast-small.png')
	      }))), DIV({
	        style: {
	          position: 'absolute',
	          left: 434,
	          top: 609,
	          color: ecast_highlight_color,
	          fontSize: 17,
	          fontWeight: 600,
	          width: 325
	        }
	      }, I({
	        className: 'fa fa-film',
	        style: {
	          position: 'absolute',
	          left: -27,
	          top: 3
	        }
	      }), 'Learn more first! Watch this video from the public forums that ECAST hosted.', SPAN({
	        style: {
	          position: 'absolute',
	          top: 24,
	          right: -15
	        }
	      }, I({
	        className: 'fa fa-angle-right',
	        style: {
	          paddingLeft: 10
	        }
	      }), I({
	        className: 'fa fa-angle-right',
	        style: {
	          paddingLeft: 5
	        }
	      }), I({
	        className: 'fa fa-angle-right',
	        style: {
	          paddingLeft: 5
	        }
	      }))), IFRAME({
	        position: 'absolute',
	        type: "text/html",
	        width: 370,
	        height: 220,
	        src: "//www.youtube.com/embed/6yImAjIws9A?autoplay=0",
	        frameborder: 0,
	        style: {
	          top: 460,
	          left: 790,
	          zIndex: 99,
	          position: 'absolute',
	          border: "5px solid " + ecast_highlight_color,
	          borderBottom: 'none'
	        }
	      }), DIV({
	        style: {
	          fontSize: 17,
	          position: 'absolute',
	          top: 156,
	          left: 97,
	          width: 600
	        }
	      }, P({
	        style: paragraph_style
	      }, "In its history, the Earth has been repeatedly struck by asteroids, \nlarge chunks of rock from space that can cause considerable damage \nin a collision. Can we—or should we—try to protect Earth from \npotentially hazardous impacts?"), P({
	        style: paragraph_style
	      }, "Sounds like stuff just for rocket scientists. But how would you like \nto be part of this discussion?"), P({
	        style: paragraph_style
	      }, "Now you can! NASA is collaborating with ECAST—Expert and Citizen \nAssessment of Science and Technology—to give citizens a say in \ndecisions about the future of space exploration."), P({
	        style: paragraph_style
	      }, "Join the dialogue below about detecting asteroids and mitigating their \npotential impact. The five recommendations below emerged from ECAST \npublic forums held in Phoenix and Boston last November."), P({
	        style: paragraph_style
	      }, "Please take a few moments to review the background materials and the \nrecommendations, and tell us what you think! Your input is important \nas we analyze the outcomes of the forums and make our final report \nto NASA.")), DIV({
	        style: {
	          position: 'absolute',
	          top: 30,
	          right: 0,
	          width: 110
	        }
	      }, ProfileMenu()));
	    }
	  })
	};

	styles += "[subdomain=\"ecastonline\"] .simplehomepage a.proposal, [subdomain=\"ecast-demo\"] .simplehomepage a.proposal{\n  border-color: " + ecast_highlight_color + " !important;\n  color: " + ecast_highlight_color + " !important;\n}";

	passes_tags = function(user, tags) {
	  var l, len2, passes, ref, tag;
	  if (typeof tags === 'string') {
	    tags = [tags];
	  }
	  user = fetch(user);
	  passes = true;
	  for (l = 0, len2 = tags.length; l < len2; l++) {
	    tag = tags[l];
	    passes && (passes = user.tags[tag] && !((ref = user.tags[tag].toLowerCase()) === 'no' || ref === 'false'));
	  }
	  return passes;
	};

	customizations.fidoruk = {
	  collapse_descriptions_at: 300,
	  civility_pledge: true,
	  show_score: false,
	  opinion_filters: [
	    {
	      label: 'Account holder',
	      tooltip: null,
	      pass: function(user) {
	        return passes_tags(user, 'fidor_account_holder');
	      },
	      icon: "<span style='color:green'>account-holder</span>"
	    }, {
	      label: 'Community member',
	      tooltip: null,
	      pass: function(user) {
	        return passes_tags(user, 'fidor_community_member');
	      },
	      icon: "<span style='color:blue'>community</span>"
	    }, {
	      label: 'Business member',
	      tooltip: null,
	      pass: function(user) {
	        return passes_tags(user, 'fidor_business_member');
	      },
	      icon: "<span style='color:orange'>business</span>"
	    }, {
	      label: 'Fidor staff',
	      tooltip: null,
	      pass: function(user) {
	        return passes_tags(user, 'fidor_staff');
	      },
	      icon: "<span style='gray'>staff</span>"
	    }
	  ],
	  HomepageHeader: ReactiveComponent({
	    displayName: 'ShortHeader',
	    render: function() {
	      var homepage, hsl, is_light, loc, subdomain;
	      subdomain = fetch('/subdomain');
	      loc = fetch('location');
	      hsl = parseCssHsl(subdomain.branding.primary_color);
	      is_light = hsl.l > .75;
	      homepage = loc.url === '/';
	      return DIV({
	        style: {
	          minHeight: 70
	        }
	      }, ProfileMenu(), DIV({
	        style: {
	          width: (homepage ? HOMEPAGE_WIDTH() : BODY_WIDTH()) + 130,
	          margin: 'auto'
	        }
	      }, back_to_homepage_button({
	        display: 'inline-block',
	        color: !is_light ? 'white' : void 0,
	        fontSize: 43,
	        visibility: homepage || !customization('has_homepage') ? 'hidden' : void 0,
	        verticalAlign: 'middle',
	        marginTop: 5
	      }), subdomain.branding.logo ? A({
	        href: subdomain.external_project_url ? subdomain.external_project_url : void 0,
	        style: {
	          verticalAlign: 'middle',
	          display: 'inline-block',
	          fontSize: 0,
	          cursor: !subdomain.external_project_url ? 'default' : void 0
	        }
	      }, IMG({
	        src: subdomain.branding.logo,
	        style: {
	          height: 80
	        }
	      })) : void 0, DIV({
	        style: {
	          color: !is_light ? 'white' : void 0,
	          marginLeft: 35,
	          fontSize: 32,
	          fontWeight: 400,
	          display: 'inline-block',
	          verticalAlign: 'middle',
	          marginTop: 5
	        }
	      }, homepage ? DIV({
	        style: {
	          paddingBottom: 10,
	          fontSize: 16,
	          color: '#444'
	        }
	      }, "Please first put your proposal into the Fidor Community platform, and link to it in your consider.it proposal. This allows us to converse, update our opinions, and track progress over a longer period of time.") : void 0)));
	    }
	  })
	};

	customizations.fidoruk.NonHomepageHeader = customizations.fidoruk.HomepageHeader;

	customizations.bitcoin = {
	  show_proposer_icon: true,
	  collapse_descriptions_at: 300,
	  civility_pledge: true,
	  slider_pole_labels: support_oppose,
	  show_score: true,
	  'cluster/Blocksize Survey': {
	    show_crafting_page_first: false,
	    slider_handle: slider_handle.triangley,
	    slider_ticks: true,
	    discussion: false,
	    show_score: false,
	    slider_pole_labels: {
	      individual: {
	        support: '',
	        oppose: '',
	        support_sub: '',
	        oppose_sub: ''
	      },
	      group: {
	        support: '',
	        oppose: '',
	        support_sub: '',
	        oppose_sub: ''
	      }
	    },
	    slider_regions: [
	      {
	        label: '1mb',
	        abbrev: '1mb'
	      }, {
	        label: '2mb',
	        abbrev: '2mb'
	      }, {
	        label: '4mb',
	        abbrev: '4mb'
	      }, {
	        label: '8mb',
	        abbrev: '8mb'
	      }, {
	        label: '16mb',
	        abbrev: '16mb'
	      }
	    ]
	  },
	  tawkspace: 'https://tawk.space/embedded-space/bitcoin',
	  auth: {
	    user_questions: [
	      {
	        tag: 'bitcoin_developer.editable',
	        question: 'Others consider me a bitcoin developer',
	        input: 'dropdown',
	        options: ['No', 'Yes'],
	        required: false
	      }, {
	        tag: 'bitcoin_business.editable',
	        question: 'I operate these bitcoin businesses (urls)',
	        input: 'text',
	        required: false
	      }
	    ]
	  },
	  opinion_filters: [
	    {
	      label: 'users',
	      tooltip: 'User sent in verification image.',
	      pass: function(user) {
	        return passes_tags(user, 'verified');
	      },
	      icon: "<span style='color:green'>\u2713 verified</span>"
	    }, {
	      label: 'miners',
	      tooltip: 'Controls > 1% hashrate.',
	      pass: function(user) {
	        return passes_tags(user, ['bitcoin_large_miner', 'verified']);
	      },
	      icon: "<span style=''>\u26CF miner</span>"
	    }, {
	      label: 'developers',
	      tooltip: 'Self reported in user profile.',
	      pass: function(user) {
	        return passes_tags(user, ['bitcoin_developer.editable', 'verified']);
	      },
	      icon: "<span style=''><img src='https://dl.dropboxusercontent.com/u/3403211/dev.png' style='width:20px' /> developer</span>"
	    }, {
	      label: 'businesses',
	      tooltip: 'Self reported in user profile',
	      pass: function(user) {
	        return passes_tags(user, ['bitcoin_business.editable', 'verified']);
	      },
	      icon: function(user) {
	        return "<span style=''>operates: " + (fetch(user).tags['bitcoin_business.editable']) + "</span>";
	      }
	    }
	  ],
	  HomepageHeader: ReactiveComponent({
	    displayName: 'ShortHeader',
	    render: function() {
	      var homepage, hsl, is_light, loc, subdomain, text;
	      subdomain = fetch('/subdomain');
	      loc = fetch('location');
	      hsl = parseCssHsl(subdomain.branding.primary_color);
	      is_light = hsl.l > .75;
	      homepage = loc.url === '/';
	      return DIV({
	        style: {
	          backgroundColor: subdomain.branding.primary_color,
	          minHeight: 70
	        }
	      }, ProfileMenu(), DIV({
	        style: {
	          width: (homepage ? CONTENT_WIDTH() : BODY_WIDTH()) + 130,
	          margin: 'auto'
	        }
	      }, back_to_homepage_button({
	        display: 'inline-block',
	        color: !is_light ? 'white' : void 0,
	        fontSize: 43,
	        visibility: homepage || !customization('has_homepage') ? 'hidden' : void 0,
	        verticalAlign: 'middle',
	        marginTop: 5
	      }), subdomain.branding.logo ? A({
	        href: subdomain.external_project_url ? subdomain.external_project_url : void 0,
	        style: {
	          verticalAlign: 'middle',
	          marginLeft: 35,
	          display: 'inline-block',
	          fontSize: 0,
	          cursor: !subdomain.external_project_url ? 'default' : void 0
	        }
	      }, IMG({
	        src: subdomain.branding.logo,
	        style: {
	          height: 56
	        }
	      })) : void 0, subdomain.branding.masthead_header_text || (!subdomain.branding.logo ? subdomain.app_title : null) ? (text = subdomain.branding.masthead_header_text || subdomain.app_title, DIV({
	        style: {
	          color: !is_light ? 'white' : void 0,
	          marginLeft: 35,
	          fontSize: 32,
	          fontWeight: 400,
	          display: 'inline-block',
	          verticalAlign: 'middle',
	          marginTop: 5
	        }
	      }, text, DIV({
	        style: {
	          paddingBottom: 10,
	          fontSize: 14,
	          color: '#444'
	        }
	      }, "Interested in running a node that mirrors consider.it data to provide an audit trail? ", A({
	        href: 'https://www.reddit.com/r/Bitcoin_Classic/comments/435gi1/distributed_publicly_auditable_data_for/',
	        target: '_blank',
	        style: {
	          textDecoration: 'underline'
	        }
	      }, "Learn more")))) : void 0));
	    }
	  })
	};

	customizations['ynpn'] = {
	  proposal_filters: false
	};

	customizations['on-chain-conf'] = _.extend({}, {
	  opinion_filters: customizations.bitcoin.opinion_filters,
	  auth: customizations.bitcoin.auth,
	  show_proposer_icon: false,
	  collapse_descriptions_at: 300,
	  show_meta: false,
	  proposal_filters: true,
	  civility_pledge: true,
	  slider_pole_labels: interested,
	  'cluster/On-chain scaling': {
	    slider_pole_labels: interested
	  },
	  'cluster/Other topics': {
	    slider_pole_labels: interested
	  },
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var homepage;
	      homepage = fetch('location').url === '/';
	      return DIV({
	        style: {
	          position: 'relative',
	          backgroundColor: '#272727',
	          overflow: 'hidden',
	          paddingBottom: 60,
	          height: !homepage ? 200 : void 0
	        },
	        onMouseEnter: (function(_this) {
	          return function() {
	            _this.local.hover = true;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseLeave: (function(_this) {
	          return function() {
	            _this.local.hover = false;
	            return save(_this.local);
	          };
	        })(this)
	      }, STYLE(null, '.profile_anchor.login {font-size: 26px; padding-top: 16px;}\np {margin-bottom: 1em}'), DIV({
	        style: {
	          margin: 'auto',
	          textAlign: 'center'
	        }
	      }, DIV({
	        style: {
	          margin: "60px auto 160px auto",
	          width: '80%',
	          position: 'relative',
	          zIndex: 3
	        }
	      }, IMG({
	        style: {
	          display: 'inline-block',
	          width: '90%'
	        },
	        src: asset('bitcoin/OnChainConferences3.svg')
	      })), DIV({
	        style: {
	          position: 'absolute',
	          left: 0,
	          top: 0,
	          height: homepage ? '64%' : '100%',
	          width: '100%',
	          background: homepage ? 'linear-gradient(to bottom, rgba(0,0,0,.97) 0%,rgba(0,0,0,0.65) 70%,rgba(0,0,0,0) 100%)' : 'rgba(0,0,0,.7)',
	          zIndex: 2
	        }
	      }), IMG({
	        style: {
	          position: 'absolute',
	          zIndex: 1,
	          width: '160%',
	          top: 0,
	          left: '-30%'
	        },
	        src: asset('bitcoin/rays.png')
	      }), DIV({
	        style: {
	          marginLeft: 50,
	          paddingTop: 13,
	          position: 'absolute',
	          zIndex: 3,
	          top: 65
	        }
	      }, back_to_homepage_button({
	        display: 'inline-block',
	        visibility: homepage ? 'hidden' : void 0,
	        color: 'white',
	        position: 'relative',
	        left: -60,
	        top: -10,
	        fontSize: 43,
	        fontWeight: 400,
	        paddingLeft: 25,
	        paddingRight: 25,
	        cursor: !homepage ? 'pointer' : void 0
	      })), homepage ? DIV({
	        style: {
	          backgroundColor: 'rgba(0,0,0,.7)',
	          color: 'white',
	          textAlign: 'center',
	          padding: '20px 0',
	          width: '100%',
	          position: 'relative',
	          zIndex: 3,
	          top: 60
	        }
	      }, DIV({
	        style: {
	          fontWeight: 600,
	          fontSize: 20
	        }
	      }, 'Upcoming, June 24-26: online conference about on-chain scaling. See ', A({
	        style: {
	          textDecoration: 'underline'
	        },
	        href: 'http://onchainscaling.com/'
	      }, 'onchainscaling.com'), '.'), DIV({
	        style: {
	          fontSize: 18
	        }
	      }, 'Express your preferences below. ')) : void 0), ProfileMenu());
	    }
	  })
	});

	customizations['on-chain-conf'].NonHomepageHeader = customizations['on-chain-conf'].HomepageHeader;

	dao_blue = '#348AC7';

	dao_red = '#F83E34';

	dao_purple = '#7474BF';

	dao_yellow = '#F8E71C';

	dao_section = {
	  width: HOMEPAGE_WIDTH(),
	  marginLeft: -70
	};

	dao_section_heading = {
	  fontSize: 36,
	  fontWeight: 300,
	  color: 'black',
	  marginBottom: 20
	};

	dao_section_description = {
	  fontSize: 18,
	  fontWeight: 400,
	  color: '#666',
	  paddingBottom: 20
	};

	customizations.dao = _.extend({}, {
	  show_proposer_icon: true,
	  collapse_descriptions_at: 300,
	  proposal_filters: true,
	  civility_pledge: true,
	  show_crafting_page_first: false,
	  default_proposal_sort: 'trending',
	  proposal_tips: ['Describe your idea in sufficient depth for others to evaluate it. The title is usually not enough.', 'Link to any contract code, external resources, or videos.', 'Link to any forum.daohub.org or /r/thedao where more free-form discussion about your idea is happening.', 'Take responsibility for improving your idea given feedback.'],
	  cluster_filters: {
	    'Inspire Us': ['Ideas', 'Proposals'],
	    'Proposal Pipeline': ['New', "Proposed to DAO", 'Under development', 'Needs more description', 'Funded', 'Rejected', 'Archived'],
	    'Meta Proposals': ['Meta', 'Hack', '*'],
	    'Hack Response': ['Hack', 'Hack meta']
	  },
	  'cluster/Under development': {
	    archived: false
	  },
	  'cluster/Proposed to DAO': {
	    one_line_desc: 'Proposals submitted to The Dao\'s smart contract'
	  },
	  'cluster/Needs more description': {
	    archived: true,
	    one_line_desc: 'Proposals needing more description to evaluate'
	  },
	  'cluster/Funded': {
	    archived: true,
	    one_line_desc: 'Proposals already funded by The DAO'
	  },
	  'cluster/Rejected': {
	    archived: true,
	    one_line_desc: 'Proposals formally rejected by The DAO'
	  },
	  'cluster/Archived': {
	    archived: true
	  },
	  'cluster/Done': {
	    archived: true
	  },
	  'cluster/Proposals': {
	    homepage_label: 'Ideas',
	    description: function() {
	      return DIV({
	        style: {
	          width: HOMEPAGE_WIDTH()
	        }
	      }, DIV({
	        style: dao_section_description
	      }, "Post inspiring ideas. Maybe a contractor will put together a proposal based \non your idea. Or maybe you get excited by the feedback, and put together\nyour own proposal."));
	    }
	  },
	  'cluster/Name the DAO': {
	    archived: true
	  },
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var homepage;
	      homepage = fetch('location').url === '/';
	      return DIV({
	        style: {
	          position: 'relative',
	          background: "linear-gradient(-45deg, " + dao_purple + ", " + dao_blue + ")",
	          paddingBottom: !homepage ? 20 : void 0,
	          borderBottom: "2px solid " + dao_yellow
	        },
	        onMouseEnter: (function(_this) {
	          return function() {
	            _this.local.hover = true;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseLeave: (function(_this) {
	          return function() {
	            _this.local.hover = false;
	            return save(_this.local);
	          };
	        })(this)
	      }, STYLE(null, '.profile_anchor.login {font-size: 26px; padding-top: 16px;}\np {margin-bottom: 1em}'), DIV({
	        style: {
	          marginLeft: 70
	        }
	      }, back_to_homepage_button({
	        display: 'inline-block',
	        visibility: fetch('location').url === '/' ? 'hidden' : void 0,
	        color: 'white',
	        opacity: .7,
	        position: 'relative',
	        left: -60,
	        top: 4,
	        fontSize: 43,
	        fontWeight: 400,
	        paddingLeft: 25,
	        paddingRight: 25,
	        cursor: fetch('location').url !== '/' ? 'pointer' : void 0
	      }), A({
	        href: homepage ? 'https://forum.daohub.org/c/theDAO' : '/'
	      }, IMG({
	        style: {
	          height: 30,
	          width: 30,
	          marginLeft: -44,
	          marginRight: 10,
	          marginTop: -10,
	          verticalAlign: 'middle'
	        },
	        src: asset('ethereum/the_dao.jpg')
	      }), SPAN({
	        style: {
	          fontSize: 24,
	          color: 'white',
	          fontWeight: 500
	        }
	      }, "The DAO"))), DIV({
	        style: {
	          width: HOMEPAGE_WIDTH(),
	          margin: 'auto'
	        }
	      }, homepage ? DIV({
	        style: {
	          position: 'relative'
	        }
	      }, DIV({
	        style: {
	          padding: "0 8px",
	          fontSize: 46,
	          fontWeight: 200,
	          color: 'white',
	          marginTop: 20
	        }
	      }, 'Deliberate Proposals about The DAO'), DIV({
	        style: {
	          backgroundColor: 'rgba(255,255,255,.2)',
	          marginTop: 10,
	          marginBottom: 16,
	          padding: '4px 12px',
	          float: 'right',
	          fontSize: 18,
	          color: 'white'
	        }
	      }, SPAN({
	        style: {
	          opacity: .8
	        }
	      }, "join meta discussion on Slack at "), A({
	        href: 'https://thedao.slack.com/messages/consider_it/',
	        target: '_blank',
	        style: {
	          color: dao_yellow,
	          fontWeight: 600
	        }
	      }, "#dao_consider_it")), DIV({
	        style: {
	          clear: 'both'
	        }
	      }), DIV({
	        style: {
	          float: 'right',
	          fontSize: 12,
	          color: 'white',
	          opacity: .9,
	          padding: '0px 10px',
	          position: 'relative'
	        }
	      }, "Donate ETH to fuel ", A({
	        href: 'https://dao.consider.it/donate_to_considerit?results=true',
	        target: '_blank',
	        style: {
	          textDecoration: 'underline',
	          fontWeight: 600
	        }
	      }, "our work"), " evolving consider.it to meet The DAO’s needs."), DIV({
	        style: {
	          clear: 'both'
	        }
	      }), DIV({
	        style: {
	          padding: '0px 10px',
	          float: 'right',
	          fontSize: 15,
	          fontWeight: 500,
	          color: dao_yellow,
	          opacity: .8,
	          fontFamily: '"Courier New",Courier,"Lucida Sans Typewriter","Lucida Typewriter",monospace'
	        }
	      }, "0xc7e165ebdad9eeb8e5f5d94eef3e96ea9739fdb2"), DIV({
	        style: {
	          clear: 'both',
	          marginBottom: 70
	        }
	      }), DIV({
	        style: {
	          position: 'relative',
	          color: 'white',
	          fontSize: 20
	        }
	      }, DIV({
	        style: {
	          position: 'relative',
	          left: 60
	        }
	      }, DIV({
	        style: {
	          width: 260,
	          position: 'relative'
	        }
	      }, SPAN({
	        style: {
	          opacity: .7
	        }
	      }, 'Ideas that inspire the community & contractors.'), BR(null), A({
	        style: {
	          opacity: !this.local.hover_idea ? .7 : void 0,
	          display: 'inline-block',
	          marginTop: 6,
	          color: dao_yellow,
	          border: "1px solid " + dao_yellow,
	          fontSize: 14,
	          fontWeight: 600,
	          padding: '4px 12px',
	          borderRadius: 8
	        },
	        onMouseEnter: (function(_this) {
	          return function() {
	            _this.local.hover_idea = true;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseLeave: (function(_this) {
	          return function() {
	            _this.local.hover_idea = null;
	            return save(_this.local);
	          };
	        })(this),
	        href: '/proposal/new?category=Proposals'
	      }, t("add new")), SVG({
	        style: {
	          position: 'absolute',
	          top: 75,
	          left: '35%',
	          opacity: .5
	        },
	        width: 67 * 1.05,
	        height: 204 * 1.05,
	        viewBox: "0 0 67 204"
	      }, G({
	        fill: 'none'
	      }, PATH({
	        strokeWidth: 1 / 1.05,
	        stroke: 'white',
	        d: "M1.62120606,0.112317888 C1.62120606,0.112317888 -3.81550783,47.7673271 15.7617242,109.624892 C35.3389562,171.482458 65.9279782,203.300407 65.9279782,203.300407"
	      }))))), DIV({
	        style: {
	          position: 'relative',
	          left: 260,
	          marginTop: 0
	        }
	      }, DIV({
	        style: {
	          width: 260,
	          position: 'relative'
	        }
	      }, SPAN({
	        style: {
	          opacity: .7
	        }
	      }, 'Proposals working toward a smart contract.'), BR(null), A({
	        style: {
	          opacity: !this.local.hover_new ? .7 : void 0,
	          display: 'inline-block',
	          marginTop: 6,
	          color: dao_yellow,
	          border: "1px solid " + dao_yellow,
	          fontSize: 14,
	          fontWeight: 600,
	          padding: '4px 12px',
	          borderRadius: 8
	        },
	        onMouseEnter: (function(_this) {
	          return function() {
	            _this.local.hover_new = true;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseLeave: (function(_this) {
	          return function() {
	            _this.local.hover_new = null;
	            return save(_this.local);
	          };
	        })(this),
	        href: '/proposal/new?category=New'
	      }, t("add new")), SVG({
	        style: {
	          position: 'absolute',
	          top: 75,
	          left: '35%',
	          opacity: .5
	        },
	        width: 67 * .63,
	        height: 204 * .63,
	        viewBox: "0 0 67 204"
	      }, G({
	        fill: 'none'
	      }, PATH({
	        strokeWidth: 1 / .63,
	        stroke: 'white',
	        d: "M1.62120606,0.112317888 C1.62120606,0.112317888 -3.81550783,47.7673271 15.7617242,109.624892 C35.3389562,171.482458 65.9279782,203.300407 65.9279782,203.300407"
	      }))))), DIV({
	        style: {
	          position: 'relative',
	          left: 490,
	          marginTop: 0
	        }
	      }, DIV({
	        style: {
	          width: 260,
	          position: 'relative'
	        }
	      }, SPAN({
	        style: {
	          opacity: .7
	        }
	      }, 'Issues related to the operation of The DAO.'), BR(null), A({
	        style: {
	          opacity: !this.local.hover_meta ? .7 : void 0,
	          display: 'inline-block',
	          marginTop: 6,
	          color: dao_yellow,
	          border: "1px solid " + dao_yellow,
	          fontSize: 14,
	          fontWeight: 600,
	          padding: '4px 12px',
	          borderRadius: 8
	        },
	        onMouseEnter: (function(_this) {
	          return function() {
	            _this.local.hover_meta = true;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseLeave: (function(_this) {
	          return function() {
	            _this.local.hover_meta = null;
	            return save(_this.local);
	          };
	        })(this),
	        href: '/proposal/new?category=Meta'
	      }, t("add new")), SVG({
	        style: {
	          position: 'absolute',
	          top: 75,
	          left: '35%',
	          opacity: .5
	        },
	        width: 67 * .21,
	        height: 204 * .21,
	        viewBox: "0 0 67 204"
	      }, G({
	        fill: 'none'
	      }, PATH({
	        strokeWidth: 1 / .21,
	        stroke: 'white',
	        d: "M1.62120606,0.112317888 C1.62120606,0.112317888 -3.81550783,47.7673271 15.7617242,109.624892 C35.3389562,171.482458 65.9279782,203.300407 65.9279782,203.300407"
	      }))))), DIV({
	        style: {
	          position: 'absolute',
	          left: 750,
	          marginTop: 0,
	          bottom: -15
	        }
	      }, DIV({
	        style: {
	          width: 260,
	          position: 'relative'
	        }
	      }, BR(null), A({
	        style: {
	          opacity: !this.local.hover_hack ? .7 : void 0,
	          display: 'inline-block',
	          marginTop: 6,
	          color: dao_yellow,
	          border: "1px solid " + dao_yellow,
	          fontSize: 14,
	          fontWeight: 600,
	          padding: '4px 12px',
	          borderRadius: 8
	        },
	        onMouseEnter: (function(_this) {
	          return function() {
	            _this.local.hover_hack = true;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseLeave: (function(_this) {
	          return function() {
	            _this.local.hover_hack = null;
	            return save(_this.local);
	          };
	        })(this),
	        href: '/proposal/new?category=Hack'
	      }, t("add new"))))), customization('cluster_filters') ? ClusterFilter() : void 0) : void 0), ProfileMenu());
	    }
	  })
	});

	customizations.dao.NonHomepageHeader = customizations.dao.HomepageHeader;

	customizations.bitcoinclassic = _.extend({}, {
	  opinion_filters: customizations.bitcoin.opinion_filters,
	  auth: customizations.bitcoin.auth,
	  show_proposer_icon: false,
	  collapse_descriptions_at: 300,
	  proposal_filters: true,
	  civility_pledge: true,
	  'cluster/Scrapped proposals': {
	    archived: true
	  },
	  'cluster/Closed pull requests': {
	    archived: true
	  },
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var homepage;
	      homepage = fetch('location').url === '/';
	      return DIV({
	        style: {
	          position: 'relative',
	          backgroundColor: 'white',
	          paddingBottom: 20
	        },
	        onMouseEnter: (function(_this) {
	          return function() {
	            _this.local.hover = true;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseLeave: (function(_this) {
	          return function() {
	            _this.local.hover = false;
	            return save(_this.local);
	          };
	        })(this)
	      }, STYLE(null, '.profile_anchor.login {font-size: 26px; padding-top: 16px;}\np {margin-bottom: 1em}'), DIV({
	        style: {
	          width: HOMEPAGE_WIDTH(),
	          margin: 'auto'
	        }
	      }, DIV({
	        style: {
	          marginLeft: -70,
	          paddingTop: 30
	        }
	      }, back_to_homepage_button({
	        display: 'inline-block',
	        visibility: homepage ? 'hidden' : void 0,
	        color: '#eee',
	        position: 'relative',
	        left: -60,
	        top: -10,
	        fontSize: 43,
	        fontWeight: 400,
	        paddingLeft: 25,
	        paddingRight: 25,
	        cursor: !homepage ? 'pointer' : void 0
	      }), A({
	        href: homepage ? 'https://bitcoinclassic.com' : '/'
	      }, IMG({
	        style: {
	          height: 51,
	          marginLeft: -50
	        },
	        src: asset('bitcoin/bitcoinclassiclogo.png')
	      })), BR(null), homepage ? SPAN({
	        style: {
	          marginLeft: 69,
	          position: 'relative',
	          marginTop: 5,
	          marginBottom: 10,
	          top: -4,
	          padding: '3px 6px',
	          fontSize: 20,
	          fontStyle: 'italic',
	          fontWeight: 700,
	          color: '#bbb'
	        }
	      }, "Propose and deliberate ideas for Bitcoin Classic. Not yet for binding votes.") : void 0), homepage ? DIV(null, DIV({
	        style: {
	          marginTop: 10,
	          padding: 8,
	          fontSize: 18
	        }
	      }, "Classic is using consider.it to sample community opinion to better understand what users really think about bitcoin and want to see it become. The governance model that Classic eventually adopts may include opinions collected from this site, but Classic has not committed itself to making decisions based only on the preferences expressed here or elsewhere.", " ", "Please vet proposals on ", A({
	        href: "https://www.reddit.com/r/Bitcoin_Classic/",
	        target: '_blank',
	        style: {
	          borderBottom: "1px solid #bbb"
	        }
	      }, "Reddit"), " or ", A({
	        href: "http://invite.bitcoinclassic.com/",
	        target: '_blank',
	        style: {
	          borderBottom: "1px solid #bbb"
	        }
	      }, "Slack"), " first. ", "Other ", A({
	        href: 'https://www.reddit.com/r/Bitcoin_Classic/comments/40u3ws/considerit_voting_guide/',
	        target: '_blank',
	        style: {
	          borderBottom: "1px solid #bbb"
	        }
	      }, "guidelines"), "."), DIV({
	        style: {
	          marginTop: 10,
	          padding: 8,
	          fontSize: 18
	        }
	      }, "Some users have abused open registration. Filtering opinions to verified users has been enabled by default.", " "), DIV({
	        style: {
	          backgroundColor: '#eee',
	          marginTop: 10,
	          padding: 8,
	          fontSize: 18
	        }
	      }, "Interested in running a node that mirrors consider.it data to provide an audit trail? ", A({
	        href: 'https://www.reddit.com/r/Bitcoin_Classic/comments/435gi1/distributed_publicly_auditable_data_for/',
	        target: '_blank',
	        style: {
	          textDecoration: 'underline'
	        }
	      }, "Learn more"))) : void 0), ProfileMenu());
	    }
	  })
	});

	customizations.bitcoinclassic.NonHomepageHeader = customizations.bitcoinclassic.HomepageHeader;

	customizations['bitcoinfoundation'] = {
	  opinion_filters: [
	    {
	      label: 'members',
	      tooltip: 'Verified member of the Second Foundation.',
	      pass: function(user) {
	        return passes_tags(user, 'second_foundation_member');
	      },
	      icon: "<span style='color:green'>\u2713 member</span>"
	    }, {
	      label: 'miners',
	      tooltip: 'Controls > 1% hashrate.',
	      pass: function(user) {
	        return passes_tags(user, ['bitcoin_large_miner', 'verified']);
	      },
	      icon: "<span style=''>\u26CF miner</span>"
	    }, {
	      label: 'developers',
	      tooltip: 'Self reported in user profile.',
	      pass: function(user) {
	        return passes_tags(user, ['bitcoin_developer.editable', 'verified']);
	      },
	      icon: "<span style=''><img src='https://dl.dropboxusercontent.com/u/3403211/dev.png' style='width:20px' /> developer</span>"
	    }
	  ],
	  civility_pledge: true,
	  show_proposer_icon: true,
	  homie_histo_title: "Votes",
	  collapse_descriptions_at: 300,
	  slider_pole_labels: support_oppose,
	  'cluster/First Foundation': {
	    slider_pole_labels: support_oppose,
	    description: function() {
	      return DIV(null, 'Archived proceedings of the First Foundation');
	    },
	    archived: true
	  },
	  show_crafting_page_first: true
	};

	ZipcodeBox = ReactiveComponent({
	  displayName: 'ZipcodeBox',
	  render: function() {
	    var current_user, extra_text, onChange;
	    current_user = fetch('/current_user');
	    extra_text = Modernizr.input.placeholder ? '' : ' Zip Code';
	    onChange = (function(_this) {
	      return function(event) {
	        if (event.target.value.match(/\d\d\d\d\d/)) {
	          current_user.tags['zip.editable'] = event.target.value;
	          return save(current_user);
	        } else if (event.target.value.length === 0) {
	          current_user.tags['zip.editable'] = void 0;
	          _this.local.stay_around = true;
	          save(current_user);
	          return save(_this.local);
	        }
	      };
	    })(this);
	    if (current_user.tags['zip.editable'] || this.local.stay_around) {
	      return DIV({
	        style: {
	          textAlign: 'center',
	          padding: '13px 23px',
	          fontSize: 20,
	          fontWeight: 400,
	          margin: 'auto',
	          color: 'white'
	        },
	        className: 'filled_zip'
	      }, 'Customized for:', INPUT({
	        style: {
	          fontSize: 20,
	          fontWeight: 600,
	          border: '1px solid transparent',
	          borderColor: this.local.focused || this.local.hovering ? '#767676' : 'transparent',
	          backgroundColor: this.local.focused || this.local.hovering ? 'white' : 'transparent',
	          width: 80,
	          marginLeft: 7,
	          color: this.local.focused || this.local.hovering ? 'black' : 'white',
	          display: 'inline-block'
	        },
	        type: 'text',
	        key: 'zip_input',
	        defaultValue: current_user.tags['zip.editable'] || '',
	        onChange: onChange,
	        onFocus: (function(_this) {
	          return function() {
	            _this.local.focused = true;
	            return save(_this.local);
	          };
	        })(this),
	        onBlur: (function(_this) {
	          return function() {
	            _this.local.focused = false;
	            _this.local.stay_around = false;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseEnter: (function(_this) {
	          return function() {
	            _this.local.hovering = true;
	            return save(_this.local);
	          };
	        })(this),
	        onMouseLeave: (function(_this) {
	          return function() {
	            _this.local.hovering = false;
	            return save(_this.local);
	          };
	        })(this)
	      }));
	    } else {
	      return DIV({
	        style: {
	          backgroundColor: 'rgba(0,0,0,.1)',
	          fontSize: 22,
	          fontWeight: 700,
	          width: 720,
	          color: 'white',
	          padding: '15px 40px',
	          marginLeft: (WINDOW_WIDTH() - 720) / 2
	        }
	      }, 'Customize this guide for your' + extra_text, INPUT({
	        type: 'text',
	        key: 'zip_input',
	        placeholder: 'Zip Code',
	        style: {
	          margin: '0 0 0 12px',
	          fontSize: 22,
	          height: 42,
	          width: 152,
	          padding: '4px 20px'
	        },
	        onChange: onChange
	      }));
	    }
	  }
	});

	customizations.livingvotersguide = {
	  civility_pledge: true,
	  slider_pole_labels: support_oppose,
	  'cluster/Advisory votes': {
	    archived: true,
	    description: function() {
	      return DIV(null, "Advisory Votes are not binding. They are a consequence of Initiative 960 passing in 2007");
	    }
	  },
	  ThanksForYourOpinion: ReactiveComponent({
	    displayName: 'ThanksForYourOpinion',
	    render: function() {
	      var tweet;
	      if (this.proposal.category && this.proposal.designator) {
	        tweet = "Flex your civic muscle on " + (this.proposal.category.substring(0, 1)) + "-\n" + this.proposal.designator + "! Learn about the issue and decide here: ";
	      } else {
	        tweet = "Learn and decide whether you will support \'" + this.proposal.name + "\' \non your Washington ballot here:";
	      }
	      return DIV({
	        style: {
	          position: 'fixed',
	          left: 0,
	          bottom: 0,
	          width: '100%',
	          backgroundColor: 'rgb(0,182,236)',
	          padding: '5px 10px',
	          color: 'white',
	          zIndex: 999,
	          textAlign: 'center',
	          fontWeight: 600,
	          fontSize: 18
	        }
	      }, 'Thanks for your opinion! Invite your friends and family: ', SPAN({
	        style: {
	          position: 'relative',
	          top: 5,
	          marginLeft: 5
	        }
	      }, FBShare(), Tweet({
	        text: tweet,
	        url: "https://livingvotersguide.org/" + this.proposal.slug + "?results=true"
	      })));
	    }
	  }),
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      var LVG_blue, LVG_green, homepage;
	      LVG_blue = '#063D72';
	      LVG_green = '#A5CE39';
	      homepage = fetch('location').url === '/';
	      return DIV({
	        style: {
	          position: 'relative'
	        }
	      }, DIV({
	        style: {
	          height: !homepage ? 150 : 455,
	          backgroundImage: "url(" + (asset('livingvotersguide/bg.png')) + ")",
	          backgroundPosition: 'center',
	          backgroundSize: 'cover',
	          backgroundColor: LVG_blue,
	          textAlign: homepage ? 'center' : void 0
	        }
	      }, DIV({
	        style: {
	          position: 'absolute',
	          right: 17,
	          top: 17
	        }
	      }, ProfileMenu({
	        style: {
	          height: 69,
	          left: 0,
	          top: 0,
	          position: 'relative',
	          display: 'inline-block'
	        }
	      }), SPAN({
	        style: {
	          color: 'white'
	        }
	      }, '   |   '), A({
	        href: '/about',
	        style: {
	          color: 'white',
	          cursor: 'pointer'
	        }
	      }, 'About')), !homepage ? back_to_homepage_button({
	        position: 'absolute',
	        display: 'inline-block',
	        top: 40,
	        left: 22,
	        fontSize: 43,
	        color: 'white'
	      }) : void 0, A({
	        style: {
	          marginTop: homepage ? 40 : 10,
	          display: 'inline-block',
	          marginLeft: !homepage ? 80 : void 0,
	          marginRight: !homepage ? 30 : void 0
	        },
	        href: (fetch('location').url === '/' ? '/about' : '/')
	      }, IMG({
	        src: asset('livingvotersguide/logo.svg'),
	        style: {
	          width: homepage ? 220 : 120,
	          height: homepage ? 220 : 120
	        }
	      })), DIV({
	        style: {
	          display: !homepage ? 'inline-block' : void 0,
	          position: 'relative',
	          top: !homepage ? -32 : void 0
	        }
	      }, DIV({
	        style: {
	          fontSize: homepage ? 32 : 24,
	          fontWeight: 700,
	          color: LVG_green,
	          margin: '12px 0 4px 0'
	        }
	      }, SPAN(null, 'Washington\'s Citizen Powered Voters Guide')), DIV({
	        style: {
	          color: 'white',
	          fontSize: homepage ? 20 : 18
	        }
	      }, 'Learn about your ballot, decide how you’ll vote, and share your opinion.')), homepage ? DIV({
	        style: {
	          color: 'white',
	          fontSize: 20,
	          marginTop: 30
	        }
	      }, DIV({
	        style: {
	          position: 'relative',
	          display: 'inline',
	          marginRight: 50,
	          height: 46
	        }
	      }, SPAN({
	        style: {
	          paddingRight: 12,
	          position: 'relative',
	          top: 4,
	          verticalAlign: 'top'
	        }
	      }, 'brought to you by'), A({
	        style: {
	          verticalAlign: 'top'
	        },
	        href: 'http://seattlecityclub.org'
	      }, IMG({
	        src: asset('livingvotersguide/cityclub.svg')
	      }))), DIV({
	        style: {
	          position: 'relative',
	          display: 'inline',
	          height: 46
	        }
	      }, SPAN({
	        style: {
	          paddingRight: 12,
	          verticalAlign: 'top',
	          position: 'relative',
	          top: 4
	        }
	      }, 'fact-checks by'), A({
	        style: {
	          verticalAlign: 'top',
	          position: 'relative',
	          top: -6
	        },
	        href: 'http://spl.org'
	      }, IMG({
	        style: {
	          height: 31
	        },
	        src: asset('livingvotersguide/spl.png')
	      })))) : void 0), homepage ? DIV({
	        style: {
	          backgroundColor: LVG_green
	        }
	      }, DIV({
	        style: {
	          color: 'white',
	          margin: 'auto',
	          padding: '40px',
	          width: 720
	        }
	      }, DIV({
	        style: {
	          fontSize: 24,
	          fontWeight: 600,
	          textAlign: 'center'
	        }
	      }, "The Living Voters Guide has passed on..."), DIV({
	        style: {
	          fontSize: 18
	        }
	      }, "We have made the difficult decision to discontinue the Living Voters Guide \nafter six years of service. Thank you for your contributions through the years!")), DIV({
	        style: {
	          paddingBottom: 15
	        }
	      }, ZipcodeBox())) : DIV({
	        style: {
	          backgroundColor: LVG_green,
	          paddingTop: 5
	        }
	      }));
	    }
	  }),
	  Footer: ReactiveComponent({
	    displayName: 'Footer',
	    render: function() {
	      return DIV({
	        style: {
	          position: 'relative',
	          textAlign: 'center',
	          zIndex: 0
	        }
	      }, DIV({
	        style: {
	          color: 'white',
	          backgroundColor: '#93928E',
	          marginTop: 48,
	          padding: 18,
	          maxHeight: 400
	        }
	      }, DIV({
	        style: {
	          fontSize: 18,
	          textAlign: 'left',
	          width: 690,
	          margin: 'auto'
	        }
	      }, "Unlike voter guides generated by government, newspapers or \nadvocacy organizations, Living Voters Guide is created ", SPAN({
	        style: {
	          fontWeight: 600
	        }
	      }, 'by the people'), ' and ', SPAN({
	        style: {
	          fontWeight: 600
	        }
	      }, 'for the people'), " of Washington State. It\'s your platform to learn about candidate and ballot measures, \ndecide how to vote and express your ideas. We believe that sharing our diverse opinions \nleads to making wiser decisions together.", A({
	        style: {
	          color: 'white',
	          textDecoration: 'underline',
	          fontWeight: 'normal'
	        },
	        href: '/about'
	      }, 'Learn more'), '.'), DIV({
	        style: {
	          marginTop: 20
	        }
	      }, FBLike(), Tweet({
	        hashtags: 'lvguide',
	        referer: 'https%3A%2F%2Flivingvotersguide.org%2F',
	        related: 'lvguide',
	        text: 'I%20flexed%20my%20civic%20muscle%20%40lvguide.',
	        url: 'https%3A%2F%2Flivingvotersguide.org%2F'
	      }))), DefaultFooter());
	    }
	  })
	};

	customizations.livingvotersguide.NonHomepageHeader = customizations.livingvotersguide.HomepageHeader;

	FBShare = ReactiveComponent({
	  displayName: 'FBShare',
	  componentDidMount: function() {
	    return FB.XFBML.parse(document);
	  },
	  render: function() {
	    var layout;
	    layout = 'button';
	    return SPAN({
	      style: {
	        display: 'inline-block',
	        marginRight: 5,
	        position: 'relative',
	        top: -6
	      },
	      dangerouslySetInnerHTML: {
	        __html: "<fb:share-button data-layout='" + layout + "'></fb:share-button>"
	      }
	    });
	  }
	});

	FBLike = ReactiveComponent({
	  displayName: 'FBLike',
	  render: function() {
	    var page;
	    page = 'http://www.facebook.com/pages/Living-Voters-Guide/157151824312366';
	    return IFRAME({
	      style: {
	        border: 'none',
	        overflow: 'hidden',
	        width: 90,
	        height: 21
	      },
	      src: "//www.facebook.com/plugins/like.php?href=" + page + "&send=false&layout=button_count&width=450&\nshow_faces=false&action=like&colorscheme=light&font=lucida+grande&height=21",
	      scrolling: "no",
	      frameBorder: "0",
	      allowTransparency: "true"
	    });
	  }
	});

	Tweet = ReactiveComponent({
	  displayName: 'Tweet',
	  render: function() {
	    var l, len2, ref, url, url_param;
	    url = "https://platform.twitter.com/widgets/tweet_button.1410542722.html#?_=\n1410827370943&count=none&id=twitter-widget-0&lang=en&size=m";
	    ref = ['hashtags', 'original_referer', 'related', 'text', 'url'];
	    for (l = 0, len2 = ref.length; l < len2; l++) {
	      url_param = ref[l];
	      if (this.props[url_param]) {
	        url += "&" + url_param + "=" + this.props[url_param];
	      }
	    }
	    return IFRAME({
	      src: url,
	      scrolling: "no",
	      frameBorder: "0",
	      allowTransparency: "true",
	      className: "twitter-share-button twitter-tweet-button twitter-share-button twitter-count-none",
	      style: {
	        width: 57,
	        height: 20
	      }
	    });
	  }
	});

	styles += "[subdomain=\"livingvotersguide\"] .endorser_group {\n  width: 305px;\n  display: inline-block;\n  margin-bottom: 1em;\n  vertical-align: top; }\n  [subdomain=\"livingvotersguide\"] .endorser_group.oppose {\n    margin-left: 60px; }\n  [subdomain=\"livingvotersguide\"] .endorser_group li, [subdomain=\"livingvotersguide\"] .endorser_group a {\n    font-size: 12px; }\n  [subdomain=\"livingvotersguide\"] .endorser_group ul {\n    margin-left: 0px;\n    padding-left: 10px; }\n[subdomain=\"livingvotersguide\"] .total_money_raised {\n  font-weight: 600;\n  float: right; }\n[subdomain=\"livingvotersguide\"] .funders li {\n  list-style: none; }\n  [subdomain=\"livingvotersguide\"] .funders li .funder_amount {\n    float: right; }\n[subdomain=\"livingvotersguide\"] .news {\n  padding-left: 0; }\n  [subdomain=\"livingvotersguide\"] .news li {\n    font-size: 13px;\n    list-style: none;\n    padding-bottom: 6px; }\n[subdomain=\"livingvotersguide\"] .editorials ul {\n  padding-left: 10px; }\n  [subdomain=\"livingvotersguide\"] .editorials ul li {\n    list-style: none;\n    padding-top: 6px; }\n";

	customizations.tigard = {
	  HomepageHeader: ReactiveComponent({
	    displayName: 'HomepageHeader',
	    render: function() {
	      return DIV({
	        style: {
	          textAlign: 'center'
	        }
	      }, STYLE(null, '.banner_link {color: #78d18b; font-weight: 600; text-decoration: underline;}'), ProfileMenu(), DIV({
	        style: {
	          color: '#707070',
	          fontSize: 32,
	          padding: '20px 0',
	          margin: '0px auto 0 auto',
	          fontWeight: 800,
	          textTransform: 'uppercase',
	          position: 'relative',
	          width: CONTENT_WIDTH()
	        }
	      }, 'Help plan ', A({
	        className: 'banner_link',
	        href: 'http://riverterracetigard.com/'
	      }, 'River Terrace'), ', Tigard\'s newest neighborhood'));
	    }
	  })
	};

	customizations.mos = {
	  slider_pole_labels: {
	    individual: {
	      support: 'Support',
	      support_sub: 'the ban',
	      oppose: 'Oppose',
	      oppose_sub: 'the ban'
	    },
	    group: {
	      support: 'Supporters',
	      support_sub: 'of the ban',
	      oppose: 'Opposers',
	      oppose_sub: 'of the ban'
	    }
	  },
	  show_crafting_page_first: true
	};

	customizations['ama-rfs'] = {
	  show_proposer_icon: true
	};

	for (k in customizations) {
	  if (!hasProp.call(customizations, k)) continue;
	  v = customizations[k];
	  _.defaults(customizations[k], customizations["default"]);
	  customizations[k].key = "customizations/" + k;
	  save(customizations[k]);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var is_android_browser, rxaosp,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	rxaosp = window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);

	is_android_browser = !!(rxaosp && rxaosp[1] < 537);

	window.browser = {
	  is_android_browser: is_android_browser,
	  is_opera_mini: !!navigator.userAgent.match(/Opera Mini/),
	  is_ie9: !!(document.documentMode && document.documentMode === 9),
	  is_iOS: !!navigator.platform.match(/(iPad|iPhone)/),
	  touch_enabled: indexOf.call(document, 'ontouchend') >= 0,
	  high_density_display: (window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), \nonly screen and (min-resolution: 1.3dppx), \nonly screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), \nonly screen and (-o-min-device-pixel-ratio: 2.6/2), \nonly screen and (min--moz-device-pixel-ratio: 1.3), \nonly screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3),
	  is_mobile: is_android_browser || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)
	};

	window.BrowserHacks = ReactiveComponent({
	  displayName: 'BrowserHacks',
	  render: function() {
	    var browser;
	    browser = fetch('browser');
	    if (browser.is_opera_mini) {
	      return DIV({
	        style: {
	          backgroundColor: 'red',
	          padding: 10,
	          textAlign: 'center',
	          color: 'white',
	          fontSize: 24
	        }
	      }, "This website does not work well with ", browser.is_android_browser ? 'the Android Browser' : 'Opera Mini', ". Please use ", A({
	        href: "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en",
	        style: {
	          color: 'white',
	          textDecoration: 'underline'
	        }
	      }, 'Chrome for Android'), ' if you experience difficulty. Thanks, and sorry for the inconvenience!');
	    } else {
	      return SCRIPT({
	        type: 'text/javascript',
	        src: '//browser-update.org/update.js'
	      });
	    }
	  }
	});


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * React v0.11.2
	 */


	!function(e){
	  if("object"==typeof exports&&"undefined"!=typeof module)
	    module.exports=e();
	  else if("function"==typeof define&&define.amd)
	    define([],e);
	  else{
	    var f;
	    "undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.React=e()
	  }
	}

	(function(){
	  var define,module,exports;
	  return (function e(t,n,r){
	    function s(o,u){
	      if(!n[o]){
	        if(!t[o]){
	          var a=typeof require=="function"&&require;
	          if(!u&&a)
	            return a(o,!0);
	          if(i)
	            return i(o,!0);
	          throw new Error("Cannot find module '"+o+"'")
	        }
	        var f=n[o]={exports:{}};
	        t[o][0].call(f.exports,function(e){
	          var n=t[o][1][e];
	          return s(n?n:e)
	        },f,f.exports,e,t,n,r)
	      }
	      return n[o].exports
	    }
	    var i=typeof require=="function"&&require;
	    for(var o=0;o<r.length;o++)
	      s(r[o]);
	    return s
	  }
	  )({1:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule AutoFocusMixin
	 * @typechecks static-only
	 */

	"use strict";

	var focusNode = _dereq_("./focusNode");

	var AutoFocusMixin = {
	  componentDidMount: function() {
	    if (this.props.autoFocus) {
	      focusNode(this.getDOMNode());
	    }
	  }
	};

	module.exports = AutoFocusMixin;

	},{"./focusNode":106}],2:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var EventPropagators = _dereq_("./EventPropagators");
	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");
	var SyntheticInputEvent = _dereq_("./SyntheticInputEvent");

	var keyOf = _dereq_("./keyOf");

	var canUseTextInputEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'TextEvent' in window &&
	  !('documentMode' in document || isPresto())
	);

	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return (
	    typeof opera === 'object' &&
	    typeof opera.version === 'function' &&
	    parseInt(opera.version(), 10) <= 12
	  );
	}

	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

	var topLevelTypes = EventConstants.topLevelTypes;

	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBeforeInput: null}),
	      captured: keyOf({onBeforeInputCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topTextInput,
	      topLevelTypes.topPaste
	    ]
	  }
	};

	// Track characters inserted via keypress and composition events.
	var fallbackChars = null;

	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (
	    (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	    // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	    !(nativeEvent.ctrlKey && nativeEvent.altKey)
	  );
	}

	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 */
	var BeforeInputEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {

	    var chars;

	    if (canUseTextInputEvent) {
	      switch (topLevelType) {
	        case topLevelTypes.topKeyPress:
	          /**
	           * If native `textInput` events are available, our goal is to make
	           * use of them. However, there is a special case: the spacebar key.
	           * In Webkit, preventing default on a spacebar `textInput` event
	           * cancels character insertion, but it *also* causes the browser
	           * to fall back to its default spacebar behavior of scrolling the
	           * page.
	           *
	           * Tracking at:
	           * https://code.google.com/p/chromium/issues/detail?id=355103
	           *
	           * To avoid this issue, use the keypress event as if no `textInput`
	           * event is available.
	           */
	          var which = nativeEvent.which;
	          if (which !== SPACEBAR_CODE) {
	            return;
	          }

	          chars = String.fromCharCode(which);
	          break;

	        case topLevelTypes.topTextInput:
	          // Record the characters to be added to the DOM.
	          chars = nativeEvent.data;

	          // If it's a spacebar character, assume that we have already handled
	          // it at the keypress level and bail immediately.
	          if (chars === SPACEBAR_CHAR) {
	            return;
	          }

	          // Otherwise, carry on.
	          break;

	        default:
	          // For other native event types, do nothing.
	          return;
	      }
	    } else {
	      switch (topLevelType) {
	        case topLevelTypes.topPaste:
	          // If a paste event occurs after a keypress, throw out the input
	          // chars. Paste events should not lead to BeforeInput events.
	          fallbackChars = null;
	          break;
	        case topLevelTypes.topKeyPress:
	          /**
	           * As of v27, Firefox may fire keypress events even when no character
	           * will be inserted. A few possibilities:
	           *
	           * - `which` is `0`. Arrow keys, Esc key, etc.
	           *
	           * - `which` is the pressed key code, but no char is available.
	           *   Ex: 'AltGr + d` in Polish. There is no modified character for
	           *   this key combination and no character is inserted into the
	           *   document, but FF fires the keypress for char code `100` anyway.
	           *   No `input` event will occur.
	           *
	           * - `which` is the pressed key code, but a command combination is
	           *   being used. Ex: `Cmd+C`. No character is inserted, and no
	           *   `input` event will occur.
	           */
	          if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	            fallbackChars = String.fromCharCode(nativeEvent.which);
	          }
	          break;
	        case topLevelTypes.topCompositionEnd:
	          fallbackChars = nativeEvent.data;
	          break;
	      }

	      // If no changes have occurred to the fallback string, no relevant
	      // event has fired and we're done.
	      if (fallbackChars === null) {
	        return;
	      }

	      chars = fallbackChars;
	    }

	    // If no characters are being inserted, no BeforeInput event should
	    // be fired.
	    if (!chars) {
	      return;
	    }

	    var event = SyntheticInputEvent.getPooled(
	      eventTypes.beforeInput,
	      topLevelTargetID,
	      nativeEvent
	    );

	    event.data = chars;
	    fallbackChars = null;
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  }
	};

	module.exports = BeforeInputEventPlugin;

	},{"./EventConstants":15,"./EventPropagators":20,"./ExecutionEnvironment":21,"./SyntheticInputEvent":86,"./keyOf":127}],3:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule CSSProperty
	 */

	"use strict";

	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  columnCount: true,
	  fillOpacity: true,
	  flex: true,
	  flexGrow: true,
	  flexShrink: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  widows: true,
	  zIndex: true,
	  zoom: true
	};

	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}

	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function(prop) {
	  prefixes.forEach(function(prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});

	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundImage: true,
	    backgroundPosition: true,
	    backgroundRepeat: true,
	    backgroundColor: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  }
	};

	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};

	module.exports = CSSProperty;

	},{}],4:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */

	"use strict";

	var CSSProperty = _dereq_("./CSSProperty");

	var dangerousStyleValue = _dereq_("./dangerousStyleValue");
	var hyphenateStyleName = _dereq_("./hyphenateStyleName");
	var memoizeStringOnly = _dereq_("./memoizeStringOnly");

	var processStyleName = memoizeStringOnly(function(styleName) {
	  return hyphenateStyleName(styleName);
	});

	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {

	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function(styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },

	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function(node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }

	};

	module.exports = CSSPropertyOperations;

	},{"./CSSProperty":3,"./dangerousStyleValue":101,"./hyphenateStyleName":118,"./memoizeStringOnly":129}],5:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule CallbackQueue
	 */

	"use strict";

	var PooledClass = _dereq_("./PooledClass");

	var invariant = _dereq_("./invariant");
	var mixInto = _dereq_("./mixInto");

	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}

	mixInto(CallbackQueue, {

	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },

	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      ("production" !== "development" ? invariant(
	        callbacks.length === contexts.length,
	        "Mismatched list of contexts in callback queue"
	      ) : invariant(callbacks.length === contexts.length));
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0, l = callbacks.length; i < l; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },

	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function() {
	    this._callbacks = null;
	    this._contexts = null;
	  },

	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function() {
	    this.reset();
	  }

	});

	PooledClass.addPoolingTo(CallbackQueue);

	module.exports = CallbackQueue;

	},{"./PooledClass":26,"./invariant":120,"./mixInto":133}],6:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ChangeEventPlugin
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var EventPluginHub = _dereq_("./EventPluginHub");
	var EventPropagators = _dereq_("./EventPropagators");
	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");
	var ReactUpdates = _dereq_("./ReactUpdates");
	var SyntheticEvent = _dereq_("./SyntheticEvent");

	var isEventSupported = _dereq_("./isEventSupported");
	var isTextInputElement = _dereq_("./isTextInputElement");
	var keyOf = _dereq_("./keyOf");

	var topLevelTypes = EventConstants.topLevelTypes;

	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onChange: null}),
	      captured: keyOf({onChangeCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topChange,
	      topLevelTypes.topClick,
	      topLevelTypes.topFocus,
	      topLevelTypes.topInput,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};

	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;

	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  return (
	    elem.nodeName === 'SELECT' ||
	    (elem.nodeName === 'INPUT' && elem.type === 'file')
	  );
	}

	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (
	    !('documentMode' in document) || document.documentMode > 8
	  );
	}

	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(
	    eventTypes.change,
	    activeElementID,
	    nativeEvent
	  );
	  EventPropagators.accumulateTwoPhaseDispatches(event);

	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}

	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue();
	}

	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}

	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}

	function getTargetIDForChangeEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}


	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (
	    !('documentMode' in document) || document.documentMode > 9
	  );
	}

	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp =  {
	  get: function() {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function(val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};

	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(
	    target.constructor.prototype,
	    'value'
	  );

	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}

	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }

	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);

	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}

	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;

	  manualDispatchChangeEvent(nativeEvent);
	}

	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}

	// For IE8 and IE9.
	function handleEventsForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}

	// For IE8 and IE9.
	function getTargetIDForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange ||
	      topLevelType === topLevelTypes.topKeyUp ||
	      topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}


	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return (
	    elem.nodeName === 'INPUT' &&
	    (elem.type === 'checkbox' || elem.type === 'radio')
	  );
	}

	function getTargetIDForClickEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}

	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {

	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }

	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(
	          eventTypes.change,
	          targetID,
	          nativeEvent
	        );
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }

	    if (handleEventFunc) {
	      handleEventFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	    }
	  }

	};

	module.exports = ChangeEventPlugin;

	},{"./EventConstants":15,"./EventPluginHub":17,"./EventPropagators":20,"./ExecutionEnvironment":21,"./ReactUpdates":76,"./SyntheticEvent":84,"./isEventSupported":121,"./isTextInputElement":123,"./keyOf":127}],7:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */

	"use strict";

	var nextReactRootIndex = 0;

	var ClientReactRootIndex = {
	  createReactRootIndex: function() {
	    return nextReactRootIndex++;
	  }
	};

	module.exports = ClientReactRootIndex;

	},{}],8:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule CompositionEventPlugin
	 * @typechecks static-only
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var EventPropagators = _dereq_("./EventPropagators");
	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");
	var ReactInputSelection = _dereq_("./ReactInputSelection");
	var SyntheticCompositionEvent = _dereq_("./SyntheticCompositionEvent");

	var getTextContentAccessor = _dereq_("./getTextContentAccessor");
	var keyOf = _dereq_("./keyOf");

	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;

	var useCompositionEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'CompositionEvent' in window
	);

	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. In Korean, for example,
	// the compositionend event contains only one character regardless of
	// how many characters have been composed since compositionstart.
	// We therefore use the fallback data while still using the native
	// events as triggers.
	var useFallbackData = (
	  !useCompositionEvent ||
	  (
	    'documentMode' in document &&
	    document.documentMode > 8 &&
	    document.documentMode <= 11
	  )
	);

	var topLevelTypes = EventConstants.topLevelTypes;
	var currentComposition = null;

	// Events and their corresponding property names.
	var eventTypes = {
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionEnd: null}),
	      captured: keyOf({onCompositionEndCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionStart: null}),
	      captured: keyOf({onCompositionStartCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionStart,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionUpdate: null}),
	      captured: keyOf({onCompositionUpdateCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionUpdate,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  }
	};

	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}

	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackStart(topLevelType, nativeEvent) {
	  return (
	    topLevelType === topLevelTypes.topKeyDown &&
	    nativeEvent.keyCode === START_KEYCODE
	  );
	}

	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return (END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1);
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return (nativeEvent.keyCode !== START_KEYCODE);
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}

	/**
	 * Helper class stores information about selection and document state
	 * so we can figure out what changed at a later date.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this.root = root;
	  this.startSelection = ReactInputSelection.getSelection(root);
	  this.startValue = this.getText();
	}

	/**
	 * Get current text of input.
	 *
	 * @return {string}
	 */
	FallbackCompositionState.prototype.getText = function() {
	  return this.root.value || this.root[getTextContentAccessor()];
	};

	/**
	 * Text that has changed since the start of composition.
	 *
	 * @return {string}
	 */
	FallbackCompositionState.prototype.getData = function() {
	  var endValue = this.getText();
	  var prefixLength = this.startSelection.start;
	  var suffixLength = this.startValue.length - this.startSelection.end;

	  return endValue.substr(
	    prefixLength,
	    endValue.length - suffixLength - prefixLength
	  );
	};

	/**
	 * This plugin creates `onCompositionStart`, `onCompositionUpdate` and
	 * `onCompositionEnd` events on inputs, textareas and contentEditable
	 * nodes.
	 */
	var CompositionEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {

	    var eventType;
	    var data;

	    if (useCompositionEvent) {
	      eventType = getCompositionEventType(topLevelType);
	    } else if (!currentComposition) {
	      if (isFallbackStart(topLevelType, nativeEvent)) {
	        eventType = eventTypes.compositionStart;
	      }
	    } else if (isFallbackEnd(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionEnd;
	    }

	    if (useFallbackData) {
	      // The current composition is stored statically and must not be
	      // overwritten while composition continues.
	      if (!currentComposition && eventType === eventTypes.compositionStart) {
	        currentComposition = new FallbackCompositionState(topLevelTarget);
	      } else if (eventType === eventTypes.compositionEnd) {
	        if (currentComposition) {
	          data = currentComposition.getData();
	          currentComposition = null;
	        }
	      }
	    }

	    if (eventType) {
	      var event = SyntheticCompositionEvent.getPooled(
	        eventType,
	        topLevelTargetID,
	        nativeEvent
	      );
	      if (data) {
	        // Inject data generated from fallback path into the synthetic event.
	        // This matches the property of native CompositionEventInterface.
	        event.data = data;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	  }
	};

	module.exports = CompositionEventPlugin;

	},{"./EventConstants":15,"./EventPropagators":20,"./ExecutionEnvironment":21,"./ReactInputSelection":58,"./SyntheticCompositionEvent":82,"./getTextContentAccessor":115,"./keyOf":127}],9:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */

	"use strict";

	var Danger = _dereq_("./Danger");
	var ReactMultiChildUpdateTypes = _dereq_("./ReactMultiChildUpdateTypes");

	var getTextContentAccessor = _dereq_("./getTextContentAccessor");
	var invariant = _dereq_("./invariant");

	/**
	 * The DOM property to use when setting text content.
	 *
	 * @type {string}
	 * @private
	 */
	var textContentAccessor = getTextContentAccessor();

	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	  parentNode.insertBefore(
	    childNode,
	    parentNode.childNodes[index] || null
	  );
	}

	var updateTextContent;
	if (textContentAccessor === 'textContent') {
	  /**
	   * Sets the text content of `node` to `text`.
	   *
	   * @param {DOMElement} node Node to change
	   * @param {string} text New text content
	   */
	  updateTextContent = function(node, text) {
	    node.textContent = text;
	  };
	} else {
	  /**
	   * Sets the text content of `node` to `text`.
	   *
	   * @param {DOMElement} node Node to change
	   * @param {string} text New text content
	   */
	  updateTextContent = function(node, text) {
	    // In order to preserve newlines correctly, we can't use .innerText to set
	    // the contents (see #1080), so we empty the element then append a text node
	    while (node.firstChild) {
	      node.removeChild(node.firstChild);
	    }
	    if (text) {
	      var doc = node.ownerDocument || document;
	      node.appendChild(doc.createTextNode(text));
	    }
	  };
	}

	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {

	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,

	  updateTextContent: updateTextContent,

	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function(updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;

	    for (var i = 0; update = updates[i]; i++) {
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING ||
	          update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;

	        ("production" !== "development" ? invariant(
	          updatedChild,
	          'processUpdates(): Unable to find child %s of element. This ' +
	          'probably means the DOM was unexpectedly mutated (e.g., by the ' +
	          'browser), usually due to forgetting a <tbody> when using tables, ' +
	          'nesting <p> or <a> tags, or using non-SVG elements in an <svg> '+
	          'parent. Try inspecting the child nodes of the element with React ' +
	          'ID `%s`.',
	          updatedIndex,
	          parentID
	        ) : invariant(updatedChild));

	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;

	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }

	    var renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);

	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }

	    for (var k = 0; update = updates[k]; k++) {
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(
	            update.parentNode,
	            renderedMarkup[update.markupIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(
	            update.parentNode,
	            initialChildren[update.parentID][update.fromIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          updateTextContent(
	            update.parentNode,
	            update.textContent
	          );
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }

	};

	module.exports = DOMChildrenOperations;

	},{"./Danger":12,"./ReactMultiChildUpdateTypes":63,"./getTextContentAccessor":115,"./invariant":120}],10:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */

	/*jslint bitwise: true */

	"use strict";

	var invariant = _dereq_("./invariant");

	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,

	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function(domPropertyConfig) {
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(
	        domPropertyConfig.isCustomAttribute
	      );
	    }

	    for (var propName in Properties) {
	      ("production" !== "development" ? invariant(
	        !DOMProperty.isStandardName.hasOwnProperty(propName),
	        'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' +
	        '\'%s\' which has already been injected. You may be accidentally ' +
	        'injecting the same DOM property config twice, or you may be ' +
	        'injecting two configs that have conflicting property names.',
	        propName
	      ) : invariant(!DOMProperty.isStandardName.hasOwnProperty(propName)));

	      DOMProperty.isStandardName[propName] = true;

	      var lowerCased = propName.toLowerCase();
	      DOMProperty.getPossibleStandardName[lowerCased] = propName;

	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        DOMProperty.getPossibleStandardName[attributeName] = propName;
	        DOMProperty.getAttributeName[propName] = attributeName;
	      } else {
	        DOMProperty.getAttributeName[propName] = lowerCased;
	      }

	      DOMProperty.getPropertyName[propName] =
	        DOMPropertyNames.hasOwnProperty(propName) ?
	          DOMPropertyNames[propName] :
	          propName;

	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        DOMProperty.getMutationMethod[propName] = DOMMutationMethods[propName];
	      } else {
	        DOMProperty.getMutationMethod[propName] = null;
	      }

	      var propConfig = Properties[propName];
	      DOMProperty.mustUseAttribute[propName] =
	        propConfig & DOMPropertyInjection.MUST_USE_ATTRIBUTE;
	      DOMProperty.mustUseProperty[propName] =
	        propConfig & DOMPropertyInjection.MUST_USE_PROPERTY;
	      DOMProperty.hasSideEffects[propName] =
	        propConfig & DOMPropertyInjection.HAS_SIDE_EFFECTS;
	      DOMProperty.hasBooleanValue[propName] =
	        propConfig & DOMPropertyInjection.HAS_BOOLEAN_VALUE;
	      DOMProperty.hasNumericValue[propName] =
	        propConfig & DOMPropertyInjection.HAS_NUMERIC_VALUE;
	      DOMProperty.hasPositiveNumericValue[propName] =
	        propConfig & DOMPropertyInjection.HAS_POSITIVE_NUMERIC_VALUE;
	      DOMProperty.hasOverloadedBooleanValue[propName] =
	        propConfig & DOMPropertyInjection.HAS_OVERLOADED_BOOLEAN_VALUE;

	      ("production" !== "development" ? invariant(
	        !DOMProperty.mustUseAttribute[propName] ||
	          !DOMProperty.mustUseProperty[propName],
	        'DOMProperty: Cannot require using both attribute and property: %s',
	        propName
	      ) : invariant(!DOMProperty.mustUseAttribute[propName] ||
	        !DOMProperty.mustUseProperty[propName]));
	      ("production" !== "development" ? invariant(
	        DOMProperty.mustUseProperty[propName] ||
	          !DOMProperty.hasSideEffects[propName],
	        'DOMProperty: Properties that have side effects must use property: %s',
	        propName
	      ) : invariant(DOMProperty.mustUseProperty[propName] ||
	        !DOMProperty.hasSideEffects[propName]));
	      ("production" !== "development" ? invariant(
	        !!DOMProperty.hasBooleanValue[propName] +
	          !!DOMProperty.hasNumericValue[propName] +
	          !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1,
	        'DOMProperty: Value can be one of boolean, overloaded boolean, or ' +
	        'numeric value, but not a combination: %s',
	        propName
	      ) : invariant(!!DOMProperty.hasBooleanValue[propName] +
	        !!DOMProperty.hasNumericValue[propName] +
	        !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1));
	    }
	  }
	};
	var defaultValueCache = {};

	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {

	  ID_ATTRIBUTE_NAME: 'data-reactid',

	  /**
	   * Checks whether a property name is a standard property.
	   * @type {Object}
	   */
	  isStandardName: {},

	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties.
	   * @type {Object}
	   */
	  getPossibleStandardName: {},

	  /**
	   * Mapping from normalized names to attribute names that differ. Attribute
	   * names are used when rendering markup or with `*Attribute()`.
	   * @type {Object}
	   */
	  getAttributeName: {},

	  /**
	   * Mapping from normalized names to properties on DOM node instances.
	   * (This includes properties that mutate due to external factors.)
	   * @type {Object}
	   */
	  getPropertyName: {},

	  /**
	   * Mapping from normalized names to mutation methods. This will only exist if
	   * mutation cannot be set simply by the property or `setAttribute()`.
	   * @type {Object}
	   */
	  getMutationMethod: {},

	  /**
	   * Whether the property must be accessed and mutated as an object property.
	   * @type {Object}
	   */
	  mustUseAttribute: {},

	  /**
	   * Whether the property must be accessed and mutated using `*Attribute()`.
	   * (This includes anything that fails `<propName> in <element>`.)
	   * @type {Object}
	   */
	  mustUseProperty: {},

	  /**
	   * Whether or not setting a value causes side effects such as triggering
	   * resources to be loaded or text selection changes. We must ensure that
	   * the value is only set if it has changed.
	   * @type {Object}
	   */
	  hasSideEffects: {},

	  /**
	   * Whether the property should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasBooleanValue: {},

	  /**
	   * Whether the property must be numeric or parse as a
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasNumericValue: {},

	  /**
	   * Whether the property must be positive numeric or parse as a positive
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasPositiveNumericValue: {},

	  /**
	   * Whether the property can be used as a flag as well as with a value. Removed
	   * when strictly equal to false; present without a value when strictly equal
	   * to true; present with a value otherwise.
	   * @type {Object}
	   */
	  hasOverloadedBooleanValue: {},

	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],

	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function(attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },

	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function(nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },

	  injection: DOMPropertyInjection
	};

	module.exports = DOMProperty;

	},{"./invariant":120}],11:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */

	"use strict";

	var DOMProperty = _dereq_("./DOMProperty");

	var escapeTextForBrowser = _dereq_("./escapeTextForBrowser");
	var memoizeStringOnly = _dereq_("./memoizeStringOnly");
	var warning = _dereq_("./warning");

	function shouldIgnoreValue(name, value) {
	  return value == null ||
	    (DOMProperty.hasBooleanValue[name] && !value) ||
	    (DOMProperty.hasNumericValue[name] && isNaN(value)) ||
	    (DOMProperty.hasPositiveNumericValue[name] && (value < 1)) ||
	    (DOMProperty.hasOverloadedBooleanValue[name] && value === false);
	}

	var processAttributeNameAndPrefix = memoizeStringOnly(function(name) {
	  return escapeTextForBrowser(name) + '="';
	});

	if ("production" !== "development") {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};

	  var warnUnknownProperty = function(name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] ||
	        warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }

	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();

	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = (
	      DOMProperty.isCustomAttribute(lowerCasedName) ?
	        lowerCasedName :
	      DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ?
	        DOMProperty.getPossibleStandardName[lowerCasedName] :
	        null
	    );

	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    ("production" !== "development" ? warning(
	      standardName == null,
	      'Unknown DOM property ' + name + '. Did you mean ' + standardName + '?'
	    ) : null);

	  };
	}

	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {

	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function(id) {
	    return processAttributeNameAndPrefix(DOMProperty.ID_ATTRIBUTE_NAME) +
	      escapeTextForBrowser(id) + '"';
	  },

	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function(name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      if (shouldIgnoreValue(name, value)) {
	        return '';
	      }
	      var attributeName = DOMProperty.getAttributeName[name];
	      if (DOMProperty.hasBooleanValue[name] ||
	          (DOMProperty.hasOverloadedBooleanValue[name] && value === true)) {
	        return escapeTextForBrowser(attributeName);
	      }
	      return processAttributeNameAndPrefix(attributeName) +
	        escapeTextForBrowser(value) + '"';
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return processAttributeNameAndPrefix(name) +
	        escapeTextForBrowser(value) + '"';
	    } else if ("production" !== "development") {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },

	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function(node, name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(name, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        node.setAttribute(DOMProperty.getAttributeName[name], '' + value);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        if (!DOMProperty.hasSideEffects[name] || node[propName] !== value) {
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        node.removeAttribute(name);
	      } else {
	        node.setAttribute(name, '' + value);
	      }
	    } else if ("production" !== "development") {
	      warnUnknownProperty(name);
	    }
	  },

	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function(node, name) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        node.removeAttribute(DOMProperty.getAttributeName[name]);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        var defaultValue = DOMProperty.getDefaultValueForProperty(
	          node.nodeName,
	          propName
	        );
	        if (!DOMProperty.hasSideEffects[name] ||
	            node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if ("production" !== "development") {
	      warnUnknownProperty(name);
	    }
	  }

	};

	module.exports = DOMPropertyOperations;

	},{"./DOMProperty":10,"./escapeTextForBrowser":104,"./memoizeStringOnly":129,"./warning":143}],12:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */

	/*jslint evil: true, sub: true */

	"use strict";

	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	var createNodesFromMarkup = _dereq_("./createNodesFromMarkup");
	var emptyFunction = _dereq_("./emptyFunction");
	var getMarkupWrap = _dereq_("./getMarkupWrap");
	var invariant = _dereq_("./invariant");

	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';

	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}

	var Danger = {

	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function(markupList) {
	    ("production" !== "development" ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyRenderMarkup(...): Cannot render markup in a Worker ' +
	      'thread. This is likely a bug in the framework. Please report ' +
	      'immediately.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      ("production" !== "development" ? invariant(
	        markupList[i],
	        'dangerouslyRenderMarkup(...): Missing markup.'
	      ) : invariant(markupList[i]));
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];

	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      for (var resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];

	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(
	            OPEN_TAG_NAME_EXP,
	            // This index will be parsed back out below.
	            '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" '
	          );
	        }
	      }

	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(
	        markupListByNodeName.join(''),
	        emptyFunction // Do nothing special with <script> tags.
	      );

	      for (i = 0; i < renderNodes.length; ++i) {
	        var renderNode = renderNodes[i];
	        if (renderNode.hasAttribute &&
	            renderNode.hasAttribute(RESULT_INDEX_ATTR)) {

	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);

	          ("production" !== "development" ? invariant(
	            !resultList.hasOwnProperty(resultIndex),
	            'Danger: Assigning to an already-occupied result index.'
	          ) : invariant(!resultList.hasOwnProperty(resultIndex)));

	          resultList[resultIndex] = renderNode;

	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;

	        } else if ("production" !== "development") {
	          console.error(
	            "Danger: Discarding unexpected node:",
	            renderNode
	          );
	        }
	      }
	    }

	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    ("production" !== "development" ? invariant(
	      resultListAssignmentCount === resultList.length,
	      'Danger: Did not assign to every index of resultList.'
	    ) : invariant(resultListAssignmentCount === resultList.length));

	    ("production" !== "development" ? invariant(
	      resultList.length === markupList.length,
	      'Danger: Expected markup to render %s nodes, but rendered %s.',
	      markupList.length,
	      resultList.length
	    ) : invariant(resultList.length === markupList.length));

	    return resultList;
	  },

	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function(oldChild, markup) {
	    ("production" !== "development" ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' +
	      'worker thread. This is likely a bug in the framework. Please report ' +
	      'immediately.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    ("production" !== "development" ? invariant(markup, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(markup));
	    ("production" !== "development" ? invariant(
	      oldChild.tagName.toLowerCase() !== 'html',
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' +
	      '<html> node. This is because browser quirks make this unreliable ' +
	      'and/or slow. If you want to render to the root you must use ' +
	      'server rendering. See renderComponentToString().'
	    ) : invariant(oldChild.tagName.toLowerCase() !== 'html'));

	    var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }

	};

	module.exports = Danger;

	},{"./ExecutionEnvironment":21,"./createNodesFromMarkup":100,"./emptyFunction":102,"./getMarkupWrap":112,"./invariant":120}],13:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */

	"use strict";

	 var keyOf = _dereq_("./keyOf");

	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [
	  keyOf({ResponderEventPlugin: null}),
	  keyOf({SimpleEventPlugin: null}),
	  keyOf({TapEventPlugin: null}),
	  keyOf({EnterLeaveEventPlugin: null}),
	  keyOf({ChangeEventPlugin: null}),
	  keyOf({SelectEventPlugin: null}),
	  keyOf({CompositionEventPlugin: null}),
	  keyOf({BeforeInputEventPlugin: null}),
	  keyOf({AnalyticsEventPlugin: null}),
	  keyOf({MobileSafariClickEventPlugin: null})
	];

	module.exports = DefaultEventPluginOrder;

	},{"./keyOf":127}],14:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var EventPropagators = _dereq_("./EventPropagators");
	var SyntheticMouseEvent = _dereq_("./SyntheticMouseEvent");

	var ReactMount = _dereq_("./ReactMount");
	var keyOf = _dereq_("./keyOf");

	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;

	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({onMouseEnter: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  },
	  mouseLeave: {
	    registrationName: keyOf({onMouseLeave: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  }
	};

	var extractedEvents = [null, null];

	var EnterLeaveEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topMouseOver &&
	        (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut &&
	        topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }

	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }

	    var from, to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      to =
	        getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement) ||
	        win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	    }

	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }

	    var fromID = from ? ReactMount.getID(from) : '';
	    var toID = to ? ReactMount.getID(to) : '';

	    var leave = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseLeave,
	      fromID,
	      nativeEvent
	    );
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;

	    var enter = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseEnter,
	      toID,
	      nativeEvent
	    );
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;

	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);

	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;

	    return extractedEvents;
	  }

	};

	module.exports = EnterLeaveEventPlugin;

	},{"./EventConstants":15,"./EventPropagators":20,"./ReactMount":61,"./SyntheticMouseEvent":88,"./keyOf":127}],15:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventConstants
	 */

	"use strict";

	var keyMirror = _dereq_("./keyMirror");

	var PropagationPhases = keyMirror({bubbled: null, captured: null});

	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topBlur: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topReset: null,
	  topScroll: null,
	  topSelectionChange: null,
	  topSubmit: null,
	  topTextInput: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topWheel: null
	});

	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};

	module.exports = EventConstants;

	},{"./keyMirror":126}],16:[function(_dereq_,module,exports){
	/**
	 * @providesModule EventListener
	 * @typechecks
	 */

	var emptyFunction = _dereq_("./emptyFunction");

	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },

	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function(target, eventType, callback) {
	    if (!target.addEventListener) {
	      if ("production" !== "development") {
	        console.error(
	          'Attempted to listen to events during the capture phase on a ' +
	          'browser that does not support the capture phase. Your application ' +
	          'will not receive some events.'
	        );
	      }
	      return {
	        remove: emptyFunction
	      };
	    } else {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    }
	  },

	  registerDefault: function() {}
	};

	module.exports = EventListener;

	},{"./emptyFunction":102}],17:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventPluginHub
	 */

	"use strict";

	var EventPluginRegistry = _dereq_("./EventPluginRegistry");
	var EventPluginUtils = _dereq_("./EventPluginUtils");

	var accumulate = _dereq_("./accumulate");
	var forEachAccumulated = _dereq_("./forEachAccumulated");
	var invariant = _dereq_("./invariant");
	var isEventSupported = _dereq_("./isEventSupported");
	var monitorCodeUse = _dereq_("./monitorCodeUse");

	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};

	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;

	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @private
	 */
	var executeDispatchesAndRelease = function(event) {
	  if (event) {
	    var executeDispatch = EventPluginUtils.executeDispatch;
	    // Plugins can provide custom behavior when dispatching events.
	    var PluginModule = EventPluginRegistry.getPluginModuleForEvent(event);
	    if (PluginModule && PluginModule.executeDispatch) {
	      executeDispatch = PluginModule.executeDispatch;
	    }
	    EventPluginUtils.executeDispatchesInOrder(event, executeDispatch);

	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};

	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;

	function validateInstanceHandle() {
	  var invalid = !InstanceHandle||
	    !InstanceHandle.traverseTwoPhase ||
	    !InstanceHandle.traverseEnterLeave;
	  if (invalid) {
	    throw new Error('InstanceHandle not injected before use!');
	  }
	}

	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {

	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {

	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,

	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function(InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if ("production" !== "development") {
	        validateInstanceHandle();
	      }
	    },

	    getInstanceHandle: function() {
	      if ("production" !== "development") {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },

	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

	  },

	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,

	  registrationNameModules: EventPluginRegistry.registrationNameModules,

	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function(id, registrationName, listener) {
	    ("production" !== "development" ? invariant(
	      !listener || typeof listener === 'function',
	      'Expected %s listener to be a function, instead got type %s',
	      registrationName, typeof listener
	    ) : invariant(!listener || typeof listener === 'function'));

	    if ("production" !== "development") {
	      // IE8 has no API for event capturing and the `onScroll` event doesn't
	      // bubble.
	      if (registrationName === 'onScroll' &&
	          !isEventSupported('scroll', true)) {
	        monitorCodeUse('react_no_scroll_event');
	        console.warn('This browser doesn\'t support the `onScroll` event');
	      }
	    }
	    var bankForRegistrationName =
	      listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	  },

	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },

	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },

	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function(id) {
	    for (var registrationName in listenerBank) {
	      delete listenerBank[registrationName][id];
	    }
	  },

	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0, l = plugins.length; i < l; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(
	          topLevelType,
	          topLevelTarget,
	          topLevelTargetID,
	          nativeEvent
	        );
	        if (extractedEvents) {
	          events = accumulate(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },

	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function(events) {
	    if (events) {
	      eventQueue = accumulate(eventQueue, events);
	    }
	  },

	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function() {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    forEachAccumulated(processingEventQueue, executeDispatchesAndRelease);
	    ("production" !== "development" ? invariant(
	      !eventQueue,
	      'processEventQueue(): Additional events were enqueued while processing ' +
	      'an event queue. Support for this has not yet been implemented.'
	    ) : invariant(!eventQueue));
	  },

	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function() {
	    listenerBank = {};
	  },

	  __getListenerBank: function() {
	    return listenerBank;
	  }

	};

	module.exports = EventPluginHub;

	},{"./EventPluginRegistry":18,"./EventPluginUtils":19,"./accumulate":94,"./forEachAccumulated":107,"./invariant":120,"./isEventSupported":121,"./monitorCodeUse":134}],18:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;

	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};

	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    ("production" !== "development" ? invariant(
	      pluginIndex > -1,
	      'EventPluginRegistry: Cannot inject event plugins that do not exist in ' +
	      'the plugin ordering, `%s`.',
	      pluginName
	    ) : invariant(pluginIndex > -1));
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    ("production" !== "development" ? invariant(
	      PluginModule.extractEvents,
	      'EventPluginRegistry: Event plugins must implement an `extractEvents` ' +
	      'method, but `%s` does not.',
	      pluginName
	    ) : invariant(PluginModule.extractEvents));
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      ("production" !== "development" ? invariant(
	        publishEventForPlugin(
	          publishedEvents[eventName],
	          PluginModule,
	          eventName
	        ),
	        'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.',
	        eventName,
	        pluginName
	      ) : invariant(publishEventForPlugin(
	        publishedEvents[eventName],
	        PluginModule,
	        eventName
	      )));
	    }
	  }
	}

	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  ("production" !== "development" ? invariant(
	    !EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName),
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'event name, `%s`.',
	    eventName
	  ) : invariant(!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName)));
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(
	          phasedRegistrationName,
	          PluginModule,
	          eventName
	        );
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(
	      dispatchConfig.registrationName,
	      PluginModule,
	      eventName
	    );
	    return true;
	  }
	  return false;
	}

	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  ("production" !== "development" ? invariant(
	    !EventPluginRegistry.registrationNameModules[registrationName],
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'registration name, `%s`.',
	    registrationName
	  ) : invariant(!EventPluginRegistry.registrationNameModules[registrationName]));
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] =
	    PluginModule.eventTypes[eventName].dependencies;
	}

	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {

	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],

	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},

	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},

	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},

	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function(InjectedEventPluginOrder) {
	    ("production" !== "development" ? invariant(
	      !EventPluginOrder,
	      'EventPluginRegistry: Cannot inject event plugin ordering more than ' +
	      'once. You are likely trying to load more than one copy of React.'
	    ) : invariant(!EventPluginOrder));
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },

	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function(injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) ||
	          namesToPlugins[pluginName] !== PluginModule) {
	        ("production" !== "development" ? invariant(
	          !namesToPlugins[pluginName],
	          'EventPluginRegistry: Cannot inject two different event plugins ' +
	          'using the same name, `%s`.',
	          pluginName
	        ) : invariant(!namesToPlugins[pluginName]));
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },

	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function(event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[
	        dispatchConfig.registrationName
	      ] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[
	        dispatchConfig.phasedRegistrationNames[phase]
	      ];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },

	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function() {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;

	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }

	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }

	};

	module.exports = EventPluginRegistry;

	},{"./invariant":120}],19:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventPluginUtils
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");

	var invariant = _dereq_("./invariant");

	/**
	 * Injected dependencies:
	 */

	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function(InjectedMount) {
	    injection.Mount = InjectedMount;
	    if ("production" !== "development") {
	      ("production" !== "development" ? invariant(
	        InjectedMount && InjectedMount.getNode,
	        'EventPluginUtils.injection.injectMount(...): Injected Mount module ' +
	        'is missing getNode.'
	      ) : invariant(InjectedMount && InjectedMount.getNode));
	    }
	  }
	};

	var topLevelTypes = EventConstants.topLevelTypes;

	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp ||
	         topLevelType === topLevelTypes.topTouchEnd ||
	         topLevelType === topLevelTypes.topTouchCancel;
	}

	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove ||
	         topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown ||
	         topLevelType === topLevelTypes.topTouchStart;
	}


	var validateEventDispatches;
	if ("production" !== "development") {
	  validateEventDispatches = function(event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;

	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ?
	      dispatchListeners.length :
	      dispatchListeners ? 1 : 0;

	    ("production" !== "development" ? invariant(
	      idsIsArr === listenersIsArr && IDsLen === listenersLen,
	      'EventPluginUtils: Invalid `event`.'
	    ) : invariant(idsIsArr === listenersIsArr && IDsLen === listenersLen));
	  };
	}

	/**
	 * Invokes `cb(event, listener, id)`. Avoids using call if no scope is
	 * provided. The `(listener,id)` pair effectively forms the "dispatch" but are
	 * kept separate to conserve memory.
	 */
	function forEachEventDispatch(event, cb) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if ("production" !== "development") {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      cb(event, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    cb(event, dispatchListeners, dispatchIDs);
	  }
	}

	/**
	 * Default implementation of PluginModule.executeDispatch().
	 * @param {SyntheticEvent} SyntheticEvent to handle
	 * @param {function} Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, listener, domID) {
	  event.currentTarget = injection.Mount.getNode(domID);
	  var returnValue = listener(event, domID);
	  event.currentTarget = null;
	  return returnValue;
	}

	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, executeDispatch) {
	  forEachEventDispatch(event, executeDispatch);
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}

	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return id of the first dispatch execution who's listener returns true, or
	 * null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if ("production" !== "development") {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}

	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}

	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if ("production" !== "development") {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  ("production" !== "development" ? invariant(
	    !Array.isArray(dispatchListener),
	    'executeDirectDispatch(...): Invalid `event`.'
	  ) : invariant(!Array.isArray(dispatchListener)));
	  var res = dispatchListener ?
	    dispatchListener(event, dispatchID) :
	    null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}

	/**
	 * @param {SyntheticEvent} event
	 * @return {bool} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}

	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,

	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatch: executeDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	  injection: injection,
	  useTouchEvents: false
	};

	module.exports = EventPluginUtils;

	},{"./EventConstants":15,"./invariant":120}],20:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventPropagators
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var EventPluginHub = _dereq_("./EventPluginHub");

	var accumulate = _dereq_("./accumulate");
	var forEachAccumulated = _dereq_("./forEachAccumulated");

	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;

	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName =
	    event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}

	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if ("production" !== "development") {
	    if (!domID) {
	      throw new Error('Dispatching id must not be null');
	    }
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulate(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulate(event._dispatchIDs, domID);
	  }
	}

	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We can not perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(
	      event.dispatchMarker,
	      accumulateDirectionalDispatches,
	      event
	    );
	  }
	}


	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulate(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulate(event._dispatchIDs, id);
	    }
	  }
	}

	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}

	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}

	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(
	    fromID,
	    toID,
	    accumulateDispatches,
	    leave,
	    enter
	  );
	}


	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}



	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};

	module.exports = EventPropagators;

	},{"./EventConstants":15,"./EventPluginHub":17,"./accumulate":94,"./forEachAccumulated":107}],21:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ExecutionEnvironment
	 */

	/*jslint evil: true */

	"use strict";

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);

	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {

	  canUseDOM: canUseDOM,

	  canUseWorkers: typeof Worker !== 'undefined',

	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),

	  canUseViewport: canUseDOM && !!window.screen,

	  isInWorker: !canUseDOM // For now, this is true - might change in the future.

	};

	module.exports = ExecutionEnvironment;

	},{}],22:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */

	/*jslint bitwise: true*/

	"use strict";

	var DOMProperty = _dereq_("./DOMProperty");
	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE =
	  DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE =
	  DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = (
	    implementation &&
	    implementation.hasFeature &&
	    implementation.hasFeature(
	      'http://www.w3.org/TR/SVG11/feature#BasicStructure',
	      '1.1'
	    )
	  );
	}


	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(
	    /^(data|aria)-[a-z_][a-z\d_.\-]*$/
	  ),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusMixin
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    label: null,
	    lang: null,
	    list: null,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scrollLeft: MUST_USE_PROPERTY,
	    scrolling: null,
	    scrollTop: MUST_USE_PROPERTY,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,

	    /**
	     * Non-standard Properties
	     */
	    autoCapitalize: null, // Supported in Mobile Safari for keyboard hints
	    autoCorrect: null, // Supported in Mobile Safari for keyboard hints
	    itemProp: MUST_USE_ATTRIBUTE, // Microdata: http://schema.org/docs/gs.html
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE, // Microdata: http://schema.org/docs/gs.html
	    itemType: MUST_USE_ATTRIBUTE, // Microdata: http://schema.org/docs/gs.html
	    property: null // Supports OG in meta tags
	  },
	  DOMAttributeNames: {
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoCapitalize: 'autocapitalize',
	    autoComplete: 'autocomplete',
	    autoCorrect: 'autocorrect',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    encType: 'enctype',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};

	module.exports = HTMLDOMPropertyConfig;

	},{"./DOMProperty":10,"./ExecutionEnvironment":21}],23:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */

	"use strict";

	var ReactPropTypes = _dereq_("./ReactPropTypes");

	var invariant = _dereq_("./invariant");

	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};

	function _assertSingleLink(input) {
	  ("production" !== "development" ? invariant(
	    input.props.checkedLink == null || input.props.valueLink == null,
	    'Cannot provide a checkedLink and a valueLink. If you want to use ' +
	    'checkedLink, you probably don\'t want to use valueLink and vice versa.'
	  ) : invariant(input.props.checkedLink == null || input.props.valueLink == null));
	}
	function _assertValueLink(input) {
	  _assertSingleLink(input);
	  ("production" !== "development" ? invariant(
	    input.props.value == null && input.props.onChange == null,
	    'Cannot provide a valueLink and a value or onChange event. If you want ' +
	    'to use value or onChange, you probably don\'t want to use valueLink.'
	  ) : invariant(input.props.value == null && input.props.onChange == null));
	}

	function _assertCheckedLink(input) {
	  _assertSingleLink(input);
	  ("production" !== "development" ? invariant(
	    input.props.checked == null && input.props.onChange == null,
	    'Cannot provide a checkedLink and a checked property or onChange event. ' +
	    'If you want to use checked or onChange, you probably don\'t want to ' +
	    'use checkedLink'
	  ) : invariant(input.props.checked == null && input.props.onChange == null));
	}

	/**
	 * @param {SyntheticEvent} e change event to handle
	 */
	function _handleLinkedValueChange(e) {
	  /*jshint validthis:true */
	  this.props.valueLink.requestChange(e.target.value);
	}

	/**
	  * @param {SyntheticEvent} e change event to handle
	  */
	function _handleLinkedCheckChange(e) {
	  /*jshint validthis:true */
	  this.props.checkedLink.requestChange(e.target.checked);
	}

	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  Mixin: {
	    propTypes: {
	      value: function(props, propName, componentName) {
	        if (!props[propName] ||
	            hasReadOnlyValue[props.type] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return;
	        }
	        return new Error(
	          'You provided a `value` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultValue`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      checked: function(props, propName, componentName) {
	        if (!props[propName] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return;
	        }
	        return new Error(
	          'You provided a `checked` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultChecked`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      onChange: ReactPropTypes.func
	    }
	  },

	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return input.props.valueLink.value;
	    }
	    return input.props.value;
	  },

	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function(input) {
	    if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return input.props.checkedLink.value;
	    }
	    return input.props.checked;
	  },

	  /**
	   * @param {ReactComponent} input Form component
	   * @return {function} change callback either from onChange prop or link.
	   */
	  getOnChange: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return _handleLinkedValueChange;
	    } else if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return _handleLinkedCheckChange;
	    }
	    return input.props.onChange;
	  }
	};

	module.exports = LinkedValueUtils;

	},{"./ReactPropTypes":69,"./invariant":120}],24:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule LocalEventTrapMixin
	 */

	"use strict";

	var ReactBrowserEventEmitter = _dereq_("./ReactBrowserEventEmitter");

	var accumulate = _dereq_("./accumulate");
	var forEachAccumulated = _dereq_("./forEachAccumulated");
	var invariant = _dereq_("./invariant");

	function remove(event) {
	  event.remove();
	}

	var LocalEventTrapMixin = {
	  trapBubbledEvent:function(topLevelType, handlerBaseName) {
	    ("production" !== "development" ? invariant(this.isMounted(), 'Must be mounted to trap events') : invariant(this.isMounted()));
	    var listener = ReactBrowserEventEmitter.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      this.getDOMNode()
	    );
	    this._localEventListeners = accumulate(this._localEventListeners, listener);
	  },

	  // trapCapturedEvent would look nearly identical. We don't implement that
	  // method because it isn't currently needed.

	  componentWillUnmount:function() {
	    if (this._localEventListeners) {
	      forEachAccumulated(this._localEventListeners, remove);
	    }
	  }
	};

	module.exports = LocalEventTrapMixin;

	},{"./ReactBrowserEventEmitter":29,"./accumulate":94,"./forEachAccumulated":107,"./invariant":120}],25:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule MobileSafariClickEventPlugin
	 * @typechecks static-only
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");

	var emptyFunction = _dereq_("./emptyFunction");

	var topLevelTypes = EventConstants.topLevelTypes;

	/**
	 * Mobile Safari does not fire properly bubble click events on non-interactive
	 * elements, which means delegated click listeners do not fire. The workaround
	 * for this bug involves attaching an empty click listener on the target node.
	 *
	 * This particular plugin works around the bug by attaching an empty click
	 * listener on `touchstart` (which does fire on every element).
	 */
	var MobileSafariClickEventPlugin = {

	  eventTypes: null,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topTouchStart) {
	      var target = nativeEvent.target;
	      if (target && !target.onclick) {
	        target.onclick = emptyFunction;
	      }
	    }
	  }

	};

	module.exports = MobileSafariClickEventPlugin;

	},{"./EventConstants":15,"./emptyFunction":102}],26:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule PooledClass
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};

	var twoArgumentPooler = function(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};

	var threeArgumentPooler = function(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};

	var fiveArgumentPooler = function(a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};

	var standardReleaser = function(instance) {
	  var Klass = this;
	  ("production" !== "development" ? invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  ) : invariant(instance instanceof Klass));
	  if (instance.destructor) {
	    instance.destructor();
	  }
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};

	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;

	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function(CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};

	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};

	module.exports = PooledClass;

	},{"./invariant":120}],27:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule React
	 */

	"use strict";

	var DOMPropertyOperations = _dereq_("./DOMPropertyOperations");
	var EventPluginUtils = _dereq_("./EventPluginUtils");
	var ReactChildren = _dereq_("./ReactChildren");
	var ReactComponent = _dereq_("./ReactComponent");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactContext = _dereq_("./ReactContext");
	var ReactCurrentOwner = _dereq_("./ReactCurrentOwner");
	var ReactDescriptor = _dereq_("./ReactDescriptor");
	var ReactDOM = _dereq_("./ReactDOM");
	var ReactDOMComponent = _dereq_("./ReactDOMComponent");
	var ReactDefaultInjection = _dereq_("./ReactDefaultInjection");
	var ReactInstanceHandles = _dereq_("./ReactInstanceHandles");
	var ReactMount = _dereq_("./ReactMount");
	var ReactMultiChild = _dereq_("./ReactMultiChild");
	var ReactPerf = _dereq_("./ReactPerf");
	var ReactPropTypes = _dereq_("./ReactPropTypes");
	var ReactServerRendering = _dereq_("./ReactServerRendering");
	var ReactTextComponent = _dereq_("./ReactTextComponent");

	var onlyChild = _dereq_("./onlyChild");
	var warning = _dereq_("./warning");

	ReactDefaultInjection.inject();

	// Specifying arguments isn't necessary since we just use apply anyway, but it
	// makes it clear for those actually consuming this API.
	function createDescriptor(type, props, children) {
	  var args = Array.prototype.slice.call(arguments, 1);
	  return type.apply(null, args);
	}

	if ("production" !== "development") {
	  var _warnedForDeprecation = false;
	}

	var React = {
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    only: onlyChild
	  },
	  DOM: ReactDOM,
	  PropTypes: ReactPropTypes,
	  initializeTouchEvents: function(shouldUseTouch) {
	    EventPluginUtils.useTouchEvents = shouldUseTouch;
	  },
	  createClass: ReactCompositeComponent.createClass,
	  createDescriptor: function() {
	    if ("production" !== "development") {
	      ("production" !== "development" ? warning(
	        _warnedForDeprecation,
	        'React.createDescriptor is deprecated and will be removed in the ' +
	        'next version of React. Use React.createElement instead.'
	      ) : null);
	      _warnedForDeprecation = true;
	    }
	    return createDescriptor.apply(this, arguments);
	  },
	  createElement: createDescriptor,
	  constructAndRenderComponent: ReactMount.constructAndRenderComponent,
	  constructAndRenderComponentByID: ReactMount.constructAndRenderComponentByID,
	  renderComponent: ReactPerf.measure(
	    'React',
	    'renderComponent',
	    ReactMount.renderComponent
	  ),
	  renderComponentToString: ReactServerRendering.renderComponentToString,
	  renderComponentToStaticMarkup:
	    ReactServerRendering.renderComponentToStaticMarkup,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  isValidClass: ReactDescriptor.isValidFactory,
	  isValidComponent: ReactDescriptor.isValidDescriptor,
	  withContext: ReactContext.withContext,
	  __internals: {
	    Component: ReactComponent,
	    CurrentOwner: ReactCurrentOwner,
	    DOMComponent: ReactDOMComponent,
	    DOMPropertyOperations: DOMPropertyOperations,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    MultiChild: ReactMultiChild,
	    TextComponent: ReactTextComponent
	  }
	};

	if ("production" !== "development") {
	  var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");
	  if (ExecutionEnvironment.canUseDOM &&
	      window.top === window.self &&
	      navigator.userAgent.indexOf('Chrome') > -1) {
	    console.debug(
	      'Download the React DevTools for a better development experience: ' +
	      'http://fb.me/react-devtools'
	    );

	    var expectedFeatures = [
	      // shims
	      Array.isArray,
	      Array.prototype.every,
	      Array.prototype.forEach,
	      Array.prototype.indexOf,
	      Array.prototype.map,
	      Date.now,
	      Function.prototype.bind,
	      Object.keys,
	      String.prototype.split,
	      String.prototype.trim,

	      // shams
	      Object.create,
	      Object.freeze
	    ];

	    for (var i in expectedFeatures) {
	      if (!expectedFeatures[i]) {
	        console.error(
	          'One or more ES5 shim/shams expected by React are not available: ' +
	          'http://fb.me/react-warning-polyfills'
	        );
	        break;
	      }
	    }
	  }
	}

	// Version exists only in the open-source version of React, not in Facebook's
	// internal version.
	React.version = '0.11.2';

	module.exports = React;

	},{"./DOMPropertyOperations":11,"./EventPluginUtils":19,"./ExecutionEnvironment":21,"./ReactChildren":30,"./ReactComponent":31,"./ReactCompositeComponent":33,"./ReactContext":34,"./ReactCurrentOwner":35,"./ReactDOM":36,"./ReactDOMComponent":38,"./ReactDefaultInjection":48,"./ReactDescriptor":51,"./ReactInstanceHandles":59,"./ReactMount":61,"./ReactMultiChild":62,"./ReactPerf":65,"./ReactPropTypes":69,"./ReactServerRendering":73,"./ReactTextComponent":75,"./onlyChild":135,"./warning":143}],28:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */

	"use strict";

	var ReactEmptyComponent = _dereq_("./ReactEmptyComponent");
	var ReactMount = _dereq_("./ReactMount");

	var invariant = _dereq_("./invariant");

	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function() {
	    ("production" !== "development" ? invariant(
	      this.isMounted(),
	      'getDOMNode(): A component must be mounted to have a DOM node.'
	    ) : invariant(this.isMounted()));
	    if (ReactEmptyComponent.isNullComponentID(this._rootNodeID)) {
	      return null;
	    }
	    return ReactMount.getNode(this._rootNodeID);
	  }
	};

	module.exports = ReactBrowserComponentMixin;

	},{"./ReactEmptyComponent":53,"./ReactMount":61,"./invariant":120}],29:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var EventPluginHub = _dereq_("./EventPluginHub");
	var EventPluginRegistry = _dereq_("./EventPluginRegistry");
	var ReactEventEmitterMixin = _dereq_("./ReactEventEmitterMixin");
	var ViewportMetrics = _dereq_("./ViewportMetrics");

	var isEventSupported = _dereq_("./isEventSupported");
	var merge = _dereq_("./merge");

	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */

	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;

	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topBlur: 'blur',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topScroll: 'scroll',
	  topSelectionChange: 'selectionchange',
	  topTextInput: 'textInput',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topWheel: 'wheel'
	};

	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = "_reactListenersID" + String(Math.random()).slice(2);

	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}

	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = merge(ReactEventEmitterMixin, {

	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,

	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function(ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(
	        ReactBrowserEventEmitter.handleTopLevel
	      );
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },

	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function(enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },

	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function() {
	    return !!(
	      ReactBrowserEventEmitter.ReactEventListener &&
	      ReactBrowserEventEmitter.ReactEventListener.isEnabled()
	    );
	  },

	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function(registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.
	      registrationNameDependencies[registrationName];

	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0, l = dependencies.length; i < l; i++) {
	      var dependency = dependencies[i];
	      if (!(
	            isListening.hasOwnProperty(dependency) &&
	            isListening[dependency]
	          )) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'wheel',
	              mountAt
	            );
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'mousewheel',
	              mountAt
	            );
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'DOMMouseScroll',
	              mountAt
	            );
	          }
	        } else if (dependency === topLevelTypes.topScroll) {

	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              mountAt
	            );
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE
	            );
	          }
	        } else if (dependency === topLevelTypes.topFocus ||
	            dependency === topLevelTypes.topBlur) {

	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topFocus,
	              'focus',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topBlur,
	              'blur',
	              mountAt
	            );
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topFocus,
	              'focusin',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topBlur,
	              'focusout',
	              mountAt
	            );
	          }

	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	            dependency,
	            topEventMapping[dependency],
	            mountAt
	          );
	        }

	        isListening[dependency] = true;
	      }
	    }
	  },

	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },

	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },

	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function(){
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },

	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,

	  registrationNameModules: EventPluginHub.registrationNameModules,

	  putListener: EventPluginHub.putListener,

	  getListener: EventPluginHub.getListener,

	  deleteListener: EventPluginHub.deleteListener,

	  deleteAllListeners: EventPluginHub.deleteAllListeners

	});

	module.exports = ReactBrowserEventEmitter;

	},{"./EventConstants":15,"./EventPluginHub":17,"./EventPluginRegistry":18,"./ReactEventEmitterMixin":55,"./ViewportMetrics":93,"./isEventSupported":121,"./merge":130}],30:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactChildren
	 */

	"use strict";

	var PooledClass = _dereq_("./PooledClass");

	var traverseAllChildren = _dereq_("./traverseAllChildren");
	var warning = _dereq_("./warning");

	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var threeArgumentPooler = PooledClass.threeArgumentPooler;

	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.forEachFunction = forEachFunction;
	  this.forEachContext = forEachContext;
	}
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

	function forEachSingleChild(traverseContext, child, name, i) {
	  var forEachBookKeeping = traverseContext;
	  forEachBookKeeping.forEachFunction.call(
	    forEachBookKeeping.forEachContext, child, i);
	}

	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc.
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }

	  var traverseContext =
	    ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}

	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, mapFunction, mapContext) {
	  this.mapResult = mapResult;
	  this.mapFunction = mapFunction;
	  this.mapContext = mapContext;
	}
	PooledClass.addPoolingTo(MapBookKeeping, threeArgumentPooler);

	function mapSingleChildIntoContext(traverseContext, child, name, i) {
	  var mapBookKeeping = traverseContext;
	  var mapResult = mapBookKeeping.mapResult;

	  var keyUnique = !mapResult.hasOwnProperty(name);
	  ("production" !== "development" ? warning(
	    keyUnique,
	    'ReactChildren.map(...): Encountered two children with the same key, ' +
	    '`%s`. Child keys must be unique; when two children share a key, only ' +
	    'the first child will be used.',
	    name
	  ) : null);

	  if (keyUnique) {
	    var mappedChild =
	      mapBookKeeping.mapFunction.call(mapBookKeeping.mapContext, child, i);
	    mapResult[name] = mappedChild;
	  }
	}

	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * TODO: This may likely break any calls to `ReactChildren.map` that were
	 * previously relying on the fact that we guarded against null children.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} mapFunction.
	 * @param {*} mapContext Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }

	  var mapResult = {};
	  var traverseContext = MapBookKeeping.getPooled(mapResult, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	  return mapResult;
	}

	function forEachSingleChildDummy(traverseContext, child, name, i) {
	  return null;
	}

	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}

	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  count: countChildren
	};

	module.exports = ReactChildren;

	},{"./PooledClass":26,"./traverseAllChildren":142,"./warning":143}],31:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactComponent
	 */

	"use strict";

	var ReactDescriptor = _dereq_("./ReactDescriptor");
	var ReactOwner = _dereq_("./ReactOwner");
	var ReactUpdates = _dereq_("./ReactUpdates");

	var invariant = _dereq_("./invariant");
	var keyMirror = _dereq_("./keyMirror");
	var merge = _dereq_("./merge");

	/**
	 * Every React component is in one of these life cycles.
	 */
	var ComponentLifeCycle = keyMirror({
	  /**
	   * Mounted components have a DOM node representation and are capable of
	   * receiving new props.
	   */
	  MOUNTED: null,
	  /**
	   * Unmounted components are inactive and cannot receive new props.
	   */
	  UNMOUNTED: null
	});

	var injected = false;

	/**
	 * Optionally injectable environment dependent cleanup hook. (server vs.
	 * browser etc). Example: A browser system caches DOM nodes based on component
	 * ID and must remove that cache entry when this instance is unmounted.
	 *
	 * @private
	 */
	var unmountIDFromEnvironment = null;

	/**
	 * The "image" of a component tree, is the platform specific (typically
	 * serialized) data that represents a tree of lower level UI building blocks.
	 * On the web, this "image" is HTML markup which describes a construction of
	 * low level `div` and `span` nodes. Other platforms may have different
	 * encoding of this "image". This must be injected.
	 *
	 * @private
	 */
	var mountImageIntoNode = null;

	/**
	 * Components are the basic units of composition in React.
	 *
	 * Every component accepts a set of keyed input parameters known as "props" that
	 * are initialized by the constructor. Once a component is mounted, the props
	 * can be mutated using `setProps` or `replaceProps`.
	 *
	 * Every component is capable of the following operations:
	 *
	 *   `mountComponent`
	 *     Initializes the component, renders markup, and registers event listeners.
	 *
	 *   `receiveComponent`
	 *     Updates the rendered DOM nodes to match the given component.
	 *
	 *   `unmountComponent`
	 *     Releases any resources allocated by this component.
	 *
	 * Components can also be "owned" by other components. Being owned by another
	 * component means being constructed by that component. This is different from
	 * being the child of a component, which means having a DOM representation that
	 * is a child of the DOM representation of that component.
	 *
	 * @class ReactComponent
	 */
	var ReactComponent = {

	  injection: {
	    injectEnvironment: function(ReactComponentEnvironment) {
	      ("production" !== "development" ? invariant(
	        !injected,
	        'ReactComponent: injectEnvironment() can only be called once.'
	      ) : invariant(!injected));
	      mountImageIntoNode = ReactComponentEnvironment.mountImageIntoNode;
	      unmountIDFromEnvironment =
	        ReactComponentEnvironment.unmountIDFromEnvironment;
	      ReactComponent.BackendIDOperations =
	        ReactComponentEnvironment.BackendIDOperations;
	      injected = true;
	    }
	  },

	  /**
	   * @internal
	   */
	  LifeCycle: ComponentLifeCycle,

	  /**
	   * Injected module that provides ability to mutate individual properties.
	   * Injected into the base class because many different subclasses need access
	   * to this.
	   *
	   * @internal
	   */
	  BackendIDOperations: null,

	  /**
	   * Base functionality for every ReactComponent constructor. Mixed into the
	   * `ReactComponent` prototype, but exposed statically for easy access.
	   *
	   * @lends {ReactComponent.prototype}
	   */
	  Mixin: {

	    /**
	     * Checks whether or not this component is mounted.
	     *
	     * @return {boolean} True if mounted, false otherwise.
	     * @final
	     * @protected
	     */
	    isMounted: function() {
	      return this._lifeCycleState === ComponentLifeCycle.MOUNTED;
	    },

	    /**
	     * Sets a subset of the props.
	     *
	     * @param {object} partialProps Subset of the next props.
	     * @param {?function} callback Called after props are updated.
	     * @final
	     * @public
	     */
	    setProps: function(partialProps, callback) {
	      // Merge with the pending descriptor if it exists, otherwise with existing
	      // descriptor props.
	      var descriptor = this._pendingDescriptor || this._descriptor;
	      this.replaceProps(
	        merge(descriptor.props, partialProps),
	        callback
	      );
	    },

	    /**
	     * Replaces all of the props.
	     *
	     * @param {object} props New props.
	     * @param {?function} callback Called after props are updated.
	     * @final
	     * @public
	     */
	    replaceProps: function(props, callback) {
	      ("production" !== "development" ? invariant(
	        this.isMounted(),
	        'replaceProps(...): Can only update a mounted component.'
	      ) : invariant(this.isMounted()));
	      ("production" !== "development" ? invariant(
	        this._mountDepth === 0,
	        'replaceProps(...): You called `setProps` or `replaceProps` on a ' +
	        'component with a parent. This is an anti-pattern since props will ' +
	        'get reactively updated when rendered. Instead, change the owner\'s ' +
	        '`render` method to pass the correct value as props to the component ' +
	        'where it is created.'
	      ) : invariant(this._mountDepth === 0));
	      // This is a deoptimized path. We optimize for always having a descriptor.
	      // This creates an extra internal descriptor.
	      this._pendingDescriptor = ReactDescriptor.cloneAndReplaceProps(
	        this._pendingDescriptor || this._descriptor,
	        props
	      );
	      ReactUpdates.enqueueUpdate(this, callback);
	    },

	    /**
	     * Schedule a partial update to the props. Only used for internal testing.
	     *
	     * @param {object} partialProps Subset of the next props.
	     * @param {?function} callback Called after props are updated.
	     * @final
	     * @internal
	     */
	    _setPropsInternal: function(partialProps, callback) {
	      // This is a deoptimized path. We optimize for always having a descriptor.
	      // This creates an extra internal descriptor.
	      var descriptor = this._pendingDescriptor || this._descriptor;
	      this._pendingDescriptor = ReactDescriptor.cloneAndReplaceProps(
	        descriptor,
	        merge(descriptor.props, partialProps)
	      );
	      ReactUpdates.enqueueUpdate(this, callback);
	    },

	    /**
	     * Base constructor for all React components.
	     *
	     * Subclasses that override this method should make sure to invoke
	     * `ReactComponent.Mixin.construct.call(this, ...)`.
	     *
	     * @param {ReactDescriptor} descriptor
	     * @internal
	     */
	    construct: function(descriptor) {
	      // This is the public exposed props object after it has been processed
	      // with default props. The descriptor's props represents the true internal
	      // state of the props.
	      this.props = descriptor.props;
	      // Record the component responsible for creating this component.
	      // This is accessible through the descriptor but we maintain an extra
	      // field for compatibility with devtools and as a way to make an
	      // incremental update. TODO: Consider deprecating this field.
	      this._owner = descriptor._owner;

	      // All components start unmounted.
	      this._lifeCycleState = ComponentLifeCycle.UNMOUNTED;

	      // See ReactUpdates.
	      this._pendingCallbacks = null;

	      // We keep the old descriptor and a reference to the pending descriptor
	      // to track updates.
	      this._descriptor = descriptor;
	      this._pendingDescriptor = null;
	    },

	    /**
	     * Initializes the component, renders markup, and registers event listeners.
	     *
	     * NOTE: This does not insert any nodes into the DOM.
	     *
	     * Subclasses that override this method should make sure to invoke
	     * `ReactComponent.Mixin.mountComponent.call(this, ...)`.
	     *
	     * @param {string} rootID DOM ID of the root node.
	     * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	     * @param {number} mountDepth number of components in the owner hierarchy.
	     * @return {?string} Rendered markup to be inserted into the DOM.
	     * @internal
	     */
	    mountComponent: function(rootID, transaction, mountDepth) {
	      ("production" !== "development" ? invariant(
	        !this.isMounted(),
	        'mountComponent(%s, ...): Can only mount an unmounted component. ' +
	        'Make sure to avoid storing components between renders or reusing a ' +
	        'single component instance in multiple places.',
	        rootID
	      ) : invariant(!this.isMounted()));
	      var props = this._descriptor.props;
	      if (props.ref != null) {
	        var owner = this._descriptor._owner;
	        ReactOwner.addComponentAsRefTo(this, props.ref, owner);
	      }
	      this._rootNodeID = rootID;
	      this._lifeCycleState = ComponentLifeCycle.MOUNTED;
	      this._mountDepth = mountDepth;
	      // Effectively: return '';
	    },

	    /**
	     * Releases any resources allocated by `mountComponent`.
	     *
	     * NOTE: This does not remove any nodes from the DOM.
	     *
	     * Subclasses that override this method should make sure to invoke
	     * `ReactComponent.Mixin.unmountComponent.call(this)`.
	     *
	     * @internal
	     */
	    unmountComponent: function() {
	      ("production" !== "development" ? invariant(
	        this.isMounted(),
	        'unmountComponent(): Can only unmount a mounted component.'
	      ) : invariant(this.isMounted()));
	      var props = this.props;
	      if (props.ref != null) {
	        ReactOwner.removeComponentAsRefFrom(this, props.ref, this._owner);
	      }
	      unmountIDFromEnvironment(this._rootNodeID);
	      this._rootNodeID = null;
	      this._lifeCycleState = ComponentLifeCycle.UNMOUNTED;
	    },

	    /**
	     * Given a new instance of this component, updates the rendered DOM nodes
	     * as if that instance was rendered instead.
	     *
	     * Subclasses that override this method should make sure to invoke
	     * `ReactComponent.Mixin.receiveComponent.call(this, ...)`.
	     *
	     * @param {object} nextComponent Next set of properties.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    receiveComponent: function(nextDescriptor, transaction) {
	      ("production" !== "development" ? invariant(
	        this.isMounted(),
	        'receiveComponent(...): Can only update a mounted component.'
	      ) : invariant(this.isMounted()));
	      this._pendingDescriptor = nextDescriptor;
	      this.performUpdateIfNecessary(transaction);
	    },

	    /**
	     * If `_pendingDescriptor` is set, update the component.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    performUpdateIfNecessary: function(transaction) {
	      if (this._pendingDescriptor == null) {
	        return;
	      }
	      var prevDescriptor = this._descriptor;
	      var nextDescriptor = this._pendingDescriptor;
	      this._descriptor = nextDescriptor;
	      this.props = nextDescriptor.props;
	      this._owner = nextDescriptor._owner;
	      this._pendingDescriptor = null;
	      this.updateComponent(transaction, prevDescriptor);
	    },

	    /**
	     * Updates the component's currently mounted representation.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @param {object} prevDescriptor
	     * @internal
	     */
	    updateComponent: function(transaction, prevDescriptor) {
	      var nextDescriptor = this._descriptor;

	      // If either the owner or a `ref` has changed, make sure the newest owner
	      // has stored a reference to `this`, and the previous owner (if different)
	      // has forgotten the reference to `this`. We use the descriptor instead
	      // of the public this.props because the post processing cannot determine
	      // a ref. The ref conceptually lives on the descriptor.

	      // TODO: Should this even be possible? The owner cannot change because
	      // it's forbidden by shouldUpdateReactComponent. The ref can change
	      // if you swap the keys of but not the refs. Reconsider where this check
	      // is made. It probably belongs where the key checking and
	      // instantiateReactComponent is done.

	      if (nextDescriptor._owner !== prevDescriptor._owner ||
	          nextDescriptor.props.ref !== prevDescriptor.props.ref) {
	        if (prevDescriptor.props.ref != null) {
	          ReactOwner.removeComponentAsRefFrom(
	            this, prevDescriptor.props.ref, prevDescriptor._owner
	          );
	        }
	        // Correct, even if the owner is the same, and only the ref has changed.
	        if (nextDescriptor.props.ref != null) {
	          ReactOwner.addComponentAsRefTo(
	            this,
	            nextDescriptor.props.ref,
	            nextDescriptor._owner
	          );
	        }
	      }
	    },

	    /**
	     * Mounts this component and inserts it into the DOM.
	     *
	     * @param {string} rootID DOM ID of the root node.
	     * @param {DOMElement} container DOM element to mount into.
	     * @param {boolean} shouldReuseMarkup If true, do not insert markup
	     * @final
	     * @internal
	     * @see {ReactMount.renderComponent}
	     */
	    mountComponentIntoNode: function(rootID, container, shouldReuseMarkup) {
	      var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	      transaction.perform(
	        this._mountComponentIntoNode,
	        this,
	        rootID,
	        container,
	        transaction,
	        shouldReuseMarkup
	      );
	      ReactUpdates.ReactReconcileTransaction.release(transaction);
	    },

	    /**
	     * @param {string} rootID DOM ID of the root node.
	     * @param {DOMElement} container DOM element to mount into.
	     * @param {ReactReconcileTransaction} transaction
	     * @param {boolean} shouldReuseMarkup If true, do not insert markup
	     * @final
	     * @private
	     */
	    _mountComponentIntoNode: function(
	        rootID,
	        container,
	        transaction,
	        shouldReuseMarkup) {
	      var markup = this.mountComponent(rootID, transaction, 0);
	      mountImageIntoNode(markup, container, shouldReuseMarkup);
	    },

	    /**
	     * Checks if this component is owned by the supplied `owner` component.
	     *
	     * @param {ReactComponent} owner Component to check.
	     * @return {boolean} True if `owners` owns this component.
	     * @final
	     * @internal
	     */
	    isOwnedBy: function(owner) {
	      return this._owner === owner;
	    },

	    /**
	     * Gets another component, that shares the same owner as this one, by ref.
	     *
	     * @param {string} ref of a sibling Component.
	     * @return {?ReactComponent} the actual sibling Component.
	     * @final
	     * @internal
	     */
	    getSiblingByRef: function(ref) {
	      var owner = this._owner;
	      if (!owner || !owner.refs) {
	        return null;
	      }
	      return owner.refs[ref];
	    }
	  }
	};

	module.exports = ReactComponent;

	},{"./ReactDescriptor":51,"./ReactOwner":64,"./ReactUpdates":76,"./invariant":120,"./keyMirror":126,"./merge":130}],32:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */

	/*jslint evil: true */

	"use strict";

	var ReactDOMIDOperations = _dereq_("./ReactDOMIDOperations");
	var ReactMarkupChecksum = _dereq_("./ReactMarkupChecksum");
	var ReactMount = _dereq_("./ReactMount");
	var ReactPerf = _dereq_("./ReactPerf");
	var ReactReconcileTransaction = _dereq_("./ReactReconcileTransaction");

	var getReactRootElementInContainer = _dereq_("./getReactRootElementInContainer");
	var invariant = _dereq_("./invariant");
	var setInnerHTML = _dereq_("./setInnerHTML");


	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;


	/**
	 * Abstracts away all functionality of `ReactComponent` requires knowledge of
	 * the browser context.
	 */
	var ReactComponentBrowserEnvironment = {
	  ReactReconcileTransaction: ReactReconcileTransaction,

	  BackendIDOperations: ReactDOMIDOperations,

	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function(rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  },

	  /**
	   * @param {string} markup Markup string to place into the DOM Element.
	   * @param {DOMElement} container DOM Element to insert markup into.
	   * @param {boolean} shouldReuseMarkup Should reuse the existing markup in the
	   * container if possible.
	   */
	  mountImageIntoNode: ReactPerf.measure(
	    'ReactComponentBrowserEnvironment',
	    'mountImageIntoNode',
	    function(markup, container, shouldReuseMarkup) {
	      ("production" !== "development" ? invariant(
	        container && (
	          container.nodeType === ELEMENT_NODE_TYPE ||
	            container.nodeType === DOC_NODE_TYPE
	        ),
	        'mountComponentIntoNode(...): Target container is not valid.'
	      ) : invariant(container && (
	        container.nodeType === ELEMENT_NODE_TYPE ||
	          container.nodeType === DOC_NODE_TYPE
	      )));

	      if (shouldReuseMarkup) {
	        if (ReactMarkupChecksum.canReuseMarkup(
	          markup,
	          getReactRootElementInContainer(container))) {
	          return;
	        } else {
	          ("production" !== "development" ? invariant(
	            container.nodeType !== DOC_NODE_TYPE,
	            'You\'re trying to render a component to the document using ' +
	            'server rendering but the checksum was invalid. This usually ' +
	            'means you rendered a different component type or props on ' +
	            'the client from the one on the server, or your render() ' +
	            'methods are impure. React cannot handle this case due to ' +
	            'cross-browser quirks by rendering at the document root. You ' +
	            'should look for environment dependent code in your components ' +
	            'and ensure the props are the same client and server side.'
	          ) : invariant(container.nodeType !== DOC_NODE_TYPE));

	          if ("production" !== "development") {
	            console.warn(
	              'React attempted to use reuse markup in a container but the ' +
	              'checksum was invalid. This generally means that you are ' +
	              'using server rendering and the markup generated on the ' +
	              'server was not what the client was expecting. React injected ' +
	              'new markup to compensate which works but you have lost many ' +
	              'of the benefits of server rendering. Instead, figure out ' +
	              'why the markup being generated is different on the client ' +
	              'or server.'
	            );
	          }
	        }
	      }

	      ("production" !== "development" ? invariant(
	        container.nodeType !== DOC_NODE_TYPE,
	        'You\'re trying to render a component to the document but ' +
	          'you didn\'t use server rendering. We can\'t do this ' +
	          'without using server rendering due to cross-browser quirks. ' +
	          'See renderComponentToString() for server rendering.'
	      ) : invariant(container.nodeType !== DOC_NODE_TYPE));

	      setInnerHTML(container, markup);
	    }
	  )
	};

	module.exports = ReactComponentBrowserEnvironment;

	},{"./ReactDOMIDOperations":40,"./ReactMarkupChecksum":60,"./ReactMount":61,"./ReactPerf":65,"./ReactReconcileTransaction":71,"./getReactRootElementInContainer":114,"./invariant":120,"./setInnerHTML":138}],33:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactCompositeComponent
	 */

	"use strict";

	var ReactComponent = _dereq_("./ReactComponent");
	var ReactContext = _dereq_("./ReactContext");
	var ReactCurrentOwner = _dereq_("./ReactCurrentOwner");
	var ReactDescriptor = _dereq_("./ReactDescriptor");
	var ReactDescriptorValidator = _dereq_("./ReactDescriptorValidator");
	var ReactEmptyComponent = _dereq_("./ReactEmptyComponent");
	var ReactErrorUtils = _dereq_("./ReactErrorUtils");
	var ReactOwner = _dereq_("./ReactOwner");
	var ReactPerf = _dereq_("./ReactPerf");
	var ReactPropTransferer = _dereq_("./ReactPropTransferer");
	var ReactPropTypeLocations = _dereq_("./ReactPropTypeLocations");
	var ReactPropTypeLocationNames = _dereq_("./ReactPropTypeLocationNames");
	var ReactUpdates = _dereq_("./ReactUpdates");

	var instantiateReactComponent = _dereq_("./instantiateReactComponent");
	var invariant = _dereq_("./invariant");
	var keyMirror = _dereq_("./keyMirror");
	var merge = _dereq_("./merge");
	var mixInto = _dereq_("./mixInto");
	var monitorCodeUse = _dereq_("./monitorCodeUse");
	var mapObject = _dereq_("./mapObject");
	var shouldUpdateReactComponent = _dereq_("./shouldUpdateReactComponent");
	var warning = _dereq_("./warning");

	/**
	 * Policies that describe methods in `ReactCompositeComponentInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base ReactCompositeComponent class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});


	var injectedMixins = [];

	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactCompositeComponent`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactCompositeComponentInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will available on the prototype.
	 *
	 * @interface ReactCompositeComponentInterface
	 * @internal
	 */
	var ReactCompositeComponentInterface = {

	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,

	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,

	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,

	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,

	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,

	  // ==== Definition methods ====

	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,

	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,

	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,

	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,



	  // ==== Delegate methods ====

	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,

	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,

	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,



	  // ==== Advanced methods ====

	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE

	};

	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function(Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function(Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function(Constructor, childContextTypes) {
	    validateTypeDef(
	      Constructor,
	      childContextTypes,
	      ReactPropTypeLocations.childContext
	    );
	    Constructor.childContextTypes = merge(
	      Constructor.childContextTypes,
	      childContextTypes
	    );
	  },
	  contextTypes: function(Constructor, contextTypes) {
	    validateTypeDef(
	      Constructor,
	      contextTypes,
	      ReactPropTypeLocations.context
	    );
	    Constructor.contextTypes = merge(Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function(Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(
	        Constructor.getDefaultProps,
	        getDefaultProps
	      );
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function(Constructor, propTypes) {
	    validateTypeDef(
	      Constructor,
	      propTypes,
	      ReactPropTypeLocations.prop
	    );
	    Constructor.propTypes = merge(Constructor.propTypes, propTypes);
	  },
	  statics: function(Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  }
	};

	function getDeclarationErrorAddendum(component) {
	  var owner = component._owner || null;
	  if (owner && owner.constructor && owner.constructor.displayName) {
	    return ' Check the render method of `' + owner.constructor.displayName +
	      '`.';
	  }
	  return '';
	}

	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      ("production" !== "development" ? invariant(
	        typeof typeDef[propName] == 'function',
	        '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	        'React.PropTypes.',
	        Constructor.displayName || 'ReactCompositeComponent',
	        ReactPropTypeLocationNames[location],
	        propName
	      ) : invariant(typeof typeDef[propName] == 'function'));
	    }
	  }
	}

	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactCompositeComponentInterface.hasOwnProperty(name) ?
	    ReactCompositeComponentInterface[name] :
	    null;

	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactCompositeComponentMixin.hasOwnProperty(name)) {
	    ("production" !== "development" ? invariant(
	      specPolicy === SpecPolicy.OVERRIDE_BASE,
	      'ReactCompositeComponentInterface: You are attempting to override ' +
	      '`%s` from your class specification. Ensure that your method names ' +
	      'do not overlap with React methods.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.OVERRIDE_BASE));
	  }

	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    ("production" !== "development" ? invariant(
	      specPolicy === SpecPolicy.DEFINE_MANY ||
	      specPolicy === SpecPolicy.DEFINE_MANY_MERGED,
	      'ReactCompositeComponentInterface: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be due ' +
	      'to a mixin.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.DEFINE_MANY ||
	    specPolicy === SpecPolicy.DEFINE_MANY_MERGED));
	  }
	}

	function validateLifeCycleOnReplaceState(instance) {
	  var compositeLifeCycleState = instance._compositeLifeCycleState;
	  ("production" !== "development" ? invariant(
	    instance.isMounted() ||
	      compositeLifeCycleState === CompositeLifeCycle.MOUNTING,
	    'replaceState(...): Can only update a mounted or mounting component.'
	  ) : invariant(instance.isMounted() ||
	    compositeLifeCycleState === CompositeLifeCycle.MOUNTING));
	  ("production" !== "development" ? invariant(compositeLifeCycleState !== CompositeLifeCycle.RECEIVING_STATE,
	    'replaceState(...): Cannot update during an existing state transition ' +
	    '(such as within `render`). This could potentially cause an infinite ' +
	    'loop so it is forbidden.'
	  ) : invariant(compositeLifeCycleState !== CompositeLifeCycle.RECEIVING_STATE));
	  ("production" !== "development" ? invariant(compositeLifeCycleState !== CompositeLifeCycle.UNMOUNTING,
	    'replaceState(...): Cannot update while unmounting component. This ' +
	    'usually means you called setState() on an unmounted component.'
	  ) : invariant(compositeLifeCycleState !== CompositeLifeCycle.UNMOUNTING));
	}

	/**
	 * Custom version of `mixInto` which handles policy validation and reserved
	 * specification keys when building `ReactCompositeComponent` classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  ("production" !== "development" ? invariant(
	    !ReactDescriptor.isValidFactory(spec),
	    'ReactCompositeComponent: You\'re attempting to ' +
	    'use a component class as a mixin. Instead, just use a regular object.'
	  ) : invariant(!ReactDescriptor.isValidFactory(spec)));
	  ("production" !== "development" ? invariant(
	    !ReactDescriptor.isValidDescriptor(spec),
	    'ReactCompositeComponent: You\'re attempting to ' +
	    'use a component as a mixin. Instead, just use a regular object.'
	  ) : invariant(!ReactDescriptor.isValidDescriptor(spec)));

	  var proto = Constructor.prototype;
	  for (var name in spec) {
	    var property = spec[name];
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }

	    validateMethodOverride(proto, name);

	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactCompositeComponent methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isCompositeComponentMethod =
	        ReactCompositeComponentInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var markedDontBind = property && property.__reactDontBind;
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind =
	        isFunction &&
	        !isCompositeComponentMethod &&
	        !isAlreadyDefined &&
	        !markedDontBind;

	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactCompositeComponentInterface[name];

	          // These cases should already be caught by validateMethodOverride
	          ("production" !== "development" ? invariant(
	            isCompositeComponentMethod && (
	              specPolicy === SpecPolicy.DEFINE_MANY_MERGED ||
	              specPolicy === SpecPolicy.DEFINE_MANY
	            ),
	            'ReactCompositeComponent: Unexpected spec policy %s for key %s ' +
	            'when mixing in component specs.',
	            specPolicy,
	            name
	          ) : invariant(isCompositeComponentMethod && (
	            specPolicy === SpecPolicy.DEFINE_MANY_MERGED ||
	            specPolicy === SpecPolicy.DEFINE_MANY
	          )));

	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if ("production" !== "development") {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}

	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }

	    var isInherited = name in Constructor;
	    var result = property;
	    if (isInherited) {
	      var existingProperty = Constructor[name];
	      var existingType = typeof existingProperty;
	      var propertyType = typeof property;
	      ("production" !== "development" ? invariant(
	        existingType === 'function' && propertyType === 'function',
	        'ReactCompositeComponent: You are attempting to define ' +
	        '`%s` on your component more than once, but that is only supported ' +
	        'for functions, which are chained together. This conflict may be ' +
	        'due to a mixin.',
	        name
	      ) : invariant(existingType === 'function' && propertyType === 'function'));
	      result = createChainedFunction(existingProperty, property);
	    }
	    Constructor[name] = result;
	  }
	}

	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeObjectsWithNoDuplicateKeys(one, two) {
	  ("production" !== "development" ? invariant(
	    one && two && typeof one === 'object' && typeof two === 'object',
	    'mergeObjectsWithNoDuplicateKeys(): Cannot merge non-objects'
	  ) : invariant(one && two && typeof one === 'object' && typeof two === 'object'));

	  mapObject(two, function(value, key) {
	    ("production" !== "development" ? invariant(
	      one[key] === undefined,
	      'mergeObjectsWithNoDuplicateKeys(): ' +
	      'Tried to merge two objects with the same key: %s',
	      key
	    ) : invariant(one[key] === undefined));
	    one[key] = value;
	  });
	  return one;
	}

	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    return mergeObjectsWithNoDuplicateKeys(a, b);
	  };
	}

	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}

	/**
	 * `ReactCompositeComponent` maintains an auxiliary life cycle state in
	 * `this._compositeLifeCycleState` (which can be null).
	 *
	 * This is different from the life cycle state maintained by `ReactComponent` in
	 * `this._lifeCycleState`. The following diagram shows how the states overlap in
	 * time. There are times when the CompositeLifeCycle is null - at those times it
	 * is only meaningful to look at ComponentLifeCycle alone.
	 *
	 * Top Row: ReactComponent.ComponentLifeCycle
	 * Low Row: ReactComponent.CompositeLifeCycle
	 *
	 * +-------+------------------------------------------------------+--------+
	 * |  UN   |                    MOUNTED                           |   UN   |
	 * |MOUNTED|                                                      | MOUNTED|
	 * +-------+------------------------------------------------------+--------+
	 * |       ^--------+   +------+   +------+   +------+   +--------^        |
	 * |       |        |   |      |   |      |   |      |   |        |        |
	 * |    0--|MOUNTING|-0-|RECEIV|-0-|RECEIV|-0-|RECEIV|-0-|   UN   |--->0   |
	 * |       |        |   |PROPS |   | PROPS|   | STATE|   |MOUNTING|        |
	 * |       |        |   |      |   |      |   |      |   |        |        |
	 * |       |        |   |      |   |      |   |      |   |        |        |
	 * |       +--------+   +------+   +------+   +------+   +--------+        |
	 * |       |                                                      |        |
	 * +-------+------------------------------------------------------+--------+
	 */
	var CompositeLifeCycle = keyMirror({
	  /**
	   * Components in the process of being mounted respond to state changes
	   * differently.
	   */
	  MOUNTING: null,
	  /**
	   * Components in the process of being unmounted are guarded against state
	   * changes.
	   */
	  UNMOUNTING: null,
	  /**
	   * Components that are mounted and receiving new props respond to state
	   * changes differently.
	   */
	  RECEIVING_PROPS: null,
	  /**
	   * Components that are mounted and receiving new state are guarded against
	   * additional state changes.
	   */
	  RECEIVING_STATE: null
	});

	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {

	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactDescriptor} descriptor
	   * @final
	   * @internal
	   */
	  construct: function(descriptor) {
	    // Children can be either an array or more than one argument
	    ReactComponent.Mixin.construct.apply(this, arguments);
	    ReactOwner.Mixin.construct.apply(this, arguments);

	    this.state = null;
	    this._pendingState = null;

	    // This is the public post-processed context. The real context and pending
	    // context lives on the descriptor.
	    this.context = null;

	    this._compositeLifeCycleState = null;
	  },

	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function() {
	    return ReactComponent.Mixin.isMounted.call(this) &&
	      this._compositeLifeCycleState !== CompositeLifeCycle.MOUNTING;
	  },

	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {number} mountDepth number of components in the owner hierarchy
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: ReactPerf.measure(
	    'ReactCompositeComponent',
	    'mountComponent',
	    function(rootID, transaction, mountDepth) {
	      ReactComponent.Mixin.mountComponent.call(
	        this,
	        rootID,
	        transaction,
	        mountDepth
	      );
	      this._compositeLifeCycleState = CompositeLifeCycle.MOUNTING;

	      if (this.__reactAutoBindMap) {
	        this._bindAutoBindMethods();
	      }

	      this.context = this._processContext(this._descriptor._context);
	      this.props = this._processProps(this.props);

	      this.state = this.getInitialState ? this.getInitialState() : null;
	      ("production" !== "development" ? invariant(
	        typeof this.state === 'object' && !Array.isArray(this.state),
	        '%s.getInitialState(): must return an object or null',
	        this.constructor.displayName || 'ReactCompositeComponent'
	      ) : invariant(typeof this.state === 'object' && !Array.isArray(this.state)));

	      this._pendingState = null;
	      this._pendingForceUpdate = false;

	      if (this.componentWillMount) {
	        this.componentWillMount();
	        // When mounting, calls to `setState` by `componentWillMount` will set
	        // `this._pendingState` without triggering a re-render.
	        if (this._pendingState) {
	          this.state = this._pendingState;
	          this._pendingState = null;
	        }
	      }

	      this._renderedComponent = instantiateReactComponent(
	        this._renderValidatedComponent()
	      );

	      // Done with mounting, `setState` will now trigger UI changes.
	      this._compositeLifeCycleState = null;
	      var markup = this._renderedComponent.mountComponent(
	        rootID,
	        transaction,
	        mountDepth + 1
	      );
	      if (this.componentDidMount) {
	        transaction.getReactMountReady().enqueue(this.componentDidMount, this);
	      }
	      return markup;
	    }
	  ),

	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function() {
	    this._compositeLifeCycleState = CompositeLifeCycle.UNMOUNTING;
	    if (this.componentWillUnmount) {
	      this.componentWillUnmount();
	    }
	    this._compositeLifeCycleState = null;

	    this._renderedComponent.unmountComponent();
	    this._renderedComponent = null;

	    ReactComponent.Mixin.unmountComponent.call(this);

	    // Some existing components rely on this.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: this.props = null;
	    // TODO: this.state = null;
	  },

	  /**
	   * Sets a subset of the state. Always use this or `replaceState` to mutate
	   * state. You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * There is no guarantee that calls to `setState` will run synchronously,
	   * as they may eventually be batched together.  You can provide an optional
	   * callback that will be executed when the call to setState is actually
	   * completed.
	   *
	   * @param {object} partialState Next partial state to be merged with state.
	   * @param {?function} callback Called after state is updated.
	   * @final
	   * @protected
	   */
	  setState: function(partialState, callback) {
	    ("production" !== "development" ? invariant(
	      typeof partialState === 'object' || partialState == null,
	      'setState(...): takes an object of state variables to update.'
	    ) : invariant(typeof partialState === 'object' || partialState == null));
	    if ("production" !== "development"){
	      ("production" !== "development" ? warning(
	        partialState != null,
	        'setState(...): You passed an undefined or null state object; ' +
	        'instead, use forceUpdate().'
	      ) : null);
	    }
	    // Merge with `_pendingState` if it exists, otherwise with existing state.
	    this.replaceState(
	      merge(this._pendingState || this.state, partialState),
	      callback
	    );
	  },

	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {object} completeState Next state.
	   * @param {?function} callback Called after state is updated.
	   * @final
	   * @protected
	   */
	  replaceState: function(completeState, callback) {
	    validateLifeCycleOnReplaceState(this);
	    this._pendingState = completeState;
	    if (this._compositeLifeCycleState !== CompositeLifeCycle.MOUNTING) {
	      // If we're in a componentWillMount handler, don't enqueue a rerender
	      // because ReactUpdates assumes we're in a browser context (which is wrong
	      // for server rendering) and we're about to do a render anyway.
	      // TODO: The callback here is ignored when setState is called from
	      // componentWillMount. Either fix it or disallow doing so completely in
	      // favor of getInitialState.
	      ReactUpdates.enqueueUpdate(this, callback);
	    }
	  },

	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function(context) {
	    var maskedContext = null;
	    var contextTypes = this.constructor.contextTypes;
	    if (contextTypes) {
	      maskedContext = {};
	      for (var contextName in contextTypes) {
	        maskedContext[contextName] = context[contextName];
	      }
	      if ("production" !== "development") {
	        this._checkPropTypes(
	          contextTypes,
	          maskedContext,
	          ReactPropTypeLocations.context
	        );
	      }
	    }
	    return maskedContext;
	  },

	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function(currentContext) {
	    var childContext = this.getChildContext && this.getChildContext();
	    var displayName = this.constructor.displayName || 'ReactCompositeComponent';
	    if (childContext) {
	      ("production" !== "development" ? invariant(
	        typeof this.constructor.childContextTypes === 'object',
	        '%s.getChildContext(): childContextTypes must be defined in order to ' +
	        'use getChildContext().',
	        displayName
	      ) : invariant(typeof this.constructor.childContextTypes === 'object'));
	      if ("production" !== "development") {
	        this._checkPropTypes(
	          this.constructor.childContextTypes,
	          childContext,
	          ReactPropTypeLocations.childContext
	        );
	      }
	      for (var name in childContext) {
	        ("production" !== "development" ? invariant(
	          name in this.constructor.childContextTypes,
	          '%s.getChildContext(): key "%s" is not defined in childContextTypes.',
	          displayName,
	          name
	        ) : invariant(name in this.constructor.childContextTypes));
	      }
	      return merge(currentContext, childContext);
	    }
	    return currentContext;
	  },

	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function(newProps) {
	    var defaultProps = this.constructor.defaultProps;
	    var props;
	    if (defaultProps) {
	      props = merge(newProps);
	      for (var propName in defaultProps) {
	        if (typeof props[propName] === 'undefined') {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else {
	      props = newProps;
	    }
	    if ("production" !== "development") {
	      var propTypes = this.constructor.propTypes;
	      if (propTypes) {
	        this._checkPropTypes(propTypes, props, ReactPropTypeLocations.prop);
	      }
	    }
	    return props;
	  },

	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function(propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the descriptor
	    // validation.
	    var componentName = this.constructor.displayName;
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error =
	          propTypes[propName](props, propName, componentName, location);
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // renderComponent calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	          ("production" !== "development" ? warning(false, error.message + addendum) : null);
	        }
	      }
	    }
	  },

	  /**
	   * If any of `_pendingDescriptor`, `_pendingState`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(transaction) {
	    var compositeLifeCycleState = this._compositeLifeCycleState;
	    // Do not trigger a state transition if we are in the middle of mounting or
	    // receiving props because both of those will already be doing this.
	    if (compositeLifeCycleState === CompositeLifeCycle.MOUNTING ||
	        compositeLifeCycleState === CompositeLifeCycle.RECEIVING_PROPS) {
	      return;
	    }

	    if (this._pendingDescriptor == null &&
	        this._pendingState == null &&
	        !this._pendingForceUpdate) {
	      return;
	    }

	    var nextContext = this.context;
	    var nextProps = this.props;
	    var nextDescriptor = this._descriptor;
	    if (this._pendingDescriptor != null) {
	      nextDescriptor = this._pendingDescriptor;
	      nextContext = this._processContext(nextDescriptor._context);
	      nextProps = this._processProps(nextDescriptor.props);
	      this._pendingDescriptor = null;

	      this._compositeLifeCycleState = CompositeLifeCycle.RECEIVING_PROPS;
	      if (this.componentWillReceiveProps) {
	        this.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }

	    this._compositeLifeCycleState = CompositeLifeCycle.RECEIVING_STATE;

	    var nextState = this._pendingState || this.state;
	    this._pendingState = null;

	    try {
	      var shouldUpdate =
	        this._pendingForceUpdate ||
	        !this.shouldComponentUpdate ||
	        this.shouldComponentUpdate(nextProps, nextState, nextContext);

	      if ("production" !== "development") {
	        if (typeof shouldUpdate === "undefined") {
	          console.warn(
	            (this.constructor.displayName || 'ReactCompositeComponent') +
	            '.shouldComponentUpdate(): Returned undefined instead of a ' +
	            'boolean value. Make sure to return true or false.'
	          );
	        }
	      }

	      if (shouldUpdate) {
	        this._pendingForceUpdate = false;
	        // Will set `this.props`, `this.state` and `this.context`.
	        this._performComponentUpdate(
	          nextDescriptor,
	          nextProps,
	          nextState,
	          nextContext,
	          transaction
	        );
	      } else {
	        // If it's determined that a component should not update, we still want
	        // to set props and state.
	        this._descriptor = nextDescriptor;
	        this.props = nextProps;
	        this.state = nextState;
	        this.context = nextContext;

	        // Owner cannot change because shouldUpdateReactComponent doesn't allow
	        // it. TODO: Remove this._owner completely.
	        this._owner = nextDescriptor._owner;
	      }
	    } finally {
	      this._compositeLifeCycleState = null;
	    }
	  },

	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactDescriptor} nextDescriptor Next descriptor
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @private
	   */
	  _performComponentUpdate: function(
	    nextDescriptor,
	    nextProps,
	    nextState,
	    nextContext,
	    transaction
	  ) {
	    var prevDescriptor = this._descriptor;
	    var prevProps = this.props;
	    var prevState = this.state;
	    var prevContext = this.context;

	    if (this.componentWillUpdate) {
	      this.componentWillUpdate(nextProps, nextState, nextContext);
	    }

	    this._descriptor = nextDescriptor;
	    this.props = nextProps;
	    this.state = nextState;
	    this.context = nextContext;

	    // Owner cannot change because shouldUpdateReactComponent doesn't allow
	    // it. TODO: Remove this._owner completely.
	    this._owner = nextDescriptor._owner;

	    this.updateComponent(
	      transaction,
	      prevDescriptor
	    );

	    if (this.componentDidUpdate) {
	      transaction.getReactMountReady().enqueue(
	        this.componentDidUpdate.bind(this, prevProps, prevState, prevContext),
	        this
	      );
	    }
	  },

	  receiveComponent: function(nextDescriptor, transaction) {
	    if (nextDescriptor === this._descriptor &&
	        nextDescriptor._owner != null) {
	      // Since descriptors are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the descriptor. We explicitly check for the existence of an owner since
	      // it's possible for a descriptor created outside a composite to be
	      // deeply mutated and reused.
	      return;
	    }

	    ReactComponent.Mixin.receiveComponent.call(
	      this,
	      nextDescriptor,
	      transaction
	    );
	  },

	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactDescriptor} prevDescriptor
	   * @internal
	   * @overridable
	   */
	  updateComponent: ReactPerf.measure(
	    'ReactCompositeComponent',
	    'updateComponent',
	    function(transaction, prevParentDescriptor) {
	      ReactComponent.Mixin.updateComponent.call(
	        this,
	        transaction,
	        prevParentDescriptor
	      );

	      var prevComponentInstance = this._renderedComponent;
	      var prevDescriptor = prevComponentInstance._descriptor;
	      var nextDescriptor = this._renderValidatedComponent();
	      if (shouldUpdateReactComponent(prevDescriptor, nextDescriptor)) {
	        prevComponentInstance.receiveComponent(nextDescriptor, transaction);
	      } else {
	        // These two IDs are actually the same! But nothing should rely on that.
	        var thisID = this._rootNodeID;
	        var prevComponentID = prevComponentInstance._rootNodeID;
	        prevComponentInstance.unmountComponent();
	        this._renderedComponent = instantiateReactComponent(nextDescriptor);
	        var nextMarkup = this._renderedComponent.mountComponent(
	          thisID,
	          transaction,
	          this._mountDepth + 1
	        );
	        ReactComponent.BackendIDOperations.dangerouslyReplaceNodeWithMarkupByID(
	          prevComponentID,
	          nextMarkup
	        );
	      }
	    }
	  ),

	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldUpdateComponent`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {?function} callback Called after update is complete.
	   * @final
	   * @protected
	   */
	  forceUpdate: function(callback) {
	    var compositeLifeCycleState = this._compositeLifeCycleState;
	    ("production" !== "development" ? invariant(
	      this.isMounted() ||
	        compositeLifeCycleState === CompositeLifeCycle.MOUNTING,
	      'forceUpdate(...): Can only force an update on mounted or mounting ' +
	        'components.'
	    ) : invariant(this.isMounted() ||
	      compositeLifeCycleState === CompositeLifeCycle.MOUNTING));
	    ("production" !== "development" ? invariant(
	      compositeLifeCycleState !== CompositeLifeCycle.RECEIVING_STATE &&
	      compositeLifeCycleState !== CompositeLifeCycle.UNMOUNTING,
	      'forceUpdate(...): Cannot force an update while unmounting component ' +
	      'or during an existing state transition (such as within `render`).'
	    ) : invariant(compositeLifeCycleState !== CompositeLifeCycle.RECEIVING_STATE &&
	    compositeLifeCycleState !== CompositeLifeCycle.UNMOUNTING));
	    this._pendingForceUpdate = true;
	    ReactUpdates.enqueueUpdate(this, callback);
	  },

	  /**
	   * @private
	   */
	  _renderValidatedComponent: ReactPerf.measure(
	    'ReactCompositeComponent',
	    '_renderValidatedComponent',
	    function() {
	      var renderedComponent;
	      var previousContext = ReactContext.current;
	      ReactContext.current = this._processChildContext(
	        this._descriptor._context
	      );
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this.render();
	        if (renderedComponent === null || renderedComponent === false) {
	          renderedComponent = ReactEmptyComponent.getEmptyComponent();
	          ReactEmptyComponent.registerNullComponentID(this._rootNodeID);
	        } else {
	          ReactEmptyComponent.deregisterNullComponentID(this._rootNodeID);
	        }
	      } finally {
	        ReactContext.current = previousContext;
	        ReactCurrentOwner.current = null;
	      }
	      ("production" !== "development" ? invariant(
	        ReactDescriptor.isValidDescriptor(renderedComponent),
	        '%s.render(): A valid ReactComponent must be returned. You may have ' +
	          'returned undefined, an array or some other invalid object.',
	        this.constructor.displayName || 'ReactCompositeComponent'
	      ) : invariant(ReactDescriptor.isValidDescriptor(renderedComponent)));
	      return renderedComponent;
	    }
	  ),

	  /**
	   * @private
	   */
	  _bindAutoBindMethods: function() {
	    for (var autoBindKey in this.__reactAutoBindMap) {
	      if (!this.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	        continue;
	      }
	      var method = this.__reactAutoBindMap[autoBindKey];
	      this[autoBindKey] = this._bindAutoBindMethod(ReactErrorUtils.guard(
	        method,
	        this.constructor.displayName + '.' + autoBindKey
	      ));
	    }
	  },

	  /**
	   * Binds a method to the component.
	   *
	   * @param {function} method Method to be bound.
	   * @private
	   */
	  _bindAutoBindMethod: function(method) {
	    var component = this;
	    var boundMethod = function() {
	      return method.apply(component, arguments);
	    };
	    if ("production" !== "development") {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis ) {var args=Array.prototype.slice.call(arguments,1);
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          monitorCodeUse('react_bind_warning', { component: componentName });
	          console.warn(
	            'bind(): React component methods may only be bound to the ' +
	            'component instance. See ' + componentName
	          );
	        } else if (!args.length) {
	          monitorCodeUse('react_bind_warning', { component: componentName });
	          console.warn(
	            'bind(): You are binding a component method to the component. ' +
	            'React does this for you automatically in a high-performance ' +
	            'way, so you can safely remove this call. See ' + componentName
	          );
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	};

	var ReactCompositeComponentBase = function() {};
	mixInto(ReactCompositeComponentBase, ReactComponent.Mixin);
	mixInto(ReactCompositeComponentBase, ReactOwner.Mixin);
	mixInto(ReactCompositeComponentBase, ReactPropTransferer.Mixin);
	mixInto(ReactCompositeComponentBase, ReactCompositeComponentMixin);

	/**
	 * Module for creating composite components.
	 *
	 * @class ReactCompositeComponent
	 * @extends ReactComponent
	 * @extends ReactOwner
	 * @extends ReactPropTransferer
	 */
	var ReactCompositeComponent = {

	  LifeCycle: CompositeLifeCycle,

	  Base: ReactCompositeComponentBase,

	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function(spec) {
	    var Constructor = function(props, owner) {
	      this.construct(props, owner);
	    };
	    Constructor.prototype = new ReactCompositeComponentBase();
	    Constructor.prototype.constructor = Constructor;

	    injectedMixins.forEach(
	      mixSpecIntoComponent.bind(null, Constructor)
	    );

	    mixSpecIntoComponent(Constructor, spec);

	    // Initialize the defaultProps property after all mixins have been merged
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }

	    ("production" !== "development" ? invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    ) : invariant(Constructor.prototype.render));

	    if ("production" !== "development") {
	      if (Constructor.prototype.componentShouldUpdate) {
	        monitorCodeUse(
	          'react_component_should_update_warning',
	          { component: spec.displayName }
	        );
	        console.warn(
	          (spec.displayName || 'A component') + ' has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.'
	         );
	      }
	    }

	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactCompositeComponentInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }

	    var descriptorFactory = ReactDescriptor.createFactory(Constructor);

	    if ("production" !== "development") {
	      return ReactDescriptorValidator.createFactory(
	        descriptorFactory,
	        Constructor.propTypes,
	        Constructor.contextTypes
	      );
	    }

	    return descriptorFactory;
	  },

	  injection: {
	    injectMixin: function(mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	};

	module.exports = ReactCompositeComponent;

	},{"./ReactComponent":31,"./ReactContext":34,"./ReactCurrentOwner":35,"./ReactDescriptor":51,"./ReactDescriptorValidator":52,"./ReactEmptyComponent":53,"./ReactErrorUtils":54,"./ReactOwner":64,"./ReactPerf":65,"./ReactPropTransferer":66,"./ReactPropTypeLocationNames":67,"./ReactPropTypeLocations":68,"./ReactUpdates":76,"./instantiateReactComponent":119,"./invariant":120,"./keyMirror":126,"./mapObject":128,"./merge":130,"./mixInto":133,"./monitorCodeUse":134,"./shouldUpdateReactComponent":140,"./warning":143}],34:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactContext
	 */

	"use strict";

	var merge = _dereq_("./merge");

	/**
	 * Keeps track of the current context.
	 *
	 * The context is automatically passed down the component ownership hierarchy
	 * and is accessible via `this.context` on ReactCompositeComponents.
	 */
	var ReactContext = {

	  /**
	   * @internal
	   * @type {object}
	   */
	  current: {},

	  /**
	   * Temporarily extends the current context while executing scopedCallback.
	   *
	   * A typical use case might look like
	   *
	   *  render: function() {
	   *    var children = ReactContext.withContext({foo: 'foo'} () => (
	   *
	   *    ));
	   *    return <div>{children}</div>;
	   *  }
	   *
	   * @param {object} newContext New context to merge into the existing context
	   * @param {function} scopedCallback Callback to run with the new context
	   * @return {ReactComponent|array<ReactComponent>}
	   */
	  withContext: function(newContext, scopedCallback) {
	    var result;
	    var previousContext = ReactContext.current;
	    ReactContext.current = merge(previousContext, newContext);
	    try {
	      result = scopedCallback();
	    } finally {
	      ReactContext.current = previousContext;
	    }
	    return result;
	  }

	};

	module.exports = ReactContext;

	},{"./merge":130}],35:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactCurrentOwner
	 */

	"use strict";

	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 *
	 * The depth indicate how many composite components are above this render level.
	 */
	var ReactCurrentOwner = {

	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null

	};

	module.exports = ReactCurrentOwner;

	},{}],36:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOM
	 * @typechecks static-only
	 */

	"use strict";

	var ReactDescriptor = _dereq_("./ReactDescriptor");
	var ReactDescriptorValidator = _dereq_("./ReactDescriptorValidator");
	var ReactDOMComponent = _dereq_("./ReactDOMComponent");

	var mergeInto = _dereq_("./mergeInto");
	var mapObject = _dereq_("./mapObject");

	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @param {boolean} omitClose True if the close tag should be omitted.
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMComponentClass(omitClose, tag) {
	  var Constructor = function(descriptor) {
	    this.construct(descriptor);
	  };
	  Constructor.prototype = new ReactDOMComponent(tag, omitClose);
	  Constructor.prototype.constructor = Constructor;
	  Constructor.displayName = tag;

	  var ConvenienceConstructor = ReactDescriptor.createFactory(Constructor);

	  if ("production" !== "development") {
	    return ReactDescriptorValidator.createFactory(
	      ConvenienceConstructor
	    );
	  }

	  return ConvenienceConstructor;
	}

	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOM = mapObject({
	  a: false,
	  abbr: false,
	  address: false,
	  area: true,
	  article: false,
	  aside: false,
	  audio: false,
	  b: false,
	  base: true,
	  bdi: false,
	  bdo: false,
	  big: false,
	  blockquote: false,
	  body: false,
	  br: true,
	  button: false,
	  canvas: false,
	  caption: false,
	  cite: false,
	  code: false,
	  col: true,
	  colgroup: false,
	  data: false,
	  datalist: false,
	  dd: false,
	  del: false,
	  details: false,
	  dfn: false,
	  dialog: false,
	  div: false,
	  dl: false,
	  dt: false,
	  em: false,
	  embed: true,
	  fieldset: false,
	  figcaption: false,
	  figure: false,
	  footer: false,
	  form: false, // NOTE: Injected, see `ReactDOMForm`.
	  h1: false,
	  h2: false,
	  h3: false,
	  h4: false,
	  h5: false,
	  h6: false,
	  head: false,
	  header: false,
	  hr: true,
	  html: false,
	  i: false,
	  iframe: false,
	  img: true,
	  input: true,
	  ins: false,
	  kbd: false,
	  keygen: true,
	  label: false,
	  legend: false,
	  li: false,
	  link: true,
	  main: false,
	  map: false,
	  mark: false,
	  menu: false,
	  menuitem: false, // NOTE: Close tag should be omitted, but causes problems.
	  meta: true,
	  meter: false,
	  nav: false,
	  noscript: false,
	  object: false,
	  ol: false,
	  optgroup: false,
	  option: false,
	  output: false,
	  p: false,
	  param: true,
	  picture: false,
	  pre: false,
	  progress: false,
	  q: false,
	  rp: false,
	  rt: false,
	  ruby: false,
	  s: false,
	  samp: false,
	  script: false,
	  section: false,
	  select: false,
	  small: false,
	  source: true,
	  span: false,
	  strong: false,
	  style: false,
	  sub: false,
	  summary: false,
	  sup: false,
	  table: false,
	  tbody: false,
	  td: false,
	  textarea: false, // NOTE: Injected, see `ReactDOMTextarea`.
	  tfoot: false,
	  th: false,
	  thead: false,
	  time: false,
	  title: false,
	  tr: false,
	  track: true,
	  u: false,
	  ul: false,
	  'var': false,
	  video: false,
	  wbr: true,

	  // SVG
	  circle: false,
	  defs: false,
	  ellipse: false,
	  feColorMatrix: false,
	  feGaussianBlur: false,
	  feOffset: false,
	  feFlood: false,
	  feComposite: false,
	  feMerge: false,
	  feMergeNode: false,
	  filter: false,
	  g: false,
	  image: false,
	  line: false,
	  linearGradient: false,
	  clipPath: false,
	  mask: false,
	  path: false,
	  pattern: false,
	  polygon: false,
	  polyline: false,
	  radialGradient: false,
	  rect: false,
	  stop: false,
	  svg: false,
	  text: false,
	  tspan: false
	}, createDOMComponentClass);

	var injection = {
	  injectComponentClasses: function(componentClasses) {
	    mergeInto(ReactDOM, componentClasses);
	  }
	};

	ReactDOM.injection = injection;

	module.exports = ReactDOM;

	},{"./ReactDOMComponent":38,"./ReactDescriptor":51,"./ReactDescriptorValidator":52,"./mapObject":128,"./mergeInto":132}],37:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMButton
	 */

	"use strict";

	var AutoFocusMixin = _dereq_("./AutoFocusMixin");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactDOM = _dereq_("./ReactDOM");

	var keyMirror = _dereq_("./keyMirror");

	// Store a reference to the <button> `ReactDOMComponent`.
	var button = ReactDOM.button;

	var mouseListenerNames = keyMirror({
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	});

	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = ReactCompositeComponent.createClass({
	  displayName: 'ReactDOMButton',

	  mixins: [AutoFocusMixin, ReactBrowserComponentMixin],

	  render: function() {
	    var props = {};

	    // Copy the props; except the mouse listeners if we're disabled
	    for (var key in this.props) {
	      if (this.props.hasOwnProperty(key) &&
	          (!this.props.disabled || !mouseListenerNames[key])) {
	        props[key] = this.props[key];
	      }
	    }

	    return button(props, this.props.children);
	  }

	});

	module.exports = ReactDOMButton;

	},{"./AutoFocusMixin":1,"./ReactBrowserComponentMixin":28,"./ReactCompositeComponent":33,"./ReactDOM":36,"./keyMirror":126}],38:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */

	"use strict";

	var CSSPropertyOperations = _dereq_("./CSSPropertyOperations");
	var DOMProperty = _dereq_("./DOMProperty");
	var DOMPropertyOperations = _dereq_("./DOMPropertyOperations");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactComponent = _dereq_("./ReactComponent");
	var ReactBrowserEventEmitter = _dereq_("./ReactBrowserEventEmitter");
	var ReactMount = _dereq_("./ReactMount");
	var ReactMultiChild = _dereq_("./ReactMultiChild");
	var ReactPerf = _dereq_("./ReactPerf");

	var escapeTextForBrowser = _dereq_("./escapeTextForBrowser");
	var invariant = _dereq_("./invariant");
	var keyOf = _dereq_("./keyOf");
	var merge = _dereq_("./merge");
	var mixInto = _dereq_("./mixInto");

	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;

	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = {'string': true, 'number': true};

	var STYLE = keyOf({style: null});

	var ELEMENT_NODE_TYPE = 1;

	/**
	 * @param {?object} props
	 */
	function assertValidProps(props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  ("production" !== "development" ? invariant(
	    props.children == null || props.dangerouslySetInnerHTML == null,
	    'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
	  ) : invariant(props.children == null || props.dangerouslySetInnerHTML == null));
	  ("production" !== "development" ? invariant(
	    props.style == null || typeof props.style === 'object',
	    'The `style` prop expects a mapping from style properties to values, ' +
	    'not a string.'
	  ) : invariant(props.style == null || typeof props.style === 'object'));
	}

	function putListener(id, registrationName, listener, transaction) {
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ?
	      container.ownerDocument :
	      container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getPutListenerQueue().enqueuePutListener(
	    id,
	    registrationName,
	    listener
	  );
	}


	/**
	 * @constructor ReactDOMComponent
	 * @extends ReactComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag, omitClose) {
	  this._tagOpen = '<' + tag;
	  this._tagClose = omitClose ? '' : '</' + tag + '>';
	  this.tagName = tag.toUpperCase();
	}

	ReactDOMComponent.Mixin = {

	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {number} mountDepth number of components in the owner hierarchy
	   * @return {string} The computed markup.
	   */
	  mountComponent: ReactPerf.measure(
	    'ReactDOMComponent',
	    'mountComponent',
	    function(rootID, transaction, mountDepth) {
	      ReactComponent.Mixin.mountComponent.call(
	        this,
	        rootID,
	        transaction,
	        mountDepth
	      );
	      assertValidProps(this.props);
	      return (
	        this._createOpenTagMarkupAndPutListeners(transaction) +
	        this._createContentMarkup(transaction) +
	        this._tagClose
	      );
	    }
	  ),

	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function(transaction) {
	    var props = this.props;
	    var ret = this._tagOpen;

	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, propValue, transaction);
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            propValue = props.style = merge(props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup =
	          DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }

	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret + '>';
	    }

	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID + '>';
	  },

	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function(transaction) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = this.props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        return innerHTML.__html;
	      }
	    } else {
	      var contentToUse =
	        CONTENT_TYPES[typeof this.props.children] ? this.props.children : null;
	      var childrenToUse = contentToUse != null ? null : this.props.children;
	      if (contentToUse != null) {
	        return escapeTextForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(
	          childrenToUse,
	          transaction
	        );
	        return mountImages.join('');
	      }
	    }
	    return '';
	  },

	  receiveComponent: function(nextDescriptor, transaction) {
	    if (nextDescriptor === this._descriptor &&
	        nextDescriptor._owner != null) {
	      // Since descriptors are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the descriptor. We explicitly check for the existence of an owner since
	      // it's possible for a descriptor created outside a composite to be
	      // deeply mutated and reused.
	      return;
	    }

	    ReactComponent.Mixin.receiveComponent.call(
	      this,
	      nextDescriptor,
	      transaction
	    );
	  },

	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactDescriptor} prevDescriptor
	   * @internal
	   * @overridable
	   */
	  updateComponent: ReactPerf.measure(
	    'ReactDOMComponent',
	    'updateComponent',
	    function(transaction, prevDescriptor) {
	      assertValidProps(this._descriptor.props);
	      ReactComponent.Mixin.updateComponent.call(
	        this,
	        transaction,
	        prevDescriptor
	      );
	      this._updateDOMProperties(prevDescriptor.props, transaction);
	      this._updateDOMChildren(prevDescriptor.props, transaction);
	    }
	  ),

	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMProperties: function(lastProps, transaction) {
	    var nextProps = this.props;
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) ||
	         !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = lastProps[propKey];
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        deleteListener(this._rootNodeID, propKey);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        ReactComponent.BackendIDOperations.deletePropertyByID(
	          this._rootNodeID,
	          propKey
	        );
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          nextProp = nextProps.style = merge(nextProp);
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) &&
	                (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) &&
	                lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, nextProp, transaction);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        ReactComponent.BackendIDOperations.updatePropertyByID(
	          this._rootNodeID,
	          propKey,
	          nextProp
	        );
	      }
	    }
	    if (styleUpdates) {
	      ReactComponent.BackendIDOperations.updateStylesByID(
	        this._rootNodeID,
	        styleUpdates
	      );
	    }
	  },

	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMChildren: function(lastProps, transaction) {
	    var nextProps = this.props;

	    var lastContent =
	      CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent =
	      CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

	    var lastHtml =
	      lastProps.dangerouslySetInnerHTML &&
	      lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml =
	      nextProps.dangerouslySetInnerHTML &&
	      nextProps.dangerouslySetInnerHTML.__html;

	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;

	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }

	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        ReactComponent.BackendIDOperations.updateInnerHTMLByID(
	          this._rootNodeID,
	          nextHtml
	        );
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction);
	    }
	  },

	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function() {
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponent.Mixin.unmountComponent.call(this);
	  }

	};

	mixInto(ReactDOMComponent, ReactComponent.Mixin);
	mixInto(ReactDOMComponent, ReactDOMComponent.Mixin);
	mixInto(ReactDOMComponent, ReactMultiChild.Mixin);
	mixInto(ReactDOMComponent, ReactBrowserComponentMixin);

	module.exports = ReactDOMComponent;

	},{"./CSSPropertyOperations":4,"./DOMProperty":10,"./DOMPropertyOperations":11,"./ReactBrowserComponentMixin":28,"./ReactBrowserEventEmitter":29,"./ReactComponent":31,"./ReactMount":61,"./ReactMultiChild":62,"./ReactPerf":65,"./escapeTextForBrowser":104,"./invariant":120,"./keyOf":127,"./merge":130,"./mixInto":133}],39:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMForm
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var LocalEventTrapMixin = _dereq_("./LocalEventTrapMixin");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactDOM = _dereq_("./ReactDOM");

	// Store a reference to the <form> `ReactDOMComponent`.
	var form = ReactDOM.form;

	/**
	 * Since onSubmit doesn't bubble OR capture on the top level in IE8, we need
	 * to capture it on the <form> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <form> a
	 * composite component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMForm = ReactCompositeComponent.createClass({
	  displayName: 'ReactDOMForm',

	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],

	  render: function() {
	    // TODO: Instead of using `ReactDOM` directly, we should use JSX. However,
	    // `jshint` fails to parse JSX so in order for linting to work in the open
	    // source repo, we need to just use `ReactDOM.form`.
	    return this.transferPropsTo(form(null, this.props.children));
	  },

	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit');
	  }
	});

	module.exports = ReactDOMForm;

	},{"./EventConstants":15,"./LocalEventTrapMixin":24,"./ReactBrowserComponentMixin":28,"./ReactCompositeComponent":33,"./ReactDOM":36}],40:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */

	/*jslint evil: true */

	"use strict";

	var CSSPropertyOperations = _dereq_("./CSSPropertyOperations");
	var DOMChildrenOperations = _dereq_("./DOMChildrenOperations");
	var DOMPropertyOperations = _dereq_("./DOMPropertyOperations");
	var ReactMount = _dereq_("./ReactMount");
	var ReactPerf = _dereq_("./ReactPerf");

	var invariant = _dereq_("./invariant");
	var setInnerHTML = _dereq_("./setInnerHTML");

	/**
	 * Errors for properties that should not be updated with `updatePropertyById()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML:
	    '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};

	/**
	 * Operations used to process updates to DOM nodes. This is made injectable via
	 * `ReactComponent.BackendIDOperations`.
	 */
	var ReactDOMIDOperations = {

	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: ReactPerf.measure(
	    'ReactDOMIDOperations',
	    'updatePropertyByID',
	    function(id, name, value) {
	      var node = ReactMount.getNode(id);
	      ("production" !== "development" ? invariant(
	        !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	        'updatePropertyByID(...): %s',
	        INVALID_PROPERTY_ERRORS[name]
	      ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));

	      // If we're updating to null or undefined, we should remove the property
	      // from the DOM node instead of inadvertantly setting to a string. This
	      // brings us in line with the same behavior we have on initial render.
	      if (value != null) {
	        DOMPropertyOperations.setValueForProperty(node, name, value);
	      } else {
	        DOMPropertyOperations.deleteValueForProperty(node, name);
	      }
	    }
	  ),

	  /**
	   * Updates a DOM node to remove a property. This should only be used to remove
	   * DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A property name to remove, see `DOMProperty`.
	   * @internal
	   */
	  deletePropertyByID: ReactPerf.measure(
	    'ReactDOMIDOperations',
	    'deletePropertyByID',
	    function(id, name, value) {
	      var node = ReactMount.getNode(id);
	      ("production" !== "development" ? invariant(
	        !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	        'updatePropertyByID(...): %s',
	        INVALID_PROPERTY_ERRORS[name]
	      ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));
	      DOMPropertyOperations.deleteValueForProperty(node, name, value);
	    }
	  ),

	  /**
	   * Updates a DOM node with new style values. If a value is specified as '',
	   * the corresponding style property will be unset.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {object} styles Mapping from styles to values.
	   * @internal
	   */
	  updateStylesByID: ReactPerf.measure(
	    'ReactDOMIDOperations',
	    'updateStylesByID',
	    function(id, styles) {
	      var node = ReactMount.getNode(id);
	      CSSPropertyOperations.setValueForStyles(node, styles);
	    }
	  ),

	  /**
	   * Updates a DOM node's innerHTML.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} html An HTML string.
	   * @internal
	   */
	  updateInnerHTMLByID: ReactPerf.measure(
	    'ReactDOMIDOperations',
	    'updateInnerHTMLByID',
	    function(id, html) {
	      var node = ReactMount.getNode(id);
	      setInnerHTML(node, html);
	    }
	  ),

	  /**
	   * Updates a DOM node's text content set by `props.content`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} content Text content.
	   * @internal
	   */
	  updateTextContentByID: ReactPerf.measure(
	    'ReactDOMIDOperations',
	    'updateTextContentByID',
	    function(id, content) {
	      var node = ReactMount.getNode(id);
	      DOMChildrenOperations.updateTextContent(node, content);
	    }
	  ),

	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: ReactPerf.measure(
	    'ReactDOMIDOperations',
	    'dangerouslyReplaceNodeWithMarkupByID',
	    function(id, markup) {
	      var node = ReactMount.getNode(id);
	      DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	    }
	  ),

	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: ReactPerf.measure(
	    'ReactDOMIDOperations',
	    'dangerouslyProcessChildrenUpdates',
	    function(updates, markup) {
	      for (var i = 0; i < updates.length; i++) {
	        updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	      }
	      DOMChildrenOperations.processUpdates(updates, markup);
	    }
	  )
	};

	module.exports = ReactDOMIDOperations;

	},{"./CSSPropertyOperations":4,"./DOMChildrenOperations":9,"./DOMPropertyOperations":11,"./ReactMount":61,"./ReactPerf":65,"./invariant":120,"./setInnerHTML":138}],41:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMImg
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var LocalEventTrapMixin = _dereq_("./LocalEventTrapMixin");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactDOM = _dereq_("./ReactDOM");

	// Store a reference to the <img> `ReactDOMComponent`.
	var img = ReactDOM.img;

	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <img> element itself. There are lots of hacks we could do
	 * to accomplish this, but the most reliable is to make <img> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMImg = ReactCompositeComponent.createClass({
	  displayName: 'ReactDOMImg',
	  tagName: 'IMG',

	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],

	  render: function() {
	    return img(this.props);
	  },

	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error');
	  }
	});

	module.exports = ReactDOMImg;

	},{"./EventConstants":15,"./LocalEventTrapMixin":24,"./ReactBrowserComponentMixin":28,"./ReactCompositeComponent":33,"./ReactDOM":36}],42:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMInput
	 */

	"use strict";

	var AutoFocusMixin = _dereq_("./AutoFocusMixin");
	var DOMPropertyOperations = _dereq_("./DOMPropertyOperations");
	var LinkedValueUtils = _dereq_("./LinkedValueUtils");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactDOM = _dereq_("./ReactDOM");
	var ReactMount = _dereq_("./ReactMount");

	var invariant = _dereq_("./invariant");
	var merge = _dereq_("./merge");

	// Store a reference to the <input> `ReactDOMComponent`.
	var input = ReactDOM.input;

	var instancesByReactID = {};

	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = ReactCompositeComponent.createClass({
	  displayName: 'ReactDOMInput',

	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],

	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    return {
	      checked: this.props.defaultChecked || false,
	      value: defaultValue != null ? defaultValue : null
	    };
	  },

	  shouldComponentUpdate: function() {
	    // Defer any updates to this component during the `onChange` handler.
	    return !this._isChanging;
	  },

	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = merge(this.props);

	    props.defaultChecked = null;
	    props.defaultValue = null;

	    var value = LinkedValueUtils.getValue(this);
	    props.value = value != null ? value : this.state.value;

	    var checked = LinkedValueUtils.getChecked(this);
	    props.checked = checked != null ? checked : this.state.checked;

	    props.onChange = this._handleChange;

	    return input(props, this.props.children);
	  },

	  componentDidMount: function() {
	    var id = ReactMount.getID(this.getDOMNode());
	    instancesByReactID[id] = this;
	  },

	  componentWillUnmount: function() {
	    var rootNode = this.getDOMNode();
	    var id = ReactMount.getID(rootNode);
	    delete instancesByReactID[id];
	  },

	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var rootNode = this.getDOMNode();
	    if (this.props.checked != null) {
	      DOMPropertyOperations.setValueForProperty(
	        rootNode,
	        'checked',
	        this.props.checked || false
	      );
	    }

	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },

	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      this._isChanging = true;
	      returnValue = onChange.call(this, event);
	      this._isChanging = false;
	    }
	    this.setState({
	      checked: event.target.checked,
	      value: event.target.value
	    });

	    var name = this.props.name;
	    if (this.props.type === 'radio' && name != null) {
	      var rootNode = this.getDOMNode();
	      var queryRoot = rootNode;

	      while (queryRoot.parentNode) {
	        queryRoot = queryRoot.parentNode;
	      }

	      // If `rootNode.form` was non-null, then we could try `form.elements`,
	      // but that sometimes behaves strangely in IE8. We could also try using
	      // `form.getElementsByName`, but that will only return direct children
	      // and won't include inputs that use the HTML5 `form=` attribute. Since
	      // the input might not even be in a form, let's just use the global
	      // `querySelectorAll` to ensure we don't miss anything.
	      var group = queryRoot.querySelectorAll(
	        'input[name=' + JSON.stringify('' + name) + '][type="radio"]');

	      for (var i = 0, groupLen = group.length; i < groupLen; i++) {
	        var otherNode = group[i];
	        if (otherNode === rootNode ||
	            otherNode.form !== rootNode.form) {
	          continue;
	        }
	        var otherID = ReactMount.getID(otherNode);
	        ("production" !== "development" ? invariant(
	          otherID,
	          'ReactDOMInput: Mixing React and non-React radio inputs with the ' +
	          'same `name` is not supported.'
	        ) : invariant(otherID));
	        var otherInstance = instancesByReactID[otherID];
	        ("production" !== "development" ? invariant(
	          otherInstance,
	          'ReactDOMInput: Unknown radio button ID %s.',
	          otherID
	        ) : invariant(otherInstance));
	        // In some cases, this will actually change the `checked` state value.
	        // In other cases, there's no change but this forces a reconcile upon
	        // which componentDidUpdate will reset the DOM property to whatever it
	        // should be.
	        otherInstance.setState({
	          checked: false
	        });
	      }
	    }

	    return returnValue;
	  }

	});

	module.exports = ReactDOMInput;

	},{"./AutoFocusMixin":1,"./DOMPropertyOperations":11,"./LinkedValueUtils":23,"./ReactBrowserComponentMixin":28,"./ReactCompositeComponent":33,"./ReactDOM":36,"./ReactMount":61,"./invariant":120,"./merge":130}],43:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMOption
	 */

	"use strict";

	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactDOM = _dereq_("./ReactDOM");

	var warning = _dereq_("./warning");

	// Store a reference to the <option> `ReactDOMComponent`.
	var option = ReactDOM.option;

	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = ReactCompositeComponent.createClass({
	  displayName: 'ReactDOMOption',

	  mixins: [ReactBrowserComponentMixin],

	  componentWillMount: function() {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if ("production" !== "development") {
	      ("production" !== "development" ? warning(
	        this.props.selected == null,
	        'Use the `defaultValue` or `value` props on <select> instead of ' +
	        'setting `selected` on <option>.'
	      ) : null);
	    }
	  },

	  render: function() {
	    return option(this.props, this.props.children);
	  }

	});

	module.exports = ReactDOMOption;

	},{"./ReactBrowserComponentMixin":28,"./ReactCompositeComponent":33,"./ReactDOM":36,"./warning":143}],44:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMSelect
	 */

	"use strict";

	var AutoFocusMixin = _dereq_("./AutoFocusMixin");
	var LinkedValueUtils = _dereq_("./LinkedValueUtils");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactDOM = _dereq_("./ReactDOM");

	var merge = _dereq_("./merge");

	// Store a reference to the <select> `ReactDOMComponent`.
	var select = ReactDOM.select;

	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function selectValueType(props, propName, componentName) {
	  if (props[propName] == null) {
	    return;
	  }
	  if (props.multiple) {
	    if (!Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be an array if ") +
	        ("`multiple` is true.")
	      );
	    }
	  } else {
	    if (Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be a scalar ") +
	        ("value if `multiple` is false.")
	      );
	    }
	  }
	}

	/**
	 * If `value` is supplied, updates <option> elements on mount and update.
	 * @param {ReactComponent} component Instance of ReactDOMSelect
	 * @param {?*} propValue For uncontrolled components, null/undefined. For
	 * controlled components, a string (or with `multiple`, a list of strings).
	 * @private
	 */
	function updateOptions(component, propValue) {
	  var multiple = component.props.multiple;
	  var value = propValue != null ? propValue : component.state.value;
	  var options = component.getDOMNode().options;
	  var selectedValue, i, l;
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0, l = value.length; i < l; ++i) {
	      selectedValue['' + value[i]] = true;
	    }
	  } else {
	    selectedValue = '' + value;
	  }
	  for (i = 0, l = options.length; i < l; i++) {
	    var selected = multiple ?
	      selectedValue.hasOwnProperty(options[i].value) :
	      options[i].value === selectedValue;

	    if (selected !== options[i].selected) {
	      options[i].selected = selected;
	    }
	  }
	}

	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * string. If `multiple` is true, the prop must be an array of strings.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = ReactCompositeComponent.createClass({
	  displayName: 'ReactDOMSelect',

	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],

	  propTypes: {
	    defaultValue: selectValueType,
	    value: selectValueType
	  },

	  getInitialState: function() {
	    return {value: this.props.defaultValue || (this.props.multiple ? [] : '')};
	  },

	  componentWillReceiveProps: function(nextProps) {
	    if (!this.props.multiple && nextProps.multiple) {
	      this.setState({value: [this.state.value]});
	    } else if (this.props.multiple && !nextProps.multiple) {
	      this.setState({value: this.state.value[0]});
	    }
	  },

	  shouldComponentUpdate: function() {
	    // Defer any updates to this component during the `onChange` handler.
	    return !this._isChanging;
	  },

	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = merge(this.props);

	    props.onChange = this._handleChange;
	    props.value = null;

	    return select(props, this.props.children);
	  },

	  componentDidMount: function() {
	    updateOptions(this, LinkedValueUtils.getValue(this));
	  },

	  componentDidUpdate: function(prevProps) {
	    var value = LinkedValueUtils.getValue(this);
	    var prevMultiple = !!prevProps.multiple;
	    var multiple = !!this.props.multiple;
	    if (value != null || prevMultiple !== multiple) {
	      updateOptions(this, value);
	    }
	  },

	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      this._isChanging = true;
	      returnValue = onChange.call(this, event);
	      this._isChanging = false;
	    }

	    var selectedValue;
	    if (this.props.multiple) {
	      selectedValue = [];
	      var options = event.target.options;
	      for (var i = 0, l = options.length; i < l; i++) {
	        if (options[i].selected) {
	          selectedValue.push(options[i].value);
	        }
	      }
	    } else {
	      selectedValue = event.target.value;
	    }

	    this.setState({value: selectedValue});
	    return returnValue;
	  }

	});

	module.exports = ReactDOMSelect;

	},{"./AutoFocusMixin":1,"./LinkedValueUtils":23,"./ReactBrowserComponentMixin":28,"./ReactCompositeComponent":33,"./ReactDOM":36,"./merge":130}],45:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMSelection
	 */

	"use strict";

	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	var getNodeForCharacterOffset = _dereq_("./getNodeForCharacterOffset");
	var getTextContentAccessor = _dereq_("./getTextContentAccessor");

	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}

	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;

	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);

	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;

	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}

	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection();

	  if (selection.rangeCount === 0) {
	    return null;
	  }

	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;

	  var currentRange = selection.getRangeAt(0);

	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(
	    selection.anchorNode,
	    selection.anchorOffset,
	    selection.focusNode,
	    selection.focusOffset
	  );

	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

	  var isTempRangeCollapsed = isCollapsed(
	    tempRange.startContainer,
	    tempRange.startOffset,
	    tempRange.endContainer,
	    tempRange.endOffset
	  );

	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;

	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	  detectionRange.detach();

	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}

	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;

	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }

	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}

	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  var selection = window.getSelection();

	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ?
	            start : Math.min(offsets.end, length);

	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }

	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);

	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();

	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }

	    range.detach();
	  }
	}

	var useIEOffsets = ExecutionEnvironment.canUseDOM && document.selection;

	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};

	module.exports = ReactDOMSelection;

	},{"./ExecutionEnvironment":21,"./getNodeForCharacterOffset":113,"./getTextContentAccessor":115}],46:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDOMTextarea
	 */

	"use strict";

	var AutoFocusMixin = _dereq_("./AutoFocusMixin");
	var DOMPropertyOperations = _dereq_("./DOMPropertyOperations");
	var LinkedValueUtils = _dereq_("./LinkedValueUtils");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactDOM = _dereq_("./ReactDOM");

	var invariant = _dereq_("./invariant");
	var merge = _dereq_("./merge");

	var warning = _dereq_("./warning");

	// Store a reference to the <textarea> `ReactDOMComponent`.
	var textarea = ReactDOM.textarea;

	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = ReactCompositeComponent.createClass({
	  displayName: 'ReactDOMTextarea',

	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],

	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = this.props.children;
	    if (children != null) {
	      if ("production" !== "development") {
	        ("production" !== "development" ? warning(
	          false,
	          'Use the `defaultValue` or `value` props instead of setting ' +
	          'children on <textarea>.'
	        ) : null);
	      }
	      ("production" !== "development" ? invariant(
	        defaultValue == null,
	        'If you supply `defaultValue` on a <textarea>, do not pass children.'
	      ) : invariant(defaultValue == null));
	      if (Array.isArray(children)) {
	        ("production" !== "development" ? invariant(
	          children.length <= 1,
	          '<textarea> can only have at most one child.'
	        ) : invariant(children.length <= 1));
	        children = children[0];
	      }

	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(this);
	    return {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue)
	    };
	  },

	  shouldComponentUpdate: function() {
	    // Defer any updates to this component during the `onChange` handler.
	    return !this._isChanging;
	  },

	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = merge(this.props);

	    ("production" !== "development" ? invariant(
	      props.dangerouslySetInnerHTML == null,
	      '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
	    ) : invariant(props.dangerouslySetInnerHTML == null));

	    props.defaultValue = null;
	    props.value = null;
	    props.onChange = this._handleChange;

	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    return textarea(props, this.state.initialValue);
	  },

	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      var rootNode = this.getDOMNode();
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },

	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      this._isChanging = true;
	      returnValue = onChange.call(this, event);
	      this._isChanging = false;
	    }
	    this.setState({value: event.target.value});
	    return returnValue;
	  }

	});

	module.exports = ReactDOMTextarea;

	},{"./AutoFocusMixin":1,"./DOMPropertyOperations":11,"./LinkedValueUtils":23,"./ReactBrowserComponentMixin":28,"./ReactCompositeComponent":33,"./ReactDOM":36,"./invariant":120,"./merge":130,"./warning":143}],47:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */

	"use strict";

	var ReactUpdates = _dereq_("./ReactUpdates");
	var Transaction = _dereq_("./Transaction");

	var emptyFunction = _dereq_("./emptyFunction");
	var mixInto = _dereq_("./mixInto");

	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function() {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};

	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};

	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}

	mixInto(ReactDefaultBatchingStrategyTransaction, Transaction.Mixin);
	mixInto(ReactDefaultBatchingStrategyTransaction, {
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  }
	});

	var transaction = new ReactDefaultBatchingStrategyTransaction();

	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,

	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function(callback, a, b) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b);
	    } else {
	      transaction.perform(callback, null, a, b);
	    }
	  }
	};

	module.exports = ReactDefaultBatchingStrategy;

	},{"./ReactUpdates":76,"./Transaction":92,"./emptyFunction":102,"./mixInto":133}],48:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDefaultInjection
	 */

	"use strict";

	var BeforeInputEventPlugin = _dereq_("./BeforeInputEventPlugin");
	var ChangeEventPlugin = _dereq_("./ChangeEventPlugin");
	var ClientReactRootIndex = _dereq_("./ClientReactRootIndex");
	var CompositionEventPlugin = _dereq_("./CompositionEventPlugin");
	var DefaultEventPluginOrder = _dereq_("./DefaultEventPluginOrder");
	var EnterLeaveEventPlugin = _dereq_("./EnterLeaveEventPlugin");
	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");
	var HTMLDOMPropertyConfig = _dereq_("./HTMLDOMPropertyConfig");
	var MobileSafariClickEventPlugin = _dereq_("./MobileSafariClickEventPlugin");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactComponentBrowserEnvironment =
	  _dereq_("./ReactComponentBrowserEnvironment");
	var ReactDefaultBatchingStrategy = _dereq_("./ReactDefaultBatchingStrategy");
	var ReactDOM = _dereq_("./ReactDOM");
	var ReactDOMButton = _dereq_("./ReactDOMButton");
	var ReactDOMForm = _dereq_("./ReactDOMForm");
	var ReactDOMImg = _dereq_("./ReactDOMImg");
	var ReactDOMInput = _dereq_("./ReactDOMInput");
	var ReactDOMOption = _dereq_("./ReactDOMOption");
	var ReactDOMSelect = _dereq_("./ReactDOMSelect");
	var ReactDOMTextarea = _dereq_("./ReactDOMTextarea");
	var ReactEventListener = _dereq_("./ReactEventListener");
	var ReactInjection = _dereq_("./ReactInjection");
	var ReactInstanceHandles = _dereq_("./ReactInstanceHandles");
	var ReactMount = _dereq_("./ReactMount");
	var SelectEventPlugin = _dereq_("./SelectEventPlugin");
	var ServerReactRootIndex = _dereq_("./ServerReactRootIndex");
	var SimpleEventPlugin = _dereq_("./SimpleEventPlugin");
	var SVGDOMPropertyConfig = _dereq_("./SVGDOMPropertyConfig");

	var createFullPageComponent = _dereq_("./createFullPageComponent");

	function inject() {
	  ReactInjection.EventEmitter.injectReactEventListener(
	    ReactEventListener
	  );

	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);

	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    CompositionEventPlugin: CompositionEventPlugin,
	    MobileSafariClickEventPlugin: MobileSafariClickEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });

	  ReactInjection.DOM.injectComponentClasses({
	    button: ReactDOMButton,
	    form: ReactDOMForm,
	    img: ReactDOMImg,
	    input: ReactDOMInput,
	    option: ReactDOMOption,
	    select: ReactDOMSelect,
	    textarea: ReactDOMTextarea,

	    html: createFullPageComponent(ReactDOM.html),
	    head: createFullPageComponent(ReactDOM.head),
	    body: createFullPageComponent(ReactDOM.body)
	  });

	  // This needs to happen after createFullPageComponent() otherwise the mixin
	  // gets double injected.
	  ReactInjection.CompositeComponent.injectMixin(ReactBrowserComponentMixin);

	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

	  ReactInjection.EmptyComponent.injectEmptyComponent(ReactDOM.noscript);

	  ReactInjection.Updates.injectReconcileTransaction(
	    ReactComponentBrowserEnvironment.ReactReconcileTransaction
	  );
	  ReactInjection.Updates.injectBatchingStrategy(
	    ReactDefaultBatchingStrategy
	  );

	  ReactInjection.RootIndex.injectCreateReactRootIndex(
	    ExecutionEnvironment.canUseDOM ?
	      ClientReactRootIndex.createReactRootIndex :
	      ServerReactRootIndex.createReactRootIndex
	  );

	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);

	  if ("production" !== "development") {
	    var url = (ExecutionEnvironment.canUseDOM && window.location.href) || '';
	    if ((/[?&]react_perf\b/).test(url)) {
	      var ReactDefaultPerf = _dereq_("./ReactDefaultPerf");
	      ReactDefaultPerf.start();
	    }
	  }
	}

	module.exports = {
	  inject: inject
	};

	},{"./BeforeInputEventPlugin":2,"./ChangeEventPlugin":6,"./ClientReactRootIndex":7,"./CompositionEventPlugin":8,"./DefaultEventPluginOrder":13,"./EnterLeaveEventPlugin":14,"./ExecutionEnvironment":21,"./HTMLDOMPropertyConfig":22,"./MobileSafariClickEventPlugin":25,"./ReactBrowserComponentMixin":28,"./ReactComponentBrowserEnvironment":32,"./ReactDOM":36,"./ReactDOMButton":37,"./ReactDOMForm":39,"./ReactDOMImg":41,"./ReactDOMInput":42,"./ReactDOMOption":43,"./ReactDOMSelect":44,"./ReactDOMTextarea":46,"./ReactDefaultBatchingStrategy":47,"./ReactDefaultPerf":49,"./ReactEventListener":56,"./ReactInjection":57,"./ReactInstanceHandles":59,"./ReactMount":61,"./SVGDOMPropertyConfig":77,"./SelectEventPlugin":78,"./ServerReactRootIndex":79,"./SimpleEventPlugin":80,"./createFullPageComponent":99}],49:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDefaultPerf
	 * @typechecks static-only
	 */

	"use strict";

	var DOMProperty = _dereq_("./DOMProperty");
	var ReactDefaultPerfAnalysis = _dereq_("./ReactDefaultPerfAnalysis");
	var ReactMount = _dereq_("./ReactMount");
	var ReactPerf = _dereq_("./ReactPerf");

	var performanceNow = _dereq_("./performanceNow");

	function roundFloat(val) {
	  return Math.floor(val * 100) / 100;
	}

	function addValue(obj, key, val) {
	  obj[key] = (obj[key] || 0) + val;
	}

	var ReactDefaultPerf = {
	  _allMeasurements: [], // last item in the list is the current one
	  _mountStack: [0],
	  _injected: false,

	  start: function() {
	    if (!ReactDefaultPerf._injected) {
	      ReactPerf.injection.injectMeasure(ReactDefaultPerf.measure);
	    }

	    ReactDefaultPerf._allMeasurements.length = 0;
	    ReactPerf.enableMeasure = true;
	  },

	  stop: function() {
	    ReactPerf.enableMeasure = false;
	  },

	  getLastMeasurements: function() {
	    return ReactDefaultPerf._allMeasurements;
	  },

	  printExclusive: function(measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getExclusiveSummary(measurements);
	    console.table(summary.map(function(item) {
	      return {
	        'Component class name': item.componentName,
	        'Total inclusive time (ms)': roundFloat(item.inclusive),
	        'Exclusive mount time (ms)': roundFloat(item.exclusive),
	        'Exclusive render time (ms)': roundFloat(item.render),
	        'Mount time per instance (ms)': roundFloat(item.exclusive / item.count),
	        'Render time per instance (ms)': roundFloat(item.render / item.count),
	        'Instances': item.count
	      };
	    }));
	    // TODO: ReactDefaultPerfAnalysis.getTotalTime() does not return the correct
	    // number.
	  },

	  printInclusive: function(measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(measurements);
	    console.table(summary.map(function(item) {
	      return {
	        'Owner > component': item.componentName,
	        'Inclusive time (ms)': roundFloat(item.time),
	        'Instances': item.count
	      };
	    }));
	    console.log(
	      'Total time:',
	      ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms'
	    );
	  },

	  printWasted: function(measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(
	      measurements,
	      true
	    );
	    console.table(summary.map(function(item) {
	      return {
	        'Owner > component': item.componentName,
	        'Wasted time (ms)': item.time,
	        'Instances': item.count
	      };
	    }));
	    console.log(
	      'Total time:',
	      ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms'
	    );
	  },

	  printDOM: function(measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getDOMSummary(measurements);
	    console.table(summary.map(function(item) {
	      var result = {};
	      result[DOMProperty.ID_ATTRIBUTE_NAME] = item.id;
	      result['type'] = item.type;
	      result['args'] = JSON.stringify(item.args);
	      return result;
	    }));
	    console.log(
	      'Total time:',
	      ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms'
	    );
	  },

	  _recordWrite: function(id, fnName, totalTime, args) {
	    // TODO: totalTime isn't that useful since it doesn't count paints/reflows
	    var writes =
	      ReactDefaultPerf
	        ._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1]
	        .writes;
	    writes[id] = writes[id] || [];
	    writes[id].push({
	      type: fnName,
	      time: totalTime,
	      args: args
	    });
	  },

	  measure: function(moduleName, fnName, func) {
	    return function() {var args=Array.prototype.slice.call(arguments,0);
	      var totalTime;
	      var rv;
	      var start;

	      if (fnName === '_renderNewRootComponent' ||
	          fnName === 'flushBatchedUpdates') {
	        // A "measurement" is a set of metrics recorded for each flush. We want
	        // to group the metrics for a given flush together so we can look at the
	        // components that rendered and the DOM operations that actually
	        // happened to determine the amount of "wasted work" performed.
	        ReactDefaultPerf._allMeasurements.push({
	          exclusive: {},
	          inclusive: {},
	          render: {},
	          counts: {},
	          writes: {},
	          displayNames: {},
	          totalTime: 0
	        });
	        start = performanceNow();
	        rv = func.apply(this, args);
	        ReactDefaultPerf._allMeasurements[
	          ReactDefaultPerf._allMeasurements.length - 1
	        ].totalTime = performanceNow() - start;
	        return rv;
	      } else if (moduleName === 'ReactDOMIDOperations' ||
	        moduleName === 'ReactComponentBrowserEnvironment') {
	        start = performanceNow();
	        rv = func.apply(this, args);
	        totalTime = performanceNow() - start;

	        if (fnName === 'mountImageIntoNode') {
	          var mountID = ReactMount.getID(args[1]);
	          ReactDefaultPerf._recordWrite(mountID, fnName, totalTime, args[0]);
	        } else if (fnName === 'dangerouslyProcessChildrenUpdates') {
	          // special format
	          args[0].forEach(function(update) {
	            var writeArgs = {};
	            if (update.fromIndex !== null) {
	              writeArgs.fromIndex = update.fromIndex;
	            }
	            if (update.toIndex !== null) {
	              writeArgs.toIndex = update.toIndex;
	            }
	            if (update.textContent !== null) {
	              writeArgs.textContent = update.textContent;
	            }
	            if (update.markupIndex !== null) {
	              writeArgs.markup = args[1][update.markupIndex];
	            }
	            ReactDefaultPerf._recordWrite(
	              update.parentID,
	              update.type,
	              totalTime,
	              writeArgs
	            );
	          });
	        } else {
	          // basic format
	          ReactDefaultPerf._recordWrite(
	            args[0],
	            fnName,
	            totalTime,
	            Array.prototype.slice.call(args, 1)
	          );
	        }
	        return rv;
	      } else if (moduleName === 'ReactCompositeComponent' && (
	        fnName === 'mountComponent' ||
	        fnName === 'updateComponent' || // TODO: receiveComponent()?
	        fnName === '_renderValidatedComponent')) {

	        var rootNodeID = fnName === 'mountComponent' ?
	          args[0] :
	          this._rootNodeID;
	        var isRender = fnName === '_renderValidatedComponent';
	        var isMount = fnName === 'mountComponent';

	        var mountStack = ReactDefaultPerf._mountStack;
	        var entry = ReactDefaultPerf._allMeasurements[
	          ReactDefaultPerf._allMeasurements.length - 1
	        ];

	        if (isRender) {
	          addValue(entry.counts, rootNodeID, 1);
	        } else if (isMount) {
	          mountStack.push(0);
	        }

	        start = performanceNow();
	        rv = func.apply(this, args);
	        totalTime = performanceNow() - start;

	        if (isRender) {
	          addValue(entry.render, rootNodeID, totalTime);
	        } else if (isMount) {
	          var subMountTime = mountStack.pop();
	          mountStack[mountStack.length - 1] += totalTime;
	          addValue(entry.exclusive, rootNodeID, totalTime - subMountTime);
	          addValue(entry.inclusive, rootNodeID, totalTime);
	        } else {
	          addValue(entry.inclusive, rootNodeID, totalTime);
	        }

	        entry.displayNames[rootNodeID] = {
	          current: this.constructor.displayName,
	          owner: this._owner ? this._owner.constructor.displayName : '<root>'
	        };

	        return rv;
	      } else {
	        return func.apply(this, args);
	      }
	    };
	  }
	};

	module.exports = ReactDefaultPerf;

	},{"./DOMProperty":10,"./ReactDefaultPerfAnalysis":50,"./ReactMount":61,"./ReactPerf":65,"./performanceNow":137}],50:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDefaultPerfAnalysis
	 */

	var merge = _dereq_("./merge");

	// Don't try to save users less than 1.2ms (a number I made up)
	var DONT_CARE_THRESHOLD = 1.2;
	var DOM_OPERATION_TYPES = {
	  'mountImageIntoNode': 'set innerHTML',
	  INSERT_MARKUP: 'set innerHTML',
	  MOVE_EXISTING: 'move',
	  REMOVE_NODE: 'remove',
	  TEXT_CONTENT: 'set textContent',
	  'updatePropertyByID': 'update attribute',
	  'deletePropertyByID': 'delete attribute',
	  'updateStylesByID': 'update styles',
	  'updateInnerHTMLByID': 'set innerHTML',
	  'dangerouslyReplaceNodeWithMarkupByID': 'replace'
	};

	function getTotalTime(measurements) {
	  // TODO: return number of DOM ops? could be misleading.
	  // TODO: measure dropped frames after reconcile?
	  // TODO: log total time of each reconcile and the top-level component
	  // class that triggered it.
	  var totalTime = 0;
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    totalTime += measurement.totalTime;
	  }
	  return totalTime;
	}

	function getDOMSummary(measurements) {
	  var items = [];
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var id;

	    for (id in measurement.writes) {
	      measurement.writes[id].forEach(function(write) {
	        items.push({
	          id: id,
	          type: DOM_OPERATION_TYPES[write.type] || write.type,
	          args: write.args
	        });
	      });
	    }
	  }
	  return items;
	}

	function getExclusiveSummary(measurements) {
	  var candidates = {};
	  var displayName;

	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var allIDs = merge(measurement.exclusive, measurement.inclusive);

	    for (var id in allIDs) {
	      displayName = measurement.displayNames[id].current;

	      candidates[displayName] = candidates[displayName] || {
	        componentName: displayName,
	        inclusive: 0,
	        exclusive: 0,
	        render: 0,
	        count: 0
	      };
	      if (measurement.render[id]) {
	        candidates[displayName].render += measurement.render[id];
	      }
	      if (measurement.exclusive[id]) {
	        candidates[displayName].exclusive += measurement.exclusive[id];
	      }
	      if (measurement.inclusive[id]) {
	        candidates[displayName].inclusive += measurement.inclusive[id];
	      }
	      if (measurement.counts[id]) {
	        candidates[displayName].count += measurement.counts[id];
	      }
	    }
	  }

	  // Now make a sorted array with the results.
	  var arr = [];
	  for (displayName in candidates) {
	    if (candidates[displayName].exclusive >= DONT_CARE_THRESHOLD) {
	      arr.push(candidates[displayName]);
	    }
	  }

	  arr.sort(function(a, b) {
	    return b.exclusive - a.exclusive;
	  });

	  return arr;
	}

	function getInclusiveSummary(measurements, onlyClean) {
	  var candidates = {};
	  var inclusiveKey;

	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var allIDs = merge(measurement.exclusive, measurement.inclusive);
	    var cleanComponents;

	    if (onlyClean) {
	      cleanComponents = getUnchangedComponents(measurement);
	    }

	    for (var id in allIDs) {
	      if (onlyClean && !cleanComponents[id]) {
	        continue;
	      }

	      var displayName = measurement.displayNames[id];

	      // Inclusive time is not useful for many components without knowing where
	      // they are instantiated. So we aggregate inclusive time with both the
	      // owner and current displayName as the key.
	      inclusiveKey = displayName.owner + ' > ' + displayName.current;

	      candidates[inclusiveKey] = candidates[inclusiveKey] || {
	        componentName: inclusiveKey,
	        time: 0,
	        count: 0
	      };

	      if (measurement.inclusive[id]) {
	        candidates[inclusiveKey].time += measurement.inclusive[id];
	      }
	      if (measurement.counts[id]) {
	        candidates[inclusiveKey].count += measurement.counts[id];
	      }
	    }
	  }

	  // Now make a sorted array with the results.
	  var arr = [];
	  for (inclusiveKey in candidates) {
	    if (candidates[inclusiveKey].time >= DONT_CARE_THRESHOLD) {
	      arr.push(candidates[inclusiveKey]);
	    }
	  }

	  arr.sort(function(a, b) {
	    return b.time - a.time;
	  });

	  return arr;
	}

	function getUnchangedComponents(measurement) {
	  // For a given reconcile, look at which components did not actually
	  // render anything to the DOM and return a mapping of their ID to
	  // the amount of time it took to render the entire subtree.
	  var cleanComponents = {};
	  var dirtyLeafIDs = Object.keys(measurement.writes);
	  var allIDs = merge(measurement.exclusive, measurement.inclusive);

	  for (var id in allIDs) {
	    var isDirty = false;
	    // For each component that rendered, see if a component that triggerd
	    // a DOM op is in its subtree.
	    for (var i = 0; i < dirtyLeafIDs.length; i++) {
	      if (dirtyLeafIDs[i].indexOf(id) === 0) {
	        isDirty = true;
	        break;
	      }
	    }
	    if (!isDirty && measurement.counts[id] > 0) {
	      cleanComponents[id] = true;
	    }
	  }
	  return cleanComponents;
	}

	var ReactDefaultPerfAnalysis = {
	  getExclusiveSummary: getExclusiveSummary,
	  getInclusiveSummary: getInclusiveSummary,
	  getDOMSummary: getDOMSummary,
	  getTotalTime: getTotalTime
	};

	module.exports = ReactDefaultPerfAnalysis;

	},{"./merge":130}],51:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDescriptor
	 */

	"use strict";

	var ReactContext = _dereq_("./ReactContext");
	var ReactCurrentOwner = _dereq_("./ReactCurrentOwner");

	var merge = _dereq_("./merge");
	var warning = _dereq_("./warning");

	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} object
	 * @param {string} key
	 */
	function defineWarningProperty(object, key) {
	  Object.defineProperty(object, key, {

	    configurable: false,
	    enumerable: true,

	    get: function() {
	      if (!this._store) {
	        return null;
	      }
	      return this._store[key];
	    },

	    set: function(value) {
	      ("production" !== "development" ? warning(
	        false,
	        'Don\'t set the ' + key + ' property of the component. ' +
	        'Mutate the existing props object instead.'
	      ) : null);
	      this._store[key] = value;
	    }

	  });
	}

	/**
	 * This is updated to true if the membrane is successfully created.
	 */
	var useMutationMembrane = false;

	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} descriptor
	 */
	function defineMutationMembrane(prototype) {
	  try {
	    var pseudoFrozenProperties = {
	      props: true
	    };
	    for (var key in pseudoFrozenProperties) {
	      defineWarningProperty(prototype, key);
	    }
	    useMutationMembrane = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}

	/**
	 * Transfer static properties from the source to the target. Functions are
	 * rebound to have this reflect the original source.
	 */
	function proxyStaticMethods(target, source) {
	  if (typeof source !== 'function') {
	    return;
	  }
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      var value = source[key];
	      if (typeof value === 'function') {
	        var bound = value.bind(source);
	        // Copy any properties defined on the function, such as `isRequired` on
	        // a PropTypes validator. (mergeInto refuses to work on functions.)
	        for (var k in value) {
	          if (value.hasOwnProperty(k)) {
	            bound[k] = value[k];
	          }
	        }
	        target[key] = bound;
	      } else {
	        target[key] = value;
	      }
	    }
	  }
	}

	/**
	 * Base constructor for all React descriptors. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @internal
	 */
	var ReactDescriptor = function() {};

	if ("production" !== "development") {
	  defineMutationMembrane(ReactDescriptor.prototype);
	}

	ReactDescriptor.createFactory = function(type) {

	  var descriptorPrototype = Object.create(ReactDescriptor.prototype);

	  var factory = function(props, children) {
	    // For consistency we currently allocate a new object for every descriptor.
	    // This protects the descriptor from being mutated by the original props
	    // object being mutated. It also protects the original props object from
	    // being mutated by children arguments and default props. This behavior
	    // comes with a performance cost and could be deprecated in the future.
	    // It could also be optimized with a smarter JSX transform.
	    if (props == null) {
	      props = {};
	    } else if (typeof props === 'object') {
	      props = merge(props);
	    }

	    // Children can be more than one argument, and those are transferred onto
	    // the newly allocated props object.
	    var childrenLength = arguments.length - 1;
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 1];
	      }
	      props.children = childArray;
	    }

	    // Initialize the descriptor object
	    var descriptor = Object.create(descriptorPrototype);

	    // Record the component responsible for creating this descriptor.
	    descriptor._owner = ReactCurrentOwner.current;

	    // TODO: Deprecate withContext, and then the context becomes accessible
	    // through the owner.
	    descriptor._context = ReactContext.current;

	    if ("production" !== "development") {
	      // The validation flag and props are currently mutative. We put them on
	      // an external backing store so that we can freeze the whole object.
	      // This can be replaced with a WeakMap once they are implemented in
	      // commonly used development environments.
	      descriptor._store = { validated: false, props: props };

	      // We're not allowed to set props directly on the object so we early
	      // return and rely on the prototype membrane to forward to the backing
	      // store.
	      if (useMutationMembrane) {
	        Object.freeze(descriptor);
	        return descriptor;
	      }
	    }

	    descriptor.props = props;
	    return descriptor;
	  };

	  // Currently we expose the prototype of the descriptor so that
	  // <Foo /> instanceof Foo works. This is controversial pattern.
	  factory.prototype = descriptorPrototype;

	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on descriptors. E.g. <Foo />.type === Foo.type and for
	  // static methods like <Foo />.type.staticMethod();
	  // This should not be named constructor since this may not be the function
	  // that created the descriptor, and it may not even be a constructor.
	  factory.type = type;
	  descriptorPrototype.type = type;

	  proxyStaticMethods(factory, type);

	  // Expose a unique constructor on the prototype is that this works with type
	  // systems that compare constructor properties: <Foo />.constructor === Foo
	  // This may be controversial since it requires a known factory function.
	  descriptorPrototype.constructor = factory;

	  return factory;

	};

	ReactDescriptor.cloneAndReplaceProps = function(oldDescriptor, newProps) {
	  var newDescriptor = Object.create(oldDescriptor.constructor.prototype);
	  // It's important that this property order matches the hidden class of the
	  // original descriptor to maintain perf.
	  newDescriptor._owner = oldDescriptor._owner;
	  newDescriptor._context = oldDescriptor._context;

	  if ("production" !== "development") {
	    newDescriptor._store = {
	      validated: oldDescriptor._store.validated,
	      props: newProps
	    };
	    if (useMutationMembrane) {
	      Object.freeze(newDescriptor);
	      return newDescriptor;
	    }
	  }

	  newDescriptor.props = newProps;
	  return newDescriptor;
	};

	/**
	 * Checks if a value is a valid descriptor constructor.
	 *
	 * @param {*}
	 * @return {boolean}
	 * @public
	 */
	ReactDescriptor.isValidFactory = function(factory) {
	  return typeof factory === 'function' &&
	         factory.prototype instanceof ReactDescriptor;
	};

	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactDescriptor.isValidDescriptor = function(object) {
	  return object instanceof ReactDescriptor;
	};

	module.exports = ReactDescriptor;

	},{"./ReactContext":34,"./ReactCurrentOwner":35,"./merge":130,"./warning":143}],52:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactDescriptorValidator
	 */

	/**
	 * ReactDescriptorValidator provides a wrapper around a descriptor factory
	 * which validates the props passed to the descriptor. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */

	"use strict";

	var ReactDescriptor = _dereq_("./ReactDescriptor");
	var ReactPropTypeLocations = _dereq_("./ReactPropTypeLocations");
	var ReactCurrentOwner = _dereq_("./ReactCurrentOwner");

	var monitorCodeUse = _dereq_("./monitorCodeUse");

	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {
	  'react_key_warning': {},
	  'react_numeric_key_warning': {}
	};
	var ownerHasMonitoredObjectMap = {};

	var loggedTypeFailures = {};

	var NUMERIC_PROPERTY_REGEX = /^\d+$/;

	/**
	 * Gets the current owner's displayName for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getCurrentOwnerDisplayName() {
	  var current = ReactCurrentOwner.current;
	  return current && current.constructor.displayName || undefined;
	}

	/**
	 * Warn if the component doesn't have an explicit key assigned to it.
	 * This component is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactComponent} component Component that requires a key.
	 * @param {*} parentType component's parent's type.
	 */
	function validateExplicitKey(component, parentType) {
	  if (component._store.validated || component.props.key != null) {
	    return;
	  }
	  component._store.validated = true;

	  warnAndMonitorForKeyUse(
	    'react_key_warning',
	    'Each child in an array should have a unique "key" prop.',
	    component,
	    parentType
	  );
	}

	/**
	 * Warn if the key is being defined as an object property but has an incorrect
	 * value.
	 *
	 * @internal
	 * @param {string} name Property name of the key.
	 * @param {ReactComponent} component Component that requires a key.
	 * @param {*} parentType component's parent's type.
	 */
	function validatePropertyKey(name, component, parentType) {
	  if (!NUMERIC_PROPERTY_REGEX.test(name)) {
	    return;
	  }
	  warnAndMonitorForKeyUse(
	    'react_numeric_key_warning',
	    'Child objects should have non-numeric keys so ordering is preserved.',
	    component,
	    parentType
	  );
	}

	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} warningID The id used when logging.
	 * @param {string} message The base warning that gets output.
	 * @param {ReactComponent} component Component that requires a key.
	 * @param {*} parentType component's parent's type.
	 */
	function warnAndMonitorForKeyUse(warningID, message, component, parentType) {
	  var ownerName = getCurrentOwnerDisplayName();
	  var parentName = parentType.displayName;

	  var useName = ownerName || parentName;
	  var memoizer = ownerHasKeyUseWarning[warningID];
	  if (memoizer.hasOwnProperty(useName)) {
	    return;
	  }
	  memoizer[useName] = true;

	  message += ownerName ?
	    (" Check the render method of " + ownerName + ".") :
	    (" Check the renderComponent call using <" + parentName + ">.");

	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwnerName = null;
	  if (component._owner && component._owner !== ReactCurrentOwner.current) {
	    // Name of the component that originally created this child.
	    childOwnerName = component._owner.constructor.displayName;

	    message += (" It was passed a child from " + childOwnerName + ".");
	  }

	  message += ' See http://fb.me/react-warning-keys for more information.';
	  monitorCodeUse(warningID, {
	    component: useName,
	    componentOwner: childOwnerName
	  });
	  console.warn(message);
	}

	/**
	 * Log that we're using an object map. We're considering deprecating this
	 * feature and replace it with proper Map and ImmutableMap data structures.
	 *
	 * @internal
	 */
	function monitorUseOfObjectMap() {
	  var currentName = getCurrentOwnerDisplayName() || '';
	  if (ownerHasMonitoredObjectMap.hasOwnProperty(currentName)) {
	    return;
	  }
	  ownerHasMonitoredObjectMap[currentName] = true;
	  monitorCodeUse('react_object_map_children');
	}

	/**
	 * Ensure that every component either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {*} component Statically passed child of any type.
	 * @param {*} parentType component's parent's type.
	 * @return {boolean}
	 */
	function validateChildKeys(component, parentType) {
	  if (Array.isArray(component)) {
	    for (var i = 0; i < component.length; i++) {
	      var child = component[i];
	      if (ReactDescriptor.isValidDescriptor(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactDescriptor.isValidDescriptor(component)) {
	    // This component was passed in a valid location.
	    component._store.validated = true;
	  } else if (component && typeof component === 'object') {
	    monitorUseOfObjectMap();
	    for (var name in component) {
	      validatePropertyKey(name, component[name], parentType);
	    }
	  }
	}

	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	        // This will soon use the warning module
	        monitorCodeUse(
	          'react_failed_descriptor_type_check',
	          { message: error.message }
	        );
	      }
	    }
	  }
	}

	var ReactDescriptorValidator = {

	  /**
	   * Wraps a descriptor factory function in another function which validates
	   * the props and context of the descriptor and warns about any failed type
	   * checks.
	   *
	   * @param {function} factory The original descriptor factory
	   * @param {object?} propTypes A prop type definition set
	   * @param {object?} contextTypes A context type definition set
	   * @return {object} The component descriptor, which may be invalid.
	   * @private
	   */
	  createFactory: function(factory, propTypes, contextTypes) {
	    var validatedFactory = function(props, children) {
	      var descriptor = factory.apply(this, arguments);

	      for (var i = 1; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], descriptor.type);
	      }

	      var name = descriptor.type.displayName;
	      if (propTypes) {
	        checkPropTypes(
	          name,
	          propTypes,
	          descriptor.props,
	          ReactPropTypeLocations.prop
	        );
	      }
	      if (contextTypes) {
	        checkPropTypes(
	          name,
	          contextTypes,
	          descriptor._context,
	          ReactPropTypeLocations.context
	        );
	      }
	      return descriptor;
	    };

	    validatedFactory.prototype = factory.prototype;
	    validatedFactory.type = factory.type;

	    // Copy static properties
	    for (var key in factory) {
	      if (factory.hasOwnProperty(key)) {
	        validatedFactory[key] = factory[key];
	      }
	    }

	    return validatedFactory;
	  }

	};

	module.exports = ReactDescriptorValidator;

	},{"./ReactCurrentOwner":35,"./ReactDescriptor":51,"./ReactPropTypeLocations":68,"./monitorCodeUse":134}],53:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactEmptyComponent
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	var component;
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIdsRegistry = {};

	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function(emptyComponent) {
	    component = emptyComponent;
	  }
	};

	/**
	 * @return {ReactComponent} component The injected empty component.
	 */
	function getEmptyComponent() {
	  ("production" !== "development" ? invariant(
	    component,
	    'Trying to return null from a render, but no null placeholder component ' +
	    'was injected.'
	  ) : invariant(component));
	  return component();
	}

	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIdsRegistry[id] = true;
	}

	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIdsRegistry[id];
	}

	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return nullComponentIdsRegistry[id];
	}

	var ReactEmptyComponent = {
	  deregisterNullComponentID: deregisterNullComponentID,
	  getEmptyComponent: getEmptyComponent,
	  injection: ReactEmptyComponentInjection,
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID
	};

	module.exports = ReactEmptyComponent;

	},{"./invariant":120}],54:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */

	"use strict";

	var ReactErrorUtils = {
	  /**
	   * Creates a guarded version of a function. This is supposed to make debugging
	   * of event handlers easier. To aid debugging with the browser's debugger,
	   * this currently simply returns the original function.
	   *
	   * @param {function} func Function to be executed
	   * @param {string} name The name of the guard
	   * @return {function}
	   */
	  guard: function(func, name) {
	    return func;
	  }
	};

	module.exports = ReactErrorUtils;

	},{}],55:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */

	"use strict";

	var EventPluginHub = _dereq_("./EventPluginHub");

	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue();
	}

	var ReactEventEmitterMixin = {

	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events = EventPluginHub.extractEvents(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent
	    );

	    runEventQueueInBatch(events);
	  }
	};

	module.exports = ReactEventEmitterMixin;

	},{"./EventPluginHub":17}],56:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */

	"use strict";

	var EventListener = _dereq_("./EventListener");
	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");
	var PooledClass = _dereq_("./PooledClass");
	var ReactInstanceHandles = _dereq_("./ReactInstanceHandles");
	var ReactMount = _dereq_("./ReactMount");
	var ReactUpdates = _dereq_("./ReactUpdates");

	var getEventTarget = _dereq_("./getEventTarget");
	var getUnboundedScrollPosition = _dereq_("./getUnboundedScrollPosition");
	var mixInto = _dereq_("./mixInto");

	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}

	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	mixInto(TopLevelCallbackBookKeeping, {
	  destructor: function() {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(
	  TopLevelCallbackBookKeeping,
	  PooledClass.twoArgumentPooler
	);

	function handleTopLevelImpl(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(
	    getEventTarget(bookKeeping.nativeEvent)
	  ) || window;

	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }

	  for (var i = 0, l = bookKeeping.ancestors.length; i < l; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(
	      bookKeeping.topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      bookKeeping.nativeEvent
	    );
	  }
	}

	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}

	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,

	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

	  setHandleTopLevel: function(handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },

	  setEnabled: function(enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },

	  isEnabled: function() {
	    return ReactEventListener._enabled;
	  },


	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return;
	    }
	    return EventListener.listen(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },

	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return;
	    }
	    return EventListener.capture(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },

	  monitorScrollValue: function(refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	    EventListener.listen(window, 'resize', callback);
	  },

	  dispatchEvent: function(topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }

	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(
	      topLevelType,
	      nativeEvent
	    );
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};

	module.exports = ReactEventListener;

	},{"./EventListener":16,"./ExecutionEnvironment":21,"./PooledClass":26,"./ReactInstanceHandles":59,"./ReactMount":61,"./ReactUpdates":76,"./getEventTarget":111,"./getUnboundedScrollPosition":116,"./mixInto":133}],57:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactInjection
	 */

	"use strict";

	var DOMProperty = _dereq_("./DOMProperty");
	var EventPluginHub = _dereq_("./EventPluginHub");
	var ReactComponent = _dereq_("./ReactComponent");
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");
	var ReactDOM = _dereq_("./ReactDOM");
	var ReactEmptyComponent = _dereq_("./ReactEmptyComponent");
	var ReactBrowserEventEmitter = _dereq_("./ReactBrowserEventEmitter");
	var ReactPerf = _dereq_("./ReactPerf");
	var ReactRootIndex = _dereq_("./ReactRootIndex");
	var ReactUpdates = _dereq_("./ReactUpdates");

	var ReactInjection = {
	  Component: ReactComponent.injection,
	  CompositeComponent: ReactCompositeComponent.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  DOM: ReactDOM.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};

	module.exports = ReactInjection;

	},{"./DOMProperty":10,"./EventPluginHub":17,"./ReactBrowserEventEmitter":29,"./ReactComponent":31,"./ReactCompositeComponent":33,"./ReactDOM":36,"./ReactEmptyComponent":53,"./ReactPerf":65,"./ReactRootIndex":72,"./ReactUpdates":76}],58:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactInputSelection
	 */

	"use strict";

	var ReactDOMSelection = _dereq_("./ReactDOMSelection");

	var containsNode = _dereq_("./containsNode");
	var focusNode = _dereq_("./focusNode");
	var getActiveElement = _dereq_("./getActiveElement");

	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}

	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {

	  hasSelectionCapabilities: function(elem) {
	    return elem && (
	      (elem.nodeName === 'INPUT' && elem.type === 'text') ||
	      elem.nodeName === 'TEXTAREA' ||
	      elem.contentEditable === 'true'
	    );
	  },

	  getSelectionInformation: function() {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange:
	          ReactInputSelection.hasSelectionCapabilities(focusedElem) ?
	          ReactInputSelection.getSelection(focusedElem) :
	          null
	    };
	  },

	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function(priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem &&
	        isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(
	          priorFocusedElem,
	          priorSelectionRange
	        );
	      }
	      focusNode(priorFocusedElem);
	    }
	  },

	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function(input) {
	    var selection;

	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }

	    return selection || {start: 0, end: 0};
	  },

	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function(input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }

	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};

	module.exports = ReactInputSelection;

	},{"./ReactDOMSelection":45,"./containsNode":96,"./focusNode":106,"./getActiveElement":108}],59:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */

	"use strict";

	var ReactRootIndex = _dereq_("./ReactRootIndex");

	var invariant = _dereq_("./invariant");

	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;

	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 100;

	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}

	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}

	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || (
	    id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR
	  );
	}

	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return (
	    descendantID.indexOf(ancestorID) === 0 &&
	    isBoundary(descendantID, ancestorID.length)
	  );
	}

	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}

	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  ("production" !== "development" ? invariant(
	    isValidID(ancestorID) && isValidID(destinationID),
	    'getNextDescendantID(%s, %s): Received an invalid React DOM ID.',
	    ancestorID,
	    destinationID
	  ) : invariant(isValidID(ancestorID) && isValidID(destinationID)));
	  ("production" !== "development" ? invariant(
	    isAncestorIDOf(ancestorID, destinationID),
	    'getNextDescendantID(...): React has made an invalid assumption about ' +
	    'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.',
	    ancestorID,
	    destinationID
	  ) : invariant(isAncestorIDOf(ancestorID, destinationID)));
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  for (var i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}

	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  ("production" !== "development" ? invariant(
	    isValidID(longestCommonID),
	    'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s',
	    oneID,
	    twoID,
	    longestCommonID
	  ) : invariant(isValidID(longestCommonID)));
	  return longestCommonID;
	}

	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  ("production" !== "development" ? invariant(
	    start !== stop,
	    'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.',
	    start
	  ) : invariant(start !== stop));
	  var traverseUp = isAncestorIDOf(stop, start);
	  ("production" !== "development" ? invariant(
	    traverseUp || isAncestorIDOf(start, stop),
	    'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' +
	    'not have a parent path.',
	    start,
	    stop
	  ) : invariant(traverseUp || isAncestorIDOf(start, stop)));
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start; /* until break */; id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    ("production" !== "development" ? invariant(
	      depth++ < MAX_TREE_DEPTH,
	      'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' +
	      'traversing the React DOM ID tree. This may be due to malformed IDs: %s',
	      start, stop
	    ) : invariant(depth++ < MAX_TREE_DEPTH));
	  }
	}

	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {

	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function() {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },

	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function(rootID, name) {
	    return rootID + name;
	  },

	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function(id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },

	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function(leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },

	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function(targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },

	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function(targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },

	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getFirstCommonAncestorID: getFirstCommonAncestorID,

	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,

	  isAncestorIDOf: isAncestorIDOf,

	  SEPARATOR: SEPARATOR

	};

	module.exports = ReactInstanceHandles;

	},{"./ReactRootIndex":72,"./invariant":120}],60:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactMarkupChecksum
	 */

	"use strict";

	var adler32 = _dereq_("./adler32");

	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',

	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function(markup) {
	    var checksum = adler32(markup);
	    return markup.replace(
	      '>',
	      ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '">'
	    );
	  },

	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function(markup, element) {
	    var existingChecksum = element.getAttribute(
	      ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	    );
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};

	module.exports = ReactMarkupChecksum;

	},{"./adler32":95}],61:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactMount
	 */

	"use strict";

	var DOMProperty = _dereq_("./DOMProperty");
	var ReactBrowserEventEmitter = _dereq_("./ReactBrowserEventEmitter");
	var ReactCurrentOwner = _dereq_("./ReactCurrentOwner");
	var ReactDescriptor = _dereq_("./ReactDescriptor");
	var ReactInstanceHandles = _dereq_("./ReactInstanceHandles");
	var ReactPerf = _dereq_("./ReactPerf");

	var containsNode = _dereq_("./containsNode");
	var getReactRootElementInContainer = _dereq_("./getReactRootElementInContainer");
	var instantiateReactComponent = _dereq_("./instantiateReactComponent");
	var invariant = _dereq_("./invariant");
	var shouldUpdateReactComponent = _dereq_("./shouldUpdateReactComponent");
	var warning = _dereq_("./warning");

	var SEPARATOR = ReactInstanceHandles.SEPARATOR;

	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};

	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;

	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};

	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};

	if ("production" !== "development") {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}

	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];

	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}

	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        ("production" !== "development" ? invariant(
	          !isValid(cached, id),
	          'ReactMount: Two valid but unequal nodes with the same `%s`: %s',
	          ATTR_NAME, id
	        ) : invariant(!isValid(cached, id)));

	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }

	  return id;
	}

	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}

	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}

	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}

	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    ("production" !== "development" ? invariant(
	      internalGetID(node) === id,
	      'ReactMount: Unexpected modification of `%s`',
	      ATTR_NAME
	    ) : invariant(internalGetID(node) === id));

	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }

	  return false;
	}

	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}

	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}

	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(
	    targetID,
	    findDeepestCachedAncestorImpl
	  );

	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}

	/**
	 * Mounting is the process of initializing a React component by creatings its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.renderComponent(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,

	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function(container, renderCallback) {
	    renderCallback();
	  },

	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function(
	      prevComponent,
	      nextComponent,
	      container,
	      callback) {
	    var nextProps = nextComponent.props;
	    ReactMount.scrollMonitor(container, function() {
	      prevComponent.replaceProps(nextProps, callback);
	    });

	    if ("production" !== "development") {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] =
	        getReactRootElementInContainer(container);
	    }

	    return prevComponent;
	  },

	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function(nextComponent, container) {
	    ("production" !== "development" ? invariant(
	      container && (
	        container.nodeType === ELEMENT_NODE_TYPE ||
	        container.nodeType === DOC_NODE_TYPE
	      ),
	      '_registerComponent(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      container.nodeType === ELEMENT_NODE_TYPE ||
	      container.nodeType === DOC_NODE_TYPE
	    )));

	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();

	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },

	  /**
	   * Render a new component into the DOM.
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: ReactPerf.measure(
	    'ReactMount',
	    '_renderNewRootComponent',
	    function(
	        nextComponent,
	        container,
	        shouldReuseMarkup) {
	      // Various parts of our code (such as ReactCompositeComponent's
	      // _renderValidatedComponent) assume that calls to render aren't nested;
	      // verify that that's the case.
	      ("production" !== "development" ? warning(
	        ReactCurrentOwner.current == null,
	        '_renderNewRootComponent(): Render methods should be a pure function ' +
	        'of props and state; triggering nested component updates from ' +
	        'render is not allowed. If necessary, trigger nested updates in ' +
	        'componentDidUpdate.'
	      ) : null);

	      var componentInstance = instantiateReactComponent(nextComponent);
	      var reactRootID = ReactMount._registerComponent(
	        componentInstance,
	        container
	      );
	      componentInstance.mountComponentIntoNode(
	        reactRootID,
	        container,
	        shouldReuseMarkup
	      );

	      if ("production" !== "development") {
	        // Record the root element in case it later gets transplanted.
	        rootElementsByReactRootID[reactRootID] =
	          getReactRootElementInContainer(container);
	      }

	      return componentInstance;
	    }
	  ),

	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactDescriptor} nextDescriptor Component descriptor to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderComponent: function(nextDescriptor, container, callback) {
	    ("production" !== "development" ? invariant(
	      ReactDescriptor.isValidDescriptor(nextDescriptor),
	      'renderComponent(): Invalid component descriptor.%s',
	      (
	        ReactDescriptor.isValidFactory(nextDescriptor) ?
	          ' Instead of passing a component class, make sure to instantiate ' +
	          'it first by calling it with props.' :
	        // Check if it quacks like a descriptor
	        typeof nextDescriptor.props !== "undefined" ?
	          ' This may be caused by unintentionally loading two independent ' +
	          'copies of React.' :
	          ''
	      )
	    ) : invariant(ReactDescriptor.isValidDescriptor(nextDescriptor)));

	    var prevComponent = instancesByReactRootID[getReactRootID(container)];

	    if (prevComponent) {
	      var prevDescriptor = prevComponent._descriptor;
	      if (shouldUpdateReactComponent(prevDescriptor, nextDescriptor)) {
	        return ReactMount._updateRootComponent(
	          prevComponent,
	          nextDescriptor,
	          container,
	          callback
	        );
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }

	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup =
	      reactRootElement && ReactMount.isRenderedByReact(reactRootElement);

	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent;

	    var component = ReactMount._renderNewRootComponent(
	      nextDescriptor,
	      container,
	      shouldReuseMarkup
	    );
	    callback && callback.call(component);
	    return component;
	  },

	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into the supplied `container`.
	   *
	   * @param {function} constructor React component constructor.
	   * @param {?object} props Initial props of the component instance.
	   * @param {DOMElement} container DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  constructAndRenderComponent: function(constructor, props, container) {
	    return ReactMount.renderComponent(constructor(props), container);
	  },

	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into a container node identified by supplied `id`.
	   *
	   * @param {function} componentConstructor React component constructor
	   * @param {?object} props Initial props of the component instance.
	   * @param {string} id ID of the DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in the container node.
	   */
	  constructAndRenderComponentByID: function(constructor, props, id) {
	    var domNode = document.getElementById(id);
	    ("production" !== "development" ? invariant(
	      domNode,
	      'Tried to get element with id of "%s" but it is not present on the page.',
	      id
	    ) : invariant(domNode));
	    return ReactMount.constructAndRenderComponent(constructor, props, domNode);
	  },

	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function(container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },

	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function(container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	    ("production" !== "development" ? warning(
	      ReactCurrentOwner.current == null,
	      'unmountComponentAtNode(): Render methods should be a pure function of ' +
	      'props and state; triggering nested component updates from render is ' +
	      'not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);

	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      return false;
	    }
	    ReactMount.unmountComponentFromNode(component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if ("production" !== "development") {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },

	  /**
	   * Unmounts a component and removes it from the DOM.
	   *
	   * @param {ReactComponent} instance React component instance.
	   * @param {DOMElement} container DOM element to unmount from.
	   * @final
	   * @internal
	   * @see {ReactMount.unmountComponentAtNode}
	   */
	  unmountComponentFromNode: function(instance, container) {
	    instance.unmountComponent();

	    if (container.nodeType === DOC_NODE_TYPE) {
	      container = container.documentElement;
	    }

	    // http://jsperf.com/emptying-a-node
	    while (container.lastChild) {
	      container.removeChild(container.lastChild);
	    }
	  },

	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function(id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];

	    if ("production" !== "development") {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        ("production" !== "development" ? invariant(
	          // Call internalGetID here because getID calls isValid which calls
	          // findReactContainerForID (this function).
	          internalGetID(rootElement) === reactRootID,
	          'ReactMount: Root element ID differed from reactRootID.'
	        ) : invariant(// Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID));

	        var containerChild = container.firstChild;
	        if (containerChild &&
	            reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          console.warn(
	            'ReactMount: Root element has been removed from its original ' +
	            'container. New container:', rootElement.parentNode
	          );
	        }
	      }
	    }

	    return container;
	  },

	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function(id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },

	  /**
	   * True if the supplied `node` is rendered by React.
	   *
	   * @param {*} node DOM Element to check.
	   * @return {boolean} True if the DOM Element appears to be rendered by React.
	   * @internal
	   */
	  isRenderedByReact: function(node) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      return false;
	    }
	    var id = ReactMount.getID(node);
	    return id ? id.charAt(0) === SEPARATOR : false;
	  },

	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function(node) {
	    var current = node;
	    while (current && current.parentNode !== current) {
	      if (ReactMount.isRenderedByReact(current)) {
	        return current;
	      }
	      current = current.parentNode;
	    }
	    return null;
	  },

	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function(ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;

	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;

	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;

	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;

	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.

	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }

	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }

	        child = child.nextSibling;
	      }

	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;

	        return targetChild;
	      }
	    }

	    firstChildren.length = 0;

	    ("production" !== "development" ? invariant(
	      false,
	      'findComponentRoot(..., %s): Unable to find element. This probably ' +
	      'means the DOM was unexpectedly mutated (e.g., by the browser), ' +
	      'usually due to forgetting a <tbody> when using tables, nesting <p> ' +
	      'or <a> tags, or using non-SVG elements in an <svg> parent. Try ' +
	      'inspecting the child nodes of the element with React ID `%s`.',
	      targetID,
	      ReactMount.getID(ancestorNode)
	    ) : invariant(false));
	  },


	  /**
	   * React ID utilities.
	   */

	  getReactRootID: getReactRootID,

	  getID: getID,

	  setID: setID,

	  getNode: getNode,

	  purgeID: purgeID
	};

	module.exports = ReactMount;

	},{"./DOMProperty":10,"./ReactBrowserEventEmitter":29,"./ReactCurrentOwner":35,"./ReactDescriptor":51,"./ReactInstanceHandles":59,"./ReactPerf":65,"./containsNode":96,"./getReactRootElementInContainer":114,"./instantiateReactComponent":119,"./invariant":120,"./shouldUpdateReactComponent":140,"./warning":143}],62:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */

	"use strict";

	var ReactComponent = _dereq_("./ReactComponent");
	var ReactMultiChildUpdateTypes = _dereq_("./ReactMultiChildUpdateTypes");

	var flattenChildren = _dereq_("./flattenChildren");
	var instantiateReactComponent = _dereq_("./instantiateReactComponent");
	var shouldUpdateReactComponent = _dereq_("./shouldUpdateReactComponent");

	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;

	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];

	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];

	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    textContent: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}

	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}

	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}

	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    textContent: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}

	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponent.BackendIDOperations.dangerouslyProcessChildrenUpdates(
	      updateQueue,
	      markupQueue
	    );
	    clearQueue();
	  }
	}

	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}

	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {

	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {

	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function(nestedChildren, transaction) {
	      var children = flattenChildren(nestedChildren);
	      var mountImages = [];
	      var index = 0;
	      this._renderedChildren = children;
	      for (var name in children) {
	        var child = children[name];
	        if (children.hasOwnProperty(name)) {
	          // The rendered children must be turned into instances as they're
	          // mounted.
	          var childInstance = instantiateReactComponent(child);
	          children[name] = childInstance;
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = childInstance.mountComponent(
	            rootID,
	            transaction,
	            this._mountDepth + 1
	          );
	          childInstance._mountIndex = index;
	          mountImages.push(mountImage);
	          index++;
	        }
	      }
	      return mountImages;
	    },

	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function(nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          errorThrown ? clearQueue() : processQueue();
	        }
	      }
	    },

	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function(nextNestedChildren, transaction) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildren, transaction);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          errorThrown ? clearQueue() : processQueue();
	        }
	      }
	    },

	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function(nextNestedChildren, transaction) {
	      var nextChildren = flattenChildren(nextNestedChildren);
	      var prevChildren = this._renderedChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var prevDescriptor = prevChild && prevChild._descriptor;
	        var nextDescriptor = nextChildren[name];
	        if (shouldUpdateReactComponent(prevDescriptor, nextDescriptor)) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild.receiveComponent(nextDescriptor, transaction);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChildByName(prevChild, name);
	          }
	          // The child must be instantiated before it's mounted.
	          var nextChildInstance = instantiateReactComponent(nextDescriptor);
	          this._mountChildByNameAtIndex(
	            nextChildInstance, name, nextIndex, transaction
	          );
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) &&
	            !(nextChildren && nextChildren[name])) {
	          this._unmountChildByName(prevChildren[name], name);
	        }
	      }
	    },

	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function() {
	      var renderedChildren = this._renderedChildren;
	      for (var name in renderedChildren) {
	        var renderedChild = renderedChildren[name];
	        // TODO: When is this not true?
	        if (renderedChild.unmountComponent) {
	          renderedChild.unmountComponent();
	        }
	      }
	      this._renderedChildren = null;
	    },

	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function(child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },

	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function(child, mountImage) {
	      enqueueMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },

	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function(child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },

	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function(textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },

	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function(child, name, index, transaction) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = child.mountComponent(
	        rootID,
	        transaction,
	        this._mountDepth + 1
	      );
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	      this._renderedChildren = this._renderedChildren || {};
	      this._renderedChildren[name] = child;
	    },

	    /**
	     * Unmounts a rendered child by name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @param {string} name Name of the child in `this._renderedChildren`.
	     * @private
	     */
	    _unmountChildByName: function(child, name) {
	      this.removeChild(child);
	      child._mountIndex = null;
	      child.unmountComponent();
	      delete this._renderedChildren[name];
	    }

	  }

	};

	module.exports = ReactMultiChild;

	},{"./ReactComponent":31,"./ReactMultiChildUpdateTypes":63,"./flattenChildren":105,"./instantiateReactComponent":119,"./shouldUpdateReactComponent":140}],63:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */

	"use strict";

	var keyMirror = _dereq_("./keyMirror");

	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  TEXT_CONTENT: null
	});

	module.exports = ReactMultiChildUpdateTypes;

	},{"./keyMirror":126}],64:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactOwner
	 */

	"use strict";

	var emptyObject = _dereq_("./emptyObject");
	var invariant = _dereq_("./invariant");

	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {

	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function(object) {
	    return !!(
	      object &&
	      typeof object.attachRef === 'function' &&
	      typeof object.detachRef === 'function'
	    );
	  },

	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function(component, ref, owner) {
	    ("production" !== "development" ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'addComponentAsRefTo(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to add a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    owner.attachRef(ref, component);
	  },

	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function(component, ref, owner) {
	    ("production" !== "development" ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to remove a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.refs[ref] === component) {
	      owner.detachRef(ref);
	    }
	  },

	  /**
	   * A ReactComponent must mix this in to have refs.
	   *
	   * @lends {ReactOwner.prototype}
	   */
	  Mixin: {

	    construct: function() {
	      this.refs = emptyObject;
	    },

	    /**
	     * Lazily allocates the refs object and stores `component` as `ref`.
	     *
	     * @param {string} ref Reference name.
	     * @param {component} component Component to store as `ref`.
	     * @final
	     * @private
	     */
	    attachRef: function(ref, component) {
	      ("production" !== "development" ? invariant(
	        component.isOwnedBy(this),
	        'attachRef(%s, ...): Only a component\'s owner can store a ref to it.',
	        ref
	      ) : invariant(component.isOwnedBy(this)));
	      var refs = this.refs === emptyObject ? (this.refs = {}) : this.refs;
	      refs[ref] = component;
	    },

	    /**
	     * Detaches a reference name.
	     *
	     * @param {string} ref Name to dereference.
	     * @final
	     * @private
	     */
	    detachRef: function(ref) {
	      delete this.refs[ref];
	    }

	  }

	};

	module.exports = ReactOwner;

	},{"./emptyObject":103,"./invariant":120}],65:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */

	"use strict";

	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,

	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,

	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function(objName, fnName, func) {
	    if ("production" !== "development") {
	      var measuredFunc = null;
	      return function() {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	    }
	    return func;
	  },

	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function(measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};

	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}

	module.exports = ReactPerf;

	},{}],66:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactPropTransferer
	 */

	"use strict";

	var emptyFunction = _dereq_("./emptyFunction");
	var invariant = _dereq_("./invariant");
	var joinClasses = _dereq_("./joinClasses");
	var merge = _dereq_("./merge");

	/**
	 * Creates a transfer strategy that will merge prop values using the supplied
	 * `mergeStrategy`. If a prop was previously unset, this just sets it.
	 *
	 * @param {function} mergeStrategy
	 * @return {function}
	 */
	function createTransferStrategy(mergeStrategy) {
	  return function(props, key, value) {
	    if (!props.hasOwnProperty(key)) {
	      props[key] = value;
	    } else {
	      props[key] = mergeStrategy(props[key], value);
	    }
	  };
	}

	var transferStrategyMerge = createTransferStrategy(function(a, b) {
	  // `merge` overrides the first object's (`props[key]` above) keys using the
	  // second object's (`value`) keys. An object's style's existing `propA` would
	  // get overridden. Flip the order here.
	  return merge(b, a);
	});

	/**
	 * Transfer strategies dictate how props are transferred by `transferPropsTo`.
	 * NOTE: if you add any more exceptions to this list you should be sure to
	 * update `cloneWithProps()` accordingly.
	 */
	var TransferStrategies = {
	  /**
	   * Never transfer `children`.
	   */
	  children: emptyFunction,
	  /**
	   * Transfer the `className` prop by merging them.
	   */
	  className: createTransferStrategy(joinClasses),
	  /**
	   * Never transfer the `key` prop.
	   */
	  key: emptyFunction,
	  /**
	   * Never transfer the `ref` prop.
	   */
	  ref: emptyFunction,
	  /**
	   * Transfer the `style` prop (which is an object) by merging them.
	   */
	  style: transferStrategyMerge
	};

	/**
	 * Mutates the first argument by transferring the properties from the second
	 * argument.
	 *
	 * @param {object} props
	 * @param {object} newProps
	 * @return {object}
	 */
	function transferInto(props, newProps) {
	  for (var thisKey in newProps) {
	    if (!newProps.hasOwnProperty(thisKey)) {
	      continue;
	    }

	    var transferStrategy = TransferStrategies[thisKey];

	    if (transferStrategy && TransferStrategies.hasOwnProperty(thisKey)) {
	      transferStrategy(props, thisKey, newProps[thisKey]);
	    } else if (!props.hasOwnProperty(thisKey)) {
	      props[thisKey] = newProps[thisKey];
	    }
	  }
	  return props;
	}

	/**
	 * ReactPropTransferer are capable of transferring props to another component
	 * using a `transferPropsTo` method.
	 *
	 * @class ReactPropTransferer
	 */
	var ReactPropTransferer = {

	  TransferStrategies: TransferStrategies,

	  /**
	   * Merge two props objects using TransferStrategies.
	   *
	   * @param {object} oldProps original props (they take precedence)
	   * @param {object} newProps new props to merge in
	   * @return {object} a new object containing both sets of props merged.
	   */
	  mergeProps: function(oldProps, newProps) {
	    return transferInto(merge(oldProps), newProps);
	  },

	  /**
	   * @lends {ReactPropTransferer.prototype}
	   */
	  Mixin: {

	    /**
	     * Transfer props from this component to a target component.
	     *
	     * Props that do not have an explicit transfer strategy will be transferred
	     * only if the target component does not already have the prop set.
	     *
	     * This is usually used to pass down props to a returned root component.
	     *
	     * @param {ReactDescriptor} descriptor Component receiving the properties.
	     * @return {ReactDescriptor} The supplied `component`.
	     * @final
	     * @protected
	     */
	    transferPropsTo: function(descriptor) {
	      ("production" !== "development" ? invariant(
	        descriptor._owner === this,
	        '%s: You can\'t call transferPropsTo() on a component that you ' +
	        'don\'t own, %s. This usually means you are calling ' +
	        'transferPropsTo() on a component passed in as props or children.',
	        this.constructor.displayName,
	        descriptor.type.displayName
	      ) : invariant(descriptor._owner === this));

	      // Because descriptors are immutable we have to merge into the existing
	      // props object rather than clone it.
	      transferInto(descriptor.props, this.props);

	      return descriptor;
	    }

	  }
	};

	module.exports = ReactPropTransferer;

	},{"./emptyFunction":102,"./invariant":120,"./joinClasses":125,"./merge":130}],67:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */

	"use strict";

	var ReactPropTypeLocationNames = {};

	if ("production" !== "development") {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}

	module.exports = ReactPropTypeLocationNames;

	},{}],68:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactPropTypeLocations
	 */

	"use strict";

	var keyMirror = _dereq_("./keyMirror");

	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});

	module.exports = ReactPropTypeLocations;

	},{"./keyMirror":126}],69:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactPropTypes
	 */

	"use strict";

	var ReactDescriptor = _dereq_("./ReactDescriptor");
	var ReactPropTypeLocationNames = _dereq_("./ReactPropTypeLocationNames");

	var emptyFunction = _dereq_("./emptyFunction");

	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */

	var ANONYMOUS = '<<anonymous>>';

	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),

	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  component: createComponentTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  renderable: createRenderableTypeChecker(),
	  shape: createShapeTypeChecker
	};

	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location) {
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error(
	          ("Required " + locationName + " `" + propName + "` was not specified in ")+
	          ("`" + componentName + "`.")
	        );
	      }
	    } else {
	      return validate(props, propName, componentName, location);
	    }
	  }

	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);

	  return chainedCheckType;
	}

	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);

	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + preciseType + "` ") +
	        ("supplied to `" + componentName + "`, expected `" + expectedType + "`.")
	      );
	    }
	  }
	  return createChainableTypeChecker(validate);
	}

	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns());
	}

	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an array.")
	      );
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}

	function createComponentTypeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!ReactDescriptor.isValidDescriptor(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a React component.")
	      );
	    }
	  }
	  return createChainableTypeChecker(validate);
	}

	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected instance of `" + expectedClassName + "`.")
	      );
	    }
	  }
	  return createChainableTypeChecker(validate);
	}

	function createEnumTypeChecker(expectedValues) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return;
	      }
	    }

	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` of value `" + propValue + "` ") +
	      ("supplied to `" + componentName + "`, expected one of " + valuesString + ".")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}

	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an object.")
	      );
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	  }
	  return createChainableTypeChecker(validate);
	}

	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  function validate(props, propName, componentName, location) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location) == null) {
	        return;
	      }
	    }

	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	      ("`" + componentName + "`.")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}

	function createRenderableTypeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!isRenderable(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a renderable prop.")
	      );
	    }
	  }
	  return createChainableTypeChecker(validate);
	}

	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + propType + "` ") +
	        ("supplied to `" + componentName + "`, expected `object`.")
	      );
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location);
	      if (error) {
	        return error;
	      }
	    }
	  }
	  return createChainableTypeChecker(validate, 'expected `object`');
	}

	function isRenderable(propValue) {
	  switch(typeof propValue) {
	    // TODO: this was probably written with the assumption that we're not
	    // returning `this.props.component` directly from `render`. This is
	    // currently not supported but we should, to make it consistent.
	    case 'number':
	    case 'string':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isRenderable);
	      }
	      if (ReactDescriptor.isValidDescriptor(propValue)) {
	        return true;
	      }
	      for (var k in propValue) {
	        if (!isRenderable(propValue[k])) {
	          return false;
	        }
	      }
	      return true;
	    default:
	      return false;
	  }
	}

	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}

	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}

	module.exports = ReactPropTypes;

	},{"./ReactDescriptor":51,"./ReactPropTypeLocationNames":67,"./emptyFunction":102}],70:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactPutListenerQueue
	 */

	"use strict";

	var PooledClass = _dereq_("./PooledClass");
	var ReactBrowserEventEmitter = _dereq_("./ReactBrowserEventEmitter");

	var mixInto = _dereq_("./mixInto");

	function ReactPutListenerQueue() {
	  this.listenersToPut = [];
	}

	mixInto(ReactPutListenerQueue, {
	  enqueuePutListener: function(rootNodeID, propKey, propValue) {
	    this.listenersToPut.push({
	      rootNodeID: rootNodeID,
	      propKey: propKey,
	      propValue: propValue
	    });
	  },

	  putListeners: function() {
	    for (var i = 0; i < this.listenersToPut.length; i++) {
	      var listenerToPut = this.listenersToPut[i];
	      ReactBrowserEventEmitter.putListener(
	        listenerToPut.rootNodeID,
	        listenerToPut.propKey,
	        listenerToPut.propValue
	      );
	    }
	  },

	  reset: function() {
	    this.listenersToPut.length = 0;
	  },

	  destructor: function() {
	    this.reset();
	  }
	});

	PooledClass.addPoolingTo(ReactPutListenerQueue);

	module.exports = ReactPutListenerQueue;

	},{"./PooledClass":26,"./ReactBrowserEventEmitter":29,"./mixInto":133}],71:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */

	"use strict";

	var CallbackQueue = _dereq_("./CallbackQueue");
	var PooledClass = _dereq_("./PooledClass");
	var ReactBrowserEventEmitter = _dereq_("./ReactBrowserEventEmitter");
	var ReactInputSelection = _dereq_("./ReactInputSelection");
	var ReactPutListenerQueue = _dereq_("./ReactPutListenerQueue");
	var Transaction = _dereq_("./Transaction");

	var mixInto = _dereq_("./mixInto");

	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};

	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function() {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },

	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occured. `close`
	   *   restores the previous value.
	   */
	  close: function(previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};

	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },

	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function() {
	    this.reactMountReady.notifyAll();
	  }
	};

	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },

	  close: function() {
	    this.putListenerQueue.putListeners();
	  }
	};

	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  SELECTION_RESTORATION,
	  EVENT_SUPPRESSION,
	  ON_DOM_READY_QUEUEING
	];

	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction() {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}

	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap proceedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },

	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },

	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },

	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;

	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};


	mixInto(ReactReconcileTransaction, Transaction.Mixin);
	mixInto(ReactReconcileTransaction, Mixin);

	PooledClass.addPoolingTo(ReactReconcileTransaction);

	module.exports = ReactReconcileTransaction;

	},{"./CallbackQueue":5,"./PooledClass":26,"./ReactBrowserEventEmitter":29,"./ReactInputSelection":58,"./ReactPutListenerQueue":70,"./Transaction":92,"./mixInto":133}],72:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */

	"use strict";

	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function(_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};

	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};

	module.exports = ReactRootIndex;

	},{}],73:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	"use strict";

	var ReactDescriptor = _dereq_("./ReactDescriptor");
	var ReactInstanceHandles = _dereq_("./ReactInstanceHandles");
	var ReactMarkupChecksum = _dereq_("./ReactMarkupChecksum");
	var ReactServerRenderingTransaction =
	  _dereq_("./ReactServerRenderingTransaction");

	var instantiateReactComponent = _dereq_("./instantiateReactComponent");
	var invariant = _dereq_("./invariant");

	/**
	 * @param {ReactComponent} component
	 * @return {string} the HTML markup
	 */
	function renderComponentToString(component) {
	  ("production" !== "development" ? invariant(
	    ReactDescriptor.isValidDescriptor(component),
	    'renderComponentToString(): You must pass a valid ReactComponent.'
	  ) : invariant(ReactDescriptor.isValidDescriptor(component)));

	  ("production" !== "development" ? invariant(
	    !(arguments.length === 2 && typeof arguments[1] === 'function'),
	    'renderComponentToString(): This function became synchronous and now ' +
	    'returns the generated markup. Please remove the second parameter.'
	  ) : invariant(!(arguments.length === 2 && typeof arguments[1] === 'function')));

	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);

	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(component);
	      var markup = componentInstance.mountComponent(id, transaction, 0);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}

	/**
	 * @param {ReactComponent} component
	 * @return {string} the HTML markup, without the extra React ID and checksum
	* (for generating static pages)
	 */
	function renderComponentToStaticMarkup(component) {
	  ("production" !== "development" ? invariant(
	    ReactDescriptor.isValidDescriptor(component),
	    'renderComponentToStaticMarkup(): You must pass a valid ReactComponent.'
	  ) : invariant(ReactDescriptor.isValidDescriptor(component)));

	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);

	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(component);
	      return componentInstance.mountComponent(id, transaction, 0);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}

	module.exports = {
	  renderComponentToString: renderComponentToString,
	  renderComponentToStaticMarkup: renderComponentToStaticMarkup
	};

	},{"./ReactDescriptor":51,"./ReactInstanceHandles":59,"./ReactMarkupChecksum":60,"./ReactServerRenderingTransaction":74,"./instantiateReactComponent":119,"./invariant":120}],74:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */

	"use strict";

	var PooledClass = _dereq_("./PooledClass");
	var CallbackQueue = _dereq_("./CallbackQueue");
	var ReactPutListenerQueue = _dereq_("./ReactPutListenerQueue");
	var Transaction = _dereq_("./Transaction");

	var emptyFunction = _dereq_("./emptyFunction");
	var mixInto = _dereq_("./mixInto");

	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },

	  close: emptyFunction
	};

	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },

	  close: emptyFunction
	};

	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  ON_DOM_READY_QUEUEING
	];

	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}

	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap proceedures.
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },

	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },

	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },

	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;

	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};


	mixInto(ReactServerRenderingTransaction, Transaction.Mixin);
	mixInto(ReactServerRenderingTransaction, Mixin);

	PooledClass.addPoolingTo(ReactServerRenderingTransaction);

	module.exports = ReactServerRenderingTransaction;

	},{"./CallbackQueue":5,"./PooledClass":26,"./ReactPutListenerQueue":70,"./Transaction":92,"./emptyFunction":102,"./mixInto":133}],75:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactTextComponent
	 * @typechecks static-only
	 */

	"use strict";

	var DOMPropertyOperations = _dereq_("./DOMPropertyOperations");
	var ReactBrowserComponentMixin = _dereq_("./ReactBrowserComponentMixin");
	var ReactComponent = _dereq_("./ReactComponent");
	var ReactDescriptor = _dereq_("./ReactDescriptor");

	var escapeTextForBrowser = _dereq_("./escapeTextForBrowser");
	var mixInto = _dereq_("./mixInto");

	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactTextComponent = function(descriptor) {
	  this.construct(descriptor);
	};

	mixInto(ReactTextComponent, ReactComponent.Mixin);
	mixInto(ReactTextComponent, ReactBrowserComponentMixin);
	mixInto(ReactTextComponent, {

	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {number} mountDepth number of components in the owner hierarchy
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, mountDepth) {
	    ReactComponent.Mixin.mountComponent.call(
	      this,
	      rootID,
	      transaction,
	      mountDepth
	    );

	    var escapedText = escapeTextForBrowser(this.props);

	    if (transaction.renderToStaticMarkup) {
	      // Normally we'd wrap this in a `span` for the reasons stated above, but
	      // since this is a situation where React won't take over (static pages),
	      // we can simply return the text as it is.
	      return escapedText;
	    }

	    return (
	      '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' +
	        escapedText +
	      '</span>'
	    );
	  },

	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {object} nextComponent Contains the next text content.
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function(nextComponent, transaction) {
	    var nextProps = nextComponent.props;
	    if (nextProps !== this.props) {
	      this.props = nextProps;
	      ReactComponent.BackendIDOperations.updateTextContentByID(
	        this._rootNodeID,
	        nextProps
	      );
	    }
	  }

	});

	module.exports = ReactDescriptor.createFactory(ReactTextComponent);

	},{"./DOMPropertyOperations":11,"./ReactBrowserComponentMixin":28,"./ReactComponent":31,"./ReactDescriptor":51,"./escapeTextForBrowser":104,"./mixInto":133}],76:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ReactUpdates
	 */

	"use strict";

	var CallbackQueue = _dereq_("./CallbackQueue");
	var PooledClass = _dereq_("./PooledClass");
	var ReactCurrentOwner = _dereq_("./ReactCurrentOwner");
	var ReactPerf = _dereq_("./ReactPerf");
	var Transaction = _dereq_("./Transaction");

	var invariant = _dereq_("./invariant");
	var mixInto = _dereq_("./mixInto");
	var warning = _dereq_("./warning");

	var dirtyComponents = [];

	var batchingStrategy = null;

	function ensureInjected() {
	  ("production" !== "development" ? invariant(
	    ReactUpdates.ReactReconcileTransaction && batchingStrategy,
	    'ReactUpdates: must inject a reconcile transaction class and batching ' +
	    'strategy'
	  ) : invariant(ReactUpdates.ReactReconcileTransaction && batchingStrategy));
	}

	var NESTED_UPDATES = {
	  initialize: function() {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function() {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};

	var UPDATE_QUEUEING = {
	  initialize: function() {
	    this.callbackQueue.reset();
	  },
	  close: function() {
	    this.callbackQueue.notifyAll();
	  }
	};

	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled(null);
	  this.reconcileTransaction =
	    ReactUpdates.ReactReconcileTransaction.getPooled();
	}

	mixInto(ReactUpdatesFlushTransaction, Transaction.Mixin);
	mixInto(ReactUpdatesFlushTransaction, {
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },

	  destructor: function() {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },

	  perform: function(method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(
	      this,
	      this.reconcileTransaction.perform,
	      this.reconcileTransaction,
	      method,
	      scope,
	      a
	    );
	  }
	});

	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

	function batchedUpdates(callback, a, b) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b);
	}

	/**
	 * Array comparator for ReactComponents by owner depth
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountDepthComparator(c1, c2) {
	  return c1._mountDepth - c2._mountDepth;
	}

	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  ("production" !== "development" ? invariant(
	    len === dirtyComponents.length,
	    'Expected flush transaction\'s stored dirty-components length (%s) to ' +
	    'match dirty-components array length (%s).',
	    len,
	    dirtyComponents.length
	  ) : invariant(len === dirtyComponents.length));

	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountDepthComparator);

	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, ignore them
	    // TODO: Queue unmounts in the same list to avoid this happening at all
	    var component = dirtyComponents[i];
	    if (component.isMounted()) {
	      // If performUpdateIfNecessary happens to enqueue any new updates, we
	      // shouldn't execute the callbacks until the next render happens, so
	      // stash the callbacks first
	      var callbacks = component._pendingCallbacks;
	      component._pendingCallbacks = null;
	      component.performUpdateIfNecessary(transaction.reconcileTransaction);

	      if (callbacks) {
	        for (var j = 0; j < callbacks.length; j++) {
	          transaction.callbackQueue.enqueue(
	            callbacks[j],
	            component
	          );
	        }
	      }
	    }
	  }
	}

	var flushBatchedUpdates = ReactPerf.measure(
	  'ReactUpdates',
	  'flushBatchedUpdates',
	  function() {
	    // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	    // array and perform any updates enqueued by mount-ready handlers (i.e.,
	    // componentDidUpdate) but we need to check here too in order to catch
	    // updates enqueued by setState callbacks.
	    while (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	  }
	);

	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component, callback) {
	  ("production" !== "development" ? invariant(
	    !callback || typeof callback === "function",
	    'enqueueUpdate(...): You called `setProps`, `replaceProps`, ' +
	    '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	    'isn\'t callable.'
	  ) : invariant(!callback || typeof callback === "function"));
	  ensureInjected();

	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	  ("production" !== "development" ? warning(
	    ReactCurrentOwner.current == null,
	    'enqueueUpdate(): Render methods should be a pure function of props ' +
	    'and state; triggering nested component updates from render is not ' +
	    'allowed. If necessary, trigger nested updates in ' +
	    'componentDidUpdate.'
	  ) : null);

	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component, callback);
	    return;
	  }

	  dirtyComponents.push(component);

	  if (callback) {
	    if (component._pendingCallbacks) {
	      component._pendingCallbacks.push(callback);
	    } else {
	      component._pendingCallbacks = [callback];
	    }
	  }
	}

	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function(ReconcileTransaction) {
	    ("production" !== "development" ? invariant(
	      ReconcileTransaction,
	      'ReactUpdates: must provide a reconcile transaction class'
	    ) : invariant(ReconcileTransaction));
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },

	  injectBatchingStrategy: function(_batchingStrategy) {
	    ("production" !== "development" ? invariant(
	      _batchingStrategy,
	      'ReactUpdates: must provide a batching strategy'
	    ) : invariant(_batchingStrategy));
	    ("production" !== "development" ? invariant(
	      typeof _batchingStrategy.batchedUpdates === 'function',
	      'ReactUpdates: must provide a batchedUpdates() function'
	    ) : invariant(typeof _batchingStrategy.batchedUpdates === 'function'));
	    ("production" !== "development" ? invariant(
	      typeof _batchingStrategy.isBatchingUpdates === 'boolean',
	      'ReactUpdates: must provide an isBatchingUpdates boolean attribute'
	    ) : invariant(typeof _batchingStrategy.isBatchingUpdates === 'boolean'));
	    batchingStrategy = _batchingStrategy;
	  }
	};

	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,

	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection
	};

	module.exports = ReactUpdates;

	},{"./CallbackQueue":5,"./PooledClass":26,"./ReactCurrentOwner":35,"./ReactPerf":65,"./Transaction":92,"./invariant":120,"./mixInto":133,"./warning":143}],77:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */

	/*jslint bitwise: true*/

	"use strict";

	var DOMProperty = _dereq_("./DOMProperty");

	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;

	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    filter: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fontWeight: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    k2: MUST_USE_ATTRIBUTE,
	    k3: MUST_USE_ATTRIBUTE,
	    in: MUST_USE_ATTRIBUTE,
	    in2: MUST_USE_ATTRIBUTE,
	    operator: MUST_USE_ATTRIBUTE,
	    floodColor: MUST_USE_ATTRIBUTE,
	    floodOpacity: MUST_USE_ATTRIBUTE,
	    stdDeviation: MUST_USE_ATTRIBUTE,
	    result: MUST_USE_ATTRIBUTE,
	    out: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    values: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    'xlink:href': MUST_USE_ATTRIBUTE,
	    x0: MUST_USE_ATTRIBUTE,
	    y0: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },

	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontWeight: 'font-weight',
	    gradientTransform: 'gradientTransform',
	    in: 'in',
	    in2: 'in2',
	    operator: 'operator',
	    floodColor: 'flood-color', 
	    floodOpacity: 'flood-opacity',   
	    stdDeviation: 'stdDeviation',
	    values: 'values',
	    result: 'result',
	    out: 'out',    
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox'
	  }
	};

	module.exports = SVGDOMPropertyConfig;

	},{"./DOMProperty":10}],78:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SelectEventPlugin
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var EventPropagators = _dereq_("./EventPropagators");
	var ReactInputSelection = _dereq_("./ReactInputSelection");
	var SyntheticEvent = _dereq_("./SyntheticEvent");

	var getActiveElement = _dereq_("./getActiveElement");
	var isTextInputElement = _dereq_("./isTextInputElement");
	var keyOf = _dereq_("./keyOf");
	var shallowEqual = _dereq_("./shallowEqual");

	var topLevelTypes = EventConstants.topLevelTypes;

	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSelect: null}),
	      captured: keyOf({onSelectCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topContextMenu,
	      topLevelTypes.topFocus,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topMouseDown,
	      topLevelTypes.topMouseUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};

	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;

	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @param {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node &&
	      ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  } else {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  }
	}

	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown ||
	      activeElement == null ||
	      activeElement != getActiveElement()) {
	    return;
	  }

	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;

	    var syntheticEvent = SyntheticEvent.getPooled(
	      eventTypes.select,
	      activeElementID,
	      nativeEvent
	    );

	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;

	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

	    return syntheticEvent;
	  }
	}

	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {

	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) ||
	            topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;

	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent);

	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't).
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      case topLevelTypes.topSelectionChange:
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent);
	    }
	  }
	};

	module.exports = SelectEventPlugin;

	},{"./EventConstants":15,"./EventPropagators":20,"./ReactInputSelection":58,"./SyntheticEvent":84,"./getActiveElement":108,"./isTextInputElement":123,"./keyOf":127,"./shallowEqual":139}],79:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */

	"use strict";

	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);

	var ServerReactRootIndex = {
	  createReactRootIndex: function() {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};

	module.exports = ServerReactRootIndex;

	},{}],80:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SimpleEventPlugin
	 */

	"use strict";

	var EventConstants = _dereq_("./EventConstants");
	var EventPluginUtils = _dereq_("./EventPluginUtils");
	var EventPropagators = _dereq_("./EventPropagators");
	var SyntheticClipboardEvent = _dereq_("./SyntheticClipboardEvent");
	var SyntheticEvent = _dereq_("./SyntheticEvent");
	var SyntheticFocusEvent = _dereq_("./SyntheticFocusEvent");
	var SyntheticKeyboardEvent = _dereq_("./SyntheticKeyboardEvent");
	var SyntheticMouseEvent = _dereq_("./SyntheticMouseEvent");
	var SyntheticDragEvent = _dereq_("./SyntheticDragEvent");
	var SyntheticTouchEvent = _dereq_("./SyntheticTouchEvent");
	var SyntheticUIEvent = _dereq_("./SyntheticUIEvent");
	var SyntheticWheelEvent = _dereq_("./SyntheticWheelEvent");

	var invariant = _dereq_("./invariant");
	var keyOf = _dereq_("./keyOf");

	var topLevelTypes = EventConstants.topLevelTypes;

	var eventTypes = {
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBlur: true}),
	      captured: keyOf({onBlurCapture: true})
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onClick: true}),
	      captured: keyOf({onClickCapture: true})
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onContextMenu: true}),
	      captured: keyOf({onContextMenuCapture: true})
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCopy: true}),
	      captured: keyOf({onCopyCapture: true})
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCut: true}),
	      captured: keyOf({onCutCapture: true})
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDoubleClick: true}),
	      captured: keyOf({onDoubleClickCapture: true})
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrag: true}),
	      captured: keyOf({onDragCapture: true})
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnd: true}),
	      captured: keyOf({onDragEndCapture: true})
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnter: true}),
	      captured: keyOf({onDragEnterCapture: true})
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragExit: true}),
	      captured: keyOf({onDragExitCapture: true})
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragLeave: true}),
	      captured: keyOf({onDragLeaveCapture: true})
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragOver: true}),
	      captured: keyOf({onDragOverCapture: true})
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragStart: true}),
	      captured: keyOf({onDragStartCapture: true})
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrop: true}),
	      captured: keyOf({onDropCapture: true})
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onFocus: true}),
	      captured: keyOf({onFocusCapture: true})
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onInput: true}),
	      captured: keyOf({onInputCapture: true})
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyDown: true}),
	      captured: keyOf({onKeyDownCapture: true})
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyPress: true}),
	      captured: keyOf({onKeyPressCapture: true})
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyUp: true}),
	      captured: keyOf({onKeyUpCapture: true})
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onLoad: true}),
	      captured: keyOf({onLoadCapture: true})
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onError: true}),
	      captured: keyOf({onErrorCapture: true})
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseDown: true}),
	      captured: keyOf({onMouseDownCapture: true})
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseMove: true}),
	      captured: keyOf({onMouseMoveCapture: true})
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOut: true}),
	      captured: keyOf({onMouseOutCapture: true})
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOver: true}),
	      captured: keyOf({onMouseOverCapture: true})
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseUp: true}),
	      captured: keyOf({onMouseUpCapture: true})
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onPaste: true}),
	      captured: keyOf({onPasteCapture: true})
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onReset: true}),
	      captured: keyOf({onResetCapture: true})
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onScroll: true}),
	      captured: keyOf({onScrollCapture: true})
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSubmit: true}),
	      captured: keyOf({onSubmitCapture: true})
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchCancel: true}),
	      captured: keyOf({onTouchCancelCapture: true})
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchEnd: true}),
	      captured: keyOf({onTouchEndCapture: true})
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchMove: true}),
	      captured: keyOf({onTouchMoveCapture: true})
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchStart: true}),
	      captured: keyOf({onTouchStartCapture: true})
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onWheel: true}),
	      captured: keyOf({onWheelCapture: true})
	    }
	  }
	};

	var topLevelEventsToDispatchConfig = {
	  topBlur:        eventTypes.blur,
	  topClick:       eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy:        eventTypes.copy,
	  topCut:         eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag:        eventTypes.drag,
	  topDragEnd:     eventTypes.dragEnd,
	  topDragEnter:   eventTypes.dragEnter,
	  topDragExit:    eventTypes.dragExit,
	  topDragLeave:   eventTypes.dragLeave,
	  topDragOver:    eventTypes.dragOver,
	  topDragStart:   eventTypes.dragStart,
	  topDrop:        eventTypes.drop,
	  topError:       eventTypes.error,
	  topFocus:       eventTypes.focus,
	  topInput:       eventTypes.input,
	  topKeyDown:     eventTypes.keyDown,
	  topKeyPress:    eventTypes.keyPress,
	  topKeyUp:       eventTypes.keyUp,
	  topLoad:        eventTypes.load,
	  topMouseDown:   eventTypes.mouseDown,
	  topMouseMove:   eventTypes.mouseMove,
	  topMouseOut:    eventTypes.mouseOut,
	  topMouseOver:   eventTypes.mouseOver,
	  topMouseUp:     eventTypes.mouseUp,
	  topPaste:       eventTypes.paste,
	  topReset:       eventTypes.reset,
	  topScroll:      eventTypes.scroll,
	  topSubmit:      eventTypes.submit,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd:    eventTypes.touchEnd,
	  topTouchMove:   eventTypes.touchMove,
	  topTouchStart:  eventTypes.touchStart,
	  topWheel:       eventTypes.wheel
	};

	for (var topLevelType in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[topLevelType].dependencies = [topLevelType];
	}

	var SimpleEventPlugin = {

	  eventTypes: eventTypes,

	  /**
	   * Same as the default implementation, except cancels the event when return
	   * value is false.
	   *
	   * @param {object} Event to be dispatched.
	   * @param {function} Application-level callback.
	   * @param {string} domID DOM ID to pass to the callback.
	   */
	  executeDispatch: function(event, listener, domID) {
	    var returnValue = EventPluginUtils.executeDispatch(event, listener, domID);
	    if (returnValue === false) {
	      event.stopPropagation();
	      event.preventDefault();
	    }
	  },

	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topError:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSubmit:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events.
	        if (nativeEvent.charCode === 0) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    ("production" !== "development" ? invariant(
	      EventConstructor,
	      'SimpleEventPlugin: Unhandled event type, `%s`.',
	      topLevelType
	    ) : invariant(EventConstructor));
	    var event = EventConstructor.getPooled(
	      dispatchConfig,
	      topLevelTargetID,
	      nativeEvent
	    );
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  }

	};

	module.exports = SimpleEventPlugin;

	},{"./EventConstants":15,"./EventPluginUtils":19,"./EventPropagators":20,"./SyntheticClipboardEvent":81,"./SyntheticDragEvent":83,"./SyntheticEvent":84,"./SyntheticFocusEvent":85,"./SyntheticKeyboardEvent":87,"./SyntheticMouseEvent":88,"./SyntheticTouchEvent":89,"./SyntheticUIEvent":90,"./SyntheticWheelEvent":91,"./invariant":120,"./keyOf":127}],81:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticEvent = _dereq_("./SyntheticEvent");

	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function(event) {
	    return (
	      'clipboardData' in event ?
	        event.clipboardData :
	        window.clipboardData
	    );
	  }
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

	module.exports = SyntheticClipboardEvent;


	},{"./SyntheticEvent":84}],82:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticEvent = _dereq_("./SyntheticEvent");

	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticEvent.augmentClass(
	  SyntheticCompositionEvent,
	  CompositionEventInterface
	);

	module.exports = SyntheticCompositionEvent;


	},{"./SyntheticEvent":84}],83:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticMouseEvent = _dereq_("./SyntheticMouseEvent");

	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

	module.exports = SyntheticDragEvent;

	},{"./SyntheticMouseEvent":88}],84:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */

	"use strict";

	var PooledClass = _dereq_("./PooledClass");

	var emptyFunction = _dereq_("./emptyFunction");
	var getEventTarget = _dereq_("./getEventTarget");
	var merge = _dereq_("./merge");
	var mergeInto = _dereq_("./mergeInto");

	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: getEventTarget,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function(event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};

	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;

	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      this[propName] = nativeEvent[propName];
	    }
	  }

	  var defaultPrevented = nativeEvent.defaultPrevented != null ?
	    nativeEvent.defaultPrevented :
	    nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}

	mergeInto(SyntheticEvent.prototype, {

	  preventDefault: function() {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    event.preventDefault ? event.preventDefault() : event.returnValue = false;
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },

	  stopPropagation: function() {
	    var event = this.nativeEvent;
	    event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },

	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function() {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },

	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,

	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function() {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }

	});

	SyntheticEvent.Interface = EventInterface;

	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function(Class, Interface) {
	  var Super = this;

	  var prototype = Object.create(Super.prototype);
	  mergeInto(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;

	  Class.Interface = merge(Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;

	  PooledClass.addPoolingTo(Class, PooledClass.threeArgumentPooler);
	};

	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.threeArgumentPooler);

	module.exports = SyntheticEvent;

	},{"./PooledClass":26,"./emptyFunction":102,"./getEventTarget":111,"./merge":130,"./mergeInto":132}],85:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticUIEvent = _dereq_("./SyntheticUIEvent");

	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

	module.exports = SyntheticFocusEvent;

	},{"./SyntheticUIEvent":90}],86:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticEvent = _dereq_("./SyntheticEvent");

	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticEvent.augmentClass(
	  SyntheticInputEvent,
	  InputEventInterface
	);

	module.exports = SyntheticInputEvent;


	},{"./SyntheticEvent":84}],87:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticUIEvent = _dereq_("./SyntheticUIEvent");

	var getEventKey = _dereq_("./getEventKey");
	var getEventModifierState = _dereq_("./getEventModifierState");

	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function(event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.

	    // KeyPress is deprecated but its replacement is not yet final and not
	    // implemented in any major browser.
	    if (event.type === 'keypress') {
	      // IE8 does not implement "charCode", but "keyCode" has the correct value.
	      return 'charCode' in event ? event.charCode : event.keyCode;
	    }
	    return 0;
	  },
	  keyCode: function(event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.

	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function(event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event. There is no need to determine the type of the event
	    // as `keyCode` and `charCode` are either aliased or default to zero.
	    return event.keyCode || event.charCode;
	  }
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

	module.exports = SyntheticKeyboardEvent;

	},{"./SyntheticUIEvent":90,"./getEventKey":109,"./getEventModifierState":110}],88:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticUIEvent = _dereq_("./SyntheticUIEvent");
	var ViewportMetrics = _dereq_("./ViewportMetrics");

	var getEventModifierState = _dereq_("./getEventModifierState");

	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function(event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function(event) {
	    return event.relatedTarget || (
	      event.fromElement === event.srcElement ?
	        event.toElement :
	        event.fromElement
	    );
	  },
	  // "Proprietary" Interface.
	  pageX: function(event) {
	    return 'pageX' in event ?
	      event.pageX :
	      event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function(event) {
	    return 'pageY' in event ?
	      event.pageY :
	      event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

	module.exports = SyntheticMouseEvent;

	},{"./SyntheticUIEvent":90,"./ViewportMetrics":93,"./getEventModifierState":110}],89:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticUIEvent = _dereq_("./SyntheticUIEvent");

	var getEventModifierState = _dereq_("./getEventModifierState");

	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

	module.exports = SyntheticTouchEvent;

	},{"./SyntheticUIEvent":90,"./getEventModifierState":110}],90:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticEvent = _dereq_("./SyntheticEvent");

	var getEventTarget = _dereq_("./getEventTarget");

	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function(event) {
	    if (event.view) {
	      return event.view;
	    }

	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }

	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function(event) {
	    return event.detail || 0;
	  }
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

	module.exports = SyntheticUIEvent;

	},{"./SyntheticEvent":84,"./getEventTarget":111}],91:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */

	"use strict";

	var SyntheticMouseEvent = _dereq_("./SyntheticMouseEvent");

	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function(event) {
	    return (
	      'deltaX' in event ? event.deltaX :
	      // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	      'wheelDeltaX' in event ? -event.wheelDeltaX : 0
	    );
	  },
	  deltaY: function(event) {
	    return (
	      'deltaY' in event ? event.deltaY :
	      // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	      'wheelDeltaY' in event ? -event.wheelDeltaY :
	      // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	      'wheelDelta' in event ? -event.wheelDelta : 0
	    );
	  },
	  deltaZ: null,

	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};

	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}

	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

	module.exports = SyntheticWheelEvent;

	},{"./SyntheticMouseEvent":88}],92:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule Transaction
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM upates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function() {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (!this.wrapperInitData) {
	      this.wrapperInitData = [];
	    } else {
	      this.wrapperInitData.length = 0;
	    }
	    this._isInTransaction = false;
	  },

	  _isInTransaction: false,

	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,

	  isInTransaction: function() {
	    return !!this._isInTransaction;
	  },

	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} args... Arguments to pass to the method (optional).
	   *                           Helps prevent need to bind in many cases.
	   * @return Return value from `method`.
	   */
	  perform: function(method, scope, a, b, c, d, e, f) {
	    ("production" !== "development" ? invariant(
	      !this.isInTransaction(),
	      'Transaction.perform(...): Cannot initialize a transaction when there ' +
	      'is already an outstanding transaction.'
	    ) : invariant(!this.isInTransaction()));
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {
	          }
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },

	  initializeAll: function(startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ?
	          wrapper.initialize.call(this) :
	          null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {
	          }
	        }
	      }
	    }
	  },

	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function(startIndex) {
	    ("production" !== "development" ? invariant(
	      this.isInTransaction(),
	      'Transaction.closeAll(): Cannot close transaction when none are open.'
	    ) : invariant(this.isInTransaction()));
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR) {
	          wrapper.close && wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {
	          }
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};

	var Transaction = {

	  Mixin: Mixin,

	  /**
	   * Token to look for to determine if an error occured.
	   */
	  OBSERVED_ERROR: {}

	};

	module.exports = Transaction;

	},{"./invariant":120}],93:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule ViewportMetrics
	 */

	"use strict";

	var getUnboundedScrollPosition = _dereq_("./getUnboundedScrollPosition");

	var ViewportMetrics = {

	  currentScrollLeft: 0,

	  currentScrollTop: 0,

	  refreshScrollValues: function() {
	    var scrollPosition = getUnboundedScrollPosition(window);
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }

	};

	module.exports = ViewportMetrics;

	},{"./getUnboundedScrollPosition":116}],94:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule accumulate
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	/**
	 * Accumulates items that must not be null or undefined.
	 *
	 * This is used to conserve memory by avoiding array allocations.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	function accumulate(current, next) {
	  ("production" !== "development" ? invariant(
	    next != null,
	    'accumulate(...): Accumulated items must be not be null or undefined.'
	  ) : invariant(next != null));
	  if (current == null) {
	    return next;
	  } else {
	    // Both are not empty. Warning: Never call x.concat(y) when you are not
	    // certain that x is an Array (x could be a string with concat method).
	    var currentIsArray = Array.isArray(current);
	    var nextIsArray = Array.isArray(next);
	    if (currentIsArray) {
	      return current.concat(next);
	    } else {
	      if (nextIsArray) {
	        return [current].concat(next);
	      } else {
	        return [current, next];
	      }
	    }
	  }
	}

	module.exports = accumulate;

	},{"./invariant":120}],95:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule adler32
	 */

	/* jslint bitwise:true */

	"use strict";

	var MOD = 65521;

	// This is a clean-room implementation of adler32 designed for detecting
	// if markup is not what we expect it to be. It does not need to be
	// cryptographically strong, only reasonable good at detecting if markup
	// generated on the server is different than that on the client.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  for (var i = 0; i < data.length; i++) {
	    a = (a + data.charCodeAt(i)) % MOD;
	    b = (b + a) % MOD;
	  }
	  return a | (b << 16);
	}

	module.exports = adler32;

	},{}],96:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */

	var isTextNode = _dereq_("./isTextNode");

	/*jslint bitwise:true */

	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if (outerNode.contains) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}

	module.exports = containsNode;

	},{"./isTextNode":124}],97:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule copyProperties
	 */

	/**
	 * Copy properties from one or more objects (up to 5) into the first object.
	 * This is a shallow copy. It mutates the first object and also returns it.
	 *
	 * NOTE: `arguments` has a very significant performance penalty, which is why
	 * we don't support unlimited arguments.
	 */
	function copyProperties(obj, a, b, c, d, e, f) {
	  obj = obj || {};

	  if ("production" !== "development") {
	    if (f) {
	      throw new Error('Too many arguments passed to copyProperties');
	    }
	  }

	  var args = [a, b, c, d, e];
	  var ii = 0, v;
	  while (args[ii]) {
	    v = args[ii++];
	    for (var k in v) {
	      obj[k] = v[k];
	    }

	    // IE ignores toString in object iteration.. See:
	    // webreflection.blogspot.com/2007/07/quick-fix-internet-explorer-and.html
	    if (v.hasOwnProperty && v.hasOwnProperty('toString') &&
	        (typeof v.toString != 'undefined') && (obj.toString !== v.toString)) {
	      obj.toString = v.toString;
	    }
	  }

	  return obj;
	}

	module.exports = copyProperties;

	},{}],98:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule createArrayFrom
	 * @typechecks
	 */

	var toArray = _dereq_("./toArray");

	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj &&
	    // arrays are objects, NodeLists are functions in Safari
	    (typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    ('length' in obj) &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    (typeof obj.nodeType != 'number') &&
	    (
	      // a real array
	      (// HTMLCollection/NodeList
	      (Array.isArray(obj) ||
	      // arguments
	      ('callee' in obj) || 'item' in obj))
	    )
	  );
	}

	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFrom = require('createArrayFrom');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFrom(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFrom(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}

	module.exports = createArrayFrom;

	},{"./toArray":141}],99:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule createFullPageComponent
	 * @typechecks
	 */

	"use strict";

	// Defeat circular references by requiring this directly.
	var ReactCompositeComponent = _dereq_("./ReactCompositeComponent");

	var invariant = _dereq_("./invariant");

	/**
	 * Create a component that will throw an exception when unmounted.
	 *
	 * Components like <html> <head> and <body> can't be removed or added
	 * easily in a cross-browser way, however it's valuable to be able to
	 * take advantage of React's reconciliation for styling and <title>
	 * management. So we just document it and throw in dangerous cases.
	 *
	 * @param {function} componentClass convenience constructor to wrap
	 * @return {function} convenience constructor of new component
	 */
	function createFullPageComponent(componentClass) {
	  var FullPageComponent = ReactCompositeComponent.createClass({
	    displayName: 'ReactFullPageComponent' + (
	      componentClass.type.displayName || ''
	    ),

	    componentWillUnmount: function() {
	      ("production" !== "development" ? invariant(
	        false,
	        '%s tried to unmount. Because of cross-browser quirks it is ' +
	        'impossible to unmount some top-level components (eg <html>, <head>, ' +
	        'and <body>) reliably and efficiently. To fix this, have a single ' +
	        'top-level component that never unmounts render these elements.',
	        this.constructor.displayName
	      ) : invariant(false));
	    },

	    render: function() {
	      return this.transferPropsTo(componentClass(null, this.props.children));
	    }
	  });

	  return FullPageComponent;
	}

	module.exports = createFullPageComponent;

	},{"./ReactCompositeComponent":33,"./invariant":120}],100:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */

	/*jslint evil: true, sub: true */

	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	var createArrayFrom = _dereq_("./createArrayFrom");
	var getMarkupWrap = _dereq_("./getMarkupWrap");
	var invariant = _dereq_("./invariant");

	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;

	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}

	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  ("production" !== "development" ? invariant(!!dummyNode, 'createNodesFromMarkup dummy not initialized') : invariant(!!dummyNode));
	  var nodeName = getNodeName(markup);

	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];

	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }

	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    ("production" !== "development" ? invariant(
	      handleScript,
	      'createNodesFromMarkup(...): Unexpected <script> element rendered.'
	    ) : invariant(handleScript));
	    createArrayFrom(scripts).forEach(handleScript);
	  }

	  var nodes = createArrayFrom(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}

	module.exports = createNodesFromMarkup;

	},{"./ExecutionEnvironment":21,"./createArrayFrom":98,"./getMarkupWrap":112,"./invariant":120}],101:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */

	"use strict";

	var CSSProperty = _dereq_("./CSSProperty");

	var isUnitlessNumber = CSSProperty.isUnitlessNumber;

	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901

	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }

	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 ||
	      isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }

	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}

	module.exports = dangerousStyleValue;

	},{"./CSSProperty":3}],102:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule emptyFunction
	 */

	var copyProperties = _dereq_("./copyProperties");

	function makeEmptyFunction(arg) {
	  return function() {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}

	copyProperties(emptyFunction, {
	  thatReturns: makeEmptyFunction,
	  thatReturnsFalse: makeEmptyFunction(false),
	  thatReturnsTrue: makeEmptyFunction(true),
	  thatReturnsNull: makeEmptyFunction(null),
	  thatReturnsThis: function() { return this; },
	  thatReturnsArgument: function(arg) { return arg; }
	});

	module.exports = emptyFunction;

	},{"./copyProperties":97}],103:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule emptyObject
	 */

	"use strict";

	var emptyObject = {};

	if ("production" !== "development") {
	  Object.freeze(emptyObject);
	}

	module.exports = emptyObject;

	},{}],104:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule escapeTextForBrowser
	 * @typechecks static-only
	 */

	"use strict";

	var ESCAPE_LOOKUP = {
	  "&": "&amp;",
	  ">": "&gt;",
	  "<": "&lt;",
	  "\"": "&quot;",
	  "'": "&#x27;"
	};

	var ESCAPE_REGEX = /[&><"']/g;

	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}

	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}

	module.exports = escapeTextForBrowser;

	},{}],105:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule flattenChildren
	 */

	"use strict";

	var traverseAllChildren = _dereq_("./traverseAllChildren");
	var warning = _dereq_("./warning");

	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = !result.hasOwnProperty(name);
	  ("production" !== "development" ? warning(
	    keyUnique,
	    'flattenChildren(...): Encountered two children with the same key, ' +
	    '`%s`. Child keys must be unique; when two children share a key, only ' +
	    'the first child will be used.',
	    name
	  ) : null);
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}

	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}

	module.exports = flattenChildren;

	},{"./traverseAllChildren":142,"./warning":143}],106:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule focusNode
	 */

	"use strict";

	/**
	 * IE8 throws if an input/textarea is disabled and we try to focus it.
	 * Focus only when necessary.
	 *
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  if (!node.disabled) {
	    node.focus();
	  }
	}

	module.exports = focusNode;

	},{}],107:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule forEachAccumulated
	 */

	"use strict";

	/**
	 * @param {array} an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};

	module.exports = forEachAccumulated;

	},{}],108:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */

	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document body is not yet defined.
	 */
	function getActiveElement() /*?DOMElement*/ {
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}

	module.exports = getActiveElement;

	},{}],109:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};

	/**
	 * Translation from legacy `which`/`keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};

	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.

	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }

	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    // Create the character from the `charCode` ourselves and use as an almost
	    // perfect replacement.
	    var charCode = 'charCode' in nativeEvent ?
	      nativeEvent.charCode :
	      nativeEvent.keyCode;

	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }

	  ("production" !== "development" ? invariant(false, "Unexpected keyboard event type: %s", nativeEvent.type) : invariant(false));
	}

	module.exports = getEventKey;

	},{"./invariant":120}],110:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */

	"use strict";

	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */

	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};

	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  /*jshint validthis:true */
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}

	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}

	module.exports = getEventModifierState;

	},{}],111:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */

	"use strict";

	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}

	module.exports = getEventTarget;

	},{}],112:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getMarkupWrap
	 */

	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	var invariant = _dereq_("./invariant");

	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	var shouldWrap = {
	  // Force wrapping for SVG elements because if they get created inside a <div>,
	  // they will be initialized in the wrong namespace (and will not display).
	  'circle': true,
	  'defs': true,
	  'ellipse': true,
	  'g': true,
	  'line': true,
	  'linearGradient': true,
	  'path': true,
	  'polygon': true,
	  'polyline': true,
	  'radialGradient': true,
	  'rect': true,
	  'stop': true,
	  'text': true
	};

	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

	var svgWrap = [1, '<svg>', '</svg>'];

	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],

	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],

	  'optgroup': selectWrap,
	  'option': selectWrap,

	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,

	  'td': trWrap,
	  'th': trWrap,

	  'circle': svgWrap,
	  'defs': svgWrap,
	  'ellipse': svgWrap,
	  'g': svgWrap,
	  'line': svgWrap,
	  'linearGradient': svgWrap,
	  'path': svgWrap,
	  'polygon': svgWrap,
	  'polyline': svgWrap,
	  'radialGradient': svgWrap,
	  'rect': svgWrap,
	  'stop': svgWrap,
	  'text': svgWrap
	};

	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  ("production" !== "development" ? invariant(!!dummyNode, 'Markup wrapping node not initialized') : invariant(!!dummyNode));
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}


	module.exports = getMarkupWrap;

	},{"./ExecutionEnvironment":21,"./invariant":120}],113:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */

	"use strict";

	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}

	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}

	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;

	  while (node) {
	    if (node.nodeType == 3) {
	      nodeEnd = nodeStart + node.textContent.length;

	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }

	      nodeStart = nodeEnd;
	    }

	    node = getLeafNode(getSiblingNode(node));
	  }
	}

	module.exports = getNodeForCharacterOffset;

	},{}],114:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getReactRootElementInContainer
	 */

	"use strict";

	var DOC_NODE_TYPE = 9;

	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 *                                           a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }

	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}

	module.exports = getReactRootElementInContainer;

	},{}],115:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getTextContentAccessor
	 */

	"use strict";

	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	var contentKey = null;

	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ?
	      'textContent' :
	      'innerText';
	  }
	  return contentKey;
	}

	module.exports = getTextContentAccessor;

	},{"./ExecutionEnvironment":21}],116:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */

	"use strict";

	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}

	module.exports = getUnboundedScrollPosition;

	},{}],117:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */

	var _uppercasePattern = /([A-Z])/g;

	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}

	module.exports = hyphenate;

	},{}],118:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */

	"use strict";

	var hyphenate = _dereq_("./hyphenate");

	var msPattern = /^ms-/;

	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *   > hyphenate('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenate('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}

	module.exports = hyphenateStyleName;

	},{"./hyphenate":117}],119:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	/**
	 * Validate a `componentDescriptor`. This should be exposed publicly in a follow
	 * up diff.
	 *
	 * @param {object} descriptor
	 * @return {boolean} Returns true if this is a valid descriptor of a Component.
	 */
	function isValidComponentDescriptor(descriptor) {
	  return (
	    descriptor &&
	    typeof descriptor.type === 'function' &&
	    typeof descriptor.type.prototype.mountComponent === 'function' &&
	    typeof descriptor.type.prototype.receiveComponent === 'function'
	  );
	}

	/**
	 * Given a `componentDescriptor` create an instance that will actually be
	 * mounted. Currently it just extracts an existing clone from composite
	 * components but this is an implementation detail which will change.
	 *
	 * @param {object} descriptor
	 * @return {object} A new instance of componentDescriptor's constructor.
	 * @protected
	 */
	function instantiateReactComponent(descriptor) {

	  // TODO: Make warning
	  // if (__DEV__) {
	    ("production" !== "development" ? invariant(
	      isValidComponentDescriptor(descriptor),
	      'Only React Components are valid for mounting.'
	    ) : invariant(isValidComponentDescriptor(descriptor)));
	  // }

	  return new descriptor.type(descriptor);
	}

	module.exports = instantiateReactComponent;

	},{"./invariant":120}],120:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule invariant
	 */

	"use strict";

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if ("production" !== "development") {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};

	module.exports = invariant;

	},{}],121:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule isEventSupported
	 */

	"use strict";

	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}

	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }

	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;

	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }

	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }

	  return isSupported;
	}

	module.exports = isEventSupported;

	},{"./ExecutionEnvironment":21}],122:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */

	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (
	    typeof Node === 'function' ? object instanceof Node :
	      typeof object === 'object' &&
	      typeof object.nodeType === 'number' &&
	      typeof object.nodeName === 'string'
	  ));
	}

	module.exports = isNode;

	},{}],123:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule isTextInputElement
	 */

	"use strict";

	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};

	function isTextInputElement(elem) {
	  return elem && (
	    (elem.nodeName === 'INPUT' && supportedInputTypes[elem.type]) ||
	    elem.nodeName === 'TEXTAREA'
	  );
	}

	module.exports = isTextInputElement;

	},{}],124:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */

	var isNode = _dereq_("./isNode");

	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}

	module.exports = isTextNode;

	},{"./isNode":122}],125:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule joinClasses
	 * @typechecks static-only
	 */

	"use strict";

	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} classes
	 * @return {string}
	 */
	function joinClasses(className/*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      nextClass && (className += ' ' + nextClass);
	    }
	  }
	  return className;
	}

	module.exports = joinClasses;

	},{}],126:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  ("production" !== "development" ? invariant(
	    obj instanceof Object && !Array.isArray(obj),
	    'keyMirror(...): Argument must be an object.'
	  ) : invariant(obj instanceof Object && !Array.isArray(obj)));
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};

	module.exports = keyMirror;

	},{"./invariant":120}],127:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule keyOf
	 */

	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without loosing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};


	module.exports = keyOf;

	},{}],128:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule mapObject
	 */

	"use strict";

	/**
	 * For each key/value pair, invokes callback func and constructs a resulting
	 * object which contains, for every key in obj, values that are the result of
	 * of invoking the function:
	 *
	 *   func(value, key, iteration)
	 *
	 * Grepable names:
	 *
	 *   function objectMap()
	 *   function objMap()
	 *
	 * @param {?object} obj Object to map keys over
	 * @param {function} func Invoked for each key/val pair.
	 * @param {?*} context
	 * @return {?object} Result of mapping or null if obj is falsey
	 */
	function mapObject(obj, func, context) {
	  if (!obj) {
	    return null;
	  }
	  var i = 0;
	  var ret = {};
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      ret[key] = func.call(context, obj[key], key, i++);
	    }
	  }
	  return ret;
	}

	module.exports = mapObject;

	},{}],129:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */

	"use strict";

	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function(string) {
	    if (cache.hasOwnProperty(string)) {
	      return cache[string];
	    } else {
	      return cache[string] = callback.call(this, string);
	    }
	  };
	}

	module.exports = memoizeStringOnly;

	},{}],130:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule merge
	 */

	"use strict";

	var mergeInto = _dereq_("./mergeInto");

	/**
	 * Shallow merges two structures into a return value, without mutating either.
	 *
	 * @param {?object} one Optional object with properties to merge from.
	 * @param {?object} two Optional object with properties to merge from.
	 * @return {object} The shallow extension of one by two.
	 */
	var merge = function(one, two) {
	  var result = {};
	  mergeInto(result, one);
	  mergeInto(result, two);
	  return result;
	};

	module.exports = merge;

	},{"./mergeInto":132}],131:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule mergeHelpers
	 *
	 * requiresPolyfills: Array.isArray
	 */

	"use strict";

	var invariant = _dereq_("./invariant");
	var keyMirror = _dereq_("./keyMirror");

	/**
	 * Maximum number of levels to traverse. Will catch circular structures.
	 * @const
	 */
	var MAX_MERGE_DEPTH = 36;

	/**
	 * We won't worry about edge cases like new String('x') or new Boolean(true).
	 * Functions are considered terminals, and arrays are not.
	 * @param {*} o The item/object/value to test.
	 * @return {boolean} true iff the argument is a terminal.
	 */
	var isTerminal = function(o) {
	  return typeof o !== 'object' || o === null;
	};

	var mergeHelpers = {

	  MAX_MERGE_DEPTH: MAX_MERGE_DEPTH,

	  isTerminal: isTerminal,

	  /**
	   * Converts null/undefined values into empty object.
	   *
	   * @param {?Object=} arg Argument to be normalized (nullable optional)
	   * @return {!Object}
	   */
	  normalizeMergeArg: function(arg) {
	    return arg === undefined || arg === null ? {} : arg;
	  },

	  /**
	   * If merging Arrays, a merge strategy *must* be supplied. If not, it is
	   * likely the caller's fault. If this function is ever called with anything
	   * but `one` and `two` being `Array`s, it is the fault of the merge utilities.
	   *
	   * @param {*} one Array to merge into.
	   * @param {*} two Array to merge from.
	   */
	  checkMergeArrayArgs: function(one, two) {
	    ("production" !== "development" ? invariant(
	      Array.isArray(one) && Array.isArray(two),
	      'Tried to merge arrays, instead got %s and %s.',
	      one,
	      two
	    ) : invariant(Array.isArray(one) && Array.isArray(two)));
	  },

	  /**
	   * @param {*} one Object to merge into.
	   * @param {*} two Object to merge from.
	   */
	  checkMergeObjectArgs: function(one, two) {
	    mergeHelpers.checkMergeObjectArg(one);
	    mergeHelpers.checkMergeObjectArg(two);
	  },

	  /**
	   * @param {*} arg
	   */
	  checkMergeObjectArg: function(arg) {
	    ("production" !== "development" ? invariant(
	      !isTerminal(arg) && !Array.isArray(arg),
	      'Tried to merge an object, instead got %s.',
	      arg
	    ) : invariant(!isTerminal(arg) && !Array.isArray(arg)));
	  },

	  /**
	   * @param {*} arg
	   */
	  checkMergeIntoObjectArg: function(arg) {
	    ("production" !== "development" ? invariant(
	      (!isTerminal(arg) || typeof arg === 'function') && !Array.isArray(arg),
	      'Tried to merge into an object, instead got %s.',
	      arg
	    ) : invariant((!isTerminal(arg) || typeof arg === 'function') && !Array.isArray(arg)));
	  },

	  /**
	   * Checks that a merge was not given a circular object or an object that had
	   * too great of depth.
	   *
	   * @param {number} Level of recursion to validate against maximum.
	   */
	  checkMergeLevel: function(level) {
	    ("production" !== "development" ? invariant(
	      level < MAX_MERGE_DEPTH,
	      'Maximum deep merge depth exceeded. You may be attempting to merge ' +
	      'circular structures in an unsupported way.'
	    ) : invariant(level < MAX_MERGE_DEPTH));
	  },

	  /**
	   * Checks that the supplied merge strategy is valid.
	   *
	   * @param {string} Array merge strategy.
	   */
	  checkArrayStrategy: function(strategy) {
	    ("production" !== "development" ? invariant(
	      strategy === undefined || strategy in mergeHelpers.ArrayStrategies,
	      'You must provide an array strategy to deep merge functions to ' +
	      'instruct the deep merge how to resolve merging two arrays.'
	    ) : invariant(strategy === undefined || strategy in mergeHelpers.ArrayStrategies));
	  },

	  /**
	   * Set of possible behaviors of merge algorithms when encountering two Arrays
	   * that must be merged together.
	   * - `clobber`: The left `Array` is ignored.
	   * - `indexByIndex`: The result is achieved by recursively deep merging at
	   *   each index. (not yet supported.)
	   */
	  ArrayStrategies: keyMirror({
	    Clobber: true,
	    IndexByIndex: true
	  })

	};

	module.exports = mergeHelpers;

	},{"./invariant":120,"./keyMirror":126}],132:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule mergeInto
	 * @typechecks static-only
	 */

	"use strict";

	var mergeHelpers = _dereq_("./mergeHelpers");

	var checkMergeObjectArg = mergeHelpers.checkMergeObjectArg;
	var checkMergeIntoObjectArg = mergeHelpers.checkMergeIntoObjectArg;

	/**
	 * Shallow merges two structures by mutating the first parameter.
	 *
	 * @param {object|function} one Object to be merged into.
	 * @param {?object} two Optional object with properties to merge from.
	 */
	function mergeInto(one, two) {
	  checkMergeIntoObjectArg(one);
	  if (two != null) {
	    checkMergeObjectArg(two);
	    for (var key in two) {
	      if (!two.hasOwnProperty(key)) {
	        continue;
	      }
	      one[key] = two[key];
	    }
	  }
	}

	module.exports = mergeInto;

	},{"./mergeHelpers":131}],133:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule mixInto
	 */

	"use strict";

	/**
	 * Simply copies properties to the prototype.
	 */
	var mixInto = function(constructor, methodBag) {
	  var methodName;
	  for (methodName in methodBag) {
	    if (!methodBag.hasOwnProperty(methodName)) {
	      continue;
	    }
	    constructor.prototype[methodName] = methodBag[methodName];
	  }
	};

	module.exports = mixInto;

	},{}],134:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule monitorCodeUse
	 */

	"use strict";

	var invariant = _dereq_("./invariant");

	/**
	 * Provides open-source compatible instrumentation for monitoring certain API
	 * uses before we're ready to issue a warning or refactor. It accepts an event
	 * name which may only contain the characters [a-z0-9_] and an optional data
	 * object with further information.
	 */

	function monitorCodeUse(eventName, data) {
	  ("production" !== "development" ? invariant(
	    eventName && !/[^a-z0-9_]/.test(eventName),
	    'You must provide an eventName using only the characters [a-z0-9_]'
	  ) : invariant(eventName && !/[^a-z0-9_]/.test(eventName)));
	}

	module.exports = monitorCodeUse;

	},{"./invariant":120}],135:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule onlyChild
	 */
	"use strict";

	var ReactDescriptor = _dereq_("./ReactDescriptor");

	var invariant = _dereq_("./invariant");

	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  ("production" !== "development" ? invariant(
	    ReactDescriptor.isValidDescriptor(children),
	    'onlyChild must be passed a children with exactly one child.'
	  ) : invariant(ReactDescriptor.isValidDescriptor(children)));
	  return children;
	}

	module.exports = onlyChild;

	},{"./ReactDescriptor":51,"./invariant":120}],136:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule performance
	 * @typechecks
	 */

	"use strict";

	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	var performance;

	if (ExecutionEnvironment.canUseDOM) {
	  performance =
	    window.performance ||
	    window.msPerformance ||
	    window.webkitPerformance;
	}

	module.exports = performance || {};

	},{"./ExecutionEnvironment":21}],137:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule performanceNow
	 * @typechecks
	 */

	var performance = _dereq_("./performance");

	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (!performance || !performance.now) {
	  performance = Date;
	}

	var performanceNow = performance.now.bind(performance);

	module.exports = performanceNow;

	},{"./performance":136}],138:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule setInnerHTML
	 */

	"use strict";

	var ExecutionEnvironment = _dereq_("./ExecutionEnvironment");

	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function(node, html) {
	  node.innerHTML = html;
	};

	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function(node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }

	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (html.match(/^[ \r\n\t\f]/) ||
	          html[0] === '<' && (
	            html.indexOf('<noscript') !== -1 ||
	            html.indexOf('<script') !== -1 ||
	            html.indexOf('<style') !== -1 ||
	            html.indexOf('<meta') !== -1 ||
	            html.indexOf('<link') !== -1)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        node.innerHTML = '\uFEFF' + html;

	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}

	module.exports = setInnerHTML;

	},{"./ExecutionEnvironment":21}],139:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule shallowEqual
	 */

	"use strict";

	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	  var key;
	  // Test for A's keys different from B.
	  for (key in objA) {
	    if (objA.hasOwnProperty(key) &&
	        (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
	      return false;
	    }
	  }
	  // Test for B'a keys missing from A.
	  for (key in objB) {
	    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
	      return false;
	    }
	  }
	  return true;
	}

	module.exports = shallowEqual;

	},{}],140:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */

	"use strict";

	/**
	 * Given a `prevDescriptor` and `nextDescriptor`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are descriptors. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevDescriptor
	 * @param {?object} nextDescriptor
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevDescriptor, nextDescriptor) {
	  if (prevDescriptor && nextDescriptor &&
	      prevDescriptor.type === nextDescriptor.type && (
	        (prevDescriptor.props && prevDescriptor.props.key) ===
	        (nextDescriptor.props && nextDescriptor.props.key)
	      ) && prevDescriptor._owner === nextDescriptor._owner) {
	    return true;
	  }
	  return false;
	}

	module.exports = shouldUpdateReactComponent;

	},{}],141:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */

	var invariant = _dereq_("./invariant");

	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFrom.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;

	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  ("production" !== "development" ? invariant(
	    !Array.isArray(obj) &&
	    (typeof obj === 'object' || typeof obj === 'function'),
	    'toArray: Array-like object expected'
	  ) : invariant(!Array.isArray(obj) &&
	  (typeof obj === 'object' || typeof obj === 'function')));

	  ("production" !== "development" ? invariant(
	    typeof length === 'number',
	    'toArray: Object needs a length property'
	  ) : invariant(typeof length === 'number'));

	  ("production" !== "development" ? invariant(
	    length === 0 ||
	    (length - 1) in obj,
	    'toArray: Object should have keys for indices'
	  ) : invariant(length === 0 ||
	  (length - 1) in obj));

	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }

	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}

	module.exports = toArray;

	},{"./invariant":120}],142:[function(_dereq_,module,exports){
	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule traverseAllChildren
	 */

	"use strict";

	var ReactInstanceHandles = _dereq_("./ReactInstanceHandles");
	var ReactTextComponent = _dereq_("./ReactTextComponent");

	var invariant = _dereq_("./invariant");

	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';

	/**
	 * TODO: Test that:
	 * 1. `mapChildren` transforms strings and numbers into `ReactTextComponent`.
	 * 2. it('should fail when supplied duplicate key', function() {
	 * 3. That a single child and an array with one item have the same key pattern.
	 * });
	 */

	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};

	var userProvidedKeyEscapeRegex = /[=.:]/g;

	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}

	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.props && component.props.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.props.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}

	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} key Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(
	    userProvidedKeyEscapeRegex,
	    userProvidedKeyEscaper
	  );
	}

	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}

	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!number} indexSoFar Number of children encountered until this point.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	var traverseAllChildrenImpl =
	  function(children, nameSoFar, indexSoFar, callback, traverseContext) {
	    var subtreeCount = 0;  // Count of children found in the current subtree.
	    if (Array.isArray(children)) {
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i];
	        var nextName = (
	          nameSoFar +
	          (nameSoFar ? SUBSEPARATOR : SEPARATOR) +
	          getComponentKey(child, i)
	        );
	        var nextIndex = indexSoFar + subtreeCount;
	        subtreeCount += traverseAllChildrenImpl(
	          child,
	          nextName,
	          nextIndex,
	          callback,
	          traverseContext
	        );
	      }
	    } else {
	      var type = typeof children;
	      var isOnlyChild = nameSoFar === '';
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows
	      var storageName =
	        isOnlyChild ? SEPARATOR + getComponentKey(children, 0) : nameSoFar;
	      if (children == null || type === 'boolean') {
	        // All of the above are perceived as null.
	        callback(traverseContext, null, storageName, indexSoFar);
	        subtreeCount = 1;
	      } else if (children.type && children.type.prototype &&
	                 children.type.prototype.mountComponentIntoNode) {
	        callback(traverseContext, children, storageName, indexSoFar);
	        subtreeCount = 1;
	      } else {
	        if (type === 'object') {
	          ("production" !== "development" ? invariant(
	            !children || children.nodeType !== 1,
	            'traverseAllChildren(...): Encountered an invalid child; DOM ' +
	            'elements are not valid children of React components.'
	          ) : invariant(!children || children.nodeType !== 1));
	          for (var key in children) {
	            if (children.hasOwnProperty(key)) {
	              subtreeCount += traverseAllChildrenImpl(
	                children[key],
	                (
	                  nameSoFar + (nameSoFar ? SUBSEPARATOR : SEPARATOR) +
	                  wrapUserProvidedKey(key) + SUBSEPARATOR +
	                  getComponentKey(children[key], 0)
	                ),
	                indexSoFar + subtreeCount,
	                callback,
	                traverseContext
	              );
	            }
	          }
	        } else if (type === 'string') {
	          var normalizedText = ReactTextComponent(children);
	          callback(traverseContext, normalizedText, storageName, indexSoFar);
	          subtreeCount += 1;
	        } else if (type === 'number') {
	          var normalizedNumber = ReactTextComponent('' + children);
	          callback(traverseContext, normalizedNumber, storageName, indexSoFar);
	          subtreeCount += 1;
	        }
	      }
	    }
	    return subtreeCount;
	  };

	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }

	  return traverseAllChildrenImpl(children, '', 0, callback, traverseContext);
	}

	module.exports = traverseAllChildren;

	},{"./ReactInstanceHandles":59,"./ReactTextComponent":75,"./invariant":120}],143:[function(_dereq_,module,exports){
	/**
	 * Copyright 2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule warning
	 */

	"use strict";

	var emptyFunction = _dereq_("./emptyFunction");

	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var warning = emptyFunction;

	if ("production" !== "development") {
	  warning = function(condition, format ) {var args=Array.prototype.slice.call(arguments,2);
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }

	    if (!condition) {
	      var argIndex = 0;
	      console.warn('Warning: ' + format.replace(/%s/g, function()  {return args[argIndex++];}));
	    }
	  };
	}

	module.exports = warning;

	},{"./emptyFunction":102}]},{},[27])
	(27)
	});

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(React, $, _) {var addEventListener, location, old_A, popstate_event, ref, relativeURLFromLocation, relativeURLFromStatebus,
	  hasProp = {}.hasOwnProperty;

	__webpack_require__(27);

	__webpack_require__(3);

	__webpack_require__(5);

	window.loadPage = function(url, query_params) {
	  var hash, i, len, loc, query_param, ref, ref1, ref2;
	  loc = fetch('location');
	  loc.query_params = query_params || {};
	  if (url.indexOf('?') > -1) {
	    ref = url.split('?'), url = ref[0], query_params = ref[1];
	    ref1 = query_params.split('&');
	    for (i = 0, len = ref1.length; i < len; i++) {
	      query_param = ref1[i];
	      query_param = query_param.split('=');
	      if (query_param.length === 2) {
	        loc.query_params[query_param[0]] = query_param[1];
	      }
	    }
	  }
	  hash = '';
	  if (url.indexOf('#') > -1) {
	    ref2 = url.split('#'), url = ref2[0], hash = ref2[1];
	    if (url === '') {
	      url = '/';
	    }
	    loc.seek_to_hash = hash;
	  }
	  loc.url = url;
	  loc.hash = hash;
	  return save(loc);
	};

	old_A = A;

	window.A = React.createClass({
	  render: function() {
	    var props;
	    props = this.props;
	    if (this.props.href) {
	      this._onclick = this.props.onClick || (function() {
	        return null;
	      });
	      if (browser.is_mobile) {
	        this.props.onTouchEnd = (function(_this) {
	          return function(e) {
	            if (!is_swipping) {
	              return _this.handleClick(e);
	            }
	          };
	        })(this);
	        if (browser.is_android_browser) {
	          this.props.onClick = function(e) {
	            e.preventDefault();
	            return e.stopPropagation();
	          };
	        }
	      } else {
	        this.props.onClick = this.handleClick;
	      }
	    }
	    return old_A(props, props.children);
	  },
	  handleClick: function(event) {
	    var href, is_external_link, is_mailto, node, opened_in_new_tab;
	    node = this.getDOMNode();
	    href = node.getAttribute('href');
	    is_external_link = href.indexOf('//') > -1;
	    is_mailto = href.toLowerCase().indexOf('mailto') > -1;
	    opened_in_new_tab = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
	    if (!is_external_link && !opened_in_new_tab && !is_mailto && !node.getAttribute('data-nojax')) {
	      event.preventDefault();
	      event.stopPropagation();
	      loadPage(href);
	      this._onclick(event);
	      if (!this.getDOMNode().getAttribute('data-no-scroll')) {
	        window.scrollTo(0, 0);
	      }
	      return false;
	    } else {
	      return this._onclick(event);
	    }
	  }
	});

	window.BrowserLocation = ReactiveComponent({
	  displayName: 'BrowserLocation',
	  render: function() {
	    var doc, loc, new_location, title;
	    loc = fetch('location');
	    doc = fetch('document');
	    title = doc.title || document.title;
	    if (doc.title && document.title !== doc.title) {
	      document.title = doc.title;
	    }
	    new_location = relativeURLFromStatebus();
	    if (this.last_location !== new_location) {
	      if (relativeURLFromLocation() !== new_location) {
	        history.pushState(loc.query_params, title, new_location);
	      }
	      this.last_location = new_location;
	      writeToLog({
	        what: 'changing url',
	        where: loc.url
	      });
	    }
	    return SPAN(null);
	  },
	  componentDidUpdate: function() {
	    var int, loc;
	    loc = fetch('location');
	    if (loc.seek_to_hash) {
	      loc.seek_to_hash = false;
	      save(loc);
	      return int = setInterval(function() {
	        var docks, el, seek_below;
	        el = document.querySelector("#" + loc.hash);
	        if (el) {
	          docks = fetch('docking_station');
	          seek_below = docks.y_stack || 50;
	          $(window).scrollTop(getCoords(el).top - seek_below);
	          return clearInterval(int);
	        }
	      }, 100);
	    }
	  }
	});

	relativeURLFromLocation = function() {
	  var loc, ref, ref1, search;
	  search = (ref = location.search) != null ? ref.replace(/\%2[fF]/g, '/') : void 0;
	  loc = (ref1 = location.pathname) != null ? ref1.replace(/\%20/g, ' ') : void 0;
	  return "" + loc + search + location.hash;
	};

	relativeURLFromStatebus = function() {
	  var k, loc, query_params, ref, relative_url, v;
	  loc = fetch('location');
	  relative_url = loc.url;
	  if (_.keys(loc.query_params).length > 0) {
	    query_params = (function() {
	      var ref, results;
	      ref = loc.query_params;
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        v = ref[k];
	        results.push(k + "=" + v);
	      }
	      return results;
	    })();
	    relative_url += "?" + (query_params.join('&'));
	  }
	  if (((ref = loc.hash) != null ? ref.length : void 0) > 0) {
	    relative_url += "#" + loc.hash;
	  }
	  return relative_url;
	};

	location = window.history.location || window.location;

	ref = window.addEventListener ? ['addEventListener', 'popstate'] : ['attachEvent', 'onpopstate'], addEventListener = ref[0], popstate_event = ref[1];

	window[addEventListener](popstate_event, function(ev) {
	  return loadPage(relativeURLFromLocation());
	});

	loadPage(relativeURLFromLocation());

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(2), __webpack_require__(1)))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var md5;

	__webpack_require__(3);

	__webpack_require__(23);

	md5 = __webpack_require__(11);

	window.Bubblemouth = function(props) {
	  var apex, bubblemouth_path, cx, full_width, id, qx1, qx2, qy1, qy2, ref, ref1, ref2, ref3, ref4, skew_x, skew_y, svg_h, svg_w, x1, x2, x3, y1, y2, y3;
	  _.defaults(props, {
	    svg_w: 85,
	    svg_h: 100,
	    skew_x: 15,
	    skew_y: 80,
	    apex_xfrac: .5,
	    fill: 'white',
	    stroke: focus_blue,
	    stroke_width: 10,
	    dash_array: "none",
	    box_shadow: null
	  });
	  full_width = props.svg_w + 4 * props.skew_x * Math.max(.5, Math.abs(.5 - props.apex_xfrac));
	  _.defaults(props, {
	    width: full_width,
	    height: props.svg_h
	  });
	  apex = props.apex_xfrac;
	  svg_w = props.svg_w;
	  svg_h = props.svg_h;
	  skew_x = props.skew_x;
	  skew_y = props.skew_y;
	  cx = skew_x + svg_w / 2;
	  ref = [skew_x - apex * skew_x, svg_h], x1 = ref[0], y1 = ref[1];
	  ref1 = [skew_x + apex * svg_w, 0], x2 = ref1[0], y2 = ref1[1];
	  ref2 = [x1 + svg_w + skew_x, svg_h], x3 = ref2[0], y3 = ref2[1];
	  ref3 = [-skew_x + apex * (cx + 2 * skew_x), skew_y], qx1 = ref3[0], qy1 = ref3[1];
	  ref4 = [qx1 + cx, skew_y], qx2 = ref4[0], qy2 = ref4[1];
	  bubblemouth_path = "M  " + x1 + "  " + y1 + "\nQ " + qx1 + " " + qy1 + "\n   " + x2 + "  " + y2 + "\nQ " + qx2 + " " + qy2 + "\n   " + x3 + "  " + y3 + "\n";
	  id = "x" + (md5(JSON.stringify(props)));
	  return SVG({
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    width: props.width,
	    height: props.height,
	    viewBox: "0 0 " + full_width + " " + svg_h,
	    preserveAspectRatio: "none",
	    style: props.style ? props.style : void 0
	  }, DEFS(null, CLIPPATH({
	    id: id
	  }, PATH({
	    strokeWidth: props.stroke_width * 2,
	    d: bubblemouth_path
	  })), props.box_shadow ? svg.dropShadow(_.extend(props.box_shadow, {
	    id: id + "-shadow"
	  })) : void 0), props.box_shadow ? PATH({
	    key: 'shadow',
	    fill: props.fill,
	    style: {
	      filter: "url(#" + id + "-shadow)"
	    },
	    d: bubblemouth_path
	  }) : void 0, PATH({
	    key: 'stroke',
	    fill: props.fill,
	    stroke: props.stroke,
	    strokeWidth: props.stroke_width * 2,
	    clipPath: "url(#" + id + ")",
	    strokeDasharray: props.dash_array,
	    d: bubblemouth_path
	  }));
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(3);

	window.Tooltip = ReactiveComponent({
	  displayName: 'Tooltip',
	  render: function() {
	    var coords, size, style, tip, tooltip;
	    tooltip = fetch('tooltip');
	    if (!tooltip.coords) {
	      return SPAN(null);
	    }
	    coords = tooltip.coords;
	    tip = tooltip.tip;
	    style = _.defaults({}, this.props.style || {}, {
	      fontSize: 16,
	      padding: '4px 8px',
	      borderRadius: 8,
	      pointerEvents: 'none',
	      zIndex: 9999,
	      color: '#777',
	      backgroundColor: '#f6f6f6',
	      position: 'absolute',
	      boxShadow: '0 1px 1px rgba(0,0,0,.2)',
	      borderBottom: '1px solid #eee'
	    });
	    size = sizeWhenRendered(tip, style);
	    _.extend(style, {
	      top: coords.top - size.height - 9,
	      left: coords.left - size.width / 2
	    });
	    return DIV({
	      style: style,
	      dangerouslySetInnerHTML: {
	        __html: tip
	      }
	    });
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	window.drawLogo = function(height, main_text_color, o_text_color, clip, draw_line, line_color, i_dot_x, transition) {
	  var width;
	  main_text_color = main_text_color || 'white';
	  o_text_color = o_text_color || logo_red;
	  line_color = line_color || 'white';
	  i_dot_x = i_dot_x || 252.25;
	  height = height || 60;
	  width = width || height * 284 / 60;
	  return SVG({
	    id: 'considerit_logo',
	    width: width,
	    height: height,
	    viewBox: "0 0 284 60",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, DEFS(null, CLIPPATH({
	    id: 'logo_clip'
	  }, RECT({
	    x: 0,
	    y: 0,
	    width: 284,
	    height: 45
	  }))), G(null, draw_line ? LINE({
	    id: 'underline',
	    x1: 8,
	    y1: 55,
	    x2: 284,
	    y2: 55,
	    stroke: line_color,
	    strokeWidth: 1
	  }) : void 0, PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M18.2811874,48.356 \nC24.1163223,48.3559999 28.0501221,47.5510218 32.5084274,43.599315 \nC32.9673706,43.1801946 33.0984972,42.4018281 32.5739907,41.9827077 \nL30.2137104,37.099623 \nC29.8203305,36.740377 29.0991341,36.6805026 28.5746276,37.099623 \nC25.8209684,39.1353508 22.4772394,40.5124608 18.5434406,40.5124607 \nC14.4641389,40.5124606 9.32086755,37.716503 9.32086787,29.1762513 \nC9.32086836,20.6359996 15.4629989,17.6360006 18.2811869,17.6360001 \nC22.4641385,17.636 25.4641379,19.6359996 27.5746276,21.2528796 \nC28.0991341,21.7318743 28.7547672,21.7318743 29.2137104,21.2528796 \nL32.5739907,17.001801 \nC33.0984972,16.5228062 33.0984972,15.804314 32.5084274,15.3253193 \nC28.0501221,11.6729842 24.903082,10.236 18.2811874,10.236 \nC8.41026668,10.236 0.0764406792,17.8200837 0.0764406792,29.3558743 \nC0.0764406792,40.2729625 8.41026668,48.3560001 18.2811874,48.356 \nZ "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M38.1601385,33.164 \nC38.1601385,41.444 44.7841385,48.356 52.9201385,48.356 \nC61.0561385,48.356 67.6801385,41.444 67.6801385,33.164 \nC67.6801385,25.028 61.0561385,18.116 52.9201385,18.116 \nC44.7841385,18.116 38.1601385,25.028 38.1601385,33.164 \nC38.1601385,33.164 38.1601385,25.028 38.1601385,33.164 \nZ\nM46.0081385,33.164 \nC46.0081385,29.132 49.0321385,25.892 52.9201385,25.892 \nC56.7361385,25.892 59.8321385,29.132 59.8321385,33.164 \nC59.8321385,37.268 56.7361385,40.58 52.9201385,40.58 \nC49.0321385,40.58 46.0081385,37.268 46.0081385,33.164 \nC46.0081385,33.164 46.0081385,37.268 46.0081385,33.164 \nZ "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M74.0881385,46.268 \nC74.0881385,46.988 74.7361385,47.636 75.4561385,47.636 \nL80.7841385,47.636 \nC82.1521385,47.636 82.5841385,47.276 82.5841385,46.268 \nL82.5841385,30.428 \nC83.3041385,28.484 85.6081385,25.892 89.3521385,25.892 \nC92.8081385,25.892 94.7521385,28.268 94.7521385,32.012 \nL94.7521385,46.268 \nC94.7521385,46.988 95.3281385,47.636 96.1201385,47.636 \nL102.024139,47.636 \nC102.744139,47.636 103.392139,46.988 103.392139,46.268 \nL103.392139,32.444 \nC103.392139,24.956 99.7201385,18.116 90.5761385,18.116 \nC85.0321385,18.116 81.5041385,21.212 80.4241385,22.364 \nL79.4161385,19.7 \nC79.2001385,19.196 78.8401385,18.836 78.1921385,18.836 \nL75.4561385,18.836 \nC74.7361385,18.836 74.0881385,19.412 74.0881385,20.204 \nC74.0881385,20.204 74.0881385,19.412 74.0881385,20.204 \nL74.0881385,46.268 \nZ "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M110.304139,45.692 \nC111.816139,46.844 115.128139,48.356 119.880139,48.356 \nC127.152139,48.356 131.328139,44.324 131.328139,39.572 \nC131.328139,33.956 127.152139,31.58 121.608139,29.42 \nC118.944139,28.34 117.648139,27.908 117.648139,26.612 \nC117.648139,25.676 118.368139,24.956 120.096139,24.956 \nC122.832139,24.956 126.072139,26.468 126.072139,26.468 \nC126.648139,26.684 127.440139,26.612 127.800139,25.964 \nL129.600139,22.292 \nC129.960139,21.572 129.600139,20.78 128.952139,20.348 \nC127.440139,19.34 124.344139,18.116 120.096139,18.116 \nC112.752139,18.116 109.512139,22.22 109.512139,26.612 \nC109.512139,31.004 112.104139,33.956 117.648139,36.116 \nC121.464139,37.628 122.472139,38.42 122.472139,39.716 \nC122.472139,40.94 121.464139,41.516 120.024139,41.516 \nC116.712139,41.516 113.472139,39.788 113.472139,39.788 \nC112.824139,39.428 112.104139,39.572 111.816139,40.292 \nL109.872139,44.18 \nC109.584139,44.756 109.872139,45.332 110.304139,45.692 \nC110.304139,45.692 109.872139,45.332 110.304139,45.692 \nZ "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M137.664139,46.268 \nC137.664139,46.988 138.312139,47.636 139.032139,47.636 \nL145.008139,47.636 \nC145.728139,47.636 146.376139,46.988 146.376139,46.268 \nL146.376139,20.204 \nC146.376139,19.412 145.728139,18.836 145.008139,18.836 \nL139.032139,18.836 \nC138.312139,18.836 137.664139,19.412 137.664139,20.204 \nC137.664139,20.204 137.664139,19.412 137.664139,20.204 \nL137.664139,46.268 \nZ "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M166.680139,48.356 \nC172.728139,48.356 176.112139,44.036 176.112139,44.036 \nL176.832139,46.268 \nC177.048139,47.06 177.552139,47.636 178.200139,47.636 \nL181.008139,47.636 \nC181.728139,47.636 182.376139,46.988 182.376139,46.268 \nL182.376139,1.604 \nC182.376139,0.884 181.728139,0.236 181.008139,0.236 \nL174.888139,0.236 \nC174.168139,0.236 173.520139,0.884 173.520139,1.604 \nL173.520139,19.412 \nC172.224139,18.908 169.992139,18.116 167.112139,18.116 \nC158.544139,18.116 152.856139,24.812 152.856139,33.236 \nC152.856139,41.516 158.832139,48.356 166.680139,48.356 \nZ \nM161.208139,33.236 \nC161.208139,29.204 164.160139,25.892 168.192139,25.892 \nC171.792139,25.892 173.808139,27.548 173.808139,27.548 \nL173.808139,35.9 \nC173.304139,37.628 171.576139,40.58 167.760139,40.58 \nC163.944139,40.58 161.208139,37.268 161.208139,33.236 \nC161.208139,33.236 161.208139,37.268 161.208139,33.236 \nZ "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M188.856139,33.236 \nC188.856139,41.516 194.976139,48.356 203.616139,48.356 \nC208.296139,48.356 211.968139,46.628 214.344139,44.396 \nC215.064139,43.82 214.920139,43.028 214.416139,42.524 \nL211.464139,39.14 \nC210.960139,38.564 210.312139,38.708 209.592139,39.14 \nC208.296139,40.076 206.208139,40.94 203.976139,40.94 \nC199.800139,40.94 197.280139,37.628 197.064139,34.676 \nL215.496139,34.676 \nC216.144139,34.676 216.792139,34.172 216.864139,33.452 \nC216.936139,32.948 217.008139,32.012 217.008139,31.508 \nC217.008139,23.732 210.960139,18.116 203.544139,18.116 \nC194.976139,18.116 188.856139,25.1 188.856139,33.236 \nC188.856139,33.236 188.856139,25.1 188.856139,33.236 \nZ \nM197.712139,29.636 \nC198.072139,26.9 200.448139,24.74 203.328139,24.74 \nC206.064139,24.74 208.368139,26.972 208.584139,29.636 \nC208.584139,29.636 208.368139,26.972 208.584139,29.636 \nL197.712139,29.636 \nZ           "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M223.056139,46.268 \nC223.056139,46.988 223.704139,47.636 224.424139,47.636 \nL229.968139,47.636 \nC230.976139,47.636 231.624139,47.276 231.624139,46.268 \nL231.624139,28.844 \nC232.128139,27.836 233.856139,25.892 236.736139,25.892 \nC237.528139,25.892 238.608139,26.252 238.824139,26.324 \nC239.400139,26.612 240.120139,26.324 240.480139,25.676 \nL243.144139,20.996 \nC244.008139,19.196 240.984139,18.116 237.600139,18.116 \nC233.136139,18.116 230.472139,21.14 229.464139,22.58 \nL228.456139,19.772 \nC228.240139,19.196 227.808139,18.836 227.160139,18.836 \nL224.424139,18.836 \nC223.704139,18.836 223.056139,19.412 223.056139,20.204 \nC223.056139,20.204 223.056139,19.412 223.056139,20.204 \nL223.056139,46.268 \nZ "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M247.608139,46.268 \nC247.608139,46.988 248.256139,47.636 248.976139,47.636 \nL254.952139,47.636 \nC255.672139,47.636 256.320139,46.988 256.320139,46.268 \nL256.320139,20.204 \nC256.320139,19.412 255.672139,18.836 254.952139,18.836 \nL248.976139,18.836 \nC248.256139,18.836 247.608139,19.412 247.608139,20.204 \nC247.608139,20.204 247.608139,19.412 247.608139,20.204 \nL247.608139,46.268 \nZ "
	  }), PATH({
	    fill: main_text_color,
	    clipPath: clip ? "url(#logo_clip)" : void 0,
	    d: "M266.472139,39.068 \nC266.472139,44.9 268.920139,48.356 274.464139,48.356 \nC277.992139,48.356 282.672139,46.7 283.032139,46.484 \nC283.752139,46.196 284.112139,45.476 283.824139,44.756 \nL282.384139,40.22 \nC282.168139,39.5 281.592139,39.14 280.800139,39.428 \nC280.008139,39.716 278.496139,40.22 277.272139,40.22 \nC276.120139,40.22 275.040139,39.932 275.040139,37.916 \nL275.040139,26.396 \nL281.376139,26.396 \nC282.168139,26.396 282.744139,25.748 282.744139,25.028 \nL282.744139,20.204 \nC282.744139,19.412 282.168139,18.836 281.376139,18.836 \nL275.040139,18.836 \nL275.040139,10.772 \nC275.040139,10.052 274.464139,9.404 273.744139,9.404 \nL267.840139,9.476 \nC267.120139,9.476 266.472139,10.124 266.472139,10.844 \nL266.472139,18.836 \nL264.024139,18.836 \nC263.304139,18.836 262.728139,19.412 262.728139,20.204 \nL262.728139,25.028 \nC262.728139,25.748 263.304139,26.396 264.024139,26.396 \nL266.472139,26.396 \nL266.472139,39.068 \nZ"
	  }), CIRCLE({
	    id: 'i_dot',
	    fill: o_text_color,
	    cx: i_dot_x,
	    cy: "55",
	    r: "4.25",
	    style: transition ? css.crossbrowserify({
	      transition: 'cx 1000ms'
	    }) : void 0
	  })));
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * JavaScript MD5 1.0.1
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * http://www.opensource.org/licenses/MIT
	 * 
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */

	/*jslint bitwise: true */
	/*global unescape, define */

	(function ($) {
	    'use strict';

	    /*
	    * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	    * to work around bugs in some JS interpreters.
	    */
	    function safe_add(x, y) {
	        var lsw = (x & 0xFFFF) + (y & 0xFFFF),
	            msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	        return (msw << 16) | (lsw & 0xFFFF);
	    }

	    /*
	    * Bitwise rotate a 32-bit number to the left.
	    */
	    function bit_rol(num, cnt) {
	        return (num << cnt) | (num >>> (32 - cnt));
	    }

	    /*
	    * These functions implement the four basic operations the algorithm uses.
	    */
	    function md5_cmn(q, a, b, x, s, t) {
	        return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
	    }
	    function md5_ff(a, b, c, d, x, s, t) {
	        return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	    }
	    function md5_gg(a, b, c, d, x, s, t) {
	        return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	    }
	    function md5_hh(a, b, c, d, x, s, t) {
	        return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	    }
	    function md5_ii(a, b, c, d, x, s, t) {
	        return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	    }

	    /*
	    * Calculate the MD5 of an array of little-endian words, and a bit length.
	    */
	    function binl_md5(x, len) {
	        /* append padding */
	        x[len >> 5] |= 0x80 << (len % 32);
	        x[(((len + 64) >>> 9) << 4) + 14] = len;

	        var i, olda, oldb, oldc, oldd,
	            a =  1732584193,
	            b = -271733879,
	            c = -1732584194,
	            d =  271733878;

	        for (i = 0; i < x.length; i += 16) {
	            olda = a;
	            oldb = b;
	            oldc = c;
	            oldd = d;

	            a = md5_ff(a, b, c, d, x[i],       7, -680876936);
	            d = md5_ff(d, a, b, c, x[i +  1], 12, -389564586);
	            c = md5_ff(c, d, a, b, x[i +  2], 17,  606105819);
	            b = md5_ff(b, c, d, a, x[i +  3], 22, -1044525330);
	            a = md5_ff(a, b, c, d, x[i +  4],  7, -176418897);
	            d = md5_ff(d, a, b, c, x[i +  5], 12,  1200080426);
	            c = md5_ff(c, d, a, b, x[i +  6], 17, -1473231341);
	            b = md5_ff(b, c, d, a, x[i +  7], 22, -45705983);
	            a = md5_ff(a, b, c, d, x[i +  8],  7,  1770035416);
	            d = md5_ff(d, a, b, c, x[i +  9], 12, -1958414417);
	            c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
	            b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
	            a = md5_ff(a, b, c, d, x[i + 12],  7,  1804603682);
	            d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
	            c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
	            b = md5_ff(b, c, d, a, x[i + 15], 22,  1236535329);

	            a = md5_gg(a, b, c, d, x[i +  1],  5, -165796510);
	            d = md5_gg(d, a, b, c, x[i +  6],  9, -1069501632);
	            c = md5_gg(c, d, a, b, x[i + 11], 14,  643717713);
	            b = md5_gg(b, c, d, a, x[i],      20, -373897302);
	            a = md5_gg(a, b, c, d, x[i +  5],  5, -701558691);
	            d = md5_gg(d, a, b, c, x[i + 10],  9,  38016083);
	            c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
	            b = md5_gg(b, c, d, a, x[i +  4], 20, -405537848);
	            a = md5_gg(a, b, c, d, x[i +  9],  5,  568446438);
	            d = md5_gg(d, a, b, c, x[i + 14],  9, -1019803690);
	            c = md5_gg(c, d, a, b, x[i +  3], 14, -187363961);
	            b = md5_gg(b, c, d, a, x[i +  8], 20,  1163531501);
	            a = md5_gg(a, b, c, d, x[i + 13],  5, -1444681467);
	            d = md5_gg(d, a, b, c, x[i +  2],  9, -51403784);
	            c = md5_gg(c, d, a, b, x[i +  7], 14,  1735328473);
	            b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

	            a = md5_hh(a, b, c, d, x[i +  5],  4, -378558);
	            d = md5_hh(d, a, b, c, x[i +  8], 11, -2022574463);
	            c = md5_hh(c, d, a, b, x[i + 11], 16,  1839030562);
	            b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
	            a = md5_hh(a, b, c, d, x[i +  1],  4, -1530992060);
	            d = md5_hh(d, a, b, c, x[i +  4], 11,  1272893353);
	            c = md5_hh(c, d, a, b, x[i +  7], 16, -155497632);
	            b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
	            a = md5_hh(a, b, c, d, x[i + 13],  4,  681279174);
	            d = md5_hh(d, a, b, c, x[i],      11, -358537222);
	            c = md5_hh(c, d, a, b, x[i +  3], 16, -722521979);
	            b = md5_hh(b, c, d, a, x[i +  6], 23,  76029189);
	            a = md5_hh(a, b, c, d, x[i +  9],  4, -640364487);
	            d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
	            c = md5_hh(c, d, a, b, x[i + 15], 16,  530742520);
	            b = md5_hh(b, c, d, a, x[i +  2], 23, -995338651);

	            a = md5_ii(a, b, c, d, x[i],       6, -198630844);
	            d = md5_ii(d, a, b, c, x[i +  7], 10,  1126891415);
	            c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
	            b = md5_ii(b, c, d, a, x[i +  5], 21, -57434055);
	            a = md5_ii(a, b, c, d, x[i + 12],  6,  1700485571);
	            d = md5_ii(d, a, b, c, x[i +  3], 10, -1894986606);
	            c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
	            b = md5_ii(b, c, d, a, x[i +  1], 21, -2054922799);
	            a = md5_ii(a, b, c, d, x[i +  8],  6,  1873313359);
	            d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
	            c = md5_ii(c, d, a, b, x[i +  6], 15, -1560198380);
	            b = md5_ii(b, c, d, a, x[i + 13], 21,  1309151649);
	            a = md5_ii(a, b, c, d, x[i +  4],  6, -145523070);
	            d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
	            c = md5_ii(c, d, a, b, x[i +  2], 15,  718787259);
	            b = md5_ii(b, c, d, a, x[i +  9], 21, -343485551);

	            a = safe_add(a, olda);
	            b = safe_add(b, oldb);
	            c = safe_add(c, oldc);
	            d = safe_add(d, oldd);
	        }
	        return [a, b, c, d];
	    }

	    /*
	    * Convert an array of little-endian words to a string
	    */
	    function binl2rstr(input) {
	        var i,
	            output = '';
	        for (i = 0; i < input.length * 32; i += 8) {
	            output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xFF);
	        }
	        return output;
	    }

	    /*
	    * Convert a raw string to an array of little-endian words
	    * Characters >255 have their high-byte silently ignored.
	    */
	    function rstr2binl(input) {
	        var i,
	            output = [];
	        output[(input.length >> 2) - 1] = undefined;
	        for (i = 0; i < output.length; i += 1) {
	            output[i] = 0;
	        }
	        for (i = 0; i < input.length * 8; i += 8) {
	            output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << (i % 32);
	        }
	        return output;
	    }

	    /*
	    * Calculate the MD5 of a raw string
	    */
	    function rstr_md5(s) {
	        return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
	    }

	    /*
	    * Calculate the HMAC-MD5, of a key and some data (raw strings)
	    */
	    function rstr_hmac_md5(key, data) {
	        var i,
	            bkey = rstr2binl(key),
	            ipad = [],
	            opad = [],
	            hash;
	        ipad[15] = opad[15] = undefined;
	        if (bkey.length > 16) {
	            bkey = binl_md5(bkey, key.length * 8);
	        }
	        for (i = 0; i < 16; i += 1) {
	            ipad[i] = bkey[i] ^ 0x36363636;
	            opad[i] = bkey[i] ^ 0x5C5C5C5C;
	        }
	        hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
	        return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
	    }

	    /*
	    * Convert a raw string to a hex string
	    */
	    function rstr2hex(input) {
	        var hex_tab = '0123456789abcdef',
	            output = '',
	            x,
	            i;
	        for (i = 0; i < input.length; i += 1) {
	            x = input.charCodeAt(i);
	            output += hex_tab.charAt((x >>> 4) & 0x0F) +
	                hex_tab.charAt(x & 0x0F);
	        }
	        return output;
	    }

	    /*
	    * Encode a string as utf-8
	    */
	    function str2rstr_utf8(input) {
	        return unescape(encodeURIComponent(input));
	    }

	    /*
	    * Take string arguments and return either raw or hex encoded strings
	    */
	    function raw_md5(s) {
	        return rstr_md5(str2rstr_utf8(s));
	    }
	    function hex_md5(s) {
	        return rstr2hex(raw_md5(s));
	    }
	    function raw_hmac_md5(k, d) {
	        return rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d));
	    }
	    function hex_hmac_md5(k, d) {
	        return rstr2hex(raw_hmac_md5(k, d));
	    }

	    function md5(string, key, raw) {
	        if (!key) {
	            if (!raw) {
	                return hex_md5(string);
	            }
	            return raw_md5(string);
	        }
	        if (!raw) {
	            return hex_hmac_md5(key, string);
	        }
	        return raw_hmac_md5(key, string);
	    }

	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return md5;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        $.md5 = md5;
	    }
	}(this));

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var golden_ratio_conjugate;

	window.focus_blue = '#2478CC';

	window.logo_red = "#B03A44";

	window.default_avatar_in_histogram_color = '#d3d3d3';

	window.considerit_gray = '#f6f7f9';

	window.parseCssRgb = function(css_color_str) {
	  var rgb, test;
	  test = document.createElement('div');
	  test.style.color = css_color_str;
	  css_color_str = test.style.color;
	  if (css_color_str === 'transparent') {
	    return {
	      r: 0,
	      g: 0,
	      b: 0,
	      a: 0
	    };
	  } else {
	    rgb = /^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+),?\s*([\.\d]+)?\s*\)$/i.exec(css_color_str);
	    if (rgb) {
	      return {
	        r: parseInt(rgb[1]),
	        g: parseInt(rgb[2]),
	        b: parseInt(rgb[3]),
	        a: rgb.length > 4 && (rgb[4] != null) ? parseFloat(rgb[4]) : 1
	      };
	    } else {
	      console.error("Color " + css_color_str + " could not be parsed");
	      return {
	        r: 0,
	        g: 0,
	        b: 0
	      };
	    }
	  }
	};

	window.parseCssHsl = function(css_color_str) {
	  var rgb;
	  rgb = parseCssRgb(css_color_str);
	  return rgb2hsl(rgb);
	};

	window.rgb2hsl = function(rgb) {
	  var b, d, g, h, l, max, min, r, s;
	  r = rgb.r / 255;
	  g = rgb.g / 255;
	  b = rgb.b / 255;
	  max = Math.max(r, g, b);
	  min = Math.min(r, g, b);
	  l = (max + min) / 2;
	  if (max === min) {
	    h = s = 0;
	  } else {
	    d = max - min;
	    s = (l > 0.5 ? d / (2 - max - min) : d / (max + min));
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	    }
	    h /= 6;
	  }
	  return {
	    h: h,
	    s: s,
	    l: l
	  };
	};

	window.hsv2rgb = function(h, s, v) {
	  var b, f, g, h_i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t;
	  h_i = Math.floor(h * 6);
	  f = h * 6 - h_i;
	  p = v * (1 - s);
	  q = v * (1 - f * s);
	  t = v * (1 - (1 - f) * s);
	  if (h_i === 0) {
	    ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
	  }
	  if (h_i === 1) {
	    ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
	  }
	  if (h_i === 2) {
	    ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
	  }
	  if (h_i === 3) {
	    ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
	  }
	  if (h_i === 4) {
	    ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
	  }
	  if (h_i === 5) {
	    ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
	  }
	  return "rgb(" + (Math.round(r * 256)) + ", " + (Math.round(g * 256)) + ", " + (Math.round(b * 256)) + ")";
	};

	window.addOpacity = function(color, opacity) {
	  var c;
	  c = parseCssRgb(color);
	  return "rgba(" + c.r + "," + c.g + "," + c.b + "," + opacity;
	};

	golden_ratio_conjugate = 0.618033988749895;

	window.getNiceRandomHues = function(num, seed) {
	  var h, hues, i;
	  h = seed || .5;
	  hues = [];
	  i = num;
	  while (i > 0) {
	    hues.push(h % 1);
	    h += golden_ratio_conjugate;
	    i -= 1;
	  }
	  return hues;
	};


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var cassowary, debug, dockingStation, realDimensions,
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	__webpack_require__(5);

	__webpack_require__(3);

	cassowary = __webpack_require__(26);

	window.Dock = ReactiveComponent({
	  displayName: 'Dock',
	  render: function() {
	    var dock, positioning_method, ref, style, x, y;
	    dock = fetch(this.key);
	    if (dock.docked) {
	      ref = [dock.x, dock.y], x = ref[0], y = ref[1];
	      positioning_method = browser.is_mobile ? 'absolute' : 'fixed';
	      style = {
	        top: 0,
	        position: positioning_method,
	        WebkitBackfaceVisibility: "hidden",
	        transform: "translate(" + x + "px, " + y + "px)",
	        zIndex: 999999 - this.local.stack_priority,
	        width: '100%'
	      };
	    }
	    return this.transferPropsTo(DIV(null, DIV({
	      style: {
	        height: dock.docked ? this.local.placeholder_height : 0
	      }
	    }), DIV({
	      ref: 'dock_child',
	      style: css.crossbrowserify(style || {})
	    }, this.props.children)));
	  },
	  componentWillMount: function() {
	    var dock;
	    this.key = this.props.key != null ? this.props.key : this.local.key;
	    dock = fetch(this.key, {
	      docked: false,
	      y: void 0,
	      x: void 0
	    });
	    return save(dock);
	  },
	  componentDidMount: function() {
	    var $el, element_height, jut_above, jut_below, last_dom, placeholder_height, ref, serializer;
	    $el = $(this.refs.dock_child.getDOMNode()).children(':visible');
	    this.local.stack_priority = $el.offset().top;
	    placeholder_height = (ref = $el[0].style.position) === 'absolute' || ref === 'fixed' ? 0 : $el.outerHeight();
	    this.local.placeholder_height = placeholder_height;
	    save(this.local);
	    element_height = jut_above = jut_below = last_dom = null;
	    serializer = new XMLSerializer();
	    return dockingStation.register(this.key, (function(_this) {
	      return function() {
	        var base, current_dom, ref1;
	        $el = $(_this.refs.dock_child.getDOMNode()).children(':visible');
	        current_dom = serializer.serializeToString($el[0]) + _this.props.skip_jut;
	        if (current_dom !== last_dom) {
	          ref1 = !_this.props.skip_jut ? realDimensions($el) : [$el.height(), 0, 0], element_height = ref1[0], jut_above = ref1[1], jut_below = ref1[2];
	          last_dom = current_dom;
	        }
	        return {
	          start: _.isFunction(_this.props.start) ? _this.props.start() : $(_this.getDOMNode()).offset().top + (_this.props.start || 0),
	          stop: (typeof (base = _this.props).stop === "function" ? base.stop() : void 0) || Infinity,
	          dock_on_zoom: _this.props.dock_on_zoomed_screens != null ? _this.props.dock_on_zoomed_screens : true,
	          skip_docking: _this.props.dockable && !_this.props.dockable(),
	          stack_priority: _this.local.stack_priority,
	          jut_above: jut_above,
	          height: element_height,
	          constraints: _this.props.constraints || [],
	          docked_key: _this.props.docked_key,
	          offset_parent: browser.is_mobile ? $(_this.getDOMNode()).offsetParent().offset().top : void 0
	        };
	      };
	    })(this));
	  },
	  componentWillUnmount: function() {
	    return dockingStation.unregister(this.key);
	  }
	});

	debug = false;

	dockingStation = {
	  registry: {},
	  listening_to_scroll_events: false,
	  component_history: {},
	  viewport: {},
	  register: function(key, info_callback) {
	    dockingStation.registry[key] = info_callback;
	    dockingStation.component_history[key] = {
	      previous: {},
	      on_dock: {}
	    };
	    if (!dockingStation.listening_to_scroll_events) {
	      $(window).on("scroll.dockingStation", function() {
	        return dockingStation.user_scrolled = true;
	      });
	      $(window).on("resize.dockingStation", dockingStation.onResize);
	      dockingStation.check_resize_interval = setInterval(dockingStation.onCheckStickyResize, 500);
	      dockingStation.listening_to_scroll_events = true;
	      return dockingStation.interval = setInterval(function() {
	        if (dockingStation.user_scrolled) {
	          dockingStation.user_scrolled = false;
	          return dockingStation.onScroll();
	        }
	      }, 100);
	    }
	  },
	  unregister: function(key) {
	    delete dockingStation.registry[key];
	    if (_.keys(dockingStation.registry).length === 0) {
	      $(window).off(".dockingStation");
	      dockingStation.listening_to_scroll_events = false;
	      clearInterval(dockingStation.check_resize_interval);
	      dockingStation.check_resize_interval = null;
	      clearInterval(dockingStation.interval);
	      return dockingStation.interval = null;
	    }
	  },
	  onScroll: function() {
	    var max_change;
	    dockingStation.updateViewport();
	    max_change = dockingStation.viewport.last.top != null ? Math.abs(dockingStation.viewport.top - dockingStation.viewport.last.top) : Infinity;
	    return dockingStation.layout(max_change);
	  },
	  onResize: function() {
	    var max_change;
	    dockingStation.updateViewport();
	    max_change = Math.abs(dockingStation.viewport.height - dockingStation.viewport.last.height);
	    return dockingStation.layout(max_change);
	  },
	  onCheckStickyResize: function() {
	    var dock, height_change, k, ref, results, v;
	    ref = dockingStation.registry;
	    results = [];
	    for (k in ref) {
	      if (!hasProp.call(ref, k)) continue;
	      v = ref[k];
	      dock = fetch(k);
	      if (dock.docked && v().height !== dockingStation.component_history[k].previous.height) {
	        height_change = v().height - dockingStation.component_history[k].previous.height;
	        if (debug) {
	          console.log("HEIGHT RESIZE at most " + height_change);
	        }
	        dockingStation.layout(Math.abs(height_change));
	        break;
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  },
	  updateViewport: function() {
	    return dockingStation.viewport = {
	      last: {
	        top: dockingStation.viewport.top,
	        height: dockingStation.viewport.height
	      },
	      top: document.documentElement.scrollTop || document.body.scrollTop,
	      height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
	    };
	  },
	  layout: function(max_change) {
	    var dock, docked, docks, k, l, len, len1, m, ref, ref1, ref2, undocked, v, x, y, y_pos, y_stack;
	    docks = {};
	    ref = dockingStation.registry;
	    for (k in ref) {
	      if (!hasProp.call(ref, k)) continue;
	      v = ref[k];
	      docks[k] = v();
	      docks[k].key = k;
	    }
	    ref1 = dockingStation.determineIfDocked(docks), docked = ref1[0], undocked = ref1[1], y_stack = ref1[2];
	    for (l = 0, len = undocked.length; l < len; l++) {
	      k = undocked[l];
	      if (fetch(k).docked) {
	        dockingStation.toggleDocked(k, docks[k]);
	      }
	    }
	    if (docked.length > 0) {
	      y_pos = dockingStation.solveForY(docked, docks, max_change);
	      for (m = 0, len1 = docked.length; m < len1; m++) {
	        k = docked[m];
	        dock = fetch(k);
	        dockingStation.component_history[k].previous = _.extend(docks[k], {
	          calculated_y: y_pos[k].value
	        });
	        ref2 = dockingStation.adjustForDevice(y_pos[k].value, docks[k]), x = ref2[0], y = ref2[1];
	        if (dock.y !== y || dock.x !== x) {
	          if (debug) {
	            console.log("UPDATING " + dock.key);
	          }
	          dock.y = y;
	          dock.x = x;
	          if (!dock.docked) {
	            dockingStation.toggleDocked(k, docks[k]);
	          }
	          save(dock);
	        }
	      }
	      docks = fetch('docking_station');
	      if (docks.y_stack !== y_stack) {
	        docks.y_stack = y_stack;
	        return save(docks);
	      }
	    }
	  },
	  determineIfDocked: function(docks) {
	    var dimensions, docked, is_docked, l, len, sorted, undocked, v, y_stack, zoomed_or_small;
	    docked = [];
	    undocked = [];
	    zoomed_or_small = window.innerWidth / $(window).width() < .95 || screen.width <= 700;
	    sorted = _.sortBy(_.values(docks), function(v) {
	      return v.stack_priority;
	    });
	    y_stack = 0;
	    for (l = 0, len = sorted.length; l < len; l++) {
	      v = sorted[l];
	      if (v.skip_docking || (!v.dock_on_zoom && zoomed_or_small)) {
	        is_docked = false;
	      } else {
	        dimensions = fetch(v.key).docked ? dockingStation.component_history[v.key].on_dock : {
	          height: v.height,
	          jut_above: v.jut_above
	        };
	        is_docked = dockingStation.viewport.top + y_stack + dimensions.jut_above >= v.start;
	      }
	      if (is_docked) {
	        y_stack += dimensions.height;
	        docked.push(v.key);
	      } else {
	        undocked.push(v.key);
	      }
	    }
	    return [docked, undocked, y_stack];
	  },
	  toggleDocked: function(k, v) {
	    var dock, external_docked, is_docked;
	    dock = fetch(k);
	    is_docked = !dock.docked;
	    dock.docked = is_docked;
	    if (!is_docked) {
	      dock.y = dock.x = null;
	      dockingStation.component_history[k].previous = {};
	    } else {
	      dockingStation.component_history[k].on_dock = v;
	    }
	    save(dock);
	    if (v.docked_key != null) {
	      external_docked = fetch(v.docked_key);
	      external_docked.docked = is_docked;
	      save(external_docked);
	    }
	    if (debug) {
	      return console.log("Toggled " + k + " to " + dock.docked);
	    }
	  },
	  solveForY: function(docked, docks, max_change) {
	    var c, dock, i, j, k, l, len, len1, len2, m, n, previous_calculated_y, scroll_distance, sk, solver, sorted, sv, v, y_pos, y_stack;
	    c = cassowary;
	    solver = new c.SimplexSolver();
	    scroll_distance = Math.abs(dockingStation.viewport.top - dockingStation.viewport.last.top);
	    if (scroll_distance > 0) {
	      dockingStation.scrolling_down = dockingStation.viewport.top > dockingStation.viewport.last.top;
	    }
	    if (debug) {
	      console.log("viewport height: ", dockingStation.viewport.height);
	    }
	    y_stack = 0;
	    sorted = (function() {
	      var results;
	      results = [];
	      for (k in docks) {
	        if (!hasProp.call(docks, k)) continue;
	        v = docks[k];
	        if (indexOf.call(docked, k) >= 0) {
	          results.push(v);
	        }
	      }
	      return results;
	    })();
	    sorted = _.sortBy(sorted, function(v) {
	      return v.stack_priority;
	    });
	    y_pos = {};
	    for (l = 0, len = sorted.length; l < len; l++) {
	      v = sorted[l];
	      y_pos[v.key] = new c.Variable;
	    }
	    for (i = m = 0, len1 = sorted.length; m < len1; i = ++m) {
	      v = sorted[i];
	      if (debug) {
	        console.log("**" + v.key + " constraints**");
	      }
	      k = v.key;
	      dock = fetch(k);
	      previous_calculated_y = dockingStation.component_history[k].previous.calculated_y;
	      if (debug) {
	        console.log("\tSTART: " + k + " >= " + v.start + ", strong");
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, v.start, c.Strength.strong));
	      if (v.stop !== Infinity) {
	        if (debug) {
	          console.log("\tSTOP: " + k + " <= " + v.stop + " - " + v.height + ", strong");
	        }
	        solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, v.stop - v.height, c.Strength.strong));
	      }
	      if ((max_change != null) && (previous_calculated_y != null)) {
	        if (debug) {
	          console.log("\tBOUNDED BY MAX CHANGE: |" + k + " - " + previous_calculated_y + "| <= " + max_change + ", strong");
	        }
	        solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, previous_calculated_y + max_change, c.Strength.strong));
	        solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, previous_calculated_y - max_change, c.Strength.strong));
	      }
	      if (debug) {
	        console.log("\tTOP OF COMPONENT VISIBLE: \n" + k + " >= " + dockingStation.viewport.top + " + " + v.jut_above + " + " + y_stack + ", \n" + (dockingStation.scrolling_down ? 'weak' : 'medium'));
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, dockingStation.viewport.top + v.jut_above + y_stack, dockingStation.scrolling_down ? c.Strength.weak : c.Strength.medium));
	      y_stack += v.height;
	      if (debug) {
	        console.log("\tBOTTOM OF COMPONENT VISIBLE: \n" + k + " + " + v.height + " <= " + dockingStation.viewport.top + " + " + dockingStation.viewport.height + ", \n" + (dockingStation.scrolling_down ? 'medium' : 'weak'));
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, dockingStation.viewport.top + dockingStation.viewport.height - v.height, dockingStation.scrolling_down ? c.Strength.medium : c.Strength.weak));
	      for (j = n = 0, len2 = sorted.length; n < len2; j = ++n) {
	        sv = sorted[j];
	        sk = sv.key;
	        if (j < i && indexOf.call(v.constraints, sk) >= 0) {
	          if (debug) {
	            console.log("\tRELATIONAL: \n" + k + " >= " + sk + " + " + sv.height + " + " + v.jut_above + " - " + sv.jut_above + "}, required");
	          }
	          solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, c.plus(y_pos[sk], sv.height + v.jut_above - sv.jut_above), c.Strength.required));
	          solver.addConstraint(new c.Equation(y_pos[k], c.plus(y_pos[sk], sv.height + v.jut_above - sv.jut_above), c.Strength.strong));
	        }
	      }
	    }
	    solver.resolve();
	    if (debug) {
	      for (k in y_pos) {
	        if (!hasProp.call(y_pos, k)) continue;
	        v = y_pos[k];
	        console.info(k + ": " + v.value);
	      }
	    }
	    return y_pos;
	  },
	  adjustForDevice: function(y, v) {
	    var x;
	    if (browser.is_mobile) {
	      y -= v.offset_parent;
	      x = 0;
	    } else {
	      y -= dockingStation.viewport.top;
	      x = -$(window).scrollLeft();
	    }
	    return [x, y];
	  },
	  initialize: function() {
	    return dockingStation.updateViewport();
	  }
	};

	dockingStation.initialize();

	realDimensions = function($el) {
	  var jut_above, jut_below, max_top, min_top, offset, recurse, ref, tar;
	  tar = $el.is('.opinion_region');
	  recurse = function($e, min_top, max_top) {
	    var child, h, l, len, ref, ref1, t;
	    t = $e.offset().top;
	    h = $e.height();
	    if (h === 0 || $e[0].style.display === 'none') {
	      return [min_top, max_top];
	    }
	    if (min_top > t) {
	      min_top = t;
	    }
	    if (t + h > max_top) {
	      max_top = t + h;
	    }
	    ref = $e.children();
	    for (l = 0, len = ref.length; l < len; l++) {
	      child = ref[l];
	      ref1 = recurse($(child), min_top, max_top), min_top = ref1[0], max_top = ref1[1];
	    }
	    return [min_top, max_top];
	  };
	  ref = recurse($el, Infinity, 0), min_top = ref[0], max_top = ref[1];
	  offset = $el.offset().top;
	  jut_above = offset - min_top;
	  jut_below = max_top - (offset + $el.height());
	  return [max_top - min_top, jut_above, jut_below];
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {window.ProfileMenu = ReactiveComponent({
	  displayName: 'ProfileMenu',
	  render: function() {
	    var current_user, dd, hsl, is_admin, is_evaluator, is_moderator, light_background, menu_options, mm, option, ref, ref1, subdomain, today, yyyy;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    is_evaluator = subdomain.assessment_enabled && current_user.is_evaluator;
	    is_admin = current_user.is_admin;
	    is_moderator = current_user.is_moderator;
	    menu_options = [
	      {
	        href: '/edit_profile',
	        label: t('Edit Profile')
	      }, {
	        href: '/dashboard/email_notifications',
	        label: t('Email Settings')
	      }, is_admin ? {
	        href: '/dashboard/import_data',
	        label: 'Import Data'
	      } : null, is_admin ? {
	        href: '/dashboard/application',
	        label: 'App Settings'
	      } : null, is_admin ? {
	        href: '/dashboard/roles',
	        label: 'User Roles'
	      } : null, is_admin ? {
	        href: '/dashboard/tags',
	        label: 'User Tags'
	      } : null, is_moderator ? {
	        href: '/dashboard/moderate',
	        label: 'Moderate'
	      } : null, is_evaluator ? {
	        href: '/dashboard/assessment',
	        label: 'Fact-check'
	      } : null
	    ];
	    menu_options = _.compact(menu_options);
	    hsl = parseCssHsl(subdomain.branding.primary_color);
	    light_background = hsl.l > .75;
	    return DIV({
	      id: 'user_nav',
	      style: _.extend({
	        position: 'absolute',
	        zIndex: 5,
	        right: 30,
	        fontSize: 26,
	        top: 17
	      }, _.clone(this.props.style))
	    }, current_user.logged_in ? DIV(null, ((ref = subdomain.name) === 'bitcoin' || ref === 'bitcoinclassic') && current_user.logged_in && ((current_user.tags['verified'] == null) || ((ref1 = current_user.tags['verified']) === 'no' || ref1 === 'false')) ? DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 10,
	        left: -315
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.show_verify = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.show_verify = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, DIV({
	      style: {
	        backgroundColor: focus_blue,
	        color: 'white',
	        fontWeight: 600,
	        padding: '4px 12px',
	        fontSize: 21,
	        borderRadius: !this.local.show_verify ? 8 : void 0,
	        position: 'relative',
	        cursor: 'pointer'
	      }
	    }, SPAN({
	      style: cssTriangle('right', focus_blue, 10, 12, {
	        position: 'absolute',
	        right: -10,
	        top: 12
	      })
	    }), 'Please verify you are human!'), this.local.show_verify ? (today = new Date(), dd = today.getDate(), mm = today.getMonth() + 1, yyyy = today.getFullYear(), dd < 10 ? dd = '0' + dd : void 0, mm < 10 ? mm = '0' + mm : void 0, today = yyyy + '/' + mm + '/' + dd, DIV({
	      style: {
	        width: 650,
	        position: 'absolute',
	        right: 0,
	        zIndex: 999,
	        padding: 40,
	        backgroundColor: 'white',
	        boxShadow: '0 1px 2px rgba(0,0,0,.3)',
	        fontSize: 21
	      }
	    }, DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "To verify you are human, write on a piece of paper:"), DIV({
	      style: {
	        marginBottom: 20,
	        marginLeft: 50
	      }
	    }, current_user.name, BR(null), "bitcoin.consider.it", BR(null), today), DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "Then take a photo of yourself with it, and email the photo to ", A({
	      href: 'mailto:verify@consider.it',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'verify@consider.it'), ". This photo will be publicly visible proof that you are real!"), DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "Yours,", BR(null), "The Admins"), IMG({
	      src: asset('bitcoin/verify example.jpg'),
	      style: {
	        width: 570
	      }
	    }), IMG({
	      src: asset('bitcoin/verification-travis.jpg'),
	      style: {
	        width: 570
	      }
	    }), IMG({
	      src: asset('bitcoin/KevinBitcoin.jpg'),
	      style: {
	        width: 570
	      }
	    }))) : void 0) : void 0, SPAN({
	      className: 'profile_menu_wrap',
	      style: {
	        position: 'relative'
	      },
	      onTouchEnd: (function(_this) {
	        return function() {
	          _this.local.menu = !_this.local.menu;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.menu = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.menu = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, DIV({
	      style: {
	        display: !this.local.menu ? 'none' : void 0,
	        position: 'absolute',
	        marginTop: -8,
	        marginLeft: -8,
	        padding: 8,
	        paddingTop: 70,
	        paddingRight: 14,
	        backgroundColor: '#eee',
	        right: 0,
	        textAlign: 'right',
	        zIndex: 999999
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = menu_options.length; i < len; i++) {
	        option = menu_options[i];
	        results.push(A({
	          className: 'menu_link',
	          href: option.href,
	          key: option.href
	        }, option.label));
	      }
	      return results;
	    })(), A({
	      'data-action': 'logout',
	      className: 'menu_link',
	      onClick: logout,
	      onTouchEnd: logout
	    }, t('Log out'))), SPAN({
	      style: {
	        color: !light_background ? 'white' : void 0,
	        position: 'relative',
	        zIndex: 9999999999,
	        backgroundColor: !this.local.menu ? 'rgba(255,255,255, .1)' : void 0,
	        boxShadow: !this.local.menu ? '0px 1px 1px rgba(0,0,0,.1)' : void 0,
	        borderRadius: 8,
	        padding: '3px 4px'
	      }
	    }, Avatar({
	      key: current_user.user,
	      hide_tooltip: true,
	      className: 'userbar_avatar',
	      style: {
	        height: 35,
	        width: 35,
	        marginRight: 7,
	        marginTop: 1
	      }
	    }), I({
	      className: 'fa fa-caret-down',
	      style: {
	        visibility: this.local.menu ? 'hidden' : void 0
	      }
	    })))) : A({
	      className: 'profile_anchor login',
	      'data-action': 'login',
	      onClick: (function(_this) {
	        return function(e) {
	          return reset_key('auth', {
	            form: 'login',
	            ask_questions: true
	          });
	        };
	      })(this),
	      style: {
	        color: !light_background ? 'white' : void 0
	      }
	    }, t('Log in')));
	  }
	});

	styles += ".profile_navigation {\n  text-align: right;\n  width: 100%;\n  padding: 20px 120px 0 0;\n  font-size: 21px; }\n\n.menu_link {\n  position: relative;\n  bottom: 8px;\n  padding-left: 27px;\n  display: block;\n  color: " + focus_blue + ";\n  white-space: nowrap; }\n\n.menu_link:hover{ color: black; }\n\n.profile_menu_wrap:hover .profile_anchor{ color: inherit; }";

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Quill;

	__webpack_require__(3);

	__webpack_require__(13);

	window.Button = function(props, text, callback) {
	  var style;
	  style = {
	    backgroundColor: focus_blue,
	    borderRadius: 8,
	    color: 'white',
	    padding: '3px 10px',
	    display: 'inline-block',
	    fontWeight: 600,
	    textAlign: 'center',
	    cursor: 'pointer'
	  };
	  props.style = _.extend(style, props.style || {});
	  props.onClick = callback;
	  return DIV(props, text);
	};

	window.AutoGrowTextArea = ReactiveComponent({
	  displayName: 'AutoGrowTextArea',
	  onChange: function(e) {
	    var base;
	    if (typeof (base = this.props).onChange === "function") {
	      base.onChange(e);
	    }
	    return this.checkAndSetHeight();
	  },
	  componentDidMount: function() {
	    return this.checkAndSetHeight();
	  },
	  componentDidUpdate: function() {
	    return this.checkAndSetHeight();
	  },
	  checkAndSetHeight: function() {
	    var h, max_height, scroll_height;
	    scroll_height = this.getDOMNode().scrollHeight;
	    max_height = this.props.max_height || 600;
	    if (scroll_height > this.getDOMNode().clientHeight) {
	      h = Math.min(scroll_height + 5, max_height);
	      if (h !== this.local.height) {
	        this.local.height = h;
	        if (this.props.onHeightChange) {
	          this.props.onHeightChange();
	        }
	        return save(this.local);
	      }
	    }
	  },
	  render: function() {
	    if (!this.local.height) {
	      this.local.height = this.props.min_height;
	    }
	    return this.transferPropsTo(TEXTAREA({
	      onChange: this.onChange,
	      style: _.extend(this.props.style || {}, {
	        height: this.local.height,
	        padding: '4px 8px'
	      })
	    }));
	  }
	});

	window.CharacterCountTextInput = ReactiveComponent({
	  displayName: 'CharacterCountTextInput',
	  render: function() {
	    var class_name, count_style;
	    if (this.local.count == null) {
	      this.local.count = (this.props.defaultValue || "").length;
	    }
	    count_style = this.props.count_style || {};
	    class_name = "is_counted";
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, SPAN({
	      style: count_style
	    }, this.props.maxLength - this.local.count), this.transferPropsTo(TEXTAREA({
	      className: class_name,
	      onChange: (function(_this) {
	        return function() {
	          _this.local.count = $(_this.getDOMNode()).find('textarea').val().length;
	          return save(_this.local);
	        };
	      })(this)
	    })));
	  }
	});

	Quill = __webpack_require__(39);

	window.WysiwygEditor = ReactiveComponent({
	  displayName: 'WysiwygEditor',
	  render: function() {
	    var button, my_data, ref, show_placeholder, subdomain, toolbar_items, wysiwyg_editor;
	    my_data = fetch(this.props.key);
	    subdomain = fetch('/subdomain');
	    wysiwyg_editor = fetch('wysiwyg_editor');
	    if (!this.local.initialized) {
	      my_data.html = this.props.html;
	      this.local.initialized = true;
	      save(this.local);
	      save(my_data);
	    }
	    show_placeholder = (!my_data.html || (((ref = this.editor) != null ? ref.getText().trim().length : void 0) === 0)) && !!this.props.placeholder;
	    toolbar_items = [
	      {
	        className: "ql-bullet fa fa-list-ul",
	        title: 'Bulleted list'
	      }, {
	        className: "ql-list fa fa-list-ol",
	        title: 'Numbered list'
	      }, {
	        className: "ql-bold fa fa-bold",
	        title: 'Bold selected text'
	      }, {
	        className: "ql-link fa fa-link",
	        title: 'Hyperlink selected text'
	      }
	    ];
	    if (fetch('/current_user').is_admin) {
	      toolbar_items.push({
	        className: 'fa fa-code',
	        title: 'Directly edit HTML',
	        onClick: (function(_this) {
	          return function() {
	            _this.local.edit_code = true;
	            return save(_this.local);
	          };
	        })(this)
	      });
	    }
	    return DIV({
	      id: this.props.key,
	      style: {
	        position: 'relative'
	      },
	      onClick: function(ev) {
	        return ev.stopPropagation();
	      }
	    }, this.local.edit_code ? AutoGrowTextArea({
	      style: {
	        width: '100%',
	        fontSize: 18
	      },
	      defaultValue: fetch(this.props.key).html,
	      onChange: (function(_this) {
	        return function(e) {
	          my_data = fetch(_this.props.key);
	          my_data.html = e.target.value;
	          return save(my_data);
	        };
	      })(this)
	    }) : DIV(null, Dock({
	      dock_on_zoomed_screens: true,
	      skip_jut: true,
	      dummy: wysiwyg_editor.showing
	    }, DIV({
	      id: 'toolbar',
	      style: {
	        position: 'absolute',
	        width: 30,
	        left: -32,
	        top: 0,
	        display: 'block',
	        visibility: wysiwyg_editor.showing !== this.props.key ? 'hidden' : void 0
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = toolbar_items.length; i < len; i++) {
	        button = toolbar_items[i];
	        results.push(I({
	          className: button.className,
	          style: {
	            fontSize: 14,
	            width: 28,
	            textAlign: 'center',
	            cursor: 'pointer',
	            padding: 2,
	            border: '1px solid #aaa',
	            borderRadius: 3
	          },
	          title: button.title,
	          onClick: button.onClick ? button.onClick : void 0
	        }));
	      }
	      return results;
	    })())), DIV({
	      style: this.props.container_style
	    }, DIV({
	      id: 'editor',
	      dangerouslySetInnerHTML: {
	        __html: this.props.html
	      },
	      'data-placeholder': show_placeholder ? this.props.placeholder : '',
	      onFocus: (function(_this) {
	        return function() {
	          wysiwyg_editor = fetch('wysiwyg_editor');
	          wysiwyg_editor.showing = _this.props.key;
	          return save(wysiwyg_editor);
	        };
	      })(this),
	      style: this.props.style
	    }))));
	  },
	  componentDidMount: function() {
	    this.editor = new Quill($(this.getDOMNode()).find('#editor')[0], {
	      modules: {
	        toolbar: {
	          container: $(this.getDOMNode()).find('#toolbar')[0]
	        },
	        'link-tooltip': true,
	        'image-tooltip': true
	      },
	      styles: true
	    });
	    return this.editor.on('text-change', (function(_this) {
	      return function(delta, source) {
	        var my_data, node, removeStyles;
	        my_data = fetch(_this.props.key);
	        my_data.html = _this.editor.getHTML();
	        if (source === 'user' && my_data.html.indexOf(' style') > -1) {
	          removeStyles = function(el) {
	            var child, i, len, ref, results;
	            el.removeAttribute('style');
	            if (el.childNodes.length > 0) {
	              ref = el.childNodes;
	              results = [];
	              for (i = 0, len = ref.length; i < len; i++) {
	                child = ref[i];
	                if (child.nodeType === 1) {
	                  results.push(removeStyles(child));
	                } else {
	                  results.push(void 0);
	                }
	              }
	              return results;
	            }
	          };
	          node = _this.editor.root;
	          removeStyles(node);
	          my_data.html = _this.editor.getHTML();
	        }
	        return save(my_data);
	      };
	    })(this));
	  }
	});

	styles += "html .ql-container{\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  padding: 0;\n  overflow-x: visible;\n  overflow-y: visible;\n}\n.ql-editor {\n  min-height: 120px;\n}\n.ql-container:after{\n  content: attr(data-placeholder);\n  left: 0;\n  top: 0;\n  position: absolute;\n  color: #aaa;\n  pointer-events: none;\n  z-index: 1;\n}";

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var calculateAvatarRadius, histo_queue, histo_run_next_job, histo_running, layoutAvatars, md5, positionAvatars;

	__webpack_require__(5);

	md5 = __webpack_require__(11);

	__webpack_require__(19);

	__webpack_require__(3);

	window.Histogram = ReactiveComponent({
	  displayName: 'Histogram',
	  render: function() {
	    var avatar_radius, base, dirtied, draw_selection_area, filter_out, hist, histocache_key, histogram_props, proposal, ref, ref1, region_selection_vertical_padding;
	    hist = fetch(this.props.key);
	    filter_out = fetch('filtered');
	    dirtied = false;
	    if (!hist.initialized) {
	      _.defaults(hist, {
	        initialized: true,
	        highlighted_users: null,
	        region_selection_width: .25,
	        selected_opinion: null,
	        selected_opinions: null
	      });
	      save(hist);
	      dirtied = true;
	    }
	    avatar_radius = calculateAvatarRadius(this.props.width, this.props.height, this.props.opinions);
	    if (this.local.avatar_size !== avatar_radius * 2) {
	      this.local.avatar_size = avatar_radius * 2;
	      save(this.local);
	      dirtied = true;
	    }
	    proposal = fetch(this.props.proposal);
	    histocache_key = this.histocache_key();
	    if ((ref = proposal.histocache) != null ? ref[histocache_key] : void 0) {
	      if (histocache_key !== ((ref1 = this.local.histocache) != null ? ref1.hash : void 0)) {
	        this.local.histocache = {
	          hash: histocache_key,
	          positions: proposal.histocache[histocache_key]
	        };
	        save(this.local);
	        dirtied = true;
	      }
	    }
	    this.local.dirty === dirtied;
	    if (dirtied) {
	      return SPAN(null);
	    }
	    if (!this.props.draw_base) {
	      this.props.draw_base_labels = false;
	    } else if (this.props.draw_base_labels == null) {
	      this.props.draw_base_labels = true;
	    }
	    (base = this.props).enable_selection && (base.enable_selection = this.props.opinions.length > 0);
	    region_selection_vertical_padding = this.props.enable_selection ? 30 : 0;
	    if (this.local.region_selection_vertical_padding !== region_selection_vertical_padding) {
	      this.local.region_selection_vertical_padding = region_selection_vertical_padding;
	    }
	    draw_selection_area = this.props.enable_selection && !hist.selected_opinion && !this.props.backgrounded && (hist.selected_opinions || (!this.local.touched && this.local.mouse_opinion_value && !this.local.hoving_over_avatar));
	    histogram_props = {
	      className: 'histogram',
	      style: css.crossbrowserify({
	        width: this.props.width,
	        height: this.props.height + this.local.region_selection_vertical_padding,
	        position: 'relative',
	        borderBottom: this.props.draw_base ? '1px solid #999' : void 0,
	        userSelect: 'none'
	      })
	    };
	    if (this.props.enable_selection) {
	      if (!browser.is_mobile) {
	        _.extend(histogram_props, {
	          onClick: this.onClick,
	          onMouseMove: this.onMouseMove,
	          onMouseLeave: this.onMouseLeave,
	          onMouseUp: this.onMouseUp,
	          onMouseDown: this.onMouseDown
	        });
	      } else {
	        _.extend(histogram_props, {
	          onTouchStart: (function(_this) {
	            return function(ev) {
	              var curr_time;
	              curr_time = new Date().getTime();
	              if (_this.local.last_tapped_at && curr_time - _this.local.last_tapped_at < 300) {
	                ev.preventDefault();
	                _this.local.touched = true;
	                save(_this.local);
	                return _this.onClick(ev);
	              } else {
	                _this.local.last_tapped_at = curr_time;
	                return save(_this.local);
	              }
	            };
	          })(this),
	          onTouchMove: (function(_this) {
	            return function(ev) {
	              ev.preventDefault();
	              return _this.onMouseMove(ev);
	            };
	          })(this),
	          onTouchEnd: (function(_this) {
	            return function(ev) {
	              var curr_time;
	              curr_time = new Date().getTime();
	              if (_this.local.last_tapped_at && curr_time - _this.local.last_tapped_at < 300) {
	                ev.preventDefault();
	                return _this.onMouseUp(ev);
	              } else {
	                _this.local.last_tapped_at = curr_time;
	                return save(_this.local);
	              }
	            };
	          })(this),
	          onTouchCancel: (function(_this) {
	            return function(ev) {
	              ev.preventDefault();
	              return _this.onMouseUp(ev);
	            };
	          })(this)
	        });
	      }
	    }
	    return DIV(histogram_props, this.props.draw_base_labels ? this.drawHistogramBase() : void 0, this.props.enable_selection ? DIV({
	      style: {
	        height: this.local.region_selection_vertical_padding
	      }
	    }) : void 0, draw_selection_area ? this.drawSelectionArea() : void 0, this.drawAvatars());
	  },
	  drawHistogramBase: function() {
	    return [
	      SPAN({
	        style: {
	          position: 'absolute',
	          left: 0,
	          bottom: -21,
	          fontSize: 14,
	          fontWeight: 400,
	          color: '#999'
	        }
	      }, customization("slider_pole_labels.group.oppose", this.props.proposal)), SPAN({
	        style: {
	          position: 'absolute',
	          right: 0,
	          bottom: -21,
	          fontSize: 14,
	          fontWeight: 400,
	          color: '#999'
	        }
	      }, customization("slider_pole_labels.group.support", this.props.proposal))
	    ];
	  },
	  drawSelectionArea: function() {
	    var anchor, base_width, hist, left, selection_left, selection_width;
	    hist = fetch(this.props.key);
	    anchor = hist.selected_opinion_value || this.local.mouse_opinion_value;
	    left = ((anchor + 1) / 2 - hist.region_selection_width / 2) * this.props.width;
	    base_width = hist.region_selection_width * this.props.width;
	    selection_width = Math.min(Math.min(base_width, base_width + left), this.props.width - left);
	    selection_left = Math.max(0, left);
	    return DIV(null, hist.selected_opinions ? DIV({
	      className: 'selection_region_resizer',
	      style: {
	        borderBottom: "3px solid " + focus_blue,
	        height: 15,
	        width: selection_width,
	        position: 'absolute',
	        left: selection_left,
	        top: -15,
	        cursor: 'col-resize'
	      }
	    }) : void 0, DIV({
	      style: {
	        height: this.props.height + this.local.region_selection_vertical_padding,
	        position: 'absolute',
	        width: selection_width,
	        backgroundColor: "rgb(246, 247, 249)",
	        cursor: 'pointer',
	        left: selection_left,
	        top: 0
	      }
	    }, !hist.selected_opinions ? DIV({
	      style: css.crossbrowserify({
	        fontSize: 12,
	        textAlign: 'center',
	        whiteSpace: 'nowrap',
	        marginTop: -18,
	        userSelect: 'none',
	        pointerEvents: 'none'
	      })
	    }, t('select_these_opinions')) : void 0));
	  },
	  drawAvatars: function() {
	    var avatar_style, backgrounded_page_avatar_style, filter_out, highlighted_users, hist, o, opinion, pos, regular_avatar_style, selected_avatar_style, selected_users, unselected_avatar_style, user;
	    hist = fetch(this.props.key);
	    filter_out = fetch('filtered');
	    highlighted_users = hist.highlighted_users;
	    selected_users = hist.selected_opinion ? [hist.selected_opinion] : hist.selected_opinions;
	    if (selected_users) {
	      if (highlighted_users) {
	        highlighted_users = _.intersection(highlighted_users, (function() {
	          var j, len, results;
	          results = [];
	          for (j = 0, len = selected_users.length; j < len; j++) {
	            o = selected_users[j];
	            results.push(fetch(o).user);
	          }
	          return results;
	        })());
	      } else {
	        highlighted_users = (function() {
	          var j, len, results;
	          results = [];
	          for (j = 0, len = selected_users.length; j < len; j++) {
	            o = selected_users[j];
	            results.push(fetch(o).user);
	          }
	          return results;
	        })();
	      }
	    }
	    regular_avatar_style = {
	      width: this.local.avatar_size,
	      height: this.local.avatar_size,
	      position: 'absolute',
	      cursor: this.props.enable_selection ? 'pointer' : 'auto'
	    };
	    selected_avatar_style = _.extend({}, regular_avatar_style, {
	      zIndex: 9,
	      backgroundColor: focus_blue
	    });
	    css.crossbrowserify(selected_avatar_style);
	    unselected_avatar_style = _.extend({}, regular_avatar_style, {
	      opacity: .2
	    });
	    backgrounded_page_avatar_style = _.extend({}, unselected_avatar_style, {
	      opacity: customization('show_histogram_on_crafting') ? .1 : 0.0
	    });
	    return DIV({
	      key: this.histocache_key(),
	      ref: 'histo',
	      style: {
	        height: this.props.height,
	        position: 'relative',
	        top: -1,
	        cursor: !this.props.backgrounded && this.props.enable_selection ? 'pointer' : void 0
	      }
	    }, (function() {
	      var j, len, ref, ref1, ref2, ref3, results;
	      ref = this.props.opinions;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        opinion = ref[j];
	        user = opinion.user;
	        if ((ref1 = filter_out.users) != null ? ref1[user] : void 0) {
	          continue;
	        }
	        o = fetch(opinion);
	        if (this.props.backgrounded) {
	          avatar_style = fetch('/current_user').user === user ? _.extend({}, regular_avatar_style, {
	            opacity: .25
	          }) : backgrounded_page_avatar_style;
	        } else if (highlighted_users) {
	          if (_.contains(highlighted_users, opinion.user)) {
	            avatar_style = selected_avatar_style;
	          } else {
	            avatar_style = unselected_avatar_style;
	          }
	        } else {
	          avatar_style = regular_avatar_style;
	        }
	        pos = (ref2 = this.local.histocache) != null ? (ref3 = ref2.positions) != null ? ref3[(user.key || user).split('/user/')[1]] : void 0 : void 0;
	        results.push(avatar(user, {
	          hide_tooltip: this.props.backgrounded,
	          style: _.extend({}, avatar_style, {
	            left: pos != null ? pos[0] : void 0,
	            top: pos != null ? pos[1] : void 0
	          })
	        }));
	      }
	      return results;
	    }).call(this));
	  },
	  onClick: function(ev) {
	    var has_selection, hist, is_clicking_user, is_deselection, max, min, user_key, user_opinion;
	    ev.stopPropagation();
	    hist = fetch(this.props.key);
	    if (this.props.backgrounded) {
	      if (this.props.on_click_when_backgrounded) {
	        return this.props.on_click_when_backgrounded();
	      }
	    } else {
	      if (ev.type === 'touchstart') {
	        this.local.mouse_opinion_value = this.getOpinionValueAtFocus(ev);
	      }
	      is_clicking_user = ev.target.className.indexOf('avatar') !== -1;
	      if (is_clicking_user) {
	        user_key = "/user/" + ev.target.getAttribute('id').substring(7, ev.target.getAttribute('id').length);
	        user_opinion = _.findWhere(this.props.opinions, {
	          user: user_key
	        });
	        is_deselection = hist.selected_opinion === user_opinion.key && !this.local.last_selection_via_drag;
	        if (is_deselection) {
	          hist.selected_opinion = null;
	        } else {
	          hist.selected_opinion = user_opinion.key;
	          hist.selected_opinions = null;
	        }
	      } else {
	        max = hist.selected_opinion_value + hist.region_selection_width;
	        min = hist.selected_opinion_value - hist.region_selection_width;
	        is_deselection = hist.selected_opinions && !this.local.last_selection_via_drag && (!this.local.touched || inRange(this.local.mouse_opinion_value, min, max));
	        if (is_deselection) {
	          hist.selected_opinions = null;
	          if (ev.type === 'touchstart') {
	            this.local.mouse_opinion_value = null;
	          }
	        } else {
	          hist.selected_opinion = null;
	          hist.selected_opinions = this.getOpinionsInCurrentRegion();
	        }
	      }
	      has_selection = hist.selected_opinion || hist.selected_opinions;
	      hist.selected_opinion_value = !has_selection ? null : !is_clicking_user ? this.local.mouse_opinion_value : user_opinion.stance;
	      this.local.last_selection_via_drag = false;
	      save(hist);
	      return save(this.local);
	    }
	  },
	  getOpinionValueAtFocus: function(ev) {
	    var h_w, h_x, m_x;
	    h_x = this.getDOMNode().getBoundingClientRect().left + window.pageXOffset;
	    h_w = this.getDOMNode().offsetWidth;
	    m_x = ev.pageX || ev.touches[0].pageX;
	    return translatePixelXToStance(m_x - h_x, h_w);
	  },
	  onMouseMove: function(ev) {
	    var change_in_selection_region, h_w, hist, mouse_x;
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving) {
	      return;
	    }
	    if (this.props.enable_selection && !this.props.backgrounded) {
	      hist = fetch(this.props.key);
	      ev.stopPropagation();
	      if (hist.dragging) {
	        h_w = this.getDOMNode().offsetWidth;
	        mouse_x = ev.pageX;
	        change_in_selection_region = 2 * (mouse_x - this.local.mouse_x_of_last_resize) / h_w;
	        hist.region_selection_width += change_in_selection_region;
	        hist.region_selection_width = Math.min(1, Math.max(.03, hist.region_selection_width));
	        this.local.mouse_x_of_last_resize = mouse_x;
	        this.local.last_selection_via_drag = true;
	        save(this.local);
	        return save(hist);
	      } else if ($(ev.target).closest('.selection_region_resizer').length === 0) {
	        this.local.hoving_over_avatar = ev.target.className.indexOf('avatar') !== -1;
	        this.local.mouse_opinion_value = this.getOpinionValueAtFocus(ev);
	        if (this.local.mouse_opinion_value + hist.region_selection_width >= 1) {
	          this.local.mouse_opinion_value = 1 - hist.region_selection_width;
	        } else if (this.local.mouse_opinion_value - hist.region_selection_width <= -1) {
	          this.local.mouse_opinion_value = -1 + hist.region_selection_width;
	        }
	        if (hist.selected_opinions && this.local.mouse_opinion_value) {
	          hist.selected_opinions = this.getOpinionsInCurrentRegion();
	          hist.selected_opinion_value = this.local.mouse_opinion_value;
	          save(hist);
	        }
	        return save(this.local);
	      }
	    }
	  },
	  onMouseLeave: function(ev) {
	    var hist;
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving) {
	      return;
	    }
	    this.local.mouse_opinion_value = null;
	    save(this.local);
	    hist = fetch(this.props.key);
	    if (hist.dragging) {
	      hist.dragging = false;
	      return save(hist);
	    }
	  },
	  onMouseUp: function(ev) {
	    var hist;
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving) {
	      return;
	    }
	    hist = fetch(this.props.key);
	    if (hist.dragging) {
	      hist.dragging = false;
	      return save(hist);
	    }
	  },
	  onMouseDown: function(ev) {
	    var hist;
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving) {
	      return;
	    }
	    ev.stopPropagation();
	    hist = fetch(this.props.key);
	    if ($(ev.target).closest('.selection_region_resizer').length > 0 && hist.selected_opinions && !this.local.touched) {
	      hist.dragging = true;
	      this.local.mouse_x_of_last_resize = ev.pageX;
	      save(hist);
	    }
	    return false;
	  },
	  getOpinionsInCurrentRegion: function() {
	    var all_opinions, hist, max, min, o, selected_opinions;
	    hist = fetch(this.props.key);
	    all_opinions = this.props.opinions || [];
	    min = this.local.mouse_opinion_value - hist.region_selection_width;
	    max = this.local.mouse_opinion_value + hist.region_selection_width;
	    selected_opinions = (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = all_opinions.length; j < len; j++) {
	        o = all_opinions[j];
	        if (inRange(o.stance, min, max)) {
	          results.push(o.key);
	        }
	      }
	      return results;
	    })();
	    return selected_opinions;
	  },
	  histocache_key: function() {
	    var filter_out, key, o, opinions;
	    filter_out = fetch('filtered');
	    opinions = (function() {
	      var j, len, ref, ref1, results;
	      ref = this.props.opinions;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        o = ref[j];
	        if (!((ref1 = filter_out.users) != null ? ref1[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    }).call(this);
	    key = JSON.stringify(_.map(opinions, (function(_this) {
	      return function(o) {
	        return Math.round(fetch(o.key).stance * 100) / 100;
	      };
	    })(this)));
	    key += " (" + this.props.width + ", " + this.props.height + ", " + this.props.width + ")";
	    return md5(key);
	  },
	  try_histocache: function() {
	    var histocache_key, proposal, ref, ref1;
	    proposal = fetch(this.props.proposal);
	    histocache_key = this.histocache_key();
	    if ((ref = proposal.histocache) != null ? ref[histocache_key] : void 0) {
	      if (histocache_key !== ((ref1 = this.local.histocache) != null ? ref1.hash : void 0)) {
	        this.local.histocache = {
	          hash: histocache_key,
	          positions: proposal.histocache[histocache_key]
	        };
	        save(this.local);
	      }
	      return true;
	    }
	    return false;
	  },
	  physicsSimulation: function() {
	    var filter_out, filtered_opinions, histocache_key, i, noop, o, opinion, opinions, proposal, ref;
	    filter_out = fetch('filtered');
	    proposal = fetch(this.props.proposal);
	    if (proposal.histocache == null) {
	      return;
	    }
	    histocache_key = this.histocache_key();
	    if (this.try_histocache()) {
	      noop = 1;
	    } else if (!this.local.dirty && histocache_key !== ((ref = this.local.histocache) != null ? ref.hash : void 0) && this.current_request !== histocache_key) {
	      filtered_opinions = (function() {
	        var j, len, ref1, ref2, results;
	        ref1 = this.props.opinions;
	        results = [];
	        for (j = 0, len = ref1.length; j < len; j++) {
	          o = ref1[j];
	          if (!((ref2 = filter_out.users) != null ? ref2[o.user] : void 0)) {
	            results.push(o);
	          }
	        }
	        return results;
	      }).call(this);
	      opinions = (function() {
	        var j, len, results;
	        results = [];
	        for (i = j = 0, len = filtered_opinions.length; j < len; i = ++j) {
	          opinion = filtered_opinions[i];
	          results.push({
	            stance: opinion.stance,
	            user: opinion.user
	          });
	        }
	        return results;
	      })();
	      setTimeout((function(_this) {
	        return function() {
	          if (_this.isMounted()) {
	            return layoutAvatars({
	              k: histocache_key,
	              w: _this.props.width,
	              h: _this.props.height,
	              o: opinions,
	              r: _this.local.avatar_size / 2,
	              abort: function() {
	                var abort;
	                abort = !_this.isMounted() || _this.current_request !== histocache_key;
	                return abort;
	              },
	              done: function(positions) {
	                if (!_this.isMounted()) {
	                  return;
	                }
	                if (Object.keys(positions).length !== 0 && _this.current_request === histocache_key) {
	                  _this.local.histocaches = {
	                    hash: histocache_key,
	                    positions: positions
	                  };
	                  save(_this.local);
	                  proposal.histocache[histocache_key] = positions;
	                  return save({
	                    key: "/histogram/proposal/" + (fetch(_this.props.proposal).id) + "/" + histocache_key,
	                    positions: positions
	                  });
	                }
	              }
	            });
	          }
	        };
	      })(this), 1);
	    }
	    return this.current_request = histocache_key;
	  },
	  componentDidMount: function() {
	    return this.physicsSimulation();
	  },
	  componentDidUpdate: function() {
	    return this.physicsSimulation();
	  }
	});

	layoutAvatars = function(opts) {
	  histo_queue.push(opts);
	  if (!histo_running) {
	    return histo_run_next_job();
	  }
	};

	histo_queue = [];

	histo_running = null;

	histo_run_next_job = function(completed) {
	  if (histo_running === completed) {
	    histo_running = null;
	  }
	  if (!histo_running && histo_queue.length > 0) {
	    histo_running = histo_queue.shift();
	    return positionAvatars(histo_running);
	  }
	};

	positionAvatars = function(opts) {
	  var aborted, alpha, collide, decay, energy_reduced_by_swap, height, i, j, len, min_alpha, nodes, o, opinions, positions, r, stable, swap_position, targets, tick, total_ticks, width, x_force_mult, y_force_mult;
	  energy_reduced_by_swap = function(p1, p2) {
	    var p1_jealousy, p2_jealousy;
	    p1_jealousy = (p1.x - p1.x_target) * (p1.x - p1.x_target) - (p2.x - p1.x_target) * (p2.x - p1.x_target);
	    p2_jealousy = (p2.x - p2.x_target) * (p2.x - p2.x_target) - (p1.x - p2.x_target) * (p1.x - p2.x_target);
	    return p1_jealousy + p2_jealousy;
	  };
	  swap_position = function(p1, p2) {
	    var swap_x, swap_y;
	    swap_x = p1.x;
	    swap_y = p1.y;
	    p1.x = p2.x;
	    p1.y = p2.y;
	    p2.x = swap_x;
	    return p2.y = swap_y;
	  };
	  tick = function(alpha) {
	    var dx, dy, i, j, k, len, len1, n, o, q, stable;
	    stable = true;
	    q = d3.geom.quadtree(nodes);
	    for (j = 0, len = nodes.length; j < len; j++) {
	      n = nodes[j];
	      q.visit(collide(n, alpha));
	    }
	    for (i = k = 0, len1 = nodes.length; k < len1; i = ++k) {
	      o = nodes[i];
	      o.px = o.x;
	      o.py = o.y;
	      o.x += alpha * (x_force_mult * width * .001) * (o.x_target - o.x);
	      o.y += alpha * y_force_mult;
	      if (o.x < o.radius) {
	        o.x = o.radius;
	      } else if (o.x > width - o.radius) {
	        o.x = width - o.radius;
	      }
	      if (o.y < o.radius) {
	        o.y = o.radius;
	      } else if (o.y > height - o.radius) {
	        o.y = height - o.radius;
	      }
	      dx = Math.abs(o.py - o.y);
	      dy = Math.abs(o.px - o.x) > .1;
	      if (stable && Math.sqrt(dx * dx + dy * dy) > 1) {
	        stable = false;
	      }
	    }
	    return stable;
	  };
	  collide = function(p1, alpha) {
	    return function(quad, x1, y1, x2, y2) {
	      var combined_r, dist, dx, dy, neighborhood_radius, nx1, nx2, ny1, ny2, offset_x, offset_y, p2, separate_by;
	      p2 = quad.point;
	      if (quad.leaf && p2 && p2 !== p1) {
	        dx = Math.abs(p1.x - p2.x);
	        dy = Math.abs(p1.y - p2.y);
	        dist = Math.sqrt(dx * dx + dy * dy);
	        combined_r = p1.radius + p2.radius;
	        if (energy_reduced_by_swap(p1, p2) > 0) {
	          swap_position(p1, p2);
	        }
	        if (dist < combined_r) {
	          separate_by = dist === 0 ? 1 : (combined_r - dist) / combined_r;
	          offset_x = (combined_r - dx) * separate_by;
	          offset_y = (combined_r - dy) * separate_by;
	          if (p1.x < p2.x) {
	            p1.x -= offset_x / 2;
	            p2.x += offset_x / 2;
	          } else {
	            p2.x -= offset_x / 2;
	            p1.x += offset_x / 2;
	          }
	          if (p1.y < p2.y) {
	            p1.y -= offset_y / 2;
	            p2.y += offset_y / 2;
	          } else {
	            p2.y -= offset_y / 2;
	            p1.y += offset_y / 2;
	          }
	        }
	      }
	      neighborhood_radius = p1.radius;
	      nx1 = p1.x - neighborhood_radius;
	      nx2 = p1.x + neighborhood_radius;
	      ny1 = p1.y - neighborhood_radius;
	      ny2 = p1.y + neighborhood_radius;
	      return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
	    };
	  };
	  targets = {};
	  opinions = opts.o.slice();
	  width = opts.w || 400;
	  height = opts.h || 70;
	  r = calculateAvatarRadius(width, height, opinions);
	  nodes = opinions.map(function(o, i) {
	    var x, x_target, y;
	    x_target = (o.stance + 1) / 2 * width;
	    if (targets[x_target]) {
	      if (x_target > .98) {
	        x_target -= .1 * Math.random();
	      } else if (x_target < .02) {
	        x_target += .1 * Math.random();
	      }
	    }
	    targets[x_target] = 1;
	    x = x_target;
	    y = height - r;
	    return {
	      index: i,
	      radius: r,
	      x: x,
	      y: y,
	      x_target: x_target
	    };
	  });
	  stable = false;
	  alpha = .8;
	  decay = .8;
	  min_alpha = 0.0000001;
	  x_force_mult = 2;
	  y_force_mult = 2;
	  total_ticks = 0;
	  while (true) {
	    stable = tick(alpha);
	    alpha *= decay;
	    total_ticks += 1;
	    stable || (stable = alpha <= min_alpha);
	    aborted = typeof opts.abort === "function" ? opts.abort() : void 0;
	    if (stable || aborted) {
	      break;
	    }
	  }
	  if (!aborted) {
	    positions = {};
	    for (i = j = 0, len = nodes.length; j < len; i = ++j) {
	      o = nodes[i];
	      positions[parseInt(opinions[i].user.split('/user/')[1])] = [Math.round((o.x - o.radius) * 10) / 10, Math.round((o.y - o.radius) * 10) / 10];
	    }
	    if (typeof opts.done === "function") {
	      opts.done(positions);
	    }
	  }
	  return histo_run_next_job(opts);
	};

	calculateAvatarRadius = function(width, height, opinions) {
	  var area_per_avatar, avg, avg_inc, avg_of_moving_avg, cnt, current_region, dense_regions, effective_width, filter_out, idx, j, k, l, len, len1, len2, max_opinions, max_region, moving_avg, o, r, ratio_filled, region, reset, stance, sum, window_size;
	  filter_out = fetch('filtered');
	  if (filter_out.users) {
	    opinions = (function() {
	      var j, len, ref, results;
	      results = [];
	      for (j = 0, len = opinions.length; j < len; j++) {
	        o = opinions[j];
	        if (!((ref = filter_out.users) != null ? ref[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    })();
	  }
	  opinions.sort(function(a, b) {
	    return a.stance - b.stance;
	  });
	  window_size = .3;
	  avg_inc = .01;
	  moving_avg = [];
	  idx = 0;
	  stance = -1.0;
	  sum = 0;
	  while (stance <= 1.0) {
	    o = idx;
	    cnt = 0;
	    while (o < opinions.length) {
	      if (opinions[o].stance < stance - window_size) {
	        idx = o;
	      } else if (opinions[o].stance > stance + window_size) {
	        break;
	      } else {
	        cnt += 1;
	      }
	      o += 1;
	    }
	    moving_avg.push(cnt);
	    stance += avg_inc;
	    sum += cnt;
	  }
	  dense_regions = [];
	  avg_of_moving_avg = sum / moving_avg.length;
	  current_region = [];
	  for (idx = j = 0, len = moving_avg.length; j < len; idx = ++j) {
	    avg = moving_avg[idx];
	    reset = idx === moving_avg.length - 1;
	    if (avg >= avg_of_moving_avg) {
	      current_region.push(idx);
	    } else {
	      reset = true;
	    }
	    if (reset && current_region.length > 0) {
	      dense_regions.push([current_region[0] * avg_inc - 1.0 - window_size, idx * avg_inc - 1.0 + window_size]);
	      current_region = [];
	    }
	  }
	  max_region = null;
	  max_opinions = 0;
	  for (k = 0, len1 = dense_regions.length; k < len1; k++) {
	    region = dense_regions[k];
	    cnt = 0;
	    for (l = 0, len2 = opinions.length; l < len2; l++) {
	      o = opinions[l];
	      if (o.stance >= region[0] && o.stance <= region[1]) {
	        cnt += 1;
	      }
	    }
	    if (cnt > max_opinions) {
	      max_opinions = cnt;
	      max_region = region;
	    }
	  }
	  ratio_filled = .5;
	  if (max_opinions > 0) {
	    effective_width = width * Math.abs(max_region[0] - max_region[1]) / 2;
	    area_per_avatar = ratio_filled * effective_width * height / max_opinions;
	    r = Math.sqrt(area_per_avatar) / 2;
	  } else {
	    r = Math.sqrt(width * height / opinions.length * ratio_filled) / 2;
	  }
	  r = Math.min(r, width / 2, height / 2);
	  return r;
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(3);

	window.Slider = ReactiveComponent({
	  displayName: 'Slider',
	  getDefaultProps: function() {
	    return {
	      handle_height: 6,
	      base_height: 6,
	      base_endpoint: 'square',
	      base_color: 'rgb(160, 160, 160)',
	      polarized: false,
	      draw_helpers: false,
	      respond_to_click: true
	    };
	  },
	  render: function() {
	    var slider, slider_style;
	    slider = fetch(this.props.key);
	    if (this.props.draw_handle == null) {
	      this.props.draw_handle = true;
	    }
	    if (slider.value == null) {
	      _.defaults(slider, {
	        value: this.props.polarized ? -1.0 : 0,
	        has_moved: false,
	        is_moving: false
	      });
	      save(slider);
	    }
	    slider_style = _.defaults({}, this.props.slider_style || {}, {
	      width: this.props.width,
	      height: Math.max(this.props.base_height, this.props.handle_height),
	      position: 'relative'
	    });
	    return DIV({
	      className: 'slider',
	      style: slider_style
	    }, this.drawSliderBase(), this.props.draw_handle ? this.drawSliderHandle() : void 0);
	  },
	  drawSliderBase: function() {
	    var d, endpoint, endpoints, idx, region, slider, slider_base_style, sty, w;
	    slider = fetch(this.props.key);
	    slider_base_style = {
	      width: this.props.width,
	      height: this.props.base_height,
	      backgroundColor: this.props.base_color,
	      position: 'absolute'
	    };
	    if (typeof this.props.base_endpoint === 'string') {
	      endpoints = [this.props.base_endpoint, this.props.base_endpoint];
	    } else {
	      endpoints = this.props.base_endpoint;
	    }
	    return DIV({
	      ref: 'base',
	      style: slider_base_style,
	      onClick: this.handleMouseClick
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = endpoints.length; i < len; idx = ++i) {
	        endpoint = endpoints[idx];
	        if (endpoint === 'square') {
	          continue;
	        }
	        if (endpoint === 'sharp') {
	          results.push(DIV({
	            key: "endpoint-" + idx,
	            style: {
	              position: 'absolute',
	              left: idx === 0 ? -5 : void 0,
	              right: idx === 1 ? -5 : void 0,
	              width: 5,
	              height: slider_base_style.height,
	              backgroundColor: slider_base_style.backgroundColor
	            }
	          }, DIV({
	            style: cssTriangle((idx === 0 ? 'left' : 'right'), slider_base_style.backgroundColor, 12, 6, {
	              position: 'absolute',
	              left: idx === 0 ? -12 : void 0,
	              right: idx === 1 ? -12 : void 0
	            })
	          })));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })(), (function() {
	      var i, len, ref, results;
	      if (this.props.draw_ticks && this.props.regions) {
	        d = this.props.width / this.props.regions.length;
	        sty = {
	          color: '#BDBDBD',
	          fontSize: 14
	        };
	        ref = this.props.regions;
	        results = [];
	        for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	          region = ref[idx];
	          w = sizeWhenRendered(region.abbrev, sty);
	          results.push(DIV({
	            style: _.extend({}, sty, {
	              color: '#BDBDBD',
	              fontSize: 14,
	              position: 'absolute',
	              left: (idx + .5) * d - w.width / 2,
	              top: 4
	            })
	          }, region.abbrev));
	        }
	        return results;
	      }
	    }).call(this));
	  },
	  drawSliderHandle: function() {
	    var handle_height, handle_width, slider, sliderHandle, support;
	    handle_width = handle_height = this.props.handle_height;
	    slider = fetch(this.props.key);
	    sliderHandle = this.props.handle || slider_handle.flat;
	    return DIV({
	      className: 'the_handle',
	      onMouseUp: this.handleMouseUp,
	      onTouchEnd: this.handleMouseUp,
	      onTouchCancel: this.handleMouseUp,
	      onMouseDown: this.handleMouseDown,
	      onTouchStart: this.handleMouseDown,
	      onTouchMove: this.handleMouseMove,
	      style: css.crossbrowserify(_.extend(this.props.handle_style || {}, {
	        width: handle_width,
	        height: handle_height,
	        top: this.props.offset ? 0 : -(handle_height - this.props.base_height) / 2,
	        position: 'relative',
	        marginLeft: -handle_width / 2,
	        zIndex: 10,
	        left: this.props.polarized ? this.props.width * (slider.value + 1) / 2 : this.props.width * slider.value
	      }))
	    }, sliderHandle(_.extend(this.props.handle_props || {}, {
	      value: this.props.polarized ? (slider.value + 1) / 2 : slider.value,
	      handle_height: handle_height,
	      handle_width: handle_width
	    })), (function() {
	      var i, len, ref, results;
	      if (this.props.draw_helpers) {
	        ref = [true, false];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          support = ref[i];
	          results.push(DIV({
	            style: {
	              right: support ? -15 : void 0,
	              left: !support ? -15 : void 0,
	              position: 'absolute',
	              top: 4,
	              color: focus_blue,
	              fontSize: 12,
	              pointerEvents: 'none'
	            }
	          }, support ? '>' : '<'));
	        }
	        return results;
	      }
	    }).call(this));
	  },
	  handleMouseDown: function(e) {
	    var el, slider;
	    el = this.getDOMNode();
	    e.preventDefault();
	    slider = fetch(this.props.key);
	    slider.is_moving = true;
	    save(slider);
	    this.local.starting_adjustment = (parseInt($(e.currentTarget)[0].style.left, 10) || 0) - (e.clientX || e.touches[0].clientX);
	    save(this.local);
	    if (this.props.onMouseDownCallback) {
	      this.props.onMouseDownCallback(e);
	    }
	    $(window).on("mousemove.slider", this.handleMouseMove);
	    return $(window).on("mouseup.slider", this.handleMouseUp);
	  },
	  handleMouseMove: function(e) {
	    var clientX, slider, x;
	    e.preventDefault();
	    slider = fetch(this.props.key);
	    clientX = e.clientX || e.touches[0].clientX;
	    x = clientX + this.local.starting_adjustment;
	    x = x < 0 ? 0 : x > this.props.width ? this.props.width : x;
	    slider.has_moved = true;
	    slider.value = x / this.props.width;
	    if (this.props.polarized) {
	      slider.value = slider.value * 2 - 1;
	    }
	    slider.value = Math.round(slider.value * 10000) / 10000;
	    save(slider);
	    if (this.props.onMouseMoveCallback) {
	      return this.props.onMouseMoveCallback(e);
	    }
	  },
	  handleMouseUp: function(e) {
	    var slider;
	    slider = fetch(this.props.key);
	    if (!slider.is_moving) {
	      return;
	    }
	    e.preventDefault();
	    slider.is_moving = false;
	    save(slider);
	    if (this.props.onMouseUpCallback) {
	      this.props.onMouseUpCallback(e);
	    }
	    return $(window).off(".slider");
	  },
	  handleMouseClick: function(e) {
	    var clientX, slider, val;
	    if (this.props.respond_to_click) {
	      e.preventDefault();
	      clientX = e.clientX || e.touches[0].clientX;
	      val = (clientX - $(this.refs.base.getDOMNode()).offset().left) / this.props.width;
	      if (val < 0) {
	        val = 0;
	      }
	      if (val > 1) {
	        val = 1;
	      }
	      if (this.props.polarized) {
	        val = val * 2 - 1;
	      }
	      slider = fetch(this.props.key);
	      slider.has_moved = true;
	      slider.value = Math.round(val * 10000) / 10000;
	      save(slider);
	      if (this.props.onClickCallback) {
	        return this.props.onClickCallback(e);
	      }
	    }
	  }
	});

	if (!window.slider_handle) {
	  window.slider_handle = {};
	}

	slider_handle.face = function(props) {
	  var bh, bw, direction, is_left, x, y;
	  return SVG({
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "-2 -1 104 104",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0
	    }
	  }, DEFS(null, svg.innerbevel({
	    id: 'handle-innerbevel',
	    shadows: [
	      {
	        color: 'black',
	        opacity: 1.0,
	        dx: 0,
	        dy: -3,
	        stdDeviation: 3
	      }, {
	        color: 'white',
	        opacity: .25,
	        dx: 0,
	        dy: 3,
	        stdDeviation: 3
	      }
	    ]
	  })), CIRCLE({
	    fill: props.color,
	    stroke: props.color,
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), G(null, CIRCLE({
	    fill: props.color,
	    filter: "url(#handle-innerbevel)",
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), props.detail ? G(null, (function() {
	    var i, len, ref, results;
	    ref = [true, false];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      is_left = ref[i];
	      direction = is_left ? -1 : 1;
	      bw = 15;
	      bh = 2;
	      x = 50 + direction * (28 + 4 * (1 - props.value)) - (is_left ? 0 : bw);
	      y = 28 - 4 * (1 - props.value);
	      results.push(RECT({
	        x: x,
	        y: y,
	        width: bw,
	        height: bh,
	        transform: "rotate(" + (direction * (5 + 30 * Math.abs(.5 - props.value))) + " " + (x + (is_left ? bw : 0)) + " " + (y + bh) + ")",
	        fill: 'white'
	      }));
	    }
	    return results;
	  })(), (function() {
	    var i, len, ref, results;
	    ref = [true, false];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      is_left = ref[i];
	      direction = is_left ? -1 : 1;
	      results.push(CIRCLE({
	        cx: 50 + direction * (13 + 6 * (1 - props.value)),
	        cy: 39,
	        r: 3,
	        fill: 'white'
	      }));
	    }
	    return results;
	  })(), (function(_this) {
	    return function() {
	      var frowniness, mw, my, qx1, qy1, ref, ref1, ref2, x1, x2, y1, y2;
	      frowniness = 5;
	      mw = 40;
	      my = 65;
	      ref = [50 - mw / 2, my + frowniness * (1 - props.value)], x1 = ref[0], y1 = ref[1];
	      ref1 = [50 + mw / 2, y1], x2 = ref1[0], y2 = ref1[1];
	      ref2 = [50, my + .5 * frowniness + 2 * frowniness * (2 * props.value - 1)], qx1 = ref2[0], qy1 = ref2[1];
	      return PATH({
	        stroke: 'white',
	        fill: focus_blue,
	        strokeWidth: 3,
	        d: "M " + x1 + " " + y1 + "\nQ " + qx1 + " " + qy1 + "\n  " + x2 + " " + y2
	      });
	    };
	  })(this)()) : void 0));
	};

	slider_handle.triangley = function(props) {
	  var svg_props;
	  svg_props = {
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "0 0 21 18",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      zIndex: 10
	    }
	  };
	  return SVG(svg_props, DEFS(null, FILTER({
	    id: "triangley_filter",
	    x: "-50%",
	    y: "-50%",
	    width: "200%",
	    height: "200%",
	    filterUnits: "objectBoundingBox"
	  }, FEOFFSET({
	    dx: "0",
	    dy: "1",
	    'in': "SourceAlpha",
	    result: "shadowOffsetOuter1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "0.5",
	    'in': "shadowOffsetOuter1",
	    result: "shadowBlurOuter1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16479563 0",
	    'in': "shadowBlurOuter1",
	    type: "matrix",
	    result: "shadowMatrixOuter1"
	  }), FEOFFSET({
	    dx: "0",
	    dy: "-1",
	    'in': "SourceAlpha",
	    result: "shadowOffsetInner1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "1",
	    'in': "shadowOffsetInner1",
	    result: "shadowBlurInner1"
	  }), FECOMPOSITE({
	    'in': "shadowBlurInner1",
	    in2: "SourceAlpha",
	    operator: "arithmetic",
	    k2: "-1",
	    k3: "1",
	    result: "shadowInnerInner1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
	    'in': "shadowInnerInner1",
	    type: "matrix",
	    result: "shadowMatrixInner1"
	  }), FEMERGE(null, FEMERGENODE({
	    'in': "shadowMatrixOuter1"
	  }), FEMERGENODE({
	    'in': "SourceGraphic"
	  }), FEMERGENODE({
	    'in': "shadowMatrixInner1"
	  })))), G({
	    stroke: "none",
	    strokeWidth: "0",
	    fill: focus_blue,
	    fillRule: "evenodd"
	  }, PATH({
	    d: "M1,6 L20,6 L20,16 L1,16 L1,6 Z M10.5,0 L20,6 L1,6 L10.5,0 Z",
	    fill: focus_blue,
	    filter: "url(#triangley_filter)"
	  })));
	};

	slider_handle.flat = function(props) {
	  var svg_props;
	  svg_props = {
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "-2 -1 104 104",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      zIndex: 10
	    }
	  };
	  return SVG(svg_props, DEFS(null, CLIPPATH({
	    id: 'slider-avatar-clip'
	  }, CIRCLE({
	    cx: 50,
	    cy: 50,
	    r: 48
	  }))), CIRCLE({
	    fill: props.color,
	    stroke: props.color,
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), props.use_face ? (function(_this) {
	    return function() {
	      var user;
	      user = fetch(fetch('/current_user').user);
	      if (user.avatar_file_name) {
	        return IMAGE({
	          'xlink:href': avatarUrl(user, 'large'),
	          x: 2,
	          y: 2,
	          width: 96,
	          height: 96,
	          clipPath: 'url(#slider-avatar-clip)'
	        });
	      }
	    };
	  })(this)() : void 0);
	};

	styles += "" + (css.grab_cursor('.the_handle'));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(){function n(n,t){return t>n?-1:n>t?1:n>=t?0:0/0}function t(n){return null===n?0/0:+n}function e(n){return!isNaN(n)}function r(n){return{left:function(t,e,r,u){for(arguments.length<3&&(r=0),arguments.length<4&&(u=t.length);u>r;){var i=r+u>>>1;n(t[i],e)<0?r=i+1:u=i}return r},right:function(t,e,r,u){for(arguments.length<3&&(r=0),arguments.length<4&&(u=t.length);u>r;){var i=r+u>>>1;n(t[i],e)>0?u=i:r=i+1}return r}}}function u(n){return n.length}function i(n){for(var t=1;n*t%1;)t*=10;return t}function o(n,t){for(var e in t)Object.defineProperty(n.prototype,e,{value:t[e],enumerable:!1})}function a(){this._=Object.create(null)}function c(n){return(n+="")===da||n[0]===ma?ma+n:n}function l(n){return(n+="")[0]===ma?n.slice(1):n}function s(n){return c(n)in this._}function f(n){return(n=c(n))in this._&&delete this._[n]}function h(){var n=[];for(var t in this._)n.push(l(t));return n}function g(){var n=0;for(var t in this._)++n;return n}function p(){for(var n in this._)return!1;return!0}function v(){this._=Object.create(null)}function d(n,t,e){return function(){var r=e.apply(t,arguments);return r===t?n:r}}function m(n,t){if(t in n)return t;t=t.charAt(0).toUpperCase()+t.slice(1);for(var e=0,r=ya.length;r>e;++e){var u=ya[e]+t;if(u in n)return u}}function y(){}function M(){}function x(n){function t(){for(var t,r=e,u=-1,i=r.length;++u<i;)(t=r[u].on)&&t.apply(this,arguments);return n}var e=[],r=new a;return t.on=function(t,u){var i,o=r.get(t);return arguments.length<2?o&&o.on:(o&&(o.on=null,e=e.slice(0,i=e.indexOf(o)).concat(e.slice(i+1)),r.remove(t)),u&&e.push(r.set(t,{on:u})),n)},t}function b(){ta.event.preventDefault()}function _(){for(var n,t=ta.event;n=t.sourceEvent;)t=n;return t}function w(n){for(var t=new M,e=0,r=arguments.length;++e<r;)t[arguments[e]]=x(t);return t.of=function(e,r){return function(u){try{var i=u.sourceEvent=ta.event;u.target=n,ta.event=u,t[u.type].apply(e,r)}finally{ta.event=i}}},t}function S(n){return xa(n,ka),n}function k(n){return"function"==typeof n?n:function(){return ba(n,this)}}function E(n){return"function"==typeof n?n:function(){return _a(n,this)}}function A(n,t){function e(){this.removeAttribute(n)}function r(){this.removeAttributeNS(n.space,n.local)}function u(){this.setAttribute(n,t)}function i(){this.setAttributeNS(n.space,n.local,t)}function o(){var e=t.apply(this,arguments);null==e?this.removeAttribute(n):this.setAttribute(n,e)}function a(){var e=t.apply(this,arguments);null==e?this.removeAttributeNS(n.space,n.local):this.setAttributeNS(n.space,n.local,e)}return n=ta.ns.qualify(n),null==t?n.local?r:e:"function"==typeof t?n.local?a:o:n.local?i:u}function N(n){return n.trim().replace(/\s+/g," ")}function C(n){return new RegExp("(?:^|\\s+)"+ta.requote(n)+"(?:\\s+|$)","g")}function z(n){return(n+"").trim().split(/^|\s+/)}function q(n,t){function e(){for(var e=-1;++e<u;)n[e](this,t)}function r(){for(var e=-1,r=t.apply(this,arguments);++e<u;)n[e](this,r)}n=z(n).map(L);var u=n.length;return"function"==typeof t?r:e}function L(n){var t=C(n);return function(e,r){if(u=e.classList)return r?u.add(n):u.remove(n);var u=e.getAttribute("class")||"";r?(t.lastIndex=0,t.test(u)||e.setAttribute("class",N(u+" "+n))):e.setAttribute("class",N(u.replace(t," ")))}}function T(n,t,e){function r(){this.style.removeProperty(n)}function u(){this.style.setProperty(n,t,e)}function i(){var r=t.apply(this,arguments);null==r?this.style.removeProperty(n):this.style.setProperty(n,r,e)}return null==t?r:"function"==typeof t?i:u}function R(n,t){function e(){delete this[n]}function r(){this[n]=t}function u(){var e=t.apply(this,arguments);null==e?delete this[n]:this[n]=e}return null==t?e:"function"==typeof t?u:r}function D(n){return"function"==typeof n?n:(n=ta.ns.qualify(n)).local?function(){return this.ownerDocument.createElementNS(n.space,n.local)}:function(){return this.ownerDocument.createElementNS(this.namespaceURI,n)}}function P(){var n=this.parentNode;n&&n.removeChild(this)}function U(n){return{__data__:n}}function j(n){return function(){return Sa(this,n)}}function F(t){return arguments.length||(t=n),function(n,e){return n&&e?t(n.__data__,e.__data__):!n-!e}}function H(n,t){for(var e=0,r=n.length;r>e;e++)for(var u,i=n[e],o=0,a=i.length;a>o;o++)(u=i[o])&&t(u,o,e);return n}function O(n){return xa(n,Aa),n}function Y(n){var t,e;return function(r,u,i){var o,a=n[i].update,c=a.length;for(i!=e&&(e=i,t=0),u>=t&&(t=u+1);!(o=a[t])&&++t<c;);return o}}function I(n,t,e){function r(){var t=this[o];t&&(this.removeEventListener(n,t,t.$),delete this[o])}function u(){var u=c(t,ra(arguments));r.call(this),this.addEventListener(n,this[o]=u,u.$=e),u._=t}function i(){var t,e=new RegExp("^__on([^.]+)"+ta.requote(n)+"$");for(var r in this)if(t=r.match(e)){var u=this[r];this.removeEventListener(t[1],u,u.$),delete this[r]}}var o="__on"+n,a=n.indexOf("."),c=Z;a>0&&(n=n.slice(0,a));var l=Ca.get(n);return l&&(n=l,c=V),a?t?u:r:t?y:i}function Z(n,t){return function(e){var r=ta.event;ta.event=e,t[0]=this.__data__;try{n.apply(this,t)}finally{ta.event=r}}}function V(n,t){var e=Z(n,t);return function(n){var t=this,r=n.relatedTarget;r&&(r===t||8&r.compareDocumentPosition(t))||e.call(t,n)}}function X(){var n=".dragsuppress-"+ ++qa,t="click"+n,e=ta.select(oa).on("touchmove"+n,b).on("dragstart"+n,b).on("selectstart"+n,b);if(za){var r=ia.style,u=r[za];r[za]="none"}return function(i){if(e.on(n,null),za&&(r[za]=u),i){var o=function(){e.on(t,null)};e.on(t,function(){b(),o()},!0),setTimeout(o,0)}}}function $(n,t){t.changedTouches&&(t=t.changedTouches[0]);var e=n.ownerSVGElement||n;if(e.createSVGPoint){var r=e.createSVGPoint();if(0>La&&(oa.scrollX||oa.scrollY)){e=ta.select("body").append("svg").style({position:"absolute",top:0,left:0,margin:0,padding:0,border:"none"},"important");var u=e[0][0].getScreenCTM();La=!(u.f||u.e),e.remove()}return La?(r.x=t.pageX,r.y=t.pageY):(r.x=t.clientX,r.y=t.clientY),r=r.matrixTransform(n.getScreenCTM().inverse()),[r.x,r.y]}var i=n.getBoundingClientRect();return[t.clientX-i.left-n.clientLeft,t.clientY-i.top-n.clientTop]}function B(){return ta.event.changedTouches[0].identifier}function W(){return ta.event.target}function J(){return oa}function G(n){return n>0?1:0>n?-1:0}function K(n,t,e){return(t[0]-n[0])*(e[1]-n[1])-(t[1]-n[1])*(e[0]-n[0])}function Q(n){return n>1?0:-1>n?Da:Math.acos(n)}function nt(n){return n>1?ja:-1>n?-ja:Math.asin(n)}function tt(n){return((n=Math.exp(n))-1/n)/2}function et(n){return((n=Math.exp(n))+1/n)/2}function rt(n){return((n=Math.exp(2*n))-1)/(n+1)}function ut(n){return(n=Math.sin(n/2))*n}function it(){}function ot(n,t,e){return this instanceof ot?(this.h=+n,this.s=+t,void(this.l=+e)):arguments.length<2?n instanceof ot?new ot(n.h,n.s,n.l):xt(""+n,bt,ot):new ot(n,t,e)}function at(n,t,e){function r(n){return n>360?n-=360:0>n&&(n+=360),60>n?i+(o-i)*n/60:180>n?o:240>n?i+(o-i)*(240-n)/60:i}function u(n){return Math.round(255*r(n))}var i,o;return n=isNaN(n)?0:(n%=360)<0?n+360:n,t=isNaN(t)?0:0>t?0:t>1?1:t,e=0>e?0:e>1?1:e,o=.5>=e?e*(1+t):e+t-e*t,i=2*e-o,new dt(u(n+120),u(n),u(n-120))}function ct(n,t,e){return this instanceof ct?(this.h=+n,this.c=+t,void(this.l=+e)):arguments.length<2?n instanceof ct?new ct(n.h,n.c,n.l):n instanceof st?ht(n.l,n.a,n.b):ht((n=_t((n=ta.rgb(n)).r,n.g,n.b)).l,n.a,n.b):new ct(n,t,e)}function lt(n,t,e){return isNaN(n)&&(n=0),isNaN(t)&&(t=0),new st(e,Math.cos(n*=Fa)*t,Math.sin(n)*t)}function st(n,t,e){return this instanceof st?(this.l=+n,this.a=+t,void(this.b=+e)):arguments.length<2?n instanceof st?new st(n.l,n.a,n.b):n instanceof ct?lt(n.h,n.c,n.l):_t((n=dt(n)).r,n.g,n.b):new st(n,t,e)}function ft(n,t,e){var r=(n+16)/116,u=r+t/500,i=r-e/200;return u=gt(u)*Ja,r=gt(r)*Ga,i=gt(i)*Ka,new dt(vt(3.2404542*u-1.5371385*r-.4985314*i),vt(-.969266*u+1.8760108*r+.041556*i),vt(.0556434*u-.2040259*r+1.0572252*i))}function ht(n,t,e){return n>0?new ct(Math.atan2(e,t)*Ha,Math.sqrt(t*t+e*e),n):new ct(0/0,0/0,n)}function gt(n){return n>.206893034?n*n*n:(n-4/29)/7.787037}function pt(n){return n>.008856?Math.pow(n,1/3):7.787037*n+4/29}function vt(n){return Math.round(255*(.00304>=n?12.92*n:1.055*Math.pow(n,1/2.4)-.055))}function dt(n,t,e){return this instanceof dt?(this.r=~~n,this.g=~~t,void(this.b=~~e)):arguments.length<2?n instanceof dt?new dt(n.r,n.g,n.b):xt(""+n,dt,at):new dt(n,t,e)}function mt(n){return new dt(n>>16,255&n>>8,255&n)}function yt(n){return mt(n)+""}function Mt(n){return 16>n?"0"+Math.max(0,n).toString(16):Math.min(255,n).toString(16)}function xt(n,t,e){var r,u,i,o=0,a=0,c=0;if(r=/([a-z]+)\((.*)\)/i.exec(n))switch(u=r[2].split(","),r[1]){case"hsl":return e(parseFloat(u[0]),parseFloat(u[1])/100,parseFloat(u[2])/100);case"rgb":return t(St(u[0]),St(u[1]),St(u[2]))}return(i=tc.get(n))?t(i.r,i.g,i.b):(null==n||"#"!==n.charAt(0)||isNaN(i=parseInt(n.slice(1),16))||(4===n.length?(o=(3840&i)>>4,o=o>>4|o,a=240&i,a=a>>4|a,c=15&i,c=c<<4|c):7===n.length&&(o=(16711680&i)>>16,a=(65280&i)>>8,c=255&i)),t(o,a,c))}function bt(n,t,e){var r,u,i=Math.min(n/=255,t/=255,e/=255),o=Math.max(n,t,e),a=o-i,c=(o+i)/2;return a?(u=.5>c?a/(o+i):a/(2-o-i),r=n==o?(t-e)/a+(e>t?6:0):t==o?(e-n)/a+2:(n-t)/a+4,r*=60):(r=0/0,u=c>0&&1>c?0:r),new ot(r,u,c)}function _t(n,t,e){n=wt(n),t=wt(t),e=wt(e);var r=pt((.4124564*n+.3575761*t+.1804375*e)/Ja),u=pt((.2126729*n+.7151522*t+.072175*e)/Ga),i=pt((.0193339*n+.119192*t+.9503041*e)/Ka);return st(116*u-16,500*(r-u),200*(u-i))}function wt(n){return(n/=255)<=.04045?n/12.92:Math.pow((n+.055)/1.055,2.4)}function St(n){var t=parseFloat(n);return"%"===n.charAt(n.length-1)?Math.round(2.55*t):t}function kt(n){return"function"==typeof n?n:function(){return n}}function Et(n){return n}function At(n){return function(t,e,r){return 2===arguments.length&&"function"==typeof e&&(r=e,e=null),Nt(t,e,n,r)}}function Nt(n,t,e,r){function u(){var n,t=c.status;if(!t&&zt(c)||t>=200&&300>t||304===t){try{n=e.call(i,c)}catch(r){return o.error.call(i,r),void 0}o.load.call(i,n)}else o.error.call(i,c)}var i={},o=ta.dispatch("beforesend","progress","load","error"),a={},c=new XMLHttpRequest,l=null;return!oa.XDomainRequest||"withCredentials"in c||!/^(http(s)?:)?\/\//.test(n)||(c=new XDomainRequest),"onload"in c?c.onload=c.onerror=u:c.onreadystatechange=function(){c.readyState>3&&u()},c.onprogress=function(n){var t=ta.event;ta.event=n;try{o.progress.call(i,c)}finally{ta.event=t}},i.header=function(n,t){return n=(n+"").toLowerCase(),arguments.length<2?a[n]:(null==t?delete a[n]:a[n]=t+"",i)},i.mimeType=function(n){return arguments.length?(t=null==n?null:n+"",i):t},i.responseType=function(n){return arguments.length?(l=n,i):l},i.response=function(n){return e=n,i},["get","post"].forEach(function(n){i[n]=function(){return i.send.apply(i,[n].concat(ra(arguments)))}}),i.send=function(e,r,u){if(2===arguments.length&&"function"==typeof r&&(u=r,r=null),c.open(e,n,!0),null==t||"accept"in a||(a.accept=t+",*/*"),c.setRequestHeader)for(var s in a)c.setRequestHeader(s,a[s]);return null!=t&&c.overrideMimeType&&c.overrideMimeType(t),null!=l&&(c.responseType=l),null!=u&&i.on("error",u).on("load",function(n){u(null,n)}),o.beforesend.call(i,c),c.send(null==r?null:r),i},i.abort=function(){return c.abort(),i},ta.rebind(i,o,"on"),null==r?i:i.get(Ct(r))}function Ct(n){return 1===n.length?function(t,e){n(null==t?e:null)}:n}function zt(n){var t=n.responseType;return t&&"text"!==t?n.response:n.responseText}function qt(){var n=Lt(),t=Tt()-n;t>24?(isFinite(t)&&(clearTimeout(ic),ic=setTimeout(qt,t)),uc=0):(uc=1,ac(qt))}function Lt(){var n=Date.now();for(oc=ec;oc;)n>=oc.t&&(oc.f=oc.c(n-oc.t)),oc=oc.n;return n}function Tt(){for(var n,t=ec,e=1/0;t;)t.f?t=n?n.n=t.n:ec=t.n:(t.t<e&&(e=t.t),t=(n=t).n);return rc=n,e}function Rt(n,t){return t-(n?Math.ceil(Math.log(n)/Math.LN10):1)}function Dt(n,t){var e=Math.pow(10,3*va(8-t));return{scale:t>8?function(n){return n/e}:function(n){return n*e},symbol:n}}function Pt(n){var t=n.decimal,e=n.thousands,r=n.grouping,u=n.currency,i=r&&e?function(n,t){for(var u=n.length,i=[],o=0,a=r[0],c=0;u>0&&a>0&&(c+a+1>t&&(a=Math.max(1,t-c)),i.push(n.substring(u-=a,u+a)),!((c+=a+1)>t));)a=r[o=(o+1)%r.length];return i.reverse().join(e)}:Et;return function(n){var e=lc.exec(n),r=e[1]||" ",o=e[2]||">",a=e[3]||"-",c=e[4]||"",l=e[5],s=+e[6],f=e[7],h=e[8],g=e[9],p=1,v="",d="",m=!1,y=!0;switch(h&&(h=+h.substring(1)),(l||"0"===r&&"="===o)&&(l=r="0",o="="),g){case"n":f=!0,g="g";break;case"%":p=100,d="%",g="f";break;case"p":p=100,d="%",g="r";break;case"b":case"o":case"x":case"X":"#"===c&&(v="0"+g.toLowerCase());case"c":y=!1;case"d":m=!0,h=0;break;case"s":p=-1,g="r"}"$"===c&&(v=u[0],d=u[1]),"r"!=g||h||(g="g"),null!=h&&("g"==g?h=Math.max(1,Math.min(21,h)):("e"==g||"f"==g)&&(h=Math.max(0,Math.min(20,h)))),g=sc.get(g)||Ut;var M=l&&f;return function(n){var e=d;if(m&&n%1)return"";var u=0>n||0===n&&0>1/n?(n=-n,"-"):"-"===a?"":a;if(0>p){var c=ta.formatPrefix(n,h);n=c.scale(n),e=c.symbol+d}else n*=p;n=g(n,h);var x,b,_=n.lastIndexOf(".");if(0>_){var w=y?n.lastIndexOf("e"):-1;0>w?(x=n,b=""):(x=n.substring(0,w),b=n.substring(w))}else x=n.substring(0,_),b=t+n.substring(_+1);!l&&f&&(x=i(x,1/0));var S=v.length+x.length+b.length+(M?0:u.length),k=s>S?new Array(S=s-S+1).join(r):"";return M&&(x=i(k+x,k.length?s-b.length:1/0)),u+=v,n=x+b,("<"===o?u+n+k:">"===o?k+u+n:"^"===o?k.substring(0,S>>=1)+u+n+k.substring(S):u+(M?n:k+n))+e}}}function Ut(n){return n+""}function jt(){this._=new Date(arguments.length>1?Date.UTC.apply(this,arguments):arguments[0])}function Ft(n,t,e){function r(t){var e=n(t),r=i(e,1);return r-t>t-e?e:r}function u(e){return t(e=n(new hc(e-1)),1),e}function i(n,e){return t(n=new hc(+n),e),n}function o(n,r,i){var o=u(n),a=[];if(i>1)for(;r>o;)e(o)%i||a.push(new Date(+o)),t(o,1);else for(;r>o;)a.push(new Date(+o)),t(o,1);return a}function a(n,t,e){try{hc=jt;var r=new jt;return r._=n,o(r,t,e)}finally{hc=Date}}n.floor=n,n.round=r,n.ceil=u,n.offset=i,n.range=o;var c=n.utc=Ht(n);return c.floor=c,c.round=Ht(r),c.ceil=Ht(u),c.offset=Ht(i),c.range=a,n}function Ht(n){return function(t,e){try{hc=jt;var r=new jt;return r._=t,n(r,e)._}finally{hc=Date}}}function Ot(n){function t(n){function t(t){for(var e,u,i,o=[],a=-1,c=0;++a<r;)37===n.charCodeAt(a)&&(o.push(n.slice(c,a)),null!=(u=pc[e=n.charAt(++a)])&&(e=n.charAt(++a)),(i=N[e])&&(e=i(t,null==u?"e"===e?" ":"0":u)),o.push(e),c=a+1);return o.push(n.slice(c,a)),o.join("")}var r=n.length;return t.parse=function(t){var r={y:1900,m:0,d:1,H:0,M:0,S:0,L:0,Z:null},u=e(r,n,t,0);if(u!=t.length)return null;"p"in r&&(r.H=r.H%12+12*r.p);var i=null!=r.Z&&hc!==jt,o=new(i?jt:hc);return"j"in r?o.setFullYear(r.y,0,r.j):"w"in r&&("W"in r||"U"in r)?(o.setFullYear(r.y,0,1),o.setFullYear(r.y,0,"W"in r?(r.w+6)%7+7*r.W-(o.getDay()+5)%7:r.w+7*r.U-(o.getDay()+6)%7)):o.setFullYear(r.y,r.m,r.d),o.setHours(r.H+(0|r.Z/100),r.M+r.Z%100,r.S,r.L),i?o._:o},t.toString=function(){return n},t}function e(n,t,e,r){for(var u,i,o,a=0,c=t.length,l=e.length;c>a;){if(r>=l)return-1;if(u=t.charCodeAt(a++),37===u){if(o=t.charAt(a++),i=C[o in pc?t.charAt(a++):o],!i||(r=i(n,e,r))<0)return-1}else if(u!=e.charCodeAt(r++))return-1}return r}function r(n,t,e){_.lastIndex=0;var r=_.exec(t.slice(e));return r?(n.w=w.get(r[0].toLowerCase()),e+r[0].length):-1}function u(n,t,e){x.lastIndex=0;var r=x.exec(t.slice(e));return r?(n.w=b.get(r[0].toLowerCase()),e+r[0].length):-1}function i(n,t,e){E.lastIndex=0;var r=E.exec(t.slice(e));return r?(n.m=A.get(r[0].toLowerCase()),e+r[0].length):-1}function o(n,t,e){S.lastIndex=0;var r=S.exec(t.slice(e));return r?(n.m=k.get(r[0].toLowerCase()),e+r[0].length):-1}function a(n,t,r){return e(n,N.c.toString(),t,r)}function c(n,t,r){return e(n,N.x.toString(),t,r)}function l(n,t,r){return e(n,N.X.toString(),t,r)}function s(n,t,e){var r=M.get(t.slice(e,e+=2).toLowerCase());return null==r?-1:(n.p=r,e)}var f=n.dateTime,h=n.date,g=n.time,p=n.periods,v=n.days,d=n.shortDays,m=n.months,y=n.shortMonths;t.utc=function(n){function e(n){try{hc=jt;var t=new hc;return t._=n,r(t)}finally{hc=Date}}var r=t(n);return e.parse=function(n){try{hc=jt;var t=r.parse(n);return t&&t._}finally{hc=Date}},e.toString=r.toString,e},t.multi=t.utc.multi=ae;var M=ta.map(),x=It(v),b=Zt(v),_=It(d),w=Zt(d),S=It(m),k=Zt(m),E=It(y),A=Zt(y);p.forEach(function(n,t){M.set(n.toLowerCase(),t)});var N={a:function(n){return d[n.getDay()]},A:function(n){return v[n.getDay()]},b:function(n){return y[n.getMonth()]},B:function(n){return m[n.getMonth()]},c:t(f),d:function(n,t){return Yt(n.getDate(),t,2)},e:function(n,t){return Yt(n.getDate(),t,2)},H:function(n,t){return Yt(n.getHours(),t,2)},I:function(n,t){return Yt(n.getHours()%12||12,t,2)},j:function(n,t){return Yt(1+fc.dayOfYear(n),t,3)},L:function(n,t){return Yt(n.getMilliseconds(),t,3)},m:function(n,t){return Yt(n.getMonth()+1,t,2)},M:function(n,t){return Yt(n.getMinutes(),t,2)},p:function(n){return p[+(n.getHours()>=12)]},S:function(n,t){return Yt(n.getSeconds(),t,2)},U:function(n,t){return Yt(fc.sundayOfYear(n),t,2)},w:function(n){return n.getDay()},W:function(n,t){return Yt(fc.mondayOfYear(n),t,2)},x:t(h),X:t(g),y:function(n,t){return Yt(n.getFullYear()%100,t,2)},Y:function(n,t){return Yt(n.getFullYear()%1e4,t,4)},Z:ie,"%":function(){return"%"}},C={a:r,A:u,b:i,B:o,c:a,d:Qt,e:Qt,H:te,I:te,j:ne,L:ue,m:Kt,M:ee,p:s,S:re,U:Xt,w:Vt,W:$t,x:c,X:l,y:Wt,Y:Bt,Z:Jt,"%":oe};return t}function Yt(n,t,e){var r=0>n?"-":"",u=(r?-n:n)+"",i=u.length;return r+(e>i?new Array(e-i+1).join(t)+u:u)}function It(n){return new RegExp("^(?:"+n.map(ta.requote).join("|")+")","i")}function Zt(n){for(var t=new a,e=-1,r=n.length;++e<r;)t.set(n[e].toLowerCase(),e);return t}function Vt(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+1));return r?(n.w=+r[0],e+r[0].length):-1}function Xt(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e));return r?(n.U=+r[0],e+r[0].length):-1}function $t(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e));return r?(n.W=+r[0],e+r[0].length):-1}function Bt(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+4));return r?(n.y=+r[0],e+r[0].length):-1}function Wt(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+2));return r?(n.y=Gt(+r[0]),e+r[0].length):-1}function Jt(n,t,e){return/^[+-]\d{4}$/.test(t=t.slice(e,e+5))?(n.Z=-t,e+5):-1}function Gt(n){return n+(n>68?1900:2e3)}function Kt(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+2));return r?(n.m=r[0]-1,e+r[0].length):-1}function Qt(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+2));return r?(n.d=+r[0],e+r[0].length):-1}function ne(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+3));return r?(n.j=+r[0],e+r[0].length):-1}function te(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+2));return r?(n.H=+r[0],e+r[0].length):-1}function ee(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+2));return r?(n.M=+r[0],e+r[0].length):-1}function re(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+2));return r?(n.S=+r[0],e+r[0].length):-1}function ue(n,t,e){vc.lastIndex=0;var r=vc.exec(t.slice(e,e+3));return r?(n.L=+r[0],e+r[0].length):-1}function ie(n){var t=n.getTimezoneOffset(),e=t>0?"-":"+",r=0|va(t)/60,u=va(t)%60;return e+Yt(r,"0",2)+Yt(u,"0",2)}function oe(n,t,e){dc.lastIndex=0;var r=dc.exec(t.slice(e,e+1));return r?e+r[0].length:-1}function ae(n){for(var t=n.length,e=-1;++e<t;)n[e][0]=this(n[e][0]);return function(t){for(var e=0,r=n[e];!r[1](t);)r=n[++e];return r[0](t)}}function ce(){}function le(n,t,e){var r=e.s=n+t,u=r-n,i=r-u;e.t=n-i+(t-u)}function se(n,t){n&&xc.hasOwnProperty(n.type)&&xc[n.type](n,t)}function fe(n,t,e){var r,u=-1,i=n.length-e;for(t.lineStart();++u<i;)r=n[u],t.point(r[0],r[1],r[2]);t.lineEnd()}function he(n,t){var e=-1,r=n.length;for(t.polygonStart();++e<r;)fe(n[e],t,1);t.polygonEnd()}function ge(){function n(n,t){n*=Fa,t=t*Fa/2+Da/4;var e=n-r,o=e>=0?1:-1,a=o*e,c=Math.cos(t),l=Math.sin(t),s=i*l,f=u*c+s*Math.cos(a),h=s*o*Math.sin(a);_c.add(Math.atan2(h,f)),r=n,u=c,i=l}var t,e,r,u,i;wc.point=function(o,a){wc.point=n,r=(t=o)*Fa,u=Math.cos(a=(e=a)*Fa/2+Da/4),i=Math.sin(a)},wc.lineEnd=function(){n(t,e)}}function pe(n){var t=n[0],e=n[1],r=Math.cos(e);return[r*Math.cos(t),r*Math.sin(t),Math.sin(e)]}function ve(n,t){return n[0]*t[0]+n[1]*t[1]+n[2]*t[2]}function de(n,t){return[n[1]*t[2]-n[2]*t[1],n[2]*t[0]-n[0]*t[2],n[0]*t[1]-n[1]*t[0]]}function me(n,t){n[0]+=t[0],n[1]+=t[1],n[2]+=t[2]}function ye(n,t){return[n[0]*t,n[1]*t,n[2]*t]}function Me(n){var t=Math.sqrt(n[0]*n[0]+n[1]*n[1]+n[2]*n[2]);n[0]/=t,n[1]/=t,n[2]/=t}function xe(n){return[Math.atan2(n[1],n[0]),nt(n[2])]}function be(n,t){return va(n[0]-t[0])<Ta&&va(n[1]-t[1])<Ta}function _e(n,t){n*=Fa;var e=Math.cos(t*=Fa);we(e*Math.cos(n),e*Math.sin(n),Math.sin(t))}function we(n,t,e){++Sc,Ec+=(n-Ec)/Sc,Ac+=(t-Ac)/Sc,Nc+=(e-Nc)/Sc}function Se(){function n(n,u){n*=Fa;var i=Math.cos(u*=Fa),o=i*Math.cos(n),a=i*Math.sin(n),c=Math.sin(u),l=Math.atan2(Math.sqrt((l=e*c-r*a)*l+(l=r*o-t*c)*l+(l=t*a-e*o)*l),t*o+e*a+r*c);kc+=l,Cc+=l*(t+(t=o)),zc+=l*(e+(e=a)),qc+=l*(r+(r=c)),we(t,e,r)}var t,e,r;Dc.point=function(u,i){u*=Fa;var o=Math.cos(i*=Fa);t=o*Math.cos(u),e=o*Math.sin(u),r=Math.sin(i),Dc.point=n,we(t,e,r)}}function ke(){Dc.point=_e}function Ee(){function n(n,t){n*=Fa;var e=Math.cos(t*=Fa),o=e*Math.cos(n),a=e*Math.sin(n),c=Math.sin(t),l=u*c-i*a,s=i*o-r*c,f=r*a-u*o,h=Math.sqrt(l*l+s*s+f*f),g=r*o+u*a+i*c,p=h&&-Q(g)/h,v=Math.atan2(h,g);Lc+=p*l,Tc+=p*s,Rc+=p*f,kc+=v,Cc+=v*(r+(r=o)),zc+=v*(u+(u=a)),qc+=v*(i+(i=c)),we(r,u,i)}var t,e,r,u,i;Dc.point=function(o,a){t=o,e=a,Dc.point=n,o*=Fa;var c=Math.cos(a*=Fa);r=c*Math.cos(o),u=c*Math.sin(o),i=Math.sin(a),we(r,u,i)},Dc.lineEnd=function(){n(t,e),Dc.lineEnd=ke,Dc.point=_e}}function Ae(n,t){function e(e,r){return e=n(e,r),t(e[0],e[1])}return n.invert&&t.invert&&(e.invert=function(e,r){return e=t.invert(e,r),e&&n.invert(e[0],e[1])}),e}function Ne(){return!0}function Ce(n,t,e,r,u){var i=[],o=[];if(n.forEach(function(n){if(!((t=n.length-1)<=0)){var t,e=n[0],r=n[t];if(be(e,r)){u.lineStart();for(var a=0;t>a;++a)u.point((e=n[a])[0],e[1]);return u.lineEnd(),void 0}var c=new qe(e,n,null,!0),l=new qe(e,null,c,!1);c.o=l,i.push(c),o.push(l),c=new qe(r,n,null,!1),l=new qe(r,null,c,!0),c.o=l,i.push(c),o.push(l)}}),o.sort(t),ze(i),ze(o),i.length){for(var a=0,c=e,l=o.length;l>a;++a)o[a].e=c=!c;for(var s,f,h=i[0];;){for(var g=h,p=!0;g.v;)if((g=g.n)===h)return;s=g.z,u.lineStart();do{if(g.v=g.o.v=!0,g.e){if(p)for(var a=0,l=s.length;l>a;++a)u.point((f=s[a])[0],f[1]);else r(g.x,g.n.x,1,u);g=g.n}else{if(p){s=g.p.z;for(var a=s.length-1;a>=0;--a)u.point((f=s[a])[0],f[1])}else r(g.x,g.p.x,-1,u);g=g.p}g=g.o,s=g.z,p=!p}while(!g.v);u.lineEnd()}}}function ze(n){if(t=n.length){for(var t,e,r=0,u=n[0];++r<t;)u.n=e=n[r],e.p=u,u=e;u.n=e=n[0],e.p=u}}function qe(n,t,e,r){this.x=n,this.z=t,this.o=e,this.e=r,this.v=!1,this.n=this.p=null}function Le(n,t,e,r){return function(u,i){function o(t,e){var r=u(t,e);n(t=r[0],e=r[1])&&i.point(t,e)}function a(n,t){var e=u(n,t);d.point(e[0],e[1])}function c(){y.point=a,d.lineStart()}function l(){y.point=o,d.lineEnd()}function s(n,t){v.push([n,t]);var e=u(n,t);x.point(e[0],e[1])}function f(){x.lineStart(),v=[]}function h(){s(v[0][0],v[0][1]),x.lineEnd();var n,t=x.clean(),e=M.buffer(),r=e.length;if(v.pop(),p.push(v),v=null,r)if(1&t){n=e[0];var u,r=n.length-1,o=-1;if(r>0){for(b||(i.polygonStart(),b=!0),i.lineStart();++o<r;)i.point((u=n[o])[0],u[1]);i.lineEnd()}}else r>1&&2&t&&e.push(e.pop().concat(e.shift())),g.push(e.filter(Te))}var g,p,v,d=t(i),m=u.invert(r[0],r[1]),y={point:o,lineStart:c,lineEnd:l,polygonStart:function(){y.point=s,y.lineStart=f,y.lineEnd=h,g=[],p=[]},polygonEnd:function(){y.point=o,y.lineStart=c,y.lineEnd=l,g=ta.merge(g);var n=Fe(m,p);g.length?(b||(i.polygonStart(),b=!0),Ce(g,De,n,e,i)):n&&(b||(i.polygonStart(),b=!0),i.lineStart(),e(null,null,1,i),i.lineEnd()),b&&(i.polygonEnd(),b=!1),g=p=null},sphere:function(){i.polygonStart(),i.lineStart(),e(null,null,1,i),i.lineEnd(),i.polygonEnd()}},M=Re(),x=t(M),b=!1;return y}}function Te(n){return n.length>1}function Re(){var n,t=[];return{lineStart:function(){t.push(n=[])},point:function(t,e){n.push([t,e])},lineEnd:y,buffer:function(){var e=t;return t=[],n=null,e},rejoin:function(){t.length>1&&t.push(t.pop().concat(t.shift()))}}}function De(n,t){return((n=n.x)[0]<0?n[1]-ja-Ta:ja-n[1])-((t=t.x)[0]<0?t[1]-ja-Ta:ja-t[1])}function Pe(n){var t,e=0/0,r=0/0,u=0/0;return{lineStart:function(){n.lineStart(),t=1},point:function(i,o){var a=i>0?Da:-Da,c=va(i-e);va(c-Da)<Ta?(n.point(e,r=(r+o)/2>0?ja:-ja),n.point(u,r),n.lineEnd(),n.lineStart(),n.point(a,r),n.point(i,r),t=0):u!==a&&c>=Da&&(va(e-u)<Ta&&(e-=u*Ta),va(i-a)<Ta&&(i-=a*Ta),r=Ue(e,r,i,o),n.point(u,r),n.lineEnd(),n.lineStart(),n.point(a,r),t=0),n.point(e=i,r=o),u=a},lineEnd:function(){n.lineEnd(),e=r=0/0},clean:function(){return 2-t}}}function Ue(n,t,e,r){var u,i,o=Math.sin(n-e);return va(o)>Ta?Math.atan((Math.sin(t)*(i=Math.cos(r))*Math.sin(e)-Math.sin(r)*(u=Math.cos(t))*Math.sin(n))/(u*i*o)):(t+r)/2}function je(n,t,e,r){var u;if(null==n)u=e*ja,r.point(-Da,u),r.point(0,u),r.point(Da,u),r.point(Da,0),r.point(Da,-u),r.point(0,-u),r.point(-Da,-u),r.point(-Da,0),r.point(-Da,u);else if(va(n[0]-t[0])>Ta){var i=n[0]<t[0]?Da:-Da;u=e*i/2,r.point(-i,u),r.point(0,u),r.point(i,u)}else r.point(t[0],t[1])}function Fe(n,t){var e=n[0],r=n[1],u=[Math.sin(e),-Math.cos(e),0],i=0,o=0;_c.reset();for(var a=0,c=t.length;c>a;++a){var l=t[a],s=l.length;if(s)for(var f=l[0],h=f[0],g=f[1]/2+Da/4,p=Math.sin(g),v=Math.cos(g),d=1;;){d===s&&(d=0),n=l[d];var m=n[0],y=n[1]/2+Da/4,M=Math.sin(y),x=Math.cos(y),b=m-h,_=b>=0?1:-1,w=_*b,S=w>Da,k=p*M;if(_c.add(Math.atan2(k*_*Math.sin(w),v*x+k*Math.cos(w))),i+=S?b+_*Pa:b,S^h>=e^m>=e){var E=de(pe(f),pe(n));Me(E);var A=de(u,E);Me(A);var N=(S^b>=0?-1:1)*nt(A[2]);(r>N||r===N&&(E[0]||E[1]))&&(o+=S^b>=0?1:-1)}if(!d++)break;h=m,p=M,v=x,f=n}}return(-Ta>i||Ta>i&&0>_c)^1&o}function He(n){function t(n,t){return Math.cos(n)*Math.cos(t)>i}function e(n){var e,i,c,l,s;return{lineStart:function(){l=c=!1,s=1},point:function(f,h){var g,p=[f,h],v=t(f,h),d=o?v?0:u(f,h):v?u(f+(0>f?Da:-Da),h):0;if(!e&&(l=c=v)&&n.lineStart(),v!==c&&(g=r(e,p),(be(e,g)||be(p,g))&&(p[0]+=Ta,p[1]+=Ta,v=t(p[0],p[1]))),v!==c)s=0,v?(n.lineStart(),g=r(p,e),n.point(g[0],g[1])):(g=r(e,p),n.point(g[0],g[1]),n.lineEnd()),e=g;else if(a&&e&&o^v){var m;d&i||!(m=r(p,e,!0))||(s=0,o?(n.lineStart(),n.point(m[0][0],m[0][1]),n.point(m[1][0],m[1][1]),n.lineEnd()):(n.point(m[1][0],m[1][1]),n.lineEnd(),n.lineStart(),n.point(m[0][0],m[0][1])))}!v||e&&be(e,p)||n.point(p[0],p[1]),e=p,c=v,i=d},lineEnd:function(){c&&n.lineEnd(),e=null},clean:function(){return s|(l&&c)<<1}}}function r(n,t,e){var r=pe(n),u=pe(t),o=[1,0,0],a=de(r,u),c=ve(a,a),l=a[0],s=c-l*l;if(!s)return!e&&n;var f=i*c/s,h=-i*l/s,g=de(o,a),p=ye(o,f),v=ye(a,h);me(p,v);var d=g,m=ve(p,d),y=ve(d,d),M=m*m-y*(ve(p,p)-1);if(!(0>M)){var x=Math.sqrt(M),b=ye(d,(-m-x)/y);if(me(b,p),b=xe(b),!e)return b;var _,w=n[0],S=t[0],k=n[1],E=t[1];w>S&&(_=w,w=S,S=_);var A=S-w,N=va(A-Da)<Ta,C=N||Ta>A;if(!N&&k>E&&(_=k,k=E,E=_),C?N?k+E>0^b[1]<(va(b[0]-w)<Ta?k:E):k<=b[1]&&b[1]<=E:A>Da^(w<=b[0]&&b[0]<=S)){var z=ye(d,(-m+x)/y);return me(z,p),[b,xe(z)]}}}function u(t,e){var r=o?n:Da-n,u=0;return-r>t?u|=1:t>r&&(u|=2),-r>e?u|=4:e>r&&(u|=8),u}var i=Math.cos(n),o=i>0,a=va(i)>Ta,c=gr(n,6*Fa);return Le(t,e,c,o?[0,-n]:[-Da,n-Da])}function Oe(n,t,e,r){return function(u){var i,o=u.a,a=u.b,c=o.x,l=o.y,s=a.x,f=a.y,h=0,g=1,p=s-c,v=f-l;if(i=n-c,p||!(i>0)){if(i/=p,0>p){if(h>i)return;g>i&&(g=i)}else if(p>0){if(i>g)return;i>h&&(h=i)}if(i=e-c,p||!(0>i)){if(i/=p,0>p){if(i>g)return;i>h&&(h=i)}else if(p>0){if(h>i)return;g>i&&(g=i)}if(i=t-l,v||!(i>0)){if(i/=v,0>v){if(h>i)return;g>i&&(g=i)}else if(v>0){if(i>g)return;i>h&&(h=i)}if(i=r-l,v||!(0>i)){if(i/=v,0>v){if(i>g)return;i>h&&(h=i)}else if(v>0){if(h>i)return;g>i&&(g=i)}return h>0&&(u.a={x:c+h*p,y:l+h*v}),1>g&&(u.b={x:c+g*p,y:l+g*v}),u}}}}}}function Ye(n,t,e,r){function u(r,u){return va(r[0]-n)<Ta?u>0?0:3:va(r[0]-e)<Ta?u>0?2:1:va(r[1]-t)<Ta?u>0?1:0:u>0?3:2}function i(n,t){return o(n.x,t.x)}function o(n,t){var e=u(n,1),r=u(t,1);return e!==r?e-r:0===e?t[1]-n[1]:1===e?n[0]-t[0]:2===e?n[1]-t[1]:t[0]-n[0]}return function(a){function c(n){for(var t=0,e=d.length,r=n[1],u=0;e>u;++u)for(var i,o=1,a=d[u],c=a.length,l=a[0];c>o;++o)i=a[o],l[1]<=r?i[1]>r&&K(l,i,n)>0&&++t:i[1]<=r&&K(l,i,n)<0&&--t,l=i;return 0!==t}function l(i,a,c,l){var s=0,f=0;if(null==i||(s=u(i,c))!==(f=u(a,c))||o(i,a)<0^c>0){do l.point(0===s||3===s?n:e,s>1?r:t);while((s=(s+c+4)%4)!==f)}else l.point(a[0],a[1])}function s(u,i){return u>=n&&e>=u&&i>=t&&r>=i}function f(n,t){s(n,t)&&a.point(n,t)}function h(){C.point=p,d&&d.push(m=[]),S=!0,w=!1,b=_=0/0}function g(){v&&(p(y,M),x&&w&&A.rejoin(),v.push(A.buffer())),C.point=f,w&&a.lineEnd()}function p(n,t){n=Math.max(-Uc,Math.min(Uc,n)),t=Math.max(-Uc,Math.min(Uc,t));var e=s(n,t);if(d&&m.push([n,t]),S)y=n,M=t,x=e,S=!1,e&&(a.lineStart(),a.point(n,t));else if(e&&w)a.point(n,t);else{var r={a:{x:b,y:_},b:{x:n,y:t}};N(r)?(w||(a.lineStart(),a.point(r.a.x,r.a.y)),a.point(r.b.x,r.b.y),e||a.lineEnd(),k=!1):e&&(a.lineStart(),a.point(n,t),k=!1)}b=n,_=t,w=e}var v,d,m,y,M,x,b,_,w,S,k,E=a,A=Re(),N=Oe(n,t,e,r),C={point:f,lineStart:h,lineEnd:g,polygonStart:function(){a=A,v=[],d=[],k=!0},polygonEnd:function(){a=E,v=ta.merge(v);var t=c([n,r]),e=k&&t,u=v.length;(e||u)&&(a.polygonStart(),e&&(a.lineStart(),l(null,null,1,a),a.lineEnd()),u&&Ce(v,i,t,l,a),a.polygonEnd()),v=d=m=null}};return C}}function Ie(n){var t=0,e=Da/3,r=ir(n),u=r(t,e);return u.parallels=function(n){return arguments.length?r(t=n[0]*Da/180,e=n[1]*Da/180):[180*(t/Da),180*(e/Da)]},u}function Ze(n,t){function e(n,t){var e=Math.sqrt(i-2*u*Math.sin(t))/u;return[e*Math.sin(n*=u),o-e*Math.cos(n)]}var r=Math.sin(n),u=(r+Math.sin(t))/2,i=1+r*(2*u-r),o=Math.sqrt(i)/u;return e.invert=function(n,t){var e=o-t;return[Math.atan2(n,e)/u,nt((i-(n*n+e*e)*u*u)/(2*u))]},e}function Ve(){function n(n,t){Fc+=u*n-r*t,r=n,u=t}var t,e,r,u;Zc.point=function(i,o){Zc.point=n,t=r=i,e=u=o},Zc.lineEnd=function(){n(t,e)}}function Xe(n,t){Hc>n&&(Hc=n),n>Yc&&(Yc=n),Oc>t&&(Oc=t),t>Ic&&(Ic=t)}function $e(){function n(n,t){o.push("M",n,",",t,i)}function t(n,t){o.push("M",n,",",t),a.point=e}function e(n,t){o.push("L",n,",",t)}function r(){a.point=n}function u(){o.push("Z")}var i=Be(4.5),o=[],a={point:n,lineStart:function(){a.point=t},lineEnd:r,polygonStart:function(){a.lineEnd=u},polygonEnd:function(){a.lineEnd=r,a.point=n},pointRadius:function(n){return i=Be(n),a},result:function(){if(o.length){var n=o.join("");return o=[],n}}};return a}function Be(n){return"m0,"+n+"a"+n+","+n+" 0 1,1 0,"+-2*n+"a"+n+","+n+" 0 1,1 0,"+2*n+"z"}function We(n,t){Ec+=n,Ac+=t,++Nc}function Je(){function n(n,r){var u=n-t,i=r-e,o=Math.sqrt(u*u+i*i);Cc+=o*(t+n)/2,zc+=o*(e+r)/2,qc+=o,We(t=n,e=r)}var t,e;Xc.point=function(r,u){Xc.point=n,We(t=r,e=u)}}function Ge(){Xc.point=We}function Ke(){function n(n,t){var e=n-r,i=t-u,o=Math.sqrt(e*e+i*i);Cc+=o*(r+n)/2,zc+=o*(u+t)/2,qc+=o,o=u*n-r*t,Lc+=o*(r+n),Tc+=o*(u+t),Rc+=3*o,We(r=n,u=t)}var t,e,r,u;Xc.point=function(i,o){Xc.point=n,We(t=r=i,e=u=o)},Xc.lineEnd=function(){n(t,e)}}function Qe(n){function t(t,e){n.moveTo(t+o,e),n.arc(t,e,o,0,Pa)}function e(t,e){n.moveTo(t,e),a.point=r}function r(t,e){n.lineTo(t,e)}function u(){a.point=t}function i(){n.closePath()}var o=4.5,a={point:t,lineStart:function(){a.point=e},lineEnd:u,polygonStart:function(){a.lineEnd=i},polygonEnd:function(){a.lineEnd=u,a.point=t},pointRadius:function(n){return o=n,a},result:y};return a}function nr(n){function t(n){return(a?r:e)(n)}function e(t){return rr(t,function(e,r){e=n(e,r),t.point(e[0],e[1])})}function r(t){function e(e,r){e=n(e,r),t.point(e[0],e[1])}function r(){M=0/0,S.point=i,t.lineStart()}function i(e,r){var i=pe([e,r]),o=n(e,r);u(M,x,y,b,_,w,M=o[0],x=o[1],y=e,b=i[0],_=i[1],w=i[2],a,t),t.point(M,x)}function o(){S.point=e,t.lineEnd()}function c(){r(),S.point=l,S.lineEnd=s}function l(n,t){i(f=n,h=t),g=M,p=x,v=b,d=_,m=w,S.point=i}function s(){u(M,x,y,b,_,w,g,p,f,v,d,m,a,t),S.lineEnd=o,o()}var f,h,g,p,v,d,m,y,M,x,b,_,w,S={point:e,lineStart:r,lineEnd:o,polygonStart:function(){t.polygonStart(),S.lineStart=c},polygonEnd:function(){t.polygonEnd(),S.lineStart=r}};return S}function u(t,e,r,a,c,l,s,f,h,g,p,v,d,m){var y=s-t,M=f-e,x=y*y+M*M;if(x>4*i&&d--){var b=a+g,_=c+p,w=l+v,S=Math.sqrt(b*b+_*_+w*w),k=Math.asin(w/=S),E=va(va(w)-1)<Ta||va(r-h)<Ta?(r+h)/2:Math.atan2(_,b),A=n(E,k),N=A[0],C=A[1],z=N-t,q=C-e,L=M*z-y*q;
	(L*L/x>i||va((y*z+M*q)/x-.5)>.3||o>a*g+c*p+l*v)&&(u(t,e,r,a,c,l,N,C,E,b/=S,_/=S,w,d,m),m.point(N,C),u(N,C,E,b,_,w,s,f,h,g,p,v,d,m))}}var i=.5,o=Math.cos(30*Fa),a=16;return t.precision=function(n){return arguments.length?(a=(i=n*n)>0&&16,t):Math.sqrt(i)},t}function tr(n){var t=nr(function(t,e){return n([t*Ha,e*Ha])});return function(n){return or(t(n))}}function er(n){this.stream=n}function rr(n,t){return{point:t,sphere:function(){n.sphere()},lineStart:function(){n.lineStart()},lineEnd:function(){n.lineEnd()},polygonStart:function(){n.polygonStart()},polygonEnd:function(){n.polygonEnd()}}}function ur(n){return ir(function(){return n})()}function ir(n){function t(n){return n=a(n[0]*Fa,n[1]*Fa),[n[0]*h+c,l-n[1]*h]}function e(n){return n=a.invert((n[0]-c)/h,(l-n[1])/h),n&&[n[0]*Ha,n[1]*Ha]}function r(){a=Ae(o=lr(m,y,M),i);var n=i(v,d);return c=g-n[0]*h,l=p+n[1]*h,u()}function u(){return s&&(s.valid=!1,s=null),t}var i,o,a,c,l,s,f=nr(function(n,t){return n=i(n,t),[n[0]*h+c,l-n[1]*h]}),h=150,g=480,p=250,v=0,d=0,m=0,y=0,M=0,x=Pc,b=Et,_=null,w=null;return t.stream=function(n){return s&&(s.valid=!1),s=or(x(o,f(b(n)))),s.valid=!0,s},t.clipAngle=function(n){return arguments.length?(x=null==n?(_=n,Pc):He((_=+n)*Fa),u()):_},t.clipExtent=function(n){return arguments.length?(w=n,b=n?Ye(n[0][0],n[0][1],n[1][0],n[1][1]):Et,u()):w},t.scale=function(n){return arguments.length?(h=+n,r()):h},t.translate=function(n){return arguments.length?(g=+n[0],p=+n[1],r()):[g,p]},t.center=function(n){return arguments.length?(v=n[0]%360*Fa,d=n[1]%360*Fa,r()):[v*Ha,d*Ha]},t.rotate=function(n){return arguments.length?(m=n[0]%360*Fa,y=n[1]%360*Fa,M=n.length>2?n[2]%360*Fa:0,r()):[m*Ha,y*Ha,M*Ha]},ta.rebind(t,f,"precision"),function(){return i=n.apply(this,arguments),t.invert=i.invert&&e,r()}}function or(n){return rr(n,function(t,e){n.point(t*Fa,e*Fa)})}function ar(n,t){return[n,t]}function cr(n,t){return[n>Da?n-Pa:-Da>n?n+Pa:n,t]}function lr(n,t,e){return n?t||e?Ae(fr(n),hr(t,e)):fr(n):t||e?hr(t,e):cr}function sr(n){return function(t,e){return t+=n,[t>Da?t-Pa:-Da>t?t+Pa:t,e]}}function fr(n){var t=sr(n);return t.invert=sr(-n),t}function hr(n,t){function e(n,t){var e=Math.cos(t),a=Math.cos(n)*e,c=Math.sin(n)*e,l=Math.sin(t),s=l*r+a*u;return[Math.atan2(c*i-s*o,a*r-l*u),nt(s*i+c*o)]}var r=Math.cos(n),u=Math.sin(n),i=Math.cos(t),o=Math.sin(t);return e.invert=function(n,t){var e=Math.cos(t),a=Math.cos(n)*e,c=Math.sin(n)*e,l=Math.sin(t),s=l*i-c*o;return[Math.atan2(c*i+l*o,a*r+s*u),nt(s*r-a*u)]},e}function gr(n,t){var e=Math.cos(n),r=Math.sin(n);return function(u,i,o,a){var c=o*t;null!=u?(u=pr(e,u),i=pr(e,i),(o>0?i>u:u>i)&&(u+=o*Pa)):(u=n+o*Pa,i=n-.5*c);for(var l,s=u;o>0?s>i:i>s;s-=c)a.point((l=xe([e,-r*Math.cos(s),-r*Math.sin(s)]))[0],l[1])}}function pr(n,t){var e=pe(t);e[0]-=n,Me(e);var r=Q(-e[1]);return((-e[2]<0?-r:r)+2*Math.PI-Ta)%(2*Math.PI)}function vr(n,t,e){var r=ta.range(n,t-Ta,e).concat(t);return function(n){return r.map(function(t){return[n,t]})}}function dr(n,t,e){var r=ta.range(n,t-Ta,e).concat(t);return function(n){return r.map(function(t){return[t,n]})}}function mr(n){return n.source}function yr(n){return n.target}function Mr(n,t,e,r){var u=Math.cos(t),i=Math.sin(t),o=Math.cos(r),a=Math.sin(r),c=u*Math.cos(n),l=u*Math.sin(n),s=o*Math.cos(e),f=o*Math.sin(e),h=2*Math.asin(Math.sqrt(ut(r-t)+u*o*ut(e-n))),g=1/Math.sin(h),p=h?function(n){var t=Math.sin(n*=h)*g,e=Math.sin(h-n)*g,r=e*c+t*s,u=e*l+t*f,o=e*i+t*a;return[Math.atan2(u,r)*Ha,Math.atan2(o,Math.sqrt(r*r+u*u))*Ha]}:function(){return[n*Ha,t*Ha]};return p.distance=h,p}function xr(){function n(n,u){var i=Math.sin(u*=Fa),o=Math.cos(u),a=va((n*=Fa)-t),c=Math.cos(a);$c+=Math.atan2(Math.sqrt((a=o*Math.sin(a))*a+(a=r*i-e*o*c)*a),e*i+r*o*c),t=n,e=i,r=o}var t,e,r;Bc.point=function(u,i){t=u*Fa,e=Math.sin(i*=Fa),r=Math.cos(i),Bc.point=n},Bc.lineEnd=function(){Bc.point=Bc.lineEnd=y}}function br(n,t){function e(t,e){var r=Math.cos(t),u=Math.cos(e),i=n(r*u);return[i*u*Math.sin(t),i*Math.sin(e)]}return e.invert=function(n,e){var r=Math.sqrt(n*n+e*e),u=t(r),i=Math.sin(u),o=Math.cos(u);return[Math.atan2(n*i,r*o),Math.asin(r&&e*i/r)]},e}function _r(n,t){function e(n,t){o>0?-ja+Ta>t&&(t=-ja+Ta):t>ja-Ta&&(t=ja-Ta);var e=o/Math.pow(u(t),i);return[e*Math.sin(i*n),o-e*Math.cos(i*n)]}var r=Math.cos(n),u=function(n){return Math.tan(Da/4+n/2)},i=n===t?Math.sin(n):Math.log(r/Math.cos(t))/Math.log(u(t)/u(n)),o=r*Math.pow(u(n),i)/i;return i?(e.invert=function(n,t){var e=o-t,r=G(i)*Math.sqrt(n*n+e*e);return[Math.atan2(n,e)/i,2*Math.atan(Math.pow(o/r,1/i))-ja]},e):Sr}function wr(n,t){function e(n,t){var e=i-t;return[e*Math.sin(u*n),i-e*Math.cos(u*n)]}var r=Math.cos(n),u=n===t?Math.sin(n):(r-Math.cos(t))/(t-n),i=r/u+n;return va(u)<Ta?ar:(e.invert=function(n,t){var e=i-t;return[Math.atan2(n,e)/u,i-G(u)*Math.sqrt(n*n+e*e)]},e)}function Sr(n,t){return[n,Math.log(Math.tan(Da/4+t/2))]}function kr(n){var t,e=ur(n),r=e.scale,u=e.translate,i=e.clipExtent;return e.scale=function(){var n=r.apply(e,arguments);return n===e?t?e.clipExtent(null):e:n},e.translate=function(){var n=u.apply(e,arguments);return n===e?t?e.clipExtent(null):e:n},e.clipExtent=function(n){var o=i.apply(e,arguments);if(o===e){if(t=null==n){var a=Da*r(),c=u();i([[c[0]-a,c[1]-a],[c[0]+a,c[1]+a]])}}else t&&(o=null);return o},e.clipExtent(null)}function Er(n,t){return[Math.log(Math.tan(Da/4+t/2)),-n]}function Ar(n){return n[0]}function Nr(n){return n[1]}function Cr(n){for(var t=n.length,e=[0,1],r=2,u=2;t>u;u++){for(;r>1&&K(n[e[r-2]],n[e[r-1]],n[u])<=0;)--r;e[r++]=u}return e.slice(0,r)}function zr(n,t){return n[0]-t[0]||n[1]-t[1]}function qr(n,t,e){return(e[0]-t[0])*(n[1]-t[1])<(e[1]-t[1])*(n[0]-t[0])}function Lr(n,t,e,r){var u=n[0],i=e[0],o=t[0]-u,a=r[0]-i,c=n[1],l=e[1],s=t[1]-c,f=r[1]-l,h=(a*(c-l)-f*(u-i))/(f*o-a*s);return[u+h*o,c+h*s]}function Tr(n){var t=n[0],e=n[n.length-1];return!(t[0]-e[0]||t[1]-e[1])}function Rr(){tu(this),this.edge=this.site=this.circle=null}function Dr(n){var t=ol.pop()||new Rr;return t.site=n,t}function Pr(n){Xr(n),rl.remove(n),ol.push(n),tu(n)}function Ur(n){var t=n.circle,e=t.x,r=t.cy,u={x:e,y:r},i=n.P,o=n.N,a=[n];Pr(n);for(var c=i;c.circle&&va(e-c.circle.x)<Ta&&va(r-c.circle.cy)<Ta;)i=c.P,a.unshift(c),Pr(c),c=i;a.unshift(c),Xr(c);for(var l=o;l.circle&&va(e-l.circle.x)<Ta&&va(r-l.circle.cy)<Ta;)o=l.N,a.push(l),Pr(l),l=o;a.push(l),Xr(l);var s,f=a.length;for(s=1;f>s;++s)l=a[s],c=a[s-1],Kr(l.edge,c.site,l.site,u);c=a[0],l=a[f-1],l.edge=Jr(c.site,l.site,null,u),Vr(c),Vr(l)}function jr(n){for(var t,e,r,u,i=n.x,o=n.y,a=rl._;a;)if(r=Fr(a,o)-i,r>Ta)a=a.L;else{if(u=i-Hr(a,o),!(u>Ta)){r>-Ta?(t=a.P,e=a):u>-Ta?(t=a,e=a.N):t=e=a;break}if(!a.R){t=a;break}a=a.R}var c=Dr(n);if(rl.insert(t,c),t||e){if(t===e)return Xr(t),e=Dr(t.site),rl.insert(c,e),c.edge=e.edge=Jr(t.site,c.site),Vr(t),Vr(e),void 0;if(!e)return c.edge=Jr(t.site,c.site),void 0;Xr(t),Xr(e);var l=t.site,s=l.x,f=l.y,h=n.x-s,g=n.y-f,p=e.site,v=p.x-s,d=p.y-f,m=2*(h*d-g*v),y=h*h+g*g,M=v*v+d*d,x={x:(d*y-g*M)/m+s,y:(h*M-v*y)/m+f};Kr(e.edge,l,p,x),c.edge=Jr(l,n,null,x),e.edge=Jr(n,p,null,x),Vr(t),Vr(e)}}function Fr(n,t){var e=n.site,r=e.x,u=e.y,i=u-t;if(!i)return r;var o=n.P;if(!o)return-1/0;e=o.site;var a=e.x,c=e.y,l=c-t;if(!l)return a;var s=a-r,f=1/i-1/l,h=s/l;return f?(-h+Math.sqrt(h*h-2*f*(s*s/(-2*l)-c+l/2+u-i/2)))/f+r:(r+a)/2}function Hr(n,t){var e=n.N;if(e)return Fr(e,t);var r=n.site;return r.y===t?r.x:1/0}function Or(n){this.site=n,this.edges=[]}function Yr(n){for(var t,e,r,u,i,o,a,c,l,s,f=n[0][0],h=n[1][0],g=n[0][1],p=n[1][1],v=el,d=v.length;d--;)if(i=v[d],i&&i.prepare())for(a=i.edges,c=a.length,o=0;c>o;)s=a[o].end(),r=s.x,u=s.y,l=a[++o%c].start(),t=l.x,e=l.y,(va(r-t)>Ta||va(u-e)>Ta)&&(a.splice(o,0,new Qr(Gr(i.site,s,va(r-f)<Ta&&p-u>Ta?{x:f,y:va(t-f)<Ta?e:p}:va(u-p)<Ta&&h-r>Ta?{x:va(e-p)<Ta?t:h,y:p}:va(r-h)<Ta&&u-g>Ta?{x:h,y:va(t-h)<Ta?e:g}:va(u-g)<Ta&&r-f>Ta?{x:va(e-g)<Ta?t:f,y:g}:null),i.site,null)),++c)}function Ir(n,t){return t.angle-n.angle}function Zr(){tu(this),this.x=this.y=this.arc=this.site=this.cy=null}function Vr(n){var t=n.P,e=n.N;if(t&&e){var r=t.site,u=n.site,i=e.site;if(r!==i){var o=u.x,a=u.y,c=r.x-o,l=r.y-a,s=i.x-o,f=i.y-a,h=2*(c*f-l*s);if(!(h>=-Ra)){var g=c*c+l*l,p=s*s+f*f,v=(f*g-l*p)/h,d=(c*p-s*g)/h,f=d+a,m=al.pop()||new Zr;m.arc=n,m.site=u,m.x=v+o,m.y=f+Math.sqrt(v*v+d*d),m.cy=f,n.circle=m;for(var y=null,M=il._;M;)if(m.y<M.y||m.y===M.y&&m.x<=M.x){if(!M.L){y=M.P;break}M=M.L}else{if(!M.R){y=M;break}M=M.R}il.insert(y,m),y||(ul=m)}}}}function Xr(n){var t=n.circle;t&&(t.P||(ul=t.N),il.remove(t),al.push(t),tu(t),n.circle=null)}function $r(n){for(var t,e=tl,r=Oe(n[0][0],n[0][1],n[1][0],n[1][1]),u=e.length;u--;)t=e[u],(!Br(t,n)||!r(t)||va(t.a.x-t.b.x)<Ta&&va(t.a.y-t.b.y)<Ta)&&(t.a=t.b=null,e.splice(u,1))}function Br(n,t){var e=n.b;if(e)return!0;var r,u,i=n.a,o=t[0][0],a=t[1][0],c=t[0][1],l=t[1][1],s=n.l,f=n.r,h=s.x,g=s.y,p=f.x,v=f.y,d=(h+p)/2,m=(g+v)/2;if(v===g){if(o>d||d>=a)return;if(h>p){if(i){if(i.y>=l)return}else i={x:d,y:c};e={x:d,y:l}}else{if(i){if(i.y<c)return}else i={x:d,y:l};e={x:d,y:c}}}else if(r=(h-p)/(v-g),u=m-r*d,-1>r||r>1)if(h>p){if(i){if(i.y>=l)return}else i={x:(c-u)/r,y:c};e={x:(l-u)/r,y:l}}else{if(i){if(i.y<c)return}else i={x:(l-u)/r,y:l};e={x:(c-u)/r,y:c}}else if(v>g){if(i){if(i.x>=a)return}else i={x:o,y:r*o+u};e={x:a,y:r*a+u}}else{if(i){if(i.x<o)return}else i={x:a,y:r*a+u};e={x:o,y:r*o+u}}return n.a=i,n.b=e,!0}function Wr(n,t){this.l=n,this.r=t,this.a=this.b=null}function Jr(n,t,e,r){var u=new Wr(n,t);return tl.push(u),e&&Kr(u,n,t,e),r&&Kr(u,t,n,r),el[n.i].edges.push(new Qr(u,n,t)),el[t.i].edges.push(new Qr(u,t,n)),u}function Gr(n,t,e){var r=new Wr(n,null);return r.a=t,r.b=e,tl.push(r),r}function Kr(n,t,e,r){n.a||n.b?n.l===e?n.b=r:n.a=r:(n.a=r,n.l=t,n.r=e)}function Qr(n,t,e){var r=n.a,u=n.b;this.edge=n,this.site=t,this.angle=e?Math.atan2(e.y-t.y,e.x-t.x):n.l===t?Math.atan2(u.x-r.x,r.y-u.y):Math.atan2(r.x-u.x,u.y-r.y)}function nu(){this._=null}function tu(n){n.U=n.C=n.L=n.R=n.P=n.N=null}function eu(n,t){var e=t,r=t.R,u=e.U;u?u.L===e?u.L=r:u.R=r:n._=r,r.U=u,e.U=r,e.R=r.L,e.R&&(e.R.U=e),r.L=e}function ru(n,t){var e=t,r=t.L,u=e.U;u?u.L===e?u.L=r:u.R=r:n._=r,r.U=u,e.U=r,e.L=r.R,e.L&&(e.L.U=e),r.R=e}function uu(n){for(;n.L;)n=n.L;return n}function iu(n,t){var e,r,u,i=n.sort(ou).pop();for(tl=[],el=new Array(n.length),rl=new nu,il=new nu;;)if(u=ul,i&&(!u||i.y<u.y||i.y===u.y&&i.x<u.x))(i.x!==e||i.y!==r)&&(el[i.i]=new Or(i),jr(i),e=i.x,r=i.y),i=n.pop();else{if(!u)break;Ur(u.arc)}t&&($r(t),Yr(t));var o={cells:el,edges:tl};return rl=il=tl=el=null,o}function ou(n,t){return t.y-n.y||t.x-n.x}function au(n,t,e){return(n.x-e.x)*(t.y-n.y)-(n.x-t.x)*(e.y-n.y)}function cu(n){return n.x}function lu(n){return n.y}function su(){return{leaf:!0,nodes:[],point:null,x:null,y:null}}function fu(n,t,e,r,u,i){if(!n(t,e,r,u,i)){var o=.5*(e+u),a=.5*(r+i),c=t.nodes;c[0]&&fu(n,c[0],e,r,o,a),c[1]&&fu(n,c[1],o,r,u,a),c[2]&&fu(n,c[2],e,a,o,i),c[3]&&fu(n,c[3],o,a,u,i)}}function hu(n,t,e,r,u,i,o){var a,c=1/0;return function l(n,s,f,h,g){if(!(s>i||f>o||r>h||u>g)){if(p=n.point){var p,v=t-p[0],d=e-p[1],m=v*v+d*d;if(c>m){var y=Math.sqrt(c=m);r=t-y,u=e-y,i=t+y,o=e+y,a=p}}for(var M=n.nodes,x=.5*(s+h),b=.5*(f+g),_=t>=x,w=e>=b,S=w<<1|_,k=S+4;k>S;++S)if(n=M[3&S])switch(3&S){case 0:l(n,s,f,x,b);break;case 1:l(n,x,f,h,b);break;case 2:l(n,s,b,x,g);break;case 3:l(n,x,b,h,g)}}}(n,r,u,i,o),a}function gu(n,t){n=ta.rgb(n),t=ta.rgb(t);var e=n.r,r=n.g,u=n.b,i=t.r-e,o=t.g-r,a=t.b-u;return function(n){return"#"+Mt(Math.round(e+i*n))+Mt(Math.round(r+o*n))+Mt(Math.round(u+a*n))}}function pu(n,t){var e,r={},u={};for(e in n)e in t?r[e]=mu(n[e],t[e]):u[e]=n[e];for(e in t)e in n||(u[e]=t[e]);return function(n){for(e in r)u[e]=r[e](n);return u}}function vu(n,t){return n=+n,t=+t,function(e){return n*(1-e)+t*e}}function du(n,t){var e,r,u,i=ll.lastIndex=sl.lastIndex=0,o=-1,a=[],c=[];for(n+="",t+="";(e=ll.exec(n))&&(r=sl.exec(t));)(u=r.index)>i&&(u=t.slice(i,u),a[o]?a[o]+=u:a[++o]=u),(e=e[0])===(r=r[0])?a[o]?a[o]+=r:a[++o]=r:(a[++o]=null,c.push({i:o,x:vu(e,r)})),i=sl.lastIndex;return i<t.length&&(u=t.slice(i),a[o]?a[o]+=u:a[++o]=u),a.length<2?c[0]?(t=c[0].x,function(n){return t(n)+""}):function(){return t}:(t=c.length,function(n){for(var e,r=0;t>r;++r)a[(e=c[r]).i]=e.x(n);return a.join("")})}function mu(n,t){for(var e,r=ta.interpolators.length;--r>=0&&!(e=ta.interpolators[r](n,t)););return e}function yu(n,t){var e,r=[],u=[],i=n.length,o=t.length,a=Math.min(n.length,t.length);for(e=0;a>e;++e)r.push(mu(n[e],t[e]));for(;i>e;++e)u[e]=n[e];for(;o>e;++e)u[e]=t[e];return function(n){for(e=0;a>e;++e)u[e]=r[e](n);return u}}function Mu(n){return function(t){return 0>=t?0:t>=1?1:n(t)}}function xu(n){return function(t){return 1-n(1-t)}}function bu(n){return function(t){return.5*(.5>t?n(2*t):2-n(2-2*t))}}function _u(n){return n*n}function wu(n){return n*n*n}function Su(n){if(0>=n)return 0;if(n>=1)return 1;var t=n*n,e=t*n;return 4*(.5>n?e:3*(n-t)+e-.75)}function ku(n){return function(t){return Math.pow(t,n)}}function Eu(n){return 1-Math.cos(n*ja)}function Au(n){return Math.pow(2,10*(n-1))}function Nu(n){return 1-Math.sqrt(1-n*n)}function Cu(n,t){var e;return arguments.length<2&&(t=.45),arguments.length?e=t/Pa*Math.asin(1/n):(n=1,e=t/4),function(r){return 1+n*Math.pow(2,-10*r)*Math.sin((r-e)*Pa/t)}}function zu(n){return n||(n=1.70158),function(t){return t*t*((n+1)*t-n)}}function qu(n){return 1/2.75>n?7.5625*n*n:2/2.75>n?7.5625*(n-=1.5/2.75)*n+.75:2.5/2.75>n?7.5625*(n-=2.25/2.75)*n+.9375:7.5625*(n-=2.625/2.75)*n+.984375}function Lu(n,t){n=ta.hcl(n),t=ta.hcl(t);var e=n.h,r=n.c,u=n.l,i=t.h-e,o=t.c-r,a=t.l-u;return isNaN(o)&&(o=0,r=isNaN(r)?t.c:r),isNaN(i)?(i=0,e=isNaN(e)?t.h:e):i>180?i-=360:-180>i&&(i+=360),function(n){return lt(e+i*n,r+o*n,u+a*n)+""}}function Tu(n,t){n=ta.hsl(n),t=ta.hsl(t);var e=n.h,r=n.s,u=n.l,i=t.h-e,o=t.s-r,a=t.l-u;return isNaN(o)&&(o=0,r=isNaN(r)?t.s:r),isNaN(i)?(i=0,e=isNaN(e)?t.h:e):i>180?i-=360:-180>i&&(i+=360),function(n){return at(e+i*n,r+o*n,u+a*n)+""}}function Ru(n,t){n=ta.lab(n),t=ta.lab(t);var e=n.l,r=n.a,u=n.b,i=t.l-e,o=t.a-r,a=t.b-u;return function(n){return ft(e+i*n,r+o*n,u+a*n)+""}}function Du(n,t){return t-=n,function(e){return Math.round(n+t*e)}}function Pu(n){var t=[n.a,n.b],e=[n.c,n.d],r=ju(t),u=Uu(t,e),i=ju(Fu(e,t,-u))||0;t[0]*e[1]<e[0]*t[1]&&(t[0]*=-1,t[1]*=-1,r*=-1,u*=-1),this.rotate=(r?Math.atan2(t[1],t[0]):Math.atan2(-e[0],e[1]))*Ha,this.translate=[n.e,n.f],this.scale=[r,i],this.skew=i?Math.atan2(u,i)*Ha:0}function Uu(n,t){return n[0]*t[0]+n[1]*t[1]}function ju(n){var t=Math.sqrt(Uu(n,n));return t&&(n[0]/=t,n[1]/=t),t}function Fu(n,t,e){return n[0]+=e*t[0],n[1]+=e*t[1],n}function Hu(n,t){var e,r=[],u=[],i=ta.transform(n),o=ta.transform(t),a=i.translate,c=o.translate,l=i.rotate,s=o.rotate,f=i.skew,h=o.skew,g=i.scale,p=o.scale;return a[0]!=c[0]||a[1]!=c[1]?(r.push("translate(",null,",",null,")"),u.push({i:1,x:vu(a[0],c[0])},{i:3,x:vu(a[1],c[1])})):c[0]||c[1]?r.push("translate("+c+")"):r.push(""),l!=s?(l-s>180?s+=360:s-l>180&&(l+=360),u.push({i:r.push(r.pop()+"rotate(",null,")")-2,x:vu(l,s)})):s&&r.push(r.pop()+"rotate("+s+")"),f!=h?u.push({i:r.push(r.pop()+"skewX(",null,")")-2,x:vu(f,h)}):h&&r.push(r.pop()+"skewX("+h+")"),g[0]!=p[0]||g[1]!=p[1]?(e=r.push(r.pop()+"scale(",null,",",null,")"),u.push({i:e-4,x:vu(g[0],p[0])},{i:e-2,x:vu(g[1],p[1])})):(1!=p[0]||1!=p[1])&&r.push(r.pop()+"scale("+p+")"),e=u.length,function(n){for(var t,i=-1;++i<e;)r[(t=u[i]).i]=t.x(n);return r.join("")}}function Ou(n,t){return t=(t-=n=+n)||1/t,function(e){return(e-n)/t}}function Yu(n,t){return t=(t-=n=+n)||1/t,function(e){return Math.max(0,Math.min(1,(e-n)/t))}}function Iu(n){for(var t=n.source,e=n.target,r=Vu(t,e),u=[t];t!==r;)t=t.parent,u.push(t);for(var i=u.length;e!==r;)u.splice(i,0,e),e=e.parent;return u}function Zu(n){for(var t=[],e=n.parent;null!=e;)t.push(n),n=e,e=e.parent;return t.push(n),t}function Vu(n,t){if(n===t)return n;for(var e=Zu(n),r=Zu(t),u=e.pop(),i=r.pop(),o=null;u===i;)o=u,u=e.pop(),i=r.pop();return o}function Xu(n){n.fixed|=2}function $u(n){n.fixed&=-7}function Bu(n){n.fixed|=4,n.px=n.x,n.py=n.y}function Wu(n){n.fixed&=-5}function Ju(n,t,e){var r=0,u=0;if(n.charge=0,!n.leaf)for(var i,o=n.nodes,a=o.length,c=-1;++c<a;)i=o[c],null!=i&&(Ju(i,t,e),n.charge+=i.charge,r+=i.charge*i.cx,u+=i.charge*i.cy);if(n.point){n.leaf||(n.point.x+=Math.random()-.5,n.point.y+=Math.random()-.5);var l=t*e[n.point.index];n.charge+=n.pointCharge=l,r+=l*n.point.x,u+=l*n.point.y}n.cx=r/n.charge,n.cy=u/n.charge}function Gu(n,t){return ta.rebind(n,t,"sort","children","value"),n.nodes=n,n.links=ri,n}function Ku(n,t){for(var e=[n];null!=(n=e.pop());)if(t(n),(u=n.children)&&(r=u.length))for(var r,u;--r>=0;)e.push(u[r])}function Qu(n,t){for(var e=[n],r=[];null!=(n=e.pop());)if(r.push(n),(i=n.children)&&(u=i.length))for(var u,i,o=-1;++o<u;)e.push(i[o]);for(;null!=(n=r.pop());)t(n)}function ni(n){return n.children}function ti(n){return n.value}function ei(n,t){return t.value-n.value}function ri(n){return ta.merge(n.map(function(n){return(n.children||[]).map(function(t){return{source:n,target:t}})}))}function ui(n){return n.x}function ii(n){return n.y}function oi(n,t,e){n.y0=t,n.y=e}function ai(n){return ta.range(n.length)}function ci(n){for(var t=-1,e=n[0].length,r=[];++t<e;)r[t]=0;return r}function li(n){for(var t,e=1,r=0,u=n[0][1],i=n.length;i>e;++e)(t=n[e][1])>u&&(r=e,u=t);return r}function si(n){return n.reduce(fi,0)}function fi(n,t){return n+t[1]}function hi(n,t){return gi(n,Math.ceil(Math.log(t.length)/Math.LN2+1))}function gi(n,t){for(var e=-1,r=+n[0],u=(n[1]-r)/t,i=[];++e<=t;)i[e]=u*e+r;return i}function pi(n){return[ta.min(n),ta.max(n)]}function vi(n,t){return n.value-t.value}function di(n,t){var e=n._pack_next;n._pack_next=t,t._pack_prev=n,t._pack_next=e,e._pack_prev=t}function mi(n,t){n._pack_next=t,t._pack_prev=n}function yi(n,t){var e=t.x-n.x,r=t.y-n.y,u=n.r+t.r;return.999*u*u>e*e+r*r}function Mi(n){function t(n){s=Math.min(n.x-n.r,s),f=Math.max(n.x+n.r,f),h=Math.min(n.y-n.r,h),g=Math.max(n.y+n.r,g)}if((e=n.children)&&(l=e.length)){var e,r,u,i,o,a,c,l,s=1/0,f=-1/0,h=1/0,g=-1/0;if(e.forEach(xi),r=e[0],r.x=-r.r,r.y=0,t(r),l>1&&(u=e[1],u.x=u.r,u.y=0,t(u),l>2))for(i=e[2],wi(r,u,i),t(i),di(r,i),r._pack_prev=i,di(i,u),u=r._pack_next,o=3;l>o;o++){wi(r,u,i=e[o]);var p=0,v=1,d=1;for(a=u._pack_next;a!==u;a=a._pack_next,v++)if(yi(a,i)){p=1;break}if(1==p)for(c=r._pack_prev;c!==a._pack_prev&&!yi(c,i);c=c._pack_prev,d++);p?(d>v||v==d&&u.r<r.r?mi(r,u=a):mi(r=c,u),o--):(di(r,i),u=i,t(i))}var m=(s+f)/2,y=(h+g)/2,M=0;for(o=0;l>o;o++)i=e[o],i.x-=m,i.y-=y,M=Math.max(M,i.r+Math.sqrt(i.x*i.x+i.y*i.y));n.r=M,e.forEach(bi)}}function xi(n){n._pack_next=n._pack_prev=n}function bi(n){delete n._pack_next,delete n._pack_prev}function _i(n,t,e,r){var u=n.children;if(n.x=t+=r*n.x,n.y=e+=r*n.y,n.r*=r,u)for(var i=-1,o=u.length;++i<o;)_i(u[i],t,e,r)}function wi(n,t,e){var r=n.r+e.r,u=t.x-n.x,i=t.y-n.y;if(r&&(u||i)){var o=t.r+e.r,a=u*u+i*i;o*=o,r*=r;var c=.5+(r-o)/(2*a),l=Math.sqrt(Math.max(0,2*o*(r+a)-(r-=a)*r-o*o))/(2*a);e.x=n.x+c*u+l*i,e.y=n.y+c*i-l*u}else e.x=n.x+r,e.y=n.y}function Si(n,t){return n.parent==t.parent?1:2}function ki(n){var t=n.children;return t.length?t[0]:n.t}function Ei(n){var t,e=n.children;return(t=e.length)?e[t-1]:n.t}function Ai(n,t,e){var r=e/(t.i-n.i);t.c-=r,t.s+=e,n.c+=r,t.z+=e,t.m+=e}function Ni(n){for(var t,e=0,r=0,u=n.children,i=u.length;--i>=0;)t=u[i],t.z+=e,t.m+=e,e+=t.s+(r+=t.c)}function Ci(n,t,e){return n.a.parent===t.parent?n.a:e}function zi(n){return 1+ta.max(n,function(n){return n.y})}function qi(n){return n.reduce(function(n,t){return n+t.x},0)/n.length}function Li(n){var t=n.children;return t&&t.length?Li(t[0]):n}function Ti(n){var t,e=n.children;return e&&(t=e.length)?Ti(e[t-1]):n}function Ri(n){return{x:n.x,y:n.y,dx:n.dx,dy:n.dy}}function Di(n,t){var e=n.x+t[3],r=n.y+t[0],u=n.dx-t[1]-t[3],i=n.dy-t[0]-t[2];return 0>u&&(e+=u/2,u=0),0>i&&(r+=i/2,i=0),{x:e,y:r,dx:u,dy:i}}function Pi(n){var t=n[0],e=n[n.length-1];return e>t?[t,e]:[e,t]}function Ui(n){return n.rangeExtent?n.rangeExtent():Pi(n.range())}function ji(n,t,e,r){var u=e(n[0],n[1]),i=r(t[0],t[1]);return function(n){return i(u(n))}}function Fi(n,t){var e,r=0,u=n.length-1,i=n[r],o=n[u];return i>o&&(e=r,r=u,u=e,e=i,i=o,o=e),n[r]=t.floor(i),n[u]=t.ceil(o),n}function Hi(n){return n?{floor:function(t){return Math.floor(t/n)*n},ceil:function(t){return Math.ceil(t/n)*n}}:bl}function Oi(n,t,e,r){var u=[],i=[],o=0,a=Math.min(n.length,t.length)-1;for(n[a]<n[0]&&(n=n.slice().reverse(),t=t.slice().reverse());++o<=a;)u.push(e(n[o-1],n[o])),i.push(r(t[o-1],t[o]));return function(t){var e=ta.bisect(n,t,1,a)-1;return i[e](u[e](t))}}function Yi(n,t,e,r){function u(){var u=Math.min(n.length,t.length)>2?Oi:ji,c=r?Yu:Ou;return o=u(n,t,c,e),a=u(t,n,c,mu),i}function i(n){return o(n)}var o,a;return i.invert=function(n){return a(n)},i.domain=function(t){return arguments.length?(n=t.map(Number),u()):n},i.range=function(n){return arguments.length?(t=n,u()):t},i.rangeRound=function(n){return i.range(n).interpolate(Du)},i.clamp=function(n){return arguments.length?(r=n,u()):r},i.interpolate=function(n){return arguments.length?(e=n,u()):e},i.ticks=function(t){return Xi(n,t)},i.tickFormat=function(t,e){return $i(n,t,e)},i.nice=function(t){return Zi(n,t),u()},i.copy=function(){return Yi(n,t,e,r)},u()}function Ii(n,t){return ta.rebind(n,t,"range","rangeRound","interpolate","clamp")}function Zi(n,t){return Fi(n,Hi(Vi(n,t)[2]))}function Vi(n,t){null==t&&(t=10);var e=Pi(n),r=e[1]-e[0],u=Math.pow(10,Math.floor(Math.log(r/t)/Math.LN10)),i=t/r*u;return.15>=i?u*=10:.35>=i?u*=5:.75>=i&&(u*=2),e[0]=Math.ceil(e[0]/u)*u,e[1]=Math.floor(e[1]/u)*u+.5*u,e[2]=u,e}function Xi(n,t){return ta.range.apply(ta,Vi(n,t))}function $i(n,t,e){var r=Vi(n,t);if(e){var u=lc.exec(e);if(u.shift(),"s"===u[8]){var i=ta.formatPrefix(Math.max(va(r[0]),va(r[1])));return u[7]||(u[7]="."+Bi(i.scale(r[2]))),u[8]="f",e=ta.format(u.join("")),function(n){return e(i.scale(n))+i.symbol}}u[7]||(u[7]="."+Wi(u[8],r)),e=u.join("")}else e=",."+Bi(r[2])+"f";return ta.format(e)}function Bi(n){return-Math.floor(Math.log(n)/Math.LN10+.01)}function Wi(n,t){var e=Bi(t[2]);return n in _l?Math.abs(e-Bi(Math.max(va(t[0]),va(t[1]))))+ +("e"!==n):e-2*("%"===n)}function Ji(n,t,e,r){function u(n){return(e?Math.log(0>n?0:n):-Math.log(n>0?0:-n))/Math.log(t)}function i(n){return e?Math.pow(t,n):-Math.pow(t,-n)}function o(t){return n(u(t))}return o.invert=function(t){return i(n.invert(t))},o.domain=function(t){return arguments.length?(e=t[0]>=0,n.domain((r=t.map(Number)).map(u)),o):r},o.base=function(e){return arguments.length?(t=+e,n.domain(r.map(u)),o):t},o.nice=function(){var t=Fi(r.map(u),e?Math:Sl);return n.domain(t),r=t.map(i),o},o.ticks=function(){var n=Pi(r),o=[],a=n[0],c=n[1],l=Math.floor(u(a)),s=Math.ceil(u(c)),f=t%1?2:t;if(isFinite(s-l)){if(e){for(;s>l;l++)for(var h=1;f>h;h++)o.push(i(l)*h);o.push(i(l))}else for(o.push(i(l));l++<s;)for(var h=f-1;h>0;h--)o.push(i(l)*h);for(l=0;o[l]<a;l++);for(s=o.length;o[s-1]>c;s--);o=o.slice(l,s)}return o},o.tickFormat=function(n,t){if(!arguments.length)return wl;arguments.length<2?t=wl:"function"!=typeof t&&(t=ta.format(t));var r,a=Math.max(.1,n/o.ticks().length),c=e?(r=1e-12,Math.ceil):(r=-1e-12,Math.floor);return function(n){return n/i(c(u(n)+r))<=a?t(n):""}},o.copy=function(){return Ji(n.copy(),t,e,r)},Ii(o,n)}function Gi(n,t,e){function r(t){return n(u(t))}var u=Ki(t),i=Ki(1/t);return r.invert=function(t){return i(n.invert(t))},r.domain=function(t){return arguments.length?(n.domain((e=t.map(Number)).map(u)),r):e},r.ticks=function(n){return Xi(e,n)},r.tickFormat=function(n,t){return $i(e,n,t)},r.nice=function(n){return r.domain(Zi(e,n))},r.exponent=function(o){return arguments.length?(u=Ki(t=o),i=Ki(1/t),n.domain(e.map(u)),r):t},r.copy=function(){return Gi(n.copy(),t,e)},Ii(r,n)}function Ki(n){return function(t){return 0>t?-Math.pow(-t,n):Math.pow(t,n)}}function Qi(n,t){function e(e){return i[((u.get(e)||("range"===t.t?u.set(e,n.push(e)):0/0))-1)%i.length]}function r(t,e){return ta.range(n.length).map(function(n){return t+e*n})}var u,i,o;return e.domain=function(r){if(!arguments.length)return n;n=[],u=new a;for(var i,o=-1,c=r.length;++o<c;)u.has(i=r[o])||u.set(i,n.push(i));return e[t.t].apply(e,t.a)},e.range=function(n){return arguments.length?(i=n,o=0,t={t:"range",a:arguments},e):i},e.rangePoints=function(u,a){arguments.length<2&&(a=0);var c=u[0],l=u[1],s=n.length<2?(c=(c+l)/2,0):(l-c)/(n.length-1+a);return i=r(c+s*a/2,s),o=0,t={t:"rangePoints",a:arguments},e},e.rangeRoundPoints=function(u,a){arguments.length<2&&(a=0);var c=u[0],l=u[1],s=n.length<2?(c=l=Math.round((c+l)/2),0):0|(l-c)/(n.length-1+a);return i=r(c+Math.round(s*a/2+(l-c-(n.length-1+a)*s)/2),s),o=0,t={t:"rangeRoundPoints",a:arguments},e},e.rangeBands=function(u,a,c){arguments.length<2&&(a=0),arguments.length<3&&(c=a);var l=u[1]<u[0],s=u[l-0],f=u[1-l],h=(f-s)/(n.length-a+2*c);return i=r(s+h*c,h),l&&i.reverse(),o=h*(1-a),t={t:"rangeBands",a:arguments},e},e.rangeRoundBands=function(u,a,c){arguments.length<2&&(a=0),arguments.length<3&&(c=a);var l=u[1]<u[0],s=u[l-0],f=u[1-l],h=Math.floor((f-s)/(n.length-a+2*c));return i=r(s+Math.round((f-s-(n.length-a)*h)/2),h),l&&i.reverse(),o=Math.round(h*(1-a)),t={t:"rangeRoundBands",a:arguments},e},e.rangeBand=function(){return o},e.rangeExtent=function(){return Pi(t.a[0])},e.copy=function(){return Qi(n,t)},e.domain(n)}function no(r,u){function i(){var n=0,t=u.length;for(a=[];++n<t;)a[n-1]=ta.quantile(r,n/t);return o}function o(n){return isNaN(n=+n)?void 0:u[ta.bisect(a,n)]}var a;return o.domain=function(u){return arguments.length?(r=u.map(t).filter(e).sort(n),i()):r},o.range=function(n){return arguments.length?(u=n,i()):u},o.quantiles=function(){return a},o.invertExtent=function(n){return n=u.indexOf(n),0>n?[0/0,0/0]:[n>0?a[n-1]:r[0],n<a.length?a[n]:r[r.length-1]]},o.copy=function(){return no(r,u)},i()}function to(n,t,e){function r(t){return e[Math.max(0,Math.min(o,Math.floor(i*(t-n))))]}function u(){return i=e.length/(t-n),o=e.length-1,r}var i,o;return r.domain=function(e){return arguments.length?(n=+e[0],t=+e[e.length-1],u()):[n,t]},r.range=function(n){return arguments.length?(e=n,u()):e},r.invertExtent=function(t){return t=e.indexOf(t),t=0>t?0/0:t/i+n,[t,t+1/i]},r.copy=function(){return to(n,t,e)},u()}function eo(n,t){function e(e){return e>=e?t[ta.bisect(n,e)]:void 0}return e.domain=function(t){return arguments.length?(n=t,e):n},e.range=function(n){return arguments.length?(t=n,e):t},e.invertExtent=function(e){return e=t.indexOf(e),[n[e-1],n[e]]},e.copy=function(){return eo(n,t)},e}function ro(n){function t(n){return+n}return t.invert=t,t.domain=t.range=function(e){return arguments.length?(n=e.map(t),t):n},t.ticks=function(t){return Xi(n,t)},t.tickFormat=function(t,e){return $i(n,t,e)},t.copy=function(){return ro(n)},t}function uo(){return 0}function io(n){return n.innerRadius}function oo(n){return n.outerRadius}function ao(n){return n.startAngle}function co(n){return n.endAngle}function lo(n){return n&&n.padAngle}function so(n,t,e,r){return(n-e)*t-(t-r)*n>0?0:1}function fo(n,t,e,r,u){var i=n[0]-t[0],o=n[1]-t[1],a=(u?r:-r)/Math.sqrt(i*i+o*o),c=a*o,l=-a*i,s=n[0]+c,f=n[1]+l,h=t[0]+c,g=t[1]+l,p=(s+h)/2,v=(f+g)/2,d=h-s,m=g-f,y=d*d+m*m,M=e-r,x=s*g-h*f,b=(0>m?-1:1)*Math.sqrt(M*M*y-x*x),_=(x*m-d*b)/y,w=(-x*d-m*b)/y,S=(x*m+d*b)/y,k=(-x*d+m*b)/y,E=_-p,A=w-v,N=S-p,C=k-v;return E*E+A*A>N*N+C*C&&(_=S,w=k),[[_-c,w-l],[_*e/M,w*e/M]]}function ho(n){function t(t){function o(){l.push("M",i(n(s),a))}for(var c,l=[],s=[],f=-1,h=t.length,g=kt(e),p=kt(r);++f<h;)u.call(this,c=t[f],f)?s.push([+g.call(this,c,f),+p.call(this,c,f)]):s.length&&(o(),s=[]);return s.length&&o(),l.length?l.join(""):null}var e=Ar,r=Nr,u=Ne,i=go,o=i.key,a=.7;return t.x=function(n){return arguments.length?(e=n,t):e},t.y=function(n){return arguments.length?(r=n,t):r},t.defined=function(n){return arguments.length?(u=n,t):u},t.interpolate=function(n){return arguments.length?(o="function"==typeof n?i=n:(i=zl.get(n)||go).key,t):o},t.tension=function(n){return arguments.length?(a=n,t):a},t}function go(n){return n.join("L")}function po(n){return go(n)+"Z"}function vo(n){for(var t=0,e=n.length,r=n[0],u=[r[0],",",r[1]];++t<e;)u.push("H",(r[0]+(r=n[t])[0])/2,"V",r[1]);return e>1&&u.push("H",r[0]),u.join("")}function mo(n){for(var t=0,e=n.length,r=n[0],u=[r[0],",",r[1]];++t<e;)u.push("V",(r=n[t])[1],"H",r[0]);return u.join("")}function yo(n){for(var t=0,e=n.length,r=n[0],u=[r[0],",",r[1]];++t<e;)u.push("H",(r=n[t])[0],"V",r[1]);return u.join("")}function Mo(n,t){return n.length<4?go(n):n[1]+_o(n.slice(1,-1),wo(n,t))}function xo(n,t){return n.length<3?go(n):n[0]+_o((n.push(n[0]),n),wo([n[n.length-2]].concat(n,[n[1]]),t))}function bo(n,t){return n.length<3?go(n):n[0]+_o(n,wo(n,t))}function _o(n,t){if(t.length<1||n.length!=t.length&&n.length!=t.length+2)return go(n);var e=n.length!=t.length,r="",u=n[0],i=n[1],o=t[0],a=o,c=1;if(e&&(r+="Q"+(i[0]-2*o[0]/3)+","+(i[1]-2*o[1]/3)+","+i[0]+","+i[1],u=n[1],c=2),t.length>1){a=t[1],i=n[c],c++,r+="C"+(u[0]+o[0])+","+(u[1]+o[1])+","+(i[0]-a[0])+","+(i[1]-a[1])+","+i[0]+","+i[1];for(var l=2;l<t.length;l++,c++)i=n[c],a=t[l],r+="S"+(i[0]-a[0])+","+(i[1]-a[1])+","+i[0]+","+i[1]}if(e){var s=n[c];r+="Q"+(i[0]+2*a[0]/3)+","+(i[1]+2*a[1]/3)+","+s[0]+","+s[1]}return r}function wo(n,t){for(var e,r=[],u=(1-t)/2,i=n[0],o=n[1],a=1,c=n.length;++a<c;)e=i,i=o,o=n[a],r.push([u*(o[0]-e[0]),u*(o[1]-e[1])]);return r}function So(n){if(n.length<3)return go(n);var t=1,e=n.length,r=n[0],u=r[0],i=r[1],o=[u,u,u,(r=n[1])[0]],a=[i,i,i,r[1]],c=[u,",",i,"L",No(Tl,o),",",No(Tl,a)];for(n.push(n[e-1]);++t<=e;)r=n[t],o.shift(),o.push(r[0]),a.shift(),a.push(r[1]),Co(c,o,a);return n.pop(),c.push("L",r),c.join("")}function ko(n){if(n.length<4)return go(n);for(var t,e=[],r=-1,u=n.length,i=[0],o=[0];++r<3;)t=n[r],i.push(t[0]),o.push(t[1]);for(e.push(No(Tl,i)+","+No(Tl,o)),--r;++r<u;)t=n[r],i.shift(),i.push(t[0]),o.shift(),o.push(t[1]),Co(e,i,o);return e.join("")}function Eo(n){for(var t,e,r=-1,u=n.length,i=u+4,o=[],a=[];++r<4;)e=n[r%u],o.push(e[0]),a.push(e[1]);for(t=[No(Tl,o),",",No(Tl,a)],--r;++r<i;)e=n[r%u],o.shift(),o.push(e[0]),a.shift(),a.push(e[1]),Co(t,o,a);return t.join("")}function Ao(n,t){var e=n.length-1;if(e)for(var r,u,i=n[0][0],o=n[0][1],a=n[e][0]-i,c=n[e][1]-o,l=-1;++l<=e;)r=n[l],u=l/e,r[0]=t*r[0]+(1-t)*(i+u*a),r[1]=t*r[1]+(1-t)*(o+u*c);return So(n)}function No(n,t){return n[0]*t[0]+n[1]*t[1]+n[2]*t[2]+n[3]*t[3]}function Co(n,t,e){n.push("C",No(ql,t),",",No(ql,e),",",No(Ll,t),",",No(Ll,e),",",No(Tl,t),",",No(Tl,e))}function zo(n,t){return(t[1]-n[1])/(t[0]-n[0])}function qo(n){for(var t=0,e=n.length-1,r=[],u=n[0],i=n[1],o=r[0]=zo(u,i);++t<e;)r[t]=(o+(o=zo(u=i,i=n[t+1])))/2;return r[t]=o,r}function Lo(n){for(var t,e,r,u,i=[],o=qo(n),a=-1,c=n.length-1;++a<c;)t=zo(n[a],n[a+1]),va(t)<Ta?o[a]=o[a+1]=0:(e=o[a]/t,r=o[a+1]/t,u=e*e+r*r,u>9&&(u=3*t/Math.sqrt(u),o[a]=u*e,o[a+1]=u*r));for(a=-1;++a<=c;)u=(n[Math.min(c,a+1)][0]-n[Math.max(0,a-1)][0])/(6*(1+o[a]*o[a])),i.push([u||0,o[a]*u||0]);return i}function To(n){return n.length<3?go(n):n[0]+_o(n,Lo(n))}function Ro(n){for(var t,e,r,u=-1,i=n.length;++u<i;)t=n[u],e=t[0],r=t[1]-ja,t[0]=e*Math.cos(r),t[1]=e*Math.sin(r);return n}function Do(n){function t(t){function c(){v.push("M",a(n(m),f),s,l(n(d.reverse()),f),"Z")}for(var h,g,p,v=[],d=[],m=[],y=-1,M=t.length,x=kt(e),b=kt(u),_=e===r?function(){return g}:kt(r),w=u===i?function(){return p}:kt(i);++y<M;)o.call(this,h=t[y],y)?(d.push([g=+x.call(this,h,y),p=+b.call(this,h,y)]),m.push([+_.call(this,h,y),+w.call(this,h,y)])):d.length&&(c(),d=[],m=[]);return d.length&&c(),v.length?v.join(""):null}var e=Ar,r=Ar,u=0,i=Nr,o=Ne,a=go,c=a.key,l=a,s="L",f=.7;return t.x=function(n){return arguments.length?(e=r=n,t):r},t.x0=function(n){return arguments.length?(e=n,t):e},t.x1=function(n){return arguments.length?(r=n,t):r},t.y=function(n){return arguments.length?(u=i=n,t):i},t.y0=function(n){return arguments.length?(u=n,t):u},t.y1=function(n){return arguments.length?(i=n,t):i},t.defined=function(n){return arguments.length?(o=n,t):o},t.interpolate=function(n){return arguments.length?(c="function"==typeof n?a=n:(a=zl.get(n)||go).key,l=a.reverse||a,s=a.closed?"M":"L",t):c
	},t.tension=function(n){return arguments.length?(f=n,t):f},t}function Po(n){return n.radius}function Uo(n){return[n.x,n.y]}function jo(n){return function(){var t=n.apply(this,arguments),e=t[0],r=t[1]-ja;return[e*Math.cos(r),e*Math.sin(r)]}}function Fo(){return 64}function Ho(){return"circle"}function Oo(n){var t=Math.sqrt(n/Da);return"M0,"+t+"A"+t+","+t+" 0 1,1 0,"+-t+"A"+t+","+t+" 0 1,1 0,"+t+"Z"}function Yo(n){return function(){var t,e;(t=this[n])&&(e=t[t.active])&&(--t.count?delete t[t.active]:delete this[n],t.active+=.5,e.event&&e.event.interrupt.call(this,this.__data__,e.index))}}function Io(n,t,e){return xa(n,Hl),n.namespace=t,n.id=e,n}function Zo(n,t,e,r){var u=n.id,i=n.namespace;return H(n,"function"==typeof e?function(n,o,a){n[i][u].tween.set(t,r(e.call(n,n.__data__,o,a)))}:(e=r(e),function(n){n[i][u].tween.set(t,e)}))}function Vo(n){return null==n&&(n=""),function(){this.textContent=n}}function Xo(n){return null==n?"__transition__":"__transition_"+n+"__"}function $o(n,t,e,r,u){var i=n[e]||(n[e]={active:0,count:0}),o=i[r];if(!o){var c=u.time;o=i[r]={tween:new a,time:c,delay:u.delay,duration:u.duration,ease:u.ease,index:t},u=null,++i.count,ta.timer(function(u){function a(e){if(i.active>r)return s();var u=i[i.active];u&&(--i.count,delete i[i.active],u.event&&u.event.interrupt.call(n,n.__data__,u.index)),i.active=r,o.event&&o.event.start.call(n,n.__data__,t),o.tween.forEach(function(e,r){(r=r.call(n,n.__data__,t))&&v.push(r)}),h=o.ease,f=o.duration,ta.timer(function(){return p.c=l(e||1)?Ne:l,1},0,c)}function l(e){if(i.active!==r)return 1;for(var u=e/f,a=h(u),c=v.length;c>0;)v[--c].call(n,a);return u>=1?(o.event&&o.event.end.call(n,n.__data__,t),s()):void 0}function s(){return--i.count?delete i[r]:delete n[e],1}var f,h,g=o.delay,p=oc,v=[];return p.t=g+c,u>=g?a(u-g):(p.c=a,void 0)},0,c)}}function Bo(n,t,e){n.attr("transform",function(n){var r=t(n);return"translate("+(isFinite(r)?r:e(n))+",0)"})}function Wo(n,t,e){n.attr("transform",function(n){var r=t(n);return"translate(0,"+(isFinite(r)?r:e(n))+")"})}function Jo(n){return n.toISOString()}function Go(n,t,e){function r(t){return n(t)}function u(n,e){var r=n[1]-n[0],u=r/e,i=ta.bisect(Wl,u);return i==Wl.length?[t.year,Vi(n.map(function(n){return n/31536e6}),e)[2]]:i?t[u/Wl[i-1]<Wl[i]/u?i-1:i]:[Kl,Vi(n,e)[2]]}return r.invert=function(t){return Ko(n.invert(t))},r.domain=function(t){return arguments.length?(n.domain(t),r):n.domain().map(Ko)},r.nice=function(n,t){function e(e){return!isNaN(e)&&!n.range(e,Ko(+e+1),t).length}var i=r.domain(),o=Pi(i),a=null==n?u(o,10):"number"==typeof n&&u(o,n);return a&&(n=a[0],t=a[1]),r.domain(Fi(i,t>1?{floor:function(t){for(;e(t=n.floor(t));)t=Ko(t-1);return t},ceil:function(t){for(;e(t=n.ceil(t));)t=Ko(+t+1);return t}}:n))},r.ticks=function(n,t){var e=Pi(r.domain()),i=null==n?u(e,10):"number"==typeof n?u(e,n):!n.range&&[{range:n},t];return i&&(n=i[0],t=i[1]),n.range(e[0],Ko(+e[1]+1),1>t?1:t)},r.tickFormat=function(){return e},r.copy=function(){return Go(n.copy(),t,e)},Ii(r,n)}function Ko(n){return new Date(n)}function Qo(n){return JSON.parse(n.responseText)}function na(n){var t=ua.createRange();return t.selectNode(ua.body),t.createContextualFragment(n.responseText)}var ta={version:"3.5.3"};Date.now||(Date.now=function(){return+new Date});var ea=[].slice,ra=function(n){return ea.call(n)},ua=document,ia=ua.documentElement,oa=window;try{ra(ia.childNodes)[0].nodeType}catch(aa){ra=function(n){for(var t=n.length,e=new Array(t);t--;)e[t]=n[t];return e}}try{ua.createElement("div").style.setProperty("opacity",0,"")}catch(ca){var la=oa.Element.prototype,sa=la.setAttribute,fa=la.setAttributeNS,ha=oa.CSSStyleDeclaration.prototype,ga=ha.setProperty;la.setAttribute=function(n,t){sa.call(this,n,t+"")},la.setAttributeNS=function(n,t,e){fa.call(this,n,t,e+"")},ha.setProperty=function(n,t,e){ga.call(this,n,t+"",e)}}ta.ascending=n,ta.descending=function(n,t){return n>t?-1:t>n?1:t>=n?0:0/0},ta.min=function(n,t){var e,r,u=-1,i=n.length;if(1===arguments.length){for(;++u<i;)if(null!=(r=n[u])&&r>=r){e=r;break}for(;++u<i;)null!=(r=n[u])&&e>r&&(e=r)}else{for(;++u<i;)if(null!=(r=t.call(n,n[u],u))&&r>=r){e=r;break}for(;++u<i;)null!=(r=t.call(n,n[u],u))&&e>r&&(e=r)}return e},ta.max=function(n,t){var e,r,u=-1,i=n.length;if(1===arguments.length){for(;++u<i;)if(null!=(r=n[u])&&r>=r){e=r;break}for(;++u<i;)null!=(r=n[u])&&r>e&&(e=r)}else{for(;++u<i;)if(null!=(r=t.call(n,n[u],u))&&r>=r){e=r;break}for(;++u<i;)null!=(r=t.call(n,n[u],u))&&r>e&&(e=r)}return e},ta.extent=function(n,t){var e,r,u,i=-1,o=n.length;if(1===arguments.length){for(;++i<o;)if(null!=(r=n[i])&&r>=r){e=u=r;break}for(;++i<o;)null!=(r=n[i])&&(e>r&&(e=r),r>u&&(u=r))}else{for(;++i<o;)if(null!=(r=t.call(n,n[i],i))&&r>=r){e=u=r;break}for(;++i<o;)null!=(r=t.call(n,n[i],i))&&(e>r&&(e=r),r>u&&(u=r))}return[e,u]},ta.sum=function(n,t){var r,u=0,i=n.length,o=-1;if(1===arguments.length)for(;++o<i;)e(r=+n[o])&&(u+=r);else for(;++o<i;)e(r=+t.call(n,n[o],o))&&(u+=r);return u},ta.mean=function(n,r){var u,i=0,o=n.length,a=-1,c=o;if(1===arguments.length)for(;++a<o;)e(u=t(n[a]))?i+=u:--c;else for(;++a<o;)e(u=t(r.call(n,n[a],a)))?i+=u:--c;return c?i/c:void 0},ta.quantile=function(n,t){var e=(n.length-1)*t+1,r=Math.floor(e),u=+n[r-1],i=e-r;return i?u+i*(n[r]-u):u},ta.median=function(r,u){var i,o=[],a=r.length,c=-1;if(1===arguments.length)for(;++c<a;)e(i=t(r[c]))&&o.push(i);else for(;++c<a;)e(i=t(u.call(r,r[c],c)))&&o.push(i);return o.length?ta.quantile(o.sort(n),.5):void 0},ta.variance=function(n,r){var u,i,o=n.length,a=0,c=0,l=-1,s=0;if(1===arguments.length)for(;++l<o;)e(u=t(n[l]))&&(i=u-a,a+=i/++s,c+=i*(u-a));else for(;++l<o;)e(u=t(r.call(n,n[l],l)))&&(i=u-a,a+=i/++s,c+=i*(u-a));return s>1?c/(s-1):void 0},ta.deviation=function(){var n=ta.variance.apply(this,arguments);return n?Math.sqrt(n):n};var pa=r(n);ta.bisectLeft=pa.left,ta.bisect=ta.bisectRight=pa.right,ta.bisector=function(t){return r(1===t.length?function(e,r){return n(t(e),r)}:t)},ta.shuffle=function(n,t,e){(i=arguments.length)<3&&(e=n.length,2>i&&(t=0));for(var r,u,i=e-t;i;)u=0|Math.random()*i--,r=n[i+t],n[i+t]=n[u+t],n[u+t]=r;return n},ta.permute=function(n,t){for(var e=t.length,r=new Array(e);e--;)r[e]=n[t[e]];return r},ta.pairs=function(n){for(var t,e=0,r=n.length-1,u=n[0],i=new Array(0>r?0:r);r>e;)i[e]=[t=u,u=n[++e]];return i},ta.zip=function(){if(!(r=arguments.length))return[];for(var n=-1,t=ta.min(arguments,u),e=new Array(t);++n<t;)for(var r,i=-1,o=e[n]=new Array(r);++i<r;)o[i]=arguments[i][n];return e},ta.transpose=function(n){return ta.zip.apply(ta,n)},ta.keys=function(n){var t=[];for(var e in n)t.push(e);return t},ta.values=function(n){var t=[];for(var e in n)t.push(n[e]);return t},ta.entries=function(n){var t=[];for(var e in n)t.push({key:e,value:n[e]});return t},ta.merge=function(n){for(var t,e,r,u=n.length,i=-1,o=0;++i<u;)o+=n[i].length;for(e=new Array(o);--u>=0;)for(r=n[u],t=r.length;--t>=0;)e[--o]=r[t];return e};var va=Math.abs;ta.range=function(n,t,e){if(arguments.length<3&&(e=1,arguments.length<2&&(t=n,n=0)),1/0===(t-n)/e)throw new Error("infinite range");var r,u=[],o=i(va(e)),a=-1;if(n*=o,t*=o,e*=o,0>e)for(;(r=n+e*++a)>t;)u.push(r/o);else for(;(r=n+e*++a)<t;)u.push(r/o);return u},ta.map=function(n,t){var e=new a;if(n instanceof a)n.forEach(function(n,t){e.set(n,t)});else if(Array.isArray(n)){var r,u=-1,i=n.length;if(1===arguments.length)for(;++u<i;)e.set(u,n[u]);else for(;++u<i;)e.set(t.call(n,r=n[u],u),r)}else for(var o in n)e.set(o,n[o]);return e};var da="__proto__",ma="\x00";o(a,{has:s,get:function(n){return this._[c(n)]},set:function(n,t){return this._[c(n)]=t},remove:f,keys:h,values:function(){var n=[];for(var t in this._)n.push(this._[t]);return n},entries:function(){var n=[];for(var t in this._)n.push({key:l(t),value:this._[t]});return n},size:g,empty:p,forEach:function(n){for(var t in this._)n.call(this,l(t),this._[t])}}),ta.nest=function(){function n(t,o,c){if(c>=i.length)return r?r.call(u,o):e?o.sort(e):o;for(var l,s,f,h,g=-1,p=o.length,v=i[c++],d=new a;++g<p;)(h=d.get(l=v(s=o[g])))?h.push(s):d.set(l,[s]);return t?(s=t(),f=function(e,r){s.set(e,n(t,r,c))}):(s={},f=function(e,r){s[e]=n(t,r,c)}),d.forEach(f),s}function t(n,e){if(e>=i.length)return n;var r=[],u=o[e++];return n.forEach(function(n,u){r.push({key:n,values:t(u,e)})}),u?r.sort(function(n,t){return u(n.key,t.key)}):r}var e,r,u={},i=[],o=[];return u.map=function(t,e){return n(e,t,0)},u.entries=function(e){return t(n(ta.map,e,0),0)},u.key=function(n){return i.push(n),u},u.sortKeys=function(n){return o[i.length-1]=n,u},u.sortValues=function(n){return e=n,u},u.rollup=function(n){return r=n,u},u},ta.set=function(n){var t=new v;if(n)for(var e=0,r=n.length;r>e;++e)t.add(n[e]);return t},o(v,{has:s,add:function(n){return this._[c(n+="")]=!0,n},remove:f,values:h,size:g,empty:p,forEach:function(n){for(var t in this._)n.call(this,l(t))}}),ta.behavior={},ta.rebind=function(n,t){for(var e,r=1,u=arguments.length;++r<u;)n[e=arguments[r]]=d(n,t,t[e]);return n};var ya=["webkit","ms","moz","Moz","o","O"];ta.dispatch=function(){for(var n=new M,t=-1,e=arguments.length;++t<e;)n[arguments[t]]=x(n);return n},M.prototype.on=function(n,t){var e=n.indexOf("."),r="";if(e>=0&&(r=n.slice(e+1),n=n.slice(0,e)),n)return arguments.length<2?this[n].on(r):this[n].on(r,t);if(2===arguments.length){if(null==t)for(n in this)this.hasOwnProperty(n)&&this[n].on(r,null);return this}},ta.event=null,ta.requote=function(n){return n.replace(Ma,"\\$&")};var Ma=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g,xa={}.__proto__?function(n,t){n.__proto__=t}:function(n,t){for(var e in t)n[e]=t[e]},ba=function(n,t){return t.querySelector(n)},_a=function(n,t){return t.querySelectorAll(n)},wa=ia.matches||ia[m(ia,"matchesSelector")],Sa=function(n,t){return wa.call(n,t)};"function"==typeof Sizzle&&(ba=function(n,t){return Sizzle(n,t)[0]||null},_a=Sizzle,Sa=Sizzle.matchesSelector),ta.selection=function(){return Na};var ka=ta.selection.prototype=[];ka.select=function(n){var t,e,r,u,i=[];n=k(n);for(var o=-1,a=this.length;++o<a;){i.push(t=[]),t.parentNode=(r=this[o]).parentNode;for(var c=-1,l=r.length;++c<l;)(u=r[c])?(t.push(e=n.call(u,u.__data__,c,o)),e&&"__data__"in u&&(e.__data__=u.__data__)):t.push(null)}return S(i)},ka.selectAll=function(n){var t,e,r=[];n=E(n);for(var u=-1,i=this.length;++u<i;)for(var o=this[u],a=-1,c=o.length;++a<c;)(e=o[a])&&(r.push(t=ra(n.call(e,e.__data__,a,u))),t.parentNode=e);return S(r)};var Ea={svg:"http://www.w3.org/2000/svg",xhtml:"http://www.w3.org/1999/xhtml",xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"};ta.ns={prefix:Ea,qualify:function(n){var t=n.indexOf(":"),e=n;return t>=0&&(e=n.slice(0,t),n=n.slice(t+1)),Ea.hasOwnProperty(e)?{space:Ea[e],local:n}:n}},ka.attr=function(n,t){if(arguments.length<2){if("string"==typeof n){var e=this.node();return n=ta.ns.qualify(n),n.local?e.getAttributeNS(n.space,n.local):e.getAttribute(n)}for(t in n)this.each(A(t,n[t]));return this}return this.each(A(n,t))},ka.classed=function(n,t){if(arguments.length<2){if("string"==typeof n){var e=this.node(),r=(n=z(n)).length,u=-1;if(t=e.classList){for(;++u<r;)if(!t.contains(n[u]))return!1}else for(t=e.getAttribute("class");++u<r;)if(!C(n[u]).test(t))return!1;return!0}for(t in n)this.each(q(t,n[t]));return this}return this.each(q(n,t))},ka.style=function(n,t,e){var r=arguments.length;if(3>r){if("string"!=typeof n){2>r&&(t="");for(e in n)this.each(T(e,n[e],t));return this}if(2>r)return oa.getComputedStyle(this.node(),null).getPropertyValue(n);e=""}return this.each(T(n,t,e))},ka.property=function(n,t){if(arguments.length<2){if("string"==typeof n)return this.node()[n];for(t in n)this.each(R(t,n[t]));return this}return this.each(R(n,t))},ka.text=function(n){return arguments.length?this.each("function"==typeof n?function(){var t=n.apply(this,arguments);this.textContent=null==t?"":t}:null==n?function(){this.textContent=""}:function(){this.textContent=n}):this.node().textContent},ka.html=function(n){return arguments.length?this.each("function"==typeof n?function(){var t=n.apply(this,arguments);this.innerHTML=null==t?"":t}:null==n?function(){this.innerHTML=""}:function(){this.innerHTML=n}):this.node().innerHTML},ka.append=function(n){return n=D(n),this.select(function(){return this.appendChild(n.apply(this,arguments))})},ka.insert=function(n,t){return n=D(n),t=k(t),this.select(function(){return this.insertBefore(n.apply(this,arguments),t.apply(this,arguments)||null)})},ka.remove=function(){return this.each(P)},ka.data=function(n,t){function e(n,e){var r,u,i,o=n.length,f=e.length,h=Math.min(o,f),g=new Array(f),p=new Array(f),v=new Array(o);if(t){var d,m=new a,y=new Array(o);for(r=-1;++r<o;)m.has(d=t.call(u=n[r],u.__data__,r))?v[r]=u:m.set(d,u),y[r]=d;for(r=-1;++r<f;)(u=m.get(d=t.call(e,i=e[r],r)))?u!==!0&&(g[r]=u,u.__data__=i):p[r]=U(i),m.set(d,!0);for(r=-1;++r<o;)m.get(y[r])!==!0&&(v[r]=n[r])}else{for(r=-1;++r<h;)u=n[r],i=e[r],u?(u.__data__=i,g[r]=u):p[r]=U(i);for(;f>r;++r)p[r]=U(e[r]);for(;o>r;++r)v[r]=n[r]}p.update=g,p.parentNode=g.parentNode=v.parentNode=n.parentNode,c.push(p),l.push(g),s.push(v)}var r,u,i=-1,o=this.length;if(!arguments.length){for(n=new Array(o=(r=this[0]).length);++i<o;)(u=r[i])&&(n[i]=u.__data__);return n}var c=O([]),l=S([]),s=S([]);if("function"==typeof n)for(;++i<o;)e(r=this[i],n.call(r,r.parentNode.__data__,i));else for(;++i<o;)e(r=this[i],n);return l.enter=function(){return c},l.exit=function(){return s},l},ka.datum=function(n){return arguments.length?this.property("__data__",n):this.property("__data__")},ka.filter=function(n){var t,e,r,u=[];"function"!=typeof n&&(n=j(n));for(var i=0,o=this.length;o>i;i++){u.push(t=[]),t.parentNode=(e=this[i]).parentNode;for(var a=0,c=e.length;c>a;a++)(r=e[a])&&n.call(r,r.__data__,a,i)&&t.push(r)}return S(u)},ka.order=function(){for(var n=-1,t=this.length;++n<t;)for(var e,r=this[n],u=r.length-1,i=r[u];--u>=0;)(e=r[u])&&(i&&i!==e.nextSibling&&i.parentNode.insertBefore(e,i),i=e);return this},ka.sort=function(n){n=F.apply(this,arguments);for(var t=-1,e=this.length;++t<e;)this[t].sort(n);return this.order()},ka.each=function(n){return H(this,function(t,e,r){n.call(t,t.__data__,e,r)})},ka.call=function(n){var t=ra(arguments);return n.apply(t[0]=this,t),this},ka.empty=function(){return!this.node()},ka.node=function(){for(var n=0,t=this.length;t>n;n++)for(var e=this[n],r=0,u=e.length;u>r;r++){var i=e[r];if(i)return i}return null},ka.size=function(){var n=0;return H(this,function(){++n}),n};var Aa=[];ta.selection.enter=O,ta.selection.enter.prototype=Aa,Aa.append=ka.append,Aa.empty=ka.empty,Aa.node=ka.node,Aa.call=ka.call,Aa.size=ka.size,Aa.select=function(n){for(var t,e,r,u,i,o=[],a=-1,c=this.length;++a<c;){r=(u=this[a]).update,o.push(t=[]),t.parentNode=u.parentNode;for(var l=-1,s=u.length;++l<s;)(i=u[l])?(t.push(r[l]=e=n.call(u.parentNode,i.__data__,l,a)),e.__data__=i.__data__):t.push(null)}return S(o)},Aa.insert=function(n,t){return arguments.length<2&&(t=Y(this)),ka.insert.call(this,n,t)},ta.select=function(n){var t=["string"==typeof n?ba(n,ua):n];return t.parentNode=ia,S([t])},ta.selectAll=function(n){var t=ra("string"==typeof n?_a(n,ua):n);return t.parentNode=ia,S([t])};var Na=ta.select(ia);ka.on=function(n,t,e){var r=arguments.length;if(3>r){if("string"!=typeof n){2>r&&(t=!1);for(e in n)this.each(I(e,n[e],t));return this}if(2>r)return(r=this.node()["__on"+n])&&r._;e=!1}return this.each(I(n,t,e))};var Ca=ta.map({mouseenter:"mouseover",mouseleave:"mouseout"});Ca.forEach(function(n){"on"+n in ua&&Ca.remove(n)});var za="onselectstart"in ua?null:m(ia.style,"userSelect"),qa=0;ta.mouse=function(n){return $(n,_())};var La=/WebKit/.test(oa.navigator.userAgent)?-1:0;ta.touch=function(n,t,e){if(arguments.length<3&&(e=t,t=_().changedTouches),t)for(var r,u=0,i=t.length;i>u;++u)if((r=t[u]).identifier===e)return $(n,r)},ta.behavior.drag=function(){function n(){this.on("mousedown.drag",u).on("touchstart.drag",i)}function t(n,t,u,i,o){return function(){function a(){var n,e,r=t(h,v);r&&(n=r[0]-M[0],e=r[1]-M[1],p|=n|e,M=r,g({type:"drag",x:r[0]+l[0],y:r[1]+l[1],dx:n,dy:e}))}function c(){t(h,v)&&(m.on(i+d,null).on(o+d,null),y(p&&ta.event.target===f),g({type:"dragend"}))}var l,s=this,f=ta.event.target,h=s.parentNode,g=e.of(s,arguments),p=0,v=n(),d=".drag"+(null==v?"":"-"+v),m=ta.select(u()).on(i+d,a).on(o+d,c),y=X(),M=t(h,v);r?(l=r.apply(s,arguments),l=[l.x-M[0],l.y-M[1]]):l=[0,0],g({type:"dragstart"})}}var e=w(n,"drag","dragstart","dragend"),r=null,u=t(y,ta.mouse,J,"mousemove","mouseup"),i=t(B,ta.touch,W,"touchmove","touchend");return n.origin=function(t){return arguments.length?(r=t,n):r},ta.rebind(n,e,"on")},ta.touches=function(n,t){return arguments.length<2&&(t=_().touches),t?ra(t).map(function(t){var e=$(n,t);return e.identifier=t.identifier,e}):[]};var Ta=1e-6,Ra=Ta*Ta,Da=Math.PI,Pa=2*Da,Ua=Pa-Ta,ja=Da/2,Fa=Da/180,Ha=180/Da,Oa=Math.SQRT2,Ya=2,Ia=4;ta.interpolateZoom=function(n,t){function e(n){var t=n*y;if(m){var e=et(v),o=i/(Ya*h)*(e*rt(Oa*t+v)-tt(v));return[r+o*l,u+o*s,i*e/et(Oa*t+v)]}return[r+n*l,u+n*s,i*Math.exp(Oa*t)]}var r=n[0],u=n[1],i=n[2],o=t[0],a=t[1],c=t[2],l=o-r,s=a-u,f=l*l+s*s,h=Math.sqrt(f),g=(c*c-i*i+Ia*f)/(2*i*Ya*h),p=(c*c-i*i-Ia*f)/(2*c*Ya*h),v=Math.log(Math.sqrt(g*g+1)-g),d=Math.log(Math.sqrt(p*p+1)-p),m=d-v,y=(m||Math.log(c/i))/Oa;return e.duration=1e3*y,e},ta.behavior.zoom=function(){function n(n){n.on(z,s).on(Xa+".zoom",h).on("dblclick.zoom",g).on(T,f)}function t(n){return[(n[0]-k.x)/k.k,(n[1]-k.y)/k.k]}function e(n){return[n[0]*k.k+k.x,n[1]*k.k+k.y]}function r(n){k.k=Math.max(A[0],Math.min(A[1],n))}function u(n,t){t=e(t),k.x+=n[0]-t[0],k.y+=n[1]-t[1]}function i(t,e,i,o){t.__chart__={x:k.x,y:k.y,k:k.k},r(Math.pow(2,o)),u(v=e,i),t=ta.select(t),N>0&&(t=t.transition().duration(N)),t.call(n.event)}function o(){x&&x.domain(M.range().map(function(n){return(n-k.x)/k.k}).map(M.invert)),S&&S.domain(_.range().map(function(n){return(n-k.y)/k.k}).map(_.invert))}function a(n){C++||n({type:"zoomstart"})}function c(n){o(),n({type:"zoom",scale:k.k,translate:[k.x,k.y]})}function l(n){--C||n({type:"zoomend"}),v=null}function s(){function n(){s=1,u(ta.mouse(r),h),c(o)}function e(){f.on(q,null).on(L,null),g(s&&ta.event.target===i),l(o)}var r=this,i=ta.event.target,o=R.of(r,arguments),s=0,f=ta.select(oa).on(q,n).on(L,e),h=t(ta.mouse(r)),g=X();Fl.call(r),a(o)}function f(){function n(){var n=ta.touches(p);return g=k.k,n.forEach(function(n){n.identifier in d&&(d[n.identifier]=t(n))}),n}function e(){var t=ta.event.target;ta.select(t).on(x,o).on(_,h),w.push(t);for(var e=ta.event.changedTouches,r=0,u=e.length;u>r;++r)d[e[r].identifier]=null;var a=n(),c=Date.now();if(1===a.length){if(500>c-y){var l=a[0];i(p,l,d[l.identifier],Math.floor(Math.log(k.k)/Math.LN2)+1),b()}y=c}else if(a.length>1){var l=a[0],s=a[1],f=l[0]-s[0],g=l[1]-s[1];m=f*f+g*g}}function o(){var n,t,e,i,o=ta.touches(p);Fl.call(p);for(var a=0,l=o.length;l>a;++a,i=null)if(e=o[a],i=d[e.identifier]){if(t)break;n=e,t=i}if(i){var s=(s=e[0]-n[0])*s+(s=e[1]-n[1])*s,f=m&&Math.sqrt(s/m);n=[(n[0]+e[0])/2,(n[1]+e[1])/2],t=[(t[0]+i[0])/2,(t[1]+i[1])/2],r(f*g)}y=null,u(n,t),c(v)}function h(){if(ta.event.touches.length){for(var t=ta.event.changedTouches,e=0,r=t.length;r>e;++e)delete d[t[e].identifier];for(var u in d)return void n()}ta.selectAll(w).on(M,null),S.on(z,s).on(T,f),E(),l(v)}var g,p=this,v=R.of(p,arguments),d={},m=0,M=".zoom-"+ta.event.changedTouches[0].identifier,x="touchmove"+M,_="touchend"+M,w=[],S=ta.select(p),E=X();e(),a(v),S.on(z,null).on(T,e)}function h(){var n=R.of(this,arguments);m?clearTimeout(m):(p=t(v=d||ta.mouse(this)),Fl.call(this),a(n)),m=setTimeout(function(){m=null,l(n)},50),b(),r(Math.pow(2,.002*Za())*k.k),u(v,p),c(n)}function g(){var n=ta.mouse(this),e=Math.log(k.k)/Math.LN2;i(this,n,t(n),ta.event.shiftKey?Math.ceil(e)-1:Math.floor(e)+1)}var p,v,d,m,y,M,x,_,S,k={x:0,y:0,k:1},E=[960,500],A=Va,N=250,C=0,z="mousedown.zoom",q="mousemove.zoom",L="mouseup.zoom",T="touchstart.zoom",R=w(n,"zoomstart","zoom","zoomend");return n.event=function(n){n.each(function(){var n=R.of(this,arguments),t=k;Ul?ta.select(this).transition().each("start.zoom",function(){k=this.__chart__||{x:0,y:0,k:1},a(n)}).tween("zoom:zoom",function(){var e=E[0],r=E[1],u=v?v[0]:e/2,i=v?v[1]:r/2,o=ta.interpolateZoom([(u-k.x)/k.k,(i-k.y)/k.k,e/k.k],[(u-t.x)/t.k,(i-t.y)/t.k,e/t.k]);return function(t){var r=o(t),a=e/r[2];this.__chart__=k={x:u-r[0]*a,y:i-r[1]*a,k:a},c(n)}}).each("interrupt.zoom",function(){l(n)}).each("end.zoom",function(){l(n)}):(this.__chart__=k,a(n),c(n),l(n))})},n.translate=function(t){return arguments.length?(k={x:+t[0],y:+t[1],k:k.k},o(),n):[k.x,k.y]},n.scale=function(t){return arguments.length?(k={x:k.x,y:k.y,k:+t},o(),n):k.k},n.scaleExtent=function(t){return arguments.length?(A=null==t?Va:[+t[0],+t[1]],n):A},n.center=function(t){return arguments.length?(d=t&&[+t[0],+t[1]],n):d},n.size=function(t){return arguments.length?(E=t&&[+t[0],+t[1]],n):E},n.duration=function(t){return arguments.length?(N=+t,n):N},n.x=function(t){return arguments.length?(x=t,M=t.copy(),k={x:0,y:0,k:1},n):x},n.y=function(t){return arguments.length?(S=t,_=t.copy(),k={x:0,y:0,k:1},n):S},ta.rebind(n,R,"on")};var Za,Va=[0,1/0],Xa="onwheel"in ua?(Za=function(){return-ta.event.deltaY*(ta.event.deltaMode?120:1)},"wheel"):"onmousewheel"in ua?(Za=function(){return ta.event.wheelDelta},"mousewheel"):(Za=function(){return-ta.event.detail},"MozMousePixelScroll");ta.color=it,it.prototype.toString=function(){return this.rgb()+""},ta.hsl=ot;var $a=ot.prototype=new it;$a.brighter=function(n){return n=Math.pow(.7,arguments.length?n:1),new ot(this.h,this.s,this.l/n)},$a.darker=function(n){return n=Math.pow(.7,arguments.length?n:1),new ot(this.h,this.s,n*this.l)},$a.rgb=function(){return at(this.h,this.s,this.l)},ta.hcl=ct;var Ba=ct.prototype=new it;Ba.brighter=function(n){return new ct(this.h,this.c,Math.min(100,this.l+Wa*(arguments.length?n:1)))},Ba.darker=function(n){return new ct(this.h,this.c,Math.max(0,this.l-Wa*(arguments.length?n:1)))},Ba.rgb=function(){return lt(this.h,this.c,this.l).rgb()},ta.lab=st;var Wa=18,Ja=.95047,Ga=1,Ka=1.08883,Qa=st.prototype=new it;Qa.brighter=function(n){return new st(Math.min(100,this.l+Wa*(arguments.length?n:1)),this.a,this.b)},Qa.darker=function(n){return new st(Math.max(0,this.l-Wa*(arguments.length?n:1)),this.a,this.b)},Qa.rgb=function(){return ft(this.l,this.a,this.b)},ta.rgb=dt;var nc=dt.prototype=new it;nc.brighter=function(n){n=Math.pow(.7,arguments.length?n:1);var t=this.r,e=this.g,r=this.b,u=30;return t||e||r?(t&&u>t&&(t=u),e&&u>e&&(e=u),r&&u>r&&(r=u),new dt(Math.min(255,t/n),Math.min(255,e/n),Math.min(255,r/n))):new dt(u,u,u)},nc.darker=function(n){return n=Math.pow(.7,arguments.length?n:1),new dt(n*this.r,n*this.g,n*this.b)},nc.hsl=function(){return bt(this.r,this.g,this.b)},nc.toString=function(){return"#"+Mt(this.r)+Mt(this.g)+Mt(this.b)};var tc=ta.map({aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074});tc.forEach(function(n,t){tc.set(n,mt(t))}),ta.functor=kt,ta.xhr=At(Et),ta.dsv=function(n,t){function e(n,e,i){arguments.length<3&&(i=e,e=null);var o=Nt(n,t,null==e?r:u(e),i);return o.row=function(n){return arguments.length?o.response(null==(e=n)?r:u(n)):e},o}function r(n){return e.parse(n.responseText)}function u(n){return function(t){return e.parse(t.responseText,n)}}function i(t){return t.map(o).join(n)}function o(n){return a.test(n)?'"'+n.replace(/\"/g,'""')+'"':n}var a=new RegExp('["'+n+"\n]"),c=n.charCodeAt(0);return e.parse=function(n,t){var r;return e.parseRows(n,function(n,e){if(r)return r(n,e-1);var u=new Function("d","return {"+n.map(function(n,t){return JSON.stringify(n)+": d["+t+"]"}).join(",")+"}");r=t?function(n,e){return t(u(n),e)}:u})},e.parseRows=function(n,t){function e(){if(s>=l)return o;if(u)return u=!1,i;var t=s;if(34===n.charCodeAt(t)){for(var e=t;e++<l;)if(34===n.charCodeAt(e)){if(34!==n.charCodeAt(e+1))break;++e}s=e+2;var r=n.charCodeAt(e+1);return 13===r?(u=!0,10===n.charCodeAt(e+2)&&++s):10===r&&(u=!0),n.slice(t+1,e).replace(/""/g,'"')}for(;l>s;){var r=n.charCodeAt(s++),a=1;if(10===r)u=!0;else if(13===r)u=!0,10===n.charCodeAt(s)&&(++s,++a);else if(r!==c)continue;return n.slice(t,s-a)}return n.slice(t)}for(var r,u,i={},o={},a=[],l=n.length,s=0,f=0;(r=e())!==o;){for(var h=[];r!==i&&r!==o;)h.push(r),r=e();t&&null==(h=t(h,f++))||a.push(h)}return a},e.format=function(t){if(Array.isArray(t[0]))return e.formatRows(t);var r=new v,u=[];return t.forEach(function(n){for(var t in n)r.has(t)||u.push(r.add(t))}),[u.map(o).join(n)].concat(t.map(function(t){return u.map(function(n){return o(t[n])}).join(n)})).join("\n")},e.formatRows=function(n){return n.map(i).join("\n")},e},ta.csv=ta.dsv(",","text/csv"),ta.tsv=ta.dsv("	","text/tab-separated-values");var ec,rc,uc,ic,oc,ac=oa[m(oa,"requestAnimationFrame")]||function(n){setTimeout(n,17)};ta.timer=function(n,t,e){var r=arguments.length;2>r&&(t=0),3>r&&(e=Date.now());var u=e+t,i={c:n,t:u,f:!1,n:null};rc?rc.n=i:ec=i,rc=i,uc||(ic=clearTimeout(ic),uc=1,ac(qt))},ta.timer.flush=function(){Lt(),Tt()},ta.round=function(n,t){return t?Math.round(n*(t=Math.pow(10,t)))/t:Math.round(n)};var cc=["y","z","a","f","p","n","\xb5","m","","k","M","G","T","P","E","Z","Y"].map(Dt);ta.formatPrefix=function(n,t){var e=0;return n&&(0>n&&(n*=-1),t&&(n=ta.round(n,Rt(n,t))),e=1+Math.floor(1e-12+Math.log(n)/Math.LN10),e=Math.max(-24,Math.min(24,3*Math.floor((e-1)/3)))),cc[8+e/3]};var lc=/(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i,sc=ta.map({b:function(n){return n.toString(2)},c:function(n){return String.fromCharCode(n)},o:function(n){return n.toString(8)},x:function(n){return n.toString(16)},X:function(n){return n.toString(16).toUpperCase()},g:function(n,t){return n.toPrecision(t)},e:function(n,t){return n.toExponential(t)},f:function(n,t){return n.toFixed(t)},r:function(n,t){return(n=ta.round(n,Rt(n,t))).toFixed(Math.max(0,Math.min(20,Rt(n*(1+1e-15),t))))}}),fc=ta.time={},hc=Date;jt.prototype={getDate:function(){return this._.getUTCDate()},getDay:function(){return this._.getUTCDay()},getFullYear:function(){return this._.getUTCFullYear()},getHours:function(){return this._.getUTCHours()},getMilliseconds:function(){return this._.getUTCMilliseconds()},getMinutes:function(){return this._.getUTCMinutes()},getMonth:function(){return this._.getUTCMonth()},getSeconds:function(){return this._.getUTCSeconds()},getTime:function(){return this._.getTime()},getTimezoneOffset:function(){return 0},valueOf:function(){return this._.valueOf()},setDate:function(){gc.setUTCDate.apply(this._,arguments)},setDay:function(){gc.setUTCDay.apply(this._,arguments)},setFullYear:function(){gc.setUTCFullYear.apply(this._,arguments)},setHours:function(){gc.setUTCHours.apply(this._,arguments)},setMilliseconds:function(){gc.setUTCMilliseconds.apply(this._,arguments)},setMinutes:function(){gc.setUTCMinutes.apply(this._,arguments)},setMonth:function(){gc.setUTCMonth.apply(this._,arguments)},setSeconds:function(){gc.setUTCSeconds.apply(this._,arguments)},setTime:function(){gc.setTime.apply(this._,arguments)}};var gc=Date.prototype;fc.year=Ft(function(n){return n=fc.day(n),n.setMonth(0,1),n},function(n,t){n.setFullYear(n.getFullYear()+t)},function(n){return n.getFullYear()}),fc.years=fc.year.range,fc.years.utc=fc.year.utc.range,fc.day=Ft(function(n){var t=new hc(2e3,0);return t.setFullYear(n.getFullYear(),n.getMonth(),n.getDate()),t},function(n,t){n.setDate(n.getDate()+t)},function(n){return n.getDate()-1}),fc.days=fc.day.range,fc.days.utc=fc.day.utc.range,fc.dayOfYear=function(n){var t=fc.year(n);return Math.floor((n-t-6e4*(n.getTimezoneOffset()-t.getTimezoneOffset()))/864e5)},["sunday","monday","tuesday","wednesday","thursday","friday","saturday"].forEach(function(n,t){t=7-t;var e=fc[n]=Ft(function(n){return(n=fc.day(n)).setDate(n.getDate()-(n.getDay()+t)%7),n},function(n,t){n.setDate(n.getDate()+7*Math.floor(t))},function(n){var e=fc.year(n).getDay();return Math.floor((fc.dayOfYear(n)+(e+t)%7)/7)-(e!==t)});fc[n+"s"]=e.range,fc[n+"s"].utc=e.utc.range,fc[n+"OfYear"]=function(n){var e=fc.year(n).getDay();return Math.floor((fc.dayOfYear(n)+(e+t)%7)/7)}}),fc.week=fc.sunday,fc.weeks=fc.sunday.range,fc.weeks.utc=fc.sunday.utc.range,fc.weekOfYear=fc.sundayOfYear;var pc={"-":"",_:" ",0:"0"},vc=/^\s*\d+/,dc=/^%/;ta.locale=function(n){return{numberFormat:Pt(n),timeFormat:Ot(n)}};var mc=ta.locale({decimal:".",thousands:",",grouping:[3],currency:["$",""],dateTime:"%a %b %e %X %Y",date:"%m/%d/%Y",time:"%H:%M:%S",periods:["AM","PM"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]});ta.format=mc.numberFormat,ta.geo={},ce.prototype={s:0,t:0,add:function(n){le(n,this.t,yc),le(yc.s,this.s,this),this.s?this.t+=yc.t:this.s=yc.t},reset:function(){this.s=this.t=0},valueOf:function(){return this.s}};var yc=new ce;ta.geo.stream=function(n,t){n&&Mc.hasOwnProperty(n.type)?Mc[n.type](n,t):se(n,t)};var Mc={Feature:function(n,t){se(n.geometry,t)},FeatureCollection:function(n,t){for(var e=n.features,r=-1,u=e.length;++r<u;)se(e[r].geometry,t)}},xc={Sphere:function(n,t){t.sphere()},Point:function(n,t){n=n.coordinates,t.point(n[0],n[1],n[2])},MultiPoint:function(n,t){for(var e=n.coordinates,r=-1,u=e.length;++r<u;)n=e[r],t.point(n[0],n[1],n[2])
	},LineString:function(n,t){fe(n.coordinates,t,0)},MultiLineString:function(n,t){for(var e=n.coordinates,r=-1,u=e.length;++r<u;)fe(e[r],t,0)},Polygon:function(n,t){he(n.coordinates,t)},MultiPolygon:function(n,t){for(var e=n.coordinates,r=-1,u=e.length;++r<u;)he(e[r],t)},GeometryCollection:function(n,t){for(var e=n.geometries,r=-1,u=e.length;++r<u;)se(e[r],t)}};ta.geo.area=function(n){return bc=0,ta.geo.stream(n,wc),bc};var bc,_c=new ce,wc={sphere:function(){bc+=4*Da},point:y,lineStart:y,lineEnd:y,polygonStart:function(){_c.reset(),wc.lineStart=ge},polygonEnd:function(){var n=2*_c;bc+=0>n?4*Da+n:n,wc.lineStart=wc.lineEnd=wc.point=y}};ta.geo.bounds=function(){function n(n,t){M.push(x=[s=n,h=n]),f>t&&(f=t),t>g&&(g=t)}function t(t,e){var r=pe([t*Fa,e*Fa]);if(m){var u=de(m,r),i=[u[1],-u[0],0],o=de(i,u);Me(o),o=xe(o);var c=t-p,l=c>0?1:-1,v=o[0]*Ha*l,d=va(c)>180;if(d^(v>l*p&&l*t>v)){var y=o[1]*Ha;y>g&&(g=y)}else if(v=(v+360)%360-180,d^(v>l*p&&l*t>v)){var y=-o[1]*Ha;f>y&&(f=y)}else f>e&&(f=e),e>g&&(g=e);d?p>t?a(s,t)>a(s,h)&&(h=t):a(t,h)>a(s,h)&&(s=t):h>=s?(s>t&&(s=t),t>h&&(h=t)):t>p?a(s,t)>a(s,h)&&(h=t):a(t,h)>a(s,h)&&(s=t)}else n(t,e);m=r,p=t}function e(){b.point=t}function r(){x[0]=s,x[1]=h,b.point=n,m=null}function u(n,e){if(m){var r=n-p;y+=va(r)>180?r+(r>0?360:-360):r}else v=n,d=e;wc.point(n,e),t(n,e)}function i(){wc.lineStart()}function o(){u(v,d),wc.lineEnd(),va(y)>Ta&&(s=-(h=180)),x[0]=s,x[1]=h,m=null}function a(n,t){return(t-=n)<0?t+360:t}function c(n,t){return n[0]-t[0]}function l(n,t){return t[0]<=t[1]?t[0]<=n&&n<=t[1]:n<t[0]||t[1]<n}var s,f,h,g,p,v,d,m,y,M,x,b={point:n,lineStart:e,lineEnd:r,polygonStart:function(){b.point=u,b.lineStart=i,b.lineEnd=o,y=0,wc.polygonStart()},polygonEnd:function(){wc.polygonEnd(),b.point=n,b.lineStart=e,b.lineEnd=r,0>_c?(s=-(h=180),f=-(g=90)):y>Ta?g=90:-Ta>y&&(f=-90),x[0]=s,x[1]=h}};return function(n){g=h=-(s=f=1/0),M=[],ta.geo.stream(n,b);var t=M.length;if(t){M.sort(c);for(var e,r=1,u=M[0],i=[u];t>r;++r)e=M[r],l(e[0],u)||l(e[1],u)?(a(u[0],e[1])>a(u[0],u[1])&&(u[1]=e[1]),a(e[0],u[1])>a(u[0],u[1])&&(u[0]=e[0])):i.push(u=e);for(var o,e,p=-1/0,t=i.length-1,r=0,u=i[t];t>=r;u=e,++r)e=i[r],(o=a(u[1],e[0]))>p&&(p=o,s=e[0],h=u[1])}return M=x=null,1/0===s||1/0===f?[[0/0,0/0],[0/0,0/0]]:[[s,f],[h,g]]}}(),ta.geo.centroid=function(n){Sc=kc=Ec=Ac=Nc=Cc=zc=qc=Lc=Tc=Rc=0,ta.geo.stream(n,Dc);var t=Lc,e=Tc,r=Rc,u=t*t+e*e+r*r;return Ra>u&&(t=Cc,e=zc,r=qc,Ta>kc&&(t=Ec,e=Ac,r=Nc),u=t*t+e*e+r*r,Ra>u)?[0/0,0/0]:[Math.atan2(e,t)*Ha,nt(r/Math.sqrt(u))*Ha]};var Sc,kc,Ec,Ac,Nc,Cc,zc,qc,Lc,Tc,Rc,Dc={sphere:y,point:_e,lineStart:Se,lineEnd:ke,polygonStart:function(){Dc.lineStart=Ee},polygonEnd:function(){Dc.lineStart=Se}},Pc=Le(Ne,Pe,je,[-Da,-Da/2]),Uc=1e9;ta.geo.clipExtent=function(){var n,t,e,r,u,i,o={stream:function(n){return u&&(u.valid=!1),u=i(n),u.valid=!0,u},extent:function(a){return arguments.length?(i=Ye(n=+a[0][0],t=+a[0][1],e=+a[1][0],r=+a[1][1]),u&&(u.valid=!1,u=null),o):[[n,t],[e,r]]}};return o.extent([[0,0],[960,500]])},(ta.geo.conicEqualArea=function(){return Ie(Ze)}).raw=Ze,ta.geo.albers=function(){return ta.geo.conicEqualArea().rotate([96,0]).center([-.6,38.7]).parallels([29.5,45.5]).scale(1070)},ta.geo.albersUsa=function(){function n(n){var i=n[0],o=n[1];return t=null,e(i,o),t||(r(i,o),t)||u(i,o),t}var t,e,r,u,i=ta.geo.albers(),o=ta.geo.conicEqualArea().rotate([154,0]).center([-2,58.5]).parallels([55,65]),a=ta.geo.conicEqualArea().rotate([157,0]).center([-3,19.9]).parallels([8,18]),c={point:function(n,e){t=[n,e]}};return n.invert=function(n){var t=i.scale(),e=i.translate(),r=(n[0]-e[0])/t,u=(n[1]-e[1])/t;return(u>=.12&&.234>u&&r>=-.425&&-.214>r?o:u>=.166&&.234>u&&r>=-.214&&-.115>r?a:i).invert(n)},n.stream=function(n){var t=i.stream(n),e=o.stream(n),r=a.stream(n);return{point:function(n,u){t.point(n,u),e.point(n,u),r.point(n,u)},sphere:function(){t.sphere(),e.sphere(),r.sphere()},lineStart:function(){t.lineStart(),e.lineStart(),r.lineStart()},lineEnd:function(){t.lineEnd(),e.lineEnd(),r.lineEnd()},polygonStart:function(){t.polygonStart(),e.polygonStart(),r.polygonStart()},polygonEnd:function(){t.polygonEnd(),e.polygonEnd(),r.polygonEnd()}}},n.precision=function(t){return arguments.length?(i.precision(t),o.precision(t),a.precision(t),n):i.precision()},n.scale=function(t){return arguments.length?(i.scale(t),o.scale(.35*t),a.scale(t),n.translate(i.translate())):i.scale()},n.translate=function(t){if(!arguments.length)return i.translate();var l=i.scale(),s=+t[0],f=+t[1];return e=i.translate(t).clipExtent([[s-.455*l,f-.238*l],[s+.455*l,f+.238*l]]).stream(c).point,r=o.translate([s-.307*l,f+.201*l]).clipExtent([[s-.425*l+Ta,f+.12*l+Ta],[s-.214*l-Ta,f+.234*l-Ta]]).stream(c).point,u=a.translate([s-.205*l,f+.212*l]).clipExtent([[s-.214*l+Ta,f+.166*l+Ta],[s-.115*l-Ta,f+.234*l-Ta]]).stream(c).point,n},n.scale(1070)};var jc,Fc,Hc,Oc,Yc,Ic,Zc={point:y,lineStart:y,lineEnd:y,polygonStart:function(){Fc=0,Zc.lineStart=Ve},polygonEnd:function(){Zc.lineStart=Zc.lineEnd=Zc.point=y,jc+=va(Fc/2)}},Vc={point:Xe,lineStart:y,lineEnd:y,polygonStart:y,polygonEnd:y},Xc={point:We,lineStart:Je,lineEnd:Ge,polygonStart:function(){Xc.lineStart=Ke},polygonEnd:function(){Xc.point=We,Xc.lineStart=Je,Xc.lineEnd=Ge}};ta.geo.path=function(){function n(n){return n&&("function"==typeof a&&i.pointRadius(+a.apply(this,arguments)),o&&o.valid||(o=u(i)),ta.geo.stream(n,o)),i.result()}function t(){return o=null,n}var e,r,u,i,o,a=4.5;return n.area=function(n){return jc=0,ta.geo.stream(n,u(Zc)),jc},n.centroid=function(n){return Ec=Ac=Nc=Cc=zc=qc=Lc=Tc=Rc=0,ta.geo.stream(n,u(Xc)),Rc?[Lc/Rc,Tc/Rc]:qc?[Cc/qc,zc/qc]:Nc?[Ec/Nc,Ac/Nc]:[0/0,0/0]},n.bounds=function(n){return Yc=Ic=-(Hc=Oc=1/0),ta.geo.stream(n,u(Vc)),[[Hc,Oc],[Yc,Ic]]},n.projection=function(n){return arguments.length?(u=(e=n)?n.stream||tr(n):Et,t()):e},n.context=function(n){return arguments.length?(i=null==(r=n)?new $e:new Qe(n),"function"!=typeof a&&i.pointRadius(a),t()):r},n.pointRadius=function(t){return arguments.length?(a="function"==typeof t?t:(i.pointRadius(+t),+t),n):a},n.projection(ta.geo.albersUsa()).context(null)},ta.geo.transform=function(n){return{stream:function(t){var e=new er(t);for(var r in n)e[r]=n[r];return e}}},er.prototype={point:function(n,t){this.stream.point(n,t)},sphere:function(){this.stream.sphere()},lineStart:function(){this.stream.lineStart()},lineEnd:function(){this.stream.lineEnd()},polygonStart:function(){this.stream.polygonStart()},polygonEnd:function(){this.stream.polygonEnd()}},ta.geo.projection=ur,ta.geo.projectionMutator=ir,(ta.geo.equirectangular=function(){return ur(ar)}).raw=ar.invert=ar,ta.geo.rotation=function(n){function t(t){return t=n(t[0]*Fa,t[1]*Fa),t[0]*=Ha,t[1]*=Ha,t}return n=lr(n[0]%360*Fa,n[1]*Fa,n.length>2?n[2]*Fa:0),t.invert=function(t){return t=n.invert(t[0]*Fa,t[1]*Fa),t[0]*=Ha,t[1]*=Ha,t},t},cr.invert=ar,ta.geo.circle=function(){function n(){var n="function"==typeof r?r.apply(this,arguments):r,t=lr(-n[0]*Fa,-n[1]*Fa,0).invert,u=[];return e(null,null,1,{point:function(n,e){u.push(n=t(n,e)),n[0]*=Ha,n[1]*=Ha}}),{type:"Polygon",coordinates:[u]}}var t,e,r=[0,0],u=6;return n.origin=function(t){return arguments.length?(r=t,n):r},n.angle=function(r){return arguments.length?(e=gr((t=+r)*Fa,u*Fa),n):t},n.precision=function(r){return arguments.length?(e=gr(t*Fa,(u=+r)*Fa),n):u},n.angle(90)},ta.geo.distance=function(n,t){var e,r=(t[0]-n[0])*Fa,u=n[1]*Fa,i=t[1]*Fa,o=Math.sin(r),a=Math.cos(r),c=Math.sin(u),l=Math.cos(u),s=Math.sin(i),f=Math.cos(i);return Math.atan2(Math.sqrt((e=f*o)*e+(e=l*s-c*f*a)*e),c*s+l*f*a)},ta.geo.graticule=function(){function n(){return{type:"MultiLineString",coordinates:t()}}function t(){return ta.range(Math.ceil(i/d)*d,u,d).map(h).concat(ta.range(Math.ceil(l/m)*m,c,m).map(g)).concat(ta.range(Math.ceil(r/p)*p,e,p).filter(function(n){return va(n%d)>Ta}).map(s)).concat(ta.range(Math.ceil(a/v)*v,o,v).filter(function(n){return va(n%m)>Ta}).map(f))}var e,r,u,i,o,a,c,l,s,f,h,g,p=10,v=p,d=90,m=360,y=2.5;return n.lines=function(){return t().map(function(n){return{type:"LineString",coordinates:n}})},n.outline=function(){return{type:"Polygon",coordinates:[h(i).concat(g(c).slice(1),h(u).reverse().slice(1),g(l).reverse().slice(1))]}},n.extent=function(t){return arguments.length?n.majorExtent(t).minorExtent(t):n.minorExtent()},n.majorExtent=function(t){return arguments.length?(i=+t[0][0],u=+t[1][0],l=+t[0][1],c=+t[1][1],i>u&&(t=i,i=u,u=t),l>c&&(t=l,l=c,c=t),n.precision(y)):[[i,l],[u,c]]},n.minorExtent=function(t){return arguments.length?(r=+t[0][0],e=+t[1][0],a=+t[0][1],o=+t[1][1],r>e&&(t=r,r=e,e=t),a>o&&(t=a,a=o,o=t),n.precision(y)):[[r,a],[e,o]]},n.step=function(t){return arguments.length?n.majorStep(t).minorStep(t):n.minorStep()},n.majorStep=function(t){return arguments.length?(d=+t[0],m=+t[1],n):[d,m]},n.minorStep=function(t){return arguments.length?(p=+t[0],v=+t[1],n):[p,v]},n.precision=function(t){return arguments.length?(y=+t,s=vr(a,o,90),f=dr(r,e,y),h=vr(l,c,90),g=dr(i,u,y),n):y},n.majorExtent([[-180,-90+Ta],[180,90-Ta]]).minorExtent([[-180,-80-Ta],[180,80+Ta]])},ta.geo.greatArc=function(){function n(){return{type:"LineString",coordinates:[t||r.apply(this,arguments),e||u.apply(this,arguments)]}}var t,e,r=mr,u=yr;return n.distance=function(){return ta.geo.distance(t||r.apply(this,arguments),e||u.apply(this,arguments))},n.source=function(e){return arguments.length?(r=e,t="function"==typeof e?null:e,n):r},n.target=function(t){return arguments.length?(u=t,e="function"==typeof t?null:t,n):u},n.precision=function(){return arguments.length?n:0},n},ta.geo.interpolate=function(n,t){return Mr(n[0]*Fa,n[1]*Fa,t[0]*Fa,t[1]*Fa)},ta.geo.length=function(n){return $c=0,ta.geo.stream(n,Bc),$c};var $c,Bc={sphere:y,point:y,lineStart:xr,lineEnd:y,polygonStart:y,polygonEnd:y},Wc=br(function(n){return Math.sqrt(2/(1+n))},function(n){return 2*Math.asin(n/2)});(ta.geo.azimuthalEqualArea=function(){return ur(Wc)}).raw=Wc;var Jc=br(function(n){var t=Math.acos(n);return t&&t/Math.sin(t)},Et);(ta.geo.azimuthalEquidistant=function(){return ur(Jc)}).raw=Jc,(ta.geo.conicConformal=function(){return Ie(_r)}).raw=_r,(ta.geo.conicEquidistant=function(){return Ie(wr)}).raw=wr;var Gc=br(function(n){return 1/n},Math.atan);(ta.geo.gnomonic=function(){return ur(Gc)}).raw=Gc,Sr.invert=function(n,t){return[n,2*Math.atan(Math.exp(t))-ja]},(ta.geo.mercator=function(){return kr(Sr)}).raw=Sr;var Kc=br(function(){return 1},Math.asin);(ta.geo.orthographic=function(){return ur(Kc)}).raw=Kc;var Qc=br(function(n){return 1/(1+n)},function(n){return 2*Math.atan(n)});(ta.geo.stereographic=function(){return ur(Qc)}).raw=Qc,Er.invert=function(n,t){return[-t,2*Math.atan(Math.exp(n))-ja]},(ta.geo.transverseMercator=function(){var n=kr(Er),t=n.center,e=n.rotate;return n.center=function(n){return n?t([-n[1],n[0]]):(n=t(),[n[1],-n[0]])},n.rotate=function(n){return n?e([n[0],n[1],n.length>2?n[2]+90:90]):(n=e(),[n[0],n[1],n[2]-90])},e([0,0,90])}).raw=Er,ta.geom={},ta.geom.hull=function(n){function t(n){if(n.length<3)return[];var t,u=kt(e),i=kt(r),o=n.length,a=[],c=[];for(t=0;o>t;t++)a.push([+u.call(this,n[t],t),+i.call(this,n[t],t),t]);for(a.sort(zr),t=0;o>t;t++)c.push([a[t][0],-a[t][1]]);var l=Cr(a),s=Cr(c),f=s[0]===l[0],h=s[s.length-1]===l[l.length-1],g=[];for(t=l.length-1;t>=0;--t)g.push(n[a[l[t]][2]]);for(t=+f;t<s.length-h;++t)g.push(n[a[s[t]][2]]);return g}var e=Ar,r=Nr;return arguments.length?t(n):(t.x=function(n){return arguments.length?(e=n,t):e},t.y=function(n){return arguments.length?(r=n,t):r},t)},ta.geom.polygon=function(n){return xa(n,nl),n};var nl=ta.geom.polygon.prototype=[];nl.area=function(){for(var n,t=-1,e=this.length,r=this[e-1],u=0;++t<e;)n=r,r=this[t],u+=n[1]*r[0]-n[0]*r[1];return.5*u},nl.centroid=function(n){var t,e,r=-1,u=this.length,i=0,o=0,a=this[u-1];for(arguments.length||(n=-1/(6*this.area()));++r<u;)t=a,a=this[r],e=t[0]*a[1]-a[0]*t[1],i+=(t[0]+a[0])*e,o+=(t[1]+a[1])*e;return[i*n,o*n]},nl.clip=function(n){for(var t,e,r,u,i,o,a=Tr(n),c=-1,l=this.length-Tr(this),s=this[l-1];++c<l;){for(t=n.slice(),n.length=0,u=this[c],i=t[(r=t.length-a)-1],e=-1;++e<r;)o=t[e],qr(o,s,u)?(qr(i,s,u)||n.push(Lr(i,o,s,u)),n.push(o)):qr(i,s,u)&&n.push(Lr(i,o,s,u)),i=o;a&&n.push(n[0]),s=u}return n};var tl,el,rl,ul,il,ol=[],al=[];Or.prototype.prepare=function(){for(var n,t=this.edges,e=t.length;e--;)n=t[e].edge,n.b&&n.a||t.splice(e,1);return t.sort(Ir),t.length},Qr.prototype={start:function(){return this.edge.l===this.site?this.edge.a:this.edge.b},end:function(){return this.edge.l===this.site?this.edge.b:this.edge.a}},nu.prototype={insert:function(n,t){var e,r,u;if(n){if(t.P=n,t.N=n.N,n.N&&(n.N.P=t),n.N=t,n.R){for(n=n.R;n.L;)n=n.L;n.L=t}else n.R=t;e=n}else this._?(n=uu(this._),t.P=null,t.N=n,n.P=n.L=t,e=n):(t.P=t.N=null,this._=t,e=null);for(t.L=t.R=null,t.U=e,t.C=!0,n=t;e&&e.C;)r=e.U,e===r.L?(u=r.R,u&&u.C?(e.C=u.C=!1,r.C=!0,n=r):(n===e.R&&(eu(this,e),n=e,e=n.U),e.C=!1,r.C=!0,ru(this,r))):(u=r.L,u&&u.C?(e.C=u.C=!1,r.C=!0,n=r):(n===e.L&&(ru(this,e),n=e,e=n.U),e.C=!1,r.C=!0,eu(this,r))),e=n.U;this._.C=!1},remove:function(n){n.N&&(n.N.P=n.P),n.P&&(n.P.N=n.N),n.N=n.P=null;var t,e,r,u=n.U,i=n.L,o=n.R;if(e=i?o?uu(o):i:o,u?u.L===n?u.L=e:u.R=e:this._=e,i&&o?(r=e.C,e.C=n.C,e.L=i,i.U=e,e!==o?(u=e.U,e.U=n.U,n=e.R,u.L=n,e.R=o,o.U=e):(e.U=u,u=e,n=e.R)):(r=n.C,n=e),n&&(n.U=u),!r){if(n&&n.C)return n.C=!1,void 0;do{if(n===this._)break;if(n===u.L){if(t=u.R,t.C&&(t.C=!1,u.C=!0,eu(this,u),t=u.R),t.L&&t.L.C||t.R&&t.R.C){t.R&&t.R.C||(t.L.C=!1,t.C=!0,ru(this,t),t=u.R),t.C=u.C,u.C=t.R.C=!1,eu(this,u),n=this._;break}}else if(t=u.L,t.C&&(t.C=!1,u.C=!0,ru(this,u),t=u.L),t.L&&t.L.C||t.R&&t.R.C){t.L&&t.L.C||(t.R.C=!1,t.C=!0,eu(this,t),t=u.L),t.C=u.C,u.C=t.L.C=!1,ru(this,u),n=this._;break}t.C=!0,n=u,u=u.U}while(!n.C);n&&(n.C=!1)}}},ta.geom.voronoi=function(n){function t(n){var t=new Array(n.length),r=a[0][0],u=a[0][1],i=a[1][0],o=a[1][1];return iu(e(n),a).cells.forEach(function(e,a){var c=e.edges,l=e.site,s=t[a]=c.length?c.map(function(n){var t=n.start();return[t.x,t.y]}):l.x>=r&&l.x<=i&&l.y>=u&&l.y<=o?[[r,o],[i,o],[i,u],[r,u]]:[];s.point=n[a]}),t}function e(n){return n.map(function(n,t){return{x:Math.round(i(n,t)/Ta)*Ta,y:Math.round(o(n,t)/Ta)*Ta,i:t}})}var r=Ar,u=Nr,i=r,o=u,a=cl;return n?t(n):(t.links=function(n){return iu(e(n)).edges.filter(function(n){return n.l&&n.r}).map(function(t){return{source:n[t.l.i],target:n[t.r.i]}})},t.triangles=function(n){var t=[];return iu(e(n)).cells.forEach(function(e,r){for(var u,i,o=e.site,a=e.edges.sort(Ir),c=-1,l=a.length,s=a[l-1].edge,f=s.l===o?s.r:s.l;++c<l;)u=s,i=f,s=a[c].edge,f=s.l===o?s.r:s.l,r<i.i&&r<f.i&&au(o,i,f)<0&&t.push([n[r],n[i.i],n[f.i]])}),t},t.x=function(n){return arguments.length?(i=kt(r=n),t):r},t.y=function(n){return arguments.length?(o=kt(u=n),t):u},t.clipExtent=function(n){return arguments.length?(a=null==n?cl:n,t):a===cl?null:a},t.size=function(n){return arguments.length?t.clipExtent(n&&[[0,0],n]):a===cl?null:a&&a[1]},t)};var cl=[[-1e6,-1e6],[1e6,1e6]];ta.geom.delaunay=function(n){return ta.geom.voronoi().triangles(n)},ta.geom.quadtree=function(n,t,e,r,u){function i(n){function i(n,t,e,r,u,i,o,a){if(!isNaN(e)&&!isNaN(r))if(n.leaf){var c=n.x,s=n.y;if(null!=c)if(va(c-e)+va(s-r)<.01)l(n,t,e,r,u,i,o,a);else{var f=n.point;n.x=n.y=n.point=null,l(n,f,c,s,u,i,o,a),l(n,t,e,r,u,i,o,a)}else n.x=e,n.y=r,n.point=t}else l(n,t,e,r,u,i,o,a)}function l(n,t,e,r,u,o,a,c){var l=.5*(u+a),s=.5*(o+c),f=e>=l,h=r>=s,g=h<<1|f;n.leaf=!1,n=n.nodes[g]||(n.nodes[g]=su()),f?u=l:a=l,h?o=s:c=s,i(n,t,e,r,u,o,a,c)}var s,f,h,g,p,v,d,m,y,M=kt(a),x=kt(c);if(null!=t)v=t,d=e,m=r,y=u;else if(m=y=-(v=d=1/0),f=[],h=[],p=n.length,o)for(g=0;p>g;++g)s=n[g],s.x<v&&(v=s.x),s.y<d&&(d=s.y),s.x>m&&(m=s.x),s.y>y&&(y=s.y),f.push(s.x),h.push(s.y);else for(g=0;p>g;++g){var b=+M(s=n[g],g),_=+x(s,g);v>b&&(v=b),d>_&&(d=_),b>m&&(m=b),_>y&&(y=_),f.push(b),h.push(_)}var w=m-v,S=y-d;w>S?y=d+w:m=v+S;var k=su();if(k.add=function(n){i(k,n,+M(n,++g),+x(n,g),v,d,m,y)},k.visit=function(n){fu(n,k,v,d,m,y)},k.find=function(n){return hu(k,n[0],n[1],v,d,m,y)},g=-1,null==t){for(;++g<p;)i(k,n[g],f[g],h[g],v,d,m,y);--g}else n.forEach(k.add);return f=h=n=s=null,k}var o,a=Ar,c=Nr;return(o=arguments.length)?(a=cu,c=lu,3===o&&(u=e,r=t,e=t=0),i(n)):(i.x=function(n){return arguments.length?(a=n,i):a},i.y=function(n){return arguments.length?(c=n,i):c},i.extent=function(n){return arguments.length?(null==n?t=e=r=u=null:(t=+n[0][0],e=+n[0][1],r=+n[1][0],u=+n[1][1]),i):null==t?null:[[t,e],[r,u]]},i.size=function(n){return arguments.length?(null==n?t=e=r=u=null:(t=e=0,r=+n[0],u=+n[1]),i):null==t?null:[r-t,u-e]},i)},ta.interpolateRgb=gu,ta.interpolateObject=pu,ta.interpolateNumber=vu,ta.interpolateString=du;var ll=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,sl=new RegExp(ll.source,"g");ta.interpolate=mu,ta.interpolators=[function(n,t){var e=typeof t;return("string"===e?tc.has(t)||/^(#|rgb\(|hsl\()/.test(t)?gu:du:t instanceof it?gu:Array.isArray(t)?yu:"object"===e&&isNaN(t)?pu:vu)(n,t)}],ta.interpolateArray=yu;var fl=function(){return Et},hl=ta.map({linear:fl,poly:ku,quad:function(){return _u},cubic:function(){return wu},sin:function(){return Eu},exp:function(){return Au},circle:function(){return Nu},elastic:Cu,back:zu,bounce:function(){return qu}}),gl=ta.map({"in":Et,out:xu,"in-out":bu,"out-in":function(n){return bu(xu(n))}});ta.ease=function(n){var t=n.indexOf("-"),e=t>=0?n.slice(0,t):n,r=t>=0?n.slice(t+1):"in";return e=hl.get(e)||fl,r=gl.get(r)||Et,Mu(r(e.apply(null,ea.call(arguments,1))))},ta.interpolateHcl=Lu,ta.interpolateHsl=Tu,ta.interpolateLab=Ru,ta.interpolateRound=Du,ta.transform=function(n){var t=ua.createElementNS(ta.ns.prefix.svg,"g");return(ta.transform=function(n){if(null!=n){t.setAttribute("transform",n);var e=t.transform.baseVal.consolidate()}return new Pu(e?e.matrix:pl)})(n)},Pu.prototype.toString=function(){return"translate("+this.translate+")rotate("+this.rotate+")skewX("+this.skew+")scale("+this.scale+")"};var pl={a:1,b:0,c:0,d:1,e:0,f:0};ta.interpolateTransform=Hu,ta.layout={},ta.layout.bundle=function(){return function(n){for(var t=[],e=-1,r=n.length;++e<r;)t.push(Iu(n[e]));return t}},ta.layout.chord=function(){function n(){var n,l,f,h,g,p={},v=[],d=ta.range(i),m=[];for(e=[],r=[],n=0,h=-1;++h<i;){for(l=0,g=-1;++g<i;)l+=u[h][g];v.push(l),m.push(ta.range(i)),n+=l}for(o&&d.sort(function(n,t){return o(v[n],v[t])}),a&&m.forEach(function(n,t){n.sort(function(n,e){return a(u[t][n],u[t][e])})}),n=(Pa-s*i)/n,l=0,h=-1;++h<i;){for(f=l,g=-1;++g<i;){var y=d[h],M=m[y][g],x=u[y][M],b=l,_=l+=x*n;p[y+"-"+M]={index:y,subindex:M,startAngle:b,endAngle:_,value:x}}r[y]={index:y,startAngle:f,endAngle:l,value:(l-f)/n},l+=s}for(h=-1;++h<i;)for(g=h-1;++g<i;){var w=p[h+"-"+g],S=p[g+"-"+h];(w.value||S.value)&&e.push(w.value<S.value?{source:S,target:w}:{source:w,target:S})}c&&t()}function t(){e.sort(function(n,t){return c((n.source.value+n.target.value)/2,(t.source.value+t.target.value)/2)})}var e,r,u,i,o,a,c,l={},s=0;return l.matrix=function(n){return arguments.length?(i=(u=n)&&u.length,e=r=null,l):u},l.padding=function(n){return arguments.length?(s=n,e=r=null,l):s},l.sortGroups=function(n){return arguments.length?(o=n,e=r=null,l):o},l.sortSubgroups=function(n){return arguments.length?(a=n,e=null,l):a},l.sortChords=function(n){return arguments.length?(c=n,e&&t(),l):c},l.chords=function(){return e||n(),e},l.groups=function(){return r||n(),r},l},ta.layout.force=function(){function n(n){return function(t,e,r,u){if(t.point!==n){var i=t.cx-n.x,o=t.cy-n.y,a=u-e,c=i*i+o*o;if(c>a*a/d){if(p>c){var l=t.charge/c;n.px-=i*l,n.py-=o*l}return!0}if(t.point&&c&&p>c){var l=t.pointCharge/c;n.px-=i*l,n.py-=o*l}}return!t.charge}}function t(n){n.px=ta.event.x,n.py=ta.event.y,a.resume()}var e,r,u,i,o,a={},c=ta.dispatch("start","tick","end"),l=[1,1],s=.9,f=vl,h=dl,g=-30,p=ml,v=.1,d=.64,m=[],y=[];return a.tick=function(){if((r*=.99)<.005)return c.end({type:"end",alpha:r=0}),!0;var t,e,a,f,h,p,d,M,x,b=m.length,_=y.length;for(e=0;_>e;++e)a=y[e],f=a.source,h=a.target,M=h.x-f.x,x=h.y-f.y,(p=M*M+x*x)&&(p=r*i[e]*((p=Math.sqrt(p))-u[e])/p,M*=p,x*=p,h.x-=M*(d=f.weight/(h.weight+f.weight)),h.y-=x*d,f.x+=M*(d=1-d),f.y+=x*d);if((d=r*v)&&(M=l[0]/2,x=l[1]/2,e=-1,d))for(;++e<b;)a=m[e],a.x+=(M-a.x)*d,a.y+=(x-a.y)*d;if(g)for(Ju(t=ta.geom.quadtree(m),r,o),e=-1;++e<b;)(a=m[e]).fixed||t.visit(n(a));for(e=-1;++e<b;)a=m[e],a.fixed?(a.x=a.px,a.y=a.py):(a.x-=(a.px-(a.px=a.x))*s,a.y-=(a.py-(a.py=a.y))*s);c.tick({type:"tick",alpha:r})},a.nodes=function(n){return arguments.length?(m=n,a):m},a.links=function(n){return arguments.length?(y=n,a):y},a.size=function(n){return arguments.length?(l=n,a):l},a.linkDistance=function(n){return arguments.length?(f="function"==typeof n?n:+n,a):f},a.distance=a.linkDistance,a.linkStrength=function(n){return arguments.length?(h="function"==typeof n?n:+n,a):h},a.friction=function(n){return arguments.length?(s=+n,a):s},a.charge=function(n){return arguments.length?(g="function"==typeof n?n:+n,a):g},a.chargeDistance=function(n){return arguments.length?(p=n*n,a):Math.sqrt(p)},a.gravity=function(n){return arguments.length?(v=+n,a):v},a.theta=function(n){return arguments.length?(d=n*n,a):Math.sqrt(d)},a.alpha=function(n){return arguments.length?(n=+n,r?r=n>0?n:0:n>0&&(c.start({type:"start",alpha:r=n}),ta.timer(a.tick)),a):r},a.start=function(){function n(n,r){if(!e){for(e=new Array(c),a=0;c>a;++a)e[a]=[];for(a=0;l>a;++a){var u=y[a];e[u.source.index].push(u.target),e[u.target.index].push(u.source)}}for(var i,o=e[t],a=-1,l=o.length;++a<l;)if(!isNaN(i=o[a][n]))return i;return Math.random()*r}var t,e,r,c=m.length,s=y.length,p=l[0],v=l[1];for(t=0;c>t;++t)(r=m[t]).index=t,r.weight=0;for(t=0;s>t;++t)r=y[t],"number"==typeof r.source&&(r.source=m[r.source]),"number"==typeof r.target&&(r.target=m[r.target]),++r.source.weight,++r.target.weight;for(t=0;c>t;++t)r=m[t],isNaN(r.x)&&(r.x=n("x",p)),isNaN(r.y)&&(r.y=n("y",v)),isNaN(r.px)&&(r.px=r.x),isNaN(r.py)&&(r.py=r.y);if(u=[],"function"==typeof f)for(t=0;s>t;++t)u[t]=+f.call(this,y[t],t);else for(t=0;s>t;++t)u[t]=f;if(i=[],"function"==typeof h)for(t=0;s>t;++t)i[t]=+h.call(this,y[t],t);else for(t=0;s>t;++t)i[t]=h;if(o=[],"function"==typeof g)for(t=0;c>t;++t)o[t]=+g.call(this,m[t],t);else for(t=0;c>t;++t)o[t]=g;return a.resume()},a.resume=function(){return a.alpha(.1)},a.stop=function(){return a.alpha(0)},a.drag=function(){return e||(e=ta.behavior.drag().origin(Et).on("dragstart.force",Xu).on("drag.force",t).on("dragend.force",$u)),arguments.length?(this.on("mouseover.force",Bu).on("mouseout.force",Wu).call(e),void 0):e},ta.rebind(a,c,"on")};var vl=20,dl=1,ml=1/0;ta.layout.hierarchy=function(){function n(u){var i,o=[u],a=[];for(u.depth=0;null!=(i=o.pop());)if(a.push(i),(l=e.call(n,i,i.depth))&&(c=l.length)){for(var c,l,s;--c>=0;)o.push(s=l[c]),s.parent=i,s.depth=i.depth+1;r&&(i.value=0),i.children=l}else r&&(i.value=+r.call(n,i,i.depth)||0),delete i.children;return Qu(u,function(n){var e,u;t&&(e=n.children)&&e.sort(t),r&&(u=n.parent)&&(u.value+=n.value)}),a}var t=ei,e=ni,r=ti;return n.sort=function(e){return arguments.length?(t=e,n):t},n.children=function(t){return arguments.length?(e=t,n):e},n.value=function(t){return arguments.length?(r=t,n):r},n.revalue=function(t){return r&&(Ku(t,function(n){n.children&&(n.value=0)}),Qu(t,function(t){var e;t.children||(t.value=+r.call(n,t,t.depth)||0),(e=t.parent)&&(e.value+=t.value)})),t},n},ta.layout.partition=function(){function n(t,e,r,u){var i=t.children;if(t.x=e,t.y=t.depth*u,t.dx=r,t.dy=u,i&&(o=i.length)){var o,a,c,l=-1;for(r=t.value?r/t.value:0;++l<o;)n(a=i[l],e,c=a.value*r,u),e+=c}}function t(n){var e=n.children,r=0;if(e&&(u=e.length))for(var u,i=-1;++i<u;)r=Math.max(r,t(e[i]));return 1+r}function e(e,i){var o=r.call(this,e,i);return n(o[0],0,u[0],u[1]/t(o[0])),o}var r=ta.layout.hierarchy(),u=[1,1];return e.size=function(n){return arguments.length?(u=n,e):u},Gu(e,r)},ta.layout.pie=function(){function n(o){var a,c=o.length,l=o.map(function(e,r){return+t.call(n,e,r)}),s=+("function"==typeof r?r.apply(this,arguments):r),f=("function"==typeof u?u.apply(this,arguments):u)-s,h=Math.min(Math.abs(f)/c,+("function"==typeof i?i.apply(this,arguments):i)),g=h*(0>f?-1:1),p=(f-c*g)/ta.sum(l),v=ta.range(c),d=[];return null!=e&&v.sort(e===yl?function(n,t){return l[t]-l[n]}:function(n,t){return e(o[n],o[t])}),v.forEach(function(n){d[n]={data:o[n],value:a=l[n],startAngle:s,endAngle:s+=a*p+g,padAngle:h}}),d}var t=Number,e=yl,r=0,u=Pa,i=0;return n.value=function(e){return arguments.length?(t=e,n):t},n.sort=function(t){return arguments.length?(e=t,n):e},n.startAngle=function(t){return arguments.length?(r=t,n):r},n.endAngle=function(t){return arguments.length?(u=t,n):u},n.padAngle=function(t){return arguments.length?(i=t,n):i},n};var yl={};ta.layout.stack=function(){function n(a,c){if(!(h=a.length))return a;var l=a.map(function(e,r){return t.call(n,e,r)}),s=l.map(function(t){return t.map(function(t,e){return[i.call(n,t,e),o.call(n,t,e)]})}),f=e.call(n,s,c);l=ta.permute(l,f),s=ta.permute(s,f);var h,g,p,v,d=r.call(n,s,c),m=l[0].length;for(p=0;m>p;++p)for(u.call(n,l[0][p],v=d[p],s[0][p][1]),g=1;h>g;++g)u.call(n,l[g][p],v+=s[g-1][p][1],s[g][p][1]);return a}var t=Et,e=ai,r=ci,u=oi,i=ui,o=ii;return n.values=function(e){return arguments.length?(t=e,n):t},n.order=function(t){return arguments.length?(e="function"==typeof t?t:Ml.get(t)||ai,n):e},n.offset=function(t){return arguments.length?(r="function"==typeof t?t:xl.get(t)||ci,n):r},n.x=function(t){return arguments.length?(i=t,n):i},n.y=function(t){return arguments.length?(o=t,n):o},n.out=function(t){return arguments.length?(u=t,n):u},n};var Ml=ta.map({"inside-out":function(n){var t,e,r=n.length,u=n.map(li),i=n.map(si),o=ta.range(r).sort(function(n,t){return u[n]-u[t]}),a=0,c=0,l=[],s=[];for(t=0;r>t;++t)e=o[t],c>a?(a+=i[e],l.push(e)):(c+=i[e],s.push(e));return s.reverse().concat(l)},reverse:function(n){return ta.range(n.length).reverse()},"default":ai}),xl=ta.map({silhouette:function(n){var t,e,r,u=n.length,i=n[0].length,o=[],a=0,c=[];for(e=0;i>e;++e){for(t=0,r=0;u>t;t++)r+=n[t][e][1];r>a&&(a=r),o.push(r)}for(e=0;i>e;++e)c[e]=(a-o[e])/2;return c},wiggle:function(n){var t,e,r,u,i,o,a,c,l,s=n.length,f=n[0],h=f.length,g=[];for(g[0]=c=l=0,e=1;h>e;++e){for(t=0,u=0;s>t;++t)u+=n[t][e][1];for(t=0,i=0,a=f[e][0]-f[e-1][0];s>t;++t){for(r=0,o=(n[t][e][1]-n[t][e-1][1])/(2*a);t>r;++r)o+=(n[r][e][1]-n[r][e-1][1])/a;i+=o*n[t][e][1]}g[e]=c-=u?i/u*a:0,l>c&&(l=c)}for(e=0;h>e;++e)g[e]-=l;return g},expand:function(n){var t,e,r,u=n.length,i=n[0].length,o=1/u,a=[];for(e=0;i>e;++e){for(t=0,r=0;u>t;t++)r+=n[t][e][1];if(r)for(t=0;u>t;t++)n[t][e][1]/=r;else for(t=0;u>t;t++)n[t][e][1]=o}for(e=0;i>e;++e)a[e]=0;return a},zero:ci});ta.layout.histogram=function(){function n(n,i){for(var o,a,c=[],l=n.map(e,this),s=r.call(this,l,i),f=u.call(this,s,l,i),i=-1,h=l.length,g=f.length-1,p=t?1:1/h;++i<g;)o=c[i]=[],o.dx=f[i+1]-(o.x=f[i]),o.y=0;if(g>0)for(i=-1;++i<h;)a=l[i],a>=s[0]&&a<=s[1]&&(o=c[ta.bisect(f,a,1,g)-1],o.y+=p,o.push(n[i]));return c}var t=!0,e=Number,r=pi,u=hi;return n.value=function(t){return arguments.length?(e=t,n):e},n.range=function(t){return arguments.length?(r=kt(t),n):r},n.bins=function(t){return arguments.length?(u="number"==typeof t?function(n){return gi(n,t)}:kt(t),n):u},n.frequency=function(e){return arguments.length?(t=!!e,n):t},n},ta.layout.pack=function(){function n(n,i){var o=e.call(this,n,i),a=o[0],c=u[0],l=u[1],s=null==t?Math.sqrt:"function"==typeof t?t:function(){return t};if(a.x=a.y=0,Qu(a,function(n){n.r=+s(n.value)}),Qu(a,Mi),r){var f=r*(t?1:Math.max(2*a.r/c,2*a.r/l))/2;Qu(a,function(n){n.r+=f}),Qu(a,Mi),Qu(a,function(n){n.r-=f})}return _i(a,c/2,l/2,t?1:1/Math.max(2*a.r/c,2*a.r/l)),o}var t,e=ta.layout.hierarchy().sort(vi),r=0,u=[1,1];return n.size=function(t){return arguments.length?(u=t,n):u},n.radius=function(e){return arguments.length?(t=null==e||"function"==typeof e?e:+e,n):t},n.padding=function(t){return arguments.length?(r=+t,n):r},Gu(n,e)},ta.layout.tree=function(){function n(n,u){var s=o.call(this,n,u),f=s[0],h=t(f);if(Qu(h,e),h.parent.m=-h.z,Ku(h,r),l)Ku(f,i);else{var g=f,p=f,v=f;Ku(f,function(n){n.x<g.x&&(g=n),n.x>p.x&&(p=n),n.depth>v.depth&&(v=n)});var d=a(g,p)/2-g.x,m=c[0]/(p.x+a(p,g)/2+d),y=c[1]/(v.depth||1);Ku(f,function(n){n.x=(n.x+d)*m,n.y=n.depth*y})}return s}function t(n){for(var t,e={A:null,children:[n]},r=[e];null!=(t=r.pop());)for(var u,i=t.children,o=0,a=i.length;a>o;++o)r.push((i[o]=u={_:i[o],parent:t,children:(u=i[o].children)&&u.slice()||[],A:null,a:null,z:0,m:0,c:0,s:0,t:null,i:o}).a=u);return e.children[0]}function e(n){var t=n.children,e=n.parent.children,r=n.i?e[n.i-1]:null;if(t.length){Ni(n);var i=(t[0].z+t[t.length-1].z)/2;r?(n.z=r.z+a(n._,r._),n.m=n.z-i):n.z=i}else r&&(n.z=r.z+a(n._,r._));n.parent.A=u(n,r,n.parent.A||e[0])}function r(n){n._.x=n.z+n.parent.m,n.m+=n.parent.m}function u(n,t,e){if(t){for(var r,u=n,i=n,o=t,c=u.parent.children[0],l=u.m,s=i.m,f=o.m,h=c.m;o=Ei(o),u=ki(u),o&&u;)c=ki(c),i=Ei(i),i.a=n,r=o.z+f-u.z-l+a(o._,u._),r>0&&(Ai(Ci(o,n,e),n,r),l+=r,s+=r),f+=o.m,l+=u.m,h+=c.m,s+=i.m;o&&!Ei(i)&&(i.t=o,i.m+=f-s),u&&!ki(c)&&(c.t=u,c.m+=l-h,e=n)}return e}function i(n){n.x*=c[0],n.y=n.depth*c[1]}var o=ta.layout.hierarchy().sort(null).value(null),a=Si,c=[1,1],l=null;return n.separation=function(t){return arguments.length?(a=t,n):a},n.size=function(t){return arguments.length?(l=null==(c=t)?i:null,n):l?null:c},n.nodeSize=function(t){return arguments.length?(l=null==(c=t)?null:i,n):l?c:null},Gu(n,o)},ta.layout.cluster=function(){function n(n,i){var o,a=t.call(this,n,i),c=a[0],l=0;Qu(c,function(n){var t=n.children;t&&t.length?(n.x=qi(t),n.y=zi(t)):(n.x=o?l+=e(n,o):0,n.y=0,o=n)});var s=Li(c),f=Ti(c),h=s.x-e(s,f)/2,g=f.x+e(f,s)/2;return Qu(c,u?function(n){n.x=(n.x-c.x)*r[0],n.y=(c.y-n.y)*r[1]}:function(n){n.x=(n.x-h)/(g-h)*r[0],n.y=(1-(c.y?n.y/c.y:1))*r[1]}),a}var t=ta.layout.hierarchy().sort(null).value(null),e=Si,r=[1,1],u=!1;return n.separation=function(t){return arguments.length?(e=t,n):e},n.size=function(t){return arguments.length?(u=null==(r=t),n):u?null:r},n.nodeSize=function(t){return arguments.length?(u=null!=(r=t),n):u?r:null},Gu(n,t)},ta.layout.treemap=function(){function n(n,t){for(var e,r,u=-1,i=n.length;++u<i;)r=(e=n[u]).value*(0>t?0:t),e.area=isNaN(r)||0>=r?0:r}function t(e){var i=e.children;if(i&&i.length){var o,a,c,l=f(e),s=[],h=i.slice(),p=1/0,v="slice"===g?l.dx:"dice"===g?l.dy:"slice-dice"===g?1&e.depth?l.dy:l.dx:Math.min(l.dx,l.dy);for(n(h,l.dx*l.dy/e.value),s.area=0;(c=h.length)>0;)s.push(o=h[c-1]),s.area+=o.area,"squarify"!==g||(a=r(s,v))<=p?(h.pop(),p=a):(s.area-=s.pop().area,u(s,v,l,!1),v=Math.min(l.dx,l.dy),s.length=s.area=0,p=1/0);s.length&&(u(s,v,l,!0),s.length=s.area=0),i.forEach(t)}}function e(t){var r=t.children;if(r&&r.length){var i,o=f(t),a=r.slice(),c=[];for(n(a,o.dx*o.dy/t.value),c.area=0;i=a.pop();)c.push(i),c.area+=i.area,null!=i.z&&(u(c,i.z?o.dx:o.dy,o,!a.length),c.length=c.area=0);r.forEach(e)}}function r(n,t){for(var e,r=n.area,u=0,i=1/0,o=-1,a=n.length;++o<a;)(e=n[o].area)&&(i>e&&(i=e),e>u&&(u=e));return r*=r,t*=t,r?Math.max(t*u*p/r,r/(t*i*p)):1/0}function u(n,t,e,r){var u,i=-1,o=n.length,a=e.x,l=e.y,s=t?c(n.area/t):0;if(t==e.dx){for((r||s>e.dy)&&(s=e.dy);++i<o;)u=n[i],u.x=a,u.y=l,u.dy=s,a+=u.dx=Math.min(e.x+e.dx-a,s?c(u.area/s):0);u.z=!0,u.dx+=e.x+e.dx-a,e.y+=s,e.dy-=s}else{for((r||s>e.dx)&&(s=e.dx);++i<o;)u=n[i],u.x=a,u.y=l,u.dx=s,l+=u.dy=Math.min(e.y+e.dy-l,s?c(u.area/s):0);u.z=!1,u.dy+=e.y+e.dy-l,e.x+=s,e.dx-=s}}function i(r){var u=o||a(r),i=u[0];return i.x=0,i.y=0,i.dx=l[0],i.dy=l[1],o&&a.revalue(i),n([i],i.dx*i.dy/i.value),(o?e:t)(i),h&&(o=u),u}var o,a=ta.layout.hierarchy(),c=Math.round,l=[1,1],s=null,f=Ri,h=!1,g="squarify",p=.5*(1+Math.sqrt(5));return i.size=function(n){return arguments.length?(l=n,i):l},i.padding=function(n){function t(t){var e=n.call(i,t,t.depth);return null==e?Ri(t):Di(t,"number"==typeof e?[e,e,e,e]:e)}function e(t){return Di(t,n)}if(!arguments.length)return s;var r;return f=null==(s=n)?Ri:"function"==(r=typeof n)?t:"number"===r?(n=[n,n,n,n],e):e,i},i.round=function(n){return arguments.length?(c=n?Math.round:Number,i):c!=Number},i.sticky=function(n){return arguments.length?(h=n,o=null,i):h
	},i.ratio=function(n){return arguments.length?(p=n,i):p},i.mode=function(n){return arguments.length?(g=n+"",i):g},Gu(i,a)},ta.random={normal:function(n,t){var e=arguments.length;return 2>e&&(t=1),1>e&&(n=0),function(){var e,r,u;do e=2*Math.random()-1,r=2*Math.random()-1,u=e*e+r*r;while(!u||u>1);return n+t*e*Math.sqrt(-2*Math.log(u)/u)}},logNormal:function(){var n=ta.random.normal.apply(ta,arguments);return function(){return Math.exp(n())}},bates:function(n){var t=ta.random.irwinHall(n);return function(){return t()/n}},irwinHall:function(n){return function(){for(var t=0,e=0;n>e;e++)t+=Math.random();return t}}},ta.scale={};var bl={floor:Et,ceil:Et};ta.scale.linear=function(){return Yi([0,1],[0,1],mu,!1)};var _l={s:1,g:1,p:1,r:1,e:1};ta.scale.log=function(){return Ji(ta.scale.linear().domain([0,1]),10,!0,[1,10])};var wl=ta.format(".0e"),Sl={floor:function(n){return-Math.ceil(-n)},ceil:function(n){return-Math.floor(-n)}};ta.scale.pow=function(){return Gi(ta.scale.linear(),1,[0,1])},ta.scale.sqrt=function(){return ta.scale.pow().exponent(.5)},ta.scale.ordinal=function(){return Qi([],{t:"range",a:[[]]})},ta.scale.category10=function(){return ta.scale.ordinal().range(kl)},ta.scale.category20=function(){return ta.scale.ordinal().range(El)},ta.scale.category20b=function(){return ta.scale.ordinal().range(Al)},ta.scale.category20c=function(){return ta.scale.ordinal().range(Nl)};var kl=[2062260,16744206,2924588,14034728,9725885,9197131,14907330,8355711,12369186,1556175].map(yt),El=[2062260,11454440,16744206,16759672,2924588,10018698,14034728,16750742,9725885,12955861,9197131,12885140,14907330,16234194,8355711,13092807,12369186,14408589,1556175,10410725].map(yt),Al=[3750777,5395619,7040719,10264286,6519097,9216594,11915115,13556636,9202993,12426809,15186514,15190932,8666169,11356490,14049643,15177372,8077683,10834324,13528509,14589654].map(yt),Nl=[3244733,7057110,10406625,13032431,15095053,16616764,16625259,16634018,3253076,7652470,10607003,13101504,7695281,10394312,12369372,14342891,6513507,9868950,12434877,14277081].map(yt);ta.scale.quantile=function(){return no([],[])},ta.scale.quantize=function(){return to(0,1,[0,1])},ta.scale.threshold=function(){return eo([.5],[0,1])},ta.scale.identity=function(){return ro([0,1])},ta.svg={},ta.svg.arc=function(){function n(){var n=Math.max(0,+e.apply(this,arguments)),l=Math.max(0,+r.apply(this,arguments)),s=o.apply(this,arguments)-ja,f=a.apply(this,arguments)-ja,h=Math.abs(f-s),g=s>f?0:1;if(n>l&&(p=l,l=n,n=p),h>=Ua)return t(l,g)+(n?t(n,1-g):"")+"Z";var p,v,d,m,y,M,x,b,_,w,S,k,E=0,A=0,N=[];if((m=(+c.apply(this,arguments)||0)/2)&&(d=i===Cl?Math.sqrt(n*n+l*l):+i.apply(this,arguments),g||(A*=-1),l&&(A=nt(d/l*Math.sin(m))),n&&(E=nt(d/n*Math.sin(m)))),l){y=l*Math.cos(s+A),M=l*Math.sin(s+A),x=l*Math.cos(f-A),b=l*Math.sin(f-A);var C=Math.abs(f-s-2*A)<=Da?0:1;if(A&&so(y,M,x,b)===g^C){var z=(s+f)/2;y=l*Math.cos(z),M=l*Math.sin(z),x=b=null}}else y=M=0;if(n){_=n*Math.cos(f-E),w=n*Math.sin(f-E),S=n*Math.cos(s+E),k=n*Math.sin(s+E);var q=Math.abs(s-f+2*E)<=Da?0:1;if(E&&so(_,w,S,k)===1-g^q){var L=(s+f)/2;_=n*Math.cos(L),w=n*Math.sin(L),S=k=null}}else _=w=0;if((p=Math.min(Math.abs(l-n)/2,+u.apply(this,arguments)))>.001){v=l>n^g?0:1;var T=null==S?[_,w]:null==x?[y,M]:Lr([y,M],[S,k],[x,b],[_,w]),R=y-T[0],D=M-T[1],P=x-T[0],U=b-T[1],j=1/Math.sin(Math.acos((R*P+D*U)/(Math.sqrt(R*R+D*D)*Math.sqrt(P*P+U*U)))/2),F=Math.sqrt(T[0]*T[0]+T[1]*T[1]);if(null!=x){var H=Math.min(p,(l-F)/(j+1)),O=fo(null==S?[_,w]:[S,k],[y,M],l,H,g),Y=fo([x,b],[_,w],l,H,g);p===H?N.push("M",O[0],"A",H,",",H," 0 0,",v," ",O[1],"A",l,",",l," 0 ",1-g^so(O[1][0],O[1][1],Y[1][0],Y[1][1]),",",g," ",Y[1],"A",H,",",H," 0 0,",v," ",Y[0]):N.push("M",O[0],"A",H,",",H," 0 1,",v," ",Y[0])}else N.push("M",y,",",M);if(null!=S){var I=Math.min(p,(n-F)/(j-1)),Z=fo([y,M],[S,k],n,-I,g),V=fo([_,w],null==x?[y,M]:[x,b],n,-I,g);p===I?N.push("L",V[0],"A",I,",",I," 0 0,",v," ",V[1],"A",n,",",n," 0 ",g^so(V[1][0],V[1][1],Z[1][0],Z[1][1]),",",1-g," ",Z[1],"A",I,",",I," 0 0,",v," ",Z[0]):N.push("L",V[0],"A",I,",",I," 0 0,",v," ",Z[0])}else N.push("L",_,",",w)}else N.push("M",y,",",M),null!=x&&N.push("A",l,",",l," 0 ",C,",",g," ",x,",",b),N.push("L",_,",",w),null!=S&&N.push("A",n,",",n," 0 ",q,",",1-g," ",S,",",k);return N.push("Z"),N.join("")}function t(n,t){return"M0,"+n+"A"+n+","+n+" 0 1,"+t+" 0,"+-n+"A"+n+","+n+" 0 1,"+t+" 0,"+n}var e=io,r=oo,u=uo,i=Cl,o=ao,a=co,c=lo;return n.innerRadius=function(t){return arguments.length?(e=kt(t),n):e},n.outerRadius=function(t){return arguments.length?(r=kt(t),n):r},n.cornerRadius=function(t){return arguments.length?(u=kt(t),n):u},n.padRadius=function(t){return arguments.length?(i=t==Cl?Cl:kt(t),n):i},n.startAngle=function(t){return arguments.length?(o=kt(t),n):o},n.endAngle=function(t){return arguments.length?(a=kt(t),n):a},n.padAngle=function(t){return arguments.length?(c=kt(t),n):c},n.centroid=function(){var n=(+e.apply(this,arguments)+ +r.apply(this,arguments))/2,t=(+o.apply(this,arguments)+ +a.apply(this,arguments))/2-ja;return[Math.cos(t)*n,Math.sin(t)*n]},n};var Cl="auto";ta.svg.line=function(){return ho(Et)};var zl=ta.map({linear:go,"linear-closed":po,step:vo,"step-before":mo,"step-after":yo,basis:So,"basis-open":ko,"basis-closed":Eo,bundle:Ao,cardinal:bo,"cardinal-open":Mo,"cardinal-closed":xo,monotone:To});zl.forEach(function(n,t){t.key=n,t.closed=/-closed$/.test(n)});var ql=[0,2/3,1/3,0],Ll=[0,1/3,2/3,0],Tl=[0,1/6,2/3,1/6];ta.svg.line.radial=function(){var n=ho(Ro);return n.radius=n.x,delete n.x,n.angle=n.y,delete n.y,n},mo.reverse=yo,yo.reverse=mo,ta.svg.area=function(){return Do(Et)},ta.svg.area.radial=function(){var n=Do(Ro);return n.radius=n.x,delete n.x,n.innerRadius=n.x0,delete n.x0,n.outerRadius=n.x1,delete n.x1,n.angle=n.y,delete n.y,n.startAngle=n.y0,delete n.y0,n.endAngle=n.y1,delete n.y1,n},ta.svg.chord=function(){function n(n,a){var c=t(this,i,n,a),l=t(this,o,n,a);return"M"+c.p0+r(c.r,c.p1,c.a1-c.a0)+(e(c,l)?u(c.r,c.p1,c.r,c.p0):u(c.r,c.p1,l.r,l.p0)+r(l.r,l.p1,l.a1-l.a0)+u(l.r,l.p1,c.r,c.p0))+"Z"}function t(n,t,e,r){var u=t.call(n,e,r),i=a.call(n,u,r),o=c.call(n,u,r)-ja,s=l.call(n,u,r)-ja;return{r:i,a0:o,a1:s,p0:[i*Math.cos(o),i*Math.sin(o)],p1:[i*Math.cos(s),i*Math.sin(s)]}}function e(n,t){return n.a0==t.a0&&n.a1==t.a1}function r(n,t,e){return"A"+n+","+n+" 0 "+ +(e>Da)+",1 "+t}function u(n,t,e,r){return"Q 0,0 "+r}var i=mr,o=yr,a=Po,c=ao,l=co;return n.radius=function(t){return arguments.length?(a=kt(t),n):a},n.source=function(t){return arguments.length?(i=kt(t),n):i},n.target=function(t){return arguments.length?(o=kt(t),n):o},n.startAngle=function(t){return arguments.length?(c=kt(t),n):c},n.endAngle=function(t){return arguments.length?(l=kt(t),n):l},n},ta.svg.diagonal=function(){function n(n,u){var i=t.call(this,n,u),o=e.call(this,n,u),a=(i.y+o.y)/2,c=[i,{x:i.x,y:a},{x:o.x,y:a},o];return c=c.map(r),"M"+c[0]+"C"+c[1]+" "+c[2]+" "+c[3]}var t=mr,e=yr,r=Uo;return n.source=function(e){return arguments.length?(t=kt(e),n):t},n.target=function(t){return arguments.length?(e=kt(t),n):e},n.projection=function(t){return arguments.length?(r=t,n):r},n},ta.svg.diagonal.radial=function(){var n=ta.svg.diagonal(),t=Uo,e=n.projection;return n.projection=function(n){return arguments.length?e(jo(t=n)):t},n},ta.svg.symbol=function(){function n(n,r){return(Rl.get(t.call(this,n,r))||Oo)(e.call(this,n,r))}var t=Ho,e=Fo;return n.type=function(e){return arguments.length?(t=kt(e),n):t},n.size=function(t){return arguments.length?(e=kt(t),n):e},n};var Rl=ta.map({circle:Oo,cross:function(n){var t=Math.sqrt(n/5)/2;return"M"+-3*t+","+-t+"H"+-t+"V"+-3*t+"H"+t+"V"+-t+"H"+3*t+"V"+t+"H"+t+"V"+3*t+"H"+-t+"V"+t+"H"+-3*t+"Z"},diamond:function(n){var t=Math.sqrt(n/(2*Pl)),e=t*Pl;return"M0,"+-t+"L"+e+",0"+" 0,"+t+" "+-e+",0"+"Z"},square:function(n){var t=Math.sqrt(n)/2;return"M"+-t+","+-t+"L"+t+","+-t+" "+t+","+t+" "+-t+","+t+"Z"},"triangle-down":function(n){var t=Math.sqrt(n/Dl),e=t*Dl/2;return"M0,"+e+"L"+t+","+-e+" "+-t+","+-e+"Z"},"triangle-up":function(n){var t=Math.sqrt(n/Dl),e=t*Dl/2;return"M0,"+-e+"L"+t+","+e+" "+-t+","+e+"Z"}});ta.svg.symbolTypes=Rl.keys();var Dl=Math.sqrt(3),Pl=Math.tan(30*Fa);ka.transition=function(n){for(var t,e,r=Ul||++Ol,u=Xo(n),i=[],o=jl||{time:Date.now(),ease:Su,delay:0,duration:250},a=-1,c=this.length;++a<c;){i.push(t=[]);for(var l=this[a],s=-1,f=l.length;++s<f;)(e=l[s])&&$o(e,s,u,r,o),t.push(e)}return Io(i,u,r)},ka.interrupt=function(n){return this.each(null==n?Fl:Yo(Xo(n)))};var Ul,jl,Fl=Yo(Xo()),Hl=[],Ol=0;Hl.call=ka.call,Hl.empty=ka.empty,Hl.node=ka.node,Hl.size=ka.size,ta.transition=function(n,t){return n&&n.transition?Ul?n.transition(t):n:Na.transition(n)},ta.transition.prototype=Hl,Hl.select=function(n){var t,e,r,u=this.id,i=this.namespace,o=[];n=k(n);for(var a=-1,c=this.length;++a<c;){o.push(t=[]);for(var l=this[a],s=-1,f=l.length;++s<f;)(r=l[s])&&(e=n.call(r,r.__data__,s,a))?("__data__"in r&&(e.__data__=r.__data__),$o(e,s,i,u,r[i][u]),t.push(e)):t.push(null)}return Io(o,i,u)},Hl.selectAll=function(n){var t,e,r,u,i,o=this.id,a=this.namespace,c=[];n=E(n);for(var l=-1,s=this.length;++l<s;)for(var f=this[l],h=-1,g=f.length;++h<g;)if(r=f[h]){i=r[a][o],e=n.call(r,r.__data__,h,l),c.push(t=[]);for(var p=-1,v=e.length;++p<v;)(u=e[p])&&$o(u,p,a,o,i),t.push(u)}return Io(c,a,o)},Hl.filter=function(n){var t,e,r,u=[];"function"!=typeof n&&(n=j(n));for(var i=0,o=this.length;o>i;i++){u.push(t=[]);for(var e=this[i],a=0,c=e.length;c>a;a++)(r=e[a])&&n.call(r,r.__data__,a,i)&&t.push(r)}return Io(u,this.namespace,this.id)},Hl.tween=function(n,t){var e=this.id,r=this.namespace;return arguments.length<2?this.node()[r][e].tween.get(n):H(this,null==t?function(t){t[r][e].tween.remove(n)}:function(u){u[r][e].tween.set(n,t)})},Hl.attr=function(n,t){function e(){this.removeAttribute(a)}function r(){this.removeAttributeNS(a.space,a.local)}function u(n){return null==n?e:(n+="",function(){var t,e=this.getAttribute(a);return e!==n&&(t=o(e,n),function(n){this.setAttribute(a,t(n))})})}function i(n){return null==n?r:(n+="",function(){var t,e=this.getAttributeNS(a.space,a.local);return e!==n&&(t=o(e,n),function(n){this.setAttributeNS(a.space,a.local,t(n))})})}if(arguments.length<2){for(t in n)this.attr(t,n[t]);return this}var o="transform"==n?Hu:mu,a=ta.ns.qualify(n);return Zo(this,"attr."+n,t,a.local?i:u)},Hl.attrTween=function(n,t){function e(n,e){var r=t.call(this,n,e,this.getAttribute(u));return r&&function(n){this.setAttribute(u,r(n))}}function r(n,e){var r=t.call(this,n,e,this.getAttributeNS(u.space,u.local));return r&&function(n){this.setAttributeNS(u.space,u.local,r(n))}}var u=ta.ns.qualify(n);return this.tween("attr."+n,u.local?r:e)},Hl.style=function(n,t,e){function r(){this.style.removeProperty(n)}function u(t){return null==t?r:(t+="",function(){var r,u=oa.getComputedStyle(this,null).getPropertyValue(n);return u!==t&&(r=mu(u,t),function(t){this.style.setProperty(n,r(t),e)})})}var i=arguments.length;if(3>i){if("string"!=typeof n){2>i&&(t="");for(e in n)this.style(e,n[e],t);return this}e=""}return Zo(this,"style."+n,t,u)},Hl.styleTween=function(n,t,e){function r(r,u){var i=t.call(this,r,u,oa.getComputedStyle(this,null).getPropertyValue(n));return i&&function(t){this.style.setProperty(n,i(t),e)}}return arguments.length<3&&(e=""),this.tween("style."+n,r)},Hl.text=function(n){return Zo(this,"text",n,Vo)},Hl.remove=function(){var n=this.namespace;return this.each("end.transition",function(){var t;this[n].count<2&&(t=this.parentNode)&&t.removeChild(this)})},Hl.ease=function(n){var t=this.id,e=this.namespace;return arguments.length<1?this.node()[e][t].ease:("function"!=typeof n&&(n=ta.ease.apply(ta,arguments)),H(this,function(r){r[e][t].ease=n}))},Hl.delay=function(n){var t=this.id,e=this.namespace;return arguments.length<1?this.node()[e][t].delay:H(this,"function"==typeof n?function(r,u,i){r[e][t].delay=+n.call(r,r.__data__,u,i)}:(n=+n,function(r){r[e][t].delay=n}))},Hl.duration=function(n){var t=this.id,e=this.namespace;return arguments.length<1?this.node()[e][t].duration:H(this,"function"==typeof n?function(r,u,i){r[e][t].duration=Math.max(1,n.call(r,r.__data__,u,i))}:(n=Math.max(1,n),function(r){r[e][t].duration=n}))},Hl.each=function(n,t){var e=this.id,r=this.namespace;if(arguments.length<2){var u=jl,i=Ul;try{Ul=e,H(this,function(t,u,i){jl=t[r][e],n.call(t,t.__data__,u,i)})}finally{jl=u,Ul=i}}else H(this,function(u){var i=u[r][e];(i.event||(i.event=ta.dispatch("start","end","interrupt"))).on(n,t)});return this},Hl.transition=function(){for(var n,t,e,r,u=this.id,i=++Ol,o=this.namespace,a=[],c=0,l=this.length;l>c;c++){a.push(n=[]);for(var t=this[c],s=0,f=t.length;f>s;s++)(e=t[s])&&(r=e[o][u],$o(e,s,o,i,{time:r.time,ease:r.ease,delay:r.delay+r.duration,duration:r.duration})),n.push(e)}return Io(a,o,i)},ta.svg.axis=function(){function n(n){n.each(function(){var n,l=ta.select(this),s=this.__chart__||e,f=this.__chart__=e.copy(),h=null==c?f.ticks?f.ticks.apply(f,a):f.domain():c,g=null==t?f.tickFormat?f.tickFormat.apply(f,a):Et:t,p=l.selectAll(".tick").data(h,f),v=p.enter().insert("g",".domain").attr("class","tick").style("opacity",Ta),d=ta.transition(p.exit()).style("opacity",Ta).remove(),m=ta.transition(p.order()).style("opacity",1),y=Math.max(u,0)+o,M=Ui(f),x=l.selectAll(".domain").data([0]),b=(x.enter().append("path").attr("class","domain"),ta.transition(x));v.append("line"),v.append("text");var _,w,S,k,E=v.select("line"),A=m.select("line"),N=p.select("text").text(g),C=v.select("text"),z=m.select("text"),q="top"===r||"left"===r?-1:1;if("bottom"===r||"top"===r?(n=Bo,_="x",S="y",w="x2",k="y2",N.attr("dy",0>q?"0em":".71em").style("text-anchor","middle"),b.attr("d","M"+M[0]+","+q*i+"V0H"+M[1]+"V"+q*i)):(n=Wo,_="y",S="x",w="y2",k="x2",N.attr("dy",".32em").style("text-anchor",0>q?"end":"start"),b.attr("d","M"+q*i+","+M[0]+"H0V"+M[1]+"H"+q*i)),E.attr(k,q*u),C.attr(S,q*y),A.attr(w,0).attr(k,q*u),z.attr(_,0).attr(S,q*y),f.rangeBand){var L=f,T=L.rangeBand()/2;s=f=function(n){return L(n)+T}}else s.rangeBand?s=f:d.call(n,f,s);v.call(n,s,f),m.call(n,f,f)})}var t,e=ta.scale.linear(),r=Yl,u=6,i=6,o=3,a=[10],c=null;return n.scale=function(t){return arguments.length?(e=t,n):e},n.orient=function(t){return arguments.length?(r=t in Il?t+"":Yl,n):r},n.ticks=function(){return arguments.length?(a=arguments,n):a},n.tickValues=function(t){return arguments.length?(c=t,n):c},n.tickFormat=function(e){return arguments.length?(t=e,n):t},n.tickSize=function(t){var e=arguments.length;return e?(u=+t,i=+arguments[e-1],n):u},n.innerTickSize=function(t){return arguments.length?(u=+t,n):u},n.outerTickSize=function(t){return arguments.length?(i=+t,n):i},n.tickPadding=function(t){return arguments.length?(o=+t,n):o},n.tickSubdivide=function(){return arguments.length&&n},n};var Yl="bottom",Il={top:1,right:1,bottom:1,left:1};ta.svg.brush=function(){function n(i){i.each(function(){var i=ta.select(this).style("pointer-events","all").style("-webkit-tap-highlight-color","rgba(0,0,0,0)").on("mousedown.brush",u).on("touchstart.brush",u),o=i.selectAll(".background").data([0]);o.enter().append("rect").attr("class","background").style("visibility","hidden").style("cursor","crosshair"),i.selectAll(".extent").data([0]).enter().append("rect").attr("class","extent").style("cursor","move");var a=i.selectAll(".resize").data(p,Et);a.exit().remove(),a.enter().append("g").attr("class",function(n){return"resize "+n}).style("cursor",function(n){return Zl[n]}).append("rect").attr("x",function(n){return/[ew]$/.test(n)?-3:null}).attr("y",function(n){return/^[ns]/.test(n)?-3:null}).attr("width",6).attr("height",6).style("visibility","hidden"),a.style("display",n.empty()?"none":null);var s,f=ta.transition(i),h=ta.transition(o);c&&(s=Ui(c),h.attr("x",s[0]).attr("width",s[1]-s[0]),e(f)),l&&(s=Ui(l),h.attr("y",s[0]).attr("height",s[1]-s[0]),r(f)),t(f)})}function t(n){n.selectAll(".resize").attr("transform",function(n){return"translate("+s[+/e$/.test(n)]+","+f[+/^s/.test(n)]+")"})}function e(n){n.select(".extent").attr("x",s[0]),n.selectAll(".extent,.n>rect,.s>rect").attr("width",s[1]-s[0])}function r(n){n.select(".extent").attr("y",f[0]),n.selectAll(".extent,.e>rect,.w>rect").attr("height",f[1]-f[0])}function u(){function u(){32==ta.event.keyCode&&(N||(y=null,z[0]-=s[1],z[1]-=f[1],N=2),b())}function p(){32==ta.event.keyCode&&2==N&&(z[0]+=s[1],z[1]+=f[1],N=0,b())}function v(){var n=ta.mouse(x),u=!1;M&&(n[0]+=M[0],n[1]+=M[1]),N||(ta.event.altKey?(y||(y=[(s[0]+s[1])/2,(f[0]+f[1])/2]),z[0]=s[+(n[0]<y[0])],z[1]=f[+(n[1]<y[1])]):y=null),E&&d(n,c,0)&&(e(S),u=!0),A&&d(n,l,1)&&(r(S),u=!0),u&&(t(S),w({type:"brush",mode:N?"move":"resize"}))}function d(n,t,e){var r,u,a=Ui(t),c=a[0],l=a[1],p=z[e],v=e?f:s,d=v[1]-v[0];return N&&(c-=p,l-=d+p),r=(e?g:h)?Math.max(c,Math.min(l,n[e])):n[e],N?u=(r+=p)+d:(y&&(p=Math.max(c,Math.min(l,2*y[e]-r))),r>p?(u=r,r=p):u=p),v[0]!=r||v[1]!=u?(e?o=null:i=null,v[0]=r,v[1]=u,!0):void 0}function m(){v(),S.style("pointer-events","all").selectAll(".resize").style("display",n.empty()?"none":null),ta.select("body").style("cursor",null),q.on("mousemove.brush",null).on("mouseup.brush",null).on("touchmove.brush",null).on("touchend.brush",null).on("keydown.brush",null).on("keyup.brush",null),C(),w({type:"brushend"})}var y,M,x=this,_=ta.select(ta.event.target),w=a.of(x,arguments),S=ta.select(x),k=_.datum(),E=!/^(n|s)$/.test(k)&&c,A=!/^(e|w)$/.test(k)&&l,N=_.classed("extent"),C=X(),z=ta.mouse(x),q=ta.select(oa).on("keydown.brush",u).on("keyup.brush",p);if(ta.event.changedTouches?q.on("touchmove.brush",v).on("touchend.brush",m):q.on("mousemove.brush",v).on("mouseup.brush",m),S.interrupt().selectAll("*").interrupt(),N)z[0]=s[0]-z[0],z[1]=f[0]-z[1];else if(k){var L=+/w$/.test(k),T=+/^n/.test(k);M=[s[1-L]-z[0],f[1-T]-z[1]],z[0]=s[L],z[1]=f[T]}else ta.event.altKey&&(y=z.slice());S.style("pointer-events","none").selectAll(".resize").style("display",null),ta.select("body").style("cursor",_.style("cursor")),w({type:"brushstart"}),v()}var i,o,a=w(n,"brushstart","brush","brushend"),c=null,l=null,s=[0,0],f=[0,0],h=!0,g=!0,p=Vl[0];return n.event=function(n){n.each(function(){var n=a.of(this,arguments),t={x:s,y:f,i:i,j:o},e=this.__chart__||t;this.__chart__=t,Ul?ta.select(this).transition().each("start.brush",function(){i=e.i,o=e.j,s=e.x,f=e.y,n({type:"brushstart"})}).tween("brush:brush",function(){var e=yu(s,t.x),r=yu(f,t.y);return i=o=null,function(u){s=t.x=e(u),f=t.y=r(u),n({type:"brush",mode:"resize"})}}).each("end.brush",function(){i=t.i,o=t.j,n({type:"brush",mode:"resize"}),n({type:"brushend"})}):(n({type:"brushstart"}),n({type:"brush",mode:"resize"}),n({type:"brushend"}))})},n.x=function(t){return arguments.length?(c=t,p=Vl[!c<<1|!l],n):c},n.y=function(t){return arguments.length?(l=t,p=Vl[!c<<1|!l],n):l},n.clamp=function(t){return arguments.length?(c&&l?(h=!!t[0],g=!!t[1]):c?h=!!t:l&&(g=!!t),n):c&&l?[h,g]:c?h:l?g:null},n.extent=function(t){var e,r,u,a,h;return arguments.length?(c&&(e=t[0],r=t[1],l&&(e=e[0],r=r[0]),i=[e,r],c.invert&&(e=c(e),r=c(r)),e>r&&(h=e,e=r,r=h),(e!=s[0]||r!=s[1])&&(s=[e,r])),l&&(u=t[0],a=t[1],c&&(u=u[1],a=a[1]),o=[u,a],l.invert&&(u=l(u),a=l(a)),u>a&&(h=u,u=a,a=h),(u!=f[0]||a!=f[1])&&(f=[u,a])),n):(c&&(i?(e=i[0],r=i[1]):(e=s[0],r=s[1],c.invert&&(e=c.invert(e),r=c.invert(r)),e>r&&(h=e,e=r,r=h))),l&&(o?(u=o[0],a=o[1]):(u=f[0],a=f[1],l.invert&&(u=l.invert(u),a=l.invert(a)),u>a&&(h=u,u=a,a=h))),c&&l?[[e,u],[r,a]]:c?[e,r]:l&&[u,a])},n.clear=function(){return n.empty()||(s=[0,0],f=[0,0],i=o=null),n},n.empty=function(){return!!c&&s[0]==s[1]||!!l&&f[0]==f[1]},ta.rebind(n,a,"on")};var Zl={n:"ns-resize",e:"ew-resize",s:"ns-resize",w:"ew-resize",nw:"nwse-resize",ne:"nesw-resize",se:"nwse-resize",sw:"nesw-resize"},Vl=[["n","e","s","w","nw","ne","se","sw"],["e","w"],["n","s"],[]],Xl=fc.format=mc.timeFormat,$l=Xl.utc,Bl=$l("%Y-%m-%dT%H:%M:%S.%LZ");Xl.iso=Date.prototype.toISOString&&+new Date("2000-01-01T00:00:00.000Z")?Jo:Bl,Jo.parse=function(n){var t=new Date(n);return isNaN(t)?null:t},Jo.toString=Bl.toString,fc.second=Ft(function(n){return new hc(1e3*Math.floor(n/1e3))},function(n,t){n.setTime(n.getTime()+1e3*Math.floor(t))},function(n){return n.getSeconds()}),fc.seconds=fc.second.range,fc.seconds.utc=fc.second.utc.range,fc.minute=Ft(function(n){return new hc(6e4*Math.floor(n/6e4))},function(n,t){n.setTime(n.getTime()+6e4*Math.floor(t))},function(n){return n.getMinutes()}),fc.minutes=fc.minute.range,fc.minutes.utc=fc.minute.utc.range,fc.hour=Ft(function(n){var t=n.getTimezoneOffset()/60;return new hc(36e5*(Math.floor(n/36e5-t)+t))},function(n,t){n.setTime(n.getTime()+36e5*Math.floor(t))},function(n){return n.getHours()}),fc.hours=fc.hour.range,fc.hours.utc=fc.hour.utc.range,fc.month=Ft(function(n){return n=fc.day(n),n.setDate(1),n},function(n,t){n.setMonth(n.getMonth()+t)},function(n){return n.getMonth()}),fc.months=fc.month.range,fc.months.utc=fc.month.utc.range;var Wl=[1e3,5e3,15e3,3e4,6e4,3e5,9e5,18e5,36e5,108e5,216e5,432e5,864e5,1728e5,6048e5,2592e6,7776e6,31536e6],Jl=[[fc.second,1],[fc.second,5],[fc.second,15],[fc.second,30],[fc.minute,1],[fc.minute,5],[fc.minute,15],[fc.minute,30],[fc.hour,1],[fc.hour,3],[fc.hour,6],[fc.hour,12],[fc.day,1],[fc.day,2],[fc.week,1],[fc.month,1],[fc.month,3],[fc.year,1]],Gl=Xl.multi([[".%L",function(n){return n.getMilliseconds()}],[":%S",function(n){return n.getSeconds()}],["%I:%M",function(n){return n.getMinutes()}],["%I %p",function(n){return n.getHours()}],["%a %d",function(n){return n.getDay()&&1!=n.getDate()}],["%b %d",function(n){return 1!=n.getDate()}],["%B",function(n){return n.getMonth()}],["%Y",Ne]]),Kl={range:function(n,t,e){return ta.range(Math.ceil(n/e)*e,+t,e).map(Ko)},floor:Et,ceil:Et};Jl.year=fc.year,fc.scale=function(){return Go(ta.scale.linear(),Jl,Gl)};var Ql=Jl.map(function(n){return[n[0].utc,n[1]]}),ns=$l.multi([[".%L",function(n){return n.getUTCMilliseconds()}],[":%S",function(n){return n.getUTCSeconds()}],["%I:%M",function(n){return n.getUTCMinutes()}],["%I %p",function(n){return n.getUTCHours()}],["%a %d",function(n){return n.getUTCDay()&&1!=n.getUTCDate()}],["%b %d",function(n){return 1!=n.getUTCDate()}],["%B",function(n){return n.getUTCMonth()}],["%Y",Ne]]);Ql.year=fc.year.utc,fc.scale.utc=function(){return Go(ta.scale.linear(),Ql,ns)},ta.text=At(function(n){return n.responseText}),ta.json=function(n,t){return Nt(n,"application/json",Qo,t)},ta.html=function(n,t){return Nt(n,"text/html",na,t)},ta.xml=At(function(n){return n.responseXML}),true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (ta), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports&&(module.exports=ta),this.d3=ta}();

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {/*!
	 * jQuery Form Plugin
	 * version: 3.51.0-2014.06.20
	 * Requires jQuery v1.5 or later
	 * Copyright (c) 2014 M. Alsup
	 * Examples and documentation at: http://malsup.com/jquery/form/
	 * Project repository: https://github.com/malsup/form
	 * Dual licensed under the MIT and GPL licenses.
	 * https://github.com/malsup/form#copyright-and-license
	 */
	/*global ActiveXObject */

	__webpack_require__(2)

	// AMD support
	// (function (factory) {
	//     "use strict";
	//     

	// }

	// (function($) {
	// "use strict";

	/*
	    Usage Note:
	    -----------
	    Do not use both ajaxSubmit and ajaxForm on the same form.  These
	    functions are mutually exclusive.  Use ajaxSubmit if you want
	    to bind your own submit handler to the form.  For example,

	    $(document).ready(function() {
	        $('#myForm').on('submit', function(e) {
	            e.preventDefault(); // <-- important
	            $(this).ajaxSubmit({
	                target: '#output'
	            });
	        });
	    });

	    Use ajaxForm when you want the plugin to manage all the event binding
	    for you.  For example,

	    $(document).ready(function() {
	        $('#myForm').ajaxForm({
	            target: '#output'
	        });
	    });

	    You can also use ajaxForm with delegation (requires jQuery v1.7+), so the
	    form does not have to exist when you invoke ajaxForm:

	    $('#myForm').ajaxForm({
	        delegation: true,
	        target: '#output'
	    });

	    When using ajaxForm, the ajaxSubmit function will be invoked for you
	    at the appropriate time.
	*/

	/**
	 * Feature detection
	 */
	var feature = {};
	feature.fileapi = $("<input type='file'/>").get(0).files !== undefined;
	feature.formdata = window.FormData !== undefined;

	var hasProp = !!$.fn.prop;

	// attr2 uses prop when it can but checks the return type for
	// an expected string.  this accounts for the case where a form 
	// contains inputs with names like "action" or "method"; in those
	// cases "prop" returns the element
	$.fn.attr2 = function() {
	    if ( ! hasProp ) {
	        return this.attr.apply(this, arguments);
	    }
	    var val = this.prop.apply(this, arguments);
	    if ( ( val && val.jquery ) || typeof val === 'string' ) {
	        return val;
	    }
	    return this.attr.apply(this, arguments);
	};

	/**
	 * ajaxSubmit() provides a mechanism for immediately submitting
	 * an HTML form using AJAX.
	 */
	$.fn.ajaxSubmit = function(options) {
	    /*jshint scripturl:true */

	    // fast fail if nothing selected (http://dev.jquery.com/ticket/2752)
	    if (!this.length) {
	        log('ajaxSubmit: skipping submit process - no element selected');
	        return this;
	    }

	    var method, action, url, $form = this;

	    if (typeof options == 'function') {
	        options = { success: options };
	    }
	    else if ( options === undefined ) {
	        options = {};
	    }

	    method = options.type || this.attr2('method');
	    action = options.url  || this.attr2('action');

	    url = (typeof action === 'string') ? $.trim(action) : '';
	    url = url || window.location.href || '';
	    if (url) {
	        // clean url (don't include hash vaue)
	        url = (url.match(/^([^#]+)/)||[])[1];
	    }

	    options = $.extend(true, {
	        url:  url,
	        success: $.ajaxSettings.success,
	        type: method || $.ajaxSettings.type,
	        iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank'
	    }, options);

	    // hook for manipulating the form data before it is extracted;
	    // convenient for use with rich editors like tinyMCE or FCKEditor
	    var veto = {};
	    this.trigger('form-pre-serialize', [this, options, veto]);
	    if (veto.veto) {
	        log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
	        return this;
	    }

	    // provide opportunity to alter form data before it is serialized
	    if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
	        log('ajaxSubmit: submit aborted via beforeSerialize callback');
	        return this;
	    }

	    var traditional = options.traditional;
	    if ( traditional === undefined ) {
	        traditional = $.ajaxSettings.traditional;
	    }

	    var elements = [];
	    var qx, a = this.formToArray(options.semantic, elements);
	    if (options.data) {
	        options.extraData = options.data;
	        qx = $.param(options.data, traditional);
	    }

	    // give pre-submit callback an opportunity to abort the submit
	    if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
	        log('ajaxSubmit: submit aborted via beforeSubmit callback');
	        return this;
	    }

	    // fire vetoable 'validate' event
	    this.trigger('form-submit-validate', [a, this, options, veto]);
	    if (veto.veto) {
	        log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
	        return this;
	    }

	    var q = $.param(a, traditional);
	    if (qx) {
	        q = ( q ? (q + '&' + qx) : qx );
	    }
	    if (options.type.toUpperCase() == 'GET') {
	        options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
	        options.data = null;  // data is null for 'get'
	    }
	    else {
	        options.data = q; // data is the query string for 'post'
	    }

	    var callbacks = [];
	    if (options.resetForm) {
	        callbacks.push(function() { $form.resetForm(); });
	    }
	    if (options.clearForm) {
	        callbacks.push(function() { $form.clearForm(options.includeHidden); });
	    }

	    // perform a load on the target only if dataType is not provided
	    if (!options.dataType && options.target) {
	        var oldSuccess = options.success || function(){};
	        callbacks.push(function(data) {
	            var fn = options.replaceTarget ? 'replaceWith' : 'html';
	            $(options.target)[fn](data).each(oldSuccess, arguments);
	        });
	    }
	    else if (options.success) {
	        callbacks.push(options.success);
	    }

	    options.success = function(data, status, xhr) { // jQuery 1.4+ passes xhr as 3rd arg
	        var context = options.context || this ;    // jQuery 1.4+ supports scope context
	        for (var i=0, max=callbacks.length; i < max; i++) {
	            callbacks[i].apply(context, [data, status, xhr || $form, $form]);
	        }
	    };

	    if (options.error) {
	        var oldError = options.error;
	        options.error = function(xhr, status, error) {
	            var context = options.context || this;
	            oldError.apply(context, [xhr, status, error, $form]);
	        };
	    }

	     if (options.complete) {
	        var oldComplete = options.complete;
	        options.complete = function(xhr, status) {
	            var context = options.context || this;
	            oldComplete.apply(context, [xhr, status, $form]);
	        };
	    }

	    // are there files to upload?

	    // [value] (issue #113), also see comment:
	    // https://github.com/malsup/form/commit/588306aedba1de01388032d5f42a60159eea9228#commitcomment-2180219
	    var fileInputs = $('input[type=file]:enabled', this).filter(function() { return $(this).val() !== ''; });

	    var hasFileInputs = fileInputs.length > 0;
	    var mp = 'multipart/form-data';
	    var multipart = ($form.attr('enctype') == mp || $form.attr('encoding') == mp);

	    var fileAPI = feature.fileapi && feature.formdata;
	    log("fileAPI :" + fileAPI);
	    var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;

	    var jqxhr;

	    // options.iframe allows user to force iframe mode
	    // 06-NOV-09: now defaulting to iframe mode if file input is detected
	    if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
	        // hack to fix Safari hang (thanks to Tim Molendijk for this)
	        // see:  http://groups.google.com/group/jquery-dev/browse_thread/thread/36395b7ab510dd5d
	        if (options.closeKeepAlive) {
	            $.get(options.closeKeepAlive, function() {
	                jqxhr = fileUploadIframe(a);
	            });
	        }
	        else {
	            jqxhr = fileUploadIframe(a);
	        }
	    }
	    else if ((hasFileInputs || multipart) && fileAPI) {
	        jqxhr = fileUploadXhr(a);
	    }
	    else {
	        jqxhr = $.ajax(options);
	    }

	    $form.removeData('jqxhr').data('jqxhr', jqxhr);

	    // clear element array
	    for (var k=0; k < elements.length; k++) {
	        elements[k] = null;
	    }

	    // fire 'notify' event
	    this.trigger('form-submit-notify', [this, options]);
	    return this;

	    // utility fn for deep serialization
	    function deepSerialize(extraData){
	        var serialized = $.param(extraData, options.traditional).split('&');
	        var len = serialized.length;
	        var result = [];
	        var i, part;
	        for (i=0; i < len; i++) {
	            // #252; undo param space replacement
	            serialized[i] = serialized[i].replace(/\+/g,' ');
	            part = serialized[i].split('=');
	            // #278; use array instead of object storage, favoring array serializations
	            result.push([decodeURIComponent(part[0]), decodeURIComponent(part[1])]);
	        }
	        return result;
	    }

	     // XMLHttpRequest Level 2 file uploads (big hat tip to francois2metz)
	    function fileUploadXhr(a) {
	        var formdata = new FormData();

	        for (var i=0; i < a.length; i++) {
	            formdata.append(a[i].name, a[i].value);
	        }

	        if (options.extraData) {
	            var serializedData = deepSerialize(options.extraData);
	            for (i=0; i < serializedData.length; i++) {
	                if (serializedData[i]) {
	                    formdata.append(serializedData[i][0], serializedData[i][1]);
	                }
	            }
	        }

	        options.data = null;

	        var s = $.extend(true, {}, $.ajaxSettings, options, {
	            contentType: false,
	            processData: false,
	            cache: false,
	            type: method || 'POST'
	        });

	        if (options.uploadProgress) {
	            // workaround because jqXHR does not expose upload property
	            s.xhr = function() {
	                var xhr = $.ajaxSettings.xhr();
	                if (xhr.upload) {
	                    xhr.upload.addEventListener('progress', function(event) {
	                        var percent = 0;
	                        var position = event.loaded || event.position; /*event.position is deprecated*/
	                        var total = event.total;
	                        if (event.lengthComputable) {
	                            percent = Math.ceil(position / total * 100);
	                        }
	                        options.uploadProgress(event, position, total, percent);
	                    }, false);
	                }
	                return xhr;
	            };
	        }

	        s.data = null;
	        var beforeSend = s.beforeSend;
	        s.beforeSend = function(xhr, o) {
	            //Send FormData() provided by user
	            if (options.formData) {
	                o.data = options.formData;
	            }
	            else {
	                o.data = formdata;
	            }
	            if(beforeSend) {
	                beforeSend.call(this, xhr, o);
	            }
	        };
	        return $.ajax(s);
	    }

	    // private function for handling file uploads (hat tip to YAHOO!)
	    function fileUploadIframe(a) {
	        var form = $form[0], el, i, s, g, id, $io, io, xhr, sub, n, timedOut, timeoutHandle;
	        var deferred = $.Deferred();

	        // #341
	        deferred.abort = function(status) {
	            xhr.abort(status);
	        };

	        if (a) {
	            // ensure that every serialized input is still enabled
	            for (i=0; i < elements.length; i++) {
	                el = $(elements[i]);
	                if ( hasProp ) {
	                    el.prop('disabled', false);
	                }
	                else {
	                    el.removeAttr('disabled');
	                }
	            }
	        }

	        s = $.extend(true, {}, $.ajaxSettings, options);
	        s.context = s.context || s;
	        id = 'jqFormIO' + (new Date().getTime());
	        if (s.iframeTarget) {
	            $io = $(s.iframeTarget);
	            n = $io.attr2('name');
	            if (!n) {
	                $io.attr2('name', id);
	            }
	            else {
	                id = n;
	            }
	        }
	        else {
	            $io = $('<iframe name="' + id + '" src="'+ s.iframeSrc +'" />');
	            $io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });
	        }
	        io = $io[0];


	        xhr = { // mock object
	            aborted: 0,
	            responseText: null,
	            responseXML: null,
	            status: 0,
	            statusText: 'n/a',
	            getAllResponseHeaders: function() {},
	            getResponseHeader: function() {},
	            setRequestHeader: function() {},
	            abort: function(status) {
	                var e = (status === 'timeout' ? 'timeout' : 'aborted');
	                log('aborting upload... ' + e);
	                this.aborted = 1;

	                try { // #214, #257
	                    if (io.contentWindow.document.execCommand) {
	                        io.contentWindow.document.execCommand('Stop');
	                    }
	                }
	                catch(ignore) {}

	                $io.attr('src', s.iframeSrc); // abort op in progress
	                xhr.error = e;
	                if (s.error) {
	                    s.error.call(s.context, xhr, e, status);
	                }
	                if (g) {
	                    $.event.trigger("ajaxError", [xhr, s, e]);
	                }
	                if (s.complete) {
	                    s.complete.call(s.context, xhr, e);
	                }
	            }
	        };

	        g = s.global;
	        // trigger ajax global events so that activity/block indicators work like normal
	        if (g && 0 === $.active++) {
	            $.event.trigger("ajaxStart");
	        }
	        if (g) {
	            $.event.trigger("ajaxSend", [xhr, s]);
	        }

	        if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
	            if (s.global) {
	                $.active--;
	            }
	            deferred.reject();
	            return deferred;
	        }
	        if (xhr.aborted) {
	            deferred.reject();
	            return deferred;
	        }

	        // add submitting element to data if we know it
	        sub = form.clk;
	        if (sub) {
	            n = sub.name;
	            if (n && !sub.disabled) {
	                s.extraData = s.extraData || {};
	                s.extraData[n] = sub.value;
	                if (sub.type == "image") {
	                    s.extraData[n+'.x'] = form.clk_x;
	                    s.extraData[n+'.y'] = form.clk_y;
	                }
	            }
	        }

	        var CLIENT_TIMEOUT_ABORT = 1;
	        var SERVER_ABORT = 2;
	                
	        function getDoc(frame) {
	            /* it looks like contentWindow or contentDocument do not
	             * carry the protocol property in ie8, when running under ssl
	             * frame.document is the only valid response document, since
	             * the protocol is know but not on the other two objects. strange?
	             * "Same origin policy" http://en.wikipedia.org/wiki/Same_origin_policy
	             */
	            
	            var doc = null;
	            
	            // IE8 cascading access check
	            try {
	                if (frame.contentWindow) {
	                    doc = frame.contentWindow.document;
	                }
	            } catch(err) {
	                // IE8 access denied under ssl & missing protocol
	                log('cannot get iframe.contentWindow document: ' + err);
	            }

	            if (doc) { // successful getting content
	                return doc;
	            }

	            try { // simply checking may throw in ie8 under ssl or mismatched protocol
	                doc = frame.contentDocument ? frame.contentDocument : frame.document;
	            } catch(err) {
	                // last attempt
	                log('cannot get iframe.contentDocument: ' + err);
	                doc = frame.document;
	            }
	            return doc;
	        }

	        // Rails CSRF hack (thanks to Yvan Barthelemy)
	        var csrf_token = $('meta[name=csrf-token]').attr('content');
	        var csrf_param = $('meta[name=csrf-param]').attr('content');
	        if (csrf_param && csrf_token) {
	            s.extraData = s.extraData || {};
	            s.extraData[csrf_param] = csrf_token;
	        }

	        // take a breath so that pending repaints get some cpu time before the upload starts
	        function doSubmit() {
	            // make sure form attrs are set
	            var t = $form.attr2('target'), 
	                a = $form.attr2('action'), 
	                mp = 'multipart/form-data',
	                et = $form.attr('enctype') || $form.attr('encoding') || mp;

	            // update form attrs in IE friendly way
	            form.setAttribute('target',id);
	            if (!method || /post/i.test(method) ) {
	                form.setAttribute('method', 'POST');
	            }
	            if (a != s.url) {
	                form.setAttribute('action', s.url);
	            }

	            // ie borks in some cases when setting encoding
	            if (! s.skipEncodingOverride && (!method || /post/i.test(method))) {
	                $form.attr({
	                    encoding: 'multipart/form-data',
	                    enctype:  'multipart/form-data'
	                });
	            }

	            // support timout
	            if (s.timeout) {
	                timeoutHandle = setTimeout(function() { timedOut = true; cb(CLIENT_TIMEOUT_ABORT); }, s.timeout);
	            }

	            // look for server aborts
	            function checkState() {
	                try {
	                    var state = getDoc(io).readyState;
	                    log('state = ' + state);
	                    if (state && state.toLowerCase() == 'uninitialized') {
	                        setTimeout(checkState,50);
	                    }
	                }
	                catch(e) {
	                    log('Server abort: ' , e, ' (', e.name, ')');
	                    cb(SERVER_ABORT);
	                    if (timeoutHandle) {
	                        clearTimeout(timeoutHandle);
	                    }
	                    timeoutHandle = undefined;
	                }
	            }

	            // add "extra" data to form if provided in options
	            var extraInputs = [];
	            try {
	                if (s.extraData) {
	                    for (var n in s.extraData) {
	                        if (s.extraData.hasOwnProperty(n)) {
	                           // if using the $.param format that allows for multiple values with the same name
	                           if($.isPlainObject(s.extraData[n]) && s.extraData[n].hasOwnProperty('name') && s.extraData[n].hasOwnProperty('value')) {
	                               extraInputs.push(
	                               $('<input type="hidden" name="'+s.extraData[n].name+'">').val(s.extraData[n].value)
	                                   .appendTo(form)[0]);
	                           } else {
	                               extraInputs.push(
	                               $('<input type="hidden" name="'+n+'">').val(s.extraData[n])
	                                   .appendTo(form)[0]);
	                           }
	                        }
	                    }
	                }

	                if (!s.iframeTarget) {
	                    // add iframe to doc and submit the form
	                    $io.appendTo('body');
	                }
	                if (io.attachEvent) {
	                    io.attachEvent('onload', cb);
	                }
	                else {
	                    io.addEventListener('load', cb, false);
	                }
	                setTimeout(checkState,15);

	                try {
	                    form.submit();
	                } catch(err) {
	                    // just in case form has element with name/id of 'submit'
	                    var submitFn = document.createElement('form').submit;
	                    submitFn.apply(form);
	                }
	            }
	            finally {
	                // reset attrs and remove "extra" input elements
	                form.setAttribute('action',a);
	                form.setAttribute('enctype', et); // #380
	                if(t) {
	                    form.setAttribute('target', t);
	                } else {
	                    $form.removeAttr('target');
	                }
	                $(extraInputs).remove();
	            }
	        }

	        if (s.forceSync) {
	            doSubmit();
	        }
	        else {
	            setTimeout(doSubmit, 10); // this lets dom updates render
	        }

	        var data, doc, domCheckCount = 50, callbackProcessed;

	        function cb(e) {
	            if (xhr.aborted || callbackProcessed) {
	                return;
	            }
	            
	            doc = getDoc(io);
	            if(!doc) {
	                log('cannot access response document');
	                e = SERVER_ABORT;
	            }
	            if (e === CLIENT_TIMEOUT_ABORT && xhr) {
	                xhr.abort('timeout');
	                deferred.reject(xhr, 'timeout');
	                return;
	            }
	            else if (e == SERVER_ABORT && xhr) {
	                xhr.abort('server abort');
	                deferred.reject(xhr, 'error', 'server abort');
	                return;
	            }

	            if (!doc || doc.location.href == s.iframeSrc) {
	                // response not received yet
	                if (!timedOut) {
	                    return;
	                }
	            }
	            if (io.detachEvent) {
	                io.detachEvent('onload', cb);
	            }
	            else {
	                io.removeEventListener('load', cb, false);
	            }

	            var status = 'success', errMsg;
	            try {
	                if (timedOut) {
	                    throw 'timeout';
	                }

	                var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
	                log('isXml='+isXml);
	                if (!isXml && window.opera && (doc.body === null || !doc.body.innerHTML)) {
	                    if (--domCheckCount) {
	                        // in some browsers (Opera) the iframe DOM is not always traversable when
	                        // the onload callback fires, so we loop a bit to accommodate
	                        log('requeing onLoad callback, DOM not available');
	                        setTimeout(cb, 250);
	                        return;
	                    }
	                    // let this fall through because server response could be an empty document
	                    //log('Could not access iframe DOM after mutiple tries.');
	                    //throw 'DOMException: not available';
	                }

	                //log('response detected');
	                var docRoot = doc.body ? doc.body : doc.documentElement;
	                xhr.responseText = docRoot ? docRoot.innerHTML : null;
	                xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
	                if (isXml) {
	                    s.dataType = 'xml';
	                }
	                xhr.getResponseHeader = function(header){
	                    var headers = {'content-type': s.dataType};
	                    return headers[header.toLowerCase()];
	                };
	                // support for XHR 'status' & 'statusText' emulation :
	                if (docRoot) {
	                    xhr.status = Number( docRoot.getAttribute('status') ) || xhr.status;
	                    xhr.statusText = docRoot.getAttribute('statusText') || xhr.statusText;
	                }

	                var dt = (s.dataType || '').toLowerCase();
	                var scr = /(json|script|text)/.test(dt);
	                if (scr || s.textarea) {
	                    // see if user embedded response in textarea
	                    var ta = doc.getElementsByTagName('textarea')[0];
	                    if (ta) {
	                        xhr.responseText = ta.value;
	                        // support for XHR 'status' & 'statusText' emulation :
	                        xhr.status = Number( ta.getAttribute('status') ) || xhr.status;
	                        xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
	                    }
	                    else if (scr) {
	                        // account for browsers injecting pre around json response
	                        var pre = doc.getElementsByTagName('pre')[0];
	                        var b = doc.getElementsByTagName('body')[0];
	                        if (pre) {
	                            xhr.responseText = pre.textContent ? pre.textContent : pre.innerText;
	                        }
	                        else if (b) {
	                            xhr.responseText = b.textContent ? b.textContent : b.innerText;
	                        }
	                    }
	                }
	                else if (dt == 'xml' && !xhr.responseXML && xhr.responseText) {
	                    xhr.responseXML = toXml(xhr.responseText);
	                }

	                try {
	                    data = httpData(xhr, dt, s);
	                }
	                catch (err) {
	                    status = 'parsererror';
	                    xhr.error = errMsg = (err || status);
	                }
	            }
	            catch (err) {
	                log('error caught: ',err);
	                status = 'error';
	                xhr.error = errMsg = (err || status);
	            }

	            if (xhr.aborted) {
	                log('upload aborted');
	                status = null;
	            }

	            if (xhr.status) { // we've set xhr.status
	                status = (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) ? 'success' : 'error';
	            }

	            // ordering of these callbacks/triggers is odd, but that's how $.ajax does it
	            if (status === 'success') {
	                if (s.success) {
	                    s.success.call(s.context, data, 'success', xhr);
	                }
	                deferred.resolve(xhr.responseText, 'success', xhr);
	                if (g) {
	                    $.event.trigger("ajaxSuccess", [xhr, s]);
	                }
	            }
	            else if (status) {
	                if (errMsg === undefined) {
	                    errMsg = xhr.statusText;
	                }
	                if (s.error) {
	                    s.error.call(s.context, xhr, status, errMsg);
	                }
	                deferred.reject(xhr, 'error', errMsg);
	                if (g) {
	                    $.event.trigger("ajaxError", [xhr, s, errMsg]);
	                }
	            }

	            if (g) {
	                $.event.trigger("ajaxComplete", [xhr, s]);
	            }

	            if (g && ! --$.active) {
	                $.event.trigger("ajaxStop");
	            }

	            if (s.complete) {
	                s.complete.call(s.context, xhr, status);
	            }

	            callbackProcessed = true;
	            if (s.timeout) {
	                clearTimeout(timeoutHandle);
	            }

	            // clean up
	            setTimeout(function() {
	                if (!s.iframeTarget) {
	                    $io.remove();
	                }
	                else { //adding else to clean up existing iframe response.
	                    $io.attr('src', s.iframeSrc);
	                }
	                xhr.responseXML = null;
	            }, 100);
	        }

	        var toXml = $.parseXML || function(s, doc) { // use parseXML if available (jQuery 1.5+)
	            if (window.ActiveXObject) {
	                doc = new ActiveXObject('Microsoft.XMLDOM');
	                doc.async = 'false';
	                doc.loadXML(s);
	            }
	            else {
	                doc = (new DOMParser()).parseFromString(s, 'text/xml');
	            }
	            return (doc && doc.documentElement && doc.documentElement.nodeName != 'parsererror') ? doc : null;
	        };
	        var parseJSON = $.parseJSON || function(s) {
	            /*jslint evil:true */
	            return window['eval']('(' + s + ')');
	        };

	        var httpData = function( xhr, type, s ) { // mostly lifted from jq1.4.4

	            var ct = xhr.getResponseHeader('content-type') || '',
	                xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
	                data = xml ? xhr.responseXML : xhr.responseText;

	            if (xml && data.documentElement.nodeName === 'parsererror') {
	                if ($.error) {
	                    $.error('parsererror');
	                }
	            }
	            if (s && s.dataFilter) {
	                data = s.dataFilter(data, type);
	            }
	            if (typeof data === 'string') {
	                if (type === 'json' || !type && ct.indexOf('json') >= 0) {
	                    data = parseJSON(data);
	                } else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
	                    $.globalEval(data);
	                }
	            }
	            return data;
	        };

	        return deferred;
	    }
	};

	/**
	 * ajaxForm() provides a mechanism for fully automating form submission.
	 *
	 * The advantages of using this method instead of ajaxSubmit() are:
	 *
	 * 1: This method will include coordinates for <input type="image" /> elements (if the element
	 *    is used to submit the form).
	 * 2. This method will include the submit element's name/value data (for the element that was
	 *    used to submit the form).
	 * 3. This method binds the submit() method to the form for you.
	 *
	 * The options argument for ajaxForm works exactly as it does for ajaxSubmit.  ajaxForm merely
	 * passes the options argument along after properly binding events for submit elements and
	 * the form itself.
	 */
	$.fn.ajaxForm = function(options) {
	    options = options || {};
	    options.delegation = options.delegation && $.isFunction($.fn.on);

	    // in jQuery 1.3+ we can fix mistakes with the ready state
	    if (!options.delegation && this.length === 0) {
	        var o = { s: this.selector, c: this.context };
	        if (!$.isReady && o.s) {
	            log('DOM not ready, queuing ajaxForm');
	            $(function() {
	                $(o.s,o.c).ajaxForm(options);
	            });
	            return this;
	        }
	        // is your DOM ready?  http://docs.jquery.com/Tutorials:Introducing_$(document).ready()
	        log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
	        return this;
	    }

	    if ( options.delegation ) {
	        $(document)
	            .off('submit.form-plugin', this.selector, doAjaxSubmit)
	            .off('click.form-plugin', this.selector, captureSubmittingElement)
	            .on('submit.form-plugin', this.selector, options, doAjaxSubmit)
	            .on('click.form-plugin', this.selector, options, captureSubmittingElement);
	        return this;
	    }

	    return this.ajaxFormUnbind()
	        .bind('submit.form-plugin', options, doAjaxSubmit)
	        .bind('click.form-plugin', options, captureSubmittingElement);
	};

	// private event handlers
	function doAjaxSubmit(e) {
	    /*jshint validthis:true */
	    var options = e.data;
	    if (!e.isDefaultPrevented()) { // if event has been canceled, don't proceed
	        e.preventDefault();
	        $(e.target).ajaxSubmit(options); // #365
	    }
	}

	function captureSubmittingElement(e) {
	    /*jshint validthis:true */
	    var target = e.target;
	    var $el = $(target);
	    if (!($el.is("[type=submit],[type=image]"))) {
	        // is this a child element of the submit el?  (ex: a span within a button)
	        var t = $el.closest('[type=submit]');
	        if (t.length === 0) {
	            return;
	        }
	        target = t[0];
	    }
	    var form = this;
	    form.clk = target;
	    if (target.type == 'image') {
	        if (e.offsetX !== undefined) {
	            form.clk_x = e.offsetX;
	            form.clk_y = e.offsetY;
	        } else if (typeof $.fn.offset == 'function') {
	            var offset = $el.offset();
	            form.clk_x = e.pageX - offset.left;
	            form.clk_y = e.pageY - offset.top;
	        } else {
	            form.clk_x = e.pageX - target.offsetLeft;
	            form.clk_y = e.pageY - target.offsetTop;
	        }
	    }
	    // clear form vars
	    setTimeout(function() { form.clk = form.clk_x = form.clk_y = null; }, 100);
	}


	// ajaxFormUnbind unbinds the event handlers that were bound by ajaxForm
	$.fn.ajaxFormUnbind = function() {
	    return this.unbind('submit.form-plugin click.form-plugin');
	};

	/**
	 * formToArray() gathers form element data into an array of objects that can
	 * be passed to any of the following ajax functions: $.get, $.post, or load.
	 * Each object in the array has both a 'name' and 'value' property.  An example of
	 * an array for a simple login form might be:
	 *
	 * [ { name: 'username', value: 'jresig' }, { name: 'password', value: 'secret' } ]
	 *
	 * It is this array that is passed to pre-submit callback functions provided to the
	 * ajaxSubmit() and ajaxForm() methods.
	 */
	$.fn.formToArray = function(semantic, elements) {
	    var a = [];
	    if (this.length === 0) {
	        return a;
	    }

	    var form = this[0];
	    var formId = this.attr('id');
	    var els = semantic ? form.getElementsByTagName('*') : form.elements;
	    var els2;

	    if (els && !/MSIE [678]/.test(navigator.userAgent)) { // #390
	        els = $(els).get();  // convert to standard array
	    }

	    // #386; account for inputs outside the form which use the 'form' attribute
	    if ( formId ) {
	        els2 = $(':input[form="' + formId + '"]').get(); // hat tip @thet
	        if ( els2.length ) {
	            els = (els || []).concat(els2);
	        }
	    }

	    if (!els || !els.length) {
	        return a;
	    }

	    var i,j,n,v,el,max,jmax;
	    for(i=0, max=els.length; i < max; i++) {
	        el = els[i];
	        n = el.name;
	        if (!n || el.disabled) {
	            continue;
	        }

	        if (semantic && form.clk && el.type == "image") {
	            // handle image inputs on the fly when semantic == true
	            if(form.clk == el) {
	                a.push({name: n, value: $(el).val(), type: el.type });
	                a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
	            }
	            continue;
	        }

	        v = $.fieldValue(el, true);
	        if (v && v.constructor == Array) {
	            if (elements) {
	                elements.push(el);
	            }
	            for(j=0, jmax=v.length; j < jmax; j++) {
	                a.push({name: n, value: v[j]});
	            }
	        }
	        else if (feature.fileapi && el.type == 'file') {
	            if (elements) {
	                elements.push(el);
	            }
	            var files = el.files;
	            if (files.length) {
	                for (j=0; j < files.length; j++) {
	                    a.push({name: n, value: files[j], type: el.type});
	                }
	            }
	            else {
	                // #180
	                a.push({ name: n, value: '', type: el.type });
	            }
	        }
	        else if (v !== null && typeof v != 'undefined') {
	            if (elements) {
	                elements.push(el);
	            }
	            a.push({name: n, value: v, type: el.type, required: el.required});
	        }
	    }

	    if (!semantic && form.clk) {
	        // input type=='image' are not found in elements array! handle it here
	        var $input = $(form.clk), input = $input[0];
	        n = input.name;
	        if (n && !input.disabled && input.type == 'image') {
	            a.push({name: n, value: $input.val()});
	            a.push({name: n+'.x', value: form.clk_x}, {name: n+'.y', value: form.clk_y});
	        }
	    }
	    return a;
	};

	/**
	 * Serializes form data into a 'submittable' string. This method will return a string
	 * in the format: name1=value1&amp;name2=value2
	 */
	$.fn.formSerialize = function(semantic) {
	    //hand off to jQuery.param for proper encoding
	    return $.param(this.formToArray(semantic));
	};

	/**
	 * Serializes all field elements in the jQuery object into a query string.
	 * This method will return a string in the format: name1=value1&amp;name2=value2
	 */
	$.fn.fieldSerialize = function(successful) {
	    var a = [];
	    this.each(function() {
	        var n = this.name;
	        if (!n) {
	            return;
	        }
	        var v = $.fieldValue(this, successful);
	        if (v && v.constructor == Array) {
	            for (var i=0,max=v.length; i < max; i++) {
	                a.push({name: n, value: v[i]});
	            }
	        }
	        else if (v !== null && typeof v != 'undefined') {
	            a.push({name: this.name, value: v});
	        }
	    });
	    //hand off to jQuery.param for proper encoding
	    return $.param(a);
	};

	/**
	 * Returns the value(s) of the element in the matched set.  For example, consider the following form:
	 *
	 *  <form><fieldset>
	 *      <input name="A" type="text" />
	 *      <input name="A" type="text" />
	 *      <input name="B" type="checkbox" value="B1" />
	 *      <input name="B" type="checkbox" value="B2"/>
	 *      <input name="C" type="radio" value="C1" />
	 *      <input name="C" type="radio" value="C2" />
	 *  </fieldset></form>
	 *
	 *  var v = $('input[type=text]').fieldValue();
	 *  // if no values are entered into the text inputs
	 *  v == ['','']
	 *  // if values entered into the text inputs are 'foo' and 'bar'
	 *  v == ['foo','bar']
	 *
	 *  var v = $('input[type=checkbox]').fieldValue();
	 *  // if neither checkbox is checked
	 *  v === undefined
	 *  // if both checkboxes are checked
	 *  v == ['B1', 'B2']
	 *
	 *  var v = $('input[type=radio]').fieldValue();
	 *  // if neither radio is checked
	 *  v === undefined
	 *  // if first radio is checked
	 *  v == ['C1']
	 *
	 * The successful argument controls whether or not the field element must be 'successful'
	 * (per http://www.w3.org/TR/html4/interact/forms.html#successful-controls).
	 * The default value of the successful argument is true.  If this value is false the value(s)
	 * for each element is returned.
	 *
	 * Note: This method *always* returns an array.  If no valid value can be determined the
	 *    array will be empty, otherwise it will contain one or more values.
	 */
	$.fn.fieldValue = function(successful) {
	    for (var val=[], i=0, max=this.length; i < max; i++) {
	        var el = this[i];
	        var v = $.fieldValue(el, successful);
	        if (v === null || typeof v == 'undefined' || (v.constructor == Array && !v.length)) {
	            continue;
	        }
	        if (v.constructor == Array) {
	            $.merge(val, v);
	        }
	        else {
	            val.push(v);
	        }
	    }
	    return val;
	};

	/**
	 * Returns the value of the field element.
	 */
	$.fieldValue = function(el, successful) {
	    var n = el.name, t = el.type, tag = el.tagName.toLowerCase();
	    if (successful === undefined) {
	        successful = true;
	    }

	    if (successful && (!n || el.disabled || t == 'reset' || t == 'button' ||
	        (t == 'checkbox' || t == 'radio') && !el.checked ||
	        (t == 'submit' || t == 'image') && el.form && el.form.clk != el ||
	        tag == 'select' && el.selectedIndex == -1)) {
	            return null;
	    }

	    if (tag == 'select') {
	        var index = el.selectedIndex;
	        if (index < 0) {
	            return null;
	        }
	        var a = [], ops = el.options;
	        var one = (t == 'select-one');
	        var max = (one ? index+1 : ops.length);
	        for(var i=(one ? index : 0); i < max; i++) {
	            var op = ops[i];
	            if (op.selected) {
	                var v = op.value;
	                if (!v) { // extra pain for IE...
	                    v = (op.attributes && op.attributes.value && !(op.attributes.value.specified)) ? op.text : op.value;
	                }
	                if (one) {
	                    return v;
	                }
	                a.push(v);
	            }
	        }
	        return a;
	    }
	    return $(el).val();
	};

	/**
	 * Clears the form data.  Takes the following actions on the form's input fields:
	 *  - input text fields will have their 'value' property set to the empty string
	 *  - select elements will have their 'selectedIndex' property set to -1
	 *  - checkbox and radio inputs will have their 'checked' property set to false
	 *  - inputs of type submit, button, reset, and hidden will *not* be effected
	 *  - button elements will *not* be effected
	 */
	$.fn.clearForm = function(includeHidden) {
	    return this.each(function() {
	        $('input,select,textarea', this).clearFields(includeHidden);
	    });
	};

	/**
	 * Clears the selected form elements.
	 */
	$.fn.clearFields = $.fn.clearInputs = function(includeHidden) {
	    var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i; // 'hidden' is not in this list
	    return this.each(function() {
	        var t = this.type, tag = this.tagName.toLowerCase();
	        if (re.test(t) || tag == 'textarea') {
	            this.value = '';
	        }
	        else if (t == 'checkbox' || t == 'radio') {
	            this.checked = false;
	        }
	        else if (tag == 'select') {
	            this.selectedIndex = -1;
	        }
	        else if (t == "file") {
	            if (/MSIE/.test(navigator.userAgent)) {
	                $(this).replaceWith($(this).clone(true));
	            } else {
	                $(this).val('');
	            }
	        }
	        else if (includeHidden) {
	            // includeHidden can be the value true, or it can be a selector string
	            // indicating a special test; for example:
	            //  $('#myForm').clearForm('.special:hidden')
	            // the above would clean hidden inputs that have the class of 'special'
	            if ( (includeHidden === true && /hidden/.test(t)) ||
	                 (typeof includeHidden == 'string' && $(this).is(includeHidden)) ) {
	                this.value = '';
	            }
	        }
	    });
	};

	/**
	 * Resets the form data.  Causes all form elements to be reset to their original value.
	 */
	$.fn.resetForm = function() {
	    return this.each(function() {
	        // guard against an input with the name of 'reset'
	        // note that IE reports the reset function as an 'object'
	        if (typeof this.reset == 'function' || (typeof this.reset == 'object' && !this.reset.nodeType)) {
	            this.reset();
	        }
	    });
	};

	/**
	 * Enables or disables any matching elements.
	 */
	$.fn.enable = function(b) {
	    if (b === undefined) {
	        b = true;
	    }
	    return this.each(function() {
	        this.disabled = !b;
	    });
	};

	/**
	 * Checks/unchecks any matching checkboxes or radio buttons and
	 * selects/deselects and matching option elements.
	 */
	$.fn.selected = function(select) {
	    if (select === undefined) {
	        select = true;
	    }
	    return this.each(function() {
	        var t = this.type;
	        if (t == 'checkbox' || t == 'radio') {
	            this.checked = select;
	        }
	        else if (this.tagName.toLowerCase() == 'option') {
	            var $sel = $(this).parent('select');
	            if (select && $sel[0] && $sel[0].type == 'select-one') {
	                // deselect all other options
	                $sel.find('option').selected(false);
	            }
	            this.selected = select;
	        }
	    });
	};

	// expose debug var
	$.fn.ajaxSubmit.debug = false;

	// helper fn for console logging
	function log() {
	    if (!$.fn.ajaxSubmit.debug) {
	        return;
	    }
	    var msg = '[jquery.form] ' + Array.prototype.join.call(arguments,'');
	    if (window.console && window.console.log) {
	        window.console.log(msg);
	    }
	    else if (window.opera && window.opera.postError) {
	        window.opera.postError(msg);
	    }
	}

	// }));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var ApplyFilters, OpinionFilter, ProposalFilter, VerificationProcessExplanation, basic_proposal_scoring, get_all_tags, regexes, set_sort, sort_options;

	__webpack_require__(3);

	__webpack_require__(4);

	get_all_tags = function() {
	  var all_tags, c, i, j, len, len1, proposal, proposals, tag, tags, text;
	  proposals = fetch('/proposals');
	  proposals = _.flatten((function() {
	    var i, len, ref, results;
	    ref = proposals.clusters;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      c = ref[i];
	      results.push(c.proposals);
	    }
	    return results;
	  })());
	  all_tags = {};
	  for (i = 0, len = proposals.length; i < len; i++) {
	    proposal = proposals[i];
	    text = proposal.name + " " + proposal.description;
	    if (text.indexOf("#") > -1 && (tags = text.match(/#(\w+)/g))) {
	      for (j = 0, len1 = tags.length; j < len1; j++) {
	        tag = tags[j];
	        tag = tag.toLowerCase();
	        all_tags[tag] || (all_tags[tag] = 0);
	        all_tags[tag] += 1;
	      }
	    }
	  }
	  return all_tags;
	};

	regexes = {};

	ApplyFilters = ReactiveComponent({
	  displayName: 'ApplyFilters',
	  render: function() {
	    var c, editor, filter, filter_out, filters, i, j, l, len, len1, len2, new_filter_out, passes, proposal, proposals, ref, ref1, text;
	    filters = fetch('filters');
	    filter_out = fetch('filtered');
	    filter_out.proposals || (filter_out.proposals = {});
	    proposals = fetch('/proposals');
	    proposals = _.flatten((function() {
	      var i, len, ref, results;
	      ref = proposals.clusters;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        c = ref[i];
	        results.push(c.proposals);
	      }
	      return results;
	    })());
	    new_filter_out = {};
	    ref = filters.for_proposals || [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      filter = ref[i];
	      if (!regexes[filter]) {
	        regexes[filter] = new RegExp(filter, 'i');
	      }
	    }
	    for (j = 0, len1 = proposals.length; j < len1; j++) {
	      proposal = proposals[j];
	      editor = proposal_editor(proposal);
	      if (editor) {
	        editor = fetch(editor).name;
	      } else {
	        editor = "";
	      }
	      text = editor + " " + proposal.name + " " + proposal.description + " " + (prettyDate(proposal.created_at));
	      passes = true;
	      ref1 = filters.for_proposals || [];
	      for (l = 0, len2 = ref1.length; l < len2; l++) {
	        filter = ref1[l];
	        passes && (passes = !!text.match(regexes[filter]));
	      }
	      if (!passes) {
	        new_filter_out[proposal.key] = 1;
	      }
	    }
	    if (JSON.stringify(new_filter_out) !== JSON.stringify(filter_out.proposals)) {
	      filter_out.proposals = new_filter_out;
	      save(filter_out);
	    }
	    return SPAN(null);
	  }
	});

	window.sorted_proposals = function(proposals) {
	  var filter_out, filtered, i, j, len, len1, proposal, proposal_rank, sort;
	  sort = fetch('sort_proposals');
	  if (sort.func == null) {
	    set_sort();
	  }
	  proposal_rank = sort.func || customization("proposal_rank");
	  proposals = proposals.slice().sort(function(a, b) {
	    return proposal_rank(b, sort.opinion_value) - proposal_rank(a, sort.opinion_value);
	  });
	  filter_out = fetch('filtered');
	  if (filter_out.proposals) {
	    filtered = [];
	    for (i = 0, len = proposals.length; i < len; i++) {
	      proposal = proposals[i];
	      if (filter_out.proposals[proposal.key]) {
	        filtered.push(proposal);
	      }
	    }
	    for (j = 0, len1 = filtered.length; j < len1; j++) {
	      proposal = filtered[j];
	      proposals.splice(proposals.indexOf(proposal), 1);
	    }
	  }
	  return proposals;
	};

	basic_proposal_scoring = function(proposal, opinion_value) {
	  var filtered_out, i, len, o, opinion, opinions, sum;
	  if (!opinion_value) {
	    opinion_value = function(o) {
	      return o.stance;
	    };
	  }
	  opinions = fetch(proposal).opinions;
	  if (!opinions || opinions.length === 0) {
	    return null;
	  }
	  filtered_out = fetch('filtered');
	  if (filtered_out.users) {
	    opinions = (function() {
	      var i, len, ref, results;
	      results = [];
	      for (i = 0, len = opinions.length; i < len; i++) {
	        o = opinions[i];
	        if (!((ref = filtered_out.users) != null ? ref[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    })();
	  }
	  sum = 0;
	  for (i = 0, len = opinions.length; i < len; i++) {
	    opinion = opinions[i];
	    sum += opinion_value(opinion);
	  }
	  return sum;
	};

	sort_options = [
	  {
	    func: basic_proposal_scoring,
	    name: 'total score',
	    opinion_value: function(o) {
	      return o.stance;
	    },
	    description: "Each proposal is scored by the sum of opinions, where opinions are on [-1, 1]."
	  }, {
	    func: function(proposal) {
	      return new Date(proposal.created_at).getTime();
	    },
	    name: 'newest',
	    description: "The proposals submitted most recently are shown first."
	  }, {
	    func: basic_proposal_scoring,
	    name: 'most activity',
	    opinion_value: function(o) {
	      return 1 + (o.point_inclusions || []).length;
	    },
	    description: "Each proposal is scored by the raw number of opinions and recognized pros/cons."
	  }, {
	    func: function(proposal, opinion_value) {
	      var sum;
	      sum = basic_proposal_scoring(proposal, opinion_value);
	      return sum / fetch(proposal).opinions.length;
	    },
	    name: 'average score',
	    opinion_value: function(o) {
	      return o.stance;
	    },
	    description: "Each proposal is scored by the average opinion score, where opinions are on [-1, 1]."
	  }, {
	    func: function(proposal) {
	      if (fetch(proposal.your_opinion).published) {
	        return proposal.your_opinion.stance;
	      } else {
	        return -1;
	      }
	    },
	    name: 'your score',
	    description: "Proposals are ordered by your own opinion on them."
	  }, {
	    func: function(proposal, opinion_value) {
	      var n, pt, sum;
	      sum = basic_proposal_scoring(proposal, opinion_value);
	      n = Date.now();
	      pt = new Date(proposal.created_at).getTime();
	      return sum / (1 + (n - pt) / 10000000000);
	    },
	    name: 'trending',
	    opinion_value: function(o) {
	      var n, ot;
	      ot = new Date(o.updated_at).getTime();
	      n = Date.now();
	      return o.stance / (1 + Math.pow((n - ot) / 100000, 2));
	    },
	    description: "Like 'total score', except that newer opinions are weighed more heavily, and older proposals are penalized."
	  }
	];

	set_sort = function() {
	  var def, found, i, j, len, len1, loc, ref, s, sort;
	  sort = fetch('sort_proposals');
	  if (sort.func == null) {
	    found = false;
	    loc = fetch('location');
	    if ((ref = loc.query_params) != null ? ref.sort_by : void 0) {
	      for (i = 0, len = sort_options.length; i < len; i++) {
	        s = sort_options[i];
	        if (s.name === loc.query_params.sort_by.replace('_', ' ')) {
	          _.extend(sort, s || sort_options[0]);
	          found = true;
	          break;
	        }
	      }
	    }
	    if (!found) {
	      if (customization("proposal_rank")) {
	        sort.func = customization("proposal_rank");
	        sort.name = 'custom';
	      } else if (customization('default_proposal_sort')) {
	        def = null;
	        for (j = 0, len1 = sort_options.length; j < len1; j++) {
	          s = sort_options[j];
	          if (s.name === customization('default_proposal_sort')) {
	            def = s;
	            break;
	          }
	        }
	        _.extend(sort, def || sort_options[0]);
	      } else {
	        _.extend(sort, sort_options[0]);
	      }
	    }
	    return save(sort);
	  }
	};

	ProposalFilter = ReactiveComponent({
	  displayName: 'ProposalFilter',
	  render: function() {
	    var filter, filter_out, filters, proposals, sort, sort_option;
	    proposals = fetch('/proposals');
	    filter_out = fetch('filtered');
	    filters = fetch('filters');
	    sort = fetch('sort_proposals');
	    if (sort.func == null) {
	      set_sort();
	    }
	    return DIV({
	      style: _.defaults(this.props.style || {})
	    }, ApplyFilters(), FORM({
	      onSubmit: (function(_this) {
	        return function(e) {
	          var n;
	          n = _this.refs.new_filter.getDOMNode();
	          filters.for_proposals || (filters.for_proposals = []);
	          filters.for_proposals.push(n.value);
	          save(filters);
	          n.value = null;
	          e.stopPropagation();
	          return e.preventDefault();
	        };
	      })(this)
	    }, INPUT({
	      ref: 'new_filter',
	      type: 'text',
	      placeholder: 'search proposals',
	      style: {
	        fontSize: 16,
	        padding: '4px 8px',
	        width: 300
	      }
	    })), DIV({
	      style: {
	        paddingTop: 5
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = filters.for_proposals || [];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        filter = ref[i];
	        results.push((function(_this) {
	          return function(filter) {
	            return SPAN({
	              style: {
	                backgroundColor: '#eee',
	                color: '#666',
	                padding: '4px 8px',
	                borderRadius: 16,
	                fontSize: 16,
	                cursor: 'pointer',
	                boxShadow: '0 1px 1px rgba(0,0,0,.2)',
	                marginRight: 10
	              },
	              onClick: function() {
	                var idx;
	                idx = filters.for_proposals.indexOf(filter);
	                filters.for_proposals.splice(idx, 1);
	                return save(filters);
	              }
	            }, filter);
	          };
	        })(this)(filter));
	      }
	      return results;
	    }).call(this)), DIV({
	      style: {
	        color: focus_blue,
	        fontSize: 20,
	        fontWeight: 500,
	        marginTop: 12
	      }
	    }, "sort proposals by ", SPAN({
	      style: {
	        fontWeight: 700,
	        position: 'relative',
	        cursor: 'pointer',
	        textDecoration: 'underline'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_sort_options = !_this.local.show_sort_options;
	          return save(_this.local);
	        };
	      })(this)
	    }, sort.name, SPAN({
	      style: _.extend(cssTriangle('bottom', focus_blue, 11, 7, {
	        display: 'inline-block',
	        marginLeft: 4
	      }))
	    }), this.local.show_sort_options ? DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 999,
	        width: HOMEPAGE_WIDTH(),
	        backgroundColor: '#eee',
	        border: "1px solid " + focus_blue,
	        top: 24,
	        borderRadius: 8,
	        fontWeight: 400,
	        overflow: 'hidden',
	        boxShadow: '0 1px 2px rgba(0,0,0,.3)'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = sort_options.length; i < len; i++) {
	        sort_option = sort_options[i];
	        results.push((function(_this) {
	          return function(sort_option) {
	            return DIV({
	              style: {
	                padding: '6px 12px',
	                borderBottom: "1px solid #ddd",
	                color: _this.local.hover === sort_option.name ? 'white' : void 0,
	                backgroundColor: _this.local.hover === sort_option.name ? focus_blue : void 0,
	                fontWeight: 600
	              },
	              onMouseEnter: function() {
	                _this.local.hover = sort_option.name;
	                return save(_this.local);
	              },
	              onMouseLeave: function() {
	                _this.local.hover = null;
	                return save(_this.local);
	              },
	              onClick: function(e) {
	                _.extend(sort, sort_option);
	                save(sort);
	                _this.local.show_sort_options = false;
	                save(_this.local);
	                return e.stopPropagation();
	              }
	            }, sort_option.name, DIV({
	              style: {
	                fontSize: 16,
	                color: _this.local.hover === sort_option.name ? '#ccc' : '#888',
	                fontWeight: 400
	              }
	            }, sort_option.description));
	          };
	        })(this)(sort_option));
	      }
	      return results;
	    }).call(this)) : void 0)));
	  }
	});

	OpinionFilter = ReactiveComponent({
	  displayName: 'OpinionFilter',
	  render: function() {
	    var bitcoin, filter, filter_out, filters, hala, idx, ref, toggle_filter, users;
	    filters = customization('opinion_filters');
	    users = fetch('/users');
	    filter_out = fetch('filtered');
	    bitcoin = (ref = fetch('/subdomain').name) === 'bitcoin' || ref === 'bitcoinclassic';
	    hala = fetch('/subdomain').name === 'HALA';
	    if (hala && !fetch('/current_user').is_admin) {
	      return SPAN(null);
	    }
	    toggle_filter = function(filter) {
	      var f, filter_funcs, func, i, j, k, len, len1, passes, ref1, user;
	      filter_out.users = {};
	      filter_out.opinion_filters || (filter_out.opinion_filters = {});
	      if (filter_out.opinion_filters[filter.label]) {
	        delete filter_out.opinion_filters[filter.label];
	      } else {
	        filter_out.opinion_filters = {};
	        filter_out.opinion_filters[filter.label] = filter;
	      }
	      filter_funcs = (function() {
	        var ref1, results;
	        ref1 = filter_out.opinion_filters;
	        results = [];
	        for (k in ref1) {
	          f = ref1[k];
	          results.push(f.pass);
	        }
	        return results;
	      })();
	      if (filter_funcs.length > 0) {
	        ref1 = users.users;
	        for (i = 0, len = ref1.length; i < len; i++) {
	          user = ref1[i];
	          passes = true;
	          for (j = 0, len1 = filter_funcs.length; j < len1; j++) {
	            func = filter_funcs[j];
	            passes && (passes = func(user));
	          }
	          if (!passes) {
	            filter_out.users[user.key] = 1;
	          }
	        }
	      }
	      return save(filter_out);
	    };
	    if (fetch('/subdomain').name === 'bitcoinclassic' && (filter_out.opinion_filters == null)) {
	      toggle_filter(filters[0]);
	    }
	    return DIV({
	      style: this.props.style || {}
	    }, DIV({
	      style: {
	        color: focus_blue,
	        fontSize: 20,
	        fontWeight: 600
	      }
	    }, 'Filter opinions to', bitcoin ? ' verified' : void 0), bitcoin ? VerificationProcessExplanation() : void 0, DIV({
	      style: {
	        marginTop: 0
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = filters.length; i < len; idx = ++i) {
	        filter = filters[idx];
	        results.push((function(_this) {
	          return function(filter, idx) {
	            var is_enabled, ref1;
	            is_enabled = (ref1 = filter_out.opinion_filters) != null ? ref1[filter.label] : void 0;
	            return DIV({
	              ref: "filter-" + idx,
	              style: {
	                display: 'inline-block',
	                marginRight: idx !== filters.length - 1 ? 5 : void 0,
	                paddingRight: idx !== filters.length - 1 ? 5 : void 0,
	                borderRight: idx !== filters.length - 1 ? '1px solid #ddd' : void 0,
	                color: is_enabled ? focus_blue : '#aaa',
	                cursor: 'pointer',
	                fontSize: 16
	              },
	              onMouseEnter: function() {
	                var tooltip;
	                if (filter.tooltip) {
	                  tooltip = fetch('tooltip');
	                  tooltip.coords = $(_this.refs["filter-" + idx].getDOMNode()).offset();
	                  tooltip.tip = filter.tooltip;
	                  return save(tooltip);
	                }
	              },
	              onMouseLeave: function() {
	                var tooltip;
	                if (filter.tooltip) {
	                  tooltip = fetch('tooltip');
	                  tooltip.coords = tooltip.tip = null;
	                  return save(tooltip);
	                }
	              },
	              onClick: function() {
	                return toggle_filter(filter);
	              }
	            }, filter.label);
	          };
	        })(this)(filter, idx));
	      }
	      return results;
	    }).call(this)));
	  }
	});

	VerificationProcessExplanation = ReactiveComponent({
	  displayName: 'VerificationProcessExplanation',
	  render: function() {
	    var callout, para, user, users;
	    users = fetch('/users');
	    callout = "about verification";
	    return DIV({
	      style: {
	        position: 'absolute',
	        right: -sizeWhenRendered(callout, {
	          fontSize: 12
	        }).width,
	        top: -3
	      }
	    }, SPAN({
	      style: {
	        color: "#aaa",
	        fontSize: 14
	      }
	    }, SPAN({
	      style: {
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        color: this.local.describe_process ? logo_red : void 0
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.describe_process = !_this.local.describe_process;
	          return save(_this.local);
	        };
	      })(this)
	    }, callout)), this.local.describe_process ? (para = {
	      marginBottom: 20
	    }, DIV({
	      style: {
	        textAlign: 'left',
	        position: 'absolute',
	        right: 0,
	        top: 40,
	        width: 650,
	        zIndex: 999,
	        padding: "20px 40px",
	        backgroundColor: '#eee',
	        fontSize: 18
	      }
	    }, SPAN({
	      style: cssTriangle('top', '#eee', 16, 8, {
	        position: 'absolute',
	        right: 50,
	        top: -8
	      })
	    }), DIV({
	      style: para
	    }, "Filters help us understand the opinions of the stakeholder groups. Filters are conjunctive: only users that pass all active filters are shown.\nThese are the filters:"), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Users'), ". Verified users have emailed us a verification image to validate their account.  \nWe have also verified a few other people via other media channels, like Reddit. ", SPAN({
	      style: {
	        fontStyle: 'italic'
	      }
	    }, "Verification results shown below.")), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Miners'), ". Miners are ", OL({
	      style: {
	        marginLeft: 20
	      }
	    }, LI(null, 'Users who control a mining pool with > 1% amount of hashrate'), LI(null, 'Users who control > 1% amount of hashrate')), 'We verify hashrate by consulting ', A({
	      href: 'https://blockchain.info/pools',
	      target: '_blank',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'https://blockchain.info/pools'), '.'), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Developers'), ". Bitcoin developers self-report by editing their user profile. If we recognize \nsomeone as a committer or maintainer of Core or XT, we assign it. \nWe aren’t satisfied by our criteria for developer. We hope to work with \nthe community to define a more robust standard for 'reputable technical voice'."), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Businesses'), ". Bitcoin businesses self-report by editing their user profile. Business accounts\nare either users who operate the business or an account that will represent that \nbusinesses' official position."), DIV({
	      style: para
	    }, "These filters aren’t perfect. If you think there is a problem, email us at ", A({
	      href: "mailto:admin@consider.it",
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'admin@consider.it'), ". We will try to make a more trustless process in the future."), DIV({
	      style: {}
	    }, DIV({
	      style: {
	        fontWeight: 600,
	        fontSize: 26
	      }
	    }, 'Verification status'), (function() {
	      var i, len, ref, ref1, ref2, results;
	      ref = users.users;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        user = ref[i];
	        user = fetch(user);
	        if (user.tags.verified && ((ref1 = user.tags.verified.toLowerCase()) !== 'no' && ref1 !== 'false')) {
	          results.push(DIV({
	            style: {
	              marginTop: 20
	            }
	          }, DIV({
	            style: {
	              fontWeight: 600
	            }
	          }, user.name), ((ref2 = user.tags.verified) != null ? ref2.indexOf('http') : void 0) === 0 ? IMG({
	            src: user.tags.verified,
	            style: {
	              width: 400
	            }
	          }) : DIV({
	            style: {
	              fontStyle: 'italic'
	            }
	          }, user.tags.verified)));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })()))) : void 0);
	  }
	});

	window.ProposalFilter = ProposalFilter;

	window.OpinionFilter = OpinionFilter;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Cluster, NewActivity, ProposalsLoading, cluster_keys, cluster_options, default_cluster_name, pad,
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	__webpack_require__(3);

	__webpack_require__(4);

	__webpack_require__(13);

	__webpack_require__(17);

	__webpack_require__(32);

	__webpack_require__(24);

	__webpack_require__(5);

	__webpack_require__(7);

	__webpack_require__(8);

	__webpack_require__(21);

	default_cluster_name = 'Proposals';

	window.Homepage = ReactiveComponent({
	  displayName: 'Homepage',
	  render: function() {
	    var doc, subdomain, title;
	    doc = fetch('document');
	    subdomain = fetch('/subdomain');
	    title = subdomain.app_title || subdomain.name;
	    if (doc.title !== title) {
	      doc.title = title;
	      save(doc);
	    }
	    return DIV(null, customization('Homepage')());
	  }
	});

	window.proposal_editor = function(proposal) {
	  var e, editor, editors;
	  editors = (function() {
	    var j, len1, ref, results;
	    ref = proposal.roles.editor;
	    results = [];
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      e = ref[j];
	      if (e !== '*') {
	        results.push(e);
	      }
	    }
	    return results;
	  })();
	  editor = editors.length > 0 && editors[0];
	  return editor !== '-' && editor;
	};

	cluster_keys = ['archived', 'label', 'description', 'homie_histo_title', 'show_proposer_icon', 'slider_handle', 'slider_pole_labels', 'slider_regions', 'slider_ticks', 'discussion', 'show_score', 'uncollapseable', 'cluster_header', 'homepage_label', 'cluster_filters', 'proposal_style', 'one_line_desc'];

	cluster_options = function(key) {
	  var j, k, len1, options;
	  options = {};
	  for (j = 0, len1 = cluster_keys.length; j < len1; j++) {
	    k = cluster_keys[j];
	    options[k] = customization(k, key);
	  }
	  options.proposal_style = _.extend({
	    fontWeight: 500
	  }, customization('proposal_style', key));
	  return options;
	};

	window.cluster_styles = function() {
	  var first_column, first_header, secnd_column, secnd_header;
	  first_column = {
	    width: HOMEPAGE_WIDTH() * .6 - 50,
	    display: 'inline-block',
	    verticalAlign: 'top',
	    position: 'relative'
	  };
	  secnd_column = {
	    width: HOMEPAGE_WIDTH() * .4,
	    display: 'inline-block',
	    verticalAlign: 'top',
	    marginLeft: 50
	  };
	  first_header = {
	    fontSize: 36,
	    marginBottom: 30,
	    fontWeight: 600
	  };
	  _.extend(first_header, first_column);
	  secnd_header = {
	    fontSize: 36,
	    fontWeight: 600,
	    position: 'relative',
	    whiteSpace: 'nowrap'
	  };
	  _.extend(secnd_header, secnd_column);
	  return [first_column, secnd_column, first_header, secnd_header];
	};

	window.get_clusters = function() {
	  var a, c, cluster, clusters, j, k, l, len1, len2, len3, m, options, proposals, ref, unnamed, v;
	  proposals = fetch('/proposals');
	  clusters = {};
	  ref = proposals.clusters || [];
	  for (j = 0, len1 = ref.length; j < len1; j++) {
	    c = ref[j];
	    if (c.name) {
	      clusters[c.name] = {};
	      for (k in c) {
	        if (!hasProp.call(c, k)) continue;
	        v = c[k];
	        clusters[c.name][k] = v;
	      }
	    } else {
	      unnamed = {};
	      for (k in c) {
	        if (!hasProp.call(c, k)) continue;
	        v = c[k];
	        unnamed[k] = v;
	      }
	    }
	    if (unnamed != null) {
	      if (clusters[default_cluster_name]) {
	        c = clusters[default_cluster_name];
	        c.proposals = c.proposals.concat(unnamed.proposals);
	      } else {
	        unnamed.name = default_cluster_name;
	        clusters[default_cluster_name] = unnamed;
	      }
	    }
	  }
	  clusters = _.values(clusters);
	  c = [];
	  a = [];
	  for (l = 0, len2 = clusters.length; l < len2; l++) {
	    cluster = clusters[l];
	    options = cluster_options("cluster/" + cluster.name);
	    if (!options.archived) {
	      c.push(cluster);
	    } else {
	      a.push(cluster);
	    }
	  }
	  for (m = 0, len3 = a.length; m < len3; m++) {
	    cluster = a[m];
	    c.push(cluster);
	  }
	  return [c, a];
	};

	ProposalsLoading = ReactiveComponent({
	  displayName: 'ProposalLoading',
	  render: function() {
	    var negative;
	    if (this.local.cnt == null) {
	      this.local.cnt = 0;
	    }
	    negative = Math.floor(this.local.cnt / 284) % 2 === 1;
	    return DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto',
	        padding: '60px',
	        textAlign: 'center',
	        fontStyle: 'italic',
	        fontSize: 24
	      }
	    }, DIV({
	      style: {
	        position: 'relative',
	        top: 6,
	        left: 3
	      }
	    }, drawLogo(50, logo_red, logo_red, false, true, logo_red, (negative ? 284 - this.local.cnt % 284 : this.local.cnt % 284), false)), "Loading proposals...there is much to consider!");
	  },
	  componentWillMount: function() {
	    return this.int = setInterval((function(_this) {
	      return function() {
	        _this.local.cnt += 1;
	        return save(_this.local);
	      };
	    })(this), 10);
	  },
	  componentWillUnmount: function() {
	    return clearInterval(this.int);
	  }
	});

	window.TagHomepage = ReactiveComponent({
	  displayName: 'TagHomepage',
	  render: function() {
	    var all, archived, cluster, clusters, colors, current_user, first_column, first_header, hues, idx, j, len1, proposal, proposals, ref, ref1, secnd_column, secnd_header, show_all, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    show_all = fetch('show_all_proposals');
	    all = fetch('/proposals');
	    if (!all.clusters) {
	      return ProposalsLoading();
	    }
	    proposals = [];
	    ref = get_clusters(), clusters = ref[0], archived = ref[1];
	    hues = getNiceRandomHues(clusters.length);
	    colors = {};
	    for (idx = j = 0, len1 = clusters.length; j < len1; idx = ++j) {
	      cluster = clusters[idx];
	      proposals = proposals.concat(cluster.proposals);
	      colors[cluster.name] = hues[idx];
	    }
	    proposals = sorted_proposals(proposals);
	    ref1 = cluster_styles(), first_column = ref1[0], secnd_column = ref1[1], first_header = ref1[2], secnd_header = ref1[3];
	    return DIV(null, DIV({
	      className: 'simplehomepage',
	      style: {
	        fontSize: 22,
	        margin: '45px auto',
	        width: HOMEPAGE_WIDTH(),
	        position: 'relative'
	      }
	    }, STYLE(null, 'a.proposal:hover {border-bottom: 1px solid grey}'), ProposalFilter({
	      style: {
	        width: first_column.width,
	        marginBottom: 20,
	        paddingLeft: customization('show_proposer_icon') ? 68 : void 0,
	        display: 'inline-block',
	        verticalAlign: 'top'
	      }
	    }), DIV(null, (function() {
	      var l, len2, results;
	      results = [];
	      for (idx = l = 0, len2 = proposals.length; l < len2; idx = ++l) {
	        proposal = proposals[idx];
	        if (idx > 20 && !show_all.show_all) {
	          continue;
	        }
	        results.push(DIV({
	          key: "collapsed" + proposal.key
	        }, CollapsedProposal({
	          key: "collapsed" + proposal.key,
	          proposal: proposal,
	          options: cluster_options("cluster/proposals"),
	          show_category: true,
	          category_color: hsv2rgb(colors[proposal.cluster], .7, .8)
	        })));
	      }
	      return results;
	    })()), !show_all.show_all && proposals.length > 20 ? DIV({
	      style: {
	        backgroundColor: '#f9f9f9',
	        width: HOMEPAGE_WIDTH(),
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        paddingTop: 10,
	        paddingBottom: 10,
	        fontWeight: 600,
	        textAlign: 'center',
	        marginTop: 40
	      },
	      onMouseDown: (function(_this) {
	        return function() {
	          show_all.show_all = true;
	          return save(show_all);
	        };
	      })(this)
	    }, 'Show all proposals') : void 0));
	  }
	});

	window.SimpleHomepage = ReactiveComponent({
	  displayName: 'SimpleHomepage',
	  render: function() {
	    var archived, cluster, cluster_filters, cluster_key, clusters, collapsed, current_user, fails_filter, filter, first_column, first_header, hala, in_others, index, j, len1, options, proposals, ref, ref1, ref2, ref3, secnd_column, secnd_header, subdomain;
	    subdomain = fetch('/subdomain');
	    cluster_filters = fetch('cluster_filters');
	    if (subdomain.name === 'dao' && cluster_filters.clusters === '*') {
	      return TagHomepage();
	    }
	    proposals = fetch('/proposals');
	    current_user = fetch('/current_user');
	    if (!proposals.clusters) {
	      return ProposalsLoading();
	    }
	    ref = get_clusters(), clusters = ref[0], archived = ref[1];
	    collapsed = fetch('collapsed');
	    if (collapsed.clusters == null) {
	      collapsed.clusters = {};
	      for (j = 0, len1 = archived.length; j < len1; j++) {
	        cluster = archived[j];
	        collapsed.clusters["cluster/" + cluster.name] = 1;
	      }
	      save(collapsed);
	    }
	    return DIV(null, DIV({
	      className: 'simplehomepage',
	      style: {
	        fontSize: 22,
	        margin: '45px auto',
	        width: HOMEPAGE_WIDTH(),
	        position: 'relative'
	      }
	    }, STYLE(null, 'a.proposal:hover {border-bottom: 1px solid grey}'), customization('proposal_filters') ? ((ref1 = cluster_styles(), first_column = ref1[0], secnd_column = ref1[1], first_header = ref1[2], secnd_header = ref1[3], ref1), ProposalFilter({
	      style: {
	        width: first_column.width,
	        marginBottom: 20,
	        paddingLeft: customization('show_proposer_icon') ? 68 : void 0,
	        display: 'inline-block',
	        verticalAlign: 'top'
	      }
	    })) : void 0, customization('opinion_filters') ? ((ref2 = cluster_styles(), first_column = ref2[0], secnd_column = ref2[1], first_header = ref2[2], secnd_header = ref2[3], ref2), hala = subdomain.name === 'HALA', OpinionFilter({
	      style: {
	        width: !hala ? secnd_column.width : void 0,
	        marginBottom: 20,
	        marginLeft: !hala ? secnd_column.marginLeft : void 0,
	        display: !hala ? 'inline-block' : void 0,
	        verticalAlign: 'top',
	        textAlign: !hala ? 'center' : 'right'
	      }
	    })) : void 0, (function() {
	      var l, len2, ref3, ref4, ref5, ref6, results;
	      ref3 = clusters || [];
	      results = [];
	      for (index = l = 0, len2 = ref3.length; l < len2; index = ++l) {
	        cluster = ref3[index];
	        cluster_key = "cluster/" + cluster.name;
	        options = cluster_options(cluster_key);
	        fails_filter = (cluster_filters.filter != null) && (cluster_filters.clusters !== '*' && !(ref4 = cluster.name, indexOf.call(cluster_filters.clusters, ref4) >= 0));
	        if (fails_filter && (indexOf.call(cluster_filters.clusters, '*') >= 0)) {
	          in_others = [];
	          ref5 = customization('cluster_filters');
	          for (filter in ref5) {
	            clusters = ref5[filter];
	            in_others = in_others.concat(clusters);
	          }
	          fails_filter && (fails_filter = (ref6 = cluster.name, indexOf.call(in_others, ref6) >= 0));
	        }
	        if (fails_filter) {
	          results.push(SPAN(null));
	        } else {
	          results.push(Cluster({
	            key: cluster_key,
	            cluster: cluster,
	            options: options,
	            index: index
	          }));
	        }
	      }
	      return results;
	    })(), permit('create proposal') > 0 && customization('show_new_proposal_button') && ((ref3 = subdomain.name) !== 'bitcoin' && ref3 !== 'bitcoinfoundation') ? A({
	      style: {
	        color: logo_red,
	        marginTop: 35,
	        display: 'inline-block',
	        borderBottom: "1px solid " + logo_red
	      },
	      href: '/proposal/new'
	    }, t('Create new proposal')) : void 0));
	  },
	  typeset: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (subdomain.name === 'RANDOM2015' && $('.MathJax').length === 0) {
	      return MathJax.Hub.Queue(["Typeset", MathJax.Hub, ".proposal_homepage_name"]);
	    }
	  },
	  componentDidMount: function() {
	    return this.typeset();
	  },
	  componentDidUpdate: function() {
	    return this.typeset();
	  },
	  drawWatchFilter: function() {
	    var filter;
	    filter = fetch('homepage_filter');
	    return DIV({
	      id: 'watching_filter',
	      style: {
	        position: 'absolute',
	        left: -87,
	        top: 5,
	        border: "1px solid #bbb",
	        opacity: !filter.watched && !this.local.hover_watch_filter ? .3 : void 0,
	        padding: '3px 10px',
	        cursor: 'pointer',
	        display: 'inline-block',
	        backgroundColor: '#fafafa',
	        borderRadius: 8
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          var tooltip;
	          _this.local.hover_watch_filter = true;
	          tooltip = fetch('tooltip');
	          tooltip.coords = $(_this.getDOMNode()).find('#watching_filter').offset();
	          tooltip.tip = t('filter_to_watched');
	          save(tooltip);
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          var tooltip;
	          _this.local.hover_watch_filter = false;
	          save(_this.local);
	          tooltip = fetch('tooltip');
	          tooltip.coords = null;
	          return save(tooltip);
	        };
	      })(this),
	      onClick: (function(_this) {
	        return function() {
	          filter.watched = !filter.watched;
	          return save(filter);
	        };
	      })(this)
	    }, SPAN({
	      style: {
	        fontSize: 16,
	        verticalAlign: 'text-bottom',
	        color: '#666'
	      }
	    }, "only "), I({
	      className: "fa fa-star",
	      style: {
	        color: logo_red,
	        verticalAlign: 'text-bottom'
	      }
	    }));
	  }
	});

	window.NewProposal = ReactiveComponent({
	  displayName: 'NewProposal',
	  render: function() {
	    var adding, cluster_key, cluster_name, cluster_slug, cluster_state, current_user, editor, error, first_column, first_header, icons, needs_to_login, permitted, ref, ref1, secnd_column, secnd_header, w;
	    cluster_name = this.props.cluster_name;
	    cluster_key = "cluster/" + cluster_name;
	    cluster_state = fetch(this.props.local);
	    if (cluster_name === 'Blocksize Survey') {
	      return SPAN(null);
	    }
	    cluster_name = cluster_name || default_cluster_name;
	    current_user = fetch('/current_user');
	    adding = cluster_state.adding_new_proposal === cluster_name;
	    cluster_slug = slugify(cluster_name);
	    permitted = permit('create proposal');
	    needs_to_login = permitted === Permission.NOT_LOGGED_IN;
	    permitted = permitted > 0;
	    icons = this.props.icons;
	    if (!permitted && !needs_to_login) {
	      return SPAN(null);
	    }
	    return DIV(null, !adding ? SPAN({
	      style: _.extend(this.props.label_style, {
	        cursor: 'pointer'
	      }),
	      onClick: (function(_this) {
	        return function(e) {
	          if (permitted) {
	            cluster_state.adding_new_proposal = cluster_name;
	            return save(cluster_state);
	          } else {
	            e.stopPropagation();
	            return reset_key('auth', {
	              form: 'login',
	              goal: '',
	              ask_questions: true
	            });
	          }
	        };
	      })(this)
	    }, permitted ? t("add new") : t("login_to_add_new")) : ((ref = cluster_styles(), first_column = ref[0], secnd_column = ref[1], first_header = ref[2], secnd_header = ref[3], ref), w = first_column.width - 50 + (icons ? -18 : 0), DIV(null, customization('proposal_tips') ? this.drawTips() : void 0, icons ? (editor = current_user.user, Avatar({
	      key: editor,
	      user: editor,
	      style: {
	        height: 50,
	        width: 50,
	        borderRadius: 0,
	        backgroundColor: '#ddd'
	      }
	    })) : void 0, DIV({
	      style: {
	        marginLeft: icons ? 18 - 8 : void 0,
	        display: 'inline-block'
	      }
	    }, TEXTAREA({
	      id: cluster_slug + "-name",
	      name: 'name',
	      pattern: '^.{3,}',
	      placeholder: t('proposal_summary_instr'),
	      required: 'required',
	      resize: 'none',
	      style: {
	        fontSize: 22,
	        width: w,
	        border: "1px solid #ccc",
	        outline: 'none',
	        padding: '6px 8px'
	      }
	    }), WysiwygEditor({
	      key: "description-new-proposal-" + cluster_slug,
	      placeholder: "Add " + (t('details')) + " here",
	      container_style: {
	        padding: '6px 8px',
	        border: '1px solid #ccc'
	      },
	      style: {
	        fontSize: 16,
	        width: w - 8 * 2,
	        marginBottom: 8,
	        minHeight: 120
	      }
	    }), ((ref1 = this.local.errors) != null ? ref1.length : void 0) > 0 ? DIV({
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var j, len1, ref2, results;
	      ref2 = this.local.errors;
	      results = [];
	      for (j = 0, len1 = ref2.length; j < len1; j++) {
	        error = ref2[j];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV({
	      style: {
	        marginTop: 8
	      }
	    }, SPAN({
	      style: {
	        backgroundColor: focus_blue,
	        color: 'white',
	        cursor: 'pointer',
	        borderRadius: 16,
	        padding: '4px 16px',
	        display: 'inline-block',
	        marginRight: 12
	      },
	      onClick: (function(_this) {
	        return function() {
	          var active, description, hide_on_homepage, name, proposal, slug;
	          name = $(_this.getDOMNode()).find("#" + cluster_slug + "-name").val();
	          description = fetch("description-new-proposal-" + cluster_slug).html;
	          slug = slugify(name);
	          active = true;
	          hide_on_homepage = false;
	          proposal = {
	            key: '/new/proposal',
	            name: name,
	            description: description,
	            cluster: cluster_name,
	            slug: slug,
	            active: active,
	            hide_on_homepage: hide_on_homepage
	          };
	          InitializeProposalRoles(proposal);
	          proposal.errors = [];
	          _this.local.errors = [];
	          save(_this.local);
	          return save(proposal, function() {
	            var ref2;
	            if (((ref2 = proposal.errors) != null ? ref2.length : void 0) === 0) {
	              cluster_state.adding_new_proposal = null;
	              return save(cluster_state);
	            } else {
	              _this.local.errors = proposal.errors;
	              return save(_this.local);
	            }
	          });
	        };
	      })(this)
	    }, t('Done')), SPAN({
	      style: {
	        color: '#888',
	        cursor: 'pointer'
	      },
	      onClick: (function(_this) {
	        return function() {
	          cluster_state.adding_new_proposal = null;
	          return save(cluster_state);
	        };
	      })(this)
	    }, t('cancel')))))));
	  },
	  drawTips: function() {
	    var guidelines_h, guidelines_w, mobile, tips;
	    mobile = browser.is_mobile;
	    guidelines_w = mobile ? 'auto' : 330;
	    guidelines_h = 300;
	    tips = customization('proposal_tips');
	    return DIV({
	      style: {
	        position: mobile ? 'relative' : 'absolute',
	        left: 512,
	        width: guidelines_w,
	        color: focus_blue,
	        zIndex: 1,
	        marginBottom: mobile ? 20 : void 0,
	        backgroundColor: mobile ? 'rgba(255,255,255,.85)' : void 0,
	        fontSize: 14
	      }
	    }, !mobile ? SVG({
	      width: guidelines_w + 28,
	      height: guidelines_h,
	      viewBox: "-4 0 " + (guidelines_w + 20 + 9) + " " + guidelines_h,
	      style: css.crossbrowserify({
	        position: 'absolute',
	        transform: 'scaleX(-1)',
	        left: -20
	      })
	    }, DEFS(null, svg.dropShadow({
	      id: "guidelines-shadow",
	      dx: '0',
	      dy: '2',
	      stdDeviation: "3",
	      opacity: .5
	    })), PATH({
	      stroke: focus_blue,
	      strokeWidth: 1,
	      fill: "#FFF",
	      filter: 'url(#guidelines-shadow)',
	      d: "M" + guidelines_w + ",33\nL" + guidelines_w + ",0\nL1,0\nL1," + guidelines_h + " \nL" + guidelines_w + "," + guidelines_h + " \nL" + guidelines_w + ",58\nL" + (guidelines_w + 20) + ",48\nL" + guidelines_w + ",33 \nZ"
	    })) : void 0, DIV({
	      style: {
	        padding: !mobile ? '14px 18px' : void 0,
	        position: 'relative',
	        marginLeft: 5
	      }
	    }, SPAN({
	      style: {
	        fontWeight: 600,
	        fontSize: PORTRAIT_MOBILE() ? 70 : LANDSCAPE_MOBILE() ? 36 : void 0
	      }
	    }, "Add new"), UL({
	      style: {
	        listStylePosition: 'outside',
	        marginLeft: 16,
	        marginTop: 5
	      }
	    }, (function() {
	      var j, len1, results, tip;
	      tips = customization('proposal_tips');
	      results = [];
	      for (j = 0, len1 = tips.length; j < len1; j++) {
	        tip = tips[j];
	        results.push(LI({
	          style: {
	            paddingBottom: 3,
	            fontSize: PORTRAIT_MOBILE() ? 24 : LANDSCAPE_MOBILE() ? 14 : void 0
	          }
	        }, tip));
	      }
	      return results;
	    })())));
	  }
	});

	window.ClusterFilter = ReactiveComponent({
	  displayName: 'ClusterFilter',
	  render: function() {
	    var cluster_filters, clusters, filter, filters, idx, k, v;
	    filters = (function() {
	      var ref, results;
	      ref = customization('cluster_filters');
	      results = [];
	      for (k in ref) {
	        v = ref[k];
	        results.push([k, v]);
	      }
	      return results;
	    })();
	    filters.unshift(["Show all", '*']);
	    cluster_filters = fetch('cluster_filters');
	    if (cluster_filters.filter == null) {
	      cluster_filters.filter = 'Show all';
	      cluster_filters.clusters = '*';
	      save(cluster_filters);
	    }
	    return DIV({
	      style: {
	        fontSize: 19,
	        fontWeight: 600,
	        color: 'white',
	        width: '100%',
	        zIndex: 2,
	        position: 'relative',
	        top: 2,
	        marginTop: 20
	      }
	    }, DIV({
	      style: {
	        width: 900,
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, (function() {
	      var j, len1, ref, results;
	      results = [];
	      for (idx = j = 0, len1 = filters.length; j < len1; idx = ++j) {
	        ref = filters[idx], filter = ref[0], clusters = ref[1];
	        results.push((function(_this) {
	          return function(filter, clusters) {
	            var current, hovering;
	            current = cluster_filters.filter === filter;
	            hovering = _this.local.hovering === filter;
	            return SPAN({
	              style: {
	                padding: '10px 30px 4px 30px',
	                display: 'inline-block',
	                cursor: 'pointer',
	                color: current ? 'black' : hovering ? '#F8E71C' : void 0,
	                backgroundColor: current ? 'white' : void 0,
	                position: 'relative',
	                borderRadius: '16px 16px 0 0',
	                borderLeft: current ? "2px solid #F8E71C" : void 0,
	                borderTop: current ? "2px solid #F8E71C" : void 0,
	                borderRight: current ? "2px solid #F8E71C" : void 0
	              },
	              onMouseEnter: function() {
	                if (cluster_filters.filter !== filter) {
	                  _this.local.hovering = filter;
	                  return save(_this.local);
	                }
	              },
	              onMouseLeave: function() {
	                _this.local.hovering = null;
	                return save(_this.local);
	              },
	              onClick: function() {
	                cluster_filters.filter = filter;
	                cluster_filters.clusters = clusters;
	                return save(cluster_filters);
	              }
	            }, filter);
	          };
	        })(this)(filter, clusters));
	      }
	      return results;
	    }).call(this)));
	  }
	});

	Cluster = ReactiveComponent({
	  displayName: 'Cluster',
	  render: function() {
	    var cluster, collapsed, current_user, idx, is_collapsed, options, proposal, proposals, subdomain;
	    options = this.props.options;
	    cluster = this.props.cluster;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    fetch('homepage_you_updated_proposal');
	    collapsed = fetch('collapsed');
	    is_collapsed = collapsed.clusters[this.props.key];
	    proposals = sorted_proposals(cluster.proposals);
	    if (!proposals || (proposals.length === 0 && !cluster.always_shown)) {
	      return SPAN(null);
	    }
	    return DIV({
	      key: cluster.name,
	      id: cluster.name && cluster.name ? cluster.name.toLowerCase() : void 0,
	      style: {
	        paddingBottom: !is_collapsed ? 45 : void 0,
	        position: 'relative'
	      }
	    }, this.drawClusterHeading(cluster, options, is_collapsed), !is_collapsed ? DIV(null, (function() {
	      var j, len1, results;
	      results = [];
	      for (idx = j = 0, len1 = proposals.length; j < len1; idx = ++j) {
	        proposal = proposals[idx];
	        results.push(DIV({
	          key: "collapsed" + proposal.key
	        }, CollapsedProposal({
	          key: "collapsed" + proposal.key,
	          proposal: proposal,
	          options: options
	        }), this.drawThreshold(subdomain, cluster, idx)));
	      }
	      return results;
	    }).call(this), customization('show_new_proposal_button') ? NewProposal({
	      cluster_name: cluster.name,
	      local: this.local.key,
	      label_style: {
	        marginLeft: options.show_proposer_icon ? 50 + 18 : void 0,
	        borderBottom: "1px solid " + logo_red,
	        color: logo_red
	      },
	      icons: options.show_proposer_icon
	    }) : void 0) : void 0);
	  },
	  drawClusterHeading: function(cluster, options, is_collapsed) {
	    var cluster_key, collapsed, first_column, first_header, icons, ref, secnd_column, secnd_header, subdomain, th, tw;
	    ref = cluster_styles(), first_column = ref[0], secnd_column = ref[1], first_header = ref[2], secnd_header = ref[3];
	    cluster_key = "cluster/" + cluster.name;
	    icons = options.show_proposer_icon;
	    collapsed = fetch('collapsed');
	    subdomain = fetch('/subdomain');
	    tw = is_collapsed ? 15 : 20;
	    th = is_collapsed ? 20 : 15;
	    return DIV(null, options.label || options.description ? DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        marginLeft: icons ? 70 : void 0
	      }
	    }, options.label ? H1({
	      style: {
	        fontSize: 48,
	        fontWeight: 200
	      }
	    }, options.label) : void 0, options.description ? DIV({
	      style: {
	        fontSize: 22,
	        fontWeight: 200,
	        marginBottom: 10
	      }
	    }, options.description()) : void 0) : void 0, options.cluster_header ? options.cluster_header() : DIV({
	      style: {
	        position: 'relative'
	      }
	    }, H1({
	      style: _.extend({}, first_header, {
	        paddingLeft: icons ? 68 : 0,
	        position: 'relative',
	        cursor: !options.uncollapseable ? 'pointer' : void 0
	      }),
	      onClick: function() {
	        if (!options.uncollapseable) {
	          if (collapsed.clusters[cluster_key]) {
	            delete collapsed.clusters[cluster_key];
	          } else {
	            collapsed.clusters[cluster_key] = 1;
	          }
	          return save(collapsed);
	        }
	      }
	    }, options.homepage_label || cluster.name || default_cluster_name, !options.uncollapseable ? SPAN({
	      style: cssTriangle((is_collapsed ? 'right' : 'bottom'), 'black', tw, th, {
	        position: 'absolute',
	        left: -tw - 20 + (icons ? 68 : 0),
	        bottom: 14,
	        width: tw,
	        height: th,
	        display: 'inline-block'
	      })
	    }) : void 0, subdomain.name === 'RANDOM2015' ? " (" + cluster.proposals.length + ")" : void 0, options.one_line_desc ? DIV({
	      style: {
	        position: 'absolute',
	        bottom: -12,
	        color: '#444',
	        fontSize: 14,
	        fontWeight: 400
	      }
	    }, options.one_line_desc) : void 0), !is_collapsed ? H1({
	      style: secnd_header
	    }, SPAN({
	      style: {
	        position: 'relative',
	        marginLeft: -(widthWhenRendered(options.homie_histo_title, {
	          fontSize: 36,
	          fontWeight: 600
	        }) - secnd_column.width) / 2
	      }
	    }, options.homie_histo_title)) : void 0));
	  },
	  drawThreshold: function(subdomain, cluster, idx) {
	    var cutoff, ref;
	    cutoff = 28;
	    if (subdomain.name === 'ANUP2015') {
	      cutoff = 7;
	    }
	    if (((ref = subdomain.name) === 'ANUP2015' || ref === 'RANDOM2015') && cluster.name === 'Under Review' && idx === cutoff) {
	      return DIV({
	        style: {
	          borderTop: "4px solid green",
	          borderBottom: "4px solid " + logo_red,
	          padding: "4px 0",
	          textAlign: 'center',
	          fontWeight: 600,
	          margin: "16px 0 32px 0"
	        }
	      }, I({
	        style: {
	          color: 'green',
	          display: 'block'
	        },
	        className: 'fa fa-thumbs-o-up'
	      }), "Acceptance threshold for " + cutoff + " papers", I({
	        style: {
	          display: 'block',
	          color: logo_red
	        },
	        className: 'fa fa-thumbs-o-down'
	      }));
	    }
	  },
	  storeSortOrder: function() {
	    var c, order, p;
	    p = (function() {
	      var j, len1, ref, results;
	      ref = sorted_proposals(this.props.cluster.proposals);
	      results = [];
	      for (j = 0, len1 = ref.length; j < len1; j++) {
	        p = ref[j];
	        results.push(p.key);
	      }
	      return results;
	    }).call(this);
	    c = fetch("cluster-" + (slugify(this.props.cluster.name)) + "/sort_order");
	    order = JSON.stringify(p);
	    if (order !== c.sort_order) {
	      c.sort_order = order;
	      return save(c);
	    }
	  },
	  componentDidMount: function() {
	    return this.storeSortOrder();
	  },
	  componentDidUpdate: function() {
	    return this.storeSortOrder();
	  }
	});

	pad = function(num, len) {
	  var dec, i, str;
	  str = num;
	  dec = str.split('.');
	  i = 0;
	  while (i < len - dec[0].toString().length) {
	    dec[0] = "0" + dec[0];
	    i += 1;
	  }
	  return dec[0] + (dec.length > 0 ? '.' + dec[1] : '');
	};

	NewActivity = ReactiveComponent({
	  displayName: 'NewActivity',
	  render: function() {
	    var proposal, unread;
	    proposal = this.props.proposal;
	    unread = hasUnreadNotifications(proposal);
	    if ((typeof current_user !== "undefined" && current_user !== null ? current_user.logged_in : void 0) && unread) {
	      return A({
	        title: 'New activity',
	        href: proposal_url(proposal),
	        style: {
	          position: 'absolute',
	          left: -66,
	          top: 11,
	          width: 8,
	          height: 8,
	          textAlign: 'center',
	          display: 'inline-block',
	          cursor: 'pointer',
	          backgroundColor: '#aaa',
	          color: 'white',
	          fontSize: 14,
	          borderRadius: '50%',
	          padding: 2,
	          fontWeight: 600
	        }
	      });
	    } else {
	      return SPAN(null);
	    }
	  }
	});

	window.CollapsedProposal = ReactiveComponent({
	  displayName: 'CollapsedProposal',
	  render: function() {
	    var avg, can_opine, cluster, current_user, draw_slider, editor, filter_out, first_column, first_header, icons, j, len1, negative, o, opinions, options, proposal, ref, ref1, score, score_w, secnd_column, secnd_header, slider, watching, your_opinion;
	    proposal = fetch(this.props.proposal);
	    options = this.props.options;
	    icons = options.show_proposer_icon;
	    fetch("cluster-" + (slugify(proposal.cluster || default_cluster_name)) + "/sort_order");
	    current_user = fetch('/current_user');
	    watching = current_user.subscriptions[proposal.key] === 'watched';
	    if (!watching && fetch('homepage_filter').watched) {
	      return;
	    }
	    ref = cluster_styles(), first_column = ref[0], secnd_column = ref[1], first_header = ref[2], secnd_header = ref[3];
	    your_opinion = fetch(proposal.your_opinion);
	    if (your_opinion != null ? your_opinion.published : void 0) {
	      can_opine = permit('update opinion', proposal, your_opinion);
	    } else {
	      can_opine = permit('publish opinion', proposal);
	    }
	    draw_slider = can_opine > 0 || (your_opinion != null ? your_opinion.published : void 0);
	    opinions = opinionsForProposal(proposal);
	    if (options.show_score) {
	      score = 0;
	      filter_out = fetch('filtered');
	      opinions = (function() {
	        var j, len1, ref1, results;
	        results = [];
	        for (j = 0, len1 = opinions.length; j < len1; j++) {
	          o = opinions[j];
	          if (!((ref1 = filter_out.users) != null ? ref1[o.user] : void 0)) {
	            results.push(o);
	          }
	        }
	        return results;
	      })();
	      for (j = 0, len1 = opinions.length; j < len1; j++) {
	        o = opinions[j];
	        score += o.stance;
	      }
	      avg = score / opinions.length;
	      negative = score < 0;
	      if (negative) {
	        score *= -1;
	      }
	      score = pad(score.toFixed(1), 2);
	      score_w = widthWhenRendered("" + score, {
	        fontSize: 18,
	        fontWeight: 600
	      });
	    }
	    if (draw_slider) {
	      slider = fetch("homepage_slider" + proposal.key);
	    } else {
	      slider = null;
	    }
	    if (slider && your_opinion && slider.value !== your_opinion.stance && !slider.has_moved) {
	      slider.value = your_opinion.stance;
	      if (your_opinion.stance) {
	        slider.has_moved = true;
	      }
	      save(slider);
	    }
	    return DIV({
	      key: proposal.key,
	      id: proposal.slug.replace('-', '_'),
	      style: {
	        minHeight: 70,
	        position: 'relative',
	        marginBottom: customization('slider_ticks', proposal) ? 15 : 15
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          if (draw_slider) {
	            _this.local.hover_proposal = proposal.key;
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          if (draw_slider && !slider.is_moving) {
	            _this.local.hover_proposal = null;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, DIV({
	      style: first_column
	    }, NewActivity({
	      proposal: proposal
	    }), (current_user != null ? current_user.logged_in : void 0) ? WatchStar({
	      proposal: proposal,
	      size: 30,
	      style: {
	        position: 'absolute',
	        left: -40,
	        top: 5
	      }
	    }) : void 0, icons ? (editor = proposal_editor(proposal), editor ? A({
	      href: proposal_url(proposal)
	    }, Avatar({
	      key: editor,
	      user: editor,
	      style: {
	        height: 50,
	        width: 50,
	        borderRadius: 0,
	        backgroundColor: '#ddd'
	      }
	    })) : SPAN({
	      style: {
	        height: 50,
	        width: 50,
	        display: 'inline-block',
	        verticalAlign: 'top',
	        border: "2px dashed #ddd"
	      }
	    })) : void 0, DIV({
	      style: {
	        display: 'inline-block',
	        fontWeight: 400,
	        marginLeft: icons ? 18 : void 0,
	        paddingBottom: 20,
	        width: first_column.width - 50 + (icons ? -18 : 0),
	        marginTop: icons ? 0 : void 0
	      }
	    }, A({
	      className: 'proposal proposal_homepage_name',
	      style: options.proposal_style,
	      href: proposal_url(proposal)
	    }, proposal.name), DIV({
	      style: {
	        fontSize: 16,
	        color: "#999",
	        fontStyle: 'italic'
	      }
	    }, customization('show_meta') ? SPAN({
	      style: {}
	    }, prettyDate(proposal.created_at), !icons && (editor = proposal_editor(proposal)) && editor === proposal.user ? SPAN({
	      style: {}
	    }, " by " + ((ref1 = fetch(editor)) != null ? ref1.name : void 0)) : void 0, SPAN({
	      style: {
	        paddingRight: 16
	      }
	    })) : void 0, this.props.show_category && proposal.cluster ? (cluster = proposal.cluster, fetch('/subdomain').name === 'dao' && proposal.cluster === 'Proposals' ? cluster = 'Ideas' : void 0, SPAN({
	      style: {
	        backgroundColor: this.props.category_color,
	        padding: '1px 2px',
	        color: 'white',
	        fontStyle: 'normal',
	        fontSize: 12
	      }
	    }, cluster)) : void 0, !proposal.active ? SPAN({
	      style: {}
	    }, t('closed')) : void 0))), DIV({
	      style: {
	        display: 'inline-block',
	        position: 'relative'
	      }
	    }, DIV({
	      style: secnd_column
	    }, Histogram({
	      key: "histogram-" + proposal.slug,
	      proposal: proposal,
	      opinions: opinions,
	      width: secnd_column.width,
	      height: 50,
	      enable_selection: false,
	      draw_base: true,
	      draw_base_labels: options['slider_ticks'] != null ? !options['slider_ticks'] : true
	    }), Slider({
	      base_height: 0,
	      draw_handle: !!(draw_slider && (this.local.hover_proposal === proposal.key || browser.is_mobile)),
	      key: "homepage_slider" + proposal.key,
	      width: secnd_column.width,
	      polarized: true,
	      regions: options.slider_regions,
	      draw_ticks: options['slider_ticks'],
	      respond_to_click: false,
	      base_color: 'transparent',
	      handle: slider_handle.triangley,
	      handle_height: 18,
	      handle_width: 21,
	      offset: true,
	      handle_props: {
	        use_face: false
	      },
	      onMouseUpCallback: (function(_this) {
	        return function(e) {
	          var mouse_over_element, prev_offset, prev_scroll, scroll_handle, update;
	          if (your_opinion.stance !== slider.value) {
	            prev_offset = _this.getDOMNode().offsetTop;
	            prev_scroll = window.scrollY;
	            your_opinion.stance = slider.value;
	            your_opinion.published = true;
	            save(your_opinion);
	            window.writeToLog({
	              what: 'move slider',
	              details: {
	                proposal: proposal.key,
	                stance: slider.value
	              }
	            });
	            _this.local.slid = 1000;
	            update = fetch('homepage_you_updated_proposal');
	            update.dummy = !update.dummy;
	            save(update);
	            _this.local.keep_in_view = {
	              offset: prev_offset,
	              scroll: prev_scroll
	            };
	            scroll_handle = function() {
	              _this.local.keep_in_view = null;
	              return window.removeEventListener('scroll', scroll_handle);
	            };
	            window.addEventListener('scroll', scroll_handle);
	          }
	          mouse_over_element = closest(e.target, function(node) {
	            return node === _this.getDOMNode();
	          });
	          if (_this.local.hover_proposal === proposal.key && !mouse_over_element) {
	            _this.local.hover_proposal = null;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }))), options.show_score ? DIV({
	      ref: 'score',
	      style: {
	        position: 'absolute',
	        right: -50 - score_w,
	        top: 10
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          var tooltip;
	          if (opinions.length > 0) {
	            tooltip = fetch('tooltip');
	            tooltip.coords = $(_this.refs.score.getDOMNode()).offset();
	            tooltip.tip = opinions.length + " opinions. Average score = " + (Math.round(avg * 100) / 100) + " on a -1 to 1 scale.";
	            return save(tooltip);
	          }
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          var tooltip;
	          tooltip = fetch('tooltip');
	          tooltip.coords = null;
	          return save(tooltip);
	        };
	      })(this)
	    }, SPAN({
	      style: {
	        color: '#999',
	        fontSize: 18,
	        fontWeight: 600,
	        cursor: 'pointer'
	      }
	    }, negative ? '–' : void 0, score), this.local.hover_score ? DIV({
	      style: {
	        position: 'absolute',
	        backgroundColor: 'white',
	        padding: "4px 10px",
	        zIndex: 10,
	        boxShadow: '0 1px 2px rgba(0,0,0,.3)',
	        fontSize: 16,
	        right: 0,
	        bottom: 30,
	        width: 200
	      }
	    }) : void 0) : void 0);
	  },
	  componentDidUpdate: function() {
	    var int, prev_offset, prev_scroll, target, update_bg;
	    if (this.local.keep_in_view) {
	      prev_scroll = this.local.keep_in_view.scroll;
	      prev_offset = this.local.keep_in_view.offset;
	      target = prev_scroll + this.getDOMNode().offsetTop - prev_offset;
	      if (window.scrollTo && window.scrollY !== target) {
	        window.scrollTo(0, target);
	        this.local.keep_in_view = null;
	      }
	    }
	    if (this.local.slid && !this.fading) {
	      this.fading = true;
	      update_bg = (function(_this) {
	        return function() {
	          if (_this.local.slid <= 0) {
	            _this.getDOMNode().style.backgroundColor = '';
	            clearInterval(int);
	            return _this.fading = false;
	          } else {
	            return _this.getDOMNode().style.backgroundColor = "rgba(253, 254, 216, " + (_this.local.slid / 1000) + ")";
	          }
	        };
	      })(this);
	      int = setInterval((function(_this) {
	        return function() {
	          _this.local.slid -= 50;
	          return update_bg();
	        };
	      })(this), 50);
	      return update_bg();
	    }
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	window.svg = {
	  setSize: function(base_width, base_height, props) {
	    if (props.width && (props.height == null)) {
	      return props.height = props.width * base_height / base_width;
	    } else if (props.height && (props.width == null)) {
	      return props.width = props.height * base_width / base_height;
	    }
	  },
	  dropShadow: function(props) {
	    return FILTER({
	      id: props.id
	    }, FEOFFSET({
	      "in": "SourceAlpha",
	      dx: props.dx,
	      dy: props.dy,
	      result: "offsetblur"
	    }), FEGAUSSIANBLUR({
	      "in": 'offsetblur',
	      stdDeviation: props.stdDeviation,
	      result: 'blur2'
	    }), FECOLORMATRIX({
	      "in": 'blur2',
	      result: 'color',
	      type: 'matrix',
	      values: "0 0 0 0  0\n0 0 0 0  0 \n0 0 0 0  0 \n0 0 0 " + props.opacity + " 0"
	    }), FEMERGE(null, FEMERGENODE({
	      "in": 'color'
	    }), FEMERGENODE({
	      "in": 'SourceGraphic'
	    })));
	  },
	  innerbevel: function(props) {
	    var idx, shadow;
	    return FILTER({
	      id: props.id,
	      x0: "-50%",
	      y0: "-50%",
	      width: "200%",
	      height: "200%"
	    }, (function() {
	      var i, len, ref, results;
	      ref = props.shadows;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        shadow = ref[idx];
	        results.push([
	          FEGAUSSIANBLUR({
	            "in": 'SourceAlpha',
	            stdDeviation: shadow.stdDeviation,
	            result: "blur" + idx
	          }), FEOFFSET({
	            dy: shadow.dy,
	            dx: shadow.dx
	          }), FECOMPOSITE({
	            in2: 'SourceAlpha',
	            operator: "arithmetic",
	            k2: "-1",
	            k3: "1",
	            result: "shadowDiff"
	          }), FEFLOOD({
	            floodColor: shadow.color,
	            floodOpacity: shadow.opacity
	          }), FECOMPOSITE({
	            in2: "shadowDiff",
	            operator: "in"
	          }), FECOMPOSITE({
	            in2: idx === 0 ? 'SourceGraphic' : "result" + (idx - 1),
	            operator: "over",
	            result: "result" + idx
	          })
	        ]);
	      }
	      return results;
	    })());
	  }
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(9);

	window.WatchStar = ReactiveComponent({
	  displayName: 'WatchStar',
	  render: function() {
	    var current_user, icon, label, proposal, size, style, watch_color, watching;
	    current_user = fetch('/current_user');
	    proposal = this.props.proposal;
	    size = this.props.size || 30;
	    icon = this.props.icon || 'fa-star';
	    watch_color = this.props.watch_color || logo_red;
	    label = this.props.label || function(watching) {
	      if (watching) {
	        return "Stop getting notifications";
	      } else {
	        return "Get notifications";
	      }
	    };
	    watching = current_user.subscriptions[proposal.key] === 'watched';
	    style = {
	      opacity: this.local.hover_watch !== proposal.key && !watching ? .35 : void 0,
	      color: watching ? watch_color : "#888",
	      width: size,
	      height: size,
	      cursor: 'pointer'
	    };
	    return I({
	      className: "fa " + (watching ? icon : icon + "-o"),
	      style: _.extend({}, style, this.props.style || {}),
	      onMouseEnter: (function(_this) {
	        return function() {
	          var tooltip;
	          _this.local.hover_watch = proposal.key;
	          save(_this.local);
	          tooltip = fetch('tooltip');
	          tooltip.coords = $(_this.getDOMNode()).offset();
	          tooltip.tip = label(watching);
	          return save(tooltip);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          var tooltip;
	          _this.local.hover_watch = null;
	          save(_this.local);
	          tooltip = fetch('tooltip');
	          tooltip.coords = null;
	          return save(tooltip);
	        };
	      })(this),
	      onClick: (function(_this) {
	        return function() {
	          if (!current_user.subscriptions[proposal.key]) {
	            current_user.subscriptions[proposal.key] = 'watched';
	          } else {
	            delete current_user.subscriptions[proposal.key];
	          }
	          return save(current_user);
	        };
	      })(this)
	    });
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(React) {(function () {

	    // ****************
	    // Public API
	    var cache = {}
	    function fetch(url, defaults) {
	        //if (window.watch && watch(url)) console.trace()

	        if (!url) return null
	        if (url.key) url = url.key   // If user passes key as object

	        window.record_dependence && record_dependence(url)

	        // Return the cached version if it exists
	        if (cache[url]) return cache[url]

	        // Else, start a serverFetch in the background and return stub.
	        if (url[0] === '/')
	            server_fetch(url)

	        update_cache(extend({key: url}, defaults))
	        return cache[url]
	    }

	    /*  Updates cache and saves to server.
	     *  You can pass a callback that will run when the saves have finished.
	     */
	    function save(object, continuation) {
	        update_cache(object)

	        // Save all the objects
	        if (object.key && object.key[0] == '/')
	            server_save(object, continuation)
	        else
	            if (continuation) continuation()
	    }

	    /*  Deletes from server (if it's there) and removes from cache
	     *  You can pass a callback that will run when the delete has finished.
	     */
	    function destroy(key, continuation) {
	        if (!key) return

	        // Save all the objects
	        if (key[0] == '/')
	            server_destroy(key, continuation)
	        else {
	            // Just remove the key from the cache if this state is
	            // owned by the client.  Note that this won't clean up
	            // references to this object in e.g. any lists. The Client
	            // is responsible for updating all the relevant
	            // references.
	            delete cache[key]
	            if (continuation) continuation()
	        }
	    }


	    // ================================
	    // == Internal funcs

	    var new_index = 0
	    var affected_keys = new Set()
	    var re_render_timer = null
	    function update_cache(object) {
	        function recurse(object) {
	            // Recurses into object and folds it into the cache.

	            // If this object has a key, update the cache for it
	            var key = object && object.key
	            if (key) {
	                // Change /new/thing to /new/thing/45
	                if (key.match(new RegExp('^/new/'))     // Starts with /new/
	                    && !key.match(new RegExp('/\\d+$'))) // Doesn't end in a /number
	                    key = object.key = key + '/' + new_index++

	                var cached = cache[key]
	                if (!cached)
	                    // This object is new.  Let's cache it.
	                    cache[key] = object
	                else if (object !== cached)
	                    // Else, mutate cache to match the object.
	                    for (var k in object)          // Mutating in place preserves
	                        cache[key][k] = object[k]  // pointers to this object

	                // Remember this key for re-rendering
	                affected_keys.add(key)
	            }

	            // Now recurse into this object.
	            //  - Through each element in arrays
	            //  - And each property on objects
	            if (Array.isArray(object))
	                for (var i=0; i < object.length; i++)
	                    object[i] = recurse(object[i])
	            else if (typeof(object) === 'object' && object !== null)
	                for (var k in object)
	                    object[k] = recurse(object[k])

	            // Return the new cached representation of this object
	            return cache[key] || object
	        }

	        recurse(object)

	        // Now initiate the re-rendering, if there isn't a timer already going
	        re_render_timer = re_render_timer || setTimeout(function () {
	            re_render_timer = null
	            var keys = affected_keys.all()
	            affected_keys.clear()
	            if (keys.length > 0) {
	                var re_render = (window.re_render || function () {
	                    console.log('You need to implement re_render()') })
	                re_render(keys)
	            }
	        })
	    }

	    var outstanding_fetches = {}
	    function server_fetch(key) {
	        // Error check
	        if (outstanding_fetches[key]) {
	            console.error('Duplicate request for '+key)
	            return
	        }

	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            delete outstanding_fetches[key]
	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                if (window.arest.trans_in)
	                    result = arest.trans_in(result)
	                update_cache(result)
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()

	        }

	        // Open request
	        outstanding_fetches[key] = request
	        request.open('GET', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')

	        request.send(null)
	    }

	    var pending_saves = {} // Stores xmlhttprequest of any key being saved
	                           // (Note: This shim will fail in many situations...)
	    function server_save(object, continuation) {
	        if (pending_saves[object.key]) {
	            console.log('Yo foo, aborting')
	            pending_saves[object.key].abort()
	            delete pending_saves[object.key]
	        }

	        var original_key = object.key
	        
	        // Special case for /new.  Grab the pieces of the URL.
	        var pattern = new RegExp("/new/([^/]+)/(\\d+)")
	        var match = original_key.match(pattern)
	        var url = (match && '/' + match[1]) || original_key

	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            // No longer pending
	            delete pending_saves[original_key]

	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                // console.log('New save result', result)
	                // Handle /new/stuff
	                deep_map(function (obj) {
	                    match = obj.key && obj.key.match(/(.*)\?original_id=(\d+)$/)
	                    if (match && match[2]) {
	                        // Let's map the old and new together
	                        var new_key = match[1]                // It's got a fresh key
	                        cache[new_key] = cache[original_key]  // Point them at the same thing
	                        obj.key = new_key                     // And it's no longer "/new/*"
	                    }
	                },
	                        result)
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                window.ajax_error && window.ajax_error()
	        }

	        object = clone(object)
	        object['authenticity_token'] = csrf()

	        // Open request
	        var POST_or_PUT = match ? 'POST' : 'PUT'
	        request.open(POST_or_PUT, url, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	        request.send(JSON.stringify(object))

	        // Remember it
	        pending_saves[original_key] = request
	    }

	    function server_destroy(key, continuation) {
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            if (request.status === 200) {
	                console.log('Destroy returned for', key)
	                var result = JSON.parse(request.responseText)
	                delete cache[key]
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()
	            else {
	                // TODO: give user feedback that DELETE failed
	                console.log('DELETE of', key, 'failed!')
	            }

	        }

	        payload = {'authenticity_token': csrf()}

	        // Open request
	        request.open('DELETE', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	        request.send(JSON.stringify(payload))
	    }

	    // This is used in a specific hack.  I need to work on it.
	    function clear_matching_objects (match_key_func) {
	        // Clears all keys where match_key_func(key) returns true
	        for (key in cache)
	            if (match_key_func(key))
	                delete cache[key]
	    }


	    var csrf_token = null
	    function csrf(new_token) {
	        if (new_token) csrf_token = new_token
	        if (csrf_token) return csrf_token
	        var metas = document.getElementsByTagName('meta')
	        for (i=0; i<metas.length; i++) { 
	            if (metas[i].getAttribute("name") == "csrf-token") { 
	                return metas[i].getAttribute("content");
	            } 
	        } 
	        return ""
	    }

	    window.loading_indicator = React.DOM.div({style: {height: '100%', width: '100%'},
	                                       className: 'loading'}, 'Loading')
	    function error_indicator(message) {
	        return React.DOM.div(null, 'Error! ' + message)
	    }

	    // ****************
	    // Wrapper for React Components
	    var components = {}                  // Indexed by 'component/0', 'component/1', etc.
	    var components_count = 0
	    var dirty_components = {}
	    var execution_context = []  // The stack of components that are being rendered
	    function ReactiveComponent(component) {
	        // STEP 1: Define get() and save()
	        component.fetch = component.data = component.get = function (key, defaults) {
	            if (!this._lifeCycleState || this._lifeCycleState == 'UNMOUNTED')
	                throw Error('Component ' + this.name + ' (' + this.local_key
	                            + ') is tryin to get data(' + key + ') after it died.')

	            if (key === undefined)    key = this.mounted_key || this.name
	            if (!key)                 return null
	            // if (!key)    throw TypeError('Component mounted onto a null key. '
	            //                              + this.name + ' ' + this.local_key)
	            if (key.key) key = key.key   // If user passes key as object
	            return fetch(key, defaults)  // Call into main activerest
	        }
	        component.save = save                  // Call into main activerest
	        

	        // STEP 2: Wrap all the component's methods
	        function wrap(obj, method, before, after) {
	            var original_method = obj[method]
	            if (!(original_method || before || after)) return
	            obj[method] = function() {
	                before && before.apply(this, arguments)
	                if (this.local_key !== undefined)
	                    // We only want to set the execution context on wrapped methods
	                    // that are called on live instance.  getDefaultProps(), for
	                    // instance, is called when defining a component class, but not
	                    // on actual instances.  You can't render new components from
	                    // within there, so we don't need to track the execution context.
	                    execution_context = this.props.parents.concat([this.local_key])

	                try {
	                    var result = original_method && original_method.apply(this, arguments)
	                } catch (e) {
	                    execution_context = []
	                    if (this.is_waiting())
	                        return loading_indicator
	                    else {
	                        // Then let's re-cause the error, but without catching it
	                        original_method.apply(this, arguments)
	                        console.assert(false) // this cannot happen unless method has side effects
	                    }
	                }

	                execution_context = []
	                after && after.apply(this, arguments)

	                return result
	            }
	        }

	        // We register the component when mounting it into the DOM
	        wrap(component, 'componentWillMount',
	             function () { 

	                 // STEP 1. Register the component's basic info
	                 if (component.displayName === undefined)
	                     throw 'Component needs a displayName'
	                 this.name = component.displayName.toLowerCase().replace(' ', '_')
	                 this.local_key = 'component/' + components_count++
	                 components[this.local_key] = this

	                 // You can pass an object in as a key if you want:
	                 if (this.props.key && this.props.key.key)
	                     this.props.key = this.props.key.key

	                 // XXX Putting this into WillMount probably won't let you use the
	                 // mounted_key inside getInitialState!  But you should be using
	                 // activerest state anyway, right?
	                 this.mounted_key = this.props.key

	                 // STEP 2: Create shortcuts e.g. `this.foo' for all parents up the
	                 // tree, and this component's local key
	                 function add_shortcut (obj, shortcut_name, to_key) {
	                     //console.log('Giving '+obj.name+' shorcut @'+shortcut_name+'='+to_key)
	                     delete obj[name]
	                     Object.defineProperty(obj, shortcut_name, {
	                         get: function () { return obj.get(to_key) },
	                         configurable: true })
	                 }

	                 // ...first for @local
	                 add_shortcut(this, 'local', this.local_key)
	                 
	                 // ...and now for all parents
	                 var parents = this.props.parents.concat([this.local_key])
	                 for (var i=0; i<parents.length; i++) {
	                     var name = components[parents[i]].name
	                     var key = components[parents[i]].props.key
	                     if (!key && cache[name] !== undefined)
	                         key = name
	                     add_shortcut(this, name, key)
	                 }
	             })

	        wrap(component, 'render', function () {
	            // Render will need to clear the component's old
	            // dependencies before rendering and finding new ones
	            clear_component_dependencies(this.local_key)
	            delete dirty_components[this.local_key]
	        })

	        wrap(component, 'componentDidMount')
	        wrap(component, 'componentDidUpdate')
	        wrap(component, 'getDefaultProps')
	        //wrap(component, 'componentWillReceiveProps')
	        wrap(component, 'componentWillUnmount', function () {
	            // Clean up
	            clear_component_dependencies(this.local_key)
	            delete cache[this.local_key]
	            delete components[this.local_key]
	            delete dirty_components[this.local_key]
	        })
	        component.shouldComponentUpdate = function (next_props, next_state) {
	            // This component definitely needs to update if it is marked as dirty
	            if (dirty_components[this.local_key] !== undefined) return true

	            // Otherwise, we'll check to see if its state or props
	            // have changed.  We can do so by simply serializing them
	            // and then comparing them.  But ignore React's 'children'
	            // prop, because it often has a circular reference.
	            next_props = clone(next_props); this_props = clone(this.props)
	            delete next_props['children']; delete this_props['children']
	            return JSON.stringify([next_state, next_props]) != JSON.stringify([this.state, this_props])
	        }
	        
	        component.is_waiting = function () {
	            // Does this component depend on any keys that are being
	            // requested?
	            var dependent_keys = keys_4_component.get(this.local_key)
	            for (var i=0; i<dependent_keys.length; i++)
	                if (outstanding_fetches[dependent_keys[i]])
	                    return true
	            return false
	        }

	        // STEP 3: Configure the global function hooks for React
	        window.re_render = react_rerender
	        window.record_dependence = record_component_dependence

	        // Now create the actual React class with this definition, and
	        // return it.
	        var react_class = React.createClass(component)
	        var result = function (props, children) {
	            props = props || {}
	            props.parents = execution_context.slice()
	            return react_class(props, children)
	        }
	        // Give it the same prototype as the original class so that it
	        // passes React.isValidClass() inspection
	        result.prototype = react_class.prototype
	        return result
	    }


	    // *****************
	    // Dependency-tracking for React components
	    var keys_4_component = new One_To_Many() // Maps component to its dependence keys
	    var components_4_key = new One_To_Many() // Maps key to its dependent components
	    function react_rerender (keys) {
	        // Re-renders only the components that depend on `keys'

	        // First we determine the components that will need to be updated
	        for (var i = 0; i < keys.length; i++) {
	            affected_components = components_4_key.get(keys[i])
	            for (var j = 0; j < affected_components.length; j++)
	                dirty_components[affected_components[j]] = true
	        }

	        // Then we sweep through and update them
	        for (var comp_key in dirty_components)
	            // the check on both dirty_components and components is a PATCH
	            // for a possible inconsistency between dirty_components and components
	            // that occurs if a component has a componentWillUnmount method.
	            if (dirty_components[comp_key] && components[comp_key]) // Since one component might update another
	                components[comp_key].forceUpdate()
	    }
	    function record_component_dependence(key) {
	        // Looks up current component from the execution context
	        if (execution_context.length > 0) {
	            var component = execution_context[execution_context.length-1]
	            keys_4_component.add(component, key)  // Track dependencies
	            components_4_key.add(key, component)  // both ways
	        }
	    }
	    function clear_component_dependencies(component) {
	        var depends_on_keys = keys_4_component.get(component)
	        for (var i=0; i<depends_on_keys.length; i++)
	            components_4_key.del(depends_on_keys[i], component)
	        keys_4_component.delAll(component)
	    }


	    // ****************
	    // Utility for React Components
	    function One_To_Many() {
	        var hash = this.hash = {}
	        this.get = function (k) { return Object.keys(hash[k] || {}) }
	        this.add = function (k, v) {
	            if (hash[k] === undefined)
	                hash[k] = {}
	            hash[k][v] = true
	        }
	        this.del = function (k, v) {
	            delete hash[k][v]
	        }
	        this.delAll = function (k) { hash[k] = {} }
	    }
	    function Set() {
	        var hash = {}
	        this.add = function (a) { hash[a] = true }
	        this.all = function () { return Object.keys(hash) }
	        this.clear = function () { hash = {} }
	    }


	    // ******************
	    // General utility funcs
	    function clone(obj) {
	        if (obj == null) return obj
	        var copy = obj.constructor()
	        for (var attr in obj)
	            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
	        return copy
	    }
	    function extend(obj, with_obj) {
	        if (with_obj === undefined) return obj
	        for (var attr in with_obj)
	            if (!obj.hasOwnProperty(attr)) obj[attr] = with_obj[attr]
	        return obj
	    }
	    function deep_map(func, object) {
	        // This function isn't actually a full "deep map" yet.
	        // Limitations: It only applies func to OBJECTS (not arrays or
	        // atoms), and doesn't return anything.
	        if (Array.isArray(object))
	            for (var i=0; i < object.length; i++)
	                deep_map(func, object[i])
	        else if (typeof(object) === 'object' && object !== null) {
	            func(object)
	            for (var k in object)
	                deep_map(func, object[k])
	        }
	    }
	    function error(e, name) {
	        console.error('In', name + ':', e.stack)
	        if (window.on_client_error)
	            window.on_client_error(e)
	    }

	    function key_id(string) {
	        return string.match(/\/[^\/]+\/(\d+)/)[1]
	    }

	    // Camelcased API options
	    var updateCache=update_cache, serverFetch=server_fetch,
	        serverSave=server_save, serverDestroy=server_destroy

	    // Export the public API
	    window.ReactiveComponent = ReactiveComponent
	    window.fetch = fetch
	    window.save = save
	    window.destroy = destroy

	    // Make the private methods accessible under "window.arest"
	    vars = 'cache fetch save server_fetch serverFetch server_save serverSave update_cache updateCache csrf keys_4_component components_4_key components execution_context One_To_Many clone dirty_components affected_keys clear_matching_objects deep_map key_id'.split(' ')
	    window.arest = {}
	    for (var i=0; i<vars.length; i++)
	        window.arest[vars[i]] = eval(vars[i])

	})()

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 * Parts Copyright (C) 2011-2012, Alex Russell (slightlyoff@chromium.org)
	 * Parts Copyright (C) Copyright (C) 1998-2000 Greg J. Badros
	 *
	 * Use of this source code is governed by the LGPL, which can be found in the
	 * COPYING.LGPL file.
	 *
	 * This is a compiled version of Cassowary/JS. For source versions or to
	 * contribute, see the github project:
	 *
	 *  https://github.com/slightlyoff/cassowary-js-refactor
	 *
	 */

	(function() {
	(function(a){"use strict";try{(function(){}).bind(a)}catch(b){Object.defineProperty(Function.prototype,"bind",{value:function(a){var b=this;return function(){return b.apply(a,arguments)}},enumerable:!1,configurable:!0,writable:!0})}var c=a.HTMLElement!==void 0,d=function(a){for(var b=null;a&&a!=Object.prototype;){if(a.tagName){b=a.tagName;break}a=a.prototype}return b||"div"},e=1e-8,f={},g=function(a,b){if(a&&b){if("function"==typeof a[b])return a[b];var c=a.prototype;if(c&&"function"==typeof c[b])return c[b];if(c!==Object.prototype&&c!==Function.prototype)return"function"==typeof a.__super__?g(a.__super__,b):void 0}},h=a.c={debug:!1,trace:!1,verbose:!1,traceAdded:!1,GC:!1,GEQ:1,LEQ:2,inherit:function(b){var e=null,g=null;b["extends"]&&(g=b["extends"],delete b["extends"]),b.initialize&&(e=b.initialize,delete b.initialize);var h=e||function(){};Object.defineProperty(h,"__super__",{value:g?g:Object,enumerable:!1,configurable:!0,writable:!1}),b._t&&(f[b._t]=h);var i=h.prototype=Object.create(g?g.prototype:Object.prototype);if(this.extend(i,b),c&&g&&g.prototype instanceof a.HTMLElement){var j=h,k=d(i),l=function(a){return a.__proto__=i,j.apply(a,arguments),i.created&&a.created(),i.decorate&&a.decorate(),a};this.extend(i,{upgrade:l}),h=function(){return l(a.document.createElement(k))},h.prototype=i,this.extend(h,{ctor:j})}return h},extend:function(a,b){return this.own(b,function(c){var d=Object.getOwnPropertyDescriptor(b,c);try{"function"==typeof d.get||"function"==typeof d.set?Object.defineProperty(a,c,d):"function"==typeof d.value||"_"===c.charAt(0)?(d.writable=!0,d.configurable=!0,d.enumerable=!1,Object.defineProperty(a,c,d)):a[c]=b[c]}catch(e){}}),a},own:function(b,c,d){return Object.getOwnPropertyNames(b).forEach(c,d||a),b},traceprint:function(a){h.verbose&&console.log(a)},fnenterprint:function(a){console.log("* "+a)},fnexitprint:function(a){console.log("- "+a)},assert:function(a,b){if(!a)throw new h.InternalError("Assertion failed: "+b)},plus:function(a,b){return a instanceof h.Expression||(a=new h.Expression(a)),b instanceof h.Expression||(b=new h.Expression(b)),a.plus(b)},minus:function(a,b){return a instanceof h.Expression||(a=new h.Expression(a)),b instanceof h.Expression||(b=new h.Expression(b)),a.minus(b)},times:function(a,b){return("number"==typeof a||a instanceof h.Variable)&&(a=new h.Expression(a)),("number"==typeof b||b instanceof h.Variable)&&(b=new h.Expression(b)),a.times(b)},divide:function(a,b){return("number"==typeof a||a instanceof h.Variable)&&(a=new h.Expression(a)),("number"==typeof b||b instanceof h.Variable)&&(b=new h.Expression(b)),a.divide(b)},approx:function(a,b){if(a===b)return!0;var c,d;return c=a instanceof h.Variable?a.value:a,d=b instanceof h.Variable?b.value:b,0==c?e>Math.abs(d):0==d?e>Math.abs(c):Math.abs(c-d)<Math.abs(c)*e},_inc:function(a){return function(){return a++}}(0),parseJSON:function(a){return JSON.parse(a,function(a,b){if("object"!=typeof b||"string"!=typeof b._t)return b;var c=b._t,d=f[c];if(c&&d){var e=g(d,"fromJSON");if(e)return e(b,d)}return b})}};"function"=="function"&&"undefined"!=typeof module&&"undefined"==typeof load&&(a.exports=h)})(this),function(a){"use strict";var b=function(a){var b=a.hashCode?a.hashCode:""+a;return b},c=function(a,b){Object.keys(a).forEach(function(c){b[c]=a[c]})},d={};a.HashTable=a.inherit({initialize:function(){this.size=0,this._store={},this._keyStrMap={},this._deleted=0},set:function(a,c){var d=b(a);this._store.hasOwnProperty(d)||this.size++,this._store[d]=c,this._keyStrMap[d]=a},get:function(a){if(!this.size)return null;a=b(a);var c=this._store[a];return c!==void 0?this._store[a]:null},clear:function(){this.size=0,this._store={},this._keyStrMap={}},_compact:function(){var a={};c(this._store,a),this._store=a},_compactThreshold:100,_perhapsCompact:function(){this._size>64||this._deleted>this._compactThreshold&&(this._compact(),this._deleted=0)},"delete":function(a){a=b(a),this._store.hasOwnProperty(a)&&(this._deleted++,delete this._store[a],this.size>0&&this.size--)},each:function(a,b){if(this.size){this._perhapsCompact();var c=this._store,d=this._keyStrMap;Object.keys(this._store).forEach(function(e){a.call(b||null,d[e],c[e])},this)}},escapingEach:function(a,b){if(this.size){this._perhapsCompact();for(var c=this,e=this._store,f=this._keyStrMap,g=d,h=Object.keys(e),i=0;h.length>i;i++)if(function(d){c._store.hasOwnProperty(d)&&(g=a.call(b||null,f[d],e[d]))}(h[i]),g){if(void 0!==g.retval)return g;if(g.brk)break}}},clone:function(){var b=new a.HashTable;return this.size&&(b.size=this.size,c(this._store,b._store),c(this._keyStrMap,b._keyStrMap)),b},equals:function(b){if(b===this)return!0;if(!(b instanceof a.HashTable)||b._size!==this._size)return!1;for(var c=Object.keys(this._store),d=0;c.length>d;d++){var e=c[d];if(this._keyStrMap[e]!==b._keyStrMap[e]||this._store[e]!==b._store[e])return!1}return!0},toString:function(){var b="";return this.each(function(a,c){b+=a+" => "+c+"\n"}),b}})}(this.c||module.parent.exports||{}),function(a){"use strict";a.HashSet=a.inherit({_t:"c.HashSet",initialize:function(){this.storage=[],this.size=0},add:function(a){var b=this.storage;b.indexOf(a),-1==b.indexOf(a)&&b.push(a),this.size=this.storage.length},values:function(){return this.storage},has:function(a){var b=this.storage;return-1!=b.indexOf(a)},"delete":function(a){var b=this.storage.indexOf(a);return-1==b?null:(this.storage.splice(b,1)[0],this.size=this.storage.length,void 0)},clear:function(){this.storage.length=0},each:function(a,b){this.size&&this.storage.forEach(a,b)},escapingEach:function(a,b){this.size&&this.storage.forEach(a,b)},toString:function(){var a=this.size+" {",b=!0;return this.each(function(c){b?b=!1:a+=", ",a+=c}),a+="}\n"},toJSON:function(){var a=[];return this.each(function(b){a.push(b.toJSON())}),{_t:"c.HashSet",data:a}},fromJSON:function(b){var c=new a.HashSet;return b.data&&(c.size=b.data.length,c.storage=b.data),c}})}(this.c||module.parent.exports||{}),function(a){"use strict";a.Error=a.inherit({initialize:function(a){a&&(this._description=a)},_name:"c.Error",_description:"An error has occured in Cassowary",set description(a){this._description=a},get description(){return"("+this._name+") "+this._description},get message(){return this.description},toString:function(){return this.description}});var b=function(b,c){return a.inherit({"extends":a.Error,initialize:function(){a.Error.apply(this,arguments)},_name:b||"",_description:c||""})};a.ConstraintNotFound=b("c.ConstraintNotFound","Tried to remove a constraint never added to the tableu"),a.InternalError=b("c.InternalError"),a.NonExpression=b("c.NonExpression","The resulting expression would be non"),a.NotEnoughStays=b("c.NotEnoughStays","There are not enough stays to give specific values to every variable"),a.RequiredFailure=b("c.RequiredFailure","A required constraint cannot be satisfied"),a.TooDifficult=b("c.TooDifficult","The constraints are too difficult to solve")}(this.c||module.parent.exports||{}),function(a){"use strict";var b=1e3;a.SymbolicWeight=a.inherit({_t:"c.SymbolicWeight",initialize:function(){this.value=0;for(var a=1,c=arguments.length-1;c>=0;--c)this.value+=arguments[c]*a,a*=b},toJSON:function(){return{_t:this._t,value:this.value}}})}(this.c||module.parent.exports||{}),function(a){a.Strength=a.inherit({initialize:function(b,c,d,e){this.name=b,this.symbolicWeight=c instanceof a.SymbolicWeight?c:new a.SymbolicWeight(c,d,e)},get required(){return this===a.Strength.required},toString:function(){return this.name+(this.isRequired?"":":"+this.symbolicWeight)}}),a.Strength.required=new a.Strength("<Required>",1e3,1e3,1e3),a.Strength.strong=new a.Strength("strong",1,0,0),a.Strength.medium=new a.Strength("medium",0,1,0),a.Strength.weak=new a.Strength("weak",0,0,1)}(this.c||(true?module.parent.exports.c:{})),function(a){"use strict";a.AbstractVariable=a.inherit({isDummy:!1,isExternal:!1,isPivotable:!1,isRestricted:!1,_init:function(b,c){this.hashCode=a._inc(),this.name=(c||"")+this.hashCode,b&&(b.name!==void 0&&(this.name=b.name),b.value!==void 0&&(this.value=b.value),b.prefix!==void 0&&(this._prefix=b.prefix))},_prefix:"",name:"",value:0,toJSON:function(){var a={};return this._t&&(a._t=this._t),this.name&&(a.name=this.name),this.value!==void 0&&(a.value=this.value),this._prefix&&(a._prefix=this._prefix),this._t&&(a._t=this._t),a},fromJSON:function(b,c){var d=new c;return a.extend(d,b),d},toString:function(){return this._prefix+"["+this.name+":"+this.value+"]"}}),a.Variable=a.inherit({_t:"c.Variable","extends":a.AbstractVariable,initialize:function(b){this._init(b,"v");var c=a.Variable._map;c&&(c[this.name]=this)},isExternal:!0}),a.DummyVariable=a.inherit({_t:"c.DummyVariable","extends":a.AbstractVariable,initialize:function(a){this._init(a,"d")},isDummy:!0,isRestricted:!0,value:"dummy"}),a.ObjectiveVariable=a.inherit({_t:"c.ObjectiveVariable","extends":a.AbstractVariable,initialize:function(a){this._init(a,"o")},value:"obj"}),a.SlackVariable=a.inherit({_t:"c.SlackVariable","extends":a.AbstractVariable,initialize:function(a){this._init(a,"s")},isPivotable:!0,isRestricted:!0,value:"slack"})}(this.c||module.parent.exports||{}),function(a){"use strict";a.Point=a.inherit({initialize:function(b,c,d){if(b instanceof a.Variable)this._x=b;else{var e={value:b};d&&(e.name="x"+d),this._x=new a.Variable(e)}if(c instanceof a.Variable)this._y=c;else{var f={value:c};d&&(f.name="y"+d),this._y=new a.Variable(f)}},get x(){return this._x},set x(b){b instanceof a.Variable?this._x=b:this._x.value=b},get y(){return this._y},set y(b){b instanceof a.Variable?this._y=b:this._y.value=b},toString:function(){return"("+this.x+", "+this.y+")"}})}(this.c||module.parent.exports||{}),function(a){"use strict";a.Expression=a.inherit({initialize:function(b,c,d){a.GC&&console.log("new c.Expression"),this.constant="number"!=typeof d||isNaN(d)?0:d,this.terms=new a.HashTable,b instanceof a.AbstractVariable?this.setVariable(b,"number"==typeof c?c:1):"number"==typeof b&&(isNaN(b)?console.trace():this.constant=b)},initializeFromHash:function(b,c){return a.verbose&&(console.log("*******************************"),console.log("clone c.initializeFromHash"),console.log("*******************************")),a.GC&&console.log("clone c.Expression"),this.constant=b,this.terms=c.clone(),this},multiplyMe:function(a){this.constant*=a;var b=this.terms;return b.each(function(c,d){b.set(c,d*a)}),this},clone:function(){a.verbose&&(console.log("*******************************"),console.log("clone c.Expression"),console.log("*******************************"));var b=new a.Expression;return b.initializeFromHash(this.constant,this.terms),b},times:function(b){if("number"==typeof b)return this.clone().multiplyMe(b);if(this.isConstant)return b.times(this.constant);if(b.isConstant)return this.times(b.constant);throw new a.NonExpression},plus:function(b){return b instanceof a.Expression?this.clone().addExpression(b,1):b instanceof a.Variable?this.clone().addVariable(b,1):void 0},minus:function(b){return b instanceof a.Expression?this.clone().addExpression(b,-1):b instanceof a.Variable?this.clone().addVariable(b,-1):void 0},divide:function(b){if("number"==typeof b){if(a.approx(b,0))throw new a.NonExpression;return this.times(1/b)}if(b instanceof a.Expression){if(!b.isConstant)throw new a.NonExpression;return this.times(1/b.constant)}},addExpression:function(b,c,d,e){return b instanceof a.AbstractVariable&&(b=new a.Expression(b),a.trace&&console.log("addExpression: Had to cast a var to an expression")),c=c||1,this.constant+=c*b.constant,b.terms.each(function(a,b){this.addVariable(a,b*c,d,e)},this),this},addVariable:function(b,c,d,e){null==c&&(c=1),a.trace&&console.log("c.Expression::addVariable():",b,c);var f=this.terms.get(b);if(f){var g=f+c;0==g||a.approx(g,0)?(e&&e.noteRemovedVariable(b,d),this.terms.delete(b)):this.setVariable(b,g)}else a.approx(c,0)||(this.setVariable(b,c),e&&e.noteAddedVariable(b,d));return this},setVariable:function(a,b){return this.terms.set(a,b),this},anyPivotableVariable:function(){if(this.isConstant)throw new a.InternalError("anyPivotableVariable called on a constant");var b=this.terms.escapingEach(function(a){return a.isPivotable?{retval:a}:void 0});return b&&void 0!==b.retval?b.retval:null},substituteOut:function(b,c,d,e){a.trace&&(a.fnenterprint("CLE:substituteOut: "+b+", "+c+", "+d+", ..."),a.traceprint("this = "+this));var f=this.setVariable.bind(this),g=this.terms,h=g.get(b);g.delete(b),this.constant+=h*c.constant,c.terms.each(function(b,c){var i=g.get(b);if(i){var j=i+h*c;a.approx(j,0)?(e.noteRemovedVariable(b,d),g.delete(b)):f(b,j)}else f(b,h*c),e&&e.noteAddedVariable(b,d)}),a.trace&&a.traceprint("Now this is "+this)},changeSubject:function(a,b){this.setVariable(a,this.newSubject(b))},newSubject:function(b){a.trace&&a.fnenterprint("newSubject:"+b);var c=1/this.terms.get(b);return this.terms.delete(b),this.multiplyMe(-c),c},coefficientFor:function(a){return this.terms.get(a)||0},get isConstant(){return 0==this.terms.size},toString:function(){var b="",c=!1;if(!a.approx(this.constant,0)||this.isConstant){if(b+=this.constant,this.isConstant)return b;c=!0}return this.terms.each(function(a,d){c&&(b+=" + "),b+=d+"*"+a,c=!0}),b},equals:function(b){return b===this?!0:b instanceof a.Expression&&b.constant===this.constant&&b.terms.equals(this.terms)},Plus:function(a,b){return a.plus(b)},Minus:function(a,b){return a.minus(b)},Times:function(a,b){return a.times(b)},Divide:function(a,b){return a.divide(b)}})}(this.c||module.parent.exports||{}),function(a){"use strict";a.AbstractConstraint=a.inherit({initialize:function(b,c){this.hashCode=a._inc(),this.strength=b||a.Strength.required,this.weight=c||1},isEditConstraint:!1,isInequality:!1,isStayConstraint:!1,get required(){return this.strength===a.Strength.required},toString:function(){return this.strength+" {"+this.weight+"} ("+this.expression+")"}});var b=a.AbstractConstraint.prototype.toString,c=function(b,c,d){a.AbstractConstraint.call(this,c||a.Strength.strong,d),this.variable=b,this.expression=new a.Expression(b,-1,b.value)};a.EditConstraint=a.inherit({"extends":a.AbstractConstraint,initialize:function(){c.apply(this,arguments)},isEditConstraint:!0,toString:function(){return"edit:"+b.call(this)}}),a.StayConstraint=a.inherit({"extends":a.AbstractConstraint,initialize:function(){c.apply(this,arguments)},isStayConstraint:!0,toString:function(){return"stay:"+b.call(this)}});var d=a.Constraint=a.inherit({"extends":a.AbstractConstraint,initialize:function(b,c,d){a.AbstractConstraint.call(this,c,d),this.expression=b}});a.Inequality=a.inherit({"extends":a.Constraint,_cloneOrNewCle:function(b){return b.clone?b.clone():new a.Expression(b)},initialize:function(b,c,e,f,g){var h=b instanceof a.Expression,i=e instanceof a.Expression,j=b instanceof a.AbstractVariable,k=e instanceof a.AbstractVariable,l="number"==typeof b,m="number"==typeof e;if((h||l)&&k){var n=b,o=c,p=e,q=f,r=g;if(d.call(this,this._cloneOrNewCle(n),q,r),o==a.LEQ)this.expression.multiplyMe(-1),this.expression.addVariable(p);else{if(o!=a.GEQ)throw new a.InternalError("Invalid operator in c.Inequality constructor");this.expression.addVariable(p,-1)}}else if(j&&(i||m)){var n=e,o=c,p=b,q=f,r=g;if(d.call(this,this._cloneOrNewCle(n),q,r),o==a.GEQ)this.expression.multiplyMe(-1),this.expression.addVariable(p);else{if(o!=a.LEQ)throw new a.InternalError("Invalid operator in c.Inequality constructor");this.expression.addVariable(p,-1)}}else{if(h&&m){var s=b,o=c,t=e,q=f,r=g;if(d.call(this,this._cloneOrNewCle(s),q,r),o==a.LEQ)this.expression.multiplyMe(-1),this.expression.addExpression(this._cloneOrNewCle(t));else{if(o!=a.GEQ)throw new a.InternalError("Invalid operator in c.Inequality constructor");this.expression.addExpression(this._cloneOrNewCle(t),-1)}return this}if(l&&i){var s=e,o=c,t=b,q=f,r=g;if(d.call(this,this._cloneOrNewCle(s),q,r),o==a.GEQ)this.expression.multiplyMe(-1),this.expression.addExpression(this._cloneOrNewCle(t));else{if(o!=a.LEQ)throw new a.InternalError("Invalid operator in c.Inequality constructor");this.expression.addExpression(this._cloneOrNewCle(t),-1)}return this}if(h&&i){var s=b,o=c,t=e,q=f,r=g;if(d.call(this,this._cloneOrNewCle(t),q,r),o==a.GEQ)this.expression.multiplyMe(-1),this.expression.addExpression(this._cloneOrNewCle(s));else{if(o!=a.LEQ)throw new a.InternalError("Invalid operator in c.Inequality constructor");this.expression.addExpression(this._cloneOrNewCle(s),-1)}}else{if(h)return d.call(this,b,c,e);if(c==a.GEQ)d.call(this,new a.Expression(e),f,g),this.expression.multiplyMe(-1),this.expression.addVariable(b);else{if(c!=a.LEQ)throw new a.InternalError("Invalid operator in c.Inequality constructor");d.call(this,new a.Expression(e),f,g),this.expression.addVariable(b,-1)}}}},isInequality:!0,toString:function(){return d.prototype.toString.call(this)+" >= 0) id: "+this.hashCode}}),a.Equation=a.inherit({"extends":a.Constraint,initialize:function(b,c,e,f){if(b instanceof a.Expression&&!c||c instanceof a.Strength)d.call(this,b,c,e);else if(b instanceof a.AbstractVariable&&c instanceof a.Expression){var g=b,h=c,i=e,j=f;d.call(this,h.clone(),i,j),this.expression.addVariable(g,-1)}else if(b instanceof a.AbstractVariable&&"number"==typeof c){var g=b,k=c,i=e,j=f;d.call(this,new a.Expression(k),i,j),this.expression.addVariable(g,-1)}else if(b instanceof a.Expression&&c instanceof a.AbstractVariable){var h=b,g=c,i=e,j=f;d.call(this,h.clone(),i,j),this.expression.addVariable(g,-1)}else{if(!(b instanceof a.Expression||b instanceof a.AbstractVariable||"number"==typeof b)||!(c instanceof a.Expression||c instanceof a.AbstractVariable||"number"==typeof c))throw"Bad initializer to c.Equation";b=b instanceof a.Expression?b.clone():new a.Expression(b),c=c instanceof a.Expression?c.clone():new a.Expression(c),d.call(this,b,e,f),this.expression.addExpression(c,-1)}a.assert(this.strength instanceof a.Strength,"_strength not set")},toString:function(){return d.prototype.toString.call(this)+" = 0)"}})}(this.c||module.parent.exports||{}),function(a){"use strict";a.EditInfo=a.inherit({initialize:function(a,b,c,d,e){this.constraint=a,this.editPlus=b,this.editMinus=c,this.prevEditConstant=d,this.index=e},toString:function(){return"<cn="+this.constraint+", ep="+this.editPlus+", em="+this.editMinus+", pec="+this.prevEditConstant+", index="+this.index+">"}})}(this.c||module.parent.exports||{}),function(a){"use strict";a.Tableau=a.inherit({initialize:function(){this.columns=new a.HashTable,this.rows=new a.HashTable,this._infeasibleRows=new a.HashSet,this._externalRows=new a.HashSet,this._externalParametricVars=new a.HashSet},noteRemovedVariable:function(b,c){a.trace&&console.log("c.Tableau::noteRemovedVariable: ",b,c);var d=this.columns.get(b);c&&d&&d.delete(c)},noteAddedVariable:function(a,b){b&&this.insertColVar(a,b)},getInternalInfo:function(){var a="Tableau Information:\n";return a+="Rows: "+this.rows.size,a+=" (= "+(this.rows.size-1)+" constraints)",a+="\nColumns: "+this.columns.size,a+="\nInfeasible Rows: "+this._infeasibleRows.size,a+="\nExternal basic variables: "+this._externalRows.size,a+="\nExternal parametric variables: ",a+=this._externalParametricVars.size,a+="\n"},toString:function(){var a="Tableau:\n";return this.rows.each(function(b,c){a+=b,a+=" <==> ",a+=c,a+="\n"}),a+="\nColumns:\n",a+=this.columns,a+="\nInfeasible rows: ",a+=this._infeasibleRows,a+="External basic variables: ",a+=this._externalRows,a+="External parametric variables: ",a+=this._externalParametricVars},insertColVar:function(b,c){var d=this.columns.get(b);d||(d=new a.HashSet,this.columns.set(b,d)),d.add(c)},addRow:function(b,c){a.trace&&a.fnenterprint("addRow: "+b+", "+c),this.rows.set(b,c),c.terms.each(function(a){this.insertColVar(a,b),a.isExternal&&this._externalParametricVars.add(a)},this),b.isExternal&&this._externalRows.add(b),a.trace&&a.traceprint(""+this)},removeColumn:function(b){a.trace&&a.fnenterprint("removeColumn:"+b);var c=this.columns.get(b);c?(this.columns.delete(b),c.each(function(a){var c=this.rows.get(a);c.terms.delete(b)},this)):a.trace&&console.log("Could not find var",b,"in columns"),b.isExternal&&(this._externalRows.delete(b),this._externalParametricVars.delete(b))},removeRow:function(b){a.trace&&a.fnenterprint("removeRow:"+b);var c=this.rows.get(b);return a.assert(null!=c),c.terms.each(function(c){var e=this.columns.get(c);null!=e&&(a.trace&&console.log("removing from varset:",b),e.delete(b))},this),this._infeasibleRows.delete(b),b.isExternal&&this._externalRows.delete(b),this.rows.delete(b),a.trace&&a.fnexitprint("returning "+c),c},substituteOut:function(b,c){a.trace&&a.fnenterprint("substituteOut:"+b+", "+c),a.trace&&a.traceprint(""+this);var d=this.columns.get(b);d.each(function(a){var d=this.rows.get(a);d.substituteOut(b,c,a,this),a.isRestricted&&0>d.constant&&this._infeasibleRows.add(a)},this),b.isExternal&&(this._externalRows.add(b),this._externalParametricVars.delete(b)),this.columns.delete(b)},columnsHasKey:function(a){return!!this.columns.get(a)}})}(this.c||module.parent.exports||{}),function(a){var b=a.Tableau,c=b.prototype,d=1e-8,e=a.Strength.weak;a.SimplexSolver=a.inherit({"extends":a.Tableau,initialize:function(){a.Tableau.call(this),this._stayMinusErrorVars=[],this._stayPlusErrorVars=[],this._errorVars=new a.HashTable,this._markerVars=new a.HashTable,this._objective=new a.ObjectiveVariable({name:"Z"}),this._editVarMap=new a.HashTable,this._editVarList=[],this._slackCounter=0,this._artificialCounter=0,this._dummyCounter=0,this.autoSolve=!0,this._fNeedsSolving=!1,this._optimizeCount=0,this.rows.set(this._objective,new a.Expression),this._stkCedcns=[0],a.trace&&a.traceprint("objective expr == "+this.rows.get(this._objective))},addLowerBound:function(b,c){var d=new a.Inequality(b,a.GEQ,new a.Expression(c));return this.addConstraint(d)},addUpperBound:function(b,c){var d=new a.Inequality(b,a.LEQ,new a.Expression(c));return this.addConstraint(d)},addBounds:function(a,b,c){return this.addLowerBound(a,b),this.addUpperBound(a,c),this},add:function(){for(var a=0;arguments.length>a;a++)this.addConstraint(arguments[a]);return this},addConstraint:function(b){a.trace&&a.fnenterprint("addConstraint: "+b);var c=Array(2),d=Array(1),e=this.newExpression(b,c,d);if(d=d[0],this.tryAddingDirectly(e)||this.addWithArtificialVariable(e),this._fNeedsSolving=!0,b.isEditConstraint){var f=this._editVarMap.size,g=c[0],h=c[1];!g instanceof a.SlackVariable&&console.warn("cvEplus not a slack variable =",g),!h instanceof a.SlackVariable&&console.warn("cvEminus not a slack variable =",h),a.debug&&console.log("new c.EditInfo("+b+", "+g+", "+h+", "+d+", "+f+")");var i=new a.EditInfo(b,g,h,d,f);this._editVarMap.set(b.variable,i),this._editVarList[f]={v:b.variable,info:i}}return this.autoSolve&&(this.optimize(this._objective),this._setExternalVariables()),this},addConstraintNoException:function(b){a.trace&&a.fnenterprint("addConstraintNoException: "+b);try{return this.addConstraint(b),!0}catch(c){return!1}},addEditVar:function(b,c){return a.trace&&a.fnenterprint("addEditVar: "+b+" @ "+c),this.addConstraint(new a.EditConstraint(b,c||a.Strength.strong))},beginEdit:function(){return a.assert(this._editVarMap.size>0,"_editVarMap.size > 0"),this._infeasibleRows.clear(),this._resetStayConstants(),this._stkCedcns.push(this._editVarMap.size),this},endEdit:function(){return a.assert(this._editVarMap.size>0,"_editVarMap.size > 0"),this.resolve(),this._stkCedcns.pop(),this.removeEditVarsTo(this._stkCedcns[this._stkCedcns.length-1]),this},removeAllEditVars:function(){return this.removeEditVarsTo(0)},removeEditVarsTo:function(b){try{for(var c=this._editVarList.length,d=b;c>d;d++)this._editVarList[d]&&this.removeConstraint(this._editVarMap.get(this._editVarList[d].v).constraint);return this._editVarList.length=b,a.assert(this._editVarMap.size==b,"_editVarMap.size == n"),this}catch(e){throw new a.InternalError("Constraint not found in removeEditVarsTo")}},addPointStays:function(b){return a.trace&&console.log("addPointStays",b),b.forEach(function(a,b){this.addStay(a.x,e,Math.pow(2,b)),this.addStay(a.y,e,Math.pow(2,b))},this),this},addStay:function(b,c,d){var f=new a.StayConstraint(b,c||e,d||1);return this.addConstraint(f)},removeConstraint:function(a){return this.removeConstraintInternal(a),this},removeConstraintInternal:function(b){a.trace&&a.fnenterprint("removeConstraintInternal: "+b),a.trace&&a.traceprint(""+this),this._fNeedsSolving=!0,this._resetStayConstants();var c=this.rows.get(this._objective),d=this._errorVars.get(b);a.trace&&a.traceprint("eVars == "+d),null!=d&&d.each(function(e){var f=this.rows.get(e);null==f?c.addVariable(e,-b.weight*b.strength.symbolicWeight.value,this._objective,this):c.addExpression(f,-b.weight*b.strength.symbolicWeight.value,this._objective,this),a.trace&&a.traceprint("now eVars == "+d)},this);var e=this._markerVars.get(b);if(this._markerVars.delete(b),null==e)throw new a.InternalError("Constraint not found in removeConstraintInternal");if(a.trace&&a.traceprint("Looking to remove var "+e),null==this.rows.get(e)){var f=this.columns.get(e);a.trace&&a.traceprint("Must pivot -- columns are "+f);var g=null,h=0;f.each(function(b){if(b.isRestricted){var c=this.rows.get(b),d=c.coefficientFor(e);if(a.trace&&a.traceprint("Marker "+e+"'s coefficient in "+c+" is "+d),0>d){var f=-c.constant/d;(null==g||h>f||a.approx(f,h)&&b.hashCode<g.hashCode)&&(h=f,g=b)}}},this),null==g&&(a.trace&&a.traceprint("exitVar is still null"),f.each(function(a){if(a.isRestricted){var b=this.rows.get(a),c=b.coefficientFor(e),d=b.constant/c;(null==g||h>d)&&(h=d,g=a)}},this)),null==g&&(0==f.size?this.removeColumn(e):f.escapingEach(function(a){return a!=this._objective?(g=a,{brk:!0}):void 0},this)),null!=g&&this.pivot(e,g)}if(null!=this.rows.get(e)&&this.removeRow(e),null!=d&&d.each(function(a){a!=e&&this.removeColumn(a)},this),b.isStayConstraint){if(null!=d)for(var j=0;this._stayPlusErrorVars.length>j;j++)d.delete(this._stayPlusErrorVars[j]),d.delete(this._stayMinusErrorVars[j])}else if(b.isEditConstraint){a.assert(null!=d,"eVars != null");var k=this._editVarMap.get(b.variable);this.removeColumn(k.editMinus),this._editVarMap.delete(b.variable)}return null!=d&&this._errorVars.delete(d),this.autoSolve&&(this.optimize(this._objective),this._setExternalVariables()),this},reset:function(){throw a.trace&&a.fnenterprint("reset"),new a.InternalError("reset not implemented")},resolveArray:function(b){a.trace&&a.fnenterprint("resolveArray"+b);var c=b.length;this._editVarMap.each(function(a,d){var e=d.index;c>e&&this.suggestValue(a,b[e])},this),this.resolve()},resolvePair:function(a,b){this.suggestValue(this._editVarList[0].v,a),this.suggestValue(this._editVarList[1].v,b),this.resolve()},resolve:function(){a.trace&&a.fnenterprint("resolve()"),this.dualOptimize(),this._setExternalVariables(),this._infeasibleRows.clear(),this._resetStayConstants()},suggestValue:function(b,c){a.trace&&console.log("suggestValue("+b+", "+c+")");var d=this._editVarMap.get(b);if(!d)throw new a.Error("suggestValue for variable "+b+", but var is not an edit variable");var e=c-d.prevEditConstant;return d.prevEditConstant=c,this.deltaEditConstant(e,d.editPlus,d.editMinus),this},solve:function(){return this._fNeedsSolving&&(this.optimize(this._objective),this._setExternalVariables()),this},setEditedValue:function(b,c){if(!this.columnsHasKey(b)&&null==this.rows.get(b))return b.value=c,this;if(!a.approx(c,b.value)){this.addEditVar(b),this.beginEdit();try{this.suggestValue(b,c)}catch(d){throw new a.InternalError("Error in setEditedValue")}this.endEdit()}return this},addVar:function(b){if(!this.columnsHasKey(b)&&null==this.rows.get(b)){try{this.addStay(b)}catch(c){throw new a.InternalError("Error in addVar -- required failure is impossible")}a.trace&&a.traceprint("added initial stay on "+b)}return this},getInternalInfo:function(){var a=c.getInternalInfo.call(this);return a+="\nSolver info:\n",a+="Stay Error Variables: ",a+=this._stayPlusErrorVars.length+this._stayMinusErrorVars.length,a+=" ("+this._stayPlusErrorVars.length+" +, ",a+=this._stayMinusErrorVars.length+" -)\n",a+="Edit Variables: "+this._editVarMap.size,a+="\n"},getDebugInfo:function(){return""+this+this.getInternalInfo()+"\n"},toString:function(){var a=c.getInternalInfo.call(this);return a+="\n_stayPlusErrorVars: ",a+="["+this._stayPlusErrorVars+"]",a+="\n_stayMinusErrorVars: ",a+="["+this._stayMinusErrorVars+"]",a+="\n",a+="_editVarMap:\n"+this._editVarMap,a+="\n"},getConstraintMap:function(){return this._markerVars},addWithArtificialVariable:function(b){a.trace&&a.fnenterprint("addWithArtificialVariable: "+b);var c=new a.SlackVariable({value:++this._artificialCounter,prefix:"a"}),d=new a.ObjectiveVariable({name:"az"}),e=b.clone();a.trace&&a.traceprint("before addRows:\n"+this),this.addRow(d,e),this.addRow(c,b),a.trace&&a.traceprint("after addRows:\n"+this),this.optimize(d);var f=this.rows.get(d);if(a.trace&&a.traceprint("azTableauRow.constant == "+f.constant),!a.approx(f.constant,0))throw this.removeRow(d),this.removeColumn(c),new a.RequiredFailure;var g=this.rows.get(c);if(null!=g){if(g.isConstant)return this.removeRow(c),this.removeRow(d),void 0;var h=g.anyPivotableVariable();this.pivot(h,c)}a.assert(null==this.rows.get(c),"rowExpression(av) == null"),this.removeColumn(c),this.removeRow(d)},tryAddingDirectly:function(b){a.trace&&a.fnenterprint("tryAddingDirectly: "+b);var c=this.chooseSubject(b);return null==c?(a.trace&&a.fnexitprint("returning false"),!1):(b.newSubject(c),this.columnsHasKey(c)&&this.substituteOut(c,b),this.addRow(c,b),a.trace&&a.fnexitprint("returning true"),!0)},chooseSubject:function(b){a.trace&&a.fnenterprint("chooseSubject: "+b);var c=null,d=!1,e=!1,f=b.terms,g=f.escapingEach(function(a,b){if(d){if(!a.isRestricted&&!this.columnsHasKey(a))return{retval:a}}else if(a.isRestricted){if(!e&&!a.isDummy&&0>b){var f=this.columns.get(a);(null==f||1==f.size&&this.columnsHasKey(this._objective))&&(c=a,e=!0)}}else c=a,d=!0},this);if(g&&void 0!==g.retval)return g.retval;if(null!=c)return c;var h=0,g=f.escapingEach(function(a,b){return a.isDummy?(this.columnsHasKey(a)||(c=a,h=b),void 0):{retval:null}},this);if(g&&void 0!==g.retval)return g.retval;if(!a.approx(b.constant,0))throw new a.RequiredFailure;return h>0&&b.multiplyMe(-1),c},deltaEditConstant:function(b,c,d){a.trace&&a.fnenterprint("deltaEditConstant :"+b+", "+c+", "+d);var e=this.rows.get(c);if(null!=e)return e.constant+=b,0>e.constant&&this._infeasibleRows.add(c),void 0;var f=this.rows.get(d);if(null!=f)return f.constant+=-b,0>f.constant&&this._infeasibleRows.add(d),void 0;var g=this.columns.get(d);g||console.log("columnVars is null -- tableau is:\n"+this),g.each(function(a){var c=this.rows.get(a),e=c.coefficientFor(d);c.constant+=e*b,a.isRestricted&&0>c.constant&&this._infeasibleRows.add(a)},this)},dualOptimize:function(){a.trace&&a.fnenterprint("dualOptimize:");for(var b=this.rows.get(this._objective);this._infeasibleRows.size;){var c=this._infeasibleRows.values()[0];this._infeasibleRows.delete(c);var d=null,e=this.rows.get(c);if(e&&0>e.constant){var g,f=Number.MAX_VALUE,h=e.terms;if(h.each(function(c,e){if(e>0&&c.isPivotable){var h=b.coefficientFor(c);g=h/e,(f>g||a.approx(g,f)&&c.hashCode<d.hashCode)&&(d=c,f=g)}}),f==Number.MAX_VALUE)throw new a.InternalError("ratio == nil (MAX_VALUE) in dualOptimize");this.pivot(d,c)}}},newExpression:function(b,c,d){a.trace&&(a.fnenterprint("newExpression: "+b),a.traceprint("cn.isInequality == "+b.isInequality),a.traceprint("cn.required == "+b.required));var e=b.expression,f=new a.Expression(e.constant),g=new a.SlackVariable,h=new a.DummyVariable,i=new a.SlackVariable,j=new a.SlackVariable,k=e.terms;if(k.each(function(a,b){var c=this.rows.get(a);c?f.addExpression(c,b):f.addVariable(a,b)},this),b.isInequality){if(a.trace&&a.traceprint("Inequality, adding slack"),++this._slackCounter,g=new a.SlackVariable({value:this._slackCounter,prefix:"s"}),f.setVariable(g,-1),this._markerVars.set(b,g),!b.required){++this._slackCounter,i=new a.SlackVariable({value:this._slackCounter,prefix:"em"}),f.setVariable(i,1);
	var l=this.rows.get(this._objective);l.setVariable(i,b.strength.symbolicWeight.value*b.weight),this.insertErrorVar(b,i),this.noteAddedVariable(i,this._objective)}}else if(b.required)a.trace&&a.traceprint("Equality, required"),++this._dummyCounter,h=new a.DummyVariable({value:this._dummyCounter,prefix:"d"}),f.setVariable(h,1),this._markerVars.set(b,h),a.trace&&a.traceprint("Adding dummyVar == d"+this._dummyCounter);else{a.trace&&a.traceprint("Equality, not required"),++this._slackCounter,j=new a.SlackVariable({value:this._slackCounter,prefix:"ep"}),i=new a.SlackVariable({value:this._slackCounter,prefix:"em"}),f.setVariable(j,-1),f.setVariable(i,1),this._markerVars.set(b,j);var l=this.rows.get(this._objective);a.trace&&console.log(l);var m=b.strength.symbolicWeight.value*b.weight;0==m&&(a.trace&&a.traceprint("cn == "+b),a.trace&&a.traceprint("adding "+j+" and "+i+" with swCoeff == "+m)),l.setVariable(j,m),this.noteAddedVariable(j,this._objective),l.setVariable(i,m),this.noteAddedVariable(i,this._objective),this.insertErrorVar(b,i),this.insertErrorVar(b,j),b.isStayConstraint?(this._stayPlusErrorVars.push(j),this._stayMinusErrorVars.push(i)):b.isEditConstraint&&(c[0]=j,c[1]=i,d[0]=e.constant)}return 0>f.constant&&f.multiplyMe(-1),a.trace&&a.fnexitprint("returning "+f),f},optimize:function(b){a.trace&&a.fnenterprint("optimize: "+b),a.trace&&a.traceprint(""+this),this._optimizeCount++;var c=this.rows.get(b);a.assert(null!=c,"zRow != null");for(var g,h,e=null,f=null;;){if(g=0,h=c.terms,h.escapingEach(function(a,b){return a.isPivotable&&g>b?(g=b,e=a,{brk:1}):void 0},this),g>=-d)return;a.trace&&console.log("entryVar:",e,"objectiveCoeff:",g);var i=Number.MAX_VALUE,j=this.columns.get(e),k=0;if(j.each(function(b){if(a.trace&&a.traceprint("Checking "+b),b.isPivotable){var c=this.rows.get(b),d=c.coefficientFor(e);a.trace&&a.traceprint("pivotable, coeff = "+d),0>d&&(k=-c.constant/d,(i>k||a.approx(k,i)&&b.hashCode<f.hashCode)&&(i=k,f=b))}},this),i==Number.MAX_VALUE)throw new a.InternalError("Objective function is unbounded in optimize");this.pivot(e,f),a.trace&&a.traceprint(""+this)}},pivot:function(b,c){a.trace&&console.log("pivot: ",b,c);var d=!1;d&&console.time(" SimplexSolver::pivot"),null==b&&console.warn("pivot: entryVar == null"),null==c&&console.warn("pivot: exitVar == null"),d&&console.time("  removeRow");var e=this.removeRow(c);d&&console.timeEnd("  removeRow"),d&&console.time("  changeSubject"),e.changeSubject(c,b),d&&console.timeEnd("  changeSubject"),d&&console.time("  substituteOut"),this.substituteOut(b,e),d&&console.timeEnd("  substituteOut"),d&&console.time("  addRow"),this.addRow(b,e),d&&console.timeEnd("  addRow"),d&&console.timeEnd(" SimplexSolver::pivot")},_resetStayConstants:function(){a.trace&&console.log("_resetStayConstants");for(var b=0;this._stayPlusErrorVars.length>b;b++){var c=this.rows.get(this._stayPlusErrorVars[b]);null==c&&(c=this.rows.get(this._stayMinusErrorVars[b])),null!=c&&(c.constant=0)}},_setExternalVariables:function(){a.trace&&a.fnenterprint("_setExternalVariables:"),a.trace&&a.traceprint(""+this),this._externalParametricVars.each(function(b){null!=this.rows.get(b)?a.trace&&console.log("Error: variable"+b+" in _externalParametricVars is basic"):b.value=0},this),this._externalRows.each(function(a){var b=this.rows.get(a);a.value!=b.constant&&(a.value=b.constant)},this),this._fNeedsSolving=!1,this.onsolved()},onsolved:function(){},insertErrorVar:function(b,c){a.trace&&a.fnenterprint("insertErrorVar:"+b+", "+c);var d=this._errorVars.get(c);d||(d=new a.HashSet,this._errorVars.set(b,d)),d.add(c)}})}(this.c||module.parent.exports||{}),function(a){"use strict";a.Timer=a.inherit({initialize:function(){this.isRunning=!1,this._elapsedMs=0},start:function(){return this.isRunning=!0,this._startReading=new Date,this},stop:function(){return this.isRunning=!1,this._elapsedMs+=new Date-this._startReading,this},reset:function(){return this.isRunning=!1,this._elapsedMs=0,this},elapsedTime:function(){return this.isRunning?(this._elapsedMs+(new Date-this._startReading))/1e3:this._elapsedMs/1e3}})}(this.c||module.parent.exports||{}),__cassowary_parser=function(){function a(a){return'"'+a.replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\x08/g,"\\b").replace(/\t/g,"\\t").replace(/\n/g,"\\n").replace(/\f/g,"\\f").replace(/\r/g,"\\r").replace(/[\x00-\x07\x0B\x0E-\x1F\x80-\uFFFF]/g,escape)+'"'}var b={parse:function(b,c){function k(a){g>e||(e>g&&(g=e,h=[]),h.push(a))}function l(){var a,b,c,d,f;if(d=e,f=e,a=z(),null!==a){if(c=m(),null!==c)for(b=[];null!==c;)b.push(c),c=m();else b=null;null!==b?(c=z(),null!==c?a=[a,b,c]:(a=null,e=f)):(a=null,e=f)}else a=null,e=f;return null!==a&&(a=function(a,b){return b}(d,a[1])),null===a&&(e=d),a}function m(){var a,b,c,d;return c=e,d=e,a=P(),null!==a?(b=s(),null!==b?a=[a,b]:(a=null,e=d)):(a=null,e=d),null!==a&&(a=function(a,b){return b}(c,a[0])),null===a&&(e=c),a}function n(){var a;return b.length>e?(a=b.charAt(e),e++):(a=null,0===f&&k("any character")),a}function o(){var a;return/^[a-zA-Z]/.test(b.charAt(e))?(a=b.charAt(e),e++):(a=null,0===f&&k("[a-zA-Z]")),null===a&&(36===b.charCodeAt(e)?(a="$",e++):(a=null,0===f&&k('"$"')),null===a&&(95===b.charCodeAt(e)?(a="_",e++):(a=null,0===f&&k('"_"')))),a}function p(){var a;return f++,/^[\t\x0B\f \xA0\uFEFF]/.test(b.charAt(e))?(a=b.charAt(e),e++):(a=null,0===f&&k("[\\t\\x0B\\f \\xA0\\uFEFF]")),f--,0===f&&null===a&&k("whitespace"),a}function q(){var a;return/^[\n\r\u2028\u2029]/.test(b.charAt(e))?(a=b.charAt(e),e++):(a=null,0===f&&k("[\\n\\r\\u2028\\u2029]")),a}function r(){var a;return f++,10===b.charCodeAt(e)?(a="\n",e++):(a=null,0===f&&k('"\\n"')),null===a&&("\r\n"===b.substr(e,2)?(a="\r\n",e+=2):(a=null,0===f&&k('"\\r\\n"')),null===a&&(13===b.charCodeAt(e)?(a="\r",e++):(a=null,0===f&&k('"\\r"')),null===a&&(8232===b.charCodeAt(e)?(a="\u2028",e++):(a=null,0===f&&k('"\\u2028"')),null===a&&(8233===b.charCodeAt(e)?(a="\u2029",e++):(a=null,0===f&&k('"\\u2029"')))))),f--,0===f&&null===a&&k("end of line"),a}function s(){var a,c,d;return d=e,a=z(),null!==a?(59===b.charCodeAt(e)?(c=";",e++):(c=null,0===f&&k('";"')),null!==c?a=[a,c]:(a=null,e=d)):(a=null,e=d),null===a&&(d=e,a=y(),null!==a?(c=r(),null!==c?a=[a,c]:(a=null,e=d)):(a=null,e=d),null===a&&(d=e,a=z(),null!==a?(c=t(),null!==c?a=[a,c]:(a=null,e=d)):(a=null,e=d))),a}function t(){var a,c;return c=e,f++,b.length>e?(a=b.charAt(e),e++):(a=null,0===f&&k("any character")),f--,null===a?a="":(a=null,e=c),a}function u(){var a;return f++,a=v(),null===a&&(a=x()),f--,0===f&&null===a&&k("comment"),a}function v(){var a,c,d,g,h,i,j;if(h=e,"/*"===b.substr(e,2)?(a="/*",e+=2):(a=null,0===f&&k('"/*"')),null!==a){for(c=[],i=e,j=e,f++,"*/"===b.substr(e,2)?(d="*/",e+=2):(d=null,0===f&&k('"*/"')),f--,null===d?d="":(d=null,e=j),null!==d?(g=n(),null!==g?d=[d,g]:(d=null,e=i)):(d=null,e=i);null!==d;)c.push(d),i=e,j=e,f++,"*/"===b.substr(e,2)?(d="*/",e+=2):(d=null,0===f&&k('"*/"')),f--,null===d?d="":(d=null,e=j),null!==d?(g=n(),null!==g?d=[d,g]:(d=null,e=i)):(d=null,e=i);null!==c?("*/"===b.substr(e,2)?(d="*/",e+=2):(d=null,0===f&&k('"*/"')),null!==d?a=[a,c,d]:(a=null,e=h)):(a=null,e=h)}else a=null,e=h;return a}function w(){var a,c,d,g,h,i,j;if(h=e,"/*"===b.substr(e,2)?(a="/*",e+=2):(a=null,0===f&&k('"/*"')),null!==a){for(c=[],i=e,j=e,f++,"*/"===b.substr(e,2)?(d="*/",e+=2):(d=null,0===f&&k('"*/"')),null===d&&(d=q()),f--,null===d?d="":(d=null,e=j),null!==d?(g=n(),null!==g?d=[d,g]:(d=null,e=i)):(d=null,e=i);null!==d;)c.push(d),i=e,j=e,f++,"*/"===b.substr(e,2)?(d="*/",e+=2):(d=null,0===f&&k('"*/"')),null===d&&(d=q()),f--,null===d?d="":(d=null,e=j),null!==d?(g=n(),null!==g?d=[d,g]:(d=null,e=i)):(d=null,e=i);null!==c?("*/"===b.substr(e,2)?(d="*/",e+=2):(d=null,0===f&&k('"*/"')),null!==d?a=[a,c,d]:(a=null,e=h)):(a=null,e=h)}else a=null,e=h;return a}function x(){var a,c,d,g,h,i,j;if(h=e,"//"===b.substr(e,2)?(a="//",e+=2):(a=null,0===f&&k('"//"')),null!==a){for(c=[],i=e,j=e,f++,d=q(),f--,null===d?d="":(d=null,e=j),null!==d?(g=n(),null!==g?d=[d,g]:(d=null,e=i)):(d=null,e=i);null!==d;)c.push(d),i=e,j=e,f++,d=q(),f--,null===d?d="":(d=null,e=j),null!==d?(g=n(),null!==g?d=[d,g]:(d=null,e=i)):(d=null,e=i);null!==c?a=[a,c]:(a=null,e=h)}else a=null,e=h;return a}function y(){var a,b;for(a=[],b=p(),null===b&&(b=w(),null===b&&(b=x()));null!==b;)a.push(b),b=p(),null===b&&(b=w(),null===b&&(b=x()));return a}function z(){var a,b;for(a=[],b=p(),null===b&&(b=r(),null===b&&(b=u()));null!==b;)a.push(b),b=p(),null===b&&(b=r(),null===b&&(b=u()));return a}function A(){var a,b;return b=e,a=C(),null===a&&(a=B()),null!==a&&(a=function(a,b){return{type:"NumericLiteral",value:b}}(b,a)),null===a&&(e=b),a}function B(){var a,c,d;if(d=e,/^[0-9]/.test(b.charAt(e))?(c=b.charAt(e),e++):(c=null,0===f&&k("[0-9]")),null!==c)for(a=[];null!==c;)a.push(c),/^[0-9]/.test(b.charAt(e))?(c=b.charAt(e),e++):(c=null,0===f&&k("[0-9]"));else a=null;return null!==a&&(a=function(a,b){return parseInt(b.join(""))}(d,a)),null===a&&(e=d),a}function C(){var a,c,d,g,h;return g=e,h=e,a=B(),null!==a?(46===b.charCodeAt(e)?(c=".",e++):(c=null,0===f&&k('"."')),null!==c?(d=B(),null!==d?a=[a,c,d]:(a=null,e=h)):(a=null,e=h)):(a=null,e=h),null!==a&&(a=function(a,b){return parseFloat(b.join(""))}(g,a)),null===a&&(e=g),a}function D(){var a,c,d,g;if(g=e,/^[\-+]/.test(b.charAt(e))?(a=b.charAt(e),e++):(a=null,0===f&&k("[\\-+]")),a=null!==a?a:"",null!==a){if(/^[0-9]/.test(b.charAt(e))?(d=b.charAt(e),e++):(d=null,0===f&&k("[0-9]")),null!==d)for(c=[];null!==d;)c.push(d),/^[0-9]/.test(b.charAt(e))?(d=b.charAt(e),e++):(d=null,0===f&&k("[0-9]"));else c=null;null!==c?a=[a,c]:(a=null,e=g)}else a=null,e=g;return a}function E(){var a,b;return f++,b=e,a=F(),null!==a&&(a=function(a,b){return b}(b,a)),null===a&&(e=b),f--,0===f&&null===a&&k("identifier"),a}function F(){var a,b,c,d,g;if(f++,d=e,g=e,a=o(),null!==a){for(b=[],c=o();null!==c;)b.push(c),c=o();null!==b?a=[a,b]:(a=null,e=g)}else a=null,e=g;return null!==a&&(a=function(a,b,c){return b+c.join("")}(d,a[0],a[1])),null===a&&(e=d),f--,0===f&&null===a&&k("identifier"),a}function G(){var a,c,d,g,h,i,j;return i=e,a=E(),null!==a&&(a=function(a,b){return{type:"Variable",name:b}}(i,a)),null===a&&(e=i),null===a&&(a=A(),null===a&&(i=e,j=e,40===b.charCodeAt(e)?(a="(",e++):(a=null,0===f&&k('"("')),null!==a?(c=z(),null!==c?(d=P(),null!==d?(g=z(),null!==g?(41===b.charCodeAt(e)?(h=")",e++):(h=null,0===f&&k('")"')),null!==h?a=[a,c,d,g,h]:(a=null,e=j)):(a=null,e=j)):(a=null,e=j)):(a=null,e=j)):(a=null,e=j),null!==a&&(a=function(a,b){return b}(i,a[2])),null===a&&(e=i))),a}function H(){var a,b,c,d,f;return a=G(),null===a&&(d=e,f=e,a=I(),null!==a?(b=z(),null!==b?(c=H(),null!==c?a=[a,b,c]:(a=null,e=f)):(a=null,e=f)):(a=null,e=f),null!==a&&(a=function(a,b,c){return{type:"UnaryExpression",operator:b,expression:c}}(d,a[0],a[2])),null===a&&(e=d)),a}function I(){var a;return 43===b.charCodeAt(e)?(a="+",e++):(a=null,0===f&&k('"+"')),null===a&&(45===b.charCodeAt(e)?(a="-",e++):(a=null,0===f&&k('"-"')),null===a&&(33===b.charCodeAt(e)?(a="!",e++):(a=null,0===f&&k('"!"')))),a}function J(){var a,b,c,d,f,g,h,i,j;if(h=e,i=e,a=H(),null!==a){for(b=[],j=e,c=z(),null!==c?(d=K(),null!==d?(f=z(),null!==f?(g=H(),null!==g?c=[c,d,f,g]:(c=null,e=j)):(c=null,e=j)):(c=null,e=j)):(c=null,e=j);null!==c;)b.push(c),j=e,c=z(),null!==c?(d=K(),null!==d?(f=z(),null!==f?(g=H(),null!==g?c=[c,d,f,g]:(c=null,e=j)):(c=null,e=j)):(c=null,e=j)):(c=null,e=j);null!==b?a=[a,b]:(a=null,e=i)}else a=null,e=i;return null!==a&&(a=function(a,b,c){for(var d=b,e=0;c.length>e;e++)d={type:"MultiplicativeExpression",operator:c[e][1],left:d,right:c[e][3]};return d}(h,a[0],a[1])),null===a&&(e=h),a}function K(){var a;return 42===b.charCodeAt(e)?(a="*",e++):(a=null,0===f&&k('"*"')),null===a&&(47===b.charCodeAt(e)?(a="/",e++):(a=null,0===f&&k('"/"'))),a}function L(){var a,b,c,d,f,g,h,i,j;if(h=e,i=e,a=J(),null!==a){for(b=[],j=e,c=z(),null!==c?(d=M(),null!==d?(f=z(),null!==f?(g=J(),null!==g?c=[c,d,f,g]:(c=null,e=j)):(c=null,e=j)):(c=null,e=j)):(c=null,e=j);null!==c;)b.push(c),j=e,c=z(),null!==c?(d=M(),null!==d?(f=z(),null!==f?(g=J(),null!==g?c=[c,d,f,g]:(c=null,e=j)):(c=null,e=j)):(c=null,e=j)):(c=null,e=j);null!==b?a=[a,b]:(a=null,e=i)}else a=null,e=i;return null!==a&&(a=function(a,b,c){for(var d=b,e=0;c.length>e;e++)d={type:"AdditiveExpression",operator:c[e][1],left:d,right:c[e][3]};return d}(h,a[0],a[1])),null===a&&(e=h),a}function M(){var a;return 43===b.charCodeAt(e)?(a="+",e++):(a=null,0===f&&k('"+"')),null===a&&(45===b.charCodeAt(e)?(a="-",e++):(a=null,0===f&&k('"-"'))),a}function N(){var a,b,c,d,f,g,h,i,j;if(h=e,i=e,a=L(),null!==a){for(b=[],j=e,c=z(),null!==c?(d=O(),null!==d?(f=z(),null!==f?(g=L(),null!==g?c=[c,d,f,g]:(c=null,e=j)):(c=null,e=j)):(c=null,e=j)):(c=null,e=j);null!==c;)b.push(c),j=e,c=z(),null!==c?(d=O(),null!==d?(f=z(),null!==f?(g=L(),null!==g?c=[c,d,f,g]:(c=null,e=j)):(c=null,e=j)):(c=null,e=j)):(c=null,e=j);null!==b?a=[a,b]:(a=null,e=i)}else a=null,e=i;return null!==a&&(a=function(a,b,c){for(var d=b,e=0;c.length>e;e++)d={type:"Inequality",operator:c[e][1],left:d,right:c[e][3]};return d}(h,a[0],a[1])),null===a&&(e=h),a}function O(){var a;return"<="===b.substr(e,2)?(a="<=",e+=2):(a=null,0===f&&k('"<="')),null===a&&(">="===b.substr(e,2)?(a=">=",e+=2):(a=null,0===f&&k('">="')),null===a&&(60===b.charCodeAt(e)?(a="<",e++):(a=null,0===f&&k('"<"')),null===a&&(62===b.charCodeAt(e)?(a=">",e++):(a=null,0===f&&k('">"'))))),a}function P(){var a,c,d,g,h,i,j,l,m;if(j=e,l=e,a=N(),null!==a){for(c=[],m=e,d=z(),null!==d?("=="===b.substr(e,2)?(g="==",e+=2):(g=null,0===f&&k('"=="')),null!==g?(h=z(),null!==h?(i=N(),null!==i?d=[d,g,h,i]:(d=null,e=m)):(d=null,e=m)):(d=null,e=m)):(d=null,e=m);null!==d;)c.push(d),m=e,d=z(),null!==d?("=="===b.substr(e,2)?(g="==",e+=2):(g=null,0===f&&k('"=="')),null!==g?(h=z(),null!==h?(i=N(),null!==i?d=[d,g,h,i]:(d=null,e=m)):(d=null,e=m)):(d=null,e=m)):(d=null,e=m);null!==c?a=[a,c]:(a=null,e=l)}else a=null,e=l;return null!==a&&(a=function(a,b,c){for(var d=b,e=0;c.length>e;e++)d={type:"Equality",operator:c[e][1],left:d,right:c[e][3]};return d}(j,a[0],a[1])),null===a&&(e=j),a}function Q(a){a.sort();for(var b=null,c=[],d=0;a.length>d;d++)a[d]!==b&&(c.push(a[d]),b=a[d]);return c}function R(){for(var a=1,c=1,d=!1,f=0;Math.max(e,g)>f;f++){var h=b.charAt(f);"\n"===h?(d||a++,c=1,d=!1):"\r"===h||"\u2028"===h||"\u2029"===h?(a++,c=1,d=!0):(c++,d=!1)}return{line:a,column:c}}var d={start:l,Statement:m,SourceCharacter:n,IdentifierStart:o,WhiteSpace:p,LineTerminator:q,LineTerminatorSequence:r,EOS:s,EOF:t,Comment:u,MultiLineComment:v,MultiLineCommentNoLineTerminator:w,SingleLineComment:x,_:y,__:z,Literal:A,Integer:B,Real:C,SignedInteger:D,Identifier:E,IdentifierName:F,PrimaryExpression:G,UnaryExpression:H,UnaryOperator:I,MultiplicativeExpression:J,MultiplicativeOperator:K,AdditiveExpression:L,AdditiveOperator:M,InequalityExpression:N,InequalityOperator:O,LinearExpression:P};if(void 0!==c){if(void 0===d[c])throw Error("Invalid rule name: "+a(c)+".")}else c="start";var e=0,f=0,g=0,h=[],S=d[c]();if(null===S||e!==b.length){var T=Math.max(e,g),U=b.length>T?b.charAt(T):null,V=R();throw new this.SyntaxError(Q(h),U,T,V.line,V.column)}return S},toSource:function(){return this._source}};return b.SyntaxError=function(b,c,d,e,f){function g(b,c){var d,e;switch(b.length){case 0:d="end of input";break;case 1:d=b[0];break;default:d=b.slice(0,b.length-1).join(", ")+" or "+b[b.length-1]}return e=c?a(c):"end of input","Expected "+d+" but "+e+" found."}this.name="SyntaxError",this.expected=b,this.found=c,this.message=g(b,c),this.offset=d,this.line=e,this.column=f},b.SyntaxError.prototype=Error.prototype,b}();
	}).call(
	  (true) ?
	      (module.compiled = true && module) : this
	);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)(module)))

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * History API JavaScript Library v4.2.0
	 *
	 * Support: IE8+, FF3+, Opera 9+, Safari, Chrome and other
	 *
	 * Copyright 2011-2014, Dmitrii Pakhtinov ( spb.piksel@gmail.com )
	 *
	 * http://spb-piksel.ru/
	 *
	 * Dual licensed under the MIT and GPL licenses:
	 *   http://www.opensource.org/licenses/mit-license.php
	 *   http://www.gnu.org/licenses/gpl.html
	 *
	 * Update: 2014-11-06 21:35
	 */
	(function(factory) {
	    if ("function" === 'function' && __webpack_require__(15)['amd']) {
	        // https://github.com/devote/HTML5-History-API/issues/57#issuecomment-43133600
	        __webpack_require__(15)(typeof document !== "object" || document.readyState !== "loading" ? [] : "html5-history-api", factory);
	    } else {
	        factory();
	    }
	})(function() {
	    // Define global variable
	    var global = (typeof window === 'object' ? window : this) || {};
	    // Prevent the code from running if there is no window.history object or library already loaded
	    if (!global.history || "emulate" in global.history) return global.history;
	    // symlink to document
	    var document = global.document;
	    // HTML element
	    var documentElement = document.documentElement;
	    // symlink to constructor of Object
	    var Object = global['Object'];
	    // symlink to JSON Object
	    var JSON = global['JSON'];
	    // symlink to instance object of 'Location'
	    var windowLocation = global.location;
	    // symlink to instance object of 'History'
	    var windowHistory = global.history;
	    // new instance of 'History'. The default is a reference to the original object instance
	    var historyObject = windowHistory;
	    // symlink to method 'history.pushState'
	    var historyPushState = windowHistory.pushState;
	    // symlink to method 'history.replaceState'
	    var historyReplaceState = windowHistory.replaceState;
	    // if the browser supports HTML5-History-API
	    var isSupportHistoryAPI = !!historyPushState;
	    // verifies the presence of an object 'state' in interface 'History'
	    var isSupportStateObjectInHistory = 'state' in windowHistory;
	    // symlink to method 'Object.defineProperty'
	    var defineProperty = Object.defineProperty;
	    // new instance of 'Location', for IE8 will use the element HTMLAnchorElement, instead of pure object
	    var locationObject = redefineProperty({}, 't') ? {} : document.createElement('a');
	    // prefix for the names of events
	    var eventNamePrefix = '';
	    // String that will contain the name of the method
	    var addEventListenerName = global.addEventListener ? 'addEventListener' : (eventNamePrefix = 'on') && 'attachEvent';
	    // String that will contain the name of the method
	    var removeEventListenerName = global.removeEventListener ? 'removeEventListener' : 'detachEvent';
	    // String that will contain the name of the method
	    var dispatchEventName = global.dispatchEvent ? 'dispatchEvent' : 'fireEvent';
	    // reference native methods for the events
	    var addEvent = global[addEventListenerName];
	    var removeEvent = global[removeEventListenerName];
	    var dispatch = global[dispatchEventName];
	    // default settings
	    var settings = {"basepath": '/', "redirect": 0, "type": '/', "init": 0};
	    // key for the sessionStorage
	    var sessionStorageKey = '__historyAPI__';
	    // Anchor Element for parseURL function
	    var anchorElement = document.createElement('a');
	    // last URL before change to new URL
	    var lastURL = windowLocation.href;
	    // Control URL, need to fix the bug in Opera
	    var checkUrlForPopState = '';
	    // for fix on Safari 8
	    var triggerEventsInWindowAttributes = 1;
	    // trigger event 'onpopstate' on page load
	    var isFireInitialState = false;
	    // if used history.location of other code
	    var isUsedHistoryLocationFlag = 0;
	    // store a list of 'state' objects in the current session
	    var stateStorage = {};
	    // in this object will be stored custom handlers
	    var eventsList = {};
	    // stored last title
	    var lastTitle = document.title;

	    /**
	     * Properties that will be replaced in the global
	     * object 'window', to prevent conflicts
	     *
	     * @type {Object}
	     */
	    var eventsDescriptors = {
	        "onhashchange": null,
	        "onpopstate": null
	    };

	    /**
	     * Fix for Chrome in iOS
	     * See https://github.com/devote/HTML5-History-API/issues/29
	     */
	    var fastFixChrome = function(method, args) {
	        var isNeedFix = global.history !== windowHistory;
	        if (isNeedFix) {
	            global.history = windowHistory;
	        }
	        method.apply(windowHistory, args);
	        if (isNeedFix) {
	            global.history = historyObject;
	        }
	    };

	    /**
	     * Properties that will be replaced/added to object
	     * 'window.history', includes the object 'history.location',
	     * for a complete the work with the URL address
	     *
	     * @type {Object}
	     */
	    var historyDescriptors = {
	        /**
	         * Setting library initialization
	         *
	         * @param {null|String} [basepath] The base path to the site; defaults to the root "/".
	         * @param {null|String} [type] Substitute the string after the anchor; by default "/".
	         * @param {null|Boolean} [redirect] Enable link translation.
	         */
	        "setup": function(basepath, type, redirect) {
	            settings["basepath"] = ('' + (basepath == null ? settings["basepath"] : basepath))
	                .replace(/(?:^|\/)[^\/]*$/, '/');
	            settings["type"] = type == null ? settings["type"] : type;
	            settings["redirect"] = redirect == null ? settings["redirect"] : !!redirect;
	        },
	        /**
	         * @namespace history
	         * @param {String} [type]
	         * @param {String} [basepath]
	         */
	        "redirect": function(type, basepath) {
	            historyObject['setup'](basepath, type);
	            basepath = settings["basepath"];
	            if (global.top == global.self) {
	                var relative = parseURL(null, false, true)._relative;
	                var path = windowLocation.pathname + windowLocation.search;
	                if (isSupportHistoryAPI) {
	                    path = path.replace(/([^\/])$/, '$1/');
	                    if (relative != basepath && (new RegExp("^" + basepath + "$", "i")).test(path)) {
	                        windowLocation.replace(relative);
	                    }
	                } else if (path != basepath) {
	                    path = path.replace(/([^\/])\?/, '$1/?');
	                    if ((new RegExp("^" + basepath, "i")).test(path)) {
	                        windowLocation.replace(basepath + '#' + path.
	                            replace(new RegExp("^" + basepath, "i"), settings["type"]) + windowLocation.hash);
	                    }
	                }
	            }
	        },
	        /**
	         * The method adds a state object entry
	         * to the history.
	         *
	         * @namespace history
	         * @param {Object} state
	         * @param {string} title
	         * @param {string} [url]
	         */
	        pushState: function(state, title, url) {
	            var t = document.title;
	            if (lastTitle != null) {
	                document.title = lastTitle;
	            }
	            historyPushState && fastFixChrome(historyPushState, arguments);
	            changeState(state, url);
	            document.title = t;
	            lastTitle = title;
	        },
	        /**
	         * The method updates the state object,
	         * title, and optionally the URL of the
	         * current entry in the history.
	         *
	         * @namespace history
	         * @param {Object} state
	         * @param {string} title
	         * @param {string} [url]
	         */
	        replaceState: function(state, title, url) {
	            var t = document.title;
	            if (lastTitle != null) {
	                document.title = lastTitle;
	            }
	            delete stateStorage[windowLocation.href];
	            historyReplaceState && fastFixChrome(historyReplaceState, arguments);
	            changeState(state, url, true);
	            document.title = t;
	            lastTitle = title;
	        },
	        /**
	         * Object 'history.location' is similar to the
	         * object 'window.location', except that in
	         * HTML4 browsers it will behave a bit differently
	         *
	         * @namespace history
	         */
	        "location": {
	            set: function(value) {
	                if (isUsedHistoryLocationFlag === 0) isUsedHistoryLocationFlag = 1;
	                global.location = value;
	            },
	            get: function() {
	                if (isUsedHistoryLocationFlag === 0) isUsedHistoryLocationFlag = 1;
	                return isSupportHistoryAPI ? windowLocation : locationObject;
	            }
	        },
	        /**
	         * A state object is an object representing
	         * a user interface state.
	         *
	         * @namespace history
	         */
	        "state": {
	            get: function() {
	                return stateStorage[windowLocation.href] || null;
	            }
	        }
	    };

	    /**
	     * Properties for object 'history.location'.
	     * Object 'history.location' is similar to the
	     * object 'window.location', except that in
	     * HTML4 browsers it will behave a bit differently
	     *
	     * @type {Object}
	     */
	    var locationDescriptors = {
	        /**
	         * Navigates to the given page.
	         *
	         * @namespace history.location
	         */
	        assign: function(url) {
	            if (('' + url).indexOf('#') === 0) {
	                changeState(null, url);
	            } else {
	                windowLocation.assign(url);
	            }
	        },
	        /**
	         * Reloads the current page.
	         *
	         * @namespace history.location
	         */
	        reload: function() {
	            windowLocation.reload();
	        },
	        /**
	         * Removes the current page from
	         * the session history and navigates
	         * to the given page.
	         *
	         * @namespace history.location
	         */
	        replace: function(url) {
	            if (('' + url).indexOf('#') === 0) {
	                changeState(null, url, true);
	            } else {
	                windowLocation.replace(url);
	            }
	        },
	        /**
	         * Returns the current page's location.
	         *
	         * @namespace history.location
	         */
	        toString: function() {
	            return this.href;
	        },
	        /**
	         * Returns the current page's location.
	         * Can be set, to navigate to another page.
	         *
	         * @namespace history.location
	         */
	        "href": {
	            get: function() {
	                return parseURL()._href;
	            }
	        },
	        /**
	         * Returns the current page's protocol.
	         *
	         * @namespace history.location
	         */
	        "protocol": null,
	        /**
	         * Returns the current page's host and port number.
	         *
	         * @namespace history.location
	         */
	        "host": null,
	        /**
	         * Returns the current page's host.
	         *
	         * @namespace history.location
	         */
	        "hostname": null,
	        /**
	         * Returns the current page's port number.
	         *
	         * @namespace history.location
	         */
	        "port": null,
	        /**
	         * Returns the current page's path only.
	         *
	         * @namespace history.location
	         */
	        "pathname": {
	            get: function() {
	                return parseURL()._pathname;
	            }
	        },
	        /**
	         * Returns the current page's search
	         * string, beginning with the character
	         * '?' and to the symbol '#'
	         *
	         * @namespace history.location
	         */
	        "search": {
	            get: function() {
	                return parseURL()._search;
	            }
	        },
	        /**
	         * Returns the current page's hash
	         * string, beginning with the character
	         * '#' and to the end line
	         *
	         * @namespace history.location
	         */
	        "hash": {
	            set: function(value) {
	                changeState(null, ('' + value).replace(/^(#|)/, '#'), false, lastURL);
	            },
	            get: function() {
	                return parseURL()._hash;
	            }
	        }
	    };

	    /**
	     * Just empty function
	     *
	     * @return void
	     */
	    function emptyFunction() {
	        // dummy
	    }

	    /**
	     * Prepares a parts of the current or specified reference for later use in the library
	     *
	     * @param {string} [href]
	     * @param {boolean} [isWindowLocation]
	     * @param {boolean} [isNotAPI]
	     * @return {Object}
	     */
	    function parseURL(href, isWindowLocation, isNotAPI) {
	        var re = /(?:(\w+\:))?(?:\/\/(?:[^@]*@)?([^\/:\?#]+)(?::([0-9]+))?)?([^\?#]*)(?:(\?[^#]+)|\?)?(?:(#.*))?/;
	        if (href != null && href !== '' && !isWindowLocation) {
	            var current = parseURL(),
	                base = document.getElementsByTagName('base')[0];
	            if (!isNotAPI && base && base.getAttribute('href')) {
	              // Fix for IE ignoring relative base tags.
	              // See http://stackoverflow.com/questions/3926197/html-base-tag-and-local-folder-path-with-internet-explorer
	              base.href = base.href;
	              current = parseURL(base.href, null, true);
	            }
	            var _pathname = current._pathname, _protocol = current._protocol;
	            // convert to type of string
	            href = '' + href;
	            // convert relative link to the absolute
	            href = /^(?:\w+\:)?\/\//.test(href) ? href.indexOf("/") === 0
	                ? _protocol + href : href : _protocol + "//" + current._host + (
	                href.indexOf("/") === 0 ? href : href.indexOf("?") === 0
	                    ? _pathname + href : href.indexOf("#") === 0
	                    ? _pathname + current._search + href : _pathname.replace(/[^\/]+$/g, '') + href
	                );
	        } else {
	            href = isWindowLocation ? href : windowLocation.href;
	            // if current browser not support History-API
	            if (!isSupportHistoryAPI || isNotAPI) {
	                // get hash fragment
	                href = href.replace(/^[^#]*/, '') || "#";
	                // form the absolute link from the hash
	                // https://github.com/devote/HTML5-History-API/issues/50
	                href = windowLocation.protocol.replace(/:.*$|$/, ':') + '//' + windowLocation.host + settings['basepath']
	                    + href.replace(new RegExp("^#[\/]?(?:" + settings["type"] + ")?"), "");
	            }
	        }
	        // that would get rid of the links of the form: /../../
	        anchorElement.href = href;
	        // decompose the link in parts
	        var result = re.exec(anchorElement.href);
	        // host name with the port number
	        var host = result[2] + (result[3] ? ':' + result[3] : '');
	        // folder
	        var pathname = result[4] || '/';
	        // the query string
	        var search = result[5] || '';
	        // hash
	        var hash = result[6] === '#' ? '' : (result[6] || '');
	        // relative link, no protocol, no host
	        var relative = pathname + search + hash;
	        // special links for set to hash-link, if browser not support History API
	        var nohash = pathname.replace(new RegExp("^" + settings["basepath"], "i"), settings["type"]) + search;
	        // result
	        return {
	            _href: result[1] + '//' + host + relative,
	            _protocol: result[1],
	            _host: host,
	            _hostname: result[2],
	            _port: result[3] || '',
	            _pathname: pathname,
	            _search: search,
	            _hash: hash,
	            _relative: relative,
	            _nohash: nohash,
	            _special: nohash + hash
	        }
	    }

	    /**
	     * Initializing storage for the custom state's object
	     */
	    function storageInitialize() {
	        var sessionStorage;
	        /**
	         * sessionStorage throws error when cookies are disabled
	         * Chrome content settings when running the site in a Facebook IFrame.
	         * see: https://github.com/devote/HTML5-History-API/issues/34
	         * and: http://stackoverflow.com/a/12976988/669360
	         */
	        try {
	            sessionStorage = global['sessionStorage'];
	            sessionStorage.setItem(sessionStorageKey + 't', '1');
	            sessionStorage.removeItem(sessionStorageKey + 't');
	        } catch(_e_) {
	            sessionStorage = {
	                getItem: function(key) {
	                    var cookie = document.cookie.split(key + "=");
	                    return cookie.length > 1 && cookie.pop().split(";").shift() || 'null';
	                },
	                setItem: function(key, value) {
	                    var state = {};
	                    // insert one current element to cookie
	                    if (state[windowLocation.href] = historyObject.state) {
	                        document.cookie = key + '=' + JSON.stringify(state);
	                    }
	                }
	            }
	        }

	        try {
	            // get cache from the storage in browser
	            stateStorage = JSON.parse(sessionStorage.getItem(sessionStorageKey)) || {};
	        } catch(_e_) {
	            stateStorage = {};
	        }

	        // hang up the event handler to event unload page
	        addEvent(eventNamePrefix + 'unload', function() {
	            // save current state's object
	            sessionStorage.setItem(sessionStorageKey, JSON.stringify(stateStorage));
	        }, false);
	    }

	    /**
	     * This method is implemented to override the built-in(native)
	     * properties in the browser, unfortunately some browsers are
	     * not allowed to override all the properties and even add.
	     * For this reason, this was written by a method that tries to
	     * do everything necessary to get the desired result.
	     *
	     * @param {Object} object The object in which will be overridden/added property
	     * @param {String} prop The property name to be overridden/added
	     * @param {Object} [descriptor] An object containing properties set/get
	     * @param {Function} [onWrapped] The function to be called when the wrapper is created
	     * @return {Object|Boolean} Returns an object on success, otherwise returns false
	     */
	    function redefineProperty(object, prop, descriptor, onWrapped) {
	        var testOnly = 0;
	        // test only if descriptor is undefined
	        if (!descriptor) {
	            descriptor = {set: emptyFunction};
	            testOnly = 1;
	        }
	        // variable will have a value of true the success of attempts to set descriptors
	        var isDefinedSetter = !descriptor.set;
	        var isDefinedGetter = !descriptor.get;
	        // for tests of attempts to set descriptors
	        var test = {configurable: true, set: function() {
	            isDefinedSetter = 1;
	        }, get: function() {
	            isDefinedGetter = 1;
	        }};

	        try {
	            // testing for the possibility of overriding/adding properties
	            defineProperty(object, prop, test);
	            // running the test
	            object[prop] = object[prop];
	            // attempt to override property using the standard method
	            defineProperty(object, prop, descriptor);
	        } catch(_e_) {
	        }

	        // If the variable 'isDefined' has a false value, it means that need to try other methods
	        if (!isDefinedSetter || !isDefinedGetter) {
	            // try to override/add the property, using deprecated functions
	            if (object.__defineGetter__) {
	                // testing for the possibility of overriding/adding properties
	                object.__defineGetter__(prop, test.get);
	                object.__defineSetter__(prop, test.set);
	                // running the test
	                object[prop] = object[prop];
	                // attempt to override property using the deprecated functions
	                descriptor.get && object.__defineGetter__(prop, descriptor.get);
	                descriptor.set && object.__defineSetter__(prop, descriptor.set);
	            }

	            // Browser refused to override the property, using the standard and deprecated methods
	            if (!isDefinedSetter || !isDefinedGetter) {
	                if (testOnly) {
	                    return false;
	                } else if (object === global) {
	                    // try override global properties
	                    try {
	                        // save original value from this property
	                        var originalValue = object[prop];
	                        // set null to built-in(native) property
	                        object[prop] = null;
	                    } catch(_e_) {
	                    }
	                    // This rule for Internet Explorer 8
	                    if ('execScript' in global) {
	                        /**
	                         * to IE8 override the global properties using
	                         * VBScript, declaring it in global scope with
	                         * the same names.
	                         */
	                        global['execScript']('Public ' + prop, 'VBScript');
	                        global['execScript']('var ' + prop + ';', 'JavaScript');
	                    } else {
	                        try {
	                            /**
	                             * This hack allows to override a property
	                             * with the set 'configurable: false', working
	                             * in the hack 'Safari' to 'Mac'
	                             */
	                            defineProperty(object, prop, {value: emptyFunction});
	                        } catch(_e_) {
	                            if (prop === 'onpopstate') {
	                                /**
	                                 * window.onpopstate fires twice in Safari 8.0.
	                                 * Block initial event on window.onpopstate
	                                 * See: https://github.com/devote/HTML5-History-API/issues/69
	                                 */
	                                addEvent('popstate', descriptor = function() {
	                                    removeEvent('popstate', descriptor, false);
	                                    var onpopstate = object.onpopstate;
	                                    // cancel initial event on attribute handler
	                                    object.onpopstate = null;
	                                    setTimeout(function() {
	                                      // restore attribute value after short time
	                                      object.onpopstate = onpopstate;
	                                    }, 1);
	                                }, false);
	                                // cancel trigger events on attributes in object the window
	                                triggerEventsInWindowAttributes = 0;
	                            }
	                        }
	                    }
	                    // set old value to new variable
	                    object[prop] = originalValue;

	                } else {
	                    // the last stage of trying to override the property
	                    try {
	                        try {
	                            // wrap the object in a new empty object
	                            var temp = Object.create(object);
	                            defineProperty(Object.getPrototypeOf(temp) === object ? temp : object, prop, descriptor);
	                            for(var key in object) {
	                                // need to bind a function to the original object
	                                if (typeof object[key] === 'function') {
	                                    temp[key] = object[key].bind(object);
	                                }
	                            }
	                            try {
	                                // to run a function that will inform about what the object was to wrapped
	                                onWrapped.call(temp, temp, object);
	                            } catch(_e_) {
	                            }
	                            object = temp;
	                        } catch(_e_) {
	                            // sometimes works override simply by assigning the prototype property of the constructor
	                            defineProperty(object.constructor.prototype, prop, descriptor);
	                        }
	                    } catch(_e_) {
	                        // all methods have failed
	                        return false;
	                    }
	                }
	            }
	        }

	        return object;
	    }

	    /**
	     * Adds the missing property in descriptor
	     *
	     * @param {Object} object An object that stores values
	     * @param {String} prop Name of the property in the object
	     * @param {Object|null} descriptor Descriptor
	     * @return {Object} Returns the generated descriptor
	     */
	    function prepareDescriptorsForObject(object, prop, descriptor) {
	        descriptor = descriptor || {};
	        // the default for the object 'location' is the standard object 'window.location'
	        object = object === locationDescriptors ? windowLocation : object;
	        // setter for object properties
	        descriptor.set = (descriptor.set || function(value) {
	            object[prop] = value;
	        });
	        // getter for object properties
	        descriptor.get = (descriptor.get || function() {
	            return object[prop];
	        });
	        return descriptor;
	    }

	    /**
	     * Wrapper for the methods 'addEventListener/attachEvent' in the context of the 'window'
	     *
	     * @param {String} event The event type for which the user is registering
	     * @param {Function} listener The method to be called when the event occurs.
	     * @param {Boolean} capture If true, capture indicates that the user wishes to initiate capture.
	     * @return void
	     */
	    function addEventListener(event, listener, capture) {
	        if (event in eventsList) {
	            // here stored the event listeners 'popstate/hashchange'
	            eventsList[event].push(listener);
	        } else {
	            // FireFox support non-standart four argument aWantsUntrusted
	            // https://github.com/devote/HTML5-History-API/issues/13
	            if (arguments.length > 3) {
	                addEvent(event, listener, capture, arguments[3]);
	            } else {
	                addEvent(event, listener, capture);
	            }
	        }
	    }

	    /**
	     * Wrapper for the methods 'removeEventListener/detachEvent' in the context of the 'window'
	     *
	     * @param {String} event The event type for which the user is registered
	     * @param {Function} listener The parameter indicates the Listener to be removed.
	     * @param {Boolean} capture Was registered as a capturing listener or not.
	     * @return void
	     */
	    function removeEventListener(event, listener, capture) {
	        var list = eventsList[event];
	        if (list) {
	            for(var i = list.length; i--;) {
	                if (list[i] === listener) {
	                    list.splice(i, 1);
	                    break;
	                }
	            }
	        } else {
	            removeEvent(event, listener, capture);
	        }
	    }

	    /**
	     * Wrapper for the methods 'dispatchEvent/fireEvent' in the context of the 'window'
	     *
	     * @param {Event|String} event Instance of Event or event type string if 'eventObject' used
	     * @param {*} [eventObject] For Internet Explorer 8 required event object on this argument
	     * @return {Boolean} If 'preventDefault' was called the value is false, else the value is true.
	     */
	    function dispatchEvent(event, eventObject) {
	        var eventType = ('' + (typeof event === "string" ? event : event.type)).replace(/^on/, '');
	        var list = eventsList[eventType];
	        if (list) {
	            // need to understand that there is one object of Event
	            eventObject = typeof event === "string" ? eventObject : event;
	            if (eventObject.target == null) {
	                // need to override some of the properties of the Event object
	                for(var props = ['target', 'currentTarget', 'srcElement', 'type']; event = props.pop();) {
	                    // use 'redefineProperty' to override the properties
	                    eventObject = redefineProperty(eventObject, event, {
	                        get: event === 'type' ? function() {
	                            return eventType;
	                        } : function() {
	                            return global;
	                        }
	                    });
	                }
	            }
	            if (triggerEventsInWindowAttributes) {
	              // run function defined in the attributes 'onpopstate/onhashchange' in the 'window' context
	              ((eventType === 'popstate' ? global.onpopstate : global.onhashchange)
	                  || emptyFunction).call(global, eventObject);
	            }
	            // run other functions that are in the list of handlers
	            for(var i = 0, len = list.length; i < len; i++) {
	                list[i].call(global, eventObject);
	            }
	            return true;
	        } else {
	            return dispatch(event, eventObject);
	        }
	    }

	    /**
	     * dispatch current state event
	     */
	    function firePopState() {
	        var o = document.createEvent ? document.createEvent('Event') : document.createEventObject();
	        if (o.initEvent) {
	            o.initEvent('popstate', false, false);
	        } else {
	            o.type = 'popstate';
	        }
	        o.state = historyObject.state;
	        // send a newly created events to be processed
	        dispatchEvent(o);
	    }

	    /**
	     * fire initial state for non-HTML5 browsers
	     */
	    function fireInitialState() {
	        if (isFireInitialState) {
	            isFireInitialState = false;
	            firePopState();
	        }
	    }

	    /**
	     * Change the data of the current history for HTML4 browsers
	     *
	     * @param {Object} state
	     * @param {string} [url]
	     * @param {Boolean} [replace]
	     * @param {string} [lastURLValue]
	     * @return void
	     */
	    function changeState(state, url, replace, lastURLValue) {
	        if (!isSupportHistoryAPI) {
	            // if not used implementation history.location
	            if (isUsedHistoryLocationFlag === 0) isUsedHistoryLocationFlag = 2;
	            // normalization url
	            var urlObject = parseURL(url, isUsedHistoryLocationFlag === 2 && ('' + url).indexOf("#") !== -1);
	            // if current url not equal new url
	            if (urlObject._relative !== parseURL()._relative) {
	                // if empty lastURLValue to skip hash change event
	                lastURL = lastURLValue;
	                if (replace) {
	                    // only replace hash, not store to history
	                    windowLocation.replace("#" + urlObject._special);
	                } else {
	                    // change hash and add new record to history
	                    windowLocation.hash = urlObject._special;
	                }
	            }
	        } else {
	            lastURL = windowLocation.href;
	        }
	        if (!isSupportStateObjectInHistory && state) {
	            stateStorage[windowLocation.href] = state;
	        }
	        isFireInitialState = false;
	    }

	    /**
	     * Event handler function changes the hash in the address bar
	     *
	     * @param {Event} event
	     * @return void
	     */
	    function onHashChange(event) {
	        // https://github.com/devote/HTML5-History-API/issues/46
	        var fireNow = lastURL;
	        // new value to lastURL
	        lastURL = windowLocation.href;
	        // if not empty fireNow, otherwise skipped the current handler event
	        if (fireNow) {
	            // if checkUrlForPopState equal current url, this means that the event was raised popstate browser
	            if (checkUrlForPopState !== windowLocation.href) {
	                // otherwise,
	                // the browser does not support popstate event or just does not run the event by changing the hash.
	                firePopState();
	            }
	            // current event object
	            event = event || global.event;

	            var oldURLObject = parseURL(fireNow, true);
	            var newURLObject = parseURL();
	            // HTML4 browser not support properties oldURL/newURL
	            if (!event.oldURL) {
	                event.oldURL = oldURLObject._href;
	                event.newURL = newURLObject._href;
	            }
	            if (oldURLObject._hash !== newURLObject._hash) {
	                // if current hash not equal previous hash
	                dispatchEvent(event);
	            }
	        }
	    }

	    /**
	     * The event handler is fully loaded document
	     *
	     * @param {*} [noScroll]
	     * @return void
	     */
	    function onLoad(noScroll) {
	        // Get rid of the events popstate when the first loading a document in the webkit browsers
	        setTimeout(function() {
	            // hang up the event handler for the built-in popstate event in the browser
	            addEvent('popstate', function(e) {
	                // set the current url, that suppress the creation of the popstate event by changing the hash
	                checkUrlForPopState = windowLocation.href;
	                // for Safari browser in OS Windows not implemented 'state' object in 'History' interface
	                // and not implemented in old HTML4 browsers
	                if (!isSupportStateObjectInHistory) {
	                    e = redefineProperty(e, 'state', {get: function() {
	                        return historyObject.state;
	                    }});
	                }
	                // send events to be processed
	                dispatchEvent(e);
	            }, false);
	        }, 0);
	        // for non-HTML5 browsers
	        if (!isSupportHistoryAPI && noScroll !== true && "location" in historyObject) {
	            // scroll window to anchor element
	            scrollToAnchorId(locationObject.hash);
	            // fire initial state for non-HTML5 browser after load page
	            fireInitialState();
	        }
	    }

	    /**
	     * Finds the closest ancestor anchor element (including the target itself).
	     *
	     * @param {HTMLElement} target The element to start scanning from.
	     * @return {HTMLElement} An element which is the closest ancestor anchor.
	     */
	    function anchorTarget(target) {
	        while (target) {
	            if (target.nodeName === 'A') return target;
	            target = target.parentNode;
	        }
	    }

	    /**
	     * Handles anchor elements with a hash fragment for non-HTML5 browsers
	     *
	     * @param {Event} e
	     */
	    function onAnchorClick(e) {
	        var event = e || global.event;
	        var target = anchorTarget(event.target || event.srcElement);
	        var defaultPrevented = "defaultPrevented" in event ? event['defaultPrevented'] : event.returnValue === false;
	        if (target && target.nodeName === "A" && !defaultPrevented) {
	            var current = parseURL();
	            var expect = parseURL(target.getAttribute("href", 2));
	            var isEqualBaseURL = current._href.split('#').shift() === expect._href.split('#').shift();
	            if (isEqualBaseURL && expect._hash) {
	                if (current._hash !== expect._hash) {
	                    locationObject.hash = expect._hash;
	                }
	                scrollToAnchorId(expect._hash);
	                if (event.preventDefault) {
	                    event.preventDefault();
	                } else {
	                    event.returnValue = false;
	                }
	            }
	        }
	    }

	    /**
	     * Scroll page to current anchor in url-hash
	     *
	     * @param hash
	     */
	    function scrollToAnchorId(hash) {
	        var target = document.getElementById(hash = (hash || '').replace(/^#/, ''));
	        if (target && target.id === hash && target.nodeName === "A") {
	            var rect = target.getBoundingClientRect();
	            global.scrollTo((documentElement.scrollLeft || 0), rect.top + (documentElement.scrollTop || 0)
	                - (documentElement.clientTop || 0));
	        }
	    }

	    /**
	     * Library initialization
	     *
	     * @return {Boolean} return true if all is well, otherwise return false value
	     */
	    function initialize() {
	        /**
	         * Get custom settings from the query string
	         */
	        var scripts = document.getElementsByTagName('script');
	        var src = (scripts[scripts.length - 1] || {}).src || '';
	        var arg = src.indexOf('?') !== -1 ? src.split('?').pop() : '';
	        arg.replace(/(\w+)(?:=([^&]*))?/g, function(a, key, value) {
	            settings[key] = (value || '').replace(/^(0|false)$/, '');
	        });

	        /**
	         * hang up the event handler to listen to the events hashchange
	         */
	        addEvent(eventNamePrefix + 'hashchange', onHashChange, false);

	        // a list of objects with pairs of descriptors/object
	        var data = [locationDescriptors, locationObject, eventsDescriptors, global, historyDescriptors, historyObject];

	        // if browser support object 'state' in interface 'History'
	        if (isSupportStateObjectInHistory) {
	            // remove state property from descriptor
	            delete historyDescriptors['state'];
	        }

	        // initializing descriptors
	        for(var i = 0; i < data.length; i += 2) {
	            for(var prop in data[i]) {
	                if (data[i].hasOwnProperty(prop)) {
	                    if (typeof data[i][prop] === 'function') {
	                        // If the descriptor is a simple function, simply just assign it an object
	                        data[i + 1][prop] = data[i][prop];
	                    } else {
	                        // prepare the descriptor the required format
	                        var descriptor = prepareDescriptorsForObject(data[i], prop, data[i][prop]);
	                        // try to set the descriptor object
	                        if (!redefineProperty(data[i + 1], prop, descriptor, function(n, o) {
	                            // is satisfied if the failed override property
	                            if (o === historyObject) {
	                                // the problem occurs in Safari on the Mac
	                                global.history = historyObject = data[i + 1] = n;
	                            }
	                        })) {
	                            // if there is no possibility override.
	                            // This browser does not support descriptors, such as IE7

	                            // remove previously hung event handlers
	                            removeEvent(eventNamePrefix + 'hashchange', onHashChange, false);

	                            // fail to initialize :(
	                            return false;
	                        }

	                        // create a repository for custom handlers onpopstate/onhashchange
	                        if (data[i + 1] === global) {
	                            eventsList[prop] = eventsList[prop.substr(2)] = [];
	                        }
	                    }
	                }
	            }
	        }

	        // check settings
	        historyObject['setup']();

	        // redirect if necessary
	        if (settings['redirect']) {
	            historyObject['redirect']();
	        }

	        // initialize
	        if (settings["init"]) {
	            // You agree that you will use window.history.location instead window.location
	            isUsedHistoryLocationFlag = 1;
	        }

	        // If browser does not support object 'state' in interface 'History'
	        if (!isSupportStateObjectInHistory && JSON) {
	            storageInitialize();
	        }

	        // track clicks on anchors
	        if (!isSupportHistoryAPI) {
	            document[addEventListenerName](eventNamePrefix + "click", onAnchorClick, false);
	        }

	        if (document.readyState === 'complete') {
	            onLoad(true);
	        } else {
	            if (!isSupportHistoryAPI && parseURL()._relative !== settings["basepath"]) {
	                isFireInitialState = true;
	            }
	            /**
	             * Need to avoid triggering events popstate the initial page load.
	             * Hang handler popstate as will be fully loaded document that
	             * would prevent triggering event onpopstate
	             */
	            addEvent(eventNamePrefix + 'load', onLoad, false);
	        }

	        // everything went well
	        return true;
	    }

	    /**
	     * Starting the library
	     */
	    if (!initialize()) {
	        // if unable to initialize descriptors
	        // therefore quite old browser and there
	        // is no sense to continue to perform
	        return;
	    }

	    /**
	     * If the property history.emulate will be true,
	     * this will be talking about what's going on
	     * emulation capabilities HTML5-History-API.
	     * Otherwise there is no emulation, ie the
	     * built-in browser capabilities.
	     *
	     * @type {boolean}
	     * @const
	     */
	    historyObject['emulate'] = !isSupportHistoryAPI;

	    /**
	     * Replace the original methods on the wrapper
	     */
	    global[addEventListenerName] = addEventListener;
	    global[removeEventListenerName] = removeEventListener;
	    global[dispatchEventName] = dispatchEvent;

	    return historyObject;
	});

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var user_name;

	__webpack_require__(3);

	__webpack_require__(9);

	__webpack_require__(4);

	window.avatarUrl = function(user, img_size) {
	  user = fetch(user);
	  return (fetch('/application').asset_host || '') + "/system/avatars/" + ((user.key.split('/')[2]) + "/" + img_size + "/" + user.avatar_file_name);
	};

	user_name = function(user, anon) {
	  user = fetch(user);
	  if (anon || !user.name || user.name.trim().length === 0) {
	    return 'Anonymous';
	  } else {
	    return user.name;
	  }
	};

	document.addEventListener("mouseover", function(e) {
	  var anonymous, filter, filters, i, icon, len, name, tooltip, user;
	  if (e.target.getAttribute('data-user') && e.target.getAttribute('data-showtooltip') === 'true') {
	    user = fetch(e.target.getAttribute('data-user'));
	    anonymous = e.target.getAttribute('data-anonymous') === 'true';
	    name = user_name(user, anonymous);
	    if (!anonymous && (filters = customization('opinion_filters'))) {
	      for (i = 0, len = filters.length; i < len; i++) {
	        filter = filters[i];
	        if (filter.pass(user) && filter.icon) {
	          if (typeof filter.icon !== 'string') {
	            icon = filter.icon(user);
	          } else {
	            icon = filter.icon;
	          }
	          name += '<span style="padding: 0 0 0 12px">' + icon + "</span>";
	        }
	      }
	    }
	    tooltip = fetch('tooltip');
	    tooltip.coords = $(e.target).offset();
	    tooltip.tip = name;
	    return save(tooltip);
	  }
	});

	document.addEventListener("mouseout", function(e) {
	  var tooltip;
	  if (e.target.getAttribute('data-user') && e.target.getAttribute('data-showtooltip') === 'true') {
	    tooltip = fetch('tooltip');
	    tooltip.coords = null;
	    return save(tooltip);
	  }
	});

	window.avatar = function(user, props) {
	  var add_initials, anonymous, attrs, current_user, ff, fontsize, id, img_size, name, ref, show_avatar, style, tag, thumbnail, use_large_image;
	  if (!user.key) {
	    if (user === ((ref = arest.cache['/current_user']) != null ? ref.user : void 0)) {
	      user = fetch(user);
	    } else if (arest.cache[user]) {
	      user = arest.cache[user];
	    } else {
	      fetch(user);
	      return SPAN(null);
	    }
	  }
	  anonymous = (props.anonymous != null) && props.anonymous;
	  id = anonymous ? "avatar-hidden" : "avatar-" + (user.key.split('/')[2]);
	  style = _.extend({}, props.style);
	  img_size = props.img_size || 'small';
	  show_avatar = !anonymous && !!user.avatar_file_name;
	  if (img_size === 'small' && (style != null ? style.width : void 0) >= 50 && !browser.is_ie9) {
	    img_size = 'large';
	  }
	  use_large_image = img_size !== 'small' && show_avatar;
	  if (use_large_image) {
	    props.src = avatarUrl(user, img_size);
	  } else if (show_avatar) {
	    props.src = avatarUrl(user, img_size);
	  } else {
	    current_user = fetch('/current_user');
	    if (current_user.user === user.key) {
	      thumbnail = current_user.b64_thumbnail;
	      if ((thumbnail != null) && img_size === 'small') {
	        props.src = thumbnail;
	      }
	    } else {
	      style.content = "''";
	    }
	  }
	  if (show_avatar) {
	    style.backgroundColor = 'white';
	  }
	  add_initials = !user.avatar_file_name;
	  if (add_initials) {
	    style.textAlign = 'center';
	  }
	  attrs = _.extend({}, props, {
	    className: "avatar " + (props.className || ''),
	    id: id,
	    'data-user': user.key,
	    'data-showtooltip': !props.hide_tooltip,
	    'data-anon': anonymous,
	    style: style
	  });
	  tag = props.src == null ? SPAN : IMG;
	  return tag(attrs, add_initials ? (name = user_name(user, anonymous), name === 'Anonymous' ? name = '?' : void 0, fontsize = style.width / 2, ff = 'monaco,Consolas,"Lucida Console",monospace', name.length === 2 ? name = "" + name[0][0] + name[1][0] : name = "" + name[0][0], SPAN({
	    style: {
	      color: 'white',
	      pointerEvents: 'none',
	      fontSize: fontsize,
	      display: 'block',
	      position: 'relative',
	      fontFamily: ff,
	      top: .3 * fontsize
	    }
	  }, name)) : void 0);
	};

	window.Avatar = ReactiveComponent({
	  displayName: 'Avatar',
	  render: function() {
	    return avatar(this.data(), this.props);
	  }
	});

	styles += ".avatar {\n  vertical-align: top;\n  background-color: transparent;\n  border: none;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border-radius: 50%;\n  background-size: cover;\n  background-color: " + default_avatar_in_histogram_color + "; \n  user-select: none; \n  -moz-user-select: none; \n  -webkit-user-select: none;\n  -ms-user-select: none;}\n  .avatar.avatar_anonymous {\n    cursor: default; \n}\n";

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(React) {var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	(function() {
	  var app, app_meta, i, len, meta, metas, style;
	  app = null;
	  metas = document.getElementsByTagName('meta');
	  app_meta = null;
	  for (i = 0, len = metas.length; i < len; i++) {
	    meta = metas[i];
	    if (meta.getAttribute('name') === 'app') {
	      app = meta.getAttribute('content');
	      app_meta = meta;
	      break;
	    }
	  }
	  if (!app) {
	    throw "Application not defined";
	  }
	  style = document.createElement('style');
	  style.type = 'text/css';
	  if (style.styleSheet) {
	    style.styleSheet.cssText = window.styles;
	  } else {
	    style.appendChild(document.createTextNode(window.styles));
	  }
	  document.body.appendChild(style);
	  switch (app) {
	    case 'franklin':
	      if (indexOf.call(document, 'ontouchend') >= 0) {
	        React.initializeTouchEvents(true);
	      }
	      return React.renderComponent(Franklin({
	        key: 'root'
	      }), document.getElementById('content'));
	    case 'product_page':
	      return React.renderComponent(Saas({
	        key: 'saas_root'
	      }), document.getElementById('content'));
	    case 'proposal_embed':
	      return React.renderComponent(ProposalEmbed({
	        key: app_meta.getAttribute('proposal')
	      }), document.getElementById('content'));
	  }
	})();

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);

	window.Footer = ReactiveComponent({
	  displayName: 'Footer',
	  render: function() {
	    return DIV({
	      style: {
	        position: 'relative',
	        zIndex: 0
	      }
	    }, customization('Footer')());
	  }
	});

	window.DefaultFooter = ReactiveComponent({
	  displayName: 'Footer',
	  render: function() {
	    var separator, subdomain;
	    subdomain = fetch('/subdomain');
	    separator = SPAN({
	      style: {
	        padding: '0 6px',
	        color: '#ccc'
	      }
	    }, '|');
	    return DIV({
	      style: {
	        position: 'relative',
	        padding: '2.5em 0 .5em 0',
	        textAlign: 'center',
	        zIndex: 0,
	        width: CONTENT_WIDTH(),
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        marginTop: 30
	      }
	    }, DIV({
	      style: {
	        color: logo_red,
	        cursor: 'pointer',
	        borderRadius: '50%',
	        display: 'inline-block',
	        padding: 10,
	        textAlign: 'center',
	        fontSize: 18
	      },
	      title: 'Back to top',
	      onClick: function() {
	        return scrollTo(0, 0);
	      }
	    }, 'Back to top', I({
	      className: 'fa fa-angle-up',
	      style: {
	        paddingLeft: 5
	      }
	    })), BR(null), TechnologyByConsiderit({
	      size: 26
	    }), DIV({
	      style: {
	        marginTop: 7,
	        maxHeight: browser.is_mobile ? 30 : void 0,
	        color: '999'
	      }
	    }, SPAN({
	      style: {
	        display: 'inline-block',
	        marginBottom: 10
	      }
	    }, A({
	      style: {
	        textDecoration: 'underline',
	        color: logo_red
	      },
	      href: "mailto:admin@consider.it"
	    }, 'Talk to us', ' at admin@consider.it')), separator, SPAN({
	      style: {
	        display: 'inline-block',
	        marginBottom: 10
	      }
	    }, A({
	      style: {
	        textDecoration: 'underline',
	        color: logo_red
	      },
	      href: "https://consider.consider.it"
	    }, 'Report bugs or share ideas')), separator, SPAN({
	      style: {
	        display: 'inline-block',
	        marginBottom: 10
	      }
	    }, A({
	      style: {
	        textDecoration: 'underline',
	        color: logo_red
	      },
	      href: "https://consider.it"
	    }, 'Create your own consider.it project')))));
	  }
	});

	__webpack_require__(10);

	window.TechnologyByConsiderit = ReactiveComponent({
	  displayName: 'TechnologyByConsiderit',
	  render: function() {
	    var base;
	    (base = this.props).size || (base.size = 20);
	    return DIV({
	      style: {
	        textAlign: 'left',
	        display: 'inline-block',
	        fontSize: this.props.size
	      }
	    }, "Technology by ", A({
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.hover = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.hover = false;
	          return save(_this.local);
	        };
	      })(this),
	      href: 'http://consider.it',
	      target: '_blank',
	      style: {
	        position: 'relative',
	        top: 6,
	        left: 3
	      }
	    }, drawLogo(this.props.size + 5, logo_red, logo_red, false, true, logo_red, (this.local.hover ? 142 : null), true)));
	  }
	});


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(14);

	__webpack_require__(4);

	window.Header = ReactiveComponent({
	  displayName: 'Header',
	  render: function() {
	    var auth, current_user, subdomain;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    auth = fetch('auth');
	    if (auth.form && auth.form !== 'edit profile') {
	      return SPAN(null);
	    }
	    return DIV(null, DIV({
	      style: {
	        position: 'relative',
	        zIndex: 2,
	        margin: '0 auto',
	        backgroundColor: 'white'
	      }
	    }, fetch('location').url === '/' ? customization('HomepageHeader')() : customization('NonHomepageHeader')(), fetch('location').url === '/about' ? DIV(null, A({
	      href: '/',
	      style: {
	        position: 'absolute',
	        display: 'inline-block',
	        zIndex: 999,
	        marginTop: 8,
	        marginLeft: 16,
	        fontWeight: 600
	      }
	    }, I({
	      className: 'fa fa-home',
	      style: {
	        fontSize: 28,
	        color: '#bbb'
	      }
	    }), SPAN({
	      style: {
	        fontSize: 15,
	        paddingLeft: 6,
	        color: '#777',
	        verticalAlign: 'text-bottom'
	      }
	    }, 'Home'))) : void 0, DIV({
	      style: {
	        backgroundColor: '#eee',
	        color: '#f00',
	        padding: '5px 20px',
	        display: this.root.server_error ? 'block' : 'none'
	      }
	    }, 'Warning: there was a server error!')));
	  }
	});

	window.DefaultHeader = ReactiveComponent({
	  displayName: 'DefaultHeader',
	  render: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    return DIV(null, subdomain.branding.masthead ? ImageHeader() : ShortHeader(), subdomain.branding.homepage_text ? DIV({
	      style: {
	        marginTop: 40,
	        width: CONTENT_WIDTH(),
	        margin: '20px auto',
	        fontSize: 18
	      },
	      dangerouslySetInnerHTML: {
	        __html: subdomain.branding.homepage_text
	      }
	    }) : void 0);
	  }
	});

	window.ImageHeader = ReactiveComponent({
	  displayName: 'ImageHeader',
	  render: function() {
	    var homepage, hsl, is_light, loc, masthead_style, subdomain;
	    subdomain = fetch('/subdomain');
	    loc = fetch('location');
	    homepage = loc.url === '/';
	    hsl = parseCssHsl(subdomain.branding.primary_color);
	    is_light = hsl.l > .75;
	    masthead_style = {
	      backgroundColor: subdomain.branding.primary_color,
	      height: 45
	    };
	    if (subdomain.branding.masthead) {
	      _.extend(masthead_style, {
	        height: 300,
	        backgroundPosition: 'center',
	        backgroundSize: 'cover',
	        backgroundImage: "url(" + subdomain.branding.masthead + ")"
	      });
	    } else {
	      throw 'ImageHeader can\'t be used without a branding masthead';
	    }
	    return DIV({
	      style: masthead_style
	    }, homepage && subdomain.external_project_url ? A({
	      href: subdomain.external_project_url,
	      style: {
	        display: 'block',
	        position: 'absolute',
	        left: 10,
	        top: 17,
	        color: !is_light ? 'white' : void 0,
	        fontSize: 18
	      }
	    }, '< project homepage') : back_to_homepage_button({
	      position: 'relative',
	      marginLeft: 20,
	      display: 'inline-block',
	      color: !is_light ? 'white' : void 0,
	      fontSize: 43,
	      visibility: homepage || !customization('has_homepage') ? 'hidden' : void 0,
	      verticalAlign: 'middle',
	      marginTop: 5
	    }), ProfileMenu());
	  }
	});

	window.ShortHeader = ReactiveComponent({
	  displayName: 'ShortHeader',
	  render: function() {
	    var homepage, hsl, is_light, loc, subdomain, text;
	    subdomain = fetch('/subdomain');
	    loc = fetch('location');
	    hsl = parseCssHsl(subdomain.branding.primary_color);
	    is_light = hsl.l > .75;
	    homepage = loc.url === '/';
	    return DIV({
	      style: {
	        backgroundColor: subdomain.branding.primary_color,
	        minHeight: 70
	      }
	    }, ProfileMenu(), DIV({
	      style: {
	        width: (homepage ? CONTENT_WIDTH() : BODY_WIDTH()) + 130,
	        margin: 'auto'
	      }
	    }, A({
	      href: '/',
	      style: {
	        display: 'inline-block',
	        color: !is_light ? 'white' : void 0,
	        fontSize: 43,
	        visibility: homepage || !customization('has_homepage') ? 'hidden' : void 0,
	        verticalAlign: 'middle',
	        marginTop: 5
	      }
	    }, '<'), subdomain.branding.logo ? A({
	      href: subdomain.external_project_url ? subdomain.external_project_url : void 0,
	      style: {
	        verticalAlign: 'middle',
	        marginLeft: 35,
	        display: 'inline-block',
	        fontSize: 0,
	        cursor: !subdomain.external_project_url ? 'default' : void 0
	      }
	    }, IMG({
	      src: subdomain.branding.logo,
	      style: {
	        height: 56
	      }
	    })) : void 0, subdomain.branding.masthead_header_text || (!subdomain.branding.logo ? subdomain.app_title : null) ? (text = subdomain.branding.masthead_header_text || subdomain.app_title, SPAN({
	      style: {
	        color: !is_light ? 'white' : void 0,
	        marginLeft: 35,
	        fontSize: 32,
	        fontWeight: 400,
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        marginTop: 5
	      }
	    }, subdomain.external_project_url && !subdomain.branding.logo ? A({
	      href: "" + subdomain.external_project_url,
	      target: '_blank'
	    }, text) : text)) : void 0));
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var AccessControlled, Permission, matchEmail, matchSomeRole, permit,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	__webpack_require__(7);

	__webpack_require__(4);

	Permission = {
	  PERMITTED: 1,
	  DISABLED: -1,
	  UNVERIFIED_EMAIL: -2,
	  NOT_LOGGED_IN: -3,
	  INSUFFICIENT_INFORMATION: -5,
	  INSUFFICIENT_PRIVILEGES: -4
	};

	permit = function(action) {
	  var comment, current_user, existing_required_info, opinion, point, proposal, required_info, subdomain;
	  current_user = fetch('/current_user');
	  switch (action) {
	    case 'create proposal':
	      subdomain = fetch('/subdomain');
	      if (!current_user.is_admin && !matchEmail(subdomain.roles.proposer)) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      break;
	    case 'update proposal':
	    case 'delete proposal':
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      proposal = fetch(arguments[1]);
	      if (!current_user.is_admin && (proposal.key === 'new_proposal' || !matchEmail(proposal.roles.editor))) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'publish opinion':
	      proposal = fetch(arguments[1]);
	      subdomain = fetch('/subdomain');
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer', 'opiner'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      required_info = _.pluck(_.where(customization('auth.user_questions'), {
	        required: true
	      }), 'tag');
	      existing_required_info = _.intersection(required_info, _.keys(current_user.tags));
	      if (existing_required_info.length !== required_info.length) {
	        return Permission.INSUFFICIENT_INFORMATION;
	      }
	      break;
	    case 'update opinion':
	      proposal = fetch(arguments[1]);
	      opinion = fetch(arguments[2]);
	      if (opinion.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'create point':
	      proposal = fetch(arguments[1]);
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer'])) {
	        if (!current_user.logged_in) {
	          return Permission.NOT_LOGGED_IN;
	        } else {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	      }
	      break;
	    case 'update point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin && point.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'delete point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin) {
	        if (point.user !== fetch('/current_user').user) {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	        if (point.includers.length > 1 || (point.includers.length === 1 && point.includers[0] !== current_user.user)) {
	          return Permission.DISABLED;
	        }
	      }
	      break;
	    case 'create comment':
	      proposal = fetch(arguments[1]);
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer', 'commenter'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'update comment':
	      comment = fetch(arguments[1]);
	      if (!current_user.is_admin && comment.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'request factcheck':
	      proposal = fetch(arguments[1]);
	      if (!proposal.assessment_enabled || !proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      break;
	    default:
	      console.error("Unrecognized action to permit: " + action);
	  }
	  return Permission.PERMITTED;
	};

	matchEmail = function(permission_list) {
	  var allowed_domain, email_or_key, i, len, ref, user;
	  user = fetch('/current_user');
	  if (indexOf.call(permission_list, '*') >= 0) {
	    return true;
	  }
	  if (ref = user.user, indexOf.call(permission_list, ref) >= 0) {
	    return true;
	  }
	  for (i = 0, len = permission_list.length; i < len; i++) {
	    email_or_key = permission_list[i];
	    if (email_or_key.indexOf('*') > -1) {
	      if (user.email) {
	        allowed_domain = email_or_key.split('@')[1];
	        if (user.email.split('@')[1] === allowed_domain) {
	          return true;
	        }
	      }
	    }
	  }
	  return false;
	};

	matchSomeRole = function(roles, accepted_roles) {
	  var i, len, role;
	  for (i = 0, len = accepted_roles.length; i < len; i++) {
	    role = accepted_roles[i];
	    if (matchEmail(roles[role])) {
	      return true;
	    }
	  }
	  return false;
	};

	window.recourse = function(permission, goal) {
	  var current_user;
	  goal = goal || 'access this page';
	  switch (permission) {
	    case Permission.INSUFFICIENT_PRIVILEGES:
	      return loadPage('/');
	    case Permission.NOT_LOGGED_IN:
	      return reset_key('auth', {
	        form: 'login',
	        goal: goal,
	        ask_questions: true
	      });
	    case Permission.UNVERIFIED_EMAIL:
	      reset_key('auth', {
	        form: 'verify email',
	        goal: goal
	      });
	      current_user = fetch('/current_user');
	      current_user.trying_to = 'send_verification_token';
	      return save(current_user);
	  }
	};

	AccessControlled = {
	  accessGranted: function() {
	    var access_attrs, current_user, local_but_not_component_unique;
	    current_user = fetch('/current_user');
	    local_but_not_component_unique = fetch("local-" + this.page.key);
	    access_attrs = ['verified', 'logged_in', 'email'];
	    if (local_but_not_component_unique._last_current_user && this.data().permission_denied) {
	      if (this._relevant_current_user_values_have_changed(access_attrs)) {
	        delete this.data().permission_denied;
	        arest.serverFetch(this.page.key);
	      }
	    }
	    if (this.data().permission_denied && this.data().permission_denied < 0) {
	      recourse(this.data().permission_denied);
	    }
	    if (this._relevant_current_user_values_have_changed(access_attrs)) {
	      local_but_not_component_unique._last_current_user = _.map(access_attrs, function(attr) {
	        return current_user[attr];
	      });
	      save(local_but_not_component_unique);
	    }
	    return !this.data().permission_denied || this.data().permission_denied > 0;
	  },
	  _relevant_current_user_values_have_changed: function(access_attrs) {
	    var current_user, el, i, idx, last_values, len, reduced_user;
	    current_user = fetch('/current_user');
	    last_values = fetch("local-" + this.page.key);
	    reduced_user = _.map(access_attrs, function(attr) {
	      return current_user[attr];
	    });
	    for (idx = i = 0, len = reduced_user.length; i < len; idx = ++i) {
	      el = reduced_user[idx];
	      if (!last_values._last_current_user || el !== last_values._last_current_user[idx]) {
	        return true;
	      }
	    }
	    return false;
	  }
	};

	window.AccessControlled = AccessControlled;

	window.permit = permit;

	window.Permission = Permission;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(4);

	__webpack_require__(3);

	window.DefaultProposalNavigation = ReactiveComponent({
	  displayName: 'ProposalNavigation',
	  render: function() {
	    var all_proposals, all_proposals_flat, c, editor, i, idx, len, mod, next_idx, next_proposal, prev_idx, prev_proposal, proposal, show_proposer_icon, subdomain, width;
	    subdomain = fetch('/subdomain');
	    show_proposer_icon = customization('show_proposer_icon', "cluster/" + this.proposal.cluster);
	    all_proposals = fetch('/proposals');
	    mod = function(n, m) {
	      return ((n % m) + m) % m;
	    };
	    next_proposal = prev_proposal = null;
	    if (all_proposals.clusters) {
	      all_proposals_flat = _.flatten((function() {
	        var i, len, ref, results;
	        ref = all_proposals.clusters;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          c = ref[i];
	          results.push(sorted_proposals(c.proposals));
	        }
	        return results;
	      })());
	      for (idx = i = 0, len = all_proposals_flat.length; i < len; idx = ++i) {
	        proposal = all_proposals_flat[idx];
	        if (proposal === this.proposal) {
	          break;
	        }
	      }
	      next_idx = mod(idx + 1, all_proposals_flat.length);
	      prev_idx = mod(idx - 1, all_proposals_flat.length);
	      next_proposal = all_proposals_flat[next_idx];
	      prev_proposal = all_proposals_flat[prev_idx];
	    }
	    return DIV({
	      style: {
	        margin: "30px auto 0 auto",
	        width: HOMEPAGE_WIDTH(),
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        position: 'absolute',
	        right: 0
	      }
	    }, next_proposal ? A({
	      style: {
	        display: 'inline-block',
	        float: 'right'
	      },
	      href: proposal_url(next_proposal),
	      'data-no-scroll': true
	    }, (t('next')) + " >") : void 0, prev_proposal ? A({
	      style: {
	        display: 'inline-block',
	        float: 'right',
	        marginRight: next_proposal ? 10 : void 0
	      },
	      href: proposal_url(prev_proposal),
	      'data-no-scroll': true
	    }, "< " + (t('prev'))) : void 0), show_proposer_icon ? (editor = proposal_editor(this.proposal), width = Math.min(GUTTER(), 120), editor ? Avatar({
	      key: editor,
	      user: editor,
	      img_size: 'original',
	      style: {
	        position: 'absolute',
	        width: width,
	        top: 36,
	        maxWidth: width - (width === 120 ? 20 : 10),
	        marginLeft: -width - (width === 120 ? 20 : 10),
	        borderRadius: 0,
	        backgroundColor: 'transparent'
	      }
	    }) : void 0) : void 0, DIV({
	      style: {
	        fontStyle: 'italic',
	        visibility: !this.proposal.cluster ? 'hidden' : void 0
	      }
	    }, permit('update proposal', this.proposal) > 0 ? INPUT({
	      ref: 'cluster',
	      name: 'cluster',
	      pattern: '^.{3,}',
	      defaultValue: this.proposal.cluster,
	      style: {
	        border: 'none',
	        outline: 'none',
	        fontStyle: 'italic',
	        fontSize: 16
	      },
	      onBlur: (function(_this) {
	        return function() {
	          _this.proposal.cluster = _this.refs.cluster.getDOMNode().value;
	          return save(_this.proposal);
	        };
	      })(this)
	    }) : this.proposal.cluster || '-'));
	  },
	  componentDidUpdate: function() {
	    return this.typeset();
	  },
	  componentDidMount: function() {
	    return this.typeset();
	  },
	  typeset: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (subdomain.name === 'RANDOM2015' && $('#proposal_name').find('.MathJax').length === 0) {
	      return MathJax.Hub.Queue(["Typeset", MathJax.Hub, "proposal_name"]);
	    }
	  }
	});

	window.ProposalNavigationWithMenu = ReactiveComponent({
	  displayName: 'ProposalNavigationWithMenu',
	  render: function() {
	    var cluster, curr_cluster, eye_style, face_size, heading_height, heading_style, hsl, index, is_light, mouth, mouth_style, next_index, next_proposal, opinion, other_proposal, proposal, proposals, subdomain, use_navigation_bar;
	    subdomain = fetch('/subdomain');
	    proposals = fetch('/proposals');
	    use_navigation_bar = this.proposal.cluster && proposals;
	    hsl = parseCssHsl(subdomain.branding.primary_color);
	    is_light = hsl.l > .75;
	    if (!use_navigation_bar) {
	      heading_style = {
	        textAlign: 'center',
	        backgroundColor: subdomain.branding.primary_color,
	        fontSize: 26,
	        padding: '4px 90px',
	        width: '100%',
	        color: is_light ? 'black' : 'white',
	        zIndex: 999,
	        position: 'relative'
	      };
	      return DIV({
	        style: heading_style
	      }, SPAN(null, this.proposal.name));
	    }
	    if (proposals.clusters) {
	      curr_cluster = _.findWhere(proposals.clusters, {
	        name: this.proposal.cluster
	      });
	    }
	    next_proposal = (function() {
	      var i, len, ref;
	      if ((curr_cluster != null ? curr_cluster.proposals.length : void 0) > 1) {
	        ref = curr_cluster.proposals;
	        for (index = i = 0, len = ref.length; i < len; index = ++i) {
	          proposal = ref[index];
	          if (this.proposal === proposal) {
	            break;
	          }
	        }
	        next_index = (index + 1) % curr_cluster.proposals.length;
	        return curr_cluster.proposals[next_index];
	      }
	    }).call(this);
	    heading_height = 50;
	    return DIV({
	      id: 'proposal_heading',
	      style: {
	        height: heading_height,
	        backgroundColor: subdomain.branding.primary_color,
	        width: '100%',
	        color: is_light ? 'black' : 'white',
	        zIndex: 999,
	        position: 'relative',
	        marginBottom: 20
	      }
	    }, customization('has_homepage') ? A({
	      href: '/',
	      style: {
	        position: 'absolute',
	        display: 'inline-block',
	        top: -8,
	        left: 12,
	        fontSize: 43
	      }
	    }, '<') : void 0, SPAN({
	      style: {
	        display: 'inline-block',
	        fontSize: 18,
	        paddingTop: 12,
	        marginLeft: 70
	      }
	    }, this.proposal.cluster), DIV({
	      style: {
	        position: 'relative',
	        display: 'inline-block',
	        textAlign: 'left',
	        backgroundColor: 'rgba(0,0,0,.1)',
	        padding: '3px 15px',
	        marginLeft: 20,
	        borderRadius: 6,
	        display: 'inline-block',
	        cursor: 'pointer'
	      },
	      onTouchEnd: ((function(_this) {
	        return function() {
	          _this.local.dropped_down = !_this.local.dropped_down;
	          return save(_this.local);
	        };
	      })(this)),
	      onMouseEnter: ((function(_this) {
	        return function() {
	          _this.local.dropped_down = true;
	          return save(_this.local);
	        };
	      })(this)),
	      onMouseLeave: ((function(_this) {
	        return function() {
	          _this.local.dropped_down = false;
	          return save(_this.local);
	        };
	      })(this))
	    }, SPAN(null, "" + (this.proposal.designator && this.proposal.category ? this.proposal.category[0] + "-" + this.proposal.designator + " " : '') + this.proposal.name, I({
	      className: 'fa fa-caret-down',
	      style: {
	        paddingLeft: 8,
	        position: 'relative',
	        top: 2
	      }
	    })), this.local.dropped_down ? DIV({
	      style: {
	        width: 500,
	        position: 'absolute',
	        paddingTop: 5
	      }
	    }, DIV({
	      style: {
	        backgroundColor: subdomain.branding.primary_color,
	        borderRadius: '4px'
	      }
	    }, DIV({
	      style: {
	        backgroundColor: 'rgba(0,0,0,.2)',
	        padding: '14px 0',
	        borderRadius: '4px'
	      }
	    }, (curr_cluster != null ? curr_cluster.proposals.length : void 0) > 1 ? DIV(null, TABLE({
	      className: 'current_cluster',
	      style: {
	        width: '100%'
	      }
	    }, TBODY(null, (function() {
	      var i, len, ref, results;
	      ref = curr_cluster.proposals;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        other_proposal = ref[i];
	        results.push(TR({
	          onClick: (function(_this) {
	            return function(other_proposal) {
	              return function() {
	                return loadPage(proposal_url(other_proposal));
	              };
	            };
	          })(this)(other_proposal),
	          key: "tr/" + other_proposal.slug
	        }, TD({
	          style: {
	            textAlign: 'left',
	            paddingLeft: 20
	          }
	        }, A({
	          href: proposal_url(other_proposal),
	          style: {
	            color: 'white',
	            fontWeight: other_proposal.key === this.proposal.key ? 700 : 400,
	            fontSize: 18
	          }
	        }, other_proposal.name)), TD({
	          style: {
	            position: 'relative'
	          }
	        }, !other_proposal.your_opinion || !fetch(other_proposal.your_opinion).published ? SPAN({
	          style: {
	            fontWeight: 400,
	            color: 'rgb(205,205,205)',
	            fontSize: 21
	          }
	        }, '?') : (opinion = fetch(other_proposal.your_opinion), face_size = 20, eye_style = {
	          width: 2,
	          height: 2,
	          borderRadius: '50%',
	          backgroundColor: subdomain.branding.primary_color,
	          position: 'absolute',
	          top: 6
	        }, mouth_style = {
	          fontSize: 12,
	          color: subdomain.branding.primary_color,
	          left: face_size * .45,
	          top: face_size * .28,
	          position: 'absolute',
	          transform: 'rotate(90deg)'
	        }, css.crossbrowserify(mouth_style), isNeutralOpinion(fetch(other_proposal.your_opinion).stance) ? mouth = '|' : opinion.stance < 0 ? mouth = '(' : mouth = ')', DIV({
	          style: {
	            borderBottom: "1px solid white",
	            width: 100,
	            position: 'relative',
	            top: 15
	          }
	        }, DIV({
	          style: {
	            borderRadius: '50%',
	            backgroundColor: 'white',
	            width: face_size,
	            height: face_size,
	            position: 'absolute',
	            top: -face_size / 2,
	            marginLeft: -face_size / 2,
	            left: (100 * (opinion.stance + 1.0) / 2.0) + "%"
	          }
	        }, DIV({
	          style: _.extend({}, eye_style, {
	            left: 6
	          })
	        }), DIV({
	          style: _.extend({}, eye_style, {
	            left: face_size - 8
	          })
	        }), DIV({
	          style: mouth_style
	        }, mouth))))), TD({
	          style: {
	            paddingRight: 20
	          }
	        })));
	      }
	      return results;
	    }).call(this))), DIV({
	      className: 'separator',
	      style: {
	        borderBottom: '1px dotted #dedede',
	        width: '85%',
	        margin: '28px auto 12px auto'
	      }
	    })) : void 0, DIV({
	      className: 'other_clusters'
	    }, (function() {
	      var i, len, ref, results;
	      ref = proposals.clusters;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        cluster = ref[i];
	        if (this.proposal.cluster !== cluster.name && cluster.proposals.length > 0) {
	          results.push((function(_this) {
	            return function(cluster) {
	              return DIV({
	                className: 'another_cluster',
	                key: cluster,
	                onMouseEnter: function() {
	                  _this.local.show_cluster = cluster.name;
	                  return save(_this.local);
	                },
	                onMouseLeave: function() {
	                  return _this.mouseLeaveOtherCluster(cluster.name);
	                },
	                style: {
	                  padding: '0 50px',
	                  width: '100%',
	                  position: 'relative'
	                }
	              }, SPAN({
	                style: {
	                  float: 'left',
	                  fontSize: 18,
	                  fontWeight: 400
	                }
	              }, cluster.name), I({
	                className: 'fa fa-caret-right',
	                style: {
	                  float: 'right'
	                }
	              }), DIV({
	                style: {
	                  clear: 'both'
	                }
	              }), _this.local.show_cluster === cluster.name ? DIV({
	                style: {
	                  width: 300,
	                  zIndex: 99999,
	                  backgroundColor: subdomain.branding.primary_color,
	                  borderRadius: '4px',
	                  position: 'absolute',
	                  left: 458,
	                  top: -12
	                }
	              }, UL({
	                className: 'other_proposal_list',
	                style: {
	                  backgroundColor: 'rgba(0,0,0,.2)',
	                  borderRadius: '4px',
	                  padding: '8px 0'
	                }
	              }, (function() {
	                var j, len1, ref1, results1;
	                ref1 = cluster.proposals;
	                results1 = [];
	                for (j = 0, len1 = ref1.length; j < len1; j++) {
	                  other_proposal = ref1[j];
	                  results1.push(LI({
	                    style: {
	                      listStyle: 'none'
	                    },
	                    key: "li/" + other_proposal.slug
	                  }, A({
	                    href: proposal_url(other_proposal),
	                    style: {
	                      display: 'block',
	                      textAlign: 'left',
	                      padding: '2px 10px',
	                      color: 'white',
	                      fontSize: 18,
	                      fontWeight: 400
	                    }
	                  }, other_proposal.name)));
	                }
	                return results1;
	              })())) : void 0);
	            };
	          })(this)(cluster));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this))))) : void 0));
	  },
	  mouseLeaveOtherCluster: function(cluster) {
	    if (this.local.show_cluster === cluster) {
	      this.local.show_cluster = null;
	      return save(this.local);
	    }
	  }
	});

	styles += ".current_cluster tr:hover, .other_proposal_list li:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n  cursor: pointer; }";

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var fn, i, len, lvar, ref, responsive, setResponsive;

	__webpack_require__(5);

	setResponsive = function() {
	  var body_width, content_width, decision_board_width, document_width, gutter, h, homepage_width, k, new_vals, point_font_size, point_width, portrait, proposal_histo_width, reasons_region_width, responsive, results, two_col, v, w, whitespace;
	  responsive = fetch('responsive_vars');
	  w = window.innerWidth;
	  h = window.innerHeight;
	  portrait = h > w;
	  two_col = w < 1080 || browser.is_mobile;
	  document_width = Math.max(900, w);
	  gutter = Math.max(80, w / 10);
	  content_width = document_width - 2 * gutter;
	  whitespace = Math.max(100, w / 10);
	  body_width = two_col ? content_width - 2 * gutter : content_width - 2 * gutter - 2 * whitespace;
	  body_width = Math.min(body_width, 700);
	  proposal_histo_width = 60 * Math.floor(body_width / 60);
	  decision_board_width = body_width + 4;
	  point_width = two_col ? body_width / 2 - 38 : decision_board_width / 2 - 30;
	  reasons_region_width = !two_col ? decision_board_width + 2 * point_width + 76 : decision_board_width;
	  point_font_size = point_width > 250 ? 15 : 14;
	  homepage_width = Math.min(content_width, 900);
	  homepage_width = 60 * Math.floor(homepage_width / 60);
	  if (browser.is_mobile && portrait) {
	    point_font_size += 4;
	  }
	  new_vals = {
	    DOCUMENT_WIDTH: document_width,
	    WINDOW_WIDTH: w,
	    GUTTER: gutter,
	    WHITESPACE: whitespace,
	    BODY_WIDTH: body_width,
	    PROPOSAL_HISTO_WIDTH: proposal_histo_width,
	    DECISION_BOARD_WIDTH: decision_board_width,
	    POINT_WIDTH: point_width,
	    REASONS_REGION_WIDTH: reasons_region_width,
	    POINT_FONT_SIZE: point_font_size,
	    AUTH_WIDTH: browser.is_mobile ? content_width : Math.max(decision_board_width, 544),
	    TWO_COL: two_col,
	    SLIDER_HANDLE_SIZE: two_col ? 65 : 25,
	    CONTENT_WIDTH: content_width,
	    PORTRAIT_MOBILE: portrait && browser.is_mobile,
	    LANDSCAPE_MOBILE: !portrait && browser.is_mobile,
	    HOMEPAGE_WIDTH: homepage_width
	  };
	  results = [];
	  for (k in new_vals) {
	    v = new_vals[k];
	    if (responsive[k] !== v) {
	      _.extend(responsive, new_vals);
	      save(responsive);
	      break;
	    } else {
	      results.push(void 0);
	    }
	  }
	  return results;
	};

	setResponsive();

	$(window).on("resize.responsive_vars", setResponsive);

	responsive = fetch('responsive_vars');

	ref = _.keys(responsive);
	fn = function(lvar) {
	  return window[lvar] = function() {
	    return fetch('responsive_vars')[lvar];
	  };
	};
	for (i = 0, len = ref.length; i < len; i++) {
	  lvar = ref[i];
	  fn(lvar);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var dict;

	__webpack_require__(4);

	window.t = function(label, args) {
	  var dictionary, lang;
	  lang = customization('lang');
	  if (dict[lang] == null) {
	    throw "Sorry, don't support language " + lang;
	  }
	  dictionary = dict[lang];
	  label = label.replace(/\ /g, '_').toLowerCase();
	  if (dictionary[label] == null) {
	    throw "Can't translate " + label + " for language " + lang;
	  }
	  if (typeof dictionary[label] === 'function') {
	    return dictionary[label](args);
	  } else {
	    return dictionary[label];
	  }
	};

	dict = {};

	dict.en = {
	  or: 'or',
	  and: 'and',
	  done: 'Done',
	  cancel: 'cancel',
	  edit: 'edit',
	  share: 'share',
	  "delete": 'delete',
	  close: 'close',
	  update: 'Update',
	  publish: 'Publish',
	  closed: 'closed',
	  add_new: 'add new'
	};

	dict.spa = {
	  or: 'ó',
	  and: 'y',
	  done: 'Hecho',
	  cancel: 'cancelar',
	  edit: 'editar',
	  share: 'compartir',
	  "delete": 'eliminar',
	  close: 'cerrar',
	  update: 'Actualizar',
	  publish: 'Publicar',
	  closed: 'cerrado',
	  add_new: 'crear nueva'
	};

	dict.ptbr = {
	  or: 'ou',
	  and: 'e',
	  done: 'Pronto',
	  cancel: 'cancelar',
	  edit: 'editar',
	  share: 'compartilhar',
	  "delete": 'apagar',
	  close: 'fechar',
	  update: 'Atualizar',
	  publish: 'Publicar',
	  closed: 'fechado',
	  add_new: 'criar novo'
	};

	dict.tun_ar = {
	  or: 'أو',
	  and: 'و',
	  done: 'منجز',
	  cancel: 'إلغاء',
	  edit: 'تعديل',
	  share: 'أنقل',
	  "delete": 'إحذف',
	  close: 'أغلق',
	  update: 'حدّث',
	  publish: 'أنشر',
	  closed: 'مغلق',
	  add_new: 'إضافة جديدة'
	};

	_.extend(dict.en, {
	  give_your_opinion: 'Give your Opinion',
	  update_your_opinion: 'Update your Opinion',
	  comment: 'comment',
	  comments: 'comments',
	  read_more: 'read more',
	  select_these_opinions: 'Select these opinions',
	  prev: 'prev',
	  next: 'next',
	  drag_from_left: function(args) {
	    return "Drag a " + args.noun + " from the left";
	  },
	  drag_from_right: function(args) {
	    return "Drag a " + args.noun + " from the right";
	  },
	  write_a_new_point: function(args) {
	    return "Write a new " + args.noun;
	  },
	  slide_your_overall_opinion: 'Slide Your Overall Opinion',
	  your_opinion: "Your opinion",
	  save_your_opinion: 'Save your opinion',
	  return_to_results: 'Return to results',
	  skip_to_results: 'or just skip to the results',
	  login_to_comment: 'Log in to write a comment',
	  login_to_add_new: 'Log in to add new',
	  login_to_save_opinion: 'Log in to save your opinion',
	  discuss_this_point: 'Discuss this Point',
	  save_comment: 'Save comment',
	  write_a_comment: 'Write a comment',
	  write_a_point: 'Write a point',
	  summary_placeholder: 'A succinct summary of your point.',
	  description_placeholder: 'Add background or evidence.',
	  sign_name: 'Sign your name',
	  tip_single: function(args) {
	    return "Make one single point. Add multiple " + args.noun + " if you have more.";
	  },
	  tip_direct: "Be direct. The summary is your main point.",
	  tip_review: "Review your language. Don’t be careless.",
	  tip_attacks: "No personal attacks.",
	  filter_to_watched: "Filter proposals to those you're watching"
	});

	_.extend(dict.spa, {
	  give_your_opinion: 'Deja tu Opinion',
	  update_your_opinion: 'Actualizar tu Opinion',
	  comment: 'comentario',
	  comments: 'comentarios',
	  read_more: 'ver más',
	  select_these_opinions: 'Selecciona estas opiniones',
	  prev: 'anterior',
	  next: 'siguiente',
	  drag_from_left: function(args) {
	    return "Arrastra un " + args.noun + " de la izquierda";
	  },
	  drag_from_right: function(args) {
	    return "Arrastra un " + args.noun + " de la derecha";
	  },
	  write_a_new_point: function(args) {
	    return "Escribe un nuevo " + args.noun;
	  },
	  slide_your_overall_opinion: 'Desliza Tu Opinión General',
	  your_opinion: "Tu opinión",
	  save_your_opinion: 'Guarda tu opinión',
	  return_to_results: 'Volver a los resultados',
	  skip_to_results: 'o ir directamente a los resultados',
	  login_to_comment: 'Inicia sesión para comentar',
	  login_to_add_new: 'Inicia sesión para crear nueva',
	  login_to_save_opinion: 'Inicia sesión para guarda tu opinión',
	  discuss_this_point: 'Debatir este Punto',
	  save_comment: 'Guardar comentario',
	  write_a_comment: 'Escribir comentario',
	  write_a_point: 'Escribir un punto de vista',
	  summary_placeholder: 'Un breve resumen de tu punto de vista.',
	  description_placeholder: 'Añadir antecedentes o pruebas',
	  sign_name: 'Firmar con tu nombre',
	  tip_single: function(args) {
	    return "Escribe una única opinión. Añade multiples " + args.noun + " si tienes más.";
	  },
	  tip_direct: "Se directo. El resumen será tu punto de vista principal.",
	  tip_review: "Revisa tu lenguaje. No seas descuidado.",
	  tip_attacks: "No ataques personales.",
	  filter_to_watched: "Filtrar propuestas por las que estás observando"
	});

	_.extend(dict.ptbr, {
	  give_your_opinion: 'Dê sua opinião',
	  update_your_opinion: 'Atualizar sua opinião',
	  comment: 'comentar',
	  comments: 'comentários',
	  read_more: 'leia mais',
	  select_these_opinions: 'Selecione estas opiniões',
	  prev: 'ant',
	  next: 'prox',
	  drag_from_left: function(args) {
	    return "Arrastar uma " + args.noun + " da esquerda";
	  },
	  drag_from_right: function(args) {
	    return "Arrastar uma " + args.noun + " da direita";
	  },
	  write_a_new_point: function(args) {
	    return "Escrever uma nova " + args.noun;
	  },
	  slide_your_overall_opinion: 'Deslize e defina sua Opinião Geral',
	  your_opinion: "Sua opinião",
	  save_your_opinion: 'Salvar sua opinião',
	  return_to_results: 'Voltar para os resultados',
	  skip_to_results: 'ou vá direto para os resultados',
	  login_to_comment: 'Conecte-se para comentar',
	  login_to_add_new: 'Conecte-se para adicionar um novo',
	  login_to_save_opinion: 'Conecte-se para salvar sua opinião',
	  discuss_this_point: 'Discutir este Ponto',
	  save_comment: 'Salvar comentário',
	  write_a_comment: 'Escrever um comentário',
	  write_a_point: 'Escrever um ponto de vista',
	  summary_placeholder: 'Um breve resumo do seu Ponto de Vista.',
	  description_placeholder: 'Inclua seus argumentos e evidências.',
	  sign_name: 'Assinar',
	  tip_single: function(args) {
	    return "Escreve seu ponto de vista. Inclua multiplos " + args.noun + " se tiver mais.";
	  },
	  tip_direct: "Seja direto. O resumo é seu ponto de vista principal.",
	  tip_review: "Reveja sua linguagem. Não seja desleixado(a).",
	  tip_attacks: "Não faça ataques pessoais.",
	  filter_to_watched: "Filtrar propostas daqueles que está observando"
	});

	_.extend(dict.tun_ar, {
	  give_your_opinion: 'أبد رأيك',
	  update_your_opinion: 'بد رأيك من جديد',
	  comment: 'علّق',
	  comments: 'تعليقات',
	  read_more: 'اقرأ المزيد',
	  select_these_opinions: 'اختر هذه الآراء',
	  prev: 'السابق',
	  next: 'اللاحق',
	  drag_from_left: function(args) {
	    return "من اليسار " + args.noun + " اسحب";
	  },
	  drag_from_right: function(args) {
	    return "من اليمين " + args.noun + "اسحب";
	  },
	  write_a_new_point: function(args) {
	    return "(ة) جديد " + args.noun + "اكتب";
	  },
	  slide_your_overall_opinion: 'حدّد رأيك العامّ',
	  your_opinion: "رأيك",
	  save_your_opinion: 'احفظ رأيك',
	  return_to_results: 'العودة إلى النتائج',
	  skip_to_results: 'أو مر مباشرة إلى النتائج',
	  login_to_comment: 'سجّل لكتابة تعليق',
	  login_to_add_new: 'سجّل لإضافة الجديد',
	  login_to_save_opinion: 'سجل لحفظ رأيك',
	  discuss_this_point: 'ناقش هذه النقطة',
	  save_comment: 'احفظ التعليق',
	  write_a_comment: 'اكتب تعليق',
	  write_a_point: 'اكتب وجهة نظر',
	  summary_placeholder: 'تلخيص موجز لوجهة نظرك',
	  description_placeholder: '.أضف خلفيّات أو دلائل/ اثباتات',
	  sign_name: 'أدخل اسمك',
	  tip_single: function(args) {
	    return "أبد وجهة نظر واحدة. أضف إن كان لديك المزيد.";
	  },
	  tip_direct: "كن موجزا. الملخص هو وجهة نظرك الرئيسية",
	  tip_review: "راجع لغتك. لا تكن مهملا.",
	  tip_attacks: "الهجوم الشخصي ممنوع",
	  filter_to_watched: "إفرز مقترحات من تتابعهم."
	});

	_.extend(dict.en, {
	  create_new_proposal: 'Create new proposal',
	  error_free: "free of language errors",
	  unambiguous: 'unambiguous',
	  make_it: 'Make it',
	  url_instr: "Just letters, numbers, underscores, dashes.",
	  summary: 'Summary',
	  proposal_summary_instr: 'Aim for 3-8 words with a verb and noun.',
	  details: 'Details',
	  label: 'Label',
	  expandable_body_instr: 'Text that is shown when expanded',
	  add_expandable: "Add expandable description section",
	  category: 'Category',
	  optional: 'optional',
	  show_on_homepage: 'List on homepage?',
	  open_for_discussion: 'Open for discussion?',
	  permissions_and_invites: 'Permissions and invitations'
	});

	_.extend(dict.spa, {
	  create_new_proposal: 'Crear nueva propuesta',
	  error_free: "libre de errores ortográficos",
	  unambiguous: 'sin ambiguedades',
	  make_it: 'Hazlo',
	  url_instr: "Solo letras, numeros, subrayados, guiones.",
	  summary: 'Resumen',
	  proposal_summary_instr: 'Que sean 3-8 palabras con un verbo y un sustantivo.',
	  details: 'Detalles',
	  label: 'Etiqueta',
	  expandable_body_instr: 'Texto mostrado al expandir',
	  add_expandable: "Añadir una sección de descripción expandible",
	  category: 'Categoría',
	  optional: 'opcional',
	  show_on_homepage: '¿Mostrar en portada?',
	  open_for_discussion: '¿Abierta a debate?',
	  permissions_and_invites: 'Permisos e invitaciones'
	});

	_.extend(dict.ptbr, {
	  create_new_proposal: 'Criar nova proposta',
	  error_free: "livre de erros ortográficos",
	  unambiguous: 'sem ambiguidades',
	  make_it: 'Faça',
	  url_instr: "Apenas letras, números, underscores e traços.",
	  summary: 'Sumário',
	  proposal_summary_instr: 'Entre 3-8 palavras com um verbo e um substantivo.',
	  details: 'Detalhes',
	  label: 'Rótulo',
	  expandable_body_instr: 'Texto exibido quando expandido',
	  add_expandable: "Adicionar uma seção de descrição expandida",
	  category: 'Categoria',
	  optional: 'opcional',
	  show_on_homepage: 'Exibir na página inicial?',
	  open_for_discussion: 'Abrir para discussão?',
	  permissions_and_invites: 'Permissões e convites'
	});

	_.extend(dict.tun_ar, {
	  create_new_proposal: 'إحدث مقترح جديد',
	  error_free: "خال من الأخطاء اللغويّة",
	  unambiguous: 'خال من الغموض',
	  make_it: 'أنجز',
	  url_instr: "مجرّد حروف وأرقام وأشرطة سفلية ومطّات",
	  summary: 'ملخص',
	  proposal_summary_instr: 'اهدف إلي 3-8 كلمات من بينها فعل واسم',
	  details: 'تفاصيل',
	  label: ' مسمّى',
	  expandable_body_instr: 'النص الذي يظهر عند التوسيع',
	  add_expandable: "أضف قسم مخصّص للوصف القابل للتوسيع",
	  category: 'فئة',
	  optional: 'اختياري',
	  show_on_homepage: 'أدرج على الصفحة الرئيسية؟',
	  open_for_discussion: 'إفتح للمناقشة؟',
	  permissions_and_invites: 'رخص ودعوات'
	});

	_.extend(dict.en, {
	  log_in: 'Log in',
	  create_new_account: 'Create new account',
	  log_out: 'Log out',
	  edit_profile: 'Edit Profile',
	  email_settings: 'Email Settings',
	  introduce_yourself: 'Introduce Yourself',
	  complete_registration: 'Complete registration',
	  login_as: 'Hi, I log in as',
	  password: 'password',
	  name_prompt: 'My name is',
	  full_name: function(args) {
	    var ref, subdomain;
	    subdomain = fetch('/subdomain');
	    if ((ref = subdomain.name) === 'bitcoin' || ref === 'bitcoinclassic') {
	      return 'user name or company name';
	    } else {
	      return 'first and last name';
	    }
	  },
	  pic_prompt: 'I look like',
	  your_profile: 'Your Profile',
	  updated_successfully: "Updated successfully",
	  reset_your_password: "Reset Your Password",
	  code: 'Code',
	  new_password: 'New password',
	  verification_sent: 'We sent you a verification code via email. Copy / paste it below.',
	  verify: 'Verify',
	  choose_password: "choose a new password",
	  code_from_email: 'verification code from email',
	  verify_your_email: 'Verify Your Email',
	  more_info: 'Please give some info',
	  forgot_password: 'I forgot my password!'
	});

	_.extend(dict.spa, {
	  log_in: 'Entrar',
	  create_new_account: 'Registrarse',
	  log_out: 'Salir',
	  edit_profile: 'Editar Perfil',
	  email_settings: 'Configuración de Email',
	  introduce_yourself: 'Descríbete',
	  complete_registration: 'Completar registro',
	  login_as: 'Hola, inicio sesión como',
	  password: 'contraseña',
	  name_prompt: 'Mi nombre es',
	  full_name: 'nombre completo',
	  pic_prompt: 'mi foto',
	  your_profile: 'Tu Perfil',
	  updated_successfully: "Actualizado correctamente",
	  reset_your_password: "Reestablecer Contraseña",
	  code: 'Codigo',
	  new_password: 'Nueva contraseña',
	  verification_sent: 'Te hemos enviado un código de verificación via email.',
	  verify: 'Verificar',
	  choose_password: "elige una nueva contraseña",
	  code_from_email: 'código de verificación recibido',
	  verify_your_email: 'Verifica Tu Email',
	  more_info: 'Por favor, proporciona alguna información',
	  forgot_password: '¡He olvidado mi contraseña!'
	});

	_.extend(dict.ptbr, {
	  log_in: 'Entrar',
	  create_new_account: 'Criar nova conta',
	  log_out: 'Sair',
	  edit_profile: 'Editar Perfil',
	  email_settings: 'Configurações de Email',
	  introduce_yourself: 'Identifique-se',
	  complete_registration: 'Completar registro',
	  login_as: 'Logar como',
	  password: 'senha',
	  name_prompt: 'Meu nome é',
	  full_name: function(args) {
	    var ref, subdomain;
	    subdomain = fetch('/subdomain');
	    if ((ref = subdomain.name) === 'bitcoin' || ref === 'bitcoinclassic') {
	      return 'nome de usuário ou nome da empresa';
	    } else {
	      return 'nome e sobrenome';
	    }
	  },
	  pic_prompt: 'Minha foto',
	  your_profile: 'Seu Perfil',
	  updated_successfully: "Atualizado com sucesso",
	  reset_your_password: "Criar nova senha",
	  code: 'Código',
	  new_password: 'Nova senha',
	  verification_sent: 'Enviamos um código de verificação para o seu email.',
	  verify: 'Verificar',
	  choose_password: "escolher uma nova senha",
	  code_from_email: 'código de verificação do email',
	  verify_your_email: 'Verifique seu Email',
	  more_info: 'Por favor, forneça algumas informações',
	  forgot_password: 'Esqueci minha senha!'
	});

	_.extend(dict.tun_ar, {
	  log_in: 'سجّل للخول',
	  create_new_account: 'إنشاء حساب جديد',
	  log_out: 'خروج',
	  edit_profile: 'تعديل البيانات الشخصية',
	  email_settings: 'إعدادات البريد الإلكتروني',
	  introduce_yourself: 'عرف بنفسك',
	  complete_registration: 'اكمل التسجيل',
	  login_as: 'مرحبا،أسجّل الدخول باسم',
	  password: 'كلمه السر',
	  name_prompt: 'اسمي',
	  full_name: 'إسم المستخدم',
	  pic_prompt: 'أنا أشبه',
	  your_profile: 'بياناتك الشخصية',
	  updated_successfully: "تم التحديث بنجاح",
	  reset_your_password: "إعادة تعيين كلمة السر",
	  code: '  رمز',
	  new_password: ' كلمة السر الجديدة',
	  verification_sent: 'لقد أرسلنا إليك رمز التحقق عبر البريد الإلكتروني. انسخ /ألصق أدناه.',
	  verify: 'تحقّق',
	  choose_password: "اختر كلمة سر جديدة",
	  code_from_email: 'رمز التحقق من البريد الإلكتروني',
	  verify_your_email: ' تحقق من البريد الإلكتروني الخاص بك',
	  more_info: 'الرجاء إعطاء بعض المعلومات',
	  forgot_password: 'لقد نسيت كلمة السر الخاصة بي'
	});

	_.extend(dict.en, {
	  send_email: 'Send me email digests',
	  email_digest_purpose: function(args) {
	    return "The digests summarize relevant new activity for you regarding " + args.project;
	  },
	  digest_timing: "Send summaries at most",
	  daily: 'daily',
	  hourly: 'hourly',
	  weekly: 'weekly',
	  monthly: 'monthly',
	  notable_events: "Emails are only sent if a notable event occurred. Which events are notable to you?",
	  watched_proposals: 'The proposals you are watching for new activity:',
	  unwatch: "Unwatch this proposal",
	  hide_notifications: 'Hide notifications',
	  show_notifications: 'Show notifications',
	  commented_on: "commented on",
	  your_point: 'your point',
	  edited_proposal: 'edited this proposal',
	  added_new_point: 'added a new point',
	  added_opinion: 'added their opinion'
	});

	_.extend(dict.spa, {
	  send_email: 'Envíame resúmenes por correo electrónico',
	  email_digest_purpose: function(args) {
	    return "Los resumenes proporcionan información de actividad sobre " + args.project;
	  },
	  digest_timing: "Envíame resúmenes como máximo",
	  daily: 'diariamente',
	  hourly: 'cada hora',
	  weekly: 'semanalmente',
	  monthly: 'mensualmente',
	  notable_events: "Los Emails únicamente se envían si ocurre algo importante. ¿Qué eventos son importantes para tí?",
	  watched_proposals: 'Las propuestas que estás observando:',
	  unwatch: "Dejar de seguir esta propuesta",
	  hide_notifications: 'Ocultar notificaciones',
	  show_notifications: 'Mostrar notificaciones',
	  commented_on: "comentado",
	  your_point: 'tu punto de vista',
	  edited_proposal: 'ha editado esta propuesta',
	  added_new_point: 'ha añadido un nuevo punto de vista',
	  added_opinion: 'ha añadido su opinión'
	});

	_.extend(dict.ptbr, {
	  send_email: 'Me envie notificações por email',
	  email_digest_purpose: function(args) {
	    return "As notificações resumem novas atividades sobre " + args.project;
	  },
	  digest_timing: "Envie resumos",
	  daily: 'diários',
	  hourly: 'por hora',
	  weekly: 'semanais',
	  monthly: 'mensais',
	  notable_events: "Emails só serão enviados para avisar eventos importantes. Quais eventos são importantes para você?",
	  watched_proposals: 'As propostas que você está seguindo:',
	  unwatch: "Deixar de seguir esta proposta",
	  hide_notifications: 'Ocultar notificações',
	  show_notifications: 'Mostrar notificações',
	  commented_on: "comentado em",
	  your_point: 'seu ponto de vista',
	  edited_proposal: 'editou esta proposta',
	  added_new_point: 'adicionou novo ponto de vista',
	  added_opinion: 'adicionou sua opinião'
	});

	_.extend(dict.tun_ar, {
	  send_email: 'أرسل لي ملخصات البريد الإلكتروني',
	  email_digest_purpose: function(args) {
	    return args.project + " ترصد الملخّصات الأنشطة الجديدة ذات الجدوى بالنسبة لك نظرا ل";
	  },
	  digest_timing: "أرسل الملخّص كل",
	  daily: 'يوم',
	  hourly: 'ساعة',
	  weekly: 'أسبوع',
	  monthly: 'شهر',
	  notable_events: "يتم إرسال رسائل البريد الإلكتروني إلا إذا وقع حدث بارز.  أي حدث يتمّ اعتباره بارزا بالنسبة لك؟",
	  watched_proposals: 'الاقتراحات التي تشاهدها لهذا النشاط الجديد',
	  unwatch: "عدم مشاهدة هذا الاقتراح",
	  hide_notifications: 'أخف التنبيهات',
	  show_notifications: 'اكشف التنبيهات',
	  commented_on: "علّق على",
	  your_point: 'وجهة نظرك',
	  edited_proposal: 'عدل هذا الاقتراح',
	  added_new_point: 'أضف وجهة نظر أخرى',
	  added_opinion: 'أضافوا أراءهم'
	});

	_.defaults(dict.spa, dict.en);

	_.defaults(dict.ptbr, dict.en);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var AdminTaskList, AppSettingsDash, DashHeader, DirectMessage, EditClaim, FactcheckDash, FactcheckPoint, ImportDataDash, ModerateItem, ModerationDash, adminStyles;

	__webpack_require__(20);

	__webpack_require__(16);

	__webpack_require__(3);

	adminStyles = function() {
	  return {
	    task_area_header_style: {
	      fontSize: 24,
	      fontWeight: 400,
	      margin: '10px 0'
	    },
	    task_area_bar: {
	      padding: '4px 30px',
	      fontSize: 24,
	      borderRadius: '8px 8px 0 0',
	      height: 35,
	      backgroundColor: 'rgba(0,0,55,.1)'
	    },
	    task_area_section_style: {
	      margin: '10px 0px 20px 0px',
	      position: 'relative'
	    },
	    task_area_style: {
	      cursor: 'auto',
	      width: CONTENT_WIDTH() * .75,
	      minWidth: 700,
	      backgroundColor: '#F4F0E9',
	      position: 'absolute',
	      left: CONTENT_WIDTH() / 4,
	      top: -35,
	      borderRadius: 8
	    }
	  };
	};

	DashHeader = ReactiveComponent({
	  displayName: 'DashHeader',
	  render: function() {
	    var doc, subdomain;
	    doc = fetch('document');
	    if (doc.title !== this.props.name) {
	      doc.title = this.props.name;
	      save(doc);
	    }
	    subdomain = fetch('/subdomain');
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        width: BODY_WIDTH(),
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, H1({
	      style: {
	        fontSize: 28,
	        padding: '20px 0',
	        fontWeight: 400
	      }
	    }, this.props.name)));
	  }
	});

	ImportDataDash = ReactiveComponent({
	  displayName: 'ImportDataDash',
	  render: function() {
	    var current_user, error, subdomain, success, table, tables;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    if (subdomain.name === 'livingvotersguide') {
	      tables = ['Measures', 'Candidates', 'Jurisdictions'];
	    } else {
	      tables = ['Users', 'Proposals', 'Opinions', 'Points', 'Comments'];
	    }
	    return DIV(null, DashHeader({
	      name: 'Import Data'
	    }), DIV({
	      style: {
	        width: BODY_WIDTH(),
	        margin: '15px auto'
	      }
	    }, P({
	      style: {
	        marginBottom: 6
	      }
	    }, "Import data into Considerit. The spreadsheet should be in comma separated value format (.csv)."), subdomain.name !== 'livingvotersguide' ? DIV(null, P({
	      style: {
	        marginBottom: 6
	      }
	    }, "To refer to a User, use their email address. For example, if you’re uploading points, in the user column, refer to the author via their email address. "), P({
	      style: {
	        marginBottom: 6
	      }
	    }, "To refer to a Proposal, refer to its url. "), P({
	      style: {
	        marginBottom: 6
	      }
	    }, "To refer to a Point, make up an id for it and use that."), P({
	      style: {
	        marginBottom: 6
	      }
	    }, "You do not have to upload every file, just what you need to. Importing the same spreadsheet multiple times is ok.")) : void 0, FORM({
	      action: '/dashboard/import_data'
	    }, TABLE(null, TBODY(null, (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = tables.length; j < len; j++) {
	        table = tables[j];
	        results.push(TR(null, TD({
	          style: {
	            paddingTop: 20,
	            textAlign: 'right'
	          }
	        }, LABEL({
	          style: {
	            whiteSpace: 'nowrap'
	          },
	          htmlFor: table + "-file"
	        }, table + " (.csv)"), DIV(null), A({
	          style: {
	            textDecoration: 'underline',
	            fontSize: 12
	          },
	          href: "/example_import_csvs/" + (table.toLowerCase()) + ".csv",
	          'data-nojax': true
	        }, 'Example')), TD({
	          style: {
	            padding: '20px 0 0 20px'
	          }
	        }, INPUT({
	          id: table + "-file",
	          name: (table.toLowerCase()) + "-file",
	          type: 'file',
	          style: {
	            backgroundColor: focus_blue,
	            color: 'white',
	            fontWeight: 700,
	            borderRadius: 8,
	            padding: 6
	          }
	        }))));
	      }
	      return results;
	    })(), current_user.is_super_admin ? [
	      TR(null, TD(null), TD({
	        style: {
	          padding: '20px 0 20px 20px'
	        }
	      }, INPUT({
	        type: 'checkbox',
	        name: 'generate_inclusions',
	        id: 'generate_inclusions'
	      }), LABEL({
	        htmlFor: 'generate_inclusions'
	      }, "Generate opinions & inclusions of points?\nIt requires a proposal file; for each proposal in the file, this option will increase by \n2x the number of existing opinions. Each simulated opinion will include two points. \nStances and inclusions will not be assigned randomly, but rather following a \nrich-get-richer model. You can use this option multiple times. This option is only good for demos."))), TR(null, TD(null), TD({
	        style: {
	          padding: '20px 0 20px 20px'
	        }
	      }, INPUT({
	        type: 'checkbox',
	        name: 'assign_pics',
	        id: 'assign_pics'
	      }), LABEL({
	        htmlFor: 'assign_pics'
	      }, "Assign a random profile picture for users without an avatar url")))
	    ] : void 0, TR(null, TD(null), TD({
	      style: {
	        padding: '20px 0 0 20px'
	      }
	    }, A({
	      id: 'submit_import',
	      style: {
	        backgroundColor: '#7ED321',
	        color: 'white',
	        border: 'none',
	        borderRadius: 8,
	        fontSize: 24,
	        fontWeight: 700,
	        padding: '10px 20px'
	      },
	      onClick: (function(_this) {
	        return function() {
	          $('html, #submit_import').css('cursor', 'wait');
	          return $(_this.getDOMNode()).find('form').ajaxSubmit({
	            type: 'POST',
	            data: {
	              authenticity_token: current_user.csrf,
	              trying_to: 'update_avatar_hack'
	            },
	            success: function(data) {
	              if (data[0].errors) {
	                _this.local.successes = null;
	                _this.local.errors = data[0].errors;
	                return save(_this.local);
	              } else {
	                $('html, #submit_import').css('cursor', '');
	                arest.clear_matching_objects(function(key) {
	                  return key.match(/\/page\//);
	                });
	                _this.local.errors = null;
	                _this.local.successes = data[0];
	                return save(_this.local);
	              }
	            },
	            error: function(result) {
	              $('html, #submit_import').css('cursor', '');
	              _this.local.successes = null;
	              _this.local.errors = ['Unknown error parsing the files. Email tkriplean@gmail.com.'];
	              return save(_this.local);
	            }
	          });
	        };
	      })(this)
	    }, 'Done. Upload!')))))), this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#FFE2E2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Ooops! There are errors in the uploaded files:'), (function() {
	      var j, len, ref, results;
	      ref = this.local.errors;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        error = ref[j];
	        results.push(DIV({
	          style: {
	            marginTop: 10
	          }
	        }, error));
	      }
	      return results;
	    }).call(this)) : void 0, this.local.successes ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#E2FFE2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Success! Here\'s what happened:'), (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = tables.length; j < len; j++) {
	        table = tables[j];
	        if (this.local.successes[table.toLowerCase()]) {
	          results.push(DIV(null, H1({
	            style: {
	              fontSize: 15,
	              fontWeight: 300
	            }
	          }, table), (function() {
	            var k, len1, ref, results1;
	            ref = this.local.successes[table.toLowerCase()];
	            results1 = [];
	            for (k = 0, len1 = ref.length; k < len1; k++) {
	              success = ref[k];
	              results1.push(DIV({
	                style: {
	                  marginTop: 10
	                }
	              }, success));
	            }
	            return results1;
	          }).call(this)));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this)) : void 0));
	  }
	});

	AppSettingsDash = ReactiveComponent({
	  displayName: 'AppSettingsDash',
	  render: function() {
	    var current_user, error, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    return DIV({
	      className: 'app_settings_dash'
	    }, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ".app_settings_dash { font-size: 18px }\n.app_settings_dash input[type=\"text\"] { display: block; width: 600px; font-size: 18px; padding: 4px 8px; } \n.app_settings_dash .input_group { margin-bottom: 12px; }"
	      }
	    }), DashHeader({
	      name: 'Application Settings'
	    }), subdomain.name ? DIV({
	      style: {
	        width: BODY_WIDTH(),
	        margin: '20px auto'
	      }
	    }, DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'app_title'
	    }, 'The name of this application'), INPUT({
	      id: 'app_title',
	      type: 'text',
	      name: 'app_title',
	      defaultValue: subdomain.app_title,
	      placeholder: 'Shows in email subject lines and in the window title.'
	    })), DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'external_project_url'
	    }, 'Project url'), INPUT({
	      id: 'external_project_url',
	      type: 'text',
	      name: 'external_project_url',
	      defaultValue: subdomain.external_project_url,
	      placeholder: 'A link to the main project\'s homepage, if any.'
	    })), current_user.is_super_admin ? (DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'about_page_url'
	    }, 'About Page URL'), INPUT({
	      id: 'about_page_url',
	      type: 'text',
	      name: 'about_page_url',
	      defaultValue: subdomain.about_page_url,
	      placeholder: 'The about page will then contain a window to this url.'
	    })), DIV(null, DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'masthead_header_text'
	    }, 'Masthead header text'), INPUT({
	      id: 'masthead_header_text',
	      type: 'text',
	      name: 'masthead_header_text',
	      defaultValue: subdomain.branding.masthead_header_text,
	      placeholder: 'This will be shown in bold white text across the top of the header.'
	    })), DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'primary_color'
	    }, 'Primary color (CSS format)'), INPUT({
	      id: 'primary_color',
	      type: 'text',
	      name: 'primary_color',
	      defaultValue: subdomain.branding.primary_color,
	      placeholder: 'The primary brand color. Needs to be dark.'
	    })), DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'homepage_text'
	    }, 'Homepage text'), TEXTAREA({
	      id: 'homepage_text',
	      name: 'homepage_text',
	      defaultValue: subdomain.branding.homepage_text,
	      placeholder: 'Shown in homepage. Can be HTML.',
	      style: {
	        display: 'block',
	        width: 500
	      }
	    })))) : void 0, FORM({
	      id: 'subdomain_files',
	      action: '/update_images_hack'
	    }, current_user.is_super_admin ? DIV({
	      className: 'input_group'
	    }, DIV(null, LABEL({
	      htmlFor: 'masthead'
	    }, 'Masthead background image. Should be pretty large.')), INPUT({
	      id: 'masthead',
	      type: 'file',
	      name: 'masthead',
	      onChange: (function(_this) {
	        return function(ev) {
	          return _this.submit_masthead = true;
	        };
	      })(this)
	    })) : void 0, DIV({
	      className: 'input_group'
	    }, DIV(null, LABEL({
	      htmlFor: 'logo'
	    }, 'Logo')), INPUT({
	      id: 'logo',
	      type: 'file',
	      name: 'logo',
	      onChange: (function(_this) {
	        return function(ev) {
	          return _this.submit_logo = true;
	        };
	      })(this)
	    }))), DIV({
	      className: 'input_group'
	    }, BUTTON({
	      className: 'primary_button button',
	      onClick: this.submit
	    }, 'Save')), this.local.save_complete ? DIV({
	      style: {
	        color: 'green'
	      }
	    }, 'Saved.') : void 0, this.local.file_errors ? DIV({
	      style: {
	        color: 'red'
	      }
	    }, 'Error uploading files!') : void 0, this.local.errors ? this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#FFE2E2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Ooops!'), (function() {
	      var j, len, ref, results;
	      ref = this.local.errors;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        error = ref[j];
	        results.push(DIV({
	          style: {
	            marginTop: 10
	          }
	        }, error));
	      }
	      return results;
	    }).call(this)) : void 0 : void 0) : void 0);
	  },
	  submit: function() {
	    var f, fields, j, len, subdomain, submitting_files;
	    submitting_files = this.submit_logo || this.submit_masthead;
	    subdomain = fetch('/subdomain');
	    fields = ['about_page_url', 'notifications_sender_email', 'app_title', 'external_project_url'];
	    for (j = 0, len = fields.length; j < len; j++) {
	      f = fields[j];
	      subdomain[f] = $(this.getDOMNode()).find("#" + f).val();
	    }
	    subdomain.branding = {
	      primary_color: $('#primary_color').val(),
	      masthead_header_text: $('#masthead_header_text').val(),
	      homepage_text: $('#homepage_text').val()
	    };
	    this.local.save_complete = this.local.file_errors = false;
	    save(this.local);
	    return save(subdomain, (function(_this) {
	      return function() {
	        var current_user;
	        if (subdomain.errors) {
	          _this.local.errors = subdomain.errors;
	        }
	        if (!submitting_files) {
	          _this.local.save_complete = true;
	        }
	        save(_this.local);
	        if (submitting_files) {
	          current_user = fetch('/current_user');
	          return $('#subdomain_files').ajaxSubmit({
	            type: 'PUT',
	            data: {
	              authenticity_token: current_user.csrf
	            },
	            success: function() {
	              return location.reload();
	            },
	            error: function() {
	              _this.local.file_errors = true;
	              return save(_this.local);
	            }
	          });
	        }
	      };
	    })(this));
	  }
	});

	AdminTaskList = ReactiveComponent({
	  displayName: 'AdminTaskList',
	  render: function() {
	    var background_color, category, dash, item, items, j, len, ref, ref1;
	    dash = this.data();
	    if (!dash.selected_task && this.props.items.length > 0) {
	      ref = this.props.items;
	      for (j = 0, len = ref.length; j < len; j++) {
	        ref1 = ref[j], category = ref1[0], items = ref1[1];
	        if (items.length > 0) {
	          dash.selected_task = items[0].key;
	          save(dash);
	          break;
	        }
	      }
	    }
	    if (dash.transition) {
	      this.selectNext();
	    }
	    return DIV(null, STYLE(null, '.task_tab:hover{background-color: #f1f1f1 }'), (function() {
	      var k, len1, ref2, ref3, results;
	      ref2 = this.props.items;
	      results = [];
	      for (k = 0, len1 = ref2.length; k < len1; k++) {
	        ref3 = ref2[k], category = ref3[0], items = ref3[1];
	        if (items.length > 0) {
	          results.push(DIV({
	            style: {
	              marginTop: 20
	            },
	            key: category
	          }, H1({
	            style: {
	              fontSize: 22
	            }
	          }, category), UL({
	            style: {}
	          }, (function() {
	            var l, len2, results1;
	            results1 = [];
	            for (l = 0, len2 = items.length; l < len2; l++) {
	              item = items[l];
	              background_color = item.key === dash.selected_task ? '#F4F0E9' : '';
	              results1.push(LI({
	                key: item.key,
	                style: {
	                  position: 'relative',
	                  listStyle: 'none',
	                  width: CONTENT_WIDTH() / 4
	                }
	              }, DIV({
	                className: 'task_tab',
	                style: {
	                  zIndex: 1,
	                  cursor: 'pointer',
	                  padding: '10px',
	                  margin: '5px 0',
	                  borderRadius: '8px 0 0 8px',
	                  backgroundColor: background_color
	                },
	                onClick: (function(_this) {
	                  return function(item) {
	                    return function() {
	                      dash.selected_task = item.key;
	                      return save(dash);
	                    };
	                  };
	                })(this)(item)
	              }, this.props.renderTab(item)), dash.selected_task === item.key ? this.props.renderTask(item) : void 0));
	            }
	            return results1;
	          }).call(this))));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this));
	  },
	  selectNext: function() {
	    return this._select(false);
	  },
	  selectPrev: function() {
	    return this._select(true);
	  },
	  _select: function(reverse) {
	    var all_items, category, data, get_next, item, items, j, k, len, len1, ref, tasks;
	    data = this.data();
	    get_next = false;
	    all_items = !reverse ? this.props.items : this.props.items.slice().reverse();
	    for (j = 0, len = all_items.length; j < len; j++) {
	      ref = all_items[j], category = ref[0], items = ref[1];
	      tasks = !reverse ? items : items.slice().reverse();
	      for (k = 0, len1 = tasks.length; k < len1; k++) {
	        item = tasks[k];
	        if (get_next) {
	          data.selected_task = item.key;
	          data.transition = null;
	          save(data);
	          return;
	        } else if (item.key === data.selected_task) {
	          get_next = true;
	        }
	      }
	    }
	  },
	  componentDidMount: function() {
	    return $(document).on('keyup.dash', (function(_this) {
	      return function(e) {
	        if (e.keyCode === 40) {
	          _this.selectNext();
	        }
	        if (e.keyCode === 38) {
	          return _this.selectPrev();
	        }
	      };
	    })(this));
	  },
	  componentWillUnmount: function() {
	    return $(document).off('keyup.dash');
	  }
	});

	ModerationDash = ReactiveComponent({
	  displayName: 'ModerationDash',
	  render: function() {
	    var failed, field, i, idx, items, j, len, model, moderation_options, moderations, passed, quarantined, reviewable, subdomain;
	    moderations = this.data().moderations.sort(function(a, b) {
	      return new Date(b.created_at) - new Date(a.created_at);
	    });
	    subdomain = fetch('/subdomain');
	    passed = [];
	    reviewable = [];
	    quarantined = [];
	    failed = [];
	    for (j = 0, len = moderations.length; j < len; j++) {
	      i = moderations[j];
	      fetch(i.key);
	      if ((i.status == null) || i.updated_since_last_evaluation) {
	        reviewable.push(i);
	      } else if (i.status === 1) {
	        passed.push(i);
	      } else if (i.status === 0) {
	        failed.push(i);
	      } else if (i.status === 2) {
	        quarantined.push(i);
	      }
	    }
	    items = [['Pending review', reviewable], ['Quarantined', quarantined], ['Failed', failed], ['Passed', passed]];
	    return DIV(null, DashHeader({
	      name: 'Moderate user contributions'
	    }), DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        margin: '15px auto'
	      }
	    }, DIV({
	      className: 'moderation_settings'
	    }, subdomain.moderated_classes.length === 0 || this.local.edit_settings ? DIV(null, (function() {
	      var k, len1, ref, results;
	      ref = ['points', 'comments', 'proposals'];
	      results = [];
	      for (k = 0, len1 = ref.length; k < len1; k++) {
	        model = ref[k];
	        moderation_options = ["Do not moderate " + model, "Do not publicly post " + model + " until moderation", "Post " + model + " immediately, but withhold email notifications until moderation", "Post " + model + " immediately, catch bad ones afterwards"];
	        results.push(FIELDSET({
	          style: {
	            marginBottom: 12
	          }
	        }, LEGEND({
	          style: {
	            fontSize: 24
	          }
	        }, capitalize(model)), (function() {
	          var l, len2, results1;
	          results1 = [];
	          for (idx = l = 0, len2 = moderation_options.length; l < len2; idx = ++l) {
	            field = moderation_options[idx];
	            results1.push(DIV({
	              style: {
	                marginLeft: 18,
	                fontSize: 18,
	                cursor: 'pointer'
	              },
	              onClick: (function(_this) {
	                return function(idx, model) {
	                  return function() {
	                    subdomain["moderate_" + model + "_mode"] = idx;
	                    return save(subdomain, function() {
	                      return arest.serverFetch('/page/dashboard/moderate');
	                    });
	                  };
	                };
	              })(this)(idx, model)
	            }, INPUT({
	              style: {
	                cursor: 'pointer'
	              },
	              type: 'radio',
	              name: "moderate_" + model + "_mode",
	              id: "moderate_" + model + "_mode_" + idx,
	              defaultChecked: subdomain["moderate_" + model + "_mode"] === idx
	            }), LABEL({
	              style: {
	                cursor: 'pointer',
	                paddingLeft: 8
	              },
	              htmlFor: "moderate_" + model + "_mode_" + idx
	            }, field)));
	          }
	          return results1;
	        }).call(this)));
	      }
	      return results;
	    }).call(this), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          _this.local.edit_settings = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'close')) : A({
	      style: {
	        textDecoration: 'underline'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.edit_settings = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'Edit moderation settings')), AdminTaskList({
	      key: 'moderation_dash',
	      items: items,
	      renderTab: (function(_this) {
	        return function(item) {
	          var class_name, moderatable, point, proposal, tease;
	          class_name = item.moderatable_type;
	          moderatable = fetch(item.moderatable);
	          if (class_name === 'Point') {
	            proposal = fetch(moderatable.proposal);
	            tease = (moderatable.nutshell.substring(0, 30)) + "...";
	          } else if (class_name === 'Comment') {
	            point = fetch(moderatable.point);
	            proposal = fetch(point.proposal);
	            tease = (moderatable.body.substring(0, 30)) + "...";
	          } else if (class_name === 'Proposal') {
	            proposal = moderatable;
	            tease = (proposal.name.substring(0, 30)) + "...";
	          }
	          return DIV({
	            className: 'tab'
	          }, DIV({
	            style: {
	              fontSize: 14,
	              fontWeight: 600
	            }
	          }, "Moderate " + class_name + " " + item.moderatable_id), DIV({
	            style: {
	              fontSize: 12,
	              fontStyle: 'italic'
	            }
	          }, tease), DIV({
	            style: {
	              fontSize: 12,
	              paddingLeft: 12
	            }
	          }, "- " + (fetch(moderatable.user).name)), item.updated_since_last_evaluation ? DIV({
	            style: {
	              fontSize: 12
	            }
	          }, "* revised") : void 0);
	        };
	      })(this),
	      renderTask: (function(_this) {
	        return function(item) {
	          return ModerateItem({
	            key: item.key
	          });
	        };
	      })(this)
	    })));
	  }
	});

	ModerateItem = ReactiveComponent({
	  displayName: 'ModerateItem',
	  render: function() {
	    var author, class_name, comment, comments, current_user, item, moderatable, point, proposal;
	    item = this.data();
	    class_name = item.moderatable_type;
	    moderatable = fetch(item.moderatable);
	    author = fetch(moderatable.user);
	    if (class_name === 'Point') {
	      point = moderatable;
	      proposal = fetch(moderatable.proposal);
	    } else if (class_name === 'Comment') {
	      point = fetch(moderatable.point);
	      proposal = fetch(point.proposal);
	      comments = fetch("/comments/" + point.id);
	    } else if (class_name === 'Proposal') {
	      proposal = moderatable;
	    }
	    current_user = fetch('/current_user');
	    return DIV({
	      style: adminStyles().task_area_style
	    }, DIV({
	      style: adminStyles().task_area_bar
	    }, item.updated_since_last_evaluation ? SPAN({
	      style: {}
	    }, "Updated since last moderation") : item.status === 1 ? SPAN({
	      style: {}
	    }, "Passed by " + (fetch(item.user).name) + " on " + (new Date(item.updated_at).toDateString())) : item.status === 2 ? SPAN({
	      style: {}
	    }, "Quarantined by " + (fetch(item.user).name) + " on " + (new Date(item.updated_at).toDateString())) : item.status === 0 ? SPAN({
	      style: {}
	    }, "Failed by " + (fetch(item.user).name) + " on " + (new Date(item.updated_at).toDateString())) : SPAN({
	      style: {}
	    }, "Is this " + class_name + " ok?")), DIV({
	      style: {
	        padding: '10px 30px'
	      }
	    }, DIV({
	      style: adminStyles().task_area_section_style
	    }, class_name === 'Point' ? UL({
	      style: {
	        marginLeft: 73
	      }
	    }, Point({
	      key: point,
	      rendered_as: 'under_review',
	      enable_dragging: false
	    })) : class_name === 'Proposal' ? DIV(null, DIV({
	      style: {
	        fontSize: 20,
	        fontWeight: 600
	      }
	    }, moderatable.name), DIV({
	      className: 'moderatable_item',
	      dangerouslySetInnerHTML: {
	        __html: moderatable.description
	      }
	    })) : class_name === 'Comment' ? !this.local.show_conversation ? DIV(null, A({
	      style: {
	        textDecoration: 'underline',
	        paddingBottom: 10,
	        display: 'block'
	      },
	      onClick: ((function(_this) {
	        return function() {
	          _this.local.show_conversation = true;
	          return save(_this.local);
	        };
	      })(this))
	    }, 'Show full conversation'), Comment({
	      key: moderatable,
	      under_review: true
	    })) : DIV(null, A({
	      style: {
	        textDecoration: 'underline',
	        paddingBottom: 10,
	        display: 'block'
	      },
	      onClick: ((function(_this) {
	        return function() {
	          _this.local.show_conversation = false;
	          return save(_this.local);
	        };
	      })(this))
	    }, 'Hide full conversation'), UL({
	      style: {
	        opacity: .5,
	        marginLeft: 73
	      }
	    }, Point({
	      key: point,
	      rendered_as: 'under_review',
	      enable_dragging: false
	    })), (function() {
	      var j, len, ref, results;
	      ref = _.uniq(_.map(comments.comments, function(c) {
	        return c.key;
	      }).concat(moderatable.key));
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        comment = ref[j];
	        if (comment !== moderatable.key) {
	          results.push(DIV({
	            style: {
	              opacity: .5
	            }
	          }, Comment({
	            key: comment
	          })));
	        } else {
	          results.push(Comment({
	            key: moderatable
	          }));
	        }
	      }
	      return results;
	    })()) : void 0, DIV({
	      style: {
	        fontSize: 12,
	        marginLeft: 73
	      }
	    }, "by " + author.name, !moderatable.hide_name && !this.local.messaging ? [
	      SPAN({
	        style: {
	          fontSize: 8,
	          padding: '0 4px'
	        }
	      }, " • "), A({
	        style: {
	          textDecoration: 'underline'
	        },
	        onClick: ((function(_this) {
	          return function() {
	            _this.local.messaging = moderatable;
	            return save(_this.local);
	          };
	        })(this))
	      }, 'Message author')
	    ] : this.local.messaging ? DirectMessage({
	      to: this.local.messaging.user,
	      parent: this.local,
	      sender_mask: 'Moderator'
	    }) : void 0)), DIV({
	      style: adminStyles().task_area_section_style
	    }, STYLE(null, ".moderation { padding: 6px 8px; display: inline-block; }\n.moderation:hover { background-color: rgba(255,255,255, .5); cursor: pointer; border-radius: 8px; }                         \n.moderation label, .moderation input { font-size: 24px; }\n.moderation label:hover, .moderation input:hover { font-size: 24px; cursor: pointer; }"), DIV({
	      className: 'moderation',
	      onClick: function() {
	        var dash;
	        dash = fetch('moderation_dash');
	        dash.transition = item.key;
	        save(dash);
	        item.status = 1;
	        return save(item);
	      }
	    }, INPUT({
	      name: 'moderation',
	      type: 'radio',
	      id: 'pass',
	      defaultChecked: item.status === 1
	    }), LABEL({
	      htmlFor: 'pass'
	    }, 'Pass')), DIV({
	      className: 'moderation',
	      onClick: function() {
	        var dash;
	        dash = fetch('moderation_dash');
	        dash.transition = item.key;
	        save(dash);
	        item.status = 2;
	        return save(item);
	      }
	    }, INPUT({
	      name: 'moderation',
	      type: 'radio',
	      id: 'quar',
	      defaultChecked: item.status === 2
	    }), LABEL({
	      htmlFor: 'quar'
	    }, 'Quarantine')), DIV({
	      className: 'moderation',
	      onClick: function() {
	        var dash;
	        dash = fetch('moderation_dash');
	        dash.transition = item.key;
	        save(dash);
	        item.status = 0;
	        return save(item);
	      }
	    }, INPUT({
	      name: 'moderation',
	      type: 'radio',
	      id: 'fail',
	      defaultChecked: item.status === 0
	    }), LABEL({
	      htmlFor: 'fail'
	    }, 'Fail')))));
	  }
	});

	styles += ".moderatable_item br {\n  padding-bottom: 0.5em; }\n.moderatable_item p, \n.moderatable_item ul, \n.moderatable_item ol, \n.moderatable_item table {\n  margin-bottom: 0.5em; }\n.moderatable_item td {\n  padding: 0 3px; }\n.moderatable_item li {\n  list-style: outside; }\n.moderatable_item ol li {\n  list-style-type: decimal; }  \n.moderatable_item ul,\n.moderatable_item ol, {\n  padding-left: 20px;\n  margin-left: 20px; }\n.moderatable_item a {\n  text-decoration: underline; }\n.moderatable_item blockquote {\n  opacity: 0.7;\n  padding: 10px 20px; }\n.moderatable_item table {\n  padding: 20px 0px; }";

	FactcheckDash = ReactiveComponent({
	  displayName: 'FactcheckDash',
	  render: function() {
	    var a, assessments, completed, items, j, len, reviewable, todo;
	    assessments = this.data().assessments.sort(function(a, b) {
	      return new Date(b.created_at) - new Date(a.created_at);
	    });
	    completed = [];
	    reviewable = [];
	    todo = [];
	    for (j = 0, len = assessments.length; j < len; j++) {
	      a = assessments[j];
	      fetch(a.key);
	      if (a.complete) {
	        completed.push(a);
	      } else if (a.reviewable) {
	        reviewable.push(a);
	      } else {
	        todo.push(a);
	      }
	    }
	    items = [['Pending review', reviewable], ['Incomplete', todo], ['Complete', completed]];
	    return DIV(null, DashHeader({
	      name: 'Fact check user contributions'
	    }), DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        margin: '15px auto'
	      }
	    }, AdminTaskList({
	      items: items,
	      key: 'factcheck_dash',
	      renderTab: (function(_this) {
	        return function(item) {
	          var point, proposal;
	          point = fetch(item.point);
	          proposal = fetch(point.proposal);
	          return DIV({
	            className: 'tab'
	          }, DIV({
	            style: {
	              fontSize: 14,
	              fontWeight: 600
	            }
	          }, "Fact check point " + point.id), DIV({
	            style: {
	              fontSize: 12
	            }
	          }, "Requested on " + (new Date(item.requests[0].created_at).toDateString())), DIV({
	            style: {
	              fontSize: 12
	            }
	          }, "Issue: " + proposal.name));
	        };
	      })(this),
	      renderTask: (function(_this) {
	        return function(item) {
	          return FactcheckPoint({
	            key: item.key
	          });
	        };
	      })(this)
	    })));
	  }
	});

	FactcheckPoint = ReactiveComponent({
	  displayName: 'FactcheckPoint',
	  render: function() {
	    var all_claims_answered, all_claims_approved, assessment, claim, current_user, j, len, point, proposal, ref, request, verdict;
	    assessment = this.data();
	    point = fetch(assessment.point);
	    proposal = fetch(point.proposal);
	    current_user = fetch('/current_user');
	    all_claims_answered = assessment.claims.length > 0;
	    all_claims_approved = assessment.claims.length > 0;
	    ref = assessment.claims;
	    for (j = 0, len = ref.length; j < len; j++) {
	      claim = ref[j];
	      if (!claim.verdict || !claim.result) {
	        all_claims_answered = all_claims_approved = false;
	      }
	      if (!claim.approver) {
	        all_claims_approved = false;
	      }
	    }
	    return DIV({
	      style: adminStyles().task_area_style
	    }, STYLE(null, '.claim_result a{text-decoration: underline;}'), DIV({
	      style: adminStyles().task_area_bar
	    }, assessment.complete ? SPAN({
	      style: {}
	    }, "Published " + (new Date(assessment.published_at).toDateString())) : assessment.reviewable ? SPAN({
	      style: {}
	    }, "Awaiting approval") : SPAN({
	      style: {}
	    }, "Fact check this point"), SPAN({
	      style: {
	        float: 'right',
	        fontSize: 18,
	        verticalAlign: 'bottom'
	      }
	    }, assessment.user ? [
	      "Responsible: " + (fetch(assessment.user).name), assessment.user === current_user.user && !assessment.reviewable && !assessment.complete ? BUTTON({
	        style: {
	          marginLeft: 8,
	          fontSize: 14
	        },
	        onClick: this.toggleResponsibility
	      }, "I won't do it") : void 0
	    ] : [
	      'Responsible: ', BUTTON({
	        style: {
	          backgroundColor: focus_blue,
	          color: 'white',
	          fontSize: 14,
	          border: 'none',
	          borderRadius: 8,
	          fontWeight: 600
	        },
	        onClick: this.toggleResponsibility
	      }, "I'll do it")
	    ])), DIV({
	      style: {
	        padding: '10px 30px'
	      }
	    }, DIV({
	      style: adminStyles().task_area_section_style
	    }, UL({
	      style: {
	        marginLeft: 73
	      }
	    }, Point({
	      key: point,
	      rendered_as: 'under_review',
	      enable_dragging: false
	    })), DIV({
	      style: {
	        fontSize: 12,
	        marginLeft: 73
	      }
	    }, "by " + (fetch(point.user).name), SPAN({
	      style: {
	        fontSize: 8,
	        padding: '0 4px'
	      }
	    }, " • "), A({
	      target: '_blank',
	      href: "/" + proposal.slug + "?selected=" + point.key,
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'Read point in context'), !point.hide_name && this.local.messaging !== point ? [
	      SPAN({
	        style: {
	          fontSize: 8,
	          padding: '0 4px'
	        }
	      }, " • "), A({
	        style: {
	          textDecoration: 'underline'
	        },
	        onClick: ((function(_this) {
	          return function() {
	            _this.local.messaging = point;
	            return save(_this.local);
	          };
	        })(this))
	      }, 'Email author')
	    ] : this.local.messaging === point ? DirectMessage({
	      to: this.local.messaging.user,
	      parent: this.local,
	      sender_mask: 'Fact-checker'
	    }) : void 0)), DIV({
	      style: adminStyles().task_area_section_style
	    }, H1({
	      style: adminStyles().task_area_header_style
	    }, 'Fact check requests'), DIV({
	      style: {}
	    }, (function() {
	      var k, len1, ref1, results;
	      ref1 = assessment.requests;
	      results = [];
	      for (k = 0, len1 = ref1.length; k < len1; k++) {
	        request = ref1[k];
	        results.push(DIV({
	          className: 'comment_entry',
	          key: request.key
	        }, Avatar({
	          className: 'comment_entry_avatar',
	          tag: DIV,
	          key: request.user,
	          hide_tooltip: true,
	          style: {
	            width: 50,
	            height: 50
	          }
	        }), DIV({
	          style: {
	            display: 'inline-block',
	            width: '80%'
	          }
	        }, DIV({
	          style: {
	            marginLeft: 20
	          }
	        }, splitParagraphs(request.suggestion)), DIV({
	          style: {
	            fontSize: 12,
	            marginLeft: 20
	          }
	        }, "by " + (fetch(request.user).name || 'anonymous'), this.local.messaging !== request ? [
	          SPAN({
	            style: {
	              fontSize: 8,
	              padding: '0 4px'
	            }
	          }, " • "), A({
	            style: {
	              textDecoration: 'underline'
	            },
	            onClick: ((function(_this) {
	              return function() {
	                _this.local.messaging = request;
	                return save(_this.local);
	              };
	            })(this))
	          }, 'Email requester')
	        ] : this.local.messaging === request ? DirectMessage({
	          to: this.local.messaging.user,
	          parent: this.local,
	          sender_mask: 'Fact-checker'
	        }) : void 0))));
	      }
	      return results;
	    }).call(this))), DIV({
	      style: adminStyles().task_area_section_style
	    }, H1({
	      style: adminStyles().task_area_header_style
	    }, 'Claims under review'), DIV({
	      style: {}
	    }, (function() {
	      var k, len1, ref1, results;
	      ref1 = assessment.claims;
	      results = [];
	      for (k = 0, len1 = ref1.length; k < len1; k++) {
	        claim = ref1[k];
	        claim = fetch(claim);
	        if (this.local.editing === claim.key) {
	          results.push(EditClaim({
	            fresh: false,
	            key: claim.key,
	            parent: this.local,
	            assessment: this.data()
	          }));
	        } else {
	          verdict = fetch(claim.verdict);
	          results.push(DIV({
	            key: claim.key,
	            style: {
	              marginLeft: 60,
	              marginBottom: 18,
	              position: 'relative'
	            }
	          }, IMG({
	            style: {
	              position: 'absolute',
	              width: 50,
	              left: -60
	            },
	            src: verdict.icon
	          }), DIV({
	            style: {
	              fontSize: 18
	            }
	          }, claim.claim_restatement), DIV({
	            style: {
	              fontSize: 12
	            }
	          }, verdict.name), DIV({
	            className: 'claim_result',
	            style: {
	              marginTop: 10,
	              fontSize: 14
	            },
	            dangerouslySetInnerHTML: {
	              __html: claim.result
	            }
	          }), DIV({
	            style: {
	              marginTop: 10,
	              position: 'relative'
	            }
	          }, DIV({
	            style: {
	              fontSize: 12,
	              marginTop: 10
	            }
	          }, DIV(null, "Created by " + (fetch(claim.creator).name)), claim.approver ? DIV(null, "Approved by " + (fetch(claim.approver).name)) : void 0), (function(_this) {
	            return function() {
	              var button_style;
	              button_style = {
	                marginRight: 5,
	                fontSize: 14
	              };
	              return DIV({
	                style: {
	                  marginTop: 10
	                }
	              }, claim.result && claim.verdict && !claim.approver ? BUTTON({
	                style: button_style,
	                onClick: (function(claim) {
	                  return function() {
	                    return _this.toggleClaimApproval(claim);
	                  };
	                })(claim)
	              }, 'Approve') : claim.approver ? BUTTON({
	                style: button_style,
	                onClick: (function(claim) {
	                  return function() {
	                    return _this.toggleClaimApproval(claim);
	                  };
	                })(claim)
	              }, 'Unapprove') : void 0, BUTTON({
	                style: button_style,
	                onClick: (function(claim) {
	                  return function() {
	                    _this.local.editing = claim.key;
	                    return save(_this.local);
	                  };
	                })(claim)
	              }, 'Edit'), BUTTON({
	                style: button_style,
	                onClick: (function(claim) {
	                  return function() {
	                    return _this.deleteClaim(claim);
	                  };
	                })(claim)
	              }, 'Delete'));
	            };
	          })(this)())));
	        }
	      }
	      return results;
	    }).call(this), this.local.editing === 'new' ? EditClaim({
	      fresh: true,
	      key: '/new/claim',
	      parent: this.local,
	      assessment: this.data()
	    }) : !this.local.editing ? Button({
	      style: {
	        marginLeft: 0,
	        marginTop: 15
	      }
	    }, '+ Add new claim', (function(_this) {
	      return function() {
	        _this.local.editing = 'new';
	        return save(_this.local);
	      };
	    })(this)) : void 0)), DIV({
	      style: adminStyles().task_area_section_style
	    }, H1({
	      style: adminStyles().task_area_header_style
	    }, 'Private notes'), AutoGrowTextArea({
	      className: 'assessment_notes',
	      placeholder: 'Private notes about this fact check',
	      defaultValue: assessment.notes,
	      min_height: 60,
	      style: {
	        width: 500,
	        fontSize: 16,
	        display: 'block',
	        padding: '4px 8px'
	      }
	    }), BUTTON({
	      style: {
	        fontSize: 14
	      },
	      onClick: this.saveNotes
	    }, 'Save notes'), DIV({
	      style: adminStyles().task_area_header_style
	    }, assessment.complete ? 'Congrats, this one is finished.' : all_claims_answered && !assessment.reviewable ? Button({}, 'Request approval', this.requestApproval) : assessment.reviewable ? all_claims_approved && current_user.user !== assessment.user ? Button({}, 'Publish fact check', this.publish) : all_claims_answered ? 'This fact-check is awaiting publication' : void 0 : void 0))));
	  },
	  deleteClaim: function(claim) {
	    return destroy(claim.key);
	  },
	  toggleClaimApproval: function(claim) {
	    if (claim.approver) {
	      claim.approver = null;
	    } else {
	      claim.approver = fetch('/current_user').user;
	    }
	    return save(claim);
	  },
	  saveNotes: function() {
	    var assessment;
	    assessment = this.data();
	    assessment.notes = $('.assessment_notes').val();
	    return save(assessment);
	  },
	  publish: function() {
	    var assessment;
	    assessment = this.data();
	    assessment.complete = true;
	    return save(assessment);
	  },
	  requestApproval: function() {
	    var assessment;
	    assessment = this.data();
	    assessment.reviewable = true;
	    if (!assessment.user) {
	      assessment.user = fetch("/current_user").user;
	    }
	    return save(assessment);
	  },
	  toggleResponsibility: function() {
	    var assessment, current_user;
	    assessment = this.data();
	    current_user = fetch('/current_user');
	    if (assessment.user === current_user.user) {
	      assessment.user = null;
	    } else if (!assessment.user) {
	      assessment.user = current_user.user;
	    }
	    return save(assessment);
	  }
	});

	DirectMessage = ReactiveComponent({
	  displayName: 'DirectMessage',
	  render: function() {
	    var text_style;
	    text_style = {
	      width: 500,
	      fontSize: 16,
	      display: 'block',
	      padding: '4px 8px'
	    };
	    return DIV({
	      style: {
	        marginTop: 18,
	        padding: '15px 20px',
	        backgroundColor: 'white',
	        width: 550,
	        border: '#999',
	        boxShadow: "0 1px 2px rgba(0,0,0,.2)"
	      }
	    }, DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL(null, 'To: ', fetch(this.props.to).name)), DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL(null, 'Subject'), AutoGrowTextArea({
	      className: 'message_subject',
	      placeholder: 'Subject line',
	      min_height: 25,
	      style: text_style
	    })), DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL(null, 'Body'), AutoGrowTextArea({
	      className: 'message_body',
	      placeholder: 'Email message',
	      min_height: 75,
	      style: text_style
	    })), Button({}, 'Send', this.submitMessage), A({
	      style: {
	        marginLeft: 8
	      },
	      onClick: ((function(_this) {
	        return function() {
	          _this.props.parent.messaging = null;
	          return save(_this.props.parent);
	        };
	      })(this))
	    }, 'cancel'));
	  },
	  submitMessage: function() {
	    var $el, attrs;
	    $el = $(this.getDOMNode());
	    attrs = {
	      recipient: this.props.to,
	      subject: $el.find('.message_subject').val(),
	      body: $el.find('.message_body').val(),
	      sender_mask: this.props.sender_mask || fetch('/current_user').name,
	      authenticity_token: fetch('/current_user').csrf
	    };
	    return $.ajax('/dashboard/message', {
	      data: attrs,
	      type: 'POST',
	      success: (function(_this) {
	        return function() {
	          _this.props.parent.messaging = null;
	          return save(_this.props.parent);
	        };
	      })(this)
	    });
	  }
	});

	EditClaim = ReactiveComponent({
	  displayName: 'EditClaim',
	  render: function() {
	    var text_style, verdict;
	    text_style = {
	      width: 550,
	      fontSize: 16,
	      display: 'block',
	      padding: '4px 8px'
	    };
	    return DIV({
	      style: {
	        padding: '8px 12px',
	        backgroundColor: "rgba(0,0,0,.1)",
	        marginLeft: 0,
	        marginBottom: 18
	      }
	    }, DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL(null, 'Restate the claim'), AutoGrowTextArea({
	      className: 'claim_restatement',
	      placeholder: 'The claim',
	      defaultValue: this.props.fresh ? null : this.data().claim_restatement,
	      min_height: 30,
	      style: text_style
	    })), DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL({
	      style: {
	        marginRight: 8
	      }
	    }, 'Evaluate the claim'), SELECT({
	      defaultValue: this.props.fresh ? null : this.data().verdict,
	      className: 'claim_verdict'
	    }, (function() {
	      var j, len, ref, results;
	      ref = fetch('/page/dashboard/assessment').verdicts;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        verdict = ref[j];
	        results.push(OPTION({
	          key: verdict.key,
	          value: verdict.key
	        }, verdict.name));
	      }
	      return results;
	    })())), DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL(null, 'Review the claim'), AutoGrowTextArea({
	      className: 'claim_result',
	      placeholder: 'Prose review of this claim',
	      defaultValue: this.props.fresh ? null : this.data().result,
	      min_height: 80,
	      style: text_style
	    })), Button({}, 'Save claim', this.saveClaim), A({
	      style: {
	        marginLeft: 12
	      },
	      onClick: ((function(_this) {
	        return function() {
	          _this.props.parent.editing = null;
	          return save(_this.props.parent);
	        };
	      })(this))
	    }, 'cancel'));
	  },
	  saveClaim: function() {
	    var $el, claim;
	    $el = $(this.getDOMNode());
	    claim = this.props.fresh ? {
	      key: '/new/claim'
	    } : this.data();
	    claim.claim_restatement = $el.find('.claim_restatement').val();
	    claim.result = $el.find('.claim_result').val();
	    claim.assessment = this.props.assessment.key;
	    claim.verdict = $el.find('.claim_verdict').val();
	    save(claim);
	    this.props.parent.editing = null;
	    return save(this.props.parent);
	  }
	});

	window.FactcheckDash = FactcheckDash;

	window.ModerationDash = ModerationDash;

	window.AppSettingsDash = AppSettingsDash;

	window.ImportDataDash = ImportDataDash;

	window.DashHeader = DashHeader;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Auth, ensureCurrentUserAvatar;

	__webpack_require__(20);

	__webpack_require__(37);

	__webpack_require__(7);

	__webpack_require__(8);

	__webpack_require__(4);

	__webpack_require__(16);

	__webpack_require__(3);

	window.logout = function() {
	  var auth, current_user;
	  current_user = fetch('/current_user');
	  current_user.logged_in = false;
	  current_user.trying_to = 'logout';
	  auth = fetch('auth');
	  if (auth.form && auth.form === 'edit profile') {
	    loadPage('/');
	  }
	  reset_key(auth);
	  return save(current_user, (function(_this) {
	    return function() {
	      return location.reload();
	    };
	  })(this));
	};

	window.auth_ghost_gray = '#a1a1a1';

	window.auth_text_gray = '#444';

	Auth = ReactiveComponent({
	  displayName: 'Auth',
	  render: function() {
	    var auth, current_user;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (!this.local.last_auth || this.local.auth !== auth.auth) {
	      this.local.last_auth = auth;
	      current_user.errors = [];
	      this.local.errors = [];
	      save(this.local);
	      return SPAN(null);
	    }
	    if (!auth.form) {
	      return SPAN(null);
	    }
	    return DIV(null, DIV({
	      style: {
	        margin: "0 auto",
	        padding: !this.props.naked ? '4em 0' : void 0,
	        position: 'relative',
	        zIndex: 0,
	        width: AUTH_WIDTH()
	      }
	    }, this.buildAuthForm()));
	  },
	  buildAuthForm: function() {
	    var auth, avatar_field, current_user, email_field, error1, footer, goal, pledges, pledges_field;
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    goal = null;
	    if (auth.goal) {
	      try {
	        goal = "To " + (t(auth.goal).toLowerCase());
	      } catch (error1) {
	        goal = "To " + (auth.goal.toLowerCase());
	      }
	    }
	    switch (auth.form) {
	      case 'login':
	        return [this.headerAndBorder(goal, t('Introduce Yourself'), this.body([[(t('login_as')) + ":", [this.inputBox('email', 'email@address', 'email'), DIV(null), this.inputBox('password', t("password"), 'password'), this.resetPasswordLink()], 'email + password']].concat(this.userQuestionInputs()))), this.footerForRegistrationAndLogin()];
	      case 'create account':
	      case 'create account via invitation':
	        if (avatar_field = this.avatarInput()) {
	          avatar_field = [(t('pic_prompt')) + ":", avatar_field];
	        }
	        if (pledges = this.pledgeInput()) {
	          pledges_field = ['I pledge to:', pledges];
	        }
	        if (auth.form === 'create account') {
	          email_field = this.inputBox('email', 'email@address', 'email');
	          footer = this.footerForRegistrationAndLogin();
	        } else {
	          email_field = DIV({
	            style: {
	              color: auth_text_gray,
	              padding: '4px 8px'
	            }
	          }, current_user.email);
	          footer = this.submitButton(t('Create new account'));
	        }
	        return [this.headerAndBorder(goal, t('Introduce Yourself'), this.body([[(t('login_as')) + ":", [email_field, this.inputBox('password', t("password"), 'password')], 'email + password'], avatar_field, [t('name_prompt'), this.inputBox('name', t('full_name'))], pledges_field].concat(this.userQuestionInputs()))), footer];
	      case 'edit profile':
	        if (avatar_field = this.avatarInput()) {
	          avatar_field = [(t('pic_prompt')) + ":", avatar_field];
	        }
	        return [
	          this.headerAndBorder(null, t('Your Profile'), this.body([[(t('login_as')) + ":", [this.inputBox('email', 'email@address', 'email'), this.inputBox('password', t("password"), 'password')]], [(t('name_prompt')) + ":", this.inputBox('name', t('full_name'))], avatar_field].concat(this.userQuestionInputs()))), this.submitButton(t('Update')), this.local.saved_successfully ? SPAN({
	            style: {
	              color: 'green'
	            }
	          }, t("Updated successfully")) : void 0
	        ];
	      case 'reset password':
	        return [this.headerAndBorder(null, t('Reset Your Password'), this.body([[(t('Code')) + ":", this.inputBox('verification_code', t('code_from_email'))], [(t('New password')) + ":", this.inputBox('password', t("choose_password"), 'password')]], t('verification_sent'))), this.submitButton(t('Log in'))];
	      case 'verify email':
	        return [this.headerAndBorder(goal, t('Verify Your Email'), this.body([[(t('Code')) + ":", this.inputBox('verification_code', t('code_from_email'))]], t('verification_sent'))), this.submitButton(t('Verify'))];
	      case 'user questions':
	        return [this.headerAndBorder(goal, t('more_info'), this.body(this.userQuestionInputs())), this.submitButton((t('Done')) + "!")];
	      default:
	        throw "Unrecognized authentication form " + auth.form;
	    }
	  },
	  headerAndBorder: function(goal, task, body) {
	    var auth;
	    auth = fetch('auth');
	    if (this.props.naked) {
	      return body;
	    }
	    return DIV(null, DIV({
	      style: {
	        width: AUTH_WIDTH(),
	        position: 'relative',
	        margin: 'auto',
	        top: 5
	      }
	    }, DIV({
	      style: {
	        textAlign: 'center',
	        position: 'relative'
	      }
	    }, goal ? DIV({
	      style: {
	        fontWeight: 600,
	        fontSize: 18,
	        color: focus_blue,
	        transform: 'translateY(6px)'
	      }
	    }, goal) : void 0, DIV({
	      style: {
	        position: 'relative',
	        marginBottom: 10,
	        fontWeight: 600,
	        fontSize: 61,
	        whiteSpace: 'nowrap',
	        color: focus_blue
	      }
	    }, SPAN({
	      style: {
	        position: 'relative'
	      }
	    }, task), auth.form !== 'edit profile' ? SPAN({
	      style: {
	        color: auth_ghost_gray,
	        position: 'absolute',
	        cursor: 'pointer',
	        right: 0,
	        top: 70,
	        padding: 10,
	        fontSize: 24
	      },
	      title: t('cancel'),
	      onClick: (function(_this) {
	        return function() {
	          if (auth.form === 'verify email' || location.pathname === '/proposal/new') {
	            loadPage('/');
	          }
	          if (auth.form === 'verify email') {
	            setTimeout(logout, 1);
	          }
	          return reset_key(auth);
	        };
	      })(this)
	    }, I({
	      className: 'fa-close fa'
	    }), ' ' + t('cancel')) : void 0)), DIV({
	      style: {
	        left: AUTH_WIDTH() / 2,
	        height: 50,
	        width: 50,
	        top: 0,
	        borderRadius: '50%',
	        marginLeft: -50 / 2,
	        backgroundColor: focus_blue,
	        position: 'relative',
	        boxShadow: "0px 1px 0px black, inset 0 1px 2px rgba(255,255,255, .4), 0px 0px 0px 1px " + focus_blue
	      }
	    }), DIV({
	      key: 'auth_bubblemouth',
	      style: css.crossbrowserify({
	        left: AUTH_WIDTH() / 2 - 34 / 2,
	        top: 10 + 3 + 1,
	        position: 'relative'
	      })
	    }, Bubblemouth({
	      apex_xfrac: .5,
	      width: 34,
	      height: 28,
	      fill: 'white',
	      stroke: focus_blue,
	      stroke_width: 11,
	      dash_array: "25 10"
	    }))), DIV({
	      className: this.local.submitting ? ' waiting' : '',
	      style: {
	        padding: '2.5em 46px 1.5em 46px',
	        fontSize: 18,
	        marginTop: 10,
	        borderRadius: 16,
	        borderStyle: 'dashed',
	        borderWidth: 3,
	        borderColor: focus_blue
	      }
	    }, body));
	  },
	  body: function(fields, additional_instructions) {
	    var additional, current_user, error, errors, field;
	    current_user = fetch('/current_user');
	    return DIV(null, additional_instructions ? DIV({
	      style: {
	        color: auth_text_gray,
	        marginBottom: 18
	      }
	    }, additional_instructions) : void 0, TABLE(null, TBODY(null, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = fields.length; i < len; i++) {
	        field = fields[i];
	        if (field) {
	          results.push([
	            TR(null, TD({
	              style: {
	                paddingTop: 4,
	                verticalAlign: 'top',
	                width: '30%'
	              }
	            }, LABEL({
	              style: {
	                color: focus_blue,
	                fontWeight: 600,
	                fontSize: browser.is_mobile ? 24 : void 0
	              }
	            }, field[0]), field.length > 2 ? LABEL({
	              style: {
	                display: 'block',
	                color: auth_ghost_gray,
	                fontSize: 14
	              }
	            }, field[2]) : void 0), TD({
	              style: {
	                verticalAlign: 'bottom',
	                width: '100%',
	                paddingLeft: 18
	              }
	            }, field[1])), TR({
	              style: {
	                height: 10
	              }
	            })
	          ]);
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })())), customization('additional_auth_footer') ? (additional = customization('additional_auth_footer')(), additional ? additional : void 0) : void 0, (current_user.errors || []).length > 0 || this.local.errors.length > 0 ? (errors = current_user.errors.concat(this.local.errors || []), DIV({
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = errors.length; i < len; i++) {
	        error = errors[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    })())) : void 0);
	  },
	  footerForRegistrationAndLogin: function() {
	    var auth, button, toggle_to;
	    auth = fetch('auth');
	    if (auth.form === 'create account') {
	      toggle_to = t('Log in');
	      button = t('Create new account');
	    } else {
	      button = t('Log in');
	      toggle_to = t('Create new account');
	    }
	    return DIV({
	      style: {
	        position: 'relative',
	        left: '50%',
	        marginLeft: -(widthWhenRendered(button, {
	          fontSize: 24
	        }) + 36 * 2) / 2
	      }
	    }, this.submitButton(button, true), SPAN({
	      style: {
	        marginTop: 23,
	        textAlign: 'left',
	        width: '100%'
	      }
	    }, SPAN({
	      style: {
	        color: '#444',
	        fontSize: 24,
	        paddingLeft: 18,
	        paddingRight: 7
	      }
	    }, 'or '), A({
	      style: {
	        display: 'inline-block',
	        color: '#444',
	        textDecoration: 'underline',
	        fontWeight: 400,
	        fontSize: 24
	      },
	      onClick: (function(_this) {
	        return function() {
	          var current_user;
	          current_user = fetch('/current_user');
	          auth.form = auth.form === 'create account' ? 'login' : 'create account';
	          current_user.errors = [];
	          _this.local.errors = [];
	          save(auth);
	          return save(_this.local);
	        };
	      })(this)
	    }, toggle_to)));
	  },
	  submitButton: function(action, inline) {
	    return DIV({
	      style: {
	        fontSize: 24,
	        display: inline ? 'inline-block' : 'block'
	      },
	      className: 'primary_button' + (this.local.submitting ? ' disabled' : ''),
	      onClick: this.submitAuth
	    }, action);
	  },
	  inputBox: function(name, placeholder, type, onChange, pattern) {
	    var auth, current_user;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (!onChange) {
	      onChange = (function(_this) {
	        return function(event) {
	          _this.local[name] = current_user[name] = event.target.value;
	          return save(_this.local);
	        };
	      })(this);
	    }
	    if (this.local[name] !== current_user[name]) {
	      this.local[name] = current_user[name];
	      save(this.local);
	      return SPAN(null);
	    }
	    return INPUT({
	      id: 'user_' + name,
	      className: 'auth_text_input',
	      style: {
	        marginBottom: 6,
	        width: Math.max(300, AUTH_WIDTH() * .55),
	        border: "1px solid " + auth_ghost_gray,
	        padding: '5px 10px',
	        fontSize: browser.is_mobile ? 36 : 18,
	        display: 'inline-block'
	      },
	      value: auth.form === 'edit profile' ? this.local[name] : null,
	      name: "user[" + name + "]",
	      key: name + "_inputBox",
	      placeholder: placeholder,
	      required: "required",
	      type: type || 'text',
	      onChange: onChange,
	      onKeyPress: (function(_this) {
	        return function(event) {
	          if (event.which === 13) {
	            return _this.submitAuth(event);
	          }
	        };
	      })(this),
	      pattern: pattern
	    });
	  },
	  avatarInput: function() {
	    var current_user;
	    if (window.FormData) {
	      current_user = fetch('/current_user');
	      return FORM({
	        id: 'user_avatar_form',
	        action: '/update_user_avatar_hack'
	      }, DIV({
	        style: {
	          height: 60,
	          width: 60,
	          borderRadius: '50%',
	          backgroundColor: '#e6e6e6',
	          overflow: 'hidden',
	          display: 'inline-block',
	          marginRight: 18
	        }
	      }, IMG({
	        id: 'avatar_preview',
	        style: {
	          width: 60
	        },
	        src: current_user.b64_thumbnail ? current_user.b64_thumbnail : current_user.avatar_remote_url ? current_user.avatar_remote_url : null
	      })), INPUT({
	        id: 'user_avatar',
	        name: "avatar",
	        type: "file",
	        style: {
	          marginTop: 24,
	          verticalAlign: 'top'
	        },
	        onChange: (function(_this) {
	          return function(ev) {
	            var input, reader;
	            _this.submit_avatar_form = true;
	            input = $('#user_avatar')[0];
	            if (input.files && input.files[0]) {
	              reader = new FileReader();
	              reader.onload = function(e) {
	                return $("#avatar_preview").attr('src', e.target.result);
	              };
	              return reader.readAsDataURL(input.files[0]);
	            } else {
	              return $("#avatar_preview").attr('src', asset('no_image_preview.png'));
	            }
	          };
	        })(this)
	      }));
	    } else {
	      return null;
	    }
	  },
	  pledgeInput: function() {
	    var idx, pledge, pledges, subdomain;
	    subdomain = fetch('/subdomain');
	    if (!customization('civility_pledge')) {
	      return null;
	    } else {
	      if (subdomain.name === 'livingvotersguide') {
	        pledges = ['Use only one account', 'Speak only on behalf of myself', 'Not attack or mock others'];
	      } else {
	        pledges = ['Use only one account', 'Not attack or mock others'];
	      }
	    }
	    return UL({
	      style: {
	        paddingTop: 6
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = pledges.length; i < len; idx = ++i) {
	        pledge = pledges[idx];
	        results.push(LI({
	          style: {
	            listStyle: 'none',
	            position: 'relative',
	            paddingLeft: 30,
	            paddingBottom: 3,
	            color: auth_text_gray
	          }
	        }, INPUT({
	          className: "pledge-input",
	          type: 'checkbox',
	          id: "pledge-" + idx,
	          name: "pledge-" + idx,
	          style: {
	            fontSize: 24,
	            position: 'absolute',
	            left: 0,
	            top: 5,
	            margin: 0
	          }
	        }), LABEL({
	          htmlFor: "pledge-" + idx,
	          style: {
	            fontSize: 18
	          }
	        }, pledge)));
	      }
	      return results;
	    })());
	  },
	  resetPasswordLink: function() {
	    return DIV({
	      style: {
	        textAlign: 'right',
	        fontSize: 18,
	        width: 300
	      }
	    }, A({
	      style: {
	        textDecoration: 'underline',
	        color: auth_ghost_gray
	      },
	      onClick: (function(_this) {
	        return function() {
	          var current_user;
	          current_user = fetch('/current_user');
	          current_user.trying_to = 'send_password_reset_token';
	          return save(current_user, function() {
	            var ref;
	            if (((ref = current_user.errors) != null ? ref.length : void 0) > 0) {
	              return arest.updateCache(current_user);
	            } else {
	              return reset_key('auth', {
	                form: 'reset password'
	              });
	            }
	          });
	        };
	      })(this)
	    }, t('forgot_password')));
	  },
	  userQuestionInputs: function() {
	    var auth, current_user, i, input, inputs, label, len, question, questions, ref, subdomain, value;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (auth.ask_questions && ((ref = auth.form) === 'edit profile' || ref === 'create account' || ref === 'create account via invitation')) {
	      questions = customization('auth.user_questions');
	    } else {
	      questions = [];
	    }
	    if (this.local.tags !== current_user.tags) {
	      this.local.tags = current_user.tags;
	      save(this.local);
	      return SPAN(null);
	    }
	    inputs = [];
	    for (i = 0, len = questions.length; i < len; i++) {
	      question = questions[i];
	      label = question.question + ":";
	      switch (question.input) {
	        case 'text':
	          input = INPUT({
	            style: _.defaults(question.input_style || {}, {
	              marginBottom: 6,
	              width: 300,
	              border: "1px solid " + auth_ghost_gray,
	              padding: '5px 10px',
	              fontSize: 18
	            }),
	            key: question.tag + "_inputBox",
	            type: 'text',
	            value: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question),
	            onKeyPress: (function(_this) {
	              return function(event) {
	                if (event.which === 13) {
	                  return _this.submitAuth(event);
	                }
	              };
	            })(this)
	          });
	          break;
	        case 'boolean':
	          input = INPUT({
	            type: 'checkbox',
	            style: _.defaults(question.input_style || {}, {
	              fontSize: 24,
	              marginTop: 10
	            }),
	            checked: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.checked;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question)
	          });
	          break;
	        case 'dropdown':
	          input = SELECT({
	            style: _.defaults(question.input_style || {}, {
	              fontSize: 18,
	              marginTop: 4
	            }),
	            value: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question)
	          }, [
	            OPTION({
	              value: '',
	              selected: true,
	              disabled: true,
	              hidden: true
	            }), (function() {
	              var j, len1, ref1, results;
	              ref1 = question.options;
	              results = [];
	              for (j = 0, len1 = ref1.length; j < len1; j++) {
	                value = ref1[j];
	                results.push(OPTION({
	                  value: value
	                }, value));
	              }
	              return results;
	            })()
	          ]);
	          break;
	        default:
	          throw "Unsupported question type: " + question.input + " for " + question.tag;
	      }
	      inputs.push([label, input]);
	    }
	    return inputs;
	  },
	  submitAuth: function(ev) {
	    var $el, auth, current_user, has_response, i, is_valid_input, len, question, questions, subdomain;
	    ev.preventDefault();
	    $el = $(this.getDOMNode());
	    subdomain = fetch('/subdomain');
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    if (auth.ask_questions) {
	      questions = customization('auth.user_questions');
	      this.local.errors = [];
	      for (i = 0, len = questions.length; i < len; i++) {
	        question = questions[i];
	        if (question.required) {
	          has_response = !!current_user.tags[question.tag];
	          if (!has_response) {
	            this.local.errors.push(question.question + " required!");
	          }
	          is_valid_input = true;
	          if (question.validation) {
	            is_valid_input = question.validation(current_user.tags[question.tag]);
	          }
	          if (!is_valid_input && has_response) {
	            this.local.errors.push(current_user.tags[question.tag] + " isn't a valid answer to " + question.question + "!");
	          }
	        }
	      }
	      save(this.local);
	    }
	    if (this.local.errors.length === 0) {
	      this.local.submitting = true;
	      save(this.local);
	      current_user.signed_pledge = $el.find('.pledge-input').length === $el.find('.pledge-input:checked').length;
	      current_user.trying_to = auth.form;
	      save(current_user, (function(_this) {
	        return function() {
	          var ref;
	          if ((ref = auth.form) === 'create account' || ref === 'edit profile') {
	            ensureCurrentUserAvatar();
	          }
	          if (auth.form === 'edit profile') {
	            _this.local.saved_successfully = current_user.errors.length === 0 && (_this.local.errors || []).length === 0;
	          } else if (current_user.logged_in) {
	            if (auth.goal === 'Save your Opinion') {
	              setTimeout((function() {
	                return updateProposalMode('results', 'after_save');
	              }), 700);
	            }
	            reset_key(auth);
	          }
	          _this.local.submitting = false;
	          return save(_this.local);
	        };
	      })(this));
	      if (this.submit_avatar_form) {
	        return $('#user_avatar_form').ajaxSubmit({
	          type: 'PUT',
	          data: {
	            authenticity_token: current_user.csrf,
	            trying_to: 'update_avatar_hack'
	          }
	        });
	      }
	    }
	  },
	  componentDidMount: function() {
	    return writeToLog({
	      what: 'accessed authentication'
	    });
	  }
	});

	ensureCurrentUserAvatar = function(attempts) {
	  if (attempts == null) {
	    attempts = 0;
	  }
	  return $.getJSON('/user_avatar_hack', (function(_this) {
	    return function(response) {
	      var current_user, ref;
	      current_user = fetch('/current_user');
	      if ((response != null ? (ref = response[0]) != null ? ref.b64_thumbnail : void 0 : void 0) && current_user.b64_thumbnail !== response[0].b64_thumbnail) {
	        $('head').append("<style type=\"text/css\">#avatar-" + current_user.id + " { background-image: url('" + response[0].b64_thumbnail + "');}</style>");
	        current_user.b64_thumbnail = response[0].b64_thumbnail;
	        return save(current_user);
	      } else if (attempts < 20) {
	        return _.delay(function() {
	          return ensureCurrentUserAvatar(attempts + 1);
	        }, 1000);
	      }
	    };
	  })(this));
	};

	styles += "\n.auth_text_input::-webkit-input-placeholder{\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input:-moz-placeholder{\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input::-moz-placeholder {\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input::-ms-input-placeholder {\n  color: " + auth_ghost_gray + ";\n}";

	window.Auth = Auth;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/*! Quill Editor v0.19.12
	 *  https://quilljs.com/
	 *  Copyright (c) 2014, Jason Chen
	 *  Copyright (c) 2013, salesforce.com
	 */
	(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Quill = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	(function (global){
	/**
	 * @license
	 * lodash 3.5.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern include="difference,intersection,last,all,each,find,invoke,map,reduce,bind,defer,partial,clone,extend,defaults,omit,values,isElement,isEqual,isFunction,isNumber,isObject,isString,uniqueId" --development --output .build/lodash.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used as the semantic version number. */
	  var VERSION = '3.5.0';

	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      REARG_FLAG = 128,
	      ARY_FLAG = 256;

	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;

	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect named functions. */
	  var reFuncName = /^\s*function[ \n\r\t]+\w/;

	  /** Used to detect host constructors (Safari > 5). */
	  var reHostCtor = /^\[object .+?Constructor\]$/;

	  /**
	   * Used to match `RegExp` special characters.
	   * See this [article on `RegExp` characters](http://www.regular-expressions.info/characters.html#special)
	   * for more details.
	   */
	  var reRegExpChars = /[.*+?^${}()|[\]\/\\]/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);

	  /** Used to detect functions containing a `this` reference. */
	  var reThis = /\bthis\b/;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };

	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;

	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it is the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || this;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }

	  /**
	   * Converts `value` to a string if it is not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    if (typeof value == 'string') {
	      return value;
	    }
	    return value == null ? '' : (value + '');
	  }

	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   * If `fromRight` is provided elements of `array` are iterated from right to left.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return (value && typeof value == 'object') || false;
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];

	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }

	  /*--------------------------------------------------------------------------*/

	  /** Used for native method references. */
	  var objectProto = Object.prototype;

	  /** Used to detect DOM support. */
	  var document = (document = root.window) && document.document;

	  /** Used to resolve the decompiled source of functions. */
	  var fnToString = Function.prototype.toString;

	  /** Used to check objects for own properties. */
	  var hasOwnProperty = objectProto.hasOwnProperty;

	  /** Used to generate unique IDs. */
	  var idCounter = 0;

	  /**
	   * Used to resolve the `toStringTag` of values.
	   * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	   * for more details.
	   */
	  var objToString = objectProto.toString;

	  /** Used to detect if a method is native. */
	  var reNative = RegExp('^' +
	    escapeRegExp(objToString)
	    .replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	  );

	  /** Native method references. */
	  var ArrayBuffer = isNative(ArrayBuffer = root.ArrayBuffer) && ArrayBuffer,
	      bufferSlice = isNative(bufferSlice = ArrayBuffer && new ArrayBuffer(0).slice) && bufferSlice,
	      floor = Math.floor,
	      getPrototypeOf = isNative(getPrototypeOf = Object.getPrototypeOf) && getPrototypeOf,
	      propertyIsEnumerable = objectProto.propertyIsEnumerable,
	      Set = isNative(Set = root.Set) && Set,
	      Uint8Array = isNative(Uint8Array = root.Uint8Array) && Uint8Array,
	      WeakMap = isNative(WeakMap = root.WeakMap) && WeakMap;

	  /** Used to clone array buffers. */
	  var Float64Array = (function() {
	    // Safari 5 errors when using an array buffer to initialize a typed array
	    // where the array buffer's `byteLength` is not a multiple of the typed
	    // array's `BYTES_PER_ELEMENT`.
	    try {
	      var func = isNative(func = root.Float64Array) && func,
	          result = new func(new ArrayBuffer(10), 0, 1) && func;
	    } catch(e) {}
	    return result;
	  }());

	  /* Native method references for those with the same name as other `lodash` methods. */
	  var nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray,
	      nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate,
	      nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys,
	      nativeMax = Math.max,
	      nativeMin = Math.min,
	      nativeNow = isNative(nativeNow = Date.now) && nativeNow;

	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1,
	      MAX_ARRAY_INDEX =  MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	  /** Used as the size, in bytes, of each `Float64Array` element. */
	  var FLOAT64_BYTES_PER_ELEMENT = Float64Array ? Float64Array.BYTES_PER_ELEMENT : 0;

	  /**
	   * Used as the maximum length of an array-like value.
	   * See the [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	   * for more details.
	   */
	  var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;

	  /** Used to store function metadata. */
	  var metaMap = WeakMap && new WeakMap;

	  /*------------------------------------------------------------------------*/

	  /**
	   * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	   * Methods that operate on and return arrays, collections, and functions can
	   * be chained together. Methods that return a boolean or single value will
	   * automatically end the chain returning the unwrapped value. Explicit chaining
	   * may be enabled using `_.chain`. The execution of chained methods is lazy,
	   * that is, execution is deferred until `_#value` is implicitly or explicitly
	   * called.
	   *
	   * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	   * fusion is an optimization that merges iteratees to avoid creating intermediate
	   * arrays and reduce the number of iteratee executions.
	   *
	   * Chaining is supported in custom builds as long as the `_#value` method is
	   * directly or indirectly included in the build.
	   *
	   * In addition to lodash methods, wrappers have `Array` and `String` methods.
	   *
	   * The wrapper `Array` methods are:
	   * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	   * `splice`, and `unshift`
	   *
	   * The wrapper `String` methods are:
	   * `replace` and `split`
	   *
	   * The wrapper methods that support shortcut fusion are:
	   * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	   * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	   * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	   * and `where`
	   *
	   * The chainable wrapper methods are:
	   * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	   * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	   * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defer`, `delay`,
	   * `difference`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `fill`,
	   * `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`, `forEach`,
	   * `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `functions`,
	   * `groupBy`, `indexBy`, `initial`, `intersection`, `invert`, `invoke`, `keys`,
	   * `keysIn`, `map`, `mapValues`, `matches`, `matchesProperty`, `memoize`, `merge`,
	   * `mixin`, `negate`, `noop`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	   * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	   * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `reverse`,
	   * `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`, `sortByOrder`, `splice`,
	   * `spread`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `tap`,
	   * `throttle`, `thru`, `times`, `toArray`, `toPlainObject`, `transform`,
	   * `union`, `uniq`, `unshift`, `unzip`, `values`, `valuesIn`, `where`,
	   * `without`, `wrap`, `xor`, `zip`, and `zipObject`
	   *
	   * The wrapper methods that are **not** chainable by default are:
	   * `add`, `attempt`, `camelCase`, `capitalize`, `clone`, `cloneDeep`, `deburr`,
	   * `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`,
	   * `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`, `has`,
	   * `identity`, `includes`, `indexOf`, `inRange`, `isArguments`, `isArray`,
	   * `isBoolean`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isError`,
	   * `isFinite`,`isFunction`, `isMatch`, `isNative`, `isNaN`, `isNull`, `isNumber`,
	   * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`,
	   * `isTypedArray`, `join`, `kebabCase`, `last`, `lastIndexOf`, `max`, `min`,
	   * `noConflict`, `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`,
	   * `random`, `reduce`, `reduceRight`, `repeat`, `result`, `runInContext`,
	   * `shift`, `size`, `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`,
	   * `startCase`, `startsWith`, `sum`, `template`, `trim`, `trimLeft`,
	   * `trimRight`, `trunc`, `unescape`, `uniqueId`, `value`, and `words`
	   *
	   * The wrapper method `sample` will return a wrapped value when `n` is provided,
	   * otherwise an unwrapped value is returned.
	   *
	   * @name _
	   * @constructor
	   * @category Chain
	   * @param {*} value The value to wrap in a `lodash` instance.
	   * @returns {Object} Returns the new `lodash` wrapper instance.
	   * @example
	   *
	   * var wrapped = _([1, 2, 3]);
	   *
	   * // returns an unwrapped value
	   * wrapped.reduce(function(sum, n) {
	   *   return sum + n;
	   * });
	   * // => 6
	   *
	   * // returns a wrapped value
	   * var squares = wrapped.map(function(n) {
	   *   return n * n;
	   * });
	   *
	   * _.isArray(squares);
	   * // => false
	   *
	   * _.isArray(squares.value());
	   * // => true
	   */
	  function lodash() {
	    // No operation performed.
	  }

	  /**
	   * An object environment feature flags.
	   *
	   * @static
	   * @memberOf _
	   * @type Object
	   */
	  var support = lodash.support = {};

	  (function(x) {

	    /**
	     * Detect if functions can be decompiled by `Function#toString`
	     * (all but Firefox OS certified apps, older Opera mobile browsers, and
	     * the PlayStation 3; forced `false` for Windows 8 apps).
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    support.funcDecomp = !isNative(root.WinRTError) && reThis.test(function() { return this; });

	    /**
	     * Detect if `Function#name` is supported (all but IE).
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    support.funcNames = typeof Function.name == 'string';

	    /**
	     * Detect if the DOM is supported.
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    try {
	      support.dom = document.createDocumentFragment().nodeType === 11;
	    } catch(e) {
	      support.dom = false;
	    }

	    /**
	     * Detect if `arguments` object indexes are non-enumerable.
	     *
	     * In Firefox < 4, IE < 9, PhantomJS, and Safari < 5.1 `arguments` object
	     * indexes are non-enumerable. Chrome < 25 and Node.js < 0.11.0 treat
	     * `arguments` object indexes as non-enumerable and fail `hasOwnProperty`
	     * checks for indexes that exceed their function's formal parameters with
	     * associated values of `0`.
	     *
	     * @memberOf _.support
	     * @type boolean
	     */
	    try {
	      support.nonEnumArgs = !propertyIsEnumerable.call(arguments, 1);
	    } catch(e) {
	      support.nonEnumArgs = true;
	    }
	  }(0, 0));

	  /*------------------------------------------------------------------------*/

	  /**
	   *
	   * Creates a cache object to store unique values.
	   *
	   * @private
	   * @param {Array} [values] The values to cache.
	   */
	  function SetCache(values) {
	    var length = values ? values.length : 0;

	    this.data = { 'hash': nativeCreate(null), 'set': new Set };
	    while (length--) {
	      this.push(values[length]);
	    }
	  }

	  /**
	   * Checks if `value` is in `cache` mimicking the return signature of
	   * `_.indexOf` by returning `0` if the value is found, else `-1`.
	   *
	   * @private
	   * @param {Object} cache The cache to search.
	   * @param {*} value The value to search for.
	   * @returns {number} Returns `0` if `value` is found, else `-1`.
	   */
	  function cacheIndexOf(cache, value) {
	    var data = cache.data,
	        result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

	    return result ? 0 : -1;
	  }

	  /**
	   * Adds `value` to the cache.
	   *
	   * @private
	   * @name push
	   * @memberOf SetCache
	   * @param {*} value The value to cache.
	   */
	  function cachePush(value) {
	    var data = this.data;
	    if (typeof value == 'string' || isObject(value)) {
	      data.set.add(value);
	    } else {
	      data.hash[value] = true;
	    }
	  }

	  /*------------------------------------------------------------------------*/

	  /**
	   * Copies the values of `source` to `array`.
	   *
	   * @private
	   * @param {Array} source The array to copy values from.
	   * @param {Array} [array=[]] The array to copy values to.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayCopy(source, array) {
	    var index = -1,
	        length = source.length;

	    array || (array = Array(length));
	    while (++index < length) {
	      array[index] = source[index];
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.forEach` for arrays without support for callback
	   * shorthands or `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array.length;

	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.every` for arrays without support for callback
	   * shorthands or `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array.length;

	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }

	  /**
	   * A specialized version of `_.map` for arrays without support for callback
	   * shorthands or `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array.length,
	        result = Array(length);

	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }

	  /**
	   * A specialized version of `_.reduce` for arrays without support for callback
	   * shorthands or `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initFromArray] Specify using the first element of `array`
	   *  as the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initFromArray) {
	    var index = -1,
	        length = array.length;

	    if (initFromArray && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }

	  /**
	   * Used by `_.defaults` to customize its `_.assign` use.
	   *
	   * @private
	   * @param {*} objectValue The destination object property value.
	   * @param {*} sourceValue The source object property value.
	   * @returns {*} Returns the value to assign to the destination object.
	   */
	  function assignDefaults(objectValue, sourceValue) {
	    return typeof objectValue == 'undefined' ? sourceValue : objectValue;
	  }

	  /**
	   * The base implementation of `_.assign` without support for argument juggling,
	   * multiple sources, and `this` binding `customizer` functions.
	   *
	   * @private
	   * @param {Object} object The destination object.
	   * @param {Object} source The source object.
	   * @param {Function} [customizer] The function to customize assigning values.
	   * @returns {Object} Returns the destination object.
	   */
	  function baseAssign(object, source, customizer) {
	    var props = keys(source);
	    if (!customizer) {
	      return baseCopy(source, object, props);
	    }
	    var index = -1,
	        length = props.length;

	    while (++index < length) {
	      var key = props[index],
	          value = object[key],
	          result = customizer(value, source[key], key, object, source);

	      if ((result === result ? (result !== value) : (value === value)) ||
	          (typeof value == 'undefined' && !(key in object))) {
	        object[key] = result;
	      }
	    }
	    return object;
	  }

	  /**
	   * Copies the properties of `source` to `object`.
	   *
	   * @private
	   * @param {Object} source The object to copy properties from.
	   * @param {Object} [object={}] The object to copy properties to.
	   * @param {Array} props The property names to copy.
	   * @returns {Object} Returns `object`.
	   */
	  function baseCopy(source, object, props) {
	    if (!props) {
	      props = object;
	      object = {};
	    }
	    var index = -1,
	        length = props.length;

	    while (++index < length) {
	      var key = props[index];
	      object[key] = source[key];
	    }
	    return object;
	  }

	  /**
	   * The base implementation of `_.callback` which supports specifying the
	   * number of arguments to provide to `func`.
	   *
	   * @private
	   * @param {*} [func=_.identity] The value to convert to a callback.
	   * @param {*} [thisArg] The `this` binding of `func`.
	   * @param {number} [argCount] The number of arguments to provide to `func`.
	   * @returns {Function} Returns the callback.
	   */
	  function baseCallback(func, thisArg, argCount) {
	    var type = typeof func;
	    if (type == 'function') {
	      return (typeof thisArg != 'undefined' && isBindable(func))
	        ? bindCallback(func, thisArg, argCount)
	        : func;
	    }
	    if (func == null) {
	      return identity;
	    }
	    if (type == 'object') {
	      return baseMatches(func);
	    }
	    return typeof thisArg == 'undefined'
	      ? baseProperty(func + '')
	      : baseMatchesProperty(func + '', thisArg);
	  }

	  /**
	   * The base implementation of `_.clone` without support for argument juggling
	   * and `this` binding `customizer` functions.
	   *
	   * @private
	   * @param {*} value The value to clone.
	   * @param {boolean} [isDeep] Specify a deep clone.
	   * @param {Function} [customizer] The function to customize cloning values.
	   * @param {string} [key] The key of `value`.
	   * @param {Object} [object] The object `value` belongs to.
	   * @param {Array} [stackA=[]] Tracks traversed source objects.
	   * @param {Array} [stackB=[]] Associates clones with source counterparts.
	   * @returns {*} Returns the cloned value.
	   */
	  function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	    var result;
	    if (customizer) {
	      result = object ? customizer(value, key, object) : customizer(value);
	    }
	    if (typeof result != 'undefined') {
	      return result;
	    }
	    if (!isObject(value)) {
	      return value;
	    }
	    var isArr = isArray(value);
	    if (isArr) {
	      result = initCloneArray(value);
	      if (!isDeep) {
	        return arrayCopy(value, result);
	      }
	    } else {
	      var tag = objToString.call(value),
	          isFunc = tag == funcTag;

	      if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	        result = initCloneObject(isFunc ? {} : value);
	        if (!isDeep) {
	          return baseCopy(value, result, keys(value));
	        }
	      } else {
	        return cloneableTags[tag]
	          ? initCloneByTag(value, tag, isDeep)
	          : (object ? value : {});
	      }
	    }
	    // Check for circular references and return corresponding clone.
	    stackA || (stackA = []);
	    stackB || (stackB = []);

	    var length = stackA.length;
	    while (length--) {
	      if (stackA[length] == value) {
	        return stackB[length];
	      }
	    }
	    // Add the source value to the stack of traversed objects and associate it with its clone.
	    stackA.push(value);
	    stackB.push(result);

	    // Recursively populate clone (susceptible to call stack limits).
	    (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	      result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.create` without support for assigning
	   * properties to the created object.
	   *
	   * @private
	   * @param {Object} prototype The object to inherit from.
	   * @returns {Object} Returns the new object.
	   */
	  var baseCreate = (function() {
	    function Object() {}
	    return function(prototype) {
	      if (isObject(prototype)) {
	        Object.prototype = prototype;
	        var result = new Object;
	        Object.prototype = null;
	      }
	      return result || root.Object();
	    };
	  }());

	  /**
	   * The base implementation of `_.delay` and `_.defer` which accepts an index
	   * of where to slice the arguments to provide to `func`.
	   *
	   * @private
	   * @param {Function} func The function to delay.
	   * @param {number} wait The number of milliseconds to delay invocation.
	   * @param {Object} args The `arguments` object to slice and provide to `func`.
	   * @returns {number} Returns the timer id.
	   */
	  function baseDelay(func, wait, args, fromIndex) {
	    if (typeof func != 'function') {
	      throw new TypeError(FUNC_ERROR_TEXT);
	    }
	    return setTimeout(function() { func.apply(undefined, baseSlice(args, fromIndex)); }, wait);
	  }

	  /**
	   * The base implementation of `_.difference` which accepts a single array
	   * of values to exclude.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Array} values The values to exclude.
	   * @returns {Array} Returns the new array of filtered values.
	   */
	  function baseDifference(array, values) {
	    var length = array ? array.length : 0,
	        result = [];

	    if (!length) {
	      return result;
	    }
	    var index = -1,
	        indexOf = getIndexOf(),
	        isCommon = indexOf == baseIndexOf,
	        cache = (isCommon && values.length >= 200) ? createCache(values) : null,
	        valuesLength = values.length;

	    if (cache) {
	      indexOf = cacheIndexOf;
	      isCommon = false;
	      values = cache;
	    }
	    outer:
	    while (++index < length) {
	      var value = array[index];

	      if (isCommon && value === value) {
	        var valuesIndex = valuesLength;
	        while (valuesIndex--) {
	          if (values[valuesIndex] === value) {
	            continue outer;
	          }
	        }
	        result.push(value);
	      }
	      else if (indexOf(values, value, 0) < 0) {
	        result.push(value);
	      }
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.forEach` without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array|Object|string} Returns `collection`.
	   */
	  function baseEach(collection, iteratee) {
	    var length = collection ? collection.length : 0;
	    if (!isLength(length)) {
	      return baseForOwn(collection, iteratee);
	    }
	    var index = -1,
	        iterable = toObject(collection);

	    while (++index < length) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  }

	  /**
	   * The base implementation of `_.every` without support for callback
	   * shorthands or `this` binding.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`
	   */
	  function baseEvery(collection, predicate) {
	    var result = true;
	    baseEach(collection, function(value, index, collection) {
	      result = !!predicate(value, index, collection);
	      return result;
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	   * without support for callback shorthands and `this` binding, which iterates
	   * over `collection` using the provided `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @param {boolean} [retKey] Specify returning the key of the found element
	   *  instead of the element itself.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFind(collection, predicate, eachFunc, retKey) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = retKey ? key : value;
	        return false;
	      }
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.flatten` with added support for restricting
	   * flattening and specifying the start index.
	   *
	   * @private
	   * @param {Array} array The array to flatten.
	   * @param {boolean} isDeep Specify a deep flatten.
	   * @param {boolean} isStrict Restrict flattening to arrays and `arguments` objects.
	   * @param {number} fromIndex The index to start from.
	   * @returns {Array} Returns the new flattened array.
	   */
	  function baseFlatten(array, isDeep, isStrict, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length,
	        resIndex = -1,
	        result = [];

	    while (++index < length) {
	      var value = array[index];

	      if (isObjectLike(value) && isLength(value.length) && (isArray(value) || isArguments(value))) {
	        if (isDeep) {
	          // Recursively flatten arrays (susceptible to call stack limits).
	          value = baseFlatten(value, isDeep, isStrict, 0);
	        }
	        var valIndex = -1,
	            valLength = value.length;

	        result.length += valLength;
	        while (++valIndex < valLength) {
	          result[++resIndex] = value[valIndex];
	        }
	      } else if (!isStrict) {
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `baseForIn` and `baseForOwn` which iterates
	   * over `object` properties returned by `keysFunc` invoking `iteratee` for
	   * each property. Iterator functions may exit iteration early by explicitly
	   * returning `false`.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {Function} keysFunc The function to get the keys of `object`.
	   * @returns {Object} Returns `object`.
	   */
	  function baseFor(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (++index < length) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  }

	  /**
	   * The base implementation of `_.forIn` without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Object} Returns `object`.
	   */
	  function baseForIn(object, iteratee) {
	    return baseFor(object, iteratee, keysIn);
	  }

	  /**
	   * The base implementation of `_.forOwn` without support for callback
	   * shorthands and `this` binding.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Object} Returns `object`.
	   */
	  function baseForOwn(object, iteratee) {
	    return baseFor(object, iteratee, keys);
	  }

	  /**
	   * The base implementation of `_.invoke` which requires additional arguments
	   * to be provided as an array of arguments rather than individually.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function|string} methodName The name of the method to invoke or
	   *  the function invoked per iteration.
	   * @param {Array} [args] The arguments to invoke the method with.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseInvoke(collection, methodName, args) {
	    var index = -1,
	        isFunc = typeof methodName == 'function',
	        length = collection ? collection.length : 0,
	        result = isLength(length) ? Array(length) : [];

	    baseEach(collection, function(value) {
	      var func = isFunc ? methodName : (value != null && value[methodName]);
	      result[++index] = func ? func.apply(value, args) : undefined;
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.isEqual` without support for `this` binding
	   * `customizer` functions.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @param {Function} [customizer] The function to customize comparing values.
	   * @param {boolean} [isWhere] Specify performing partial comparisons.
	   * @param {Array} [stackA] Tracks traversed `value` objects.
	   * @param {Array} [stackB] Tracks traversed `other` objects.
	   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	   */
	  function baseIsEqual(value, other, customizer, isWhere, stackA, stackB) {
	    // Exit early for identical values.
	    if (value === other) {
	      // Treat `+0` vs. `-0` as not equal.
	      return value !== 0 || (1 / value == 1 / other);
	    }
	    var valType = typeof value,
	        othType = typeof other;

	    // Exit early for unlike primitive values.
	    if ((valType != 'function' && valType != 'object' && othType != 'function' && othType != 'object') ||
	        value == null || other == null) {
	      // Return `false` unless both values are `NaN`.
	      return value !== value && other !== other;
	    }
	    return baseIsEqualDeep(value, other, baseIsEqual, customizer, isWhere, stackA, stackB);
	  }

	  /**
	   * A specialized version of `baseIsEqual` for arrays and objects which performs
	   * deep comparisons and tracks traversed objects enabling objects with circular
	   * references to be compared.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {Function} equalFunc The function to determine equivalents of values.
	   * @param {Function} [customizer] The function to customize comparing objects.
	   * @param {boolean} [isWhere] Specify performing partial comparisons.
	   * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	   * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	   */
	  function baseIsEqualDeep(object, other, equalFunc, customizer, isWhere, stackA, stackB) {
	    var objIsArr = isArray(object),
	        othIsArr = isArray(other),
	        objTag = arrayTag,
	        othTag = arrayTag;

	    if (!objIsArr) {
	      objTag = objToString.call(object);
	      if (objTag == argsTag) {
	        objTag = objectTag;
	      } else if (objTag != objectTag) {
	        objIsArr = isTypedArray(object);
	      }
	    }
	    if (!othIsArr) {
	      othTag = objToString.call(other);
	      if (othTag == argsTag) {
	        othTag = objectTag;
	      } else if (othTag != objectTag) {
	        othIsArr = isTypedArray(other);
	      }
	    }
	    var objIsObj = objTag == objectTag,
	        othIsObj = othTag == objectTag,
	        isSameTag = objTag == othTag;

	    if (isSameTag && !(objIsArr || objIsObj)) {
	      return equalByTag(object, other, objTag);
	    }
	    var valWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	    if (valWrapped || othWrapped) {
	      return equalFunc(valWrapped ? object.value() : object, othWrapped ? other.value() : other, customizer, isWhere, stackA, stackB);
	    }
	    if (!isSameTag) {
	      return false;
	    }
	    // Assume cyclic values are equal.
	    // For more information on detecting circular references see https://es5.github.io/#JO.
	    stackA || (stackA = []);
	    stackB || (stackB = []);

	    var length = stackA.length;
	    while (length--) {
	      if (stackA[length] == object) {
	        return stackB[length] == other;
	      }
	    }
	    // Add `object` and `other` to the stack of traversed objects.
	    stackA.push(object);
	    stackB.push(other);

	    var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isWhere, stackA, stackB);

	    stackA.pop();
	    stackB.pop();

	    return result;
	  }

	  /**
	   * The base implementation of `_.isMatch` without support for callback
	   * shorthands or `this` binding.
	   *
	   * @private
	   * @param {Object} object The object to inspect.
	   * @param {Array} props The source property names to match.
	   * @param {Array} values The source values to match.
	   * @param {Array} strictCompareFlags Strict comparison flags for source values.
	   * @param {Function} [customizer] The function to customize comparing objects.
	   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	   */
	  function baseIsMatch(object, props, values, strictCompareFlags, customizer) {
	    var length = props.length;
	    if (object == null) {
	      return !length;
	    }
	    var index = -1,
	        noCustomizer = !customizer;

	    while (++index < length) {
	      if ((noCustomizer && strictCompareFlags[index])
	            ? values[index] !== object[props[index]]
	            : !hasOwnProperty.call(object, props[index])
	          ) {
	        return false;
	      }
	    }
	    index = -1;
	    while (++index < length) {
	      var key = props[index];
	      if (noCustomizer && strictCompareFlags[index]) {
	        var result = hasOwnProperty.call(object, key);
	      } else {
	        var objValue = object[key],
	            srcValue = values[index];

	        result = customizer ? customizer(objValue, srcValue, key) : undefined;
	        if (typeof result == 'undefined') {
	          result = baseIsEqual(srcValue, objValue, customizer, true);
	        }
	      }
	      if (!result) {
	        return false;
	      }
	    }
	    return true;
	  }

	  /**
	   * The base implementation of `_.map` without support for callback shorthands
	   * or `this` binding.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function baseMap(collection, iteratee) {
	    var result = [];
	    baseEach(collection, function(value, key, collection) {
	      result.push(iteratee(value, key, collection));
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.matches` which does not clone `source`.
	   *
	   * @private
	   * @param {Object} source The object of property values to match.
	   * @returns {Function} Returns the new function.
	   */
	  function baseMatches(source) {
	    var props = keys(source),
	        length = props.length;

	    if (length == 1) {
	      var key = props[0],
	          value = source[key];

	      if (isStrictComparable(value)) {
	        return function(object) {
	          return object != null && object[key] === value && hasOwnProperty.call(object, key);
	        };
	      }
	    }
	    var values = Array(length),
	        strictCompareFlags = Array(length);

	    while (length--) {
	      value = source[props[length]];
	      values[length] = value;
	      strictCompareFlags[length] = isStrictComparable(value);
	    }
	    return function(object) {
	      return baseIsMatch(object, props, values, strictCompareFlags);
	    };
	  }

	  /**
	   * The base implementation of `_.matchesProperty` which does not coerce `key`
	   * to a string.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @param {*} value The value to compare.
	   * @returns {Function} Returns the new function.
	   */
	  function baseMatchesProperty(key, value) {
	    if (isStrictComparable(value)) {
	      return function(object) {
	        return object != null && object[key] === value;
	      };
	    }
	    return function(object) {
	      return object != null && baseIsEqual(value, object[key], null, true);
	    };
	  }

	  /**
	   * The base implementation of `_.property` which does not coerce `key` to a string.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight` without support
	   * for callback shorthands or `this` binding, which iterates over `collection`
	   * using the provided `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initFromCollection Specify using the first or last element
	   *  of `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initFromCollection
	        ? (initFromCollection = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }

	  /**
	   * The base implementation of `setData` without support for hot loop detection.
	   *
	   * @private
	   * @param {Function} func The function to associate metadata with.
	   * @param {*} data The metadata.
	   * @returns {Function} Returns `func`.
	   */
	  var baseSetData = !metaMap ? identity : function(func, data) {
	    metaMap.set(func, data);
	    return func;
	  };

	  /**
	   * The base implementation of `_.slice` without an iteratee call guard.
	   *
	   * @private
	   * @param {Array} array The array to slice.
	   * @param {number} [start=0] The start position.
	   * @param {number} [end=array.length] The end position.
	   * @returns {Array} Returns the slice of `array`.
	   */
	  function baseSlice(array, start, end) {
	    var index = -1,
	        length = array.length;

	    start = start == null ? 0 : (+start || 0);
	    if (start < 0) {
	      start = -start > length ? 0 : (length + start);
	    }
	    end = (typeof end == 'undefined' || end > length) ? length : (+end || 0);
	    if (end < 0) {
	      end += length;
	    }
	    length = start > end ? 0 : ((end - start) >>> 0);
	    start >>>= 0;

	    var result = Array(length);
	    while (++index < length) {
	      result[index] = array[index + start];
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * returned by `keysFunc`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    var index = -1,
	        length = props.length,
	        result = Array(length);

	    while (++index < length) {
	      result[index] = object[props[index]];
	    }
	    return result;
	  }

	  /**
	   * Performs a binary search of `array` to determine the index at which `value`
	   * should be inserted into `array` in order to maintain its sort order.
	   *
	   * @private
	   * @param {Array} array The sorted array to inspect.
	   * @param {*} value The value to evaluate.
	   * @param {boolean} [retHighest] Specify returning the highest, instead
	   *  of the lowest, index at which a value should be inserted into `array`.
	   * @returns {number} Returns the index at which `value` should be inserted
	   *  into `array`.
	   */
	  function binaryIndex(array, value, retHighest) {
	    var low = 0,
	        high = array ? array.length : low;

	    if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	      while (low < high) {
	        var mid = (low + high) >>> 1,
	            computed = array[mid];

	        if (retHighest ? (computed <= value) : (computed < value)) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return high;
	    }
	    return binaryIndexBy(array, value, identity, retHighest);
	  }

	  /**
	   * This function is like `binaryIndex` except that it invokes `iteratee` for
	   * `value` and each element of `array` to compute their sort ranking. The
	   * iteratee is invoked with one argument; (value).
	   *
	   * @private
	   * @param {Array} array The sorted array to inspect.
	   * @param {*} value The value to evaluate.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {boolean} [retHighest] Specify returning the highest, instead
	   *  of the lowest, index at which a value should be inserted into `array`.
	   * @returns {number} Returns the index at which `value` should be inserted
	   *  into `array`.
	   */
	  function binaryIndexBy(array, value, iteratee, retHighest) {
	    value = iteratee(value);

	    var low = 0,
	        high = array ? array.length : 0,
	        valIsNaN = value !== value,
	        valIsUndef = typeof value == 'undefined';

	    while (low < high) {
	      var mid = floor((low + high) / 2),
	          computed = iteratee(array[mid]),
	          isReflexive = computed === computed;

	      if (valIsNaN) {
	        var setLow = isReflexive || retHighest;
	      } else if (valIsUndef) {
	        setLow = isReflexive && (retHighest || typeof computed != 'undefined');
	      } else {
	        setLow = retHighest ? (computed <= value) : (computed < value);
	      }
	      if (setLow) {
	        low = mid + 1;
	      } else {
	        high = mid;
	      }
	    }
	    return nativeMin(high, MAX_ARRAY_INDEX);
	  }

	  /**
	   * A specialized version of `baseCallback` which only supports `this` binding
	   * and specifying the number of arguments to provide to `func`.
	   *
	   * @private
	   * @param {Function} func The function to bind.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {number} [argCount] The number of arguments to provide to `func`.
	   * @returns {Function} Returns the callback.
	   */
	  function bindCallback(func, thisArg, argCount) {
	    if (typeof func != 'function') {
	      return identity;
	    }
	    if (typeof thisArg == 'undefined') {
	      return func;
	    }
	    switch (argCount) {
	      case 1: return function(value) {
	        return func.call(thisArg, value);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(thisArg, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(thisArg, accumulator, value, index, collection);
	      };
	      case 5: return function(value, other, key, object, source) {
	        return func.call(thisArg, value, other, key, object, source);
	      };
	    }
	    return function() {
	      return func.apply(thisArg, arguments);
	    };
	  }

	  /**
	   * Creates a clone of the given array buffer.
	   *
	   * @private
	   * @param {ArrayBuffer} buffer The array buffer to clone.
	   * @returns {ArrayBuffer} Returns the cloned array buffer.
	   */
	  function bufferClone(buffer) {
	    return bufferSlice.call(buffer, 0);
	  }
	  if (!bufferSlice) {
	    // PhantomJS has `ArrayBuffer` and `Uint8Array` but not `Float64Array`.
	    bufferClone = !(ArrayBuffer && Uint8Array) ? constant(null) : function(buffer) {
	      var byteLength = buffer.byteLength,
	          floatLength = Float64Array ? floor(byteLength / FLOAT64_BYTES_PER_ELEMENT) : 0,
	          offset = floatLength * FLOAT64_BYTES_PER_ELEMENT,
	          result = new ArrayBuffer(byteLength);

	      if (floatLength) {
	        var view = new Float64Array(result, 0, floatLength);
	        view.set(new Float64Array(buffer, 0, floatLength));
	      }
	      if (byteLength != offset) {
	        view = new Uint8Array(result, offset);
	        view.set(new Uint8Array(buffer, offset));
	      }
	      return result;
	    };
	  }

	  /**
	   * Creates an array that is the composition of partially applied arguments,
	   * placeholders, and provided arguments into a single array of arguments.
	   *
	   * @private
	   * @param {Array|Object} args The provided arguments.
	   * @param {Array} partials The arguments to prepend to those provided.
	   * @param {Array} holders The `partials` placeholder indexes.
	   * @returns {Array} Returns the new array of composed arguments.
	   */
	  function composeArgs(args, partials, holders) {
	    var holdersLength = holders.length,
	        argsIndex = -1,
	        argsLength = nativeMax(args.length - holdersLength, 0),
	        leftIndex = -1,
	        leftLength = partials.length,
	        result = Array(argsLength + leftLength);

	    while (++leftIndex < leftLength) {
	      result[leftIndex] = partials[leftIndex];
	    }
	    while (++argsIndex < holdersLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	    while (argsLength--) {
	      result[leftIndex++] = args[argsIndex++];
	    }
	    return result;
	  }

	  /**
	   * This function is like `composeArgs` except that the arguments composition
	   * is tailored for `_.partialRight`.
	   *
	   * @private
	   * @param {Array|Object} args The provided arguments.
	   * @param {Array} partials The arguments to append to those provided.
	   * @param {Array} holders The `partials` placeholder indexes.
	   * @returns {Array} Returns the new array of composed arguments.
	   */
	  function composeArgsRight(args, partials, holders) {
	    var holdersIndex = -1,
	        holdersLength = holders.length,
	        argsIndex = -1,
	        argsLength = nativeMax(args.length - holdersLength, 0),
	        rightIndex = -1,
	        rightLength = partials.length,
	        result = Array(argsLength + rightLength);

	    while (++argsIndex < argsLength) {
	      result[argsIndex] = args[argsIndex];
	    }
	    var pad = argsIndex;
	    while (++rightIndex < rightLength) {
	      result[pad + rightIndex] = partials[rightIndex];
	    }
	    while (++holdersIndex < holdersLength) {
	      result[pad + holders[holdersIndex]] = args[argsIndex++];
	    }
	    return result;
	  }

	  /**
	   * Creates a function that assigns properties of source object(s) to a given
	   * destination object.
	   *
	   * @private
	   * @param {Function} assigner The function to assign values.
	   * @returns {Function} Returns the new assigner function.
	   */
	  function createAssigner(assigner) {
	    return function() {
	      var args = arguments,
	          length = args.length,
	          object = args[0];

	      if (length < 2 || object == null) {
	        return object;
	      }
	      var customizer = args[length - 2],
	          thisArg = args[length - 1],
	          guard = args[3];

	      if (length > 3 && typeof customizer == 'function') {
	        customizer = bindCallback(customizer, thisArg, 5);
	        length -= 2;
	      } else {
	        customizer = (length > 2 && typeof thisArg == 'function') ? thisArg : null;
	        length -= (customizer ? 1 : 0);
	      }
	      if (guard && isIterateeCall(args[1], args[2], guard)) {
	        customizer = length == 3 ? null : customizer;
	        length = 2;
	      }
	      var index = 0;
	      while (++index < length) {
	        var source = args[index];
	        if (source) {
	          assigner(object, source, customizer);
	        }
	      }
	      return object;
	    };
	  }

	  /**
	   * Creates a function that wraps `func` and invokes it with the `this`
	   * binding of `thisArg`.
	   *
	   * @private
	   * @param {Function} func The function to bind.
	   * @param {*} [thisArg] The `this` binding of `func`.
	   * @returns {Function} Returns the new bound function.
	   */
	  function createBindWrapper(func, thisArg) {
	    var Ctor = createCtorWrapper(func);

	    function wrapper() {
	      var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	      return fn.apply(thisArg, arguments);
	    }
	    return wrapper;
	  }

	  /**
	   * Creates a `Set` cache object to optimize linear searches of large arrays.
	   *
	   * @private
	   * @param {Array} [values] The values to cache.
	   * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	   */
	  var createCache = !(nativeCreate && Set) ? constant(null) : function(values) {
	    return new SetCache(values);
	  };

	  /**
	   * Creates a function that produces an instance of `Ctor` regardless of
	   * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	   *
	   * @private
	   * @param {Function} Ctor The constructor to wrap.
	   * @returns {Function} Returns the new wrapped function.
	   */
	  function createCtorWrapper(Ctor) {
	    return function() {
	      var thisBinding = baseCreate(Ctor.prototype),
	          result = Ctor.apply(thisBinding, arguments);

	      // Mimic the constructor's `return` behavior.
	      // See https://es5.github.io/#x13.2.2 for more details.
	      return isObject(result) ? result : thisBinding;
	    };
	  }

	  /**
	   * Creates a function that wraps `func` and invokes it with optional `this`
	   * binding of, partial application, and currying.
	   *
	   * @private
	   * @param {Function|string} func The function or method name to reference.
	   * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	   * @param {*} [thisArg] The `this` binding of `func`.
	   * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	   * @param {Array} [holders] The `partials` placeholder indexes.
	   * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	   * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	   * @param {Array} [argPos] The argument positions of the new function.
	   * @param {number} [ary] The arity cap of `func`.
	   * @param {number} [arity] The arity of `func`.
	   * @returns {Function} Returns the new wrapped function.
	   */
	  function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	    var isAry = bitmask & ARY_FLAG,
	        isBind = bitmask & BIND_FLAG,
	        isBindKey = bitmask & BIND_KEY_FLAG,
	        isCurry = bitmask & CURRY_FLAG,
	        isCurryBound = bitmask & CURRY_BOUND_FLAG,
	        isCurryRight = bitmask & CURRY_RIGHT_FLAG;

	    var Ctor = !isBindKey && createCtorWrapper(func),
	        key = func;

	    function wrapper() {
	      // Avoid `arguments` object use disqualifying optimizations by
	      // converting it to an array before providing it to other functions.
	      var length = arguments.length,
	          index = length,
	          args = Array(length);

	      while (index--) {
	        args[index] = arguments[index];
	      }
	      if (partials) {
	        args = composeArgs(args, partials, holders);
	      }
	      if (partialsRight) {
	        args = composeArgsRight(args, partialsRight, holdersRight);
	      }
	      if (isCurry || isCurryRight) {
	        var placeholder = wrapper.placeholder,
	            argsHolders = replaceHolders(args, placeholder);

	        length -= argsHolders.length;
	        if (length < arity) {
	          var newArgPos = argPos ? arrayCopy(argPos) : null,
	              newArity = nativeMax(arity - length, 0),
	              newsHolders = isCurry ? argsHolders : null,
	              newHoldersRight = isCurry ? null : argsHolders,
	              newPartials = isCurry ? args : null,
	              newPartialsRight = isCurry ? null : args;

	          bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	          bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

	          if (!isCurryBound) {
	            bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	          }
	          var result = createHybridWrapper(func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity);
	          result.placeholder = placeholder;
	          return result;
	        }
	      }
	      var thisBinding = isBind ? thisArg : this;
	      if (isBindKey) {
	        func = thisBinding[key];
	      }
	      if (argPos) {
	        args = reorder(args, argPos);
	      }
	      if (isAry && ary < args.length) {
	        args.length = ary;
	      }
	      var fn = (this && this !== root && this instanceof wrapper) ? (Ctor || createCtorWrapper(func)) : func;
	      return fn.apply(thisBinding, args);
	    }
	    return wrapper;
	  }

	  /**
	   * Creates a function that wraps `func` and invokes it with the optional `this`
	   * binding of `thisArg` and the `partials` prepended to those provided to
	   * the wrapper.
	   *
	   * @private
	   * @param {Function} func The function to partially apply arguments to.
	   * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} partials The arguments to prepend to those provided to the new function.
	   * @returns {Function} Returns the new bound function.
	   */
	  function createPartialWrapper(func, bitmask, thisArg, partials) {
	    var isBind = bitmask & BIND_FLAG,
	        Ctor = createCtorWrapper(func);

	    function wrapper() {
	      // Avoid `arguments` object use disqualifying optimizations by
	      // converting it to an array before providing it `func`.
	      var argsIndex = -1,
	          argsLength = arguments.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          args = Array(argsLength + leftLength);

	      while (++leftIndex < leftLength) {
	        args[leftIndex] = partials[leftIndex];
	      }
	      while (argsLength--) {
	        args[leftIndex++] = arguments[++argsIndex];
	      }
	      var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	      return fn.apply(isBind ? thisArg : this, args);
	    }
	    return wrapper;
	  }

	  /**
	   * Creates a function that either curries or invokes `func` with optional
	   * `this` binding and partially applied arguments.
	   *
	   * @private
	   * @param {Function|string} func The function or method name to reference.
	   * @param {number} bitmask The bitmask of flags.
	   *  The bitmask may be composed of the following flags:
	   *     1 - `_.bind`
	   *     2 - `_.bindKey`
	   *     4 - `_.curry` or `_.curryRight` of a bound function
	   *     8 - `_.curry`
	   *    16 - `_.curryRight`
	   *    32 - `_.partial`
	   *    64 - `_.partialRight`
	   *   128 - `_.rearg`
	   *   256 - `_.ary`
	   * @param {*} [thisArg] The `this` binding of `func`.
	   * @param {Array} [partials] The arguments to be partially applied.
	   * @param {Array} [holders] The `partials` placeholder indexes.
	   * @param {Array} [argPos] The argument positions of the new function.
	   * @param {number} [ary] The arity cap of `func`.
	   * @param {number} [arity] The arity of `func`.
	   * @returns {Function} Returns the new wrapped function.
	   */
	  function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	    var isBindKey = bitmask & BIND_KEY_FLAG;
	    if (!isBindKey && typeof func != 'function') {
	      throw new TypeError(FUNC_ERROR_TEXT);
	    }
	    var length = partials ? partials.length : 0;
	    if (!length) {
	      bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	      partials = holders = null;
	    }
	    length -= (holders ? holders.length : 0);
	    if (bitmask & PARTIAL_RIGHT_FLAG) {
	      var partialsRight = partials,
	          holdersRight = holders;

	      partials = holders = null;
	    }
	    var data = !isBindKey && getData(func),
	        newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

	    if (data && data !== true) {
	      mergeData(newData, data);
	      bitmask = newData[1];
	      arity = newData[9];
	    }
	    newData[9] = arity == null
	      ? (isBindKey ? 0 : func.length)
	      : (nativeMax(arity - length, 0) || 0);

	    if (bitmask == BIND_FLAG) {
	      var result = createBindWrapper(newData[0], newData[2]);
	    } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	      result = createPartialWrapper.apply(undefined, newData);
	    } else {
	      result = createHybridWrapper.apply(undefined, newData);
	    }
	    var setter = data ? baseSetData : setData;
	    return setter(result, newData);
	  }

	  /**
	   * A specialized version of `baseIsEqualDeep` for arrays with support for
	   * partial deep comparisons.
	   *
	   * @private
	   * @param {Array} array The array to compare.
	   * @param {Array} other The other array to compare.
	   * @param {Function} equalFunc The function to determine equivalents of values.
	   * @param {Function} [customizer] The function to customize comparing arrays.
	   * @param {boolean} [isWhere] Specify performing partial comparisons.
	   * @param {Array} [stackA] Tracks traversed `value` objects.
	   * @param {Array} [stackB] Tracks traversed `other` objects.
	   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	   */
	  function equalArrays(array, other, equalFunc, customizer, isWhere, stackA, stackB) {
	    var index = -1,
	        arrLength = array.length,
	        othLength = other.length,
	        result = true;

	    if (arrLength != othLength && !(isWhere && othLength > arrLength)) {
	      return false;
	    }
	    // Deep compare the contents, ignoring non-numeric properties.
	    while (result && ++index < arrLength) {
	      var arrValue = array[index],
	          othValue = other[index];

	      result = undefined;
	      if (customizer) {
	        result = isWhere
	          ? customizer(othValue, arrValue, index)
	          : customizer(arrValue, othValue, index);
	      }
	      if (typeof result == 'undefined') {
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isWhere) {
	          var othIndex = othLength;
	          while (othIndex--) {
	            othValue = other[othIndex];
	            result = (arrValue && arrValue === othValue) || equalFunc(arrValue, othValue, customizer, isWhere, stackA, stackB);
	            if (result) {
	              break;
	            }
	          }
	        } else {
	          result = (arrValue && arrValue === othValue) || equalFunc(arrValue, othValue, customizer, isWhere, stackA, stackB);
	        }
	      }
	    }
	    return !!result;
	  }

	  /**
	   * A specialized version of `baseIsEqualDeep` for comparing objects of
	   * the same `toStringTag`.
	   *
	   * **Note:** This function only supports comparing values with tags of
	   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	   *
	   * @private
	   * @param {Object} value The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {string} tag The `toStringTag` of the objects to compare.
	   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	   */
	  function equalByTag(object, other, tag) {
	    switch (tag) {
	      case boolTag:
	      case dateTag:
	        // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	        // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	        return +object == +other;

	      case errorTag:
	        return object.name == other.name && object.message == other.message;

	      case numberTag:
	        // Treat `NaN` vs. `NaN` as equal.
	        return (object != +object)
	          ? other != +other
	          // But, treat `-0` vs. `+0` as not equal.
	          : (object == 0 ? ((1 / object) == (1 / other)) : object == +other);

	      case regexpTag:
	      case stringTag:
	        // Coerce regexes to strings and treat strings primitives and string
	        // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	        return object == (other + '');
	    }
	    return false;
	  }

	  /**
	   * A specialized version of `baseIsEqualDeep` for objects with support for
	   * partial deep comparisons.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {Function} equalFunc The function to determine equivalents of values.
	   * @param {Function} [customizer] The function to customize comparing values.
	   * @param {boolean} [isWhere] Specify performing partial comparisons.
	   * @param {Array} [stackA] Tracks traversed `value` objects.
	   * @param {Array} [stackB] Tracks traversed `other` objects.
	   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	   */
	  function equalObjects(object, other, equalFunc, customizer, isWhere, stackA, stackB) {
	    var objProps = keys(object),
	        objLength = objProps.length,
	        othProps = keys(other),
	        othLength = othProps.length;

	    if (objLength != othLength && !isWhere) {
	      return false;
	    }
	    var hasCtor,
	        index = -1;

	    while (++index < objLength) {
	      var key = objProps[index],
	          result = hasOwnProperty.call(other, key);

	      if (result) {
	        var objValue = object[key],
	            othValue = other[key];

	        result = undefined;
	        if (customizer) {
	          result = isWhere
	            ? customizer(othValue, objValue, key)
	            : customizer(objValue, othValue, key);
	        }
	        if (typeof result == 'undefined') {
	          // Recursively compare objects (susceptible to call stack limits).
	          result = (objValue && objValue === othValue) || equalFunc(objValue, othValue, customizer, isWhere, stackA, stackB);
	        }
	      }
	      if (!result) {
	        return false;
	      }
	      hasCtor || (hasCtor = key == 'constructor');
	    }
	    if (!hasCtor) {
	      var objCtor = object.constructor,
	          othCtor = other.constructor;

	      // Non `Object` object instances with different constructors are not equal.
	      if (objCtor != othCtor &&
	          ('constructor' in object && 'constructor' in other) &&
	          !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	            typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	        return false;
	      }
	    }
	    return true;
	  }

	  /**
	   * Gets the appropriate "callback" function. If the `_.callback` method is
	   * customized this function returns the custom method, otherwise it returns
	   * the `baseCallback` function. If arguments are provided the chosen function
	   * is invoked with them and its result is returned.
	   *
	   * @private
	   * @returns {Function} Returns the chosen function or its result.
	   */
	  function getCallback(func, thisArg, argCount) {
	    var result = lodash.callback || callback;
	    result = result === callback ? baseCallback : result;
	    return argCount ? result(func, thisArg, argCount) : result;
	  }

	  /**
	   * Gets metadata for `func`.
	   *
	   * @private
	   * @param {Function} func The function to query.
	   * @returns {*} Returns the metadata for `func`.
	   */
	  var getData = !metaMap ? noop : function(func) {
	    return metaMap.get(func);
	  };

	  /**
	   * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	   * customized this function returns the custom method, otherwise it returns
	   * the `baseIndexOf` function. If arguments are provided the chosen function
	   * is invoked with them and its result is returned.
	   *
	   * @private
	   * @returns {Function|number} Returns the chosen function or its result.
	   */
	  function getIndexOf(collection, target, fromIndex) {
	    var result = lodash.indexOf || indexOf;
	    result = result === indexOf ? baseIndexOf : result;
	    return collection ? result(collection, target, fromIndex) : result;
	  }

	  /**
	   * Initializes an array clone.
	   *
	   * @private
	   * @param {Array} array The array to clone.
	   * @returns {Array} Returns the initialized clone.
	   */
	  function initCloneArray(array) {
	    var length = array.length,
	        result = new array.constructor(length);

	    // Add array properties assigned by `RegExp#exec`.
	    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	      result.index = array.index;
	      result.input = array.input;
	    }
	    return result;
	  }

	  /**
	   * Initializes an object clone.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @returns {Object} Returns the initialized clone.
	   */
	  function initCloneObject(object) {
	    var Ctor = object.constructor;
	    if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	      Ctor = Object;
	    }
	    return new Ctor;
	  }

	  /**
	   * Initializes an object clone based on its `toStringTag`.
	   *
	   * **Note:** This function only supports cloning values with tags of
	   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	   *
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {string} tag The `toStringTag` of the object to clone.
	   * @param {boolean} [isDeep] Specify a deep clone.
	   * @returns {Object} Returns the initialized clone.
	   */
	  function initCloneByTag(object, tag, isDeep) {
	    var Ctor = object.constructor;
	    switch (tag) {
	      case arrayBufferTag:
	        return bufferClone(object);

	      case boolTag:
	      case dateTag:
	        return new Ctor(+object);

	      case float32Tag: case float64Tag:
	      case int8Tag: case int16Tag: case int32Tag:
	      case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	        var buffer = object.buffer;
	        return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

	      case numberTag:
	      case stringTag:
	        return new Ctor(object);

	      case regexpTag:
	        var result = new Ctor(object.source, reFlags.exec(object));
	        result.lastIndex = object.lastIndex;
	    }
	    return result;
	  }

	  /**
	   * Checks if `func` is eligible for `this` binding.
	   *
	   * @private
	   * @param {Function} func The function to check.
	   * @returns {boolean} Returns `true` if `func` is eligible, else `false`.
	   */
	  function isBindable(func) {
	    var support = lodash.support,
	        result = !(support.funcNames ? func.name : support.funcDecomp);

	    if (!result) {
	      var source = fnToString.call(func);
	      if (!support.funcNames) {
	        result = !reFuncName.test(source);
	      }
	      if (!result) {
	        // Check if `func` references the `this` keyword and store the result.
	        result = reThis.test(source) || isNative(func);
	        baseSetData(func, result);
	      }
	    }
	    return result;
	  }

	  /**
	   * Checks if `value` is a valid array-like index.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	   */
	  function isIndex(value, length) {
	    value = +value;
	    length = length == null ? MAX_SAFE_INTEGER : length;
	    return value > -1 && value % 1 == 0 && value < length;
	  }

	  /**
	   * Checks if the provided arguments are from an iteratee call.
	   *
	   * @private
	   * @param {*} value The potential iteratee value argument.
	   * @param {*} index The potential iteratee index or key argument.
	   * @param {*} object The potential iteratee object argument.
	   * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	   */
	  function isIterateeCall(value, index, object) {
	    if (!isObject(object)) {
	      return false;
	    }
	    var type = typeof index;
	    if (type == 'number') {
	      var length = object.length,
	          prereq = isLength(length) && isIndex(index, length);
	    } else {
	      prereq = type == 'string' && index in object;
	    }
	    if (prereq) {
	      var other = object[index];
	      return value === value ? (value === other) : (other !== other);
	    }
	    return false;
	  }

	  /**
	   * Checks if `value` is a valid array-like length.
	   *
	   * **Note:** This function is based on ES `ToLength`. See the
	   * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	   * for more details.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	   */
	  function isLength(value) {
	    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	  }

	  /**
	   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` if suitable for strict
	   *  equality comparisons, else `false`.
	   */
	  function isStrictComparable(value) {
	    return value === value && (value === 0 ? ((1 / value) > 0) : !isObject(value));
	  }

	  /**
	   * Merges the function metadata of `source` into `data`.
	   *
	   * Merging metadata reduces the number of wrappers required to invoke a function.
	   * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	   * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	   * augment function arguments, making the order in which they are executed important,
	   * preventing the merging of metadata. However, we make an exception for a safe
	   * common case where curried functions have `_.ary` and or `_.rearg` applied.
	   *
	   * @private
	   * @param {Array} data The destination metadata.
	   * @param {Array} source The source metadata.
	   * @returns {Array} Returns `data`.
	   */
	  function mergeData(data, source) {
	    var bitmask = data[1],
	        srcBitmask = source[1],
	        newBitmask = bitmask | srcBitmask;

	    var arityFlags = ARY_FLAG | REARG_FLAG,
	        bindFlags = BIND_FLAG | BIND_KEY_FLAG,
	        comboFlags = arityFlags | bindFlags | CURRY_BOUND_FLAG | CURRY_RIGHT_FLAG;

	    var isAry = bitmask & ARY_FLAG && !(srcBitmask & ARY_FLAG),
	        isRearg = bitmask & REARG_FLAG && !(srcBitmask & REARG_FLAG),
	        argPos = (isRearg ? data : source)[7],
	        ary = (isAry ? data : source)[8];

	    var isCommon = !(bitmask >= REARG_FLAG && srcBitmask > bindFlags) &&
	      !(bitmask > bindFlags && srcBitmask >= REARG_FLAG);

	    var isCombo = (newBitmask >= arityFlags && newBitmask <= comboFlags) &&
	      (bitmask < REARG_FLAG || ((isRearg || isAry) && argPos.length <= ary));

	    // Exit early if metadata can't be merged.
	    if (!(isCommon || isCombo)) {
	      return data;
	    }
	    // Use source `thisArg` if available.
	    if (srcBitmask & BIND_FLAG) {
	      data[2] = source[2];
	      // Set when currying a bound function.
	      newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	    }
	    // Compose partial arguments.
	    var value = source[3];
	    if (value) {
	      var partials = data[3];
	      data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	      data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	    }
	    // Compose partial right arguments.
	    value = source[5];
	    if (value) {
	      partials = data[5];
	      data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	      data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	    }
	    // Use source `argPos` if available.
	    value = source[7];
	    if (value) {
	      data[7] = arrayCopy(value);
	    }
	    // Use source `ary` if it's smaller.
	    if (srcBitmask & ARY_FLAG) {
	      data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	    }
	    // Use source `arity` if one is not provided.
	    if (data[9] == null) {
	      data[9] = source[9];
	    }
	    // Use source `func` and merge bitmasks.
	    data[0] = source[0];
	    data[1] = newBitmask;

	    return data;
	  }

	  /**
	   * A specialized version of `_.pick` that picks `object` properties specified
	   * by the `props` array.
	   *
	   * @private
	   * @param {Object} object The source object.
	   * @param {string[]} props The property names to pick.
	   * @returns {Object} Returns the new object.
	   */
	  function pickByArray(object, props) {
	    object = toObject(object);

	    var index = -1,
	        length = props.length,
	        result = {};

	    while (++index < length) {
	      var key = props[index];
	      if (key in object) {
	        result[key] = object[key];
	      }
	    }
	    return result;
	  }

	  /**
	   * A specialized version of `_.pick` that picks `object` properties `predicate`
	   * returns truthy for.
	   *
	   * @private
	   * @param {Object} object The source object.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Object} Returns the new object.
	   */
	  function pickByCallback(object, predicate) {
	    var result = {};
	    baseForIn(object, function(value, key, object) {
	      if (predicate(value, key, object)) {
	        result[key] = value;
	      }
	    });
	    return result;
	  }

	  /**
	   * Reorder `array` according to the specified indexes where the element at
	   * the first index is assigned as the first element, the element at
	   * the second index is assigned as the second element, and so on.
	   *
	   * @private
	   * @param {Array} array The array to reorder.
	   * @param {Array} indexes The arranged array indexes.
	   * @returns {Array} Returns `array`.
	   */
	  function reorder(array, indexes) {
	    var arrLength = array.length,
	        length = nativeMin(indexes.length, arrLength),
	        oldArray = arrayCopy(array);

	    while (length--) {
	      var index = indexes[length];
	      array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	    }
	    return array;
	  }

	  /**
	   * Sets metadata for `func`.
	   *
	   * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	   * period of time, it will trip its breaker and transition to an identity function
	   * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	   * for more details.
	   *
	   * @private
	   * @param {Function} func The function to associate metadata with.
	   * @param {*} data The metadata.
	   * @returns {Function} Returns `func`.
	   */
	  var setData = (function() {
	    var count = 0,
	        lastCalled = 0;

	    return function(key, value) {
	      var stamp = now(),
	          remaining = HOT_SPAN - (stamp - lastCalled);

	      lastCalled = stamp;
	      if (remaining > 0) {
	        if (++count >= HOT_COUNT) {
	          return key;
	        }
	      } else {
	        count = 0;
	      }
	      return baseSetData(key, value);
	    };
	  }());

	  /**
	   * A fallback implementation of `_.isPlainObject` which checks if `value`
	   * is an object created by the `Object` constructor or has a `[[Prototype]]`
	   * of `null`.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	   */
	  function shimIsPlainObject(value) {
	    var Ctor,
	        support = lodash.support;

	    // Exit early for non `Object` objects.
	    if (!(isObjectLike(value) && objToString.call(value) == objectTag) ||
	        (!hasOwnProperty.call(value, 'constructor') &&
	          (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	      return false;
	    }
	    // IE < 9 iterates inherited properties before own properties. If the first
	    // iterated property is an object's own property then there are no inherited
	    // enumerable properties.
	    var result;
	    // In most environments an object's own properties are iterated before
	    // its inherited properties. If the last iterated property is an object's
	    // own property then there are no inherited enumerable properties.
	    baseForIn(value, function(subValue, key) {
	      result = key;
	    });
	    return typeof result == 'undefined' || hasOwnProperty.call(value, result);
	  }

	  /**
	   * A fallback implementation of `Object.keys` which creates an array of the
	   * own enumerable property names of `object`.
	   *
	   * @private
	   * @param {Object} object The object to inspect.
	   * @returns {Array} Returns the array of property names.
	   */
	  function shimKeys(object) {
	    var props = keysIn(object),
	        propsLength = props.length,
	        length = propsLength && object.length,
	        support = lodash.support;

	    var allowIndexes = length && isLength(length) &&
	      (isArray(object) || (support.nonEnumArgs && isArguments(object)));

	    var index = -1,
	        result = [];

	    while (++index < propsLength) {
	      var key = props[index];
	      if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	        result.push(key);
	      }
	    }
	    return result;
	  }

	  /**
	   * Converts `value` to an object if it is not one.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {Object} Returns the object.
	   */
	  function toObject(value) {
	    return isObject(value) ? value : Object(value);
	  }

	  /*------------------------------------------------------------------------*/

	  /**
	   * Creates an array excluding all values of the provided arrays using
	   * `SameValueZero` for equality comparisons.
	   *
	   * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	   * e.g. `===`, except that `NaN` matches `NaN`. See the
	   * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	   * for more details.
	   *
	   * @static
	   * @memberOf _
	   * @category Array
	   * @param {Array} array The array to inspect.
	   * @param {...Array} [values] The arrays of values to exclude.
	   * @returns {Array} Returns the new array of filtered values.
	   * @example
	   *
	   * _.difference([1, 2, 3], [4, 2]);
	   * // => [1, 3]
	   */
	  function difference() {
	    var args = arguments,
	        index = -1,
	        length = args.length;

	    while (++index < length) {
	      var value = args[index];
	      if (isArray(value) || isArguments(value)) {
	        break;
	      }
	    }
	    return baseDifference(value, baseFlatten(args, false, true, ++index));
	  }

	  /**
	   * This method is like `_.find` except that it returns the index of the first
	   * element `predicate` returns truthy for, instead of the element itself.
	   *
	   * If a property name is provided for `predicate` the created `_.property`
	   * style callback returns the property value of the given element.
	   *
	   * If a value is also provided for `thisArg` the created `_.matchesProperty`
	   * style callback returns `true` for elements that have a matching property
	   * value, else `false`.
	   *
	   * If an object is provided for `predicate` the created `_.matches` style
	   * callback returns `true` for elements that have the properties of the given
	   * object, else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Array
	   * @param {Array} array The array to search.
	   * @param {Function|Object|string} [predicate=_.identity] The function invoked
	   *  per iteration.
	   * @param {*} [thisArg] The `this` binding of `predicate`.
	   * @returns {number} Returns the index of the found element, else `-1`.
	   * @example
	   *
	   * var users = [
	   *   { 'user': 'barney',  'active': false },
	   *   { 'user': 'fred',    'active': false },
	   *   { 'user': 'pebbles', 'active': true }
	   * ];
	   *
	   * _.findIndex(users, function(chr) {
	   *   return chr.user == 'barney';
	   * });
	   * // => 0
	   *
	   * // using the `_.matches` callback shorthand
	   * _.findIndex(users, { 'user': 'fred', 'active': false });
	   * // => 1
	   *
	   * // using the `_.matchesProperty` callback shorthand
	   * _.findIndex(users, 'active', false);
	   * // => 0
	   *
	   * // using the `_.property` callback shorthand
	   * _.findIndex(users, 'active');
	   * // => 2
	   */
	  function findIndex(array, predicate, thisArg) {
	    var index = -1,
	        length = array ? array.length : 0;

	    predicate = getCallback(predicate, thisArg, 3);
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * Gets the index at which the first occurrence of `value` is found in `array`
	   * using `SameValueZero` for equality comparisons. If `fromIndex` is negative,
	   * it is used as the offset from the end of `array`. If `array` is sorted
	   * providing `true` for `fromIndex` performs a faster binary search.
	   *
	   * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	   * e.g. `===`, except that `NaN` matches `NaN`. See the
	   * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	   * for more details.
	   *
	   * @static
	   * @memberOf _
	   * @category Array
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	   *  to perform a binary search on a sorted array.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   * @example
	   *
	   * _.indexOf([1, 2, 1, 2], 2);
	   * // => 1
	   *
	   * // using `fromIndex`
	   * _.indexOf([1, 2, 1, 2], 2, 2);
	   * // => 3
	   *
	   * // performing a binary search
	   * _.indexOf([1, 1, 2, 2], 2, true);
	   * // => 2
	   */
	  function indexOf(array, value, fromIndex) {
	    var length = array ? array.length : 0;
	    if (!length) {
	      return -1;
	    }
	    if (typeof fromIndex == 'number') {
	      fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	    } else if (fromIndex) {
	      var index = binaryIndex(array, value),
	          other = array[index];

	      if (value === value ? (value === other) : (other !== other)) {
	        return index;
	      }
	      return -1;
	    }
	    return baseIndexOf(array, value, fromIndex || 0);
	  }

	  /**
	   * Creates an array of unique values in all provided arrays using `SameValueZero`
	   * for equality comparisons.
	   *
	   * **Note:** `SameValueZero` comparisons are like strict equality comparisons,
	   * e.g. `===`, except that `NaN` matches `NaN`. See the
	   * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
	   * for more details.
	   *
	   * @static
	   * @memberOf _
	   * @category Array
	   * @param {...Array} [arrays] The arrays to inspect.
	   * @returns {Array} Returns the new array of shared values.
	   * @example
	   * _.intersection([1, 2], [4, 2], [2, 1]);
	   * // => [2]
	   */
	  function intersection() {
	    var args = [],
	        argsIndex = -1,
	        argsLength = arguments.length,
	        caches = [],
	        indexOf = getIndexOf(),
	        isCommon = indexOf == baseIndexOf;

	    while (++argsIndex < argsLength) {
	      var value = arguments[argsIndex];
	      if (isArray(value) || isArguments(value)) {
	        args.push(value);
	        caches.push((isCommon && value.length >= 120) ? createCache(argsIndex && value) : null);
	      }
	    }
	    argsLength = args.length;
	    var array = args[0],
	        index = -1,
	        length = array ? array.length : 0,
	        result = [],
	        seen = caches[0];

	    outer:
	    while (++index < length) {
	      value = array[index];
	      if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	        argsIndex = argsLength;
	        while (--argsIndex) {
	          var cache = caches[argsIndex];
	          if ((cache ? cacheIndexOf(cache, value) : indexOf(args[argsIndex], value, 0)) < 0) {
	            continue outer;
	          }
	        }
	        if (seen) {
	          seen.push(value);
	        }
	        result.push(value);
	      }
	    }
	    return result;
	  }

	  /**
	   * Gets the last element of `array`.
	   *
	   * @static
	   * @memberOf _
	   * @category Array
	   * @param {Array} array The array to query.
	   * @returns {*} Returns the last element of `array`.
	   * @example
	   *
	   * _.last([1, 2, 3]);
	   * // => 3
	   */
	  function last(array) {
	    var length = array ? array.length : 0;
	    return length ? array[length - 1] : undefined;
	  }

	  /*------------------------------------------------------------------------*/

	  /**
	   * Checks if `predicate` returns truthy for **all** elements of `collection`.
	   * The predicate is bound to `thisArg` and invoked with three arguments;
	   * (value, index|key, collection).
	   *
	   * If a property name is provided for `predicate` the created `_.property`
	   * style callback returns the property value of the given element.
	   *
	   * If a value is also provided for `thisArg` the created `_.matchesProperty`
	   * style callback returns `true` for elements that have a matching property
	   * value, else `false`.
	   *
	   * If an object is provided for `predicate` the created `_.matches` style
	   * callback returns `true` for elements that have the properties of the given
	   * object, else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias all
	   * @category Collection
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function|Object|string} [predicate=_.identity] The function invoked
	   *  per iteration.
	   * @param {*} [thisArg] The `this` binding of `predicate`.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   * @example
	   *
	   * _.every([true, 1, null, 'yes'], Boolean);
	   * // => false
	   *
	   * var users = [
	   *   { 'user': 'barney', 'active': false },
	   *   { 'user': 'fred',   'active': false }
	   * ];
	   *
	   * // using the `_.matches` callback shorthand
	   * _.every(users, { 'user': 'barney', 'active': false });
	   * // => false
	   *
	   * // using the `_.matchesProperty` callback shorthand
	   * _.every(users, 'active', false);
	   * // => true
	   *
	   * // using the `_.property` callback shorthand
	   * _.every(users, 'active');
	   * // => false
	   */
	  function every(collection, predicate, thisArg) {
	    var func = isArray(collection) ? arrayEvery : baseEvery;
	    if (typeof predicate != 'function' || typeof thisArg != 'undefined') {
	      predicate = getCallback(predicate, thisArg, 3);
	    }
	    return func(collection, predicate);
	  }

	  /**
	   * Iterates over elements of `collection`, returning the first element
	   * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	   * invoked with three arguments; (value, index|key, collection).
	   *
	   * If a property name is provided for `predicate` the created `_.property`
	   * style callback returns the property value of the given element.
	   *
	   * If a value is also provided for `thisArg` the created `_.matchesProperty`
	   * style callback returns `true` for elements that have a matching property
	   * value, else `false`.
	   *
	   * If an object is provided for `predicate` the created `_.matches` style
	   * callback returns `true` for elements that have the properties of the given
	   * object, else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias detect
	   * @category Collection
	   * @param {Array|Object|string} collection The collection to search.
	   * @param {Function|Object|string} [predicate=_.identity] The function invoked
	   *  per iteration.
	   * @param {*} [thisArg] The `this` binding of `predicate`.
	   * @returns {*} Returns the matched element, else `undefined`.
	   * @example
	   *
	   * var users = [
	   *   { 'user': 'barney',  'age': 36, 'active': true },
	   *   { 'user': 'fred',    'age': 40, 'active': false },
	   *   { 'user': 'pebbles', 'age': 1,  'active': true }
	   * ];
	   *
	   * _.result(_.find(users, function(chr) {
	   *   return chr.age < 40;
	   * }), 'user');
	   * // => 'barney'
	   *
	   * // using the `_.matches` callback shorthand
	   * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	   * // => 'pebbles'
	   *
	   * // using the `_.matchesProperty` callback shorthand
	   * _.result(_.find(users, 'active', false), 'user');
	   * // => 'fred'
	   *
	   * // using the `_.property` callback shorthand
	   * _.result(_.find(users, 'active'), 'user');
	   * // => 'barney'
	   */
	  function find(collection, predicate, thisArg) {
	    if (isArray(collection)) {
	      var index = findIndex(collection, predicate, thisArg);
	      return index > -1 ? collection[index] : undefined;
	    }
	    predicate = getCallback(predicate, thisArg, 3);
	    return baseFind(collection, predicate, baseEach);
	  }

	  /**
	   * Iterates over elements of `collection` invoking `iteratee` for each element.
	   * The `iteratee` is bound to `thisArg` and invoked with three arguments;
	   * (value, index|key, collection). Iterator functions may exit iteration early
	   * by explicitly returning `false`.
	   *
	   * **Note:** As with other "Collections" methods, objects with a `length` property
	   * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	   * may be used for object iteration.
	   *
	   * @static
	   * @memberOf _
	   * @alias each
	   * @category Collection
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	   * @param {*} [thisArg] The `this` binding of `iteratee`.
	   * @returns {Array|Object|string} Returns `collection`.
	   * @example
	   *
	   * _([1, 2]).forEach(function(n) {
	   *   console.log(n);
	   * }).value();
	   * // => logs each value from left to right and returns the array
	   *
	   * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	   *   console.log(n, key);
	   * });
	   * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	   */
	  function forEach(collection, iteratee, thisArg) {
	    return (typeof iteratee == 'function' && typeof thisArg == 'undefined' && isArray(collection))
	      ? arrayEach(collection, iteratee)
	      : baseEach(collection, bindCallback(iteratee, thisArg, 3));
	  }

	  /**
	   * Invokes the method named by `methodName` on each element in `collection`,
	   * returning an array of the results of each invoked method. Any additional
	   * arguments are provided to each invoked method. If `methodName` is a function
	   * it is invoked for, and `this` bound to, each element in `collection`.
	   *
	   * @static
	   * @memberOf _
	   * @category Collection
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function|string} methodName The name of the method to invoke or
	   *  the function invoked per iteration.
	   * @param {...*} [args] The arguments to invoke the method with.
	   * @returns {Array} Returns the array of results.
	   * @example
	   *
	   * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	   * // => [[1, 5, 7], [1, 2, 3]]
	   *
	   * _.invoke([123, 456], String.prototype.split, '');
	   * // => [['1', '2', '3'], ['4', '5', '6']]
	   */
	  function invoke(collection, methodName) {
	    return baseInvoke(collection, methodName, baseSlice(arguments, 2));
	  }

	  /**
	   * Creates an array of values by running each element in `collection` through
	   * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	   * arguments; (value, index|key, collection).
	   *
	   * If a property name is provided for `predicate` the created `_.property`
	   * style callback returns the property value of the given element.
	   *
	   * If a value is also provided for `thisArg` the created `_.matchesProperty`
	   * style callback returns `true` for elements that have a matching property
	   * value, else `false`.
	   *
	   * If an object is provided for `predicate` the created `_.matches` style
	   * callback returns `true` for elements that have the properties of the given
	   * object, else `false`.
	   *
	   * Many lodash methods are guarded to work as interatees for methods like
	   * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	   *
	   * The guarded methods are:
	   * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`, `drop`,
	   * `dropRight`, `fill`, `flatten`, `invert`, `max`, `min`, `parseInt`, `slice`,
	   * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimLeft`, `trimRight`,
	   * `trunc`, `random`, `range`, `sample`, `uniq`, and `words`
	   *
	   * @static
	   * @memberOf _
	   * @alias collect
	   * @category Collection
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	   *  per iteration.
	   *  create a `_.property` or `_.matches` style callback respectively.
	   * @param {*} [thisArg] The `this` binding of `iteratee`.
	   * @returns {Array} Returns the new mapped array.
	   * @example
	   *
	   * function timesThree(n) {
	   *   return n * 3;
	   * }
	   *
	   * _.map([1, 2], timesThree);
	   * // => [3, 6]
	   *
	   * _.map({ 'a': 1, 'b': 2 }, timesThree);
	   * // => [3, 6] (iteration order is not guaranteed)
	   *
	   * var users = [
	   *   { 'user': 'barney' },
	   *   { 'user': 'fred' }
	   * ];
	   *
	   * // using the `_.property` callback shorthand
	   * _.map(users, 'user');
	   * // => ['barney', 'fred']
	   */
	  function map(collection, iteratee, thisArg) {
	    var func = isArray(collection) ? arrayMap : baseMap;
	    iteratee = getCallback(iteratee, thisArg, 3);
	    return func(collection, iteratee);
	  }

	  /**
	   * Reduces `collection` to a value which is the accumulated result of running
	   * each element in `collection` through `iteratee`, where each successive
	   * invocation is supplied the return value of the previous. If `accumulator`
	   * is not provided the first element of `collection` is used as the initial
	   * value. The `iteratee` is bound to `thisArg`and invoked with four arguments;
	   * (accumulator, value, index|key, collection).
	   *
	   * Many lodash methods are guarded to work as interatees for methods like
	   * `_.reduce`, `_.reduceRight`, and `_.transform`.
	   *
	   * The guarded methods are:
	   * `assign`, `defaults`, `merge`, and `sortAllBy`
	   *
	   * @static
	   * @memberOf _
	   * @alias foldl, inject
	   * @category Collection
	   * @param {Array|Object|string} collection The collection to iterate over.
	   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {*} [thisArg] The `this` binding of `iteratee`.
	   * @returns {*} Returns the accumulated value.
	   * @example
	   *
	   * _.reduce([1, 2], function(sum, n) {
	   *   return sum + n;
	   * });
	   * // => 3
	   *
	   * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	   *   result[key] = n * 3;
	   *   return result;
	   * }, {});
	   * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	   */
	  function reduce(collection, iteratee, accumulator, thisArg) {
	    var func = isArray(collection) ? arrayReduce : baseReduce;
	    return func(collection, getCallback(iteratee, thisArg, 4), accumulator, arguments.length < 3, baseEach);
	  }

	  /*------------------------------------------------------------------------*/

	  /**
	   * Gets the number of milliseconds that have elapsed since the Unix epoch
	   * (1 January 1970 00:00:00 UTC).
	   *
	   * @static
	   * @memberOf _
	   * @category Date
	   * @example
	   *
	   * _.defer(function(stamp) {
	   *   console.log(_.now() - stamp);
	   * }, _.now());
	   * // => logs the number of milliseconds it took for the deferred function to be invoked
	   */
	  var now = nativeNow || function() {
	    return new Date().getTime();
	  };

	  /*------------------------------------------------------------------------*/

	  /**
	   * Creates a function that invokes `func` with the `this` binding of `thisArg`
	   * and prepends any additional `_.bind` arguments to those provided to the
	   * bound function.
	   *
	   * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	   * may be used as a placeholder for partially applied arguments.
	   *
	   * **Note:** Unlike native `Function#bind` this method does not set the `length`
	   * property of bound functions.
	   *
	   * @static
	   * @memberOf _
	   * @category Function
	   * @param {Function} func The function to bind.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {...*} [args] The arguments to be partially applied.
	   * @returns {Function} Returns the new bound function.
	   * @example
	   *
	   * var greet = function(greeting, punctuation) {
	   *   return greeting + ' ' + this.user + punctuation;
	   * };
	   *
	   * var object = { 'user': 'fred' };
	   *
	   * var bound = _.bind(greet, object, 'hi');
	   * bound('!');
	   * // => 'hi fred!'
	   *
	   * // using placeholders
	   * var bound = _.bind(greet, object, _, '!');
	   * bound('hi');
	   * // => 'hi fred!'
	   */
	  function bind(func, thisArg) {
	    var bitmask = BIND_FLAG;
	    if (arguments.length > 2) {
	      var partials = baseSlice(arguments, 2),
	          holders = replaceHolders(partials, bind.placeholder);

	      bitmask |= PARTIAL_FLAG;
	    }
	    return createWrapper(func, bitmask, thisArg, partials, holders);
	  }

	  /**
	   * Defers invoking the `func` until the current call stack has cleared. Any
	   * additional arguments are provided to `func` when it is invoked.
	   *
	   * @static
	   * @memberOf _
	   * @category Function
	   * @param {Function} func The function to defer.
	   * @param {...*} [args] The arguments to invoke the function with.
	   * @returns {number} Returns the timer id.
	   * @example
	   *
	   * _.defer(function(text) {
	   *   console.log(text);
	   * }, 'deferred');
	   * // logs 'deferred' after one or more milliseconds
	   */
	  function defer(func) {
	    return baseDelay(func, 1, arguments, 1);
	  }

	  /**
	   * Creates a function that invokes `func` with `partial` arguments prepended
	   * to those provided to the new function. This method is like `_.bind` except
	   * it does **not** alter the `this` binding.
	   *
	   * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	   * builds, may be used as a placeholder for partially applied arguments.
	   *
	   * **Note:** This method does not set the `length` property of partially
	   * applied functions.
	   *
	   * @static
	   * @memberOf _
	   * @category Function
	   * @param {Function} func The function to partially apply arguments to.
	   * @param {...*} [args] The arguments to be partially applied.
	   * @returns {Function} Returns the new partially applied function.
	   * @example
	   *
	   * var greet = function(greeting, name) {
	   *   return greeting + ' ' + name;
	   * };
	   *
	   * var sayHelloTo = _.partial(greet, 'hello');
	   * sayHelloTo('fred');
	   * // => 'hello fred'
	   *
	   * // using placeholders
	   * var greetFred = _.partial(greet, _, 'fred');
	   * greetFred('hi');
	   * // => 'hi fred'
	   */
	  function partial(func) {
	    var partials = baseSlice(arguments, 1),
	        holders = replaceHolders(partials, partial.placeholder);

	    return createWrapper(func, PARTIAL_FLAG, null, partials, holders);
	  }

	  /*------------------------------------------------------------------------*/

	  /**
	   * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	   * otherwise they are assigned by reference. If `customizer` is provided it is
	   * invoked to produce the cloned values. If `customizer` returns `undefined`
	   * cloning is handled by the method instead. The `customizer` is bound to
	   * `thisArg` and invoked with two argument; (value [, index|key, object]).
	   *
	   * **Note:** This method is loosely based on the structured clone algorithm.
	   * The enumerable properties of `arguments` objects and objects created by
	   * constructors other than `Object` are cloned to plain `Object` objects. An
	   * empty object is returned for uncloneable values such as functions, DOM nodes,
	   * Maps, Sets, and WeakMaps. See the [HTML5 specification](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm)
	   * for more details.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to clone.
	   * @param {boolean} [isDeep] Specify a deep clone.
	   * @param {Function} [customizer] The function to customize cloning values.
	   * @param {*} [thisArg] The `this` binding of `customizer`.
	   * @returns {*} Returns the cloned value.
	   * @example
	   *
	   * var users = [
	   *   { 'user': 'barney' },
	   *   { 'user': 'fred' }
	   * ];
	   *
	   * var shallow = _.clone(users);
	   * shallow[0] === users[0];
	   * // => true
	   *
	   * var deep = _.clone(users, true);
	   * deep[0] === users[0];
	   * // => false
	   *
	   * // using a customizer callback
	   * var el = _.clone(document.body, function(value) {
	   *   if (_.isElement(value)) {
	   *     return value.cloneNode(false);
	   *   }
	   * });
	   *
	   * el === document.body
	   * // => false
	   * el.nodeName
	   * // => BODY
	   * el.childNodes.length;
	   * // => 0
	   */
	  function clone(value, isDeep, customizer, thisArg) {
	    if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	      isDeep = false;
	    }
	    else if (typeof isDeep == 'function') {
	      thisArg = customizer;
	      customizer = isDeep;
	      isDeep = false;
	    }
	    customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 1);
	    return baseClone(value, isDeep, customizer);
	  }

	  /**
	   * Checks if `value` is classified as an `arguments` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isArguments(function() { return arguments; }());
	   * // => true
	   *
	   * _.isArguments([1, 2, 3]);
	   * // => false
	   */
	  function isArguments(value) {
	    var length = isObjectLike(value) ? value.length : undefined;
	    return (isLength(length) && objToString.call(value) == argsTag) || false;
	  }

	  /**
	   * Checks if `value` is classified as an `Array` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isArray([1, 2, 3]);
	   * // => true
	   *
	   * _.isArray(function() { return arguments; }());
	   * // => false
	   */
	  var isArray = nativeIsArray || function(value) {
	    return (isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag) || false;
	  };

	  /**
	   * Checks if `value` is a DOM element.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	   * @example
	   *
	   * _.isElement(document.body);
	   * // => true
	   *
	   * _.isElement('<body>');
	   * // => false
	   */
	  function isElement(value) {
	    return (value && value.nodeType === 1 && isObjectLike(value) &&
	      (objToString.call(value).indexOf('Element') > -1)) || false;
	  }
	  // Fallback for environments without DOM support.
	  if (!support.dom) {
	    isElement = function(value) {
	      return (value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value)) || false;
	    };
	  }

	  /**
	   * Performs a deep comparison between two values to determine if they are
	   * equivalent. If `customizer` is provided it is invoked to compare values.
	   * If `customizer` returns `undefined` comparisons are handled by the method
	   * instead. The `customizer` is bound to `thisArg` and invoked with three
	   * arguments; (value, other [, index|key]).
	   *
	   * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	   * numbers, `Object` objects, regexes, and strings. Objects are compared by
	   * their own, not inherited, enumerable properties. Functions and DOM nodes
	   * are **not** supported. Provide a customizer function to extend support
	   * for comparing other values.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @param {Function} [customizer] The function to customize comparing values.
	   * @param {*} [thisArg] The `this` binding of `customizer`.
	   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	   * @example
	   *
	   * var object = { 'user': 'fred' };
	   * var other = { 'user': 'fred' };
	   *
	   * object == other;
	   * // => false
	   *
	   * _.isEqual(object, other);
	   * // => true
	   *
	   * // using a customizer callback
	   * var array = ['hello', 'goodbye'];
	   * var other = ['hi', 'goodbye'];
	   *
	   * _.isEqual(array, other, function(value, other) {
	   *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	   *     return true;
	   *   }
	   * });
	   * // => true
	   */
	  function isEqual(value, other, customizer, thisArg) {
	    customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 3);
	    if (!customizer && isStrictComparable(value) && isStrictComparable(other)) {
	      return value === other;
	    }
	    var result = customizer ? customizer(value, other) : undefined;
	    return typeof result == 'undefined' ? baseIsEqual(value, other, customizer) : !!result;
	  }

	  /**
	   * Checks if `value` is classified as a `Function` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isFunction(_);
	   * // => true
	   *
	   * _.isFunction(/abc/);
	   * // => false
	   */
	  var isFunction = !(baseIsFunction(/x/) || (Uint8Array && !baseIsFunction(Uint8Array))) ? baseIsFunction : function(value) {
	    // The use of `Object#toString` avoids issues with the `typeof` operator
	    // in older versions of Chrome and Safari which return 'function' for regexes
	    // and Safari 8 equivalents which return 'object' for typed array constructors.
	    return objToString.call(value) == funcTag;
	  };

	  /**
	   * Checks if `value` is the language type of `Object`.
	   * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	   *
	   * **Note:** See the [ES5 spec](https://es5.github.io/#x8) for more details.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	   * @example
	   *
	   * _.isObject({});
	   * // => true
	   *
	   * _.isObject([1, 2, 3]);
	   * // => true
	   *
	   * _.isObject(1);
	   * // => false
	   */
	  function isObject(value) {
	    // Avoid a V8 JIT bug in Chrome 19-20.
	    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	    var type = typeof value;
	    return type == 'function' || (value && type == 'object') || false;
	  }

	  /**
	   * Checks if `value` is a native function.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	   * @example
	   *
	   * _.isNative(Array.prototype.push);
	   * // => true
	   *
	   * _.isNative(_);
	   * // => false
	   */
	  function isNative(value) {
	    if (value == null) {
	      return false;
	    }
	    if (objToString.call(value) == funcTag) {
	      return reNative.test(fnToString.call(value));
	    }
	    return (isObjectLike(value) && reHostCtor.test(value)) || false;
	  }

	  /**
	   * Checks if `value` is classified as a `Number` primitive or object.
	   *
	   * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	   * as numbers, use the `_.isFinite` method.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isNumber(8.4);
	   * // => true
	   *
	   * _.isNumber(NaN);
	   * // => true
	   *
	   * _.isNumber('8.4');
	   * // => false
	   */
	  function isNumber(value) {
	    return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag) || false;
	  }

	  /**
	   * Checks if `value` is a plain object, that is, an object created by the
	   * `Object` constructor or one with a `[[Prototype]]` of `null`.
	   *
	   * **Note:** This method assumes objects created by the `Object` constructor
	   * have no inherited enumerable properties.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	   * @example
	   *
	   * function Foo() {
	   *   this.a = 1;
	   * }
	   *
	   * _.isPlainObject(new Foo);
	   * // => false
	   *
	   * _.isPlainObject([1, 2, 3]);
	   * // => false
	   *
	   * _.isPlainObject({ 'x': 0, 'y': 0 });
	   * // => true
	   *
	   * _.isPlainObject(Object.create(null));
	   * // => true
	   */
	  var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
	    if (!(value && objToString.call(value) == objectTag)) {
	      return false;
	    }
	    var valueOf = value.valueOf,
	        objProto = isNative(valueOf) && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);

	    return objProto
	      ? (value == objProto || getPrototypeOf(value) == objProto)
	      : shimIsPlainObject(value);
	  };

	  /**
	   * Checks if `value` is classified as a `String` primitive or object.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isString('abc');
	   * // => true
	   *
	   * _.isString(1);
	   * // => false
	   */
	  function isString(value) {
	    return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag) || false;
	  }

	  /**
	   * Checks if `value` is classified as a typed array.
	   *
	   * @static
	   * @memberOf _
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   * @example
	   *
	   * _.isTypedArray(new Uint8Array);
	   * // => true
	   *
	   * _.isTypedArray([]);
	   * // => false
	   */
	  function isTypedArray(value) {
	    return (isObjectLike(value) && isLength(value.length) && typedArrayTags[objToString.call(value)]) || false;
	  }

	  /*------------------------------------------------------------------------*/

	  /**
	   * Assigns own enumerable properties of source object(s) to the destination
	   * object. Subsequent sources overwrite property assignments of previous sources.
	   * If `customizer` is provided it is invoked to produce the assigned values.
	   * The `customizer` is bound to `thisArg` and invoked with five arguments;
	   * (objectValue, sourceValue, key, object, source).
	   *
	   * @static
	   * @memberOf _
	   * @alias extend
	   * @category Object
	   * @param {Object} object The destination object.
	   * @param {...Object} [sources] The source objects.
	   * @param {Function} [customizer] The function to customize assigning values.
	   * @param {*} [thisArg] The `this` binding of `customizer`.
	   * @returns {Object} Returns `object`.
	   * @example
	   *
	   * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	   * // => { 'user': 'fred', 'age': 40 }
	   *
	   * // using a customizer callback
	   * var defaults = _.partialRight(_.assign, function(value, other) {
	   *   return typeof value == 'undefined' ? other : value;
	   * });
	   *
	   * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	   * // => { 'user': 'barney', 'age': 36 }
	   */
	  var assign = createAssigner(baseAssign);

	  /**
	   * Assigns own enumerable properties of source object(s) to the destination
	   * object for all destination properties that resolve to `undefined`. Once a
	   * property is set, additional values of the same property are ignored.
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The destination object.
	   * @param {...Object} [sources] The source objects.
	   * @returns {Object} Returns `object`.
	   * @example
	   *
	   * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	   * // => { 'user': 'barney', 'age': 36 }
	   */
	  function defaults(object) {
	    if (object == null) {
	      return object;
	    }
	    var args = arrayCopy(arguments);
	    args.push(assignDefaults);
	    return assign.apply(undefined, args);
	  }

	  /**
	   * Creates an array of the own enumerable property names of `object`.
	   *
	   * **Note:** Non-object values are coerced to objects. See the
	   * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.keys)
	   * for more details.
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The object to inspect.
	   * @returns {Array} Returns the array of property names.
	   * @example
	   *
	   * function Foo() {
	   *   this.a = 1;
	   *   this.b = 2;
	   * }
	   *
	   * Foo.prototype.c = 3;
	   *
	   * _.keys(new Foo);
	   * // => ['a', 'b'] (iteration order is not guaranteed)
	   *
	   * _.keys('hi');
	   * // => ['0', '1']
	   */
	  var keys = !nativeKeys ? shimKeys : function(object) {
	    if (object) {
	      var Ctor = object.constructor,
	          length = object.length;
	    }
	    if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	        (typeof object != 'function' && (length && isLength(length)))) {
	      return shimKeys(object);
	    }
	    return isObject(object) ? nativeKeys(object) : [];
	  };

	  /**
	   * Creates an array of the own and inherited enumerable property names of `object`.
	   *
	   * **Note:** Non-object values are coerced to objects.
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The object to inspect.
	   * @returns {Array} Returns the array of property names.
	   * @example
	   *
	   * function Foo() {
	   *   this.a = 1;
	   *   this.b = 2;
	   * }
	   *
	   * Foo.prototype.c = 3;
	   *
	   * _.keysIn(new Foo);
	   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	   */
	  function keysIn(object) {
	    if (object == null) {
	      return [];
	    }
	    if (!isObject(object)) {
	      object = Object(object);
	    }
	    var length = object.length;
	    length = (length && isLength(length) &&
	      (isArray(object) || (support.nonEnumArgs && isArguments(object))) && length) || 0;

	    var Ctor = object.constructor,
	        index = -1,
	        isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	        result = Array(length),
	        skipIndexes = length > 0;

	    while (++index < length) {
	      result[index] = (index + '');
	    }
	    for (var key in object) {
	      if (!(skipIndexes && isIndex(key, length)) &&
	          !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	        result.push(key);
	      }
	    }
	    return result;
	  }

	  /**
	   * The opposite of `_.pick`; this method creates an object composed of the
	   * own and inherited enumerable properties of `object` that are not omitted.
	   * Property names may be specified as individual arguments or as arrays of
	   * property names. If `predicate` is provided it is invoked for each property
	   * of `object` omitting the properties `predicate` returns truthy for. The
	   * predicate is bound to `thisArg` and invoked with three arguments;
	   * (value, key, object).
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The source object.
	   * @param {Function|...(string|string[])} [predicate] The function invoked per
	   *  iteration or property names to omit, specified as individual property
	   *  names or arrays of property names.
	   * @param {*} [thisArg] The `this` binding of `predicate`.
	   * @returns {Object} Returns the new object.
	   * @example
	   *
	   * var object = { 'user': 'fred', 'age': 40 };
	   *
	   * _.omit(object, 'age');
	   * // => { 'user': 'fred' }
	   *
	   * _.omit(object, _.isNumber);
	   * // => { 'user': 'fred' }
	   */
	  function omit(object, predicate, thisArg) {
	    if (object == null) {
	      return {};
	    }
	    if (typeof predicate != 'function') {
	      var props = arrayMap(baseFlatten(arguments, false, false, 1), String);
	      return pickByArray(object, baseDifference(keysIn(object), props));
	    }
	    predicate = bindCallback(predicate, thisArg, 3);
	    return pickByCallback(object, function(value, key, object) {
	      return !predicate(value, key, object);
	    });
	  }

	  /**
	   * Creates an array of the own enumerable property values of `object`.
	   *
	   * **Note:** Non-object values are coerced to objects.
	   *
	   * @static
	   * @memberOf _
	   * @category Object
	   * @param {Object} object The object to query.
	   * @returns {Array} Returns the array of property values.
	   * @example
	   *
	   * function Foo() {
	   *   this.a = 1;
	   *   this.b = 2;
	   * }
	   *
	   * Foo.prototype.c = 3;
	   *
	   * _.values(new Foo);
	   * // => [1, 2] (iteration order is not guaranteed)
	   *
	   * _.values('hi');
	   * // => ['h', 'i']
	   */
	  function values(object) {
	    return baseValues(object, keys(object));
	  }

	  /*------------------------------------------------------------------------*/

	  /**
	   * Escapes the `RegExp` special characters "\", "^", "$", ".", "|", "?", "*",
	   * "+", "(", ")", "[", "]", "{" and "}" in `string`.
	   *
	   * @static
	   * @memberOf _
	   * @category String
	   * @param {string} [string=''] The string to escape.
	   * @returns {string} Returns the escaped string.
	   * @example
	   *
	   * _.escapeRegExp('[lodash](https://lodash.com/)');
	   * // => '\[lodash\]\(https://lodash\.com/\)'
	   */
	  function escapeRegExp(string) {
	    string = baseToString(string);
	    return (string && reHasRegExpChars.test(string))
	      ? string.replace(reRegExpChars, '\\$&')
	      : string;
	  }

	  /*------------------------------------------------------------------------*/

	  /**
	   * Creates a function that invokes `func` with the `this` binding of `thisArg`
	   * and arguments of the created function. If `func` is a property name the
	   * created callback returns the property value for a given element. If `func`
	   * is an object the created callback returns `true` for elements that contain
	   * the equivalent object properties, otherwise it returns `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias iteratee
	   * @category Utility
	   * @param {*} [func=_.identity] The value to convert to a callback.
	   * @param {*} [thisArg] The `this` binding of `func`.
	   * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	   * @returns {Function} Returns the callback.
	   * @example
	   *
	   * var users = [
	   *   { 'user': 'barney', 'age': 36 },
	   *   { 'user': 'fred',   'age': 40 }
	   * ];
	   *
	   * // wrap to create custom callback shorthands
	   * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	   *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	   *   if (!match) {
	   *     return callback(func, thisArg);
	   *   }
	   *   return function(object) {
	   *     return match[2] == 'gt'
	   *       ? object[match[1]] > match[3]
	   *       : object[match[1]] < match[3];
	   *   };
	   * });
	   *
	   * _.filter(users, 'age__gt36');
	   * // => [{ 'user': 'fred', 'age': 40 }]
	   */
	  function callback(func, thisArg, guard) {
	    if (guard && isIterateeCall(func, thisArg, guard)) {
	      thisArg = null;
	    }
	    return isObjectLike(func)
	      ? matches(func)
	      : baseCallback(func, thisArg);
	  }

	  /**
	   * Creates a function that returns `value`.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {*} value The value to return from the new function.
	   * @returns {Function} Returns the new function.
	   * @example
	   *
	   * var object = { 'user': 'fred' };
	   * var getter = _.constant(object);
	   *
	   * getter() === object;
	   * // => true
	   */
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }

	  /**
	   * This method returns the first argument provided to it.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {*} value Any value.
	   * @returns {*} Returns `value`.
	   * @example
	   *
	   * var object = { 'user': 'fred' };
	   *
	   * _.identity(object) === object;
	   * // => true
	   */
	  function identity(value) {
	    return value;
	  }

	  /**
	   * Creates a function which performs a deep comparison between a given object
	   * and `source`, returning `true` if the given object has equivalent property
	   * values, else `false`.
	   *
	   * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	   * numbers, `Object` objects, regexes, and strings. Objects are compared by
	   * their own, not inherited, enumerable properties. For comparing a single
	   * own or inherited property value see `_.matchesProperty`.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} source The object of property values to match.
	   * @returns {Function} Returns the new function.
	   * @example
	   *
	   * var users = [
	   *   { 'user': 'barney', 'age': 36, 'active': true },
	   *   { 'user': 'fred',   'age': 40, 'active': false }
	   * ];
	   *
	   * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	   * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	   */
	  function matches(source) {
	    return baseMatches(baseClone(source, true));
	  }

	  /**
	   * A no-operation function which returns `undefined` regardless of the
	   * arguments it receives.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @example
	   *
	   * var object = { 'user': 'fred' };
	   *
	   * _.noop(object) === undefined;
	   * // => true
	   */
	  function noop() {
	    // No operation performed.
	  }

	  /**
	   * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {string} [prefix] The value to prefix the ID with.
	   * @returns {string} Returns the unique ID.
	   * @example
	   *
	   * _.uniqueId('contact_');
	   * // => 'contact_104'
	   *
	   * _.uniqueId();
	   * // => '105'
	   */
	  function uniqueId(prefix) {
	    var id = ++idCounter;
	    return baseToString(prefix) + id;
	  }

	  /*------------------------------------------------------------------------*/

	  // Add functions to the `Set` cache.
	  SetCache.prototype.push = cachePush;

	  // Add functions that return wrapped values when chaining.
	  lodash.assign = assign;
	  lodash.bind = bind;
	  lodash.callback = callback;
	  lodash.constant = constant;
	  lodash.defaults = defaults;
	  lodash.defer = defer;
	  lodash.difference = difference;
	  lodash.forEach = forEach;
	  lodash.intersection = intersection;
	  lodash.invoke = invoke;
	  lodash.keys = keys;
	  lodash.keysIn = keysIn;
	  lodash.map = map;
	  lodash.matches = matches;
	  lodash.omit = omit;
	  lodash.partial = partial;
	  lodash.values = values;

	  // Add aliases.
	  lodash.collect = map;
	  lodash.each = forEach;
	  lodash.extend = assign;
	  lodash.iteratee = callback;

	  /*------------------------------------------------------------------------*/

	  // Add functions that return unwrapped values when chaining.
	  lodash.clone = clone;
	  lodash.escapeRegExp = escapeRegExp;
	  lodash.every = every;
	  lodash.find = find;
	  lodash.findIndex = findIndex;
	  lodash.identity = identity;
	  lodash.indexOf = indexOf;
	  lodash.isArguments = isArguments;
	  lodash.isArray = isArray;
	  lodash.isElement = isElement;
	  lodash.isEqual = isEqual;
	  lodash.isFunction = isFunction;
	  lodash.isNative = isNative;
	  lodash.isNumber = isNumber;
	  lodash.isObject = isObject;
	  lodash.isPlainObject = isPlainObject;
	  lodash.isString = isString;
	  lodash.isTypedArray = isTypedArray;
	  lodash.last = last;
	  lodash.noop = noop;
	  lodash.now = now;
	  lodash.reduce = reduce;
	  lodash.uniqueId = uniqueId;

	  // Add aliases.
	  lodash.all = every;
	  lodash.detect = find;
	  lodash.foldl = reduce;
	  lodash.inject = reduce;

	  /*------------------------------------------------------------------------*/

	  /**
	   * The semantic version number.
	   *
	   * @static
	   * @memberOf _
	   * @type string
	   */
	  lodash.VERSION = VERSION;

	  // Assign default placeholders.
	  arrayEach(['bind', 'partial'], function(methodName) {
	    lodash[methodName].placeholder = lodash;
	  });

	  /*--------------------------------------------------------------------------*/

	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = lodash;

	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    define(function() {
	      return lodash;
	    });
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = lodash)._ = lodash;
	    }
	    // Export for Narwhal or Rhino -require.
	    else {
	      freeExports._ = lodash;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = lodash;
	  }
	}.call(this));

	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],2:[function(_dereq_,module,exports){
	/*!
	 * EventEmitter2
	 * https://github.com/hij1nx/EventEmitter2
	 *
	 * Copyright (c) 2013 hij1nx
	 * Licensed under the MIT license.
	 */
	;!function(undefined) {

	  var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
	    return Object.prototype.toString.call(obj) === "[object Array]";
	  };
	  var defaultMaxListeners = 10;

	  function init() {
	    this._events = {};
	    if (this._conf) {
	      configure.call(this, this._conf);
	    }
	  }

	  function configure(conf) {
	    if (conf) {

	      this._conf = conf;

	      conf.delimiter && (this.delimiter = conf.delimiter);
	      conf.maxListeners && (this._events.maxListeners = conf.maxListeners);
	      conf.wildcard && (this.wildcard = conf.wildcard);
	      conf.newListener && (this.newListener = conf.newListener);

	      if (this.wildcard) {
	        this.listenerTree = {};
	      }
	    }
	  }

	  function EventEmitter(conf) {
	    this._events = {};
	    this.newListener = false;
	    configure.call(this, conf);
	  }

	  //
	  // Attention, function return type now is array, always !
	  // It has zero elements if no any matches found and one or more
	  // elements (leafs) if there are matches
	  //
	  function searchListenerTree(handlers, type, tree, i) {
	    if (!tree) {
	      return [];
	    }
	    var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
	        typeLength = type.length, currentType = type[i], nextType = type[i+1];
	    if (i === typeLength && tree._listeners) {
	      //
	      // If at the end of the event(s) list and the tree has listeners
	      // invoke those listeners.
	      //
	      if (typeof tree._listeners === 'function') {
	        handlers && handlers.push(tree._listeners);
	        return [tree];
	      } else {
	        for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
	          handlers && handlers.push(tree._listeners[leaf]);
	        }
	        return [tree];
	      }
	    }

	    if ((currentType === '*' || currentType === '**') || tree[currentType]) {
	      //
	      // If the event emitted is '*' at this part
	      // or there is a concrete match at this patch
	      //
	      if (currentType === '*') {
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
	          }
	        }
	        return listeners;
	      } else if(currentType === '**') {
	        endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
	        if(endReached && tree._listeners) {
	          // The next element has a _listeners, add it to the handlers.
	          listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
	        }

	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            if(branch === '*' || branch === '**') {
	              if(tree[branch]._listeners && !endReached) {
	                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
	              }
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            } else if(branch === nextType) {
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
	            } else {
	              // No match on this one, shift into the tree but not in the type array.
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            }
	          }
	        }
	        return listeners;
	      }

	      listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
	    }

	    xTree = tree['*'];
	    if (xTree) {
	      //
	      // If the listener tree will allow any match for this part,
	      // then recursively explore all branches of the tree
	      //
	      searchListenerTree(handlers, type, xTree, i+1);
	    }

	    xxTree = tree['**'];
	    if(xxTree) {
	      if(i < typeLength) {
	        if(xxTree._listeners) {
	          // If we have a listener on a '**', it will catch all, so add its handler.
	          searchListenerTree(handlers, type, xxTree, typeLength);
	        }

	        // Build arrays of matching next branches and others.
	        for(branch in xxTree) {
	          if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
	            if(branch === nextType) {
	              // We know the next element will match, so jump twice.
	              searchListenerTree(handlers, type, xxTree[branch], i+2);
	            } else if(branch === currentType) {
	              // Current node matches, move into the tree.
	              searchListenerTree(handlers, type, xxTree[branch], i+1);
	            } else {
	              isolatedBranch = {};
	              isolatedBranch[branch] = xxTree[branch];
	              searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
	            }
	          }
	        }
	      } else if(xxTree._listeners) {
	        // We have reached the end and still on a '**'
	        searchListenerTree(handlers, type, xxTree, typeLength);
	      } else if(xxTree['*'] && xxTree['*']._listeners) {
	        searchListenerTree(handlers, type, xxTree['*'], typeLength);
	      }
	    }

	    return listeners;
	  }

	  function growListenerTree(type, listener) {

	    type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();

	    //
	    // Looks for two consecutive '**', if so, don't add the event at all.
	    //
	    for(var i = 0, len = type.length; i+1 < len; i++) {
	      if(type[i] === '**' && type[i+1] === '**') {
	        return;
	      }
	    }

	    var tree = this.listenerTree;
	    var name = type.shift();

	    while (name) {

	      if (!tree[name]) {
	        tree[name] = {};
	      }

	      tree = tree[name];

	      if (type.length === 0) {

	        if (!tree._listeners) {
	          tree._listeners = listener;
	        }
	        else if(typeof tree._listeners === 'function') {
	          tree._listeners = [tree._listeners, listener];
	        }
	        else if (isArray(tree._listeners)) {

	          tree._listeners.push(listener);

	          if (!tree._listeners.warned) {

	            var m = defaultMaxListeners;

	            if (typeof this._events.maxListeners !== 'undefined') {
	              m = this._events.maxListeners;
	            }

	            if (m > 0 && tree._listeners.length > m) {

	              tree._listeners.warned = true;
	              console.error('(node) warning: possible EventEmitter memory ' +
	                            'leak detected. %d listeners added. ' +
	                            'Use emitter.setMaxListeners() to increase limit.',
	                            tree._listeners.length);
	              console.trace();
	            }
	          }
	        }
	        return true;
	      }
	      name = type.shift();
	    }
	    return true;
	  }

	  // By default EventEmitters will print a warning if more than
	  // 10 listeners are added to it. This is a useful default which
	  // helps finding memory leaks.
	  //
	  // Obviously not all Emitters should be limited to 10. This function allows
	  // that to be increased. Set to zero for unlimited.

	  EventEmitter.prototype.delimiter = '.';

	  EventEmitter.prototype.setMaxListeners = function(n) {
	    this._events || init.call(this);
	    this._events.maxListeners = n;
	    if (!this._conf) this._conf = {};
	    this._conf.maxListeners = n;
	  };

	  EventEmitter.prototype.event = '';

	  EventEmitter.prototype.once = function(event, fn) {
	    this.many(event, 1, fn);
	    return this;
	  };

	  EventEmitter.prototype.many = function(event, ttl, fn) {
	    var self = this;

	    if (typeof fn !== 'function') {
	      throw new Error('many only accepts instances of Function');
	    }

	    function listener() {
	      if (--ttl === 0) {
	        self.off(event, listener);
	      }
	      fn.apply(this, arguments);
	    }

	    listener._origin = fn;

	    this.on(event, listener);

	    return self;
	  };

	  EventEmitter.prototype.emit = function() {

	    this._events || init.call(this);

	    var type = arguments[0];

	    if (type === 'newListener' && !this.newListener) {
	      if (!this._events.newListener) { return false; }
	    }

	    // Loop through the *_all* functions and invoke them.
	    if (this._all) {
	      var l = arguments.length;
	      var args = new Array(l - 1);
	      for (var i = 1; i < l; i++) args[i - 1] = arguments[i];
	      for (i = 0, l = this._all.length; i < l; i++) {
	        this.event = type;
	        this._all[i].apply(this, args);
	      }
	    }

	    // If there is no 'error' event listener then throw.
	    if (type === 'error') {

	      if (!this._all &&
	        !this._events.error &&
	        !(this.wildcard && this.listenerTree.error)) {

	        if (arguments[1] instanceof Error) {
	          throw arguments[1]; // Unhandled 'error' event
	        } else {
	          throw new Error("Uncaught, unspecified 'error' event.");
	        }
	        return false;
	      }
	    }

	    var handler;

	    if(this.wildcard) {
	      handler = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    }
	    else {
	      handler = this._events[type];
	    }

	    if (typeof handler === 'function') {
	      this.event = type;
	      if (arguments.length === 1) {
	        handler.call(this);
	      }
	      else if (arguments.length > 1)
	        switch (arguments.length) {
	          case 2:
	            handler.call(this, arguments[1]);
	            break;
	          case 3:
	            handler.call(this, arguments[1], arguments[2]);
	            break;
	          // slower
	          default:
	            var l = arguments.length;
	            var args = new Array(l - 1);
	            for (var i = 1; i < l; i++) args[i - 1] = arguments[i];
	            handler.apply(this, args);
	        }
	      return true;
	    }
	    else if (handler) {
	      var l = arguments.length;
	      var args = new Array(l - 1);
	      for (var i = 1; i < l; i++) args[i - 1] = arguments[i];

	      var listeners = handler.slice();
	      for (var i = 0, l = listeners.length; i < l; i++) {
	        this.event = type;
	        listeners[i].apply(this, args);
	      }
	      return (listeners.length > 0) || !!this._all;
	    }
	    else {
	      return !!this._all;
	    }

	  };

	  EventEmitter.prototype.on = function(type, listener) {

	    if (typeof type === 'function') {
	      this.onAny(type);
	      return this;
	    }

	    if (typeof listener !== 'function') {
	      throw new Error('on only accepts instances of Function');
	    }
	    this._events || init.call(this);

	    // To avoid recursion in the case that type == "newListeners"! Before
	    // adding it to the listeners, first emit "newListeners".
	    this.emit('newListener', type, listener);

	    if(this.wildcard) {
	      growListenerTree.call(this, type, listener);
	      return this;
	    }

	    if (!this._events[type]) {
	      // Optimize the case of one listener. Don't need the extra array object.
	      this._events[type] = listener;
	    }
	    else if(typeof this._events[type] === 'function') {
	      // Adding the second element, need to change to array.
	      this._events[type] = [this._events[type], listener];
	    }
	    else if (isArray(this._events[type])) {
	      // If we've already got an array, just append.
	      this._events[type].push(listener);

	      // Check for listener leak
	      if (!this._events[type].warned) {

	        var m = defaultMaxListeners;

	        if (typeof this._events.maxListeners !== 'undefined') {
	          m = this._events.maxListeners;
	        }

	        if (m > 0 && this._events[type].length > m) {

	          this._events[type].warned = true;
	          console.error('(node) warning: possible EventEmitter memory ' +
	                        'leak detected. %d listeners added. ' +
	                        'Use emitter.setMaxListeners() to increase limit.',
	                        this._events[type].length);
	          console.trace();
	        }
	      }
	    }
	    return this;
	  };

	  EventEmitter.prototype.onAny = function(fn) {

	    if (typeof fn !== 'function') {
	      throw new Error('onAny only accepts instances of Function');
	    }

	    if(!this._all) {
	      this._all = [];
	    }

	    // Add the function to the event listener collection.
	    this._all.push(fn);
	    return this;
	  };

	  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	  EventEmitter.prototype.off = function(type, listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('removeListener only takes instances of Function');
	    }

	    var handlers,leafs=[];

	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	    }
	    else {
	      // does not use listeners(), so no side effect of creating _events[type]
	      if (!this._events[type]) return this;
	      handlers = this._events[type];
	      leafs.push({_listeners:handlers});
	    }

	    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	      var leaf = leafs[iLeaf];
	      handlers = leaf._listeners;
	      if (isArray(handlers)) {

	        var position = -1;

	        for (var i = 0, length = handlers.length; i < length; i++) {
	          if (handlers[i] === listener ||
	            (handlers[i].listener && handlers[i].listener === listener) ||
	            (handlers[i]._origin && handlers[i]._origin === listener)) {
	            position = i;
	            break;
	          }
	        }

	        if (position < 0) {
	          continue;
	        }

	        if(this.wildcard) {
	          leaf._listeners.splice(position, 1);
	        }
	        else {
	          this._events[type].splice(position, 1);
	        }

	        if (handlers.length === 0) {
	          if(this.wildcard) {
	            delete leaf._listeners;
	          }
	          else {
	            delete this._events[type];
	          }
	        }
	        return this;
	      }
	      else if (handlers === listener ||
	        (handlers.listener && handlers.listener === listener) ||
	        (handlers._origin && handlers._origin === listener)) {
	        if(this.wildcard) {
	          delete leaf._listeners;
	        }
	        else {
	          delete this._events[type];
	        }
	      }
	    }

	    return this;
	  };

	  EventEmitter.prototype.offAny = function(fn) {
	    var i = 0, l = 0, fns;
	    if (fn && this._all && this._all.length > 0) {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++) {
	        if(fn === fns[i]) {
	          fns.splice(i, 1);
	          return this;
	        }
	      }
	    } else {
	      this._all = [];
	    }
	    return this;
	  };

	  EventEmitter.prototype.removeListener = EventEmitter.prototype.off;

	  EventEmitter.prototype.removeAllListeners = function(type) {
	    if (arguments.length === 0) {
	      !this._events || init.call(this);
	      return this;
	    }

	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);

	      for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	        var leaf = leafs[iLeaf];
	        leaf._listeners = null;
	      }
	    }
	    else {
	      if (!this._events[type]) return this;
	      this._events[type] = null;
	    }
	    return this;
	  };

	  EventEmitter.prototype.listeners = function(type) {
	    if(this.wildcard) {
	      var handlers = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
	      return handlers;
	    }

	    this._events || init.call(this);

	    if (!this._events[type]) this._events[type] = [];
	    if (!isArray(this._events[type])) {
	      this._events[type] = [this._events[type]];
	    }
	    return this._events[type];
	  };

	  EventEmitter.prototype.listenersAny = function() {

	    if(this._all) {
	      return this._all;
	    }
	    else {
	      return [];
	    }

	  };

	  if (typeof define === 'function' && define.amd) {
	     // AMD. Register as an anonymous module.
	    define(function() {
	      return EventEmitter;
	    });
	  } else if (typeof exports === 'object') {
	    // CommonJS
	    exports.EventEmitter2 = EventEmitter;
	  }
	  else {
	    // Browser global.
	    window.EventEmitter2 = EventEmitter;
	  }
	}();

	},{}],3:[function(_dereq_,module,exports){
	var diff = _dereq_('fast-diff');
	var is = _dereq_('./is');
	var op = _dereq_('./op');


	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (is.array(ops)) {
	    this.ops = ops;
	  } else if (is.object(ops) && is.array(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};


	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (is.string(text)) {
	    if (text.length === 0) return this;
	    newOp.insert = text;
	  } else if (is.number(text)) {
	    newOp.insert = text;
	  }
	  if (is.object(attributes) && Object.keys(attributes).length > 0) newOp.attributes = attributes;
	  return this.push(newOp);
	};

	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};

	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (is.object(attributes) && Object.keys(attributes).length > 0) newOp.attributes = attributes;
	  return this.push(newOp);
	};

	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = op.clone(newOp);
	  if (is.object(lastOp)) {
	    if (is.number(newOp['delete']) && is.number(lastOp['delete'])) {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (is.number(lastOp['delete']) && (is.string(newOp.insert) || is.number(newOp.insert))) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (!is.object(lastOp)) {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (is.equal(newOp.attributes, lastOp.attributes)) {
	      if (is.string(newOp.insert) && is.string(lastOp.insert)) {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (is.object(newOp.attributes)) this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (is.number(newOp.retain) && is.number(lastOp.retain)) {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (is.object(newOp.attributes)) this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  this.ops.splice(index, 0, newOp);
	  return this;
	};

	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};

	Delta.prototype.length = function () {
	  return this.ops.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};

	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (!is.number(end)) end = Infinity;
	  var delta = new Delta();
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      delta.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return delta;
	};


	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  this.ops = [];
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      this.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      this.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (is.number(otherOp.retain)) {
	        var newOp = {};
	        if (is.number(thisOp.retain)) {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, is.number(thisOp.retain));
	        if (attributes) newOp.attributes = attributes;
	        this.push(newOp);
	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (is.number(otherOp['delete']) && is.number(thisOp.retain)) {
	        this.push(otherOp);
	      }
	    }
	  }
	  return this.chop();
	};

	Delta.prototype.diff = function (other) {
	  var strings = [this.ops, other.ops].map(function (ops) {
	    return ops.map(function (op) {
	      if (is.string(op.insert)) return op.insert;
	      if (is.number(op.insert)) return NULL_CHARACTER;
	      var prep = ops === other.ops ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var diffResult = diff(strings[0], strings[1]);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (thisOp.insert === otherOp.insert) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};

	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (is.number(other)) {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};

	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};


	module.exports = Delta;

	},{"./is":4,"./op":5,"fast-diff":6}],4:[function(_dereq_,module,exports){
	module.exports = {
	  equal: function (a, b) {
	    if (a === b) return true;
	    if (a == null && b == null) return true;
	    if (a == null || b == null) return false;
	    if (Object.keys(a).length != Object.keys(b).length) return false;
	    for(var key in a) {
	      // Only compare one level deep
	      if (a[key] !== b[key]) return false;
	    }
	    return true;
	  },

	  array: function (value) {
	    return Array.isArray(value);
	  },

	  number: function (value) {
	    if (typeof value === 'number') return true;
	    if (typeof value === 'object' && Object.prototype.toString.call(value) === '[object Number]') return true;
	    return false;
	  },

	  object: function (value) {
	    if (!value) return false;
	    return (typeof value === 'function' || typeof value === 'object');
	  },

	  string: function (value) {
	    if (typeof value === 'string') return true;
	    if (typeof value === 'object' && Object.prototype.toString.call(value) === '[object String]') return true;
	    return false;
	  }
	};

	},{}],5:[function(_dereq_,module,exports){
	var is = _dereq_('./is');


	var lib = {
	  attributes: {
	    clone: function (attributes, keepNull) {
	      if (!is.object(attributes)) return {};
	      return Object.keys(attributes).reduce(function (memo, key) {
	        if (attributes[key] !== undefined && (attributes[key] !== null || keepNull)) {
	          memo[key] = attributes[key];
	        }
	        return memo;
	      }, {});
	    },

	    compose: function (a, b, keepNull) {
	      if (!is.object(a)) a = {};
	      if (!is.object(b)) b = {};
	      var attributes = this.clone(b, keepNull);
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },

	    diff: function(a, b) {
	      if (!is.object(a)) a = {};
	      if (!is.object(b)) b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (a[key] !== b[key]) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },

	    transform: function (a, b, priority) {
	      if (!is.object(a)) return b;
	      if (!is.object(b)) return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },

	  clone: function (op) {
	    var newOp = this.attributes.clone(op);
	    if (is.object(newOp.attributes)) {
	      newOp.attributes = this.attributes.clone(newOp.attributes, true);
	    }
	    return newOp;
	  },

	  iterator: function (ops) {
	    return new Iterator(ops);
	  },

	  length: function (op) {
	    if (is.number(op['delete'])) {
	      return op['delete'];
	    } else if (is.number(op.retain)) {
	      return op.retain;
	    } else {
	      return is.string(op.insert) ? op.insert.length : 1;
	    }
	  }
	};


	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};

	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};

	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (is.number(nextOp['delete'])) {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (is.number(nextOp.retain)) {
	        retOp.retain = length;
	      } else if (is.string(nextOp.insert)) {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};

	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};

	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (is.number(this.ops[this.index]['delete'])) {
	      return 'delete';
	    } else if (is.number(this.ops[this.index].retain)) {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};


	module.exports = lib;

	},{"./is":4}],6:[function(_dereq_,module,exports){
	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */


	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;


	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }

	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);

	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);

	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);

	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  return diffs;
	};


	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;

	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }

	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }

	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }

	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }

	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }

	  return diff_bisect_(text1, text2);
	};


	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }

	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};


	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);

	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);

	  return diffs.concat(diffsb);
	};


	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};


	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};


	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }

	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }

	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }

	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};


	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }

	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};


	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;


	module.exports = diff;

	},{}],7:[function(_dereq_,module,exports){
	module.exports={"version":"0.19.12"}
	},{}],8:[function(_dereq_,module,exports){
	var Delta, Document, Format, Line, LinkedList, Normalizer, _, dom;

	_ = _dereq_('lodash');

	Delta = _dereq_('rich-text/lib/delta');

	dom = _dereq_('../lib/dom');

	Format = _dereq_('./format');

	Line = _dereq_('./line');

	LinkedList = _dereq_('../lib/linked-list');

	Normalizer = _dereq_('./normalizer');

	Document = (function() {
	  function Document(root, options) {
	    this.root = root;
	    if (options == null) {
	      options = {};
	    }
	    this.normalizer = new Normalizer();
	    this.formats = {};
	    _.each(options.formats, _.bind(this.addFormat, this));
	    this.setHTML(this.root.innerHTML);
	  }

	  Document.prototype.addFormat = function(name, config) {
	    if (!_.isObject(config)) {
	      config = Format.FORMATS[name];
	    }
	    if (this.formats[name] != null) {
	      console.warn('Overwriting format', name, this.formats[name]);
	    }
	    this.formats[name] = new Format(config);
	    return this.normalizer.addFormat(config);
	  };

	  Document.prototype.appendLine = function(lineNode) {
	    return this.insertLineBefore(lineNode, null);
	  };

	  Document.prototype.findLeafAt = function(index, inclusive) {
	    var line, offset, ref;
	    ref = this.findLineAt(index), line = ref[0], offset = ref[1];
	    if (line != null) {
	      return line.findLeafAt(offset, inclusive);
	    } else {
	      return [void 0, offset];
	    }
	  };

	  Document.prototype.findLine = function(node) {
	    var line;
	    while ((node != null) && (dom.BLOCK_TAGS[node.tagName] == null)) {
	      node = node.parentNode;
	    }
	    line = node != null ? dom(node).data(Line.DATA_KEY) : void 0;
	    if ((line != null ? line.node : void 0) === node) {
	      return line;
	    } else {
	      return void 0;
	    }
	  };

	  Document.prototype.findLineAt = function(index) {
	    var curLine, length;
	    if (!(this.lines.length > 0)) {
	      return [void 0, index];
	    }
	    length = this.toDelta().length();
	    if (index === length) {
	      return [this.lines.last, this.lines.last.length];
	    }
	    if (index > length) {
	      return [void 0, index - length];
	    }
	    curLine = this.lines.first;
	    while (curLine != null) {
	      if (index < curLine.length) {
	        return [curLine, index];
	      }
	      index -= curLine.length;
	      curLine = curLine.next;
	    }
	    return [void 0, index];
	  };

	  Document.prototype.getHTML = function() {
	    return this.root.innerHTML.replace(/\>\s+\</g, '>&nbsp;<');
	  };

	  Document.prototype.insertLineBefore = function(newLineNode, refLine) {
	    var line;
	    line = new Line(this, newLineNode);
	    if (refLine != null) {
	      if (!dom(newLineNode.parentNode).isElement()) {
	        this.root.insertBefore(newLineNode, refLine.node);
	      }
	      this.lines.insertAfter(refLine.prev, line);
	    } else {
	      if (!dom(newLineNode.parentNode).isElement()) {
	        this.root.appendChild(newLineNode);
	      }
	      this.lines.append(line);
	    }
	    return line;
	  };

	  Document.prototype.mergeLines = function(line, lineToMerge) {
	    if (lineToMerge.length > 1) {
	      if (line.length === 1) {
	        dom(line.leaves.last.node).remove();
	      }
	      _.each(dom(lineToMerge.node).childNodes(), function(child) {
	        if (child.tagName !== dom.DEFAULT_BREAK_TAG) {
	          return line.node.appendChild(child);
	        }
	      });
	    }
	    this.removeLine(lineToMerge);
	    return line.rebuild();
	  };

	  Document.prototype.optimizeLines = function() {
	    return _.each(this.lines.toArray(), function(line, i) {
	      line.optimize();
	      return true;
	    });
	  };

	  Document.prototype.rebuild = function() {
	    var lineNode, lines, results;
	    lines = this.lines.toArray();
	    lineNode = this.root.firstChild;
	    if ((lineNode != null) && (dom.LIST_TAGS[lineNode.tagName] != null)) {
	      lineNode = lineNode.firstChild;
	    }
	    _.each(lines, (function(_this) {
	      return function(line, index) {
	        var newLine, ref;
	        while (line.node !== lineNode) {
	          if (line.node.parentNode === _this.root || ((ref = line.node.parentNode) != null ? ref.parentNode : void 0) === _this.root) {
	            lineNode = _this.normalizer.normalizeLine(lineNode);
	            newLine = _this.insertLineBefore(lineNode, line);
	            lineNode = dom(lineNode).nextLineNode(_this.root);
	          } else {
	            return _this.removeLine(line);
	          }
	        }
	        if (line.outerHTML !== lineNode.outerHTML) {
	          line.node = _this.normalizer.normalizeLine(line.node);
	          line.rebuild();
	        }
	        return lineNode = dom(lineNode).nextLineNode(_this.root);
	      };
	    })(this));
	    results = [];
	    while (lineNode != null) {
	      lineNode = this.normalizer.normalizeLine(lineNode);
	      this.appendLine(lineNode);
	      results.push(lineNode = dom(lineNode).nextLineNode(this.root));
	    }
	    return results;
	  };

	  Document.prototype.removeLine = function(line) {
	    if (line.node.parentNode != null) {
	      if (dom.LIST_TAGS[line.node.parentNode.tagName] && line.node.parentNode.childNodes.length === 1) {
	        dom(line.node.parentNode).remove();
	      } else {
	        dom(line.node).remove();
	      }
	    }
	    return this.lines.remove(line);
	  };

	  Document.prototype.setHTML = function(html) {
	    html = Normalizer.stripComments(html);
	    html = Normalizer.stripWhitespace(html);
	    this.root.innerHTML = html;
	    this.lines = new LinkedList();
	    return this.rebuild();
	  };

	  Document.prototype.splitLine = function(line, offset) {
	    var lineNode1, lineNode2, newLine, ref;
	    offset = Math.min(offset, line.length - 1);
	    ref = dom(line.node).split(offset, true), lineNode1 = ref[0], lineNode2 = ref[1];
	    line.node = lineNode1;
	    line.rebuild();
	    newLine = this.insertLineBefore(lineNode2, line.next);
	    newLine.formats = _.clone(line.formats);
	    newLine.resetContent();
	    return newLine;
	  };

	  Document.prototype.toDelta = function() {
	    var delta, lines;
	    lines = this.lines.toArray();
	    delta = new Delta();
	    _.each(lines, function(line) {
	      return _.each(line.delta.ops, function(op) {
	        return delta.push(op);
	      });
	    });
	    return delta;
	  };

	  return Document;

	})();

	module.exports = Document;



	},{"../lib/dom":17,"../lib/linked-list":18,"./format":10,"./line":12,"./normalizer":13,"lodash":1,"rich-text/lib/delta":3}],9:[function(_dereq_,module,exports){
	var Document, Editor, Line, Selection, _, dom;

	_ = _dereq_('lodash');

	dom = _dereq_('../lib/dom');

	Document = _dereq_('./document');

	Line = _dereq_('./line');

	Selection = _dereq_('./selection');

	Editor = (function() {
	  Editor.sources = {
	    API: 'api',
	    SILENT: 'silent',
	    USER: 'user'
	  };

	  function Editor(root, quill, options) {
	    this.root = root;
	    this.quill = quill;
	    this.options = options != null ? options : {};
	    this.root.setAttribute('id', this.options.id);
	    this.doc = new Document(this.root, this.options);
	    this.delta = this.doc.toDelta();
	    this.length = this.delta.length();
	    this.selection = new Selection(this.doc, this.quill);
	    this.timer = setInterval(_.bind(this.checkUpdate, this), this.options.pollInterval);
	    if (!this.options.readOnly) {
	      this.enable();
	    }
	  }

	  Editor.prototype.destroy = function() {
	    return clearInterval(this.timer);
	  };

	  Editor.prototype.disable = function() {
	    return this.enable(false);
	  };

	  Editor.prototype.enable = function(enabled) {
	    if (enabled == null) {
	      enabled = true;
	    }
	    return this.root.setAttribute('contenteditable', enabled);
	  };

	  Editor.prototype.applyDelta = function(delta, source) {
	    var localDelta;
	    localDelta = this._update();
	    if (localDelta) {
	      delta = localDelta.transform(delta, true);
	      localDelta = delta.transform(localDelta, false);
	    }
	    if (delta.ops.length > 0) {
	      delta = this._trackDelta((function(_this) {
	        return function() {
	          var index;
	          index = 0;
	          _.each(delta.ops, function(op) {
	            if (_.isString(op.insert)) {
	              _this._insertAt(index, op.insert, op.attributes);
	              return index += op.insert.length;
	            } else if (_.isNumber(op.insert)) {
	              _this._insertEmbed(index, op.attributes);
	              return index += 1;
	            } else if (_.isNumber(op["delete"])) {
	              return _this._deleteAt(index, op["delete"]);
	            } else if (_.isNumber(op.retain)) {
	              _.each(op.attributes, function(value, name) {
	                return _this._formatAt(index, op.retain, name, value);
	              });
	              return index += op.retain;
	            }
	          });
	          return _this.selection.shiftAfter(0, 0, _.bind(_this.doc.optimizeLines, _this.doc));
	        };
	      })(this));
	      this.delta = this.doc.toDelta();
	      this.length = this.delta.length();
	      this.innerHTML = this.root.innerHTML;
	      if (delta && source !== Editor.sources.SILENT) {
	        this.quill.emit(this.quill.constructor.events.TEXT_CHANGE, delta, source);
	      }
	    }
	    if (localDelta && localDelta.ops.length > 0 && source !== Editor.sources.SILENT) {
	      return this.quill.emit(this.quill.constructor.events.TEXT_CHANGE, localDelta, Editor.sources.USER);
	    }
	  };

	  Editor.prototype.checkUpdate = function(source) {
	    var delta;
	    if (source == null) {
	      source = 'user';
	    }
	    if (this.root.parentNode == null) {
	      return clearInterval(this.timer);
	    }
	    delta = this._update();
	    if (delta) {
	      this.delta.compose(delta);
	      this.length = this.delta.length();
	      this.quill.emit(this.quill.constructor.events.TEXT_CHANGE, delta, source);
	    }
	    if (delta) {
	      source = Editor.sources.SILENT;
	    }
	    return this.selection.update(source);
	  };

	  Editor.prototype.focus = function() {
	    if (this.selection.range != null) {
	      return this.selection.setRange(this.selection.range);
	    } else {      
	      return this.root.focus();
	    }
	  };

	  Editor.prototype.getBounds = function(index) {
	    var bounds, containerBounds, leaf, offset, range, ref, side;
	    this.checkUpdate();
	    ref = this.doc.findLeafAt(index, true), leaf = ref[0], offset = ref[1];
	    if (leaf == null) {
	      throw new Error('Invalid index');
	    }
	    containerBounds = this.root.parentNode.getBoundingClientRect();
	    side = 'left';
	    if (leaf.length === 0) {
	      bounds = leaf.node.parentNode.getBoundingClientRect();
	    } else if (dom.VOID_TAGS[leaf.node.tagName]) {
	      bounds = leaf.node.getBoundingClientRect();
	      if (offset === 1) {
	        side = 'right';
	      }
	    } else {
	      range = document.createRange();
	      if (offset < leaf.length) {
	        range.setStart(leaf.node, offset);
	        range.setEnd(leaf.node, offset + 1);
	      } else {
	        range.setStart(leaf.node, offset - 1);
	        range.setEnd(leaf.node, offset);
	        side = 'right';
	      }
	      bounds = range.getBoundingClientRect();
	    }
	    return {
	      height: bounds.height,
	      left: bounds[side] - containerBounds.left,
	      top: bounds.top - containerBounds.top
	    };
	  };

	  Editor.prototype._deleteAt = function(index, length) {
	    if (length <= 0) {
	      return;
	    }
	    return this.selection.shiftAfter(index, -1 * length, (function(_this) {
	      return function() {
	        var curLine, deleteLength, firstLine, mergeFirstLine, nextLine, offset, ref;
	        ref = _this.doc.findLineAt(index), firstLine = ref[0], offset = ref[1];
	        curLine = firstLine;
	        mergeFirstLine = firstLine.length - offset <= length && offset > 0;
	        while ((curLine != null) && length > 0) {
	          nextLine = curLine.next;
	          deleteLength = Math.min(curLine.length - offset, length);
	          if (offset === 0 && length >= curLine.length) {
	            _this.doc.removeLine(curLine);
	          } else {
	            curLine.deleteText(offset, deleteLength);
	          }
	          length -= deleteLength;
	          curLine = nextLine;
	          offset = 0;
	        }
	        if (mergeFirstLine && firstLine.next) {
	          return _this.doc.mergeLines(firstLine, firstLine.next);
	        }
	      };
	    })(this));
	  };

	  Editor.prototype._formatAt = function(index, length, name, value) {
	    return this.selection.shiftAfter(index, 0, (function(_this) {
	      return function() {
	        var formatLength, line, offset, ref, results;
	        ref = _this.doc.findLineAt(index), line = ref[0], offset = ref[1];
	        results = [];
	        while ((line != null) && length > 0) {
	          formatLength = Math.min(length, line.length - offset - 1);
	          line.formatText(offset, formatLength, name, value);
	          length -= formatLength;
	          if (length > 0) {
	            line.format(name, value);
	          }
	          length -= 1;
	          offset = 0;
	          results.push(line = line.next);
	        }
	        return results;
	      };
	    })(this));
	  };

	  Editor.prototype._insertEmbed = function(index, attributes) {
	    return this.selection.shiftAfter(index, 1, (function(_this) {
	      return function() {
	        var line, offset, ref;
	        ref = _this.doc.findLineAt(index), line = ref[0], offset = ref[1];
	        return line.insertEmbed(offset, attributes);
	      };
	    })(this));
	  };

	  Editor.prototype._insertAt = function(index, text, formatting) {
	    if (formatting == null) {
	      formatting = {};
	    }
	    return this.selection.shiftAfter(index, text.length, (function(_this) {
	      return function() {
	        var line, lineTexts, offset, ref;
	        text = text.replace(/\r\n?/g, '\n');
	        lineTexts = text.split('\n');
	        ref = _this.doc.findLineAt(index), line = ref[0], offset = ref[1];
	        return _.each(lineTexts, function(lineText, i) {
	          var nextLine;
	          if ((line == null) || line.length <= offset) {
	            if (i < lineTexts.length - 1 || lineText.length > 0) {
	              line = _this.doc.appendLine(document.createElement(dom.DEFAULT_BLOCK_TAG));
	              offset = 0;
	              line.insertText(offset, lineText, formatting);
	              line.format(formatting);
	              nextLine = null;
	            }
	          } else {
	            line.insertText(offset, lineText, formatting);
	            if (i < lineTexts.length - 1) {
	              nextLine = _this.doc.splitLine(line, offset + lineText.length);
	              _.each(_.defaults({}, formatting, line.formats), function(value, format) {
	                return line.format(format, formatting[format]);
	              });
	              offset = 0;
	            }
	          }
	          return line = nextLine;
	        });
	      };
	    })(this));
	  };

	  Editor.prototype._trackDelta = function(fn) {
	    var delta, newDelta;
	    fn();
	    newDelta = this.doc.toDelta();
	    delta = this.delta.diff(newDelta);
	    return delta;
	  };

	  Editor.prototype._update = function() {
	    var delta;
	    if (this.innerHTML === this.root.innerHTML) {
	      return false;
	    }
	    delta = this._trackDelta((function(_this) {
	      return function() {
	        _this.selection.preserve(_.bind(_this.doc.rebuild, _this.doc));
	        return _this.selection.shiftAfter(0, 0, _.bind(_this.doc.optimizeLines, _this.doc));
	      };
	    })(this));
	    this.innerHTML = this.root.innerHTML;
	    if (delta.ops.length > 0) {
	      return delta;
	    } else {
	      return false;
	    }
	  };

	  return Editor;

	})();

	module.exports = Editor;



	},{"../lib/dom":17,"./document":8,"./line":12,"./selection":14,"lodash":1}],10:[function(_dereq_,module,exports){
	var Format, _, dom;

	_ = _dereq_('lodash');

	dom = _dereq_('../lib/dom');

	Format = (function() {
	  Format.types = {
	    LINE: 'line',
	    EMBED: 'embed'
	  };

	  Format.FORMATS = {
	    bold: {
	      tag: 'B',
	      prepare: 'bold'
	    },
	    italic: {
	      tag: 'I',
	      prepare: 'italic'
	    },
	    underline: {
	      tag: 'U',
	      prepare: 'underline'
	    },
	    strike: {
	      tag: 'S',
	      prepare: 'strikeThrough'
	    },
	    color: {
	      style: 'color',
	      "default": 'rgb(0, 0, 0)',
	      prepare: 'foreColor'
	    },
	    background: {
	      style: 'backgroundColor',
	      "default": 'rgb(255, 255, 255)',
	      prepare: 'backColor'
	    },
	    font: {
	      style: 'fontFamily',
	      "default": "'Helvetica', 'Arial', sans-serif",
	      prepare: 'fontName'
	    },
	    size: {
	      style: 'fontSize',
	      "default": '13px',
	      prepare: function(value) {
	        return document.execCommand('fontSize', false, dom.convertFontSize(value));
	      }
	    },
	    link: {
	      tag: 'A',
	      add: function(node, value) {
	        node.setAttribute('href', value);
	        return node;
	      },
	      remove: function(node) {
	        node.removeAttribute('href');
	        return node;
	      },
	      value: function(node) {
	        return node.getAttribute('href');
	      }
	    },
	    image: {
	      type: Format.types.EMBED,
	      tag: 'IMG',
	      attribute: 'src'
	    },
	    align: {
	      type: Format.types.LINE,
	      style: 'textAlign',
	      "default": 'left'
	    },
	    bullet: {
	      type: Format.types.LINE,
	      exclude: 'list',
	      parentTag: 'UL',
	      tag: 'LI'
	    },
	    list: {
	      type: Format.types.LINE,
	      exclude: 'bullet',
	      parentTag: 'OL',
	      tag: 'LI'
	    }
	  };

	  function Format(config) {
	    this.config = config;
	  }

	  Format.prototype.add = function(node, value) {
	    var formatNode, inline, parentNode, ref, ref1;
	    if (!value) {
	      return this.remove(node);
	    }
	    if (this.value(node) === value) {
	      return node;
	    }
	    if (_.isString(this.config.parentTag)) {
	      parentNode = document.createElement(this.config.parentTag);
	      dom(node).wrap(parentNode);
	      if (node.parentNode.tagName === ((ref = node.parentNode.previousSibling) != null ? ref.tagName : void 0)) {
	        dom(node.parentNode.previousSibling).merge(node.parentNode);
	      }
	      if (node.parentNode.tagName === ((ref1 = node.parentNode.nextSibling) != null ? ref1.tagName : void 0)) {
	        dom(node.parentNode).merge(node.parentNode.nextSibling);
	      }
	    }
	    if (_.isString(this.config.tag)) {
	      formatNode = document.createElement(this.config.tag);
	      if (dom.VOID_TAGS[formatNode.tagName] != null) {
	        if (node.parentNode != null) {
	          dom(node).replace(formatNode);
	        }
	        node = formatNode;
	      } else if (this.isType(Format.types.LINE)) {
	        node = dom(node).switchTag(this.config.tag);
	      } else {
	        dom(node).wrap(formatNode);
	        node = formatNode;
	      }
	    }
	    if (_.isString(this.config.style) || _.isString(this.config.attribute) || _.isString(this.config["class"])) {
	      if (_.isString(this.config["class"])) {
	        node = this.remove(node);
	      }
	      if (dom(node).isTextNode()) {
	        inline = document.createElement(dom.DEFAULT_INLINE_TAG);
	        dom(node).wrap(inline);
	        node = inline;
	      }
	      if (_.isString(this.config.style)) {
	        if (value !== this.config["default"]) {
	          node.style[this.config.style] = value;
	        }
	      }
	      if (_.isString(this.config.attribute)) {
	        node.setAttribute(this.config.attribute, value);
	      }
	      if (_.isString(this.config["class"])) {
	        dom(node).addClass(this.config["class"] + value);
	      }
	    }
	    if (_.isFunction(this.config.add)) {
	      node = this.config.add(node, value);
	    }
	    return node;
	  };

	  Format.prototype.isType = function(type) {
	    return type === this.config.type;
	  };

	  Format.prototype.match = function(node) {
	    var c, i, len, ref, ref1;
	    if (!dom(node).isElement()) {
	      return false;
	    }
	    if (_.isString(this.config.parentTag) && ((ref = node.parentNode) != null ? ref.tagName : void 0) !== this.config.parentTag) {
	      return false;
	    }
	    if (_.isString(this.config.tag) && node.tagName !== this.config.tag) {
	      return false;
	    }
	    if (_.isString(this.config.style) && (!node.style[this.config.style] || node.style[this.config.style] === this.config["default"])) {
	      return false;
	    }
	    if (_.isString(this.config.attribute) && !node.hasAttribute(this.config.attribute)) {
	      return false;
	    }
	    if (_.isString(this.config["class"])) {
	      ref1 = dom(node).classes();
	      for (i = 0, len = ref1.length; i < len; i++) {
	        c = ref1[i];
	        if (c.indexOf(this.config["class"]) === 0) {
	          return true;
	        }
	      }
	      return false;
	    }
	    return true;
	  };

	  Format.prototype.prepare = function(value) {
	    if (_.isString(this.config.prepare)) {
	      return document.execCommand(this.config.prepare, false, value);
	    } else if (_.isFunction(this.config.prepare)) {
	      return this.config.prepare(value);
	    }
	  };

	  Format.prototype.remove = function(node) {
	    var c, i, len, ref;
	    if (!this.match(node)) {
	      return node;
	    }
	    if (_.isString(this.config.style)) {
	      node.style[this.config.style] = '';
	      if (!node.getAttribute('style')) {
	        node.removeAttribute('style');
	      }
	    }
	    if (_.isString(this.config.attribute)) {
	      node.removeAttribute(this.config.attribute);
	    }
	    if (_.isString(this.config["class"])) {
	      ref = dom(node).classes();
	      for (i = 0, len = ref.length; i < len; i++) {
	        c = ref[i];
	        if (c.indexOf(this.config["class"]) === 0) {
	          dom(node).removeClass(c);
	        }
	      }
	    }
	    if (_.isString(this.config.tag)) {
	      if (this.isType(Format.types.LINE)) {
	        if (_.isString(this.config.parentTag)) {
	          if (node.previousSibling != null) {
	            dom(node).splitBefore(node.parentNode.parentNode);
	          }
	          if (node.nextSibling != null) {
	            dom(node.nextSibling).splitBefore(node.parentNode.parentNode);
	          }
	        }
	        node = dom(node).switchTag(dom.DEFAULT_BLOCK_TAG);
	      } else if (this.isType(Format.types.EMBED)) {
	        dom(node).remove();
	        return void 0;
	      } else {
	        node = dom(node).switchTag(dom.DEFAULT_INLINE_TAG);
	      }
	    }
	    if (_.isString(this.config.parentTag)) {
	      dom(node.parentNode).unwrap();
	    }
	    if (_.isFunction(this.config.remove)) {
	      node = this.config.remove(node);
	    }
	    if (node.tagName === dom.DEFAULT_INLINE_TAG && !node.hasAttributes()) {
	      node = dom(node).unwrap();
	    }
	    return node;
	  };

	  Format.prototype.value = function(node) {
	    var c, i, len, ref;
	    if (!this.match(node)) {
	      return void 0;
	    }
	    if (this.config.value) {
	      return this.config.value(node);
	    }
	    if (_.isString(this.config.attribute)) {
	      return node.getAttribute(this.config.attribute) || void 0;
	    } else if (_.isString(this.config.style)) {
	      return node.style[this.config.style] || void 0;
	    } else if (_.isString(this.config["class"])) {
	      ref = dom(node).classes();
	      for (i = 0, len = ref.length; i < len; i++) {
	        c = ref[i];
	        if (c.indexOf(this.config["class"]) === 0) {
	          return c.slice(this.config["class"].length);
	        }
	      }
	    } else if (_.isString(this.config.tag)) {
	      return true;
	    }
	    return void 0;
	  };

	  return Format;

	})();

	module.exports = Format;



	},{"../lib/dom":17,"lodash":1}],11:[function(_dereq_,module,exports){
	var Format, Leaf, LinkedList, _, dom,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;

	_ = _dereq_('lodash');

	dom = _dereq_('../lib/dom');

	Format = _dereq_('./format');

	LinkedList = _dereq_('../lib/linked-list');

	Leaf = (function(superClass) {
	  extend(Leaf, superClass);

	  Leaf.DATA_KEY = 'leaf';

	  Leaf.isLeafNode = function(node) {
	    return dom(node).isTextNode() || (node.firstChild == null);
	  };

	  function Leaf(node1, formats) {
	    this.node = node1;
	    this.formats = _.clone(formats);
	    this.text = dom(this.node).text();
	    this.length = this.text.length;
	    dom(this.node).data(Leaf.DATA_KEY, this);
	  }

	  Leaf.prototype.deleteText = function(offset, length) {
	    var textNode;
	    if (!(length > 0)) {
	      return;
	    }
	    this.text = this.text.slice(0, offset) + this.text.slice(offset + length);
	    this.length = this.text.length;
	    if (dom.EMBED_TAGS[this.node.tagName] != null) {
	      textNode = document.createTextNode(this.text);
	      dom(textNode).data(Leaf.DATA_KEY, this);
	      return this.node = dom(this.node).replace(textNode);
	    } else {
	      return dom(this.node).text(this.text);
	    }
	  };

	  Leaf.prototype.insertText = function(offset, text) {
	    var textNode;
	    this.text = this.text.slice(0, offset) + text + this.text.slice(offset);
	    if (dom(this.node).isTextNode()) {
	      dom(this.node).text(this.text);
	    } else {
	      textNode = document.createTextNode(text);
	      dom(textNode).data(Leaf.DATA_KEY, this);
	      if (this.node.tagName === dom.DEFAULT_BREAK_TAG) {
	        this.node = dom(this.node).replace(textNode);
	      } else {
	        this.node.appendChild(textNode);
	        this.node = textNode;
	      }
	    }
	    return this.length = this.text.length;
	  };

	  return Leaf;

	})(LinkedList.Node);

	module.exports = Leaf;



	},{"../lib/dom":17,"../lib/linked-list":18,"./format":10,"lodash":1}],12:[function(_dereq_,module,exports){
	var Delta, Format, Leaf, Line, LinkedList, Normalizer, _, dom,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;

	_ = _dereq_('lodash');

	Delta = _dereq_('rich-text/lib/delta');

	dom = _dereq_('../lib/dom');

	Format = _dereq_('./format');

	Leaf = _dereq_('./leaf');

	Line = _dereq_('./line');

	LinkedList = _dereq_('../lib/linked-list');

	Normalizer = _dereq_('./normalizer');

	Line = (function(superClass) {
	  extend(Line, superClass);

	  Line.DATA_KEY = 'line';

	  function Line(doc, node1) {
	    this.doc = doc;
	    this.node = node1;
	    this.formats = {};
	    this.rebuild();
	    Line.__super__.constructor.call(this, this.node);
	  }

	  Line.prototype.buildLeaves = function(node, formats) {
	    return _.each(dom(node).childNodes(), (function(_this) {
	      return function(node) {
	        var nodeFormats;
	        node = _this.doc.normalizer.normalizeNode(node);
	        nodeFormats = _.clone(formats);
	        _.each(_this.doc.formats, function(format, name) {
	          if (!format.isType(Format.types.LINE) && format.match(node)) {
	            return nodeFormats[name] = format.value(node);
	          }
	        });
	        if (Leaf.isLeafNode(node)) {
	          return _this.leaves.append(new Leaf(node, nodeFormats));
	        } else {
	          return _this.buildLeaves(node, nodeFormats);
	        }
	      };
	    })(this));
	  };

	  Line.prototype.deleteText = function(offset, length) {
	    var deleteLength, leaf, ref;
	    if (!(length > 0)) {
	      return;
	    }
	    ref = this.findLeafAt(offset), leaf = ref[0], offset = ref[1];
	    while ((leaf != null) && length > 0) {
	      deleteLength = Math.min(length, leaf.length - offset);
	      leaf.deleteText(offset, deleteLength);
	      length -= deleteLength;
	      leaf = leaf.next;
	      offset = 0;
	    }
	    return this.rebuild();
	  };

	  Line.prototype.findLeaf = function(leafNode) {
	    if (leafNode != null) {
	      return dom(leafNode).data(Leaf.DATA_KEY);
	    } else {
	      return void 0;
	    }
	  };

	  Line.prototype.findLeafAt = function(offset, inclusive) {
	    var leaf;
	    if (inclusive == null) {
	      inclusive = false;
	    }
	    if (offset >= this.length - 1) {
	      return [this.leaves.last, this.leaves.last.length];
	    }
	    leaf = this.leaves.first;
	    while (leaf != null) {
	      if (offset < leaf.length || (offset === leaf.length && inclusive)) {
	        return [leaf, offset];
	      }
	      offset -= leaf.length;
	      leaf = leaf.next;
	    }
	    return [this.leaves.last, offset - this.leaves.last.length];
	  };

	  Line.prototype.format = function(name, value) {
	    var formats;
	    if (_.isObject(name)) {
	      formats = name;
	    } else {
	      formats = {};
	      formats[name] = value;
	    }
	    _.each(formats, (function(_this) {
	      return function(value, name) {
	        var excludeFormat, format;
	        format = _this.doc.formats[name];
	        if (format == null) {
	          return;
	        }
	        if (format.isType(Format.types.LINE)) {
	          if (format.config.exclude && _this.formats[format.config.exclude]) {
	            excludeFormat = _this.doc.formats[format.config.exclude];
	            if (excludeFormat != null) {
	              _this.node = excludeFormat.remove(_this.node);
	              delete _this.formats[format.config.exclude];
	            }
	          }
	          _this.node = format.add(_this.node, value);
	        }
	        if (value) {
	          return _this.formats[name] = value;
	        } else {
	          return delete _this.formats[name];
	        }
	      };
	    })(this));
	    return this.resetContent();
	  };

	  Line.prototype.formatText = function(offset, length, name, value) {
	    var format, leaf, leafOffset, leftNode, nextLeaf, ref, ref1, ref2, rightNode, targetNode;
	    ref = this.findLeafAt(offset), leaf = ref[0], leafOffset = ref[1];
	    format = this.doc.formats[name];
	    if (!((format != null) && format.config.type !== Format.types.LINE)) {
	      return;
	    }
	    while ((leaf != null) && length > 0) {
	      nextLeaf = leaf.next;
	      if ((value && leaf.formats[name] !== value) || (!value && (leaf.formats[name] != null))) {
	        targetNode = leaf.node;
	        if (leaf.formats[name] != null) {
	          dom(targetNode).splitBefore(this.node);
	          while (!format.match(targetNode)) {
	            targetNode = targetNode.parentNode;
	          }
	          dom(targetNode).split(leaf.length);
	        }
	        if (leafOffset > 0) {
	          ref1 = dom(targetNode).split(leafOffset), leftNode = ref1[0], targetNode = ref1[1];
	        }
	        if (leaf.length > leafOffset + length) {
	          ref2 = dom(targetNode).split(length), targetNode = ref2[0], rightNode = ref2[1];
	        }
	        format.add(targetNode, value);
	      }
	      length -= leaf.length - leafOffset;
	      leafOffset = 0;
	      leaf = nextLeaf;
	    }
	    return this.rebuild();
	  };

	  Line.prototype._insert = function(offset, node, formats) {
	    var leaf, leafOffset, nextNode, prevNode, ref, ref1;
	    ref = this.findLeafAt(offset), leaf = ref[0], leafOffset = ref[1];
	    node = _.reduce(formats, (function(_this) {
	      return function(node, value, name) {
	        var format;
	        format = _this.doc.formats[name];
	        if (format != null) {
	          node = format.add(node, value);
	        }
	        return node;
	      };
	    })(this), node);
	    ref1 = dom(leaf.node).split(leafOffset), prevNode = ref1[0], nextNode = ref1[1];
	    if (nextNode) {
	      nextNode = dom(nextNode).splitBefore(this.node).get();
	    }
	    this.node.insertBefore(node, nextNode);
	    return this.rebuild();
	  };

	  Line.prototype.insertEmbed = function(offset, attributes) {
	    var formatName, leaf, leafOffset, nextNode, node, prevNode, ref, ref1;
	    ref = this.findLeafAt(offset), leaf = ref[0], leafOffset = ref[1];
	    ref1 = dom(leaf.node).split(leafOffset), prevNode = ref1[0], nextNode = ref1[1];
	    formatName = _.find(Object.keys(attributes), (function(_this) {
	      return function(name) {
	        return _this.doc.formats[name].isType(Format.types.EMBED);
	      };
	    })(this));
	    node = this.doc.formats[formatName].add({}, attributes[formatName]);
	    attributes = _.clone(attributes);
	    delete attributes[formatName];
	    return this._insert(offset, node, attributes);
	  };

	  Line.prototype.insertText = function(offset, text, formats) {
	    var leaf, leafOffset, ref;
	    if (formats == null) {
	      formats = {};
	    }
	    if (!(text.length > 0)) {
	      return;
	    }
	    ref = this.findLeafAt(offset), leaf = ref[0], leafOffset = ref[1];
	    if (_.isEqual(leaf.formats, formats)) {
	      leaf.insertText(leafOffset, text);
	      return this.resetContent();
	    } else {
	      return this._insert(offset, document.createTextNode(text), formats);
	    }
	  };

	  Line.prototype.optimize = function() {
	    Normalizer.optimizeLine(this.node);
	    return this.rebuild();
	  };

	  Line.prototype.rebuild = function(force) {
	    if (force == null) {
	      force = false;
	    }
	    if (!force && (this.outerHTML != null) && this.outerHTML === this.node.outerHTML) {
	      if (_.all(this.leaves.toArray(), (function(_this) {
	        return function(leaf) {
	          return dom(leaf.node).isAncestor(_this.node);
	        };
	      })(this))) {
	        return false;
	      }
	    }
	    this.node = this.doc.normalizer.normalizeNode(this.node);
	    if (dom(this.node).length() === 0 && !this.node.querySelector(dom.DEFAULT_BREAK_TAG)) {
	      this.node.appendChild(document.createElement(dom.DEFAULT_BREAK_TAG));
	    }
	    this.leaves = new LinkedList();
	    this.formats = _.reduce(this.doc.formats, (function(_this) {
	      return function(formats, format, name) {
	        if (format.isType(Format.types.LINE)) {
	          if (format.match(_this.node)) {
	            formats[name] = format.value(_this.node);
	          } else {
	            delete formats[name];
	          }
	        }
	        return formats;
	      };
	    })(this), this.formats);
	    this.buildLeaves(this.node, {});
	    this.resetContent();
	    return true;
	  };

	  Line.prototype.resetContent = function() {
	    dom(this.node).data(Line.DATA_KEY, this);
	    this.outerHTML = this.node.outerHTML;
	    this.length = 1;
	    this.delta = new Delta();
	    _.each(this.leaves.toArray(), (function(_this) {
	      return function(leaf) {
	        _this.length += leaf.length;
	        if (dom.EMBED_TAGS[leaf.node.tagName] != null) {
	          return _this.delta.insert(1, leaf.formats);
	        } else {
	          return _this.delta.insert(leaf.text, leaf.formats);
	        }
	      };
	    })(this));
	    return this.delta.insert('\n', this.formats);
	  };

	  return Line;

	})(LinkedList.Node);

	module.exports = Line;



	},{"../lib/dom":17,"../lib/linked-list":18,"./format":10,"./leaf":11,"./line":12,"./normalizer":13,"lodash":1,"rich-text/lib/delta":3}],13:[function(_dereq_,module,exports){
	var Normalizer, _, camelize, dom;

	_ = _dereq_('lodash');

	dom = _dereq_('../lib/dom');

	camelize = function(str) {
	  str = str.replace(/(?:^|[-_])(\w)/g, function(i, c) {
	    if (c) {
	      return c.toUpperCase();
	    } else {
	      return '';
	    }
	  });
	  return str.charAt(0).toLowerCase() + str.slice(1);
	};

	Normalizer = (function() {
	  Normalizer.ALIASES = {
	    'STRONG': 'B',
	    'EM': 'I',
	    'DEL': 'S',
	    'STRIKE': 'S'
	  };

	  Normalizer.ATTRIBUTES = {
	    'color': 'color',
	    'face': 'fontFamily',
	    'size': 'fontSize'
	  };

	  function Normalizer() {
	    this.whitelist = {
	      styles: {},
	      tags: {}
	    };
	    this.whitelist.tags[dom.DEFAULT_BREAK_TAG] = true;
	    this.whitelist.tags[dom.DEFAULT_BLOCK_TAG] = true;
	    this.whitelist.tags[dom.DEFAULT_INLINE_TAG] = true;
	  }

	  Normalizer.prototype.addFormat = function(config) {
	    if (config.tag != null) {
	      this.whitelist.tags[config.tag] = true;
	    }
	    if (config.parentTag != null) {
	      this.whitelist.tags[config.parentTag] = true;
	    }
	    if (config.style != null) {
	      return this.whitelist.styles[config.style] = true;
	    }
	  };

	  Normalizer.prototype.normalizeLine = function(lineNode) {
	    lineNode = Normalizer.wrapInline(lineNode);
	    lineNode = Normalizer.handleBreaks(lineNode);
	    lineNode = Normalizer.pullBlocks(lineNode);
	    lineNode = this.normalizeNode(lineNode);
	    Normalizer.unwrapText(lineNode);
	    if ((lineNode != null) && (dom.LIST_TAGS[lineNode.tagName] != null)) {
	      lineNode = lineNode.firstChild;
	    }
	    return lineNode;
	  };

	  Normalizer.prototype.normalizeNode = function(node) {
	    if (dom(node).isTextNode()) {
	      return node;
	    }
	    _.each(Normalizer.ATTRIBUTES, function(style, attribute) {
	      var value;
	      if (node.hasAttribute(attribute)) {
	        value = node.getAttribute(attribute);
	        if (attribute === 'size') {
	          value = dom.convertFontSize(value);
	        }
	        node.style[style] = value;
	        return node.removeAttribute(attribute);
	      }
	    });
	    this.whitelistStyles(node);
	    return this.whitelistTags(node);
	  };

	  Normalizer.prototype.whitelistStyles = function(node) {
	    var original, styles;
	    original = dom(node).styles();
	    styles = _.omit(original, (function(_this) {
	      return function(value, key) {
	        return _this.whitelist.styles[camelize(key)] == null;
	      };
	    })(this));
	    if (Object.keys(styles).length < Object.keys(original).length) {
	      if (Object.keys(styles).length > 0) {
	        return dom(node).styles(styles, true);
	      } else {
	        return node.removeAttribute('style');
	      }
	    }
	  };

	  Normalizer.prototype.whitelistTags = function(node) {
	    if (!dom(node).isElement()) {
	      return node;
	    }
	    if (Normalizer.ALIASES[node.tagName] != null) {
	      node = dom(node).switchTag(Normalizer.ALIASES[node.tagName]);
	    } else if (this.whitelist.tags[node.tagName] == null) {
	      if (dom.BLOCK_TAGS[node.tagName] != null) {
	        node = dom(node).switchTag(dom.DEFAULT_BLOCK_TAG);
	      } else if (!node.hasAttributes() && (node.firstChild != null)) {
	        node = dom(node).unwrap();
	      } else {
	        node = dom(node).switchTag(dom.DEFAULT_INLINE_TAG);
	      }
	    }
	    return node;
	  };

	  Normalizer.handleBreaks = function(lineNode) {
	    var breaks;
	    breaks = _.map(lineNode.querySelectorAll(dom.DEFAULT_BREAK_TAG));
	    _.each(breaks, (function(_this) {
	      return function(br) {
	        if ((br.nextSibling != null) && (!dom.isIE(10) || (br.previousSibling != null))) {
	          return dom(br.nextSibling).splitBefore(lineNode.parentNode);
	        }
	      };
	    })(this));
	    return lineNode;
	  };

	  Normalizer.optimizeLine = function(lineNode) {
	    var lineNodeLength, node, nodes, results;
	    lineNode.normalize();
	    lineNodeLength = dom(lineNode).length();
	    nodes = dom(lineNode).descendants();
	    results = [];
	    while (nodes.length > 0) {
	      node = nodes.pop();
	      if ((node != null ? node.parentNode : void 0) == null) {
	        continue;
	      }
	      if (dom.EMBED_TAGS[node.tagName] != null) {
	        continue;
	      }
	      if (node.tagName === dom.DEFAULT_BREAK_TAG) {
	        if (lineNodeLength !== 0) {
	          results.push(dom(node).remove());
	        } else {
	          results.push(void 0);
	        }
	      } else if (dom(node).length() === 0) {
	        nodes.push(node.nextSibling);
	        results.push(dom(node).unwrap());
	      } else if ((node.previousSibling != null) && node.tagName === node.previousSibling.tagName) {
	        if (_.isEqual(dom(node).attributes(), dom(node.previousSibling).attributes())) {
	          nodes.push(node.firstChild);
	          results.push(dom(node.previousSibling).merge(node));
	        } else {
	          results.push(void 0);
	        }
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  };

	  Normalizer.pullBlocks = function(lineNode) {
	    var curNode;
	    curNode = lineNode.firstChild;
	    while (curNode != null) {
	      if ((dom.BLOCK_TAGS[curNode.tagName] != null) && curNode.tagName !== 'LI') {
	        dom(curNode).isolate(lineNode.parentNode);
	        if ((dom.LIST_TAGS[curNode.tagName] == null) || !curNode.firstChild) {
	          dom(curNode).unwrap();
	          Normalizer.pullBlocks(lineNode);
	        } else {
	          dom(curNode.parentNode).unwrap();
	          if (lineNode.parentNode == null) {
	            lineNode = curNode;
	          }
	        }
	        break;
	      }
	      curNode = curNode.nextSibling;
	    }
	    return lineNode;
	  };

	  Normalizer.stripComments = function(html) {
	    return html.replace(/<!--[\s\S]*?-->/g, '');
	  };

	  Normalizer.stripWhitespace = function(html) {
	    html = html.trim();
	    html = html.replace(/(\r?\n|\r)+/g, ' ');
	    html = html.replace(/\>\s+\</g, '><');
	    return html;
	  };

	  Normalizer.wrapInline = function(lineNode) {
	    var blockNode, nextNode;
	    if (dom.BLOCK_TAGS[lineNode.tagName] != null) {
	      return lineNode;
	    }
	    blockNode = document.createElement(dom.DEFAULT_BLOCK_TAG);
	    lineNode.parentNode.insertBefore(blockNode, lineNode);
	    while ((lineNode != null) && (dom.BLOCK_TAGS[lineNode.tagName] == null)) {
	      nextNode = lineNode.nextSibling;
	      blockNode.appendChild(lineNode);
	      lineNode = nextNode;
	    }
	    return blockNode;
	  };

	  Normalizer.unwrapText = function(lineNode) {
	    var spans;
	    spans = _.map(lineNode.querySelectorAll(dom.DEFAULT_INLINE_TAG));
	    return _.each(spans, function(span) {
	      if (!span.hasAttributes()) {
	        return dom(span).unwrap();
	      }
	    });
	  };

	  return Normalizer;

	})();

	module.exports = Normalizer;



	},{"../lib/dom":17,"lodash":1}],14:[function(_dereq_,module,exports){
	var Leaf, Normalizer, Range, Selection, _, dom;

	_ = _dereq_('lodash');

	dom = _dereq_('../lib/dom');

	Leaf = _dereq_('./leaf');

	Normalizer = _dereq_('./normalizer');

	Range = _dereq_('../lib/range');

	Selection = (function() {
	  function Selection(doc, emitter) {
	    this.doc = doc;
	    this.emitter = emitter;
	    this.focus = false;
	    this.range = new Range(0, 0);
	    this.nullDelay = false;
	    this.update('silent');
	  }

	  Selection.prototype.checkFocus = function() {
	    return document.activeElement === this.doc.root;
	  };

	  Selection.prototype.getRange = function(ignoreFocus) {
	    var end, nativeRange, start;
	    if (ignoreFocus == null) {
	      ignoreFocus = false;
	    }
	    if (this.checkFocus()) {
	      nativeRange = this._getNativeRange();
	      if (nativeRange == null) {
	        return null;
	      }
	      start = this._positionToIndex(nativeRange.startContainer, nativeRange.startOffset);
	      if (nativeRange.startContainer === nativeRange.endContainer && nativeRange.startOffset === nativeRange.endOffset) {
	        end = start;
	      } else {
	        end = this._positionToIndex(nativeRange.endContainer, nativeRange.endOffset);
	      }
	      return new Range(Math.min(start, end), Math.max(start, end));
	    } else if (ignoreFocus) {
	      return this.range;
	    } else {
	      return null;
	    }
	  };

	  Selection.prototype.preserve = function(fn) {
	    var endNode, endOffset, nativeRange, ref, ref1, ref2, ref3, startNode, startOffset;
	    nativeRange = this._getNativeRange();
	    if ((nativeRange != null) && this.checkFocus()) {
	      ref = this._encodePosition(nativeRange.startContainer, nativeRange.startOffset), startNode = ref[0], startOffset = ref[1];
	      ref1 = this._encodePosition(nativeRange.endContainer, nativeRange.endOffset), endNode = ref1[0], endOffset = ref1[1];
	      fn();
	      ref2 = this._decodePosition(startNode, startOffset), startNode = ref2[0], startOffset = ref2[1];
	      ref3 = this._decodePosition(endNode, endOffset), endNode = ref3[0], endOffset = ref3[1];
	      return this._setNativeRange(startNode, startOffset, endNode, endOffset);
	    } else {
	      return fn();
	    }
	  };

	  Selection.prototype.setRange = function(range, source) {
	    var endNode, endOffset, ref, ref1, ref2, startNode, startOffset;


	    if (range != null) {
	      ref = this._indexToPosition(range.start), startNode = ref[0], startOffset = ref[1];
	      if (range.isCollapsed()) {
	        ref1 = [startNode, startOffset], endNode = ref1[0], endOffset = ref1[1];
	      } else {
	        ref2 = this._indexToPosition(range.end), endNode = ref2[0], endOffset = ref2[1];
	      }
	      this._setNativeRange(startNode, startOffset, endNode, endOffset);
	    } else {
	      this._setNativeRange(null);
	    }
	    return this.update(source);
	  };

	  Selection.prototype.shiftAfter = function(index, length, fn) {
	    var range;
	    range = this.getRange();
	    fn();
	    if (range != null) {
	      range.shift(index, length);
	      return this.setRange(range, 'silent');
	    }
	  };

	  Selection.prototype.update = function(source) {
	    var emit, focus, range, toEmit;
	    focus = this.checkFocus();
	    range = this.getRange(true);
	    emit = source !== 'silent' && (!Range.compare(range, this.range) || focus !== this.focus);
	    toEmit = focus ? range : null;
	    if (toEmit === null && source === 'user' && !this.nullDelay) {
	      return this.nullDelay = true;
	    } else {
	      this.nullDelay = false;
	      this.range = range;
	      this.focus = focus;
	      if (emit) {
	        return this.emitter.emit(this.emitter.constructor.events.SELECTION_CHANGE, toEmit, source);
	      }
	    }
	  };

	  Selection.prototype._decodePosition = function(node, offset) {
	    var childIndex;
	    if (dom(node).isElement()) {
	      childIndex = dom(node.parentNode).childNodes().indexOf(node);
	      offset += childIndex;
	      node = node.parentNode;
	    }
	    return [node, offset];
	  };

	  Selection.prototype._encodePosition = function(node, offset) {
	    var text;
	    while (true) {
	      if (dom(node).isTextNode() || node.tagName === dom.DEFAULT_BREAK_TAG || (dom.EMBED_TAGS[node.tagName] != null)) {
	        return [node, offset];
	      } else if (offset < node.childNodes.length) {
	        node = node.childNodes[offset];
	        offset = 0;
	      } else if (node.childNodes.length === 0) {
	        if (this.doc.normalizer.whitelist.tags[node.tagName] == null) {
	          text = document.createTextNode('');
	          node.appendChild(text);
	          node = text;
	        }
	        return [node, 0];
	      } else {
	        node = node.lastChild;
	        if (dom(node).isElement()) {
	          if (node.tagName === dom.DEFAULT_BREAK_TAG || (dom.EMBED_TAGS[node.tagName] != null)) {
	            return [node, 1];
	          } else {
	            offset = node.childNodes.length;
	          }
	        } else {
	          return [node, dom(node).length()];
	        }
	      }
	    }
	  };

	  Selection.prototype._getNativeRange = function() {
	    var range, selection;
	    selection = document.getSelection();
	    if ((selection != null ? selection.rangeCount : void 0) > 0) {
	      range = selection.getRangeAt(0);
	      if (dom(range.startContainer).isAncestor(this.doc.root, true)) {
	        if (range.startContainer === range.endContainer || dom(range.endContainer).isAncestor(this.doc.root, true)) {
	          return range;
	        }
	      }
	    }
	    return null;
	  };

	  Selection.prototype._indexToPosition = function(index) {
	    var leaf, offset, ref;
	    if (this.doc.lines.length === 0) {
	      return [this.doc.root, 0];
	    }
	    ref = this.doc.findLeafAt(index, true), leaf = ref[0], offset = ref[1];
	    return this._decodePosition(leaf.node, offset);
	  };

	  Selection.prototype._positionToIndex = function(node, offset) {
	    var leaf, leafNode, leafOffset, line, lineOffset, ref;
	    if (dom.isIE(10) && node.tagName === 'BR' && offset === 1) {
	      offset = 0;
	    }
	    ref = this._encodePosition(node, offset), leafNode = ref[0], offset = ref[1];
	    line = this.doc.findLine(leafNode);
	    if (line == null) {
	      return 0;
	    }
	    leaf = line.findLeaf(leafNode);
	    lineOffset = 0;
	    while (line.prev != null) {
	      line = line.prev;
	      lineOffset += line.length;
	    }
	    if (leaf == null) {
	      return lineOffset;
	    }
	    leafOffset = 0;
	    while (leaf.prev != null) {
	      leaf = leaf.prev;
	      leafOffset += leaf.length;
	    }
	    return lineOffset + leafOffset + offset;
	  };

	  Selection.prototype._setNativeRange = function(startNode, startOffset, endNode, endOffset) {

	    var nativeRange, selection;
	    selection = document.getSelection();
	    if (!selection) {
	      return;
	    }
	    if (startNode != null) {

	      if (!this.checkFocus()) {
	        // TRAVIS: The focus was causing a scroll event that moved us to the top of the element
	        //         in chrome and safari. But without it in Firefox, the system doesn't 
	        //         work (though it doesn't cause the scroll problem). 
	        ///        So we now save the current scroll position and restore it.
	        var x = window.scrollX, y = window.scrollY;
	        this.doc.root.focus();
	        if(window.scrollTo)
	          window.scrollTo(x, y);
	      }

	      nativeRange = this._getNativeRange();
	      
	      if ((nativeRange == null) || startNode !== nativeRange.startContainer || startOffset !== nativeRange.startOffset || endNode !== nativeRange.endContainer || endOffset !== nativeRange.endOffset) {
	        selection.removeAllRanges();
	        nativeRange = document.createRange();
	        nativeRange.setStart(startNode, startOffset);
	        nativeRange.setEnd(endNode, endOffset);
	        return selection.addRange(nativeRange);
	      }
	    } else {
	      selection.removeAllRanges();
	      this.doc.root.blur();
	      if (dom.isIE(11) && !dom.isIE(9)) {
	        return document.body.focus();
	      }
	    }
	  };

	  return Selection;

	})();

	module.exports = Selection;



	},{"../lib/dom":17,"../lib/range":20,"./leaf":11,"./normalizer":13,"lodash":1}],15:[function(_dereq_,module,exports){
	_dereq_('./modules/authorship');

	_dereq_('./modules/image-tooltip');

	_dereq_('./modules/keyboard');

	_dereq_('./modules/link-tooltip');

	_dereq_('./modules/multi-cursor');

	_dereq_('./modules/paste-manager');

	_dereq_('./modules/toolbar');

	_dereq_('./modules/tooltip');

	_dereq_('./modules/undo-manager');

	module.exports = _dereq_('./quill');



	},{"./modules/authorship":21,"./modules/image-tooltip":22,"./modules/keyboard":23,"./modules/link-tooltip":24,"./modules/multi-cursor":25,"./modules/paste-manager":26,"./modules/toolbar":27,"./modules/tooltip":28,"./modules/undo-manager":29,"./quill":30}],16:[function(_dereq_,module,exports){
	var ColorPicker, Picker, dom,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;

	dom = _dereq_('./dom');

	Picker = _dereq_('./picker');

	ColorPicker = (function(superClass) {
	  extend(ColorPicker, superClass);

	  function ColorPicker() {
	    ColorPicker.__super__.constructor.apply(this, arguments);
	    dom(this.container).addClass('ql-color-picker');
	  }

	  ColorPicker.prototype.buildItem = function(picker, option, index) {
	    var item;
	    item = ColorPicker.__super__.buildItem.call(this, picker, option, index);
	    item.style.backgroundColor = option.value;
	    return item;
	  };

	  return ColorPicker;

	})(Picker);

	module.exports = ColorPicker;



	},{"./dom":17,"./picker":19}],17:[function(_dereq_,module,exports){
	var SelectWrapper, Wrapper, _, dom, lastKeyEvent,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;

	_ = _dereq_('lodash');

	lastKeyEvent = null;

	Wrapper = (function() {
	  function Wrapper(node1) {
	    this.node = node1;
	    this.trigger = bind(this.trigger, this);
	  }

	  Wrapper.prototype.addClass = function(cssClass) {
	    if (this.hasClass(cssClass)) {
	      return;
	    }
	    if (this.node.classList != null) {
	      this.node.classList.add(cssClass);
	    } else if (this.node.className != null) {
	      this.node.className = (this.node.className + ' ' + cssClass).trim();
	    }
	    return this;
	  };

	  Wrapper.prototype.attributes = function(attributes) {
	    var attr, i, j, len, ref, value;
	    if (attributes) {
	      _.each(attributes, (function(_this) {
	        return function(value, name) {
	          return _this.node.setAttribute(name, value);
	        };
	      })(this));
	      return this;
	    } else {
	      if (this.node.attributes == null) {
	        return {};
	      }
	      attributes = {};
	      ref = this.node.attributes;
	      for (i = j = 0, len = ref.length; j < len; i = ++j) {
	        value = ref[i];
	        attr = this.node.attributes[i];
	        attributes[attr.name] = attr.value;
	      }
	      return attributes;
	    }
	  };

	  Wrapper.prototype.child = function(offset) {
	    var child, length;
	    child = this.node.firstChild;
	    length = dom(child).length();
	    while (child != null) {
	      if (offset < length) {
	        break;
	      }
	      offset -= length;
	      child = child.nextSibling;
	      length = dom(child).length();
	    }
	    if (child == null) {
	      child = this.node.lastChild;
	      offset = dom(child).length();
	    }
	    return [child, offset];
	  };

	  Wrapper.prototype.childNodes = function() {
	    return _.map(this.node.childNodes);
	  };

	  Wrapper.prototype.classes = function() {
	    return this.node.className.split(/\s+/);
	  };

	  Wrapper.prototype.data = function(key, value) {
	    var ref;
	    if (value != null) {
	      if (this.node['ql-data'] == null) {
	        this.node['ql-data'] = {};
	      }
	      this.node['ql-data'][key] = value;
	      return this;
	    } else {
	      return (ref = this.node['ql-data']) != null ? ref[key] : void 0;
	    }
	  };

	  Wrapper.prototype.descendants = function() {
	    return _.map(this.node.getElementsByTagName('*'));
	  };

	  Wrapper.prototype.get = function() {
	    return this.node;
	  };

	  Wrapper.prototype.hasClass = function(cssClass) {
	    if (this.node.classList != null) {
	      return this.node.classList.contains(cssClass);
	    } else if (this.node.className != null) {
	      return this.classes().indexOf(cssClass) > -1;
	    }
	    return false;
	  };

	  Wrapper.prototype.isAncestor = function(ancestor, inclusive) {
	    var node;
	    if (inclusive == null) {
	      inclusive = false;
	    }
	    if (ancestor === this.node) {
	      return inclusive;
	    }
	    node = this.node;
	    while (node) {
	      if (node === ancestor) {
	        return true;
	      }
	      node = node.parentNode;
	    }
	    return false;
	  };

	  Wrapper.prototype.isElement = function() {
	    var ref;
	    return ((ref = this.node) != null ? ref.nodeType : void 0) === dom.ELEMENT_NODE;
	  };

	  Wrapper.prototype.isTextNode = function() {
	    var ref;
	    return ((ref = this.node) != null ? ref.nodeType : void 0) === dom.TEXT_NODE;
	  };

	  Wrapper.prototype.isolate = function(root) {
	    if (this.node.nextSibling != null) {
	      dom(this.node.nextSibling).splitBefore(root);
	    }
	    this.splitBefore(root);
	    return this;
	  };

	  Wrapper.prototype.length = function() {
	    var length;
	    if (this.node == null) {
	      return 0;
	    }
	    length = this.text().length;
	    if (this.isElement()) {
	      length += this.node.querySelectorAll(Object.keys(dom.EMBED_TAGS).join(',')).length;
	    }
	    return length;
	  };

	  Wrapper.prototype.merge = function(node) {
	    var $node;
	    $node = dom(node);
	    if (this.isElement()) {
	      $node.moveChildren(this.node);
	      this.normalize();
	    } else {
	      this.text(this.text() + $node.text());
	    }
	    $node.remove();
	    return this;
	  };

	  Wrapper.prototype.moveChildren = function(newParent) {
	    _.each(this.childNodes(), function(child) {
	      return newParent.appendChild(child);
	    });
	    return this;
	  };

	  Wrapper.prototype.nextLineNode = function(root) {
	    var nextNode;
	    nextNode = this.node.nextSibling;
	    if ((nextNode == null) && this.node.parentNode !== root) {
	      nextNode = this.node.parentNode.nextSibling;
	    }
	    if ((nextNode != null) && (dom.LIST_TAGS[nextNode.tagName] != null)) {
	      nextNode = nextNode.firstChild;
	    }
	    return nextNode;
	  };

	  Wrapper.prototype.normalize = function() {
	    var $node, curNode, followingNode, nextNode;
	    curNode = this.node.firstChild;
	    while (curNode != null) {
	      nextNode = curNode.nextSibling;
	      $node = dom(curNode);
	      if ((nextNode != null) && dom(nextNode).isTextNode()) {
	        if ($node.text().length === 0) {
	          $node.remove();
	        } else if ($node.isTextNode()) {
	          followingNode = nextNode.nextSibling;
	          $node.merge(nextNode);
	          nextNode = followingNode;
	        }
	      }
	      curNode = nextNode;
	    }
	    return this;
	  };

	  Wrapper.prototype.on = function(eventName, listener) {
	    this.node.addEventListener(eventName, (function(_this) {
	      return function(event) {
	        var arg, propagate;
	        arg = lastKeyEvent && (eventName === 'keydown' || eventName === 'keyup') ? lastKeyEvent : event;
	        propagate = listener.call(_this.node, arg);
	        if (!propagate) {
	          event.preventDefault();
	          event.stopPropagation();
	        }
	        return propagate;
	      };
	    })(this));
	    return this;
	  };

	  Wrapper.prototype.remove = function() {
	    var ref;
	    if ((ref = this.node.parentNode) != null) {
	      ref.removeChild(this.node);
	    }
	    this.node = null;
	    return null;
	  };

	  Wrapper.prototype.removeClass = function(cssClass) {
	    var classArray;
	    if (!this.hasClass(cssClass)) {
	      return;
	    }
	    if (this.node.classList != null) {
	      this.node.classList.remove(cssClass);
	    } else if (this.node.className != null) {
	      classArray = this.classes();
	      classArray.splice(classArray.indexOf(cssClass), 1);
	      this.node.className = classArray.join(' ');
	    }
	    if (!this.node.getAttribute('class')) {
	      this.node.removeAttribute('class');
	    }
	    return this;
	  };

	  Wrapper.prototype.replace = function(newNode) {
	    this.node.parentNode.replaceChild(newNode, this.node);
	    this.node = newNode;
	    return newNode;
	  };

	  Wrapper.prototype.splitBefore = function(root, force) {
	    var nextNode, parentClone, parentNode, refNode;
	    if (force == null) {
	      force = false;
	    }
	    if (this.node === root || this.node.parentNode === root) {
	      return this;
	    }
	    if ((this.node.previousSibling != null) || force) {
	      parentNode = this.node.parentNode;
	      parentClone = parentNode.cloneNode(false);
	      parentNode.parentNode.insertBefore(parentClone, parentNode.nextSibling);
	      refNode = this.node;
	      while (refNode != null) {
	        nextNode = refNode.nextSibling;
	        parentClone.appendChild(refNode);
	        refNode = nextNode;
	      }
	      return dom(parentClone).splitBefore(root);
	    } else {
	      return dom(this.node.parentNode).splitBefore(root);
	    }
	  };

	  Wrapper.prototype.split = function(offset, force) {
	    var after, child, childLeft, childRight, left, nextRight, nodeLength, ref, ref1, right;
	    if (force == null) {
	      force = false;
	    }
	    nodeLength = this.length();
	    offset = Math.max(0, offset);
	    offset = Math.min(offset, nodeLength);
	    if (!(force || offset !== 0)) {
	      return [this.node.previousSibling, this.node, false];
	    }
	    if (!(force || offset !== nodeLength)) {
	      return [this.node, this.node.nextSibling, false];
	    }
	    if (this.node.nodeType === dom.TEXT_NODE) {
	      after = this.node.splitText(offset);
	      return [this.node, after, true];
	    } else {
	      left = this.node;
	      right = this.node.cloneNode(false);
	      this.node.parentNode.insertBefore(right, left.nextSibling);
	      ref = this.child(offset), child = ref[0], offset = ref[1];
	      ref1 = dom(child).split(offset), childLeft = ref1[0], childRight = ref1[1];
	      while (childRight !== null) {
	        nextRight = childRight.nextSibling;
	        right.appendChild(childRight);
	        childRight = nextRight;
	      }
	      return [left, right, true];
	    }
	  };

	  Wrapper.prototype.styles = function(styles, overwrite) {
	    var obj, styleString;
	    if (overwrite == null) {
	      overwrite = false;
	    }
	    if (styles) {
	      if (!overwrite) {
	        styles = _.defaults(styles, this.styles());
	      }
	      styleString = _.map(styles, function(style, name) {
	        return name + ": " + style;
	      }).join('; ') + ';';
	      this.node.setAttribute('style', styleString);
	      return this;
	    } else {
	      styleString = this.node.getAttribute('style') || '';
	      obj = _.reduce(styleString.split(';'), function(styles, str) {
	        var name, ref, value;
	        ref = str.split(':'), name = ref[0], value = ref[1];
	        if (name && value) {
	          name = name.trim();
	          value = value.trim();
	          styles[name.toLowerCase()] = value;
	        }
	        return styles;
	      }, {});
	      return obj;
	    }
	  };

	  Wrapper.prototype.switchTag = function(newTag) {
	    var attributes, newNode;
	    newTag = newTag.toUpperCase();
	    if (this.node.tagName === newTag) {
	      return this;
	    }
	    newNode = document.createElement(newTag);
	    attributes = this.attributes();
	    if (dom.VOID_TAGS[newTag] == null) {
	      this.moveChildren(newNode);
	    }
	    this.replace(newNode);
	    return this.attributes(attributes).get();
	  };

	  Wrapper.prototype.text = function(text) {
	    if (text != null) {
	      switch (this.node.nodeType) {
	        case dom.ELEMENT_NODE:
	          this.node.textContent = text;
	          break;
	        case dom.TEXT_NODE:
	          this.node.data = text;
	      }
	      return this;
	    } else {
	      switch (this.node.nodeType) {
	        case dom.ELEMENT_NODE:
	          if (this.node.tagName === dom.DEFAULT_BREAK_TAG) {
	            return "";
	          }
	          if (dom.EMBED_TAGS[this.node.tagName] != null) {
	            return dom.EMBED_TEXT;
	          }
	          if (this.node.textContent != null) {
	            return this.node.textContent;
	          }
	          return "";
	        case dom.TEXT_NODE:
	          return this.node.data || "";
	        default:
	          return "";
	      }
	    }
	  };

	  Wrapper.prototype.textNodes = function() {
	    var textNode, textNodes, walker;
	    walker = document.createTreeWalker(this.node, NodeFilter.SHOW_TEXT, null, false);
	    textNodes = [];
	    while (textNode = walker.nextNode()) {
	      textNodes.push(textNode);
	    }
	    return textNodes;
	  };

	  Wrapper.prototype.toggleClass = function(className, state) {
	    if (state == null) {
	      state = !this.hasClass(className);
	    }
	    if (state) {
	      this.addClass(className);
	    } else {
	      this.removeClass(className);
	    }
	    return this;
	  };

	  Wrapper.prototype.trigger = function(eventName, options) {
	    var event, initFn, modifiers;
	    if (options == null) {
	      options = {};
	    }
	    if (['keypress', 'keydown', 'keyup'].indexOf(eventName) < 0) {
	      event = document.createEvent('Event');
	      event.initEvent(eventName, options.bubbles, options.cancelable);
	    } else {
	      event = document.createEvent('KeyboardEvent');
	      lastKeyEvent = _.clone(options);
	      if (_.isNumber(options.key)) {
	        lastKeyEvent.which = options.key;
	      } else if (_.isString(options.key)) {
	        lastKeyEvent.which = options.key.toUpperCase().charCodeAt(0);
	      } else {
	        lastKeyEvent.which = 0;
	      }
	      if (dom.isIE(10)) {
	        modifiers = [];
	        if (options.altKey) {
	          modifiers.push('Alt');
	        }
	        if (options.ctrlKey) {
	          modifiers.push('Control');
	        }
	        if (options.metaKey) {
	          modifiers.push('Meta');
	        }
	        if (options.shiftKey) {
	          modifiers.push('Shift');
	        }
	        event.initKeyboardEvent(eventName, options.bubbles, options.cancelable, window, 0, 0, modifiers.join(' '), null, null);
	      } else {
	        initFn = _.isFunction(event.initKeyboardEvent) ? 'initKeyboardEvent' : 'initKeyEvent';
	        event[initFn](eventName, options.bubbles, options.cancelable, window, options.ctrlKey, options.altKey, options.shiftKey, options.metaKey, 0, 0);
	      }
	    }
	    this.node.dispatchEvent(event);
	    lastKeyEvent = null;
	    return this;
	  };

	  Wrapper.prototype.unwrap = function() {
	    var next, ret;
	    ret = this.node.firstChild;
	    next = this.node.nextSibling;
	    _.each(this.childNodes(), (function(_this) {
	      return function(child) {
	        return _this.node.parentNode.insertBefore(child, next);
	      };
	    })(this));
	    this.remove();
	    return ret;
	  };

	  Wrapper.prototype.wrap = function(wrapper) {
	    var parent;
	    if (this.node.parentNode != null) {
	      this.node.parentNode.insertBefore(wrapper, this.node);
	    }
	    parent = wrapper;
	    while (parent.firstChild != null) {
	      parent = wrapper.firstChild;
	    }
	    parent.appendChild(this.node);
	    return this;
	  };

	  return Wrapper;

	})();

	SelectWrapper = (function(superClass) {
	  extend(SelectWrapper, superClass);

	  function SelectWrapper() {
	    return SelectWrapper.__super__.constructor.apply(this, arguments);
	  }

	  SelectWrapper.prototype["default"] = function() {
	    return this.node.querySelector('option[selected]');
	  };

	  SelectWrapper.prototype.option = function(option, trigger) {
	    var child, i, j, len, ref, value;
	    if (trigger == null) {
	      trigger = true;
	    }
	    value = _.isElement(option) ? option.value : option;
	    if (value) {
	      value = value.replace(/[^\w]+/g, '');
	      ref = this.node.children;
	      for (i = j = 0, len = ref.length; j < len; i = ++j) {
	        child = ref[i];
	        if (child.value.replace(/[^\w]+/g, '') === value) {
	          this.node.selectedIndex = i;
	          break;
	        }
	      }
	    } else {
	      this.node.selectedIndex = -1;
	    }
	    if (trigger) {
	      this.trigger('change');
	    }
	    return this;
	  };

	  SelectWrapper.prototype.reset = function(trigger) {
	    var option;
	    if (trigger == null) {
	      trigger = true;
	    }
	    option = this["default"]();
	    if (option != null) {
	      option.selected = true;
	    } else {
	      this.node.selectedIndex = 0;
	    }
	    if (trigger) {
	      this.trigger('change');
	    }
	    return this;
	  };

	  SelectWrapper.prototype.value = function() {
	    if (this.node.selectedIndex > -1) {
	      return this.node.options[this.node.selectedIndex].value;
	    } else {
	      return '';
	    }
	  };

	  return SelectWrapper;

	})(Wrapper);

	dom = function(node) {
	  if ((node != null ? node.tagName : void 0) === 'SELECT') {
	    return new SelectWrapper(node);
	  } else {
	    return new Wrapper(node);
	  }
	};

	dom = _.extend(dom, {
	  ELEMENT_NODE: 1,
	  NOBREAK_SPACE: "&nbsp;",
	  TEXT_NODE: 3,
	  ZERO_WIDTH_NOBREAK_SPACE: "\uFEFF",
	  DEFAULT_BLOCK_TAG: 'DIV',
	  DEFAULT_BREAK_TAG: 'BR',
	  DEFAULT_INLINE_TAG: 'SPAN',
	  EMBED_TEXT: '!',
	  FONT_SIZES: {
	    '10px': 1,
	    '13px': 2,
	    '16px': 3,
	    '18px': 4,
	    '24px': 5,
	    '32px': 6,
	    '48px': 7
	  },
	  KEYS: {
	    BACKSPACE: 8,
	    TAB: 9,
	    ENTER: 13,
	    ESCAPE: 27,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    DELETE: 46
	  },
	  BLOCK_TAGS: {
	    'ADDRESS': 'ADDRESS',
	    'ARTICLE': 'ARTICLE',
	    'ASIDE': 'ASIDE',
	    'AUDIO': 'AUDIO',
	    'BLOCKQUOTE': 'BLOCKQUOTE',
	    'CANVAS': 'CANVAS',
	    'DD': 'DD',
	    'DIV': 'DIV',
	    'DL': 'DL',
	    'FIGCAPTION': 'FIGCAPTION',
	    'FIGURE': 'FIGURE',
	    'FOOTER': 'FOOTER',
	    'FORM': 'FORM',
	    'H1': 'H1',
	    'H2': 'H2',
	    'H3': 'H3',
	    'H4': 'H4',
	    'H5': 'H5',
	    'H6': 'H6',
	    'HEADER': 'HEADER',
	    'HGROUP': 'HGROUP',
	    'LI': 'LI',
	    'OL': 'OL',
	    'OUTPUT': 'OUTPUT',
	    'P': 'P',
	    'PRE': 'PRE',
	    'SECTION': 'SECTION',
	    'TABLE': 'TABLE',
	    'TBODY': 'TBODY',
	    'TD': 'TD',
	    'TFOOT': 'TFOOT',
	    'TH': 'TH',
	    'THEAD': 'THEAD',
	    'TR': 'TR',
	    'UL': 'UL',
	    'VIDEO': 'VIDEO'
	  },
	  EMBED_TAGS: {
	    'IMG': 'IMG'
	  },
	  LINE_TAGS: {
	    'DIV': 'DIV',
	    'LI': 'LI'
	  },
	  LIST_TAGS: {
	    'OL': 'OL',
	    'UL': 'UL'
	  },
	  VOID_TAGS: {
	    'AREA': 'AREA',
	    'BASE': 'BASE',
	    'BR': 'BR',
	    'COL': 'COL',
	    'COMMAND': 'COMMAND',
	    'EMBED': 'EMBED',
	    'HR': 'HR',
	    'IMG': 'IMG',
	    'INPUT': 'INPUT',
	    'KEYGEN': 'KEYGEN',
	    'LINK': 'LINK',
	    'META': 'META',
	    'PARAM': 'PARAM',
	    'SOURCE': 'SOURCE',
	    'TRACK': 'TRACK',
	    'WBR': 'WBR'
	  },
	  convertFontSize: function(size) {
	    var i, s, sources, targets;
	    if (_.isString(size) && size.indexOf('px') > -1) {
	      sources = Object.keys(dom.FONT_SIZES);
	      targets = _.values(dom.FONT_SIZES);
	    } else {
	      targets = Object.keys(dom.FONT_SIZES);
	      sources = _.values(dom.FONT_SIZES);
	    }
	    for (i in sources) {
	      s = sources[i];
	      if (parseInt(size) <= parseInt(s)) {
	        return targets[i];
	      }
	    }
	    return _.last(targets);
	  },
	  isIE: function(maxVersion) {
	    var version;
	    version = document.documentMode;
	    return version && maxVersion >= version;
	  },
	  isIOS: function() {
	    return /iPhone|iPad/i.test(navigator.userAgent);
	  },
	  isMac: function() {
	    return /Mac/i.test(navigator.platform);
	  }
	});

	module.exports = dom;



	},{"lodash":1}],18:[function(_dereq_,module,exports){
	var LinkedList, Node;

	Node = (function() {
	  function Node(data) {
	    this.data = data;
	    this.prev = this.next = null;
	  }

	  return Node;

	})();

	LinkedList = (function() {
	  LinkedList.Node = Node;

	  function LinkedList() {
	    this.length = 0;
	    this.first = this.last = null;
	  }

	  LinkedList.prototype.append = function(node) {
	    if (this.first != null) {
	      node.next = null;
	      this.last.next = node;
	    } else {
	      this.first = node;
	    }
	    node.prev = this.last;
	    this.last = node;
	    return this.length += 1;
	  };

	  LinkedList.prototype.insertAfter = function(refNode, newNode) {
	    newNode.prev = refNode;
	    if (refNode != null) {
	      newNode.next = refNode.next;
	      if (refNode.next != null) {
	        refNode.next.prev = newNode;
	      }
	      refNode.next = newNode;
	      if (refNode === this.last) {
	        this.last = newNode;
	      }
	    } else {
	      newNode.next = this.first;
	      this.first.prev = newNode;
	      this.first = newNode;
	    }
	    return this.length += 1;
	  };

	  LinkedList.prototype.remove = function(node) {
	    if (this.length > 1) {
	      if (node.prev != null) {
	        node.prev.next = node.next;
	      }
	      if (node.next != null) {
	        node.next.prev = node.prev;
	      }
	      if (node === this.first) {
	        this.first = node.next;
	      }
	      if (node === this.last) {
	        this.last = node.prev;
	      }
	    } else {
	      this.first = this.last = null;
	    }
	    node.prev = node.next = null;
	    return this.length -= 1;
	  };

	  LinkedList.prototype.toArray = function() {
	    var arr, cur;
	    arr = [];
	    cur = this.first;
	    while (cur != null) {
	      arr.push(cur);
	      cur = cur.next;
	    }
	    return arr;
	  };

	  return LinkedList;

	})();

	module.exports = LinkedList;



	},{}],19:[function(_dereq_,module,exports){
	var Picker, _, dom;

	_ = _dereq_('lodash');

	dom = _dereq_('./dom');

	Picker = (function() {
	  Picker.TEMPLATE = '<span class="ql-picker-label"></span><span class="ql-picker-options"></span>';

	  function Picker(select) {
	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    dom(this.container).addClass('ql-picker');
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);
	    dom(document).on('click', (function(_this) {
	      return function() {
	        _this.close();
	        return true;
	      };
	    })(this));
	    dom(this.label).on('click', (function(_this) {
	      return function() {
	        _.defer(function() {
	          return dom(_this.container).toggleClass('ql-expanded');
	        });
	        return false;
	      };
	    })(this));
	    dom(this.select).on('change', (function(_this) {
	      return function() {
	        var item, option;
	        if (_this.select.selectedIndex > -1) {
	          item = _this.container.querySelectorAll('.ql-picker-item')[_this.select.selectedIndex];
	          option = _this.select.options[_this.select.selectedIndex];
	        }
	        _this.selectItem(item, false);
	        return dom(_this.label).toggleClass('ql-active', option !== dom(_this.select)["default"]());
	      };
	    })(this));
	  }

	  Picker.prototype.buildItem = function(picker, option, index) {
	    var item;
	    item = document.createElement('span');
	    item.setAttribute('data-value', option.getAttribute('value'));
	    dom(item).addClass('ql-picker-item').text(dom(option).text()).on('click', (function(_this) {
	      return function() {
	        _this.selectItem(item, true);
	        return _this.close();
	      };
	    })(this));
	    if (this.select.selectedIndex === index) {
	      this.selectItem(item, false);
	    }
	    return item;
	  };

	  Picker.prototype.buildPicker = function() {
	    var picker;
	    _.each(dom(this.select).attributes(), (function(_this) {
	      return function(value, name) {
	        return _this.container.setAttribute(name, value);
	      };
	    })(this));
	    this.container.innerHTML = Picker.TEMPLATE;
	    this.label = this.container.querySelector('.ql-picker-label');
	    picker = this.container.querySelector('.ql-picker-options');
	    return _.each(this.select.options, (function(_this) {
	      return function(option, i) {
	        var item;
	        item = _this.buildItem(picker, option, i);
	        return picker.appendChild(item);
	      };
	    })(this));
	  };

	  Picker.prototype.close = function() {
	    return dom(this.container).removeClass('ql-expanded');
	  };

	  Picker.prototype.selectItem = function(item, trigger) {
	    var selected, value;
	    selected = this.container.querySelector('.ql-selected');
	    if (selected != null) {
	      dom(selected).removeClass('ql-selected');
	    }
	    if (item != null) {
	      value = item.getAttribute('data-value');
	      dom(item).addClass('ql-selected');
	      dom(this.label).text(dom(item).text());
	      dom(this.select).option(value, trigger);
	      return this.label.setAttribute('data-value', value);
	    } else {
	      this.label.innerHTML = '&nbsp;';
	      return this.label.removeAttribute('data-value');
	    }
	  };

	  return Picker;

	})();

	module.exports = Picker;



	},{"./dom":17,"lodash":1}],20:[function(_dereq_,module,exports){
	var Range, _;

	_ = _dereq_('lodash');

	Range = (function() {
	  Range.compare = function(r1, r2) {
	    if (r1 === r2) {
	      return true;
	    }
	    if (!((r1 != null) && (r2 != null))) {
	      return false;
	    }
	    return r1.equals(r2);
	  };

	  function Range(start, end) {
	    this.start = start;
	    this.end = end;
	  }

	  Range.prototype.equals = function(range) {
	    if (range == null) {
	      return false;
	    }
	    return this.start === range.start && this.end === range.end;
	  };

	  Range.prototype.shift = function(index, length) {
	    var ref;
	    return ref = _.map([this.start, this.end], function(pos) {
	      if (index > pos) {
	        return pos;
	      }
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    }), this.start = ref[0], this.end = ref[1], ref;
	  };

	  Range.prototype.isCollapsed = function() {
	    return this.start === this.end;
	  };

	  return Range;

	})();

	module.exports = Range;



	},{"lodash":1}],21:[function(_dereq_,module,exports){
	var Authorship, Delta, Quill, _, dom;

	Quill = _dereq_('../quill');

	_ = Quill.require('lodash');

	dom = Quill.require('dom');

	Delta = Quill.require('delta');

	Authorship = (function() {
	  Authorship.DEFAULTS = {
	    authorId: null,
	    color: 'transparent',
	    enabled: false
	  };

	  function Authorship(quill, options) {
	    this.quill = quill;
	    this.options = options;
	    if (this.options.button != null) {
	      this.attachButton(this.options.button);
	    }
	    if (this.options.enabled) {
	      this.enable();
	    }
	    this.quill.addFormat('author', {
	      "class": 'author-'
	    });
	    if (this.options.authorId == null) {
	      return;
	    }
	    this.quill.on(this.quill.constructor.events.PRE_EVENT, (function(_this) {
	      return function(eventName, delta, origin) {
	        var authorDelta, authorFormat;
	        if (eventName === _this.quill.constructor.events.TEXT_CHANGE && origin === 'user') {
	          authorDelta = new Delta();
	          authorFormat = {
	            author: _this.options.authorId
	          };
	          _.each(delta.ops, function(op) {
	            if (op["delete"] != null) {
	              return;
	            }
	            if ((op.insert != null) || ((op.retain != null) && (op.attributes != null))) {
	              op.attributes || (op.attributes = {});
	              op.attributes.author = _this.options.authorId;
	              return authorDelta.retain(op.retain || op.insert.length || 1, authorFormat);
	            } else {
	              return authorDelta.retain(op.retain);
	            }
	          });
	          return _this.quill.updateContents(authorDelta, Quill.sources.SILENT);
	        }
	      };
	    })(this));
	    this.addAuthor(this.options.authorId, this.options.color);
	  }

	  Authorship.prototype.addAuthor = function(id, color) {
	    var styles;
	    styles = {};
	    styles[".authorship .author-" + id] = {
	      "background-color": "" + color
	    };
	    return this.quill.theme.addStyles(styles);
	  };

	  Authorship.prototype.attachButton = function(button) {
	    var $button;
	    $button = dom(button);
	    return $button.on('click', (function(_this) {
	      return function() {
	        $button.toggleClass('ql-on');
	        return _this.enable($dom.hasClass('ql-on'));
	      };
	    })(this));
	  };

	  Authorship.prototype.enable = function(enabled) {
	    if (enabled == null) {
	      enabled = true;
	    }
	    return dom(this.quill.root).toggleClass('authorship', enabled);
	  };

	  Authorship.prototype.disable = function() {
	    return this.enable(false);
	  };

	  return Authorship;

	})();

	Quill.registerModule('authorship', Authorship);

	module.exports = Authorship;



	},{"../quill":30}],22:[function(_dereq_,module,exports){
	var Delta, ImageTooltip, Quill, Range, Tooltip, _, dom,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;

	Quill = _dereq_('../quill');

	Tooltip = _dereq_('./tooltip');

	_ = Quill.require('lodash');

	dom = Quill.require('dom');

	Delta = Quill.require('delta');

	Range = Quill.require('range');

	ImageTooltip = (function(superClass) {
	  extend(ImageTooltip, superClass);

	  ImageTooltip.DEFAULTS = {
	    template: '<input class="input" type="textbox"> <div class="preview"> <span>Preview</span> </div> <a href="javascript:;" class="cancel">Cancel</a> <a href="javascript:;" class="insert">Insert</a>'
	  };

	  function ImageTooltip(quill, options) {
	    this.quill = quill;
	    this.options = options;
	    this.options = _.defaults(this.options, Tooltip.DEFAULTS);
	    ImageTooltip.__super__.constructor.call(this, this.quill, this.options);
	    this.preview = this.container.querySelector('.preview');
	    this.textbox = this.container.querySelector('.input');
	    dom(this.container).addClass('ql-image-tooltip');
	    this.initListeners();
	  }

	  ImageTooltip.prototype.initListeners = function() {
	    dom(this.quill.root).on('focus', _.bind(this.hide, this));
	    dom(this.container.querySelector('.insert')).on('click', _.bind(this.insertImage, this));
	    dom(this.container.querySelector('.cancel')).on('click', _.bind(this.hide, this));
	    dom(this.textbox).on('input', _.bind(this._preview, this));
	    this.initTextbox(this.textbox, this.insertImage, this.hide);
	    return this.quill.onModuleLoad('toolbar', (function(_this) {
	      return function(toolbar) {
	        _this.toolbar = toolbar;
	        return toolbar.initFormat('image', _.bind(_this._onToolbar, _this));
	      };
	    })(this));
	  };

	  ImageTooltip.prototype.insertImage = function() {
	    var index, url;
	    url = this._normalizeURL(this.textbox.value);
	    if (this.range == null) {
	      this.range = new Range(0, 0);
	    }
	    if (this.range) {
	      this.preview.innerHTML = '<span>Preview</span>';
	      this.textbox.value = '';
	      index = this.range.end;
	      this.quill.insertEmbed(index, 'image', url, 'user');
	      this.quill.setSelection(index + 1, index + 1);
	    }
	    return this.hide();
	  };

	  ImageTooltip.prototype._onToolbar = function(range, value) {
	    if (value) {
	      if (!this.textbox.value) {
	        this.textbox.value = 'http://';
	      }
	      this.show();
	      this.textbox.focus();
	      return _.defer((function(_this) {
	        return function() {
	          return _this.textbox.setSelectionRange(_this.textbox.value.length, _this.textbox.value.length);
	        };
	      })(this));
	    } else {
	      this.quill.deleteText(range, 'user');
	      return this.toolbar.setActive('image', false);
	    }
	  };

	  ImageTooltip.prototype._preview = function() {
	    var img;
	    if (!this._matchImageURL(this.textbox.value)) {
	      return;
	    }
	    if (this.preview.firstChild.tagName === 'IMG') {
	      return this.preview.firstChild.setAttribute('src', this.textbox.value);
	    } else {
	      img = document.createElement('img');
	      img.setAttribute('src', this.textbox.value);
	      return this.preview.replaceChild(img, this.preview.firstChild);
	    }
	  };

	  ImageTooltip.prototype._matchImageURL = function(url) {
	    return /^https?:\/\/.+\.(jpe?g|gif|png)$/.test(url);
	  };

	  ImageTooltip.prototype._normalizeURL = function(url) {
	    if (!/^https?:\/\//.test(url)) {
	      url = 'http://' + url;
	    }
	    return url;
	  };

	  return ImageTooltip;

	})(Tooltip);

	Quill.registerModule('image-tooltip', ImageTooltip);

	module.exports = ImageTooltip;



	},{"../quill":30,"./tooltip":28}],23:[function(_dereq_,module,exports){
	var Delta, Keyboard, Quill, _, dom;

	Quill = _dereq_('../quill');

	_ = Quill.require('lodash');

	dom = Quill.require('dom');

	Delta = Quill.require('delta');

	Keyboard = (function() {
	  Keyboard.hotkeys = {
	    BOLD: {
	      key: 'B',
	      metaKey: true
	    },
	    INDENT: {
	      key: dom.KEYS.TAB
	    },
	    ITALIC: {
	      key: 'I',
	      metaKey: true
	    },
	    OUTDENT: {
	      key: dom.KEYS.TAB,
	      shiftKey: true
	    },
	    UNDERLINE: {
	      key: 'U',
	      metaKey: true
	    }
	  };

	  function Keyboard(quill, options) {
	    this.quill = quill;
	    this.hotkeys = {};
	    this._initListeners();
	    this._initHotkeys();
	    this.quill.onModuleLoad('toolbar', (function(_this) {
	      return function(toolbar) {
	        return _this.toolbar = toolbar;
	      };
	    })(this));
	  }

	  Keyboard.prototype.addHotkey = function(hotkeys, callback) {
	    if (!Array.isArray(hotkeys)) {
	      hotkeys = [hotkeys];
	    }
	    return _.each(hotkeys, (function(_this) {
	      return function(hotkey) {
	        var base, which;
	        hotkey = _.isObject(hotkey) ? _.clone(hotkey) : {
	          key: hotkey
	        };
	        hotkey.callback = callback;
	        which = _.isNumber(hotkey.key) ? hotkey.key : hotkey.key.toUpperCase().charCodeAt(0);
	        if ((base = _this.hotkeys)[which] == null) {
	          base[which] = [];
	        }
	        return _this.hotkeys[which].push(hotkey);
	      };
	    })(this));
	  };

	  Keyboard.prototype.toggleFormat = function(range, format) {
	    var delta, value;
	    if (range.isCollapsed()) {
	      delta = this.quill.getContents(Math.max(0, range.start - 1), range.end);
	    } else {
	      delta = this.quill.getContents(range);
	    }
	    value = delta.ops.length === 0 || !_.all(delta.ops, function(op) {
	      var ref;
	      return (ref = op.attributes) != null ? ref[format] : void 0;
	    });
	    if (range.isCollapsed()) {
	      this.quill.prepareFormat(format, value, Quill.sources.USER);
	    } else {
	      this.quill.formatText(range, format, value, Quill.sources.USER);
	    }
	    if (this.toolbar != null) {
	      return this.toolbar.setActive(format, value);
	    }
	  };

	  Keyboard.prototype._initEnter = function() {
	    var keys;
	    keys = [
	      {
	        key: dom.KEYS.ENTER
	      }, {
	        key: dom.KEYS.ENTER,
	        shiftKey: true
	      }
	    ];
	    return this.addHotkey(keys, (function(_this) {
	      return function(range, hotkey) {
	        var delta, leaf, line, offset, ref, ref1;
	        if (range == null) {
	          return true;
	        }
	        ref = _this.quill.editor.doc.findLineAt(range.start), line = ref[0], offset = ref[1];
	        ref1 = line.findLeafAt(offset), leaf = ref1[0], offset = ref1[1];
	        delta = new Delta().retain(range.start).insert('\n', line.formats)["delete"](range.end - range.start);
	        _this.quill.updateContents(delta, Quill.sources.USER);
	        _.each(leaf.formats, function(value, format) {
	          _this.quill.prepareFormat(format, value);
	          return _this.toolbar.setActive(format, value);
	        });
	        return false;
	      };
	    })(this));
	  };

	  Keyboard.prototype._initDeletes = function() {
	    return this.addHotkey([dom.KEYS.DELETE, dom.KEYS.BACKSPACE], (function(_this) {
	      return function(range, hotkey) {
	        var format, line, offset, ref;
	        if ((range != null) && _this.quill.getLength() > 0) {
	          if (range.start !== range.end) {
	            _this.quill.deleteText(range.start, range.end, Quill.sources.USER);
	          } else {
	            if (hotkey.key === dom.KEYS.BACKSPACE) {
	              ref = _this.quill.editor.doc.findLineAt(range.start), line = ref[0], offset = ref[1];
	              if (offset === 0 && (line.formats.bullet || line.formats.list)) {
	                format = line.formats.bullet ? 'bullet' : 'list';
	                _this.quill.formatLine(range.start, range.start, format, false);
	              } else if (range.start > 0) {
	                _this.quill.deleteText(range.start - 1, range.start, Quill.sources.USER);
	              }
	            } else if (range.start < _this.quill.getLength() - 1) {
	              _this.quill.deleteText(range.start, range.start + 1, Quill.sources.USER);
	            }
	          }
	        }
	        return false;
	      };
	    })(this));
	  };

	  Keyboard.prototype._initHotkeys = function() {
	    this.addHotkey(Keyboard.hotkeys.INDENT, (function(_this) {
	      return function(range) {
	        _this._onTab(range, false);
	        return false;
	      };
	    })(this));
	    this.addHotkey(Keyboard.hotkeys.OUTDENT, (function(_this) {
	      return function(range) {
	        return false;
	      };
	    })(this));
	    _.each(['bold', 'italic', 'underline'], (function(_this) {
	      return function(format) {
	        return _this.addHotkey(Keyboard.hotkeys[format.toUpperCase()], function(range) {
	          _this.toggleFormat(range, format);
	          return false;
	        });
	      };
	    })(this));
	    this._initDeletes();
	    return this._initEnter();
	  };

	  Keyboard.prototype._initListeners = function() {
	    return dom(this.quill.root).on('keydown', (function(_this) {
	      return function(event) {
	        var prevent;
	        prevent = false;
	        _.each(_this.hotkeys[event.which], function(hotkey) {
	          var metaKey;
	          metaKey = dom.isMac() ? event.metaKey : event.metaKey || event.ctrlKey;
	          if (!!hotkey.metaKey !== !!metaKey) {
	            return;
	          }
	          if (!!hotkey.shiftKey !== !!event.shiftKey) {
	            return;
	          }
	          if (!!hotkey.altKey !== !!event.altKey) {
	            return;
	          }
	          prevent = hotkey.callback(_this.quill.getSelection(), hotkey, event) === false || prevent;
	          return true;
	        });
	        return !prevent;
	      };
	    })(this));
	  };

	  Keyboard.prototype._onTab = function(range, shift) {
	    var delta;
	    if (shift == null) {
	      shift = false;
	    }
	    delta = new Delta().retain(range.start).insert("\t")["delete"](range.end - range.start).retain(this.quill.getLength() - range.end);
	    this.quill.updateContents(delta, Quill.sources.USER);
	    return this.quill.setSelection(range.start + 1, range.start + 1);
	  };

	  return Keyboard;

	})();

	Quill.registerModule('keyboard', Keyboard);

	module.exports = Keyboard;



	},{"../quill":30}],24:[function(_dereq_,module,exports){
	var LinkTooltip, Quill, Tooltip, _, dom,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;

	Quill = _dereq_('../quill');

	Tooltip = _dereq_('./tooltip');

	_ = Quill.require('lodash');

	dom = Quill.require('dom');

	LinkTooltip = (function(superClass) {
	  extend(LinkTooltip, superClass);

	  LinkTooltip.DEFAULTS = {
	    maxLength: 50,
	    template: '<span class="title">Visit URL:&nbsp;</span> <a href="#" class="url" target="_blank" href="about:blank"></a> <input class="input" type="text"> <span>&nbsp;&#45;&nbsp;</span> <a href="javascript:;" class="change">Change</a> <a href="javascript:;" class="remove">Remove</a> <a href="javascript:;" class="done">Done</a>'
	  };

	  LinkTooltip.hotkeys = {
	    LINK: {
	      key: 'K',
	      metaKey: true
	    }
	  };

	  function LinkTooltip(quill, options) {
	    this.quill = quill;
	    this.options = options;
	    this.options = _.defaults(this.options, Tooltip.DEFAULTS);
	    LinkTooltip.__super__.constructor.call(this, this.quill, this.options);
	    dom(this.container).addClass('ql-link-tooltip');
	    this.textbox = this.container.querySelector('.input');
	    this.link = this.container.querySelector('.url');
	    this.initListeners();
	  }

	  LinkTooltip.prototype.initListeners = function() {
	    this.quill.on(this.quill.constructor.events.SELECTION_CHANGE, (function(_this) {
	      return function(range) {
	        var anchor;
	        if (!((range != null) && range.isCollapsed())) {
	          return;
	        }
	        anchor = _this._findAnchor(range);
	        if (anchor) {
	          _this.setMode(anchor.href, false);
	          return _this.show(anchor);
	        } else if (_this.container.style.left !== Tooltip.HIDE_MARGIN) {
	          _this.range = null;
	          return _this.hide();
	        }
	      };
	    })(this));
	    dom(this.container.querySelector('.done')).on('click', _.bind(this.saveLink, this));
	    dom(this.container.querySelector('.remove')).on('click', (function(_this) {
	      return function() {
	        return _this.removeLink(_this.range);
	      };
	    })(this));
	    dom(this.container.querySelector('.change')).on('click', (function(_this) {
	      return function() {
	        return _this.setMode(_this.link.href, true);
	      };
	    })(this));
	    this.initTextbox(this.textbox, this.saveLink, this.hide);
	    this.quill.onModuleLoad('toolbar', (function(_this) {
	      return function(toolbar) {
	        _this.toolbar = toolbar;
	        return toolbar.initFormat('link', _.bind(_this._onToolbar, _this));
	      };
	    })(this));
	    return this.quill.onModuleLoad('keyboard', (function(_this) {
	      return function(keyboard) {
	        return keyboard.addHotkey(LinkTooltip.hotkeys.LINK, _.bind(_this._onKeyboard, _this));
	      };
	    })(this));
	  };

	  LinkTooltip.prototype.saveLink = function() {
	    var anchor, end, url;
	    url = this._normalizeURL(this.textbox.value);
	    if (this.range != null) {
	      end = this.range.end;
	      if (this.range.isCollapsed()) {
	        anchor = this._findAnchor(this.range);
	        if (anchor != null) {
	          anchor.href = url;
	        }
	      } else {
	        this.quill.formatText(this.range, 'link', url, 'user');
	      }
	      this.quill.setSelection(end, end);
	    }
	    return this.setMode(url, false);
	  };

	  LinkTooltip.prototype.removeLink = function(range) {
	    if (range.isCollapsed()) {
	      range = this._expandRange(range);
	    }
	    this.hide();
	    this.quill.formatText(range, 'link', false, 'user');
	    if (this.toolbar != null) {
	      return this.toolbar.setActive('link', false);
	    }
	  };

	  LinkTooltip.prototype.setMode = function(url, edit) {
	    var text;
	    if (edit == null) {
	      edit = false;
	    }
	    if (edit) {
	      this.textbox.value = url;
	      _.defer((function(_this) {
	        return function() {
	          _this.textbox.focus();
	          return _this.textbox.setSelectionRange(0, url.length);
	        };
	      })(this));
	    } else {
	      this.link.href = url;
	      url = this.link.href;
	      text = url.length > this.options.maxLength ? url.slice(0, this.options.maxLength) + '...' : url;
	      dom(this.link).text(text);
	    }
	    return dom(this.container).toggleClass('editing', edit);
	  };

	  LinkTooltip.prototype._findAnchor = function(range) {
	    var leaf, node, offset, ref;
	    ref = this.quill.editor.doc.findLeafAt(range.start, true), leaf = ref[0], offset = ref[1];
	    if (leaf != null) {
	      node = leaf.node;
	    }
	    while ((node != null) && node !== this.quill.root) {
	      if (node.tagName === 'A') {
	        return node;
	      }
	      node = node.parentNode;
	    }
	    return null;
	  };

	  LinkTooltip.prototype._expandRange = function(range) {
	    var end, leaf, offset, ref, start;
	    ref = this.quill.editor.doc.findLeafAt(range.start, true), leaf = ref[0], offset = ref[1];
	    start = range.start - offset;
	    end = start + leaf.length;
	    return {
	      start: start,
	      end: end
	    };
	  };

	  LinkTooltip.prototype._onToolbar = function(range, value) {
	    return this._toggle(range, value);
	  };

	  LinkTooltip.prototype._onKeyboard = function() {
	    var range;
	    range = this.quill.getSelection();
	    return this._toggle(range, !this._findAnchor(range));
	  };

	  LinkTooltip.prototype._toggle = function(range, value) {
	    var nativeRange;
	    if (!range) {
	      return;
	    }
	    if (!value) {
	      return this.removeLink(range);
	    } else if (!range.isCollapsed()) {
	      this.setMode(this._suggestURL(range), true);
	      nativeRange = this.quill.editor.selection._getNativeRange();
	      return this.show(nativeRange);
	    }
	  };

	  LinkTooltip.prototype._normalizeURL = function(url) {
	    if (!/^(https?:\/\/|mailto:)/.test(url)) {
	      url = 'http://' + url;
	    }
	    return url;
	  };

	  LinkTooltip.prototype._suggestURL = function(range) {
	    var text;
	    text = this.quill.getText(range);
	    return this._normalizeURL(text);
	  };

	  return LinkTooltip;

	})(Tooltip);

	Quill.registerModule('link-tooltip', LinkTooltip);

	module.exports = LinkTooltip;



	},{"../quill":30,"./tooltip":28}],25:[function(_dereq_,module,exports){
	var EventEmitter2, MultiCursor, Quill, _, dom,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;

	Quill = _dereq_('../quill');

	EventEmitter2 = _dereq_('eventemitter2').EventEmitter2;

	_ = Quill.require('lodash');

	dom = Quill.require('dom');

	MultiCursor = (function(superClass) {
	  extend(MultiCursor, superClass);

	  MultiCursor.DEFAULTS = {
	    template: '<span class="cursor-flag"> <span class="cursor-name"></span> </span> <span class="cursor-caret"></span>',
	    timeout: 2500
	  };

	  MultiCursor.events = {
	    CURSOR_ADDED: 'cursor-addded',
	    CURSOR_MOVED: 'cursor-moved',
	    CURSOR_REMOVED: 'cursor-removed'
	  };

	  function MultiCursor(quill, options) {
	    this.quill = quill;
	    this.options = options;
	    this.cursors = {};
	    this.container = this.quill.addContainer('ql-multi-cursor', true);
	    this.quill.on(this.quill.constructor.events.TEXT_CHANGE, _.bind(this._applyDelta, this));
	  }

	  MultiCursor.prototype.clearCursors = function() {
	    _.each(Object.keys(this.cursors), _.bind(this.removeCursor, this));
	    return this.cursors = {};
	  };

	  MultiCursor.prototype.moveCursor = function(userId, index) {
	    var cursor;
	    cursor = this.cursors[userId];
	    cursor.index = index;
	    dom(cursor.elem).removeClass('hidden');
	    clearTimeout(cursor.timer);
	    cursor.timer = setTimeout((function(_this) {
	      return function() {
	        dom(cursor.elem).addClass('hidden');
	        return cursor.timer = null;
	      };
	    })(this), this.options.timeout);
	    this._updateCursor(cursor);
	    return cursor;
	  };

	  MultiCursor.prototype.removeCursor = function(userId) {
	    var cursor;
	    cursor = this.cursors[userId];
	    this.emit(MultiCursor.events.CURSOR_REMOVED, cursor);
	    if (cursor != null) {
	      cursor.elem.parentNode.removeChild(cursor.elem);
	    }
	    return delete this.cursors[userId];
	  };

	  MultiCursor.prototype.setCursor = function(userId, index, name, color) {
	    var cursor;
	    if (this.cursors[userId] == null) {
	      this.cursors[userId] = cursor = {
	        userId: userId,
	        index: index,
	        color: color,
	        elem: this._buildCursor(name, color)
	      };
	      this.emit(MultiCursor.events.CURSOR_ADDED, cursor);
	    }
	    _.defer((function(_this) {
	      return function() {
	        return _this.moveCursor(userId, index);
	      };
	    })(this));
	    return this.cursors[userId];
	  };

	  MultiCursor.prototype.shiftCursors = function(index, length, authorId) {
	    if (authorId == null) {
	      authorId = null;
	    }
	    return _.each(this.cursors, (function(_this) {
	      return function(cursor, id) {
	        if (!(cursor && (cursor.index > index || cursor.userId === authorId))) {
	          return;
	        }
	        return cursor.index += Math.max(length, index - cursor.index);
	      };
	    })(this));
	  };

	  MultiCursor.prototype.update = function() {
	    return _.each(this.cursors, (function(_this) {
	      return function(cursor, id) {
	        if (cursor == null) {
	          return;
	        }
	        _this._updateCursor(cursor);
	        return true;
	      };
	    })(this));
	  };

	  MultiCursor.prototype._applyDelta = function(delta) {
	    var index;
	    index = 0;
	    _.each(delta.ops, (function(_this) {
	      return function(op) {
	        var length, ref;
	        length = 0;
	        if (op.insert != null) {
	          length = op.insert.length || 1;
	          _this.shiftCursors(index, length, (ref = op.attributes) != null ? ref['author'] : void 0);
	        } else if (op["delete"] != null) {
	          _this.shiftCursors(index, -1 * op["delete"], null);
	        } else if (op.retain != null) {
	          _this.shiftCursors(index, 0, null);
	          length = op.retain;
	        }
	        return index += length;
	      };
	    })(this));
	    return this.update();
	  };

	  MultiCursor.prototype._buildCursor = function(name, color) {
	    var cursor, cursorCaret, cursorFlag, cursorName;
	    cursor = document.createElement('span');
	    dom(cursor).addClass('cursor');
	    cursor.innerHTML = this.options.template;
	    cursorFlag = cursor.querySelector('.cursor-flag');
	    cursorName = cursor.querySelector('.cursor-name');
	    dom(cursorName).text(name);
	    cursorCaret = cursor.querySelector('.cursor-caret');
	    cursorCaret.style.backgroundColor = cursorName.style.backgroundColor = color;
	    this.container.appendChild(cursor);
	    return cursor;
	  };

	  MultiCursor.prototype._updateCursor = function(cursor) {
	    var bounds, flag;
	    bounds = this.quill.getBounds(cursor.index);
	    cursor.elem.style.top = (bounds.top - this.quill.container.scrollTop) + 'px';
	    cursor.elem.style.left = bounds.left + 'px';
	    cursor.elem.style.height = bounds.height + 'px';
	    flag = cursor.elem.querySelector('.cursor-flag');
	    dom(cursor.elem).toggleClass('top', parseInt(cursor.elem.style.top) <= flag.offsetHeight).toggleClass('left', parseInt(cursor.elem.style.left) <= flag.offsetWidth).toggleClass('right', this.quill.root.offsetWidth - parseInt(cursor.elem.style.left) <= flag.offsetWidth);
	    return this.emit(MultiCursor.events.CURSOR_MOVED, cursor);
	  };

	  return MultiCursor;

	})(EventEmitter2);

	Quill.registerModule('multi-cursor', MultiCursor);

	module.exports = MultiCursor;



	},{"../quill":30,"eventemitter2":2}],26:[function(_dereq_,module,exports){
	var Delta, Document, PasteManager, Quill, _, dom;

	Quill = _dereq_('../quill');

	Document = _dereq_('../core/document');

	_ = Quill.require('lodash');

	dom = Quill.require('dom');

	Delta = Quill.require('delta');

	PasteManager = (function() {
	  function PasteManager(quill, options) {
	    this.quill = quill;
	    this.options = options;
	    this.container = this.quill.addContainer('ql-paste-manager');
	    this.container.setAttribute('contenteditable', true);
	    dom(this.quill.root).on('paste', _.bind(this._paste, this));
	  }

	  PasteManager.prototype._paste = function() {
	    var oldDocLength, range;
	    oldDocLength = this.quill.getLength();
	    range = this.quill.getSelection();
	    if (range == null) {
	      return;
	    }
	    this.container.focus();
	    return _.defer((function(_this) {
	      return function() {
	        var delta, doc, lengthAdded, line, lineBottom, offset, ref, windowBottom;
	        doc = new Document(_this.container, _this.quill.options);
	        delta = doc.toDelta();
	        lengthAdded = delta.length() - 1;
	        delta.compose(new Delta().retain(lengthAdded)["delete"](1));
	        if (range.start > 0) {
	          delta.ops.unshift({
	            retain: range.start
	          });
	        }
	        delta["delete"](range.end - range.start);
	        _this.quill.updateContents(delta, 'user');
	        _this.quill.setSelection(range.start + lengthAdded, range.start + lengthAdded);
	        ref = _this.quill.editor.doc.findLineAt(range.start + lengthAdded), line = ref[0], offset = ref[1];
	        lineBottom = line.node.getBoundingClientRect().bottom;
	        windowBottom = document.documentElement.clientHeight;
	        if (lineBottom > windowBottom) {
	          line.node.scrollIntoView(false);
	        }
	        return _this.container.innerHTML = "";
	      };
	    })(this));
	  };

	  return PasteManager;

	})();

	Quill.registerModule('paste-manager', PasteManager);

	module.exports = PasteManager;



	},{"../core/document":8,"../quill":30}],27:[function(_dereq_,module,exports){
	var Quill, Toolbar, _, dom;

	Quill = _dereq_('../quill');

	_ = Quill.require('lodash');

	dom = Quill.require('dom');

	Toolbar = (function() {
	  Toolbar.DEFAULTS = {
	    container: null
	  };

	  Toolbar.formats = {
	    LINE: {
	      'align': 'align',
	      'bullet': 'bullet',
	      'list': 'list'
	    },
	    SELECT: {
	      'align': 'align',
	      'background': 'background',
	      'color': 'color',
	      'font': 'font',
	      'size': 'size'
	    },
	    TOGGLE: {
	      'bold': 'bold',
	      'bullet': 'bullet',
	      'image': 'image',
	      'italic': 'italic',
	      'link': 'link',
	      'list': 'list',
	      'strike': 'strike',
	      'underline': 'underline'
	    },
	    TOOLTIP: {
	      'image': 'image',
	      'link': 'link'
	    }
	  };

	  function Toolbar(quill, options) {
	    this.quill = quill;
	    this.options = options;
	    if (_.isString(this.options) || _.isElement(this.options)) {
	      this.options = {
	        container: this.options
	      };
	    }
	    if (this.options.container == null) {
	      throw new Error('container required for toolbar', this.options);
	    }
	    this.container = _.isString(this.options.container) ? document.querySelector(this.options.container) : this.options.container;
	    this.inputs = {};
	    this.preventUpdate = false;
	    this.triggering = false;
	    _.each(this.quill.options.formats, (function(_this) {
	      return function(name) {
	        if (Toolbar.formats.TOOLTIP[name] != null) {
	          return;
	        }
	        return _this.initFormat(name, _.bind(_this._applyFormat, _this, name));
	      };
	    })(this));
	    this.quill.on(Quill.events.FORMAT_INIT, (function(_this) {
	      return function(name) {
	        if (Toolbar.formats.TOOLTIP[name] != null) {
	          return;
	        }
	        return _this.initFormat(name, _.bind(_this._applyFormat, _this, name));
	      };
	    })(this));
	    this.quill.on(Quill.events.SELECTION_CHANGE, (function(_this) {
	      return function(range) {
	        if (range != null) {
	          return _this.updateActive(range);
	        }
	      };
	    })(this));
	    this.quill.on(Quill.events.TEXT_CHANGE, (function(_this) {
	      return function() {
	        return _this.updateActive();
	      };
	    })(this));
	    this.quill.onModuleLoad('keyboard', (function(_this) {
	      return function(keyboard) {
	        return keyboard.addHotkey([dom.KEYS.BACKSPACE, dom.KEYS.DELETE], function() {
	          return _.defer(_.bind(_this.updateActive, _this));
	        });
	      };
	    })(this));
	    dom(this.container).addClass('ql-toolbar');
	    if (dom.isIOS()) {
	      dom(this.container).addClass('ios');
	    }
	    if (dom.isIE(11)) {
	      dom(this.container).on('mousedown', (function(_this) {
	        return function() {
	          return false;
	        };
	      })(this));
	    }
	  }

	  Toolbar.prototype.initFormat = function(format, callback) {
	    var eventName, input, selector;
	    selector = ".ql-" + format;
	    if (Toolbar.formats.SELECT[format] != null) {
	      selector = "select" + selector;
	      eventName = 'change';
	    } else {
	      eventName = 'click';
	    }
	    input = this.container.querySelector(selector);
	    if (input == null) {
	      return;
	    }
	    this.inputs[format] = input;
	    return dom(input).on(eventName, (function(_this) {
	      return function() {
	        var range, value;
	        value = eventName === 'change' ? dom(input).value() : !dom(input).hasClass('ql-active');
	        _this.preventUpdate = true;
	        _this.quill.focus();
	        range = _this.quill.getSelection();
	        if (range != null) {
	          callback(range, value);
	        }
	        _this.preventUpdate = false;

	        return true;
	      };
	    })(this));
	  };

	  Toolbar.prototype.setActive = function(format, value) {
	    var $input, input, ref, selectValue;
	    if (format === 'image') {
	      value = false;
	    }
	    input = this.inputs[format];
	    if (input == null) {
	      return;
	    }
	    $input = dom(input);
	    if (input.tagName === 'SELECT') {
	      this.triggering = true;
	      selectValue = $input.value(input);
	      if (value == null) {
	        value = (ref = $input["default"]()) != null ? ref.value : void 0;
	      }
	      if (Array.isArray(value)) {
	        value = '';
	      }
	      if (value !== selectValue) {
	        if (value != null) {
	          $input.option(value);
	        } else {
	          $input.reset();
	        }
	      }
	      return this.triggering = false;
	    } else {
	      return $input.toggleClass('ql-active', value || false);
	    }
	  };

	  Toolbar.prototype.updateActive = function(range, formats) {
	    var activeFormats;
	    if (formats == null) {
	      formats = null;
	    }
	    range || (range = this.quill.getSelection());
	    if (!((range != null) && !this.preventUpdate)) {
	      return;
	    }
	    activeFormats = this._getActive(range);
	    return _.each(this.inputs, (function(_this) {
	      return function(input, format) {
	        if (!Array.isArray(formats) || formats.indexOf(format) > -1) {
	          _this.setActive(format, activeFormats[format]);
	        }
	        return true;
	      };
	    })(this));
	  };

	  Toolbar.prototype._applyFormat = function(format, range, value) {
	    if (this.triggering) {
	      return;
	    }
	    if (range.isCollapsed()) {
	      this.quill.prepareFormat(format, value, 'user');
	    } else if (Toolbar.formats.LINE[format] != null) {
	      this.quill.formatLine(range, format, value, 'user');
	    } else {
	      this.quill.formatText(range, format, value, 'user');
	    }
	    return _.defer((function(_this) {
	      return function() {
	        _this.updateActive(range, ['bullet', 'list']);
	        return _this.setActive(format, value);
	      };
	    })(this));
	  };

	  Toolbar.prototype._getActive = function(range) {
	    var leafFormats, lineFormats;
	    leafFormats = this._getLeafActive(range);
	    lineFormats = this._getLineActive(range);
	    return _.defaults({}, leafFormats, lineFormats);
	  };

	  Toolbar.prototype._getLeafActive = function(range) {
	    var contents, formatsArr, line, offset, ref;
	    if (range.isCollapsed()) {
	      ref = this.quill.editor.doc.findLineAt(range.start), line = ref[0], offset = ref[1];
	      if (offset === 0) {
	        contents = this.quill.getContents(range.start, range.end + 1);
	      } else {
	        contents = this.quill.getContents(range.start - 1, range.end);
	      }
	    } else {
	      contents = this.quill.getContents(range);
	    }
	    formatsArr = _.map(contents.ops, 'attributes');
	    return this._intersectFormats(formatsArr);
	  };

	  Toolbar.prototype._getLineActive = function(range) {
	    var firstLine, formatsArr, lastLine, offset, ref, ref1;
	    formatsArr = [];
	    ref = this.quill.editor.doc.findLineAt(range.start), firstLine = ref[0], offset = ref[1];
	    ref1 = this.quill.editor.doc.findLineAt(range.end), lastLine = ref1[0], offset = ref1[1];
	    if ((lastLine != null) && lastLine === firstLine) {
	      lastLine = lastLine.next;
	    }
	    while ((firstLine != null) && firstLine !== lastLine) {
	      formatsArr.push(_.clone(firstLine.formats));
	      firstLine = firstLine.next;
	    }
	    return this._intersectFormats(formatsArr);
	  };

	  Toolbar.prototype._intersectFormats = function(formatsArr) {
	    return _.reduce(formatsArr.slice(1), function(activeFormats, formats) {
	      var activeKeys, added, formatKeys, intersection, missing;
	      if (formats == null) {
	        formats = {};
	      }
	      activeKeys = Object.keys(activeFormats);
	      formatKeys = formats != null ? Object.keys(formats) : {};
	      intersection = _.intersection(activeKeys, formatKeys);
	      missing = _.difference(activeKeys, formatKeys);
	      added = _.difference(formatKeys, activeKeys);
	      _.each(intersection, function(name) {
	        if (Toolbar.formats.SELECT[name] != null) {
	          if (Array.isArray(activeFormats[name])) {
	            if (activeFormats[name].indexOf(formats[name]) < 0) {
	              return activeFormats[name].push(formats[name]);
	            }
	          } else if (activeFormats[name] !== formats[name]) {
	            return activeFormats[name] = [activeFormats[name], formats[name]];
	          }
	        }
	      });
	      _.each(missing, function(name) {
	        if (Toolbar.formats.TOGGLE[name] != null) {
	          return delete activeFormats[name];
	        } else if ((Toolbar.formats.SELECT[name] != null) && !Array.isArray(activeFormats[name])) {
	          return activeFormats[name] = [activeFormats[name]];
	        }
	      });
	      _.each(added, function(name) {
	        if (Toolbar.formats.SELECT[name] != null) {
	          return activeFormats[name] = [formats[name]];
	        }
	      });
	      return activeFormats;
	    }, formatsArr[0] || {});
	  };

	  return Toolbar;

	})();

	Quill.registerModule('toolbar', Toolbar);

	module.exports = Toolbar;



	},{"../quill":30}],28:[function(_dereq_,module,exports){
	var Quill, Tooltip, _, dom;

	Quill = _dereq_('../quill');

	_ = Quill.require('lodash');

	dom = Quill.require('dom');

	Tooltip = (function() {
	  Tooltip.DEFAULTS = {
	    offset: 10,
	    template: ''
	  };

	  Tooltip.HIDE_MARGIN = '-10000px';

	  function Tooltip(quill, options) {
	    this.quill = quill;
	    this.options = options;
	    this.container = this.quill.addContainer('ql-tooltip');
	    this.container.innerHTML = this.options.template;
	    this.hide();
	    this.quill.on(this.quill.constructor.events.TEXT_CHANGE, (function(_this) {
	      return function(delta, source) {
	        if (_this.container.style.left !== Tooltip.HIDE_MARGIN) {
	          _this.range = null;
	          return _this.hide();
	        }
	      };
	    })(this));
	  }

	  Tooltip.prototype.initTextbox = function(textbox, enterCallback, escapeCallback) {
	    return dom(textbox).on('keydown', (function(_this) {
	      return function(event) {
	        switch (event.which) {
	          case dom.KEYS.ENTER:
	            event.preventDefault();
	            return enterCallback.call(_this);
	          case dom.KEYS.ESCAPE:
	            event.preventDefault();
	            return escapeCallback.call(_this);
	          default:
	            return true;
	        }
	      };
	    })(this));
	  };

	  Tooltip.prototype.hide = function() {
	    this.container.style.left = Tooltip.HIDE_MARGIN;
	    if (this.range) {
	      this.quill.setSelection(this.range);
	    }
	    return this.range = null;
	  };

	  Tooltip.prototype.position = function(reference) {
	    var left, offsetBottom, offsetLeft, offsetTop, parentBounds, referenceBounds, top;
	    if (reference != null) {
	      referenceBounds = reference.getBoundingClientRect();
	      parentBounds = this.quill.container.getBoundingClientRect();
	      offsetLeft = referenceBounds.left - parentBounds.left;
	      offsetTop = referenceBounds.top - parentBounds.top;
	      offsetBottom = referenceBounds.bottom - parentBounds.bottom;
	      left = offsetLeft + referenceBounds.width / 2 - this.container.offsetWidth / 2;
	      top = offsetTop + referenceBounds.height + this.options.offset;
	      if (top + this.container.offsetHeight > this.quill.container.offsetHeight) {
	        top = offsetTop - this.container.offsetHeight - this.options.offset;
	      }
	      left = Math.max(0, Math.min(left, this.quill.container.offsetWidth - this.container.offsetWidth));
	      top = Math.max(0, Math.min(top, this.quill.container.offsetHeight - this.container.offsetHeight));
	    } else {
	      left = this.quill.container.offsetWidth / 2 - this.container.offsetWidth / 2;
	      top = this.quill.container.offsetHeight / 2 - this.container.offsetHeight / 2;
	    }
	    top += this.quill.container.scrollTop;
	    return [left, top];
	  };

	  Tooltip.prototype.show = function(reference) {
	    var left, ref, top;
	    this.range = this.quill.getSelection();
	    ref = this.position(reference), left = ref[0], top = ref[1];
	    this.container.style.left = left + "px";
	    this.container.style.top = top + "px";
	    return this.container.focus();
	  };

	  return Tooltip;

	})();

	Quill.registerModule('tooltip', Tooltip);

	module.exports = Tooltip;



	},{"../quill":30}],29:[function(_dereq_,module,exports){
	var Delta, Quill, UndoManager, _;

	Quill = _dereq_('../quill');

	_ = Quill.require('lodash');

	Delta = Quill.require('delta');

	UndoManager = (function() {
	  UndoManager.DEFAULTS = {
	    delay: 1000,
	    maxStack: 100
	  };

	  UndoManager.hotkeys = {
	    UNDO: {
	      key: 'Z',
	      metaKey: true
	    },
	    REDO: {
	      key: 'Z',
	      metaKey: true,
	      shiftKey: true
	    }
	  };

	  function UndoManager(quill, options) {
	    this.quill = quill;
	    this.options = options != null ? options : {};
	    this.lastRecorded = 0;
	    this.ignoreChange = false;
	    this.clear();
	    this.initListeners();
	  }

	  UndoManager.prototype.initListeners = function() {
	    this.quill.onModuleLoad('keyboard', (function(_this) {
	      return function(keyboard) {
	        keyboard.addHotkey(UndoManager.hotkeys.UNDO, function() {
	          _this.quill.editor.checkUpdate();
	          _this.undo();
	          return false;
	        });
	        return keyboard.addHotkey(UndoManager.hotkeys.REDO, function() {
	          _this.quill.editor.checkUpdate();
	          _this.redo();
	          return false;
	        });
	      };
	    })(this));
	    return this.quill.on(this.quill.constructor.events.TEXT_CHANGE, (function(_this) {
	      return function(delta, origin) {
	        if (_this.ignoreChange) {
	          return;
	        }
	        _this.record(delta, _this.oldDelta);
	        return _this.oldDelta = _this.quill.getContents();
	      };
	    })(this));
	  };

	  UndoManager.prototype.clear = function() {
	    this.stack = {
	      undo: [],
	      redo: []
	    };
	    return this.oldDelta = this.quill.getContents();
	  };

	  UndoManager.prototype.record = function(changeDelta, oldDelta) {
	    var change, ignored, timestamp, undoDelta;
	    if (!(changeDelta.ops.length > 0)) {
	      return;
	    }
	    this.stack.redo = [];
	    try {
	      undoDelta = this.quill.getContents().diff(this.oldDelta);
	      timestamp = new Date().getTime();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        change = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(change.undo);
	        changeDelta = change.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        return this.stack.undo.unshift();
	      }
	    } catch (_error) {
	      ignored = _error;
	      console.warn('Could not record change... clearing undo stack.');
	      return this.clear();
	    }
	  };

	  UndoManager.prototype.redo = function() {
	    return this._change('redo', 'undo');
	  };

	  UndoManager.prototype.undo = function() {
	    return this._change('undo', 'redo');
	  };

	  UndoManager.prototype._getLastChangeIndex = function(delta) {
	    var index, lastIndex;
	    lastIndex = 0;
	    index = 0;
	    _.each(delta.ops, function(op) {
	      if (op.insert != null) {
	        return lastIndex = Math.max(index + (op.insert.length || 1), lastIndex);
	      } else if (op["delete"] != null) {
	        return lastIndex = Math.max(index, lastIndex);
	      } else if (op.retain != null) {
	        if (op.attributes != null) {
	          lastIndex = Math.max(index + op.retain, lastIndex);
	        }
	        return index += op.retain;
	      }
	    });
	    return lastIndex;
	  };

	  UndoManager.prototype._change = function(source, dest) {
	    var change, index;
	    if (this.stack[source].length > 0) {
	      change = this.stack[source].pop();
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(change[source], 'user');
	      this.ignoreChange = false;
	      index = this._getLastChangeIndex(change[source]);
	      this.quill.setSelection(index, index);
	      this.oldDelta = this.quill.getContents();
	      return this.stack[dest].push(change);
	    }
	  };

	  return UndoManager;

	})();

	Quill.registerModule('undo-manager', UndoManager);

	module.exports = UndoManager;



	},{"../quill":30}],30:[function(_dereq_,module,exports){
	var Delta, Editor, EventEmitter2, Format, Normalizer, Quill, Range, _, dom, pkg,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  slice = [].slice;

	_ = _dereq_('lodash');

	pkg = _dereq_('../package.json');

	Delta = _dereq_('rich-text/lib/delta');

	EventEmitter2 = _dereq_('eventemitter2').EventEmitter2;

	dom = _dereq_('./lib/dom');

	Editor = _dereq_('./core/editor');

	Format = _dereq_('./core/format');

	Normalizer = _dereq_('./core/normalizer');

	Range = _dereq_('./lib/range');

	Quill = (function(superClass) {
	  extend(Quill, superClass);

	  Quill.version = pkg.version;

	  Quill.editors = [];

	  Quill.modules = [];

	  Quill.themes = [];

	  Quill.DEFAULTS = {
	    formats: ['align', 'bold', 'italic', 'strike', 'underline', 'color', 'background', 'font', 'size', 'link', 'image', 'bullet', 'list'],
	    modules: {
	      'keyboard': true,
	      'paste-manager': true,
	      'undo-manager': true
	    },
	    pollInterval: 100,
	    readOnly: false,
	    styles: {},
	    theme: 'base'
	  };

	  Quill.events = {
	    FORMAT_INIT: 'format-init',
	    MODULE_INIT: 'module-init',
	    POST_EVENT: 'post-event',
	    PRE_EVENT: 'pre-event',
	    SELECTION_CHANGE: 'selection-change',
	    TEXT_CHANGE: 'text-change'
	  };

	  Quill.sources = Editor.sources;

	  Quill.registerModule = function(name, module) {
	    if (Quill.modules[name] != null) {
	      console.warn("Overwriting " + name + " module");
	    }
	    return Quill.modules[name] = module;
	  };

	  Quill.registerTheme = function(name, theme) {
	    if (Quill.themes[name] != null) {
	      console.warn("Overwriting " + name + " theme");
	    }
	    return Quill.themes[name] = theme;
	  };

	  Quill.require = function(name) {
	    switch (name) {
	      case 'lodash':
	        return _;
	      case 'delta':
	        return Delta;
	      case 'format':
	        return Format;
	      case 'normalizer':
	        return Normalizer;
	      case 'dom':
	        return dom;
	      case 'range':
	        return Range;
	      default:
	        return null;
	    }
	  };

	  function Quill(container1, options) {
	    var html, moduleOptions, themeClass;
	    this.container = container1;
	    if (options == null) {
	      options = {};
	    }
	    if (_.isString(this.container)) {
	      this.container = document.querySelector(this.container);
	    }
	    if (this.container == null) {
	      throw new Error('Invalid Quill container');
	    }
	    moduleOptions = _.defaults(options.modules || {}, Quill.DEFAULTS.modules);
	    html = this.container.innerHTML;
	    this.container.innerHTML = '';
	    this.options = _.defaults(options, Quill.DEFAULTS);
	    this.options.modules = moduleOptions;
	    this.options.id = this.id = "ql-editor-" + (Quill.editors.length + 1);
	    this.modules = {};
	    this.root = this.addContainer('ql-editor');
	    this.editor = new Editor(this.root, this, this.options);
	    Quill.editors.push(this);
	    this.setHTML(html, Quill.sources.SILENT);
	    themeClass = Quill.themes[this.options.theme];
	    if (themeClass == null) {
	      throw new Error("Cannot load " + this.options.theme + " theme. Are you sure you registered it?");
	    }
	    this.theme = new themeClass(this, this.options);
	    _.each(this.options.modules, (function(_this) {
	      return function(option, name) {
	        return _this.addModule(name, option);
	      };
	    })(this));
	  }

	  Quill.prototype.destroy = function() {
	    var html;
	    html = this.getHTML();
	    _.each(this.modules, function(module, name) {
	      if (_.isFunction(module.destroy)) {
	        return module.destroy();
	      }
	    });
	    this.editor.destroy();
	    this.removeAllListeners();
	    Quill.editors.splice(_.indexOf(Quill.editors, this), 1);
	    return this.container.innerHTML = html;
	  };

	  Quill.prototype.addContainer = function(className, before) {
	    var container, refNode;
	    if (before == null) {
	      before = false;
	    }
	    refNode = before ? this.root : null;
	    container = document.createElement('div');
	    dom(container).addClass(className);
	    this.container.insertBefore(container, refNode);
	    return container;
	  };

	  Quill.prototype.addFormat = function(name, config) {
	    this.editor.doc.addFormat(name, config);
	    return this.emit(Quill.events.FORMAT_INIT, name);
	  };

	  Quill.prototype.addModule = function(name, options) {
	    var moduleClass;
	    moduleClass = Quill.modules[name];
	    if (moduleClass == null) {
	      throw new Error("Cannot load " + name + " module. Are you sure you registered it?");
	    }
	    if (options === true) {
	      options = {};
	    }
	    options = _.defaults(options, this.theme.constructor.OPTIONS[name] || {}, moduleClass.DEFAULTS || {});
	    this.modules[name] = new moduleClass(this, options);
	    this.emit(Quill.events.MODULE_INIT, name, this.modules[name]);
	    return this.modules[name];
	  };

	  Quill.prototype.deleteText = function(start, end, source) {
	    var delta, formats, ref;
	    if (source == null) {
	      source = Quill.sources.API;
	    }
	    ref = this._buildParams(start, end, {}, source), start = ref[0], end = ref[1], formats = ref[2], source = ref[3];
	    if (!(end > start)) {
	      return;
	    }
	    delta = new Delta().retain(start)["delete"](end - start);
	    return this.editor.applyDelta(delta, source);
	  };

	  Quill.prototype.emit = function() {
	    var args, eventName;
	    eventName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    Quill.__super__.emit.apply(this, [Quill.events.PRE_EVENT, eventName].concat(slice.call(args)));
	    Quill.__super__.emit.apply(this, [eventName].concat(slice.call(args)));
	    return Quill.__super__.emit.apply(this, [Quill.events.POST_EVENT, eventName].concat(slice.call(args)));
	  };

	  Quill.prototype.focus = function() {
	    return this.editor.focus();
	  };

	  Quill.prototype.formatLine = function(start, end, name, value, source) {
	    var formats, line, offset, ref, ref1;
	    ref = this._buildParams(start, end, name, value, source), start = ref[0], end = ref[1], formats = ref[2], source = ref[3];
	    ref1 = this.editor.doc.findLineAt(end), line = ref1[0], offset = ref1[1];
	    if (line != null) {
	      end += line.length - offset;
	    }
	    return this.formatText(start, end, formats, source);
	  };

	  Quill.prototype.formatText = function(start, end, name, value, source) {
	    var delta, formats, ref;
	    ref = this._buildParams(start, end, name, value, source), start = ref[0], end = ref[1], formats = ref[2], source = ref[3];
	    formats = _.reduce(formats, (function(_this) {
	      return function(formats, value, name) {
	        var format;
	        format = _this.editor.doc.formats[name];
	        if (!(value && value !== format.config["default"])) {
	          formats[name] = null;
	        }
	        return formats;
	      };
	    })(this), formats);
	    delta = new Delta().retain(start).retain(end - start, formats);
	    return this.editor.applyDelta(delta, source);
	  };

	  Quill.prototype.getBounds = function(index) {
	    return this.editor.getBounds(index);
	  };

	  Quill.prototype.getContents = function(start, end) {
	    if (start == null) {
	      start = 0;
	    }
	    if (end == null) {
	      end = null;
	    }
	    if (_.isObject(start)) {
	      end = start.end;
	      start = start.start;
	    }
	    return this.editor.delta.slice(start, end);
	  };

	  Quill.prototype.getHTML = function() {
	    return this.editor.doc.getHTML();
	  };

	  Quill.prototype.getLength = function() {
	    return this.editor.length;
	  };

	  Quill.prototype.getModule = function(name) {
	    return this.modules[name];
	  };

	  Quill.prototype.getSelection = function() {
	    this.editor.checkUpdate();
	    return this.editor.selection.getRange();
	  };

	  Quill.prototype.getText = function(start, end) {
	    if (start == null) {
	      start = 0;
	    }
	    if (end == null) {
	      end = null;
	    }
	    return _.map(this.getContents(start, end).ops, function(op) {
	      if (_.isString(op.insert)) {
	        return op.insert;
	      } else {
	        return '';
	      }
	    }).join('');
	  };

	  Quill.prototype.insertEmbed = function(index, type, url, source) {
	    var delta, end, formats, ref;
	    ref = this._buildParams(index, 0, type, url, source), index = ref[0], end = ref[1], formats = ref[2], source = ref[3];
	    delta = new Delta().retain(index).insert(1, formats);
	    return this.editor.applyDelta(delta, source);
	  };

	  Quill.prototype.insertText = function(index, text, name, value, source) {
	    var delta, end, formats, ref;
	    ref = this._buildParams(index, 0, name, value, source), index = ref[0], end = ref[1], formats = ref[2], source = ref[3];
	    if (!(text.length > 0)) {
	      return;
	    }
	    delta = new Delta().retain(index).insert(text, formats);
	    return this.editor.applyDelta(delta, source);
	  };

	  Quill.prototype.onModuleLoad = function(name, callback) {
	    if (this.modules[name]) {
	      return callback(this.modules[name]);
	    }
	    return this.on(Quill.events.MODULE_INIT, function(moduleName, module) {
	      if (moduleName === name) {
	        return callback(module);
	      }
	    });
	  };

	  Quill.prototype.prepareFormat = function(name, value, source) {
	    var format, range;
	    if (source == null) {
	      source = Quill.sources.API;
	    }
	    format = this.editor.doc.formats[name];
	    if (format == null) {
	      return;
	    }
	    range = this.getSelection();
	    if (!(range != null ? range.isCollapsed() : void 0)) {
	      return;
	    }
	    if (format.isType(Format.types.LINE)) {
	      return this.formatLine(range, name, value, source);
	    } else {
	      return format.prepare(value);
	    }
	  };

	  Quill.prototype.setContents = function(delta, source) {
	    var lastOp;
	    if (source == null) {
	      source = Quill.sources.API;
	    }
	    if (Array.isArray(delta)) {
	      delta = new Delta(delta.slice());
	    } else {
	      delta = new Delta(delta.ops.slice());
	    }
	    lastOp = _.last(delta.slice(delta.length() - 1).ops);
	    delta["delete"](this.getLength() - 1);
	    if ((lastOp != null) && _.isString(lastOp.insert) && _.last(lastOp.insert) === '\n') {
	      delta["delete"](1);
	    }
	    return this.updateContents(delta, source);
	  };

	  Quill.prototype.setHTML = function(html, source) {
	    if (source == null) {
	      source = Quill.sources.API;
	    }
	    if (!html.trim()) {
	      html = "<" + dom.DEFAULT_BLOCK_TAG + "><" + dom.DEFAULT_BREAK_TAG + "></" + dom.DEFAULT_BLOCK_TAG + ">";
	    }
	    this.editor.doc.setHTML(html);
	    return this.editor.checkUpdate(source);
	  };

	  Quill.prototype.setSelection = function(start, end, source) {
	    var range;
	    if (source == null) {
	      source = Quill.sources.API;
	    }
	    if (_.isNumber(start) && _.isNumber(end)) {
	      range = new Range(start, end);
	    } else {
	      range = start;
	      source = end || source;
	    }
	    return this.editor.selection.setRange(range, source);
	  };

	  Quill.prototype.setText = function(text, source) {
	    var delta;
	    if (source == null) {
	      source = Quill.sources.API;
	    }
	    delta = new Delta().insert(text);
	    return this.setContents(delta, source);
	  };

	  Quill.prototype.updateContents = function(delta, source) {
	    if (source == null) {
	      source = Quill.sources.API;
	    }
	    if (Array.isArray(delta)) {
	      delta = {
	        ops: delta
	      };
	    }
	    return this.editor.applyDelta(delta, source);
	  };

	  Quill.prototype._buildParams = function() {
	    var formats, params;
	    params = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (_.isObject(params[0])) {
	      params.splice(0, 1, params[0].start, params[0].end);
	    }
	    if (_.isString(params[2])) {
	      formats = {};
	      formats[params[2]] = params[3];
	      params.splice(2, 2, formats);
	    }
	    if (params[3] == null) {
	      params[3] = Quill.sources.API;
	    }
	    return params;
	  };

	  return Quill;

	})(EventEmitter2);

	Quill.registerTheme('base', _dereq_('./themes/base'));

	Quill.registerTheme('snow', _dereq_('./themes/snow'));

	module.exports = Quill;



	},{"../package.json":7,"./core/editor":9,"./core/format":10,"./core/normalizer":13,"./lib/dom":17,"./lib/range":20,"./themes/base":32,"./themes/snow":33,"eventemitter2":2,"lodash":1,"rich-text/lib/delta":3}],31:[function(_dereq_,module,exports){
	module.exports = ".ql-image-tooltip{padding:10px;width:300px}.ql-image-tooltip:after{clear:both;content:\"\";display:table}.ql-image-tooltip a{border:1px solid #000;box-sizing:border-box;display:inline-block;float:left;padding:5px;text-align:center;width:50%}.ql-image-tooltip img{bottom:0;left:0;margin:auto;max-height:100%;max-width:100%;position:absolute;right:0;top:0}.ql-image-tooltip .input{box-sizing:border-box;width:100%}.ql-image-tooltip .preview{margin:10px 0;position:relative;border:1px dashed #000;height:200px}.ql-image-tooltip .preview span{display:inline-block;position:absolute;text-align:center;top:40%;width:100%}.ql-link-tooltip{padding:5px 10px}.ql-link-tooltip input.input{width:170px}.ql-link-tooltip a.done,.ql-link-tooltip input.input{display:none}.ql-link-tooltip a.change{margin-right:4px}.ql-link-tooltip.editing a.done,.ql-link-tooltip.editing input.input{display:inline-block}.ql-link-tooltip.editing a.change,.ql-link-tooltip.editing a.remove,.ql-link-tooltip.editing a.url{display:none}.ql-multi-cursor{position:absolute;left:0;top:0;z-index:1000}.ql-multi-cursor .cursor{margin-left:-1px;position:absolute}.ql-multi-cursor .cursor-flag{bottom:100%;position:absolute;white-space:nowrap}.ql-multi-cursor .cursor-name{display:inline-block;color:#fff;padding:2px 8px}.ql-multi-cursor .cursor-caret{height:100%;position:absolute;width:2px}.ql-multi-cursor .cursor.hidden .cursor-flag{display:none}.ql-multi-cursor .cursor.top .cursor-flag{bottom:auto;top:100%}.ql-multi-cursor .cursor.right .cursor-flag{right:-2px}.ql-paste-manager{left:-100000px;position:absolute;top:50%}.ql-toolbar{box-sizing:border-box}.ql-tooltip{background-color:#fff;border:1px solid #000;box-sizing:border-box;position:absolute;top:0;white-space:nowrap;z-index:2000}.ql-tooltip a{cursor:pointer;text-decoration:none}.ql-container{box-sizing:border-box;cursor:text;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;line-height:1.42;margin:0;overflow-x:hidden;overflow-y:auto;padding:12px 15px;position:relative}.ql-editor{box-sizing:border-box;min-height:100%;outline:0;tab-size:4;white-space:pre-wrap}.ql-editor div{margin:0;padding:0}.ql-editor a{text-decoration:underline}.ql-editor b{font-weight:700}.ql-editor i{font-style:italic}.ql-editor s{text-decoration:line-through}.ql-editor u{text-decoration:underline}.ql-editor a,.ql-editor b,.ql-editor i,.ql-editor s,.ql-editor span,.ql-editor u{background-color:inherit}.ql-editor img{max-width:100%}.ql-editor blockquote,.ql-editor ol,.ql-editor ul{margin:0 0 0 2em;padding:0}.ql-editor ol{list-style-type:decimal}.ql-editor ul{list-style-type:disc}.ql-editor.ql-ie-10 br,.ql-editor.ql-ie-9 br{display:none}";
	},{}],32:[function(_dereq_,module,exports){
	var BaseTheme, _, baseStyles, dom;

	_ = _dereq_('lodash');

	dom = _dereq_('../../lib/dom');

	baseStyles = _dereq_('./base.styl');

	BaseTheme = (function() {
	  BaseTheme.OPTIONS = {};

	  BaseTheme.objToCss = function(obj) {
	    return _.map(obj, function(value, key) {
	      var innerStr;
	      innerStr = _.map(value, function(innerValue, innerKey) {
	        return innerKey + ": " + innerValue + ";";
	      }).join(' ');
	      return key + " { " + innerStr + " }";
	    }).join("\n");
	  };

	  function BaseTheme(quill, options) {
	    var version;
	    this.quill = quill;
	    this.options = options;
	    dom(this.quill.container).addClass('ql-container');
	    if (this.options.styles) {
	      this.addStyles(baseStyles + BaseTheme.objToCss(this.options.styles));
	    }
	    if (dom.isIE(10)) {
	      version = dom.isIE(9) ? '9' : '10';
	      dom(this.quill.root).addClass('ql-ie-' + version);
	    }
	  }

	  BaseTheme.prototype.addStyles = function(css) {
	    var style;
	    if (_.isObject(css)) {
	      css = BaseTheme.objToCss(css);
	    }
	    style = document.createElement('style');
	    style.type = 'text/css';
	    style.appendChild(document.createTextNode(css));
	    return document.head.appendChild(style);
	  };

	  return BaseTheme;

	})();

	module.exports = BaseTheme;



	},{"../../lib/dom":17,"./base.styl":31,"lodash":1}],33:[function(_dereq_,module,exports){
	var BaseTheme, ColorPicker, Picker, SnowTheme, _, dom,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;

	_ = _dereq_('lodash');

	ColorPicker = _dereq_('../../lib/color-picker');

	BaseTheme = _dereq_('../base');

	dom = _dereq_('../../lib/dom');

	Picker = _dereq_('../../lib/picker');

	SnowTheme = (function(superClass) {
	  extend(SnowTheme, superClass);

	  SnowTheme.COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008A00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

	  SnowTheme.OPTIONS = {
	    'multi-cursor': {
	      template: '<span class="cursor-flag"> <span class="cursor-triangle top"></span> <span class="cursor-name"></span> <span class="cursor-triangle bottom"></span> </span> <span class="cursor-caret"></span>'
	    }
	  };

	  function SnowTheme(quill, options) {
	    this.quill = quill;
	    this.options = options;
	    SnowTheme.__super__.constructor.apply(this, arguments);
	    dom(this.quill.container).addClass('ql-snow');
	    this.pickers = [];
	    this.quill.on(this.quill.constructor.events.SELECTION_CHANGE, (function(_this) {
	      return function(range) {
	        if (range != null) {
	          return _.invoke(_this.pickers, 'close');
	        }
	      };
	    })(this));
	    this.quill.onModuleLoad('multi-cursor', _.bind(this.extendMultiCursor, this));
	    this.quill.onModuleLoad('toolbar', _.bind(this.extendToolbar, this));
	  }

	  SnowTheme.prototype.extendMultiCursor = function(module) {
	    return module.on(module.constructor.events.CURSOR_ADDED, function(cursor) {
	      var bottomTriangle, topTriangle;
	      bottomTriangle = cursor.elem.querySelector('.cursor-triangle.bottom');
	      topTriangle = cursor.elem.querySelector('.cursor-triangle.top');
	      return bottomTriangle.style.borderTopColor = topTriangle.style.borderBottomColor = cursor.color;
	    });
	  };

	  SnowTheme.prototype.extendToolbar = function(module) {
	    dom(module.container).addClass('ql-snow');
	    _.each(['color', 'background', 'font', 'size', 'align'], (function(_this) {
	      return function(format) {
	        var picker, select;
	        select = module.container.querySelector(".ql-" + format);
	        if (select == null) {
	          return;
	        }
	        switch (format) {
	          case 'font':
	          case 'size':
	          case 'align':
	            picker = new Picker(select);
	            break;
	          case 'color':
	          case 'background':
	            picker = new ColorPicker(select);
	            _.each(picker.container.querySelectorAll('.ql-picker-item'), function(item, i) {
	              if (i < 7) {
	                return dom(item).addClass('ql-primary-color');
	              }
	            });
	        }
	        if (picker != null) {
	          return _this.pickers.push(picker);
	        }
	      };
	    })(this));
	    return _.each(dom(module.container).textNodes(), function(node) {
	      if (dom(node).text().trim().length === 0) {
	        return dom(node).remove();
	      }
	    });
	  };

	  return SnowTheme;

	})(BaseTheme);

	module.exports = SnowTheme;



	},{"../../lib/color-picker":16,"../../lib/dom":17,"../../lib/picker":19,"../base":32,"lodash":1}]},{},[15])(15)
	});

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var Development;

	__webpack_require__(3);

	Development = ReactiveComponent({
	  displayName: 'Development',
	  render: function() {
	    var app, apps, hues, idx, ref, sub, subdomains, submenu, submenus;
	    subdomains = fetch('/subdomains').subs;
	    apps = fetch('/apps');
	    app = fetch('/application');
	    hues = getNiceRandomHues(Math.max(subdomains != null ? subdomains.length : void 0, (ref = apps.apps) != null ? ref.length : void 0));
	    submenus = app.app === 'franklin' ? ['change subdomain', 'change application'] : app.app === 'product_page' ? ['change application'] : void 0;
	    subdomains.sort(function(a, b) {
	      if (a.name.toLowerCase() > b.name.toLowerCase()) {
	        return 1;
	      } else {
	        return -1;
	      }
	    });
	    return DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        left: 0,
	        top: 0,
	        opacity: this.local.hover_top ? 1 : 0,
	        backgroundColor: 'black',
	        color: 'white',
	        padding: 15
	      },
	      onTouchEnd: (function(_this) {
	        return function(e) {
	          _this.local.hover_top = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseEnter: (function(_this) {
	        return function(e) {
	          _this.local.hover_top = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function(e) {
	          _this.local.hover_top = _this.local.hover_second = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, this.local.hover_top ? SPAN(null, UL({
	      style: {
	        listStyle: 'none',
	        display: 'inline-block'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = submenus.length; i < len; i++) {
	        submenu = submenus[i];
	        results.push(LI({
	          style: {
	            display: 'inline-block',
	            padding: '0px 18px',
	            backgroundColor: 'black',
	            color: 'white',
	            fontWeight: 600
	          },
	          onTouchEnd: (function(_this) {
	            return function(submenu) {
	              return function(e) {
	                _this.local.hover_second = submenu;
	                return save(_this.local);
	              };
	            };
	          })(this)(submenu),
	          onMouseEnter: (function(_this) {
	            return function(submenu) {
	              return function(e) {
	                _this.local.hover_second = submenu;
	                return save(_this.local);
	              };
	            };
	          })(this)(submenu)
	        }, submenu));
	      }
	      return results;
	    }).call(this)), DIV({
	      style: {
	        width: '100%'
	      }
	    }, this.local.hover_second === 'change subdomain' ? UL(null, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = subdomains.length; i < len; idx = ++i) {
	        sub = subdomains[idx];
	        results.push(LI({
	          style: {
	            display: 'inline-block',
	            listStyle: 'none'
	          }
	        }, A({
	          href: "/change_subdomain/" + sub.id,
	          'data-nojax': false,
	          style: {
	            padding: "4px 8px",
	            fontSize: 18,
	            backgroundColor: hsv2rgb(hues[idx], .7, .5),
	            color: 'white',
	            display: 'inline-block'
	          }
	        }, sub.name)));
	      }
	      return results;
	    })()) : this.local.hover_second === 'change application' ? UL(null, (function() {
	      var i, len, ref1, results;
	      ref1 = apps.apps;
	      results = [];
	      for (idx = i = 0, len = ref1.length; i < len; idx = ++i) {
	        app = ref1[idx];
	        results.push(LI({
	          style: {
	            display: 'inline-block',
	            listStyle: 'none'
	          }
	        }, A({
	          href: "/set_app/" + app,
	          'data-nojax': false,
	          style: {
	            padding: "4px 8px",
	            fontSize: 18,
	            backgroundColor: hsv2rgb(hues[idx], .7, .5),
	            color: 'white',
	            display: 'inline-block'
	          }
	        }, app)));
	      }
	      return results;
	    })()) : void 0)) : void 0);
	  },
	  componentDidMount: function() {
	    return document.addEventListener("keypress", function(e) {
	      var app, cur_idx, i, idx, key, len, next_idx, ref, sub, subdomain, subdomains;
	      key = (e && e.keyCode) || e.keyCode;
	      if (key === 14) {
	        app = fetch('/application');
	        if (app.app === 'franklin') {
	          subdomains = fetch('/subdomains');
	          subdomain = fetch('/subdomain');
	          cur_idx = -1;
	          ref = subdomains.subs;
	          for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	            sub = ref[idx];
	            if (sub.id === subdomain.id) {
	              cur_idx = idx;
	            }
	          }
	          next_idx = cur_idx + 1;
	          if (next_idx >= subdomains.subs.length) {
	            next_idx = 0;
	          }
	          return window.location = "/change_subdomain/" + subdomains.subs[next_idx].id;
	        }
	      }
	    });
	  }
	});

	window.Development = Development;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {$.fn.ensureInView = function(options) {
	  var $el, bottom_inside, distance_to_travel, doc_bottom, doc_height, doc_top, el_bottom, el_height, el_top, in_viewport, is_onscreen, target, top_inside;
	  if (options == null) {
	    options = {};
	  }
	  _.defaults(options, {
	    fill_threshold: .5,
	    offset_buffer: 50,
	    scroll: true,
	    position: 'top',
	    speed: null,
	    callback: function() {}
	  });
	  $el = $(this);
	  el_height = $el.height();
	  el_top = $el.offset().top;
	  el_bottom = el_top + el_height;
	  doc_height = $(window).height();
	  doc_top = $(window).scrollTop();
	  doc_bottom = doc_top + doc_height;
	  is_onscreen = el_top > doc_top && el_bottom < doc_bottom;
	  bottom_inside = el_bottom < doc_bottom && (el_bottom - doc_top) > options.fill_threshold * el_height;
	  top_inside = el_top > doc_top && (doc_bottom - el_top) > options.fill_threshold * el_height;
	  in_viewport = is_onscreen || top_inside || bottom_inside;
	  if (!in_viewport) {
	    switch (options.position) {
	      case 'top':
	        target = el_top - options.offset_buffer;
	        break;
	      case 'bottom':
	        target = el_bottom - doc_height + options.offset_buffer;
	        break;
	      default:
	        throw 'bad position for ensureInView';
	    }
	    if (options.scroll) {
	      distance_to_travel = options.speed || Math.abs(doc_top - target);
	      return $("html, body").animate({
	        scrollTop: $el.offset().top - options.offset_buffer
	      }, {
	        duration: Math.min(distance_to_travel, 1500),
	        complete: options.callback
	      }, 'ease-in');
	    } else {
	      $(document).scrollTop(target);
	      return options.callback();
	    }
	  } else {
	    return options.callback();
	  }
	};

	$.fn.moveToTop = function(options) {
	  var $el, distance_to_travel, doc_top, el_bottom, el_top, target;
	  if (options == null) {
	    options = {};
	  }
	  _.defaults(options, {
	    offset_buffer: 50,
	    scroll: false
	  });
	  $el = $(this);
	  el_top = $el.offset().top;
	  el_bottom = target = el_top - options.offset_buffer;
	  doc_top = $(document).scrollTop();
	  if (options.scroll) {
	    distance_to_travel = Math.abs(doc_top - target);
	    return $('body').animate({
	      scrollTop: target
	    }, distance_to_travel);
	  } else {
	    return $(document).scrollTop(target);
	  }
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(React, $) {var el, rainbows, recent_keys, reset_selection;

	for (el in React.DOM) {
	  this[el.toUpperCase()] = React.DOM[el];
	}

	window.parse_key = function(key) {
	  var has_match, is_new, m, name, number, owner, regexp, server_owned, tmp1, tmp2, word;
	  word = "([^/]+)";
	  regexp = new RegExp("(/)?(new/)?" + word + "(/" + word + ")?(/)?");
	  m = key.match(regexp);
	  if (!m) {
	    return null;
	  }
	  has_match = m[0], server_owned = m[1], is_new = m[2], name = m[3], tmp1 = m[4], number = m[5], tmp2 = m[6];
	  owner = server_owned ? 'server' : 'client';
	  return has_match && {
	    owner: owner,
	    'new': is_new,
	    name: name,
	    number: number
	  };
	};

	window.StateDash = ReactiveComponent({
	  displayName: 'State Dash',
	  render: function() {
	    var best_guess, cache, cluster_rows, clusters, dash, field, fieldset, first_key, key, name, owner, prefix, ref, ref1, row, search_results, selected_keys, tree, url_tree;
	    dash = this.fetch('state_dash');
	    if (((ref = dash.filter) != null ? ref.match(/idkfa/) : void 0) || ((ref1 = dash.filter) != null ? ref1.match(/idmap/) : void 0)) {
	      dash.on = false;
	      dash.filter = '';
	      save(dash);
	    }
	    if (!dash.on) {
	      return DIV(null, '');
	    }
	    url_tree = function(cache) {
	      var add_key, key, tree;
	      tree = {
	        server: {},
	        client: {}
	      };
	      add_key = function(key) {
	        var base, name1, p;
	        p = parse_key(key);
	        if (!p) {
	          console.log('The state dash can\'t deal with key', key);
	          return null;
	        }
	        (base = tree[p.owner])[name1 = p.name] || (base[name1] = []);
	        return tree[p.owner][p.name][p.number || null] = cache[key];
	      };
	      for (key in cache) {
	        add_key(key);
	      }
	      return tree;
	    };
	    search_results = this.search_results();
	    cache = search_results.matches;
	    tree = url_tree(cache);
	    first_key = function(cache) {
	      var key, reject_name, reject_numb;
	      for (key in cache) {
	        reject_name = dash.selected.name && parse_key(key).name !== dash.selected.name;
	        reject_numb = dash.selected.number && parse_key(key).number !== dash.selected.number;
	        if (!reject_name && !reject_numb) {
	          return key;
	        }
	      }
	      return null;
	    };
	    best_guess = first_key(search_results.key_matches) || first_key(search_results.data_matches);
	    cluster_rows = function(keys) {
	      var clusters, fields, i, key, len;
	      clusters = {};
	      for (i = 0, len = keys.length; i < len; i++) {
	        key = keys[i];
	        fields = JSON.stringify(Object.keys(cache[key]));
	        clusters[fields] = clusters[fields] || [];
	        clusters[fields].push(key);
	      }
	      return clusters;
	    };
	    return DIV({
	      className: 'state_dash',
	      style: this.props.style
	    }, STYLE(null, ".state_dash {\n  position: absolute;\n  margin: 20px;\n  z-index: 10000;\n}\n.state_dash .left, .state_dash .right, .state_dash .top {\n  background-color: #eee;\n  overflow-wrap: break-word;\n  padding: 10px;\n  vertical-align: top;\n}\n.state_dash .left  { min-width:   40px; display: inline-block; }\n.state_dash .right { margin-left: 30px; display: inline-block; }\n.state_dash .top   { max-width:   100%; margin: 20px 0; }\n\n.string { color: green; }\n.number { color: darkorange; }\n.boolean { color: blue; }\n.null { color: magenta; }\n.key { color: red; }\n\n.cell {\n  width: 150px;\n  border: 1px solid grey;\n  padding: 2px;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: clip;\n  margin: 0;\n}"), DIV({
	      className: 'left'
	    }, INPUT({
	      className: 'search',
	      onChange: this.filter_to,
	      onMouseEnter: reset_selection
	    }), (function() {
	      var i, len, ref2, results;
	      ref2 = ['client', 'server'];
	      results = [];
	      for (i = 0, len = ref2.length; i < len; i++) {
	        owner = ref2[i];
	        prefix = (owner === 'server') && '/' || '';
	        results.push(DIV({
	          key: owner
	        }, (function() {
	          var results1;
	          results1 = [];
	          for (name in tree[owner]) {
	            results1.push((function(owner, name) {
	              var f, style;
	              f = function() {
	                dash.selected = {
	                  owner: owner,
	                  name: name,
	                  number: null
	                };
	                return save(dash);
	              };
	              style = (name === dash.selected.name) && {
	                'background-color': '#aaf'
	              } || {};
	              return DIV({
	                onMouseEnter: f,
	                key: name,
	                style: style
	              }, prefix + name);
	            })(owner, name));
	          }
	          return results1;
	        })()));
	      }
	      return results;
	    })()), DIV({
	      className: 'right'
	    }, (function() {
	      var results;
	      if (dash.selected.name) {
	        selected_keys = (function() {
	          var results;
	          results = [];
	          for (key in cache) {
	            if (parse_key(key).name === dash.selected.name) {
	              results.push(key);
	            }
	          }
	          return results;
	        })();
	        clusters = cluster_rows(selected_keys);
	        results = [];
	        for (fieldset in clusters) {
	          results.push(DIV(null, (function() {
	            var i, len, ref2, results1;
	            ref2 = JSON.parse(fieldset);
	            results1 = [];
	            for (i = 0, len = ref2.length; i < len; i++) {
	              field = ref2[i];
	              results1.push(DIV({
	                key: field,
	                style: {
	                  fontWeight: 'bold',
	                  borderColor: '#eee'
	                },
	                className: 'cell'
	              }, field));
	            }
	            return results1;
	          })(), (function() {
	            var i, len, ref2, results1;
	            ref2 = clusters[fieldset];
	            results1 = [];
	            for (i = 0, len = ref2.length; i < len; i++) {
	              key = ref2[i];
	              row = cache[key];
	              results1.push(DIV({
	                key: key
	              }, (function() {
	                var results2;
	                results2 = [];
	                for (field in row) {
	                  results2.push(DIV({
	                    className: 'cell',
	                    key: field,
	                    onClick: (function(_this) {
	                      return function(key, field) {
	                        return function(evt) {
	                          _this.local.editing = {
	                            key_: key,
	                            field: field
	                          };
	                          save(_this.local);
	                          return setTimeout(function() {
	                            return _this.refs.dash_input.getDOMNode().focus();
	                          });
	                        };
	                      };
	                    })(this)(key, field)
	                  }, this.local.editing && this.local.editing.key_ === key && this.local.editing.field === field ? SPAN(null, TEXTAREA({
	                    key: field,
	                    type: 'text',
	                    ref: 'dash_input',
	                    defaultValue: JSON.stringify(row[field]),
	                    onChange: (function(_this) {
	                      return function(event) {
	                        var e, error, val;
	                        try {
	                          val = JSON.parse(_this.refs.dash_input.getDOMNode().value);
	                          cache[_this.local.editing.key_][_this.local.editing.field] = val;
	                          save(cache[_this.local.editing.key_]);
	                          event.stopPropagation();
	                          delete _this.local.editing.error;
	                          return save(_this.local);
	                        } catch (error) {
	                          e = error;
	                          _this.local.editing.error = true;
	                          return save(_this.local);
	                        }
	                      };
	                    })(this),
	                    onBlur: (function(_this) {
	                      return function(event) {
	                        delete _this.local.editing;
	                        return save(_this.local);
	                      };
	                    })(this),
	                    style: {
	                      position: 'absolute',
	                      backgroundColor: this.local.editing.error ? '#faa' : void 0
	                    }
	                  })) : void 0, JSON.stringify(row[field])));
	                }
	                return results2;
	              }).call(this)));
	            }
	            return results1;
	          }).call(this)));
	        }
	        return results;
	      }
	    }).call(this)));
	  },
	  search_results: function() {
	    var dash, data_matches, key, key_matches, matches;
	    dash = fetch('state_dash');
	    matches = {};
	    key_matches = {};
	    data_matches = {};
	    if (dash.filter) {
	      for (key in arest.cache) {
	        if (key.match(dash.filter)) {
	          matches[key] = arest.cache[key];
	          key_matches[key] = arest.cache[key];
	        }
	        if (JSON.stringify(arest.cache[key]).match(dash.filter)) {
	          matches[key] = arest.cache[key];
	          data_matches[key] = arest.cache[key];
	        }
	      }
	    } else {
	      matches = key_matches = data_matches = arest.cache;
	    }
	    return {
	      matches: matches,
	      key_matches: key_matches,
	      data_matches: data_matches
	    };
	  },
	  filter_to: function(e) {
	    var dash;
	    dash = this.data('state_dash');
	    dash.filter = e.target.value;
	    if (dash.filter.length === 0) {
	      dash.filter = null;
	    }
	    save(dash);
	    return true;
	  }
	});

	reset_selection = function() {
	  var dash;
	  dash = fetch('state_dash');
	  dash.selected = {
	    owner: null,
	    name: null,
	    number: null
	  };
	  return save(dash);
	};

	rainbows = function(json) {
	  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function(match) {
	    var cls;
	    cls = 'number';
	    if (/^"/.test(match)) {
	      if (/:$/.test(match)) {
	        cls = 'key';
	      } else {
	        cls = 'string';
	      }
	    } else if (/true|false/.test(match)) {
	      cls = 'boolean';
	    } else if (/null/.test(match)) {
	      cls = 'null';
	    }
	    return "<span class=\"" + cls + "\">" + match + "</span>";
	  });
	};

	fetch('state_dash', {
	  on: false,
	  selected: {
	    owner: null,
	    name: null,
	    number: null
	  },
	  filter: null
	});

	recent_keys = [0, 0, 0, 0, 0];

	document.addEventListener("keypress", function(e) {
	  var dash, key;
	  key = (e && e.keyCode) || e.keyCode;
	  recent_keys.push(key);
	  recent_keys = recent_keys.slice(1);
	  if (key === 4 || ("" + recent_keys) === ("" + [105, 100, 109, 97, 112]) || ("" + recent_keys) === ("" + [105, 100, 107, 102, 97])) {
	    dash = fetch('state_dash');
	    if (dash.on) {
	      dash.on = false;
	    } else {
	      dash.on = true;
	    }
	    save(dash);
	    return setTimeout(function() {
	      return $('.state_dash input').focus();
	    });
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(2)))

/***/ },
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	d3.tip=function(){function t(t){v=d(t),w=v.createSVGPoint(),document.body.appendChild(x)}function e(){return"n"}function n(){return[0,0]}function r(){return" "}function o(){var t=y();return{top:t.n.y-x.offsetHeight,left:t.n.x-x.offsetWidth/2}}function l(){var t=y();return{top:t.s.y,left:t.s.x-x.offsetWidth/2}}function s(){var t=y();return{top:t.e.y-x.offsetHeight/2,left:t.e.x}}function f(){var t=y();return{top:t.w.y-x.offsetHeight/2,left:t.w.x-x.offsetWidth}}function i(){var t=y();return{top:t.nw.y-x.offsetHeight,left:t.nw.x-x.offsetWidth}}function u(){var t=y();return{top:t.ne.y-x.offsetHeight,left:t.ne.x}}function a(){var t=y();return{top:t.sw.y,left:t.sw.x-x.offsetWidth}}function c(){var t=y();return{top:t.se.y,left:t.e.x}}function p(){var t=d3.select(document.createElement("div"));return t.style({position:"absolute",opacity:0,pointerEvents:"none",boxSizing:"border-box"}),t.node()}function d(t){return t=t.node(),"svg"==t.tagName.toLowerCase()?t:t.ownerSVGElement}function y(){var t=T||d3.event.target,e={},n=t.getScreenCTM(),r=t.getBBox(),o=r.width,l=r.height,s=r.x,f=r.y,i=document.documentElement.scrollTop||document.body.scrollTop,u=document.documentElement.scrollLeft||document.body.scrollLeft;return w.x=s+u,w.y=f+i,e.nw=w.matrixTransform(n),w.x+=o,e.ne=w.matrixTransform(n),w.y+=l,e.se=w.matrixTransform(n),w.x-=o,e.sw=w.matrixTransform(n),w.y-=l/2,e.w=w.matrixTransform(n),w.x+=o,e.e=w.matrixTransform(n),w.x-=o/2,w.y-=l/2,e.n=w.matrixTransform(n),w.y+=l,e.s=w.matrixTransform(n),e}var m=e,g=n,h=r,x=p(),v=null,w=null,T=null;t.show=function(){var e=Array.prototype.slice.call(arguments);e[e.length-1]instanceof SVGElement&&(T=e.pop());var n,r=h.apply(this,e),o=g.apply(this,e),l=m.apply(this,e),s=d3.select(x),f=0;for(s.html(r).style({opacity:1,"pointer-events":"all"});f--;)s.classed(E[f],!1);return n=b.get(l).apply(this),s.classed(l,!0).style({top:n.top+o[0]+"px",left:n.left+o[1]+"px"}),t},t.hide=function(){return nodel=d3.select(x),nodel.style({opacity:0,"pointer-events":"none"}),t},t.attr=function(e){if(arguments.length<2&&"string"==typeof e)return d3.select(x).attr(e);var n=Array.prototype.slice.call(arguments);return d3.selection.prototype.attr.apply(d3.select(x),n),t},t.style=function(e){if(arguments.length<2&&"string"==typeof e)return d3.select(x).style(e);var n=Array.prototype.slice.call(arguments);return d3.selection.prototype.style.apply(d3.select(x),n),t},t.direction=function(e){return arguments.length?(m=null==e?e:d3.functor(e),t):m},t.offset=function(e){return arguments.length?(g=null==e?e:d3.functor(e),t):g},t.html=function(e){return arguments.length?(h=null==e?e:d3.functor(e),t):h};var b=d3.map({n:o,s:l,e:s,w:f,nw:i,ne:u,sw:a,se:c}),E=b.keys();return t};

/***/ },
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function( jQuery ) {

	if ( window.XDomainRequest ) {
	  jQuery.ajaxTransport(function( s ) {
	    if ( s.crossDomain && s.async ) {
	      if ( s.timeout ) {
	        s.xdrTimeout = s.timeout;
	        delete s.timeout;
	      }
	      var xdr;
	      return {
	        send: function( _, complete ) {
	          function callback( status, statusText, responses, responseHeaders ) {
	            xdr.onload = xdr.onerror = xdr.ontimeout = xdr.onprogress = jQuery.noop;
	            xdr = undefined;
	            complete( status, statusText, responses, responseHeaders );
	          }
	          xdr = new XDomainRequest();
	          xdr.open( s.type, s.url );
	          xdr.onload = function() {
	            callback( 200, "OK", { text: xdr.responseText }, "Content-Type: " + xdr.contentType );
	          };
	          xdr.onerror = function() {
	            callback( 404, "Not Found" );
	          };
	          xdr.onprogress = function() {};
	          if ( s.xdrTimeout ) {
	            xdr.ontimeout = function() {
	              callback( 0, "timeout" );
	            };
	            xdr.timeout = s.xdrTimeout;
	          }
	          xdr.send( ( s.hasContent && s.data ) || null );
	        },
	        abort: function() {
	          if ( xdr ) {
	            xdr.onerror = jQuery.noop();
	            xdr.abort();
	          }
	        }
	      };
	    }
	  });
	}
	})( jQuery );
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * jQuery UI Touch Punch 0.2.3
	 *
	 * Copyright 2011–2014, Dave Furfero
	 * Dual licensed under the MIT or GPL Version 2 licenses.
	 *
	 * Depends:
	 *  jquery.ui.widget.js
	 *  jquery.ui.mouse.js
	 */

	(function ($) {

	  // Detect touch support
	  $.support.touch = 'ontouchend' in document;

	  // Ignore browsers without touch support
	  if (!$.support.touch) {
	    return;
	  }

	  var mouseProto = $.ui.mouse.prototype,
	      _mouseInit = mouseProto._mouseInit,
	      _mouseDestroy = mouseProto._mouseDestroy,
	      touchHandled;

	  /**
	   * Simulate a mouse event based on a corresponding touch event
	   * @param {Object} event A touch event
	   * @param {String} simulatedType The corresponding mouse event
	   */
	  function simulateMouseEvent (event, simulatedType) {

	    // Ignore multi-touch events
	    if (event.originalEvent.touches.length > 1) {
	      return;
	    }

	    event.preventDefault();

	    var touch = event.originalEvent.changedTouches[0],
	        simulatedEvent = document.createEvent('MouseEvents');
	    
	    // Initialize the simulated mouse event using the touch event's coordinates
	    simulatedEvent.initMouseEvent(
	      simulatedType,    // type
	      true,             // bubbles                    
	      true,             // cancelable                 
	      window,           // view                       
	      1,                // detail                     
	      touch.screenX,    // screenX                    
	      touch.screenY,    // screenY                    
	      touch.clientX,    // clientX                    
	      touch.clientY,    // clientY                    
	      false,            // ctrlKey                    
	      false,            // altKey                     
	      false,            // shiftKey                   
	      false,            // metaKey                    
	      0,                // button                     
	      null              // relatedTarget              
	    );

	    // Dispatch the simulated event to the target element
	    event.target.dispatchEvent(simulatedEvent);
	  }

	  /**
	   * Handle the jQuery UI widget's touchstart events
	   * @param {Object} event The widget element's touchstart event
	   */
	  mouseProto._touchStart = function (event) {

	    var self = this;

	    // Ignore the event if another widget is already being handled
	    if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
	      return;
	    }

	    // Set the flag to prevent other widgets from inheriting the touch event
	    touchHandled = true;

	    // Track movement to determine if interaction was a click
	    self._touchMoved = false;

	    // Simulate the mouseover event
	    simulateMouseEvent(event, 'mouseover');

	    // Simulate the mousemove event
	    simulateMouseEvent(event, 'mousemove');

	    // Simulate the mousedown event
	    simulateMouseEvent(event, 'mousedown');
	  };

	  /**
	   * Handle the jQuery UI widget's touchmove events
	   * @param {Object} event The document's touchmove event
	   */
	  mouseProto._touchMove = function (event) {

	    // Ignore event if not handled
	    if (!touchHandled) {
	      return;
	    }

	    // Interaction was not a click
	    this._touchMoved = true;

	    // Simulate the mousemove event
	    simulateMouseEvent(event, 'mousemove');
	  };

	  /**
	   * Handle the jQuery UI widget's touchend events
	   * @param {Object} event The document's touchend event
	   */
	  mouseProto._touchEnd = function (event) {

	    // Ignore event if not handled
	    if (!touchHandled) {
	      return;
	    }

	    // Simulate the mouseup event
	    simulateMouseEvent(event, 'mouseup');

	    // Simulate the mouseout event
	    simulateMouseEvent(event, 'mouseout');

	    // If the touch interaction did not move, it should trigger a click
	    if (!this._touchMoved) {

	      // Simulate the click event
	      simulateMouseEvent(event, 'click');
	    }

	    // Unset the flag to allow other widgets to inherit the touch event
	    touchHandled = false;
	  };

	  /**
	   * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
	   * This method extends the widget with bound touch event handlers that
	   * translate touch events to mouse events and pass them to the widget's
	   * original mouse event handling methods.
	   */
	  mouseProto._mouseInit = function () {
	    
	    var self = this;

	    // Delegate the touch handlers to the widget's element
	    self.element.bind({
	      touchstart: $.proxy(self, '_touchStart'),
	      touchmove: $.proxy(self, '_touchMove'),
	      touchend: $.proxy(self, '_touchEnd')
	    });

	    // Call the original $.ui.mouse init method
	    _mouseInit.call(self);
	  };

	  /**
	   * Remove the touch event handlers
	   */
	  mouseProto._mouseDestroy = function () {
	    
	    var self = this;

	    // Delegate the touch handlers to the widget's element
	    self.element.unbind({
	      touchstart: $.proxy(self, '_touchStart'),
	      touchmove: $.proxy(self, '_touchMove'),
	      touchend: $.proxy(self, '_touchEnd')
	    });

	    // Call the original $.ui.mouse destroy method
	    _mouseDestroy.call(self);
	  };

	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*! jQuery UI - v1.10.4 - 2014-05-30
	* http://jqueryui.com
	* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.draggable.js, jquery.ui.droppable.js, jquery.ui.slider.js
	* Copyright 2014 jQuery Foundation and other contributors; Licensed MIT */

	(function( $, undefined ) {

	var uuid = 0,
	  runiqueId = /^ui-id-\d+$/;

	// $.ui might exist from components with no dependencies, e.g., $.ui.position
	$.ui = $.ui || {};

	$.extend( $.ui, {
	  version: "1.10.4",

	  keyCode: {
	    BACKSPACE: 8,
	    COMMA: 188,
	    DELETE: 46,
	    DOWN: 40,
	    END: 35,
	    ENTER: 13,
	    ESCAPE: 27,
	    HOME: 36,
	    LEFT: 37,
	    NUMPAD_ADD: 107,
	    NUMPAD_DECIMAL: 110,
	    NUMPAD_DIVIDE: 111,
	    NUMPAD_ENTER: 108,
	    NUMPAD_MULTIPLY: 106,
	    NUMPAD_SUBTRACT: 109,
	    PAGE_DOWN: 34,
	    PAGE_UP: 33,
	    PERIOD: 190,
	    RIGHT: 39,
	    SPACE: 32,
	    TAB: 9,
	    UP: 38
	  }
	});

	// plugins
	$.fn.extend({
	  focus: (function( orig ) {
	    return function( delay, fn ) {
	      return typeof delay === "number" ?
	        this.each(function() {
	          var elem = this;
	          setTimeout(function() {
	            $( elem ).focus();
	            if ( fn ) {
	              fn.call( elem );
	            }
	          }, delay );
	        }) :
	        orig.apply( this, arguments );
	    };
	  })( $.fn.focus ),

	  scrollParent: function() {
	    var scrollParent;
	    if (($.ui.ie && (/(static|relative)/).test(this.css("position"))) || (/absolute/).test(this.css("position"))) {
	      scrollParent = this.parents().filter(function() {
	        return (/(relative|absolute|fixed)/).test($.css(this,"position")) && (/(auto|scroll)/).test($.css(this,"overflow")+$.css(this,"overflow-y")+$.css(this,"overflow-x"));
	      }).eq(0);
	    } else {
	      scrollParent = this.parents().filter(function() {
	        return (/(auto|scroll)/).test($.css(this,"overflow")+$.css(this,"overflow-y")+$.css(this,"overflow-x"));
	      }).eq(0);
	    }

	    return (/fixed/).test(this.css("position")) || !scrollParent.length ? $(document) : scrollParent;
	  },

	  zIndex: function( zIndex ) {
	    if ( zIndex !== undefined ) {
	      return this.css( "zIndex", zIndex );
	    }

	    if ( this.length ) {
	      var elem = $( this[ 0 ] ), position, value;
	      while ( elem.length && elem[ 0 ] !== document ) {
	        // Ignore z-index if position is set to a value where z-index is ignored by the browser
	        // This makes behavior of this function consistent across browsers
	        // WebKit always returns auto if the element is positioned
	        position = elem.css( "position" );
	        if ( position === "absolute" || position === "relative" || position === "fixed" ) {
	          // IE returns 0 when zIndex is not specified
	          // other browsers return a string
	          // we ignore the case of nested elements with an explicit value of 0
	          // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
	          value = parseInt( elem.css( "zIndex" ), 10 );
	          if ( !isNaN( value ) && value !== 0 ) {
	            return value;
	          }
	        }
	        elem = elem.parent();
	      }
	    }

	    return 0;
	  },

	  uniqueId: function() {
	    return this.each(function() {
	      if ( !this.id ) {
	        this.id = "ui-id-" + (++uuid);
	      }
	    });
	  },

	  removeUniqueId: function() {
	    return this.each(function() {
	      if ( runiqueId.test( this.id ) ) {
	        $( this ).removeAttr( "id" );
	      }
	    });
	  }
	});

	// selectors
	function focusable( element, isTabIndexNotNaN ) {
	  var map, mapName, img,
	    nodeName = element.nodeName.toLowerCase();
	  if ( "area" === nodeName ) {
	    map = element.parentNode;
	    mapName = map.name;
	    if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
	      return false;
	    }
	    img = $( "img[usemap=#" + mapName + "]" )[0];
	    return !!img && visible( img );
	  }
	  return ( /input|select|textarea|button|object/.test( nodeName ) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) &&
	    // the element and all of its ancestors must be visible
	    visible( element );
	}

	function visible( element ) {
	  return $.expr.filters.visible( element ) &&
	    !$( element ).parents().addBack().filter(function() {
	      return $.css( this, "visibility" ) === "hidden";
	    }).length;
	}

	$.extend( $.expr[ ":" ], {
	  data: $.expr.createPseudo ?
	    $.expr.createPseudo(function( dataName ) {
	      return function( elem ) {
	        return !!$.data( elem, dataName );
	      };
	    }) :
	    // support: jQuery <1.8
	    function( elem, i, match ) {
	      return !!$.data( elem, match[ 3 ] );
	    },

	  focusable: function( element ) {
	    return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	  },

	  tabbable: function( element ) {
	    var tabIndex = $.attr( element, "tabindex" ),
	      isTabIndexNaN = isNaN( tabIndex );
	    return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	  }
	});

	// support: jQuery <1.8
	if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
	  $.each( [ "Width", "Height" ], function( i, name ) {
	    var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
	      type = name.toLowerCase(),
	      orig = {
	        innerWidth: $.fn.innerWidth,
	        innerHeight: $.fn.innerHeight,
	        outerWidth: $.fn.outerWidth,
	        outerHeight: $.fn.outerHeight
	      };

	    function reduce( elem, size, border, margin ) {
	      $.each( side, function() {
	        size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
	        if ( border ) {
	          size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
	        }
	        if ( margin ) {
	          size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
	        }
	      });
	      return size;
	    }

	    $.fn[ "inner" + name ] = function( size ) {
	      if ( size === undefined ) {
	        return orig[ "inner" + name ].call( this );
	      }

	      return this.each(function() {
	        $( this ).css( type, reduce( this, size ) + "px" );
	      });
	    };

	    $.fn[ "outer" + name] = function( size, margin ) {
	      if ( typeof size !== "number" ) {
	        return orig[ "outer" + name ].call( this, size );
	      }

	      return this.each(function() {
	        $( this).css( type, reduce( this, size, true, margin ) + "px" );
	      });
	    };
	  });
	}

	// support: jQuery <1.8
	if ( !$.fn.addBack ) {
	  $.fn.addBack = function( selector ) {
	    return this.add( selector == null ?
	      this.prevObject : this.prevObject.filter( selector )
	    );
	  };
	}

	// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
	if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
	  $.fn.removeData = (function( removeData ) {
	    return function( key ) {
	      if ( arguments.length ) {
	        return removeData.call( this, $.camelCase( key ) );
	      } else {
	        return removeData.call( this );
	      }
	    };
	  })( $.fn.removeData );
	}





	// deprecated
	$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

	$.support.selectstart = "onselectstart" in document.createElement( "div" );
	$.fn.extend({
	  disableSelection: function() {
	    return this.bind( ( $.support.selectstart ? "selectstart" : "mousedown" ) +
	      ".ui-disableSelection", function( event ) {
	        event.preventDefault();
	      });
	  },

	  enableSelection: function() {
	    return this.unbind( ".ui-disableSelection" );
	  }
	});

	$.extend( $.ui, {
	  // $.ui.plugin is deprecated. Use $.widget() extensions instead.
	  plugin: {
	    add: function( module, option, set ) {
	      var i,
	        proto = $.ui[ module ].prototype;
	      for ( i in set ) {
	        proto.plugins[ i ] = proto.plugins[ i ] || [];
	        proto.plugins[ i ].push( [ option, set[ i ] ] );
	      }
	    },
	    call: function( instance, name, args ) {
	      var i,
	        set = instance.plugins[ name ];
	      if ( !set || !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) {
	        return;
	      }

	      for ( i = 0; i < set.length; i++ ) {
	        if ( instance.options[ set[ i ][ 0 ] ] ) {
	          set[ i ][ 1 ].apply( instance.element, args );
	        }
	      }
	    }
	  },

	  // only used by resizable
	  hasScroll: function( el, a ) {

	    //If overflow is hidden, the element might have extra content, but the user wants to hide it
	    if ( $( el ).css( "overflow" ) === "hidden") {
	      return false;
	    }

	    var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
	      has = false;

	    if ( el[ scroll ] > 0 ) {
	      return true;
	    }

	    // TODO: determine which cases actually cause this to happen
	    // if the element doesn't have the scroll set, see if it's possible to
	    // set the scroll
	    el[ scroll ] = 1;
	    has = ( el[ scroll ] > 0 );
	    el[ scroll ] = 0;
	    return has;
	  }
	});

	})( jQuery );
	(function( $, undefined ) {

	var uuid = 0,
	  slice = Array.prototype.slice,
	  _cleanData = $.cleanData;
	$.cleanData = function( elems ) {
	  for ( var i = 0, elem; (elem = elems[i]) != null; i++ ) {
	    try {
	      $( elem ).triggerHandler( "remove" );
	    // http://bugs.jquery.com/ticket/8235
	    } catch( e ) {}
	  }
	  _cleanData( elems );
	};

	$.widget = function( name, base, prototype ) {
	  var fullName, existingConstructor, constructor, basePrototype,
	    // proxiedPrototype allows the provided prototype to remain unmodified
	    // so that it can be used as a mixin for multiple widgets (#8876)
	    proxiedPrototype = {},
	    namespace = name.split( "." )[ 0 ];

	  name = name.split( "." )[ 1 ];
	  fullName = namespace + "-" + name;

	  if ( !prototype ) {
	    prototype = base;
	    base = $.Widget;
	  }

	  // create selector for plugin
	  $.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
	    return !!$.data( elem, fullName );
	  };

	  $[ namespace ] = $[ namespace ] || {};
	  existingConstructor = $[ namespace ][ name ];
	  constructor = $[ namespace ][ name ] = function( options, element ) {
	    // allow instantiation without "new" keyword
	    if ( !this._createWidget ) {
	      return new constructor( options, element );
	    }

	    // allow instantiation without initializing for simple inheritance
	    // must use "new" keyword (the code above always passes args)
	    if ( arguments.length ) {
	      this._createWidget( options, element );
	    }
	  };
	  // extend with the existing constructor to carry over any static properties
	  $.extend( constructor, existingConstructor, {
	    version: prototype.version,
	    // copy the object used to create the prototype in case we need to
	    // redefine the widget later
	    _proto: $.extend( {}, prototype ),
	    // track widgets that inherit from this widget in case this widget is
	    // redefined after a widget inherits from it
	    _childConstructors: []
	  });

	  basePrototype = new base();
	  // we need to make the options hash a property directly on the new instance
	  // otherwise we'll modify the options hash on the prototype that we're
	  // inheriting from
	  basePrototype.options = $.widget.extend( {}, basePrototype.options );
	  $.each( prototype, function( prop, value ) {
	    if ( !$.isFunction( value ) ) {
	      proxiedPrototype[ prop ] = value;
	      return;
	    }
	    proxiedPrototype[ prop ] = (function() {
	      var _super = function() {
	          return base.prototype[ prop ].apply( this, arguments );
	        },
	        _superApply = function( args ) {
	          return base.prototype[ prop ].apply( this, args );
	        };
	      return function() {
	        var __super = this._super,
	          __superApply = this._superApply,
	          returnValue;

	        this._super = _super;
	        this._superApply = _superApply;

	        returnValue = value.apply( this, arguments );

	        this._super = __super;
	        this._superApply = __superApply;

	        return returnValue;
	      };
	    })();
	  });
	  constructor.prototype = $.widget.extend( basePrototype, {
	    // TODO: remove support for widgetEventPrefix
	    // always use the name + a colon as the prefix, e.g., draggable:start
	    // don't prefix for widgets that aren't DOM-based
	    widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
	  }, proxiedPrototype, {
	    constructor: constructor,
	    namespace: namespace,
	    widgetName: name,
	    widgetFullName: fullName
	  });

	  // If this widget is being redefined then we need to find all widgets that
	  // are inheriting from it and redefine all of them so that they inherit from
	  // the new version of this widget. We're essentially trying to replace one
	  // level in the prototype chain.
	  if ( existingConstructor ) {
	    $.each( existingConstructor._childConstructors, function( i, child ) {
	      var childPrototype = child.prototype;

	      // redefine the child widget using the same prototype that was
	      // originally used, but inherit from the new version of the base
	      $.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
	    });
	    // remove the list of existing child constructors from the old constructor
	    // so the old child constructors can be garbage collected
	    delete existingConstructor._childConstructors;
	  } else {
	    base._childConstructors.push( constructor );
	  }

	  $.widget.bridge( name, constructor );
	};

	$.widget.extend = function( target ) {
	  var input = slice.call( arguments, 1 ),
	    inputIndex = 0,
	    inputLength = input.length,
	    key,
	    value;
	  for ( ; inputIndex < inputLength; inputIndex++ ) {
	    for ( key in input[ inputIndex ] ) {
	      value = input[ inputIndex ][ key ];
	      if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	        // Clone objects
	        if ( $.isPlainObject( value ) ) {
	          target[ key ] = $.isPlainObject( target[ key ] ) ?
	            $.widget.extend( {}, target[ key ], value ) :
	            // Don't extend strings, arrays, etc. with objects
	            $.widget.extend( {}, value );
	        // Copy everything else by reference
	        } else {
	          target[ key ] = value;
	        }
	      }
	    }
	  }
	  return target;
	};

	$.widget.bridge = function( name, object ) {
	  var fullName = object.prototype.widgetFullName || name;
	  $.fn[ name ] = function( options ) {
	    var isMethodCall = typeof options === "string",
	      args = slice.call( arguments, 1 ),
	      returnValue = this;

	    // allow multiple hashes to be passed on init
	    options = !isMethodCall && args.length ?
	      $.widget.extend.apply( null, [ options ].concat(args) ) :
	      options;

	    if ( isMethodCall ) {
	      this.each(function() {
	        var methodValue,
	          instance = $.data( this, fullName );
	        if ( !instance ) {
	          return $.error( "cannot call methods on " + name + " prior to initialization; " +
	            "attempted to call method '" + options + "'" );
	        }
	        if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
	          return $.error( "no such method '" + options + "' for " + name + " widget instance" );
	        }
	        methodValue = instance[ options ].apply( instance, args );
	        if ( methodValue !== instance && methodValue !== undefined ) {
	          returnValue = methodValue && methodValue.jquery ?
	            returnValue.pushStack( methodValue.get() ) :
	            methodValue;
	          return false;
	        }
	      });
	    } else {
	      this.each(function() {
	        var instance = $.data( this, fullName );
	        if ( instance ) {
	          instance.option( options || {} )._init();
	        } else {
	          $.data( this, fullName, new object( options, this ) );
	        }
	      });
	    }

	    return returnValue;
	  };
	};

	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];

	$.Widget.prototype = {
	  widgetName: "widget",
	  widgetEventPrefix: "",
	  defaultElement: "<div>",
	  options: {
	    disabled: false,

	    // callbacks
	    create: null
	  },
	  _createWidget: function( options, element ) {
	    element = $( element || this.defaultElement || this )[ 0 ];
	    this.element = $( element );
	    this.uuid = uuid++;
	    this.eventNamespace = "." + this.widgetName + this.uuid;
	    this.options = $.widget.extend( {},
	      this.options,
	      this._getCreateOptions(),
	      options );

	    this.bindings = $();
	    this.hoverable = $();
	    this.focusable = $();

	    if ( element !== this ) {
	      $.data( element, this.widgetFullName, this );
	      this._on( true, this.element, {
	        remove: function( event ) {
	          if ( event.target === element ) {
	            this.destroy();
	          }
	        }
	      });
	      this.document = $( element.style ?
	        // element within the document
	        element.ownerDocument :
	        // element is window or document
	        element.document || element );
	      this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
	    }

	    this._create();
	    this._trigger( "create", null, this._getCreateEventData() );
	    this._init();
	  },
	  _getCreateOptions: $.noop,
	  _getCreateEventData: $.noop,
	  _create: $.noop,
	  _init: $.noop,

	  destroy: function() {
	    this._destroy();
	    // we can probably remove the unbind calls in 2.0
	    // all event bindings should go through this._on()
	    this.element
	      .unbind( this.eventNamespace )
	      // 1.9 BC for #7810
	      // TODO remove dual storage
	      .removeData( this.widgetName )
	      .removeData( this.widgetFullName )
	      // support: jquery <1.6.3
	      // http://bugs.jquery.com/ticket/9413
	      .removeData( $.camelCase( this.widgetFullName ) );
	    this.widget()
	      .unbind( this.eventNamespace )
	      .removeAttr( "aria-disabled" )
	      .removeClass(
	        this.widgetFullName + "-disabled " +
	        "ui-state-disabled" );

	    // clean up events and states
	    this.bindings.unbind( this.eventNamespace );
	    this.hoverable.removeClass( "ui-state-hover" );
	    this.focusable.removeClass( "ui-state-focus" );
	  },
	  _destroy: $.noop,

	  widget: function() {
	    return this.element;
	  },

	  option: function( key, value ) {
	    var options = key,
	      parts,
	      curOption,
	      i;

	    if ( arguments.length === 0 ) {
	      // don't return a reference to the internal hash
	      return $.widget.extend( {}, this.options );
	    }

	    if ( typeof key === "string" ) {
	      // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
	      options = {};
	      parts = key.split( "." );
	      key = parts.shift();
	      if ( parts.length ) {
	        curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
	        for ( i = 0; i < parts.length - 1; i++ ) {
	          curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
	          curOption = curOption[ parts[ i ] ];
	        }
	        key = parts.pop();
	        if ( arguments.length === 1 ) {
	          return curOption[ key ] === undefined ? null : curOption[ key ];
	        }
	        curOption[ key ] = value;
	      } else {
	        if ( arguments.length === 1 ) {
	          return this.options[ key ] === undefined ? null : this.options[ key ];
	        }
	        options[ key ] = value;
	      }
	    }

	    this._setOptions( options );

	    return this;
	  },
	  _setOptions: function( options ) {
	    var key;

	    for ( key in options ) {
	      this._setOption( key, options[ key ] );
	    }

	    return this;
	  },
	  _setOption: function( key, value ) {
	    this.options[ key ] = value;

	    if ( key === "disabled" ) {
	      this.widget()
	        .toggleClass( this.widgetFullName + "-disabled ui-state-disabled", !!value )
	        .attr( "aria-disabled", value );
	      this.hoverable.removeClass( "ui-state-hover" );
	      this.focusable.removeClass( "ui-state-focus" );
	    }

	    return this;
	  },

	  enable: function() {
	    return this._setOption( "disabled", false );
	  },
	  disable: function() {
	    return this._setOption( "disabled", true );
	  },

	  _on: function( suppressDisabledCheck, element, handlers ) {
	    var delegateElement,
	      instance = this;

	    // no suppressDisabledCheck flag, shuffle arguments
	    if ( typeof suppressDisabledCheck !== "boolean" ) {
	      handlers = element;
	      element = suppressDisabledCheck;
	      suppressDisabledCheck = false;
	    }

	    // no element argument, shuffle and use this.element
	    if ( !handlers ) {
	      handlers = element;
	      element = this.element;
	      delegateElement = this.widget();
	    } else {
	      // accept selectors, DOM elements
	      element = delegateElement = $( element );
	      this.bindings = this.bindings.add( element );
	    }

	    $.each( handlers, function( event, handler ) {
	      function handlerProxy() {
	        // allow widgets to customize the disabled handling
	        // - disabled as an array instead of boolean
	        // - disabled class as method for disabling individual parts
	        if ( !suppressDisabledCheck &&
	            ( instance.options.disabled === true ||
	              $( this ).hasClass( "ui-state-disabled" ) ) ) {
	          return;
	        }
	        return ( typeof handler === "string" ? instance[ handler ] : handler )
	          .apply( instance, arguments );
	      }

	      // copy the guid so direct unbinding works
	      if ( typeof handler !== "string" ) {
	        handlerProxy.guid = handler.guid =
	          handler.guid || handlerProxy.guid || $.guid++;
	      }

	      var match = event.match( /^(\w+)\s*(.*)$/ ),
	        eventName = match[1] + instance.eventNamespace,
	        selector = match[2];
	      if ( selector ) {
	        delegateElement.delegate( selector, eventName, handlerProxy );
	      } else {
	        element.bind( eventName, handlerProxy );
	      }
	    });
	  },

	  _off: function( element, eventName ) {
	    eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) + this.eventNamespace;
	    element.unbind( eventName ).undelegate( eventName );
	  },

	  _delay: function( handler, delay ) {
	    function handlerProxy() {
	      return ( typeof handler === "string" ? instance[ handler ] : handler )
	        .apply( instance, arguments );
	    }
	    var instance = this;
	    return setTimeout( handlerProxy, delay || 0 );
	  },

	  _hoverable: function( element ) {
	    this.hoverable = this.hoverable.add( element );
	    this._on( element, {
	      mouseenter: function( event ) {
	        $( event.currentTarget ).addClass( "ui-state-hover" );
	      },
	      mouseleave: function( event ) {
	        $( event.currentTarget ).removeClass( "ui-state-hover" );
	      }
	    });
	  },

	  _focusable: function( element ) {
	    this.focusable = this.focusable.add( element );
	    this._on( element, {
	      focusin: function( event ) {
	        $( event.currentTarget ).addClass( "ui-state-focus" );
	      },
	      focusout: function( event ) {
	        $( event.currentTarget ).removeClass( "ui-state-focus" );
	      }
	    });
	  },

	  _trigger: function( type, event, data ) {
	    var prop, orig,
	      callback = this.options[ type ];

	    data = data || {};
	    event = $.Event( event );
	    event.type = ( type === this.widgetEventPrefix ?
	      type :
	      this.widgetEventPrefix + type ).toLowerCase();
	    // the original event may come from any element
	    // so we need to reset the target on the new event
	    event.target = this.element[ 0 ];

	    // copy original event properties over to the new event
	    orig = event.originalEvent;
	    if ( orig ) {
	      for ( prop in orig ) {
	        if ( !( prop in event ) ) {
	          event[ prop ] = orig[ prop ];
	        }
	      }
	    }

	    this.element.trigger( event, data );
	    return !( $.isFunction( callback ) &&
	      callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
	      event.isDefaultPrevented() );
	  }
	};

	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	  $.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
	    if ( typeof options === "string" ) {
	      options = { effect: options };
	    }
	    var hasOptions,
	      effectName = !options ?
	        method :
	        options === true || typeof options === "number" ?
	          defaultEffect :
	          options.effect || defaultEffect;
	    options = options || {};
	    if ( typeof options === "number" ) {
	      options = { duration: options };
	    }
	    hasOptions = !$.isEmptyObject( options );
	    options.complete = callback;
	    if ( options.delay ) {
	      element.delay( options.delay );
	    }
	    if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
	      element[ method ]( options );
	    } else if ( effectName !== method && element[ effectName ] ) {
	      element[ effectName ]( options.duration, options.easing, callback );
	    } else {
	      element.queue(function( next ) {
	        $( this )[ method ]();
	        if ( callback ) {
	          callback.call( element[ 0 ] );
	        }
	        next();
	      });
	    }
	  };
	});

	})( jQuery );
	(function( $, undefined ) {

	var mouseHandled = false;
	$( document ).mouseup( function() {
	  mouseHandled = false;
	});

	$.widget("ui.mouse", {
	  version: "1.10.4",
	  options: {
	    cancel: "input,textarea,button,select,option",
	    distance: 1,
	    delay: 0
	  },
	  _mouseInit: function() {
	    var that = this;

	    this.element
	      .bind("mousedown."+this.widgetName, function(event) {
	        return that._mouseDown(event);
	      })
	      .bind("click."+this.widgetName, function(event) {
	        if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
	          $.removeData(event.target, that.widgetName + ".preventClickEvent");

	          //TRAVIS: HACK TO ALLOW CLICK ON SLIDER HANDLE TO TOGGLESTATE
	          if(!that._mouseDistanceMet(event)){
	            return true;
	          } else {
	            event.stopImmediatePropagation();
	            return false;
	          }
	          // /hack
	        }
	      });

	    this.started = false;
	  },

	  // TODO: make sure destroying one instance of mouse doesn't mess with
	  // other instances of mouse
	  _mouseDestroy: function() {
	    this.element.unbind("."+this.widgetName);
	    if ( this._mouseMoveDelegate ) {
	      $(document)
	        .unbind("mousemove."+this.widgetName, this._mouseMoveDelegate)
	        .unbind("mouseup."+this.widgetName, this._mouseUpDelegate);
	    }
	  },

	  _mouseDown: function(event) {
	    // don't let more than one widget handle mouseStart
	    if( mouseHandled ) { return; }

	    // we may have missed mouseup (out of window)
	    (this._mouseStarted && this._mouseUp(event));

	    this._mouseDownEvent = event;

	    var that = this,
	      btnIsLeft = (event.which === 1),
	      // event.target.nodeName works around a bug in IE 8 with
	      // disabled inputs (#7620)
	      elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
	    if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
	      return true;
	    }

	    this.mouseDelayMet = !this.options.delay;
	    if (!this.mouseDelayMet) {
	      this._mouseDelayTimer = setTimeout(function() {
	        that.mouseDelayMet = true;
	      }, this.options.delay);
	    }

	    if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
	      this._mouseStarted = (this._mouseStart(event) !== false);
	      if (!this._mouseStarted) {
	        event.preventDefault();
	        return true;
	      }
	    }

	    // Click event may never have fired (Gecko & Opera)
	    if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
	      $.removeData(event.target, this.widgetName + ".preventClickEvent");
	    }

	    // these delegates are required to keep context
	    this._mouseMoveDelegate = function(event) {
	      return that._mouseMove(event);
	    };
	    this._mouseUpDelegate = function(event) {
	      return that._mouseUp(event);
	    };
	    $(document)
	      .bind("mousemove."+this.widgetName, this._mouseMoveDelegate)
	      .bind("mouseup."+this.widgetName, this._mouseUpDelegate);

	    event.preventDefault();

	    mouseHandled = true;
	    return true;
	  },

	  _mouseMove: function(event) {
	    // IE mouseup check - mouseup happened when mouse was out of window
	    if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
	      return this._mouseUp(event);
	    }

	    if (this._mouseStarted) {
	      this._mouseDrag(event);
	      return event.preventDefault();
	    }

	    if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
	      this._mouseStarted =
	        (this._mouseStart(this._mouseDownEvent, event) !== false);
	      (this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
	    }

	    return !this._mouseStarted;
	  },

	  _mouseUp: function(event) {
	    $(document)
	      .unbind("mousemove."+this.widgetName, this._mouseMoveDelegate)
	      .unbind("mouseup."+this.widgetName, this._mouseUpDelegate);

	    if (this._mouseStarted) {
	      this._mouseStarted = false;

	      if (event.target === this._mouseDownEvent.target) {
	        $.data(event.target, this.widgetName + ".preventClickEvent", true);
	      }

	      this._mouseStop(event);
	    }

	    return false;
	  },

	  _mouseDistanceMet: function(event) {
	    return (Math.max(
	        Math.abs(this._mouseDownEvent.pageX - event.pageX),
	        Math.abs(this._mouseDownEvent.pageY - event.pageY)
	      ) >= this.options.distance
	    );
	  },

	  _mouseDelayMet: function(/* event */) {
	    return this.mouseDelayMet;
	  },

	  // These are placeholder methods, to be overriden by extending plugin
	  _mouseStart: function(/* event */) {},
	  _mouseDrag: function(/* event */) {},
	  _mouseStop: function(/* event */) {},
	  _mouseCapture: function(/* event */) { return true; }
	});

	})(jQuery);
	(function( $, undefined ) {

	$.widget("ui.draggable", $.ui.mouse, {
	  version: "1.10.4",
	  widgetEventPrefix: "drag",
	  options: {
	    addClasses: true,
	    appendTo: "parent",
	    axis: false,
	    connectToSortable: false,
	    containment: false,
	    cursor: "auto",
	    cursorAt: false,
	    grid: false,
	    handle: false,
	    helper: "original",
	    iframeFix: false,
	    opacity: false,
	    refreshPositions: false,
	    revert: false,
	    revertDuration: 500,
	    scope: "default",
	    scroll: true,
	    scrollSensitivity: 20,
	    scrollSpeed: 20,
	    snap: false,
	    snapMode: "both",
	    snapTolerance: 20,
	    stack: false,
	    zIndex: false,

	    // callbacks
	    drag: null,
	    start: null,
	    stop: null
	  },
	  _create: function() {

	    if (this.options.helper === "original" && !(/^(?:r|a|f)/).test(this.element.css("position"))) {
	      this.element[0].style.position = "relative";
	    }
	    if (this.options.addClasses){
	      this.element.addClass("ui-draggable");
	    }
	    if (this.options.disabled){
	      this.element.addClass("ui-draggable-disabled");
	    }

	    this._mouseInit();

	  },

	  _destroy: function() {
	    this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
	    this._mouseDestroy();
	  },

	  _mouseCapture: function(event) {

	    var o = this.options;

	    // among others, prevent a drag on a resizable-handle
	    if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
	      return false;
	    }

	    //Quit if we're not on a valid handle
	    this.handle = this._getHandle(event);
	    if (!this.handle) {
	      return false;
	    }

	    $(o.iframeFix === true ? "iframe" : o.iframeFix).each(function() {
	      $("<div class='ui-draggable-iframeFix' style='background: #fff;'></div>")
	      .css({
	        width: this.offsetWidth+"px", height: this.offsetHeight+"px",
	        position: "absolute", opacity: "0.001", zIndex: 1000
	      })
	      .css($(this).offset())
	      .appendTo("body");
	    });

	    return true;

	  },

	  _mouseStart: function(event) {

	    var o = this.options;

	    //Create and append the visible helper
	    this.helper = this._createHelper(event);

	    this.helper.addClass("ui-draggable-dragging");

	    //Cache the helper size
	    this._cacheHelperProportions();

	    //If ddmanager is used for droppables, set the global draggable
	    if($.ui.ddmanager) {
	      $.ui.ddmanager.current = this;
	    }

	    /*
	     * - Position generation -
	     * This block generates everything position related - it's the core of draggables.
	     */

	    //Cache the margins of the original element
	    this._cacheMargins();

	    //Store the helper's css position
	    this.cssPosition = this.helper.css( "position" );
	    this.scrollParent = this.helper.scrollParent();
	    this.offsetParent = this.helper.offsetParent();
	    this.offsetParentCssPosition = this.offsetParent.css( "position" );

	    //The element's absolute position on the page minus margins
	    this.offset = this.positionAbs = this.element.offset();
	    this.offset = {
	      top: this.offset.top - this.margins.top,
	      left: this.offset.left - this.margins.left
	    };

	    //Reset scroll cache
	    this.offset.scroll = false;

	    $.extend(this.offset, {
	      click: { //Where the click happened, relative to the element
	        left: event.pageX - this.offset.left,
	        top: event.pageY - this.offset.top
	      },
	      parent: this._getParentOffset(),
	      relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
	    });

	    //Generate the original position
	    this.originalPosition = this.position = this._generatePosition(event);
	    this.originalPageX = event.pageX;
	    this.originalPageY = event.pageY;

	    //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
	    (o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

	    //Set a containment if given in the options
	    this._setContainment();

	    //Trigger event + callbacks
	    if(this._trigger("start", event) === false) {
	      this._clear();
	      return false;
	    }

	    //Recache the helper size
	    this._cacheHelperProportions();

	    //Prepare the droppable offsets
	    if ($.ui.ddmanager && !o.dropBehaviour) {
	      $.ui.ddmanager.prepareOffsets(this, event);
	    }


	    this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

	    //If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
	    if ( $.ui.ddmanager ) {
	      $.ui.ddmanager.dragStart(this, event);
	    }

	    return true;
	  },

	  _mouseDrag: function(event, noPropagation) {
	    // reset any necessary cached properties (see #5009)
	    if ( this.offsetParentCssPosition === "fixed" ) {
	      this.offset.parent = this._getParentOffset();
	    }

	    //Compute the helpers position
	    this.position = this._generatePosition(event);
	    this.positionAbs = this._convertPositionTo("absolute");

	    //Call plugins and callbacks and use the resulting position if something is returned
	    if (!noPropagation) {
	      var ui = this._uiHash();
	      if(this._trigger("drag", event, ui) === false) {
	        this._mouseUp({});
	        return false;
	      }
	      this.position = ui.position;
	    }

	    if(!this.options.axis || this.options.axis !== "y") {
	      this.helper[0].style.left = this.position.left+"px";
	    }
	    if(!this.options.axis || this.options.axis !== "x") {
	      this.helper[0].style.top = this.position.top+"px";
	    }
	    if($.ui.ddmanager) {
	      $.ui.ddmanager.drag(this, event);
	    }

	    return false;
	  },

	  _mouseStop: function(event) {

	    //If we are using droppables, inform the manager about the drop
	    var that = this,
	      dropped = false;
	    if ($.ui.ddmanager && !this.options.dropBehaviour) {
	      dropped = $.ui.ddmanager.drop(this, event);
	    }

	    //if a drop comes from outside (a sortable)
	    if(this.dropped) {
	      dropped = this.dropped;
	      this.dropped = false;
	    }

	    //if the original element is no longer in the DOM don't bother to continue (see #8269)
	    if ( this.options.helper === "original" && !$.contains( this.element[ 0 ].ownerDocument, this.element[ 0 ] ) ) {
	      return false;
	    }

	    if((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
	      $(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
	        if(that._trigger("stop", event) !== false) {
	          that._clear();
	        }
	      });
	    } else {
	      if(this._trigger("stop", event) !== false) {
	        this._clear();
	      }
	    }

	    return false;
	  },

	  _mouseUp: function(event) {
	    //Remove frame helpers
	    $("div.ui-draggable-iframeFix").each(function() {
	      this.parentNode.removeChild(this);
	    });

	    //If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
	    if( $.ui.ddmanager ) {
	      $.ui.ddmanager.dragStop(this, event);
	    }

	    return $.ui.mouse.prototype._mouseUp.call(this, event);
	  },

	  cancel: function() {

	    if(this.helper.is(".ui-draggable-dragging")) {
	      this._mouseUp({});
	    } else {
	      this._clear();
	    }

	    return this;

	  },

	  _getHandle: function(event) {
	    return this.options.handle ?
	      !!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
	      true;
	  },

	  _createHelper: function(event) {

	    var o = this.options,
	      helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event])) : (o.helper === "clone" ? this.element.clone().removeAttr("id") : this.element);

	    if(!helper.parents("body").length) {
	      helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
	    }

	    if(helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
	      helper.css("position", "absolute");
	    }

	    return helper;

	  },

	  _adjustOffsetFromHelper: function(obj) {
	    if (typeof obj === "string") {
	      obj = obj.split(" ");
	    }
	    if ($.isArray(obj)) {
	      obj = {left: +obj[0], top: +obj[1] || 0};
	    }
	    if ("left" in obj) {
	      this.offset.click.left = obj.left + this.margins.left;
	    }
	    if ("right" in obj) {
	      this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
	    }
	    if ("top" in obj) {
	      this.offset.click.top = obj.top + this.margins.top;
	    }
	    if ("bottom" in obj) {
	      this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
	    }
	  },

	  _getParentOffset: function() {

	    //Get the offsetParent and cache its position
	    var po = this.offsetParent.offset();

	    // This is a special case where we need to modify a offset calculated on start, since the following happened:
	    // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
	    // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
	    //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
	    if(this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
	      po.left += this.scrollParent.scrollLeft();
	      po.top += this.scrollParent.scrollTop();
	    }

	    //This needs to be actually done for all browsers, since pageX/pageY includes this information
	    //Ugly IE fix
	    if((this.offsetParent[0] === document.body) ||
	      (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie)) {
	      po = { top: 0, left: 0 };
	    }

	    return {
	      top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
	      left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
	    };

	  },

	  _getRelativeOffset: function() {

	    if(this.cssPosition === "relative") {
	      var p = this.element.position();
	      return {
	        top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
	        left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
	      };
	    } else {
	      return { top: 0, left: 0 };
	    }

	  },

	  _cacheMargins: function() {
	    this.margins = {
	      left: (parseInt(this.element.css("marginLeft"),10) || 0),
	      top: (parseInt(this.element.css("marginTop"),10) || 0),
	      right: (parseInt(this.element.css("marginRight"),10) || 0),
	      bottom: (parseInt(this.element.css("marginBottom"),10) || 0)
	    };
	  },

	  _cacheHelperProportions: function() {
	    this.helperProportions = {
	      width: this.helper.outerWidth(),
	      height: this.helper.outerHeight()
	    };
	  },

	  _setContainment: function() {

	    var over, c, ce,
	      o = this.options;

	    if ( !o.containment ) {
	      this.containment = null;
	      return;
	    }

	    if ( o.containment === "window" ) {
	      this.containment = [
	        $( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
	        $( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
	        $( window ).scrollLeft() + $( window ).width() - this.helperProportions.width - this.margins.left,
	        $( window ).scrollTop() + ( $( window ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
	      ];
	      return;
	    }

	    if ( o.containment === "document") {
	      this.containment = [
	        0,
	        0,
	        $( document ).width() - this.helperProportions.width - this.margins.left,
	        ( $( document ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
	      ];
	      return;
	    }

	    if ( o.containment.constructor === Array ) {
	      this.containment = o.containment;
	      return;
	    }

	    if ( o.containment === "parent" ) {
	      o.containment = this.helper[ 0 ].parentNode;
	    }

	    c = $( o.containment );
	    ce = c[ 0 ];

	    if( !ce ) {
	      return;
	    }

	    over = c.css( "overflow" ) !== "hidden";

	    this.containment = [
	      ( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
	      ( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingTop" ), 10 ) || 0 ) ,
	      ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) - ( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) - ( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) - this.helperProportions.width - this.margins.left - this.margins.right,
	      ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) - ( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) - ( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) - this.helperProportions.height - this.margins.top  - this.margins.bottom
	    ];
	    this.relative_container = c;
	  },

	  _convertPositionTo: function(d, pos) {

	    if(!pos) {
	      pos = this.position;
	    }

	    var mod = d === "absolute" ? 1 : -1,
	      scroll = this.cssPosition === "absolute" && !( this.scrollParent[ 0 ] !== document && $.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ? this.offsetParent : this.scrollParent;

	    //Cache the scroll
	    if (!this.offset.scroll) {
	      this.offset.scroll = {top : scroll.scrollTop(), left : scroll.scrollLeft()};
	    }

	    return {
	      top: (
	        pos.top +                               // The absolute mouse position
	        this.offset.relative.top * mod +                    // Only for relative positioned nodes: Relative offset from element to offset parent
	        this.offset.parent.top * mod -                    // The offsetParent's offset without borders (offset + border)
	        ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : this.offset.scroll.top ) * mod )
	      ),
	      left: (
	        pos.left +                                // The absolute mouse position
	        this.offset.relative.left * mod +                   // Only for relative positioned nodes: Relative offset from element to offset parent
	        this.offset.parent.left * mod -                   // The offsetParent's offset without borders (offset + border)
	        ( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : this.offset.scroll.left ) * mod )
	      )
	    };

	  },

	  _generatePosition: function(event) {

	    var containment, co, top, left,
	      o = this.options,
	      scroll = this.cssPosition === "absolute" && !( this.scrollParent[ 0 ] !== document && $.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ? this.offsetParent : this.scrollParent,
	      pageX = event.pageX,
	      pageY = event.pageY;

	    //Cache the scroll
	    if (!this.offset.scroll) {
	      this.offset.scroll = {top : scroll.scrollTop(), left : scroll.scrollLeft()};
	    }

	    /*
	     * - Position constraining -
	     * Constrain the position to a mix of grid, containment.
	     */

	    // If we are not dragging yet, we won't check for options
	    if ( this.originalPosition ) {
	      if ( this.containment ) {
	        if ( this.relative_container ){
	          co = this.relative_container.offset();
	          containment = [
	            this.containment[ 0 ] + co.left,
	            this.containment[ 1 ] + co.top,
	            this.containment[ 2 ] + co.left,
	            this.containment[ 3 ] + co.top
	          ];
	        }
	        else {
	          containment = this.containment;
	        }

	        if(event.pageX - this.offset.click.left < containment[0]) {
	          pageX = containment[0] + this.offset.click.left;
	        }
	        if(event.pageY - this.offset.click.top < containment[1]) {
	          pageY = containment[1] + this.offset.click.top;
	        }
	        if(event.pageX - this.offset.click.left > containment[2]) {
	          pageX = containment[2] + this.offset.click.left;
	        }
	        if(event.pageY - this.offset.click.top > containment[3]) {
	          pageY = containment[3] + this.offset.click.top;
	        }
	      }

	      if(o.grid) {
	        //Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
	        top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
	        pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

	        left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
	        pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
	      }

	    }

	    return {
	      top: (
	        pageY -                                 // The absolute mouse position
	        this.offset.click.top -                       // Click offset (relative to the element)
	        this.offset.relative.top -                        // Only for relative positioned nodes: Relative offset from element to offset parent
	        this.offset.parent.top +                        // The offsetParent's offset without borders (offset + border)
	        ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : this.offset.scroll.top )
	      ),
	      left: (
	        pageX -                                 // The absolute mouse position
	        this.offset.click.left -                        // Click offset (relative to the element)
	        this.offset.relative.left -                       // Only for relative positioned nodes: Relative offset from element to offset parent
	        this.offset.parent.left +                       // The offsetParent's offset without borders (offset + border)
	        ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : this.offset.scroll.left )
	      )
	    };

	  },

	  _clear: function() {
	    this.helper.removeClass("ui-draggable-dragging");
	    if(this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
	      this.helper.remove();
	    }
	    this.helper = null;
	    this.cancelHelperRemoval = false;
	  },

	  // From now on bulk stuff - mainly helpers

	  _trigger: function(type, event, ui) {
	    ui = ui || this._uiHash();
	    $.ui.plugin.call(this, type, [event, ui]);
	    //The absolute position has to be recalculated after plugins
	    if(type === "drag") {
	      this.positionAbs = this._convertPositionTo("absolute");
	    }
	    return $.Widget.prototype._trigger.call(this, type, event, ui);
	  },

	  plugins: {},

	  _uiHash: function() {
	    return {
	      helper: this.helper,
	      position: this.position,
	      originalPosition: this.originalPosition,
	      offset: this.positionAbs
	    };
	  }

	});

	$.ui.plugin.add("draggable", "connectToSortable", {
	  start: function(event, ui) {

	    var inst = $(this).data("ui-draggable"), o = inst.options,
	      uiSortable = $.extend({}, ui, { item: inst.element });
	    inst.sortables = [];
	    $(o.connectToSortable).each(function() {
	      var sortable = $.data(this, "ui-sortable");
	      if (sortable && !sortable.options.disabled) {
	        inst.sortables.push({
	          instance: sortable,
	          shouldRevert: sortable.options.revert
	        });
	        sortable.refreshPositions();  // Call the sortable's refreshPositions at drag start to refresh the containerCache since the sortable container cache is used in drag and needs to be up to date (this will ensure it's initialised as well as being kept in step with any changes that might have happened on the page).
	        sortable._trigger("activate", event, uiSortable);
	      }
	    });

	  },
	  stop: function(event, ui) {

	    //If we are still over the sortable, we fake the stop event of the sortable, but also remove helper
	    var inst = $(this).data("ui-draggable"),
	      uiSortable = $.extend({}, ui, { item: inst.element });

	    $.each(inst.sortables, function() {
	      if(this.instance.isOver) {

	        this.instance.isOver = 0;

	        inst.cancelHelperRemoval = true; //Don't remove the helper in the draggable instance
	        this.instance.cancelHelperRemoval = false; //Remove it in the sortable instance (so sortable plugins like revert still work)

	        //The sortable revert is supported, and we have to set a temporary dropped variable on the draggable to support revert: "valid/invalid"
	        if(this.shouldRevert) {
	          this.instance.options.revert = this.shouldRevert;
	        }

	        //Trigger the stop of the sortable
	        this.instance._mouseStop(event);

	        this.instance.options.helper = this.instance.options._helper;

	        //If the helper has been the original item, restore properties in the sortable
	        if(inst.options.helper === "original") {
	          this.instance.currentItem.css({ top: "auto", left: "auto" });
	        }

	      } else {
	        this.instance.cancelHelperRemoval = false; //Remove the helper in the sortable instance
	        this.instance._trigger("deactivate", event, uiSortable);
	      }

	    });

	  },
	  drag: function(event, ui) {

	    var inst = $(this).data("ui-draggable"), that = this;

	    $.each(inst.sortables, function() {

	      var innermostIntersecting = false,
	        thisSortable = this;

	      //Copy over some variables to allow calling the sortable's native _intersectsWith
	      this.instance.positionAbs = inst.positionAbs;
	      this.instance.helperProportions = inst.helperProportions;
	      this.instance.offset.click = inst.offset.click;

	      if(this.instance._intersectsWith(this.instance.containerCache)) {
	        innermostIntersecting = true;
	        $.each(inst.sortables, function () {
	          this.instance.positionAbs = inst.positionAbs;
	          this.instance.helperProportions = inst.helperProportions;
	          this.instance.offset.click = inst.offset.click;
	          if (this !== thisSortable &&
	            this.instance._intersectsWith(this.instance.containerCache) &&
	            $.contains(thisSortable.instance.element[0], this.instance.element[0])
	          ) {
	            innermostIntersecting = false;
	          }
	          return innermostIntersecting;
	        });
	      }


	      if(innermostIntersecting) {
	        //If it intersects, we use a little isOver variable and set it once, so our move-in stuff gets fired only once
	        if(!this.instance.isOver) {

	          this.instance.isOver = 1;
	          //Now we fake the start of dragging for the sortable instance,
	          //by cloning the list group item, appending it to the sortable and using it as inst.currentItem
	          //We can then fire the start event of the sortable with our passed browser event, and our own helper (so it doesn't create a new one)
	          this.instance.currentItem = $(that).clone().removeAttr("id").appendTo(this.instance.element).data("ui-sortable-item", true);
	          this.instance.options._helper = this.instance.options.helper; //Store helper option to later restore it
	          this.instance.options.helper = function() { return ui.helper[0]; };

	          event.target = this.instance.currentItem[0];
	          this.instance._mouseCapture(event, true);
	          this.instance._mouseStart(event, true, true);

	          //Because the browser event is way off the new appended portlet, we modify a couple of variables to reflect the changes
	          this.instance.offset.click.top = inst.offset.click.top;
	          this.instance.offset.click.left = inst.offset.click.left;
	          this.instance.offset.parent.left -= inst.offset.parent.left - this.instance.offset.parent.left;
	          this.instance.offset.parent.top -= inst.offset.parent.top - this.instance.offset.parent.top;

	          inst._trigger("toSortable", event);
	          inst.dropped = this.instance.element; //draggable revert needs that
	          //hack so receive/update callbacks work (mostly)
	          inst.currentItem = inst.element;
	          this.instance.fromOutside = inst;

	        }

	        //Provided we did all the previous steps, we can fire the drag event of the sortable on every draggable drag, when it intersects with the sortable
	        if(this.instance.currentItem) {
	          this.instance._mouseDrag(event);
	        }

	      } else {

	        //If it doesn't intersect with the sortable, and it intersected before,
	        //we fake the drag stop of the sortable, but make sure it doesn't remove the helper by using cancelHelperRemoval
	        if(this.instance.isOver) {

	          this.instance.isOver = 0;
	          this.instance.cancelHelperRemoval = true;

	          //Prevent reverting on this forced stop
	          this.instance.options.revert = false;

	          // The out event needs to be triggered independently
	          this.instance._trigger("out", event, this.instance._uiHash(this.instance));

	          this.instance._mouseStop(event, true);
	          this.instance.options.helper = this.instance.options._helper;

	          //Now we remove our currentItem, the list group clone again, and the placeholder, and animate the helper back to it's original size
	          this.instance.currentItem.remove();
	          if(this.instance.placeholder) {
	            this.instance.placeholder.remove();
	          }

	          inst._trigger("fromSortable", event);
	          inst.dropped = false; //draggable revert needs that
	        }

	      }

	    });

	  }
	});

	$.ui.plugin.add("draggable", "cursor", {
	  start: function() {
	    var t = $("body"), o = $(this).data("ui-draggable").options;
	    if (t.css("cursor")) {
	      o._cursor = t.css("cursor");
	    }
	    t.css("cursor", o.cursor);
	  },
	  stop: function() {
	    var o = $(this).data("ui-draggable").options;
	    if (o._cursor) {
	      $("body").css("cursor", o._cursor);
	    }
	  }
	});

	$.ui.plugin.add("draggable", "opacity", {
	  start: function(event, ui) {
	    var t = $(ui.helper), o = $(this).data("ui-draggable").options;
	    if(t.css("opacity")) {
	      o._opacity = t.css("opacity");
	    }
	    t.css("opacity", o.opacity);
	  },
	  stop: function(event, ui) {
	    var o = $(this).data("ui-draggable").options;
	    if(o._opacity) {
	      $(ui.helper).css("opacity", o._opacity);
	    }
	  }
	});

	$.ui.plugin.add("draggable", "scroll", {
	  start: function() {
	    var i = $(this).data("ui-draggable");
	    if(i.scrollParent[0] !== document && i.scrollParent[0].tagName !== "HTML") {
	      i.overflowOffset = i.scrollParent.offset();
	    }
	  },
	  drag: function( event ) {

	    var i = $(this).data("ui-draggable"), o = i.options, scrolled = false;

	    if(i.scrollParent[0] !== document && i.scrollParent[0].tagName !== "HTML") {

	      if(!o.axis || o.axis !== "x") {
	        if((i.overflowOffset.top + i.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity) {
	          i.scrollParent[0].scrollTop = scrolled = i.scrollParent[0].scrollTop + o.scrollSpeed;
	        } else if(event.pageY - i.overflowOffset.top < o.scrollSensitivity) {
	          i.scrollParent[0].scrollTop = scrolled = i.scrollParent[0].scrollTop - o.scrollSpeed;
	        }
	      }

	      if(!o.axis || o.axis !== "y") {
	        if((i.overflowOffset.left + i.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity) {
	          i.scrollParent[0].scrollLeft = scrolled = i.scrollParent[0].scrollLeft + o.scrollSpeed;
	        } else if(event.pageX - i.overflowOffset.left < o.scrollSensitivity) {
	          i.scrollParent[0].scrollLeft = scrolled = i.scrollParent[0].scrollLeft - o.scrollSpeed;
	        }
	      }

	    } else {

	      if(!o.axis || o.axis !== "x") {
	        if(event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
	          scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
	        } else if($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
	          scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
	        }
	      }

	      if(!o.axis || o.axis !== "y") {
	        if(event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
	          scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
	        } else if($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
	          scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
	        }
	      }

	    }

	    if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
	      $.ui.ddmanager.prepareOffsets(i, event);
	    }

	  }
	});

	$.ui.plugin.add("draggable", "snap", {
	  start: function() {

	    var i = $(this).data("ui-draggable"),
	      o = i.options;

	    i.snapElements = [];

	    $(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
	      var $t = $(this),
	        $o = $t.offset();
	      if(this !== i.element[0]) {
	        i.snapElements.push({
	          item: this,
	          width: $t.outerWidth(), height: $t.outerHeight(),
	          top: $o.top, left: $o.left
	        });
	      }
	    });

	  },
	  drag: function(event, ui) {

	    var ts, bs, ls, rs, l, r, t, b, i, first,
	      inst = $(this).data("ui-draggable"),
	      o = inst.options,
	      d = o.snapTolerance,
	      x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
	      y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

	    for (i = inst.snapElements.length - 1; i >= 0; i--){

	      l = inst.snapElements[i].left;
	      r = l + inst.snapElements[i].width;
	      t = inst.snapElements[i].top;
	      b = t + inst.snapElements[i].height;

	      if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains( inst.snapElements[ i ].item.ownerDocument, inst.snapElements[ i ].item ) ) {
	        if(inst.snapElements[i].snapping) {
	          (inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
	        }
	        inst.snapElements[i].snapping = false;
	        continue;
	      }

	      if(o.snapMode !== "inner") {
	        ts = Math.abs(t - y2) <= d;
	        bs = Math.abs(b - y1) <= d;
	        ls = Math.abs(l - x2) <= d;
	        rs = Math.abs(r - x1) <= d;
	        if(ts) {
	          ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top - inst.margins.top;
	        }
	        if(bs) {
	          ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top - inst.margins.top;
	        }
	        if(ls) {
	          ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left - inst.margins.left;
	        }
	        if(rs) {
	          ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left - inst.margins.left;
	        }
	      }

	      first = (ts || bs || ls || rs);

	      if(o.snapMode !== "outer") {
	        ts = Math.abs(t - y1) <= d;
	        bs = Math.abs(b - y2) <= d;
	        ls = Math.abs(l - x1) <= d;
	        rs = Math.abs(r - x2) <= d;
	        if(ts) {
	          ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top - inst.margins.top;
	        }
	        if(bs) {
	          ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top - inst.margins.top;
	        }
	        if(ls) {
	          ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left - inst.margins.left;
	        }
	        if(rs) {
	          ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left - inst.margins.left;
	        }
	      }

	      if(!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
	        (inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
	      }
	      inst.snapElements[i].snapping = (ts || bs || ls || rs || first);

	    }

	  }
	});

	$.ui.plugin.add("draggable", "stack", {
	  start: function() {
	    var min,
	      o = this.data("ui-draggable").options,
	      group = $.makeArray($(o.stack)).sort(function(a,b) {
	        return (parseInt($(a).css("zIndex"),10) || 0) - (parseInt($(b).css("zIndex"),10) || 0);
	      });

	    if (!group.length) { return; }

	    min = parseInt($(group[0]).css("zIndex"), 10) || 0;
	    $(group).each(function(i) {
	      $(this).css("zIndex", min + i);
	    });
	    this.css("zIndex", (min + group.length));
	  }
	});

	$.ui.plugin.add("draggable", "zIndex", {
	  start: function(event, ui) {
	    var t = $(ui.helper), o = $(this).data("ui-draggable").options;
	    if(t.css("zIndex")) {
	      o._zIndex = t.css("zIndex");
	    }
	    t.css("zIndex", o.zIndex);
	  },
	  stop: function(event, ui) {
	    var o = $(this).data("ui-draggable").options;
	    if(o._zIndex) {
	      $(ui.helper).css("zIndex", o._zIndex);
	    }
	  }
	});

	})(jQuery);
	(function( $, undefined ) {

	function isOverAxis( x, reference, size ) {
	  return ( x > reference ) && ( x < ( reference + size ) );
	}

	$.widget("ui.droppable", {
	  version: "1.10.4",
	  widgetEventPrefix: "drop",
	  options: {
	    accept: "*",
	    activeClass: false,
	    addClasses: true,
	    greedy: false,
	    hoverClass: false,
	    scope: "default",
	    tolerance: "intersect",

	    // callbacks
	    activate: null,
	    deactivate: null,
	    drop: null,
	    out: null,
	    over: null
	  },
	  _create: function() {

	    var proportions,
	      o = this.options,
	      accept = o.accept;

	    this.isover = false;
	    this.isout = true;

	    this.accept = $.isFunction(accept) ? accept : function(d) {
	      return d.is(accept);
	    };

	    this.proportions = function( /* valueToWrite */ ) {
	      if ( arguments.length ) {
	        // Store the droppable's proportions
	        proportions = arguments[ 0 ];
	      } else {
	        // Retrieve or derive the droppable's proportions
	        return proportions ?
	          proportions :
	          proportions = {
	            width: this.element[ 0 ].offsetWidth,
	            height: this.element[ 0 ].offsetHeight
	          };
	      }
	    };

	    // Add the reference and positions to the manager
	    $.ui.ddmanager.droppables[o.scope] = $.ui.ddmanager.droppables[o.scope] || [];
	    $.ui.ddmanager.droppables[o.scope].push(this);

	    (o.addClasses && this.element.addClass("ui-droppable"));

	  },

	  _destroy: function() {
	    var i = 0,
	      drop = $.ui.ddmanager.droppables[this.options.scope];

	    for ( ; i < drop.length; i++ ) {
	      if ( drop[i] === this ) {
	        drop.splice(i, 1);
	      }
	    }

	    this.element.removeClass("ui-droppable ui-droppable-disabled");
	  },

	  _setOption: function(key, value) {

	    if(key === "accept") {
	      this.accept = $.isFunction(value) ? value : function(d) {
	        return d.is(value);
	      };
	    }
	    $.Widget.prototype._setOption.apply(this, arguments);
	  },

	  _activate: function(event) {
	    var draggable = $.ui.ddmanager.current;
	    if(this.options.activeClass) {
	      this.element.addClass(this.options.activeClass);
	    }
	    if(draggable){
	      this._trigger("activate", event, this.ui(draggable));
	    }
	  },

	  _deactivate: function(event) {
	    var draggable = $.ui.ddmanager.current;
	    if(this.options.activeClass) {
	      this.element.removeClass(this.options.activeClass);
	    }
	    if(draggable){
	      this._trigger("deactivate", event, this.ui(draggable));
	    }
	  },

	  _over: function(event) {

	    var draggable = $.ui.ddmanager.current;

	    // Bail if draggable and droppable are same element
	    if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) {
	      return;
	    }

	    if (this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
	      if(this.options.hoverClass) {
	        this.element.addClass(this.options.hoverClass);
	      }
	      this._trigger("over", event, this.ui(draggable));
	    }

	  },

	  _out: function(event) {

	    var draggable = $.ui.ddmanager.current;

	    // Bail if draggable and droppable are same element
	    if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) {
	      return;
	    }

	    if (this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
	      if(this.options.hoverClass) {
	        this.element.removeClass(this.options.hoverClass);
	      }
	      this._trigger("out", event, this.ui(draggable));
	    }

	  },

	  _drop: function(event,custom) {

	    var draggable = custom || $.ui.ddmanager.current,
	      childrenIntersection = false;

	    // Bail if draggable and droppable are same element
	    if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) {
	      return false;
	    }

	    this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function() {
	      var inst = $.data(this, "ui-droppable");
	      if(
	        inst.options.greedy &&
	        !inst.options.disabled &&
	        inst.options.scope === draggable.options.scope &&
	        inst.accept.call(inst.element[0], (draggable.currentItem || draggable.element)) &&
	        $.ui.intersect(draggable, $.extend(inst, { offset: inst.element.offset() }), inst.options.tolerance)
	      ) { childrenIntersection = true; return false; }
	    });
	    if(childrenIntersection) {
	      return false;
	    }

	    if(this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
	      if(this.options.activeClass) {
	        this.element.removeClass(this.options.activeClass);
	      }
	      if(this.options.hoverClass) {
	        this.element.removeClass(this.options.hoverClass);
	      }
	      this._trigger("drop", event, this.ui(draggable));
	      return this.element;
	    }

	    return false;

	  },

	  ui: function(c) {
	    return {
	      draggable: (c.currentItem || c.element),
	      helper: c.helper,
	      position: c.position,
	      offset: c.positionAbs
	    };
	  }

	});

	$.ui.intersect = function(draggable, droppable, toleranceMode) {

	  if (!droppable.offset) {
	    return false;
	  }

	  var draggableLeft, draggableTop,
	    x1 = (draggable.positionAbs || draggable.position.absolute).left,
	    y1 = (draggable.positionAbs || draggable.position.absolute).top,
	    x2 = x1 + draggable.helperProportions.width,
	    y2 = y1 + draggable.helperProportions.height,
	    l = droppable.offset.left,
	    t = droppable.offset.top,
	    r = l + droppable.proportions().width,
	    b = t + droppable.proportions().height;

	  switch (toleranceMode) {
	    case "fit":
	      return (l <= x1 && x2 <= r && t <= y1 && y2 <= b);
	    case "intersect":
	      return (l < x1 + (draggable.helperProportions.width / 2) && // Right Half
	        x2 - (draggable.helperProportions.width / 2) < r && // Left Half
	        t < y1 + (draggable.helperProportions.height / 2) && // Bottom Half
	        y2 - (draggable.helperProportions.height / 2) < b ); // Top Half
	    case "pointer":
	      draggableLeft = ((draggable.positionAbs || draggable.position.absolute).left + (draggable.clickOffset || draggable.offset.click).left);
	      draggableTop = ((draggable.positionAbs || draggable.position.absolute).top + (draggable.clickOffset || draggable.offset.click).top);
	      return isOverAxis( draggableTop, t, droppable.proportions().height ) && isOverAxis( draggableLeft, l, droppable.proportions().width );
	    case "touch":
	      return (
	        (y1 >= t && y1 <= b) || // Top edge touching
	        (y2 >= t && y2 <= b) || // Bottom edge touching
	        (y1 < t && y2 > b)    // Surrounded vertically
	      ) && (
	        (x1 >= l && x1 <= r) || // Left edge touching
	        (x2 >= l && x2 <= r) || // Right edge touching
	        (x1 < l && x2 > r)    // Surrounded horizontally
	      );
	    default:
	      return false;
	    }

	};

	/*
	  This manager tracks offsets of draggables and droppables
	*/
	$.ui.ddmanager = {
	  current: null,
	  droppables: { "default": [] },
	  prepareOffsets: function(t, event) {

	    var i, j,
	      m = $.ui.ddmanager.droppables[t.options.scope] || [],
	      type = event ? event.type : null, // workaround for #2317
	      list = (t.currentItem || t.element).find(":data(ui-droppable)").addBack();

	    droppablesLoop: for (i = 0; i < m.length; i++) {

	      //No disabled and non-accepted
	      if(m[i].options.disabled || (t && !m[i].accept.call(m[i].element[0],(t.currentItem || t.element)))) {
	        continue;
	      }

	      // Filter out elements in the current dragged item
	      for (j=0; j < list.length; j++) {
	        if(list[j] === m[i].element[0]) {
	          m[i].proportions().height = 0;
	          continue droppablesLoop;
	        }
	      }

	      m[i].visible = m[i].element.css("display") !== "none";
	      if(!m[i].visible) {
	        continue;
	      }

	      //Activate the droppable if used directly from draggables
	      if(type === "mousedown") {
	        m[i]._activate.call(m[i], event);
	      }

	      m[ i ].offset = m[ i ].element.offset();
	      m[ i ].proportions({ width: m[ i ].element[ 0 ].offsetWidth, height: m[ i ].element[ 0 ].offsetHeight });

	    }

	  },
	  drop: function(draggable, event) {

	    var dropped = false;
	    // Create a copy of the droppables in case the list changes during the drop (#9116)
	    $.each(($.ui.ddmanager.droppables[draggable.options.scope] || []).slice(), function() {

	      if(!this.options) {
	        return;
	      }
	      if (!this.options.disabled && this.visible && $.ui.intersect(draggable, this, this.options.tolerance)) {
	        dropped = this._drop.call(this, event) || dropped;
	      }

	      if (!this.options.disabled && this.visible && this.accept.call(this.element[0],(draggable.currentItem || draggable.element))) {
	        this.isout = true;
	        this.isover = false;
	        this._deactivate.call(this, event);
	      }

	    });
	    return dropped;

	  },
	  dragStart: function( draggable, event ) {
	    //Listen for scrolling so that if the dragging causes scrolling the position of the droppables can be recalculated (see #5003)
	    draggable.element.parentsUntil( "body" ).bind( "scroll.droppable", function() {
	      if( !draggable.options.refreshPositions ) {
	        $.ui.ddmanager.prepareOffsets( draggable, event );
	      }
	    });
	  },
	  drag: function(draggable, event) {

	    //If you have a highly dynamic page, you might try this option. It renders positions every time you move the mouse.
	    if(draggable.options.refreshPositions) {
	      $.ui.ddmanager.prepareOffsets(draggable, event);
	    }

	    //Run through all droppables and check their positions based on specific tolerance options
	    $.each($.ui.ddmanager.droppables[draggable.options.scope] || [], function() {

	      if(this.options.disabled || this.greedyChild || !this.visible) {
	        return;
	      }

	      var parentInstance, scope, parent,
	        intersects = $.ui.intersect(draggable, this, this.options.tolerance),
	        c = !intersects && this.isover ? "isout" : (intersects && !this.isover ? "isover" : null);
	      if(!c) {
	        return;
	      }

	      if (this.options.greedy) {
	        // find droppable parents with same scope
	        scope = this.options.scope;
	        parent = this.element.parents(":data(ui-droppable)").filter(function () {
	          return $.data(this, "ui-droppable").options.scope === scope;
	        });

	        if (parent.length) {
	          parentInstance = $.data(parent[0], "ui-droppable");
	          parentInstance.greedyChild = (c === "isover");
	        }
	      }

	      // we just moved into a greedy child
	      if (parentInstance && c === "isover") {
	        parentInstance.isover = false;
	        parentInstance.isout = true;
	        parentInstance._out.call(parentInstance, event);
	      }

	      this[c] = true;
	      this[c === "isout" ? "isover" : "isout"] = false;
	      this[c === "isover" ? "_over" : "_out"].call(this, event);

	      // we just moved out of a greedy child
	      if (parentInstance && c === "isout") {
	        parentInstance.isout = false;
	        parentInstance.isover = true;
	        parentInstance._over.call(parentInstance, event);
	      }
	    });

	  },
	  dragStop: function( draggable, event ) {
	    draggable.element.parentsUntil( "body" ).unbind( "scroll.droppable" );
	    //Call prepareOffsets one final time since IE does not fire return scroll events when overflow was caused by drag (see #5003)
	    if( !draggable.options.refreshPositions ) {
	      $.ui.ddmanager.prepareOffsets( draggable, event );
	    }
	  }
	};

	})(jQuery);
	(function( $, undefined ) {

	// number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	var numPages = 5;

	$.widget( "ui.slider", $.ui.mouse, {
	  version: "1.10.4",
	  widgetEventPrefix: "slide",

	  options: {
	    animate: false,
	    distance: 1,
	    max: 100,
	    min: 0,
	    orientation: "horizontal",
	    range: false,
	    step: 1,
	    value: 0,
	    values: null,

	    // callbacks
	    change: null,
	    slide: null,
	    start: null,
	    stop: null
	  },

	  _create: function() {
	    this._keySliding = false;
	    this._mouseSliding = false;
	    this._animateOff = true;
	    this._handleIndex = null;
	    this._detectOrientation();
	    this._mouseInit();

	    this.element
	      .addClass( "ui-slider" +
	        " ui-slider-" + this.orientation +
	        " ui-widget" +
	        " ui-widget-content" +
	        " ui-corner-all");

	    this._refresh();
	    this._setOption( "disabled", this.options.disabled );

	    this._animateOff = false;
	  },

	  _refresh: function() {
	    this._createRange();
	    this._createHandles();
	    this._setupEvents();
	    this._refreshValue();
	  },

	  _createHandles: function() {
	    var i, handleCount,
	      options = this.options,
	      existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all" ),
	      handle = "<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",
	      handles = [];

	    handleCount = ( options.values && options.values.length ) || 1;

	    if ( existingHandles.length > handleCount ) {
	      existingHandles.slice( handleCount ).remove();
	      existingHandles = existingHandles.slice( 0, handleCount );
	    }

	    for ( i = existingHandles.length; i < handleCount; i++ ) {
	      handles.push( handle );
	    }

	    this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

	    this.handle = this.handles.eq( 0 );

	    this.handles.each(function( i ) {
	      $( this ).data( "ui-slider-handle-index", i );
	    });
	  },

	  _createRange: function() {
	    var options = this.options,
	      classes = "";

	    if ( options.range ) {
	      if ( options.range === true ) {
	        if ( !options.values ) {
	          options.values = [ this._valueMin(), this._valueMin() ];
	        } else if ( options.values.length && options.values.length !== 2 ) {
	          options.values = [ options.values[0], options.values[0] ];
	        } else if ( $.isArray( options.values ) ) {
	          options.values = options.values.slice(0);
	        }
	      }

	      if ( !this.range || !this.range.length ) {
	        this.range = $( "<div></div>" )
	          .appendTo( this.element );

	        classes = "ui-slider-range" +
	        // note: this isn't the most fittingly semantic framework class for this element,
	        // but worked best visually with a variety of themes
	        " ui-widget-header ui-corner-all";
	      } else {
	        this.range.removeClass( "ui-slider-range-min ui-slider-range-max" )
	          // Handle range switching from true to min/max
	          .css({
	            "left": "",
	            "bottom": ""
	          });
	      }

	      this.range.addClass( classes +
	        ( ( options.range === "min" || options.range === "max" ) ? " ui-slider-range-" + options.range : "" ) );
	    } else {
	      if ( this.range ) {
	        this.range.remove();
	      }
	      this.range = null;
	    }
	  },

	  _setupEvents: function() {
	    var elements = this.handles.add( this.range ).filter( "a" );
	    this._off( elements );
	    this._on( elements, this._handleEvents );
	    this._hoverable( elements );
	    this._focusable( elements );
	  },

	  _destroy: function() {
	    this.handles.remove();
	    if ( this.range ) {
	      this.range.remove();
	    }

	    this.element
	      .removeClass( "ui-slider" +
	        " ui-slider-horizontal" +
	        " ui-slider-vertical" +
	        " ui-widget" +
	        " ui-widget-content" +
	        " ui-corner-all" );

	    this._mouseDestroy();
	  },

	  _mouseCapture: function( event ) {
	    var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
	      that = this,
	      o = this.options;

	    if ( o.disabled ) {
	      return false;
	    }

	    this.elementSize = {
	      width: this.element.outerWidth(),
	      height: this.element.outerHeight()
	    };
	    this.elementOffset = this.element.offset();

	    position = { x: event.pageX, y: event.pageY };
	    normValue = this._normValueFromMouse( position );
	    distance = this._valueMax() - this._valueMin() + 1;
	    this.handles.each(function( i ) {
	      var thisDistance = Math.abs( normValue - that.values(i) );
	      if (( distance > thisDistance ) ||
	        ( distance === thisDistance &&
	          (i === that._lastChangedValue || that.values(i) === o.min ))) {
	        distance = thisDistance;
	        closestHandle = $( this );
	        index = i;
	      }
	    });

	    allowed = this._start( event, index );
	    if ( allowed === false ) {
	      return false;
	    }
	    this._mouseSliding = true;

	    this._handleIndex = index;

	    closestHandle
	      .addClass( "ui-state-active" )
	      .focus();

	    offset = closestHandle.offset();
	    mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
	    this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
	      left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
	      top: event.pageY - offset.top -
	        ( closestHandle.height() / 2 ) -
	        ( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
	        ( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
	        ( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
	    };

	    if ( !this.handles.hasClass( "ui-state-hover" ) ) {
	      this._slide( event, index, normValue );
	    }
	    this._animateOff = true;
	    return true;
	  },

	  _mouseStart: function() {
	    return true;
	  },

	  _mouseDrag: function( event ) {
	    var position = { x: event.pageX, y: event.pageY },
	      normValue = this._normValueFromMouse( position );

	    this._slide( event, this._handleIndex, normValue );

	    return false;
	  },

	  _mouseStop: function( event ) {
	    this.handles.removeClass( "ui-state-active" );
	    this._mouseSliding = false;

	    this._stop( event, this._handleIndex );
	    this._change( event, this._handleIndex );

	    this._handleIndex = null;
	    this._clickOffset = null;
	    this._animateOff = false;

	    return false;
	  },

	  _detectOrientation: function() {
	    this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	  },

	  _normValueFromMouse: function( position ) {
	    var pixelTotal,
	      pixelMouse,
	      percentMouse,
	      valueTotal,
	      valueMouse;

	    if ( this.orientation === "horizontal" ) {
	      pixelTotal = this.elementSize.width;
	      pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
	    } else {
	      pixelTotal = this.elementSize.height;
	      pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
	    }

	    percentMouse = ( pixelMouse / pixelTotal );
	    if ( percentMouse > 1 ) {
	      percentMouse = 1;
	    }
	    if ( percentMouse < 0 ) {
	      percentMouse = 0;
	    }
	    if ( this.orientation === "vertical" ) {
	      percentMouse = 1 - percentMouse;
	    }

	    valueTotal = this._valueMax() - this._valueMin();
	    valueMouse = this._valueMin() + percentMouse * valueTotal;

	    return this._trimAlignValue( valueMouse );
	  },

	  _start: function( event, index ) {
	    var uiHash = {
	      handle: this.handles[ index ],
	      value: this.value()
	    };
	    if ( this.options.values && this.options.values.length ) {
	      uiHash.value = this.values( index );
	      uiHash.values = this.values();
	    }
	    return this._trigger( "start", event, uiHash );
	  },

	  _slide: function( event, index, newVal ) {
	    var otherVal,
	      newValues,
	      allowed;

	    if ( this.options.values && this.options.values.length ) {
	      otherVal = this.values( index ? 0 : 1 );

	      if ( ( this.options.values.length === 2 && this.options.range === true ) &&
	          ( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
	        ) {
	        newVal = otherVal;
	      }

	      if ( newVal !== this.values( index ) ) {
	        newValues = this.values();
	        newValues[ index ] = newVal;
	        // A slide can be canceled by returning false from the slide callback
	        allowed = this._trigger( "slide", event, {
	          handle: this.handles[ index ],
	          value: newVal,
	          values: newValues
	        } );
	        otherVal = this.values( index ? 0 : 1 );
	        if ( allowed !== false ) {
	          this.values( index, newVal );
	        }
	      }
	    } else {
	      if ( newVal !== this.value() ) {
	        // A slide can be canceled by returning false from the slide callback
	        allowed = this._trigger( "slide", event, {
	          handle: this.handles[ index ],
	          value: newVal
	        } );
	        if ( allowed !== false ) {
	          this.value( newVal );
	        }
	      }
	    }
	  },

	  _stop: function( event, index ) {
	    var uiHash = {
	      handle: this.handles[ index ],
	      value: this.value()
	    };
	    if ( this.options.values && this.options.values.length ) {
	      uiHash.value = this.values( index );
	      uiHash.values = this.values();
	    }

	    this._trigger( "stop", event, uiHash );
	  },

	  _change: function( event, index ) {
	    if ( !this._keySliding && !this._mouseSliding ) {
	      var uiHash = {
	        handle: this.handles[ index ],
	        value: this.value()
	      };
	      if ( this.options.values && this.options.values.length ) {
	        uiHash.value = this.values( index );
	        uiHash.values = this.values();
	      }

	      //store the last changed value index for reference when handles overlap
	      this._lastChangedValue = index;

	      this._trigger( "change", event, uiHash );
	    }
	  },

	  value: function( newValue ) {
	    if ( arguments.length ) {
	      this.options.value = this._trimAlignValue( newValue );
	      this._refreshValue();
	      this._change( null, 0 );
	      return;
	    }

	    return this._value();
	  },

	  values: function( index, newValue ) {
	    var vals,
	      newValues,
	      i;

	    if ( arguments.length > 1 ) {
	      this.options.values[ index ] = this._trimAlignValue( newValue );
	      this._refreshValue();
	      this._change( null, index );
	      return;
	    }

	    if ( arguments.length ) {
	      if ( $.isArray( arguments[ 0 ] ) ) {
	        vals = this.options.values;
	        newValues = arguments[ 0 ];
	        for ( i = 0; i < vals.length; i += 1 ) {
	          vals[ i ] = this._trimAlignValue( newValues[ i ] );
	          this._change( null, i );
	        }
	        this._refreshValue();
	      } else {
	        if ( this.options.values && this.options.values.length ) {
	          return this._values( index );
	        } else {
	          return this.value();
	        }
	      }
	    } else {
	      return this._values();
	    }
	  },

	  _setOption: function( key, value ) {
	    var i,
	      valsLength = 0;

	    if ( key === "range" && this.options.range === true ) {
	      if ( value === "min" ) {
	        this.options.value = this._values( 0 );
	        this.options.values = null;
	      } else if ( value === "max" ) {
	        this.options.value = this._values( this.options.values.length-1 );
	        this.options.values = null;
	      }
	    }

	    if ( $.isArray( this.options.values ) ) {
	      valsLength = this.options.values.length;
	    }

	    $.Widget.prototype._setOption.apply( this, arguments );

	    switch ( key ) {
	      case "orientation":
	        this._detectOrientation();
	        this.element
	          .removeClass( "ui-slider-horizontal ui-slider-vertical" )
	          .addClass( "ui-slider-" + this.orientation );
	        this._refreshValue();
	        break;
	      case "value":
	        this._animateOff = true;
	        this._refreshValue();
	        this._change( null, 0 );
	        this._animateOff = false;
	        break;
	      case "values":
	        this._animateOff = true;
	        this._refreshValue();
	        for ( i = 0; i < valsLength; i += 1 ) {
	          this._change( null, i );
	        }
	        this._animateOff = false;
	        break;
	      case "min":
	      case "max":
	        this._animateOff = true;
	        this._refreshValue();
	        this._animateOff = false;
	        break;
	      case "range":
	        this._animateOff = true;
	        this._refresh();
	        this._animateOff = false;
	        break;
	    }
	  },

	  //internal value getter
	  // _value() returns value trimmed by min and max, aligned by step
	  _value: function() {
	    var val = this.options.value;
	    val = this._trimAlignValue( val );

	    return val;
	  },

	  //internal values getter
	  // _values() returns array of values trimmed by min and max, aligned by step
	  // _values( index ) returns single value trimmed by min and max, aligned by step
	  _values: function( index ) {
	    var val,
	      vals,
	      i;

	    if ( arguments.length ) {
	      val = this.options.values[ index ];
	      val = this._trimAlignValue( val );

	      return val;
	    } else if ( this.options.values && this.options.values.length ) {
	      // .slice() creates a copy of the array
	      // this copy gets trimmed by min and max and then returned
	      vals = this.options.values.slice();
	      for ( i = 0; i < vals.length; i+= 1) {
	        vals[ i ] = this._trimAlignValue( vals[ i ] );
	      }

	      return vals;
	    } else {
	      return [];
	    }
	  },

	  // returns the step-aligned value that val is closest to, between (inclusive) min and max
	  _trimAlignValue: function( val ) {
	    if ( val <= this._valueMin() ) {
	      return this._valueMin();
	    }
	    if ( val >= this._valueMax() ) {
	      return this._valueMax();
	    }
	    var step = ( this.options.step > 0 ) ? this.options.step : 1,
	      valModStep = (val - this._valueMin()) % step,
	      alignValue = val - valModStep;

	    if ( Math.abs(valModStep) * 2 >= step ) {
	      alignValue += ( valModStep > 0 ) ? step : ( -step );
	    }

	    // Since JavaScript has problems with large floats, round
	    // the final value to 5 digits after the decimal point (see #4124)
	    return parseFloat( alignValue.toFixed(5) );
	  },

	  _valueMin: function() {
	    return this.options.min;
	  },

	  _valueMax: function() {
	    return this.options.max;
	  },

	  _refreshValue: function() {
	    var lastValPercent, valPercent, value, valueMin, valueMax,
	      oRange = this.options.range,
	      o = this.options,
	      that = this,
	      animate = ( !this._animateOff ) ? o.animate : false,
	      _set = {};

	    if ( this.options.values && this.options.values.length ) {
	      this.handles.each(function( i ) {
	        valPercent = ( that.values(i) - that._valueMin() ) / ( that._valueMax() - that._valueMin() ) * 100;
	        _set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
	        $( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
	        if ( that.options.range === true ) {
	          if ( that.orientation === "horizontal" ) {
	            if ( i === 0 ) {
	              that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
	            }
	            if ( i === 1 ) {
	              that.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
	            }
	          } else {
	            if ( i === 0 ) {
	              that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
	            }
	            if ( i === 1 ) {
	              that.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
	            }
	          }
	        }
	        lastValPercent = valPercent;
	      });
	    } else {
	      value = this.value();
	      valueMin = this._valueMin();
	      valueMax = this._valueMax();
	      valPercent = ( valueMax !== valueMin ) ?
	          ( value - valueMin ) / ( valueMax - valueMin ) * 100 :
	          0;
	      _set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
	      this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

	      if ( oRange === "min" && this.orientation === "horizontal" ) {
	        this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
	      }
	      if ( oRange === "max" && this.orientation === "horizontal" ) {
	        this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
	      }
	      if ( oRange === "min" && this.orientation === "vertical" ) {
	        this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
	      }
	      if ( oRange === "max" && this.orientation === "vertical" ) {
	        this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
	      }
	    }
	  },

	  _handleEvents: {
	    keydown: function( event ) {
	      var allowed, curVal, newVal, step,
	        index = $( event.target ).data( "ui-slider-handle-index" );

	      switch ( event.keyCode ) {
	        case $.ui.keyCode.HOME:
	        case $.ui.keyCode.END:
	        case $.ui.keyCode.PAGE_UP:
	        case $.ui.keyCode.PAGE_DOWN:
	        case $.ui.keyCode.UP:
	        case $.ui.keyCode.RIGHT:
	        case $.ui.keyCode.DOWN:
	        case $.ui.keyCode.LEFT:
	          event.preventDefault();
	          if ( !this._keySliding ) {
	            this._keySliding = true;
	            $( event.target ).addClass( "ui-state-active" );
	            allowed = this._start( event, index );
	            if ( allowed === false ) {
	              return;
	            }
	          }
	          break;
	      }

	      step = this.options.step;
	      if ( this.options.values && this.options.values.length ) {
	        curVal = newVal = this.values( index );
	      } else {
	        curVal = newVal = this.value();
	      }

	      switch ( event.keyCode ) {
	        case $.ui.keyCode.HOME:
	          newVal = this._valueMin();
	          break;
	        case $.ui.keyCode.END:
	          newVal = this._valueMax();
	          break;
	        case $.ui.keyCode.PAGE_UP:
	          newVal = this._trimAlignValue( curVal + ( (this._valueMax() - this._valueMin()) / numPages ) );
	          break;
	        case $.ui.keyCode.PAGE_DOWN:
	          newVal = this._trimAlignValue( curVal - ( (this._valueMax() - this._valueMin()) / numPages ) );
	          break;
	        case $.ui.keyCode.UP:
	        case $.ui.keyCode.RIGHT:
	          if ( curVal === this._valueMax() ) {
	            return;
	          }
	          newVal = this._trimAlignValue( curVal + step );
	          break;
	        case $.ui.keyCode.DOWN:
	        case $.ui.keyCode.LEFT:
	          if ( curVal === this._valueMin() ) {
	            return;
	          }
	          newVal = this._trimAlignValue( curVal - step );
	          break;
	      }

	      this._slide( event, index, newVal );
	    },
	    click: function( event ) {
	      event.preventDefault();
	    },
	    keyup: function( event ) {
	      var index = $( event.target ).data( "ui-slider-handle-index" );

	      if ( this._keySliding ) {
	        this._keySliding = false;
	        this._stop( event, index );
	        this._change( event, index );
	        $( event.target ).removeClass( "ui-state-active" );
	      }
	    }
	  }

	});

	}(jQuery));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/* Modernizr 2.6.2 (Custom Build) | MIT & BSD
	 * Build: http://modernizr.com/download/#-backgroundsize-hsla-multiplebgs-opacity-rgba-cssanimations-generatedcontent-cssgradients-csstransforms-csstransitions-applicationcache-canvas-canvastext-draganddrop-history-audio-video-indexeddb-input-inputtypes-localstorage-postmessage-sessionstorage-websockets-inlinesvg-svg-svgclippaths-shiv-cssclasses-teststyles-testprop-testallprops-hasevent-prefixes-domprefixes-load
	 */
	;

	window.Modernizr = (function( ) {

	    var version = '2.6.2',

	    Modernizr = {},

	    enableClasses = true,

	    docElement = document.documentElement,

	    mod = 'modernizr',
	    modElem = document.createElement(mod),
	    mStyle = modElem.style,

	    inputElem  = document.createElement('input')  ,

	    smile = ':)',

	    toString = {}.toString,

	    prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),



	    omPrefixes = 'Webkit Moz O ms',

	    cssomPrefixes = omPrefixes.split(' '),

	    domPrefixes = omPrefixes.toLowerCase().split(' '),

	    ns = {'svg': 'http://www.w3.org/2000/svg'},

	    tests = {},
	    inputs = {},
	    attrs = {},

	    classes = [],

	    slice = classes.slice,

	    featureName, 


	    injectElementWithStyles = function( rule, callback, nodes, testnames ) {

	      var style, ret, node, docOverflow,
	          div = document.createElement('div'),
	                body = document.body,
	                fakeBody = body || document.createElement('body');

	      if ( parseInt(nodes, 10) ) {
	                      while ( nodes-- ) {
	              node = document.createElement('div');
	              node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
	              div.appendChild(node);
	          }
	      }

	                style = ['&#173;','<style id="s', mod, '">', rule, '</style>'].join('');
	      div.id = mod;
	          (body ? div : fakeBody).innerHTML += style;
	      fakeBody.appendChild(div);
	      if ( !body ) {
	                fakeBody.style.background = '';
	                fakeBody.style.overflow = 'hidden';
	          docOverflow = docElement.style.overflow;
	          docElement.style.overflow = 'hidden';
	          docElement.appendChild(fakeBody);
	      }

	      ret = callback(div, rule);
	        if ( !body ) {
	          fakeBody.parentNode.removeChild(fakeBody);
	          docElement.style.overflow = docOverflow;
	      } else {
	          div.parentNode.removeChild(div);
	      }

	      return !!ret;

	    },



	    isEventSupported = (function() {

	      var TAGNAMES = {
	        'select': 'input', 'change': 'input',
	        'submit': 'form', 'reset': 'form',
	        'error': 'img', 'load': 'img', 'abort': 'img'
	      };

	      function isEventSupported( eventName, element ) {

	        element = element || document.createElement(TAGNAMES[eventName] || 'div');
	        eventName = 'on' + eventName;

	            var isSupported = eventName in element;

	        if ( !isSupported ) {
	                if ( !element.setAttribute ) {
	            element = document.createElement('div');
	          }
	          if ( element.setAttribute && element.removeAttribute ) {
	            element.setAttribute(eventName, '');
	            isSupported = is(element[eventName], 'function');

	                    if ( !is(element[eventName], 'undefined') ) {
	              element[eventName] = undefined;
	            }
	            element.removeAttribute(eventName);
	          }
	        }

	        element = null;
	        return isSupported;
	      }
	      return isEventSupported;
	    })(),


	    _hasOwnProperty = ({}).hasOwnProperty, hasOwnProp;

	    if ( !is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined') ) {
	      hasOwnProp = function (object, property) {
	        return _hasOwnProperty.call(object, property);
	      };
	    }
	    else {
	      hasOwnProp = function (object, property) { 
	        return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
	      };
	    }


	    if (!Function.prototype.bind) {
	      Function.prototype.bind = function bind(that) {

	        var target = this;

	        if (typeof target != "function") {
	            throw new TypeError();
	        }

	        var args = slice.call(arguments, 1),
	            bound = function () {

	            if (this instanceof bound) {

	              var F = function(){};
	              F.prototype = target.prototype;
	              var self = new F();

	              var result = target.apply(
	                  self,
	                  args.concat(slice.call(arguments))
	              );
	              if (Object(result) === result) {
	                  return result;
	              }
	              return self;

	            } else {

	              return target.apply(
	                  that,
	                  args.concat(slice.call(arguments))
	              );

	            }

	        };

	        return bound;
	      };
	    }

	    function setCss( str ) {
	        mStyle.cssText = str;
	    }

	    function setCssAll( str1, str2 ) {
	        return setCss(prefixes.join(str1 + ';') + ( str2 || '' ));
	    }

	    function is( obj, type ) {
	        return typeof obj === type;
	    }

	    function contains( str, substr ) {
	        return !!~('' + str).indexOf(substr);
	    }

	    function testProps( props, prefixed ) {
	        for ( var i in props ) {
	            var prop = props[i];
	            if ( !contains(prop, "-") && mStyle[prop] !== undefined ) {
	                return prefixed == 'pfx' ? prop : true;
	            }
	        }
	        return false;
	    }

	    function testDOMProps( props, obj, elem ) {
	        for ( var i in props ) {
	            var item = obj[props[i]];
	            if ( item !== undefined) {

	                            if (elem === false) return props[i];

	                            if (is(item, 'function')){
	                                return item.bind(elem || obj);
	                }

	                            return item;
	            }
	        }
	        return false;
	    }

	    function testPropsAll( prop, prefixed, elem ) {

	        var ucProp  = prop.charAt(0).toUpperCase() + prop.slice(1),
	            props   = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

	            if(is(prefixed, "string") || is(prefixed, "undefined")) {
	          return testProps(props, prefixed);

	            } else {
	          props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
	          return testDOMProps(props, prefixed, elem);
	        }
	    }



	    tests['canvas'] = function() {
	        var elem = document.createElement('canvas');
	        return !!(elem.getContext && elem.getContext('2d'));
	    };

	    tests['canvastext'] = function() {
	        return !!(Modernizr['canvas'] && is(document.createElement('canvas').getContext('2d').fillText, 'function'));
	    };
	    tests['postmessage'] = function() {
	      return !!window.postMessage;
	    };



	    tests['indexedDB'] = function() {
	      return !!testPropsAll("indexedDB", window);
	    };


	    tests['history'] = function() {
	      return !!(window.history && history.pushState);
	    };

	    tests['draganddrop'] = function() {
	        var div = document.createElement('div');
	        return ('draggable' in div) || ('ondragstart' in div && 'ondrop' in div);
	    };

	    tests['websockets'] = function() {
	        return 'WebSocket' in window || 'MozWebSocket' in window;
	    };


	    tests['rgba'] = function() {
	        setCss('background-color:rgba(150,255,150,.5)');

	        return contains(mStyle.backgroundColor, 'rgba');
	    };

	    tests['hsla'] = function() {
	            setCss('background-color:hsla(120,40%,100%,.5)');

	        return contains(mStyle.backgroundColor, 'rgba') || contains(mStyle.backgroundColor, 'hsla');
	    };

	    tests['multiplebgs'] = function() {
	                setCss('background:url(https://),url(https://),red url(https://)');

	            return (/(url\s*\(.*?){3}/).test(mStyle.background);
	    };    tests['backgroundsize'] = function() {
	        return testPropsAll('backgroundSize');
	    };



	    tests['opacity'] = function() {
	                setCssAll('opacity:.55');

	                    return (/^0.55$/).test(mStyle.opacity);
	    };


	    tests['cssanimations'] = function() {
	        return testPropsAll('animationName');
	    };    tests['cssgradients'] = function() {
	        var str1 = 'background-image:',
	            str2 = 'gradient(linear,left top,right bottom,from(#9f9),to(white));',
	            str3 = 'linear-gradient(left top,#9f9, white);';

	        setCss(
	                       (str1 + '-webkit- '.split(' ').join(str2 + str1) +
	                       prefixes.join(str3 + str1)).slice(0, -str1.length)
	        );

	        return contains(mStyle.backgroundImage, 'gradient');
	    };    tests['csstransforms'] = function() {
	        return !!testPropsAll('transform');
	    };    tests['csstransitions'] = function() {
	        return testPropsAll('transition');
	    };



	    tests['generatedcontent'] = function() {
	        var bool;

	        injectElementWithStyles(['#',mod,'{font:0/0 a}#',mod,':after{content:"',smile,'";visibility:hidden;font:3px/1 a}'].join(''), function( node ) {
	          bool = node.offsetHeight >= 3;
	        });

	        return bool;
	    };
	    tests['video'] = function() {
	        var elem = document.createElement('video'),
	            bool = false;

	            try {
	            if ( bool = !!elem.canPlayType ) {
	                bool      = new Boolean(bool);
	                bool.ogg  = elem.canPlayType('video/ogg; codecs="theora"')      .replace(/^no$/,'');

	                            bool.h264 = elem.canPlayType('video/mp4; codecs="avc1.42E01E"') .replace(/^no$/,'');

	                bool.webm = elem.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,'');
	            }

	        } catch(e) { }

	        return bool;
	    };

	    tests['audio'] = function() {
	        var elem = document.createElement('audio'),
	            bool = false;

	        try {
	            if ( bool = !!elem.canPlayType ) {
	                bool      = new Boolean(bool);
	                bool.ogg  = elem.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,'');
	                bool.mp3  = elem.canPlayType('audio/mpeg;')               .replace(/^no$/,'');

	                                                    bool.wav  = elem.canPlayType('audio/wav; codecs="1"')     .replace(/^no$/,'');
	                bool.m4a  = ( elem.canPlayType('audio/x-m4a;')            ||
	                              elem.canPlayType('audio/aac;'))             .replace(/^no$/,'');
	            }
	        } catch(e) { }

	        return bool;
	    };


	    tests['localstorage'] = function() {
	        try {
	            localStorage.setItem(mod, mod);
	            localStorage.removeItem(mod);
	            return true;
	        } catch(e) {
	            return false;
	        }
	    };

	    tests['sessionstorage'] = function() {
	        try {
	            sessionStorage.setItem(mod, mod);
	            sessionStorage.removeItem(mod);
	            return true;
	        } catch(e) {
	            return false;
	        }
	    };    tests['applicationcache'] = function() {
	        return !!window.applicationCache;
	    };


	    tests['svg'] = function() {
	        return !!document.createElementNS && !!document.createElementNS(ns.svg, 'svg').createSVGRect;
	    };

	    tests['inlinesvg'] = function() {
	      var div = document.createElement('div');
	      div.innerHTML = '<svg/>';
	      return (div.firstChild && div.firstChild.namespaceURI) == ns.svg;
	    };



	    tests['svgclippaths'] = function() {
	        return !!document.createElementNS && /SVGClipPath/.test(toString.call(document.createElementNS(ns.svg, 'clipPath')));
	    };

	    function webforms() {
	                                            Modernizr['input'] = (function( props ) {
	            for ( var i = 0, len = props.length; i < len; i++ ) {
	                attrs[ props[i] ] = !!(props[i] in inputElem);
	            }
	            if (attrs.list){
	                                  attrs.list = !!(document.createElement('datalist') && window.HTMLDataListElement);
	            }
	            return attrs;
	        })('autocomplete autofocus list placeholder max min multiple pattern required step'.split(' '));
	                            Modernizr['inputtypes'] = (function(props) {

	            for ( var i = 0, bool, inputElemType, defaultView, len = props.length; i < len; i++ ) {

	                inputElem.setAttribute('type', inputElemType = props[i]);
	                bool = inputElem.type !== 'text';

	                                                    if ( bool ) {

	                    inputElem.value         = smile;
	                    inputElem.style.cssText = 'position:absolute;visibility:hidden;';

	                    if ( /^range$/.test(inputElemType) && inputElem.style.WebkitAppearance !== undefined ) {

	                      docElement.appendChild(inputElem);
	                      defaultView = document.defaultView;

	                                        bool =  defaultView.getComputedStyle &&
	                              defaultView.getComputedStyle(inputElem, null).WebkitAppearance !== 'textfield' &&
	                                                                                  (inputElem.offsetHeight !== 0);

	                      docElement.removeChild(inputElem);

	                    } else if ( /^(search|tel)$/.test(inputElemType) ){
	                                                                                    } else if ( /^(url|email)$/.test(inputElemType) ) {
	                                        bool = inputElem.checkValidity && inputElem.checkValidity() === false;

	                    } else {
	                                        bool = inputElem.value != smile;
	                    }
	                }

	                inputs[ props[i] ] = !!bool;
	            }
	            return inputs;
	        })('search tel url email datetime date month week time datetime-local number range color'.split(' '));
	        }
	    for ( var feature in tests ) {
	        if ( hasOwnProp(tests, feature) ) {
	                                    featureName  = feature.toLowerCase();
	            Modernizr[featureName] = tests[feature]();

	            classes.push((Modernizr[featureName] ? '' : 'no-') + featureName);
	        }
	    }

	    Modernizr.input || webforms();


	     Modernizr.addTest = function ( feature, test ) {
	       if ( typeof feature == 'object' ) {
	         for ( var key in feature ) {
	           if ( hasOwnProp( feature, key ) ) {
	             Modernizr.addTest( key, feature[ key ] );
	           }
	         }
	       } else {

	         feature = feature.toLowerCase();

	         if ( Modernizr[feature] !== undefined ) {
	                                              return Modernizr;
	         }

	         test = typeof test == 'function' ? test() : test;

	         if (typeof enableClasses !== "undefined" && enableClasses) {
	           docElement.className += ' ' + (test ? '' : 'no-') + feature;
	         }
	         Modernizr[feature] = test;

	       }

	       return Modernizr; 
	     };


	    setCss('');
	    modElem = inputElem = null;

	    ;(function(window, document) {
	        var options = window.html5 || {};

	        var reSkip = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i;

	        var saveClones = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i;

	        var supportsHtml5Styles;

	        var expando = '_html5shiv';

	        var expanID = 0;

	        var expandoData = {};

	        var supportsUnknownElements;

	      (function() {
	        try {
	            var a = document.createElement('a');
	            a.innerHTML = '<xyz></xyz>';
	                    supportsHtml5Styles = ('hidden' in a);

	            supportsUnknownElements = a.childNodes.length == 1 || (function() {
	                        (document.createElement)('a');
	              var frag = document.createDocumentFragment();
	              return (
	                typeof frag.cloneNode == 'undefined' ||
	                typeof frag.createDocumentFragment == 'undefined' ||
	                typeof frag.createElement == 'undefined'
	              );
	            }());
	        } catch(e) {
	          supportsHtml5Styles = true;
	          supportsUnknownElements = true;
	        }

	      }());        function addStyleSheet(ownerDocument, cssText) {
	        var p = ownerDocument.createElement('p'),
	            parent = ownerDocument.getElementsByTagName('head')[0] || ownerDocument.documentElement;

	        p.innerHTML = 'x<style>' + cssText + '</style>';
	        return parent.insertBefore(p.lastChild, parent.firstChild);
	      }

	        function getElements() {
	        var elements = html5.elements;
	        return typeof elements == 'string' ? elements.split(' ') : elements;
	      }

	          function getExpandoData(ownerDocument) {
	        var data = expandoData[ownerDocument[expando]];
	        if (!data) {
	            data = {};
	            expanID++;
	            ownerDocument[expando] = expanID;
	            expandoData[expanID] = data;
	        }
	        return data;
	      }

	        function createElement(nodeName, ownerDocument, data){
	        if (!ownerDocument) {
	            ownerDocument = document;
	        }
	        if(supportsUnknownElements){
	            return ownerDocument.createElement(nodeName);
	        }
	        if (!data) {
	            data = getExpandoData(ownerDocument);
	        }
	        var node;

	        if (data.cache[nodeName]) {
	            node = data.cache[nodeName].cloneNode();
	        } else if (saveClones.test(nodeName)) {
	            node = (data.cache[nodeName] = data.createElem(nodeName)).cloneNode();
	        } else {
	            node = data.createElem(nodeName);
	        }

	                                    return node.canHaveChildren && !reSkip.test(nodeName) ? data.frag.appendChild(node) : node;
	      }

	        function createDocumentFragment(ownerDocument, data){
	        if (!ownerDocument) {
	            ownerDocument = document;
	        }
	        if(supportsUnknownElements){
	            return ownerDocument.createDocumentFragment();
	        }
	        data = data || getExpandoData(ownerDocument);
	        var clone = data.frag.cloneNode(),
	            i = 0,
	            elems = getElements(),
	            l = elems.length;
	        for(;i<l;i++){
	            clone.createElement(elems[i]);
	        }
	        return clone;
	      }

	        function shivMethods(ownerDocument, data) {
	        if (!data.cache) {
	            data.cache = {};
	            data.createElem = ownerDocument.createElement;
	            data.createFrag = ownerDocument.createDocumentFragment;
	            data.frag = data.createFrag();
	        }


	        ownerDocument.createElement = function(nodeName) {
	                if (!html5.shivMethods) {
	              return data.createElem(nodeName);
	          }
	          return createElement(nodeName, ownerDocument, data);
	        };

	        ownerDocument.createDocumentFragment = Function('h,f', 'return function(){' +
	          'var n=f.cloneNode(),c=n.createElement;' +
	          'h.shivMethods&&(' +
	                    getElements().join().replace(/\w+/g, function(nodeName) {
	              data.createElem(nodeName);
	              data.frag.createElement(nodeName);
	              return 'c("' + nodeName + '")';
	            }) +
	          ');return n}'
	        )(html5, data.frag);
	      }        function shivDocument(ownerDocument) {
	        if (!ownerDocument) {
	            ownerDocument = document;
	        }
	        var data = getExpandoData(ownerDocument);

	        if (html5.shivCSS && !supportsHtml5Styles && !data.hasCSS) {
	          data.hasCSS = !!addStyleSheet(ownerDocument,
	                    'article,aside,figcaption,figure,footer,header,hgroup,nav,section{display:block}' +
	                    'mark{background:#FF0;color:#000}'
	          );
	        }
	        if (!supportsUnknownElements) {
	          shivMethods(ownerDocument, data);
	        }
	        return ownerDocument;
	      }        var html5 = {

	            'elements': options.elements || 'abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video',

	            'shivCSS': (options.shivCSS !== false),

	            'supportsUnknownElements': supportsUnknownElements,

	            'shivMethods': (options.shivMethods !== false),

	            'type': 'default',

	            'shivDocument': shivDocument,

	            createElement: createElement,

	            createDocumentFragment: createDocumentFragment
	      };        window.html5 = html5;

	        shivDocument(document);

	    }(this, document));

	    Modernizr._version      = version;

	    Modernizr._prefixes     = prefixes;
	    Modernizr._domPrefixes  = domPrefixes;
	    Modernizr._cssomPrefixes  = cssomPrefixes;


	    Modernizr.hasEvent      = isEventSupported;

	    Modernizr.testProp      = function(prop){
	        return testProps([prop]);
	    };

	    Modernizr.testAllProps  = testPropsAll;


	    Modernizr.testStyles    = injectElementWithStyles;    docElement.className = docElement.className.replace(/(^|\s)no-js(\s|$)/, '$1$2') +

	                                                    (enableClasses ? ' js ' + classes.join(' ') : '');

	    return Modernizr;

	})();

	/*yepnope1.5.4|WTFPL*/
	(function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}})(this,document);
	Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0));};
	;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	window.EditComment = ReactiveComponent({
	  displayName: 'EditComment',
	  render: function() {
	    var permitted;
	    permitted = permit('create comment', this.proposal);
	    return DIV({
	      className: 'comment_entry'
	    }, DIV({
	      style: {
	        fontWeight: 'bold',
	        color: '#666'
	      }
	    }, (fetch('/current_user').name || 'You') + ':'), Avatar({
	      style: {
	        position: 'absolute',
	        width: 50,
	        height: 50,
	        backgroundColor: permitted < 0 ? 'transparent' : void 0,
	        border: permitted < 0 ? '1px dashed grey' : void 0
	      },
	      key: fetch('/current_user').user,
	      hide_tooltip: true
	    }), permitted === Permission.DISABLED ? SPAN({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px'
	      }
	    }, 'Comments closed') : permitted === Permission.INSUFFICIENT_PRIVILEGES ? SPAN({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px'
	      }
	    }, 'Sorry, you do not have permission to comment') : permitted < 0 ? A({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px',
	        cursor: 'pointer',
	        zIndex: 1
	      },
	      onTouchEnd: (function(_this) {
	        return function(e) {
	          return e.stopPropagation();
	        };
	      })(this),
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          if (permitted === Permission.NOT_LOGGED_IN) {
	            return reset_key('auth', {
	              form: 'login',
	              goal: 'Write a comment'
	            });
	          } else if (permitted === Permission.UNVERIFIED_EMAIL) {
	            reset_key('auth', {
	              form: 'verify email',
	              goal: 'Write a comment'
	            });
	            current_user.trying_to = 'send_verification_token';
	            return save(current_user);
	          }
	        };
	      })(this)
	    }, permitted === Permission.NOT_LOGGED_IN ? DIV(null, SPAN({
	      style: {
	        textDecoration: 'underline',
	        color: focus_blue,
	        fontSize: browser.is_mobile ? 18 : void 0
	      }
	    }, t('login_to_comment')), indexOf.call(this.proposal.roles.commenter, '*') < 0 ? DIV({
	      style: {
	        fontSize: 11
	      }
	    }, 'Only some email addresses are authorized to comment.') : void 0) : permitted === Permission.UNVERIFIED_EMAIL ? (DIV(null, SPAN({
	      style: {
	        textDecoration: 'underline',
	        color: focus_blue
	      }
	    }), 'Verify your account'), SPAN(null, "to " + (t('write a comment')))) : void 0) : void 0, DIV({
	      style: {
	        marginLeft: 60
	      }
	    }, AutoGrowTextArea({
	      ref: 'comment_input',
	      placeholder: permitted > 0 ? t('Write a comment') : '',
	      disabled: permitted < 0,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.new_comment = e.target.value;
	          return save(_this.local);
	        };
	      })(this),
	      defaultValue: this.props.fresh ? null : this.data().body,
	      min_height: 80,
	      style: {
	        width: '100%',
	        lineHeight: 1.4,
	        fontSize: PORTRAIT_MOBILE() ? 50 : LANDSCAPE_MOBILE() ? 30 : 16,
	        border: permitted < 0 ? 'dashed 1px' : void 0
	      }
	    })), permitted > 0 ? Button({
	      style: {
	        marginLeft: 60,
	        padding: '8px 16px',
	        fontSize: browser.is_mobile ? 24 : void 0
	      },
	      'data-action': 'save-comment'
	    }, t('Save comment'), (function(_this) {
	      return function(e) {
	        var comment;
	        e.stopPropagation();
	        if (_this.props.fresh) {
	          comment = {
	            key: '/new/comment',
	            body: _this.local.new_comment,
	            user: fetch('/current_user').user,
	            point: "/point/" + _this.props.point
	          };
	        } else {
	          comment = _this.data();
	          comment.body = _this.local.new_comment;
	          comment.editing = false;
	        }
	        save(comment, function() {
	          _this.local.new_comment = null;
	          return save(_this.local);
	        });
	        return $(_this.refs.comment_input.getDOMNode()).val('');
	      };
	    })(this)) : void 0);
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {window.EditPoint = ReactiveComponent({
	  displayName: 'EditPoint',
	  render: function() {
	    var error, mobile, parent, parent_offset, ref, style, textarea_style;
	    this.local = this.data(this.local_key, {
	      sign_name: this.props.fresh ? true : !this.data().hide_name,
	      add_details: false
	    });
	    mobile = browser.is_mobile;
	    if (mobile) {
	      textarea_style = {
	        width: '100%',
	        overflow: 'hidden',
	        fontSize: PORTRAIT_MOBILE() ? 50 : 30,
	        padding: '4px 6px'
	      };
	      parent = $("#proposal-" + this.proposal.id);
	      parent_offset = parent.length > 0 ? parent.offset().top : 0;
	      style = {
	        position: 'absolute',
	        top: 0,
	        left: 50,
	        height: '100%',
	        width: WINDOW_WIDTH() - 100,
	        backgroundColor: 'rgba(255,255,255,.85)',
	        fontSize: 20,
	        zIndex: 99999999,
	        padding: (this.scrollY - parent_offset) + "px 50px 100px 50px"
	      };
	    } else {
	      textarea_style = {
	        width: mobile ? '75%' : '100%',
	        overflow: 'hidden',
	        fontSize: mobile ? 30 : 14,
	        padding: '4px 6px'
	      };
	      style = {
	        position: 'relative',
	        fontSize: 14,
	        zIndex: 1,
	        marginTop: TWO_COL() ? 40 : void 0,
	        marginBottom: 15
	      };
	    }
	    return DIV({
	      className: 'edit_point',
	      style: style
	    }, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, this.drawTips(), CharacterCountTextInput({
	      id: 'nutshell',
	      maxLength: 180,
	      name: 'nutshell',
	      pattern: '^.{3,}',
	      placeholder: t('summary_placeholder'),
	      required: 'required',
	      defaultValue: this.props.fresh ? null : this.data().nutshell,
	      style: _.extend({}, textarea_style, {
	        minHeight: 75
	      }),
	      count_style: {
	        position: 'absolute',
	        right: 0,
	        top: -21
	      }
	    }), INPUT({
	      id: 'is_pro',
	      name: 'is_pro',
	      type: 'hidden',
	      value: "" + (this.props.valence === 'pros')
	    })), DIV(null, AutoGrowTextArea({
	      id: 'text',
	      name: 'text',
	      placeholder: t('description_placeholder'),
	      min_height: PORTRAIT_MOBILE() ? 150 : 100,
	      defaultValue: this.props.fresh ? null : this.data().text,
	      style: textarea_style,
	      onHeightChange: (function(_this) {
	        return function() {
	          var s;
	          s = fetch('reasons_height_adjustment');
	          s.edit_point_height = $(_this.getDOMNode()).height();
	          return save(s);
	        };
	      })(this)
	    })), ((ref = this.local.errors) != null ? ref.length : void 0) > 0 ? DIV({
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = this.local.errors;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        error = ref1[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV({
	      style: {
	        marginTop: 3,
	        marginBottom: '.5em'
	      }
	    }, !this.proposal.active ? DIV({
	      style: {
	        color: '#777',
	        fontSize: 12
	      }
	    }, 'New points disabled for this proposal') : DIV({
	      className: 'primary_button',
	      'data-action': 'submit-point',
	      onClick: this.savePoint,
	      style: {
	        marginTop: 0,
	        display: 'inline-block',
	        fontSize: PORTRAIT_MOBILE() ? 50 : LANDSCAPE_MOBILE() ? 36 : 24,
	        padding: '4px 25px',
	        float: 'left'
	      }
	    }, t('Done')), A({
	      onTouchEnd: this.done,
	      onClick: this.done,
	      style: {
	        display: 'inline-block',
	        color: '#888888',
	        cursor: 'pointer',
	        zIndex: 1,
	        top: mobile ? 0 : 12,
	        fontSize: PORTRAIT_MOBILE() ? 50 : LANDSCAPE_MOBILE() ? 36 : 16,
	        right: mobile ? -10 : 20,
	        position: 'relative',
	        float: mobile ? 'left' : 'right',
	        padding: mobile ? 10 : void 0
	      }
	    }, t('cancel')), DIV({
	      style: {
	        clear: 'both'
	      }
	    })), this.proposal.active ? DIV({
	      style: {
	        position: 'relative'
	      }
	    }, INPUT({
	      className: 'newpoint-anonymous',
	      type: 'checkbox',
	      id: "sign_name-" + this.props.valence,
	      name: "sign_name-" + this.props.valence,
	      checked: this.local.sign_name,
	      onChange: (function(_this) {
	        return function() {
	          _this.local.sign_name = !_this.local.sign_name;
	          return save(_this.local);
	        };
	      })(this)
	    }), LABEL({
	      htmlFor: "sign_name-" + this.props.valence,
	      title: "This won\'t make your point perfectly anonymous, but will make it considerably harder for others to associate with you. Note that signing your name lends your point more weight with peers."
	    }, t('sign_name'))) : void 0);
	  },
	  componentWillMount: function() {
	    if (browser.is_mobile) {
	      return this.scrollY = window.scrollY;
	    }
	  },
	  componentDidMount: function() {
	    var $el;
	    if (this.proposal.active) {
	      $el = $(this.getDOMNode());
	      if (!browser.is_mobile) {
	        $el.find('#nutshell').focus();
	      }
	      return $el.find('[data-action="submit-point"]').ensureInView({
	        scroll: false,
	        position: 'bottom'
	      });
	    }
	  },
	  componentWillUnmount: function() {
	    var s;
	    s = fetch('reasons_height_adjustment');
	    s.edit_point_height = 0;
	    return save(s);
	  },
	  drawTips: function() {
	    var guidelines_h, guidelines_w, mobile, plural, singular;
	    mobile = browser.is_mobile;
	    guidelines_w = mobile ? 'auto' : 230;
	    guidelines_h = 238;
	    singular = this.props.valence === 'pros' ? customization('point_labels.pro', this.proposal) : customization('point_labels.con', this.proposal);
	    plural = this.props.valence === 'pros' ? customization('point_labels.pros', this.proposal) : customization('point_labels.cons', this.proposal);
	    return DIV({
	      style: {
	        position: mobile ? 'relative' : 'absolute',
	        left: !mobile ? (this.props.valence === 'pros' ? -guidelines_w - 25 : POINT_WIDTH() + 15) : void 0,
	        width: guidelines_w,
	        color: focus_blue,
	        zIndex: 1,
	        marginBottom: mobile ? 20 : void 0,
	        backgroundColor: mobile ? 'rgba(255,255,255,.85)' : void 0
	      }
	    }, !mobile ? SVG({
	      width: guidelines_w + 28,
	      height: guidelines_h,
	      viewBox: "-4 0 " + (guidelines_w + 20 + 9) + " " + guidelines_h,
	      style: css.crossbrowserify({
	        position: 'absolute',
	        transform: this.props.valence === 'cons' ? 'scaleX(-1)' : void 0,
	        left: this.props.valence === 'cons' ? -20 : void 0
	      })
	    }, DEFS(null, svg.dropShadow({
	      id: "guidelines-shadow",
	      dx: '0',
	      dy: '2',
	      stdDeviation: "3",
	      opacity: .5
	    })), PATH({
	      stroke: focus_blue,
	      strokeWidth: 1,
	      fill: "#FFF",
	      filter: 'url(#guidelines-shadow)',
	      d: "M" + guidelines_w + ",33\nL" + guidelines_w + ",0\nL1,0\nL1," + guidelines_h + " \nL" + guidelines_w + "," + guidelines_h + " \nL" + guidelines_w + ",58\nL" + (guidelines_w + 20) + ",48\nL" + guidelines_w + ",33 \nZ"
	    })) : void 0, DIV({
	      style: {
	        padding: !mobile ? '14px 18px' : void 0,
	        position: 'relative',
	        marginLeft: 5
	      }
	    }, SPAN({
	      style: {
	        fontWeight: 600,
	        fontSize: PORTRAIT_MOBILE() ? 70 : LANDSCAPE_MOBILE() ? 36 : void 0
	      }
	    }, t('write_a_new_point', {
	      noun: capitalize(singular)
	    })), UL({
	      style: {
	        listStylePosition: 'outside',
	        marginLeft: 16,
	        marginTop: 5
	      }
	    }, (function() {
	      var i, len, results, tip, tips;
	      tips = [
	        t('tip_single', {
	          noun: capitalize(plural)
	        }), t('tip_direct'), t('tip_review'), t('tip_attacks')
	      ];
	      results = [];
	      for (i = 0, len = tips.length; i < len; i++) {
	        tip = tips[i];
	        results.push(LI({
	          style: {
	            paddingBottom: 3,
	            fontSize: PORTRAIT_MOBILE() ? 24 : LANDSCAPE_MOBILE() ? 14 : void 0
	          }
	        }, tip));
	      }
	      return results;
	    })())));
	  },
	  done: function() {
	    var your_points;
	    your_points = fetch(this.props.your_points_key);
	    if (this.props.fresh) {
	      your_points.adding_new_point = false;
	    } else {
	      your_points.editing_points = _.without(your_points.editing_points, this.props.key);
	    }
	    return save(your_points);
	  },
	  savePoint: function(ev) {
	    var $form, current_user, hide_name, nutshell, point, text;
	    $form = $(this.getDOMNode());
	    nutshell = $form.find('#nutshell').val();
	    text = $form.find('#text').val();
	    hide_name = !$form.find("#sign_name-" + this.props.valence).is(':checked');
	    if (!this.props.fresh) {
	      point = this.data();
	      point.nutshell = nutshell;
	      point.text = text;
	      point.hide_name = hide_name;
	    } else {
	      current_user = fetch('/current_user').user;
	      point = {
	        key: '/new/point',
	        is_pro: this.props.valence === 'pros',
	        user: current_user,
	        comment_count: 0,
	        includers: [current_user],
	        proposal: this.proposal.key,
	        nutshell: nutshell,
	        text: text,
	        hide_name: hide_name
	      };
	    }
	    point.errors = [];
	    return save(point, (function(_this) {
	      return function() {
	        var ref;
	        if (((ref = point.errors) != null ? ref.length : void 0) === 0) {
	          return _this.done();
	        } else {
	          _this.local.errors = point.errors;
	          return save(_this.local);
	        }
	      };
	    })(this));
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	window.EditProposal = ReactiveComponent({
	  displayName: 'EditProposal',
	  render: function() {
	    var block_style, cluster, description_field_style, error, field, field_open, i, idx, input_style, label_style, len, loc, min_requirements, operation_style, permitted, proposal, ref, ref1, req, subdomain, toggleDescriptionFieldOpen, user;
	    user = fetch('/current_user');
	    proposal = this.data();
	    subdomain = fetch('/subdomain');
	    if (!this.props.fresh && !proposal.id) {
	      return SPAN(null);
	    }
	    permitted = this.props.fresh ? permit('create proposal') : permit('update proposal', proposal);
	    if (permitted < 0) {
	      recourse(permitted, 'create a proposal');
	      return DIV(null);
	    }
	    block_style = {
	      width: CONTENT_WIDTH(),
	      padding: '2px 0px',
	      marginBottom: 12,
	      position: 'relative'
	    };
	    description_field_style = {
	      fontSize: 18,
	      width: CONTENT_WIDTH(),
	      padding: 12,
	      marginBottom: 8,
	      border: '1px solid #ccc'
	    };
	    input_style = _.extend({}, description_field_style, {
	      display: 'block'
	    });
	    label_style = {
	      fontSize: 24,
	      fontWeight: 600,
	      width: 240,
	      display: 'inline-block',
	      color: focus_blue,
	      marginBottom: 3
	    };
	    operation_style = {
	      color: '#aaa',
	      textDecoration: 'underline',
	      fontSize: 14,
	      cursor: 'pointer',
	      display: 'block'
	    };
	    if (this.props.fresh) {
	      loc = fetch('location');
	      cluster = loc.query_params.category || '';
	    } else {
	      cluster = proposal.cluster;
	    }
	    if (!this.local.description_fields && (this.props.fresh || this.data().slug)) {
	      this.local.description_fields = this.data().description_fields ? $.parseJSON(this.data().description_fields) || [] : [];
	      this.local.open_fields = [];
	      if (this.local.description_fields.length > 0) {
	        if (this.local.description_fields[0].group) {
	          this.local.description_fields = _.flatten(this.local.description_fields.map(function(group) {
	            return group.items;
	          }));
	        }
	        ref = this.local.description_fields;
	        for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	          field = ref[idx];
	          field.id = idx;
	        }
	      }
	      save(this.local);
	    }
	    toggleDescriptionFieldOpen = (function(_this) {
	      return function(field, field_open) {
	        if (field_open) {
	          _this.local.open_fields = _.without(_this.local.open_fields, field.id);
	        } else {
	          _this.local.open_fields.push(field.id);
	        }
	        return save(_this.local);
	      };
	    })(this);
	    return DIV(null, DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        margin: 'auto',
	        padding: '3em 0',
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        fontSize: 28,
	        marginBottom: 20
	      }
	    }, DIV({
	      style: {
	        fontSize: 30,
	        fontWeight: 700
	      }
	    }, this.props.fresh ? subdomain.name === 'dao' && cluster === 'Proposals' ? 'Add a new inspiring idea' : subdomain.name === 'dao' && cluster === 'Meta' ? 'Add a new meta proposal' : subdomain.name === 'dao' && cluster === 'New' ? 'Create a new proposal. Please include:' : t('create_new_proposal') : (capitalize(t('edit'))) + " '" + proposal.name + "'"), subdomain.name === 'dao' && cluster === 'New' ? (min_requirements = ['At least one sentence on the problem or opportunity.', 'At least one sentence on the solution.', 'Address the execution of the work, such as by identifying a contractor.', 'Links to any external converations (e.g. on forum.daohub.org), contract code, external resources, or videos.'], UL({
	      style: {
	        fontSize: 18,
	        marginLeft: 40
	      }
	    }, (function() {
	      var j, len1, results;
	      results = [];
	      for (j = 0, len1 = min_requirements.length; j < len1; j++) {
	        req = min_requirements[j];
	        results.push(LI(null, req));
	      }
	      return results;
	    })())) : void 0, subdomain.name === 'dao' && cluster === 'Proposals' ? DIV({
	      style: {
	        fontSize: 18
	      }
	    }, "Toss out an idea. Maybe a contractor will put together a proposal \nbased on your idea. Or maybe you get excited by the feedback, and \nput together your own more detailed proposal for funding.") : DIV({
	      style: {
	        fontSize: 18
	      }
	    }, t('make_it') + ' ', SPAN({
	      style: {
	        fontWeight: 600
	      }
	    }, t("unambiguous")), ' ' + t('and') + ' ', SPAN({
	      style: {
	        fontWeight: 600
	      }
	    }, t('error_free')), '.')), fetch('/current_user').is_admin ? DIV({
	      style: block_style
	    }, LABEL({
	      htmlFor: 'slug',
	      style: label_style
	    }, 'URL:'), BR(null), SPAN({
	      style: {
	        fontSize: 20,
	        color: '#aaa'
	      }
	    }, location.origin + "/"), INPUT({
	      id: 'slug',
	      name: 'slug',
	      pattern: '^.{3,}',
	      placeholder: t('url_instr'),
	      required: 'required',
	      defaultValue: this.props.fresh ? null : proposal.slug,
	      style: _.extend({}, input_style, {
	        width: 400,
	        display: 'inline-block'
	      })
	    })) : void 0, DIV({
	      style: block_style
	    }, LABEL({
	      htmlFor: 'name',
	      style: label_style
	    }, t('Summary') + ':'), INPUT({
	      id: 'name',
	      name: 'name',
	      pattern: '^.{3,}',
	      placeholder: t('proposal_summary_instr'),
	      required: 'required',
	      defaultValue: this.props.fresh ? null : proposal.name,
	      style: input_style
	    })), DIV({
	      style: block_style
	    }, LABEL({
	      htmlFor: 'description',
	      style: label_style
	    }, t('details') + ':'), WysiwygEditor({
	      key: "description-" + proposal.key,
	      style: input_style,
	      html: this.props.fresh ? null : proposal.description
	    }), DIV({
	      style: {
	        marginBottom: 20,
	        marginLeft: 45,
	        display: !fetch('/current_user').is_admin ? 'none' : void 0
	      }
	    }, (function() {
	      var j, len1, ref1, ref2, results;
	      ref1 = this.local.description_fields;
	      results = [];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        field = ref1[j];
	        field_open = (ref2 = field.id, indexOf.call(this.local.open_fields, ref2) >= 0);
	        results.push(DIV({
	          key: "field-" + field.id,
	          style: _.extend({}, block_style, {
	            width: ''
	          })
	        }, I({
	          className: "fa fa-" + (field_open ? 'minus' : 'plus') + "-circle",
	          style: {
	            position: 'absolute',
	            left: -20,
	            top: 18,
	            color: '#414141',
	            cursor: 'pointer'
	          },
	          onClick: (function(_this) {
	            return function(field, field_open) {
	              return function() {
	                return toggleDescriptionFieldOpen(field, field_open);
	              };
	            };
	          })(this)(field, field_open)
	        }), field_open ? [
	          INPUT({
	            style: _.extend({}, description_field_style, {
	              width: description_field_style.width - 45
	            }),
	            type: 'text',
	            id: "field-" + field.id + "-label",
	            name: "field-" + field.id + "-label",
	            pattern: '^.{3,}',
	            placeholder: t('Label'),
	            required: 'required',
	            onChange: (function(_this) {
	              return function(field) {
	                return function(e) {
	                  field.label = e.target.value;
	                  return save(_this.local);
	                };
	              };
	            })(this)(field),
	            value: field.label
	          }), WysiwygEditor({
	            key: "field-" + field.id + "-html-" + (this.props.fresh ? '/new/proposal' : proposal.key),
	            name: "field-" + field.id + "-html",
	            placeholder: t('expandable_body_instr'),
	            style: _.extend({}, description_field_style, {
	              width: description_field_style.width - 45
	            }),
	            html: field.html
	          })
	        ] : DIV({
	          style: {
	            fontSize: 18,
	            fontWeight: 600,
	            cursor: 'pointer',
	            marginTop: 12,
	            marginLeft: 5,
	            width: description_field_style.width - 45
	          },
	          onClick: (function(_this) {
	            return function(field, field_open) {
	              return function() {
	                return toggleDescriptionFieldOpen(field, field_open);
	              };
	            };
	          })(this)(field, field_open)
	        }, field.label), DIV({
	          style: {
	            position: 'absolute',
	            right: 150,
	            top: 12
	          }
	        }, A({
	          style: operation_style,
	          onClick: (function(_this) {
	            return function(field, field_open) {
	              return function() {
	                return toggleDescriptionFieldOpen(field, field_open);
	              };
	            };
	          })(this)(field, field_open)
	        }, field_open ? t('close') : t('edit')), A({
	          style: operation_style,
	          onClick: (function(_this) {
	            return function(field) {
	              return function() {
	                _this.local.description_fields = _.filter(_this.local.description_fields, function(fld) {
	                  return fld.id !== field.id;
	                });
	                return save(_this.local);
	              };
	            };
	          })(this)(field)
	        }, t('delete')))));
	      }
	      return results;
	    }).call(this), SPAN({
	      style: {
	        color: '#aaa',
	        cursor: 'pointer',
	        fontSize: 18,
	        marginLeft: -18
	      },
	      onClick: (function(_this) {
	        return function() {
	          var j, len1, new_id, ref1;
	          new_id = 0;
	          ref1 = _this.local.description_fields;
	          for (j = 0, len1 = ref1.length; j < len1; j++) {
	            field = ref1[j];
	            new_id += field.id;
	          }
	          new_id += 1;
	          _this.local.description_fields.push({
	            label: null,
	            html: null,
	            id: new_id
	          });
	          _this.local.open_fields.push(new_id);
	          return save(_this.local);
	        };
	      })(this)
	    }, "+ ", SPAN({
	      style: {
	        textDecoration: 'underline',
	        marginLeft: 7
	      }
	    }, t('add_expandable'))))), DIV({
	      style: block_style
	    }, LABEL({
	      htmlFor: 'cluster',
	      style: label_style
	    }, t('category') + ' (' + t('optional') + '):'), INPUT({
	      id: 'cluster',
	      name: 'cluster',
	      pattern: '^.{3,}',
	      placeholder: 'The proposal will be shown on the homepage under this category. (Default="Proposals")',
	      defaultValue: cluster,
	      style: input_style
	    })), DIV({
	      style: _.extend({}, block_style, {
	        display: !user.is_admin ? 'none' : void 0
	      })
	    }, LABEL({
	      htmlFor: 'listed_on_homepage',
	      style: label_style
	    }, t('show_on_homepage')), INPUT({
	      id: 'listed_on_homepage',
	      name: 'listed_on_homepage',
	      type: 'checkbox',
	      defaultChecked: this.props.fresh ? true : !proposal.hide_on_homepage,
	      style: {
	        fontSize: 24
	      }
	    })), DIV({
	      style: _.extend({}, block_style, {
	        display: !user.is_admin ? 'none' : void 0
	      })
	    }, LABEL({
	      htmlFor: 'open_for_discussion',
	      style: label_style
	    }, t('open_for_discussion')), INPUT({
	      id: 'open_for_discussion',
	      name: 'open_for_discussion',
	      type: 'checkbox',
	      defaultChecked: this.props.fresh ? true : proposal.active,
	      style: {
	        fontSize: 24
	      }
	    })), DIV({
	      style: {
	        display: !user.is_admin ? 'none' : void 0
	      }
	    }, SPAN({
	      style: _.extend({}, label_style, {
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        width: 400,
	        position: 'relative'
	      }),
	      onClick: (function(_this) {
	        return function() {
	          _this.local.edit_roles = !_this.local.edit_roles;
	          return save(_this.local);
	        };
	      })(this)
	    }, I({
	      className: 'fa-child fa',
	      style: {
	        position: 'absolute',
	        left: -25,
	        top: 5
	      }
	    }), t('permissions_and_invites')), DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        backgroundColor: '#fafafa',
	        padding: '10px 60px',
	        display: this.local.edit_roles ? 'block' : 'none'
	      }
	    }, ProposalRoles({
	      key: this.props.fresh ? this.local.key : proposal.key
	    }))), ((ref1 = this.local.errors) != null ? ref1.length : void 0) > 0 ? DIV({
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var j, len1, ref2, results;
	      ref2 = this.local.errors;
	      results = [];
	      for (j = 0, len1 = ref2.length; j < len1; j++) {
	        error = ref2[j];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV(null, INPUT({
	      className: 'button primary_button',
	      type: 'submit',
	      style: {
	        width: 400,
	        marginTop: 35
	      },
	      value: "" + (this.props.fresh ? t('Publish') : t('Update')),
	      onClick: this.saveProposal
	    }), A({
	      type: 'submit',
	      style: {
	        marginTop: 10,
	        padding: 25,
	        marginLeft: 10,
	        fontSize: 22
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (_this.props.fresh) {
	            return loadPage("/");
	          } else {
	            return loadPage("/" + proposal.slug);
	          }
	        };
	      })(this)
	    }, t('cancel')))));
	  },
	  saveProposal: function() {
	    var $el, active, cluster, description, edited_html, field, hide_on_homepage, i, len, name, proposal, ref, slug;
	    $el = $(this.getDOMNode());
	    name = $el.find('#name').val();
	    description = fetch("description-" + (this.data().key)).html;
	    slug = $el.find('#slug').val() || slugify(name);
	    cluster = $el.find('#cluster').val();
	    if (cluster === "") {
	      cluster = null;
	    }
	    active = $el.find('#open_for_discussion:checked').length > 0;
	    hide_on_homepage = $el.find('#listed_on_homepage:checked').length === 0;
	    if (this.props.fresh) {
	      proposal = {
	        key: '/new/proposal',
	        name: name,
	        description: description,
	        cluster: cluster,
	        slug: slug,
	        active: active,
	        hide_on_homepage: hide_on_homepage
	      };
	    } else {
	      proposal = this.data();
	      _.extend(proposal, {
	        cluster: cluster,
	        name: name,
	        slug: slug,
	        description: description,
	        active: active,
	        hide_on_homepage: hide_on_homepage
	      });
	    }
	    if (this.local.roles) {
	      proposal.roles = this.local.roles;
	      proposal.invitations = this.local.invitations;
	    }
	    if (this.local.description_fields) {
	      ref = this.local.description_fields;
	      for (i = 0, len = ref.length; i < len; i++) {
	        field = ref[i];
	        edited_html = fetch("field-" + field.id + "-html-" + proposal.key);
	        if (edited_html.html) {
	          field.html = edited_html.html;
	        }
	      }
	      proposal.description_fields = JSON.stringify(this.local.description_fields);
	    }
	    proposal.errors = [];
	    this.local.errors = [];
	    save(this.local);
	    return save(proposal, (function(_this) {
	      return function() {
	        var ref1;
	        if (((ref1 = proposal.errors) != null ? ref1.length : void 0) === 0) {
	          window.scrollTo(0, 0);
	          return loadPage("/" + slug);
	        } else {
	          _this.local.errors = proposal.errors;
	          return save(_this.local);
	        }
	      };
	    })(this));
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);

	window.GodMode = ReactiveComponent({
	  displayName: 'GodMode',
	  render: function() {
	    var godmode, user, users;
	    godmode = fetch('godmode');
	    if (!godmode.enabled) {
	      return SPAN(null);
	    }
	    users = fetch('/users');
	    if (this.local.switch_user == null) {
	      this.local.switch_user = true;
	      save(this.local);
	    }
	    return DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        left: 0,
	        top: 0,
	        width: '100%',
	        backgroundColor: 'black',
	        color: 'white',
	        padding: 10
	      },
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.switch_user = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, SPAN({
	      style: {
	        fontWeight: 300,
	        color: 'cyan',
	        display: 'inline-block',
	        fontSize: 28,
	        marginRight: 20
	      }
	    }, 'GODMODE'), A({
	      style: {
	        fontWeight: 'bold'
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.switch_user = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'Switch user'), this.local.switch_user ? UL({
	      style: {
	        width: '100%'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = users.users;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        user = ref[i];
	        results.push(LI({
	          style: {
	            backgroundColor: 'black',
	            listStyle: 'none',
	            display: 'inline-block',
	            margin: 10,
	            cursor: 'pointer'
	          },
	          onClick: (function(_this) {
	            return function(user) {
	              return function() {
	                var current_user;
	                current_user = fetch('/current_user');
	                current_user.trying_to = 'switch_users';
	                current_user.switch_to = user;
	                save(current_user, function() {
	                  return location.reload();
	                });
	                _this.local.switch_user = false;
	                save(_this.local);
	                godmode.enabled = false;
	                return save(godmode);
	              };
	            };
	          })(this)(user)
	        }, Avatar({
	          key: user,
	          user: user,
	          hide_tooltip: true,
	          style: {
	            width: 50,
	            height: 50
	          }
	        }), SPAN({
	          style: {
	            paddingTop: 12,
	            paddingLeft: 5,
	            display: 'inline-block'
	          }
	        }, fetch(user).name)));
	      }
	      return results;
	    }).call(this)) : void 0);
	  },
	  componentDidMount: function() {
	    return document.addEventListener("keyup", function(e) {
	      var godmode, key;
	      key = (e && e.keyCode) || e.keyCode;
	      if (key === 85 && e.ctrlKey) {
	        godmode = fetch('godmode');
	        godmode.enabled = !godmode.enabled;
	        return save(godmode);
	      }
	    });
	  }
	});


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(24);

	document.addEventListener("keypress", function(e) {
	  var filter, key;
	  key = (e && e.keyCode) || e.keyCode;
	  if (key === 23) {
	    filter = fetch('homepage_filter');
	    filter.watched = !filter.watched;
	    return save(filter);
	  }
	});

	window.Notifications = ReactiveComponent({
	  displayName: 'Notifications',
	  render: function() {
	    var current_user, data, prefs, settings, subdomain;
	    data = this.data();
	    settings = {};
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    prefs = current_user.subscriptions;
	    return DIV({
	      style: {
	        width: BODY_WIDTH(),
	        margin: '50px auto'
	      }
	    }, DIV({
	      style: {
	        fontSize: 24,
	        marginBottom: 10,
	        position: 'relative'
	      }
	    }, INPUT({
	      type: 'checkbox',
	      defaultChecked: !!prefs['send_emails'],
	      id: 'enable_email',
	      style: {
	        verticalAlign: 'top',
	        display: 'inline-block',
	        marginTop: 12,
	        fontSize: 24,
	        position: 'absolute',
	        left: -40
	      },
	      onChange: (function(_this) {
	        return function() {
	          if (prefs['send_emails']) {
	            current_user.subscriptions['send_emails'] = null;
	          } else {
	            current_user.subscriptions['send_emails'] = settings['default_subscription'];
	          }
	          return save(current_user);
	        };
	      })(this)
	    }), DIV({
	      style: {
	        display: 'inline-block'
	      }
	    }, LABEL({
	      htmlFor: 'enable_email'
	    }, SPAN({
	      style: {
	        color: focus_blue,
	        fontWeight: 600
	      }
	    }, t('send_email')), DIV({
	      style: {
	        fontSize: 14,
	        color: '#888'
	      }
	    }, t('email_digest_purpose', {
	      project: subdomain.app_title || subdomain.name
	    }))))), prefs['send_emails'] ? [this.drawEmailSettings(), this.drawWatched()] : void 0);
	  },
	  drawEmailSettings: function() {
	    var config, current_user, event, settings, u;
	    current_user = fetch('/current_user');
	    settings = current_user.subscriptions;
	    return DIV({
	      style: {
	        padding: '10px 10px 10px 30px'
	      }
	    }, SPAN({
	      style: {
	        marginRight: 10,
	        display: 'inline-block'
	      }
	    }, t('digest_timing')), SELECT({
	      style: {
	        width: 80,
	        fontSize: 18
	      },
	      value: settings['send_emails'],
	      onChange: (function(_this) {
	        return function(e) {
	          current_user.subscriptions['send_emails'] = e.target.value;
	          return save(current_user);
	        };
	      })(this)
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['hour', 'day', 'week', 'month'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        u = ref[i];
	        results.push(OPTION({
	          value: "1_" + u
	        }, u === 'day' ? t('daily') : t(u + "ly")));
	      }
	      return results;
	    })()), DIV({
	      style: {
	        marginTop: 15
	      }
	    }, DIV({
	      style: {
	        marginBottom: 10
	      }
	    }, t('notable_events')), UL({
	      style: {
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = _.keys(settings).sort();
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        event = ref[i];
	        config = settings[event];
	        if (!config.ui_label) {
	          continue;
	        }
	        results.push(LI({
	          style: {
	            display: 'block',
	            padding: '5px 0'
	          }
	        }, SPAN({
	          style: {
	            display: 'inline-block',
	            verticalAlign: 'top',
	            position: 'relative'
	          }
	        }, INPUT({
	          id: event + "_input",
	          type: 'checkbox',
	          checked: config.email_trigger ? true : void 0,
	          style: {
	            fontSize: 24,
	            position: 'absolute',
	            left: -40,
	            top: 2
	          },
	          onChange: (function(_this) {
	            return function(config) {
	              return function() {
	                config.email_trigger = !config.email_trigger;
	                return save(current_user);
	              };
	            };
	          })(this)(config)
	        })), LABEL({
	          htmlFor: event + "_input",
	          style: {
	            display: 'inline-block',
	            verticalAlign: 'top'
	          }
	        }, config.ui_label)));
	      }
	      return results;
	    }).call(this))));
	  },
	  drawWatched: function() {
	    var current_user, k, ref, unsubscribed, v;
	    current_user = fetch('/current_user');
	    unsubscribed = {};
	    ref = current_user.subscriptions;
	    for (k in ref) {
	      v = ref[k];
	      if (v === 'watched' && k.match(/\/proposal\//)) {
	        unsubscribed[k] = v;
	      }
	    }
	    if (_.keys(unsubscribed).length > 0) {
	      return DIV({
	        style: {
	          padding: '20px 0',
	          marginLeft: 63
	        }
	      }, DIV({
	        style: {
	          position: 'relative',
	          paddingBottom: 10
	        }
	      }, t('watched_proposals')), DIV({
	        style: {
	          width: 550,
	          display: 'inline-block'
	        }
	      }, UL({
	        style: {
	          position: 'relative',
	          paddingLeft: 37
	        }
	      }, (function() {
	        var results;
	        results = [];
	        for (k in unsubscribed) {
	          v = unsubscribed[k];
	          results.push((function(_this) {
	            return function(k) {
	              var obj;
	              obj = fetch(k);
	              return LI({
	                style: {
	                  listStyle: 'none',
	                  padding: '5px 0',
	                  position: 'relative'
	                }
	              }, WatchStar({
	                proposal: obj,
	                watch_color: "#777",
	                label: function(watching) {
	                  return t('unwatch');
	                },
	                style: {
	                  position: 'absolute',
	                  left: -35,
	                  top: 8
	                }
	              }), A({
	                href: "/" + obj.slug,
	                style: {
	                  textDecoration: 'underline'
	                }
	              }, obj.name));
	            };
	          })(this)(k));
	        }
	        return results;
	      }).call(this))));
	    }
	  }
	});

	window.hasUnreadNotifications = function(proposal) {
	  var n, notifications, unread;
	  notifications = notifications_for(proposal);
	  if (!notifications) {
	    return false;
	  }
	  unread = (function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = notifications.length; i < len; i++) {
	      n = notifications[i];
	      if (!n.read_at) {
	        results.push(n);
	      }
	    }
	    return results;
	  })();
	  if (unread.length === 0) {
	    unread = null;
	  }
	  return unread;
	};

	window.notifications_for = function(proposal) {
	  var current_user, i, len, n, ref, results;
	  current_user = arest.cache['/current_user'];
	  if (current_user.notifications == null) {
	    return false;
	  }
	  ref = current_user.notifications;
	  results = [];
	  for (i = 0, len = ref.length; i < len; i++) {
	    n = ref[i];
	    if (n.digest_object_id === fetch(proposal).id) {
	      results.push(n);
	    }
	  }
	  return results;
	};

	window.ActivityFeed = ReactiveComponent({
	  displayName: 'ActivityFeed',
	  render: function() {
	    var current_user, i, len, n, notification, notifications, unread;
	    current_user = fetch('/current_user');
	    notifications = fetch("/notifications/" + this.proposal.id);
	    if (this.is_waiting()) {
	      return SPAN(null);
	    }
	    unread = hasUnreadNotifications(this.proposal);
	    if (unread) {
	      for (i = 0, len = unread.length; i < len; i++) {
	        n = unread[i];
	        if (!n.read_at) {
	          n.read_at = Date.now();
	          save(n);
	        }
	      }
	    }
	    return DIV({
	      style: {
	        width: BODY_WIDTH(),
	        position: 'relative',
	        margin: 'auto',
	        marginBottom: 18
	      }
	    }, UL({
	      style: {
	        border: "1px solid #eee",
	        listStyle: 'none',
	        padding: 20
	      }
	    }, (function() {
	      var j, len1, ref, results;
	      ref = notifications.notifications;
	      results = [];
	      for (j = 0, len1 = ref.length; j < len1; j++) {
	        notification = ref[j];
	        results.push(this.drawNotification(notification));
	      }
	      return results;
	    }).call(this)));
	  },
	  drawNotification: function(notification) {
	    var action, date, event_object, loc, point, protagonist, subdomain;
	    event_object = fetch("/" + (notification.event_object_type.toLowerCase()) + "/" + notification.event_object_id);
	    protagonist = fetch(event_object.user);
	    subdomain = fetch('/subdomain');
	    date = prettyDate(notification.created_at);
	    loc = fetch('location');
	    action = (function() {
	      switch (notification.event_object_type) {
	        case 'Comment':
	          point = fetch(event_object.point);
	          return SPAN({
	            style: {}
	          }, (t('commented_on')) + " ", notification.event_object_relationship === 'point_authored' ? SPAN({
	            style: {
	              fontWeight: 600
	            }
	          }, t('your point') + ' ') : void 0, A({
	            style: {
	              color: logo_red,
	              fontWeight: 600
	            },
	            onClick: (function(_this) {
	              return function(ev) {
	                ev.stopPropagation();
	                loc.query_params.selected = point.key;
	                return save(loc);
	              };
	            })(this)
	          }, shorten(point.nutshell)));
	        case 'Proposal':
	          return SPAN({
	            style: {}
	          }, subdomain.name === 'RANDOM2015' ? "uploaded a review from EasyChair, edited the description, or changed the category" : t("edited this proposal"));
	        case 'Point':
	          return SPAN({
	            style: {}
	          }, t('added_new_point') + " ", A({
	            style: {
	              color: logo_red,
	              fontWeight: 600
	            },
	            onClick: (function(_this) {
	              return function(ev) {
	                ev.stopPropagation();
	                loc.query_params.selected = event_object.key;
	                return save(loc);
	              };
	            })(this)
	          }, shorten(event_object.nutshell)));
	        case 'Opinion':
	          return t('added_opinion');
	      }
	    }).call(this);
	    return LI({
	      style: {
	        display: 'block',
	        padding: '10px 0'
	      }
	    }, DIV({
	      style: {}
	    }, Avatar({
	      key: protagonist,
	      user: protagonist,
	      hide_tooltip: true,
	      style: {
	        height: 35,
	        width: 35,
	        display: 'inline-block',
	        verticalAlign: 'top'
	      }
	    }), DIV({
	      style: {
	        display: 'inline-block',
	        verticalAlign: 'top',
	        marginLeft: 20,
	        width: '80%'
	      }
	    }, DIV({
	      style: {
	        color: '#999'
	      }
	    }, date), protagonist.name + " ", action)));
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(18);

	__webpack_require__(3);

	__webpack_require__(4);

	window.OpinionSlider = ReactiveComponent({
	  displayName: 'OpinionSlider',
	  render: function() {
	    var hist, hist_selection, slider, slider_style, your_opinion;
	    this.proposal || (this.proposal = fetch(this.props.proposal));
	    slider = fetch(this.props.key);
	    your_opinion = fetch(this.props.your_opinion);
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    hist_selection = hist.selected_opinions || hist.selected_opinion;
	    if (slider.value !== your_opinion.stance && !slider.has_moved) {
	      slider.value = your_opinion.stance;
	      if (your_opinion.stance) {
	        slider.has_moved = true;
	      }
	      save(slider);
	    }
	    slider_style = {
	      position: 'relative',
	      left: -(this.props.width - PROPOSAL_HISTO_WIDTH()) / 2,
	      width: this.props.width,
	      height: SLIDER_HANDLE_SIZE()
	    };
	    if (this.props.backgrounded) {
	      css.grayscale(slider_style);
	    }
	    return DIV({
	      className: 'opinion_slider',
	      style: slider_style
	    }, this.drawPoleLabels(), (this.props.focused || TWO_COL()) && this.props.permitted && !hist_selection ? this.drawFeedback() : void 0, Slider({
	      key: this.props.key,
	      width: this.props.width,
	      handle_height: SLIDER_HANDLE_SIZE(),
	      base_height: 6,
	      base_color: this.props.focused ? 'rgb(175, 215, 255)' : 'rgb(200, 200, 200)',
	      base_endpoint: slider.docked ? 'square' : 'sharp',
	      regions: customization('slider_regions', this.proposal),
	      draw_ticks: customization('slider_ticks', this.proposal),
	      polarized: true,
	      draw_helpers: this.props.focused && !slider.has_moved,
	      handle: this.props.backgrounded ? slider_handle.flat : customization('slider_handle', this.proposal),
	      handle_props: {
	        color: this.props.backgrounded ? '#ccc' : focus_blue,
	        detail: this.props.focused
	      },
	      handle_style: {
	        transition: "transform " + TRANSITION_SPEED + "ms",
	        transform: "scale(" + (!this.props.focused || slider.docked ? 1 : 2.5) + ")",
	        visibility: hist_selection || !this.props.permitted ? 'hidden' : void 0
	      },
	      onMouseUpCallback: this.handleMouseUp,
	      respond_to_click: false
	    }), this.saveYourOpinionNotice());
	  },
	  saveYourOpinionNotice: function() {
	    var current_user, notice, s, slider, style, your_opinion;
	    your_opinion = fetch(this.props.your_opinion);
	    slider = fetch(this.props.key);
	    current_user = fetch('/current_user');
	    if ((!TWO_COL() && customization('discussion', this.proposal)) || (your_opinion.published || (!slider.has_moved && your_opinion.point_inclusions.length === 0)) || slider.is_moving) {
	      return SPAN(null);
	    }
	    style = {
	      padding: 10,
	      color: 'white',
	      textAlign: 'center',
	      fontSize: 16,
	      margin: '10px 0',
	      position: 'relative',
	      fontWeight: 700,
	      textDecoration: 'underline',
	      cursor: 'pointer',
	      color: focus_blue
	    };
	    notice = current_user.logged_in ? t('save_your_opinion') : t('login_to_save_opinion');
	    s = sizeWhenRendered(notice, style);
	    return DIV({
	      style: {
	        width: this.props.width,
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, A({
	      style: _.extend(style, {
	        left: (slider.value + 1) / 2 * this.props.width - s.width / 2 - 10
	      }),
	      onClick: (function(_this) {
	        return function() {
	          return saveOpinion(_this.proposal);
	        };
	      })(this)
	    }, notice));
	  },
	  drawPoleLabels: function() {
	    var available_x, i, idx, j, len, len1, main_text, pole_label, ref, ref1, results, results1, slider, sub_text, w;
	    slider = fetch(this.props.key);
	    if (!slider.docked) {
	      ref = this.props.pole_labels;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        pole_label = ref[idx];
	        main_text = pole_label[0], sub_text = pole_label[1];
	        available_x = WHITESPACE() + GUTTER() - 55;
	        w = Math.max(widthWhenRendered(main_text, {
	          fontSize: 30,
	          maxWidth: available_x
	        }), widthWhenRendered(sub_text, {
	          fontSize: 14,
	          maxWidth: available_x
	        }));
	        results.push(DIV({
	          key: main_text,
	          style: {
	            position: 'absolute',
	            fontSize: 30,
	            top: -20,
	            pointerEvents: 'none',
	            left: idx === 0 ? -(w + 55) : void 0,
	            right: idx === 1 ? -(w + 55) : void 0,
	            width: w
	          }
	        }, main_text, DIV({
	          key: "pole_" + sub_text + "_sub",
	          style: {
	            fontSize: 14,
	            textAlign: 'center'
	          }
	        }, sub_text)));
	      }
	      return results;
	    } else {
	      ref1 = this.props.pole_labels;
	      results1 = [];
	      for (idx = j = 0, len1 = ref1.length; j < len1; idx = ++j) {
	        pole_label = ref1[idx];
	        results1.push(DIV({
	          key: "small-" + pole_label[0],
	          style: {
	            position: 'absolute',
	            fontSize: 20,
	            top: -12,
	            pointerEvents: 'none',
	            left: idx === 0 ? -15 : void 0,
	            right: idx === 1 ? -20 : void 0
	          }
	        }, idx === 0 ? '–' : '+'));
	      }
	      return results1;
	    }
	  },
	  drawFeedback: function() {
	    var feedback_left, feedback_style, feedback_width, func, labels, slider, slider_feedback;
	    slider = fetch(this.props.key);
	    labels = customization('slider_pole_labels', this.proposal);
	    slider_feedback = !slider.has_moved ? t('Slide Your Overall Opinion') : (func = labels.slider_feedback) ? func(slider.value, this.proposal) : !customization('show_slider_feedback', this.proposal) ? TWO_COL() ? t("Your opinion") : '' : '';
	    feedback_style = {
	      pointerEvents: 'none',
	      fontSize: TWO_COL() ? 22 : 30,
	      fontWeight: !TWO_COL() ? 700 : void 0,
	      color: this.props.backgrounded ? '#eee' : focus_blue
	    };
	    feedback_left = this.props.width * (slider.value + 1) / 2;
	    feedback_width = widthWhenRendered(slider_feedback, feedback_style) + 10;
	    if (slider.docked) {
	      if (slider.value > 0) {
	        feedback_left = Math.min(this.props.width - feedback_width / 2, feedback_left);
	      } else {
	        feedback_left = Math.max(feedback_width / 2, feedback_left);
	      }
	    }
	    _.extend(feedback_style, {
	      position: 'absolute',
	      top: slider.docked ? -57 : !TWO_COL() ? -80 : 37,
	      left: feedback_left,
	      marginLeft: -feedback_width / 2,
	      width: feedback_width
	    });
	    return DIV({
	      style: feedback_style
	    }, slider_feedback);
	  },
	  handleMouseUp: function(e) {
	    var mode, new_page, slider, transition, your_opinion;
	    slider = fetch(this.props.key);
	    your_opinion = fetch(this.props.your_opinion);
	    mode = get_proposal_mode();
	    e.stopPropagation();
	    transition = !TWO_COL() && (slider.value === your_opinion.stance || mode === 'results') && customization('discussion', this.proposal);
	    if (transition) {
	      new_page = mode === 'results' ? 'crafting' : 'results';
	      updateProposalMode(new_page, 'click_slider');
	    }
	    if (your_opinion.stance !== slider.value) {
	      your_opinion.stance = slider.value;
	      if (!transition && fetch('/current_user').logged_in) {
	        your_opinion.published = true;
	      }
	      save(your_opinion);
	      return window.writeToLog({
	        what: 'move slider',
	        details: {
	          stance: slider.value
	        }
	      });
	    }
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {window.Point = ReactiveComponent({
	  displayName: 'Point',
	  render: function() {
	    var can_opine, current_user, draw_all_includers, expand_to_see_details, includePoint, included, includers_style, ioffset, is_selected, left_or_right, mouth_style, point, point_content_style, point_style, ref, ref1, ref2, renderIncluders, renderNewIndicator, select_enticement, side, your_opinion;
	    point = this.data();
	    is_selected = get_selected_point() === this.props.key;
	    current_user = fetch('/current_user');
	    renderIncluders = (function(_this) {
	      return function(draw_all_includers) {
	        var curr_column, i, includer, includers, left_right, s, side_offset, style, top_offset;
	        if (_this.data().includers) {
	          if (draw_all_includers) {
	            includers = _this.buildIncluders();
	          } else {
	            includers = [point.user];
	          }
	          s = {
	            rows: 8,
	            dx: 2,
	            dy: 5,
	            col_gap: 8
	          };
	          if (includers.length === 0) {
	            includers = [point.user];
	          }
	          i = includers.length;
	          return DIV(null, (function() {
	            var j, len, results;
	            results = [];
	            for (j = 0, len = includers.length; j < len; j++) {
	              includer = includers[j];
	              i -= 1;
	              curr_column = Math.floor(i / s.rows);
	              side_offset = curr_column * s.col_gap + i * s.dx;
	              top_offset = (i % s.rows) * s.dy;
	              left_right = this.data().is_pro && this.props.rendered_as !== 'under_review' ? 'left' : 'right';
	              style = {
	                top: top_offset,
	                position: 'absolute'
	              };
	              style[left_right] = side_offset;
	              results.push(Avatar({
	                key: includer,
	                className: "point_includer_avatar",
	                style: style,
	                hide_tooltip: this.props.rendered_as === 'under_review',
	                anonymous: point.user === includer && point.hide_name
	              }));
	            }
	            return results;
	          }).call(_this));
	        }
	      };
	    })(this);
	    renderNewIndicator = (function(_this) {
	      return function() {
	        var left_right, side_offset, style;
	        if (_this.data().includers) {
	          side_offset = 48;
	          left_right = _this.data().is_pro ? 'right' : 'left';
	          style = {
	            position: 'absolute',
	            color: 'rgb(255,22,3)',
	            fontSize: '11px',
	            top: -14,
	            zIndex: 5,
	            fontVariant: 'small-caps',
	            fontWeight: 'bold'
	          };
	          style[left_right] = "" + (-side_offset);
	          return SPAN({
	            style: style
	          }, '-new-');
	        }
	      };
	    })(this);
	    point_content_style = {
	      width: POINT_WIDTH(),
	      borderWidth: 3,
	      borderStyle: 'solid',
	      borderColor: 'transparent',
	      top: -3,
	      position: 'relative',
	      zIndex: 1
	    };
	    if (is_selected) {
	      _.extend(point_content_style, {
	        borderColor: focus_blue,
	        backgroundColor: 'white'
	      });
	    }
	    if (this.props.rendered_as === 'decision_board_point') {
	      _.extend(point_content_style, {
	        padding: 8,
	        borderRadius: 8,
	        top: point_content_style.top - 8,
	        left: -11
	      });
	    } else if (this.props.rendered_as === 'community_point') {
	      _.extend(point_content_style, {
	        padding: 8,
	        borderRadius: TWO_COL() ? "16px 16px 0 0" : 16,
	        top: point_content_style.top - 8
	      });
	    } else if (this.props.rendered_as === 'under_review') {
	      _.extend(point_content_style, {
	        width: 500
	      });
	    }
	    expand_to_see_details = point.text && (point.nutshell.length + point.text.length) > 210;
	    select_enticement = [];
	    if (expand_to_see_details) {
	      select_enticement.push(DIV({
	        key: 1
	      }, is_selected ? "read less" : [
	        SPAN({
	          key: 1,
	          dangerouslySetInnerHTML: {
	            __html: '&hellip;'
	          }
	        }), A({
	          key: 2,
	          className: 'select_point'
	        }, t("read_more"))
	      ]));
	    }
	    if (point.comment_count > 0 || !expand_to_see_details) {
	      select_enticement.push(DIV({
	        key: 2,
	        style: {
	          whiteSpace: 'nowrap'
	        }
	      }, A({
	        className: 'select_point'
	      }, point.comment_count, " ", point.comment_count !== 1 ? t('comments') : t('comment'))));
	    }
	    if (point.assessment) {
	      select_enticement.push(DIV({
	        key: 3
	      }, I({
	        className: 'fa fa-search',
	        title: 'Click to read a fact-check of this point',
	        style: {
	          color: '#5E6B9E',
	          fontSize: 14,
	          cursor: 'help',
	          paddingLeft: 4
	        }
	      })));
	    }
	    point_style = {
	      position: 'relative',
	      listStyle: 'none outside none'
	    };
	    if (this.props.rendered_as === 'decision_board_point') {
	      _.extend(point_style, {
	        marginLeft: 9,
	        padding: '0 18px 0 18px'
	      });
	    } else if ((ref = this.props.rendered_as) === 'community_point' || ref === 'under_review') {
	      point_style.marginBottom = '0.5em';
	    }
	    includers_style = {
	      position: 'absolute',
	      height: 25,
	      width: 25
	    };
	    left_or_right = this.data().is_pro && !((ref1 = this.props.rendered_as) === 'decision_board_point' || ref1 === 'under_review') ? 'right' : 'left';
	    ioffset = (ref2 = this.props.rendered_as) === 'under_review' ? -10 : -50;
	    includers_style[left_or_right] = ioffset;
	    draw_all_includers = this.props.rendered_as === 'community_point' || (this.props.rendered_as !== 'under_review' && TWO_COL());
	    return LI({
	      key: "point-" + point.id,
	      'data-id': this.props.key,
	      className: "point " + this.props.rendered_as + " " + (point.is_pro ? 'pro' : 'con'),
	      onClick: this.selectPoint,
	      onTouchEnd: this.selectPoint,
	      style: point_style
	    }, this.props.rendered_as === 'community_point' && this.props.is_new ? renderNewIndicator() : void 0, this.props.rendered_as === 'decision_board_point' ? DIV({
	      style: {
	        position: 'absolute',
	        left: 0,
	        top: 0
	      }
	    }, this.data().is_pro ? '•' : '•') : DIV({
	      className: 'includers',
	      onMouseEnter: this.props.rendered_as !== 'under_review' ? this.highlightIncluders : void 0,
	      onMouseLeave: this.props.rendered_as !== 'under_review' ? this.unHighlightIncluders : void 0,
	      style: includers_style
	    }, renderIncluders(draw_all_includers)), DIV({
	      className: 'point_content',
	      style: point_content_style
	    }, this.props.rendered_as !== 'decision_board_point' ? (side = point.is_pro && this.props.rendered_as !== 'under_review' ? 'right' : 'left', mouth_style = {
	      top: 8,
	      position: 'absolute'
	    }, mouth_style[side] = -POINT_MOUTH_WIDTH + (is_selected || this.props.rendered_as === 'under_review' ? 3 : 1), !point.is_pro || this.props.rendered_as === 'under_review' ? mouth_style['transform'] = 'rotate(270deg) scaleX(-1)' : mouth_style['transform'] = 'rotate(90deg)', DIV({
	      key: 'community_point_mouth',
	      style: css.crossbrowserify(mouth_style)
	    }, Bubblemouth({
	      apex_xfrac: 0,
	      width: POINT_MOUTH_WIDTH,
	      height: POINT_MOUTH_WIDTH,
	      fill: considerit_gray,
	      stroke: is_selected ? focus_blue : 'transparent',
	      stroke_width: is_selected ? 20 : 0,
	      box_shadow: {
	        dx: '3',
	        dy: '0',
	        stdDeviation: "2",
	        opacity: .5
	      }
	    }))) : void 0, DIV({
	      style: {
	        wordWrap: 'break-word',
	        fontSize: POINT_FONT_SIZE()
	      }
	    }, DIV({
	      className: 'point_nutshell'
	    }, splitParagraphs(point.nutshell)), DIV({
	      className: "point_details" + (is_selected || this.props.rendered_as === 'under_review' ? '' : '_tease'),
	      style: {
	        wordWrap: 'break-word',
	        marginTop: '0.5em',
	        fontSize: POINT_FONT_SIZE(),
	        fontWeight: browser.high_density_display && !browser.is_mobile ? 300 : 400
	      }
	    }, point.text && point.text.length > 0 ? is_selected || !expand_to_see_details || this.props.rendered_as === 'under_review' ? splitParagraphs(point.text) : $("<span>" + point.text.slice(0, +(210 - point.nutshell.length) + 1 || 9e9) + "</span>").text() : void 0, select_enticement && this.props.rendered_as !== 'under_review' ? DIV({
	      style: {
	        fontSize: 12
	      }
	    }, select_enticement) : void 0)), DIV(null, permit('update point', point) > 0 && (this.props.rendered_as === 'decision_board_point' || TWO_COL()) ? A({
	      style: {
	        fontSize: browser.is_mobile ? 24 : 14,
	        color: focus_blue,
	        padding: '3px 12px 3px 0'
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      },
	      onClick: ((function(_this) {
	        return function(e) {
	          var points;
	          e.stopPropagation();
	          points = fetch(_this.props.your_points_key);
	          points.editing_points.push(_this.props.key);
	          return save(points);
	        };
	      })(this))
	    }, SPAN(null, t('edit'))) : void 0, permit('delete point', point) > 0 && (this.props.rendered_as === 'decision_board_point' || TWO_COL()) ? A({
	      'data-action': 'delete-point',
	      style: {
	        fontSize: browser.is_mobile ? 24 : 14,
	        color: focus_blue,
	        padding: '3px 8px'
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          if (confirm('Delete this point forever?')) {
	            return destroy(_this.props.key);
	          }
	        };
	      })(this)
	    }, SPAN(null, t('delete'))) : void 0)), TWO_COL() && this.props.rendered_as !== 'under_review' ? (your_opinion = fetch(this.proposal.your_opinion), (your_opinion != null ? your_opinion.published : void 0) ? can_opine = permit('update opinion', this.proposal, your_opinion) : can_opine = permit('publish opinion', this.proposal), included = this.included(), includePoint = (function(_this) {
	      return function(e) {
	        e.stopPropagation();
	        e.preventDefault();
	        if (!(e.type !== 'click' || (!browser.is_android_browser && e.type === 'click'))) {
	          return;
	        }
	        if (included) {
	          return _this.remove();
	        } else {
	          return _this.include();
	        }
	      };
	    })(this), DIV({
	      style: {
	        border: "1px solid " + (included || this.local.hover_important ? focus_blue : '#414141'),
	        borderTopColor: included ? focus_blue : 'transparent',
	        color: included ? 'white' : this.local.hover_important ? focus_blue : "#414141",
	        position: 'relative',
	        top: -13,
	        padding: '8px 5px',
	        textAlign: 'center',
	        borderRadius: '0 0 16px 16px',
	        cursor: 'pointer',
	        backgroundColor: included ? focus_blue : 'white',
	        fontSize: 18,
	        zIndex: 0,
	        display: can_opine < 0 ? 'none' : void 0
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.hover_important = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.hover_important = false;
	          return save(_this.local);
	        };
	      })(this),
	      onTouchEnd: includePoint,
	      onClick: includePoint
	    }, I({
	      className: 'fa fa-thumbs-o-up',
	      style: {
	        display: 'inline-block',
	        marginRight: 10
	      }
	    }), "Important point" + (included ? '' : '?'))) : void 0, is_selected ? Discussion({
	      key: "/comments/" + point.id,
	      point: point.key
	    }) : void 0);
	  },
	  componentDidMount: function() {
	    this.setDraggability();
	    return this.ensureDiscussionIsInViewPort();
	  },
	  componentDidUpdate: function() {
	    this.setDraggability();
	    return this.ensureDiscussionIsInViewPort();
	  },
	  ensureDiscussionIsInViewPort: function() {
	    var is_selected;
	    is_selected = get_selected_point() === this.props.key;
	    if (this.local.is_selected !== is_selected) {
	      if (is_selected) {
	        if (browser.is_mobile) {
	          $(this.getDOMNode()).moveToTop({
	            scroll: false
	          });
	        } else {
	          $(this.getDOMNode()).ensureInView({
	            scroll: false
	          });
	        }
	      }
	      this.local.is_selected = is_selected;
	      return save(this.local);
	    }
	  },
	  setDraggability: function() {
	    var $point_content, revert;
	    if (this.props.rendered_as === 'under_review') {
	      return;
	    }
	    $point_content = $(this.getDOMNode()).find('.point_content');
	    revert = this.props.rendered_as === 'community_point' ? 'invalid' : (function(_this) {
	      return function(valid) {
	        if (!valid) {
	          _this.remove();
	        }
	        return valid;
	      };
	    })(this);
	    if ($point_content.hasClass("ui-draggable")) {
	      return $point_content.draggable(this.props.enable_dragging ? 'enable' : 'disable');
	    } else {
	      return $point_content.draggable({
	        revert: revert,
	        disabled: !this.props.enable_dragging
	      });
	    }
	  },
	  included: function() {
	    var your_opinion;
	    your_opinion = fetch(this.proposal.your_opinion);
	    return your_opinion.point_inclusions.indexOf(this.props.key) > -1;
	  },
	  remove: function() {
	    var your_opinion;
	    your_opinion = fetch(this.proposal.your_opinion);
	    your_opinion.point_inclusions = _.without(your_opinion.point_inclusions, this.props.key);
	    save(your_opinion);
	    return window.writeToLog({
	      what: 'removed point',
	      details: {
	        point: this.props.key
	      }
	    });
	  },
	  include: function() {
	    var your_opinion;
	    your_opinion = fetch(this.proposal.your_opinion);
	    your_opinion.point_inclusions.push(this.data().key);
	    save(your_opinion);
	    return window.writeToLog({
	      what: 'included point',
	      details: {
	        point: this.data().key
	      }
	    });
	  },
	  selectPoint: function(e) {
	    var loc, what;
	    if (this.props.rendered_as === 'under_review') {
	      return;
	    }
	    e.stopPropagation();
	    if (!((browser.is_mobile && e.type !== 'click') || (!browser.is_mobile && e.type === 'click'))) {
	      return;
	    }
	    loc = fetch('location');
	    if (get_selected_point() === this.props.key) {
	      delete loc.query_params.selected;
	      what = 'deselected a point';
	    } else {
	      what = 'selected a point';
	      loc.query_params.selected = this.props.key;
	    }
	    save(loc);
	    return window.writeToLog({
	      what: what,
	      details: {
	        point: this.props.key
	      }
	    });
	  },
	  highlightIncluders: function() {
	    var hist, includers, point;
	    point = this.data();
	    includers = point.includers;
	    if (point.hide_name) {
	      includers = _.without(includers, point.user);
	    }
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    if (hist.highlighted_users !== includers) {
	      hist.highlighted_users = includers;
	      return save(hist);
	    }
	  },
	  unHighlightIncluders: function() {
	    var hist;
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    hist.highlighted_users = null;
	    return save(hist);
	  },
	  buildIncluders: function() {
	    var hist, includers, o, point, selected_opinions, selected_users;
	    point = this.data();
	    includers = point.includers;
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    selected_opinions = hist.selected_opinion ? [hist.selected_opinion] : hist.selected_opinions;
	    if ((selected_opinions != null ? selected_opinions.length : void 0) > 0) {
	      selected_users = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = selected_opinions.length; j < len; j++) {
	          o = selected_opinions[j];
	          results.push(fetch(o).user);
	        }
	        return results;
	      })();
	      includers = _.intersection(includers, selected_users);
	    }
	    if (true) {
	      includers = _.without(includers, point.user);
	      includers.push(point.user);
	    }
	    return _.uniq(includers);
	  }
	});

	styles += "\n/* war! disabled jquery UI draggable class defined with !important */\n.point_content.ui-draggable-disabled {\n  cursor: pointer !important; }\n\n" + (css.grab_cursor('.point_content.ui-draggable')) + "\n\n.community_point .point_content, .under_review .point_content {\n  border-radius: 16px;\n  padding: 0.5em 9px;\n  background-color: " + considerit_gray + ";\n  box-shadow: #b5b5b5 0 1px 1px 0px;\n  min-height: 34px; }\n\n.point_nutshell a { text-decoration: underline; }\n.point_details_tease a, .point_details a {\n  text-decoration: underline;\n  word-break: break-all; }\n.point_details a.select_point{text-decoration: none;}\n\n.point_details {\n  display: block; }\n\n.point_details_tease {\n  cursor: pointer; }\n  .point_details_tease a.select_point {\n    text-decoration: none; }\n    .point_details_tease a.select_point:hover {\n      text-decoration: underline; }\n\n.point_details p {\n  margin-bottom: 1em; }\n\n.point_details p:last-child {\n  margin-bottom: 0; }\n\n.under_review .point_includer_avatar {\n  top: 0px;\n  width: 50px;\n  height: 50px;\n  left: -64px;\n  box-shadow: -1px 2px 0 0 #eeeeee; }\n\n.point_includer_avatar {\n  width: 22px;\n  height: 22px; }\n\n.community_point.con .point_includer_avatar {\n  box-shadow: -1px 2px 0 0 #eeeeee; }\n\n.community_point.pro .point_includer_avatar {\n  box-shadow: 1px 2px 0 0 #eeeeee; }\n\n.decision_board_point.pro .point_includer_avatar {\n  left: -10px; }\n";

	window.Comment = ReactiveComponent({
	  displayName: 'Comment',
	  render: function() {
	    var comment, comment_action_style;
	    comment = this.data();
	    if (comment.editing) {
	      return EditComment({
	        fresh: false,
	        point: comment.point,
	        key: comment.key
	      });
	    } else {
	      return DIV({
	        className: 'comment_entry'
	      }, DIV({
	        className: 'comment_entry_name'
	      }, fetch(comment.user).name + ':'), Avatar({
	        key: comment.user,
	        hide_tooltip: true,
	        style: {
	          position: 'absolute',
	          width: 50,
	          height: 50
	        }
	      }), DIV({
	        className: 'comment_entry_body'
	      }, splitParagraphs(comment.body)), permit('update comment', comment) > 0 && !this.props.under_review ? (comment_action_style = {
	        color: '#444',
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        paddingRight: 10
	      }, DIV({
	        style: {
	          marginLeft: 60
	        }
	      }, SPAN({
	        'data-action': 'delete-comment',
	        style: comment_action_style,
	        onClick: (function(_this) {
	          return function(key) {
	            return function(e) {
	              e.stopPropagation();
	              if (confirm('Delete this comment forever?')) {
	                return destroy(key);
	              }
	            };
	          };
	        })(this)(comment.key)
	      }, t('delete')), SPAN({
	        style: comment_action_style,
	        onClick: (function(_this) {
	          return function(key) {
	            return function(e) {
	              e.stopPropagation();
	              comment.editing = true;
	              return save(comment);
	            };
	          };
	        })(this)(comment.key)
	      }, t('edit')))) : void 0);
	    }
	  }
	});

	styles += ".comment_entry {\n  margin-bottom: 45px;\n  min-height: 60px;\n  position: relative; }\n\n.comment_entry_name {\n  font-weight: 600;\n  color: #666666; }\n\n.comment_entry_body {\n  margin-left: 60px;\n  word-wrap: break-word;\n  position: relative; }\n  .comment_entry_body a {\n    text-decoration: underline; }\n  .comment_entry_body strong {\n    font-weight: 600; }\n  .comment_entry_body p {\n    margin-bottom: 1em; }";

	window.FactCheck = ReactiveComponent({
	  displayName: 'FactCheck',
	  render: function() {
	    var assessment, claim, verdict;
	    assessment = this.data();
	    return DIV({
	      className: 'comment_entry'
	    }, DIV({
	      className: 'comment_entry_name'
	    }, 'Fact check by Seattle Public Library:'), DIV({
	      className: 'magnifying_glass'
	    }, I({
	      className: 'fa fa-search'
	    })), DIV({
	      className: 'comment_entry_body'
	    }, (function() {
	      var j, len, ref, results;
	      ref = assessment.claims;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        claim = ref[j];
	        claim = fetch(claim.key);
	        verdict = fetch(claim.verdict);
	        results.push([
	          DIV({
	            style: {
	              margin: '10px 0'
	            }
	          }, IMG({
	            style: {
	              position: 'absolute',
	              width: 25,
	              left: -40
	            },
	            src: verdict.icon
	          }), 'Claim: ', SPAN({
	            style: {
	              fontWeight: 600
	            }
	          }, claim.claim_restatement)), DIV(null, SPAN({
	            style: {
	              cursor: 'help'
	            },
	            title: verdict.desc
	          }, 'Rating: ', SPAN({
	            style: {
	              fontStyle: 'italic'
	            }
	          }, verdict.name))), DIV({
	            style: {
	              margin: '10px 0'
	            },
	            dangerouslySetInnerHTML: {
	              __html: claim.result
	            }
	          })
	        ]);
	      }
	      return results;
	    })()));
	  }
	});

	styles += ".magnifying_glass {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  font-size: 50px;\n  margin-top: -9px;\n  color: #5e6b9e; }";

	window.Discussion = ReactiveComponent({
	  displayName: 'Discussion',
	  render: function() {
	    var comment, comments, discussion_style, in_wings, is_pro, mouth_style, point, point_included, proposal, side, trans_func, your_opinion;
	    point = fetch(this.props.point);
	    proposal = fetch(point.proposal);
	    is_pro = point.is_pro;
	    your_opinion = fetch(proposal.your_opinion);
	    point_included = _.contains(your_opinion.point_inclusions, point.key);
	    in_wings = get_proposal_mode() === 'crafting' && !point_included;
	    comments = this.discussion.comments;
	    if (this.discussion.assessment) {
	      comments = comments.slice();
	      comments.push(this.discussion.assessment);
	    }
	    comments.sort(function(a, b) {
	      return a.created_at > b.created_at;
	    });
	    discussion_style = {
	      width: DECISION_BOARD_WIDTH(),
	      border: "3px solid " + focus_blue,
	      position: 'absolute',
	      zIndex: 100,
	      padding: '20px 40px',
	      borderRadius: 16,
	      backgroundColor: 'white'
	    };
	    side = is_pro ? 'right' : 'left';
	    if (in_wings) {
	      discussion_style[side] = POINT_WIDTH() + 10;
	      discussion_style['top'] = 44;
	    } else {
	      discussion_style[side] = is_pro ? -23 : -30;
	      discussion_style['marginTop'] = 18;
	    }
	    mouth_style = {
	      position: 'absolute'
	    };
	    if (in_wings) {
	      mouth_style[side] = -29;
	      trans_func = 'rotate(270deg)';
	      if (is_pro) {
	        trans_func += ' scaleY(-1)';
	      }
	      _.extend(mouth_style, {
	        transform: trans_func,
	        top: 19
	      });
	    } else {
	      _.extend(mouth_style, {
	        left: is_pro ? 335 : 100,
	        top: -28,
	        transform: !is_pro ? 'scaleX(-1)' : void 0
	      });
	    }
	    return DIV({
	      style: discussion_style,
	      onClick: function(e) {
	        return e.stopPropagation();
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      }
	    }, DIV({
	      style: css.crossbrowserify(mouth_style)
	    }, Bubblemouth({
	      apex_xfrac: 1.1,
	      width: 36,
	      height: 28,
	      fill: 'white',
	      stroke: focus_blue,
	      stroke_width: 11
	    })), SubmitFactCheck(), H1({
	      style: {
	        textAlign: 'left',
	        fontSize: 30,
	        color: focus_blue,
	        marginLeft: 60,
	        marginBottom: 25,
	        marginTop: 24,
	        fontWeight: 600
	      }
	    }, t('Discuss this Point')), DIV({
	      className: 'comments'
	    }, (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = comments.length; j < len; j++) {
	        comment = comments[j];
	        if (comment.key.match(/(comment)/)) {
	          results.push(Comment({
	            key: comment.key
	          }));
	        } else {
	          results.push(FactCheck({
	            key: comment.key
	          }));
	        }
	      }
	      return results;
	    })()), EditComment({
	      fresh: true,
	      point: arest.key_id(this.props.key)
	    }));
	  },
	  componentDidUpdate: function() {
	    return this.setHeight();
	  },
	  componentDidMount: function() {
	    return this.setHeight();
	  },
	  setHeight: function() {
	    var dist_from_parent, open_point_height, s;
	    s = fetch('reasons_height_adjustment');
	    dist_from_parent = $(this.getDOMNode()).offset().top - $('.reasons_region').offset().top;
	    open_point_height = $(this.getDOMNode()).height() + dist_from_parent;
	    if (s.open_point_height !== open_point_height) {
	      s.open_point_height = open_point_height;
	      return save(s);
	    }
	  }
	});

	window.SubmitFactCheck = ReactiveComponent({
	  displayName: 'SubmitFactCheck',
	  render: function() {
	    var a_librarian_will_respond, fact_check_completed, logged_in, r, ref, request_a_fact_check, request_a_factcheck, request_completed, request_in_progress, top_message_style, your_requests;
	    if (!this.proposal.assessment_enabled) {
	      return SPAN(null);
	    }
	    logged_in = fetch('/current_user').logged_in;
	    request_a_fact_check = (function(_this) {
	      return function() {
	        return [
	          DIV({
	            style: {
	              fontStyle: 'italic',
	              cursor: 'pointer'
	            }
	          }, 'Confused by a claim that this point makes? ', SPAN({
	            style: {
	              textDecoration: 'underline',
	              color: logo_red,
	              fontWeight: 600
	            },
	            onClick: (function() {
	              if (_this.local.state === 'blank slate') {
	                _this.local.state = 'clicked';
	              } else if (_this.local.state === 'clicked') {
	                _this.local.state = 'blank slate';
	              }
	              return save(_this.local);
	            })
	          }, 'Request a Fact Check'), ' from The Seattle Public Library')
	        ];
	      };
	    })(this);
	    a_librarian_will_respond = (function(_this) {
	      return function(width) {
	        return DIV({
	          style: {
	            maxWidth: width
	          }
	        }, 'A ', A({
	          style: {
	            textDecoration: 'underline'
	          },
	          target: '_blank',
	          href: '/about#fact_check'
	        }, 'librarian will respond'), ' within 48 hours');
	      };
	    })(this);
	    request_a_factcheck = (function(_this) {
	      return function() {
	        if (permit('request factcheck', _this.proposal) > 0) {
	          return [
	            DIV({
	              style: {
	                marginTop: 12
	              }
	            }, 'What factual claim do you want researched?'), AutoGrowTextArea({
	              className: 'new_request',
	              style: {
	                width: '100%',
	                height: 60,
	                lineHeight: 1.4,
	                fontSize: 16,
	                padding: '3px 8px'
	              },
	              placeholder: (logged_in && 'Your research question') || '',
	              disabled: !logged_in,
	              onChange: function(e) {
	                _this.local.research_question = e.target.value;
	                return save(_this.local);
	              }
	            }), BUTTON({
	              style: {
	                backgroundColor: focus_blue,
	                borderRadius: 8,
	                color: 'white',
	                padding: '3px 10px',
	                display: 'inline-block',
	                fontWeight: 600,
	                textAlign: 'center',
	                cursor: 'pointer',
	                float: 'right',
	                fontSize: 18,
	                border: 'none'
	              },
	              onClick: function(e) {
	                var request;
	                e.stopPropagation();
	                request = {
	                  key: '/new/request',
	                  suggestion: _this.local.research_question,
	                  point: "/point/" + (arest.key_id(_this.discussion.key))
	                };
	                save(request);
	                $(_this.getDOMNode()).find('.new_request').val('');
	                _this.local.state = 'requested';
	                return save(_this.local);
	              }
	            }, 'submit'), a_librarian_will_respond(300)
	          ];
	        } else {
	          return DIV({
	            onClick: function(e) {
	              e.stopPropagation();
	              return reset_key('auth', {
	                form: 'login',
	                goal: 'Request a Fact Check'
	              });
	            },
	            style: {
	              marginTop: 14,
	              textDecoration: 'underline',
	              color: focus_blue,
	              cursor: 'pointer'
	            }
	          }, 'Log in to request a fact check');
	        }
	      };
	    })(this);
	    top_message_style = {
	      marginBottom: 0,
	      fontStyle: 'italic'
	    };
	    request_in_progress = (function(_this) {
	      return function() {
	        return DIV(null, DIV({
	          style: top_message_style
	        }, 'You have requested a Fact Check from The Seattle Public Library'), a_librarian_will_respond());
	      };
	    })(this);
	    request_completed = (function(_this) {
	      return function() {
	        var overall_verdict;
	        overall_verdict = fetch(_this.discussion.assessment.verdict);
	        return [
	          DIV({
	            style: top_message_style
	          }, 'This point has been ', A({
	            style: {
	              textDecoration: 'underline'
	            },
	            target: '_blank',
	            href: '/about#fact_check'
	          }, 'Fact-checked'), ' by The Seattle Public Library. See the librarians\' research below.'), DIV({
	            style: {
	              marginBottom: 10
	            }
	          }, A({
	            style: {
	              textDecoration: 'underline'
	            }
	          }, ''))
	        ];
	      };
	    })(this);
	    this.local.state = this.local.state || 'blank slate';
	    your_requests = (function() {
	      var j, len, ref, results;
	      ref = this.discussion.requests || [];
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        r = ref[j];
	        if (r.user === fetch('/current_user').user) {
	          results.push(r);
	        }
	      }
	      return results;
	    }).call(this);
	    fact_check_completed = ((ref = this.discussion.claims) != null ? ref.length : void 0) > 0;
	    if (fact_check_completed) {
	      this.local.state = 'verdict';
	    } else if (your_requests.length > 0) {
	      this.local.state = 'requested';
	    }
	    return DIV({
	      style: {}
	    }, DIV({
	      style: {
	        marginLeft: 0
	      }
	    }, (function() {
	      switch (this.local.state) {
	        case 'blank slate':
	          return request_a_fact_check();
	        case 'clicked':
	          return [request_a_fact_check(), request_a_factcheck()];
	        case 'requested':
	          return request_in_progress();
	        case 'verdict':
	          return request_completed();
	      }
	    }).call(this)));
	  }
	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var AddRolesAndInvite, ProposalRoles, SpecifyRoles, SubdomainRoles, UserWithRole, UsersWithRole, all_roles;

	__webpack_require__(4);

	__webpack_require__(16);

	__webpack_require__(3);

	all_roles = function() {
	  var all, con_label, pro_label;
	  pro_label = customization('point_labels.pro');
	  con_label = customization('point_labels.con');
	  all = [
	    {
	      name: 'editor',
	      label: 'Editors',
	      description: 'Can modify the description of the proposal, as well as ' + 'write, comment, and opine.',
	      icon: 'fa-edit',
	      wildcard: {
	        label: 'Any registered user who can observe can edit',
	        "default": false
	      }
	    }, {
	      name: 'writer',
	      label: 'Writers',
	      description: ("Can write " + pro_label + " and " + con_label + " points that are ") + "shared with others. Any writer can comment and opine.",
	      icon: 'fa-th-list',
	      wildcard: {
	        label: 'Any registered user who can observe can write',
	        "default": true
	      }
	    }, {
	      name: 'commenter',
	      label: 'Commenters',
	      description: "Can comment on " + pro_label + " and " + con_label + " points.",
	      icon: 'fa-comment',
	      wildcard: {
	        label: 'Any registered user who can observe can comment',
	        "default": true
	      }
	    }, {
	      name: 'opiner',
	      label: 'Opiners',
	      description: 'Can drag the slider and build a list of other people\'s Pros/Cons, but can\'t write new Pros, Cons or Comments.',
	      icon: 'fa-bar-chart',
	      wildcard: {
	        label: 'Any registered user who can observe can opine',
	        "default": true
	      }
	    }, {
	      name: 'observer',
	      label: 'Observers',
	      description: 'Can access this proposal. But that\'s it.',
	      icon: 'fa-eye',
	      wildcard: {
	        label: "Public. Anyone can view",
	        "default": true
	      }
	    }
	  ];
	  all = _.compact(all);
	  return all;
	};

	ProposalRoles = ReactiveComponent({
	  displayName: 'ProposalRoles',
	  render: function() {
	    var current_user, proposal, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    proposal = fetch(this.props.key);
	    if (!proposal.roles) {
	      InitializeProposalRoles(proposal);
	    }
	    return SpecifyRoles(proposal, all_roles());
	  }
	});

	window.InitializeProposalRoles = function(proposal) {
	  var current_user, i, len, ref, role, subdomain;
	  current_user = fetch('/current_user');
	  subdomain = fetch('/subdomain');
	  proposal.roles = {};
	  ref = all_roles();
	  for (i = 0, len = ref.length; i < len; i++) {
	    role = ref[i];
	    proposal.roles[role.name] = [];
	    if (role.wildcard && role.wildcard["default"]) {
	      if (role.name === 'observer') {
	        proposal.roles[role.name] = subdomain.roles['visitor'].slice();
	      } else {
	        proposal.roles[role.name].push('*');
	      }
	    }
	  }
	  return proposal.roles['editor'].push("/user/" + current_user.id);
	};

	SubdomainRoles = ReactiveComponent({
	  displayName: 'SubdomainRoles',
	  render: function() {
	    var roles, subdomain;
	    subdomain = fetch('/subdomain');
	    roles = [
	      {
	        name: 'admin',
	        label: 'Administrators',
	        description: 'Can configure everything related to this site, including all of the below.',
	        icon: 'fa-wrench'
	      }, {
	        name: 'moderator',
	        label: 'Moderators',
	        description: 'Can moderate user content. Will receive emails for content needing moderation.',
	        icon: 'fa-fire-extinguisher'
	      }, subdomain.assessment_enabled ? {
	        name: 'evaluator',
	        label: 'Fact checkers',
	        description: 'Can validate claims. Will receive emails when a fact-check is requested.',
	        icon: 'fa-flag-checkered'
	      } : null, {
	        name: 'proposer',
	        label: 'Proposers',
	        description: 'Can add new proposals.',
	        icon: 'fa-lightbulb-o',
	        wildcard: {
	          label: 'Any registered visitor can post new proposals',
	          "default": true
	        }
	      }, {
	        name: 'visitor',
	        label: 'Visitors',
	        description: 'Default users who can view proposals.',
	        icon: 'fa-android',
	        wildcard: {
	          label: 'Proposals are public by default.',
	          "default": true
	        }
	      }
	    ];
	    roles = _.compact(roles);
	    return DIV(null, DashHeader({
	      name: 'User Roles'
	    }), DIV({
	      style: {
	        width: BODY_WIDTH(),
	        margin: 'auto'
	      }
	    }, SpecifyRoles(subdomain, roles)));
	  }
	});

	SpecifyRoles = function(target, roles) {
	  var idx, role;
	  return DIV(null, (function() {
	    var i, len, results;
	    results = [];
	    for (idx = i = 0, len = roles.length; i < len; idx = ++i) {
	      role = roles[idx];
	      results.push(DIV({
	        key: role.name,
	        style: {
	          marginTop: 24
	        }
	      }, H1({
	        style: {
	          fontSize: 18,
	          position: 'relative'
	        }
	      }, I({
	        className: "fa " + role.icon,
	        style: {
	          position: 'absolute',
	          top: 2,
	          left: -35,
	          fontSize: 24
	        }
	      }), role.label), SPAN({
	        style: {
	          fontSize: 14
	        }
	      }, role.description), UsersWithRole({
	        key: role.name,
	        target: target,
	        role: role
	      })));
	    }
	    return results;
	  })(), DIV({
	    style: {
	      marginLeft: -35,
	      marginTop: 12
	    }
	  }, AddRolesAndInvite({
	    key: 'roles_and_invite',
	    roles: roles,
	    target: target
	  })));
	};

	AddRolesAndInvite = ReactiveComponent({
	  displayName: 'Invite',
	  render: function() {
	    var available_users, idx, processNewFolks, role, target, user, user_key, users;
	    target = fetch(this.props.target);
	    users = fetch('/users');
	    if (!this.local.role) {
	      this.local.added = [];
	      this.local.role = this.props.roles[0];
	      save(this.local);
	    }
	    processNewFolks = (function(_this) {
	      return function() {
	        var $filter, candidate_email, candidates, i, len;
	        $filter = $(_this.getDOMNode()).find('#filter');
	        candidates = $filter.val();
	        $filter.val('');
	        if (candidates) {
	          candidates = candidates.split(',');
	          for (i = 0, len = candidates.length; i < len; i++) {
	            candidate_email = candidates[i];
	            candidate_email = candidate_email.trim();
	            if (candidate_email.indexOf(' ') < 0 && candidate_email.indexOf('@') > 0 && candidate_email.indexOf('.') > 0) {
	              _this.local.added.push(candidate_email);
	            }
	          }
	          return save(_this.local);
	        }
	      };
	    })(this);
	    return DIV({
	      style: {
	        position: 'relative',
	        backgroundColor: '#E7F2FF',
	        padding: '18px 24px'
	      }
	    }, STYLE(null, ".invite_menu_item:hover{background-color: #414141; color: white}"), DIV({
	      style: {
	        fontWeight: 500,
	        fontSize: 18,
	        marginBottom: 6,
	        display: 'inline-block'
	      }
	    }, DIV({
	      id: 'select_new_role',
	      style: {
	        backgroundColor: 'rgba(100,100,150,.1)',
	        padding: '8px 12px',
	        borderRadius: 8,
	        cursor: 'pointer'
	      },
	      onClick: (function(_this) {
	        return function() {
	          $(document).on('click.select_new_role', function(e) {
	            if (e.target.id !== 'select_new_role') {
	              _this.local.select_new_role = false;
	              save(_this.local);
	              return $(document).off('click.select_new_role');
	            }
	          });
	          _this.local.select_new_role = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, I({
	      className: "fa " + this.local.role.icon,
	      style: {
	        displayName: 'inline-block',
	        margin: '0 8px 0 0'
	      }
	    }), "Add " + this.local.role.label, I({
	      style: {
	        marginLeft: 8
	      },
	      className: "fa fa-caret-down"
	    })), this.local.select_new_role ? UL({
	      style: {
	        width: 500,
	        position: 'absolute',
	        zIndex: 99,
	        listStyle: 'none',
	        backgroundColor: '#fff',
	        border: '1px solid #eee'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = this.props.roles;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        role = ref[idx];
	        if (role.name !== this.local.role.name) {
	          results.push(LI({
	            className: 'invite_menu_item',
	            style: {
	              padding: '2px 12px',
	              fontSize: 18,
	              cursor: 'pointer',
	              borderBottom: '1px solid #fafafa'
	            },
	            key: idx,
	            onClick: (function(_this) {
	              return function(role) {
	                return function(e) {
	                  _this.local.role = role;
	                  save(_this.local);
	                  return e.stopPropagation();
	                };
	              };
	            })(this)(role)
	          }, I({
	            className: "fa " + role.icon,
	            style: {
	              displayName: 'inline-block',
	              margin: '0 8px 0 0'
	            }
	          }), "Add " + role.label));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this)) : void 0), this.local.added.length > 0 ? DIV(null, (function() {
	      var i, len, ref, results;
	      ref = this.local.added;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        user_key = ref[idx];
	        results.push(UserWithRole(user_key, (function(_this) {
	          return function(user_key) {
	            _this.local.added = _.without(_this.local.added, user_key);
	            return save(_this.local);
	          };
	        })(this)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV(null, INPUT({
	      id: 'filter',
	      type: 'text',
	      style: {
	        fontSize: 18,
	        width: 350,
	        padding: '3px 6px'
	      },
	      autoComplete: 'off',
	      placeholder: "Name or email...",
	      onChange: (function(_this) {
	        return function() {
	          _this.local.filtered = $(_this.getDOMNode()).find('#filter').val();
	          return save(_this.local);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 13) {
	            e.preventDefault();
	            return processNewFolks();
	          }
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.selecting = true;
	          save(_this.local);
	          e.stopPropagation();
	          $(document).on('click.roles', function(e) {
	            if (e.target.id !== 'filter') {
	              processNewFolks();
	              _this.local.selecting = false;
	              _this.local.filtered = null;
	              save(_this.local);
	              return $(document).off('click.roles');
	            }
	          });
	          return false;
	        };
	      })(this)
	    })), this.local.selecting ? (available_users = _.filter(users.users, (function(_this) {
	      return function(u) {
	        return target.roles[_this.local.role.name].indexOf(u.key) < 0 && _this.local.added.indexOf(u.key) < 0 && (!_this.local.filtered || (u.name + " <" + u.email + ">").indexOf(_this.local.filtered) > -1);
	      };
	    })(this)), available_users.length > 0 ? UL({
	      style: {
	        width: 500,
	        position: 'absolute',
	        zIndex: 99,
	        listStyle: 'none',
	        backgroundColor: '#fff',
	        border: '1px solid #eee'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = available_users.length; i < len; idx = ++i) {
	        user = available_users[idx];
	        results.push(LI({
	          className: 'invite_menu_item',
	          style: {
	            padding: '2px 12px',
	            fontSize: 18,
	            cursor: 'pointer',
	            borderBottom: '1px solid #fafafa'
	          },
	          key: idx,
	          onClick: (function(_this) {
	            return function(user) {
	              return function(e) {
	                _this.local.added.push(user.key);
	                save(_this.local);
	                return e.stopPropagation();
	              };
	            };
	          })(this)(user)
	        }, user.name + " <" + user.email + ">"));
	      }
	      return results;
	    }).call(this)) : void 0) : void 0, DIV({
	      style: {
	        marginTop: 20
	      }
	    }, INPUT({
	      type: 'checkbox',
	      id: 'send_email_invite',
	      name: 'send_email_invite',
	      onClick: (function(_this) {
	        return function() {
	          _this.local.send_email_invite = !_this.local.send_email_invite;
	          return save(_this.local);
	        };
	      })(this)
	    }), LABEL({
	      htmlFor: 'send_email_invite'
	    }, 'Send email invitation'), this.local.send_email_invite ? DIV({
	      style: {
	        marginLeft: 20,
	        marginTop: 10
	      }
	    }, AutoGrowTextArea({
	      id: 'custom_email_message',
	      name: 'custom_email_message',
	      placeholder: '(optional) custom message',
	      style: {
	        width: '90%',
	        fontSize: 18,
	        padding: '8px 14px'
	      }
	    })) : void 0), DIV({
	      style: {
	        backgroundColor: focus_blue,
	        color: 'white',
	        padding: '8px 14px',
	        fontSize: 16,
	        display: 'inline-block',
	        cursor: 'pointer',
	        borderRadius: 8,
	        marginTop: 12
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          var invitation;
	          if (_this.local.added.length > 0) {
	            target.roles[_this.local.role.name] = target.roles[_this.local.role.name].concat(_this.local.added);
	            if (_this.local.send_email_invite) {
	              if (!target.invitations) {
	                target.invitations = [];
	              }
	              invitation = {
	                role: _this.local.role.name,
	                keys_or_emails: _this.local.added
	              };
	              invitation.message = $('#custom_email_message').val();
	              target.invitations.push(invitation);
	            }
	            _this.local.added = [];
	            save(target);
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, 'Done. Add these roles.'));
	  }
	});

	UsersWithRole = ReactiveComponent({
	  displayName: 'UsersWithRole',
	  render: function() {
	    var role, target, user_key;
	    target = fetch(this.props.target);
	    role = this.props.role;
	    return DIV({
	      style: {
	        marginLeft: -4
	      }
	    }, role.wildcard ? DIV(null, INPUT({
	      id: "wildcard-" + role.name,
	      name: "wildcard-" + role.name,
	      type: 'checkbox',
	      defaultChecked: target.roles[role.name].indexOf('*') > -1,
	      onChange: function() {
	        if ($("#wildcard-" + role.name).is(':checked')) {
	          target.roles[role.name].push('*');
	        } else {
	          target.roles[role.name] = _.without(target.roles[role.name], '*');
	        }
	        return save(target);
	      }
	    }), LABEL({
	      htmlFor: "wildcard-" + role.name
	    }, role.wildcard.label)) : !target.roles[role.name] || target.roles[role.name].length === 0 ? DIV({
	      style: {
	        fontStyle: 'italic',
	        margin: 4
	      }
	    }, 'None') : void 0, (function() {
	      var i, len, ref, results;
	      if (target.roles[role.name]) {
	        ref = target.roles[role.name];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          user_key = ref[i];
	          if (user_key !== '*') {
	            results.push(UserWithRole(user_key, (function(_this) {
	              return function(user_key) {
	                var invite, j, len1, ref1;
	                target.roles[role.name] = _.without(target.roles[role.name], user_key);
	                if (target.invitations) {
	                  ref1 = target.invitations;
	                  for (j = 0, len1 = ref1.length; j < len1; j++) {
	                    invite = ref1[j];
	                    if (invite.role === role.name) {
	                      invite.keys_or_emails = _.without(invite.keys_or_emails, user_key);
	                    }
	                  }
	                }
	                return save(target);
	              };
	            })(this)));
	          } else {
	            results.push(void 0);
	          }
	        }
	        return results;
	      }
	    }).call(this));
	  }
	});

	UserWithRole = function(user_key, on_remove_from_role) {
	  var user;
	  return SPAN({
	    key: user_key,
	    style: {
	      display: 'inline-block',
	      padding: '6px 12px',
	      fontSize: 13,
	      backgroundColor: 'rgb(217, 227, 244)',
	      color: 'black',
	      borderRadius: 8,
	      margin: 4
	    }
	  }, SPAN(null, user_key && user_key[0] === '/' ? (user = fetch(user_key), SPAN(null, user.avatar_file_name ? Avatar({
	    key: user_key,
	    hide_tooltip: true,
	    style: {
	      width: 20,
	      height: 20,
	      marginRight: 5
	    }
	  }) : void 0, user.name ? user.name : user.email)) : user_key), SPAN({
	    style: {
	      cursor: 'pointer',
	      marginLeft: 8
	    },
	    onClick: function() {
	      if (on_remove_from_role) {
	        return on_remove_from_role(user_key);
	      }
	    }
	  }, 'x'));
	};

	window.SubdomainRoles = SubdomainRoles;

	window.ProposalRoles = ProposalRoles;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(2)))

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(React) {var addGradient, addSVGDefs, collide, el, nodeSize, pretty_print, refresh_data, transform_to_d3, xor,
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	__webpack_require__(19);

	__webpack_require__(66);

	fetch('state_graph', {
	  on: false,
	  show_component_parent_child_relations: false,
	  show_unused_data: false,
	  show_data_dependencies: true,
	  removed_nodes: [],
	  focus: null
	});

	document.addEventListener("keypress", function(e) {
	  var graph, key;
	  key = (e && e.keyCode) || e.keyCode;
	  if (key === 7) {
	    graph = fetch('state_graph');
	    graph.on = !graph.on;
	    return save(graph);
	  }
	});

	for (el in React.DOM) {
	  if (!window[el.toUpperCase()]) {
	    this[el.toUpperCase()] = React.DOM[el];
	  }
	}

	window.StateGraph = ReactiveComponent({
	  displayName: 'State Graph',
	  render: function() {
	    var control_button, controls, counter, digit, focus, graph, idx, inst, instructions, k, l, label, max_digits, n, num, num_components, num_data_entries, num_dependencies, pad, para, prop, text, v;
	    graph = fetch('state_graph');
	    if (this.local.nodes == null) {
	      this.local.nodes = {};
	      this.local.links = {};
	      save(this.local);
	    }
	    if (!graph.on) {
	      return SPAN(null);
	    }
	    num_components = ((function() {
	      var ref, results;
	      ref = this.local.nodes;
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        n = ref[k];
	        if (!n.is_key) {
	          results.push(n);
	        }
	      }
	      return results;
	    }).call(this)).length.toString();
	    num_data_entries = ((function() {
	      var ref, results;
	      ref = this.local.nodes;
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        n = ref[k];
	        if (n.is_key) {
	          results.push(n);
	        }
	      }
	      return results;
	    }).call(this)).length.toString();
	    num_dependencies = ((function() {
	      var ref, results;
	      ref = this.local.links;
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        l = ref[k];
	        if (xor(this.local.nodes[k.split(',')[0]].is_key, this.local.nodes[k.split(',')[1]].is_key)) {
	          results.push(l);
	        }
	      }
	      return results;
	    }).call(this)).length.toString();
	    pad = function(num, len) {
	      var i, str;
	      str = num.toString();
	      i = 0;
	      while (i < len - num.toString().length) {
	        str = "0" + str;
	        i += 1;
	      }
	      return str;
	    };
	    max_digits = Math.max(num_dependencies.length, num_components.length, num_data_entries.length);
	    counter = [[pad(num_components, max_digits), 'components'], [pad(num_data_entries, max_digits), 'data entries'], [pad(num_dependencies, max_digits), 'dependencies']];
	    instructions = ['Drag/click any node to fix its position', 'Shift+click a fixed node to free it', 'Click a data node to see its values', 'Alt+click a node to remove it'];
	    controls = [['parent-child links', 'show_component_parent_child_relations'], ['data dependencies', 'show_data_dependencies'], ['unused_data', 'show_unused_data']];
	    control_button = function(label, prop) {
	      var active;
	      active = graph[prop];
	      return SPAN({
	        style: {
	          borderRadius: 8,
	          border: "1px solid " + (active ? '#88EB39' : 'black'),
	          fontSize: 24,
	          fontFamily: 'Orbitron, sans-serif',
	          padding: '12px 20px 8px 20px',
	          color: active ? "#56BA06" : 'black',
	          cursor: 'pointer',
	          marginRight: 20
	        },
	        onClick: function() {
	          graph[prop] = !graph[prop];
	          return save(graph);
	        }
	      }, label);
	    };
	    return DIV({
	      style: {
	        backgroundColor: 'white',
	        zIndex: 9999999,
	        padding: '20px 5px 20px 50px'
	      }
	    }, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        fontSize: 65,
	        color: 'black',
	        WebkitTextFillColor: 'white',
	        WebkitTextStrokeWidth: 1,
	        WebkitTextStrokeColor: 'black',
	        fontFamily: 'Orbitron, sans-serif'
	      }
	    }, 'Welcome to State Space'), DIV({
	      style: {
	        marginTop: 5
	      }
	    }, DIV({
	      style: {
	        display: 'inline-block'
	      }
	    }, (function() {
	      var len1, m, ref, results;
	      results = [];
	      for (m = 0, len1 = counter.length; m < len1; m++) {
	        ref = counter[m], num = ref[0], label = ref[1];
	        results.push(DIV({
	          style: {
	            marginBottom: 15
	          }
	        }, (function() {
	          var len2, o, results1;
	          results1 = [];
	          for (o = 0, len2 = num.length; o < len2; o++) {
	            digit = num[o];
	            results1.push(SPAN({
	              style: {
	                border: '1px solid #f4f4f4',
	                boxShadow: '0 1px 1px black',
	                paddingTop: 7,
	                fontWeight: 600,
	                fontFamily: 'Orbitron, sans-serif',
	                fontSize: 30,
	                marginRight: 8,
	                width: 36,
	                display: 'inline-block',
	                textAlign: 'center'
	              }
	            }, digit));
	          }
	          return results1;
	        })(), SPAN({
	          style: {
	            marginLeft: 10,
	            fontSize: 24,
	            marginTop: 10,
	            fontFamily: 'Orbitron, sans-serif'
	          }
	        }, label)));
	      }
	      return results;
	    })()), DIV({
	      style: {
	        fontSize: 24,
	        color: 'black',
	        marginLeft: 150,
	        display: 'inline-block',
	        padding: '15px 0',
	        fontFamily: 'Orbitron, sans-serif',
	        fontSize: 24,
	        verticalAlign: 'top'
	      }
	    }, (function() {
	      var len1, m, results;
	      results = [];
	      for (m = 0, len1 = instructions.length; m < len1; m++) {
	        inst = instructions[m];
	        results.push(DIV({
	          style: {
	            marginBottom: 11
	          }
	        }, inst));
	      }
	      return results;
	    })())), DIV({
	      style: {
	        margin: '25px 0'
	      }
	    }, (function() {
	      var len1, m, ref, results;
	      results = [];
	      for (m = 0, len1 = controls.length; m < len1; m++) {
	        ref = controls[m], label = ref[0], prop = ref[1];
	        results.push(control_button(label, prop));
	      }
	      return results;
	    })(), A({
	      style: {
	        textDecoration: 'underline',
	        margin: '0 10px',
	        fontSize: 24,
	        fontFamily: 'Orbitron, sans-serif'
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          var ref, v;
	          e.stopPropagation();
	          graph.removed_nodes = [];
	          graph.focus = null;
	          ref = _this.local.nodes;
	          for (k in ref) {
	            if (!hasProp.call(ref, k)) continue;
	            v = ref[k];
	            v.fixed = false;
	          }
	          return save(graph);
	        };
	      })(this)
	    }, 'reset nodes'))), graph.focus ? (focus = this.local.nodes[graph.focus], focus.is_key ? DIV({
	      style: {
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        position: 'absolute',
	        left: document.body.clientWidth - 290,
	        top: 10,
	        backgroundColor: 'white',
	        overflow: 'hidden',
	        zIndex: 1
	      }
	    }, (function() {
	      var ref, results;
	      ref = arest.cache[focus.name];
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        v = ref[k];
	        text = pretty_print(v);
	        results.push(DIV({
	          style: {
	            maxWidth: 230,
	            backgroundColor: 'white',
	            marginBottom: 10
	          }
	        }, DIV({
	          style: {
	            fontFamily: 'Orbitron, sans-serif'
	          }
	        }, k), DIV({
	          style: {
	            paddingLeft: 10,
	            fontSize: 12
	          }
	        }, (function() {
	          var len1, m, ref1, results1;
	          ref1 = text.split('\n');
	          results1 = [];
	          for (idx = m = 0, len1 = ref1.length; m < len1; idx = ++m) {
	            para = ref1[idx];
	            results1.push([idx > 0 ? BR(null) : void 0, SPAN(null, para)]);
	          }
	          return results1;
	        })())));
	      }
	      return results;
	    })())) : void 0) : void 0, DIV({
	      id: 'state_graph',
	      ref: 'graph',
	      style: {
	        border: '1px solid #eee'
	      }
	    }), LINK({
	      href: 'http://fonts.googleapis.com/css?family=Orbitron:400,500,700',
	      rel: 'stylesheet',
	      type: 'text/css'
	    }), STYLE(null, '.tooltip { \n  font-family: Orbitron, sans-serif;\n  color: red;\n  font-weight: 700;\n  font-size: 32px;\n  -webkit-text-fill-color: red; /* Will override color (regardless of order) */\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: white;\n}\n.tooltip.component { \n  color: blue;\n  -webkit-text-fill-color: blue;\n\n}'));
	  },
	  componentDidUpdate: function() {
	    var graph;
	    graph = fetch('state_graph');
	    if (graph.on) {
	      this.drawGraph();
	      if (!this.interval) {
	        return this.interval = setInterval(this.drawGraph, 2000);
	      }
	    } else {
	      if (this.interval) {
	        clearInterval(this.interval);
	      }
	      return this.force = this.interval = null;
	    }
	  },
	  drawGraph: function() {
	    var d3_links, d3_nodes, defs, delta, drag, graph, hash, height, k, len1, len2, link, m, new_links, new_nodes, node, o, ref, ref1, stale_links, stale_nodes, svg, tip, v, width;
	    graph = fetch('state_graph');
	    ref = refresh_data(this.local.nodes, this.local.links), new_nodes = ref[0], new_links = ref[1], stale_nodes = ref[2], stale_links = ref[3];
	    delta = Object.keys(new_nodes).length + Object.keys(new_links).length + stale_nodes.length + stale_links.length;
	    hash = this.compute_hash();
	    if (delta === 0 && this.force && this.last_hash === hash) {
	      return;
	    }
	    for (k in new_nodes) {
	      if (!hasProp.call(new_nodes, k)) continue;
	      v = new_nodes[k];
	      this.local.nodes[k] = v;
	    }
	    for (k in new_links) {
	      if (!hasProp.call(new_links, k)) continue;
	      v = new_links[k];
	      this.local.links[k] = v;
	    }
	    for (m = 0, len1 = stale_nodes.length; m < len1; m++) {
	      k = stale_nodes[m];
	      delete this.local.nodes[k];
	    }
	    for (o = 0, len2 = stale_links.length; o < len2; o++) {
	      k = stale_links[o];
	      delete this.local.links[k];
	    }
	    ref1 = transform_to_d3(this.local.nodes, this.local.links), d3_nodes = ref1[0], d3_links = ref1[1];
	    width = document.body.clientWidth - 300;
	    height = 700;
	    if (!this.force) {
	      this.force = d3.layout.force().charge(function(d) {
	        return Math.min(-50 * d.weight, -100);
	      }).chargeDistance(220).gravity(.01).friction(.5).linkDistance(function(l) {
	        return nodeSize(l.source) + nodeSize(l.target) + 3;
	      }).size([width, height]);
	      svg = d3.select('#state_graph').append('svg').attr('width', width).attr('height', height);
	      tip = d3.tip().attr('class', 'd3-tip').offset([-10, 0]).html(function(d) {
	        return ("<div class='tooltip " + (d.is_key ? 'cache-key' : 'component') + "'>") + ((d.is_key ? 'data' : 'code') + ":" + d.name) + "</div>";
	      });
	      svg.call(tip);
	    } else {
	      svg = d3.select('#state_graph svg');
	    }
	    d3.select('#state_graph_defs').remove();
	    defs = svg.append('defs').attr('id', 'state_graph_defs');
	    addSVGDefs(defs, d3_nodes);
	    this.force.nodes(d3_nodes).links(d3_links).start();
	    link = svg.selectAll('.link').data(d3_links);
	    link.enter().append('line').attr('class', 'link').style('stroke-width', 1);
	    link.exit().remove();
	    link.style('stroke', (function(_this) {
	      return function(l) {
	        if (graph.focus === l.source.graph_key || graph.focus === l.target.graph_key) {
	          return "rgb(213, 231, 255)";
	        } else {
	          return "rgb(240,240,240)";
	        }
	      };
	    })(this));
	    drag = this.force.drag().on("dragstart", function(d) {
	      return d.fixed = true;
	    });
	    node = svg.selectAll('.node').data(d3_nodes);
	    node.enter().append('rect').attr('class', function(d) {
	      if (d.is_key) {
	        return 'node cache-key';
	      } else {
	        return 'node component';
	      }
	    }).style('cursor', 'pointer').on('mouseover', (function(_this) {
	      return function(d) {
	        return tip.show(d);
	      };
	    })(this)).on('mouseout', (function(_this) {
	      return function(d) {
	        return tip.hide(d);
	      };
	    })(this)).on('click', function(d) {
	      if (d3.event.altKey) {
	        graph.removed_nodes.push(d.graph_key);
	      } else if (d3.event.shiftKey && d.fixed) {
	        d.fixed = false;
	        if (graph.focus === d.graph_key) {
	          graph.focus = null;
	        }
	      } else {
	        if (graph.focus === d.graph_key) {
	          graph.focus = null;
	        } else {
	          graph.focus = d.graph_key;
	        }
	      }
	      return save(graph);
	    }).call(drag);
	    node.exit().remove();
	    node.attr('width', function(d) {
	      return 2 * nodeSize(d);
	    }).attr('height', function(d) {
	      return 2 * nodeSize(d);
	    }).attr('rx', function(d) {
	      if (d.is_key) {
	        return nodeSize(d);
	      } else {
	        return nodeSize(d) / 10;
	      }
	    }).attr('ry', function(d) {
	      if (d.is_key) {
	        return nodeSize(d);
	      } else {
	        return nodeSize(d) / 10;
	      }
	    }).style('fill', function(d) {
	      if (!d.is_key) {
	        return "url(#radial-component-" + d.component + ")";
	      } else {
	        return "url(#radial-cache-key-" + d.prefix + ")";
	      }
	    }).style('stroke', function(d) {
	      if (graph.focus === d.graph_key || d.fixed) {
	        return 'black';
	      } else {
	        return 'transparent';
	      }
	    }).style('stroke-width', function(d) {
	      if (graph.focus === d.graph_key) {
	        return 3;
	      } else if (d.fixed) {
	        return 1;
	      } else {
	        return 0;
	      }
	    });
	    svg.selectAll('.node, .link').sort(function(a, b) {
	      if ((a.target != null) && (b.target != null)) {
	        return 0;
	      } else if (a.target != null) {
	        return -1;
	      } else if (b.target) {
	        return 1;
	      } else {
	        return b.weight - a.weight;
	      }
	    });
	    this.force.on('tick', function(e) {
	      var d, len3, p, q;
	      q = d3.geom.quadtree(d3_nodes);
	      for (p = 0, len3 = d3_nodes.length; p < len3; p++) {
	        d = d3_nodes[p];
	        q.visit(collide(d));
	        if (d.x < nodeSize(d)) {
	          d.x = Math.max(d.x, nodeSize(d) * 5);
	        }
	        if (d.x > width - nodeSize(d)) {
	          d.x = Math.min(d.x, width - nodeSize(d) * 5);
	        }
	        if (d.y < nodeSize(d)) {
	          d.y = Math.max(d.y, nodeSize(d) * 5);
	        }
	        if (d.y > height - nodeSize(d)) {
	          d.y = Math.min(d.y, height - nodeSize(d) * 5);
	        }
	      }
	      link.attr('x1', function(d) {
	        return d.source.x;
	      }).attr('y1', function(d) {
	        return d.source.y;
	      }).attr('x2', function(d) {
	        return d.target.x;
	      }).attr('y2', function(d) {
	        return d.target.y;
	      });
	      node.attr('x', function(d) {
	        return d.x - nodeSize(d);
	      }).attr('y', function(d) {
	        return d.y - nodeSize(d);
	      });
	    });
	    this.last_hash = this.compute_hash();
	    return save(this.local);
	  },
	  compute_hash: function() {
	    var k, len1, m, obj, props, ref, v;
	    props = {};
	    ref = [this.local, fetch('state_graph')];
	    for (m = 0, len1 = ref.length; m < len1; m++) {
	      obj = ref[m];
	      for (k in obj) {
	        if (!hasProp.call(obj, k)) continue;
	        v = obj[k];
	        if (k !== 'links' && k !== 'nodes' && k !== 'key') {
	          props[k] = v;
	        }
	      }
	    }
	    return JSON.stringify(props);
	  }
	});

	nodeSize = function(node) {
	  return Math.sqrt(4 * node.weight) + 3;
	};

	collide = function(node) {
	  return function(quad, x1, y1, x2, y2) {
	    var combined_r, dist, dx, dy, neighborhood_radius, nx1, nx2, ny1, ny2, offset_x, offset_y, separate_by;
	    if (quad.leaf && quad.point && quad.point !== node) {
	      dx = node.x - quad.point.x;
	      dy = node.y - quad.point.y;
	      dist = Math.sqrt(dx * dx + dy * dy);
	      combined_r = nodeSize(node) + nodeSize(quad.point);
	      if (dist < combined_r) {
	        separate_by = dist === 0 ? 1 : (dist - combined_r) / dist;
	        offset_x = dx * separate_by * .6;
	        offset_y = dy * separate_by * .6;
	        node.x -= offset_x;
	        node.y -= offset_y;
	        quad.point.x += offset_x;
	        quad.point.y += offset_y;
	      }
	    }
	    neighborhood_radius = nodeSize(node) + 16;
	    nx1 = node.x - neighborhood_radius;
	    nx2 = node.x + neighborhood_radius;
	    ny1 = node.y - neighborhood_radius;
	    ny2 = node.y + neighborhood_radius;
	    return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
	  };
	};

	refresh_data = function(nodes, links) {
	  var dep, k, key, len1, m, new_links, new_nodes, parent, processed_links, processed_nodes, ref, ref1, ref2, ref3, stale_links, stale_nodes, v;
	  processed_links = {};
	  processed_nodes = {};
	  new_nodes = {};
	  new_links = {};
	  stale_nodes = [];
	  stale_links = [];
	  ref = arest.cache;
	  for (k in ref) {
	    if (!hasProp.call(ref, k)) continue;
	    v = ref[k];
	    key = "_" + k;
	    if (!(key in nodes)) {
	      new_nodes[key] = {
	        name: k,
	        prefix: k.split('/').filter(function(f) {
	          return f !== '';
	        })[0],
	        is_key: true,
	        graph_key: key
	      };
	    }
	    processed_nodes[key] = 1;
	  }
	  ref1 = arest.components;
	  for (k in ref1) {
	    if (!hasProp.call(ref1, k)) continue;
	    v = ref1[k];
	    if (!(k in nodes)) {
	      new_nodes[k] = {
	        name: v.name,
	        component: v.name,
	        graph_key: k,
	        is_key: false
	      };
	    }
	    processed_nodes[k] = 1;
	    ref2 = arest.keys_4_component.get(k);
	    for (m = 0, len1 = ref2.length; m < len1; m++) {
	      dep = ref2[m];
	      key = ["_" + dep, k];
	      if (!(key in links)) {
	        new_links[key] = 1;
	      }
	      processed_links[key] = 1;
	    }
	  }
	  ref3 = arest.components;
	  for (k in ref3) {
	    if (!hasProp.call(ref3, k)) continue;
	    v = ref3[k];
	    if (v._owner) {
	      parent = v._owner.local_key;
	      key = parent < k ? [parent, k] : [k, parent];
	      if (!(key in links)) {
	        new_links[key] = 1;
	      }
	      processed_links[key] = 1;
	    }
	  }
	  for (k in nodes) {
	    if (!hasProp.call(nodes, k)) continue;
	    v = nodes[k];
	    if (!(k in processed_nodes)) {
	      stale_nodes.push(k);
	    }
	  }
	  for (k in links) {
	    if (!hasProp.call(links, k)) continue;
	    v = links[k];
	    if (!(k in processed_links)) {
	      stale_links.push(k);
	    }
	  }
	  return [new_nodes, new_links, stale_nodes, stale_links];
	};

	transform_to_d3 = function(nodes, links) {
	  var d3_links, d3_nodes, graph, i, idx, j, k, k1, k2, key, len1, len2, len3, link_enabled, m, n, n1, n2, node_idx, o, p, ref, show_component, show_data, show_unused_data, v, weights;
	  graph = fetch('state_graph');
	  show_data = graph.show_data_dependencies;
	  show_component = graph.show_component_parent_child_relations;
	  show_unused_data = graph.show_unused_data;
	  d3_nodes = [];
	  d3_links = [];
	  link_enabled = function(n1, n2) {
	    var active, enabled, present;
	    present = (n1 + "," + n2) in links;
	    enabled = (show_data && xor(nodes[n1].is_key, nodes[n2].is_key)) || (show_component && (!nodes[n1].is_key && !nodes[n2].is_key));
	    active = !(indexOf.call(graph.removed_nodes, n1) >= 0) && !(indexOf.call(graph.removed_nodes, n2) >= 0);
	    return present && enabled && active;
	  };
	  if (!(show_unused_data && show_data)) {
	    weights = {};
	    for (k in links) {
	      if (!hasProp.call(links, k)) continue;
	      v = links[k];
	      ref = k.split(','), k1 = ref[0], k2 = ref[1];
	      if (link_enabled(k1, k2)) {
	        weights[k1] = 1 + (weights[k1] || 0);
	        weights[k2] = 1 + (weights[k2] || 0);
	      }
	    }
	  }
	  d3_nodes = (function() {
	    var len1, m, ref1, results;
	    ref1 = Object.keys(nodes);
	    results = [];
	    for (m = 0, len1 = ref1.length; m < len1; m++) {
	      k = ref1[m];
	      if ((show_unused_data && show_data) || k in weights) {
	        results.push(nodes[k]);
	      }
	    }
	    return results;
	  })();
	  node_idx = {};
	  for (idx = m = 0, len1 = d3_nodes.length; m < len1; idx = ++m) {
	    n = d3_nodes[idx];
	    node_idx[n.graph_key] = idx;
	  }
	  for (i = o = 0, len2 = d3_nodes.length; o < len2; i = ++o) {
	    n1 = d3_nodes[i];
	    for (j = p = 0, len3 = d3_nodes.length; p < len3; j = ++p) {
	      n2 = d3_nodes[j];
	      if (i < j) {
	        if (n1.graph_key < n2.graph_key) {
	          key = [n1.graph_key, n2.graph_key];
	        } else {
	          key = [n2.graph_key, n1.graph_key];
	        }
	        if (link_enabled(key[0], key[1])) {
	          d3_links.push({
	            source: node_idx[key[0]],
	            target: node_idx[key[1]],
	            value: links[key]
	          });
	        }
	      }
	    }
	  }
	  return [d3_nodes, d3_links];
	};

	addSVGDefs = function(defs, nodes) {
	  var cache_prefixes, component_names, h, hues, i, k, len1, m, n, results, s, v;
	  cache_prefixes = {};
	  component_names = {};
	  for (m = 0, len1 = nodes.length; m < len1; m++) {
	    n = nodes[m];
	    if (n.is_key) {
	      cache_prefixes[n.prefix] = (cache_prefixes[n.prefix] || 0) + 1;
	    } else {
	      component_names[n.component] = (component_names[n.component] || 0) + 1;
	    }
	  }
	  hues = getNiceRandomHues(Object.keys(cache_prefixes).length, .1);
	  i = 0;
	  for (k in cache_prefixes) {
	    if (!hasProp.call(cache_prefixes, k)) continue;
	    v = cache_prefixes[k];
	    h = hues[i];
	    s = .8;
	    addGradient('linearGradient', defs, "radial-cache-key-" + k, hsv2rgb(h, 1.0, 1.0), hsv2rgb(h, 1.0, .8));
	    i += 1;
	  }
	  hues = getNiceRandomHues(Object.keys(component_names).length, .5);
	  i = 0;
	  results = [];
	  for (k in component_names) {
	    if (!hasProp.call(component_names, k)) continue;
	    v = component_names[k];
	    h = hues[i];
	    addGradient('linearGradient', defs, "radial-component-" + k, hsv2rgb(h, .8, .6), hsv2rgb(h, .8, .5));
	    results.push(i += 1);
	  }
	  return results;
	};

	addGradient = function(gradient, defs, id, c1, c2) {
	  gradient = defs.append(gradient).attr('id', id).attr('fx', '25%').attr('fy', '25%');
	  gradient.append('stop').attr('offset', '10%').attr('stop-color', c1);
	  return gradient.append('stop').attr('offset', '95%').attr('stop-color', c2);
	};

	xor = function(a, b) {
	  return (a || b) && !(a && b);
	};

	pretty_print = function(obj) {
	  var idx, k, len1, m, result, v;
	  result = "";
	  if (Array.isArray(obj)) {
	    if (obj.length === 0) {
	      result = "[]";
	    } else {
	      result += "[\n";
	      for (idx = m = 0, len1 = obj.length; m < len1; idx = ++m) {
	        k = obj[idx];
	        result += "" + (pretty_print(k));
	        if (idx !== obj.length - 1) {
	          result += ', ';
	        }
	      }
	      result += "\n]";
	    }
	  } else if (obj === null) {
	    result += 'null';
	  } else if (typeof obj === 'object') {
	    result += "{\n";
	    for (k in obj) {
	      if (!hasProp.call(obj, k)) continue;
	      v = obj[k];
	      result += k + ": " + (pretty_print(v)) + ",";
	    }
	    result += "\n}\n";
	  } else if (typeof obj === 'string') {
	    if (obj === '') {
	      result += '""';
	    } else {
	      result += obj;
	    }
	  } else if (typeof obj === 'function') {
	    result += '[function]';
	  } else {
	    result += JSON.stringify(obj);
	  }
	  return result;
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var UserTags;

	UserTags = ReactiveComponent({
	  displayName: 'UserTags',
	  render: function() {
	    var all_tags, available_users, change_current_user, current_user, idx, j, k, len, ref, ref1, ref2, subdomain, tag, tag_group, tag_users, tags, user, users, v, val;
	    subdomain = fetch('/subdomain');
	    users = fetch('/users');
	    current_user = this.local.current_user ? fetch(this.local.current_user) : void 0;
	    change_current_user = (function(_this) {
	      return function(new_user) {
	        var k, v;
	        _this.local.new_tags = {};
	        _this.local.current_user = new_user;
	        current_user = _this.local.current_user ? fetch(_this.local.current_user) : void 0;
	        if (current_user) {
	          for (k in all_tags) {
	            v = all_tags[k];
	            if (k !== 'no tags') {
	              if (current_user.tags[k] == null) {
	                _this.local.new_tags[k] = "";
	              }
	            }
	          }
	        }
	        return save(_this.local);
	      };
	    })(this);
	    all_tags = {};
	    ref = users.users;
	    for (j = 0, len = ref.length; j < len; j++) {
	      user = ref[j];
	      if ((user.tags != null) && Object.keys(user.tags).length > 0) {
	        ref1 = user.tags;
	        for (tag in ref1) {
	          val = ref1[tag];
	          all_tags[tag] || (all_tags[tag] = {
	            yes: [],
	            no: []
	          });
	          if (val && ((ref2 = val.toLowerCase()) !== "no" && ref2 !== 'false')) {
	            all_tags[tag].yes.push(user);
	          } else {
	            all_tags[tag].no.push(user);
	          }
	        }
	      } else {
	        all_tags['no tags'] || (all_tags['no tags'] = {
	          yes: [],
	          no: []
	        });
	        all_tags['no tags'].yes.push(user);
	      }
	    }
	    all_tags;
	    return DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        margin: 'auto',
	        paddingTop: 50
	      }
	    }, DIV({
	      style: {
	        marginBottom: 12
	      }
	    }, H1({
	      style: {
	        fontSize: 28
	      }
	    }, "User tags")), DIV(null, INPUT({
	      id: 'filter',
	      type: 'text',
	      style: {
	        fontSize: 18,
	        width: 350,
	        padding: '3px 6px'
	      },
	      autoComplete: 'off',
	      placeholder: "Name or email...",
	      value: current_user ? current_user.name : void 0,
	      onChange: (function(_this) {
	        return function() {
	          var ref3;
	          _this.local.filtered = (ref3 = $(_this.getDOMNode()).find('#filter').val()) != null ? ref3.toLowerCase() : void 0;
	          change_current_user(null);
	          return save(_this.local);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 13) {
	            e.preventDefault();
	            change_current_user(_this.local.hovered_user);
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.selecting = true;
	          save(_this.local);
	          e.stopPropagation();
	          $(document).on('click.tags', function(e) {
	            if (e.target.id !== 'filter') {
	              _this.local.selecting = false;
	              save(_this.local);
	              return $(document).off('click.tags');
	            }
	          });
	          return false;
	        };
	      })(this)
	    })), this.local.selecting ? (available_users = _.filter(users.users, (function(_this) {
	      return function(u) {
	        return u.key !== _this.local.current_user && (!_this.local.filtered || (u.name + " <" + u.email + ">").toLowerCase().indexOf(_this.local.filtered) > -1);
	      };
	    })(this)), available_users.length > 0 ? UL({
	      style: {
	        width: 500,
	        position: 'absolute',
	        zIndex: 99,
	        listStyle: 'none',
	        backgroundColor: '#fff',
	        border: '1px solid #eee'
	      }
	    }, (function() {
	      var l, len1, results;
	      results = [];
	      for (idx = l = 0, len1 = available_users.length; l < len1; idx = ++l) {
	        user = available_users[idx];
	        results.push((function(_this) {
	          return function(user) {
	            return LI({
	              className: 'invite_menu_item',
	              style: {
	                padding: '2px 12px',
	                fontSize: 18,
	                cursor: 'pointer',
	                borderBottom: '1px solid #fafafa'
	              },
	              key: idx,
	              onMouseEnter: function(e) {
	                _this.local.hovered_user = user.key;
	                return save(_this.local);
	              },
	              onMouseLeave: function(e) {
	                _this.local.hovered_user = null;
	                return save(_this.local);
	              },
	              onClick: function(e) {
	                change_current_user(_this.local.hovered_user);
	                return e.stopPropagation();
	              }
	            }, user.name + " <" + user.email + ">");
	          };
	        })(this)(user));
	      }
	      return results;
	    }).call(this)) : void 0) : void 0, current_user ? DIV({
	      style: {
	        marginTop: 20
	      }
	    }, (function() {
	      var l, len1, ref3, results;
	      ref3 = [current_user.tags, this.local.new_tags];
	      results = [];
	      for (l = 0, len1 = ref3.length; l < len1; l++) {
	        tags = ref3[l];
	        results.push((function() {
	          var results1;
	          results1 = [];
	          for (k in tags) {
	            v = tags[k];
	            results1.push((function(_this) {
	              return function(k, v, tags) {
	                var editing;
	                editing = _this.local.editing === k;
	                return DIV({
	                  key: k + "-" + v,
	                  style: {},
	                  onFocus: function(e) {
	                    _this.local.editing = k;
	                    return save(_this.local);
	                  },
	                  onBlur: function(e) {
	                    _this.local.editing = null;
	                    return save(_this.local);
	                  }
	                }, INPUT({
	                  ref: k,
	                  style: {
	                    fontWeight: 600,
	                    padding: '5px 10px',
	                    marginRight: 18,
	                    display: 'inline-block',
	                    border: "1px solid " + (editing ? '#bbb' : 'transparent'),
	                    outline: 'none',
	                    fontSize: 18,
	                    width: 400
	                  },
	                  defaultValue: k
	                }), INPUT({
	                  ref: k + "-val",
	                  style: {
	                    padding: '5px 10px',
	                    display: 'inline-block',
	                    border: "1px solid " + (editing ? '#bbb' : 'transparent'),
	                    outline: 'none',
	                    fontSize: 18,
	                    width: 400
	                  },
	                  defaultValue: v
	                }));
	              };
	            })(this)(k, v, tags));
	          }
	          return results1;
	        }).call(this));
	      }
	      return results;
	    }).call(this), DIV({
	      style: {
	        marginTop: 12
	      }
	    }, INPUT({
	      type: 'submit',
	      style: {
	        padding: '5px 10px',
	        fontSize: 18
	      },
	      value: 'new tag',
	      onClick: (function(_this) {
	        return function() {
	          var i;
	          i = 0;
	          while (_this.local.new_tags["tag-" + i]) {
	            i++;
	          }
	          _this.local.new_tags["tag-" + i] = "";
	          return save(_this.local);
	        };
	      })(this)
	    })), DIV({
	      style: {
	        marginTop: 12
	      }
	    }, INPUT({
	      type: 'submit',
	      style: {
	        backgroundColor: focus_blue,
	        border: 'none',
	        outline: 'none',
	        color: 'white',
	        padding: '5px 10px',
	        borderRadius: 8,
	        fontSize: 18
	      },
	      onClick: (function(_this) {
	        return function() {
	          var l, len1, new_k, new_v, ref3, update;
	          update = {};
	          ref3 = [current_user.tags, _this.local.new_tags];
	          for (l = 0, len1 = ref3.length; l < len1; l++) {
	            tags = ref3[l];
	            for (k in tags) {
	              v = tags[k];
	              new_k = _this.refs[k].getDOMNode().value;
	              new_v = _this.refs[k + "-val"].getDOMNode().value;
	              if ((new_k != null ? new_k.length : void 0) > 0 && (new_v != null ? new_v.length : void 0) > 0) {
	                update[new_k] = new_v;
	              }
	            }
	          }
	          current_user.tags = update;
	          save(current_user);
	          _this.local.new_tags = {};
	          return save(_this.local);
	        };
	      })(this),
	      value: 'Update'
	    }))) : void 0, DIV({
	      style: {
	        marginTop: 12
	      }
	    }, (function() {
	      var results;
	      results = [];
	      for (tag_group in all_tags) {
	        tag_users = all_tags[tag_group];
	        results.push(DIV({
	          style: {
	            width: 300,
	            display: 'inline-block',
	            verticalAlign: 'top',
	            padding: 10,
	            backgroundColor: '#eaeaea',
	            borderRadius: 16,
	            marginRight: 10,
	            marginBottom: 10
	          }
	        }, DIV({
	          style: {
	            fontWeight: 600,
	            marginBottom: 4,
	            color: "#666"
	          }
	        }, tag_group), UL({
	          style: {
	            listStyle: 'none',
	            display: 'inline',
	            fontSize: 0,
	            lineHeight: 0
	          }
	        }, (function() {
	          var l, len1, ref3, results1;
	          ref3 = tag_users.yes;
	          results1 = [];
	          for (l = 0, len1 = ref3.length; l < len1; l++) {
	            user = ref3[l];
	            results1.push((function(_this) {
	              return function(user) {
	                return Avatar({
	                  key: user.key,
	                  style: {
	                    width: 40,
	                    height: 40,
	                    cursor: 'pointer'
	                  },
	                  onClick: function() {
	                    return change_current_user(user.key);
	                  }
	                });
	              };
	            })(this)(user));
	          }
	          return results1;
	        }).call(this), (function() {
	          var l, len1, ref3, results1;
	          ref3 = tag_users.no;
	          results1 = [];
	          for (l = 0, len1 = ref3.length; l < len1; l++) {
	            user = ref3[l];
	            results1.push((function(_this) {
	              return function(user) {
	                return Avatar({
	                  key: user.key,
	                  style: {
	                    width: 40,
	                    height: 40,
	                    cursor: 'pointer',
	                    opacity: .2
	                  },
	                  onClick: function() {
	                    return change_current_user(user.key);
	                  }
	                });
	              };
	            })(this)(user));
	          }
	          return results1;
	        }).call(this))));
	      }
	      return results;
	    }).call(this)));
	  }
	});

	window.UserTags = UserTags;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(1)))

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** franklin.53d80ccef9e09061bf32.js
 **/